// Config Production
function getConfig() {
     return {
          buildVersion:"hc87SIO 2026-07-06T13:04",
          urlApi: "https://cadernoapplication.eattae.com.br/api/V141/",
          urlApiV150: "https://cadernoapplication.eattae.com.br/api/v150/",
          urlTracker: "https://tracker.eattae.com.br/",
          urlAddressApi: "https://address.eattae.com.br/v1/",
          urlRejection403: "https://account.eattae.com.br/Pagamento",
          urlRejection402: "https://account.eattae.com.br/Pagamento",
          urlBaseAccountApplicationUI: "https://account.eattae.com.br",

          urlComprador: "https://comprador.eattae.com.br/",
          urlMeApresenta: "https://meapresenta.eattae.com.br/",
          urlCadernocampo: "https://caderno.eattae.com.br/",
          urlGerenciarlicenca: "https://account.eattae.com.br/Geral",
          urlCredenciados: 'https://account.eattae.com.br/credenciados',
          urlGestaoRede: 'https://gestor.eattae.com.br/',

          authentication: {
               authority: "https://identity.eattae.com.br",
               client_id: "EattaeCadernoUI",
               redirect_uri: location.origin + "/authentication_callback.html",
               response_type: "id_token token",
               scope: "openid profile EattaeCadernoApplication",
               post_logout_redirect_uri: location.origin + "/authentication_logoutcallback.html",
          }
     }

}

(function () {
    'use strict';

    angular
        .module('app.insumo.defensivo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.registro.manejo.insumo.defensivo', {
                abstract: true,
                url: '/defensivo'
            })
            .state('app.registro.manejo.insumo.defensivo.criar', {
                url: '/criar?area&propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/defensivo/views/criar.html',
                        controller: 'CriarInsumoController as vm'
                    }
                },
                resolve: {
                    areas: function (insumoDefensivoService) {
                         return insumoDefensivoService.getAreasAdd();
                    }
                }
            })
            .state('app.registro.manejo.insumo.defensivo.criar_sem_estoque', {
               url: '/criar_sem_estoque',
               views: {
                   'content@app': {
                       templateUrl: 'app/main/registro/insumo/defensivo/views/criar_sem_estoque.html',
                       controller: 'CriarSemEstoqueInsumoController as vm'
                   }
               },
               resolve: {
                   model: function (insumoDefensivoService) {
                       return insumoDefensivoService.getNew();
                   },
                   areas: function (insumoDefensivoService) {
                        return insumoDefensivoService.getAreasAdd();
                   },
                   unidade_medida: function (estoqueInsumoDefensivoService) {
                       return estoqueInsumoDefensivoService.getUnidadesMedidas();
                   }
               }
           })
            .state('app.registro.manejo.insumo.defensivo.sucesso', {
                url: '/sucesso',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/defensivo/views/sucesso.html',
                        controller: 'SucessoInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                }
            })
            .state('app.registro.manejo.insumo.defensivo.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/defensivo/views/visualizar.html',
                        controller: 'VisualizarInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, insumoDefensivoService) {
                        return insumoDefensivoService.get($stateParams.id);
                    }
                }
            })
            .state('app.registro.manejo.insumo.defensivo.buscar', {
                url: '/buscar?propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/defensivo/views/buscar.html',
                        controller: 'BuscarInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    filtros: function (insumoDefensivoService){
                         return insumoDefensivoService.filtrosInsumo();
                    },
                    propriedades: function (insumoDefensivoService){
                         return insumoDefensivoService.queryPropertie();
                    }
                }
            })


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/registro/insumo/defensivo');
        $translatePartialLoaderProvider.addPart('app/main/registro');

        //Menu
        msNavigationServiceProvider.saveItem('manejo.insumo.defensivo', {
            title: 'Insumo',
            state: 'app.registro.manejo.insumo.defensivo.buscar',
            translate: 'DEFENSIVO.DEFENSIVO',
            weight: 2
        });
    }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.defensivo')
          .controller('VisualizarInsumoDefensivoController', VisualizarInsumoDefensivoController);

     /** @ngInject */
     function VisualizarInsumoDefensivoController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.defensivo.buscar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
    'use strict';

    angular
         .module('app.insumo.defensivo')
         .controller('SucessoInsumoDefensivoController', SucessoInsumoDefensivoController);

    /** @ngInject */
    function SucessoInsumoDefensivoController($state, $mdDialog, $rootScope, $filter, $scope) {
         var vm = this;

         // Data

         // Methods
         vm.gotoList = gotoList;
         vm.gotoAplicarInsumoDefensivo = gotoAplicarInsumoDefensivo;
         vm.gotoHistorico = gotoHistorico;
         vm.gotoHome = gotoHome;

         //////////

         init();

         /**
          * Initialize
          */
         function init() {

         }

         function gotoList() {
               $state.go('app.registro.manejo.insumo.defensivo.buscar');
          }

         function gotoAplicarInsumoDefensivo() {
              $state.go('app.registro.manejo.insumo.defensivo.criar');
         }

         function gotoHistorico() {
              $state.go('app.relatorios.insumos.buscar');
         }

         function gotoHome() {
              $state.go('app.home');
         }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.insumo.defensivo')
        .controller('CriarSemEstoqueInsumoController', CriarSemEstoqueInsumoController);

    /** @ngInject */
    function CriarSemEstoqueInsumoController(model, areas, $rootScope, $filter, $state, insumoDefensivoService, estoqueInsumoDefensivoService, $mdToast, $mdDialog, unidade_medida) {
        var vm = this;

        // Data
        vm.model = model;
        vm.areas = areas;
        vm.status = [];
        vm.isDisabled = false;
        vm.api_response_erro = {};
        vm.unidadesMedida = unidade_medida;
        vm.productStock = [];
        vm.step = 1;
        vm.total_area_produtiva = 0;

        // Methods
        vm.addProducts = addProducts;
        vm.removeProducts = removeProducts;
        vm.searchProductStock = searchProductStock;
        vm.changeProduto = changeProduto;
        vm.getModelConsolidado = getModelConsolidado();


        vm.save = save;
        vm.gotoSearch = gotoSearch;
        vm.gotoSucesso = gotoSucesso;
        vm.gotoVoltar = gotoVoltar;
        vm.gotoStep = gotoStep;
        vm.savePromise = null;
        vm.areaSelecionada = null;
        vm.cancelClick = cancelClick;

        //////////

        init();

        function init() {

            vm.model.propriedade_areas = new Array();
            vm.model.produtos = new Array();

            vm.date = new Date();

            checkAreas();

            // Cria um novo produto.
            addProducts();
        }

        function addProducts() {
            vm.model.produtos.push({
                insumo_agricola_nome: "",
                quantidade: "",
                unidade_medida: ""
            });
        }

        function removeProducts(index) {
            vm.model.produtos.splice(index, 1);
        }

        function searchProductStock() {

            var args = {
                loading: false,
                //page: 1,
                //per_page: 9999
            };

            $rootScope.loadingProgress = true;

            insumoDefensivoService.querySemEstoque(args).then(function (response) {
                $rootScope.loadingProgress = false;
                vm.productStock = response.data;
                console.log('procura stock', vm.productStock)
                if (response.data.length == 0)
                    EstoqueNaoEncontrado();

            }).catch(function (response) {

                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;

                EstoqueNaoEncontrado();
            });
        }



        function changeProduto(produto) {
            produto.insumo_estoque_rateio = undefined;
            produto.estoque_insumo_rateio_id = undefined;
            produto.quantidade = 0;
            produto.valor = 0;
            produto.estoque_insumo_id = produto.insumo_estoque.id;
            produto.tipo_medida_id = produto.insumo_estoque.tipo_medida.id;

            console.log('change produto', produto);

            // coloca o nome do insumo agricola.
            produto.insumo_agricola_nome = produto.insumo_estoque.nome;
        }


        function save(form) {

            if (form.$invalid) {
                return;
            }

            console.log('save', vm.model);
            //return

            this.savePromise = insumoDefensivoService.createSemEstoque(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('DEFENSIVO.DEFENSIVOCREATED'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                gotoSucesso();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;

                if(response.data.errors)
                    {
                         let err = '';
                         for (let prop in response.data.errors) {
                              err += response.data.errors[prop];
                         }

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
            });
        }


        function checkAreas() {
            if(vm.areas.length == 0)
                AreaNaoEncontrado();
            else
                searchProductStock();
        }

        function gotoEstoqueDefensivo() {
            $state.go('app.estoque_insumo.defensivo.criar');
       }

        function gotoSearch() {
            $state.go('app.registro.manejo.insumo.defensivo.buscar');
        }

        function gotoSucesso(){
            $state.go('app.registro.manejo.insumo.defensivo.sucesso');
        }

        function gotoVoltar() {
            $state.go('app.registro.manejo.insumo.defensivo.buscar');
        }

        function gotoCreateArea() {
            $state.go('app.registro.area.criar');
        }

        function gotoStep(step) {
            vm.step = step;

            // atualiza a lista dos dados consolidados.
            getModelConsolidado();

            // Passando valores das quantidades finais em cada produto por área para o post
            for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
               var area = vm.model.propriedade_areas[index];
               var produto = vm.areas_consolidadas[index];
               if(area.id == produto.area.id){
                    vm.model.propriedade_areas[index].produtos = produto.produtos[0].produtos
               }
            }
        }

        function getModelConsolidado() {
            vm.areas_consolidadas = [];

            if (vm.model.propriedade_areas) {

               for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                    var area = vm.model.propriedade_areas[index];
                    var produto_peso = {
                         quantidades: 0,
                         produtos: []
                    };

                    for (var indexInsumo = 0; indexInsumo < vm.model.produtos.length; indexInsumo++) {
                         var produto = vm.model.produtos[indexInsumo];

                         var quantidade = produto.quantidade * (area.area_produtiva / vm.total_area_produtiva);
                         var valor = produto.valor * (area.area_produtiva / vm.total_area_produtiva);

                         var obj = {
                              produto: produto,
                              valor: ArredondaResultadoValor(valor),
                              quantidade: ArredondaResultadoQuantidade(quantidade),
                              quantidade_original: quantidade,
                              valor_original: valor,
                              area_id: area.id
                         }

                         produto_peso.produtos.push(obj);
                         produto_peso.quantidades += quantidade;
                    }

                    vm.areas_consolidadas.push({
                         area: area,
                         produtos: [
                              produto_peso
                         ]
                    });
               }
            }

            console.log('getModelCosolidado', vm.model);
       }

          function ArredondaResultadoQuantidade(value){
               if(value < 0.0005){
                    return 0.001
               }else{
                    return value
               }
          }
          function ArredondaResultadoValor(value){
               if(value < 0.005){
                    return 0.01
               }else{
                    return value
               }
          }

        function showConfirm(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Antes de finalizar')
                .textContent('Gostaria de fazer mais uma aplicação de insumo defensivo?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                gotoInsumo();
            }, function () {
                gotoSearch();
            });
        };

        function cancelClick(form, ev) {

            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);
            }
        }

        function EstoqueNaoEncontrado(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Produto não encontrado')
                .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                gotoEstoqueDefensivo();
            }, function () {
                // gotoSearch();
            });
        };

        function AreaNaoEncontrado(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Área não encontrado')
                .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                 gotoCreateArea();
            }, function () {
                 // gotoSearch();
            });
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.insumo.defensivo')
        .controller('CriarInsumoController', CriarInsumoController);

    /** @ngInject */
    function CriarInsumoController(areas, $rootScope, $scope, $filter, $state, insumoDefensivoService, estoqueInsumoDefensivoService, $mdToast, $mdDialog) {
        var vm = this;

        // Data
        vm.model = {};
        vm.areas = areas;
        vm.status = [];
        vm.isDisabled = false;
        vm.api_response_erro = {};
        vm.productStock = [];
        vm.step = 1;
        vm.total_area_produtiva = 0;

        // Methods
        vm.addProducts = addProducts;
        vm.removeProducts = removeProducts;
        vm.searchProductStock = searchProductStock;
        vm.changeProduto = changeProduto;
        vm.changeRateio = changeRateio;
        vm.changeQuantidade = changeQuantidade;
        vm.getModelConsolidado = getModelConsolidado();
        vm.openModalEstoque = openModalEstoque;


        vm.save = save;
        vm.gotoSearch = gotoSearch;
        vm.gotoSucesso = gotoSucesso;
        vm.gotoVoltar = gotoVoltar;
        vm.gotoStep = gotoStep;
        vm.savePromise = null;
        vm.areaSelecionada = null;
        vm.cancelClick = cancelClick;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;

        //////////

        init();

        function init() {

            vm.model.propriedade_areas = new Array();
            vm.model.produtos = new Array();

            vm.date = new Date();

            checkAreas();

            // Cria um novo produto.
            addProducts();
        }

          function openModalEstoque(produto){
               $mdDialog.show({
                    locals:{dataToPass: produto},
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/insumo/defensivo/views/modal_estoque.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
          }
          function mdDialogCtrl($scope, $mdDialog, dataToPass) {
               // Consulta o rateio do produto.
               searchRateioProductStock(dataToPass);
               $scope.dataModal = dataToPass;
               console.log('estoque', dataToPass);

               $scope.hide = function () {
                    $mdDialog.hide();
               };
          }

        function addProducts() {
            vm.model.produtos.push({
                insumo_agricola_nome: "",
                quantidade: ""
            });
        }

        function removeProducts(index) {
            vm.model.produtos.splice(index, 1);
        }

        function searchProductStock() {

            var args = {
                loading: false,
                per_page: 999
            };

            $rootScope.loadingProgress = true;

            estoqueInsumoDefensivoService.query150(args).then(function (response) {
                $rootScope.loadingProgress = false;
                vm.productStock = response.data.estoques_insumo_model;
                console.log('procura stock', vm.productStock)
                if (response.data.estoques_insumo_model.length == 0)
                    EstoqueNaoEncontrado();

            }).catch(function (response) {

                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;

                EstoqueNaoEncontrado();
            });
        }

        function searchRateioProductStock(produto) {

            $rootScope.loadingProgress = true;

            insumoDefensivoService
                .rateio(produto.insumo_estoque.id, produto.insumo_estoque.insumo_id, produto.insumo_estoque.tipo_medida_id)
                .then(function (response) {
                    console.log('rateio', response);
                    $rootScope.loadingProgress = false;
                    produto.rateioProductStock = response;

                    if (response.length == 1) {
                        produto.insumo_estoque_rateio = response[0]
                        changeRateio(produto);
                    } else if (response.length == 0)
                        RateioInsuficiente(produto);

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }





        function changeProduto(produto) {
            produto.insumo_estoque_rateio = undefined;
            produto.estoque_insumo_rateio_id = undefined;
            produto.quantidade = 0;
            produto.estoque_insumo_id = produto.insumo_estoque.id;
            produto.tipo_medida_id = produto.insumo_estoque.tipo_medida_id;

            // coloca o nome do insumo agricola.
            produto.insumo_agricola_nome = produto.insumo_estoque.insumo_nome;
        }

        function changeRateio(produto) {

            produto.estoque_insumo_rateio_id = produto.insumo_estoque_rateio.id
            vm.model.estoque_insumo_rateio_id = produto.insumo_estoque_rateio.id

            changeQuantidadeOuUnidadeDeMedida(produto)
        }

        function changeQuantidade(produto) {
               changeQuantidadeOuUnidadeDeMedida(produto);
        }

        function changeQuantidadeOuUnidadeDeMedida(produto) {

            if (produto.insumo_estoque.quantidade < produto.quantidade)
               EstoqueInsuficiente(produto);

            // Verificar se deve ser feito o calculo.
            //produto.valor = (produto.insumo_estoque_rateio.valor / produto.insumo_estoque_rateio.quantidade_origem) * produto.quantidade;

            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }
        }






        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = insumoDefensivoService.create(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('DEFENSIVO.DEFENSIVOCREATED'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                gotoSucesso();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;

                if(response.data.errors)
                    {
                         let err = '';
                         for (let prop in response.data.errors) {
                              err += response.data.errors[prop];
                         }

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
            });
        }


        function checkAreas() {
            if(vm.areas.length == 0)
                AreaNaoEncontrado();
            else
                searchProductStock();
        }


        function gotoEstoqueDefensivo() {
            $state.go('app.estoque_insumo.defensivo.criar');
       }

        function gotoSearch() {
            $state.go('app.registro.manejo.insumo.defensivo.buscar');
        }

        function gotoSucesso(){
            $state.go('app.registro.manejo.insumo.defensivo.sucesso');
        }

        function gotoVoltar() {
            $state.go('app.registro.manejo.insumo.defensivo.buscar');
        }

        function gotoCreateArea() {
            $state.go('app.registro.area.criar');
        }

        function gotoStep(step) {
            vm.step = step;

            // atualiza a lista dos dados consolidados.
            getModelConsolidado();

            // Passando valores das quantidades finais em cada produto por área para o post
            for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
               var area = vm.model.propriedade_areas[index];
               var produto = vm.areas_consolidadas[index];
               if(area.id == produto.area.id){
                    vm.model.propriedade_areas[index].produtos = produto.produtos[0].produtos
               }
            }
        }

        function getModelConsolidado() {
            vm.areas_consolidadas = [];

            if (vm.model.propriedade_areas) {

                for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                    var area = vm.model.propriedade_areas[index];
                    var produto_peso = {
                        quantidades: 0,
                        produtos: []
                    };

                    for (var indexInsumo = 0; indexInsumo < vm.model.produtos.length; indexInsumo++) {
                        var produto = vm.model.produtos[indexInsumo];

                        var quantidade = produto.quantidade * (area.area_produtiva / vm.total_area_produtiva);

                        var obj = {
                            produto: produto,
                            valor: produto.valor * (area.area_produtiva / vm.total_area_produtiva),
                            quantidade: ArredondaResultado(quantidade),
                            quantidade_original: quantidade,
                            area_id: area.id
                        }

                         produto_peso.produtos.push(obj);
                         produto_peso.quantidades += quantidade;
                    }

                    vm.areas_consolidadas.push({
                        area: area,
                        produtos: [
                            produto_peso
                        ]
                    });
                }
            }
       }

       function ArredondaResultado(value){
          if(value < 0.0005){
               return 0.001
          }else{
               return value
          }
       }

        function showConfirm(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Antes de finalizar')
                .textContent('Gostaria de fazer mais uma aplicação de insumo defensivo?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                gotoInsumo();
            }, function () {
                gotoSearch();
            });
        };

        function cancelClick(form, ev) {

            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);
            }
        }

        function EstoqueNaoEncontrado(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Produto não encontrado')
                .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                gotoEstoqueDefensivo();
            }, function () {
                // gotoSearch();
            });
        };

        function AreaNaoEncontrado(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Área não encontrado')
                .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                 gotoCreateArea();
            }, function () {
                 // gotoSearch();
            });
        }

        function EstoqueInsuficiente(produto) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Estoque insuficiente')
                .textContent('Você não possui estoque suficiente deste produto para fazer a aplicação. O que gostaria de fazer agora?')
                // .targetEvent(ev)
                .ok('Cadastrar novo insumo!')
                .cancel('Voltar');

            $mdDialog.show(confirm).then(function () {
                gotoEstoqueDefensivo();
            }, function () {
                // gotoSearch();
            });
        };

        function unidadeMedidaFormat(input, tipo_medida) {

            if (tipo_medida == undefined)
                return { quantidade: input, number: input, sigla: '', nome: '' }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return { quantidade: input, number: input, sigla: 'mg', nome: 'Miligrama' }

                    if (input < 1000000)
                        return { quantidade: convertToDecimalCase((input / 1000), 2), number: (input / 1000), sigla: 'g', nome: 'Grama' }

                    if (input < 1000000000)
                        return { quantidade: convertToDecimalCase((input / 1000000), 2), number: (input / 1000000), sigla: 'kg', nome: 'Quilograma' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000000000), 2), number: (input / 1000000000), sigla: 'T', nome: 'Tonelada' }

                case 2: // Líquido

                    if (input < 1000)
                        return { quantidade: input, number: input, sigla: 'ml', nome: 'Mililitro' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000), 2), number: (input / 1000), sigla: 'Litros', nome: 'Litros' }

                default:
                    return { quantidade: input, number: input, sigla: 'ml', nome: tipo_medida.nome }
            }
        }

        function convertToDecimalCase(number, decimal) {
            var n = parseFloat(number);

            if (Number.isInteger(n)) {
                return n;
            }
            else {
                if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                    return parseInt(number);

                return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            }
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.insumo.defensivo')
        .controller('BuscarInsumoDefensivoController', BuscarInsumoDefensivoController);

    /** @ngInject */
    function BuscarInsumoDefensivoController(propriedades, clientePerfilService, filtros, $filter, $stateParams, insumoDefensivoService, $state, $mdDialog, $mdToast) {

        var vm = this;

        // Status
        vm.loadingProgress = false;
        vm.activeFilters = false;

        // Data
        vm.models = null;
        vm.filtros = filtros;
        vm.propriedades = propriedades;

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoVisualizar = gotoVisualizar;
        vm.search = search;
        vm.resetFilters = resetFilters;
        vm.deletarConfirm = deletarConfirm;
        vm.viewTutorial = viewTutorial;

        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        //////////

        init();

        function init() {
          clientePerfilService.getAtivo().then(function (response) {
               vm.clientePerfil = response;
               console.log('CLIENTE DADOS', vm.clientePerfil);
          });
          if (vm.propriedades == undefined || vm.propriedades.length == 0)
               cadastroPropriedadeConfirm();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar insumo defensivo?')
                .textContent('Tem certeza que deseja deletar o insumo defensivo?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não, não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            insumoDefensivoService.deleteInsumo(model.id)
                .then(function (response) {
                    var message = $filter('translate')('DEFENSIVO.DELETE');
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function (response) {
                    //var message = $filter('translate')('DEFENSIVO.ERRO_DELETE');
                    console.log(response);
                    var message = response.data.detail;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/registro/insumo/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function search() {

            var arg = {
                sort_by: 'data_aplicacao',
                sort_order: 'desc',
                Propriedade_Id: $stateParams.propriedade
            };

            vm.loadingProgress = true;
            insumoDefensivoService.query(arg)
                .then(function successCallback(data) {
                    vm.models = data.data;

                    if (!vm.models.propriedades_cliente || vm.models.propriedades_cliente.length == 0)
                        cadastroPropriedadeConfirm();
                    else {
                        if ($stateParams.propriedade)
                            vm.args.Propriedade_Id = $stateParams.propriedade
                        else
                            vm.args.Propriedade_Id = vm.models.propriedades_cliente[0].id
                    }

                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query

        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            insumo_agricola: null,
            data_aplicacao: null,
            propriedade_area_id: null,
            Propriedade_Id: null,
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            insumoDefensivoService.query(vm.args).then(function (response) {
                vm.models = response.listagem;

                vm.args.total_rows = response.total_itens;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();


            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function resetFilters() {
            vm.args.insumo_agricola = null;
            vm.args.propriedade_area_id = null;
            vm.args.data_aplicacao = null;
            change();
        }

        function showActiveFilters(){
            vm.activeFilters = null;
            let arr = null;
            let dataAplicacao = $filter('date')(vm.args.data_aplicacao,'dd/MM/yyyy');
            let counter = 0;
            arr = [
                 {
                      description: vm.args.propriedade_area_id,
                      value: 'propriedade_area_id'
                 },
                 {
                      description: vm.args.insumo_agricola,
                      value: 'insumo_agricola'
                 },
                 {
                      description: dataAplicacao,
                      value: 'data_aplicacao'
                  }
            ];

            for (let i = 0; i < arr.length; i++) {
                 if (arr[i].description != null) counter++;
            }

            if(counter > 0){
                 vm.activeFilters = arr;
            }
          }

          function desableFilter(value){
            vm.args[value] = null;
            change();
          }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {

                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();

        }

        function gotoAdd(is_estoque_automatico) {
          if(is_estoque_automatico){
               $state.go('app.registro.manejo.insumo.defensivo.criar');
          }else{
               $state.go('app.registro.manejo.insumo.defensivo.criar_sem_estoque');
          }

        }

        function gotoVisualizar(id) {
            $state.go('app.registro.manejo.insumo.defensivo.visualizar', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }
    }


})();

(function () {
    'use strict';

    angular
        .module('app.insumo.biologico', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.registro.manejo.insumo.biologico', {
                abstract: true,
                url: '/biologico'
            })
            .state('app.registro.manejo.insumo.biologico.criar', {
                url: '/criar?propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/biologico/views/criar.html',
                        controller: 'CriarInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    areas: function (insumoBiologicoService) {
                        return insumoBiologicoService.getAreasAdd();
                    }
                }
            })
            .state('app.registro.manejo.insumo.biologico.criar_sem_estoque', {
               url: '/criar_sem_estoque',
               views: {
                   'content@app': {
                       templateUrl: 'app/main/registro/insumo/biologico/views/criar_sem_estoque.html',
                       controller: 'CriarSemEstoqueBiologicoController as vm'
                   }
               },
               resolve: {
                   areas: function (insumoBiologicoService) {
                       return insumoBiologicoService.getAreasAdd();
                   }
               }
           })
            .state('app.registro.manejo.insumo.biologico.sucesso', {
                url: '/sucesso',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/biologico/views/sucesso.html',
                        controller: 'SucessoInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                }
            })
            .state('app.registro.manejo.insumo.biologico.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/biologico/views/visualizar.html',
                        controller: 'VisualizarInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, insumoBiologicoService) {
                        return insumoBiologicoService.get($stateParams.id);
                    }
                }
            })
            .state('app.registro.manejo.insumo.biologico.buscar', {
                url: '/buscar?propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/biologico/views/buscar.html',
                        controller: 'BuscarInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    filtros: function (insumoBiologicoService){
                         return insumoBiologicoService.filtrosInsumo();
                    },
                    propriedades: function (insumoBiologicoService){
                         return insumoBiologicoService.queryPropertie();
                    }
                }
            })


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/registro/insumo/biologico');
        $translatePartialLoaderProvider.addPart('app/main/registro');

        //Menu
        msNavigationServiceProvider.saveItem('manejo.insumo.biologico', {
            title: 'Biológico',
            state: 'app.registro.manejo.insumo.biologico.buscar',
            translate: 'BIOLOGICO.BIOLOGICO',
            weight: 1
        });
    }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .factory('unidadeMedidaService', unidadeMedidaService);

     /** @ngInject */
     function unidadeMedidaService($q, api) {


          var service = {
               query: query
          };

          return service;

          function query(args, cache) {

               var deferred = $q.defer();
               deferred.resolve({

                    fertilizante: [
                         'ml',
                         'l',
                         'mg',
                         'g',
                         'kg',
                         'cartela'
                    ],
                    defensivo: [
                         'ml',
                         'l',
                         'mg',
                         'g',
                         'kg',
                         'ton'
                    ],
               });

               return deferred.promise;
          };

     }

})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .factory('insumoBiologicoService', insumoBiologicoService);

     /** @ngInject */
     function insumoBiologicoService($q, $mdToast, $filter, msApi, api, areaService, propertieService) {

          var insumos = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'caderno_campo_propriedade_area_propriedade_nome',
               sort_order: 'asc',

          };
          var modelNew = {
               produto_aplicados: [],
               propriedade_areas: []
          };

          var service = {
               get: get,
               getNew: getNew,
               create: create,
               createSemEstoque: createSemEstoque,
               query: query,
               querySemEstoque: querySemEstoque,
               filtrosInsumo: filtrosInsumo,
               getProdutosAplicados: getProdutosAplicados,
               searchArea: searchArea,
               searchListaAgrofit: searchListaAgrofit,
               deleteInsumo: deleteInsumo,
               getAreaInsumo: getAreaInsumo,
               searchPropertie: searchPropertie,
               recalculaQuantidadeDeProdutoPorArea: recalculaQuantidadeDeProdutoPorArea,
               getAreas: getAreas,
               queryPropertie: queryPropertie,
               getAreasAdd: getAreasAdd,
               getPropriedades: getPropriedades
          };

          return service;

          //////////

          function getNew() {
               return {};
          }


          ////// LISTAR - INSUMO //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.CadernoCampoInsumoBiologicoLista.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - INSUMO //////

          ////// FILTROS INSUMO //////
          function filtrosInsumo() {
               var deferred = $q.defer();

               api.FiltrosInsumoBiologico.get().$promise.then(
               function (response) {
                    deferred.resolve(response);
               }

               ).catch(function (response) {
               deferred.reject(response);
               console.log(response);
               });
               return deferred.promise;
          }

          // SEM CONTROLE DE ESTOQUE /////////////////////////
          function querySemEstoque(args, cache) {
               var deferred = $q.defer();
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;
               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
               api.InsumoBiologicoSemEstoque.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         queryResponse = response;
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    });
               }
               return deferred.promise;
          } /////////////////////////////////////////////////

          ////// CRIAR - INSUMO //////
          function create(model) {

               var deferred = $q.defer();

               api.CadernoCampoInsumoBiologico.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - INSUMO //////

          ////// CRIAR - INSUMO S/ ESTOQUE //////
          function createSemEstoque(model) {

               var deferred = $q.defer();

               api.CadernoCampoInsumoBiologicoSemEstoque.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - INSUMO  S/ ESTOQUE //////


          ////// CONSULTA POR ID - INSUMO //////
          function get(id) {
               var deferred = $q.defer();

               api.CadernoCampoInsumoBiologico.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - INSUMO //////


          ////// DELETAR - INSUMO //////
          function deleteInsumo(id) {
               // Create a new deferred object
               var deferred = $q.defer();
               api.CadernoCampoInsumoBiologico.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);

                    }
               );
               return deferred.promise;
          }

          ////// DELETAR - INSUMO //////


          ////// CONSULTA DE ÁREA - PLANTIO //////
          function getAreaInsumo(id) {
               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE ÁREA - PLANTIO //////


          ////// SELECT - INSUMO //////
          function getProdutosAplicados() {
               return [{
                    id: 1,
                    nome: "Defensivo (Agrotóxico)"
               }, {
                    id: 2,
                    nome: "Fertilizante/Biológico/Natural"
               }]
          };
          ////// SELECT - INSUMO //////


          ////// CONSULTA AGROFIT - INSUMO //////
          function searchListaAgrofit(query) {
               var deferred = $q.defer();

               api.InsumoAgrofit.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA AGROFIT - INSUMO //////


          ////// CONSULTA ÁREA - INSUMO //////
          function searchArea(query) {
               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA ÁREA - INSUMO //////


          ////// CONSULTA PROPRIEDADE - INSUMO //////
          function searchPropertie(query) {
               var deferred = $q.defer();

               api.Propriedade.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA PROPRIEDADE - INSUMO //////


          // Divide a quantidade de produto aplicado por areas
          function recalculaQuantidadeDeProdutoPorArea(totalProduto, unidadeMedida, areas) {

               if (!totalProduto) {
                    totalProduto = 0.0;
               }

               if (areas.length === 0) {
                    return areas;
               }

               var totalArea = 0.0;
               for (var i = 0; i < areas.length; i++) {
                    totalArea += areas[i].area_produtiva;
               }

               for (var i = 0; i < areas.length; i++) {
                    var area = areas[i];
                    area.quantidade = round((area.area_produtiva * totalProduto) / totalArea, 2);
                    area.unidade_medida = unidadeMedida;
               }

               // Calcula diferença e soma na ultima área
               var totalQuantidadeArea = 0.0;
               for (var i = 0; i < areas.length; i++) {
                    var area = areas[i];
                    totalQuantidadeArea += area.quantidade;
               }

               var DiferencaTotalQuantidadeArea = totalProduto - totalQuantidadeArea;

               areas[areas.length - 1].quantidade = round(areas[areas.length - 1].quantidade + DiferencaTotalQuantidadeArea, 2);

               return areas;

          }

          function round(value, decimals) {
               return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
          }

          function getAreas(areaid) {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };


               areaService.fullQuery(args, false).then(function (response) {

                    // filtra por area
                    if (areaid && areaid > 0) {

                         var areas = response.data.filter(function (a) {
                              return a.id == areaid;

                         });

                         if (areas.length > 0) {
                              deferred.resolve(response.data.filter(function (a) {
                                   return a.id == areaid;
                              }));
                         } else {
                              deferred.resolve(response.data);
                         }
                         return;
                    }
                    deferred.resolve(response.data);

               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);

               });

               return deferred.promise;
          }

          function queryPropertie() {

               var deferred = $q.defer();

               api.Propriedade.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getAreasAdd() {
               var deferred = $q.defer();
               api.PropriedadeAreaFiltroInsumo.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getPropriedades() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               propertieService.query(args, false).then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }
     }

})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .controller('VisualizarInsumoBiologicoController', VisualizarInsumoBiologicoController);

     /** @ngInject */
     function VisualizarInsumoBiologicoController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .controller('SucessoInsumoBiologicoController', SucessoInsumoBiologicoController);

     /** @ngInject */
     function SucessoInsumoBiologicoController($state, $mdDialog, $rootScope, $filter, $scope) {
          var vm = this;

          // Data

          // Methods
          vm.gotoList = gotoList;
          vm.gotoAplicarInsumoBiologico = gotoAplicarInsumoBiologico;
          vm.gotoHistorico = gotoHistorico;
          vm.gotoHome = gotoHome;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoList() {
              $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoAplicarInsumoBiologico() {
               $state.go('app.registro.manejo.insumo.biologico.criar');
          }

          function gotoHistorico() {
               $state.go('app.relatorios.insumos.buscar');
          }

          function gotoHome() {
               $state.go('app.home');
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .controller('CriarSemEstoqueBiologicoController', CriarSemEstoqueBiologicoController);

     /** @ngInject */
     function CriarSemEstoqueBiologicoController($rootScope, areas, $filter, $state, insumoBiologicoService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = {};
          vm.areas = areas;
          vm.status = [];
          vm.isDisabled = false;
          vm.api_response_erro = {};
          vm.productStock = [];
          vm.step = 1;
          vm.total_area_produtiva = 0;

          // Methods
          vm.addProducts = addProducts;
          vm.removeProducts = removeProducts;
          vm.searchProductStock = searchProductStock;
          vm.changeProduto = changeProduto;
          vm.getModelConsolidado = getModelConsolidado();


          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.gotoSucesso = gotoSucesso;
          vm.gotoVoltar = gotoVoltar;
          vm.gotoStep = gotoStep;
          vm.savePromise = null;
          vm.areaSelecionada = null;
          vm.cancelClick = cancelClick;

          //////////

          init();

          function init() {

               vm.model.propriedade_areas = new Array();
               vm.model.produtos = new Array();

               vm.date = new Date();

               checkAreas();

               // Cria um novo produto.
               addProducts();
          }

          function addProducts() {
               vm.model.produtos.push({
                    insumo_agricola_nome: "",
                    quantidade: ""
               });
          }

          function removeProducts(index) {
               vm.model.produtos.splice(index, 1);
          }

          function searchProductStock() {

               var args = {
                    loading: false,
               };

               $rootScope.loadingProgress = true;

               insumoBiologicoService.querySemEstoque(args).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productStock = response.data;
                    console.log('procura stock', response)
                    if (response.data.length == 0)
                         EstoqueNaoEncontrado();

               }).catch(function (response) {

                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    EstoqueNaoEncontrado();
               });
          }

          function changeProduto(produto) {
               produto.insumo_estoque_rateio = undefined;
               produto.estoque_insumo_rateio_id = undefined;
               produto.quantidade = 0;
               produto.valor = 0;
               produto.estoque_insumo_id = produto.insumo_estoque.id;
               produto.tipo_medida_id = produto.insumo_estoque.tipo_medida.id;

               console.log('change produto', produto);

               // coloca o nome do insumo agricola.
               produto.insumo_agricola_nome = produto.insumo_estoque.nome;
           }

          function save(form) {

               if (form.$invalid) {
                    return;
               }
               console.log('save data', vm.model);
               //return

               this.savePromise = insumoBiologicoService.createSemEstoque(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    //vm.model.id = response.id;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent($filter('translate')('BIOLOGICO.BIOLOGICOCREATED'))
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );

                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = '';
                         for (let prop in response.data.errors) {
                              err += response.data.errors[prop];
                         }

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });

          }

          function checkAreas() {

               if(vm.areas.length == 0)
                    AreaNaoEncontrado();
               else
                    searchProductStock();
          }

          function gotoEstoqueBiologico() {
               $state.go('app.estoque_insumo.biologico.criar');
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoSucesso(){
               $state.go('app.registro.manejo.insumo.biologico.sucesso');
          }

          function gotoVoltar() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoCreateArea() {
               $state.go('app.registro.area.criar');
          }

          function gotoStep(step) {
               vm.step = step;

               // atualiza a lista dos dados consolidados.
               getModelConsolidado();

               // Passando valores das quantidades finais em cada produto por área para o post
               for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                    var area = vm.model.propriedade_areas[index];
                    var produto = vm.areas_consolidadas[index];
                    if(area.id == produto.area.id){
                         vm.model.propriedade_areas[index].produtos = produto.produtos[0].produtos
                    }
               }
          }

          function getModelConsolidado() {
               vm.areas_consolidadas = [];

               console.log('getModelCosolidado', vm.model);

               if (vm.model.propriedade_areas) {

                    for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                         var area = vm.model.propriedade_areas[index];
                         var produto_peso = {
                              quantidades: 0,
                              produtos: []
                         };

                         for (var indexInsumo = 0; indexInsumo < vm.model.produtos.length; indexInsumo++) {
                              var produto = vm.model.produtos[indexInsumo];

                              var quantidade = produto.quantidade * (area.area_produtiva / vm.total_area_produtiva);
                              var valor = produto.valor * (area.area_produtiva / vm.total_area_produtiva);

                              var obj = {
                                   produto: produto,
                                   valor: ArredondaResultadoValor(valor),
                                   quantidade: ArredondaResultadoQuantidade(quantidade),
                                   quantidade_original: quantidade,
                                   valor_original: valor,
                                   area_id: area.id
                              }
                              produto_peso.produtos.push(obj);
                              produto_peso.quantidades += quantidade;
                         }

                         vm.areas_consolidadas.push({
                              area: area,
                              produtos: [
                                   produto_peso,
                              ]
                         });
                    }
               }
          }

          function ArredondaResultadoQuantidade(value){
               if(value < 0.0005){
                    return 0.001
               }else{
                    return value
               }
          }
          function ArredondaResultadoValor(value){
               if(value < 0.005){
                    return 0.01
               }else{
                    return value
               }
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function EstoqueNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Produto não encontrado')
                    .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueBiologico();
               }, function () {
                    // gotoSearch();
               });
          }

          function AreaNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Área não encontrado')
                    .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoCreateArea();
               }, function () {
                    // gotoSearch();
               });
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .controller('CriarInsumoBiologicoController', CriarInsumoBiologicoController);

     /** @ngInject */
     function CriarInsumoBiologicoController($rootScope, $scope, areas, $filter, $state, insumoBiologicoService, estoqueInsumoBiologicoService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = {};
          vm.areas = areas;
          vm.status = [];
          vm.isDisabled = false;
          vm.api_response_erro = {};
          vm.productStock = [];
          vm.step = 1;
          vm.total_area_produtiva = 0;

          // Methods
          vm.addProducts = addProducts;
          vm.removeProducts = removeProducts;
          vm.searchProductStock = searchProductStock;
          vm.changeProduto = changeProduto;
          vm.changeRateio = changeRateio;
          vm.changeQuantidade = changeQuantidade;
          vm.openModalEstoque = openModalEstoque;

          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.gotoSucesso = gotoSucesso;
          vm.gotoVoltar = gotoVoltar;
          vm.gotoStep = gotoStep;
          vm.savePromise = null;
          vm.areaSelecionada = null;
          vm.cancelClick = cancelClick;
          vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;

          //////////

          init();

          function init() {

               vm.model.propriedade_areas = new Array();
               vm.model.produtos = new Array();

               vm.date = new Date();

               checkAreas();

               // Cria um novo produto.
               addProducts();
          }

          function addProducts() {
               vm.model.produtos.push({
                    insumo_agricola_nome: "",
                    quantidade: ""
               });
          }

          function removeProducts(index) {
               vm.model.produtos.splice(index, 1);
          }

          function searchProductStock() {

               var args = {
                    loading: false
               };

               $rootScope.loadingProgress = true;

               estoqueInsumoBiologicoService.query150(args).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productStock = response.data.estoques_insumo_model;
                    console.log('procura stock', vm.productStock)
                    if (response.data.estoques_insumo_model.length == 0)
                         EstoqueNaoEncontrado();

               }).catch(function (response) {

                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    EstoqueNaoEncontrado();
               });
          }

          function searchRateioProductStock(produto) {
               $rootScope.loadingProgress = true;

               estoqueInsumoBiologicoService
                    .queryRateio150(produto.insumo_estoque.id, produto.insumo_estoque.insumo_id, produto.insumo_estoque.tipo_medida_id)
                    .then(function (response) {
                         console.log('rateio', response)
                         $rootScope.loadingProgress = false;
                         produto.rateioProductStock = response;

                         if (response.length == 1) {
                              produto.insumo_estoque_rateio = response[0]
                              changeRateio(produto);
                         } else if (response.length == 0)
                              RateioInsuficiente(produto);

                    }).catch(function (response) {
                         $rootScope.loadingProgress = false;
                         vm.api_response_erro = response;
                    });
          }

          function changeProduto(produto) {

               produto.insumo_estoque_rateio = undefined;
               produto.estoque_insumo_rateio_id = undefined;
               produto.quantidade = 0;
               produto.estoque_insumo_id = produto.insumo_estoque.id;
               produto.tipo_medida_id = produto.insumo_estoque.tipo_medida_id;

               // coloca o nome do insumo agricola.
               produto.insumo_agricola_nome = produto.insumo_estoque.insumo_nome;
          }

          function changeRateio(produto) {

               produto.estoque_insumo_rateio_id = produto.insumo_estoque_rateio.id
               vm.model.estoque_insumo_rateio_id = produto.insumo_estoque_rateio.id

               changeQuantidadeOuUnidadeDeMedida(produto)
          }

          function changeQuantidade(produto) {

               changeQuantidadeOuUnidadeDeMedida(produto);
          }

          function changeQuantidadeOuUnidadeDeMedida(produto) {

               if (produto.insumo_estoque.quantidade < produto.quantidade)
                    EstoqueInsuficiente(produto);

               // Verificar se deve ser feito o calculo.
               produto.valor = (produto.insumo_estoque.valor / produto.insumo_estoque.quantidade) * produto.quantidade;

               if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                    $scope.$apply();
               }
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               console.log('model save', vm.model);
               //return

               this.savePromise = insumoBiologicoService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    //vm.model.id = response.id;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent($filter('translate')('BIOLOGICO.BIOLOGICOCREATED'))
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );

                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = '';
                         for (let prop in response.data.errors) {
                              err += response.data.errors[prop];
                         }

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });

          }

          function checkAreas() {

               if(vm.areas.length == 0)
                    AreaNaoEncontrado();
               else
                    searchProductStock();
          }

          function gotoEstoqueBiologico() {
               $state.go('app.estoque_insumo.biologico.criar');
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoSucesso(){
               $state.go('app.registro.manejo.insumo.biologico.sucesso');
          }

          function gotoVoltar() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoCreateArea() {
               $state.go('app.registro.area.criar');
          }

          function gotoStep(step) {
               vm.step = step;

               // atualiza a lista dos dados consolidados.
               getModelConsolidado();

               // Passando valores das quantidades finais em cada produto por área para o post
               for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                    var area = vm.model.propriedade_areas[index];
                    var produto = vm.areas_consolidadas[index];
                    if(area.id == produto.area.id){
                         vm.model.propriedade_areas[index].produtos = produto.produtos[0].produtos
                    }
               }
          }

          function getModelConsolidado() {
               vm.areas_consolidadas = [];

               console.log('getModelCosolidado', vm.model);

               if (vm.model.propriedade_areas) {

                    for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                         var area = vm.model.propriedade_areas[index];
                         var produto_peso = {
                              quantidades: 0,
                              produtos: []
                         };

                         for (var indexInsumo = 0; indexInsumo < vm.model.produtos.length; indexInsumo++) {
                              var produto = vm.model.produtos[indexInsumo];

                              // separar cálculo que vai para o post s/ tratamento
                              var quantidade = produto.quantidade * (area.area_produtiva / vm.total_area_produtiva);

                              //Math.round(quantidade * 10000)/10000
                              var obj = {
                                   produto: produto,
                                   valor: produto.valor * (area.area_produtiva / vm.total_area_produtiva),
                                   quantidade: ArredondaResultado(quantidade),
                                   quantidade_original: quantidade,
                                   area_id: area.id
                              }
                              produto_peso.produtos.push(obj);
                              produto_peso.quantidades += quantidade;
                         }

                         vm.areas_consolidadas.push({
                              area: area,
                              produtos: [
                                   produto_peso
                              ]
                         });
                    }
               }
          }

          function ArredondaResultado(value){
               if(value < 0.0005){
                    return 0.001
               }else{
                    return value
               }
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function EstoqueNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Produto não encontrado')
                    .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueBiologico();
               }, function () {
                    // gotoSearch();
               });
          }

          function AreaNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Área não encontrado')
                    .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoCreateArea();
               }, function () {
                    // gotoSearch();
               });
          }

          function EstoqueInsuficiente(produto) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estoque insuficiente')
                    .textContent('Você não possui estoque suficiente deste produto para fazer a aplicação. O que gostaria de fazer agora?')
                    // .targetEvent(ev)
                    .ok('Cadastrar novo insumo!')
                    .cancel('Voltar');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueBiologico();
               }, function () {
                    // gotoSearch();
               });
          }

          function RateioInsuficiente(produto) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Insumo insuficiente em estoque')
                    .textContent('O insumo ' + produto.insumo_estoque.insumo.nome + ' não está mais disponível. Deseja adicionar mais insumo no estoque.?')
                    // .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueBiologico();
               }, function () {
                    // gotoSearch();
               });
          }

          function openModalEstoque(produto){
               $mdDialog.show({
                    locals:{dataToPass: produto},
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/insumo/biologico/views/modal_estoque.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
          }
          function mdDialogCtrl($scope, $mdDialog, dataToPass) {
               // Consulta o rateio do produto.
               searchRateioProductStock(dataToPass);
               $scope.dataModal = dataToPass;
               console.log('estoque', dataToPass);

               $scope.hide = function () {
                    $mdDialog.hide();
               };
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.biologico')
          .controller('BuscarInsumoBiologicoController', BuscarInsumoBiologicoController);

     /** @ngInject */
     function BuscarInsumoBiologicoController(propriedades, clientePerfilService, filtros, $filter, insumoBiologicoService, $state, $mdDialog, $mdToast) {

          var vm = this;

          // Status
          vm.loadingProgress = false;
          vm.activeFilters = false;

          // Data
          vm.models = null;
          vm.filtros = filtros;
          vm.propriedades = propriedades;

          // Methods
          vm.gotoAdd = gotoAdd;
          vm.gotoVisualizar = gotoVisualizar;
          vm.resetFilters = resetFilters;
          vm.deletarConfirm = deletarConfirm;
          vm.viewTutorial = viewTutorial;

          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          //////////

          init();

          function init() {

               clientePerfilService.getAtivo().then(function (response) {
                    vm.clientePerfil = response;
                    console.log('CLIENTE DADOS', vm.clientePerfil);
               });

               if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',
               insumo_agricola: null,
               data_aplicacao: null,
               propriedade_area_id: null,
               Propriedade_Id: null,
               _change: change
          }

          vm.args._change();


          function change() {
               vm.args.loading = true;
               insumoBiologicoService.query(vm.args).then(function (response) {
                    vm.models = response.listagem;

                    vm.args.total_rows = response.total_itens;
                    vm.args.length_rows = vm.models.length;
                    showActiveFilters();
                    vm.args.updatePaggination();

               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               vm.args.insumo_agricola = null;
               vm.args.propriedade_area_id = null;
               vm.args.data_aplicacao = null;
               change();
          }

          function showActiveFilters() {
               vm.activeFilters = null;
               let arr = null;
               let dataAplicacao = $filter('date')(vm.args.data_aplicacao, 'dd/MM/yyyy');
               let counter = 0;
               arr = [{
                         description: vm.args.propriedade_area_id,
                         value: 'propriedade_area_id'
                    },
                    {
                         description: vm.args.insumo_agricola,
                         value: 'insumo_agricola'
                    },
                    {
                         description: dataAplicacao,
                         value: 'data_aplicacao'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if (counter > 0) {
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value) {
               vm.args[value] = null;
               change();
          }

          function viewTutorial() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/insumo/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
          }

          function mdDialogCtrl($scope, $mdDialog) {

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                    .title('Deletar insumo biológico?')
                    .textContent('Tem certeza que deseja deletar o insumo biológico?')
                    .targetEvent(model)
                    .ok('Sim, quero deletar!')
                    .cancel('Não, não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          }

          function deletar(model) {
               insumoBiologicoService.deleteInsumo(model.id)
                    .then(function (response) {
                         var message = $filter('translate')('BIOLOGICO.DELETE');
                         vm.models.splice(vm.models.indexOf(model), 1);
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         //console.log('erro', response.data.detail);
                         var message = response.data.detail;
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }



          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function gotoAdd(is_estoque_automatico) {
               //console.log('is_estoque_automatico', is_estoque_automatico);
               if(is_estoque_automatico){
                    $state.go('app.registro.manejo.insumo.biologico.criar');
               }else{
                    $state.go('app.registro.manejo.insumo.biologico.criar_sem_estoque');
               }

          }

          function gotoVisualizar(id) {
               $state.go('app.registro.manejo.insumo.biologico.visualizar', {
                    id: id
               });
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }

          function cadastroPropriedadeConfirm() {

               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }
     }


})();

(function () {
    'use strict';

    angular
        .module('app.insumo.fertilizante', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
        // State
        $stateProvider
            .state('app.registro.manejo.insumo.fertilizante', {
                abstract: true,
                url: '/fertilizante'
            })
            .state('app.registro.manejo.insumo.fertilizante.criar', {
                url: '/criar?propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/fertilizante/views/criar.html',
                        controller: 'CriarInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    areas: function (insumoFertilizanteService) {
                         return insumoFertilizanteService.getAreasAdd();
                    }
                }
            })
            .state('app.registro.manejo.insumo.fertilizante.criar_sem_estoque', {
               url: '/criar_sem_estoque',
               views: {
                   'content@app': {
                       templateUrl: 'app/main/registro/insumo/fertilizante/views/criar_sem_estoque.html',
                       controller: 'CriarSemEstoqueFertilizanteController as vm'
                   }
               },
               resolve: {
                   model: function (insumoFertilizanteService) {
                       return insumoFertilizanteService.getNew();
                   },
                   unidade_medida: function (estoqueInsumoFertilizanteService) {
                       return estoqueInsumoFertilizanteService.getUnidadesMedidas();
                   },
                   areas: function (insumoFertilizanteService) {
                        return insumoFertilizanteService.getAreasAdd();
                   }
               }
           })
            .state('app.registro.manejo.insumo.fertilizante.sucesso', {
                url: '/sucesso',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/fertilizante/views/sucesso.html',
                        controller: 'SucessoInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                }
            })
            .state('app.registro.manejo.insumo.fertilizante.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/fertilizante/views/visualizar.html',
                        controller: 'VisualizarInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, insumoFertilizanteService) {
                        return insumoFertilizanteService.get($stateParams.id);
                    }
                }
            })
            .state('app.registro.manejo.insumo.fertilizante.buscar', {
                url: '/buscar?propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/insumo/fertilizante/views/buscar.html',
                        controller: 'BuscarInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    filtros: function (insumoFertilizanteService){
                         return insumoFertilizanteService.filtrosInsumo();
                    },
                    propriedades: function (insumoDefensivoService){
                         return insumoDefensivoService.queryPropertie();
                    }
                }
            })


        // Translation
        $translatePartialLoaderProvider.addPart('app/main/registro/insumo/fertilizante');
        $translatePartialLoaderProvider.addPart('app/main/registro');

        //Menu
        msNavigationServiceProvider.saveItem('manejo.insumo.fertilizante', {
            title: 'Insumo',
            state: 'app.registro.manejo.insumo.fertilizante.buscar',
            translate: 'FERTILIZANTE.FERTILIZANTE',
            weight: 3
        });
    }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.fertilizante')
          .factory('unidadeMedidaService', unidadeMedidaService);

     /** @ngInject */
     function unidadeMedidaService($q, api) {


          var service = {
               query: query
          };

          return service;

          function query(args, cache) {

               var deferred = $q.defer();
               deferred.resolve({

                    fertilizante: [
                         'ml',
                         'l',
                         'mg',
                         'g',
                         'kg',
                         'cartela'
                    ],
                    defensivo: [
                         'ml',
                         'l',
                         'mg',
                         'g',
                         'kg',
                         'ton'
                    ],
               });

               return deferred.promise;
          };

     }

})();

(function () {
     'use strict';

     angular
          .module('app.insumo.fertilizante')
          .factory('insumoFertilizanteService', insumoFertilizanteService);

     /** @ngInject */
     function insumoFertilizanteService($q, $mdToast, $filter, msApi, api, areaService, propertieService) {

          var insumos = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'caderno_campo_propriedade_area_propriedade_nome',
               sort_order: 'asc',

          };
          var modelNew = {
               produto_aplicados: [],
               propriedade_areas: []
          };

          var service = {
               get: get,
               getNew: getNew,
               create: create,
               createSemEstoque: createSemEstoque,
               query: query,
               querySemEstoque: querySemEstoque,
               getProdutosAplicados: getProdutosAplicados,
               searchArea: searchArea,
               searchListaAgrofit: searchListaAgrofit,
               deleteInsumo: deleteInsumo,
               getAreaInsumo: getAreaInsumo,
               searchPropertie: searchPropertie,
               recalculaQuantidadeDeProdutoPorArea: recalculaQuantidadeDeProdutoPorArea,
               getAreas: getAreas,
               getAreasAdd: getAreasAdd,
               queryPropertie: queryPropertie,
               filtrosInsumo: filtrosInsumo,
               getPropriedades: getPropriedades
          };

          return service;

          //////////

          function getNew() {
               return {};
          }


          ////// LISTAR - INSUMO //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.CadernoCampoInsumoFertilizanteLista.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - INSUMO //////

          // SEM CONTROLE DE ESTOQUE /////////////////////////
          function querySemEstoque(args, cache) {
               var deferred = $q.defer();
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;
               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
               api.InsumoFertilizanteSemEstoque.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         queryResponse = response;
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    });
               }
               return deferred.promise;
          } /////////////////////////////////////////////////


          ////// CRIAR - INSUMO //////
          function create(model) {

               var deferred = $q.defer();

               api.CadernoCampoInsumoFertilizante.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - INSUMO //////

          ////// CRIAR - INSUMO S/ ESTOQUE //////
          function createSemEstoque(model) {

               var deferred = $q.defer();

               api.CadernoCampoInsumoFertilizanteSemEstoque.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - INSUMO  S/ ESTOQUE //////


          ////// CONSULTA POR ID - INSUMO //////
          function get(id) {
               var deferred = $q.defer();

               api.CadernoCampoInsumoFertilizante.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - INSUMO //////


          ////// DELETAR - INSUMO //////
          function deleteInsumo(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.CadernoCampoInsumoFertilizante.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);

                    }
               );
               return deferred.promise;
          }

          ////// DELETAR - INSUMO //////


          ////// CONSULTA DE ÁREA - PLANTIO //////
          function getAreaInsumo(id) {
               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE ÁREA - PLANTIO //////


          ////// SELECT - INSUMO //////
          function getProdutosAplicados() {
               return [{
                    id: 1,
                    nome: "Defensivo (Agrotóxico)"
               }, {
                    id: 2,
                    nome: "Fertilizante/Biológico/Natural"
               }]
          };
          ////// SELECT - INSUMO //////


          ////// CONSULTA AGROFIT - INSUMO //////
          function searchListaAgrofit(query) {
               var deferred = $q.defer();

               api.CadernoCampoInsumoDefensivoAgrofit.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA AGROFIT - INSUMO //////


          ////// CONSULTA ÁREA - INSUMO //////
          function searchArea(query) {
               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA ÁREA - INSUMO //////


          ////// CONSULTA PROPRIEDADE - INSUMO //////
          function searchPropertie(query) {
               var deferred = $q.defer();

               api.Propriedade.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA PROPRIEDADE - INSUMO //////


          // Divide a quantidade de produto aplicado por areas
          function recalculaQuantidadeDeProdutoPorArea(totalProduto, unidadeMedida, areas) {

               if (!totalProduto) {
                    totalProduto = 0.0;
               }

               if (areas.length === 0) {
                    return areas;
               }

               var totalArea = 0.0;
               for (var i = 0; i < areas.length; i++) {
                    totalArea += areas[i].area_produtiva;
               }

               for (var i = 0; i < areas.length; i++) {
                    var area = areas[i];
                    area.quantidade = round((area.area_produtiva * totalProduto) / totalArea, 2);
                    area.unidade_medida = unidadeMedida;
               }

               // Calcula diferença e soma na ultima área
               var totalQuantidadeArea = 0.0;
               for (var i = 0; i < areas.length; i++) {
                    var area = areas[i];
                    totalQuantidadeArea += area.quantidade;
               }

               var DiferencaTotalQuantidadeArea = totalProduto - totalQuantidadeArea;

               areas[areas.length - 1].quantidade = round(areas[areas.length - 1].quantidade + DiferencaTotalQuantidadeArea, 2);

               return areas;

          }

          function round(value, decimals) {
               return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
          }

          function getAreas(areaid) {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };


               areaService.fullQuery(args, false).then(function (response) {

                    // filtra por area
                    if (areaid && areaid > 0) {

                         var areas = response.data.filter(function (a) {
                              return a.id == areaid;

                         });

                         if (areas.length > 0) {
                              deferred.resolve(response.data.filter(function (a) {
                                   return a.id == areaid;
                              }));
                         } else {
                              deferred.resolve(response.data);
                         }
                         return;
                    }
                    deferred.resolve(response.data);

               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);

               });

               return deferred.promise;
          }

          function queryPropertie() {
               var deferred = $q.defer();
               api.Propriedade.query({}).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          ////// FILTROS INSUMO //////
          function filtrosInsumo() {
               var deferred = $q.defer();
               api.FiltrosInsumoFertilizante.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getPropriedades() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               propertieService.query(args, false).then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }

          function getAreasAdd() {
               var deferred = $q.defer();
               api.PropriedadeAreaFiltroInsumo.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }


     }

})();

(function () {
     'use strict';

     angular
          .module('app.insumo.fertilizante')
          .controller('VisualizarInsumoFertilizanteController', VisualizarInsumoFertilizanteController);

     /** @ngInject */
     function VisualizarInsumoFertilizanteController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.fertilizante')
          .controller('SucessoInsumoFertilizanteController', SucessoInsumoFertilizanteController);

     /** @ngInject */
     function SucessoInsumoFertilizanteController($state) {
          var vm = this;

          // Data

          // Methods
          vm.gotoList = gotoList;
          vm.gotoAplicarInsumoFertilizante = gotoAplicarInsumoFertilizante;
          vm.gotoHistorico = gotoHistorico;
          vm.gotoHome = gotoHome;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoList() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
           }

          function gotoAplicarInsumoFertilizante() {
               $state.go('app.registro.manejo.insumo.fertilizante.criar');
          }

          function gotoHistorico() {
               $state.go('app.relatorios.insumos.buscar');
          }

          function gotoHome() {
               $state.go('app.home');
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo.fertilizante')
          .controller('CriarSemEstoqueFertilizanteController', CriarSemEstoqueFertilizanteController);

     /** @ngInject */
     function CriarSemEstoqueFertilizanteController(model, areas, $rootScope, $scope, $filter, $state, insumoFertilizanteService, estoqueInsumoFertilizanteService, $mdToast, $mdDialog, unidade_medida) {
          var vm = this;

          // Data
          vm.model = model;
          vm.areas = areas;
          vm.status = [];
          vm.isDisabled = false;
          vm.api_response_erro = {};
          vm.unidadesMedida = unidade_medida;
          vm.productStock = [];
          vm.step = 1;
          vm.total_area_produtiva = 0;

          // Methods
          vm.addProducts = addProducts;
          vm.removeProducts = removeProducts;
          vm.searchProductStock = searchProductStock;
          vm.changeProduto = changeProduto;
          vm.getModelConsolidado = getModelConsolidado();


          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.gotoSucesso = gotoSucesso;
          vm.gotoVoltar = gotoVoltar;
          vm.gotoStep = gotoStep;
          vm.savePromise = null;
          vm.areaSelecionada = null;
          vm.cancelClick = cancelClick;

          //////////

          init();

          function init() {

               vm.model.propriedade_areas = new Array();
               vm.model.produtos = new Array();

               vm.date = new Date();

               checkAreas();

               // Cria um novo produto.
               addProducts();
          }

          function addProducts() {
               vm.model.produtos.push({
                    insumo_agricola_nome: "",
                    quantidade: "",
                    unidade_medida: ""
               });
          }

          function removeProducts(index) {
               vm.model.produtos.splice(index, 1);
          }

          function searchProductStock() {

               var args = {
                    loading: false,
                    //page: 1,
                    //per_page: 9999
               };

               $rootScope.loadingProgress = true;

               insumoFertilizanteService.querySemEstoque(args).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productStock = response.data;
                    console.log('procura stock', vm.productStock)
                    if (response.data.length == 0)
                         EstoqueNaoEncontrado();

               }).catch(function (response) {

                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    EstoqueNaoEncontrado();
               });
          }


          function changeProduto(produto) {
               produto.insumo_estoque_rateio = undefined;
               produto.estoque_insumo_rateio_id = undefined;
               produto.quantidade = 0;
               produto.valor = 0;
               produto.estoque_insumo_id = produto.insumo_estoque.id;
               produto.tipo_medida_id = produto.insumo_estoque.tipo_medida.id;

               console.log('change produto', produto);

               // coloca o nome do insumo agricola.
               produto.insumo_agricola_nome = produto.insumo_estoque.nome;
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               console.log('save data', vm.model);
               //return

               this.savePromise = insumoFertilizanteService.createSemEstoque(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent($filter('translate')('FERTILIZANTE.FERTILIZANTECREATED'))
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = '';
                         for (let prop in response.data.errors) {
                              err += response.data.errors[prop];
                         }

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });
          }

          function checkAreas() {

               if(vm.areas.length == 0)
                    AreaNaoEncontrado();
               else
                    searchProductStock();
          }

          function gotoInsumo() {
               $state.go('app.registro.manejo.insumo.fertilizante.criar');
          }

          function gotoEstoqueFertilizante() {
               $state.go('app.estoque_insumo.fertilizante.criar');
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function gotoSucesso() {
               $state.go('app.registro.manejo.insumo.fertilizante.sucesso');
          }

          function gotoVoltar() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function gotoCreateArea() {
               $state.go('app.registro.area.criar');
          }

          function gotoStep(step) {
               vm.step = step;

               // atualiza a lista dos dados consolidados.
               getModelConsolidado();

               // Passando valores das quantidades finais em cada produto por área para o post
               for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                    var area = vm.model.propriedade_areas[index];
                    var produto = vm.areas_consolidadas[index];
                    if(area.id == produto.area.id){
                         vm.model.propriedade_areas[index].produtos = produto.produtos[0].produtos
                    }
               }
          }

          function getModelConsolidado() {
               vm.areas_consolidadas = [];

               console.log('getModelCosolidado', vm.model);

               if (vm.model.propriedade_areas) {

                    for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                         var area = vm.model.propriedade_areas[index];
                         var produto_peso = {
                              quantidades: 0,
                              produtos: []
                         };

                         for (var indexInsumo = 0; indexInsumo < vm.model.produtos.length; indexInsumo++) {
                              var produto = vm.model.produtos[indexInsumo];

                              var quantidade = produto.quantidade * (area.area_produtiva / vm.total_area_produtiva);
                              var valor = produto.valor * (area.area_produtiva / vm.total_area_produtiva);

                              var obj = {
                                   produto: produto,
                                   valor: ArredondaResultadoValor(valor),
                                   quantidade: ArredondaResultadoQuantidade(quantidade),
                                   quantidade_original: quantidade,
                                   valor_original: valor,
                                   area_id: area.id
                              }

                              produto_peso.produtos.push(obj);
                              produto_peso.quantidades += quantidade;
                         }

                         vm.areas_consolidadas.push({
                              area: area,
                              produtos: [
                                   produto_peso
                              ]
                         });
                    }
               }
          }

          function ArredondaResultadoQuantidade(value){
               if(value < 0.0005){
                    return 0.001
               }else{
                    return value
               }
          }
          function ArredondaResultadoValor(value){
               if(value < 0.005){
                    return 0.01
               }else{
                    return value
               }
          }


          function showConfirm(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Antes de finalizar')
                    .textContent('Gostaria de fazer mais uma aplicação de insumo fertilizante?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoInsumo();
               }, function () {
                    gotoSearch();
               });
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);
               }
          }

          function AreaNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Área não encontrado')
                    .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoCreateArea();
               }, function () {
                    // gotoSearch();
               });
          }

          function EstoqueNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Produto não encontrado')
                    .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueFertilizante();
               }, function () {
                    // gotoSearch();
               });
          }
     }

})();

(function () {
     'use strict';

     angular
          .module('app.insumo.fertilizante')
          .controller('CriarInsumoFertilizanteController', CriarInsumoFertilizanteController);

     /** @ngInject */
     function CriarInsumoFertilizanteController(areas, $rootScope, $scope, $filter, $state, insumoFertilizanteService, estoqueInsumoFertilizanteService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = {};
          vm.areas = areas;
          vm.status = [];
          vm.isDisabled = false;
          vm.api_response_erro = {};
          vm.productStock = [];
          vm.step = 1;
          vm.total_area_produtiva = 0;

          // Methods
          vm.addProducts = addProducts;
          vm.removeProducts = removeProducts;
          vm.changePropriedade = changePropriedade;
          vm.searchProductStock = searchProductStock;

          vm.changeProduto = changeProduto;
          vm.changeRateio = changeRateio;
          vm.changeQuantidade = changeQuantidade;
          vm.getModelConsolidado = getModelConsolidado();
          vm.openModalEstoque = openModalEstoque;



          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.gotoSucesso = gotoSucesso;
          vm.gotoVoltar = gotoVoltar;
          vm.gotoStep = gotoStep;
          vm.savePromise = null;
          vm.areaSelecionada = null;
          vm.cancelClick = cancelClick;
          vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;

          //////////

          init();

          function init() {

               vm.model.propriedade_areas = new Array();
               vm.model.produtos = new Array();

               vm.date = new Date();

               checkAreas();

               // Cria um novo produto.
               addProducts();
          }

          function changePropriedade() {
               // Verificar se realmente deve trocar de propriedade.

               vm.model.propriedade_areas = new Array();
               vm.model.produtos = new Array();

               // Cria um novo produto.
               addProducts();

               searchProductStock();

               // Atualiza dos as areas para selected igual a false, para não carregar já selecionado.
               for (var index = 0; index < vm.propriedadeSelecionada.propriedade_areas.length; index++) {
                    var area = vm.propriedadeSelecionada.propriedade_areas[index];
                    area.selected = false;
               }
          }

          function addProducts() {
               vm.model.produtos.push({
                    insumo_agricola_nome: "",
                    quantidade: ""
               });
          }

          function removeProducts(index) {
               vm.model.produtos.splice(index, 1);
          }

          function searchProductStock() {

               var args = {
                    loading: false
               };

               $rootScope.loadingProgress = true;

               estoqueInsumoFertilizanteService.query150(args).then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.productStock = response.data.estoques_insumo_model;
                    console.log('procura stock', vm.productStock)
                    if (response.data.estoques_insumo_model.length == 0)
                         EstoqueNaoEncontrado();

               }).catch(function (response) {

                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    EstoqueNaoEncontrado();
               });
          }

          function searchRateioProductStock(produto) {

               $rootScope.loadingProgress = true;

               estoqueInsumoFertilizanteService
                    .queryRateio150(produto.insumo_estoque.id, produto.insumo_estoque.insumo_id, produto.insumo_estoque.tipo_medida_id)
                    .then(function (response) {

                         $rootScope.loadingProgress = false;
                         produto.rateioProductStock = response;

                         if (response.length == 1) {
                              produto.insumo_estoque_rateio = response[0]
                              changeRateio(produto);
                         }

                    }).catch(function (response) {
                         $rootScope.loadingProgress = false;
                         vm.api_response_erro = response;
                    });
          }


          function changeProduto(produto) {

               produto.insumo_estoque_rateio = undefined;
               produto.estoque_insumo_rateio_id = undefined;
               produto.quantidade = 0;
               produto.estoque_insumo_id = produto.insumo_estoque.id;
               produto.tipo_medida_id = produto.insumo_estoque.tipo_medida_id;

               // coloca o nome do insumo agricola.
               produto.insumo_agricola_nome = produto.insumo_estoque.insumo_nome;
          }

          function changeRateio(produto) {

               produto.estoque_insumo_rateio_id = produto.insumo_estoque_rateio.id
               vm.model.estoque_insumo_rateio_id = produto.insumo_estoque_rateio.id

               changeQuantidadeOuUnidadeDeMedida(produto)
          }

          function changeQuantidade(produto) {

               changeQuantidadeOuUnidadeDeMedida(produto);
          }

          function changeQuantidadeOuUnidadeDeMedida(produto) {

               if (produto.insumo_estoque.quantidade < produto.quantidade)
                    EstoqueInsuficiente(produto);

               // Verificar se deve ser feito o calculo.
               //produto.valor = (produto.insumo_estoque_rateio.valor / produto.insumo_estoque_rateio.quantidade_origem) * produto.quantidade;

               if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                    $scope.$apply();
               }
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               this.savePromise = insumoFertilizanteService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent($filter('translate')('FERTILIZANTE.FERTILIZANTECREATED'))
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = '';
                         for (let prop in response.data.errors) {
                              err += response.data.errors[prop];
                         }

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });
          }

          function checkAreas() {

               if(vm.areas.length == 0)
                    AreaNaoEncontrado();
               else
                    searchProductStock();
          }

          function gotoInsumo() {
               $state.go('app.registro.manejo.insumo.fertilizante.criar');
          }

          function gotoEstoqueFertilizante() {
               $state.go('app.estoque_insumo.fertilizante.criar');
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function gotoSucesso() {
               $state.go('app.registro.manejo.insumo.fertilizante.sucesso');
          }

          function gotoVoltar() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function gotoCreateArea() {
               $state.go('app.registro.area.criar');
          }

          function gotoStep(step) {
               vm.step = step;

               // atualiza a lista dos dados consolidados.
               getModelConsolidado();

               // Passando valores das quantidades finais em cada produto por área para o post
               for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                    var area = vm.model.propriedade_areas[index];
                    var produto = vm.areas_consolidadas[index];
                    if(area.id == produto.area.id){
                         vm.model.propriedade_areas[index].produtos = produto.produtos[0].produtos
                    }
               }
          }

          function getModelConsolidado() {
               vm.areas_consolidadas = [];

               console.log('getModelCosolidado', vm.model);

               if (vm.model.propriedade_areas) {

                    for (var index = 0; index < vm.model.propriedade_areas.length; index++) {
                         var area = vm.model.propriedade_areas[index];
                         var produto_peso = {
                              quantidades: 0,
                              produtos: []
                         };

                         for (var indexInsumo = 0; indexInsumo < vm.model.produtos.length; indexInsumo++) {
                              var produto = vm.model.produtos[indexInsumo];

                              var quantidade = produto.quantidade * (area.area_produtiva / vm.total_area_produtiva);

                              var obj = {
                                   produto: produto,
                                   valor: produto.valor * (area.area_produtiva / vm.total_area_produtiva),
                                   quantidade: ArredondaResultado(quantidade),
                                   quantidade_original: quantidade,
                                   area_id: area.id
                              }
                              produto_peso.produtos.push(obj);
                              produto_peso.quantidades += quantidade;
                         }

                         vm.areas_consolidadas.push({
                              area: area,
                              produtos: [
                                   produto_peso
                              ]
                         });
                    }
               }
          }

          function ArredondaResultado(value){
               if(value < 0.0005){
                    return 0.001
               }else{
                    return value
               }
          }

          function showConfirm(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Antes de finalizar')
                    .textContent('Gostaria de fazer mais uma aplicação de insumo fertilizante?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoInsumo();
               }, function () {
                    gotoSearch();
               });
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);
               }
          }

          function AreaNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Área não encontrado')
                    .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoCreateArea();
               }, function () {
                    // gotoSearch();
               });
          }

          function EstoqueNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Produto não encontrado')
                    .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueFertilizante();
               }, function () {
                    // gotoSearch();
               });
          }

          function EstoqueInsuficiente(produto) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estoque insuficiente')
                    .textContent('Você não possui estoque suficiente deste produto para fazer a aplicação. O que gostaria de fazer agora?')
                    // .targetEvent(ev)
                    .ok('Cadastrar novo insumo!')
                    .cancel('Voltar');

               $mdDialog.show(confirm).then(function () {
                    gotoEstoqueFertilizante();
               }, function () {
                    // gotoSearch();
               });
          }

          function convertToDecimalCase(number, decimal) {
               var n = parseFloat(number);

               if (Number.isInteger(n)) {
                    return n;
               } else {
                    if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                         return parseInt(number);

                    return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', {
                         minimumFractionDigits: 2
                    });
               }
          }

          function openModalEstoque(produto){
               $mdDialog.show({
                    locals:{dataToPass: produto},
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/insumo/fertilizante/views/modal_estoque.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
          }
          function mdDialogCtrl($scope, $mdDialog, dataToPass) {
               // Consulta o rateio do produto.
               searchRateioProductStock(dataToPass);
               $scope.dataModal = dataToPass;
               console.log('estoque', dataToPass);

               $scope.hide = function () {
                    $mdDialog.hide();
               };
          }
     }

})();

(function () {
    'use strict';

    angular
        .module('app.insumo.fertilizante')
        .controller('BuscarInsumoFertilizanteController', BuscarInsumoFertilizanteController);

    /** @ngInject */
    function BuscarInsumoFertilizanteController(propriedades, clientePerfilService, filtros, $filter, insumoFertilizanteService, $state, $mdDialog, $mdToast) {

        var vm = this;

        // Status
        vm.loadingProgress = false;
        vm.activeFilters = false;

        // Data
        vm.models = null;
        vm.filtros = filtros;
        vm.propriedades = propriedades;

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoVisualizar = gotoVisualizar;
        vm.resetFilters = resetFilters;
        vm.deletarConfirm = deletarConfirm;
        vm.viewTutorial = viewTutorial;

        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        //////////

        init();

        function init() {
          clientePerfilService.getAtivo().then(function (response) {
               vm.clientePerfil = response;
               console.log('CLIENTE DADOS', vm.clientePerfil);
          });

          if (vm.propriedades == undefined || vm.propriedades.length == 0)
               cadastroPropriedadeConfirm();
        }

        function deletarConfirm(model) {
            var confirm = $mdDialog.confirm()
                .title('Deletar insumo de fertilizante?')
                .textContent('Tem certeza que deseja deletar o insumo de fertilizante?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não, não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }


        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/registro/insumo/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function deletar(model) {
            insumoFertilizanteService.deleteInsumo(model.id)
                .then(function (response) {
                    var message = $filter('translate')('FERTILIZANTE.DELETE');
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function (response) {
                    //var message = $filter('translate')('FERTILIZANTE.ERRO_DELETE');
                    console.log(response);
                    var message = response.data.detail;
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            Propriedade_Id: null,
            insumo_agricola: null,
            data_aplicacao: null,
            propriedade_area_id: null,
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            insumoFertilizanteService.query(vm.args).then(function (response) {
                vm.models = response.listagem;

                vm.args.total_rows = response.total_itens;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();


            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function resetFilters() {
            vm.args.insumo_agricola = null;
            vm.args.propriedade_area_id = null;
            vm.args.data_aplicacao = null;
            change();
        }

        function showActiveFilters(){
            vm.activeFilters = null;
            let arr = null;
            let dataAplicacao = $filter('date')(vm.args.data_aplicacao,'dd/MM/yyyy');
            let counter = 0;
            arr = [
                 {
                      description: vm.args.propriedade_area_id,
                      value: 'propriedade_area_id'
                 },
                 {
                      description: vm.args.insumo_agricola,
                      value: 'insumo_agricola'
                 },
                 {
                      description: dataAplicacao,
                      value: 'data_aplicacao'
                  }
            ];

            for (let i = 0; i < arr.length; i++) {
                 if (arr[i].description != null) counter++;
            }

            if(counter > 0){
                 vm.activeFilters = arr;
            }
          }

          function desableFilter(value){
            vm.args[value] = null;
            change();
          }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {

                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();

        }

        function gotoAdd(is_estoque_automatico) {
          if(is_estoque_automatico){
               $state.go('app.registro.manejo.insumo.fertilizante.criar');
          }else{
               $state.go('app.registro.manejo.insumo.fertilizante.criar_sem_estoque');
          }

        }

        function gotoVisualizar(id) {
            $state.go('app.registro.manejo.insumo.fertilizante.visualizar', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }
    }


})();

(function () {
     'use strict';

     angular
          .module('app.insumo.defensivo')
          .factory('unidadeMedidaService', unidadeMedidaService);

     /** @ngInject */
     function unidadeMedidaService($q, api) {


          var service = {
               query: query
          };

          return service;

          function query(args, cache) {

               var deferred = $q.defer();
               deferred.resolve({

                    fertilizante: [
                         'ml',
                         'l',
                         'mg',
                         'g',
                         'kg',
                         'cartela'
                    ],
                    defensivo: [
                         'ml',
                         'l',
                         'mg',
                         'g',
                         'kg',
                         'ton'
                    ],
               });

               return deferred.promise;
          };

     }

})();

(function () {
     'use strict';

     angular
          .module('app.insumo.defensivo')
          .factory('insumoDefensivoService', insumoDefensivoService);

     /** @ngInject */
     function insumoDefensivoService($q, $mdToast, $filter, msApi, api, areaService, propertieService) {

          var insumos = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'caderno_campo_propriedade_area_propriedade_nome',
               sort_order: 'asc',

          };
          var modelNew = {
               produto_aplicados: [],
               propriedade_areas: []
          };

          var service = {
               get: get,
               getNew: getNew,
               create: create,
               createSemEstoque: createSemEstoque,
               query: query,
               querySemEstoque: querySemEstoque,
               getProdutosAplicados: getProdutosAplicados,
               searchArea: searchArea,
               searchListaAgrofit: searchListaAgrofit,
               deleteInsumo: deleteInsumo,
               getAreaInsumo: getAreaInsumo,
               searchPropertie: searchPropertie,
               recalculaQuantidadeDeProdutoPorArea: recalculaQuantidadeDeProdutoPorArea,
               getAreas: getAreas,
               queryPropertie: queryPropertie,
               filtrosInsumo: filtrosInsumo,
               getAreasAdd: getAreasAdd,
               getPropriedades: getPropriedades,
               rateio: rateio
          };

          return service;

          //////////

          function getNew() {
               return {};
          }

          function rateio(estoqueInsumoId, insumoId, unidadeMedidaId) {
               var deferred = $q.defer();
               var args = {
                   estoqueInsumoId: estoqueInsumoId,
                   insumoId: insumoId,
                   unidadeMedidaId: unidadeMedidaId
               };
               api.EstoqueInsumoRateioDefensivo
                   .query(args).$promise
                   .then(function (response) {
                       deferred.resolve(response.data);
                   }).catch(function (response) {
                       deferred.reject(response);
                   });
               return deferred.promise;
           }


          ////// LISTAR - INSUMO //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    // api.Insumo.query(args).$promise.then(
                    api.CadernoCampoInsumoDefensivoLista.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - INSUMO //////


          ////// CRIAR - INSUMO //////
          function create(model) {

               var deferred = $q.defer();

               // api.Insumo.save(model).$promise.then(
               api.CadernoCampoInsumoDefensivo.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CRIAR - INSUMO //////

          // SEM CONTROLE DE ESTOQUE /////////////////////////
          function querySemEstoque(args, cache) {
               var deferred = $q.defer();
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;
               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
               api.InsumoDefensivoSemEstoque.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         queryResponse = response;
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    });
               }
               return deferred.promise;
          } /////////////////////////////////////////////////

          ////// CRIAR - INSUMO S/ ESTOQUE //////
          function createSemEstoque(model) {

               var deferred = $q.defer();

               api.CadernoCampoInsumoDefensivoSemEstoque.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - INSUMO  S/ ESTOQUE //////

          ////// CONSULTA POR ID - INSUMO //////
          function get(id) {
               var deferred = $q.defer();
               // api.Insumo.get({
               api.CadernoCampoInsumoDefensivo.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - INSUMO //////


          ////// DELETAR - INSUMO //////
          function deleteInsumo(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               // api.Insumo.delete({
               api.CadernoCampoInsumoDefensivo.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);

                         }
                    );
               return deferred.promise;
          }

          ////// DELETAR - INSUMO //////


          ////// CONSULTA DE ÁREA - PLANTIO //////
          function getAreaInsumo(id) {
               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE ÁREA - PLANTIO //////


          ////// SELECT - INSUMO //////
          function getProdutosAplicados() {
               return [{
                    id: 1,
                    nome: "Defensivo (Agrotóxico)"
               }, {
                    id: 2,
                    nome: "Fertilizante/Biológico/Natural"
               }]
          };
          ////// SELECT - INSUMO //////


          ////// CONSULTA AGROFIT - INSUMO //////
          function searchListaAgrofit(query) {
               var deferred = $q.defer();

               api.InsumoAgrofit.query({
                    query: query
               }).$promise.then(
                    function (response) {

                         let retorno = [];

                         for (let index = 0; index < response.data.length; index++) {
                              const element = response.data[index];
                              retorno.push(element.nome);
                         }

                         deferred.resolve(retorno);
                         console.log(retorno);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA AGROFIT - INSUMO //////


          ////// CONSULTA ÁREA - INSUMO //////
          function searchArea(query) {
               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA ÁREA - INSUMO //////


          ////// CONSULTA PROPRIEDADE - INSUMO //////
          function searchPropertie(query) {
               var deferred = $q.defer();

               api.Propriedade.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA PROPRIEDADE - INSUMO //////


          // Divide a quantidade de produto aplicado por areas
          function recalculaQuantidadeDeProdutoPorArea(totalProduto, unidadeMedida, areas) {

               if (!totalProduto) {
                    totalProduto = 0.0;
               }

               if (areas.length === 0) {
                    return areas;
               }

               var totalArea = 0.0;
               for (var i = 0; i < areas.length; i++) {
                    totalArea += areas[i].area_produtiva;
               }

               for (var i = 0; i < areas.length; i++) {
                    var area = areas[i];
                    area.quantidade = round((area.area_produtiva * totalProduto) / totalArea, 2);
                    area.unidade_medida = unidadeMedida;
               }

               // Calcula diferença e soma na ultima área
               var totalQuantidadeArea = 0.0;
               for (var i = 0; i < areas.length; i++) {
                    var area = areas[i];
                    totalQuantidadeArea += area.quantidade;
               }

               var DiferencaTotalQuantidadeArea = totalProduto - totalQuantidadeArea;

               areas[areas.length - 1].quantidade = round(areas[areas.length - 1].quantidade + DiferencaTotalQuantidadeArea, 2);

               return areas;

          }

          function round(value, decimals) {
               return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals);
          }

          function getAreas(areaid) {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };


               areaService.fullQuery(args, false).then(function (response) {

                    // filtra por area
                    if (areaid && areaid > 0) {

                         var areas = response.data.filter(function (a) {
                              return a.id == areaid;

                         });

                         if (areas.length > 0) {
                              deferred.resolve(response.data.filter(function (a) {
                                   return a.id == areaid;
                              }));
                         } else {
                              deferred.resolve(response.data);
                         }
                         return;
                    }
                    deferred.resolve(response.data);

               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);

               });

               return deferred.promise;
          }

          function queryPropertie() {
               var deferred = $q.defer();
               api.Propriedade.query({}).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          ////// FILTROS INSUMO //////
          function filtrosInsumo() {
               var deferred = $q.defer();
               api.FiltrosInsumoDefensivo.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getAreasAdd() {
               var deferred = $q.defer();
               api.PropriedadeAreaFiltroInsumo.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getPropriedades() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               propertieService.query(args, false).then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }


     }

})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_distribuicao', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.vendas.lotes_distribuicao', {
                    abstract: true,
                    url: '/distribuicao'
               })
               .state('app.vendas.lotes_distribuicao.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/vendas/lotes_distribuicao/views/buscar.html',
                              controller: 'BuscarDistribuicaoController as vm'
                         }
                    },
                    resolve: {
                         data: function (distribuicaoService) {
                              return distribuicaoService.query();
                         },
                         cliente: function (clientePerfilService) {
                              return clientePerfilService.get();
                         },
                    }
               })
               .state('app.vendas.lotes_distribuicao.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/vendas/lotes_distribuicao/views/visualizar.html',
                              controller: 'VisualizarDistribuicaoController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, distribuicaoService) {
                              return distribuicaoService.get($stateParams.id);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/vendas/lotes_distribuicao');

          //Menu
          // msNavigationServiceProvider.saveItem('vendas.lotes.distribuicao', {
          //      title: 'distribuicao',
          //      // icon: 'icon-document',
          //      state: 'app.vendas.lotes.distribuicao.buscar',
          //      translate: 'VENDAS.VENDIDOS'
          // });

     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_distribuicao')
          .factory('distribuicaoService', distribuicaoService);

     /** @ngInject */
     function distribuicaoService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               getNew: getNew,
               query: query,
               get: get
          };

          return service;

          //////////


          function getNew() {
               return {};
          }

          ////// LISTAR - PAGAMENTO ////// 
          function query(args, cache) {

               // cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         models = response.data;
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          };
          ////// LISTAR - PAGAMENTO ////// 

          ////// CONSULTA POR ID - LOTE ////// 
          function get(id) {
               var deferred = $q.defer();

               api.LoteDistribuicaoLoteNumero.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - LOTE ////// 




     }

})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_vendidos', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.vendas.lotes_vendidos', {
                    abstract: true,
                    url: '/lotes_vendidos'
               })
               // .state('app.vendas.lotes_vendidos.buscar', {
               //      url: '/buscar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/vendas/lotes_vendidos/views/buscar.html',
               //                controller: 'BuscarVendidosController as vm'
               //           }
               //      },
               //      resolve: {
               //           data: function (vendidosService) {
               //                return vendidosService.query();
               //           },
               //           cliente: function (clientePerfilService) {
               //                return clientePerfilService.getAtivo();
               //           },
               //           culturas: function (areaService) {
               //                return areaService.getCulturas();
               //           }
               //      }
               // })
               .state('app.vendas.lotes_vendidos.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/vendas/lotes_vendidos/views/visualizar.html',
                              controller: 'VisualizarVendidosController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, vendidosService) {
                              return vendidosService.get($stateParams.id);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/vendas/lotes_vendidos');

          //Menu
         /* msNavigationServiceProvider.saveItem('financeiro.lotes_vendidos', {
               title: 'Receitas',
               // icon: 'icon-document',
               state: 'app.vendas.lotes_vendidos.buscar',
               translate: 'VENDAS.VENDIDOS'
          });*/

          // msNavigationServiceProvider.saveItem('rastreamento.lotes_vendidos', {
          //      title: 'Receitas',
          //      // icon: 'icon-document',
          //      state: 'app.vendas.lotes_vendidos.buscar',
          //      translate: 'VENDAS.VENDIDOS'
          // });

     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_vendidos')
          .factory('vendidosService', vendidosService);

     /** @ngInject */
     function vendidosService($q, api, clienteService, $mdToast) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               getNew: getNew,
               query: query,
               get: get,
               encerrarLote: encerrarLote,
               estornarLote: estornarLote,
               cancelar: cancelar,
               removerLote: removerLote,
               getClients:getClients,
               alterarConsumidor:alterarConsumidor,
               aplicacaoInsumos: aplicacaoInsumos
          };

          return service;

          //////////


          function getNew() {
               return {};
          }

          ////// LISTAR - PAGAMENTO ////// 
          function query(args, cache) {

               // cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         models = response.data;
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    if(response.data.data.detail){
                         console.log('aq', response.data.data.detail);
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(response.data.data.detail)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    }
                    console.log(response);
               });

               return deferred.promise;
          };
          ////// LISTAR - PAGAMENTO ////// 

          ////// CONSULTA POR ID - LOTE ////// 
          function get(id) {
               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - LOTE ////// 

          ////// CONSULTA INSUMOS POR ID ////// 
          function aplicacaoInsumos(id, args) {

               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               api.AplicaocaoInsumos.get(args, {
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA INSUMOS POR ID ////// 

          ////// REMOVER LOTE ////// 
          function removerLote(id, idLote) {

               var deferred = $q.defer();

               api.LoteDistribuicaoConsolidacao.removerLote(id, idLote).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// REMOVER LOTE ////// 


          ////// ENCERRAR CADERNO CAMPO - LOTE ////// 
          function encerrarLote(model) {

               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.encerrar(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// ENCERRAR CADERNO CAMPO - LOTE ////// 


          ////// ESTORNAR CADERNO CAMPO - LOTE ////// 
          function estornarLote(model) {

               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.estornarEncerramento(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// ESTORNAR CADERNO CAMPO - LOTE ////// 
         
          ////// ESTORNAR CADERNO CAMPO - LOTE ////// 
          function alterarConsumidor(model) {
               return api.LoteDistribuicaoVendaAlterarConsumidor.AlteraConsumidor(model).$promise;
          }
          ////// ESTORNAR CADERNO CAMPO - LOTE ////// 

          ////// CANCELAR - LOTE ////// 
          function cancelar(model) {

               var deferred = $q.defer();

               api.LoteDistribuicaoVendaCancelar.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CANCELAR - LOTE ////// 

          ////// BUSCA DE CLIENTES ////// 
          function getClients() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               clienteService.query(args, false).then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }
          ////// BUSCA DE CLIENTES ////// 

     }

})();
(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_vendidos')
          .controller('VisualizarVendidosController', VisualizarVendidosController);

     /** @ngInject */
     function VisualizarVendidosController($scope, $state, $filter, model, $mdToast, $mdDialog, vendidosService) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.insumos = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.ConfirmacaoEncerramento = ConfirmacaoEncerramento;
          vm.comeBack = comeBack;
          vm.ConfirmacaoEstorno = ConfirmacaoEstorno;
          vm.ConfirmacaoRemoverLote = ConfirmacaoRemoverLote;
          vm.gotoLoteProducao = gotoLoteProducao;
          vm.gotoLoteVenda = gotoLoteVenda;
          vm.encerrar = encerrar;
          vm.removerLote = removerLote;
          vm.estornar = estornar;
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.isCollapsed = isCollapsed;
          vm.savePromise = null;
          vm.viewCaderno = viewCaderno;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {
               console.log(vm.model);
          }

          function isCollapsed(model){
               model.open = !model.open;
          }

          function ConfirmacaoEncerramento(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Encerrar o lote?')
                    .textContent('Você tem certeza que gostaria de encerrar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não, depois encerro!');

               $mdDialog.show(confirm).then(function () {
                    encerrar(model);
               }, function () {
                    return null
               });
          };
          function comeBack(){
               // console.log('oi')
               javascript:history.back(1);
          }
          function ConfirmacaoEstorno(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estornar o lote?')
                    .textContent('Você tem certeza que gostaria de estornar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero estornar!')
                    .cancel('Não, depois estorno!');

               $mdDialog.show(confirm).then(function () {
                    estornar(model);
               }, function () {
                    return null
               });
          };

          function ConfirmacaoRemoverLote(consolidacao, lote) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Remover esse lote?')
                    .textContent('Você tem certeza que gostaria de remover esse lote da consolidação?')
                    .targetEvent(consolidacao, lote)
                    .ok('Sim, quero remover!')
                    .cancel('Não, não quero!');

               $mdDialog.show(confirm).then(function () {
                    removerLote(consolidacao, lote);
               }, function () {
                    return null
               });
          };

          function encerrar(model) {

               vendidosService.encerrarLote(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTE_VENDA.LOTE_ENCERRADO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         var message = $filter('translate')('LOTE_VENDA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function removerLote(consolidacao, lote) {

               vendidosService.removerLote({
                    id: consolidacao.id,
                    idLote: lote.id
               })
                    .then(function (response) {

                         var itemConsolidacao = vm.model.lote_distribuicao_consolidacao_presentes[vm.model.lote_distribuicao_consolidacao_presentes.indexOf(consolidacao)];
                         itemConsolidacao.lote_distribuicao_consolidacao_lote_distribuicao_vinculos.splice(itemConsolidacao.lote_distribuicao_consolidacao_lote_distribuicao_vinculos.indexOf(lote), 1);

                         var message = $filter('translate')('LOTE_VENDA.LOTE_REMOVIDO_CONSOLIDACAO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         var message = $filter('translate')('LOTE_VENDA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });

          }

          function estornar(model) {

               vendidosService.estornarLote(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTE_VENDA.LOTE_ESTORNADO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         var message = $filter('translate')('LOTE_VENDA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function gotoSearch() {
               $state.go('app.vendas.lotes_vendidos.buscar');
          }

          function gotoLoteProducao(id) {
               $state.go('app.registro.lote_producao.visualizar', {
                    id: id
               });
          }

          function gotoLoteVenda(id) {
               $state.go('app.vendas.lotes_vendidos.visualizar', {
                    id: id
               });
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function viewCaderno(id, tipo){
               let args = {
                    tipoLote: tipo,
                    loteDistribuicaoId: vm.model.lote_distribuicao.id
               }
               vendidosService.aplicacaoInsumos(id, args)
                    .then(function (response) {
                         vm.insumos = response;
                         $mdDialog.show({
                              locals: {
                                   dataToPass: {
                                       loteID: id,
                                       insumos: vm.insumos
                                   }
                              },
                             controller: mdDialogCtrlCaderno,
                             templateUrl: 'app/main/vendas/lotes_vendidos/views/modal-caderno.html',
                             parent: angular.element(document.body),
                             clickOutsideToClose: true,
                             fullscreen: true // Only for -xs, -sm breakpoints.
                         });

                    }).catch(function (response) {
                         return response;
               });
          }

          function mdDialogCtrlCaderno($scope, dataToPass, $mdDialog) {

               $scope.isumosdetalhes = '';
               $scope.model = dataToPass;

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };

               $scope.openInsumos = function (){
                    !$scope.isumosdetalhes? $scope.isumosdetalhes = 'active': $scope.isumosdetalhes = '';
               }
          }
     }
})();

(function () {
    'use strict';

    angular
        .module('app.vendas.lotes_vendidos')
        .controller('BuscarVendidosController', BuscarVendidosController)
        .controller('ModalVideosController', ModalVideosController)
        .controller('TutorialController', TutorialController)
        .controller('EditarClienteLotesVendidosController', EditarClienteLotesVendidosController);

    /** @ngInject */
    function BuscarVendidosController(data, $state, $scope, culturas, vendidosService, $mdDialog, cliente, $filter) {
        var vm = this;
        vm.models = data.data;
        vm.closeColapse = true;
        vm.activeFilters = false;
        vm.btncancelarlote = false;

        // Data
        vm.gotoVisualizar = gotoVisualizar;
        vm.search = search;
        vm.gotoPrint = gotoPrint;
        vm.resetFilters = resetFilters;
        // vm.clearPreDate = clearPreDate;
        // vm.clearRangeDate = clearRangeDate;
        vm.gotoCancelar = gotoCancelar;
        vm.clientePerfil = cliente;
        vm.culturas = culturas;
        vm.showDialogCliente = showDialogCliente;
        vm.isColapsed = isColapsed;
        vm.closeColapsed = closeColapsed;
        vm.gotoGerenciar = gotoGerenciar;
        vm.gotoCriarLaudo = gotoCriarLaudo;
        vm.showConfirm = showConfirm;
        vm.viewTutorial = viewTutorial;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.btnFiltrar = btnFiltrar;
        vm.openFilter = openFilter;
        vm.closeFilter = closeFilter;

        // DATAPICKER //////////////////
        var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
        var datapickerActive = angular.element(document.querySelector('#dataspicker'));
        var periodoActive = angular.element(document.querySelector('.select-periodo'));

        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;

        vm.periods = [
          {
               description: "Últimos 7 dias",
               value: 7
           },
           {
               description: "Últimos 15 dias",
               value: 15
           },
           {
               description: "Últimos 30 dias",
               value: 30
           },
           {
               description: "Últimos 3 meses",
               value: 90
           },
           {
               description: "Últimos 6 meses",
               value: 180
           }
        ]

        vm.model = {
            dataInicial: new Date(),
            dataFinal: new Date()
        }
        //////////

        /// Guarda Query
        vm.addQuery = {
            periodo: 30,
            data_inicial: null,
            data_final: null,
            cultura: null,
            cliente_consumidor_id: null
        };

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            periodo: 30,
            sort_by: 'data_expedicao',
            sort_order: 'desc',
            _change: change
        };

        vm.args._change();

        init();

        function init() {
            vm.date = new Date();
            selectedPeriodo();
        }

        function search() {

            vm.loadingProgress = true;
            vendidosService.query()
                .then(function successCallback(data) {
                    vm.models = data;
                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        function btnFiltrar (){
            vm.args.periodo = vm.addQuery.periodo?vm.addQuery.periodo:null;
            vm.args.data_inicial = vm.addQuery.data_inicial?vm.addQuery.data_inicial:null;
            vm.args.data_final = vm.addQuery.data_final?vm.addQuery.data_final:null;
            vm.args.cultura = vm.addQuery.cultura?vm.addQuery.cultura:null;
            vm.args.cliente_consumidor_id = vm.addQuery.cliente_consumidor_id?vm.addQuery.cliente_consumidor_id:null;
            vm.args.query = vm.args.query?vm.args.query:null;

            vm.args._change();
        }

        function change() {
            vm.args.loading = true;
            vendidosService.query(vm.args).then(function (response) {
                vm.models = response.data;
                //console.log(vm.models)
                vm.args.total_rows = response.total_rows;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();

            }).finally(function () {
                vm.args.loading = false;
            });

        }

        function resetFilters() {
            vm.addQuery.periodo = 30;
            vm.addQuery.query = null;
            vm.addQuery.cultura = null;
            vm.addQuery.data_inicial = null;
            vm.addQuery.data_final = null;
            vm.addQuery.cliente_consumidor_id = null;
            vm.args.periodo = 30;
            vm.args.query = null;
            vm.args.cultura = null;
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            vm.args.cliente_consumidor_id = null;
            datapickerActive.removeClass("dates-active");
            periodoActive.addClass("select-active");
            vm.activeFilters = null;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
          let counter = 0;
          let clienteNome = null;
          for (let i = 0; i < vm.periods.length; i++) {
            if (vm.periods[i].value == vm.args.periodo) {
                 periodoSelect = vm.periods[i].description
            };
          }
          let clientes = vm.models.cliente_consumidor;
          for (let i = 0; i < clientes.length; i++) {
               if (clientes[i].id == vm.args.cliente_consumidor_id){
                    clienteNome = clientes[i].nome
               }
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: vm.args.query,
                    value: 'query'
               },
               {
                    description: clienteNome,
                    value: 'cliente_consumidor_id'
               },
               {
                    description: vm.args.cultura,
                    value: 'cultura'
               }
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.addQuery.data_inicial = null;
               vm.addQuery.data_final = null;
               datapickerActive.removeClass("dates-active");
          } else if(value == 'periodo'){
                periodoActive.removeClass("select-active");
                vm.args[value] = 30;
                vm.addQuery[value] = 30;
          }else{
            vm.args[value] = null;
            vm.addQuery[value] = null;
          }
          change();
        }

        // DATAPICKER //////////////////
        function clearPreDate() {
            vm.args.periodo = null;
            vm.addQuery.periodo = null;
        }
        function selectedPeriodo() {
                vm.args.date_inicio = null;
                vm.args.date_fim = null;
                periodoActive.addClass("select-active");
                datapickerActive.removeClass("dates-active");
        }
        function openDatasSelect(){
                datapicker.css("display", "block");
        }
        function selecionarDatas(){
                clearPreDate();
                datapicker.css("display", "none");
                datapickerActive.addClass("dates-active");
                periodoActive.removeClass("select-active");
        }
        function closedDatasSelect(){
                datapicker.css("display", "none");
                vm.args.date_inicio = null;
                vm.args.date_fim = null;
                vm.args.periodo = null;
                datapickerActive.removeClass("dates-active");
                //periodoActive.classList.add("select-active");
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {

                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();

        }

        this.openMenu = function ($mdMenu, ev) {
            // eslint-disable-next-line no-unused-vars
            var originatorEv;
            originatorEv = ev;
            $mdMenu.open(ev);
        };

        function openFilter(){
            let contentFilter = angular.element(document.querySelector('.form-search-horizontal'));
            contentFilter.addClass('actived');
        }
        function closeFilter(){
            let contentFilter = angular.element(document.querySelector('.form-search-horizontal'));
            contentFilter.removeClass('actived');
        }

        function isColapsed(model) {
            model.isLoading = false;
            model.colapsed = true;
            vm.isDisabled = true;
        }

        function closeColapsed(model) {
            model.colapsed = false;
            vm.isDisabled = false;
        }

        function gotoCancelar(model, ev) {
            console.log('event', model, ev)
            $mdDialog.show({
                locals: {
                    dataToPass: model
                },
                controller: CancelarDialogCtrl,
                templateUrl: 'app/main/vendas/lotes_vendidos/views/cancelar.html',
                //contentElement: '#DialogCancelarLote',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        }

        function showDialogCliente(ev, model) {
            $mdDialog.show({
                locals: {
                    dataToPass: model
                },
                controller: 'EditarClienteLotesVendidosController as vm',
                templateUrl: 'app/main/vendas/lotes_vendidos/views/editar_cliente.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            });

        }

        function gotoPrint(model, ev) {
            let pesototal = model.quantidade;
            let pesoembalagem = model.embalagem_peso;
            let embalagem_quantidade;
            if(model.unidade_medida == 'unidades'){
                embalagem_quantidade = pesoembalagem;
            }else{
                embalagem_quantidade = pesototal / pesoembalagem;
            }
            $mdDialog.show({
                locals: {
                    dataToPass: {
                        codigo_fornecedor: vm.clientePerfil.id,
                        nome_clientePerfil: vm.clientePerfil.nome,
                        cnpj_cpf_clientePerfil: vm.clientePerfil.cnpj_cpf,
                        lote_numero: model.codigo_rastreamento,
                        produto_nome: model.cultura,
                        produto_variedade: model.variedade,
                        // data_colheita: model.data_colheita,
                        data_expedicao: model.data_expedicao,
                        quantidade: model.quantidade,
                        embalagem_quantidade: embalagem_quantidade,
                        unidade_medida: model.unidade_medida,
                        produto_embalagem_tipo: model.embalagem_tipo,
                        produto_embalagem_peso: model.embalagem_peso,
                        distribuidor_nome: model.distribuidor_nome,
                        distribuidor_cnpj_cpf: model.distribuidor_cnpj_cpf,
                        // distribuidor_cnpj_cpf: model.cliente_distribuidor ? model.cliente_distribuidor.cnpj_cpf : "null",
                        quantidade_etiquetas: model.quantidade_etiquetas,
                        tamanho_etiquetas: model.tamanho_etiquetas,
                        tipo_etiquetas: model.tipo_etiquetas,
                        id_lote: model.id


                    }
                },
                controller: mdDialogCtrl,
                templateUrl: 'app/main/vendas/lotes_vendidos/views/print-label.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: true,
                fullscreen: false
            })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });
        }

        function CancelarDialogCtrl($scope, dataToPass, $mdDialog, vendidosService, $filter, $mdToast) {
            $scope.btncancelarlote = true;
            $scope.cancelamento = 'Cancelamento'
            // $scope.model = dataToPass;

            var utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
            $scope.date = utc;

            $scope.close = function () {
                $mdDialog.cancel();
            };

            $scope.cancelarLote = function () {
                $scope.btncancelarlote = false;
                let post = {
                    id: dataToPass.id,
                    descricao: $scope.descricao
                }
                vendidosService.cancelar(post)
                    .then(function (response) {
                        vm.models.lote_distribuicao_venda.splice(vm.models.lote_distribuicao_venda.indexOf(dataToPass), 1);
                        var message = $filter('translate')('LOTE.LOTE_CANCELADO');
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(message)
                                .position('top right')
                                .theme("success-toast")
                                .hideDelay(6000)
                        );
                        $mdDialog.cancel();
                    }).catch(function (response) {
                        //var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                        var message = response.data.errors[Object.keys(response.data.errors)[0]] + ' ('+response.data.detail+')';
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent(message)
                                .position('top right')
                                .theme("error-toast")
                                .hideDelay(6000)
                        );
                    });
            }

        }

        function mdDialogCtrl($scope, dataToPass, $mdDialog) {

            $scope.rolo = 'Rolo'
            $scope.coluna = '2 Colunas'
            $scope.coluna_unity = '1 Coluna'
            $scope.coluna_3 = '3 Colunas'

            $scope.tamanho_etiquetas = [
                {
                    id: 1,
                    tamanho: "100mm X 50mm"
                }, {
                    id: 2,
                    tamanho: "120mm X 50mm"
                }, {
                    id: 3,
                    tamanho: "60mm X 39mm (Logo)"
                }, {
                    id: 4,
                    tamanho: "40mm X 25mm"
                },
                {
                    id: 5,
                    tamanho: "33mm X 21mm"
                }
            ];

            $scope.tipo_etiquetas = [
                {
                    id: 1,
                    tipo: "A4"
                },
                {
                    id: 2,
                    tipo: "Rolo"
                }
            ];

            $scope.colunas = [
                {
                    id: 1,
                    tipo: "1 coluna"
                },
                {
                    id: 2,
                    tipo: "2 colunas"
                }
            ];

            $scope.Export = function (quantidade) {

                for (var i = 1; i <= quantidade; i++) {

                    $("#imprimirdezporcincoa4").clone().appendTo("#printThis");

                    if (i % 10 === 0) {
                        $("#printThis").append("<div style='page-break-after:always'></div>");
                    }
                }

                var element = document.getElementById('printThis');
                var opt = {
                    margin: 0.1,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        unit: 'in',
                        format: 'a4',
                        orientation: 'portrait'
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }

            $scope.ExportRolo = function () {

                $("#imprimirdezporcincorolo").clone().appendTo("#printThisRolo");

                var element = document.getElementById('printThisRolo');
                var opt = {
                    margin: 0.5,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        orientation: "landscape",
                        unit: "mm",
                        format: [107, 58]
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }

            $scope.ExportRolo2x = function () {

                for (var i = 1; i <= 2; i++) {
                    $("#imprimirdezporcincorolo2x").clone().appendTo("#printThisRolo2x");
                }

                var element = document.getElementById('printThisRolo2x');
                var opt = {
                    margin: 0.5,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        orientation: "portrait",
                        unit: "mm",
                        format: [107, 114]
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }


            $scope.ExportDoze = function () {


                $("#imprimirdozeporcinco").clone().appendTo("#printThisDoze");


                var element = document.getElementById('printThisDoze');
                var opt = {
                    margin: 0.5,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        orientation: "landscape",
                        unit: "mm",
                        format: [129, 58]
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }

            $scope.ExportDozeRotate = function () {

                for (var i = 1; i <= 2; i++) {
                    $("#imprimirdozeporcincorotate").clone().appendTo("#printThisDozeRotate");
                }

                var element = document.getElementById('printThisDozeRotate');
                var opt = {
                    margin: 0.5,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        orientation: "landscape",
                        unit: "mm",
                        format: [129, 119]
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }

            $scope.ExportSeisPorQuatro = function () {

                for (var i = 1; i <= 2; i++) {
                    $("#imprimirseisporquatrorotate").clone().appendTo("#printThisSeisRotate");
                }

                var element = document.getElementById('printThisSeisRotate');
                var opt = {
                    margin: 1,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        orientation: "portrait",
                        unit: "mm",
                        format: [66, 93]
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }

            $scope.ExportQuatroPorDois = function () {

                $("#imprimirquatropordoisemeio").clone().appendTo("#printThisQuatroPorDois");

                var element = document.getElementById('printThisQuatroPorDois');
                var opt = {
                    margin: 1,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        orientation: "landscape",
                        unit: "mm",
                        format: [46, 32.9]
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }

            $scope.ExportTrintaETresPorVinteEUm = function () {

                for (var i = 1; i <= 3; i++) {
                    $("#imprimirtrintaetresporvinteeum").clone().appendTo("#printThisTrintaETresPorVinteEUm");
                }

                var element = document.getElementById('printThisTrintaETresPorVinteEUm');
                var opt = {
                    margin: 0,
                    filename: 'myfile.pdf',
                    image: {
                        type: 'jpeg',
                        quality: 1
                    },
                    html2canvas: {
                        scale: 2,
                        logging: true
                    },
                    jsPDF: {
                        unit: 'mm',
                        format: [24, 104],
                        orientation: 'landscape'
                    }
                };
                html2pdf(element, opt);
                $mdDialog.hide();
            }



            $scope.vm = {
                model: {
                    data: 'colheita'
                }
            }
            $scope.model = dataToPass;

            $scope.model.url = getConfig().urlTracker + "home?lote=" + $scope.model.lote_numero;

            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
        }


        function gotoVisualizar(id) {
            $state.go('app.vendas.lotes_vendidos.visualizar', {
                id: id
            });

        }

        function viewTutorial() {

            $mdDialog.show({
                controller: 'ModalVideosController as vm',
                templateUrl: 'app/main/vendas/lotes_vendidos/views/modal-videos.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function () {
                    return null;
                }, function () {
                    return null;
                });

        }


        function gotoGerenciar(id) {
            $state.go('app.laudo.gerenciar', {
                id: id
            });
        }

        function showConfirm(id, ev) {
            var confirm = $mdDialog.confirm()
                .title('Geração de laudo')
                .textContent('Você deseja gerar um laudo para essa venda?')
                .targetEvent(ev)
                .ok('Sim')
                .cancel('Voltar');

            $mdDialog.show(confirm).then(function () {
                vm.gotoCriarLaudo(id);
            }, function () {
                $mdDialog.hide();
            });
        };

        function gotoCriarLaudo(id) {
            $state.go('app.laudo.criar', {
                venda_id: id
            });
        }
    }


    function EditarClienteLotesVendidosController($rootScope, $scope, dataToPass, $filter, vendidosService, cadastrosClienteService, $mdToast, $mdDialog) {


        var vm = this;
        $scope.model = dataToPass;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.dismissModal = dismissModal;
        vm.get = get;
        vm.update = update;
        vm.updateNew = updateNew;
        vm.save = save;
        vm.getClientes = getClientes;
        //////////

        let model = $scope.model;

        init();

        function init() {
            vm.getClientes();
        }


        function get() {

            cadastrosClienteService.get($scope.model.cliente_consumidor.id).then(function (response) {
                vm.model = response;
            });
        }

        function update(data) {

            let put = {
                id: $scope.model.id,
                cliente_consumidor_id: vm.model.lote_distribuicao_venda_itens.cliente.id,
                comentario: data.comentario,
                model_row: model
            }


            var message = '';
            var message = $filter('translate')('CLIENTE.CLIENTE_ALTERADO');
            this.savePromise = vendidosService.alterarConsumidor(put);
            console.log(put);
            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                console.log(response);
                angular.copy(response, model);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );
                $mdDialog.hide();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function updateNew(putChange) {
            this.savePromise = vendidosService.alterarConsumidor(putChange);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                angular.copy(response, model);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('CLIENTE.CLIENTE_ALTERADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );
                $mdDialog.hide();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function save(putSave) {

            if (model.$invalid) {
                return;
            }

            this.savePromise = cadastrosClienteService.create(putSave);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;

                let putChange = {
                    id: $scope.model.id,
                    cliente_consumidor_id: response.id,
                    comentario: putSave.comentario,
                    model_row: model
                }
                console.log(putSave);
                console.log(putChange);
                vm.updateNew(putChange);
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function getClientes() {
            vendidosService.getClients().then(function (response) {
                vm.clientes = response.cliente_consumidor;
            });
        }


        function dismissModal() {
            $mdDialog.hide();
        }
    }
    function TutorialController($mdDialog) {
        var vm = this;
        vm.close = close;
        vm.returnModal = returnModal;

        function returnModal() {
            $mdDialog.hide();
            $mdDialog.show({
                controller: 'ModalVideosController as vm',
                templateUrl: 'app/main/vendas/lotes_vendidos/views/modal-videos.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function () {
                    return null;
                }, function () {
                    return null;
                });
        };

        function close() {
            $mdDialog.hide();
        };
    }


    function ModalVideosController($mdDialog) {
        var vm = this;
        vm.close = close;
        vm.viewTutorialVenderLotes = viewTutorialVenderLotes;
        vm.viewTutorialImprimirTrocarClienteLotes = viewTutorialImprimirTrocarClienteLotes;
        vm.viewTutorialGerarLaudo = viewTutorialGerarLaudo;

        function viewTutorialVenderLotes() {
            $mdDialog.hide();

            $mdDialog.show({
                controller: 'TutorialController as vm',
                templateUrl: 'app/main/vendas/lotes_vendidos/views/tutorials/tutorial-vender-lotes.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function () {
                    return null;
                }, function () {
                    return null;
                });
        }

        function viewTutorialImprimirTrocarClienteLotes() {
            $mdDialog.hide();

            $mdDialog.show({
                controller: 'TutorialController as vm',
                templateUrl: 'app/main/vendas/lotes_vendidos/views/tutorials/tutorial-imprimir-trocarcliente.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function () {
                    return null;
                }, function () {
                    return null;
                });
        }

        function viewTutorialGerarLaudo() {
          $mdDialog.hide();

          $mdDialog.show({
              controller: 'TutorialController as vm',
              templateUrl: 'app/main/vendas/lotes_vendidos/views/tutorials/gerar-laudo.html',
              parent: angular.element(document.body),
              clickOutsideToClose: true,
              fullscreen: true // Only for -xs, -sm breakpoints.
          })
              .then(function () {
                  return null;
              }, function () {
                  return null;
              });
      }


        function close() {
            $mdDialog.hide();
        };
    }

})();

(function () {
     'use strict';

     angular
          .module('app.vendas.venda', ['app.cadastros.cliente'])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.vendas.venda', {
                    abstract: true,
                    url: '/venda'
               })
               // .state('app.vendas.venda.selecionar', {
               //      url: '/selecionar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/vendas/venda/views/selecionar.html',
               //                controller: 'SelecionarVendaNovoController as vm'
               //           }
               //      },
               //      resolve: {
               //           data: function (vendaNovoService) {
               //                return vendaNovoService.query();
               //           },
               //           filtros: function (vendaNovoService) {
               //                return vendaNovoService.getFiltros();
               //           },
               //           model: function (vendaNovoService) {
               //                return vendaNovoService.getNewModal();
               //           }
               //      }
               // })
               // .state('app.vendas.venda.preencher', {
               //      url: '/preencher',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/vendas/venda/views/preencher.html',
               //                controller: 'PreencherVendaNovoController as vm'
               //           }
               //      },
               //      resolve: {
               //           model: function (vendaNovoService) {
               //                return vendaNovoService.getNew();
               //           },
               //           unidade: function (vendaNovoService) {
               //                return vendaNovoService.getUnidade();
               //           },
               //           tipo: function (vendaNovoService) {
               //                return vendaNovoService.getTipo();
               //           },
               //           cliente_consumidores: function (vendaNovoService) {
               //                return vendaNovoService.getClients();
               //           },
               //           cliente_distribuidores: function (vendaNovoService) {
               //                return vendaNovoService.getDistribuidores();
               //           }
               //      }
               // })
               // .state('app.vendas.venda.confirmar', {
               //      url: '/confirmar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/vendas/venda/views/confirmar.html',
               //                controller: 'ConfirmarVendaController as vm'
               //           }
               //      },
               //      resolve: {
               //           model: function (vendaNovoService) {
               //                return vendaNovoService.getNew();
               //           }
               //      }
               // })
               // .state('app.vendas.venda.sucesso', {
               //      url: '/sucesso/:id',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/vendas/venda/views/sucesso.html',
               //                controller: 'SucessoVendaController as vm'
               //           }
               //      },
               //      resolve: {
               //           model: function ($stateParams, vendaNovoService) {
               //                return vendaNovoService.getVenda($stateParams.id);
               //           },
               //           cliente: function (clientePerfilService) {
               //                return clientePerfilService.getAtivo();
               //           }
               //      }
               // })


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/vendas/venda');
          $translatePartialLoaderProvider.addPart('app/main/vendas');

          // Menu
          // msNavigationServiceProvider.saveItem('rastreamento.venda', {
          //      title: 'venda',
          //      state: 'app.vendas.venda.selecionar',
          //      translate: 'VENDA.VENDAS',
          //      weight: 1
          // });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.venda')
          .factory('vendaNovoService', vendaNovoService);

     /** @ngInject */
     function vendaNovoService($q, clienteService, distribuidorService, $mdToast, $filter, msApi, api) {

          var loteselecionados = [];
          var pesototal = 0;
          var dadosVenda = [];

          var vendas = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {
               caderno_campo_colheita_detalhes: []
          };

          var service = {
               get: get,
               getNew: getNew,
               getNewModal: getNewModal,
               create: create,
               query: query,
               getUnidade: getUnidade,
               getTipo: getTipo,
               getClients: getClients,
               getDistribuidores: getDistribuidores,
               addLote: addLote,
               getLotes: getLotes,
               clearLotes: clearLotes,
               addPeso: addPeso,
               getPeso: getPeso,
               getFiltros: getFiltros,
               addDados: addDados,
               getDados: getDados,
               clearDados: clearDados,
               getVenda: getVenda
          };

          return service;

          //////////

          function addLote(lote) {
               loteselecionados = lote;
          }
          function getLotes() {
               return loteselecionados;
          }
          function clearLotes() {
               loteselecionados = [];
          }

          function addPeso(peso) {
               pesototal = peso;
          }
          function getPeso() {
               return pesototal;
          }


          function addDados(dados) {
               dadosVenda = dados;
          }
          function getDados() {
               return dadosVenda;
          }
          function clearDados() {
               dadosVenda = [];
          }

          function getNew() {
               return {};
          }

          function getNewModal() {
               return {};
          }

          function getUnidade() {
               return [
                    "kg",
                    "unidades"
               ]
          };

          function getTipo() {
               return [
                    "Cônicas",
                    "Caixas",
                    "Sacos",
                    "Cumbucas",
                    "Bandejas",
                    "Granel",
                    "Big Bag"
               ]
          }

          ////// LISTAR - VENDA //////
          function query(args, cache) {
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.LoteDisponivelVenda.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - VENDA //////

          ////// CRIAR - VENDA //////
          function create(model) {

               //console.log(JSON.stringify(model));
               //console.log(model);
               //return false;
               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         vendas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CRIAR - VENDA //////


          ////// CONSULTA POR ID E TIPO - VENDA //////
          function get(id, tipo) {
               var deferred = $q.defer();

               api.LoteProducaoDistribuicao.get({
                    id: id,
                    tipoId: tipo
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID E TIPO - VENDA //////

          ////// CONSULTA POR ID - VENDA //////
          function getVenda(id) {
               var deferred = $q.defer();

               api.LoteDistribuicaoVenda.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - VENDA //////


          function getClients() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               clienteService.query(args, false).then(function (response) {
                    deferred.resolve(response.data.cliente_consumidor);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }

          function getDistribuidores() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               distribuidorService.query(args, false).then(function (response) {
                    deferred.resolve(response.data.cliente_distribuidor);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }

          function getFiltros() {

               var deferred = $q.defer();
               var args = {};
               api.Filtros
                   .query(args).$promise
                   .then(function (response) {
                       deferred.resolve(response.data);
                   })
                   .catch(function (response) {
                       deferred.reject(response);
                   });
               return deferred.promise;
          }

     }

})();

(function() {
     'use strict';

     angular
          .module('app.vendas.venda')
          .factory('distribuidorService', distribuidorService);

     /** @ngInject */
     function distribuidorService($q, api) {

          var queryCache = {
               response: null,
               args: {
                    page: 1,
                    per_page: 10,
                    page_sizes: [5, 10, 25, 100],
                    total_rows: 0,
                    length_rows: 1,
                    sort_by: 'id',
                    sort_order: 'asc',
               },
               valid: null // TODO: será implementado
          };

          var modelNew = {
               cliente_liberado: null
          };

          var service = {
               getNew: getNew,
               query: query,
               create: create,
               delete: Delete,
               args: getArgs
          };

          return service;

          function getArgs() {

               return queryCache.args;
          }

          function getNew() {
               return modelNew;
          }

          function create(model) {

               var deferred = $q.defer();
               api.ClienteDistribuidor.save(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         queryCache.response.data.cliente_distribuidor.push(response);
                         queryCache.response.args.total_rows++;
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;

          }

          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               var deferred = $q.defer();

               if (!args) {
                    args = queryCache.args;
               }

               if (queryCache.response && cache && angular.equals(args, queryCache.args)) {
                    deferred.resolve(queryCache.response);
                    console.log("query using: true");
               } else {

                    api.ClienteDistribuidor.query(args).$promise
                         .then(function(response) {
                              queryCache.args = angular.copy(args);
                              queryCache.response = response;
                              // TODO: setar o valid
                              deferred.resolve(queryCache.response);

                         }).catch(function(response) {
                              deferred.reject(response);
                              console.log(response);
                         });
               }

               return deferred.promise;
          };

          function Delete(model) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.ClienteDistribuidor.delete({
                    id: model.id
               }).$promise.then(
                    function(response) {
                         //   Resolve the promise
                         const index = queryCache.response.data.indexOf(model);
                         queryCache.response.data.splice(index, 1);
                         queryCache.response.args.total_rows--;
                         deferred.resolve(response);
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }

     }

})();

(function() {
     'use strict';

     angular
          .module('app.vendas.venda')
          .factory('clienteService', clienteService);

     /** @ngInject */
     function clienteService($q, api) {

          var queryCache = {
               response: null,
               args: {
                    page: 1,
                    per_page: 10,
                    page_sizes: [5, 10, 25, 100],
                    total_rows: 0,
                    length_rows: 1,
                    sort_by: 'id',
                    sort_order: 'asc',
               },
               valid: null // TODO: será implementado
          };

          var modelNew = {
               cliente_liberado: null
          };

          var service = {
               getNew: getNew,
               query: query,
               create: create,
               delete: Delete,
               args: getArgs
          };

          return service;

          function getArgs() {

               return queryCache.args;
          }

          function getNew() {
               return modelNew;
          }

          function create(model) {

               var deferred = $q.defer();
               api.ClienteConsumidor.save(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         queryCache.response.data.cliente_consumidor.push(response);
                         queryCache.response.args.total_rows++;
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;

          }

          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               var deferred = $q.defer();

               if (!args) {
                    args = queryCache.args;
               }

               if (queryCache.response && cache && angular.equals(args, queryCache.args)) {
                    deferred.resolve(queryCache.response);
                    console.log("query using: true");
               } else {

                    api.ClienteConsumidor.query(args).$promise
                         .then(function(response) {
                              queryCache.args = angular.copy(args);
                              queryCache.response = response;
                              // TODO: setar o valid
                              deferred.resolve(queryCache.response);

                         }).catch(function(response) {
                              deferred.reject(response);
                              console.log(response);
                         });
               }

               return deferred.promise;
          };

          function Delete(model) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.ClienteConsumidor.delete({
                    id: model.id
               }).$promise.then(
                    function(response) {
                         //   Resolve the promise
                         const index = queryCache.response.data.indexOf(model);
                         queryCache.response.data.splice(index, 1);
                         queryCache.response.args.total_rows--;
                         deferred.resolve(response);
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }

     }

})();

(function () {
     'use strict';

     angular
          .module('app.vendas.venda')
          .controller('SucessoVendaController', SucessoVendaController);

     /** @ngInject */
     function SucessoVendaController($state, model, cliente, $mdDialog, $rootScope, $filter, $scope) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.undMedida = null;
          vm.clientePerfil = cliente;

          // Methods
          vm.gotoVender = gotoVender;
          vm.gotoLotesVendidos = gotoLotesVendidos;
          vm.gotoHome = gotoHome;
          vm.gotoPrint = gotoPrint;
          vm.showConfirm = showConfirm;
          vm.gotoCriarLaudo = gotoCriarLaudo;
          vm.viewImprimirTrocarCliente = viewImprimirTrocarCliente;
          vm.viewGerarLaudo = viewGerarLaudo;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {
               if(vm.model.id == null){
                    gotoVender()
               }
          }

          function gotoVender() {
               $state.go('app.vendas.venda.selecionar');
          }

          function gotoLotesVendidos() {
               $state.go('app.vendas.lotes_vendidos.buscar');
          }

          function gotoHome() {
               $state.go('app.home');
          }

          function gotoPrint(model, ev) {
               //console.log(vm.model.cliente_consumidor.id);
               //return
               let pesototal = vm.model.quantidade;
               let pesoembalagem = vm.model.embalagem_peso;
               let embalagem_quantidade;
                if(vm.model.unidade_medida == 'unidades'){
                    embalagem_quantidade = pesoembalagem;
                }else{
                    embalagem_quantidade = pesototal / pesoembalagem;
                }
               $mdDialog.show({
                   locals: {
                       dataToPass: {
                           codigo_fornecedor: vm.clientePerfil.id,
                           nome_clientePerfil: vm.clientePerfil.nome,
                           cnpj_cpf_clientePerfil: vm.clientePerfil.cnpj_cpf,
                           lote_numero: vm.model.lote_distribuicao.lote_numero,
                           produto_nome: vm.model.cultura.nome,
                           produto_variedade: vm.model.produto_variedade,
                           data_expedicao: vm.model.data_expedicao,
                           quantidade: vm.model.quantidade,
                           embalagem_quantidade: embalagem_quantidade,
                           unidade_medida: vm.model.unidade_medida,
                           produto_embalagem_tipo: vm.model.embalagem_tipo,
                           produto_embalagem_peso: vm.model.embalagem_peso,
                           distribuidor_nome: (vm.model.cliente_distribuidor)?vm.model.cliente_distribuidor.nome:null,
                           distribuidor_cnpj_cpf: (vm.model.cliente_distribuidor)?vm.model.cliente_distribuidor.cnpj_cpf:null,
                           quantidade_etiquetas: $scope.quantidade_etiquetas,
                           tamanho_etiquetas: $scope.tamanho_etiquetas,
                           tipo_etiquetas: $scope.tipo_etiquetas,
                           id_lote: vm.model.id
                       }
                   },
                   controller: mdDialogCtrl,
                   templateUrl: 'app/main/vendas/lotes_vendidos/views/print-label.html',
                   parent: angular.element(document.body),
                   targetEvent: ev,
                   clickOutsideToClose: true,
                   fullscreen: false
               })
                   .then(function (answer) {
                       $scope.status = 'You said the information was "' + answer + '".';
                   }, function () {
                       $scope.status = 'You cancelled the dialog.';
                   });
           }

           function showConfirm(id, ev) {
               var confirm = $mdDialog.confirm()
                   .title('Geração de laudo')
                   .textContent('Você deseja gerar um laudo para essa venda?')
                   .targetEvent(ev)
                   .ok('Sim')
                   .cancel('Voltar');

               $mdDialog.show(confirm).then(function () {
                   vm.gotoCriarLaudo(id);
               }, function () {
                   $mdDialog.hide();
               });
           }

           function gotoCriarLaudo(id) {
               $state.go('app.laudo.criar', {
                   venda_id: id
               });
           }

           function viewImprimirTrocarCliente() {
               $mdDialog.show({
                    controller: mdDialogCtrlPasso,
                    templateUrl: 'app/main/home/view/videos/tutorial-imprimiretiqueta-trocarcliente.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewGerarLaudo(){
               $mdDialog.show({
                    controller: mdDialogCtrlPasso,
                    templateUrl: 'app/main/home/view/videos/tutorial-gerar-laudo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function mdDialogCtrlPasso($scope, $mdDialog) {
               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

           function mdDialogCtrl($scope, dataToPass, $mdDialog) {

               $scope.rolo = 'Rolo'
               $scope.coluna = '2 Colunas'
               $scope.coluna_unity = '1 Coluna'
               $scope.coluna_3 = '3 Colunas'

               $scope.tamanho_etiquetas = [
                   {
                       id: 1,
                       tamanho: "100mm X 50mm"
                   }, {
                       id: 2,
                       tamanho: "120mm X 50mm"
                   }, {
                       id: 3,
                       tamanho: "60mm X 39mm (Logo)"
                   }, {
                       id: 4,
                       tamanho: "40mm X 25mm"
                   },
                   {
                       id: 5,
                       tamanho: "33mm X 21mm"
                   }
               ];

               $scope.tipo_etiquetas = [
                   {
                       id: 1,
                       tipo: "A4"
                   },
                   {
                       id: 2,
                       tipo: "Rolo"
                   }
               ];

               $scope.colunas = [
                   {
                       id: 1,
                       tipo: "1 coluna"
                   },
                   {
                       id: 2,
                       tipo: "2 colunas"
                   }
               ];

               $scope.Export = function (quantidade) {

                   for (var i = 1; i <= quantidade; i++) {

                       $("#imprimirdezporcincoa4").clone().appendTo("#printThis");

                       if (i % 10 === 0) {
                           $("#printThis").append("<div style='page-break-after:always'></div>");
                       }
                   }

                   var element = document.getElementById('printThis');
                   var opt = {
                       margin: 0.1,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           unit: 'in',
                           format: 'a4',
                           orientation: 'portrait'
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }

               $scope.ExportRolo = function () {

                   $("#imprimirdezporcincorolo").clone().appendTo("#printThisRolo");

                   var element = document.getElementById('printThisRolo');
                   var opt = {
                       margin: 0.5,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           orientation: "landscape",
                           unit: "mm",
                           format: [107, 58]
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }

               $scope.ExportRolo2x = function () {

                   for (var i = 1; i <= 2; i++) {
                       $("#imprimirdezporcincorolo2x").clone().appendTo("#printThisRolo2x");
                   }

                   var element = document.getElementById('printThisRolo2x');
                   var opt = {
                       margin: 0.5,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           orientation: "portrait",
                           unit: "mm",
                           format: [107, 114]
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }


               $scope.ExportDoze = function () {


                   $("#imprimirdozeporcinco").clone().appendTo("#printThisDoze");


                   var element = document.getElementById('printThisDoze');
                   var opt = {
                       margin: 0.5,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           orientation: "landscape",
                           unit: "mm",
                           format: [129, 58]
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }

               $scope.ExportDozeRotate = function () {

                   for (var i = 1; i <= 2; i++) {
                       $("#imprimirdozeporcincorotate").clone().appendTo("#printThisDozeRotate");
                   }

                   var element = document.getElementById('printThisDozeRotate');
                   var opt = {
                       margin: 0.5,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           orientation: "landscape",
                           unit: "mm",
                           format: [129, 119]
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }

               $scope.ExportSeisPorQuatro = function () {

                   for (var i = 1; i <= 2; i++) {
                       $("#imprimirseisporquatrorotate").clone().appendTo("#printThisSeisRotate");
                   }

                   var element = document.getElementById('printThisSeisRotate');
                   var opt = {
                       margin: 1,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           orientation: "portrait",
                           unit: "mm",
                           format: [66, 93]
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }

               $scope.ExportQuatroPorDois = function () {

                   $("#imprimirquatropordoisemeio").clone().appendTo("#printThisQuatroPorDois");

                   var element = document.getElementById('printThisQuatroPorDois');
                   var opt = {
                       margin: 1,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           orientation: "landscape",
                           unit: "mm",
                           format: [46, 32.9]
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }

               $scope.ExportTrintaETresPorVinteEUm = function () {

                   for (var i = 1; i <= 3; i++) {
                       $("#imprimirtrintaetresporvinteeum").clone().appendTo("#printThisTrintaETresPorVinteEUm");
                   }

                   var element = document.getElementById('printThisTrintaETresPorVinteEUm');
                   var opt = {
                       margin: 0,
                       filename: 'myfile.pdf',
                       image: {
                           type: 'jpeg',
                           quality: 1
                       },
                       html2canvas: {
                           scale: 2,
                           logging: true
                       },
                       jsPDF: {
                           unit: 'mm',
                           format: [24, 104],
                           orientation: 'landscape'
                       }
                   };
                   html2pdf(element, opt);
                   $mdDialog.hide();
               }



               $scope.vm = {
                   model: {
                       data: 'colheita'
                   }
               }
               $scope.model = dataToPass;

               $scope.model.url = getConfig().urlTracker + "home?lote=" + $scope.model.lote_numero;

               $scope.cancelar = function () {
                   $mdDialog.cancel();
               };
           }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.venda')
          .controller('SelecionarVendaNovoController', SelecionarVendaNovoController);

     /** @ngInject */
     function SelecionarVendaNovoController($scope, data, model, vendaNovoService, clientePerfilService, filtros, $filter, $state, $mdDialog, $mdToast) {

          var vm = this;

          // Status
          vm.loadingProgress = false;
          vm.totalInputs = 0;
          vm.myCheck = false;
          vm.uniddMedida = null;
          // vm.cultura = null;
          vm.variedade = null;

          // Data
          vm.models = data;
          vm.model = model;
          vm.filtros = filtros;
          vm.activeFilters = null;
          vm.LotesSelecionados = [];

          // Methods
          vm.search = search;
          vm.gotoVenda = gotoVenda;
          vm.resetFilters = resetFilters;
          vm.gotoLote = gotoLote;
          vm.getName = getName;

          vm.getSelecionados = vendaNovoService.getLotes();
          vm.gotoLoteProducao = gotoLoteProducao;

          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.selectedPeriodo = selectedPeriodo;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          vm.checkFunction = checkFunction;
          vm.updateValor = updateValor;
          vm.modalPassoAPasso = modalPassoAPasso;
          vm.checkModal = checkModal;
          vm.viewTutorial = viewTutorial;
          vm.close = close;
          vm.openFilter = openFilter;
          vm.closeFilter = closeFilter;

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.periods = [
               {
                   description: "Últimos 7 dias",
                   value: 7
               },
               {
                   description: "Últimos 15 dias",
                   value: 15
               },
               {
                   description: "Últimos 30 dias",
                   value: 30
               },
               {
                   description: "Últimos 3 meses",
                   value: 90
               },
               {
                   description: "Últimos 6 meses",
                   value: 180
               }
           ];

           /// Query
          vm.args = {
               loading: false,
               page: 1,
               total_rows: data.total_rows,
               cultura: null,
               variedade: null,
               periodo: null,
               fornecedor: null,
               date_inicio: null,
               date_fim: null,
               _change: change
          };

          init();

          function init() {
               resetFilters();
               getName();
               vendaNovoService.clearDados();
               let modalCheck = localStorage.getItem('modalVender');
               if(!modalCheck){
                    modalPassoAPasso()
               }
          }

          function getName() {
               clientePerfilService.getAtivo().then(function (response) {
                    //console.log(response);
                    vm.user = response
               });
          }

          function search() {

               vm.loadingProgress = true;
               vendaNovoService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          function resetFilters(){
               vm.args = {
                    loading: false,
                    page: 1,
                    total_rows: null,
                    cultura: null,
                    variedade: null,
                    periodo: null,
                    fornecedor: null,
                    date_inicio: null,
                    date_fim: null,
                    _change: change
               };
               datapickerActive.removeClass("dates-active");
               periodoActive.removeClass("select-active");
               vm.variedade = null;
               vm.activeFilters = null;
               vm.totalInputs = 0;
               vm.uniddMedida = null;
          }

          function change() {
               var message = 'Os filtros Cultura e Variedade são obrigatórios';
               vm.totalInputs = 0;
               vm.uniddMedida = null;

               vm.variedade?vm.args.variedade=vm.variedade.nome:null;

               if(vm.args.cultura && vm.variedade){

                    vm.args.loading = true;
                    vendaNovoService.query(vm.args).then(function (response) {
                         vm.models = response.data;
                         vm.args.total_rows = response.total_rows;
                         vm.args.length_rows = vm.models.length;
                         showActiveFilters();
                         // limpar inputs e checks
                         vm.models.lote_producao_distribuicao.forEach( function(item) {
                              if(item.qtdinput != 0){
                                   item.qtdinput = null;
                                   item.selected = false;
                              }
                         });

                    }).finally(function () {
                         vm.args.loading = false;
                    });
               }else{
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                    );
                    resetFilters();
               }
          }

          var counterFilters = 0;
          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let inicio = $filter('date')(vm.args.date_inicio,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.date_fim,'dd/MM/yyyy');
               let arrFilters = null;
               for (let i = 0; i < vm.periods.length; i++) {
                    if (vm.periods[i].value == vm.args.periodo) {
                         periodoSelect = vm.periods[i].description
                    };
               }

               arrFilters = [
                    {
                         description: vm.args.cultura,
                         value: 'cultura'
                    },
                    {
                         description: vm.variedade.nome,
                         value: 'variedade'
                    },
                    {
                         description: periodoSelect,
                         value: 'periodo'
                    },
                    {
                         description: inicio?inicio+" - "+fim:null,
                         value: 'datepicker'
                    },
                    {
                         description: vm.args.fornecedor,
                         value: 'fornecedor'
                    }
               ];
               for (let i = 0; i < arrFilters.length; i++) {
                    if (arrFilters[i].description != null || arrFilters[i].description != undefined) counterFilters++;
               }

               if(counterFilters > 0){
                    vm.activeFilters = arrFilters;
               }
          }

          function desableFilter(value){
               if(value == 'datepicker'){
                    vm.args.date_inicio = null;
                    vm.args.date_fim = null;
                    datapickerActive.removeClass("dates-active");
               }
               if(value == 'periodo'){
                    periodoActive.removeClass("select-active");
               }
               if(value == 'cultura' || value == 'variedade'){
                    vm.cultura = null;
                    vm.variedade = null;
               }
               vm.args[value] = null;
               if(counterFilters > 1){
                    change();
               }else{
                    counterFilters = 0;
                    resetFilters();
               }
          }

          function openFilter(){
               let contentFilter = angular.element(document.querySelector('.form-search-horizontal'));
               contentFilter.addClass('actived');
          }
          function closeFilter(){
               let contentFilter = angular.element(document.querySelector('.form-search-horizontal'));
               contentFilter.removeClass('actived');
          }

          function gotoLote() {
               $state.go('app.compras.lotes_comprados.buscar');
          }

          function gotoLoteProducao(id) {
               $state.go('app.registro.lote_producao.visualizar', {
                    id: id
               });
          }

          function IsNullReturnZero (valor){
               if(valor){
                    return valor;
               }else{
                    return 0;
               }
          }

          function checkFunction (model) {
               vm.totalInputs = 0;
               if(model.selected){
                    // arredondar, para menos, unidades quebradas
                    if(model.unidade_medida == 'unidades'){
                         model.qtdinput = Math.trunc(model.quantidade_disponivel);
                    }else{
                         model.qtdinput = model.quantidade_disponivel;
                    }
               }else{
                    model.qtdinput = 0;
               }
               updateValor();
          }

          function updateValor () {
               vm.totalInputs = 0;
               // busca por item preenchido para a soma
               vm.models.lote_producao_distribuicao.forEach( function(item) {
                    item.errors = '';
                    // limpar imput
                    if(item.qtdinput == 0){
                         item.qtdinput = null;
                    }
                    // erro quando digita valor maior que disponível
                    if(item.qtdinput > item.quantidade_disponivel){
                         item.errors = 'O valor não pode ser maior que a quantidade disponível';
                    }
                    // SOMA
                    vm.totalInputs += IsNullReturnZero(item.qtdinput);
               });
               // busca pelo primiro tipo de unidade selecionada
               let PrimeiroItemSelecionado = vm.models.lote_producao_distribuicao.find(function(item){
                    return IsNullReturnZero(item.qtdinput) > 0;
               });
               vm.uniddMedida = PrimeiroItemSelecionado == null?null:PrimeiroItemSelecionado.unidade_medida;
               // busca por item com erro para desabilitar o botão
               let itensComErro = vm.models.lote_producao_distribuicao.filter(function(item){
                    return item.errors != '';
               });
               vm.myCheck = itensComErro.length == 0 && PrimeiroItemSelecionado != null;
               // gravando total vendido p/ tela 2
               vendaNovoService.addPeso(vm.totalInputs);
          }

          function gotoVenda(model) {
               vendaNovoService.clearLotes();
               for (let index = 0; index < model.length; index++) {
                    const element = model[index];

                    if (element.selected || element.qtdinput) {
                         vm.LotesSelecionados.push({
                              id: element.id,
                              lote_producao_distribuicao_tipo: {
                                   id: element.lote_producao_distribuicao_tipo.id,
                                   nome: element.lote_producao_distribuicao_tipo.nome
                                   },
                              lote_producao_distribuicao_cultura: {
                                   cultura_descricao: element.lote_producao_distribuicao_cultura.cultura_descricao,
                                   cultura_variedade: element.lote_producao_distribuicao_cultura.cultura_variedade
                                   },
                              data: element.data,
                              lote_numero: element.lote_numero,
                              produtor_nome: element.produtor_nome,
                              produtor_cnpj_cpf: element.produtor_cnpj_cpf,
                              quantidade: element.quantidade,
                              unidade_medida: vm.uniddMedida,
                              quantidade_disponivel: element.quantidade_disponivel,
                              quantidade_vendida: element.qtdinput //document.getElementById("inptqtd"+[index]).value
                         });
                         vendaNovoService.addLote(vm.LotesSelecionados);
                    }
               }
               console.log(vm.LotesSelecionados);
               $state.go('app.vendas.venda.preencher');
          }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               //vm.args.periodo = null;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }

          function viewTutorial() {

               $mdDialog.show({
                   controller: mdDialogCtrlPasso,
                   templateUrl: 'app/main/vendas/venda/views/modal-tutorial.html',
                   parent: angular.element(document.body),
                   clickOutsideToClose: true,
                   fullscreen: true // Only for -xs, -sm breakpoints.
               })
                   .then(function () {
                       return null;
                   }, function () {
                       return null;
                   });

           }

           function mdDialogCtrlPasso($scope, $mdDialog) {
               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function checkModal(){
               $mdDialog.hide();
               if(vm.model.check == true){
                    localStorage.setItem('modalVender', true);
                    return
               }
               localStorage.removeItem('modalVender');
          }

          function modalPassoAPasso(form) {
               $mdDialog.hide();

               $mdDialog.show({
                    contentElement: '#myStaticDialog',
                   //templateUrl: 'app/main/vendas/venda/views/modal-passo-a-passo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: false, // Only for -xs, -sm breakpoints.
                    controller: 'SelecionarVendaNovoController as vm'
               });
           }

           function close() {
               $mdDialog.hide();
           }



          // var api2 = 'http://localhost:3333/culturas';
          // $http.get(api2).
          // then(function(response) {
          //      $scope.culturas = response.data;
          // });
     }

})();

(function () {
     'use strict';

     angular
          .module('app.vendas.venda')
          .controller('PreencherVendaNovoController', PreencherVendaNovoController)
          .controller('CriarClienteController', CriarClienteController)
          .controller('CriarDistribuidorController', CriarDistribuidorController);

     /** @ngInject */
     function PreencherVendaNovoController($scope, unidade, cliente_consumidores, cliente_distribuidores, tipo, $filter, $state, vendaNovoService, model, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.lotes = vendaNovoService.getLotes();
          vm.pesoTotal = vendaNovoService.getPeso();
          vm.selecionarForm = vendaNovoService.getDados();

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;
          vm.qtdstatus = false

          //Events
          vm.addPageColheita = addPageColheita;
          vm.removePageColheita = removePageColheita;
          vm.gotoSearch = gotoSearch;
          vm.encerrar = encerrar;
          vm.checkQTD = checkQTD;

          vm.api_response_erro = {};

          vm.cliente_consumidores = cliente_consumidores;
          vm.cliente_distribuidores = cliente_distribuidores;
          vm.unidades = unidade
          vm.tipos = tipo
          vm.gotoAddClient = gotoAddClient;
          vm.showDialogCreateCliente = ShowDialogCreateCliente;
          vm.showDialogCreateDistribuidor = showDialogCreateDistribuidor;
          vm.cancelClick = cancelClick;
          vm.gotoConfirmar = gotoConfirmar;
          vm.selectedClienteEmail = selectedClienteEmail;
          //////////

          vm.myDate = new Date();

          vm.minDate = new Date(
               vm.myDate.getFullYear(),
               vm.myDate.getMonth(),
               vm.myDate.getDate() - 15
          );
          vm.maxDate = new Date(
               vm.myDate.getFullYear(),
               vm.myDate.getMonth(),
               vm.myDate.getDate() + 7
          );
          //vm.maxDate = new Date();

          init();

          function init() {

               if(vm.lotes.length == 0){
                    gotoSearch();
                    return
               }

          }

          function gotoConfirmar(text) {
               vm.selecionarForm = {
                    data: text.data,
                    tipo_embalagem: text.tipo_embalagem,
                    peso_embalagem: text.peso_embalagem,
                    quantidade_embalagem: text.quantidade_embalagem,
                    valor_total: text.valor_total,
                    numero_doc: text.numero_doc,
                    cliente: text.cliente,
                    email_cliente: text.email_cliente,
                    distribuidor: text.distribuidor
               };
               //console.log(vm.salvarDados)
               if(checkQTD()){
                    vendaNovoService.addDados(vm.selecionarForm);
                    $state.go('app.vendas.venda.confirmar');
               }

          }

          function checkQTD(){
               vm.qtdstatus = null;
               let pesoEmbalagem = vm.selecionarForm.peso_embalagem;
               let pesoTotal = vm.pesoTotal;//parseFloat(vm.pesoTotal.replace(".","").replace(",","."));
               //let btnConfirmar = document.querySelector('#btnAdcnrDstrbdr');
               let QTDembalagem = pesoTotal / pesoEmbalagem;
               vm.selecionarForm.quantidade_embalagem = Math.ceil(QTDembalagem);
               if(QTDembalagem){
                    // console.log('pesoXqtd ='+pesoXqtd);
                    // console.log('pesoTotal ='+pesoTotal);
                    // console.log('embalagens='+pesoTotal / pesoEmbalagem);
                    let QTDembalagem2 = parseInt(vm.selecionarForm.quantidade_embalagem);
                    let pesoXqtd = parseInt(QTDembalagem2 * pesoEmbalagem);
                    if(pesoXqtd > pesoTotal){
                         let resto = pesoTotal - (Math.trunc(QTDembalagem) * pesoEmbalagem);
                         if(vm.lotes[0].unidade_medida == 'kg'){
                              vm.qtdstatus = 'Uma embalagem conterá apenas ' + $filter('number')(resto,3) + ' ' + vm.lotes[0].unidade_medida;
                         }else{
                              vm.qtdstatus = 'Uma embalagem conterá apenas ' + Math.trunc(resto) + ' ' + vm.lotes[0].unidade_medida;
                         }
                         //btnConfirmar.setAttribute("disabled", "disabled");
                         return true;
                    }
                    return true
               }else{
                    vm.qtdstatus = null;
                    return false;
               }
          }

          function selectedClienteEmail(){
               if(vm.selecionarForm.cliente.email != null){
                    vm.selecionarForm.email_cliente = vm.selecionarForm.cliente.email
               }else{
                    vm.selecionarForm.email_cliente = null
               }
          }

          function encerrar(model) {

               var message = $filter('translate')('COLHEITA.CADERNO_CAMPO_ENCERRADO');

               vendaNovoService.encerrarCadernoCampo(model)
                    .then(function (response) {
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch();

                    }).catch(function (response) {
                         var message = $filter('translate')('COLHEITA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function addPageColheita() {
               vm.model.lote_distribuicao_venda_itens.push({
                    quantidade: "",
                    cliente: ""
               });
          }

          function removePageColheita(index) {
               vm.model.lote_distribuicao_venda_itens.splice(index, 1);
          }

          function gotoAddClient() {
               $state.go('app.vendas.venda.buscar');
          }

          function gotoSearch() {
               $state.go('app.vendas.venda.selecionar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function ShowDialogCreateCliente(ev, lista_detalhes) {

               $mdDialog.show({
                    controller: 'CriarClienteController as vm',
                    templateUrl: 'app/main/vendas/venda/views/criar_cliente.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function (answer) {
                         if (answer) {
                              //vm.cliente_consumidores.push(answer);
                              vm.selecionarForm.cliente = answer;
                         }
                    }, function () {
                         vm.model.cliente = null;
                    });

          }

          function showDialogCreateDistribuidor(ev, lista_detalhes) {

               $mdDialog.show({
                    controller: 'CriarDistribuidorController as vm',
                    templateUrl: 'app/main/vendas/venda/views/criar_distribuidor.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function (answer) {
                         if (answer) {
                              //vm.distruibuidores.push(answer);
                              vm.selecionarForm.distribuidor = answer;
                         }
                    }, function () {
                         vm.model.cliente = null;
                    });

          }

          function pesoQuantidadeFormat(value){
               let number = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

               if(number.length >= 9){
                    number = number.replace(",",".");
               }
               return number;
          }

     }

     function CriarClienteController($rootScope, $scope, $state, $filter, clienteService, distribuidorService, $mdToast, $mdDialog) {


          var vm = this;

          // Data
          vm.model = {};
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: 1
               }

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               message = $filter('translate')('VENDA.CLIENTE_ADICIONADO');
               this.savePromise = clienteService.create(vm.model);

               if (vm.model.distribuidor == true) {
                    this.savePromise = distribuidorService.create(vm.model);
               }

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdDialog.hide(vm.model);


                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );




                    //gotoSearch();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               //$state.go('app.cadastros.buscar');
               $mdDialog.hide();
          }


     }

     function CriarDistribuidorController($rootScope, $scope, $state, $filter, distribuidorService, clienteService, $mdToast, $mdDialog) {


          var vm = this;

          // Data
          vm.model = {};
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: 1
               }

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               var message = $filter('translate')('VENDA.DISTRIBUIDOR_ADICIONADO');
               this.savePromise = distribuidorService.create(vm.model);

               if (vm.model.distribuidor == true) {
                    this.savePromise = clienteService.create(vm.model);
               }

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdDialog.hide(vm.model);

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );

                    //gotoSearch();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               //$state.go('app.cadastros.buscar');
               $mdDialog.hide();
          }


     }


})();

(function () {
     'use strict';

     angular
          .module('app.vendas.venda')
          .controller('ConfirmarVendaController', ConfirmarVendaController);

     /** @ngInject */
     function ConfirmarVendaController($state, model, vendaNovoService, $rootScope, $filter, $mdToast, $location) {
          var vm = this;

          vm.lotes = vendaNovoService.getLotes();
          vm.pesoTotal = vendaNovoService.getPeso();
          vm.dadosVenda = vendaNovoService.getDados();

          // Data
          vm.model = model;
          vm.status = [];
          vm.undMedida = null;

          // Methods
          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.cancelClick = cancelClick;
          vm.gotoSucesso = gotoSucesso;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {
               if(vm.dadosVenda.length != 0){
                    vm.undMedida = vm.lotes[0].unidade_medida;
               }else{
                    $state.go('app.vendas.venda.selecionar');
                    return
               }
          }

          function save() {
               let lotesSelecionados = [];
               let dadosVendaFinal = {
                    data_expedicao: vm.dadosVenda.data,
                    peso_total_lotes: vm.pesoTotal,
                    unidade_medida: vm.undMedida,
                    embalagem_tipo: vm.dadosVenda.tipo_embalagem,
                    embalagem_peso: vm.dadosVenda.peso_embalagem,
                    embalagem_quantidade: vm.dadosVenda.quantidade_embalagem,
                    valor_total_venda: vm.dadosVenda.valor_total.toFixed(2),
                    numero_documento: vm.dadosVenda.numero_doc,
                    cliente_consumidor: {
                         id: vm.dadosVenda.cliente.id,
                         email: vm.dadosVenda.email_cliente
                    },
                    cliente_distribuidor: (vm.dadosVenda.distribuidor)?{
                         id: vm.dadosVenda.distribuidor.id
                    }:null,
                    lotes: [
                         {
                              id: null,
                              lote_tipo: {
                                   id: null
                              },
                              quantidade: null
                         }
                    ]
               }

               for (let index = 0; index < vm.lotes.length; index++) {
                    const lote = vm.lotes[index];
                    lotesSelecionados.push(
                         {
                              id: lote.id,
                              lote_tipo: {
                                   id: lote.lote_producao_distribuicao_tipo.id
                              },
                              quantidade: lote.quantidade_vendida
                         }
                    );
               }

               dadosVendaFinal.lotes = lotesSelecionados;

               console.log(dadosVendaFinal);
               
               var message = '';
               message = $filter('translate')('VENDA.VENDA_CREATED');
               this.savePromise = vendaNovoService.create(dadosVendaFinal);
               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    let postID = response.id;
                    vendaNovoService.clearDados();
                    if(postID){
                        gotoSucesso(postID);
                    }else{
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch();
                    }

               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(vm.api_response_erro.data.errors[Object.keys(response.data.errors)[0]] + ' ('+vm.api_response_erro.data.detail+')')
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(10000)
                    );
               });
          }

          function gotoSucesso(id) {

               $state.go('app.vendas.venda.sucesso', {
                   id: id
               });
           }

          function gotoSearch() {
               $state.go('app.vendas.lotes_vendidos.buscar');
          }

          function cancelClick() {
               $state.go('app.vendas.venda.preencher');
          }

          // function pesoQuantidadeFormat(value){
          //      let number = value.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');

          //      if(number.length >= 9){
          //           number = number.replace(",",".");
          //      }
          //      return number;
          // }
          // function pesoQuantidadeDB(value){
          //      let number = value;
          //      if(typeof number === 'string'){
          //           number = number.replace(".","").replace(",",".");
          //      }else{
          //           number = number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
          //           if(number.length > 7){
          //                number = number.replace(".","");
          //           }
          //      }
          //      return parseFloat(number);
          // }

     }
})();

(function () {
    'use strict';

    angular
         .module('app.vendas.lotes_cancelados', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.vendas.lotes_cancelados', {
                   abstract: true,
                   url: '/lotes_cancelados'
              })
          //     .state('app.vendas.lotes_cancelados.buscar', {
          //          url: '/buscar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/vendas/lotes_cancelados/views/buscar.html',
          //                    controller: 'BuscarCanceladosController as vm'
          //               }
          //          },
          //          resolve: {
          //               data: function (canceladosService) {
          //                    return canceladosService.query();
          //               },
          //           //     cliente: function (clientePerfilService) {
          //           //          return clientePerfilService.get();
          //           //     },
          //               culturas: function (areaService) {
          //                    return areaService.getCulturas();
          //               }
          //          }
          //     })
          //     .state('app.vendas.lotes_cancelados.visualizar', {
          //          url: '/visualizar/:id',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/vendas/lotes_cancelados/views/visualizar.html',
          //                    controller: 'VisualizarCanceladosController as vm'
          //               }
          //          },
          //          resolve: {
          //               model: function ($stateParams, canceladosService) {
          //                    return canceladosService.VendaCanceladaID($stateParams.id);
          //               }
          //          }
          //     })

         // Translation
         $translatePartialLoaderProvider.addPart('app/main/vendas/lotes_cancelados');

         //Menu
     //     msNavigationServiceProvider.saveItem('rastreamento.lotes_cancelados', {
     //          title: 'Lotes Cancelados',
     //          // icon: 'icon-document',
     //          state: 'app.vendas.lotes_cancelados.buscar',
     //          translate: 'CANCELADOS.CANCELADOS'
     //     });

    }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_cancelados')
          .factory('canceladosService', canceladosService);

     /** @ngInject */
     function canceladosService($q, api, $mdToast) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               getNew: getNew,
               query: query,
               get: get,
               estornar: estornar,
               VendaCanceladaID: VendaCanceladaID,
          };

          return service;

          //////////


          function getNew() {
               return {};
          }

          ////// LISTAR - PAGAMENTO ////// 
          function query(args, cache) {

               // cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               api.LoteDistribuicaoVendaCancelados.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         models = response.data;
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    if (response.data.data.detail) {
                         console.log('aq', response.data.data.detail);
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(response.data.data.detail)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    }
                    console.log(response);
               });

               return deferred.promise;
          };
          ////// LISTAR - PAGAMENTO ////// 

          ////// CONSULTA POR ID - LOTE ////// 
          function get(id) {
               var deferred = $q.defer();

               api.LoteDistribuicao.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - LOTE ////// 

          ////// CONSULTA POR ID - LOTE ////// 
          function VendaCanceladaID(id) {
               var deferred = $q.defer();

               api.VendaCanceladaID.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - LOTE ////// 

          ////// CANCELAR - LOTE ////// 
          function estornar(model) {

               var deferred = $q.defer();

               api.LoteDistribuicaoVendaEstorno.post(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CANCELAR - LOTE ////// 

     }

})();

(function () {
    'use strict';

    angular
         .module('app.vendas.lotes_cancelados')
         .controller('VisualizarCanceladosController', VisualizarCanceladosController);

    /** @ngInject */
    function VisualizarCanceladosController($scope, $state, $filter, model, $mdToast, $mdDialog, vendidosService) {
         var vm = this;

         // Data
         vm.model = model;
         vm.status = [];

         // Filters
         vm.categoriesSelectFilter = '';

         // Methods
         vm.comeBack = comeBack;
         vm.gotoLoteProducao = gotoLoteProducao;
         vm.gotoLoteVenda = gotoLoteVenda;
         vm.gotoSearch = gotoSearch;

         //////////

         init();

         /**
          * Initialize
          */
         function init() {

         }

         function comeBack(){
              // console.log('oi')
              javascript:history.back(1);
         }

         function gotoSearch() {
              $state.go('app.vendas.lotes_vendidos.buscar');
         }

         function gotoLoteProducao(id) {
              $state.go('app.registro.lote_producao.visualizar', {
                   id: id
              });
         }

         function gotoLoteVenda(id) {
              $state.go('app.vendas.lotes_vendidos.visualizar', {
                   id: id
              });
         }
    }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_cancelados')
          .controller('BuscarCanceladosController', BuscarCanceladosController)

     /** @ngInject */
     function BuscarCanceladosController(data, $state, $scope, culturas, canceladosService, $mdDialog, $filter) {
          var vm = this;

          vm.models = data.data;
          // Data
          vm.gotoVisualizar = gotoVisualizar;
          vm.search = search;
          vm.resetFilters = resetFilters;
          vm.clearPreDate = clearPreDate;
          vm.gotoEstornar = gotoEstornar;
          vm.clearRangeDate = clearRangeDate;

          vm.activeFilters = false;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;

          vm.culturas = culturas;
          vm.periods = [
               {
                   description: "Últimos 7 dias",
                   value: 7
               },
               {
                   description: "Últimos 15 dias",
                   value: 15
               },
               {
                   description: "Últimos 30 dias",
                   value: 30
               },
               {
                   description: "Últimos 3 meses",
                   value: 90
               },
               {
                   description: "Últimos 6 meses",
                   value: 180
               }
          ];

          vm.model = {
               dataInicial: new Date(),
               dataFinal: new Date()
          }
          //////////

          init();

          function init() {
               vm.date = new Date();

          }

          function search() {

               vm.loadingProgress = true;
               canceladosService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               periodo: null,
               data_inicial: null,
               data_final: null,
               cultura: null,
               cliente_consumidor_id: null,
               sort_by: 'data_expedicao',
               sort_order: 'desc',
               _change: change
          };

          vm.args._change();

          function change() {
               vm.args.loading = true;
               canceladosService.query(vm.args).then(function (response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    showActiveFilters();
                    vm.args.updatePaggination();


               }).finally(function () {
                    vm.args.loading = false;
               });
          }
          function gotoEstornar(ev, model) {
               $mdDialog.show({
                    locals: {
                         dataToPass: model
                    },
                    controller: EstornoDialogCtrl,
                    templateUrl: 'app/main/vendas/lotes_cancelados/views/estornar.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               });

          }

          function resetFilters() {
               vm.args.periodo = null;
               vm.args.cultura = null;
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.cliente_consumidor_id = null;
               change();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let arr = null;
               let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
               let counter = 0;
               for (let i = 0; i < vm.periods.length; i++) {
                    if (vm.periods[i].value == vm.args.periodo) {
                         periodoSelect = vm.periods[i].description
                    };
               }
               for (let i = 0; i < vm.models.consumidores.length; i++) {
                    if (vm.models.consumidores[i].id == vm.args.cliente_consumidor_id) {
                         var clienteNome = vm.models.consumidores[i].nome
                    };
               }
               arr = [
                    {
                         description: periodoSelect,
                         value: 'periodo'
                    },
                    {
                         description: inicio?inicio+" - "+fim:null,
                         value: 'datepicker'
                    },
                    {
                         description: clienteNome,
                         value: 'cliente_consumidor_id'
                    },
                    {
                         description: vm.args.cultura,
                         value: 'cultura'
                    },
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value){
               if(value == 'datepicker'){
                    vm.args.data_inicial = null;
                    vm.args.data_final = null;
               }
               vm.args[value] = null;
               change();
          }

          function clearPreDate() {
               vm.args.periodo = null
          }
          function clearRangeDate() {
               vm.args.data_inicial = null
               vm.args.data_final = null
          }


          this.openMenu = function ($mdMenu, ev) {
               // eslint-disable-next-line no-unused-vars
               var originatorEv;
               originatorEv = ev;
               $mdMenu.open(ev);
          };


          function gotoVisualizar(id) {
               $state.go('app.vendas.lotes_cancelados.visualizar', {
                    id: id
               });
          }
          function EstornoDialogCtrl($scope, dataToPass, $mdDialog, canceladosService, $filter, $mdToast) {
               $scope.estorno = 'Estorno';
               var utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
               $scope.date = utc;

               $scope.estornarLote = function () {
                    let post = {
                         id: dataToPass.id,
                         descricao: $scope.descricao
                    }
                    canceladosService.estornar(post)
                         .then(function (response) {
                              vm.models.lote_distribuicao_venda.splice(vm.models.lote_distribuicao_venda.indexOf(dataToPass), 1);
                              var message = $filter('translate')('CANCELADOS.ESTORNADO');
                              $mdToast.show(
                                   $mdToast.simple()
                                        .textContent(message)
                                        .position('top right')
                                        .theme("success-toast")
                                        .hideDelay(6000)
                              );
                              $mdDialog.cancel();
                         }).catch(function (response) {
                              //var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                              var message = response.data.errors[Object.keys(response.data.errors)[0]] + ' ('+response.data.detail+')';
                              $mdToast.show(
                                   $mdToast.simple()
                                        .textContent(message)
                                        .position('top right')
                                        .theme("error-toast")
                                        .hideDelay(6000)
                              );
                         });
               }

               $scope.close = function () {
                    $mdDialog.cancel();
               };

          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_distribuicao')
          .controller('VisualizarDistribuicaoController', VisualizarDistribuicaoController);

     /** @ngInject */
     function VisualizarDistribuicaoController($scope, $state, $filter, model, $mdToast, $mdDialog, distribuicaoService) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods         
          vm.gotoLoteProducao = gotoLoteProducao;
          vm.isFormValid = isFormValid;
          vm.gotoLoteVenda = gotoLoteVenda;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoLoteProducao(id) {
               $state.go('app.registro.lote_producao.visualizar', {
                    id: id
               });
          }

          function gotoLoteVenda(id) {
               $state.go('app.vendas.lotes_distribuicao.visualizar', {
                    id: id
               });
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas.lotes_distribuicao')
          .controller('BuscarDistribuicaoController', BuscarDistribuicaoController);

     /** @ngInject */
     function BuscarDistribuicaoController(data, $state, $scope, distribuicaoService, $mdDialog, cliente) {
          var vm = this;
          vm.models = data.data;
          // Data
          vm.gotoVisualizar = gotoVisualizar;
          vm.search = search;
          vm.gotoPrint = gotoPrint;
          vm.clientePerfil = cliente;
          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               distribuicaoService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'asc',
               _change: change
          };

          vm.args._change();

          function change() {
               

               vm.args.loading = true;
               distribuicaoService.query(vm.args).then(function (response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function gotoPrint(model, ev) {

               var endereco = vm.clientePerfil.cliente_endereco.endereco +
                    ' ' +
                    vm.clientePerfil.cliente_endereco.numero

               // if (vm.clientePerfil.cliente_endereco.complemento.length > 0) {
               //      endereco += ' - ' + vm.clientePerfil.cliente_endereco.cidade_nome;
               // }

               //  endereco += ' ' + vm.clientePerfil.cliente_endereco.endereco +
               //       '-' + vm.clientePerfil.cliente_endereco.uf

               $mdDialog.show({
                    locals: {
                         dataToPass: {
                              codigo_fornecedor: vm.clientePerfil.id,
                              lote_numero: model.lote_numero,
                              nome_produtor: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_nome,
                              endereco: {
                                   rua: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_rua,
                                   numero: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_numero,
                                   cidade: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_cidade_nome,
                                   uf: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_uf
                              },
                              cnpj_cpf: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_cnpj_cpf,
                              telefone: {
                                   ddd: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_telefone_ddd,
                                   numero: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_telefone_numero
                              },
                              produto_nome: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produto_nome,
                              produto_variedade: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produto_variedade,
                              data_colheita: model.lote_producao_lote_distribuicao_vinculos[0].lote_producao.data_colheita,
                              data_expedicao: model.lote_distribuicao_venda.data_expedicao,
                              quantidade: model.lote_distribuicao_venda.quantidade,
                              unidade_medida: model.lote_distribuicao_venda.unidade_medida,
                              produto_embalagem_tipo: model.lote_distribuicao_venda.embalagem_tipo,
                              produto_embalagem_peso: model.lote_distribuicao_venda.embalagem_peso,
                              distribuidor_nome: model.lote_distribuicao_venda.cliente_distribuidor.nome,
                              distribuidor_cnpj_cpf: model.lote_distribuicao_venda.cliente_distribuidor.cnpj_cpf,
                              quantidade_etiquetas: model.quantidade_etiquetas,
                              tamanho_etiquetas: model.tamanho_etiquetas,
                              tipo_etiquetas: model.tipo_etiquetas,
                              id_lote: model.lote_distribuicao.id

                         }
                    },
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/vendas/lotes/comprados/views/print-label.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: false
               })
                    .then(function (answer) {
                         $scope.status = 'You said the information was "' + answer + '".';
                    }, function () {
                         $scope.status = 'You cancelled the dialog.';
                    });
          }

          function mdDialogCtrl($scope, dataToPass, $mdDialog) {

               $scope.rolo = 'Rolo'

               $scope.tamanho_etiquetas = [{
                    id: 1,
                    tamanho: "100mm X 50mm"
               }, {
                    id: 2,
                    tamanho: "120mm X 50mm"
               }];

               $scope.tipo_etiquetas = [{
                    id: 1,
                    tipo: "A4"
               },
               {
                    id: 2,
                    tipo: "Rolo"
               }
               ];

               $scope.colunas = [{
                    id: 1,
                    tipo: "1 coluna"
               },
               {
                    id: 2,
                    tipo: "2 colunas"
               }
               ];

               $scope.Export = function (quantidade) {

                    for (var i = 1; i <= quantidade; i++) {

                         $("#imprimirdezporcincoa4").clone().appendTo("#printThis");

                         if (i % 10 === 0) {
                              $("#printThis").append("<div style='page-break-after:always'></div>");
                         }
                    }

                    var element = document.getElementById('printThis');
                    var opt = {
                         margin: 0.1,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              unit: 'in',
                              format: 'a4',
                              orientation: 'portrait'
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportRolo = function () {

                    $("#imprimirdezporcincorolo").clone().appendTo("#printThisRolo");

                    var element = document.getElementById('printThisRolo');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [108, 58]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }


               $scope.ExportDoze = function () {


                    $("#imprimirdozeporcinco").clone().appendTo("#printThisDoze");


                    var element = document.getElementById('printThisDoze');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [129, 58]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportDozeRotate = function () {

                    for (var i = 1; i <= 2; i++) {
                         $("#imprimirdozeporcincorotate").clone().appendTo("#printThisDozeRotate");
                    }

                    var element = document.getElementById('printThisDozeRotate');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [129, 112]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }



               $scope.vm = {
                    model: {
                         data: 'colheita'
                    }
               }
               $scope.model = dataToPass;

               $scope.model.url = location.origin + "/vendas/lotes_vendidos/visualizar/" + $scope.model.id_lote;

               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function gotoVisualizar(id) {
               $state.go('app.vendas.lotes_distribuicao.visualizar', {
                    id: id
               });
          }

          // function gotoPrintLabel(id) {
          //      $state.go('app.vendas.lote_venda.imprimir', {
          //           id: id
          //      });
          // }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.area', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
               .state('app.registro.area', {
                    abstract: true,
                    url: '/area'
               })
               .state('app.registro.area.dash', {
                    url: '/dash',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/area/views/dashboard.html',
                              controller: 'DashAreaController as vm'
                         }
                    },
                    resolve: {
                         data: function (areaService) {
                              return areaService.dash(null);
                         },
                         propriedades: function (areaService){
                              return areaService.queryPropertie();
                         }
                    }
               })
               .state('app.registro.area.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/area/views/buscar.html',
                              controller: 'BuscarAreaController as vm'
                         }
                    },
                    resolve: {
                         // data: function (areaService) {
                         //      return areaService.query(null);
                         // },
                         filtros: function (areaService) {
                              return areaService.getFiltros();
                         }
                    }
               })
               .state('app.registro.area.criar', {
                    url: '/criar?propriedade',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/area/views/criar.html',
                              controller: 'CriarAreaController as vm'
                         }
                    },
                    resolve: {
                         model: function (areaService) {
                              return areaService.getNew();
                         },
                         propriedades: function (areaService, $stateParams) {
                              return areaService.getPropriedades($stateParams);
                         },
                         culturas: function (areaService) {
                              return areaService.getCulturas();
                         }
                    }
               })
               .state('app.registro.area.editar', {
                    url: '/editar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/area/views/editar.html',
                              controller: 'EditarAreaController as vm'
                         }
                    },
                    resolve: {
                         model: function (areaService, $stateParams) {
                              return areaService.getId($stateParams.id);
                         },
                         culturas: function (areaService) {
                              return areaService.getCulturas();
                         }
                    }
               })
               .state('app.registro.area.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/area/views/visualizar.html',
                              controller: 'VisualizarAreaController as vm'
                         }
                    },
                    resolve: {
                         model: function (areaService) {
                              return areaService.get();
                         }
                    }
               })
               .state('app.registro.area.historico', {
                    url: '/historico',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/area/views/historico.html',
                              controller: 'HistoricoAreaController as vm'
                         }
                    }
                    // resolve: {
                    //      model: function (areaService) {
                    //           return areaService.query(null);
                    //      }
                    // }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro/area');
          $translatePartialLoaderProvider.addPart('app/main/registro');


          // msNavigationServiceProvider.saveItem('registro.area', {
          //      title: 'Area',
          //  //     icon: 'icon-library-books',
          //      // group: true,
          //      weight: 1,
          //      translate: 'PROPERTIES.AREA'
          // });

          //Menu
          msNavigationServiceProvider.saveItem('area.dash', {
               title: 'Dashboard',
               state: 'app.registro.area.dash',
          });
          msNavigationServiceProvider.saveItem('area', {
               title: 'Áreas',
               img: '/assets/icons/ico-menu-areas.svg',
               weight: 2,
               //state: 'app.registro.area.buscar',
               //translate: 'AREA.CADASTRO'
          });
          msNavigationServiceProvider.saveItem('area.criar', {
               title: 'Cadastro',
               state: 'app.registro.area.criar',
               //translate: 'AREA.CADASTRO'
          });
          msNavigationServiceProvider.saveItem('area.historico', {
               title: 'Histórico',
               state: 'app.registro.area.historico',
               //translate: 'AREA.CADASTRO'
          });

          // msNavigationServiceProvider.saveItem('registro.area.historico', {
          //      title: 'Area',
          //      // icon: 'icon-select',
          //      state: 'app.registro.area.historico',
          //      translate: 'AREA.HISTORICO'
          // });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.area')
          .factory('areaService', areaService);

     /** @ngInject */
     function areaService($q, propertieService, $mdToast, $filter, api) {

          var areas = [];
          var models = [];
          var queryResponse = {};
          var filtrosDash = [];
          // var status = {};

          var queryArgsDefault = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'asc',
          };

          var queryArgs = queryArgsDefault;

          var service = {
               getNew: getNew,
               dash: dash,
               query: query,
               fullQuery: fullQuery,
               areasSemPlantio: areasSemPlantio,
               create: create,
               update: update,
               getId: getId,
               get: get,
               getFiltros: getFiltros,
               getPropriedade: getPropriedade,
               search: search,
               getCulturas: getCulturas,
               getVariedades: getVariedades,
               createVariedade: createVariedade,
               getPropriedadeAreaHistoricoList: getPropriedadeAreaHistoricoList,
               encerrarCadernoCampo: encerrarCadernoCampo,
               deleteArea: deleteArea,
               CadernoCampoEstornarEncerramento: CadernoCampoEstornarEncerramento,
               queryCadernoCampoCancelados: queryCadernoCampoCancelados,
               getPropriedades: getPropriedades,
               getHistory: getHistory,
               getExcelFile: getExcelFile,
               encerrarCadernoCampoArea: encerrarCadernoCampoArea,
               addFiltroDash: addFiltroDash,
               getFiltroDash: getFiltroDash,
               queryPropertie: queryPropertie,
               clearFiltroDash: clearFiltroDash,
               getCulturasVariedades: getCulturasVariedades
          };

          return service;

          //////////

          function addFiltroDash(dados) {
               dados?filtrosDash=dados:filtrosDash=null;
          }
          function getFiltroDash() {
               return filtrosDash;
          }
          function clearFiltroDash() {
               filtrosDash = [];
          }

          function getNew() {
               return {};
          }

          ////// DASH - ÁREA //////
          function dash(args, cache) {
               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.PropriedadeAreaDash.get(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };

          ////// LISTAR - ÁREA //////
          function query(args, cache) {
               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    // PROVISORIO ///////////////////////////////
                    api.Area141.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };

          ////// LISTAR - CadernoCampoCancelados //////
          function queryCadernoCampoCancelados(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.CadernoCampoCancelados.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };

          ////// LISTAR - ÁREA //////

          ////// LISTAR - ÁREA TODOS //////
          function fullQuery(args, cache) {
               //console.log('FULLL')
               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("fullquery using: true");
               } else {
                    api.AreaList.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };

          ////// LISTAR - ÁREA TODOS//////

          ////// LISTAR - ÁREA SEM PLANTIO//////
          function areasSemPlantio(args, cache) {
               //console.log('FULLL')
               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("areassemplantio using: true");
               } else {
                    api.AreaFiltro.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - ÁREA SEM PLANTIO//////

          ////// CRIAR - ÁREA //////
          function create(model) {

               var deferred = $q.defer();

               api.Area.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         areas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - ÁREA //////

          // function CadernoCampoEstornarEncerramento(model) {

          //      var deferred = $q.defer();

          //      api.CadernoCampoEstornarEncerramento.estornar(model).$promise.then(

          //           // SUCCESS
          //           function (response) {
          //                deferred.resolve(response);
          //                areas.unshift(model);
          //                modelNew = {};
          //           }).catch(
          //           function (response) {
          //                //   Resolve the promise
          //                deferred.reject(response);
          //           }
          //      );
          //      return deferred.promise;
          // }


          ////// EDITAR - ÁREA //////
          function update(model) {

               var deferred = $q.defer();

               api.Area.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         areas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          ////// EDITAR - ÁREA //////


          ////// CONSULTA POR ID - ÁREA //////
          function getId(id) {

               var deferred = $q.defer();

               api.Area.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - ÁREA //////

          ////// VISUALIZAR - ÁREA //////
          function get(args) {
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;

               var deferred = $q.defer();

               api.Area.get(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         models = response.data;
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          };

          // FILTROS BUSCA AREA
          function getFiltros() {
               var deferred = $q.defer();
               //var args = {};
               api.PropriedadeAreaFiltros
                   .get().$promise
                   .then(function (response) {
                       deferred.resolve(response);
                   })
                   .catch(function (response) {
                       deferred.reject(response);
                   });
               return deferred.promise;
          }


           ////// HISTÓRICO DA ÁREA //////
           function getHistory(modelResponse) {

               var deferred = $q.defer();

               api.PropriedadeAreaHistorico.get(modelResponse).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// HISTÓRICO DA ÁREA //////

          ////// HISTÓRICO DA ÁREA //////
           function getExcelFile(modelResponse) {

               var deferred = $q.defer();

               api.PropriedadeAreaHistoricoExcel.get(modelResponse).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// HISTÓRICO DA ÁREA //////


          ////// CONSULTA PROPRIEDADE - ÁREA //////
          function search(query) {

               var deferred = $q.defer();

               api.Propriedade.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA PROPRIEDADE - ÁREA //////


          ////// CONSULTA POR PROPRIEDADE - ÁREA //////
          function getPropriedade(id) {

               var deferred = $q.defer();

               api.Propriedade.query({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR PROPRIEDADE - ÁREA //////


          ////// CULTURAS - ÁREA //////
          function getCulturas(query) {
               var deferred = $q.defer();

               api.CulturaVariedade.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getCulturasVariedades() {

               var deferred = $q.defer();
               api.PropriedadeAreaCulturasVariedades
                   .get().$promise
                   .then(function (response) {
                       deferred.resolve(response);
                   })
                   .catch(function (response) {
                       deferred.reject(response);
                   });
               return deferred.promise;
          }

          function getPropriedadeAreaHistoricoList(query) {
               var deferred = $q.defer();

               api.PropriedadeAreaHistoricoList.query(query).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          ////// CULTURAS - ÁREA //////

          ////// VARIEDADES - ÁREA //////
          function getVariedades(args) {
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;
               var deferred = $q.defer();

               if (angular.equals(args) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.Variedades.query(args).$promise.then(
                         function (response) {
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }
                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// VARIEDADES - ÁREA //////

          ////// CRIAR - VARIEDADE //////
          function createVariedade(model) {

               var deferred = $q.defer();

               api.Variedades.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         areas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          ////// ENCERRAR CADERNO CAMPO - COLHEITA //////
          function encerrarCadernoCampo(model) {

               model = {
                    id: model.propriedade_area_caderno_campos[model.propriedade_area_caderno_campos.length - 1].id
               };

               var deferred = $q.defer();

               api.CadernoCampo.encerrar(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// ENCERRAR CADERNO CAMPO - COLHEITA //////


          ////// DELETAR - ÁREA //////
          function deleteArea(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.Area.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          ////// DELETAR - ÁREA //////


          ////// PROPRIEDADE - COLHEITA //////
          function getPropriedades(propriedadeId) {
               var deferred = $q.defer();

               propertieService.query({}, false).then(function (response) {

                    if (propriedadeId && propriedadeId > 0) {
                         var propriedades = response.data.filter(function (a) {
                              return a.id == propriedadeId;
                         });

                         if (propriedades.length > 0) {
                              deferred.resolve(propriedades);
                              return;
                         }

                    }

                    deferred.resolve(response.data);

               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }
          ////// PROPRIEDADE - COLHEITA //////

          function queryPropertie() {
               var deferred = $q.defer();
               api.Propriedade.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }


          ////// ENCERRAR CADERNO CAMPO  //////
          function encerrarCadernoCampoArea(model) {
               return api.CadernoCampo.encerrarCadernoCampoArea(model).$promise;
          }
          ////// ENCERRAR CADERNO CAMPO  //////


          ////// ESTORNAR CADERNO CAMPO  //////
          function CadernoCampoEstornarEncerramento(model) {
               return api.CadernoCampo.EstornarCadernoArea(model).$promise;
          }
          ////// ESTORNAR CADERNO CAMPO  //////


     }

})();

(function () {
     'use strict';

     angular
          .module('app.area')
          .controller('VisualizarAreaController', VisualizarAreaController);

     /** @ngInject */
     function VisualizarAreaController($state, $filter, $stateParams, $mdToast, $mdDialog, areaService) {
          var vm = this;

          // DATAPICKER //////////////////
          var datapicker = document.querySelector('#dataspicker .date-picker-box');

          // // Data
         // vm.culturas = culturas;
         vm.id = $stateParams.id;
         vm.loadingProgress = false;

          vm.periods = [
               {
                   description: "Últimos 7 dias",
                   value: 7
               },
               {
                   description: "Últimos 15 dias",
                   value: 15
               },
               {
                   description: "Últimos 30 dias",
                   value: 30
               },
               {
                   description: "Últimos 3 meses",
                   value: 90
               },
               {
                   description: "Últimos 6 meses",
                   value: 180
               }
          ];

          vm.gotoEditar = gotoEditar;
          vm.gotoPlantio = gotoPlantio;
          vm.gotoSementes = gotoSementes;
          vm.gotoBiologico = gotoBiologico;
          vm.gotoDefensivo = gotoDefensivo;
          vm.gotoFertilizante = gotoFertilizante;
          vm.gotoColheita = gotoColheita;
          vm.gotoCustos = gotoCustos;
          vm.gotoLotesProduzidos = gotoLotesProduzidos;
          vm.encerrar = encerrar;
          vm.ConfirmacaoEncerramento = ConfirmacaoEncerramento;
          vm.savePromise = null

          vm.topOpenDatasSelect = topOpenDatasSelect;
          vm.topSelecionarDatas = topSelecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.topSelectedPeriodo = topSelectedPeriodo;
          //////////

          init();

          /**
           * Initialize
           */
          function init() {
          }

          /// Query
          vm.args = {
               id: vm.id,
               loading: false,
               periodo: 90,
               data_inicio: null,
               data_final: null,
               _change: change
          };
          vm.args._change();

          function change() {
               vm.args.loading = true;
               areaService.get(vm.args).then(function (response) {
                    vm.models = response;
                    console.log('DADOS', vm.models)
                }).finally(function () {
                    vm.args.loading = false;
                });
          }

          function ConfirmacaoEncerramento(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Encerrar caderno de campo?')
                    .textContent('Você tem certeza que gostaria de encerrar o caderno de campo?')
                    .targetEvent(ev)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não, depois encerro!');

               $mdDialog.show(confirm).then(function () {
                    encerrar(model);
               }, function () {
                    gotoSearch()
               });
          }

          function encerrar(model) {

               areaService.encerrarCadernoCampo(model)
                    .then(function () {
                         // vm.model.id = response.id
                         var message = $filter('translate')('COLHEITA.CADERNO_CAMPO_ENCERRADO');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );

                    }).catch(function () {
                         var message = $filter('translate')('COLHEITA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }

          function gotoEditar(id) {
               $state.go('app.registro.area.editar', {
                   id: id
               });
          }

          function gotoPlantio() {
               $state.go('app.registro.manejo.plantio.buscar');
          }

          function gotoSementes() {
               $state.go('app.estoque_insumo.semente.buscar');
          }

          function gotoBiologico() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoDefensivo() {
               $state.go('app.registro.manejo.insumo.defensivo.buscar');
          }

          function gotoFertilizante() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function gotoColheita() {
               $state.go('app.registro.manejo.colheita.buscar');
          }
         
          function gotoCustos() {
               $state.go('app.registro.custos.buscar');
          }

          function gotoLotesProduzidos() {
               $state.go('app.registro.lote_producao.buscar');
          }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.data_inicio = null;
               vm.args.data_final = null;
          }
          function topSelectedPeriodo() {
               vm.args.data_inicio = null;
               vm.args.data_final = null;
               change();
          }
          function topOpenDatasSelect(){
               datapicker.style.display = "block";
          }
          function topSelecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               change();
          }
     }
})();

(function () {
    'use strict';

    angular
        .module('app.area')
        .controller('HistoricoAreaController', HistoricoAreaController);

    /** @ngInject */
    function HistoricoAreaController($state, $rootScope, $mdDialog, areaService) {
        var vm = this;

        // // Data
        vm.models = {};
        vm.areas = {};
        vm.api_response_erro = {};
        vm.gotoSearch = gotoSearch;
        vm.savePromise = null
        //vm.areaSearch = areaSearch;
        vm.getHistory = getHistory;
        vm.getExcelFile = getExcelFile;
        vm.getAreas = getAreas;
        vm.getInsumos = getInsumos;
        vm.canShowExcelButton = canShowExcelButton;
        vm.viewTutorial = viewTutorial;
        vm.resetFilters = resetFilters;

        var new_date = moment(new Date()).subtract('days', 30).format();

        vm.model = {
            id: null,
            dataInicial: new_date,
            dataFinal: new Date()
        }

        vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               length_rows: 1,
               sort_by: 'nome',
               area_menor_que: null,
               area_maior_que: null,
               sort_order: 'asc',
               aberta: 0,
               Propriedade_Id: null,
               area: null,
               _change: change
          };

          vm.args._change();


        //////////

        init();

        /**
         * Initialize
         */

        function init() {
            vm.date = new Date();
            //vm.search();
            getAreas();
        }

          function change() {
               vm.args.loading = true;
               areaService.query(vm.args).then(function (response) {
               vm.models = response.data;

               vm.args.total_rows = response.total_rows;
               vm.args.length_rows = vm.models.length;

               }).finally(function () {
               vm.args.loading = false;
               });
          }

        function getAreas() {
          vm.args.loading = true;
          areaService.getPropriedadeAreaHistoricoList()
          .then(function (data) {
               vm.areas = data;
          }).finally(function () {
               vm.args.loading = false;
          });
        }

        /*
        function search() {

            vm.loadingProgress = true;
            areaService.query()
                .then(function successCallback(data) {
                    vm.models = data.data;

                    // if (!vm.models.propriedades_cliente || vm.models.propriedades_cliente.length == 0)
                    //     cadastroPropriedadeConfirm();
                    // else
                    //     vm.args.Propriedade_Id = vm.models.propriedades_cliente[0].id
                    propertieService.query().then(function (response) {
                        if (response && response.data && response.data.length > 0){
                            vm.args.Propriedade_Id = response.data[0].id;
                            var args = {
                                PropriedadeId: vm.args.Propriedade_Id
                            }
                            areaService.getPropriedadeAreaHistoricoList(args)
                                .then(function (data) {
                                    vm.areas = data;
                                });
                        }else{
                            cadastroPropriedadeConfirm();
                        }
                    })
                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }
        */

        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/registro/area/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function resetFilters() {
            vm.model = {
                id: null,
                dataInicial: new_date,
                dataFinal: new Date()
            }
            vm.modelResponse = null;
            //getHistory(vm.model);
        }

     //    function areaSearch(query) {
     //        var teste = {
     //            query: query,
     //            PropriedadeId: vm.args.Propriedade_Id
     //        }
     //        // eslint-disable-next-line no-console
     //        console.log(teste);
     //        var retorno = areaService.getPropriedadeAreaHistoricoList(teste);
     //        // var retorno = retornoApi.area
     //        return retorno;
     //    }

        this.openMenu = function ($mdMenu, ev) {
            // eslint-disable-next-line no-unused-vars
            var originatorEv;
            originatorEv = ev;
            $mdMenu.open(ev);
        };


        function getInsumos(data) {
            vm.modelResponse = data;
            var insumos = vm.modelResponse.insumos_biologicos || vm.modelResponse.insumos_defensivos || vm.modelResponse.insumos_fertilizantes;
            return insumos;
        }

        function canShowExcelButton() {

            var insumos =
                vm.modelResponse.insumos_biologicos.length > 0 ||
                vm.modelResponse.insumos_defensivos.length > 0 ||
                vm.modelResponse.insumos_fertilizantes.length > 0 ||
                vm.modelResponse.plantios.length > 0;
            vm.modelResponse.colheitas.length > 0;

            return insumos;
        }

        function getHistory(modelResponse) {
            var obj = {
                dataFinal: modelResponse.dataFinal,
                dataInicial: modelResponse.dataInicial,
                id: modelResponse.id,
            }
            $rootScope.loadingProgress = true;

            areaService.getHistory(obj)
                .then(function (data) {
                    $rootScope.loadingProgress = false;
                    // eslint-disable-next-line no-console
                    console.log(data);
                    vm.modelResponse = data;

                }).catch(function (data) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = data;
                });
        }

        function getExcelFile(modelResponse) {
            var obj = {
                dataFinal: modelResponse.dataFinal,
                dataInicial: modelResponse.dataInicial,
                id: modelResponse.id,
            }
            $rootScope.loadingProgress = true;

            areaService.getExcelFile(obj)
                .then(function (data) {
                    $rootScope.loadingProgress = false;

                    var data_inicial = moment(vm.model.dataInicial).format('ll');
                    var data_final = moment(vm.model.dataFinal).format('ll');
                    var area = vm.modelResponse.area_nome;

                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(data.response);
                    link.download = area + '_' + data_inicial + '_' + data_final;
                    link.click()
                    // eslint-disable-next-line no-console
                    console.log(link);
                    document.body.removeChild(link);

                }).catch(function (data) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = data;
                });
        }

        function gotoSearch() {
            $state.go('app.registro.area.buscar');
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }
    }
})();

(function () {
     'use strict';

     angular
          .module('app.propriedade', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
               .state('app.registro.propriedade', {
                    abstract: true,
                    url: '/propriedade'
               })
               .state('app.registro.propriedade.criar', {
                    url: '/criar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/propriedade/views/criar.html',
                              controller: 'CriarPropriedadeController as vm'
                         }
                    },
                    resolve: {
                         model: function (propertieService) {
                              return propertieService.getNew();
                         },
                         types: function (propertieService) {
                              return propertieService.getTypes();
                         },
                         propriedade: function (propertieService, $stateParams) {
                              if (!$stateParams.propriedade) return null;
                              return propertieService.get($stateParams.propriedade);
                         }
                    }
               })
               .state('app.registro.propriedade.editar', {
                    url: '/editar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/propriedade/views/editar.html',
                              controller: 'EditarPropriedadeController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, propertieService) {
                              return propertieService.get($stateParams.id);
                         },
                         types: function (propertieService) {
                              return propertieService.getTypes();
                         }
                    }
               })
               .state('app.registro.propriedade.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/propriedade/views/visualizar.html',
                              controller: 'VisualizarPropriedadeController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, propertieService) {
                              return propertieService.get($stateParams.id);
                         },
                         types: function (propertieService) {
                              return propertieService.getTypes();
                         }
                    }
               })
               .state('app.registro.propriedade.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/propriedade/views/buscar.html',
                              controller: 'BuscarPropriedadeController as vm'
                         }
                    }
                    // resolve: {
                    //      data: function (propertieService) {
                    //           return propertieService.query(null);
                    //      }
                    // }
               })
               .state('app.registro.propriedade.sucesso', {
                    url: '/sucesso/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/propriedade/views/sucesso.html',
                              controller: 'SucessoPropriedadeController as vm'
                         }
                    }
               })


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro/propriedade');
          $translatePartialLoaderProvider.addPart('app/main/registro');

          //Menu
          // msNavigationServiceProvider.saveItem('registro.propriedade', {
          //      title: 'properties',
          //      // icon: 'icon-home-variant',
          //      state: 'app.registro.propriedade.buscar',
          //      translate: 'PROPERTIES.PROPERTIES'
          // });
          msNavigationServiceProvider.saveItem('propriedademenu.buscar', {
               title: 'Dados da propriedade',
               state: 'app.registro.propriedade.buscar',
               //translate: 'PROPERTIES.PROPERTIES'
          });
     }
})();

(function() {
     'use strict';

     angular
          .module('app.propriedade')
          .controller('EditarAreaController', EditarAreaController);

     /** @ngInject */
     function EditarAreaController($rootScope, $scope, culturas, $state, areaService, $filter, $mdToast, model, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.save = save;
          vm.culturas = culturas;
          vm.api_response_erro = {};


          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.citySearch = citySearch;
          vm.savePromise = null;
          vm.propriedadeSearch = propriedadeSearch
          vm.cancelClick = cancelClick;
          vm.culturaSearch = culturaSearch;
          vm.onSelectCultura = onSelectCultura;
          vm.showDialogCreateVariedade = showDialogCreateVariedade;
          //////////

          /// Query
          vm.args = {
               loading: false,
               Page: 1,
               Per_Page: 10,
               //page_sizes: [5, 10, 25, 100],
               //sort_order: 'Asc',
               culturaId: null,
               Query: null
          };

          init();
          /**
           * Initialize
           */
          function init() {
               console.log('edit model', vm.model);
               vm.args.culturaId = vm.model.cultura_id;
               onSelectCultura();
          }

          function onSelectCultura(cultura) {
               console.log('CULTURA selected', cultura);
               vm.variedades = null;
               vm.loadingProgress = true;
               if(cultura)
                    vm.args.culturaId = cultura.id;

               areaService.getVariedades(vm.args)
                    .then(function successCallback(data) {
                         vm.variedades = data;
                         console.log('VARIEDADES', vm.variedades);
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });

               
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               var message = $filter('translate')('AREA.AREA_ALTERED');
               vm.model.cultura_id = vm.model.cultura.id;

               this.savePromise = areaService.update(vm.model);
               $rootScope.loadingProgress = true;
               this.savePromise.then(function() {
                    $rootScope.loadingProgress = false;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(message)
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoSearch();
               }).catch(function(response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               $state.go('app.registro.area.buscar');
          }


          function propriedadeSearch(query) {
               console.log(query);
               var retorno = areaService.search(query);
               return retorno;
          }

          function culturaSearch(query) {
               console.log(query);
               var retorno = areaService.getCulturas(query);
               // vm.model.cultura.id = vm.model.cultura_id;
               return retorno;
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function citySearch(query) {
               var retorno = propertieService.getCity(query);
               console.log(retorno);
               return retorno;
          }

          function cancelClick(form, ev) {
               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function() {
                         gotoSearch()
                    }, null);

               }
          }

          function showDialogCreateVariedade(ev) {
               console.log(vm.model.cultura);
               $mdDialog.show({
                    locals:{dataToPass: vm.model.cultura_id}, 
                    controller: 'CriarVariedadeController as vm',
                    templateUrl: 'app/main/registro/area/views/criar_variedade.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: false // Only for -xs, -sm breakpoints.
               })
                   .then(function (answer) {
                         if (answer) {
                              console.log('NEW VARIEDADE',answer)
                              vm.variedades.push(answer);
                              vm.model.variedade_id = answer.id;
                         }
                   }, function () {
                       console.error('Ocorreu um erro ao retornar da modal showDialogCreateVariedade');
                   });
          }

     }
})();
//const { date } = require("gulp-util");
(function () {
    'use strict';

    angular
        .module('app.area')
        .controller('DashAreaController', DashAreaController);

    /** @ngInject */
    function DashAreaController(data, propriedades, areaService, propertieService, $state, $mdDialog) {

        var vm = this;
        //var originatorEv;
        // Status
        areaService.clearFiltroDash();
        vm.loadingProgress = false;

        // Data
        vm.models = data;
        vm.propriedades = propriedades;
        //vm.culturas = culturas;
        vm.culturasVariedades = {};

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoEditar = gotoEditar;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoHistorico = gotoHistorico;
        vm.gotoLista = gotoLista;
        vm.openModalCulturas = openModalCulturas;


        /// Query
        vm.args = {
            loading: false
        };

        init();

        function init() {
            if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();

          // propertieService.query().then(function(response) {
          //      if (!response || response.data.length == 0)
          //           cadastroPropriedadeConfirm();
          // });
        }

        function gotoAdd(propriedade) {
            $state.go('app.registro.area.criar', {
                propriedade: propriedade
            });
        }
        function gotoEditar(id) {
            $state.go('app.registro.area.editar', {
                id: id
            });
        }
        function gotoHistorico(id) {
            $state.go('app.registro.area.historico', {
                id: id
            });
        }
        function gotoVisualizar(id) {
            $state.go('app.registro.area.visualizar', {
                id: id
            });
        }
        function gotoLista(status) {
            if(status != 0){
                let dados = {
                    status: status
                }
                areaService.addFiltroDash(dados);
            }
            $state.go('app.registro.area.buscar');
        }
        function openModalCulturas(){

            $mdDialog.show({
                controller: mdDialogCtrl,
                templateUrl: 'app/main/registro/area/views/culturas.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false
           })
        }
        function mdDialogCtrl($scope, $mdDialog) {
            $scope.loading = true;
            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };

            areaService.getCulturasVariedades().then(function (response) {
                $scope.culturasVariedades = response;
                let culturas = response;
                console.log('CULTURAS', culturas);
            }).finally(function () {
                $scope.loading = false;
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }
    }


})();

(function () {
     'use strict';

     angular
          .module('app.area')
          .controller('CriarAreaController', CriarAreaController);

     /** @ngInject */
     function CriarAreaController($rootScope, propriedades, culturas, $state, $filter, model, areaService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};
          vm.propriedadeSelecionada = null;
          vm.propriedades = propriedades;
          vm.teste = 2;
          vm.culturas = culturas;
          vm.variedades = [];

          // Metodos
          vm.gotoAddPlantio = gotoAddPlantio;
          vm.gotoSearch = gotoSearch;
          vm.gotoCadastroPropriedade = gotoCadastroPropriedade;
          vm.culturaSearch = culturaSearch;
          vm.onSelectCultura = onSelectCultura;
          vm.propriedadeSearch = propriedadeSearch;
          vm.save = save
          vm.showConfirm = showConfirm;
          vm.cancelClick = cancelClick;
          vm.autoSelectPropriedade = autoSelectPropriedade;
          vm.showDialogCreateVariedade = showDialogCreateVariedade;
          //////////

          /// Query
          vm.args = {
               loading: false,
               Page: 1,
               Per_Page: 10,
               //page_sizes: [5, 10, 25, 100],
               //sort_order: 'Asc',
               culturaId: null,
               Query: null
          };
          //vm.args._change();

          init();

          function init() {
               autoSelectPropriedade();
          }

          function autoSelectPropriedade(){
               // if ($stateParams.propriedade) {
               //      let id = $stateParams.propriedade;

               //      let filter = vm.propriedades.filter( function(propriedade) {
               //           return propriedade.id == id
               //      });

               //      vm.model.propriedade = filter[0];
               //      return
               // }
               vm.model.propriedade = vm.propriedades[0];
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               vm.model.cultura_id = vm.model.cultura.id;

               console.log('model save', vm.model);
               //return

               var message = '';
               var message = "Área criada com sucesso!";
               this.savePromise = areaService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(message)
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    showConfirm(response);
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function showConfirm(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Antes de finalizar')
                    .textContent('Gostaria de adicionar uma data de plantio para a sua área?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria')
                    .cancel('Não, não gostaria');

               $mdDialog.show(confirm).then(function () {
                    gotoAddPlantio(vm.model)
               }, function () {
                    gotoSearch()
               });
          };

          function culturaSearch(query) {
               console.log(query);
               var retorno = areaService.getCulturas(query);
               return retorno;
          }

          function onSelectCultura(cultura) {
               vm.loadingProgress = true;
               vm.args.culturaId = cultura.id;
               areaService.getVariedades(vm.args)
                    .then(function successCallback(data) {
                         vm.variedades = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });

               console.log('VARIEDADES', vm.variedades);
          }

          function propriedadeSearch(query) {
               console.log(query);
               var retorno = areaService.search(query);
               return retorno;
          }

          function gotoSearch() {
               $state.go('app.registro.area.buscar');
          }

          function gotoAddPlantio(model) {
               $state.go('app.registro.manejo.plantio.criar', {
                    area: model.id
               })
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
           }

          function cancelClick(form, ev) {
               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function showDialogCreateVariedade(ev, index) {

               $mdDialog.show({
                    locals:{dataToPass: vm.args.culturaId},
                    controller: 'CriarVariedadeController as vm',
                    templateUrl: 'app/main/registro/area/views/criar_variedade.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: false // Only for -xs, -sm breakpoints.
               })
                   .then(function (answer) {
                       if (answer) {
                           console.log('NEW VARIEDADE',answer)
                           vm.variedades.push(answer);
                           vm.model.variedade_id = answer.id;
                       }
                   }, function () {
                       console.error('Ocorreu um erro ao retornar da modal showDialogCreateVariedade');
                   });
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.area')
        .controller('CriarVariedadeController', CriarVariedadeController)

    /** @ngInject */
    function CriarVariedadeController($scope, $rootScope, areaService, $mdToast, $mdDialog, dataToPass) {

        var vm = this;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        vm.model = {
            nome: null,
            cultura_id: dataToPass
        }

        init();

        function init() {
            //console.log('ID', dataToPass);
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = areaService.createVariedade(vm.model);

            $rootScope.loadingProgress = true;

            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                console.log('response create variedade', response);
                vm.model.id = response.id;

                $mdDialog.hide(vm.model);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Variedade criada com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }

})();
//const { functions } = require("lodash");

//const { date } = require("gulp-util");
(function () {
    'use strict';

    angular
        .module('app.area')
        .controller('BuscarAreaController', BuscarAreaController);

    /** @ngInject */
    function BuscarAreaController(areaService, propertieService, $state, $mdDialog, filtros, $mdToast, $filter) {

        var vm = this;
        //var originatorEv;
        // Status
        vm.loadingProgress = false;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        //vm.models = data.data;
        vm.filtros = filtros;
        vm.getFiltro = areaService.getFiltroDash();
        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
        ];

        vm.status = [
            {
                description: "ABERTO",
                value: 1
            },
            {
                description: "FECHADO",
                value: 2
            }
        ];

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            //total_rows: data.total_rows,
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            Propriedade_Id: null,
            periodo: null,
            cultura: null,
            area: null,
            date_inicio: null,
            date_fim: null,
            status: null,
            _change: change
        };
        //vm.args._change();


        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoEditar = gotoEditar;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoHistorico = gotoHistorico;
        //vm.search = search;
        vm.deletarConfirm = deletarConfirm;
        vm.resetFilters = resetFilters;
        vm.deletar = deletar;
        vm.resetPagination = resetPagination;
        vm.showConfirmEncerrar = showConfirmEncerrar;
        vm.estornarConfirm = estornarConfirm;
        vm.estornar = estornar;
        vm.viewTutorial = viewTutorial;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;

        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        vm.getFiltrosBuscar = getFiltrosBuscar;

        init();

        function init() {

            vm.args.status = vm.getFiltro.status

            //vm.search();

            propertieService.query().then(function (response) {
               if (response && response.data && response.data.length > 0){
                   vm.args.Propriedade_Id = response.data[0].id;
                   vm.args._change();
               }else{
                   cadastroPropriedadeConfirm();
               }
           })
        }

        function getFiltrosBuscar(){
            areaService.getFiltros().then(function (response) {
                vm.filtros = response;
            }).finally(function () {
                vm.args.loading = false;
            });
        }

     //    function search() {
     //        vm.loadingProgress = true;

     //        areaService.query(vm.args)
     //            .then(function successCallback(data) {
     //                vm.models = data.data;
     //            }).finally(function () {
     //                vm.loadingProgress = false;
     //            });
     //    }

        function change() {
            vm.args.loading = true;
            areaService.query(vm.args).then(function (response) {
                vm.models = response.data;
                vm.args.total_rows = response.total_rows;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();
            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function resetFilters() {
            vm.args.status = null;
            vm.args.cultura = null;
            vm.args.periodo = null;
            vm.args.date_inicio = null;
            vm.args.date_fim = null;
            vm.args.area = null;
            periodoActive.classList.remove("select-active");
            datapickerActive.classList.remove("dates-active");
            vm.activeFilters = null;
            vm.get = null;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let status = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.date_inicio,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.date_fim,'dd/MM/yyyy');
          let counter = 0;
          if(vm.args.status == 1){
               status = 'Aberto';
          } else if(vm.args.status == 2) {
               status = 'Fechado';
          }
          switch (vm.args.periodo) {
               case 7:
                    periodoSelect = "Últimos 7 dias";
                    break;
               case 15:
                    periodoSelect = "Últimos 15 dias";
                    break;
               case 30:
                    periodoSelect = "Últimos 30 dias";
                    break;
               case 90:
                    periodoSelect = "Últimos 3 meses";
                    break;
               case 180:
                    periodoSelect = "Últimos 6 meses";
                    break;
               default:
                    periodoSelect = null;
                    break;
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: vm.args.cultura,
                    value: 'cultura'
                },
                {
                    description: vm.args.area,
                    value: 'area'
                },

                {
                    description: status,
                    value: 'status'
                },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
            if(value == 'datepicker'){
                vm.args.date_inicio = null;
                vm.args.date_fim = null;
                datapickerActive.classList.remove("dates-active");
            } else if(value == 'periodo'){
                periodoActive.classList.remove("select-active");
            }
            vm.args[value] = null;
            change();
        }


        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/registro/area/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
       }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar área?')
                .textContent('Tem certeza que deseja deletar a área?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }
        function resetPagination() {
            vm.args.page = 1;
        }

        function deletar(model) {

            var message = "Área deletada com sucesso!";

            areaService.deleteArea(model.id)
                .then(function () {
                    vm.models.propriedade_area.splice(vm.models.propriedade_area.indexOf(model), 1);
                    getFiltrosBuscar();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function () {

                    // TODO mensagem de erro
                });
        }

        function showConfirmEncerrar(model) {
            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Atenção')
                .textContent('Gostaria de encerrar o caderno de campo desta área?')
                .targetEvent(model)
                .ok('Sim, gostaria')
                .cancel('Não, não gostaria');

            $mdDialog.show(confirm).then(function () {
                gotoEncerrarCadernoArea(model)
            }, function () {
                $mdDialog.hide();
            });
        }

        function gotoEncerrarCadernoArea(model) {
            var message = "Caderno encerrado com sucesso!";

            areaService.encerrarCadernoCampoArea(model)
                .then(function (response) {
                    //angular.copy(response, model);
                    vm.args._change();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Não há um caderno de campo ativo nesta área.')
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }


        function estornarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Estornar área encerrada')
                .textContent('Tem certeza que deseja estornar área encerrada?')
                .targetEvent(model)
                .ok('Sim, quero estornar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    estornar(model);
                }, function () {
                    return null
                });
        }

        function estornar(model) {

            var message = $filter('translate')('AREA.AREA_ESTORNADA');

            areaService.CadernoCampoEstornarEncerramento(model)
                .then(function (response) {
                    //angular.copy(response, model);
                    vm.args._change();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function () {
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Não foi possível estornar o caderno de campo.')
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

     //    vm.openMenu = function ($mdMenu, ev) {
     //        originatorEv = ev;
     //        $mdMenu.open(ev);
     //    };


        function gotoAdd() {
            $state.go('app.registro.area.criar');
            // $state.go('app.registro.area.criar', {
            //     propriedade: propriedade
            // });
        }
        function gotoEditar(id) {
            $state.go('app.registro.area.editar', {
                id: id
            });
        }

        function gotoHistorico(id) {
            $state.go('app.registro.area.historico', {
                id: id
            });
        }

        function gotoVisualizar(id) {
            $state.go('app.registro.area.visualizar', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               periodoActive.classList.add("select-active");
               datapickerActive.classList.remove("dates-active");
          }
          function openDatasSelect(){
               datapicker.style.display = "block";
          }
          function selecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               datapickerActive.classList.add("dates-active");
               periodoActive.classList.remove("select-active");
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               datapickerActive.classList.remove("dates-active");
          }
    }


})();

(function () {
     'use strict';

     angular
          .module('app.colheita', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.registro.manejo.colheita', {
                    abstract: true,
                    url: '/colheita'
               })
               .state('app.registro.manejo.colheita.criar', {
                    url: '/criar?area',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/colheita/views/criar.html',
                              controller: 'CriarColheitaController as vm'
                         }
                    },
                    resolve: {
                         model: function (colheitaService) {
                              return colheitaService.getNew();
                         },
                         propriedades: function (colheitaService) {
                              return colheitaService.getPropriedades();
                         },
                         areas: function (colheitaService) {
                              return colheitaService.filtrosColheitaAdd();
                         },
                         unidade: function (colheitaService) {
                              return colheitaService.getUnidade();
                         },
                         tipo: function (colheitaService) {
                              return colheitaService.getTipo();
                         },
                         clientes: function (colheitaService) {
                              return colheitaService.getClients();
                         }
                    }
               })
               .state('app.registro.manejo.colheita.editar', {
                    url: '/editar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/colheita/views/editar.html',
                              controller: 'EditarColheitaController as vm'
                         }
                    },
                    resolve: {
                         model: function (colheitaService, $stateParams) {
                              return colheitaService.get($stateParams.id);
                         }
                    }
               })
               .state('app.registro.manejo.colheita.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/colheita/views/visualizar.html',
                              controller: 'VisualizarColheitaController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, colheitaService) {
                              return colheitaService.get($stateParams.id);
                         }
                    }
               })
               .state('app.registro.manejo.colheita.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/colheita/views/buscar.html',
                              controller: 'BuscarColheitaController as vm'
                         }
                    },
                    resolve: {
                         propriedades: function (colheitaService) {
                              return colheitaService.queryPropertie();
                         },
                         data: function (colheitaService) {
                              return colheitaService.query(null);
                         },
                         filtros: function (colheitaService){
                              return colheitaService.filtrosColheita();
                         }
                    }
               })

          $mdDateLocaleProvider.formatDate = function (date) {
               return date ? moment(date).format('DD/MM/YYYY') : '';
          };


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro/colheita');
          $translatePartialLoaderProvider.addPart('app/main/registro');

          //Menu
          msNavigationServiceProvider.saveItem('manejo.colheita', {
               title: 'colheita',
               // icon: 'icon-tree',
               state: 'app.registro.manejo.colheita.buscar',
               translate: 'COLHEITA.COLHEITA'
          });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.colheita')
          .factory('colheitaService', colheitaService);

     /** @ngInject */
     function colheitaService($q, propertieService, areaService, clienteService, $mdToast, $filter, msApi, api) {

          var colheitas = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {
               caderno_campo_colheita_detalhes: []
          };

          var service = {
               get: get,
               getNew: getNew,
               update: update,
               create: create,
               query: query,
               searchArea: searchArea,
               deletarColheita: deletarColheita,
               encerrarCadernoCampo: encerrarCadernoCampo,
               searchPropertie: searchPropertie,
               getPropriedades: getPropriedades,
               getAreas: getAreas,
               filtrosColheita: filtrosColheita,
               filtrosColheitaAdd: filtrosColheitaAdd,
               searchCultura: searchCultura,
               getUnidade: getUnidade,
               getTipo: getTipo,
               getClients: getClients,
               estornarCadernoCampo: estornarCadernoCampo,
               queryPropertie: queryPropertie
          };

          return service;

          //////////


          function getNew() {
               return {};
          }

          function getUnidade() {
               return [
                    "kg",
                    "unidades"
               ]
          }

          function getTipo() {
               return [
                    "Cônicas",
                    "Caixas",
                    "Sacos",
                    "Cumbucas",
                    "Bandejas"
               ]
          }

          ////// LISTAR - COLHEITA //////
          function query(args, cache) {
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.ColheitaGet.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - COLHEITA //////


          ////// CRIAR - COLHEITA //////
          function create(model) {

               var deferred = $q.defer();

               api.Colheita.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - COLHEITA //////

          ////// EDITAR - COLHEITA //////
          function update(model) {

               var deferred = $q.defer();

               api.Colheita.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          ////// EDITAR - COLHEITA //////


          ////// ENCERRAR CADERNO CAMPO - COLHEITA //////
          function encerrarCadernoCampo(model) {

               var deferred = $q.defer();

               api.CadernoCampo.encerrar(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// ENCERRAR CADERNO CAMPO - COLHEITA //////


          ////// ESTORNAR CADERNO CAMPO - COLHEITA //////
          function estornarCadernoCampo(model) {

               var deferred = $q.defer();

               api.CadernoCampo.estornar(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// ESTORNAR CADERNO CAMPO - COLHEITA //////


          ////// CONSULTA POR ID - COLHEITA //////
          function get(id) {
               var deferred = $q.defer();

               api.Colheita.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - COLHEITA //////


          ////// DELETAR - COLHEITA //////
          function deletarColheita(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.Colheita.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          ////// DELETAR - COLHEITA //////

          ////// CONSULTA PROPRIEDADE - COLHEITA //////
          function searchPropertie(query) {
               var deferred = $q.defer();

               api.Propriedade.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA PROPRIEDADE - COLHEITA //////


          ////// CONSULTA DE ÁREA - COLHEITA //////
          function searchArea(query) {

               var deferred = $q.defer();

               api.PropriedadeArea.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE ÁREA - COLHEITA //////

          // Retorna area para tela de insumo
          // areaid: opcional
          function getAreas(areaid) {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };


               areaService.fullQuery(args, false).then(function (response) {

                    // filtra por area
                    if (areaid && areaid > 0) {

                         var areas = response.data.filter(function (a) {
                              return a.id == areaid;

                         });

                         if (areas.length > 0) {
                              deferred.resolve(response.data.filter(function (a) {
                                   return a.id == areaid;
                              }));
                         } else {
                              deferred.resolve(response.data);
                         }
                         return;
                    }
                    deferred.resolve(response.data);

               }).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);

               });

               return deferred.promise;
          }

          function getClients() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               clienteService.query(args, false).then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }

          function getPropriedades() {

               var deferred = $q.defer();

               var args = {
                    per_page: 999,
                    sort_by: 'nome',
                    sort_order: 'asc',
               };

               propertieService.query(args, false).then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          }

          ////// CONSULTA DE CULTURA - COLHEITA //////
          function searchCultura(query) {
               var deferred = $q.defer();

               api.Cultura.query({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CULTURA - COLHEITA //////

          ////// FILTROS BUSCA //////
          function filtrosColheita() {
               var deferred = $q.defer();
               api.filtrosColheita.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);
               });
               return deferred.promise;
          }
          ////// FILTROS CADASTRO //////
          function filtrosColheitaAdd() {
               var deferred = $q.defer();
               api.filtrosColheitaAdd.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);
               });
               return deferred.promise;
          }

          function queryPropertie() {
               var deferred = $q.defer();
               api.Propriedade.query({}).$promise.then(
               function (response) {
                    deferred.resolve(response.data);
               }
               ).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

     }

})();

(function () {
     'use strict';

     angular
          .module('app.colheita')
          .controller('VisualizarColheitaController', VisualizarColheitaController);

     /** @ngInject */
     function VisualizarColheitaController($state, model, colheitaService, $mdDialog, $mdToast, $filter) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.ConfirmacaoEncerramento = ConfirmacaoEncerramento;
          vm.ConfirmacaoEstorno = ConfirmacaoEstorno;
          vm.encerrar = encerrar;
          vm.estornar = estornar;
          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function ConfirmacaoEncerramento(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Encerrar o caderno de campo?')
                    .textContent('Você tem certeza que gostaria de encerrar o caderno de campo?')
                    .targetEvent(ev)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não, depois encerro!');

               $mdDialog.show(confirm).then(function () {
                    encerrar(model.caderno_campo);
               }, function () {
                    return null
               });
          };

          function ConfirmacaoEstorno(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estornar o caderno de campo?')
                    .textContent('Você tem certeza que gostaria de estornar o caderno de campo?')
                    .targetEvent(ev)
                    .ok('Sim, quero estornar!')
                    .cancel('Não, depois estorno!');

               $mdDialog.show(confirm).then(function () {
                    estornar(model.caderno_campo);
               }, function () {
                    return null
               });
          };

          function encerrar(model) {

               colheitaService.encerrarCadernoCampo(model)
                    .then(function (response) {
                         var message = $filter('translate')('COLHEITA.CADERNO_CAMPO_ENCERRADO');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );
                         gotoSearch();

                    }).catch(function (response) {
                         var message = $filter('translate')('COLHEITA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }

          function estornar(model) {

               colheitaService.estornarCadernoCampo(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('COLHEITA.CADERNO_CAMPO_ESTORNADO');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );
                         gotoSearch();

                    }).catch(function (response) {
                         var message = $filter('translate')('LOTE_VENDA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.colheita.buscar');
          }
     }
})();

(function() {
     'use strict';

     angular
          .module('app.colheita')
          .controller('EditarColheitaController', EditarColheitaController)

     /** @ngInject */
     function EditarColheitaController($rootScope, $scope, $filter, $state, colheitaService, model, $mdToast, $mdDialog, $q, $controller) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Methods
          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //Events
          vm.gotoSearch = gotoSearch;
          vm.api_response_erro = {};
          vm.gotoAddClient = gotoAddClient;
          vm.cancelClick = cancelClick;
          vm.calcValor = calcValor;
          //////////

          init();

          function init() {

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }
               var message = '';
               if (vm.model.id > 0) {
                    var message = $filter('translate')('COLHEITA.COLHEITA_ALTERED');
                    this.savePromise = colheitaService.update(vm.model);
               } else {
                    var message = $filter('translate')('COLHEITA.COLHEITA_CREATED');
                    this.savePromise = colheitaService.create(vm.model);
               }
               $rootScope.loadingProgress = true;
               this.savePromise.then(function(colheita) {
                    $rootScope.loadingProgress = false;
                    model = colheita;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(message)
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoSearch();
               }).catch(function(response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });;
          }

          function calcValor(valor){
               if(valor)
                    vm.model.valor_total = vm.model.quantidade * valor;
          }


          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function() {
                         gotoSearch()
                    }, null);

               }
          }


          function gotoAddClient() {
               $state.go('app.registro.manejo.colheita.buscar');
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.colheita.buscar');
          }


          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.colheita')
          .controller('CriarColheitaController', CriarColheitaController)

     /** @ngInject */
     function CriarColheitaController($rootScope, $scope, propriedades, unidade, areas, clientes, tipo, $filter, $state, colheitaService, model, $mdToast, $mdDialog, $q, $controller) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Methods
          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;
          vm.areaSearch = areaSearch;

          //Events
          vm.addPageColheita = addPageColheita;
          vm.removePageColheita = removePageColheita;
          vm.gotoSearch = gotoSearch;
          vm.showConfirm = showConfirm;
          vm.encerrar = encerrar;
          vm.propriedadeSearch = propriedadeSearch;
          vm.api_response_erro = {};
          vm.areas = areas;
          vm.clientes = clientes;
          vm.propriedades = propriedades;
          vm.propriedadeSelecionada = null;
          vm.culturaSearch = culturaSearch;
          vm.unidades = unidade
          vm.tipos = tipo
          vm.gotoAddClient = gotoAddClient;
          vm.cancelClick = cancelClick;
          vm.areaChange = areaChange;
          vm.autoSelectPropriedade = autoSelectPropriedade;
          vm.calcValor = calcValor;
          vm.cultura = null;
          vm.variedade = null;
          //////////

          init();

          function init() {
               console.log('FILTROS', vm.areas);

               autoSelectPropriedade();

               vm.model.unidade_medida = "kg";
               vm.date = new Date();

               if (vm.model.caderno_campo_colheita_vendas == null) {
                    vm.model.caderno_campo_colheita_vendas = new Array();
               }

               if (vm.model.caderno_campo_colheita_vendas.length == 0) {

                    vm.model.caderno_campo_colheita_vendas.push({
                         quantidade: "",
                         cliente: ""
                    });
               } else {
                    return null
               }

               // Se o cliente tiver apenas uma area cadastrada ou se a tela estiver vindo com a area pre selecionada,
               //   inicia a tela com a area selecionada
               if (vm.areas.length == 1) {
                    // vm.propriedades = vm.propriedades.filter(function (p) {
                    //      return p.id == vm.areas[0].propriedade.id
                    // });
                    // vm.model.propriedade = vm.propriedades[0];
                    vm.model.propriedade_area = vm.areas[0];
                    vm.cultura = vm.areas[0].cultura;
                    vm.variedade = vm.areas[0].produto_variedade;
               }

               if (vm.propriedades.length == 1) {
                    vm.model.propriedade = vm.propriedades[0];

               }

          }

          function calcValor(valor){
               //console.log('veio aqui', model);
               if(valor)
                    vm.model.valor_total = vm.model.quantidade * valor;
          }

          function save(form) {
               if (form.$invalid) {
                    return;
               }
               var message = '';
               var message = $filter('translate')('COLHEITA.COLHEITA_CREATED');
               console.log('save', vm.model);
               this.savePromise = colheitaService.create(vm.model);
               $rootScope.loadingProgress = true;
               this.savePromise.then(function (colheita) {
                    $rootScope.loadingProgress = false;
                    model = colheita;
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );
                    showConfirm();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function autoSelectPropriedade() {

               // if ($stateParams.propriedade) {
               //     let id = $stateParams.propriedade;

               //     let filter = vm.propriedades.filter(function (propriedade) {
               //         return propriedade.id == id
               //     });
               //     // let filter = vm.propriedades.filter((propriedade) => {
               //     //
               //     // });
               //     vm.model.propriedade = filter[0];
               //     return
               // }
               vm.model.propriedade = vm.propriedades[0];
          }

          function showConfirm(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Antes de finalizar')
                    .textContent('Deseja encerrar a colheita nessa área?')
                    .targetEvent(ev)
                    .ok('Não, não gostaria')
                    .cancel('Sim, gostaria');

               $mdDialog.show(confirm).then(function () {
                    gotoSearch();
               }, function () {
                    encerrar(model);
               });
          }

          function encerrar(model) {

               var message = $filter('translate')('COLHEITA.CADERNO_CAMPO_ENCERRADO');
               console.log('model encerrar', model);
               colheitaService.encerrarCadernoCampo(model)
                    .then(function (response) {
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch();

                    }).catch(function (response) {
                         var message = $filter('translate')('COLHEITA.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function propriedadeSearch(query) {
               return colheitaService.searchPropertie(query);
          }

          function areaSearch(propriedadeid, query) {

               var deferred = $q.defer();
               colheitaService.searchArea(query)
                    .then(function (response) {

                         response = $filter('filter')(response, {
                              'propriedade': {
                                   id: propriedadeid
                              }
                         });

                         deferred.resolve(response);


                    }).catch(function (response) {

                         deferred.reject(response);

                    });

               return deferred.promise;

          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function addPageColheita() {
               vm.model.caderno_campo_colheita_vendas.push({
                    quantidade: "",
                    cliente: ""
               });
          }

          function removePageColheita(index) {
               vm.model.caderno_campo_colheita_vendas.splice(index, 1);
          }

          function gotoAddClient() {
               $state.go('app.registro.manejo.colheita.buscar');
          }

          function gotoSearch() {
               $state.go('app.registro.manejo.colheita.buscar');
          }

          function culturaSearch(query) {
               console.log(query);
               return colheitaService.searchCultura(query);
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function areaChange() {
               vm.cultura = null;
               vm.variedade = null;
               console.log(vm.model.propriedade_area);
               console.log('areas', vm.areas);

               vm.areas.forEach( function(item) {
                    if(item.id === vm.model.propriedade_area.id){
                         console.log('selected', item);
                         vm.cultura = item.cultura;
                         vm.variedade = item.produto_variedade;
                    }
               });
          }
     }
 })();

(function () {
    'use strict';

    angular
        .module('app.colheita')
        .controller('BuscarColheitaController', BuscarColheitaController);

    /** @ngInject */
    function BuscarColheitaController(data, propriedades, colheitaService, filtros, $filter, $state, $mdDialog, $mdToast) {

        var vm = this;
        // Status
        vm.loadingProgress = false;
        vm.activeFilters = false;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        vm.models = data.data;
        vm.filtros = filtros;
        vm.propriedades = propriedades;

        vm.periods = [
            {
                description: "Últimos 7 dias",
                value: 7
            },
            {
                description: "Últimos 15 dias",
                value: 15
            },
            {
                description: "Últimos 30 dias",
                value: 30
            },
            {
                description: "Últimos 3 meses",
                value: 90
            },
            {
                description: "Últimos 6 meses",
                value: 180
            }
        ];

        // Methods
        vm.gotoAdd = gotoAdd;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoEditar = gotoEditar;
        //vm.search = search;
        vm.deletarConfirm = deletarConfirm;
        vm.resetFilters = resetFilters;
        vm.deletar = deletar;
        vm.viewTutorial = viewTutorial;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;

        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        //////////

        init();

        function init() {
          if (vm.propriedades == undefined || vm.propriedades.length == 0)
               cadastroPropriedadeConfirm();

          //vm.search();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Cancelar colheita?')
                .textContent('Tem certeza que deseja cancelar a colheita?')
                .targetEvent(model)
                .ok('Sim, quero cancelar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        };


        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/registro/colheita/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function deletar(model) {

            var message = $filter('translate')('COLHEITA.DELETE');

            colheitaService.deletarColheita(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function (response) {

                    // TODO mensagem de erro
                });
        }



     //    function search() {
     //        vm.loadingProgress = true;
     //        colheitaService.query()
     //            .then(function successCallback(data) {
     //                vm.models = data.data;

     //                // if (!vm.models.propriedades_cliente || vm.models.propriedades_cliente.length == 0)
     //                //     cadastroPropriedadeConfirm();
     //                // else
     //                //     vm.args.Propriedade_Id = vm.models.propriedades_cliente[0].id

     //            }).finally(function () {
     //                vm.loadingProgress = false;
     //            });
     //    }


        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            Propriedade_Id: null,
            variedade: null,
            cultura: null,
            propriedade_area_id: null,
            colheita_data_de: null,
            colheita_data_ate: null,
            periodo: null,
            _change: change
        };

        vm.args._change();


        function resetFilters() {
            //vm.activeFilters = null;
            vm.args.Propriedade_Id = vm.args.Propriedade_Id;
            vm.args.variedade = null;
            vm.args.cultura = null;
            vm.args.propriedade_area_id = null;
            vm.args.colheita_data_de = null;
            vm.args.colheita_data_ate = null;
            vm.args.periodo = null;
            change();
        }

        function change() {
            vm.args.loading = true;
            colheitaService.query(vm.args).then(function (response) {
               console.log('DATA', response);
               vm.models = response.data;

               vm.args.total_rows = response.total_rows;
               vm.args.length_rows = vm.models.length;
               showActiveFilters();
               vm.args.updatePaggination();

            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let area;
          let arr = null;
          let inicio = $filter('date')(vm.args.colheita_data_de,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.colheita_data_ate,'dd/MM/yyyy');
          let counter = 0;

          for (let i = 0; i < vm.filtros.propriedades_area.length; i++) {
               if (vm.filtros.propriedades_area[i].id == vm.args.propriedade_area_id) {
                    area = vm.filtros.propriedades_area[i].nome
               };
          }

          arr = [
               {
                    description: area,
                    value: 'propriedade_area_id'
               },
               {
                    description: vm.args.cultura,
                    value: 'cultura'
               },
               {
                    description: vm.args.variedade,
                    value: 'variedade'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.colheita_data_de = null;
               vm.args.colheita_data_ate = null;
          } else if(value == 'periodo'){
               periodoActive.classList.remove("select-active");
          }
          vm.args[value] = null;
          change();
        }

     //    function _sortBy(col) {

     //        if (vm.args.sort_by == col) {

     //            vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

     //        } else {
     //            vm.args.sort_order = 'asc';
     //            vm.args.sort_by = col;
     //        }

     //        vm.args._change();

     //    }

        function gotoAdd() {
            $state.go('app.registro.manejo.colheita.criar');
        }

        function gotoEditar(id) {
            $state.go('app.registro.manejo.colheita.editar', {
                id: id
            });
        }

        function gotoVisualizar(id) {
            $state.go('app.registro.manejo.colheita.visualizar', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        // DATAPICKER //////////////////
        function clearPreDate() {
            vm.args.periodo = null;
       }
       function selectedPeriodo() {
            vm.args.date_inicio = null;
            vm.args.date_fim = null;
            periodoActive.classList.add("select-active");
            datapickerActive.classList.remove("dates-active");
       }
       function openDatasSelect(){
            datapicker.style.display = "block";
       }
       function selecionarDatas(){
            vm.clearPreDate();
            datapicker.style.display = "none";
            datapickerActive.classList.add("dates-active");
            periodoActive.classList.remove("select-active");
       }
       function closedDatasSelect(){
            datapicker.style.display = "none";
            vm.args.date_inicio = null;
            vm.args.date_fim = null;
            datapickerActive.classList.remove("dates-active");
       }
    }


})();

(function () {
     'use strict';

     angular
          .module('app.propriedade')
          .factory('propertieService', propertieService);

     /** @ngInject */
     function propertieService($q, $mdToast, $filter, api) {

          var properties = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var modelNew = {};

          var queryArgsDefault = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'nome',
               sort_order: 'asc',
          };

          var queryArgs = queryArgsDefault;


          var service = {
               getNew: getNew,
               query: query,
               getLista: getLista,
               selectPropriedade: selectPropriedade,
               create: create,
               update: update,
               get: get,
               getTypes: getTypes,
               getCity: getCity,
               upload: upload,
          };

          return service;

          ////////////////

          function getNew() {
               return {};
          }


          ////// LISTAR - PROPRIEDADE //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;


               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.Propriedade.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - PROPRIEDADE //////

          // LISTA PROPRIEDADES SEM FILTRO (SELECT COMBO) ////
          function getLista(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : false;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgsDefault;


               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {

                    api.PropriedadeList.query(args).$promise.then(
                         function (response) {
                              deferred.resolve(response.data);
                         }
                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          // PRORIEDADES (SELECT COMBO) ///////////////////////

          ////// SELECIONAR - PROPRIEDADE //////
          function selectPropriedade(id) {

               var deferred = $q.defer();

               api.PropriedadeSelect.update({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               // api.PropriedadeSelect.update(model).$promise.then(
               //      // SUCCESS
               //      function (response) {
               //           deferred.resolve(response);
               //           properties.unshift(model);
               //           modelNew = {};
               //      }).catch(
               //           function (response) {
               //                //   Resolve the promise
               //                deferred.reject(response);
               //           }
               //      );

               return deferred.promise;
          }
          ////// SELECIONAR - PROPRIEDADE //////

          ////// CRIAR - PROPRIEDADE //////
          function create(model) {

               var deferred = $q.defer();

               api.Propriedade.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         properties.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// CRIAR - PROPRIEDADE //////


          ////// EDITAR - PROPRIEDADE //////
          function update(model) {

               var deferred = $q.defer();

               api.Propriedade.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         properties.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// EDITAR - PROPRIEDADE //////


          ////// CONSULTA POR ID - PROPRIEDADE //////
          function get(id) {
               var deferred = $q.defer();

               api.PropriedadeAddPut.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - PROPRIEDADE //////


          ////// TIPO DE PESSOA - PROPRIEDADE //////
          function getTypes() {

               var deferred = $q.defer();

               if (status.length > 0) {
                    deferred.resolve(status);
               } else {

                    deferred.resolve([{
                         id: 1,
                         descricao: "fisica"
                    },
                    {
                         id: 2,
                         descricao: "juridica"
                    }
                    ]);
               }
               return deferred.promise;
          }
          ////// TIPO DE PESSOA - PROPRIEDADE //////


          ////// CONSULTA DE CIDADE - PROPRIEDADE //////
          function getCity(query) {

               var deferred = $q.defer();

               api.Cidade.query({
                    query: query
               }).$promise.then(
                    function (response) {

                         var enderecos = [];

                         for (var i = 0; i < response.data.length; i++) {
                              enderecos.push({
                                   cep: "",
                                   endereco: "",
                                   cidade_nome: response.data[i].nome,
                                   uf: response.data[i].estado,
                                   numero: "",
                                   complemento: ""
                              });

                         }

                         deferred.resolve(enderecos);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CIDADE - PROPRIEDADE //////


          function upload(propriedadeId, files) {

               // Create a new deferred object
               var deferred = $q.defer();

               api.PropriedadeFile.upload({
                    id: propriedadeId,
                    uploadedFile: files
               }).$promise
                    .then(function (response) {

                         console.log('PropriedadeService.upload.then', response);

                         // Resolve the promise
                         deferred.resolve(response);

                    })
                    .catch(function (response) {

                         console.log('PropriedadeService.upload.catch', response);

                         // Reject the promise
                         deferred.reject(response);
                    });

               return deferred.promise;
          }
     }

})();

(function() {
     'use strict';

     angular
          .module('app.propriedade')
          .controller('VisualizarPropriedadeController', VisualizarPropriedadeController);

     /** @ngInject */
     function VisualizarPropriedadeController($scope, $state, model, types) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.types = types;

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.registro.propriedade.buscar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();
(function () {
     'use strict';

     angular
          .module('app.propriedade')
          .controller('SucessoPropriedadeController', SucessoPropriedadeController)

     /** @ngInject */
     function SucessoPropriedadeController($state) {

          var vm = this;

          // Data

          // Metodos
          vm.gotoAdd = gotoVisualizar;
          vm.gotoHome = gotoHome;
          //////////

          init();

          function init() {
          }

          function gotoVisualizar() {
               console.log('veio aqui');
               //$state.go('app.caldas.cadastro');
          }

          function gotoHome() {
               $state.go('app.home');
          }
     }


})();

(function () {
     'use strict';

     angular
          .module('app.propriedade')
          .controller('EditarPropriedadeController', EditarPropriedadeController);



     /** @ngInject */
     function EditarPropriedadeController($rootScope, $scope, $state, propertieService, $filter, $mdToast, model, types, $mdDialog) {
          var vm = this;





          // Data
          vm.model = model;
          vm.files = [];
          vm.status = [];
          vm.types = types;
          vm.save = save;
          vm.api_response_erro = {};
          vm.propriedade_files_changed = false;


          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.gotoCreateArea = gotoCreateArea;
          vm.isFormValid = isFormValid;
          vm.citySearch = citySearch;
          vm.savePromise = null;
          vm.cancelClick = cancelClick;


          //////////

          init();

          /**
           * Initialize
           */
          function init() {
               vm.model.files = [];
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }
               $rootScope.loadingProgress = true;

               if (vm.files.length > 0) {
                    saveFiles();
               } else {
                    savePropriedade();
               }

          }

          function savePropriedade() {

               propertieService.update(vm.model)
                    .then(function () {

                         $rootScope.loadingProgress = false;

                         var message = $filter('translate')('PROPERTIES.PROPERTIE_ALTERED');

                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );

                         if (vm.propriedadeFixed) {
                              gotoEdit(vm.model.propriedade.id);
                         } else {
                              gotoSearch();
                         }
                    }).catch(function (response) {
                         $rootScope.loadingProgress = false;
                         vm.api_response_erro = response;
                    });
          }


          function saveFiles() {

               propertieService.upload(model.id, vm.files)
                    .then(function (values) {

                         vm.files = [];

                         for(var i=0; i<values.propriedade_files.length;i++){
                              vm.model.propriedade_files.push(values.propriedade_files[i]);
                         }

                         savePropriedade();
                    })
                    .catch(function (response) {
                         $rootScope.loadingProgress = false;
                         vm.api_response_erro = response;
                    });

          }

          function gotoSearch() {
               $state.go('app.registro.propriedade.buscar');
          }

          function gotoCreateArea() {
               $state.go('app.registro.area.criar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function citySearch(query) {
               var retorno = propertieService.getCity(query);
               console.log(retorno);
               return retorno;
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }
          vm.fileSelected = function (element) {
               vm.model.files = element.files[0];
          };



     }
})();

(function () {
     'use strict';

     angular
          .module('app.propriedade')
          .controller('CriarPropriedadeController', CriarPropriedadeController);

     /** @ngInject */
     function CriarPropriedadeController($rootScope, $document, $filter, $state, propertieService, model, types, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.files = [];
          vm.types = types;
          vm.api_response_erro = {};

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.save = save;
          vm.gotoSearch = gotoSearch;
          vm.gotoCreateArea = gotoCreateArea;
          vm.gotoEdit = gotoEdit;
          vm.isFormValid = isFormValid;
          vm.citySearch = citySearch;
          vm.savePromise = null;
          vm.showConfirm = showConfirm;
          vm.showError = showError;
          vm.cancelClick = cancelClick;
          //////////

          init();

          /**
           * Initialize
           */
          function init() {
               vm.model = {
                    pessoa_tipo_id: '1'
               }

          }

          function showError(ev) {
               var confirm = $mdDialog.confirm()
                    .title('Ops, algo aconteceu!')
                    .textContent('O tipo de pessoa selecionado não condiz com o CPF/CNPJ')
                    .targetEvent(ev)
                    .ok('OK')

               $mdDialog.show(confirm).then(function () {
                    return null
               }, function () {
                    return null
               });
          };


          function showConfirm(ev) {
               var confirm = $mdDialog.confirm()
                    .title('Antes de finalizar')
                    .textContent('Gostaria de adicionar uma área para sua propriedade?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria')
                    .cancel('Não, não gostaria');

               $mdDialog.show(confirm).then(function () {
                    gotoCreateArea(vm.model)
               }, function () {
                    gotoSearch()
               });
          };

          function save(form) {

               //console.log('SAVE', vm.model);
               //return

               if (form.$invalid) {
                    return;
               }

               if ((vm.model.pessoa_tipo_id == 1 && vm.model.cnpj_cpf.length == 14) || (vm.model.pessoa_tipo_id == 2 && vm.model.cnpj_cpf.length == 11)) {
                    showError();
               }

               var message = '';
               if (vm.model.id > 0) {
                    var message = $filter('translate')('PROPERTIES.PROPERTIE_ALTERED');
                    this.savePromise = propertieService.update(vm.model);
               } else {
                    var message = $filter('translate')('PROPERTIES.PROPERTIE_CREATED');
                    this.savePromise = propertieService.create(vm.model);
               }

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    vm.model.id = response.id;

                    if (vm.files.length > 0)
                    {
                         saveFiles();
                    }
                    else
                    {
                         $mdToast.show(
                              $mdToast.simple()

                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );
                         showConfirm(response);
                         $rootScope.loadingProgress = false;
                    }

                    $rootScope.$emit("toolBar");
                    console.log('toollbar');

               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function saveFiles() {

               propertieService.upload(vm.model.id, vm.files)
                    .then(function (response) {

                              var message = $filter('translate')('PROPERTIES.PROPERTIE_CREATED');
                              $mdToast.show(
                                   $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                              );
                              showConfirm(response);
                              $rootScope.loadingProgress = false;
                    })
                    .catch(function (response) {
                         $rootScope.loadingProgress = false;
                         vm.api_response_erro = response;
                    });

          }

          function gotoEdit(id) {
               $state.go('app.registro.area.criar:id', {
                    id: id
               });
          }

          function gotoSearch() {

               $state.go('app.registro.propriedade.buscar');
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function gotoCreateArea(model) {
               $state.go('app.registro.area.criar', {
                    propriedade: model.id
               });
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function citySearch(query) {
               var retorno = propertieService.getCity(query);
               console.log(retorno);
               return retorno;
          }

     }
})();

(function() {
     'use strict';

     angular
          .module('app.propriedade')
          .controller('BuscarPropriedadeController', BuscarPropriedadeController);

     /** @ngInject */
     function BuscarPropriedadeController(propertieService, $state, $mdDialog) {

          var vm = this;

          // Status
          vm.loadingProgress = false;

          // Data
          //vm.companies = data.data;

          // Methods
          vm.gotoAdd = gotoAdd;
          vm.gotoEditar = gotoEditar;
          vm.gotoVisualizar = gotoVisualizar;
          //vm.search = search;
          vm.viewTutorial = viewTutorial;

          //////////

          // function search() {

          //      vm.loadingProgress = true;
          //      propertieService.query()
          //           .then(function successCallback(data) {
          //                vm.models = data;
          //           }).finally(function() {
          //                vm.loadingProgress = false;
          //           });
          // }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: null,
               length_rows: 1,
               sort_by: 'nome',
               sort_order: 'asc',
               _change: change
          };

          vm.args._change();


          function viewTutorial() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/propriedade/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }


           function mdDialogCtrl($scope, $mdDialog) {

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }




          function change() {
             

               vm.args.loading = true;
               propertieService.getLista(vm.args).then(function(response) {

                    //response.total_rows?vm.args.total_rows=response.total_rows:vm.args.total_rows=0;
                    vm.args.total_rows = response.length;
                    ////////////////////
                    vm.models = response;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();
                    

               }).finally(function() {
                    vm.args.loading = false;
               });
          }

          // eslint-disable-next-line no-unused-vars
          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function gotoAdd() {
               $state.go('app.registro.propriedade.criar');
          }

          function gotoEditar(id) {
               $state.go('app.registro.propriedade.editar', {
                    id: id
               });
          }

          function gotoVisualizar(id) {
               $state.go('app.registro.propriedade.visualizar', {
                    id: id
               });
          }
     }

})();

(function () {
     'use strict';

     angular
          .module('app.plantio', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
               .state('app.registro.manejo.plantio', {
                    abstract: true,
                    url: '/plantio'
               })
               .state('app.registro.manejo.plantio.criar', {
                    url: '/criar?area?propriedade',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/plantio/views/criar.html',
                              controller: 'CriarPlantioController as vm'
                         }
                    },
                    resolve: {
                         model: function (plantioService) {
                              return plantioService.getNew();
                         },
                         propriedades: function (plantioService, $stateParams) {
                              return plantioService.getPropriedades($stateParams);
                         },
                         areas: function (plantioService, $stateParams) {
                              return plantioService.getAreas($stateParams.area);
                         },
                         unidades: function (plantioService) {
                              return plantioService.getUnidade();
                         },
                         tipo_plantios: function (plantioService) {
                              return plantioService.getTipoPlantio();
                         }
                    }
               })
               .state('app.registro.manejo.plantio.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/plantio/views/visualizar.html',
                              controller: 'VisualizarPlantioController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, plantioService) {
                              return plantioService.get($stateParams.id);
                         }
                    }
               })
               .state('app.registro.manejo.plantio.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/plantio/views/buscar.html',
                              controller: 'BuscarPlantioController as vm'
                         }
                    },
                    resolve: {
                         propriedades: function (plantioService) {
                              return plantioService.queryPropertie();
                         },
                         data: function (plantioService) {
                              return plantioService.query(null);
                         },
                         filtros: function (plantioService){
                              return plantioService.filtrosPlantio();
                         }
                    }
               })


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro/plantio');
          $translatePartialLoaderProvider.addPart('app/main/registro');

          //Menu
          msNavigationServiceProvider.saveItem('manejo.plantio', {
               title: 'plantio',
               // icon: 'icon-leaf',
               state: 'app.registro.manejo.plantio.buscar',
               translate: 'PLANTIO.PLANTIO'
          });
     }
})();

(function () {
    'use strict';

    angular
        .module('app.plantio')
        .factory('plantioService', plantioService);

    /** @ngInject */
    function plantioService($q, propertieService, $mdToast, $filter, api) {

        var plantis = [];
        var status = [];
        var type = [];
        var models = [];
        var queryResponse = {};
        var queryArgs = {};
        var modelNew = {};

        var service = {
            get: get,
            getNew: getNew,
            create: create,
            query: query,
            getAreaPlantio: getAreaPlantio,
            searchArea: searchArea,
            searchPropertie: searchPropertie,
            searchCultura: searchCultura,
            deletePlantio: deletePlantio,
            getPropriedade: getPropriedade,
            getAreas: getAreas,
            getPropriedades: getPropriedades,
            getUnidade: getUnidade,
            getTipoPlantio: getTipoPlantio,
            filtrosPlantio: filtrosPlantio,
            queryPropertie: queryPropertie
        };

        return service;

        //////////

        function getNew() {
            return {};
        }

        function getUnidade() {
            return [
               // { id: 1, nome: 'kg' },
               // { id: 3, nome: 'unidades' }
               { id: 1, tipo_id: 1, nome: 'kg' },
               { id: 2, tipo_id: 1, nome: 'unidades' },

               { id: 3, tipo_id: 2, nome: 'miligrama', sigla: 'mg' },
               { id: 4, tipo_id: 2, nome: 'grama', sigla: 'g' },
               { id: 5, tipo_id: 2, nome: 'quilograma', sigla: 'kg' }
               //{ id: 6, tipo_id: 2, nome: 'Tonelada', sigla: 'T' }

            ];
        }

        function getTipoPlantio() {
            return [
                { id: 1, nome: 'Muda' },
                { id: 2, nome: 'Semente' }
            ]
        }


        ////// LISTAR - PLANTIO //////
        function query(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                deferred.resolve(queryResponse);
            } else {
                api.PlantioList.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }
        ////// LISTAR - PLANTIO //////



        ////// CRIAR - PLANTIO //////
        function create(model) {

            var deferred = $q.defer();

            api.Plantio.save(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    plantis.unshift(model);
                    modelNew = {};
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );

            return deferred.promise;
        }
        ////// CRIAR - PLANTIO //////


        ////// CONSULTA POR ID - PLANTIO //////
        function get(id) {
            var deferred = $q.defer();

            api.Plantio.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA POR ID - PLANTIO //////


        ////// DELETAR - PLANTIO //////
        function deletePlantio(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            api.Plantio.delete({
                id: id
            }).$promise.then(
                function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// DELETAR - PLANTIO //////


        ////// CONSULTA POR PROPRIEDADE - PLANTIO //////
        function getPropriedade(id) {

            var deferred = $q.defer();

            api.Propriedade.query({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('REGISTERS.ERROR_WHILE_SEARCHING'))
                        .position('top right')
                        .theme("error-toast")
                        .hideDelay(5000)
                );
            });
            return deferred.promise;
        }
        ////// CONSULTA POR PROPRIEDADE - PLANTIO //////


        ////// CONSULTA DE ÁREA - PLANTIO //////
        function getAreaPlantio(id) {
            var deferred = $q.defer();

            api.PropriedadeArea.query({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA DE ÁREA - PLANTIO //////


        ////// CONSULTA PROPRIEDADE - PLANTIO //////
        function searchPropertie(query) {
            var deferred = $q.defer();

            api.Propriedade.query({
                query: query
            }).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA PROPRIEDADE - PLANTIO //////


        ////// CONSULTA DE ÁREA - PLANTIO //////
        function searchArea(query) {
            var deferred = $q.defer();

            api.PropriedadeArea.query({
                query: query
            }).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA DE ÁREA - PLANTIO //////


        ////// CONSULTA DE CULTURA - PLANTIO //////
        function searchCultura(query) {
            var deferred = $q.defer();

            api.Cultura.query({
                query: query
            }).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA DE CULTURA - PLANTIO //////

        // Retorna area para tela de insumo
        function getAreas(areaId) {
            var deferred = $q.defer();

            api.AreasPlantio.get().$promise.then(
                function (response) {

                    if (areaId && areaId > 0) {
                        // console.log('responseAreas', response);
                        // console.log('area id', areaId);
                        var area = response.filter(function (a) {
                            return a.id == areaId;
                        });

                        if (area.length > 0) {
                            deferred.resolve(area);
                            return;
                        }

                    }else{
                        deferred.resolve(response);
                    }
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

          function queryPropertie() {
               var deferred = $q.defer();
               api.Propriedade.query({}).$promise.then(
               function (response) {
                    deferred.resolve(response.data);
               }
               ).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

        function getPropriedades(propriedadeId) {
            var deferred = $q.defer();

            propertieService.query({}, false).then(function (response) {

                if (propriedadeId && propriedadeId > 0) {
                    var propriedades = response.data.filter(function (a) {
                        return a.id == propriedadeId;
                    });

                    if (propriedades.length > 0) {
                        deferred.resolve(propriedades);
                        return;
                    }

                }

                deferred.resolve(response.data);

            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }

        ////// FILTROS //////
        function filtrosPlantio() {
               var deferred = $q.defer();

               api.filtrosPlantio.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);
               });
               return deferred.promise;
          }

    }

})();

(function() {
     'use strict';

     angular
          .module('app.plantio')
          .controller('VisualizarPlantioController', VisualizarPlantioController);

     /** @ngInject */
     function VisualizarPlantioController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.gotoVisualizar = gotoVisualizar;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.registro.manejo.plantio.buscar');
          }

          function gotoVisualizar(id) {
               $state.go('app.registro.manejo.plantio.visualizar', {
                    id: id
               });
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();
(function () {
    'use strict';

    angular
        .module('app.plantio')
        .controller('CriarPlantioController', CriarPlantioController);

    /** @ngInject */
    function CriarPlantioController($scope, $stateParams, $rootScope, $filter, unidades, tipo_plantios, propriedades, areas, $state, plantioService, estoqueInsumoSementeService, model, $mdToast, $mdDialog, $q) {
        var vm = this;

        // Data
        vm.model = model;
        vm.status = [];
        vm.savePromise = null;
        vm.api_response_erro = {};
        vm.areas = areas;
        vm.tipo_plantios = tipo_plantios;
        vm.unidades = unidades;
        vm.propriedades = propriedades;
        vm.productStock = [];

        // Methods
        vm.save = save;
        vm.gotoInsumo = gotoInsumo;
        vm.gotoSearch = gotoSearch;
        vm.plantioSearch = plantioSearch;
        vm.culturaSearch = culturaSearch;
        vm.propriedadeSearch = propriedadeSearch;
        vm.isFormValid = isFormValid;
        vm.cancelClick = cancelClick;
        vm.setCultura = setCultura;
        vm.autoSelectPropriedade = autoSelectPropriedade;
        vm.changePropriedade = changePropriedade;
        vm.changeTipoPlantio = changeTipoPlantio;
        vm.changeProduto = changeProduto;
        vm.changeQuantidade = changeQuantidade;
        vm.changeRateio = changeRateio;
        vm.changeArea = changeArea;


        vm.searchProductStock = searchProductStock;
        //////////

        init();

        function init() {
            autoSelectPropriedade();

            vm.date = new Date();

            // Setar unidade KG ///////////////
            vm.model.tipo_unidade_medida = {
                id: 1,
                tipo_id: 1,
                nome: "kg"
            }

            $scope.$watch("vm.model.dias", function (newValue, oldValue) {

                if (newValue == undefined) {
                    return;
                }

                var startdate = vm.model.data_plantio;
                var new_date = moment(startdate, "DD-MM-YYYY").add('days', vm.model.dias);
                vm.model.data_colheita_prevista = new_date;

                if (vm.model.dias == "") {
                    vm.model.data_colheita_prevista = null;
                }

            }, true);


            // Se o cliente tiver apenas uma area cadastrada ou se a tela estiver vindo com a area pre selecionada,
            //   inicia a tela com a area selecionada
            console.log('Areas', vm.areas);
            if (vm.areas.length == 1) {
                if(!vm.areas[0].variedade){
                    vm.model.variedade = null;
                }else{
                    vm.model.cultura = {
                        id: vm.areas[0].cultura_id,
                        nome: vm.areas[0].cultura_nome
                    };
                    vm.model.variedade = vm.areas[0].variedade;
                    vm.model.variedadeId = vm.areas[0].variedadeId
                    vm.model.propriedade_area = vm.areas[0];
                }
            }
            console.log('MODEL init',vm.model);
            // if (vm.propriedades.length == 1) {
            //      vm.propriedadeSelecionada = vm.propriedades[0];
            // }

        }

        function autoSelectPropriedade() {

            if ($stateParams.propriedade) {
                let id = $stateParams.propriedade;

                let filter = vm.propriedades.filter(function (propriedade) {
                    return propriedade.id == id
                });
                // let filter = vm.propriedades.filter((propriedade) => {
                //
                // });
                vm.model.propriedade = filter[0];
                return
            }
            vm.model.propriedade = vm.propriedades[0];
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            vm.model.unidade_medida = vm.model.tipo_unidade_medida.nome;
            vm.model.tipo_plantio = vm.model.obj_tipo_plantio.nome;
            if (vm.model.insumo_estoque_rateio)
                vm.model.estoque_insumo_rateio_id = vm.model.insumo_estoque_rateio.id;


            //console.log('MODEL save',vm.model);
            //return
            var message = '';
            message = $filter('translate')('PLANTIO.PLANTIO_CREATED');
            this.savePromise = plantioService.create(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
               $rootScope.loadingProgress = false;

               vm.model.id = response.id;

               $mdToast.show(
                    $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );
                // showConfirm(response);
                gotoSearch()
            }).catch(function (response) {
               $rootScope.loadingProgress = false;
               vm.api_response_erro = response;
               $mdToast.show(
                    $mdToast.simple()
                         .textContent(vm.api_response_erro.data.errors[Object.keys(response.data.errors)[0]])
                         .position('top right')
                         .theme("error-toast")
                         .hideDelay(10000)
               );
            });
        }

        function showConfirm(ev) {
            var confirm = $mdDialog.co
            nfirm()
                .title('Antes de finalizar')
                .textContent($filter('translate')('PLANTIO.GOSTARIA_DE_ADICIONAR_UMA_APLICACAO_DE_INSUMO'))
                .targetEvent(ev)
                .ok($filter('translate')('PLANTIO.SIM_QUERO_ADICIONAR'))
                .cancel($filter('translate')('PLANTIO.NAO_DEPOIS_ADICIONO'));
            $mdDialog.show(confirm).then(function () {
                // gotoInsumo(vm.model);
                gotoInsumo();
            }, function () {
                gotoSearch()
            });
        };

        function propriedadeSearch(query) {
            console.log(query);
            return plantioService.searchPropertie(query);
        }

        function changeArea() {
            setCultura(vm.model.propriedade_area);

            vm.model.insumo_estoque = undefined;
            vm.model.insumo_estoque_rateio = undefined;
            vm.model.obj_tipo_plantio = undefined;
            //vm.model.variedade = undefined;
            vm.model.data_plantio = undefined;
            vm.model.quantidade = undefined;
            //vm.model.tipo_unidade_medida = undefined;
        }

        function setCultura(model) {
            console.log('AREA selected', model);
            if (model.variedade && model.variedadeId > 0){
                vm.model.cultura = {
                    id: model.cultura_id,
                    nome: model.cultura_nome
                };
                vm.model.variedade = model.variedade;
                vm.model.variedadeId = model.variedadeId
            } else {
                //vm.model.cultura = model.cultura_nome;
                vm.model.cultura = {
                    id: model.cultura_id,
                    nome: model.cultura_nome
                };
                vm.model.variedade = undefined;
                vm.model.variedadeId = null
                //CulturaNaoEncontrada();
            }
        }

        function culturaSearch(query) {
            console.log('culturaSearch', query);
            return plantioService.searchCultura(query);
        }

        function cancelClick(form, ev) {

            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }

        function plantioSearch(propriedadeid, query) {

            var deferred = $q.defer();
            plantioService.searchArea(query)
                .then(function (response) {

                    response = $filter('filter')(response, {
                        'propriedade': {
                            id: propriedadeid
                        }
                    });

                    deferred.resolve(response);


                }).catch(function (response) {

                    deferred.reject(response);

                });

            return deferred.promise;
        };

        function gotoInsumo() {
            $state.go('app.registro.manejo.insumo.buscar');
        }

        function gotoEstoqueSemente() {
            $state.go('app.estoque_insumo.semente.criar', {
                propriedade: vm.model.propriedade.id
            });
        }

        function gotoSearch() {
            $state.go('app.registro.manejo.plantio.buscar');
        }

        function isFormValid(formName) {
            if ($scope[formName] && $scope[formName].$valid) {
                return $scope[formName].$valid;
            }
        }

        function changePropriedade() {
            vm.model.insumo_estoque = undefined;
            vm.model.insumo_estoque_rateio = undefined;
            vm.model.obj_tipo_plantio = undefined;
            vm.model.cultura = undefined;
            vm.model.variedade = undefined;
            vm.model.data_plantio = undefined;
            vm.model.quantidade = undefined;
            vm.model.tipo_unidade_medida = undefined;


            // if (vm.model.obj_tipo_plantio.id == 2)
            //     searchProductStock();
            // else {
            //     vm.model.insumo_estoque = undefined;
            //     vm.model.insumo_estoque_rateio = undefined;
            // }
        }

        function changeTipoPlantio() {
            //vm.model.tipo_unidade_medida = null;
            vm.model.quantidade = null;
            if (vm.model.obj_tipo_plantio.id == 2)
                searchProductStock();
            else {
                vm.model.insumo_estoque = undefined;
                vm.model.insumo_estoque_rateio = undefined;
            }
        }

        function changeQuantidade() {

            if (!vm.model.obj_tipo_plantio || !vm.model.insumo_estoque_rateio || !vm.model.insumo_estoque_rateio.quantidade)
                return;



          //   if (vm.model.obj_tipo_plantio.id == 1) {
          //      console.log('veio aqui 1');
          //       // Caso seja do tipo peso, é convertido para miligrama para fazer o calculo. 100000
          //       var quantidade = vm.model.quantidade * (vm.model.insumo_estoque.tipo_medida.id == 1 ? 1000000 : 1);

          //   }
          console.log('rateio teste', vm.model);

          //   if (vm.model.obj_tipo_plantio.id == 2) {
          //      // console.log('quantidade', vm.model.quantidade);
          //      // console.log('rateio', vm.model.insumo_estoque_rateio.quantidade);
          //        let convert = 0;
          //        switch (vm.model.tipo_unidade_medida.id) {
          //           case 3:
          //           convert = 1;
          //                break;
          //           case 4:
          //           convert = 1000;
          //                break;
          //           case 5:
          //           convert = 1000000;
          //                break;
          //           default:
          //                break;
          //        }
          //      // Caso seja do tipo peso, é convertido para miligrama para fazer o calculo.
          //      var quantidade = vm.model.quantidade * convert;
          //  }

           if (vm.model.insumo_estoque_rateio.quantidade < vm.model.quantidade)
                    EstoqueInsuficiente(vm.model);
        }

        function changeProduto() {

            // Consulta o rateio do produto.
            searchRateioProductStock(vm.model.insumo_estoque);

            var unidades = vm.unidades.filter(function (unidade) {
                return unidade.id == vm.model.insumo_estoque.tipo_medida.id
            });
            if (unidades && unidades.length > 0)
                vm.model.tipo_unidade_medida = unidades[0];
        }

        function changeRateio(produto) {

            changeQuantidade();
        }

        function searchProductStock() {

            console.log('model sem', vm.model)

            if (!vm.model.propriedade)
                return;

            var cultura = undefined;
            if (vm.model.cultura)
                cultura = vm.model.cultura.id;

            var args = {
                loading: false,
                page: 1,
                per_page: 9999,
                Propriedade_Id: vm.model.propriedade.id,
                CulturaId: cultura
            };

            $rootScope.loadingProgress = true;

            estoqueInsumoSementeService.query(args).then(function (response) {
                $rootScope.loadingProgress = false;
                console.log('sementes', response);
                vm.productStock = response.data.estoques_insumo_model;

                if (response.data.estoques_insumo_model.length == 0)
                    EstoqueNaoEncontrado();

            }).catch(function (response) {

                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;

                EstoqueNaoEncontrado();
            });
        }

        function searchRateioProductStock(produto) {
          console.log('searchRateioProductStock', produto);
            $rootScope.loadingProgress = true;

            estoqueInsumoSementeService
                .queryRateio(produto.id, produto.insumo_id, produto.tipo_medida_id)
                .then(function (response) {

                    $rootScope.loadingProgress = false;
                    vm.rateioProductStock = response;

                    if (vm.rateioProductStock.length == 1) {
                        vm.model.insumo_estoque_rateio = vm.rateioProductStock[0]
                        changeRateio(produto);
                    }
                    else if (vm.rateioProductStock.length == 0)
                        RateioInsuficiente(produto);

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }



        function EstoqueInsuficiente(produto) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Estoque insuficiente')
                .textContent('Você não possui estoque suficiente deste produto para fazer a aplicação. O que gostaria de fazer agora?')
                // .targetEvent(ev)
                .ok('Cadastrar novo insumo!')
                .cancel('Voltar');

            $mdDialog.show(confirm).then(function () {
                gotoEstoqueSemente();
            }, function () {
                // gotoSearch();
            });
        }

        function RateioInsuficiente(produto) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Insumo insuficiente em estoque')
                .textContent('O insumo ' + produto.insumo.nome + ' não está mais disponível. Deseja adicionar mais insumo no estoque?')
                // .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                gotoEstoqueSemente();
            }, function () {
                // gotoSearch();
            });
        }

        function EstoqueNaoEncontrado(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Produto não encontrado')
                .textContent('Não foi possível encontrar um produto disponível no estoque para essa propriedade. Deseja cadastrar um novo produto?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {
                gotoEstoqueSemente();
            }, function () {
                // gotoSearch();
            });
        }

        function CulturaNaoEncontrada(ev) {

            // Appending dialog to document.body to cover sidenav in docs app
            var confirm = $mdDialog.confirm()
                .title('Cultura não encontrada')
                .textContent('Deseja cadastrar uma cultura para essa area?')
                .targetEvent(ev)
                .ok('Sim, gostaria!')
                .cancel('Não, não gostaria!');

            $mdDialog.show(confirm).then(function () {

                $state.go('app.registro.area.editar', {
                    id: vm.model.propriedade_area.id
                });

            }, function () {
                // gotoSearch();
            });
        }

        function unidadeMedidaFormat(input, tipo_medida) {

            if (tipo_medida == undefined)
                return { quantidade: input, sigla: '', nome: '' }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return { quantidade: input, sigla: 'mg', nome: 'Miligrama' }

                    if (input < 1000000)
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'g', nome: 'Grama' }

                    if (input < 1000000000)
                        return { quantidade: convertToDecimalCase((input / 1000000), 2), sigla: 'kg', nome: 'Quilograma' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000000000), 2), sigla: 'T', nome: 'Tonelada' }

                case 2: // Volume

                    if (input < 1000)
                        return { quantidade: input, sigla: 'ml', nome: 'Mililitro' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'Litros', nome: 'Litros' }

                case 3: // Unidade
                    return { quantidade: input, sigla: 'un', nome: 'Unidades' }

                default:
                    return { quantidade: input, sigla: 'ml', nome: tipo_medida.nome }
            }
        }

        function convertToDecimalCase(number, decimal) {
            var n = parseFloat(number);

            if (Number.isInteger(n)) {
                return n;
            }
            else {
                if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                    return parseInt(number);

                return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.plantio')
        .controller('BuscarPlantioController', BuscarPlantioController);

    /** @ngInject */
    function BuscarPlantioController(data, propriedades, filtros, $filter, plantioService, $state, $mdDialog, $mdToast) {

        var vm = this;

        // Status
        vm.loadingProgress = false;
        vm.activeFilters = false;

        // Data
        vm.rows = data.data;
        vm.filtros = filtros;
        vm.propriedades = propriedades;

        // Methods
        vm.gotoAdd = gotoAdd
        vm.gotoVisualizar = gotoVisualizar;
        vm.search = search;
        vm.resetFilters = resetFilters;
        vm.deletarConfirm = deletarConfirm;
        vm.viewTutorial = viewTutorial;

        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        //////////

        init();

        function init() {
          if (vm.propriedades == undefined || vm.propriedades.length == 0)
               cadastroPropriedadeConfirm();
        }

        function search() {

            vm.loadingProgress = true;
            plantioService.query()
                .then(function successCallback(data) {
                    vm.rows = data.data;
                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            propriedade_area_id: null,
            cultura: null,
            plantio_de: null,
            data_plantio: null,
            Propriedade_Id: null,
            _change: change
        };

        vm.args._change();

        function change() {
          vm.args.loading = true;
          plantioService.query(vm.args).then(function (response) {
               console.log('plantio list', response);

              vm.rows = response.plantios;
              vm.args.total_rows = response.total_itens;
              //vm.args.length_rows = vm.rows.length;
              showActiveFilters();
              vm.args.updatePaggination();

          }).finally(function () {
              vm.args.loading = false;
          });
      }

        function resetFilters() {
            vm.args.propriedade_area_id = null;
            vm.args.cultura = null;
            vm.args.plantio_de = null;
            vm.args.data_plantio = null;
            vm.args.Propriedade_Id = vm.args.Propriedade_Id;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let arr = null;
          let propriedadeNome;
          let dataPlantio = $filter('date')(vm.args.data_plantio,'dd/MM/yyyy');
          let counter = 0;
          for (let i = 0; i < vm.filtros.propriedades_area.length; i++) {
               if (vm.filtros.propriedades_area[i].id == vm.args.propriedade_area_id) {
                    propriedadeNome = vm.filtros.propriedades_area[i].nome
               };
          }
          arr = [
               {
                    description: vm.args.query,
                    value: 'query'
               },
               {
                    description: propriedadeNome,
                    value: 'propriedade_area_id'
               },
               {
                    description: vm.args.cultura,
                    value: 'cultura'
               },
               {
                    description: vm.args.plantio_de,
                    value: 'plantio_de'
               },
               {
                    description: dataPlantio,
                    value: 'data_plantio'
               }
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          vm.args[value] = null;
          change();
        }

        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/registro/plantio/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar plantio?')
                .textContent('Tem certeza que deseja deletar o plantio?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

          console.log('delete model', model);
          //return

            var message = $filter('translate')('PLANTIO.DELETE');

            plantioService.deletePlantio(model.id)
                .then(function (response) {
                    vm.rows.splice(vm.rows.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function (response) {

                    // TODO mensagem de erro
                });
        }


        function _sortBy(col) {

            if (vm.args.sort_by == col) {

                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();

        }

        function gotoAdd(propriedade) {
            $state.go('app.registro.manejo.plantio.criar', {
                propriedade: propriedade
            });
        }

        function gotoVisualizar(id) {
            $state.go('app.registro.manejo.plantio.visualizar', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }
    }


})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.registro.lote_producao', {
                    abstract: true,
                    url: '/lote_producao'
               })
               .state('app.registro.lote_producao.dash', {
                    url: '/dash',
                    views: {
                        'content@app': {
                            templateUrl: 'app/main/registro/lote_producao/views/dash.html',
                            controller: 'dashLotesProduzidosController as vm'
                        }
                    },
                    resolve: {
                         filtros: function (loteProducaoService) {
                            return loteProducaoService.getFiltros();
                         }
                    }
                })
               .state('app.registro.lote_producao.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/buscar.html',
                              controller: 'BuscarLoteProducaoController as vm'
                         }
                    },
                    resolve: {
                         filtros: function (loteProducaoService) {
                            return loteProducaoService.getFiltrosLista();
                         }
                    }
               })
               .state('app.registro.lote_producao.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/visualizar.html',
                              controller: 'VisualizarLoteProducaoController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, loteProducaoService) {
                              return loteProducaoService.get($stateParams.id);
                         },
                         // data: function ($stateParams, loteProducaoService) {
                         //      return loteProducaoService.getVendas($stateParams.id);
                         // },
                         idLoteProducao : function ($stateParams) {
                              return $stateParams.id;
                         },
                    }
               })
               .state('app.registro.lote_producao.manutencao', {
                    url: '/visualizar/:id/manutencao',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/manutencao.html',
                              controller: 'ManutencaoLoteProducaoController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, loteProducaoService) {
                              return loteProducaoService.get($stateParams.id);
                         }
                    }
               })
               .state('app.registro.lote_producao.ocorrencia', {
                    url: '/visualizar/:id/ocorrencia',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/ocorrencia.html',
                              controller: 'OcorrenciaLoteProducaoController as vm'
                         }
                    },
                    resolve: {
                         idLoteProducao : function ($stateParams) {
                              return $stateParams.id;
                         },
                         data: function ($stateParams, loteProducaoService) {
                              return loteProducaoService.getOcorrencias($stateParams.id);
                         }
                    }
               })
               .state('app.registro.lote_producao.insumobiologicoexcluido', {
                    url: '/:id/insumobiologico/:insumoBiologicoId/excluido',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/insumo.biologico.excluido.html',
                              controller: 'VisualizarInsumoBiologicoExcluidoController as vm'
                         }

                    },
                    resolve: {
                         model: function ($stateParams, loteProducaoService) {
                              return loteProducaoService.getInsumoBiologicoExcluido($stateParams.id, $stateParams.insumoBiologicoId);
                         }
                    }
               })

               .state('app.registro.lote_producao.insumodefensivoexcluido', {
                    url: '/:id/insumodefensivo/:insumoDefensivoId/excluido',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/insumo.defensivo.excluido.html',
                              controller: 'VisualizarInsumoDefensivoExcluidoController as vm'
                         }

                    },
                    resolve: {
                         model: function ($stateParams, loteProducaoService) {
                              return loteProducaoService.getInsumoDefensivoExcluido($stateParams.id, $stateParams.insumoDefensivoId);
                         }
                    }
               })

               .state('app.registro.lote_producao.insumofertilizanteexcluido', {
                    url: '/:id/insumofertilizante/:insumoFertilizanteId/excluido',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/lote_producao/views/insumo.fertilizante.excluido.html',
                              controller: 'VisualizarInsumoFertilizanteExcluidoController as vm'
                         }

                    },
                    resolve: {
                         model: function ($stateParams, loteProducaoService) {
                              return loteProducaoService.getInsumoFertilizanteExcluido($stateParams.id, $stateParams.insumoFertilizanteId);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro');
          $translatePartialLoaderProvider.addPart('app/main/registro/lote_producao');

          //Menu
          msNavigationServiceProvider.saveItem('lotes_produzidos', {
               title: 'Lotes produzidos',
               img: '/assets/icons/ico-menu-lotes-produzidos.svg',
               weight: 4

          });
          msNavigationServiceProvider.saveItem('lotes_produzidos.dashboard', {
               title: 'Dashboard',
               state: 'app.registro.lote_producao.dash',
               weight: 1
          });
          msNavigationServiceProvider.saveItem('lotes_produzidos.buscar', {
               title: 'Ver lotes',
               //icon: 'icon-document',
               state: 'app.registro.lote_producao.buscar',
               //translate: 'LOTE_PRODUCAO.LOTE_PRODUZIDOS',
               weight: 2
          });


     }
})();

(function () {
    'use strict';

    angular
        .module('app.lote_producao')
        .factory('loteProducaoService', loteProducaoService);

    /** @ngInject */
    function loteProducaoService($q, api) {

          var models = [];
          var vendas = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               query: query,
               queryLot: queryLot,
               get: get,
               encerrarLote: encerrarLote,
               estornarLote: estornarLote,
               getFiltros: getFiltros,
               getDistribuidores: getDistribuidores,
               getOcorrencias: getOcorrencias,
               removerInsumoBiologico: removerInsumoBiologico,
               removerInsumoFertilizante : removerInsumoFertilizante,
               removerInsumoDefensivo : removerInsumoDefensivo,
               getInsumoBiologicoExcluido: getInsumoBiologicoExcluido,
               getInsumoDefensivoExcluido: getInsumoDefensivoExcluido,
               getInsumoFertilizanteExcluido: getInsumoFertilizanteExcluido,
               getVendas:getVendas,
               getListDashPorArea: getListDashPorArea,
               getListDashPorCultura: getListDashPorCultura,
               getExcelFileArea: getExcelFileArea,
               getExcelFileCultura: getExcelFileCultura,
               getFiltrosLista: getFiltrosLista

          };


        return service;

        //////////

        ////// LISTAR - PAGAMENTO //////
        function query(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                deferred.resolve(queryResponse);
            } else {
                api.LoteProducao.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        models = response.data;
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
                });
            }
            return deferred.promise;
        }
        ////// LISTAR - PAGAMENTO //////

        ////// FILTROS LISTA //////
        function getFiltrosLista() {

          var deferred = $q.defer();

          api.LoteProducaoFiltros.get().$promise.then(
               function (response) {
               deferred.resolve(response);
          }).catch(function (response) {
               deferred.reject(response);
               console.log(response);
          });

          return deferred.promise;
      }

        ////// LISTAR - VENDA DO LOTE DE PRODUÇÃO //////
        function queryLot(args, cache) {

        cache = (typeof cache !== 'undefined') ? cache : true;
        args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

        var deferred = $q.defer();

        if (cache && angular.equals(args, queryArgs)) {
            deferred.resolve(queryResponse);
        } else {
            api.LoteProducao.queryLot(args).$promise.then(
                function (response) {
                    queryArgs = angular.copy(args);
                    sales = response.data;
                    queryResponse = response;
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
        }
        return deferred.promise;
    };
    ////// LISTAR - PAGAMENTO //////

        ////// CONSULTA POR ID - LOTE //////
        function get(id) {
            var deferred = $q.defer();

            api.LoteProducao.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA POR ID - LOTE //////

        ////// ENCERRAR CADERNO CAMPO - LOTE //////
        function encerrarLote(model) {

            var deferred = $q.defer();

            api.LoteProducao.encerrar(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response.data);
                    colheitas.unshift(model);
                    modelNew = {};
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// ENCERRAR CADERNO CAMPO - LOTE //////

        ////// ESTORNAR CADERNO CAMPO - LOTE //////
        function estornarLote(model) {

            var deferred = $q.defer();

            api.LoteProducao.estornarEncerramento(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response.data);
                    colheitas.unshift(model);
                    modelNew = {};
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// ESTORNAR CADERNO CAMPO - LOTE //////

        ////// FILTROS DASHBOARD //////
        function getFiltros() {

          var deferred = $q.defer();

          api.FiltrosLotesProduzidosDash.get().$promise.then(
               function (response) {
               deferred.resolve(response);
          }).catch(function (response) {
               deferred.reject(response);
               console.log(response);
          });

          return deferred.promise;
      }

      ////// LISTA DASH - POR ÁREA //////
      function getListDashPorArea(args, cache) {

          cache = (typeof cache !== 'undefined') ? cache : true;
          args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

          var deferred = $q.defer();

          if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
              deferred.resolve(queryResponse);
          } else {
              api.LotesProduzidosDashboardPorArea.query(args).$promise.then(
                  function (response) {
                      queryArgs = angular.copy(args);
                      //models = response.data;
                      queryResponse = response.data;
                      deferred.resolve(response.data);
                  }

              ).catch(function (response) {
                  deferred.reject(response);
                  console.log(response);
              });
          }
          return deferred.promise;
      }
      ////// LISTA DASH - POR CULTURA //////
      function getListDashPorCultura(args, cache) {

          cache = (typeof cache !== 'undefined') ? cache : true;
          args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

          var deferred = $q.defer();

          if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
              deferred.resolve(queryResponse);
          } else {
              api.LotesProduzidosDashboardPorCultura.query(args).$promise.then(
                  function (response) {
                      queryArgs = angular.copy(args);
                      //models = response.data;
                      queryResponse = response.data;
                      deferred.resolve(response.data);
                  }

              ).catch(function (response) {
                  deferred.reject(response);
                  console.log(response);
              });
          }
          return deferred.promise;
      }

          function getExcelFileArea(query){
               var deferred = $q.defer();

               api.ExcelLotesProduzidosArea.query(query).$promise.then(
               function (response) {
                    deferred.resolve(response);
               }

               ).catch(function (response) {
               deferred.reject(response);
               });
               return deferred.promise;
          }

          function getExcelFileCultura(query){
               var deferred = $q.defer();

               api.ExcelLotesProduzidosCultura.query(query).$promise.then(
               function (response) {
                    deferred.resolve(response);
               }

               ).catch(function (response) {
               deferred.reject(response);
               });
               return deferred.promise;
          }


        ////// LISTA DE DISTRIBUIDORES - PRINT-LABEL //////
        function getDistribuidores() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            distribuidorService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }
        ////// LISTA DE DISTRIBUIDORES - PRINT-LABEL //////


        ////// CONSULTA POR ID - LOTE //////
        function getOcorrencias(args) {

            // console.log('getOcorrencias', args);

            var deferred = $q.defer();

            api.LoteProducaoOcorrencia.query(args).$promise.then(
                function (response) {
                    deferred.resolve(response);
            })
            .catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
            });

            return deferred.promise;
        }
        ////// CONSULTA POR ID - LOTE //////

         ////// CONSULTA DE VENDA POR ID - LOTE //////
         function getVendas(args) {

            var deferred = $q.defer();

            api.LoteProducaoVenda.query(args).$promise.then(
                function (response) {
                    deferred.resolve(response);
            })
            .catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
            });

            return deferred.promise;
        }
        ////// CONSULTA DE VENDA POR ID - LOTE //////

        function removerInsumoBiologico(model){

            var deferred = $q.defer();

            api.LoteProducaoOcorrenciaInsumo.InsumoBiologico(model).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

        function removerInsumoFertilizante(model){

            var deferred = $q.defer();

            api.LoteProducaoOcorrenciaInsumo.InsumoFertilizante(model).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

        function removerInsumoDefensivo(model){

            var deferred = $q.defer();

            api.LoteProducaoOcorrenciaInsumo.InsumoDefensivo(model).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

          function getInsumoBiologicoExcluido (loteProducaoId, insumoBiologicoId) {

               var deferred = $q.defer();

               api.LoteProducaoInsumoBiologico.getExcluido({
                    id: loteProducaoId,
                    insumoBiologicoId: insumoBiologicoId
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getInsumoDefensivoExcluido (loteProducaoId, insumoDefensivoId) {

               var deferred = $q.defer();

               api.LoteProducaoInsumoDefensivo.getExcluido({
                    id: loteProducaoId,
                    insumoDefensivoId: insumoDefensivoId
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function getInsumoFertilizanteExcluido (loteProducaoId, insumoFertilizanteId) {

               var deferred = $q.defer();

               api.LoteProducaoInsumoFertilizante.getExcluido({
                    id: loteProducaoId,
                    insumoFertilizanteId: insumoFertilizanteId
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }


    }

})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao')
          .controller('VisualizarLoteProducaoController', VisualizarLoteProducaoController);

     /** @ngInject */
     function VisualizarLoteProducaoController($scope, idLoteProducao, $state, model, $filter, $mdToast, $mdDialog, loteProducaoService) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.idLoteProducao = idLoteProducao;
          vm.ConfirmacaoEncerramento = ConfirmacaoEncerramento;
          vm.comeBack = comeBack;
          vm.ConfirmacaoEstorno = ConfirmacaoEstorno;
          vm.encerrar = encerrar;
          vm.estornar = estornar;
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;
          vm.search = search;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {}

          function search() {

               vm.loadingProgress = true;
               // loteProducaoService.getVendas()
               //      .then(function successCallback(data) {
               //           vm.sales = data;
               //      }).finally(function () {
               //           vm.loadingProgress = false;
               //      });
          }

          /// Query
          // vm.args = {
          //      loading: false,
          //      query: '',
          //      page: 1,
          //      per_page: 10,
          //      page_sizes: [5, 10, 25, 100],
          //      total_rows: null,
          //      length_rows: 1,
          //      sort_by: 'data',
          //      sort_order: 'desc',
          //      _change: change
          // };

          // vm.args._change();

          // function change() {

          //      vm.args.loading = true;
          //      vm.args.id = vm.idLoteProducao;

          //      // loteProducaoService.getVendas(vm.args).then(function (response) {

          //      //      vm.sales = response.data;

          //      //      vm.args.total_rows = response.total_rows;
          //      //      vm.args.length_rows = vm.sales.length;


          //      // }).finally(function () {
          //      //      vm.args.loading = false;
          //      // });
          // }


          function comeBack(){
               javascript:history.back(1);
          }

          function ConfirmacaoEncerramento(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Encerrar o lote?')
                    .textContent('Você tem certeza que gostaria de encerrar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não, depois encerro!');

               $mdDialog.show(confirm).then(function () {
                    encerrar(model);
               }, function () {
                    return null
               });
          };

          function ConfirmacaoEstorno(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estornar o lote?')
                    .textContent('Você tem certeza que gostaria de estornar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero estornar!')
                    .cancel('Não, depois estorno!');

               $mdDialog.show(confirm).then(function () {
                    estornar(model);
               }, function () {
                    return null
               });
          };

          function encerrar(model) {

               loteProducaoService.encerrarLote(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTE_PRODUCAO.LOTE_ENCERRADO');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );
                         gotoSearch()
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTE_PRODUCAO.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }

          function estornar(model) {

               loteProducaoService.estornarLote(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTE_PRODUCAO.LOTE_ESTORNADO');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );
                         gotoSearch()        
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTE_PRODUCAO.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }

          function gotoSearch() {
               $state.go('app.registro.lote_producao.buscar');
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao')
          .controller('OcorrenciaLoteProducaoController', OcorrenciaLoteProducaoController);

     /** @ngInject */
     function OcorrenciaLoteProducaoController($state, data, idLoteProducao, loteProducaoService, $mdDialog, $scope) {
          var vm = this;

          // Data
          vm.idLoteProducao = idLoteProducao

          vm.gotoVisualizarMotivo = gotoVisualizarMotivo;
          vm.mdDialogCtrl = mdDialogCtrl;
          vm.gotoInsumoBiologico = gotoInsumoBiologico;
          vm.gotoInsumoFertilizante = gotoInsumoFertilizante;
          vm.gotoInsumoDefensivo = gotoInsumoDefensivo;
          vm.search = search;
          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               loteProducaoService.getOcorrencias()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               query: '',
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'data',
               sort_order: 'desc',
               _change: change,
               updatePaggination: updatePaggination
          };

          vm.args._change();

          function updatePaggination() {

          }

          function change() {

               vm.args.loading = true;
               vm.args.id = vm.idLoteProducao;

               loteProducaoService.getOcorrencias(vm.args).then(function (response) {

                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();
          }

          function mdDialogCtrl($scope, dataToPass) {
               $scope.model = dataToPass

               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function gotoInsumoBiologico(insumoId) {

               $state.go('app.registro.lote_producao.insumobiologicoexcluido', {
                    id: vm.idLoteProducao,
                    insumoBiologicoId : insumoId
               });
          }

          function gotoInsumoFertilizante(insumoId) {

               $state.go('app.registro.lote_producao.insumofertilizanteexcluido', {
                    id: vm.idLoteProducao,
                    insumoFertilizanteId : insumoId
               });
          }

          function gotoInsumoDefensivo(insumoId) {

               $state.go('app.registro.lote_producao.insumodefensivoexcluido', {
                    id: vm.idLoteProducao,
                    insumoDefensivoId : insumoId
               });
          }

          function gotoVisualizarMotivo(motivo) {

               var alert = $mdDialog.alert({
                    title: 'Visualizar motivo da ocorrência',
                    textContent: motivo,
                    ok: 'Voltar'
               });

               $mdDialog
                    .show(alert)
                    .finally(function () {
                         alert = undefined;
                    });
          }
     }
})();

(function () {
    'use strict';

    angular
         .module('app.lote_producao')
         .controller('ManutencaoLoteProducaoController', ManutencaoLoteProducaoController)
         .controller('ModalMotivoController', ModalMotivoController);
         

    /** @ngInject */
    function ManutencaoLoteProducaoController(model, $state, loteProducaoService, $mdDialog, $mdToast, $scope) {
         var vm = this;
         
         // Data
         vm.model = model;
         vm.status = [];
         
          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.comeBack = comeBack;
          vm.isFormValid = isFormValid;
          vm.gotoVisualizarOcorrencia = gotoVisualizarOcorrencia;
          vm.removerInsumoBiologicoDialog = removerInsumoBiologicoDialog;
          vm.removerInsumoDefensivoDialog = removerInsumoDefensivoDialog;
          vm.removerInsumoFertilizanteDialog = removerInsumoFertilizanteDialog;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }
          function comeBack(){
               javascript:history.back(1);
          }

          function removerInsumoBiologicoDialog(ev, model, lote_producao){

                    $mdDialog.show({
                         controller: 'ModalMotivoController as vm',
                         templateUrl: 'app/main/registro/lote_producao/views/manutencao.tmpl.html',
                         parent: angular.element(document.body),
                         targetEvent: ev,
                         clickOutsideToClose: false,
                         fullscreen: true // Only for -xs, -sm breakpoints.
                    }).then(function (answer) {
                         removerInsumoBiologico(model, answer, lote_producao);
                    }, function () {

                    });
          }

          function removerInsumoBiologico(model, motivo, lote_producao) {

               var obj = {
                    "motivo": motivo,
                    "lote_producao_id": lote_producao.id,
                    "ocorrencia_tipo": 1,
                    "lote_producao_insumo_biologico_id": model.id
               };
    
               loteProducaoService.removerInsumoBiologico(obj)
               .then(function (response) {
                    
                    reload(lote_producao.id);

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent("Insumo excluido com sucesso!")
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    
               }).catch(function (response) {
                    

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(response.data.detail)
                         .position('top right')
                         .theme("error-toast")
                         .hideDelay(6000)
                    );
               });
          }

          function removerInsumoDefensivoDialog(ev, model, lote_producao){

               $mdDialog.show({
                    controller: 'ModalMotivoController as vm',
                    templateUrl: 'app/main/registro/lote_producao/views/manutencao.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               }).then(function (answer) {
                    removerInsumoDefensivo(model, answer, lote_producao);
               }, function () {

               });
          }

          function removerInsumoDefensivo(model, motivo, lote_producao) {

               var obj = {
                    "motivo": motivo,
                    "lote_producao_id": lote_producao.id,
                    "ocorrencia_tipo": 1,
                    "lote_producao_insumo_defensivo_id": model.id
               };
    
               loteProducaoService.removerInsumoDefensivo(obj)
               .then(function (response) {
                    
                    reload(lote_producao.id);

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent("Insumo excluido com sucesso!")
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );

               }).catch(function (response) {

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(response.data.detail)
                         .position('top right')
                         .theme("error-toast")
                         .hideDelay(6000)
                    );
               });
          }
          
          function removerInsumoFertilizanteDialog(ev, model, lote_producao){
               
               $mdDialog.show({
                    controller: 'ModalMotivoController as vm',
                    templateUrl: 'app/main/registro/lote_producao/views/manutencao.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               }).then(function (answer) {
                    removerInsumoFertilizante(model, answer, lote_producao);
               }, function () {

               });
          }

          function removerInsumoFertilizante(model, motivo, lote_producao) {

               var obj = {
                    "motivo": motivo,
                    "lote_producao_id": lote_producao.id,
                    "ocorrencia_tipo": 1,
                    "lote_producao_insumo_fertilizante_id": model.id
               };
    
               loteProducaoService.removerInsumoFertilizante(obj)
               .then(function (response) {
                    
                    reload(lote_producao.id);

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent("Insumo excluido com sucesso!")
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    
               }).catch(function (response) {

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(response.data.detail)
                         .position('top right')
                         .theme("error-toast")
                         .hideDelay(6000)
                    );
               });
          }

          function reload(loteProducaoId) {
               
               loteProducaoService.get(loteProducaoId).then(function (response) {
                    vm.model = response;
               }).catch(function (response) {
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent("Não foi possível atualizar a tela.")
                         .position('top right')
                         .theme("error-toast")
                         .hideDelay(6000)
                    );
               });
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

         function gotoVisualizarOcorrencia() {
              $state.go('app.registro.lote_producao.ocorrencia', {
                   id: model.id
              });
         }
    }


    function ModalMotivoController(loteProducaoService, $mdDialog, $mdToast, $scope) {

     
          var vm = this;

          // Data
          vm.motivo = "";
          vm.api_response_erro = {};

          // Metodos
          vm.save = save;
          vm.close = close;
          
          //////////

          init();

          function init() {
               
          }

          function save(){
               $mdDialog.hide(vm.motivo);
          }
          
          function close() {
               $mdDialog.cancel();
          }
     }

})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao')
          .controller('VisualizarInsumoFertilizanteExcluidoController', VisualizarInsumoFertilizanteExcluidoController);

     /** @ngInject */
     function VisualizarInsumoFertilizanteExcluidoController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               javascript:history.back(1);
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao')
          .controller('VisualizarInsumoDefensivoExcluidoController', VisualizarInsumoDefensivoExcluidoController);

     /** @ngInject */
     function VisualizarInsumoDefensivoExcluidoController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               javascript:history.back(1);
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao')
          .controller('VisualizarInsumoBiologicoExcluidoController', VisualizarInsumoBiologicoExcluidoController);

     /** @ngInject */
     function VisualizarInsumoBiologicoExcluidoController($scope, $state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               javascript:history.back(1);
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.lote_producao')
          .controller('dashLotesProduzidosController', dashLotesProduzidosController)

     /** @ngInject */
     function dashLotesProduzidosController($state, loteProducaoService, propertieService, $mdDialog, $location, $anchorScroll, $filter, filtros) {
          var vm = this;
          vm.activeFilters = false;

          // Data
          vm.models = null;
          vm.dash = null;
          vm.filtros = filtros;
          //
          vm.closeColapse = true;
          vm.resetFilters = resetFilters;
          vm.gotoAdd = gotoAdd;
          vm.gotoList = gotoList;
          vm.getDash = getDash;
          vm.toAncoraLink = toAncoraLink;
          vm.isColapsed = isColapsed;
          vm.isShowItem = isShowItem;
          vm.closeColapsed = closeColapsed;
          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.selectedPeriodo = selectedPeriodo;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          vm.agrupadoPorChange = agrupadoPorChange;
          vm.getExcelFile = getExcelFile;
          vm.onSelectCultura = onSelectCultura;

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.model = {
               dataInicial: new Date(),
               dataFinal: new Date()
          }

          vm.periods = [
               {
                    description: "Últimos 7 dias",
                    value: 7
               },
               {
                    description: "Últimos 15 dias",
                    value: 15
               },
               {
                    description: "Últimos 30 dias",
                    value: 30
               },
               {
                    description: "Últimos 3 meses",
                    value: 90
               },
               {
                    description: "Últimos 6 meses",
                    value: 180
               }
          ]

          //////////

          /// Query
          vm.args = {
               loading: false,
               //sort_by: 'data_cadastro',
               //sort_order: 'desc',
               periodo: 180,
               data_inicial: null,
               data_final: null,
               area: null,
               cultura: null,
               variedade: null,
               agrupado_por: 1,
               _change: change
          };

          vm.args._change();

          init();

          function init() {
               //console.log('args:',vm.args);
               periodoActive.addClass("select-active");

               propertieService.query().then(function(response) {
                    if (!response || response.data.length == 0)
                         cadastroPropriedadeConfirm();
                    vm.propriedade = response.data;
               });

               //getDash();
          }

          function agrupadoPorChange() {
               // Por Área
               if(vm.args.agrupado_por == 1){
                    vm.args.variedade = null;
               // Por Cultura
               } else {
                    vm.args.area = null;
               }

               change();
               //desableFilter("area");
               // vm.models = [];

           }

          function getDash() {
               vm.args.loading = true;
               loteProducaoService.getDash().then(function (response) {
                    vm.dash = response;

               }).finally(function () {
                   vm.args.loading = false;
               });
          }

          function onSelectCultura(culturaName) {
               vm.args.variedade = null;
               let variedades = [];
               vm.filtros.culturas.forEach( function(item) {
                 if(item.nome == culturaName){
                   variedades = item.variedades;
                 }
               });
               vm.variedades = variedades;
          }

          function getExcelFile(){
               vm.args.loading = true;
               var rand = Math.random();
               // Por Área
               if(vm.args.agrupado_por == 1){
                    loteProducaoService.getExcelFileArea(vm.args)
                    .then(function (data) {
                        vm.args.loading = false;

                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(data.response);

                        link.download = 'LotesProduzidosArea_' + rand + '.xlsx';

                        link.click()

                        $mdDialog.hide();

                        document.body.removeChild(link);

                    }).catch(function (data) {
                        vm.args.loading = false;
                        vm.api_response_erro = data;
                    });
               } else {
               // Por Cultura
                    loteProducaoService.getExcelFileCultura(vm.args)
                    .then(function (data) {
                        vm.args.loading = false;

                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(data.response);

                        link.download = 'LotesProduzidosCultura_' + rand + '.xlsx';

                        link.click()

                        $mdDialog.hide();

                        document.body.removeChild(link);

                    }).catch(function (data) {
                        vm.args.loading = false;
                        vm.api_response_erro = data;
                    });
               }

          }

          function change() {
               vm.args.loading = true;
               // Por Área
               if(vm.args.agrupado_por == 1) {
                    loteProducaoService.getListDashPorArea(vm.args).then(function (response) {
                         console.log(response);
                         vm.models = response;
                         showActiveFilters();
                         vm.isDisabled = false;
                    }).finally(function () {
                         vm.args.loading = false;
                    });
               // Por Cultura
               } else {
                    loteProducaoService.getListDashPorCultura(vm.args).then(function (response) {
                         console.log(response);
                         vm.models = response;
                         showActiveFilters();
                         vm.isDisabled = false;
                    }).finally(function () {
                         vm.args.loading = false;
                    });
               }

          }

          function resetFilters() {
               // IMPORTANTE: limpar individualmente p/ não bugar a paginação!
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 180;
               vm.args.area = null;
               vm.args.cultura = null;
               vm.args.variedade = null;
               vm.args.agrupado_por = 1;
               change();
          }

          function isColapsed(model) {
               model.isLoading = false;
               model.colapsed = true;
               vm.isDisabled = true;
          }

          function closeColapsed(model) {
               model.colapsed = false;
               vm.isDisabled = false;
          }

          function isShowItem(item) {
               item.show = !item.show;
          }

          function gotoAdd() {
               $state.go('app.previsao_colheita.criar');
          }

          function gotoList() {
               $state.go('app.previsao_colheita.buscar');
          }

          function toAncoraLink(value) {
               $location.hash(value);
               $anchorScroll();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let arr = null;
               let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
               let counter = 0;
               for (let i = 0; i < vm.periods.length; i++) {
                    if (vm.periods[i].value == vm.args.periodo) {
                         periodoSelect = vm.periods[i].description
                    };
               }
               arr = [
                    {
                         description: periodoSelect,
                         value: 'periodo'
                    },
                    {
                         description: inicio?inicio+" - "+fim:null,
                         value: 'datepicker'
                    },
                    {
                         description: vm.args.area,
                         value: 'area'
                    },
                    {
                         description: vm.args.cultura,
                         value: 'cultura'
                    },
                    {
                         description: vm.args.variedade,
                         value: 'variedade'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
             }

          function desableFilter(value){
               if(value == 'datepicker'){
                    vm.args.data_inicial = null;
                    vm.args.data_final = null;
                    vm.args.periodo = 180;
                    datapickerActive.removeClass("dates-active");
                    periodoActive.addClass("select-active");
               } else if(value == 'periodo'){
                    vm.args[value] = 180;
               }else{
                    vm.args[value] = null;
               }
               change();
          }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 180;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }
          function cadastroPropriedadeConfirm() {
               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');
               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.lote_producao')
        .controller('BuscarLoteProducaoController', BuscarLoteProducaoController);

    /** @ngInject */
    function BuscarLoteProducaoController($state, loteProducaoService, propertieService, $mdDialog, filtros, $filter) {
        var vm = this;

        // Data
        vm.filtros = filtros;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoManutencao = gotoManutencao;
        vm.search = search;
        //vm.gotoPrint = gotoPrint;
        vm.resetFilters = resetFilters;
        //vm.mdDialogCtrl = mdDialogCtrl;
        //vm.cliente = cliente;
        vm.viewTutorial = viewTutorial;

        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        vm.onSelectCultura = onSelectCultura;
        //////////

        init();

        function init() {
            //vm.search();
        }

        function search() {
            vm.loadingProgress = true;
            loteProducaoService.query()
                .then(function successCallback(data) {
                    vm.models = data.data;

                    propertieService.query().then(function (response) {
                        if (response && response.data && response.data.length > 0){
                            vm.args.Propriedade_Id = response.data[0].id;
                            vm.args._change();
                        }else{
                            cadastroPropriedadeConfirm();
                        }
                    })
                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            propriedade_area: null,
            cultura: null,
            variedade: null,
            producao_data_de: null,
            producao_data_ate: null,
            aberta: null,
            Propriedade_Id: null,
            _change: change
        };

        vm.args._change();

        function change() {

          vm.args.loading = true;
          loteProducaoService.query(vm.args).then(function (response) {
              vm.models = response.data;

              vm.args.total_rows = response.total_rows;
              vm.args.length_rows = vm.models.length;
              showActiveFilters();
              vm.args.updatePaggination();


          }).finally(function () {
              vm.args.loading = false;
          });
       }

          function onSelectCultura(culturaName) {
               vm.args.variedade = null;
               let variedades = [];
               vm.filtros.culturas.forEach( function(item) {
               if(item.nome == culturaName){
               variedades = item.variedades;
               }
               });
               vm.variedades = variedades;
          }

        function resetFilters() {
            vm.args.propriedade_area = null;
            vm.args.cultura = null;
            vm.args.variedade = null;
            vm.args.producao_data_de = null;
            vm.args.producao_data_ate = null;
            vm.args.aberta = null;
            vm.args.Propriedade_Id = vm.args.Propriedade_Id;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let arr = null;
          let status = null;
          let inicio = $filter('date')(vm.args.producao_data_de,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.producao_data_ate,'dd/MM/yyyy');
          let counter = 0;
          if(vm.args.aberta == 1){
               status = 'Aberto';
          } else if(vm.args.aberta == 2) {
               status = 'Fechado';
          }
          arr = [
               {
                    description: vm.args.propriedade_area,
                    value: 'propriedade_area'
               },
               {
                    description: vm.args.cultura,
                    value: 'cultura'
               },
               {
                    description: vm.args.variedade,
                    value: 'variedade'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: status,
                    value: 'aberta'
               },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.DataInicio = null;
               vm.args.DataFim = null;
               datapickerActive.classList.remove("dates-active");
          }
          vm.args[value] = null;
          change();
        }


        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrlColheita,
                 templateUrl: 'app/main/registro/colheita/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrlColheita($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {

                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();

        }

        // function gotoPrint(model, ev) {

        //     var endereco = vm.clientecliente_endereco.endereco +
        //         ' ' +
        //         vm.cliente.cliente_endereco.numero

        //     $mdDialog.show({
        //         locals: {
        //             dataToPass: {
        //                 codigo_fornecedor: vm.clienteid,
        //                 data_expedicao: model.data_expedicao,
        //                 lote_numero: model.lote_numero,
        //                 nome_produtor: model.produtor_nome,
        //                 endereco: {
        //                     rua: model.produtor_endereco_rua,
        //                     numero: model.produtor_endereco_numero,
        //                     cidade: model.produtor_endereco_cidade_nome,
        //                     uf: model.produtor_endereco_uf
        //                 },
        //                 cnpj_cpf: model.produtor_cnpj_cpf,
        //                 telefone: {
        //                     ddd: model.produtor_telefone_ddd,
        //                     numero: model.produtor_telefone_numero
        //                 },
        //                 produto_nome: model.produto_nome,
        //                 produto_variedade: model.produto_variedade,
        //                 produto_embalagem_tipo: model.produto_embalagem_tipo,
        //                 produto_embalagem_peso: model.produto_embalagem_peso,
        //                 logado_nome: vm.clientenome,
        //                 logado_cnpj_cpf: vm.clientecnpj_cpf,
        //                 logado_endereco: endereco
        //             }
        //         },
        //         controller: mdDialogCtrl,
        //         templateUrl: 'app/main/registro/lote_producao/views/print-label.html',
        //         parent: angular.element(document.body),
        //         targetEvent: ev,
        //         clickOutsideToClose: true,
        //         fullscreen: false
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // }

        // function mdDialogCtrl($scope, dataToPass) {
        //     $scope.model = dataToPass

        //     $scope.cancelar = function () {
        //         $mdDialog.cancel();
        //     };
        // }

        function gotoVisualizar(id) {
            $state.go('app.registro.lote_producao.visualizar', {
                id: id
            });
        }

        function gotoManutencao(id) {

            $state.go('app.registro.lote_producao.manutencao', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.despesas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.registro.despesas', {
                abstract: true,
                url: '/despesas'
            })
            .state('app.registro.despesas.buscar', {
                url: '/buscar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/despesas/views/buscar.html',
                        controller: 'BuscarDespesasController as vm'
                    }
                },
                resolve: {
                    propriedades: function (despesasService) {
                        return despesasService.queryPropertie();
                    },
                    // data: function (despesasService) {
                    //     return despesasService.query();
                    // },
                    // cliente: function (clientePerfilService) {
                    //     return clientePerfilService.get();
                    // },
                    filtros: function (despesasService) {
                        return despesasService.getFiltros();
                    },
                    propriedade_id :function ($stateParams){
                        return $stateParams.propriedade
                    }
                }
            })
            .state('app.registro.despesas.criar', {
                url: '/criar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/despesas/views/criar.html',
                        controller: 'CriarDespesasController as vm'
                    }
                },
                resolve: {
                    model: function (despesasService) {
                        return despesasService.getNew();
                    },
                    areas: function (despesasService) {
                        return despesasService.getAreasAdd();
                    },
                    propriedades: function (despesasService) {
                        return despesasService.searchPropertie();
                    },
                    despesa_tipo: function (despesasService) {
                        return despesasService.getDespesaTipo();
                    },
                    despesa_nome: function (despesasService){
                        return despesasService.getDespesaNome();
                    },
                    despesa_favorecido: function (despesasService){
                        return despesasService.getDespesaFavorecido();
                    }
                }
            })
            .state('app.registro.despesas.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/registro/despesas/views/visualizar.html',
                        controller: 'VisualizarDespesasController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, despesasService) {
                        return despesasService.get($stateParams.id);
                    }
                }
            })


        $translatePartialLoaderProvider.addPart('app/main/registro/despesas');

        msNavigationServiceProvider.saveItem('financeiro.despesas', {
            title: 'Despesas Administrativas',
            state: 'app.registro.despesas.buscar',
            weight: 2
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.despesas')
        .factory('despesasService', despesasService);

    /** @ngInject */
    function despesasService($q, api, cadastrosDespesaTipoService, cadastrosDespesaNomeService, cadastrosDespesaFavorecidoService) {

        var models = [];
        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,
            getNew: getNew,
            get: get,
            getFiltros: getFiltros,
            queryPropertie: queryPropertie,
            searchPropertie: searchPropertie,
            create: create,
            deletarCusto: deletarCusto,
            getDespesaTipo: getDespesaTipo,
            getDespesaNome: getDespesaNome,
            getDespesaFavorecido: getDespesaFavorecido,
            getAreasAdd: getAreasAdd
        };

        return service;


        function getNew() {
            return {
                despesas: [
                    {
                        data_entrada: new Date()
                    }
                ]
            };
        }

        function query(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.DespesaAdministrativa.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        models = response.data;
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.DespesaAdministrativa.save(model).$promise.then(
                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    // modelNew = {};
                }
            ).catch(
                function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        function get(id) {
            var deferred = $q.defer();

            api.DespesaAdministrativa.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function searchPropertie(query) {
            var deferred = $q.defer();

            api.Propriedade.query({
                query: query
            }).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function queryPropertie() {

            var deferred = $q.defer();

            api.Propriedade.query({}).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function deletarCusto(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            api.DespesaAdministrativa.delete({
                id: id
            }).$promise.then(
                function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );

            return deferred.promise;
        }

        function getFiltros() {
               var deferred = $q.defer();
               api.DespesaAdministrativaFiltros.query().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
        }

        function getDespesaTipo() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            cadastrosDespesaTipoService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getDespesaNome() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            cadastrosDespesaNomeService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }



        function getDespesaFavorecido() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            cadastrosDespesaFavorecidoService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

          function getAreasAdd() {
               var deferred = $q.defer();
               api.PropriedadeAreaFiltroInsumo.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

    }

})();

(function () {
     'use strict';

     angular
          .module('app.despesas')
          .controller('VisualizarDespesasController', VisualizarDespesasController)

     /** @ngInject */
     function VisualizarDespesasController($state, model) {
          var vm = this;
          // Data
          vm.data_entrada_format = '';
          vm.data_vencimento_format = '';
          vm.model = model;
          vm.gotoSearch = gotoSearch;

          init();

          function init() {
               vm.data_entrada_format = formatDate(vm.model.data_entrada);
               vm.data_vencimento_format = formatDate(vm.model.data_vencimento);
          }

          function formatDate(obj) {
               var data = new Date(obj),
                    dia = data.getDate().toString(),
                    diaF = (dia.length == 1) ? '0' + dia : dia,
                    mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
                    mesF = (mes.length == 1) ? '0' + mes : mes,
                    anoF = data.getFullYear();
               return diaF + "/" + mesF + "/" + anoF;
          }

          function gotoSearch() {
               $state.go('app.registro.despesas.buscar', {
                    propriedade: vm.model.propriedade_area.propriedade.id
               });
          }
     }
})();

(function () {
    'use strict';

    angular
        .module('app.despesas')
        .controller('CriarDespesasController', CriarDespesasController)
        .controller('CriarTipoDespesaController', CriarTipoDespesaController)
        .controller('CriarNomeDespesaController', CriarNomeDespesaController)
        .controller('CriarFavorecidoDespesaController', CriarFavorecidoDespesaController)

    /** @ngInject */
    function CriarDespesasController($rootScope, $scope, $stateParams, $state, $filter, despesasService, propriedades, areas, despesa_tipo, despesa_nome, despesa_favorecido, $mdDialog, $mdToast, model, $element) {

        var vm = this;
        // Data
        vm.model = model;
        vm.tipo_despesas = despesa_tipo;
        vm.nome_despesas = despesa_nome;
        vm.nome_favorecidos = despesa_favorecido;
        vm.areas = areas;
        //vm.all_propriedades = propriedades;
        //vm.propriedades = [];
        vm.propriedade_areas = [];
        vm.propriedades = propriedades;
        vm.propriedadeSelecionada = null;
        vm.dateEntradaMax = onlyDateNow();

        // md-max-date="vm.date"

        // Metodos
        vm.onChangePropriedade = onChangePropriedade;
        vm.addDespesa = addDespesa;
        vm.removeDespesa = removeDespesa;
        vm.onChangeDataEntrada = onChangeDataEntrada;
        vm.showDialogCreateTipoDespesa = showDialogCreateTipoDespesa;
        vm.showDialogCreateNomeDespesa = showDialogCreateNomeDespesa;
        vm.showDialogCreateFavorecidoDespesa = showDialogCreateFavorecidoDespesa
        vm.save = save;
        vm.showConfirm = showConfirm;
        vm.gotoSearch = gotoSearch;
        vm.gotoCriar = gotoCriar;
        //////////

        init();

        function init() {
            vm.model.propriedade_areas = new Array();
            //initPropriedade();
            autoSelectPropriedade();
            console.log('model init:',vm.model);
        }

          // function initPropriedade() {
          //      for (let index = 0; index < vm.all_propriedades.length; index++) {

          //           const element = vm.all_propriedades[index];

          //           vm.propriedades.push({
          //           id: element.id,
          //           nome: element.nome
          //           });
          //      }
          // }

          function initPropriedadeAreas() {
               vm.model.propriedade_areas = [];
               for (let index = 0; index < vm.areas.length; index++) {

                    const element = vm.areas[index];

                    if(element.selected == true){
                         vm.model.propriedade_areas.push({
                              propriedade_area_id: element.id,
                              propriedade_area_nome: element.nome,
                              propriedade_id: element.propriedade_id
                              //propriedade_nome: element.propriedade.nome
                         });
                    }

               }
          }

        function save(tela) {

          initPropriedadeAreas();

          console.log('save despesa', vm.model);
          //return
            var promise = despesasService.create(vm.model);
            $rootScope.loadingProgress = true;

            promise.then(function (response) {
                $rootScope.loadingProgress = false;

                if (response == undefined) {
                    vm.api_response_erro = response;
                    return;
                }
                vm.model.id = response.id;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Despesa criada com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );
               if(tela == 'criar'){
                    gotoCriar();
               }else{
                    gotoSearch();
               }

            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $state.go('app.registro.despesas.buscar');
        }

        function gotoCriar() {
             $state.go('app.registro.despesas.criar',{},{reload:true});
        }

        function onChangePropriedade() {
            //vm.model.propriedade_areas = [];
               vm.model.propriedade_areas = new Array();

               // Atualiza dos as areas para selected igual a false, para não carregar já selecionado.
               for (var index = 0; index < vm.propriedadeSelecionada.propriedade_areas.length; index++) {
                    var area = vm.propriedadeSelecionada.propriedade_areas[index];
                    area.selected = false;
               }
        }

        function addDespesa() {
            vm.model.despesas.push({
                data_entrada: new Date()
            });
        }

        function removeDespesa(index) {
            vm.model.despesas.splice(index, 1);
        }

        function onChangeDataEntrada(despesa) {

            if (onlyDate(despesa.data_entrada) > onlyDate(despesa.data_vencimento))
                despesa.data_vencimento = undefined;
        }

        function onlyDate(date) {
            return new Date(date.toDateString());
        }

        function onlyDateNow() {
            return onlyDate(new Date());
        }

        function showDialogCreateTipoDespesa(ev, model, index) {

            $mdDialog.show({
                controller: 'CriarTipoDespesaController as vm',
                templateUrl: 'app/main/registro/despesas/views/criar_tipo_despesa.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.tipo_despesas.push(answer);
                        model.despesa_tipo_id = answer.id;
                    }
                }, function () {
                    console.error('Ocorreu um erro ao retornar da modal showDialogCreateTipoDespesa');
                });
        }

        function showDialogCreateNomeDespesa(ev, model, index) {

            $mdDialog.show({
                controller: 'CriarNomeDespesaController as vm',
                templateUrl: 'app/main/registro/despesas/views/criar_nome_despesa.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.nome_despesas.push(answer);
                        model.despesa_nome_id = answer.id;
                    }
                }, function () {
                    console.error('Ocorreu um erro ao retornar da modal showDialogCreateNomeDespesa');
                });
        }

        function showDialogCreateFavorecidoDespesa(ev, model, index) {

            $mdDialog.show({
                controller: 'CriarFavorecidoDespesaController as vm',
                templateUrl: 'app/main/registro/despesas/views/criar_favorecido_despesa.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.nome_favorecidos.push(answer);
                        model.despesa_favorecido_id = answer.id;
                    }
                }, function () {
                    console.error('Ocorreu um erro ao retornar da modal showDialogCreateFavorecidoDespesa');
                });
        }


        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }

        function showConfirm(form) {

            if (form.$invalid) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title('Atenção')
                .textContent('Gostaria de salvar uma nova despesa?')
                .targetEvent(form)
                .ok('Sim, gostaria')
                .cancel('Não, não gostaria');

            $mdDialog
                .show(confirm)
                .then(function () {
                    save('criar');
                    // add + 1
                }, function () {
                    save('buscar');
                    // vai para busca
                });
        }

        function autoSelectPropriedade() {

               if ($stateParams.propriedade) {
                    var id = $stateParams.propriedade;

                    var filter = vm.propriedades.filter(function (propriedade) {
                         return propriedade.id == id
                    });

                    vm.propriedadeSelecionada = filter[0];

               } else {
                    vm.propriedadeSelecionada = vm.propriedades[0];
               }
        }
    }


    function CriarTipoDespesaController($rootScope, $scope, $state, $filter, cadastrosDespesaTipoService, $mdToast, $mdDialog) {

        var vm = this;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            // vm.model.id = 10;
            // $mdDialog.hide(vm.model);


            var message = '';
            this.savePromise = cadastrosDespesaTipoService.create(vm.model);

            $rootScope.loadingProgress = true;

            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdDialog.hide(vm.model);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('DESPESA_TIPO.DESPESA_TIPO_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }


    function CriarNomeDespesaController($rootScope, $scope, $state, $filter, cadastrosDespesaNomeService, $mdToast, $mdDialog) {

        var vm = this;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }


            var message = '';
            this.savePromise = cadastrosDespesaNomeService.create(vm.model);

            $rootScope.loadingProgress = true;

            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdDialog.hide(vm.model);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('DESPESA_NOME.DESPESA_NOME_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }


    function CriarFavorecidoDespesaController($rootScope, $scope, $state, $filter, cadastrosDespesaFavorecidoService, $mdToast, $mdDialog) {

        var vm = this;

        // Data
        vm.model = {
            pessoa_tipo_id: 1
        };
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            var message = '';
            this.savePromise = cadastrosDespesaFavorecidoService.create(vm.model);

            $rootScope.loadingProgress = true;

            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdDialog.hide(vm.model);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('DESPESA_FAVORECIDO.DESPESA_FAVORECIDO_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.despesas')
        .controller('BuscarDespesasController', BuscarDespesasController);

    /** @ngInject */
    function BuscarDespesasController($state, despesasService, propriedades, filtros, $stateParams, $mdDialog, $scope, $mdToast, $filter) {
        var vm = this;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        vm.filtros = filtros;
        // vm.manejos = manejos;
        vm.total_cost = 0;
        vm.propriedades = propriedades;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoAdd = gotoAdd;
        //vm.search = search;
        // vm.gotoPrint = gotoPrint;
        vm.mdDialogCtrl = mdDialogCtrl;
        //vm.cliente = cliente;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;

        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
        ];

        vm.model = {
            dataInicio: new Date(),
            dataFim: new Date()
        }


        function init() {
               periodoActive.classList.add("select-active");

               if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();

        }

        init();

     //    function search() {

     //        vm.loadingProgress = true;
     //        despesasService.query()
     //            .then(function successCallback(data) {
     //                vm.models = data;
     //                vm.args.PropriedadeId = vm.propriedades[0].id;
     //            }).finally(function () {
     //                vm.loadingProgress = false;
     //            });
     //    }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            DataInicio: null,
            DataFim: null,
            PropriedadeAreaId: null,
            periodo: 30,
            sort_by: 'data_entrada',
            PropriedadeId: selectPropriedade(),
            sort_order: 'desc',
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            despesasService.query(vm.args).then(function (response) {
                vm.models = response.data;

                vm.total_cost = response.total_cost;
                vm.args.total_rows = response.total_rows;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();

            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function clearPreDate() {
            vm.args.periodo = null
        }
        function clearRangeDate() {
            vm.args.DataInicio = null
            vm.args.DataFim = null
        }

        function resetFilters() {
            vm.args.DataInicio = null;
            vm.args.DataFim = null;
            vm.args.PropriedadeAreaId = null;
            vm.args.periodo = 30;
            vm.args.PropriedadeId = vm.args.PropriedadeId;
            periodoActive.classList.add("select-active");
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.DataInicio,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.DataFim,'dd/MM/yyyy');
          let counter = 0;
          for (let i = 0; i < vm.periods.length; i++) {
               if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
               };
          }
          for (let i = 0; i < vm.filtros.areas.length; i++) {
               if (vm.filtros.areas[i].id == vm.args.PropriedadeAreaId) {
                    var areaNome = vm.filtros.areas[i].nome
               };
          }
          for (let i = 0; i < vm.filtros.tipos.length; i++) {
               if (vm.filtros.tipos[i].id == vm.args.DespesaTipoId) {
                    var tipoNome = vm.filtros.tipos[i].nome
               };
          }
          for (let i = 0; i < vm.filtros.nomes.length; i++) {
               if (vm.filtros.nomes[i].id == vm.args.DespesaNomeId) {
                    var nomeNome = vm.filtros.nomes[i].nome
               };
          }
          for (let i = 0; i < vm.filtros.favorecidos.length; i++) {
               if (vm.filtros.favorecidos[i].id == vm.args.DespesaFavorecidoId) {
                    var favorecidoNome = vm.filtros.favorecidos[i].nome
               };
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: areaNome,
                    value: 'PropriedadeAreaId'
               },
               {
                    description: tipoNome,
                    value: 'DespesaTipoId'
               },
               {
                    description: nomeNome,
                    value: 'DespesaNomeId'
               },
               {
                    description: favorecidoNome,
                    value: 'DespesaFavorecidoId'
               }
          ];
          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.DataInicio = null;
               vm.args.DataFim = null;
               datapickerActive.classList.remove("dates-active");
          } else if(value == 'periodo'){
               periodoActive.classList.remove("select-active");
          }
          vm.args[value] = null;
          change();
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        // function gotoPrint(model, ev) {

        //     var endereco = //cliente_endereco.endereco +
        //         ' ' +
        //         vm.cliente.cliente_endereco.numero

        //     $mdDialog.show({
        //         locals: {
        //             dataToPass: {
        //                 codigo_fornecedor: vm.clienteid,
        //                 data_expedicao: model.data_expedicao,
        //                 lote_numero: model.lote_numero,
        //                 nome_produtor: model.produtor_nome,
        //                 endereco: {
        //                     rua: model.produtor_endereco_rua,
        //                     numero: model.produtor_endereco_numero,
        //                     cidade: model.produtor_endereco_cidade_nome,
        //                     uf: model.produtor_endereco_uf
        //                 },
        //                 cnpj_cpf: model.produtor_cnpj_cpf,
        //                 telefone: {
        //                     ddd: model.produtor_telefone_ddd,
        //                     numero: model.produtor_telefone_numero
        //                 },
        //                 produto_nome: model.produto_nome,
        //                 produto_variedade: model.produto_variedade,
        //                 produto_embalagem_tipo: model.produto_embalagem_tipo,
        //                 produto_embalagem_peso: model.produto_embalagem_peso,
        //                 logado_nome: vm.clientenome,
        //                 logado_cnpj_cpf: vm.clientecnpj_cpf,
        //                 logado_endereco: endereco
        //             }
        //         },
        //         controller: mdDialogCtrl,
        //         templateUrl: 'app/main/registro/lote_producao/views/print-label.html',
        //         parent: angular.element(document.body),
        //         targetEvent: ev,
        //         clickOutsideToClose: true,
        //         fullscreen: false
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // }

        function mdDialogCtrl($scope, dataToPass) {
            $scope.model = dataToPass

            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Cancelar manejo?')
                .textContent('Tem certeza que deseja deletar o manejo?')
                .targetEvent(model)
                .ok('Sim, quero cancelar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            despesasService.deletarCusto(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Manejo deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoVisualizar(id) {
            $state.go('app.registro.despesas.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.registro.despesas.criar', {
                propriedade: vm.args.PropriedadeId
            });
        }

        //function autoSelectPropriedade() {

            // if (propriedade_id) {

            //     let filter = vm.propriedades.filter(function (propriedade) {
            //         return propriedade.id == propriedade_id
            //     });

            //     if (filter != undefined && filter.length > 0)
            //         vm.args.PropriedadeId = filter[0].id;
            // }
        //}

        function selectPropriedade() {

            var propriedade_id = undefined;

            if ($stateParams.propriedade != undefined && $stateParams.propriedade != '') {
                propriedade_id = $stateParams.propriedade;
            }
            else {

                if (vm.propriedades != undefined && vm.propriedades.length > 0)
                    propriedade_id = vm.propriedades[0].id;
            }

            if (propriedade_id) {

                var filter = vm.propriedades.filter(function (propriedade) {
                    return propriedade.id == propriedade_id
                });

                if (filter == undefined || filter.length == 0)
                    return undefined
            }

            return propriedade_id;
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {


            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.DataInicio = null;
               vm.args.DataFim = null;
               periodoActive.classList.add("select-active");
               datapickerActive.classList.remove("dates-active");
          }
          function openDatasSelect(){
               datapicker.style.display = "block";
          }
          function selecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               datapickerActive.classList.add("dates-active");
               periodoActive.classList.remove("select-active");
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.DataInicio = null;
               vm.args.DataFim = null;
               datapickerActive.classList.remove("dates-active");
          }
    }
})();

(function() {
     'use strict';

     angular
          .module('app.dados', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.registro.dados', {
                    abstract: true,
                    url: '/dados'
               })
               .state('app.registro.dados.alterar', {
                    url: '/alterar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/dados/views/alterar.html',
                              controller: 'DadosController as vm'
                         }
                    },
                    resolve: {
                         model: function(dadosService, $stateParams) {
                              return dadosService.get($stateParams.id);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro/dados');
          $translatePartialLoaderProvider.addPart('app/main/registro');
     }
})();
(function() {
     'use strict';

     angular
          .module('app.dados')
          .factory('dadosService', dadosService);

     /** @ngInject */
     function dadosService($q, $mdToast, $filter, api) {

          var dados = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {

          };

          var service = {
               get: get,
               getNew: getNew,
               update: update,
               getCity: getCity
          };

          return service;

          //////////

          function getNew() {
               return modelNew;
          }

          //// CONSULTA POR ID - CLIENTE ////// 
          function get(id) {
               var deferred = $q.defer();

               api.ClientePerfil.get({
                    id: id
               }).$promise.then(
                    function(response) {
                         deferred.resolve(response);
                    }

               ).catch(function(response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - CLIENTE ////// 


          //// ATUALIZAR DADOS - CLIENTE ////// 
          function update(model) {

               var deferred = $q.defer();

               api.Cliente.update(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         dados.unshift(model);
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          //// ATUALIZAR DADOS - CLIENTE ////// 

          ////// CONSULTA DE CIDADE ////// 
          function getCity(query) {

               var deferred = $q.defer();

               api.Cidade.query({
                    query: query
               }).$promise.then(
                    function(response) {

                         var enderecos = [];

                         for (var i = 0; i < response.data.length; i++) {
                              enderecos.push({
                                   cep: "",
                                   endereco: "",
                                   cidade_nome: response.data[i].nome,
                                   uf: response.data[i].estado,
                                   numero: "",
                                   complemento: ""
                              });

                         }

                         deferred.resolve(enderecos);
                    }

               ).catch(function(response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CIDADE ////// 

     }

})();
(function () {
     'use strict';

     angular
          .module('app.custos', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

           // State
           $stateProvider
           .state('app.registro.custos', {
                abstract: true,
                url: '/custos'
           })
           .state('app.registro.custos.buscar', {
                url: '/buscar',
                views: {
                     'content@app': {
                          templateUrl: 'app/main/registro/custos/views/buscar.html',
                          controller: 'BuscarCustosController as vm'
                     }
                },
                resolve: {
                    propriedades: function (custosService){
                         return custosService.queryPropertie();
                    },
                    data: function (custosService) {
                         return custosService.query();
                    },
                    filtros: function (custosService){
                         return custosService.filtrosManejo();
                    }
                }
           })
           .state('app.registro.custos.criar-step-1', {
                url: '/criar-step-1',
                views: {
                     'content@app': {
                          templateUrl: 'app/main/registro/custos/views/criar_step-1.html',
                          controller: 'CriarCustoS1Controller as vm'
                     }
                },
                resolve: {
                     model: function (custosService) {
                          return custosService.getNew();
                     },
                     professionals: function (custosService) {
                          return custosService.getProfessionals();
                     },
                     machines: function (custosService) {
                          return custosService.getMachines();
                     },
                     areas: function (custosService) {
                          return custosService.getAreas();
                     },
                     manejos: function (custosService){
                          return custosService.getManejos();
                     },
                }
           })
           .state('app.registro.custos.criar-step-2', {
               url: '/criar-step-2',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/registro/custos/views/criar_step-2.html',
                         controller: 'CriarCustoS2Controller as vm'
                    }
               },
               resolve: {
                    model: function (custosService) {
                         return custosService.getDados();
                    }
               }
          })
          .state('app.registro.custos.criar-sucesso', {
               url: '/criar-sucesso',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/registro/custos/views/criar_sucesso.html',
                         controller: 'CriarCustoSucessoController as vm'
                    }
               }
          })
           .state('app.registro.custos.visualizar', {
                url: '/visualizar/:id',
                views: {
                     'content@app': {
                          templateUrl: 'app/main/registro/custos/views/visualizar.html',
                          controller: 'VisualizarCustosController as vm'
                     }
                },
                resolve: {
                     model: function ($stateParams, custosService) {
                          return custosService.get($stateParams.id);
                     }
                }
           })


           $translatePartialLoaderProvider.addPart('app/main/registro/custos');

           msNavigationServiceProvider.saveItem('manejo.custos', {
                title: 'Outros manejos e custos',
           //     icon: 'icon-library-books',
                // group: true,
                state: 'app.registro.custos.buscar',
                weight: 5
           });

     }
 })();

(function () {
    'use strict';

    angular
        .module('app.custos')
        .factory('custosService', custosService);

    /** @ngInject */
    function custosService($q, api, cadastrosProfissionalService, cadastrosMaquinaService, areaService) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var dadosCustos = {};

          var service = {
               query: query,
               queryLot: queryLot,
               getNew: getNew,
               get: get,
               encerrarLote: encerrarLote,
               estornarLote: estornarLote,
               getProfessionals: getProfessionals,
               getMachines: getMachines,
               searchTipoManejo:searchTipoManejo,
               getManejos: getManejos,
               filtrosManejo: filtrosManejo,
               getAreas:getAreas,
               create:create,
               queryPropertie:queryPropertie,
               deletarCusto:deletarCusto,
               searchPropertie: searchPropertie,
               getAreasFilter:getAreasFilter,
               addDados: addDados,
               getDados: getDados,
               clearDados: clearDados
          };


        return service;

        //////////

        function getNew() {
            return {};
       }

        function addDados(dados) {
            dadosCustos = dados;
        }
        function getDados() {
            return dadosCustos;
        }
        function clearDados() {
            dadosCustos = {};
        }

        ////// LISTAR - PAGAMENTO //////
        function query(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.CustosAtividade.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        //models = response;
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                    //console.log(response);
                });
            }
            return deferred.promise;
        };
        ////// LISTAR - PAGAMENTO //////

        ////// LISTAR - VENDA DO LOTE DE PRODUÇÃO //////
        function queryLot(args, cache) {

        cache = (typeof cache !== 'undefined') ? cache : true;
        args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

        var deferred = $q.defer();

        if (cache && angular.equals(args, queryArgs)) {
            deferred.resolve(queryResponse);
        } else {
            api.LoteProducao.queryLot(args).$promise.then(
                function (response) {
                    queryArgs = angular.copy(args);
                    sales = response.data;
                    queryResponse = response;
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
        }
        return deferred.promise;
    };
    ////// LISTAR - PAGAMENTO //////

    ////// CRIAR - ÁREA //////
    function create(model) {

        var deferred = $q.defer();

        api.CustosAtividade.save(model).$promise.then(

             // SUCCESS
             function (response) {
                  deferred.resolve(response);
                  areas.unshift(model);
                  modelNew = {};
             }).catch(
             function (response) {
                  //   Resolve the promise
                  deferred.reject(response);
             }
        );
        return deferred.promise;
   }
   ////// CRIAR - ÁREA //////

        ////// CONSULTA POR ID - LOTE //////
        function get(id) {
            var deferred = $q.defer();

            api.CustosAtividade.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA POR ID - LOTE //////

        ////// ENCERRAR CADERNO CAMPO - LOTE //////
        function encerrarLote(model) {

            var deferred = $q.defer();

            api.LoteProducao.encerrar(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response.data);
                    colheitas.unshift(model);
                    modelNew = {};
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// ENCERRAR CADERNO CAMPO - LOTE //////

        ////// ESTORNAR CADERNO CAMPO - LOTE //////
        function estornarLote(model) {

            var deferred = $q.defer();

            api.LoteProducao.estornarEncerramento(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response.data);
                    colheitas.unshift(model);
                    modelNew = {};
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// ESTORNAR CADERNO CAMPO - LOTE //////


        ////// LISTA DE PROFISSIONAIS  //////
        function getProfessionals() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            cadastrosProfissionalService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }
        ////// LISTA DE PROFISSIONAIS  //////

        ////// LISTA DE MAQUINAS  //////
        function getMachines() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            cadastrosMaquinaService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }
        ////// LISTA DE MAQUINAS  //////

        ////// CONSULTA PROPRIEDADE //////
        function searchPropertie(query) {
            var deferred = $q.defer();

            api.Propriedade.query({
                    query: query
            }).$promise.then(
                    function (response) {
                        deferred.resolve(response.data);
                    }

            ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA PROPRIEDADE //////

        ////// LISTA DE AREAS  //////
        function getAreasFilter() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            areaService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }
        ////// LISTA DE AREAS  //////

        ////// TIPO DE MANEJO //////
        function searchTipoManejo(query) {
            var deferred = $q.defer();

            api.TiposManejos.query({
                 query: query
            }).$promise.then(
                 function (response) {
                      deferred.resolve(response);
                 }

            ).catch(function (response) {
                 deferred.reject(response);
                 console.log(response);
            });
            return deferred.promise;
       }
       function getManejos() {
          var deferred = $q.defer();

          api.TiposManejosSelect.get().$promise.then(
               function (response) {
                    deferred.resolve(response);
               }

          ).catch(function (response) {
               deferred.reject(response);
               console.log(response);
          });
          return deferred.promise;
       }
       ////// TIPO DE MANEJO //////

       ////// FILTROS CUSTOS //////
        function filtrosManejo() {
            var deferred = $q.defer();

            api.FiltrosCustosManejos.get().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }


       function queryPropertie() {

        var deferred = $q.defer();

            api.Propriedade.query({}).$promise.then(
                 function (response) {
                      deferred.resolve(response.data);
                 }

            ).catch(function (response) {
                 deferred.reject(response);
                 console.log(response);
            });
            return deferred.promise;
        }

        ////// DELETAR - COLHEITA //////
        function deletarCusto(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            api.CustosAtividade.delete({
                 id: id
            }).$promise.then(
                 function (response) {
                      //   Resolve the promise
                      deferred.resolve(response);

                 }).catch(
                 function (response) {
                      //   Resolve the promise
                      deferred.reject(response);
                 }
            );

            return deferred.promise;
       }
       ////// DELETAR - COLHEITA //////


       ////// CONSULTA DE Areas //////

          // Retorna area para tela de insumo
          function getAreas() {
               var deferred = $q.defer();

               api.AreasCustos.query({}).$promise.then(
                   function (response) {
                       deferred.resolve(response);
                   }

               ).catch(function (response) {
                   deferred.reject(response);
                   console.log(response);
               });
               return deferred.promise;
          }


    }

})();

(function() {
     'use strict';

     angular
          .module('app.dados')
          .controller('DadosController', DadosController)
          .controller('TermosController', TermosController);

     /** @ngInject */
     function DadosController($scope, $filter, $state, dadosService, model, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];
          vm.isDisabled = false;

          // Methods
          vm.isFormValid = isFormValid;
          vm.savePromise = null;
          vm.disableClick = disableClick;
          vm.update = update;
          vm.citySearch = citySearch;
          vm.gotoDashboard = gotoDashboard;
          vm.ShowDialogTermos = ShowDialogTermos;
          //////////

          init();

          function init() {
               vm.date = new Date();
          }

          function disableClick() {
               // alert('teste')
               vm.isDisabled = true;
               return false;
          }


          function update(form) {

               disableClick()

               if (form.$invalid) {
                    return;
               }

               var message = '';
               var message = $filter('translate')('DADOS.DADOS_ALTERED');
               this.savePromise = dadosService.update(vm.model);
               this.savePromise.then(function() {
                    // vm.model.id = response.id;
                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(message)
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoDashboard();
               });
          }

          function ShowDialogTermos(ev) {

               $mdDialog.show({
                         controller: 'TermosController as vm',
                         templateUrl: 'app/main/novo/termos-uso.tmpl.html',
                         parent: angular.element(document.body),
                         targetEvent: ev,
                         clickOutsideToClose: true,
                         fullscreen: true // Only for -xs, -sm breakpoints.
                    })
                    .then(function() {
                         return null;
                    }, function() {
                         return null;
                    });

          }

          function gotoSearch() {
               $state.go('app.registro.colheita.buscar');
          }

          function gotoDashboard() {
               $state.go('app.dashboard');
          }

          function citySearch(query) {
               var retorno = dadosService.getCity(query);
               return retorno;
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }
     }

     function TermosController($mdDialog) {
          var vm = this;
          vm.close = close;

          function close() {
               $mdDialog.hide();
          };
     }

})();

(function () {
    'use strict';

    angular
         .module('app.custos')
         .controller('VisualizarCustosController', VisualizarCustosController)

    /** @ngInject */
    function VisualizarCustosController($state, model, $filter) {
         var vm = this;
         // Data
         vm.model = model;

         vm.gotoSearch = gotoSearch;
         vm.horasCorridas = horasCorridas;

         init();

         function init() {
          }

          function gotoSearch() {
               $state.go('app.registro.custos.buscar');
          }

          function horasCorridas(horas){
               return $filter('number')(timeToDecimal(getNumberWithCommas(horas)),2);
          }

          function getNumberWithCommas(number) {
               return number.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
           }

          function timeToDecimal(t) {
               if (t == undefined)
                    return 0;
               t = t.split(':');
               return parseFloat(parseInt(t[0], 10) + parseInt(t[1], 10) / 60);
          }
    }


})();

(function () {
     'use strict';

     angular
          .module('app.custos')
          .controller('CriarCustoSucessoController', CriarCustoSucessoController)

     /** @ngInject */
     function CriarCustoSucessoController($rootScope, $scope, $stateParams, $state, $filter, custosService, $mdDialog, $mdToast, $element) {
          var vm = this;
          // vm.model.profissionalSelecionado = 0;
          // Data
          vm.model = custosService.getDados();

          // Metodos
          vm.gotoAdd = gotoAdd;
          vm.gotoSearch = gotoSearch;
          vm.gotoHome = gotoHome;
          vm.getNumberWithCommas = getNumberWithCommas;
          vm.cancelClick = cancelClick;
          //////////

          init();

          function init() {
               console.log('json final sucesso', vm.model);
               if(vm.model.id == null){
                    gotoAdd()
               }
               custosService.clearDados();
          }

          function getNumberWithCommas(number) {
               return number.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
           }

          function timeToDecimal(t) {
               if (t == undefined)
                    return 0;
               t = t.split(':');
               return parseFloat(parseInt(t[0], 10) + parseInt(t[1], 10) / 60);
          }

          function gotoAdd() {
               $state.go('app.registro.custos.criar-step-1');
          }

          function gotoSearch(){
               $state.go('app.registro.custos.buscar');
          }

          function gotoHome(){
               $state.go('app.home');
          }

          function cancelClick(ev) {
               var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
               $mdDialog.show(confirm).then(function () {
                    gotoSearch()
               }, null);
          }
     }


})();

(function () {
     'use strict';

     angular
          .module('app.custos')
          .controller('CriarCustoS2Controller', CriarCustoS2Controller)

     /** @ngInject */
     function CriarCustoS2Controller($rootScope, $scope, $stateParams, $state, $filter, custosService, $mdDialog, $mdToast, $element) {

          var vm = this;

          // Data
          vm.model = custosService.getDados();
          vm.areas = [];
          vm.totalGastos = 0;

          // Metodos
          vm.gotoStep1 = gotoStep1;
          vm.gotoSucesso = gotoSucesso;
          vm.save = save;
          vm.getNumberWithCommas = getNumberWithCommas;
          vm.cancelClick = cancelClick;
          vm.totalGastos = totalGastos;
          vm.gastosPorArea = gastosPorArea;
          vm.horasCorridas = horasCorridas;

          //////////

          init();

          function init() {
               if(typeof vm.model.propriedade_areas == 'undefined'){
                    gotoStep1();
                    return
               }
               totalGastos();
               gastosPorArea();

               console.log('json step-2', vm.model);
          }

          function totalGastos(){
               let totalProfissionais = 0;
               let totalMaquinas = 0;
               let totalOutros = 0;
               if(vm.model.profissionais){
                    vm.model.profissionais.forEach(function(item){
                         totalProfissionais += (item.valor_total?item.valor_total:0);
                    });
               }
               if(vm.model.equipamentos){
                    vm.model.equipamentos.forEach(function(item){
                         totalMaquinas += (item.valor_total?item.valor_total:0);
                    });
               }
               if(vm.model.outros){
                    vm.model.outros.forEach(function(item){
                         totalOutros += (item.valor_total?item.valor_total:0);
                    });
               }

               vm.totalGastos = totalProfissionais + totalMaquinas + totalOutros;
          }

          function gastosPorArea(){
               let totalAreas = 0;
               let tamanhoPorc;
               let totallitrosArea;
               let totalValorArea;
               vm.model.propriedade_areas.forEach( function(item) {
                    totalAreas += (item.area_produtiva?item.area_produtiva:0);
               });

               vm.model.propriedade_areas.forEach( function(item) {
                    tamanhoPorc = (100 * item.area_produtiva) / totalAreas;
                    totallitrosArea = (vm.model.total_litros * tamanhoPorc) / 100;
                    totalValorArea = (vm.totalGastos * tamanhoPorc) / 100;
                    vm.areas.push({
                         propriedade_area_nome: item.propriedade_area_nome,
                         area_produtiva: item.area_produtiva,
                         totallitrosArea: totallitrosArea,
                         totalValorArea: totalValorArea
                    });
               });

          }

          function horasCorridas(horas){
               return $filter('number')(timeToDecimal(getNumberWithCommas(horas)),2);
          }

          function getNumberWithCommas(number) {
               return number.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
           }

          function timeToDecimal(t) {
               if (t == undefined)
                    return 0;
               t = t.split(':');
               return parseFloat(parseInt(t[0], 10) + parseInt(t[1], 10) / 60);
          }

          function save() {
               //console.log('SAVE', vm.model);
               //return;

               this.savePromise = custosService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    // $mdToast.show(
                    //      $mdToast.simple()
                    //           .textContent('Manejo criado com sucesso!')
                    //           .position('top right')
                    //           .theme("success-toast")
                    //           .hideDelay(6000)
                    // );
                    // showConfirm(response);
                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                    custosService.clearDados();
               });
          }

          function gotoSucesso() {
               $state.go('app.registro.custos.criar-sucesso');
          }

          function gotoStep1() {
               $state.go('app.registro.custos.criar-step-1');
          }

          function cancelClick(ev) {
               // var confirm = $mdDialog.confirm()
               //      .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
               //      .targetEvent(ev)
               //      .ok($filter('translate')('REGISTERS.DESCARTAR'))
               //      .cancel($filter('translate')('REGISTERS.CANCELAR'));
               // $mdDialog.show(confirm).then(function () {
               //      gotoStep1()
               // }, null);
               $state.go('app.registro.custos.criar-step-1');
          }
     }


})();

(function () {
     'use strict';

     angular
          .module('app.custos')
          .controller('CriarCustoS1Controller', CriarCustoS1Controller)
          .controller('CriarProfissionalController', CriarProfissionalController)
          .controller('CriarMaquinaController', CriarMaquinaController)

     /** @ngInject */
     function CriarCustoS1Controller($scope, $stateParams, $state, $filter, custosService, professionals, areas, machines, $mdDialog, model, manejos) {
          var vm = this;
          // vm.model.profissionalSelecionado = 0;
          // Data
          vm.model = model;
          vm.api_response_erro = {};
          vm.propriedadeSelecionada = null;
          vm.professionals = professionals;
          vm.machines = machines;
          vm.areas = areas;
          vm.manejos = manejos;
          vm.propriedade_areas = [];
          //vm.propriedades = propriedades;
          vm.areas_selecionadas = null;
          vm.dadosForm = custosService.getDados();
          vm.totalAreaProdutiva = 0;

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.cancelClick = cancelClick;
          vm.showDialogCreateProfessional = showDialogCreateProfessional;
          vm.showDialogCreateMachine = showDialogCreateMachine;
          vm.addProfissional = addProfissional;
          vm.addMaquina = addMaquina;
          vm.addOutros = addOutros;
          vm.removeProfissional = removeProfissional;
          vm.removeProfissional2 = removeProfissional2;
          vm.removeOutros = removeOutros;
          vm.removeMaquina = removeMaquina;
          vm.tipoManejo = tipoManejo;
          vm.onChangeProfessional = onChangeProfessional;
          vm.onChangeProfessionalCount = onChangeProfessionalCount;
          vm.resetInputs = resetInputs;
          vm.onChangeMachine = onChangeMachine;
          vm.onChangeMachineCount = onChangeMachineCount;
          vm.onChangeOtherCount = onChangeOtherCount;
          vm.gotoConfirmar = gotoConfirmar;
          vm.getNumberWithCommas = getNumberWithCommas;
          vm.areasSelecionadas = areasSelecionadas;
          vm.remover = remover;
          vm.autoSelectAreas = autoSelectAreas;
          //vm.filterAreas = filterAreas;
          //////////

          init();

          function init() {

               vm.date = new Date();

               vm.model.total_litros = 0;

               if (!vm.dadosForm.profissionais) {
                    if (vm.dadosForm.profissionais == null) {
                         vm.dadosForm.profissionais = new Array();
                    }
                    vm.dadosForm.profissionais.push({});
               }

               if (!vm.dadosForm.equipamentos) {
                    if (vm.dadosForm.equipamentos == null) {
                         vm.dadosForm.equipamentos = new Array();
                    }
                    vm.dadosForm.equipamentos.push({});
               }

               if (!vm.dadosForm.outros) {
                    if (vm.dadosForm.outros == null) {
                         vm.dadosForm.outros = new Array();
                    }
                    vm.dadosForm.outros.push({});
               }

               if (vm.model.propriedade_areas == null) {
                    vm.model.propriedade_areas = new Array();
               }

               console.log('DADOS FORM',  vm.dadosForm);

               for (let index = 0; index < vm.areas.length; index++) {

                    const element = vm.areas[index];

                    vm.propriedade_areas.push({
                         propriedade_area_id: element.id,
                         propriedade_area_nome: element.nome,
                         //propriedade_id: element.propriedade.id,
                         //propriedade_nome: element.propriedade.nome,
                         area_produtiva: element.area_produtiva,
                         cultura: element.cultura_nome,
                         produto_variedade: element.variedade_nome,
                         selected: element.selected
                    });
               }

               autoSelectAreas();

          }

          function areasSelecionadas(){
               vm.totalAreaProdutiva = 0;
               vm.areas_selecionadas = [];
               vm.propriedade_areas.forEach( function(item) {
                    if(item.selected){
                         vm.areas_selecionadas.push({
                              propriedade_area_id: item.propriedade_area_id,
                              propriedade_area_nome: item.propriedade_area_nome,
                              propriedade_id: item.propriedade_id,
                              propriedade_nome: item.propriedade_nome,
                              area_produtiva: item.area_produtiva,
                              cultura: item.cultura,
                              produto_variedade: item.produto_variedade,
                              selected: item.selected
                         });
                         vm.totalAreaProdutiva += item.area_produtiva;
                    }
               });
               //console.log(vm.areas_selecionadas);
          }

          function autoSelectAreas(){
               if(vm.dadosForm.propriedade_areas){
                    //console.log(vm.propriedade_areas);
                    vm.propriedade_areas.forEach( function(item) {
                         vm.dadosForm.propriedade_areas.forEach(function(dados) {
                              if(item.propriedade_area_id == dados.propriedade_area_id){
                                   item.selected = true;
                              }
                         });
                    });
                    areasSelecionadas();
               }
          }

          function gotoConfirmar(form) {
               vm.dadosForm.propriedade_areas = vm.areas_selecionadas;

               if (form.$invalid) {
                    return;
               }

               custosService.addDados(vm.dadosForm);
               //console.log(custosService.getDados());
               //return

               $state.go('app.registro.custos.criar-step-2');
          }

          function remover(area) {
               //area.selected = false;
               var index = vm.areas_selecionadas.indexOf(area);
               vm.areas_selecionadas.splice(index, 1);

               vm.propriedade_areas.forEach( function(item) {
                    if(item.propriedade_area_id == area.propriedade_area_id){
                         item.selected = false
                    }
               });
               if (vm.totalAreaProdutiva)
                    vm.totalAreaProdutiva -= area.area_produtiva;
               //console.log(vm.propriedade_areas);
          }

          function onChangeProfessional(profissional, $index) {
               $scope.isRequiredProfessional = true;
               vm.dadosForm.profissionais[$index].valor_hora = profissional.tipo_profissional.valor_hora;
               vm.dadosForm.profissionais[$index].tipo_profissional_id = profissional.tipo_profissional.id;

               onChangeProfessionalCount(profissional.quantidade_profissional, profissional, $index);
          }

          function onChangeProfessionalCount(quantidade, profissional, $index) {
               var horas = 0;
               if (vm.dadosForm.profissionais[$index].quantidade_horas != undefined)
                    horas = timeToDecimal(getNumberWithCommas(vm.dadosForm.profissionais[$index].quantidade_horas));

               var quantidade_profisssionais = parseFloat(vm.dadosForm.profissionais[$index].quantidade_profissional);

               var total = horas * quantidade_profisssionais * parseFloat(profissional.tipo_profissional.valor_hora);
               vm.dadosForm.profissionais[$index].valor_total = total;

               // if (vm.dadosForm.profissionais[$index].quantidade_horas == null) {
               //      vm.resetInputs();
               // }
          }

          function getNumberWithCommas(number) {
               return number.toString().replace(/\B(?=(\d{2})+(?!\d))/g, ":");
           }

          function timeToDecimal(t) {
               if (t == undefined)
                    return 0;
               t = t.split(':');
               return parseFloat(parseInt(t[0], 10) + parseInt(t[1], 10) / 60);
          }


          function resetInputs(quantidade, horas, $index) {
               if (quantidade == null || horas == null) {
                    vm.dadosForm.profissionais[$index].quantidade_horas = "";
                    vm.dadosForm.profissionais[$index].quantidade_profissional = "";
                    vm.dadosForm.profissionais[$index].valor_total = "";
               }
          }

          function onChangeMachine(equipamento, $index) {
               $scope.isRequiredMachines = true;
               vm.dadosForm.equipamentos[$index].valor_hora = equipamento.equipamento.valor_hora;
               vm.dadosForm.equipamentos[$index].equipamento_id = equipamento.equipamento.id;

               onChangeMachineCount(equipamento, $index)
          }

          function onChangeMachineCount(quantidade, $index) {

               var horas = 0;
               if (vm.dadosForm.equipamentos[$index].quantidade_horas != undefined)
                    horas = timeToDecimal(getNumberWithCommas(vm.dadosForm.equipamentos[$index].quantidade_horas));

               var maquinas = parseFloat(vm.dadosForm.equipamentos[$index].quantidade_maquinas);
               var total = maquinas * parseFloat(quantidade.equipamento.valor_hora) * horas;
               vm.dadosForm.equipamentos[$index].valor_total = total;
          }

          function onChangeOtherCount($index) {
               var horas_trabalhadas = timeToDecimal(getNumberWithCommas(vm.dadosForm.outros[$index].quantidade));
               var valor_hora = vm.dadosForm.outros[$index].valor;
               var total = horas_trabalhadas * valor_hora;
               vm.dadosForm.outros[$index].valor_total = total;
          }

          function addProfissional() {
               vm.dadosForm.profissionais.push({
                    quantidade_profissional: "",
                    quantidade_horas: "",
                    valor_hora: "",
                    valor_total: ""
               });
          }

          function removeProfissional(index) {
               vm.dadosForm.profissionais.splice(index, 1);
          }

          function removeProfissional2(index) {
               vm.dadosForm.profissionais.splice(index, 1);
          }

          function addMaquina() {
               vm.dadosForm.equipamentos.push({
                    quantidade_maquinas: "",
                    // quantidade_horas: "",
                    valor_hora: "",
                    valor_total: ""
               });
          }

          function removeMaquina(index) {
               vm.dadosForm.equipamentos.splice(index, 1);
          }

          function addOutros() {
               vm.dadosForm.outros.push({
                    nome: "",
                    quantidade: "",
                    valor: ""
               });
          }

          function removeOutros(index) {
               vm.dadosForm.outros.splice(index, 1);
          }

          function gotoSearch() {
               $state.go('app.registro.custos.buscar');
          }

          function tipoManejo(query) {
               console.log(query);
               let retorno = custosService.searchTipoManejo(query);
               return retorno;
          }


          function showDialogCreateProfessional(ev, lista_detalhes) {

               $mdDialog.show({
                    controller: 'CriarProfissionalController as vm',
                    templateUrl: 'app/main/registro/custos/views/criar_profissional.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function (answer) {
                         if (answer) {
                              vm.professionals.push(answer);
                              lista_detalhes = answer;
                         }
                    }, function () {
                         vm.model.cliente = null;
                    });

          }

          function showDialogCreateMachine(ev, lista_detalhes) {

               $mdDialog.show({
                    controller: 'CriarMaquinaController as vm',
                    templateUrl: 'app/main/registro/custos/views/criar_maquina.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function (answer) {
                         if (answer) {
                              vm.machines.push(answer);
                              lista_detalhes = answer;
                         }
                    }, function () {
                         vm.model.cliente = null;
                    });

          }

          function cancelClick(form, ev) {
               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function autoSelectPropriedade() {

               if ($stateParams.propriedade) {
                    let id = $stateParams.propriedade;

                    let filter = vm.propriedades.filter(function (propriedade) {
                         return propriedade.id == id
                    });
                    // let filter = vm.propriedades.filter((propriedade) => {
                    //
                    // });
                    vm.dadosForm.propriedade = filter[0];
                    return
               }
               vm.dadosForm.propriedade = vm.propriedades[0];
          }
     }


     function CriarProfissionalController($rootScope, $scope, $state, $filter, cadastrosProfissionalService, $mdToast, $mdDialog) {


          var vm = this;

          // Data
          vm.model = {};
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: 1
               }

          }

          function save(form) {
               $scope.btnDesabled = true;

               if (form.$invalid) {
                    return;
               }

               var message = '';
               this.savePromise = cadastrosProfissionalService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdDialog.hide(vm.model);

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('PROFISSIONAL.PROFISSIONAL_ADICIONADO'))
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );

                    //gotoSearch();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               $mdDialog.hide();
          }


     }

     function CriarMaquinaController($rootScope, $scope, $state, $filter, cadastrosMaquinaService, $mdToast, $mdDialog) {


          var vm = this;

          // Data
          vm.model = {};
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: 1
               }

          }

          function save(form) {
               $scope.btnDesabled = true;

               if (form.$invalid) {
                    return;
               }

               var message = '';
               this.savePromise = cadastrosMaquinaService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdDialog.hide(vm.model);

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('MAQUINA.MAQUINA_ADICIONADO'))
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );

                    //gotoSearch();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               $mdDialog.hide();
          }


     }


})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.custos')
        .controller('BuscarCustosController', BuscarCustosController);

    /** @ngInject */
    function BuscarCustosController($state, custosService, propriedades, filtros, $mdDialog, $mdToast, $filter) {
        var vm = this;

        vm.activeFilters = false;

        // DATAPICKER //////////////////
        var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
        var datapickerActive = angular.element(document.querySelector('#dataspicker'));
        var periodoActive = angular.element(document.querySelector('.select-periodo'));

        // Data
        //vm.areas = areas;
        //vm.manejos = manejos;
        vm.filtros = filtros;
        vm.total_cost = 0;
        vm.propriedades = propriedades;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoAdd = gotoAdd;
        vm.search = search;
        //vm.gotoPrint = gotoPrint;
        //vm.mdDialogCtrl = mdDialogCtrl;
        //vm.cliente = cliente;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;

        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        vm.openFilter = openFilter;
        vm.closeFilter = closeFilter;
        vm.viewTutorial = viewTutorial;
        vm.close = close;

        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
      ];

        vm.model = {
            dataInicio: new Date(),
            dataFim: new Date()
        }


        function init() {
            console.log('filtros', vm.filtros);

            periodoActive.addClass("select-active");
            custosService.clearDados();
            if (vm.propriedades == undefined || vm.propriedades.length == 0)
                cadastroPropriedadeConfirm();
        }

        init();

        function search() {

            vm.loadingProgress = true;
            custosService.query()
                .then(function successCallback(data) {
                    vm.models = data;
                    vm.args.PropriedadeId = vm.propriedades[0].id;
                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: null,
            length_rows: 1,
            DataInicio: null,
            DataFim: null,
            PropriedadeAreaId: null,
            sort_by: 'tipoManejo',
            sort_order: 'desc',
            PropriedadeId: selectPropriedade(),
            Periodo: 30,
            TipoManejoId: null,
            _change: change
        };

        vm.args._change();

        function change() {
            vm.args.loading = true;
            custosService.query(vm.args).then(function (response) {
                vm.models = response.data;
                //console.log('CUSTOS', response);

                vm.total_cost = response.total_cost;
                vm.args.total_rows = response.total_rows;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();

                console.log('ARGS', vm.args);

            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function resetFilters() {
            vm.args.Periodo = 30;
            vm.args.DataInicio = null;
            vm.args.DataFim = null;
            vm.args.PropriedadeAreaId = null;
            vm.args.TipoManejoId = null;
            datapickerActive.removeClass("dates-active");
            periodoActive.removeClass("select-active");
            change();
        }

        function clearPreDate() {
            vm.args.Periodo = null
        }
        function clearRangeDate() {
            vm.args.DataInicio = null
            vm.args.DataFim = null
        }



        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let areas = vm.filtros.propriedade_area;
          let areaNome;
          let atividades = vm.filtros.tipos_manejo;
          let atividadeNome;
          let arr = null;
          let inicio = $filter('date')(vm.args.DataInicio,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.DataFim,'dd/MM/yyyy');
          let counter = 0;
          for (let i = 0; i < areas.length; i++) {
               if (areas[i].id == vm.args.PropriedadeAreaId) {
                    areaNome = areas[i].descricao
               };
          }
          for (let i = 0; i < atividades.length; i++) {
               if (atividades[i].id == vm.args.TipoManejoId) {
                    atividadeNome = atividades[i].descricao
               };
          }
          for (let i = 0; i < vm.periods.length; i++) {
               if (vm.periods[i].value == vm.args.Periodo) {
                    periodoSelect = vm.periods[i].description
               };
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'Periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: areaNome,
                    value: 'PropriedadeAreaId'
               },
               {
                    description: atividadeNome,
                    value: 'TipoManejoId'
               }
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.DataInicio = null;
               vm.args.DataFim = null;
               datapickerActive.removeClass("dates-active");
          } else if(value == 'Periodo'){
                periodoActive.removeClass("select-active");
                vm.args[value] = 30;
          }else{
                vm.args[value] = null;
          }
          change();
        }

        function openFilter(){
            let contentFilter = angular.element(document.querySelector('.form-search-horizontal'));
            contentFilter.addClass('actived');
        }
        function closeFilter(){
            let contentFilter = angular.element(document.querySelector('.form-search-horizontal'));
            contentFilter.removeClass('actived');
        }

        // function gotoPrint(model, ev) {

        //     var endereco = vm.clientecliente_endereco.endereco +
        //         ' ' +
        //         vm.cliente.cliente_endereco.numero

        //     $mdDialog.show({
        //         locals: {
        //             dataToPass: {
        //                 codigo_fornecedor: vm.clienteid,
        //                 data_expedicao: model.data_expedicao,
        //                 lote_numero: model.lote_numero,
        //                 nome_produtor: model.produtor_nome,
        //                 endereco: {
        //                     rua: model.produtor_endereco_rua,
        //                     numero: model.produtor_endereco_numero,
        //                     cidade: model.produtor_endereco_cidade_nome,
        //                     uf: model.produtor_endereco_uf
        //                 },
        //                 cnpj_cpf: model.produtor_cnpj_cpf,
        //                 telefone: {
        //                     ddd: model.produtor_telefone_ddd,
        //                     numero: model.produtor_telefone_numero
        //                 },
        //                 produto_nome: model.produto_nome,
        //                 produto_variedade: model.produto_variedade,
        //                 produto_embalagem_tipo: model.produto_embalagem_tipo,
        //                 produto_embalagem_peso: model.produto_embalagem_peso,
        //                 logado_nome: vm.clientenome,
        //                 logado_cnpj_cpf: vm.clientecnpj_cpf,
        //                 logado_endereco: endereco
        //             }
        //         },
        //         controller: mdDialogCtrl,
        //         templateUrl: 'app/main/registro/lote_producao/views/print-label.html',
        //         parent: angular.element(document.body),
        //         targetEvent: ev,
        //         clickOutsideToClose: true,
        //         fullscreen: false
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // }

        // function mdDialogCtrl($scope, dataToPass) {
        //     $scope.model = dataToPass

        //     $scope.cancelar = function () {
        //         $mdDialog.cancel();
        //     };
        // }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Cancelar manejo?')
                .textContent('Tem certeza que deseja deletar o manejo?')
                .targetEvent(model)
                .ok('Sim, quero cancelar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            custosService.deletarCusto(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Manejo deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function _sortBy(col) {

               if (vm.args.sort_by == col) {

               vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
               vm.args.sort_order = 'asc';
               vm.args.sort_by = col;
               }

               vm.args._change();

          }

        function gotoVisualizar(id) {
            $state.go('app.registro.custos.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.registro.custos.criar-step-1');
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {

            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');
            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        function selectPropriedade() {

            if (vm.propriedades != undefined && vm.propriedades.length > 0)
                return vm.propriedades[0].id;
            else
                return undefined;
        }

        // DATAPICKER //////////////////
        function clearPreDate() {
            vm.args.Periodo = null;
        }
        function selectedPeriodo() {
                vm.args.DataInicio = null;
                vm.args.DataFim = null;
                periodoActive.addClass("select-active");
                datapickerActive.removeClass("dates-active");
        }
        function openDatasSelect(){
                datapicker.css("display", "block");
        }
        function selecionarDatas(){
                vm.clearPreDate();
                datapicker.css("display", "none");
                datapickerActive.addClass("dates-active");
                periodoActive.removeClass("select-active");
        }
        function closedDatasSelect(){
                datapicker.css("display", "none");
                vm.args.DataInicio = null;
                vm.args.DataFim = null;
                //vm.args.periodo = null;
                datapickerActive.removeClass("dates-active");
        }

        function viewTutorial(){
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/home/view/videos/tutorial-gerar-custos.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }
        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

       function close(){
            $mdDialog.hide();
       }

    }
})();

(function() {
     'use strict';

     angular
          .module('app.consulta', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.registro.consulta', {
                    abstract: true,
                    url: '/consulta'
               })
               .state('app.registro.consulta.pagamento', {
                    url: '/pagamento',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/registro/consulta/views/pagamento.html',
                              controller: 'ConsultaPagamentoController as vm'
                         }
                    },
                    resolve: {
                         data: function(consultaPagamentoService) {
                              return consultaPagamentoService.query();
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/registro/consulta');
          $translatePartialLoaderProvider.addPart('app/main/registro');

     }
})();
(function() {
     'use strict';

     angular
          .module('app.consulta')
          .controller('ConsultaPagamentoController', ConsultaPagamentoController);

     /** @ngInject */
     function ConsultaPagamentoController(data, $state, consultaPagamentoService) {
          var vm = this;

          // Data
          vm.gotoSearch = gotoSearch;
          vm.search = search;
          vm.reimprimeboleto = reimprimeboleto;

          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               consultaPagamentoService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function() {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'asc',
               _change: change
          };

          vm.args._change();

          function change() {
               

               vm.args.loading = true;
               consultaPagamentoService.query(vm.args).then(function(response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function() {
                    vm.args.loading = false;
                    console.log(vm.models)
               });
          }

          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function gotoSearch() {
               $state.go('app.registro.colheita.buscar');
          }
          function reimprimeboleto(model){
               window.open((model.dados_boleto.boleto_url), "mywindow", "location=1,status=1,scrollbars=1, width = 800, height = 500");
          }

     }
})();
(function() {
     'use strict';

     angular
          .module('app.consulta')
          .factory('consultaPagamentoService', consultaPagamentoService);

     /** @ngInject */
     function consultaPagamentoService($q, $mdToast, $filter, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {

          };

          var service = {
               query: query,
               getNew: getNew
          };

          return service;

          //////////

          function getNew() {
               return {};
          }

          ////// LISTAR - PAGAMENTO ////// 
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.Pagamento.query(args).$promise.then(
                         function(response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function(response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - PAGAMENTO ////// 

     }

})();
(function () {
    'use strict';

    angular
         .module('app.relatorios.insumos',[])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
         // State
         $stateProvider
              .state('app.relatorios.insumos', {
                   abstract: true,
                   url: '/insumos'
              })
              .state('app.relatorios.insumos.buscar', {
                   url: '/buscar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/relatorios/insumos/views/buscar.html',
                             controller: 'BuscarInsumosController as vm'
                        }
                   },
                   resolve: {
                         propriedades: function (insumoService){
                              return insumoService.queryPropertie();
                         },
                         data: function () {
                            return {};
                         }
                   }
              })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/relatorios/insumos');
         $translatePartialLoaderProvider.addPart('app/main/relatorios');

         //Menu
         msNavigationServiceProvider.saveItem('manejo.insumos', {
              title: 'Histórico de aplicações',
              state: 'app.relatorios.insumos.buscar',
              //translate: 'RELATORIOS.INSUMOS',
              weight: 5
         });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.relatorios.insumos')
        .factory('insumoService', insumoService);

    /** @ngInject */
    function insumoService($q, api) {

        var models = [];
        var agrupados = [];
        var queryResponse = {};
        var queryArgs = {
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'nome',
            sort_order: 'asc',

        };

        var service = {
            getNew: getNew,
            queryArea: queryArea,
            queryProduto: queryProduto,
            queryPropertie: queryPropertie,
            queryInsumosAgrupados: queryInsumosAgrupados,
            getPropriedadeAreaHistoricoList : getPropriedadeAreaHistoricoList,
            getExcelFile: getExcelFile
        };

        return service;

        //////////


        function getNew() {
            return {};
        }
        
        ////// LISTAR - INSUMO //////
        function queryArea(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                deferred.resolve(queryResponse);
            } else {
                api.PropriedadeHistorico.queryArea(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        models = response.data;
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }
        ////// LISTAR - INSUMO //////

        ////// LISTAR - INSUMO //////
        function queryProduto(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                deferred.resolve(queryResponse);
            } else {
                api.PropriedadeHistorico.queryProduto(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        models = response.data;
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }
        ////// LISTAR - INSUMO //////

        function queryPropertie() {

            var deferred = $q.defer();

            api.Propriedade.query({}).$promise.then(
                function (response) {
                    deferred.resolve(response.data);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }


        function queryInsumosAgrupados(insumosAgrupados) {

            var deferred = $q.defer();

            api.PropriedadeHistorico.InsumosAgrupados(insumosAgrupados).$promise.then(
                function (response) {
                    queryArgs = angular.copy(insumosAgrupados);
                    agrupados = response.data;
                    queryResponse = response;
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }

        function getPropriedadeAreaHistoricoList(query) {
            var deferred = $q.defer();

            api.PropriedadeAreaHistoricoList.query(query).$promise.then(
                 function (response) {
                      deferred.resolve(response.data);
                 }

            ).catch(function (response) {
                 deferred.reject(response);
            });
            return deferred.promise;
       }

       function getExcelFile(query){
            var deferred = $q.defer();

            api.PropriedadeHistorico.getExcel(query).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
       }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.relatorios.insumos')
        .controller('mdDialogPrintExcel', mdDialogPrintExcel)
        .controller('BuscarInsumosController', BuscarInsumosController);

    /** @ngInject */
    function BuscarInsumosController(data, propriedades, $scope, insumoService, $mdDialog) {

        var vm = this;

        // Status
        vm.closeColapse = true;
        vm.loadingProgress = false;
        vm.isLoading = false;
        vm.isDisabled = false;

        vm.propriedades = propriedades;
        vm.models = data.data;
        vm.agrupados = [];

        vm.search = search;
        vm.areaSearch = areaSearch;
        vm.resetFilters = resetFilters;
        vm.agrupadoPorChange = agrupadoPorChange;
        vm.isColapsed = isColapsed;
        vm.closeColapsed = closeColapsed;
        vm.getExcelFile = getExcelFile;
        vm.viewTutorial = viewTutorial;
        //vm.unidadeMedidaFormat = unidadeMedidaFormat;

        vm.tipo_insumos = [
            {
                description: "Biológico",
                value: "biologico"
            },
            {
                description: "Defensivo",
                value: "defensivo"
            },
            {
                description: "Fertilizante",
                value: "fertilizante"
            }
        ];


        /// Query
        vm.args = {
            loading: false,
            Data_Inicial: null,
            Data_Final: null,
            sort_by: 'nome',
            sort_order: 'asc',
            Tipo_Insumo: 'defensivo',
            Propriedade_Id: null,
            Propriedade_Area_Id: null,
            _change: search
        };

        vm.model = {
            Data_Inicial: new Date(),
            Data_Final: new Date(),
            agrupado_por: 1
        }

        init();

        function init() {

            if (vm.propriedades && vm.propriedades.length > 0)
                vm.args.Propriedade_Id = vm.propriedades[0].id;
            else
                cadastroPropriedadeConfirm();
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }
        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');
            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        function search() {

            if (vm.model.area) {
                vm.args.Propriedade_Area_Id = vm.model.area.id;
            }else{
                vm.args.Propriedade_Area_Id = undefined;
            }


            vm.loadingProgress = true;
            var promisse = null;

            if (vm.model.agrupado_por == 1)
                promisse = insumoService.queryArea(vm.args, false);
            else
                promisse = insumoService.queryProduto(vm.args, false);

            promisse.then(function successCallback(data) {
                vm.models = data.data;
                vm.isDisabled = false;
            }).finally(function () {
                vm.loadingProgress = false;
            });
        }

        function viewTutorial() {
            $mdDialog.show({
                controller: mdDialogCtrl,
                templateUrl: 'app/main/registro/insumo/views/tutorial.html',
                parent: angular.element(document.body),
                clickOutsideToClose: true,
                fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                $mdDialog.hide();
            };
            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
        }

        function resetFilters() {
            vm.isDisabled = false;

            var propriedade_id = vm.args.Propriedade_Id

            vm.args = {
                loading: false,
                Data_Inicial: null,
                Data_Final: null,
                sort_by: 'nome',
                sort_order: 'asc',
                Tipo_Insumo: 'defensivo',
                Propriedade_Id: propriedade_id,
                Propriedade_Area_Id: undefined,
                _change: search
            };

            vm.model.area = undefined;
        }

        function agrupadoPorChange() {
            // vm.models = [];
            // vm.agrupados = [];
        }

        function isColapsed(model) {

            model.isLoading = true;
            model.colapsed = true;
            vm.args.loading = true;

            var insumosAgrupados = {
                DataAplicacaoInicio: vm.args.Data_Inicial,
                DataAplicacaoFim: vm.args.Data_Final,
                InsumoAgricolaNome: model.insumo_agricola_nome,
                UnidadeMedida: model.unidade_medida,
                TipoInsumo: vm.args.Tipo_Insumo,
                PropriedadeId: vm.args.Propriedade_Id,
                PropriedadeAreaId: model.propriedade_area_id,
            };

            insumoService.queryInsumosAgrupados(insumosAgrupados).then(function (response) {

                vm.agrupados = response.data;
                model.isLoading = false;
                vm.isDisabled = true;

            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function closeColapsed(model) {
            model.colapsed = false;
            vm.isDisabled = false;
        }

     //    function unidadeMedidaFormat(valor, tipo_medida) {

     //        valor = Math.abs(parseFloat(valor))

     //        switch (tipo_medida) {
     //            case 'g': // Peso
     //            case 'mg': // Peso
     //            case 'kg': // Peso
     //            case 't': // Peso
     //            case 'T': // Peso

     //                if (valor < 1000)
     //                    return { valor: valor, unidade: 'mg' }

     //                if (valor < 1000000)
     //                    return { valor: convertToDecimalCase((valor / 1000), 2), unidade: 'g' }

     //                if (valor < 1000000000)
     //                    return { valor: convertToDecimalCase((valor / 1000000), 2), unidade: 'kg' }
     //                else
     //                    return { valor: convertToDecimalCase((valor / 1000000000), 2), unidade: 'Tonelada' }


     //            case 'ml': // Líquido
     //            case 'l': // Líquido

     //                if (valor < 1000)
     //                    return { valor: valor, unidade: 'ml' }
     //                else {
     //                    var numero = convertToDecimalCase((valor / 1000), 2);
     //                    return { valor: numero, unidade: (valor == 1 ? 'Litro' : 'Litros') };
     //                }

     //            default:
     //                return { valor: valor, unidade: tipo_medida };
     //        }

     //    }

     //    function convertToDecimalCase(number, decimal) {
     //        var n = parseFloat(number);

     //        if (Number.isInteger(n)) {
     //            return n;
     //        }
     //        else {
     //            if (Number.isInteger(parseFloat(n.toFixed(decimal))))
     //                return parseInt(number);

     //            return parseFloat(n.toFixed(decimal));
     //        }
     //    }

        function areaSearch(query) {
            var obj = {
                query: query,
                PropriedadeId: vm.args.Propriedade_Id
            }
            var retorno = insumoService.getPropriedadeAreaHistoricoList(obj);

            return retorno;
        }

        function getExcelFile(ev){

            $mdDialog.show({
                controller: 'mdDialogPrintExcel as vm',
                templateUrl: 'app/main/relatorios/insumos/views/excel-download.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false
            })
                .then(function (answer) {
                    $scope.status = 'You said the information was "' + answer + '".';
                }, function () {
                    $scope.status = 'You cancelled the dialog.';
                });

            if (vm.model.area) {
                vm.args.Propriedade_Area_Id = vm.model.area.id;
            }

            vm.loadingProgress = true;

            insumoService.getExcelFile(vm.args)
                .then(function (data) {
                    vm.loadingProgress = false;

                    var data_inicial = '';
                    if(vm.args.Data_Inicial)
                        data_inicial = moment(vm.args.Data_Inicial).format('ll');

                    var data_final = '';
                    if(vm.args.Data_Final)
                        data_final = moment(vm.args.Data_Final).format('ll');

                    var link = document.createElement('a');
                    link.href = window.URL.createObjectURL(data.response);
                    link.download = 'HistoricoInsumos_' + data_inicial + '_' + data_final;

                    link.click()

                    $mdDialog.hide();

                    document.body.removeChild(link);

                }).catch(function (data) {
                    vm.loadingProgress = false;
                    vm.api_response_erro = data;
                });
        }
    }

    function mdDialogPrintExcel($scope, $mdDialog) {

        $scope.dismissModal = function () {
             $mdDialog.cancel();
        }
   }

})();

(function () {
     'use strict';

     angular
          .module('app.produtores', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

          // State
          $stateProvider
               .state('app.produtores', {
                    abstract: true,
                    url: '/produtores',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               });



          // Translation
          // $translatePartialLoaderProvider.addPart('app/main/produtores');

          // msNavigationServiceProvider.saveItem('produtores', {
          //      title: 'Produtores',
          //      icon: 'icon-account-box',
          //      // group: true,
          //      weight: 2,
          //      translate: 'PRODUTORES.PRODUTORES'
          // });

     }
})();

(function() {
     'use strict';

     angular
          .module('app.produtores')
          .factory('produtoresService', produtoresService);

     /** @ngInject */
     function produtoresService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               query: query,
          };

          return service;

          //////////

          ////// LISTAR - PRODUTORES ////// 
          function query(args, cache) {
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.ProdutoresLiberados.query(args).$promise.then(
                         function(response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function(response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - PRODUTORES ////// 

     }

})();
(function () {
     'use strict';

     angular
          .module('app.produtores.consultar', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.produtores.consultar', {
                    url: '/consultar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/produtores/consultar/views/consultar.html',
                              controller: 'ProdutoresController as vm'
                         }
                    },
                    resolve: {
                         data: function (produtoresService) {
                              return produtoresService.query();
                         }
                    }
               })

          // Translation
          // $translatePartialLoaderProvider.addPart('app/main/produtores');
          // $translatePartialLoaderProvider.addPart('app/main/produtores/consultar');

          // //Menu
          // msNavigationServiceProvider.saveItem('produtores.consultar', {
          //      title: 'produtores',
          //      // icon: 'icon-document',
          //      state: 'app.produtores.consultar',
          //      translate: 'Consulta de Produtores'
          // });

     }
})();

(function() {
     'use strict';

     angular
          .module('app.produtores.consultar')
          .controller('ProdutoresController', ProdutoresController);

     /** @ngInject */
     function ProdutoresController(data, $state, produtoresService, $mdDialog, $scope) {
          var vm = this;

          // Data
          vm.search = search;

          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               produtoresService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function() {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'asc',
               _change: change
          };

          vm.args._change();

          function change() {
               

               vm.args.loading = true;
               produtoresService.query(vm.args).then(function(response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function() {
                    vm.args.loading = false;
               });
          }

          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.fechamento_custos.mensal', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.fechamento_custos', {
                abstract: true,
                url: '/fechamento_custos'
            })
            .state('app.fechamento_custos.mensal', {
                url: '/mensal',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/fechamento_custos/mensal/views/dash.html',
                        controller: 'dashFechamentoMensalController as vm'
                    }
                },
                resolve: {
                    filtro: function (fechamentoCustosMensalService) {
                        return fechamentoCustosMensalService.getFiltroArea();
                    }
                }
            })

          //Menu
          msNavigationServiceProvider.saveItem('propriedademenu.fechamento_custos.mensal', {
               title: 'Mensal',
               // icon: 'icon-fill',
               weight: 1,
               state: 'app.fechamento_custos.mensal',
          });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.fechamento_custos.mensal')
        .factory('fechamentoCustosMensalService', fechamentoCustosMensalService);

    /** @ngInject */
    function fechamentoCustosMensalService($q, api, propertieService, areaService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,
            getListDashArea: getListDashArea,
            getListDashAtividade: getListDashAtividade,
            getList: getList,
            getDash: getDash,
            get: get,
            getPropriedades: getPropriedades,
            getAreas: getAreas,
            getFiltroArea: getFiltroArea,
            getFiltroAtividade: getFiltroAtividade,
            getCulturasVariedades: getCulturasVariedades,
            getColheitas: getColheitas,
            create: create,
            update: update,
            deletar: deletar,
            getStatus: getStatus,
            getExcelFileArea: getExcelFileArea,
            getExcelFileAtividade: getExcelFileAtividade
        };

        return service;

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaCultura.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getDash(args, cache) {

          var deferred = $q.defer();

          cache = (typeof cache !== 'undefined') ? cache : true;
          args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


          if (cache && angular.equals(args, queryArgs)) {
              deferred.resolve(queryResponse);
          } else {
              api.FechamentoCustosMensalDash.query(args).$promise.then(
                  function (response) {
                      queryArgs = angular.copy(args);
                      queryResponse = response;
                      deferred.resolve(response);
                  }

              ).catch(function (response) {
                  deferred.reject(response);
              });
          }
          return deferred.promise;
      }

        function getListDashArea(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.FechamentoCustosMensalListArea.get(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getListDashAtividade(args, cache) {

               var deferred = $q.defer();

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               if (cache && angular.equals(args, queryArgs)) {
               deferred.resolve(queryResponse);
               } else {
               api.FechamentoCustosMensalListAtividade.get(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
               });
               }
               return deferred.promise;
          }

        function getList(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaList.get(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getFiltroArea() {
               var deferred = $q.defer();
               api.FiltroFechamentoCustosMensalArea.query().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
        }
        function getFiltroAtividade() {
               var deferred = $q.defer();
               api.FiltroFechamentoCustosMensalAtividade.query().$promise.then(
               function (response) {
                    deferred.resolve(response);
               }
               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
        }

          function getExcelFileArea(query){
               var deferred = $q.defer();

               api.ExcelFechamentoCustosMensalArea.query(query).$promise.then(
               function (response) {
                    deferred.resolve(response);
               }

               ).catch(function (response) {
               deferred.reject(response);
               });
               return deferred.promise;
          }
          function getExcelFileAtividade(query){
               var deferred = $q.defer();

               api.ExcelFechamentoCustosMensalAtividade.query(query).$promise.then(
               function (response) {
                    deferred.resolve(response);
               }

               ).catch(function (response) {
               deferred.reject(response);
               });
               return deferred.promise;
          }

        function getPropriedades() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            propertieService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }

        // Retorna area para tela de insumo
          // areaid: opcional
          function getAreas() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            areaService.query(args, false).then(function (response) {
                deferred.resolve(response.data);

            }).catch(function (response) {
                 deferred.reject(response);
                 console.log(response);

            });

            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.PrevisaoColheita
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }


        function get(id) {

            var deferred = $q.defer();

            api.PrevisaoColheitaGetId.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getCulturasVariedades() {

            var deferred = $q.defer();
            api.PropriedadeAreaCulturasVariedades
                .get().$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        }

        function getColheitas(id) {
            var deferred = $q.defer();
                api.PrevisaoColheitaColheitas
                    .get({
                        id: id
                    }).$promise
                    .then(function (response) {
                        deferred.resolve(response);
                    })
                    .catch(function (response) {
                        deferred.reject(response);
                    });
            return deferred.promise;
        }

        ////// ALTERAR //////
        function update(model) {
            var deferred = $q.defer();
            api.PrevisaoColheita.update(model).$promise.then(
                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    modelNew = {};
                }).catch(
                    function (response) {
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

        function deletar(id){
            var deferred = $q.defer();

            api.PrevisaoColheita.delete({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }).catch(
                function (response) {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        function getStatus() {
            return [
                {
                    nome: "Válido",
                    id: 1
                },
                {
                    nome: "Vencido",
                    id: 2
                },
                {
                    nome: "Todos",
                    id: 3
                }
            ]
       }
    }
})();

(function () {
     'use strict';

     angular
          .module('app.fechamento_custos.mensal')
          .controller('dashFechamentoMensalController', dashFechamentoMensalController)

     /** @ngInject */
     function dashFechamentoMensalController($state, fechamentoCustosMensalService, previsaoColheitaService, propertieService, $mdDialog, $location, $anchorScroll, $filter, filtro) {
          var vm = this;
          vm.activeFilters = false;

          // Data
          vm.models = null;
          vm.dash = null;
          vm.filtros = filtro;
          //
          vm.closeColapse = true;
          vm.resetFilters = resetFilters;
          vm.gotoAdd = gotoAdd;
          vm.gotoList = gotoList;
          vm.getFiltros = getFiltros;
          vm.getDash = getDash;
          vm.toAncoraLink = toAncoraLink;
          vm.isColapsed = isColapsed;
          vm.isShowItem = isShowItem;
          vm.closeColapsed = closeColapsed;
          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.selectedPeriodo = selectedPeriodo;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          vm.agrupadoPorChange = agrupadoPorChange;
          vm.getExcelFile = getExcelFile;

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.model = {
               dataInicial: new Date(),
               dataFinal: new Date()
          }

          vm.periods = [
               {
                    description: "Últimos 7 dias",
                    value: 7
               },
               {
                    description: "Últimos 15 dias",
                    value: 15
               },
               {
                    description: "Últimos 30 dias",
                    value: 30
               },
               {
                    description: "Últimos 3 meses",
                    value: 90
               },
               {
                    description: "Últimos 6 meses",
                    value: 180
               }
          ]

          //////////

          /// Query
          vm.args = {
               loading: false,
               //sort_by: 'data_cadastro',
               //sort_order: 'desc',
               periodo: 180,
               data_inicial: null,
               data_final: null,
               area: null,
               agrupado_por: 1,
               _change: change
          };

          vm.args._change();

          init();

          function init() {
               //console.log('args:',vm.args);
               periodoActive.addClass("select-active");

               propertieService.query().then(function(response) {
                    if (!response || response.data.length == 0)
                         cadastroPropriedadeConfirm();
                    vm.propriedade = response.data;
               });
          }

          function agrupadoPorChange(){
               getFiltros();
               change();
          }

          function getFiltros() {
               vm.args.loading = true;
               // Área
               if(vm.args.agrupado_por == 1) {
                    fechamentoCustosMensalService.getFiltroArea(vm.args).then(function (result) {
                         vm.filtros = result;
                    }).finally(function () {
                         vm.args.loading = false;
                    });
               // Atividade
               } else {
                    fechamentoCustosMensalService.getFiltroAtividade(vm.args).then(function (result) {
                         vm.filtros = result;
                    }).finally(function () {
                         vm.args.loading = false;
                    });
               }

          }

          function getDash() {
               vm.args.loading = true;
               fechamentoCustosMensalService.getDash(vm.args).then(function (result) {
                    vm.dash = result.data;
               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function change() {

               getDash();

               // Por Área
               if(vm.args.agrupado_por == 1) {
                    fechamentoCustosMensalService.getListDashArea(vm.args).then(function (response) {
                         console.log(response);
                         vm.models = response;

                         showActiveFilters();
                         vm.isDisabled = false;
                    }).finally(function () {
                         vm.args.loading = false;
                    });
               // Por Atividade
               } else {
                    fechamentoCustosMensalService.getListDashAtividade(vm.args).then(function (response) {
                         console.log(response);
                         vm.models = response;
                         showActiveFilters();
                         vm.isDisabled = false;
                    }).finally(function () {
                         vm.args.loading = false;
                    });
               }

          }

          function resetFilters() {
               // IMPORTANTE limpar individualmente p/ não bugar a paginação!
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 180;
               vm.args.area = null;
               vm.args.atividade = null;
               vm.args.agrupado_por = 1;
               change();
               getFiltros();
          }

          function getExcelFile(){
               vm.args.loading = true;
               var rand = Math.random();
               // Por Área
               if(vm.args.agrupado_por == 1){
                    fechamentoCustosMensalService.getExcelFileArea(vm.args)
                    .then(function (data) {
                        vm.args.loading = false;

                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(data.response);

                        link.download = 'FechamentoMensalArea_' + rand + '.xlsx';

                        link.click()

                        $mdDialog.hide();

                        document.body.removeChild(link);

                    }).catch(function (data) {
                        vm.args.loading = false;
                        vm.api_response_erro = data;
                    });
               } else {
               // Por Atividade
                    fechamentoCustosMensalService.getExcelFileAtividade(vm.args)
                    .then(function (data) {
                        vm.args.loading = false;

                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(data.response);

                        link.download = 'FechamentoMensalAtividade_' + rand + '.xlsx';

                        link.click()

                        $mdDialog.hide();

                        document.body.removeChild(link);

                    }).catch(function (data) {
                        vm.args.loading = false;
                        vm.api_response_erro = data;
                    });
               }

          }

          function isColapsed(model) {
               model.isLoading = false;
               model.colapsed = true;
               vm.isDisabled = true;
          }

          function closeColapsed(model) {
               model.colapsed = false;
               vm.isDisabled = false;
          }

          function isShowItem(item) {
               item.show = !item.show;
          }

          function gotoAdd() {
               $state.go('app.previsao_colheita.criar');
          }

          function gotoList() {
               $state.go('app.previsao_colheita.buscar');
          }

          function toAncoraLink(value) {
               $location.hash(value);
               $anchorScroll();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let arr = null;
               let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
               let counter = 0;
               for (let i = 0; i < vm.periods.length; i++) {
                    if (vm.periods[i].value == vm.args.periodo) {
                         periodoSelect = vm.periods[i].description
                    };
               }
               arr = [
                    {
                         description: periodoSelect,
                         value: 'periodo'
                    },
                    {
                         description: inicio?inicio+" - "+fim:null,
                         value: 'datepicker'
                    },
                    {
                         description: vm.args.area,
                         value: 'area'
                    },
                    {
                         description: vm.args.atividade,
                         value: 'atividade'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
             }

          function desableFilter(value){
               if(value == 'datepicker'){
                    vm.args.data_inicial = null;
                    vm.args.data_final = null;
                    vm.args.periodo = 180;
                    datapickerActive.removeClass("dates-active");
                    periodoActive.addClass("select-active");
               } else if(value == 'periodo'){
                    vm.args[value] = 180;
               }else{
                    vm.args[value] = null;
               }
               change();
          }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 180;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }
          function cadastroPropriedadeConfirm() {
               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');
               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.previsao_colheita', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.previsao_colheita', {
                abstract: true,
                url: '/previsao_colheita',
                resolve: {
                    authorize: function (authorization) {
                         authorization.authorize();
                    }
               }
            })
            .state('app.previsao_colheita.buscar', {
                url: '/buscar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/previsao_colheita/views/buscar.html',
                        controller: 'BuscarPrevisaoColheitaController as vm'
                    }
                },
                resolve: {
                    data: function (previsaoColheitaService) {
                        return previsaoColheitaService.query();
                    }
                }
            })
            .state('app.previsao_colheita.dash', {
                url: '/dash',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/previsao_colheita/views/dash.html',
                        controller: 'dashPrevisaoColheitaController as vm'
                    }
                },
                resolve: {
                    data: function (previsaoColheitaService) {
                        return previsaoColheitaService.query();
                    }
                }
            })
            .state('app.previsao_colheita.criar', {
                url: '/criar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/previsao_colheita/views/criar.html',
                        controller: 'CriarPrevisaoColheitaController as vm'
                    }
                },
                resolve: {
                    areas: function (previsaoColheitaService) {
                        return previsaoColheitaService.getAreas();
                    },
                    propriedades: function (previsaoColheitaService) {
                        return previsaoColheitaService.getPropriedades();
                    },
                    unidades: function (previsaoColheitaService) {
                        return previsaoColheitaService.getUnidade();
                    }
                }
            })
            .state('app.previsao_colheita.editar', {
                url: '/previsao_colheita/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/previsao_colheita/views/editar.html',
                        controller: 'EditarPrevisaoColheitaController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, previsaoColheitaService) {
                        return previsaoColheitaService.get($stateParams.id);
                    }
                }
            })

            //Menu
            msNavigationServiceProvider.saveItem('previsao_colheita', {
                title: 'Previsão colheita',
                weight: 7,
                img: '/assets/icons/previsa-colheita/ico-previsao-colheita-br.svg',
            });
            msNavigationServiceProvider.saveItem('previsao_colheita.dash', {
                title: 'Dashboard',
                state: 'app.previsao_colheita.dash',
            });
            msNavigationServiceProvider.saveItem('previsao_colheita.buscar', {
                title: 'Lista de previsões',
                state: 'app.previsao_colheita.buscar',
            });

    }
})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .controller('BuscarPrevisaoColheitaController', BuscarPrevisaoColheitaController);

    /** @ngInject */
    function BuscarPrevisaoColheitaController(data, $state, previsaoColheitaService, propertieService, $mdDialog, $mdToast, $filter) {
        var vm = this;

        // Data
        vm.filtros = [];
        vm.variedades = [];

        vm.gotoEdit = gotoEdit;
        vm.gotoAdd = gotoAdd;
        vm.mdDialogCtrl = mdDialogCtrl;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        vm.onSelectCultura = onSelectCultura;

        // DATAPICKER //////////////////
        var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
        var datapickerActive = angular.element(document.querySelector('#dataspicker'));
        var periodoActive = angular.element(document.querySelector('.select-periodo'));

        vm.periods = [
            {
                description: "Últimos 7 dias",
                value: 7
            },
            {
                description: "Últimos 15 dias",
                value: 15
            },
            {
                description: "Últimos 30 dias",
                value: 30
            },
            {
                description: "Últimos 3 meses",
                value: 90
            },
            {
                description: "Últimos 6 meses",
                value: 180
            }
        ];

        vm.model = {
            data_inicial: new Date(),
            data_final: new Date()
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            // sort_by: 'data_cadastro',
            // sort_order: 'desc',
            periodo: 180,
            data_inicial: null,
            data_final: null,
            cultura: null,
            variedade: null,
            query: null,
            _change: change
        };

        vm.args._change();

        function init() {
            periodoActive.addClass("select-active");
            propertieService.query().then(function(response) {
                if (!response || response.data.length == 0)
                    cadastroPropriedadeConfirm();
                vm.propriedade = response.data;
           });
        }

        init();

        function change() {

            vm.args.loading = true;
            previsaoColheitaService.getList(vm.args).then(function (response) {
                vm.models = response.previsao_colheitas;
                vm.filtros = response;
                vm.args.total_rows = response.total_itens;
                //vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();
            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function onSelectCultura(culturaName) {
            //console.log('veio aqui',culturaName.nome);
            //this.filterActive = false;
            vm.args.variedade = null;
            let variedades = [];
            vm.filtros.culturas.forEach( function(item) {
              if(item.nome == culturaName){
                variedades = item.variedades;
              }
            });
            vm.variedades = variedades;
        }

        function clearPreDate() {
            vm.args.periodo = null
        }
        function clearRangeDate() {
            vm.args.data_inicial = null
            vm.args.data_final = null
        }

        function resetFilters() {
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            vm.args.periodo = 180;
            vm.args.cultura = null;
            vm.args.variedade = null;
            change();
        }

        function showActiveFilters(){
            vm.activeFilters = null;
            let periodoSelect;
            let arr = null;
            let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
            let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
            let counter = 0;
            for (let i = 0; i < vm.periods.length; i++) {
                if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
                };
            }
            arr = [
                {
                    description: periodoSelect,
                    value: 'periodo'
                },
                {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
                },
                {
                    description: vm.args.cultura,
                    value: 'cultura'
                },
                {
                    description: vm.args.variedade,
                    value: 'variedade'
                }
            ];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
                }

                if(counter > 0){
                    vm.activeFilters = arr;
                }
        }

        function desableFilter(value){
            if(value == 'datepicker'){
                vm.args.data_inicial = null;
                vm.args.data_final = null;
                vm.args.periodo = 180;
                datapickerActive.removeClass("dates-active");
                periodoActive.addClass("select-active");
            } else if(value == 'periodo'){
                vm.args[value] = 180;
            }else{
                vm.args[value] = null;
            }
            change();
        }

        function mdDialogCtrl($scope, dataToPass) {
            $scope.model = dataToPass

            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Exclusão de previsão')
                .textContent('Você deseja excluir essa previsão?')
                .targetEvent(model)
                .ok('Sim')
                .cancel('Não');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            previsaoColheitaService.deletar(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Previsão deletada com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoEdit(id) {
            $state.go('app.previsao_colheita.editar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.previsao_colheita.criar');
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }
        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        // DATAPICKER //////////////////
        function clearPreDate() {
            vm.args.periodo = null;
        }
        function selectedPeriodo() {
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            periodoActive.addClass("select-active");
            datapickerActive.removeClass("dates-active");
        }
        function openDatasSelect(){
            datapicker.css("display", "block");
        }
        function selecionarDatas(){
            clearPreDate();
            datapicker.css("display", "none");
            datapickerActive.addClass("dates-active");
            periodoActive.removeClass("select-active");
        }
        function closedDatasSelect(){
            datapicker.css("display", "none");
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            vm.args.periodo = null;
            datapickerActive.removeClass("dates-active");
            //periodoActive.classList.add("select-active");
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.estoque_insumo.semente', {
                abstract: true,
                url: '/semente'
            })
            .state('app.estoque_insumo.semente.buscar', {
                url: '/buscar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/semente/views/buscar.html',
                        controller: 'BuscarEstoqueInsumoSementeController as vm'
                    }
                },
                resolve: {
                    propriedades: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.searchProperties();
                    },
                    data: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.query();
                    },
                    fornecedores: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getInsumos();
                    }
                }
            })
            .state('app.estoque_insumo.semente.criar', {
                url: '/criar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/semente/views/criar.html',
                        controller: 'CriarEstoqueInsumoSementeController as vm'
                    }
                },
                resolve: {
                    model: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getNew();
                    },
                    fornecedores: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getAllInsumos();
                    },
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    }
                }
            })
            .state('app.estoque_insumo.semente.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/semente/views/visualizar.html',
                        controller: 'VisualizarEstoqueInsumoSementeController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.get($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.semente.historico', {
                url: '/historico/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/semente/views/historico.html',
                        controller: 'historicoEstoqueInsumoSementeController as vm'
                    }
                },
                resolve: {
                    estoque_insumo: function ($stateParams, estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getEstoqueInsumo($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })
            .state('app.estoque_insumo.semente.acerto', {
                url: '/acerto/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/semente/views/acerto.html',
                        controller: 'AcertoEstoqueInsumoSementeController as vm'
                    }
                },
                resolve: {
                    estoque_insumo: function ($stateParams, estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getRateio($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.semente.rateio', {
                url: '/rateio/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/semente/views/rateio.html',
                        controller: 'RateioEstoqueInsumoSementeController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoSementeService) {
                        return estoqueInsumoSementeService.getRateio($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })

        $translatePartialLoaderProvider.addPart('app/main/estoque_insumo/semente');

        msNavigationServiceProvider.saveItem('estoque_insumo.gestao.semente', {
            title: 'Semente',
            state: 'app.estoque_insumo.semente.buscar',
            weight: 2
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente')
        .factory('estoqueInsumoSementeService', estoqueInsumoSementeService);

    /** @ngInject */
    function estoqueInsumoSementeService($q, api, cadastrosFornecedorService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,
            getNew: getNew,
            get: get,
            create: create,

            queryRateio: queryRateio,
            getRateio: getRateio,
            createAcerto: createAcerto,

            queryHistoricoCompra: queryHistoricoCompra,
            getEstoqueInsumo: getEstoqueInsumo,

            deletarCusto: deletarCusto,
            searchProperties: searchProperties,

            getUnidadesMedidas: getUnidadesMedidas,
            getInsumos: getInsumos,
            getAllInsumos: getAllInsumos,
            getFornecedores: getFornecedores
        };

        return service;

        function getNew() {
            return {
                data_compra: new Date(),
                cliente_fornecedor_id: 0,
                numero_documento: '',
                estoque: [
                    // {
                    //     id: 1,
                    //     produto_id: 0,
                    //     valor_pago: 0,
                    //     quantidade: '',
                    //     unidade_medida_id: 0,
                    //     data_vencimento: new Date()
                    // }
                ]
            };
        }

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.EstoqueInsumoSemente150.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoSemente150
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function get(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoSemente150.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                // console.log(response);
            });

            return deferred.promise;
        }

        function getEstoqueInsumo(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoSemente150
                .getEstoqueInsumo({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function getFornecedores() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
                categoria: 'insumo'
            };

            cadastrosFornecedorService
                .query(args)
                .then(function (response) {
                    deferred.resolve(response.data.cliente_fornecedor);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function getAllInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'semente',
                per_page: 1000
            };

            api.EstoqueInsumo
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'semente'
            };

            api.EstoqueInsumoTodos
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getUnidadesMedidas() {

            var deferred = $q.defer();

            var unidades_medidas = [
                { id: 1, tipo_medida_id: 1, nome: 'miligrama', sigla: 'mg' },
                { id: 2, tipo_medida_id: 1, nome: 'grama', sigla: 'g' },
                { id: 3, tipo_medida_id: 1, nome: 'quilograma', sigla: 'kg' },
                //{ id: 4, tipo_medida_id: 1, nome: 'Tonelada', sigla: 'T' },

                { id: 5, tipo_medida_id: 2, nome: 'mililitro', sigla: 'ml' },
                { id: 6, tipo_medida_id: 2, nome: 'litro', sigla: 'L' },

                { id: 7, tipo_medida_id: 3, nome: 'Unidade', sigla: 'un' }
            ];

            //tipo_medida_id:  1-Peso  | 2-Líquido

            deferred.resolve(unidades_medidas)

            return deferred.promise;
        }


        function deletarCusto(id) {

            // Create a new deferred object
            var deferred = $q.defer();

            var args = {
                id: id
            };

            api.EstoqueInsumoRateio
                .delete(args).$promise
                .then(function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function searchProperties() {

            var deferred = $q.defer();

            var args = {};

            api.Propriedade
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryRateio(estoqueInsumoId, insumoId, unidadeMedidaId) {
            var deferred = $q.defer();

            var args = {
                estoqueInsumoId: estoqueInsumoId,
                insumoId: insumoId,
                unidadeMedidaId: unidadeMedidaId
            };

            api.EstoqueInsumoRateio
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }

        function getRateio(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoRateio150
                .get({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function createAcerto(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoSemente150
                .acerto(model).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryHistoricoCompra(args) {
            var deferred = $q.defer();

            api.EstoqueInsumoHistorico
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
         .module('app.estoque_insumo.semente')
         .controller('VisualizarEstoqueInsumoSementeController', VisualizarEstoqueInsumoSementeController)

    /** @ngInject */
    function VisualizarEstoqueInsumoSementeController($state, model) {
         var vm = this;
         // Data
         vm.model = model;

         vm.gotoSearch = gotoSearch;

         init();

         function init() {
          }

          function gotoSearch() {
               $state.go('app.estoque_insumo.semente.buscar');
          }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente')
        .controller('RateioEstoqueInsumoSementeController', RateioEstoqueInsumoSementeController)

    /** @ngInject */
    function RateioEstoqueInsumoSementeController($scope, $state, model) {
        var vm = this;
        // Data
        vm.model = model;

        vm.gotoSearch = gotoSearch;

        init();

        function init() {
        }

        function gotoSearch() {
            javascript:history.back(1);
       }
    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente')
        .controller('historicoEstoqueInsumoSementeController', HistoricoEstoqueInsumoSementeController);

    /** @ngInject */
    function HistoricoEstoqueInsumoSementeController(estoque_insumo, $state, $stateParams, estoqueInsumoSementeService, $mdDialog, $scope, cliente, $mdToast) {
        var vm = this;

        // Data
        vm.cliente = cliente;
        vm.models = [];
        vm.estoque_insumo = estoque_insumo;

        vm.gotoSearch = gotoSearch;
        vm.gotoVisualizarRateio = gotoVisualizarRateio;
        vm.search = search;
        vm.deletar = deletar;
        vm.deletarConfirm = deletarConfirm;

        function init() {
            //vm.estoque_insumo.unidade_medida = unidadeMedida(vm.estoque_insumo);
        }


        init();


        function search() {

            // vm.loadingProgress = true;

            // estoqueInsumoSementeService.queryHistoricoCompra(vm.estoque_insumo.insumo.id)
            //     .then(function successCallback(response) {
            //         vm.models = response.data;
            //         // vm.args.PropriedadeId = vm.propriedades[0].id;
            //     }).finally(function () {
            //         vm.loadingProgress = false;
            //     });
        }
        // search();

        /// Query
        vm.args = {
            id: vm.estoque_insumo.insumo.id,
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            estoqueInsumoSementeService.queryHistoricoCompra(vm.args)
                .then(function successCallback(response) {
                    vm.models = response.data;

                    vm.models = formatarModels(response.data);

                    // vm.total_cost = response.total_cost;
                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();

                }).finally(function () {
                    vm.args.loading = false;
                });
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar insumo?')
                .textContent('Tem certeza que deseja deletar esse insumo?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoSementeService.deletarCusto(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Insumo deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoSearch(id) {
            $state.go('app.estoque_insumo.semente.buscar', {
                id: id
            });
        }

        function gotoVisualizarRateio(id) {
            $state.go('app.estoque_insumo.semente.rateio', {
                id: id
            });
        }

        function unidadeMedida(model) {
            // , descricao: 'Mg (Miligrama)', formatado: input + ' mg'
            var estoque_insumo = unidadeMedidaFormat(model.quantidade, model.tipo_medida)

            return {
                quantidade: estoque_insumo.quantidade,
                sigla: estoque_insumo.sigla,
                nome: estoque_insumo.nome,
                descricao: estoque_insumo.sigla + " (" + estoque_insumo.nome + ")",
                formatado: estoque_insumo.quantidade + " " + estoque_insumo.sigla
            }
        }

        function unidadeMedidaFormat(input, tipo_medida) {

            if (tipo_medida == undefined)
                return { quantidade: input, sigla: '', nome: '' }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return { quantidade: input, sigla: 'mg', nome: 'Miligrama' }

                    if (input < 1000000)
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'g', nome: 'Grama' }

                    if (input < 1000000000)
                        return { quantidade: convertToDecimalCase((input / 1000000), 2), sigla: 'kg', nome: 'Quilograma' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000000000), 2), sigla: 'T', nome: 'Tonelada' }

                case 2: // Líquido

                    if (input < 1000)
                        return { quantidade: input, sigla: 'ml', nome: 'Mililitro' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'Litros', nome: 'Litros' }

                case 3: // Unidade
                    return { quantidade: input, sigla: 'un', nome: 'Unidade' }

                default:
                    return { quantidade: input, sigla: 'ml', nome: tipo_medida.nome }
            }
        }

        function convertToDecimalCase(number, decimal) {
            var n = parseFloat(number);

            if (Number.isInteger(n)) {
                return n;
            }
            else {
                if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                    return parseInt(number);

                return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            }
        }

        function formatarModels(data) {

            var retorno = [];

            for (var index = 0; index < data.length; index++) {
                var model = data[index];

                model.valor_pago = model.estoque_insumo_rateio.valor / model.estoque_insumo_rateio.quantidade_origem * Math.abs(model.quantidade);
                if(model.valor_pago < 0.01){
                    model.valor_pago = 0.01;
                }

                if (model.estoque_insumo_lancamento_tipo.id == 2) {
                    model.tipo_acerto = (model.quantidade > 0) ? 'Acerto - Acrescentado' : 'Acerto - Retirado';
                } else {
                    model.tipo_acerto = model.estoque_insumo_lancamento_tipo.descricao
                }


                retorno.push(model);
            }

            return retorno;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente')
        .controller('CriarEstoqueInsumoSementeController', CriarEstoqueInsumoSementeController)
        .controller('CriarLojaController', CriarLojaController)
        .controller('CriarCadastroInsumoSementeController', CriarCadastroInsumoSementeController)


    /** @ngInject */
    function CriarEstoqueInsumoSementeController($rootScope, $scope, $stateParams, $state, $filter, estoqueInsumoSementeService, fornecedores, insumos, $mdDialog, $mdToast, model) {
        var vm = this;

        // Data
        vm.model = model;
        vm.api_response_erro = {};

        vm.fornecedores = fornecedores;
        vm.insumos = insumos;

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.gotoLojaFornecedor = gotoLojaFornecedor;
        vm.gotoCadastroInsumo = gotoCadastroInsumo;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.showConfirm = showConfirm;
        vm.addInsumo = addInsumo;
        vm.removeInsumo = removeInsumo;
        vm.changeInsumo = changeInsumo;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        vm.showDialogCreateMarketplace = showDialogCreateMarketplace;
        vm.showDialogCreateInsumo = showDialogCreateInsumo;
        //////////


        init();

        function init() {

            addInsumo();

            vm.date = new Date();
        }

        function save(form, confirmType) {

            if (form.$invalid) {
                return;
            }

            $rootScope.loadingProgress = true;

            estoqueInsumoSementeService
                .create(vm.model)
                .then(function (response) {
                    $rootScope.loadingProgress = false;
                    // vm.model.id = response.id;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Estoque criado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    (confirmType == 'Y')?gotoAdd():gotoSearch();
                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }

        function showConfirm(form) {

            if (form.$invalid) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title('Atenção')
                .textContent('Gostaria de salvar um novo insumo no estoque?')
                .targetEvent(form)
                .ok('Sim, gostaria')
                .cancel('Não, não gostaria');

          $mdDialog
                .show(confirm)
                .then(function () {
                    save(form, 'Y')
                }, function () {
                    save(form, 'N')
                });
        };

        function gotoAdd() {
          $state.go('app.estoque_insumo.semente.criar', {
              propriedade: vm.model.propriedade_Id
          });
        }

        function gotoSearch() {
            $state.go('app.estoque_insumo.semente.buscar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function gotoLojaFornecedor() {
            $state.go('app.cadastros.fornecedor.buscar');
        }

        function gotoCadastroInsumo() {
            $state.go('app.estoque_insumo.cadastro_insumo.criar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }

        function addInsumo() {

            var insumo = { id: 0 };

            if (vm.insumos.length > 0) {
                insumo = vm.insumos[0]
            }

            vm.model.estoque.push({
                id: vm.model.estoque.length + 1,
                insumo: insumo,
                valor_pago: 0,
                quantidade: '',
                data_vencimento: undefined
            });
        }

        function removeInsumo(index) {
            vm.model.estoque.splice(index, 1);

            reorganizarIndexSementes();
        }

        function reorganizarIndexSementes() {

            for (var index = 0; index < vm.model.estoque.length; index++) {
                vm.model.estoque[index].id = index + 1;
            }
        }

        function changeInsumo(semente) {

            changeQuantidadeOuUnidadeDeMedida(semente)
        }

        function changeQuantidadeOuUnidadeDeMedida(semente) {

            semente.tipo_medida_id = semente.insumo.tipo_medida.id

            if (semente.insumo != undefined)
                semente.insumo_id = semente.insumo.id

            semente.valor = semente.valor_pago;

            // $scope.$apply();
            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }

        }

        function showDialogCreateMarketplace(ev, lista_detalhes) {

            $mdDialog.show({
                controller: 'CriarLojaController as vm',
                templateUrl: 'app/main/estoque_insumo/semente/views/criar_loja.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.fornecedores.push(answer);
                        vm.model.cliente_fornecedor_id = answer.id;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }

        function showDialogCreateInsumo(ev, semente) {

            $mdDialog.show({
                controller: 'CriarCadastroInsumoSementeController as vm',
                templateUrl: 'app/main/estoque_insumo/semente/views/criar_insumo.tmpl.html',
                resolve: {
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    },
                    tipo_medida: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoMedida();
                    }
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {

                    if (answer && answer.insumo_tipo_id == 4) {
                        vm.insumos.push(answer);
                        semente.insumo = answer;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }


        // function initPropriedade() {
        //     for (let index = 0; index < vm.all_propriedades.length; index++) {

        //         const element = vm.all_propriedades[index];

        //         vm.propriedades.push({
        //             id: element.id,
        //             nome: element.nome
        //         });
        //     }
        // }

        // function initPropriedadeAreas() {
        //     for (let index = 0; index < vm.areas.length; index++) {

        //         const element = vm.areas[index];

        //         vm.propriedade_areas.push({
        //             propriedade_area_id: element.id,
        //             propriedade_area_nome: element.nome,
        //             propriedade_id: element.propriedade.id,
        //             propriedade_nome: element.propriedade.nome
        //         });
        //     }
        // }
    }

    function CriarLojaController($rootScope, $scope, $state, $filter, cadastrosFornecedorService, $mdToast, $mdDialog) {


        var vm = this;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        init();

        function init() {
            console.log('Criar loja SEMENTE');
            vm.model.pessoa_tipo = {
                id: 1
            }
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            var message = '';
            this.savePromise = cadastrosFornecedorService.create(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdDialog.hide(vm.model);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('FORNECEDOR.FORNECEDOR_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $mdDialog.hide();
        }


    }

    function CriarCadastroInsumoSementeController($rootScope, $scope, $state, $filter, cadastrosCadastroInsumoService, areaService, tipo_medida, tipo_insumo, $q, $mdToast, $mdDialog) {


        var vm = this;

        // Data
        vm.model = {
            insumo_tipo_id: 4
        };
        vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        vm.tipo_insumo = tipo_insumo;
        vm.defensivos = [];
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.culturaSearch = culturaSearch;
        vm.listaAgrofitSearch = listaAgrofitSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.changeInsumoTipo = changeInsumoTipo;
        vm.save = save;
        //////////

        init();

        function init() {
            // autoSelectTipoMedida();
            // autoSelectTipoInsumo();

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            // Força o tipo de insumo para semente.
            vm.model.insumo_tipo_id = 4;
            vm.model.cultura_id = vm.model.cultura.id;
            // Força o tipo de medida PESO
            vm.model.tipo_medida_id = 1;

            var model = {
                estoque_insumo: [
                    vm.model
                ]
            }

            var message = '';
            this.savePromise = cadastrosCadastroInsumoService.create(model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.data[0].id;

                $mdDialog.hide({
                    id: vm.model.id,
                    nome: vm.model.nome,
                    insumo_tipo_id: vm.model.insumo_tipo_id,
                    tipo_medida_id: vm.model.tipo_medida_id,
                    tipo_medida: {
                        id: vm.model.tipo_medida_id,
                        descricao: response.data[0].unidade_medida
                    }
                });

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = response.data.data.errors;
                }

                vm.api_response_erro = response;
            });
        }

        function autoSelectTipoMedida() {

            if (vm.tipo_medida != undefined && vm.tipo_medida.length > 0)
                vm.model.tipo_medida_id = vm.tipo_medida[0].id;
        }

        function autoSelectTipoInsumo() {

            if (vm.tipo_insumo != undefined && vm.tipo_insumo.length > 0)
                vm.model.insumo_tipo_id = vm.tipo_insumo[0].id;
        }

        function changeInsumoTipo() {
            vm.model.insumo_agricola_id = undefined;

            if (vm.model.insumo_tipo_id == 4)
                vm.model.tipo_medida_id = 3;
            else
                if (vm.model.tipo_medida_id == 3)
                    vm.model.tipo_medida_id = 1;

            vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        }

        function listaAgrofitSearch(query) {

            var deferred = $q.defer();

            var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
            promisse.then(function (response) {

                vm.defensivos = response.data;
                let retorno = [];

                for (let index = 0; index < response.data.length; index++) {
                    const element = response.data[index];
                    retorno.push(element.nome);
                }

                deferred.resolve(retorno)

            }).finally(function () {

            });

            return deferred.promise;
        }

        function culturaSearch(query) {

            var retorno = areaService.getCulturas(query);
            return retorno;
        }

        function selectedItemChange(nome) {

            if (nome == undefined) {
                vm.model.insumo_agricola_id = undefined;
                return;
            }

            let item = vm.defensivos.filter(function (obj) {
                return obj.nome == nome
            });

            vm.model.insumo_agricola_id = item[0].id;
        }

        function getTipoMedida(tipoInsumo) {

            var tipo_insumo = [];

            if (tipoInsumo == 4) {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
               //  tipo_insumo.push({ id: 3, nome: 'Unidade' });
            } else {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 2, nome: 'L' });
            }

            return tipo_insumo;
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }
})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente')
        .controller('BuscarEstoqueInsumoSementeController', BuscarEstoqueInsumoSementeController);

    /** @ngInject */
    function BuscarEstoqueInsumoSementeController(data, $state, $stateParams, estoqueInsumoSementeService, propriedades, fornecedores, insumos, $mdDialog, $scope, $mdToast, $filter) {
        var vm = this;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        vm.total_cost = 0;
        vm.propriedades = propriedades;
        vm.fornecedores = fornecedores;
        vm.insumos = insumos;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoAdd = gotoAdd;
        vm.gotoHistory = gotoHistory;
        vm.gotoAcerto = gotoAcerto;
        vm.search = search;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;
        vm.isDetailOpened = false;
        vm.openDetail = openDetail;
        vm.closeDetail = closeDetail;
        vm.viewTutorial = viewTutorial;
        vm.agrupados = [];

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;

        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
        ];

        vm.model = {
            dataInicio: new Date(),
            dataFim: new Date()
        }


        function init() {

               periodoActive.classList.add("select-active");

               if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();

            // vm.search();
        }
        init();

        function search() {

            vm.loadingProgress = true;
            estoqueInsumoSementeService.query()
                .then(function successCallback(data) {
                    vm.models = data;

                    if ($stateParams.propriedade)
                        vm.args.Propriedade_Id = $stateParams.propriedade
                    else
                        vm.args.Propriedade_Id = vm.propriedades[0].id

                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: "id",
            sort_order: "desc",
            //Propriedade_Id: selectPropriedade(),
            Fornecedor_id: null,
            insumo_id: null,
            numero_documento: "",
            compra_de: null,
            periodo: 30,
            compra_ate: null,
            _change: change
        }

        vm.args._change();

        function change() {

            closeAllDetail();

            vm.args.loading = true;
            estoqueInsumoSementeService.query(vm.args).then(function (response) {
                vm.models = response.data.estoques_insumo_model;

                // vm.total_cost = response.total_cost;
                vm.args.total_rows = response.data.total_itens;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();



            }).finally(function () {
                vm.args.loading = false;
            });
        }


        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogTutorialCtrl,
                 templateUrl: 'app/main/estoque_insumo/semente/views/tutorial.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogTutorialCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function clearPreDate() {
            vm.args.periodo = null
        }

        function clearRangeDate() {
            vm.args.compra_de = null
            vm.args.compra_ate = null
        }

        function resetFilters() {
            vm.args.Fornecedor_id = null;
            vm.args.insumo_id = null;
            vm.args.periodo = 30;
            vm.args.compra_de = null;
            vm.args.compra_ate = null;
            periodoActive.classList.add("select-active");
            datapickerActive.classList.remove("dates-active");
            vm.activeFilters = null;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.compra_de,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.compra_ate,'dd/MM/yyyy');
          let fornecedores = vm.fornecedores;
          let fornecedorNome;
          let insumos = vm.insumos;
          let insumoNome;
          let counter = 0;
          for (let i = 0; i < vm.periods.length; i++) {
               if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
               };
          }
          for (let i = 0; i < fornecedores.length; i++) {
               if (fornecedores[i].id == vm.args.Fornecedor_id) {
                    fornecedorNome = fornecedores[i].nome
               };
          }
          for (let i = 0; i < insumos.length; i++) {
               if (insumos[i].id == vm.args.insumo_id) {
                    insumoNome = insumos[i].nome
               };
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: fornecedorNome,
                    value: 'Fornecedor_id'
               },
               {
                    description: insumoNome,
                    value: 'insumo_id'
               },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.compra_de = null;
               vm.args.compra_ate = null;
               datapickerActive.classList.remove("dates-active");
          } else if(value == 'periodo'){
               periodoActive.classList.remove("select-active");
          }
          vm.args[value] = null;
          change();
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar rateio?')
                .textContent('Tem certeza que deseja deletar esse rateio?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoSementeService.deletarCusto(model.id)
                .then(function (response) {

                    vm.agrupados.splice(vm.agrupados.indexOf(model), 1);

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Rateio deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {

                    var msgErro = 'Não foi possível deletar o rateio. Tente novamente.';

                    if (response.data.status == 422 && response.data.detail != undefined && response.data.detail != '')
                        msgErro = response.data.detail;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msgErro)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

        function gotoVisualizar(id) {
            $state.go('app.estoque_insumo.semente.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.estoque_insumo.semente.criar', {
                propriedade: vm.args.Propriedade_Id
            });
        }

        function gotoHistory(id) {
            $state.go('app.estoque_insumo.semente.historico', {
                id: id
            });
        }
        function gotoAcerto(id) {
            $state.go('app.estoque_insumo.semente.acerto', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');
            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        function openDetail(model) {

            vm.isDetailOpened = true;
            model.isOpen = true;

            consultarDatails(model)
        }

        function closeDetail(model) {

            vm.isDetailOpened = false;
            model.isOpen = false;

        }

        function closeAllDetail() {

            if (!vm.isDetailOpened)
                return;

            for (var index = 0; index < vm.models.length; index++) {
                var model = vm.models[index];

                model.isOpen = false
            }
            vm.isDetailOpened = false;
        }



        function consultarDatails(model) {
            model.isLoading = true;

            estoqueInsumoSementeService
                .queryRateio(model.id, model.insumo_id, model.tipo_medida.id)
                .then(function (response) {

                    vm.agrupados = response;

                }).finally(function () {

                    model.isLoading = false;

                    if (vm.agrupados == undefined)
                        vm.agrupados = [];

                    if (!$scope.$$phase) {
                        //$digest or $apply
                        $scope.$apply();
                    }
                });
        }

        function selectPropriedade() {

            if ($stateParams.propriedade != undefined && $stateParams.propriedade != '')
                return $stateParams.propriedade;

            if (vm.propriedades != undefined && vm.propriedades.length > 0)
                return vm.propriedades[0].id;
            else
                return undefined;
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               periodoActive.classList.add("select-active");
               datapickerActive.classList.remove("dates-active");
          }
          function openDatasSelect(){
               datapicker.style.display = "block";
          }
          function selecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               datapickerActive.classList.add("dates-active");
               periodoActive.classList.remove("select-active");
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               datapickerActive.classList.remove("dates-active");
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.semente')
        .controller('AcertoEstoqueInsumoSementeController', AcertoEstoqueInsumoSementeController)


    /** @ngInject */
    function AcertoEstoqueInsumoSementeController($rootScope, $scope, $state, $filter, estoqueInsumoSementeService, estoque_insumo, $mdDialog, $mdToast) {
        var vm = this;

        // Data
        vm.model = {
            estoque_rateio_id: estoque_insumo.id,
            estoque_tipo_id: 1
        };
        vm.api_response_erro = {};

        vm.estoque_insumo_rateio = estoque_insumo;
        vm.tipos = [{ id: 1, nome: "Acerto" }, { id: 2, nome: "Perda" }];

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.changeTipoAcerto = changeTipoAcerto;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = estoqueInsumoSementeService.createAcerto(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Acerto criado com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = {
                        quantidade: [response.data.detail]
                    };
                }

                vm.api_response_erro = response;
            });
        }


        function gotoSearch() {
            $state.go('app.estoque_insumo.semente.buscar');
        }

        function getTipoAcertoEnum(model) {
            if (model.tipo.id == 2) {
                return 'Perda';
            } else {
                if (model.estoque_tipo_id == 1) {
                    return 'Acerto_Acrescentar';
                } else {
                    return 'Acerto_Remover';
                }
            }
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }


        function changeTipoAcerto() {
            if (vm.model.tipo.id == 1 && vm.model.estoque_tipo_id == undefined)
                vm.model.estoque_tipo_id = 1;

            vm.model.tipo_acerto = getTipoAcertoEnum(vm.model);
        }

        function changeQuantidadeOuUnidadeDeMedida() {

            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.estoque_insumo.fertilizante', {
                abstract: true,
                url: '/fertilizante'
            })
            .state('app.estoque_insumo.fertilizante.buscar', {
                url: '/buscar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/fertilizante/views/buscar.html',
                        controller: 'BuscarEstoqueInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    propriedades: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.searchProperties();
                    },
                    data: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.query();
                    },
                    fornecedores: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getInsumos();
                    }
                }
            })
            .state('app.estoque_insumo.fertilizante.criar', {
                url: '/criar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/fertilizante/views/criar.html',
                        controller: 'CriarEstoqueInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    model: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getNew();
                    },
                    fornecedores: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getAllInsumos();
                    },
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    }
                }
            })
            .state('app.estoque_insumo.fertilizante.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/fertilizante/views/visualizar.html',
                        controller: 'VisualizarEstoqueInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.get($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.fertilizante.historico', {
                url: '/historico/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/fertilizante/views/historico.html',
                        controller: 'historicoEstoqueInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    estoque_insumo: function ($stateParams, estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getEstoqueInsumo($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })
            .state('app.estoque_insumo.fertilizante.acerto', {
                url: '/acerto/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/fertilizante/views/acerto.html',
                        controller: 'AcertoEstoqueInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    estoque_insumo: function ($stateParams, estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getRateio($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.fertilizante.rateio', {
                url: '/rateio/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/fertilizante/views/rateio.html',
                        controller: 'RateioEstoqueInsumoFertilizanteController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoFertilizanteService) {
                        return estoqueInsumoFertilizanteService.getRateio($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })

        $translatePartialLoaderProvider.addPart('app/main/estoque_insumo/fertilizante');

        msNavigationServiceProvider.saveItem('estoque_insumo.gestao.fertilizante', {
            title: 'Fertilizante',
            state: 'app.estoque_insumo.fertilizante.buscar',
            weight: 2
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante')
        .factory('estoqueInsumoFertilizanteService', estoqueInsumoFertilizanteService);

    /** @ngInject */
    function estoqueInsumoFertilizanteService($q, api, cadastrosFornecedorService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,

            query150: query150,
            queryRateio150: queryRateio150,

            getNew: getNew,
            get: get,
            create: create,

            queryRateio: queryRateio,
            getRateio: getRateio,
            createAcerto: createAcerto,

            queryHistoricoCompra: queryHistoricoCompra,
            getEstoqueInsumo: getEstoqueInsumo,

            deletarCusto: deletarCusto,
            searchProperties: searchProperties,

            getUnidadesMedidas: getUnidadesMedidas,
            getInsumos: getInsumos,
            getAllInsumos: getAllInsumos,
            getFornecedores: getFornecedores
        };

        return service;

        function getNew() {
            return {
                data_compra: new Date(),
                cliente_fornecedor_id: 0,
                numero_documento: '',
                estoque: [
                    // {
                    //     id: 1,
                    //     produto_id: 0,
                    //     valor_pago: 0,
                    //     quantidade: '',
                    //     unidade_medida_id: 0,
                    //     data_vencimento: new Date()
                    // }
                ]
            };
        }

          function query150(args, cache) {
               var deferred = $q.defer();
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;
               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.EstoqueInsumoFertilizante150.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              queryResponse = response;
                              deferred.resolve(response);
                         }
                    ).catch(function (response) {
                         deferred.reject(response);
                    });
               }
               return deferred.promise;
          }
          function queryRateio150(estoqueInsumoId, insumoId, unidadeMedidaId) {
               var deferred = $q.defer();
               var args = {
                   estoqueInsumoId: estoqueInsumoId,
                   insumoId: insumoId,
                   unidadeMedidaId: unidadeMedidaId
               };
               api.EstoqueInsumoRateio150
                   .query(args).$promise
                   .then(function (response) {
                       deferred.resolve(response.data);
                   }).catch(function (response) {
                       deferred.reject(response);
                   });
               return deferred.promise;
           }

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.EstoqueInsumoFertilizante150.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoFertilizante150
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function get(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoFertilizante150.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                // console.log(response);
            });

            return deferred.promise;
        }

        function getEstoqueInsumo(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoFertilizante150
                .getEstoqueInsumo({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function getFornecedores() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
                categoria: 'insumo'
            };

            cadastrosFornecedorService
                .query(args)
                .then(function (response) {
                    deferred.resolve(response.data.cliente_fornecedor);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function getAllInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'fertilizante',
                per_page: 1000
            };

            api.EstoqueInsumo
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'fertilizante'
            };

            api.EstoqueInsumoTodos
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getUnidadesMedidas() {

            var deferred = $q.defer();

            var unidades_medidas = [
                { id: 1, tipo_medida_id: 1, nome: 'miligrama', sigla: 'mg' },
                { id: 2, tipo_medida_id: 1, nome: 'grama', sigla: 'g' },
                { id: 3, tipo_medida_id: 1, nome: 'quilograma', sigla: 'kg' },
                { id: 4, tipo_medida_id: 1, nome: 'Tonelada', sigla: 'T' },

                { id: 5, tipo_medida_id: 2, nome: 'mililitro', sigla: 'ml' },
                { id: 6, tipo_medida_id: 2, nome: 'litro', sigla: 'L' },

                { id: 7, tipo_medida_id: 3, nome: 'Unidade', sigla: 'un' }
            ];

            //tipo_medida_id:  1-Peso  | 2-Líquido

            deferred.resolve(unidades_medidas)

            return deferred.promise;
        }


        function deletarCusto(id) {

            // Create a new deferred object
            var deferred = $q.defer();

            var args = {
                id: id
            };

            api.EstoqueInsumoRateio
                .delete(args).$promise
                .then(function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function searchProperties() {

            var deferred = $q.defer();

            var args = {};

            api.Propriedade
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryRateio(estoqueInsumoId, insumoId, unidadeMedidaId) {
            var deferred = $q.defer();

            var args = {
                estoqueInsumoId: estoqueInsumoId,
                insumoId: insumoId,
                unidadeMedidaId: unidadeMedidaId
            };

            api.EstoqueInsumoRateio
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }

        function getRateio(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoRateio150
                .get({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function createAcerto(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoFertilizante150
                .acerto(model).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryHistoricoCompra(args) {
            var deferred = $q.defer();

            api.EstoqueInsumoHistorico
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
         .module('app.estoque_insumo.fertilizante')
         .controller('VisualizarEstoqueInsumoFertilizanteController', VisualizarEstoqueInsumoFertilizanteController)

    /** @ngInject */
    function VisualizarEstoqueInsumoFertilizanteController($state, model) {
         var vm = this;
         // Data
         vm.model = model;

         vm.gotoSearch = gotoSearch;

         init();

         function init() {
          }

          function gotoSearch() {
               $state.go('app.estoque_insumo.fertilizante.buscar');
          }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante')
        .controller('RateioEstoqueInsumoFertilizanteController', RateioEstoqueInsumoFertilizanteController)

    /** @ngInject */
    function RateioEstoqueInsumoFertilizanteController($scope, $state, model) {
        var vm = this;
        // Data
        vm.model = model;

        vm.gotoSearch = gotoSearch;

        init();

        function init() {
        }

        function gotoSearch() {
            javascript:history.back(1);
       }
    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante')
        .controller('historicoEstoqueInsumoFertilizanteController', HistoricoEstoqueInsumoFertilizanteController);

    /** @ngInject */
    function HistoricoEstoqueInsumoFertilizanteController(estoque_insumo, $state, $stateParams, estoqueInsumoFertilizanteService, $mdDialog, $scope, cliente, $mdToast) {
        var vm = this;

        // Data
        vm.cliente = cliente;
        vm.models = [];
        vm.estoque_insumo = estoque_insumo;

        vm.gotoSearch = gotoSearch;
        vm.gotoVisualizarRateio = gotoVisualizarRateio;
        vm.search = search;
        vm.deletar = deletar;
        vm.deletarConfirm = deletarConfirm;

        function init() {
            //vm.estoque_insumo.unidade_medida = unidadeMedida(vm.estoque_insumo);
        }


        init();


        function search() {

            // vm.loadingProgress = true;

            // estoqueInsumoFertilizanteService.queryHistoricoCompra(vm.estoque_insumo.insumo.id)
            //     .then(function successCallback(response) {
            //         vm.models = response.data;
            //         // vm.args.PropriedadeId = vm.propriedades[0].id;
            //     }).finally(function () {
            //         vm.loadingProgress = false;
            //     });
        }
        // search();

        /// Query
        vm.args = {
            id: vm.estoque_insumo.insumo.id,
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            estoqueInsumoFertilizanteService.queryHistoricoCompra(vm.args)
                .then(function successCallback(response) {
                    vm.models = response.data;

                    vm.models = formatarModels(response.data);

                    // vm.total_cost = response.total_cost;
                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();

                }).finally(function () {
                    vm.args.loading = false;
                });
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar insumo?')
                .textContent('Tem certeza que deseja deletar esse insumo?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoFertilizanteService.deletarCusto(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Insumo deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoSearch(id) {
            $state.go('app.estoque_insumo.fertilizante.buscar', {
                id: id
            });
        }

        function gotoVisualizarRateio(id) {
            $state.go('app.estoque_insumo.fertilizante.rateio', {
                id: id
            });
        }

        function unidadeMedida(model) {
            // , descricao: 'Mg (Miligrama)', formatado: input + ' mg'
            var estoque_insumo = unidadeMedidaFormat(model.quantidade, model.tipo_medida)

            return {
                quantidade: estoque_insumo.quantidade,
                sigla: estoque_insumo.sigla,
                nome: estoque_insumo.nome,
                descricao: estoque_insumo.sigla + " (" + estoque_insumo.nome + ")",
                formatado: estoque_insumo.quantidade + " " + estoque_insumo.sigla
            }
        }

        function unidadeMedidaFormat(input, tipo_medida) {

            if (tipo_medida == undefined)
                return { quantidade: input, sigla: '', nome: '' }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return { quantidade: input, sigla: 'mg', nome: 'Miligrama' }

                    if (input < 1000000)
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'g', nome: 'Grama' }

                    if (input < 1000000000)
                        return { quantidade: convertToDecimalCase((input / 1000000), 2), sigla: 'kg', nome: 'Quilograma' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000000000), 2), sigla: 'T', nome: 'Tonelada' }

                case 2: // Líquido

                    if (input < 1000)
                        return { quantidade: input, sigla: 'ml', nome: 'Mililitro' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'Litros', nome: 'Litros' }

                case 3: // Unidade
                    return { quantidade: input, sigla: 'un', nome: 'Unidade' }

                default:
                    return { quantidade: input, sigla: 'ml', nome: tipo_medida.nome }
            }
        }

        function convertToDecimalCase(number, decimal) {
            var n = parseFloat(number);

            if (Number.isInteger(n)) {
                return n;
            }
            else {
                if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                    return parseInt(number);

                return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            }
        }

        function formatarModels(data) {

            var retorno = [];

            for (var index = 0; index < data.length; index++) {
                var model = data[index];

                model.valor_pago = model.estoque_insumo_rateio.valor / model.estoque_insumo_rateio.quantidade_origem * Math.abs(model.quantidade);
                if(model.valor_pago < 0.01){
                    model.valor_pago = 0.01;
                }

                if (model.estoque_insumo_lancamento_tipo.id == 2) {
                    model.tipo_acerto = (model.quantidade > 0) ? 'Acerto - Acrescentado' : 'Acerto - Retirado';
                } else {
                    model.tipo_acerto = model.estoque_insumo_lancamento_tipo.descricao
                }


                retorno.push(model);
            }

            return retorno;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante')
        .controller('CriarEstoqueInsumoFertilizanteController', CriarEstoqueInsumoFertilizanteController)
        //.controller('CriarLojaController', CriarLojaController) // ver criar.controller em semente
        .controller('CriarCadastroInsumoFertilizanteController', CriarCadastroInsumoFertilizanteController)


    /** @ngInject */
    function CriarEstoqueInsumoFertilizanteController($rootScope, $scope, $state, $filter, estoqueInsumoFertilizanteService, fornecedores, insumos, $mdDialog, $mdToast, model) {
        var vm = this;

        // Data
        vm.model = model;
        vm.api_response_erro = {};

        vm.fornecedores = fornecedores;
        vm.insumos = insumos;

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.gotoLojaFornecedor = gotoLojaFornecedor;
        vm.gotoCadastroInsumo = gotoCadastroInsumo;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.showConfirm = showConfirm;
        vm.addInsumo = addInsumo;
        vm.removeInsumo = removeInsumo;
        vm.changeInsumo = changeInsumo;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        vm.showDialogCreateMarketplace = showDialogCreateMarketplace;
        vm.showDialogCreateInsumo = showDialogCreateInsumo;
        //////////


        init();

        function init() {

            addInsumo();

            vm.date = new Date();
        }

        function save(form, confirmType) {

            if (form.$invalid) {
                return;
            }

            $rootScope.loadingProgress = true;

            estoqueInsumoFertilizanteService
                .create(vm.model)
                .then(function (response) {
                    $rootScope.loadingProgress = false;
                    // vm.model.id = response.id;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Estoque criado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    (confirmType == 'Y')?gotoAdd():gotoSearch();
                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }

        function showConfirm(form) {

            if (form.$invalid) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title('Atenção')
                .textContent('Gostaria de salvar um novo insumo no estoque?')
                .targetEvent(form)
                .ok('Sim, gostaria')
                .cancel('Não, não gostaria');

          $mdDialog
                .show(confirm)
                .then(function () {
                    save(form, 'Y')
                }, function () {
                    save(form, 'N')
                });
        };

        function gotoAdd() {
          $state.go('app.estoque_insumo.fertilizante.criar', {
              propriedade: vm.model.propriedade_Id
          });
        }

        function gotoSearch() {
            $state.go('app.estoque_insumo.fertilizante.buscar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function gotoLojaFornecedor() {
            $state.go('app.cadastros.fornecedor.buscar');
        }

        function gotoCadastroInsumo() {
            $state.go('app.estoque_insumo.cadastro_insumo.criar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }

        function addInsumo() {

            var insumo = { id: 0 };

            if (vm.insumos.length > 0) {
                insumo = vm.insumos[0]
            }

            vm.model.estoque.push({
                id: vm.model.estoque.length + 1,
                insumo: insumo,
                valor_pago: 0,
                quantidade: '',
                data_vencimento: undefined
            });
        }

        function removeInsumo(index) {
            vm.model.estoque.splice(index, 1);

            reorganizarIndexFertilizantes();
        }

        function reorganizarIndexFertilizantes() {

            for (var index = 0; index < vm.model.estoque.length; index++) {
                vm.model.estoque[index].id = index + 1;
            }
        }

        function changeInsumo(fertilizante) {

            changeQuantidadeOuUnidadeDeMedida(fertilizante)
        }

        function changeQuantidadeOuUnidadeDeMedida(fertilizante) {

            fertilizante.tipo_medida_id = fertilizante.insumo.tipo_medida.id

            if (fertilizante.insumo != undefined)
                fertilizante.insumo_id = fertilizante.insumo.id

            fertilizante.valor = fertilizante.valor_pago;

            // $scope.$apply();
            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }

        }

        function showDialogCreateMarketplace(ev, lista_detalhes) {

            $mdDialog.show({
                controller: 'CriarLojaController as vm', // em criar.controller semente
                templateUrl: 'app/main/estoque_insumo/fertilizante/views/criar_loja.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.fornecedores.push(answer);
                        vm.model.cliente_fornecedor_id = answer.id;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }

        function showDialogCreateInsumo(ev, fertilizante) {

            $mdDialog.show({
                controller: 'CriarCadastroInsumoFertilizanteController as vm',
                templateUrl: 'app/main/estoque_insumo/fertilizante/views/criar_insumo.tmpl.html',
                resolve: {
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    },
                    tipo_medida: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoMedida();
                    }
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {

                    if (answer && answer.insumo_tipo_id == 3) {
                        vm.insumos.push(answer);
                        fertilizante.insumo = answer;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }


        // function initPropriedade() {
        //     for (let index = 0; index < vm.all_propriedades.length; index++) {

        //         const element = vm.all_propriedades[index];

        //         vm.propriedades.push({
        //             id: element.id,
        //             nome: element.nome
        //         });
        //     }
        // }

        // function initPropriedadeAreas() {
        //     for (let index = 0; index < vm.areas.length; index++) {

        //         const element = vm.areas[index];

        //         vm.propriedade_areas.push({
        //             propriedade_area_id: element.id,
        //             propriedade_area_nome: element.nome,
        //             propriedade_id: element.propriedade.id,
        //             propriedade_nome: element.propriedade.nome
        //         });
        //     }
        // }
    }

    function CriarCadastroInsumoFertilizanteController($rootScope, $scope, $state, $filter, cadastrosCadastroInsumoService, areaService, tipo_medida, tipo_insumo, $q, $mdToast, $mdDialog) {


        var vm = this;

        // Data
        vm.model = {
            insumo_tipo_id: 3
        };
        vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        vm.tipo_insumo = tipo_insumo;
        vm.defensivos = [];
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.culturaSearch = culturaSearch;
        vm.listaAgrofitSearch = listaAgrofitSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.changeInsumoTipo = changeInsumoTipo;
        vm.save = save;
        //////////

        init();

        function init() {
            // autoSelectTipoMedida();
            // autoSelectTipoInsumo();

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            // Força o tipo de insumo para biológico.
            vm.model.insumo_tipo_id = 3;

            var model = {
                estoque_insumo: [
                    vm.model
                ]
            }

            var message = '';
            this.savePromise = cadastrosCadastroInsumoService.create(model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.data[0].id;

                $mdDialog.hide({
                    id: vm.model.id,
                    nome: vm.model.nome,
                    insumo_tipo_id: vm.model.insumo_tipo_id,
                    tipo_medida_id: vm.model.tipo_medida_id,
                    tipo_medida: {
                        id: vm.model.tipo_medida_id,
                        descricao: response.data[0].unidade_medida
                    }
                });

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = response.data.data.errors;
                }

                vm.api_response_erro = response;
            });
        }

        function autoSelectTipoMedida() {

            if (vm.tipo_medida != undefined && vm.tipo_medida.length > 0)
                vm.model.tipo_medida_id = vm.tipo_medida[0].id;
        }

        function autoSelectTipoInsumo() {

            if (vm.tipo_insumo != undefined && vm.tipo_insumo.length > 0)
                vm.model.insumo_tipo_id = vm.tipo_insumo[0].id;
        }

        function changeInsumoTipo() {
            vm.model.insumo_agricola_id = undefined;

            if (vm.model.insumo_tipo_id == 4)
                vm.model.tipo_medida_id = 3;
            else
                if (vm.model.tipo_medida_id == 3)
                    vm.model.tipo_medida_id = 1;

            vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        }

        function listaAgrofitSearch(query) {

            var deferred = $q.defer();

            var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
            promisse.then(function (response) {

                vm.defensivos = response.data;
                let retorno = [];

                for (let index = 0; index < response.data.length; index++) {
                    const element = response.data[index];
                    retorno.push(element.nome);
                }

                deferred.resolve(retorno)

            }).finally(function () {

            });

            return deferred.promise;
        }

        function culturaSearch(query) {

            var retorno = areaService.getCulturas(query);
            return retorno;
        }

        function selectedItemChange(nome) {

            if (nome == undefined) {
                vm.model.insumo_agricola_id = undefined;
                return;
            }

            let item = vm.defensivos.filter(function (obj) {
                return obj.nome == nome
            });

            vm.model.insumo_agricola_id = item[0].id;
        }

        function getTipoMedida(tipoInsumo) {

            var tipo_insumo = [];

            if (tipoInsumo == 4) {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 3, nome: 'Unidade' });
            } else {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 2, nome: 'L' });
            }

            return tipo_insumo;
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }
})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante')
        .controller('BuscarEstoqueInsumoFertilizanteController', BuscarEstoqueInsumoFertilizanteController);

    /** @ngInject */
    function BuscarEstoqueInsumoFertilizanteController(data, $state, $stateParams, estoqueInsumoFertilizanteService, propriedades, fornecedores, insumos, $mdDialog, $scope, $mdToast, $filter) {
        var vm = this;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        vm.total_cost = 0;
        vm.propriedades = propriedades;
        vm.fornecedores = fornecedores;
        vm.insumos = insumos;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoAdd = gotoAdd;
        vm.gotoHistory = gotoHistory;
        vm.gotoAcerto = gotoAcerto;
        vm.search = search;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;
        vm.isDetailOpened = false;
        vm.openDetail = openDetail;
        vm.closeDetail = closeDetail;
        vm.agrupados = [];

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;

        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
        ];

        vm.model = {
            dataInicio: new Date(),
            dataFim: new Date()
        }


        function init() {
               periodoActive.classList.add("select-active");

               if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();

            // vm.search();
        }
        init();

        function search() {

            vm.loadingProgress = true;
            estoqueInsumoFertilizanteService.query()
                .then(function successCallback(data) {
                    vm.models = data;

                    if ($stateParams.propriedade)
                        vm.args.Propriedade_Id = $stateParams.propriedade
                    else
                        vm.args.Propriedade_Id = vm.propriedades[0].id

                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            sort_by: "id",
            sort_order: "desc",
            Propriedade_Id: selectPropriedade(),
            Fornecedor_id: null,
            insumo_id: null,
            numero_documento: "",
            compra_de: null,
            periodo: 30,
            compra_ate: null,
            _change: change
        }

        vm.args._change();

        function change() {

            closeAllDetail();

            vm.args.loading = true;
            estoqueInsumoFertilizanteService.query(vm.args).then(function (response) {
                vm.models = response.data.estoques_insumo_model;

                // vm.total_cost = response.total_cost;
                vm.args.total_rows = response.data.total_itens;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();

            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function clearPreDate() {
            vm.args.periodo = null
        }

        function clearRangeDate() {
            vm.args.compra_de = null
            vm.args.compra_ate = null
        }

        function resetFilters() {
            vm.args.Fornecedor_id = null;
            vm.args.insumo_id = null;
            vm.args.periodo = 30;
            vm.args.compra_de = null;
            vm.args.compra_ate = null;
            periodoActive.classList.add("select-active");
            datapickerActive.classList.remove("dates-active");
            vm.activeFilters = null;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.compra_de,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.compra_ate,'dd/MM/yyyy');
          let fornecedores = vm.fornecedores;
          let fornecedorNome;
          let insumos = vm.insumos;
          let insumoNome;
          let counter = 0;
          for (let i = 0; i < vm.periods.length; i++) {
               if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
               };
          }
          for (let i = 0; i < fornecedores.length; i++) {
               if (fornecedores[i].id == vm.args.Fornecedor_id) {
                    fornecedorNome = fornecedores[i].nome
               };
          }
          for (let i = 0; i < insumos.length; i++) {
               if (insumos[i].id == vm.args.insumo_id) {
                    insumoNome = insumos[i].nome
               };
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: fornecedorNome,
                    value: 'Fornecedor_id'
               },
               {
                    description: insumoNome,
                    value: 'insumo_id'
               },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.compra_de = null;
               vm.args.compra_ate = null;
               datapickerActive.classList.remove("dates-active");
          } else if(value == 'periodo'){
               periodoActive.classList.remove("select-active");
          }
          vm.args[value] = null;
          change();
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar rateio?')
                .textContent('Tem certeza que deseja deletar esse rateio?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoFertilizanteService.deletarCusto(model.id)
                .then(function (response) {

                    vm.agrupados.splice(vm.agrupados.indexOf(model), 1);

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Rateio deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {

                    var msgErro = 'Não foi possível deletar o rateio. Tente novamente.';

                    if (response.data.status == 422 && response.data.detail != undefined && response.data.detail != '')
                        msgErro = response.data.detail;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msgErro)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

        function gotoVisualizar(id) {
            $state.go('app.estoque_insumo.fertilizante.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.estoque_insumo.fertilizante.criar', {
                propriedade: vm.args.Propriedade_Id
            });
        }

        function gotoHistory(id) {
            $state.go('app.estoque_insumo.fertilizante.historico', {
                id: id
            });
        }
        function gotoAcerto(id) {
            $state.go('app.estoque_insumo.fertilizante.acerto', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');
            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        function openDetail(model) {

            vm.isDetailOpened = true;
            model.isOpen = true;

            consultarDatails(model)
        }

        function closeDetail(model) {

            vm.isDetailOpened = false;
            model.isOpen = false;

        }

        function closeAllDetail() {

            if (!vm.isDetailOpened)
                return;

            for (var index = 0; index < vm.models.length; index++) {
                var model = vm.models[index];

                model.isOpen = false
            }
            vm.isDetailOpened = false;
        }



        function consultarDatails(model) {
            model.isLoading = true;

            estoqueInsumoFertilizanteService
                .queryRateio(model.id, model.insumo_id, model.tipo_medida.id)
                .then(function (response) {

                    vm.agrupados = response;

                }).finally(function () {

                    model.isLoading = false;

                    if (vm.agrupados == undefined)
                        vm.agrupados = [];

                    if (!$scope.$$phase) {
                        //$digest or $apply
                        $scope.$apply();
                    }
                });
        }

        function selectPropriedade() {

            if ($stateParams.propriedade != undefined && $stateParams.propriedade != '')
                return $stateParams.propriedade;

            if (vm.propriedades != undefined && vm.propriedades.length > 0)
                return vm.propriedades[0].id;
            else
                return undefined;
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               periodoActive.classList.add("select-active");
               datapickerActive.classList.remove("dates-active");
          }
          function openDatasSelect(){
               datapicker.style.display = "block";
          }
          function selecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               datapickerActive.classList.add("dates-active");
               periodoActive.classList.remove("select-active");
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               datapickerActive.classList.remove("dates-active");
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.fertilizante')
        .controller('AcertoEstoqueInsumoFertilizanteController', AcertoEstoqueInsumoFertilizanteController)


    /** @ngInject */
    function AcertoEstoqueInsumoFertilizanteController($rootScope, $scope, $state, $filter, estoqueInsumoFertilizanteService, estoque_insumo, $mdDialog, $mdToast) {
        var vm = this;

        // Data
        vm.model = {
            estoque_rateio_id: estoque_insumo.id,
            estoque_tipo_id: 1
        };
        vm.api_response_erro = {};

        vm.estoque_insumo_rateio = estoque_insumo;
        vm.tipos = [{ id: 1, nome: "Acerto" }, { id: 2, nome: "Perda" }];

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.cancelClick = cancelClick;
        vm.save = save;
        // vm.changeInsumo = changeInsumo;
        vm.changeTipoAcerto = changeTipoAcerto;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        // vm.showDialogCreateLojaFornecedor = showDialogCreateLojaFornecedor;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = estoqueInsumoFertilizanteService.createAcerto(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Acerto criado com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = {
                        quantidade: [response.data.detail]
                    };
                }

                vm.api_response_erro = response;
            });
        }


        function gotoSearch() {
            $state.go('app.estoque_insumo.fertilizante.buscar');
        }

        function getTipoAcertoEnum(model) {
            if (model.tipo.id == 2) {
                return 'Perda';
            } else {
                if (model.estoque_tipo_id == 1) {
                    return 'Acerto_Acrescentar';
                } else {
                    return 'Acerto_Remover';
                }
            }
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }


        function changeTipoAcerto() {
            if (vm.model.tipo.id == 1 && vm.model.estoque_tipo_id == undefined)
                vm.model.estoque_tipo_id = 1;

            vm.model.tipo_acerto = getTipoAcertoEnum(vm.model);
        }

        function changeQuantidadeOuUnidadeDeMedida() {

            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.estoque_insumo.defensivo', {
                abstract: true,
                url: '/defensivo'
            })
            .state('app.estoque_insumo.defensivo.buscar', {
                url: '/buscar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/defensivo/views/buscar.html',
                        controller: 'BuscarEstoqueInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    propriedades: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.searchProperties();
                    },
                    data: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.query();
                    },
                    fornecedores: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getInsumos();
                    }
                }
            })
            .state('app.estoque_insumo.defensivo.criar', {
                url: '/criar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/defensivo/views/criar.html',
                        controller: 'CriarEstoqueInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    model: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getNew();
                    },
                    fornecedores: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getAllInsumos();
                    },
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    }
                }
            })
            .state('app.estoque_insumo.defensivo.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/defensivo/views/visualizar.html',
                        controller: 'VisualizarEstoqueInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.get($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.defensivo.historico', {
                url: '/historico/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/defensivo/views/historico.html',
                        controller: 'historicoEstoqueInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    estoque_insumo:function ($stateParams,estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getEstoqueInsumo($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })
            .state('app.estoque_insumo.defensivo.acerto', {
                url: '/acerto/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/defensivo/views/acerto.html',
                        controller: 'AcertoEstoqueInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    estoque_insumo:function ($stateParams,estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getRateio($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.defensivo.rateio', {
                url: '/rateio/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/defensivo/views/rateio.html',
                        controller: 'RateioEstoqueInsumoDefensivoController as vm'
                    }
                },
                resolve: {
                    model:function ($stateParams,estoqueInsumoDefensivoService) {
                        return estoqueInsumoDefensivoService.getRateio($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })



        $translatePartialLoaderProvider.addPart('app/main/estoque_insumo/defensivo');

        msNavigationServiceProvider.saveItem('estoque_insumo.gestao.defensivo', {
            title: 'Defensivo',
            state: 'app.estoque_insumo.defensivo.buscar',
            weight: 2
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo')
        .factory('estoqueInsumoDefensivoService', estoqueInsumoDefensivoService);

    /** @ngInject */
    function estoqueInsumoDefensivoService($q, api, cadastrosFornecedorService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,

            query150: query150,
            queryRateio150: queryRateio150,

            getNew: getNew,
            get: get,
            create: create,

            queryRateio: queryRateio,
            getRateio: getRateio,
            createAcerto: createAcerto,

            queryHistoricoCompra: queryHistoricoCompra,
            getEstoqueInsumo: getEstoqueInsumo,

            deletarCusto: deletarCusto,
            searchProperties: searchProperties,

            getUnidadesMedidas: getUnidadesMedidas,
            getAllInsumos: getAllInsumos,
            getInsumos: getInsumos,
            getFornecedores: getFornecedores
        };

        return service;

        function getNew() {
            return {
                data_compra: new Date(),
                cliente_fornecedor_id: 0,
                numero_documento: '',
                estoque: [
                    // {
                    //     id: 1,
                    //     produto_id: 0,
                    //     valor_pago: 0,
                    //     quantidade: '',
                    //     unidade_medida_id: 0,
                    //     data_vencimento: new Date()
                    // }
                ]
            };
        }

          function query150(args, cache) {
               var deferred = $q.defer();
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;
               if (cache && angular.equals(args, queryArgs)) {
               deferred.resolve(queryResponse);
               } else {
               api.EstoqueInsumoDefensivo150.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         queryResponse = response;
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
               });
               }
               return deferred.promise;
          }
          function queryRateio150(estoqueInsumoId, insumoId, unidadeMedidaId) {
               var deferred = $q.defer();
               var args = {
                   estoqueInsumoId: estoqueInsumoId,
                   insumoId: insumoId,
                   unidadeMedidaId: unidadeMedidaId
               };
               api.EstoqueInsumoRateio150
                   .query(args).$promise
                   .then(function (response) {
                       deferred.resolve(response.data);
                   }).catch(function (response) {
                       deferred.reject(response);
                   });
               return deferred.promise;
           }

        function query(args, cache) {
            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.EstoqueInsumoDefensivo150.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoDefensivo150
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function get(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoDefensivo150.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                // console.log(response);
            });

            return deferred.promise;
        }

        function getEstoqueInsumo(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoDefensivo150
                .getEstoqueInsumo({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function getFornecedores() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
                categoria: 'insumo'
            };

            cadastrosFornecedorService
                .query(args)
                .then(function (response) {
                    deferred.resolve(response.data.cliente_fornecedor);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function getInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'defensivo'
            };

            api.EstoqueInsumoTodos
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getAllInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'defensivo',
                per_page: 1000
            };

            api.EstoqueInsumo
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

          function getUnidadesMedidas() {

               var deferred = $q.defer();

               var unidades_medidas = [
                    { id: 1, tipo_medida_id: 1, nome: 'miligrama', sigla: 'mg' },
                    { id: 2, tipo_medida_id: 1, nome: 'grama', sigla: 'g' },
                    { id: 3, tipo_medida_id: 1, nome: 'quilograma', sigla: 'kg' },
                    { id: 4, tipo_medida_id: 1, nome: 'Tonelada', sigla: 'T' },

                    { id: 5, tipo_medida_id: 2, nome: 'mililitro', sigla: 'ml' },
                    { id: 6, tipo_medida_id: 2, nome: 'litro', sigla: 'L' },

                    { id: 7, tipo_medida_id: 3, nome: 'Unidade', sigla: 'un' }
               ];

               //tipo_medida_id:  1-Peso  | 2-Líquido

               deferred.resolve(unidades_medidas)

               return deferred.promise;
        }


        function deletarCusto(id) {

            // Create a new deferred object
            var deferred = $q.defer();

            var args = {
                id: id
            };

            api.EstoqueInsumoRateio
                .delete(args).$promise
                .then(function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function searchProperties() {

            var deferred = $q.defer();

            var args = {};

            api.Propriedade
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryRateio(estoqueInsumoId, insumoId, unidadeMedidaId) {
            var deferred = $q.defer();

            var args = {
                estoqueInsumoId: estoqueInsumoId,
                insumoId: insumoId,
                unidadeMedidaId: unidadeMedidaId
            };

            api.EstoqueInsumoRateio
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }

        function getRateio(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoRateio150
                .get({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function createAcerto(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoDefensivo150
                .acerto(model).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryHistoricoCompra(args) {
            var deferred = $q.defer();

            api.EstoqueInsumoHistorico
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
         .module('app.estoque_insumo.defensivo')
         .controller('VisualizarEstoqueInsumoDefensivoController', VisualizarEstoqueInsumoDefensivoController)

    /** @ngInject */
    function VisualizarEstoqueInsumoDefensivoController($state, model) {
         var vm = this;
         // Data
         vm.model = model;

         vm.gotoSearch = gotoSearch;

         init();

         function init() {
          }

          function gotoSearch() {
               $state.go('app.estoque_insumo.defensivo.buscar');
          }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo')
        .controller('RateioEstoqueInsumoDefensivoController', RateioEstoqueInsumoDefensivoController)

    /** @ngInject */
    function RateioEstoqueInsumoDefensivoController($scope, $state, model) {
        var vm = this;
        // Data
        vm.model = model;

        vm.gotoSearch = gotoSearch;

        init();

        function init() {
        }

        function gotoSearch() {
            javascript:history.back(1);
       }
    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo')
        .controller('historicoEstoqueInsumoDefensivoController', HistoricoEstoqueInsumoDefensivoController);

    /** @ngInject */
    function HistoricoEstoqueInsumoDefensivoController(estoque_insumo, $state, $stateParams, estoqueInsumoDefensivoService, $mdDialog, $scope, cliente, $mdToast) {
        var vm = this;

        // Data
        vm.cliente = cliente;
        vm.models = [];
        vm.estoque_insumo = estoque_insumo;

        vm.gotoSearch = gotoSearch;
        vm.gotoVisualizarRateio = gotoVisualizarRateio;
        vm.search = search;
        vm.deletar = deletar;
        vm.deletarConfirm = deletarConfirm;

        function init() {
            //vm.estoque_insumo.unidade_medida = unidadeMedida(vm.estoque_insumo);
        }


        init();


        function search() {

            // vm.loadingProgress = true;

            // estoqueInsumoDefensivoService.queryHistoricoCompra(vm.estoque_insumo.insumo.id)
            //     .then(function successCallback(response) {
            //         vm.models = response.data;
            //         // vm.args.PropriedadeId = vm.propriedades[0].id;
            //     }).finally(function () {
            //         vm.loadingProgress = false;
            //     });
        }
        // search();

        /// Query
        vm.args = {
            id: vm.estoque_insumo.insumo.id,
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            estoqueInsumoDefensivoService.queryHistoricoCompra(vm.args)
                .then(function successCallback(response) {
                    vm.models = response.data;

                    vm.models = formatarModels(response.data);

                    // vm.total_cost = response.total_cost;
                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();

                }).finally(function () {
                    vm.args.loading = false;
                });
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar insumo?')
                .textContent('Tem certeza que deseja deletar esse insumo?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoDefensivoService.deletarCusto(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Insumo deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoSearch(id) {
            $state.go('app.estoque_insumo.defensivo.buscar', {
                id: id
            });
        }

        function gotoVisualizarRateio(id) {
            $state.go('app.estoque_insumo.defensivo.rateio', {
                id: id
            });
        }

        function unidadeMedida(model) {
            // , descricao: 'Mg (Miligrama)', formatado: input + ' mg'
            var estoque_insumo = unidadeMedidaFormat(model.quantidade, model.tipo_medida)

            return {
                quantidade: estoque_insumo.quantidade,
                sigla: estoque_insumo.sigla,
                nome: estoque_insumo.nome,
                descricao: estoque_insumo.sigla + " (" + estoque_insumo.nome + ")",
                formatado: estoque_insumo.quantidade + " " + estoque_insumo.sigla
            }
        }

        function unidadeMedidaFormat(input, tipo_medida) {

            if (tipo_medida == undefined)
                return { quantidade: input, sigla: '', nome: '' }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return { quantidade: input, sigla: 'mg', nome: 'Miligrama' }

                    if (input < 1000000)
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'g', nome: 'Grama' }

                    if (input < 1000000000)
                        return { quantidade: convertToDecimalCase((input / 1000000), 2), sigla: 'kg', nome: 'Quilograma' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000000000), 2), sigla: 'T', nome: 'Tonelada' }

                case 2: // Líquido

                    if (input < 1000)
                        return { quantidade: input, sigla: 'ml', nome: 'Mililitro' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'Litros', nome: 'Litros' }

                case 3: // Unidade
                    return { quantidade: input, sigla: 'un', nome: 'Unidade' }

                default:
                    return { quantidade: input, sigla: 'ml', nome: tipo_medida.nome }
            }
        }

        function convertToDecimalCase(number, decimal) {
            var n = parseFloat(number);

            if (Number.isInteger(n)) {
                return n;
            }
            else {
                if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                    return parseInt(number);

                return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            }
        }

        function formatarModels(data) {

            var retorno = [];

            for (var index = 0; index < data.length; index++) {
                var model = data[index];

                model.valor_pago = model.estoque_insumo_rateio.valor / model.estoque_insumo_rateio.quantidade_origem * Math.abs(model.quantidade);
                if(model.valor_pago < 0.01){
                    model.valor_pago = 0.01;
                }

                if (model.estoque_insumo_lancamento_tipo.id == 2) {
                    model.tipo_acerto = (model.quantidade > 0) ? 'Acerto - Acrescentado' : 'Acerto - Retirado';
                } else {
                    model.tipo_acerto = model.estoque_insumo_lancamento_tipo.descricao
                }


                retorno.push(model);

                //
            }

            return retorno;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo')
        .controller('CriarEstoqueInsumoDefensivoController', CriarEstoqueInsumoDefensivoController)
        //.controller('CriarLojaController', CriarLojaController) // ver criar.controller em semente
        .controller('CriarCadastroInsumoDefensivoController', CriarCadastroInsumoDefensivoController)


    /** @ngInject */
    function CriarEstoqueInsumoDefensivoController($rootScope, $scope, $state, $filter, estoqueInsumoDefensivoService, fornecedores, insumos, $mdDialog, $mdToast, model) {
        var vm = this;

        // Data
        vm.model = model;
        vm.api_response_erro = {};

        vm.fornecedores = fornecedores;
        vm.insumos = insumos;

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.gotoLojaFornecedor = gotoLojaFornecedor;
        vm.gotoCadastroInsumo = gotoCadastroInsumo;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.showConfirm = showConfirm;
        vm.addInsumo = addInsumo;
        vm.removeInsumo = removeInsumo;
        vm.changeInsumo = changeInsumo;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        vm.showDialogCreateMarketplace = showDialogCreateMarketplace;
        vm.showDialogCreateInsumo = showDialogCreateInsumo;
        //////////


        init();

        function init() {

            addInsumo();

            vm.date = new Date();
        }

        function save(form, confirmType) {

            if (form.$invalid) {
                return;
            }

            $rootScope.loadingProgress = true;

            estoqueInsumoDefensivoService
                .create(vm.model)
                .then(function (response) {
                    $rootScope.loadingProgress = false;
                    // vm.model.id = response.id;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Estoque criado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    (confirmType == 'Y')?gotoAdd():gotoSearch();
                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }


        function showConfirm(form) {

            if (form.$invalid) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title('Atenção')
                .textContent('Gostaria de salvar um novo insumo no estoque?')
                .targetEvent(form)
                .ok('Sim, gostaria')
                .cancel('Não, não gostaria');

          $mdDialog
                .show(confirm)
                .then(function () {
                    save(form, 'Y')
                }, function () {
                    save(form, 'N')
                });
        };

        function gotoAdd() {
          $state.go('app.estoque_insumo.defensivo.criar', {
              propriedade: vm.model.propriedade_Id
          });
        }

        function gotoSearch() {
            $state.go('app.estoque_insumo.defensivo.buscar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function gotoLojaFornecedor() {
            $state.go('app.cadastros.fornecedor.buscar');
        }

        function gotoCadastroInsumo() {
            $state.go('app.estoque_insumo.cadastro_insumo.criar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }

        function addInsumo() {

            var insumo = { id: 0 };

            if (vm.insumos.length > 0) {
                insumo = vm.insumos[0]
            }

            vm.model.estoque.push({
                id: vm.model.estoque.length + 1,
                insumo: insumo,
                valor_pago: 0,
                quantidade: '',
                data_vencimento: undefined
            });
        }

        function removeInsumo(index) {
            vm.model.estoque.splice(index, 1);

            reorganizarIndexDefensivos();
        }

        function reorganizarIndexDefensivos() {

            for (var index = 0; index < vm.model.estoque.length; index++) {
                vm.model.estoque[index].id = index + 1;
            }
        }

        function changeInsumo(defensivo) {

            changeQuantidadeOuUnidadeDeMedida(defensivo)
        }

        function changeQuantidadeOuUnidadeDeMedida(defensivo) {

            defensivo.tipo_medida_id = defensivo.insumo.tipo_medida.id

            if (defensivo.insumo != undefined)
                defensivo.insumo_id = defensivo.insumo.id

            defensivo.valor = defensivo.valor_pago;

            // $scope.$apply();
            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }

        }

        function showDialogCreateMarketplace(ev, lista_detalhes) {

            $mdDialog.show({
                controller: 'CriarLojaController as vm', // em criar.controller semente
                templateUrl: 'app/main/estoque_insumo/defensivo/views/criar_loja.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.fornecedores.push(answer);
                        lista_detalhes.cliente_consumidor = answer;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }

        function showDialogCreateInsumo(ev, defensivo) {

            $mdDialog.show({
                controller: 'CriarCadastroInsumoDefensivoController as vm',
                templateUrl: 'app/main/estoque_insumo/defensivo/views/criar_insumo.tmpl.html',
                resolve: {
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    },
                    tipo_medida: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoMedida();
                    }
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer && answer.insumo_tipo_id == 2) {
                        vm.insumos.push(answer);
                        defensivo.insumo = answer;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }


        // function initPropriedade() {
        //     for (let index = 0; index < vm.all_propriedades.length; index++) {

        //         const element = vm.all_propriedades[index];

        //         vm.propriedades.push({
        //             id: element.id,
        //             nome: element.nome
        //         });
        //     }
        // }

        // function initPropriedadeAreas() {
        //     for (let index = 0; index < vm.areas.length; index++) {

        //         const element = vm.areas[index];

        //         vm.propriedade_areas.push({
        //             propriedade_area_id: element.id,
        //             propriedade_area_nome: element.nome,
        //             propriedade_id: element.propriedade.id,
        //             propriedade_nome: element.propriedade.nome
        //         });
        //     }
        // }
    }

    function CriarCadastroInsumoDefensivoController($rootScope, $scope, $state, $filter, cadastrosCadastroInsumoService, areaService, tipo_medida, tipo_insumo, $q, $mdToast, $mdDialog) {


        var vm = this;

        // Data
        vm.model = {
            insumo_tipo_id: 2
        };
        vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        vm.tipo_insumo = tipo_insumo;
        vm.defensivos = [];
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.culturaSearch = culturaSearch;
        vm.listaAgrofitSearch = listaAgrofitSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.changeInsumoTipo = changeInsumoTipo;
        vm.save = save;
        //////////

        init();

        function init() {
            // autoSelectTipoMedida();
            // autoSelectTipoInsumo();
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }


            // Força o tipo de insumo para defensivo.
            vm.model.insumo_tipo_id = 2;


            var model = {

                estoque_insumo: [
                    vm.model
                ]
            }

            var message = '';
            this.savePromise = cadastrosCadastroInsumoService.create(model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.data[0].id;

                $mdDialog.hide({
                    id: vm.model.id,
                    nome: vm.model.nome,
                    insumo_tipo_id: vm.model.insumo_tipo_id,
                    tipo_medida_id: vm.model.tipo_medida_id,
                    tipo_medida: {
                        id: vm.model.tipo_medida_id,
                        descricao: response.data[0].unidade_medida
                    }
                });

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = response.data.data.errors;
                }

                vm.api_response_erro = response;
            });
        }

        function autoSelectTipoMedida() {

            if (vm.tipo_medida != undefined && vm.tipo_medida.length > 0)
                vm.model.tipo_medida_id = vm.tipo_medida[0].id;
        }

        function autoSelectTipoInsumo() {

            if (vm.tipo_insumo != undefined && vm.tipo_insumo.length > 0)
                vm.model.insumo_tipo_id = vm.tipo_insumo[0].id;
        }

        function changeInsumoTipo() {
            vm.model.insumo_agricola_id = undefined;

            if (vm.model.insumo_tipo_id == 4)
                vm.model.tipo_medida_id = 3;
            else
                if (vm.model.tipo_medida_id == 3)
                    vm.model.tipo_medida_id = 1;

            vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        }

        function listaAgrofitSearch(query) {

            var deferred = $q.defer();

            var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
            promisse.then(function (response) {

                vm.defensivos = response.data;
                let retorno = [];

                for (let index = 0; index < response.data.length; index++) {
                    const element = response.data[index];
                    retorno.push(element.nome);
                }

                deferred.resolve(retorno)

            }).finally(function () {

            });

            return deferred.promise;
        }

        function culturaSearch(query) {

            var retorno = areaService.getCulturas(query);
            return retorno;
        }

        function selectedItemChange(nome) {

            if (nome == undefined) {
                vm.model.insumo_agricola_id = undefined;
                return;
            }

            let item = vm.defensivos.filter(function (obj) {
                return obj.nome == nome
            });

            vm.model.insumo_agricola_id = item[0].id;
        }

        function getTipoMedida(tipoInsumo) {

            var tipo_insumo = [];

            if (tipoInsumo == 4) {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 3, nome: 'Unidade' });
            } else {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 2, nome: 'L' });
            }

            return tipo_insumo;
        }

        function gotoSearch() {
            $mdDialog.hide();
        }


    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo')
        .controller('BuscarEstoqueInsumoDefensivoController', BuscarEstoqueInsumoDefensivoController);

    /** @ngInject */
    function BuscarEstoqueInsumoDefensivoController(data, $state, $stateParams, estoqueInsumoDefensivoService, propriedades, fornecedores, insumos, $mdDialog, $scope, $mdToast, $filter) {
        var vm = this;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        vm.total_cost = 0;
        vm.propriedades = propriedades;
        vm.fornecedores = fornecedores;
        vm.insumos = insumos;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoAdd = gotoAdd;
        vm.gotoHistory = gotoHistory;
        vm.gotoAcerto = gotoAcerto;
        vm.search = search;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;
        vm.isDetailOpened = false;
        vm.openDetail = openDetail;
        vm.closeDetail = closeDetail;
        vm.agrupados = [];

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;

        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
        ];

        vm.model = {
            dataInicio: new Date(),
            dataFim: new Date()
        }


        function init() {

               periodoActive.classList.add("select-active");

               if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();

            // vm.search();
        }
        init();

        function search() {

            vm.loadingProgress = true;
            estoqueInsumoDefensivoService.query()
                .then(function successCallback(data) {
                    vm.models = data;

                    if ($stateParams.propriedade)
                        vm.args.Propriedade_Id = $stateParams.propriedade
                    else
                        vm.args.Propriedade_Id = vm.propriedades[0].id

                }).finally(function () {
                    vm.loadingProgress = false;
                });
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            sort_by: "id",
            sort_order: "desc",
            Propriedade_Id: selectPropriedade(),
            Fornecedor_id: null,
            insumo_id: null,
            numero_documento: "",
            compra_de: null,
            periodo: 30,
            compra_ate: null,
            _change: change
        }

        vm.args._change();

        function change() {

            closeAllDetail();

            vm.args.loading = true;
            estoqueInsumoDefensivoService.query(vm.args).then(function (response) {
                vm.models = response.data.estoques_insumo_model;

                // vm.total_cost = response.total_cost;
                vm.args.total_rows = response.data.total_itens;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();



            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function clearPreDate() {
            vm.args.periodo = null
        }

        function clearRangeDate() {
            vm.args.compra_de = null
            vm.args.compra_ate = null
        }

        function resetFilters() {
            vm.args.Fornecedor_id = null;
            vm.args.insumo_id = null;
            vm.args.periodo = 30;
            vm.args.compra_de = null;
            vm.args.compra_ate = null;
            periodoActive.classList.add("select-active");
            datapickerActive.classList.remove("dates-active");
            vm.activeFilters = null;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.compra_de,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.compra_ate,'dd/MM/yyyy');
          let fornecedores = vm.fornecedores;
          let fornecedorNome;
          let insumos = vm.insumos;
          let insumoNome;
          let counter = 0;
          for (let i = 0; i < vm.periods.length; i++) {
               if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
               };
          }
          for (let i = 0; i < fornecedores.length; i++) {
               if (fornecedores[i].id == vm.args.Fornecedor_id) {
                    fornecedorNome = fornecedores[i].nome
               };
          }
          for (let i = 0; i < insumos.length; i++) {
               if (insumos[i].id == vm.args.insumo_id) {
                    insumoNome = insumos[i].nome
               };
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: fornecedorNome,
                    value: 'Fornecedor_id'
               },
               {
                    description: insumoNome,
                    value: 'insumo_id'
               },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.compra_de = null;
               vm.args.compra_ate = null;
               datapickerActive.classList.remove("dates-active");
          } else if(value == 'periodo'){
               periodoActive.classList.remove("select-active");
          }
          vm.args[value] = null;
          change();
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar rateio?')
                .textContent('Tem certeza que deseja deletar esse rateio?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoDefensivoService.deletarCusto(model.id)
                .then(function (response) {

                    vm.agrupados.splice(vm.agrupados.indexOf(model), 1);

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Rateio deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {

                    var msgErro = 'Não foi possível deletar o rateio. Tente novamente.';

                    if (response.data.status == 422 && response.data.detail != undefined && response.data.detail != '')
                        msgErro = response.data.detail;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msgErro)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

        function gotoVisualizar(id) {
            $state.go('app.estoque_insumo.defensivo.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.estoque_insumo.defensivo.criar', {
                propriedade: vm.args.Propriedade_Id
            });
        }

        function gotoHistory(id) {
            $state.go('app.estoque_insumo.defensivo.historico', {
                id: id
            });
        }
        function gotoAcerto(id) {
            $state.go('app.estoque_insumo.defensivo.acerto', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {


            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }


        function openDetail(model) {

            vm.isDetailOpened = true;
            model.isOpen = true;

            consultarDatails(model)
        }

        function closeDetail(model) {

            vm.isDetailOpened = false;
            model.isOpen = false;

        }

        function closeAllDetail() {

            if (!vm.isDetailOpened)
                return;

            for (var index = 0; index < vm.models.length; index++) {
                var model = vm.models[index];

                model.isOpen = false
            }
            vm.isDetailOpened = false;
        }



        function consultarDatails(model) {
            model.isLoading = true;

            estoqueInsumoDefensivoService
                .queryRateio(model.id, model.insumo_id, model.tipo_medida.id)
                .then(function (response) {

                    vm.agrupados = response;

                }).finally(function () {

                    model.isLoading = false;

                    if (vm.agrupados == undefined)
                        vm.agrupados = [];

                    if (!$scope.$$phase) {
                        //$digest or $apply
                        $scope.$apply();
                    }
                });
        }

        function selectPropriedade() {

            if ($stateParams.propriedade != undefined && $stateParams.propriedade != '')
                return $stateParams.propriedade;

            if (vm.propriedades != undefined && vm.propriedades.length > 0)
                return vm.propriedades[0].id;
            else
                return undefined;
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               periodoActive.classList.add("select-active");
               datapickerActive.classList.remove("dates-active");
          }
          function openDatasSelect(){
               datapicker.style.display = "block";
          }
          function selecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               datapickerActive.classList.add("dates-active");
               periodoActive.classList.remove("select-active");
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               datapickerActive.classList.remove("dates-active");
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.defensivo')
        .controller('AcertoEstoqueInsumoDefensivoController', AcertoEstoqueInsumoDefensivoController)


    /** @ngInject */
    function AcertoEstoqueInsumoDefensivoController($rootScope, $scope, $state, $filter, estoqueInsumoDefensivoService, estoque_insumo, $mdDialog, $mdToast) {
        var vm = this;

        // Data
        vm.model = {
            estoque_rateio_id: estoque_insumo.id
        };
        vm.api_response_erro = {};

        vm.estoque_insumo_rateio = estoque_insumo;
        vm.tipos = [{ id: 1, nome: "Acerto" }, { id: 2, nome: "Perda" }];

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.cancelClick = cancelClick;
        vm.save = save;
        // vm.changeInsumo = changeInsumo;
        vm.changeTipoAcerto = changeTipoAcerto;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        // vm.showDialogCreateLojaFornecedor = showDialogCreateLojaFornecedor;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = estoqueInsumoDefensivoService.createAcerto(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Acerto criado com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = {
                        quantidade: [response.data.detail]
                    };
                }

                vm.api_response_erro = response;
            });
        }


        function gotoSearch() {
            $state.go('app.estoque_insumo.defensivo.buscar');
        }

        function getTipoAcertoEnum(model) {
            if (model.tipo.id == 2) {
                return 'Perda';
            } else {
                if (model.estoque_tipo_id == 1) {
                    return 'Acerto_Acrescentar';
                } else {
                    return 'Acerto_Remover';
                }
            }
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }


        function changeTipoAcerto() {
            if (vm.model.tipo.id == 1 && vm.model.estoque_tipo_id == undefined)
                vm.model.estoque_tipo_id = 1;

            vm.model.tipo_acerto = getTipoAcertoEnum(vm.model);
        }

        function changeQuantidadeOuUnidadeDeMedida() {
            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.cadastro_insumo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.estoque_insumo.cadastro_insumo', {
                abstract: true,
                url: '/cadastro_insumo'
            })
            .state('app.estoque_insumo.cadastro_insumo.buscar', {
                url: '/buscar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/buscar.html',
                        controller: 'buscarCadastroInsumoController as vm'
                    }
                },
                resolve: {
                    data: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.query();
                    }
                }
            })
            .state('app.estoque_insumo.cadastro_insumo.criar', {
                url: '/criar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/criar.html',
                        controller: 'criarCadastroInsumoController as vm'
                    }
                },
                resolve: {
                    model: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getNew();
                    },
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    },
                    tipo_medida: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoMedida();
                    }
                }
            })
            .state('app.estoque_insumo.cadastro_insumo.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/visualizar.html',
                        controller: 'visualizarCadastroInsumoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.get($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.cadastro_insumo.editar', {
                url: '/editar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/editar.html',
                        controller: 'editarCadastroInsumoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.get($stateParams.id);
                    }
                }
            })





        $translatePartialLoaderProvider.addPart('app/main/estoque_insumo/cadastro_insumo');

        msNavigationServiceProvider.saveItem('estoque_insumo.cadastro_insumo', {
            title: 'Cadastro de insumos',
            state: 'app.estoque_insumo.cadastro_insumo.buscar',
            weight: 1
        });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.cadastro_insumo')
        .factory('cadastrosCadastroInsumoService', cadastrosCadastroInsumoService);

    /** @ngInject */
    function cadastrosCadastroInsumoService($q, api) {

        var models = [];
        var queryResponse = {};
        var queryArgs = {};
        var modelNew = {};
        var service = {
            getNew: getNew,
            query: query,
            get: get,
            create: create,
            update: update,
            delete: deleteInsumo,
            getTipoInsumo: getTipoInsumo,
            getTipoMedida: getTipoMedida,
            searchListaAgrofit: searchListaAgrofit

        };

        return service;


        function getNew() {
            return modelNew;
        }

        //////////

        ////// LISTAR - CLIENTE CadastroInsumo //////
        function query(args, cache) {

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            var deferred = $q.defer();

            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.EstoqueInsumo.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        models = response.data;
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        };
        ////// LISTAR - CLIENTE FORNECEDOR //////


        ////// CONSULTA POR ID - CLIENTE FORNECEDOR //////
        function get(id) {
            var deferred = $q.defer();

            api.EstoqueInsumo.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });
            return deferred.promise;
        }
        ////// CONSULTA POR ID - CLIENTE FORNECEDOR //////


        ////// CRIAR - CLIENTE FORNECEDOR //////
        function create(model) {

            var deferred = $q.defer();

            api.EstoqueInsumo
                .save(model).$promise
                .then(function (response) {
                    deferred.resolve(response);
                    modelNew = {};
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }
        ////// CRIAR - CLIENTE FORNECEDOR //////

        ////// ALTERAR - CLIENTE FORNECEDOR //////
        function update(model) {

            var deferred = $q.defer();

            api.EstoqueInsumo.update(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    modelNew = {};
                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// ALTERAR - CLIENTE FORNECEDOR //////




        ////// CONSULTA DE FORNECEDOR //////

        ////// DELETAR - COLHEITA //////
        function deleteInsumo(id) {
            // Create a new deferred object
            var deferred = $q.defer();

            api.EstoqueInsumo.delete({
                id: id
            }).$promise.then(
                function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(
                    function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                    }
                );

            return deferred.promise;
        }
        ////// DELETAR - COLHEITA //////



        function getTipoInsumo() {

            var deferred = $q.defer();

            var tipo_insumo = [
                { id: 1, nome: 'Biológico' },
                { id: 2, nome: 'Defensivo' },
                { id: 3, nome: 'Fertilizante' },
                { id: 4, nome: 'Semente' }
            ];

            deferred.resolve(tipo_insumo)

            return deferred.promise;
        }

        function getTipoMedida() {

            var deferred = $q.defer();

            var tipo_medidas = [
                { id: 1, nome: 'Kg' },
                { id: 2, nome: 'Litro' },
                { id: 3, nome: 'Unidade' }
            ];

            deferred.resolve(tipo_medidas)

            return deferred.promise;
        }


        function searchListaAgrofit(query) {

            var deferred = $q.defer();

            api.InsumoAgrofit.query({
                query: query
            }).$promise
                .then(function (response) {

                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }
    }

})();

(function() {
    'use strict';

    angular
         .module('app.estoque_insumo.cadastro_insumo')
         .controller('visualizarCadastroInsumoController', visualizarCadastroInsumoController);

    /** @ngInject */
    function visualizarCadastroInsumoController($state, model) {
         var vm = this;

         // Data
         vm.model = model;
         vm.status = [];

         // Methods
         vm.gotoSearch = gotoSearch;

         //////////

         init();

         /**
          * Initialize
          */
         function init() {

         }

         function gotoSearch() {
              $state.go('app.estoque_insumo.cadastro_insumo.buscar');
         }
    }
})();
(function () {
    'use strict';

    angular
         .module('app.estoque_insumo.cadastro_insumo')
         .controller('editarCadastroInsumoController', editarCadastroInsumoController);

    /** @ngInject */
    function editarCadastroInsumoController($rootScope, $scope, $state, $filter, model, cadastrosCadastroInsumoService, $mdToast, $mdDialog) {
         var vm = this;

         // Data
         vm.model = model;
         vm.api_response_erro = {};

         // Metodos
         vm.gotoSearch = gotoSearch;
         vm.save = save;
         //////////

         init();

         function init() {

         }

         function save(form) {

              if (form.$invalid) {
                   return;
              }

              var message = '';
              var message = $filter('translate')('CADASTRO_INSUMO.INSUMO_ALTERADO');
              this.savePromise = cadastrosCadastroInsumoService.update(vm.model);

              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                   );
                   gotoSearch()
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }

         function gotoSearch() {
              $state.go('app.estoque_insumo.cadastro_insumo.buscar');
         }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.cadastro_insumo')
        .controller('criarCadastroInsumoController', criarCadastroInsumoController);

    /** @ngInject */
    function criarCadastroInsumoController($rootScope, $scope, $state, $filter, model, cadastrosCadastroInsumoService, insumoDefensivoService, areaService, $q, tipo_medida, tipo_insumo, $mdToast, $mdDialog) {
        var vm = this;

        // Data
        vm.model = model;
        vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        vm.tipo_insumo = tipo_insumo;
        vm.defensivos = [];
        vm.api_response_erro = {};

        // Metodos
        vm.listaAgrofitSearch = listaAgrofitSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.changeInsumoTipo = changeInsumoTipo;
        vm.gotoSearch = gotoSearch;
        vm.culturaSearch = culturaSearch;
        vm.save = save;
        //////////

        init();

        function init() {

            // autoSelectTipoMedida();
            // autoSelectTipoInsumo();
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            if (vm.model.insumo_tipo_id == 4 && vm.model.cultura)
                vm.model.cultura_id = vm.model.cultura.id;
            else
                vm.model.cultura_id = undefined;

            var model = {

                estoque_insumo: [
                    vm.model
                ]
            }

            var message = $filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO');
            this.savePromise = cadastrosCadastroInsumoService.create(model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );
                gotoSearch()
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = response.data.data.errors;
                }

                vm.api_response_erro = response;
            });
        }

        function citySearch(query) {
            console.log(query);
            var retorno = cadastrosCadastroInsumoService.getCity(query);
            return retorno;
        }

        function gotoSearch() {
            $state.go('app.estoque_insumo.cadastro_insumo.buscar');
        }

        function autoSelectTipoMedida() {

            if (vm.tipo_medida != undefined && vm.tipo_medida.length > 0)
                vm.model.tipo_medida_id = vm.tipo_medida[0].id;
        }

        function autoSelectTipoInsumo() {

            if (vm.tipo_insumo != undefined && vm.tipo_insumo.length > 0)
                vm.model.insumo_tipo_id = vm.tipo_insumo[0].id;
        }

        function changeInsumoTipo() {
            vm.model.insumo_agricola_id = undefined;

            if (vm.model.insumo_tipo_id == 4)
                vm.model.tipo_medida_id = 1;
            else
                if (vm.model.tipo_medida_id == 3)
                    vm.model.tipo_medida_id = 1;

            vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);

            // if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
            //     $scope.$apply();
            // }
        }


        function listaAgrofitSearch(query) {

            var deferred = $q.defer();

            var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
            promisse.then(function (response) {

                vm.defensivos = response.data;
                let retorno = [];

                for (let index = 0; index < response.data.length; index++) {
                    const element = response.data[index];
                    retorno.push(element.nome);
                }

                deferred.resolve(retorno)

            }).finally(function () {

            });

            return deferred.promise;
        }

        function selectedItemChange(nome) {

            if (nome == undefined) {
                vm.model.insumo_agricola_id = undefined;
                return;
            }

            let item = vm.defensivos.filter(function (obj) {
                return obj.nome == nome
            });

            vm.model.insumo_agricola_id = item[0].id;
        }

        function getTipoMedida(tipoInsumo) {

            var tipo_insumo = [];

            if (tipoInsumo == 4) {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                //tipo_insumo.push({ id: 3, nome: 'Unidade' });
            } else {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 2, nome: 'L' });
            }

            return tipo_insumo;
        }

        function culturaSearch(query) {

            var retorno = areaService.getCulturas(query);
            return retorno;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.cadastro_insumo')
        .controller('buscarCadastroInsumoController', buscarCadastroInsumoController);

    /** @ngInject */
    function buscarCadastroInsumoController(data, $state, $filter, cadastrosCadastroInsumoService, propertieService, $mdDialog, $mdToast, $scope) {
        var vm = this;

        // Data
        vm.search = search;
        vm.gotoAddClient = gotoAddClient;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoEditar = gotoEditar;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.viewTutorial = viewTutorial;

        //////////

        init();

        function init() {
            propertieService.getLista().then(function(response) {
                vm.propriedades = response;
                if(!vm.propriedades || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm()
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }
        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');
            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        function search() {

            change();
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            sort_by: 'nome',
            sort_order: 'asc',
            _change: change
        };

        vm.args._change();



        function viewTutorial() {
            $mdDialog.show({
                 controller: mdDialogCtrl,
                 templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/tutorial-insumo.html',
                 parent: angular.element(document.body),
                 clickOutsideToClose: true,
                 fullscreen: false
            })
        }

        function mdDialogCtrl($scope, $mdDialog) {

            $scope.hide = function () {
                 $mdDialog.hide();
            };
            $scope.cancelar = function () {
                 $mdDialog.cancel();
            };
       }

        function change() {


            vm.args.loading = true;
            cadastrosCadastroInsumoService.query(vm.args).then(function (response) {
                vm.models = response.data;

                vm.args.total_rows = response.total_rows;
                vm.args.length_rows = vm.models.length;
                vm.args.updatePaggination();


            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {

                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();

        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar Insumo?')
                .textContent('Tem certeza que deseja deletar esse Insumo?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            var message = $filter('translate')('CADASTRO_INSUMO.INSUMO_DELETADO');

            cadastrosCadastroInsumoService.delete(model.id)
                .then(function (response) {

                    vm.models.splice(vm.models.indexOf(model), 1);

                    vm.args.total_rows = vm.args.total_rows - 1;
                    vm.args.length_rows = vm.args.length_rows - 1;
                    vm.args.updatePaggination();

                    if (vm.args.length_rows == 0)
                        search();

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                }).catch(function (response) {

                    // TODO mensagem de erro
                });
        }

        function gotoAddClient() {
            $state.go('app.estoque_insumo.cadastro_insumo.criar');
        }

        function gotoVisualizar(id) {
            $state.go('app.estoque_insumo.cadastro_insumo.visualizar', {
                id: id
            });
        }

        function gotoEditar(id) {
            $state.go('app.estoque_insumo.cadastro_insumo.editar', {
                id: id
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.estoque_insumo.biologico', {
                abstract: true,
                url: '/biologico'
            })
            .state('app.estoque_insumo.biologico.buscar', {
                url: '/buscar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/biologico/views/buscar.html',
                        controller: 'BuscarEstoqueInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    propriedades: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.searchProperties();
                    },
                    data: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.query();
                    },
                    fornecedores: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getInsumos();
                    }
                }
            })
            .state('app.estoque_insumo.biologico.criar', {
                url: '/criar/:propriedade',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/biologico/views/criar.html',
                        controller: 'CriarEstoqueInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    model: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getNew();
                    },
                    fornecedores: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getFornecedores();
                    },
                    insumos: function (estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getAllInsumos();
                    },
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    },
                }
            })
            .state('app.estoque_insumo.biologico.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/biologico/views/visualizar.html',
                        controller: 'VisualizarEstoqueInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.get($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.biologico.historico', {
                url: '/historico/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/biologico/views/historico.html',
                        controller: 'historicoEstoqueInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    estoque_insumo: function ($stateParams, estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getEstoqueInsumo($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })
            .state('app.estoque_insumo.biologico.acerto', {
                url: '/acerto/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/biologico/views/acerto.html',
                        controller: 'AcertoEstoqueInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    estoque_insumo: function ($stateParams, estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getRateio($stateParams.id);
                    }
                }
            })
            .state('app.estoque_insumo.biologico.rateio', {
                url: '/rateio/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/estoque_insumo/biologico/views/rateio.html',
                        controller: 'RateioEstoqueInsumoBiologicoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, estoqueInsumoBiologicoService) {
                        return estoqueInsumoBiologicoService.getRateio($stateParams.id);
                    },
                    cliente: function (clientePerfilService) {
                        return clientePerfilService.getAtivo();
                    }
                }
            })

        $translatePartialLoaderProvider.addPart('app/main/estoque_insumo/biologico');

        msNavigationServiceProvider.saveItem('estoque_insumo.gestao.biologico', {
            title: 'Biológico',
            state: 'app.estoque_insumo.biologico.buscar',
            weight: 2
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico')
        .factory('estoqueInsumoBiologicoService', estoqueInsumoBiologicoService);

    /** @ngInject */
    function estoqueInsumoBiologicoService($q, api, cadastrosFornecedorService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,

            query150: query150,
            queryRateio150: queryRateio150,

            getNew: getNew,
            get: get,
            create: create,

            queryRateio: queryRateio,
            getRateio: getRateio,
            createAcerto: createAcerto,

            queryHistoricoCompra: queryHistoricoCompra,
            getEstoqueInsumo: getEstoqueInsumo,

            deletarCusto: deletarCusto,
            searchProperties: searchProperties,

            getUnidadesMedidas: getUnidadesMedidas,
            getInsumos: getInsumos,
            getAllInsumos : getAllInsumos,
            getFornecedores: getFornecedores
        };

        return service;

        function getNew() {
            return {
                data_compra: new Date(),
                cliente_fornecedor_id: 0,
                numero_documento: '',
                estoque: [
                    // {
                    //     id: 1,
                    //     produto_id: 0,
                    //     valor_pago: 0,
                    //     quantidade: '',
                    //     unidade_medida_id: 0,
                    //     data_vencimento: new Date()
                    // }
                ]
            };
        }

          function query150(args, cache) {
               var deferred = $q.defer();
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;
               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
               api.EstoqueInsumoBiologico150.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         queryResponse = response;
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
                    });
               }
               return deferred.promise;
          }

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.EstoqueInsumoBiologico150.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoBiologico150
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function get(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoBiologico150.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                // console.log(response);
            });

            return deferred.promise;
        }

        function getEstoqueInsumo(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoBiologico150
                .getEstoqueInsumo({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function getFornecedores() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
                categoria: 'insumo'
            };

            cadastrosFornecedorService
                .query(args)
                .then(function (response) {
                    deferred.resolve(response.data.cliente_fornecedor);
                }).catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function getAllInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'biologico',
                per_page: 1000
            };

            api.EstoqueInsumo
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getInsumos() {

            var deferred = $q.defer();

            var args = {
                insumoTipo: 'biologico'
            };

            api.EstoqueInsumoTodos
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                }).catch(function (response) {
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function getUnidadesMedidas() {

            var deferred = $q.defer();

            var unidades_medidas = [
                { id: 1, tipo_medida_id: 1, nome: 'miligrama', sigla: 'mg' },
                { id: 2, tipo_medida_id: 1, nome: 'grama', sigla: 'g' },
                { id: 3, tipo_medida_id: 1, nome: 'quilograma', sigla: 'kg' },
                { id: 4, tipo_medida_id: 1, nome: 'Tonelada', sigla: 'T' },

                { id: 5, tipo_medida_id: 2, nome: 'mililitro', sigla: 'ml' },
                { id: 6, tipo_medida_id: 2, nome: 'litro', sigla: 'L' },

                { id: 7, tipo_medida_id: 3, nome: 'Unidade', sigla: 'un' }
            ];

            //tipo_medida_id:  1-Peso  | 2-Líquido

            deferred.resolve(unidades_medidas)

            return deferred.promise;
        }


        function deletarCusto(id) {

            // Create a new deferred object
            var deferred = $q.defer();

            var args = {
                id: id
            };

            api.EstoqueInsumoRateio
                .delete(args).$promise
                .then(function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

                }).catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);

                });

            return deferred.promise;
        }

        function searchProperties() {

            var deferred = $q.defer();

            var args = {};

            api.Propriedade
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response.data);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });

            return deferred.promise;
        }

          function queryRateio150(estoqueInsumoId, insumoId, unidadeMedidaId) {
               var deferred = $q.defer();
               var args = {
                    estoqueInsumoId: estoqueInsumoId,
                    insumoId: insumoId,
                    unidadeMedidaId: unidadeMedidaId
               };
               api.EstoqueInsumoRateio150
               .query(args).$promise
               .then(function (response) {
                    deferred.resolve(response.data);
               }).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

          function queryRateio(estoqueInsumoId, insumoId, unidadeMedidaId) {
               var deferred = $q.defer();

               var args = {
                    estoqueInsumoId: estoqueInsumoId,
                    insumoId: insumoId,
                    unidadeMedidaId: unidadeMedidaId
               };

               api.EstoqueInsumoRateio
                    .query(args).$promise
                    .then(function (response) {
                    deferred.resolve(response.data);
                    }).catch(function (response) {
                    deferred.reject(response);
                    });


               return deferred.promise;
          }

        function getRateio(id) {

            var deferred = $q.defer();

            api.EstoqueInsumoRateio150
                .get({ id: id }).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                    // console.log(response);
                });

            return deferred.promise;
        }

        function createAcerto(model) {

            var deferred = $q.defer();

            api.EstoqueInsumoBiologico150
                .acerto(model).$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function queryHistoricoCompra(args) {
            var deferred = $q.defer();

            api.EstoqueInsumoHistorico
                .query(args).$promise
                .then(function (response) {
                    deferred.resolve(response);
                }).catch(function (response) {
                    deferred.reject(response);
                });


            return deferred.promise;
        }
    }
})();

(function () {
    'use strict';

    angular
         .module('app.estoque_insumo.biologico')
         .controller('VisualizarEstoqueInsumoBiologicoController', VisualizarEstoqueInsumoBiologicoController)

    /** @ngInject */
    function VisualizarEstoqueInsumoBiologicoController($state, model) {
         var vm = this;
         // Data
         vm.model = model;

         vm.gotoSearch = gotoSearch;

         init();

         function init() {
          }

          function gotoSearch() {
               $state.go('app.estoque_insumo.biologico.buscar');
          }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico')
        .controller('RateioEstoqueInsumoBiologicoController', RateioEstoqueInsumoBiologicoController)

    /** @ngInject */
    function RateioEstoqueInsumoBiologicoController($scope, $state, model) {
        var vm = this;
        // Data
        vm.model = model;

        vm.gotoSearch = gotoSearch;

        init();

        function init() {
          console.log('RATEIO', vm.model);
        }

        function gotoSearch() {
            javascript:history.back(1);
       }
    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico')
        .controller('historicoEstoqueInsumoBiologicoController', HistoricoEstoqueInsumoBiologicoController);

    /** @ngInject */
    function HistoricoEstoqueInsumoBiologicoController(estoque_insumo, $state, estoqueInsumoBiologicoService, $mdDialog, cliente, $mdToast) {
        var vm = this;

        // Data
        vm.cliente = cliente;
        vm.models = [];
        vm.estoque_insumo = estoque_insumo;

        vm.gotoSearch = gotoSearch;
        vm.gotoVisualizarRateio = gotoVisualizarRateio;
        vm.search = search;
        vm.deletar = deletar;
        vm.deletarConfirm = deletarConfirm;

        function init() {
            //vm.estoque_insumo.unidade_medida = unidadeMedida(vm.estoque_insumo);
        }


        init();


        function search() {

            // vm.loadingProgress = true;

            // estoqueInsumoBiologicoService.queryHistoricoCompra(vm.estoque_insumo.insumo.id)
            //     .then(function successCallback(response) {
            //         vm.models = response.data;
            //         // vm.args.PropriedadeId = vm.propriedades[0].id;
            //     }).finally(function () {
            //         vm.loadingProgress = false;
            //     });
        }
        // search();

        /// Query
        vm.args = {
            id: vm.estoque_insumo.insumo.id,
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: 0,
            length_rows: 1,
            sort_by: 'id',
            sort_order: 'desc',
            _change: change
        };

        vm.args._change();

        function change() {

            vm.args.loading = true;
            estoqueInsumoBiologicoService.queryHistoricoCompra(vm.args)
                .then(function successCallback(response) {
                    vm.models = response.data;

                    vm.models = formatarModels(response.data);

                    // vm.total_cost = response.total_cost;
                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();

                }).finally(function () {
                    vm.args.loading = false;
                });
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar insumo?')
                .textContent('Tem certeza que deseja deletar esse insumo?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoBiologicoService.deletarCusto(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Insumo deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoSearch(id) {
            $state.go('app.estoque_insumo.biologico.buscar', {
                id: id
            });
        }

        function gotoVisualizarRateio(id) {
            $state.go('app.estoque_insumo.biologico.rateio', {
                id: id
            });
        }

        function unidadeMedida(model) {
            // , descricao: 'Mg (Miligrama)', formatado: input + ' mg'
            var estoque_insumo = unidadeMedidaFormat(model.quantidade, model.tipo_medida)

            return {
                quantidade: estoque_insumo.quantidade,
                sigla: estoque_insumo.sigla,
                nome: estoque_insumo.nome,
                descricao: estoque_insumo.sigla + " (" + estoque_insumo.nome + ")",
                formatado: estoque_insumo.quantidade + " " + estoque_insumo.sigla
            }
        }

        function unidadeMedidaFormat(input, tipo_medida) {

            if (tipo_medida == undefined)
                return { quantidade: input, sigla: '', nome: '' }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return { quantidade: input, sigla: 'mg', nome: 'Miligrama' }

                    if (input < 1000000)
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'g', nome: 'Grama' }

                    if (input < 1000000000)
                        return { quantidade: convertToDecimalCase((input / 1000000), 2), sigla: 'kg', nome: 'Quilograma' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000000000), 2), sigla: 'T', nome: 'Tonelada' }

                case 2: // Líquido

                    if (input < 1000)
                        return { quantidade: input, sigla: 'ml', nome: 'Mililitro' }
                    else
                        return { quantidade: convertToDecimalCase((input / 1000), 2), sigla: 'Litros', nome: 'Litros' }

                case 3: // Unidade
                    return { quantidade: input, sigla: 'un', nome: 'Unidade' }

                default:
                    return { quantidade: input, sigla: 'ml', nome: tipo_medida.nome }
            }
        }

        function convertToDecimalCase(number, decimal) {
            var n = parseFloat(number);

            if (Number.isInteger(n)) {
                return n;
            }
            else {
                if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                    return parseInt(number);

                return parseFloat(n.toFixed(decimal)).toLocaleString('pt-br', { minimumFractionDigits: 2 });
            }
        }

        function formatarModels(data) {

            var retorno = [];

            for (var index = 0; index < data.length; index++) {
                var model = data[index];

                model.valor_pago = model.estoque_insumo_rateio.valor / model.estoque_insumo_rateio.quantidade_origem * Math.abs(model.quantidade);
                if(model.valor_pago < 0.01){
                    model.valor_pago = 0.01;
                }

                if (model.estoque_insumo_lancamento_tipo.id == 2) {
                    model.tipo_acerto = (model.quantidade > 0) ? 'Acerto - Acrescentado' : 'Acerto - Retirado';
                } else {
                    model.tipo_acerto = model.estoque_insumo_lancamento_tipo.descricao
                }


                retorno.push(model);
            }

            return retorno;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico')
        .controller('CriarEstoqueInsumoBiologicoController', CriarEstoqueInsumoBiologicoController)
        //.controller('CriarLojaController', CriarLojaController) // ver criar.controller em semente
        .controller('CriarCadastroInsumoBiologicoController', CriarCadastroInsumoBiologicoController)


    /** @ngInject */
    function CriarEstoqueInsumoBiologicoController($rootScope, $scope, $state, $filter, estoqueInsumoBiologicoService, fornecedores, insumos, $mdDialog, $mdToast, model) {
        var vm = this;

        // Data
        vm.model = model;
        vm.api_response_erro = {};

        vm.fornecedores = fornecedores;
        vm.insumos = insumos;

        // Metodos
        vm.gotoAdd = gotoAdd;
        vm.gotoSearch = gotoSearch;
        vm.gotoLojaFornecedor = gotoLojaFornecedor;
        vm.gotoCadastroInsumo = gotoCadastroInsumo;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.showConfirm = showConfirm;
        vm.addInsumo = addInsumo;
        vm.removeInsumo = removeInsumo;
        vm.changeInsumo = changeInsumo;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        vm.showDialogCreateMarketplace = showDialogCreateMarketplace;
        vm.showDialogCreateInsumo = showDialogCreateInsumo;
        //////////


        init();

        function init() {
            addInsumo();

            vm.date = new Date();
        }

          function save(form, confirmType) {

               if (form.$invalid) {
               return;
               }

               $rootScope.loadingProgress = true;

               estoqueInsumoBiologicoService
               .create(vm.model)
               .then(function (response) {
                    $rootScope.loadingProgress = false;
                    // vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent('Estoque criado com sucesso!')
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );
                         (confirmType == 'Y')?gotoAdd():gotoSearch();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

        function showConfirm(form) {

            if (form.$invalid) {
                return;
            }

            var confirm = $mdDialog.confirm()
                .title('Atenção')
                .textContent('Gostaria de salvar um novo insumo no estoque?')
                .targetEvent(form)
                .ok('Sim, gostaria')
                .cancel('Não, não gostaria');

            $mdDialog
               .show(confirm)
               .then(function () {
                    save(form, 'Y')
               }, function () {
                    save(form, 'N')
               });
        };

        function gotoAdd() {
          $state.go('app.estoque_insumo.biologico.criar', {
              propriedade: vm.model.propriedade_Id
          });
        }

        function gotoSearch() {
            $state.go('app.estoque_insumo.biologico.buscar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function gotoLojaFornecedor() {
            $state.go('app.cadastros.fornecedor.buscar');
        }

        function gotoCadastroInsumo() {
            $state.go('app.estoque_insumo.cadastro_insumo.criar', {
                propriedade: vm.model.propriedade_id
            });
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }

        function addInsumo() {

            var insumo = { id: 0 };

            if (vm.insumos.length > 0) {
                insumo = vm.insumos[0]
            }

            vm.model.estoque.push({
                id: vm.model.estoque.length + 1,
                insumo: insumo,
                valor_pago: 0,
                quantidade: '',
                data_vencimento: undefined
            });
        }

        function removeInsumo(index) {
            vm.model.estoque.splice(index, 1);

            reorganizarIndexBiologicos();
        }

        function reorganizarIndexBiologicos() {

            for (var index = 0; index < vm.model.estoque.length; index++) {
                vm.model.estoque[index].id = index + 1;
            }
        }

        function changeInsumo(biologico) {
            console.log('changeInsumo', biologico);
            changeQuantidadeOuUnidadeDeMedida(biologico)
        }

        function changeQuantidadeOuUnidadeDeMedida(biologico) {

            biologico.tipo_medida_id = biologico.insumo.tipo_medida.id

            if (biologico.insumo != undefined)
                biologico.insumo_id = biologico.insumo.id


            biologico.valor = biologico.valor_pago;

            // $scope.$apply();
            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }

        }

        function showDialogCreateMarketplace(ev, lista_detalhes) {
            $mdDialog.show({
                controller: 'CriarLojaController as vm', // em criar.controller semente
                templateUrl: 'app/main/estoque_insumo/biologico/views/criar_loja.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        vm.fornecedores.push(answer);
                        vm.model.cliente_fornecedor_id = answer.id;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }

        function showDialogCreateInsumo(ev, biologico) {

            $mdDialog.show({
                controller: 'CriarCadastroInsumoBiologicoController as vm',
                templateUrl: 'app/main/estoque_insumo/biologico/views/criar_insumo.tmpl.html',
                resolve: {
                    tipo_insumo: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoInsumo();
                    },
                    tipo_medida: function (cadastrosCadastroInsumoService) {
                        return cadastrosCadastroInsumoService.getTipoMedida();
                    }
                },
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: true // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {

                    if (answer && answer.insumo_tipo_id == 1) {
                         console.log('add insumo', answer);
                         vm.insumos.push(answer);
                         biologico.insumo = answer;
                    }
                }, function () {
                    vm.model.cliente = null;
                });

        }


        // function initPropriedade() {
        //     for (let index = 0; index < vm.all_propriedades.length; index++) {

        //         const element = vm.all_propriedades[index];

        //         vm.propriedades.push({
        //             id: element.id,
        //             nome: element.nome
        //         });
        //     }
        // }

        // function initPropriedadeAreas() {
        //     for (let index = 0; index < vm.areas.length; index++) {

        //         const element = vm.areas[index];

        //         vm.propriedade_areas.push({
        //             propriedade_area_id: element.id,
        //             propriedade_area_nome: element.nome,
        //             propriedade_id: element.propriedade.id,
        //             propriedade_nome: element.propriedade.nome
        //         });
        //     }
        // }
    }

    function CriarCadastroInsumoBiologicoController($rootScope, $scope, $state, $filter, cadastrosCadastroInsumoService, areaService, tipo_medida, tipo_insumo, $q, $mdToast, $mdDialog) {


        var vm = this;

        // Data
        vm.model = {
            insumo_tipo_id: 1
        };
        vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        vm.tipo_insumo = tipo_insumo;
        vm.defensivos = [];
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.culturaSearch = culturaSearch;
        vm.listaAgrofitSearch = listaAgrofitSearch;
        vm.selectedItemChange = selectedItemChange;
        vm.changeInsumoTipo = changeInsumoTipo;
        vm.save = save;
        //////////

        init();

        function init() {
            // autoSelectTipoMedida();
            // autoSelectTipoInsumo();
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            // Força o tipo de insumo para biológico.
            vm.model.insumo_tipo_id = 1;

            var model = {
                estoque_insumo: [
                    vm.model
                ]
            }

            var message = '';
            this.savePromise = cadastrosCadastroInsumoService.create(model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.data[0].id;

                $mdDialog.hide({
                    id: vm.model.id,
                    nome: vm.model.nome,
                    insumo_tipo_id: vm.model.insumo_tipo_id,
                    tipo_medida_id: vm.model.tipo_medida_id,
                    tipo_medida: {
                        id: vm.model.tipo_medida_id,
                        descricao: response.data[0].unidade_medida
                    }
                });

                $mdToast.show(
                    $mdToast.simple()
                        .textContent($filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = response.data.data.errors;
                }

                vm.api_response_erro = response;
            });
        }

        function autoSelectTipoMedida() {

            if (vm.tipo_medida != undefined && vm.tipo_medida.length > 0)
                vm.model.tipo_medida_id = vm.tipo_medida[0].id;
        }

        function autoSelectTipoInsumo() {

            if (vm.tipo_insumo != undefined && vm.tipo_insumo.length > 0)
                vm.model.insumo_tipo_id = vm.tipo_insumo[0].id;
        }

        function changeInsumoTipo() {
            vm.model.insumo_agricola_id = undefined;

            if (vm.model.insumo_tipo_id == 4)
                vm.model.tipo_medida_id = 3;
            else
                if (vm.model.tipo_medida_id == 3)
                    vm.model.tipo_medida_id = 1;

            vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
        }

        function listaAgrofitSearch(query) {

            var deferred = $q.defer();

            var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
            promisse.then(function (response) {

                vm.defensivos = response.data;
                let retorno = [];

                for (let index = 0; index < response.data.length; index++) {
                    const element = response.data[index];
                    retorno.push(element.nome);
                }

                deferred.resolve(retorno)

            }).finally(function () {

            });

            return deferred.promise;
        }

        function culturaSearch(query) {

            var retorno = areaService.getCulturas(query);
            return retorno;
        }

        function selectedItemChange(nome) {

            if (nome == undefined) {
                vm.model.insumo_agricola_id = undefined;
                return;
            }

            let item = vm.defensivos.filter(function (obj) {
                return obj.nome == nome
            });

            vm.model.insumo_agricola_id = item[0].id;
        }

        function getTipoMedida(tipoInsumo) {

            var tipo_insumo = [];

            if (tipoInsumo == 4) {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 3, nome: 'Unidade' });
            } else {
                tipo_insumo.push({ id: 1, nome: 'Kg' });
                tipo_insumo.push({ id: 2, nome: 'L' });
            }

            return tipo_insumo;
        }

        function gotoSearch() {
            $mdDialog.hide();
        }


    }

})();

/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico')
        .controller('BuscarEstoqueInsumoBiologicoController', BuscarEstoqueInsumoBiologicoController);

    /** @ngInject */
    function BuscarEstoqueInsumoBiologicoController(data, $state, $stateParams, estoqueInsumoBiologicoService, propriedades, fornecedores, insumos, $mdDialog, $scope, $mdToast, $filter) {
        var vm = this;

        // DATAPICKER //////////////////
        var datapicker = document.querySelector('#dataspicker .date-picker-box');
        var datapickerActive = document.querySelector('#dataspicker');
        var periodoActive = document.querySelector('.select-periodo');

        // Data
        vm.total_cost = 0;
        vm.propriedades = propriedades;
        vm.fornecedores = fornecedores;
        vm.insumos = insumos;
        vm.gotoVisualizar = gotoVisualizar;
        vm.gotoAdd = gotoAdd;
        vm.gotoHistory = gotoHistory;
        vm.gotoAcerto = gotoAcerto;
        //vm.gotoPrint = gotoPrint;
        //vm.mdDialogCtrl = mdDialogCtrl;
        //vm.cliente = cliente;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;
        vm.isDetailOpened = false;
        vm.openDetail = openDetail;
        vm.closeDetail = closeDetail;
        vm.agrupados = [];

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;

        vm.periods = [
          {
              description: "Últimos 7 dias",
              value: 7
          },
          {
              description: "Últimos 15 dias",
              value: 15
          },
          {
              description: "Últimos 30 dias",
              value: 30
          },
          {
              description: "Últimos 3 meses",
              value: 90
          },
          {
              description: "Últimos 6 meses",
              value: 180
          }
        ];

        vm.model = {
            dataInicio: new Date(),
            dataFim: new Date()
        }


        function init() {

               periodoActive.classList.add("select-active");

               if (vm.propriedades == undefined || vm.propriedades.length == 0)
                    cadastroPropriedadeConfirm();

        }

        init();

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            sort_by: "id",
            sort_order: "desc",
            Fornecedor_id: null,
            insumo_id: null,
            numero_documento: "",
            compra_de: null,
            periodo: 30,
            compra_ate: null,
            _change: change
        }

        vm.args._change();

        function change() {

            closeAllDetail();

            vm.args.loading = true;
            estoqueInsumoBiologicoService.query(vm.args).then(function (response) {

                vm.models = response.data.estoques_insumo_model;

                console.log('change', vm.models);

                vm.args.total_rows = response.data.total_itens;
                vm.args.length_rows = vm.models.length;
                showActiveFilters();
                if(vm.args.updatePaggination)
                    vm.args.updatePaggination();

            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function clearPreDate() {
            vm.args.periodo = null
        }

        function clearRangeDate() {
            vm.args.compra_de = null
            vm.args.compra_ate = null
        }

        function resetFilters() {
            vm.args.Fornecedor_id = null;
            vm.args.insumo_id = null;
            vm.args.periodo = 30;
            vm.args.compra_de = null;
            vm.args.compra_ate = null;
            periodoActive.classList.add("select-active");
            datapickerActive.classList.remove("dates-active");
            vm.activeFilters = null;
            change();
        }

        function showActiveFilters(){
          vm.activeFilters = null;
          let periodoSelect;
          let arr = null;
          let inicio = $filter('date')(vm.args.compra_de,'dd/MM/yyyy');
          let fim = $filter('date')(vm.args.compra_ate,'dd/MM/yyyy');
          let fornecedores = vm.fornecedores;
          let fornecedorNome;
          let insumos = vm.insumos;
          let insumoNome;
          let counter = 0;
          for (let i = 0; i < vm.periods.length; i++) {
               if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
               };
          }
          for (let i = 0; i < fornecedores.length; i++) {
               if (fornecedores[i].id == vm.args.Fornecedor_id) {
                    fornecedorNome = fornecedores[i].nome
               };
          }
          for (let i = 0; i < insumos.length; i++) {
               if (insumos[i].id == vm.args.insumo_id) {
                    insumoNome = insumos[i].nome
               };
          }
          arr = [
               {
                    description: periodoSelect,
                    value: 'periodo'
               },
               {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
               },
               {
                    description: fornecedorNome,
                    value: 'Fornecedor_id'
               },
               {
                    description: insumoNome,
                    value: 'insumo_id'
               },
          ];

          for (let i = 0; i < arr.length; i++) {
               if (arr[i].description != null) counter++;
          }

          if(counter > 0){
               vm.activeFilters = arr;
          }
        }

        function desableFilter(value){
          if(value == 'datepicker'){
               vm.args.compra_de = null;
               vm.args.compra_ate = null;
               datapickerActive.classList.remove("dates-active");
          } else if(value == 'periodo'){
               periodoActive.classList.remove("select-active");
          }
          vm.args[value] = null;
          change();
        }

        function _sortBy(col) {

            if (vm.args.sort_by == col) {
                vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
                vm.args.sort_order = 'asc';
                vm.args.sort_by = col;
            }

            vm.args._change();
        }


        // function gotoPrint(model, ev) {

        //     var endereco = //cliente_endereco.endereco +
        //         ' ' +
        //         //.cliente_endereco.numero

        //     $mdDialog.show({
        //         locals: {
        //             dataToPass: {
        //                 codigo_fornecedor: //id,
        //                 data_expedicao: model.data_expedicao,
        //                 lote_numero: model.lote_numero,
        //                 nome_produtor: model.produtor_nome,
        //                 endereco: {
        //                     rua: model.produtor_endereco_rua,
        //                     numero: model.produtor_endereco_numero,
        //                     cidade: model.produtor_endereco_cidade_nome,
        //                     uf: model.produtor_endereco_uf
        //                 },
        //                 cnpj_cpf: model.produtor_cnpj_cpf,
        //                 telefone: {
        //                     ddd: model.produtor_telefone_ddd,
        //                     numero: model.produtor_telefone_numero
        //                 },
        //                 produto_nome: model.produto_nome,
        //                 produto_variedade: model.produto_variedade,
        //                 produto_embalagem_tipo: model.produto_embalagem_tipo,
        //                 produto_embalagem_peso: model.produto_embalagem_peso,
        //                 logado_nome: //nome,
        //                 logado_cnpj_cpf: //cnpj_cpf,
        //                 logado_endereco: endereco
        //             }
        //         },
        //         controller: mdDialogCtrl,
        //         templateUrl: 'app/main/registro/lote_producao/views/print-label.html',
        //         parent: angular.element(document.body),
        //         targetEvent: ev,
        //         clickOutsideToClose: true,
        //         fullscreen: false
        //     })
        //         .then(function (answer) {
        //             $scope.status = 'You said the information was "' + answer + '".';
        //         }, function () {
        //             $scope.status = 'You cancelled the dialog.';
        //         });
        // }

        // function mdDialogCtrl($scope, dataToPass) {
        //     $scope.model = dataToPass

        //     $scope.cancelar = function () {
        //         $mdDialog.cancel();
        //     };
        // }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Deletar rateio?')
                .textContent('Tem certeza que deseja deletar esse rateio?')
                .targetEvent(model)
                .ok('Sim, quero deletar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            estoqueInsumoBiologicoService.deletarCusto(model.id)
                .then(function (response) {

                    vm.agrupados.splice(vm.agrupados.indexOf(model), 1);

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Rateio deletado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {

                    var msgErro = 'Não foi possível deletar o rateio. Tente novamente.';

                    if (response.data.status == 422 && response.data.detail != undefined && response.data.detail != '')
                        msgErro = response.data.detail;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(msgErro)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                });
        }

        function gotoVisualizar(id) {
            $state.go('app.estoque_insumo.biologico.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.estoque_insumo.biologico.criar', {
                propriedade: vm.args.Propriedade_Id
            });
        }

        function gotoHistory(id) {
            $state.go('app.estoque_insumo.biologico.historico', {
                id: id
            });
        }
        function gotoAcerto(id) {
            $state.go('app.estoque_insumo.biologico.acerto', {
                id: id
            });
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }

        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');
            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        function openDetail(model) {

            vm.isDetailOpened = true;
            model.isOpen = true;

            consultarDatails(model)
        }

        function closeDetail(model) {

            vm.isDetailOpened = false;
            model.isOpen = false;

        }

        function closeAllDetail() {

            if (!vm.isDetailOpened)
                return;

            for (var index = 0; index < vm.models.length; index++) {
                var model = vm.models[index];

                model.isOpen = false
            }
            vm.isDetailOpened = false;
        }



        function consultarDatails(model) {
            model.isLoading = true;

            estoqueInsumoBiologicoService
                .queryRateio(model.id, model.insumo_id, model.tipo_medida.id)
                .then(function (response) {

                    vm.agrupados = response;

                }).finally(function () {

                    model.isLoading = false;

                    if (vm.agrupados == undefined)
                        vm.agrupados = [];

                    if (!$scope.$$phase) {
                        //$digest or $apply
                        $scope.$apply();
                    }
                });
        }

        function selectPropriedade() {

            if ($stateParams.propriedade != undefined && $stateParams.propriedade != '')
                return $stateParams.propriedade;

            if (vm.propriedades != undefined && vm.propriedades.length > 0)
                return vm.propriedades[0].id;
            else
                return undefined;
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               periodoActive.classList.add("select-active");
               datapickerActive.classList.remove("dates-active");
          }
          function openDatasSelect(){
               datapicker.style.display = "block";
          }
          function selecionarDatas(){
               vm.clearPreDate();
               datapicker.style.display = "none";
               datapickerActive.classList.add("dates-active");
               periodoActive.classList.remove("select-active");
          }
          function closedDatasSelect(){
               datapicker.style.display = "none";
               vm.args.date_inicio = null;
               vm.args.date_fim = null;
               datapickerActive.classList.remove("dates-active");
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo.biologico')
        .controller('AcertoEstoqueInsumoBiologicoController', AcertoEstoqueInsumoBiologicoController)


    /** @ngInject */
    function AcertoEstoqueInsumoBiologicoController($rootScope, $scope, $state, $filter, estoqueInsumoBiologicoService, estoque_insumo, $mdDialog, $mdToast) {
        var vm = this;

        // Data
        vm.model = {
            estoque_rateio_id: estoque_insumo.id,
            estoque_tipo_id: 1
        };
        vm.api_response_erro = {};

        vm.estoque_insumo_rateio = estoque_insumo;
        vm.tipos = [{ id: 1, nome: "Acerto" }, { id: 2, nome: "Perda" }];

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.cancelClick = cancelClick;
        vm.save = save;
        vm.changeTipoAcerto = changeTipoAcerto;
        vm.changeQuantidadeOuUnidadeDeMedida = changeQuantidadeOuUnidadeDeMedida;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = estoqueInsumoBiologicoService.createAcerto(vm.model);

            $rootScope.loadingProgress = true;
            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                vm.model.id = response.id;

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Acerto criado com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;

                if (response.data.errors == undefined) {
                    response.data.errors = {
                        quantidade: [response.data.detail]
                    };
                }

                vm.api_response_erro = response;
            });
        }


        function gotoSearch() {
            $state.go('app.estoque_insumo.biologico.buscar');
        }

        function getTipoAcertoEnum(model) {
            if (model.tipo.id == 2) {
                return 'Perda';
            } else {
                if (model.estoque_tipo_id == 1) {
                    return 'Acerto_Acrescentar';
                } else {
                    return 'Acerto_Remover';
                }
            }
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);

            }
        }


        function changeTipoAcerto() {
            if (vm.model.tipo.id == 1 && vm.model.estoque_tipo_id == undefined)
                vm.model.estoque_tipo_id = 1;

            vm.model.tipo_acerto = getTipoAcertoEnum(vm.model);
        }

        function changeQuantidadeOuUnidadeDeMedida() {

            //vm.model.quantidade = converterUnidadeMedidaParaMiligramaOuMililitro(vm.model.unidade_medida.id, vm.model.quantidade_produto);

            if ($scope.$root.$$phase != '$apply' && $scope.$root.$$phase != '$digest') {
                $scope.$apply();
            }
        }

    }
})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_comprados', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.compras.lotes_comprados', {
                    abstract: true,
                    url: '/lotes_comprados'
               })
               // .state('app.compras.lotes_comprados.buscar', {
               //      url: '/buscar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/compras/lotes_comprados/views/buscar.html',
               //                controller: 'BuscarCompradosController as vm'
               //           }
               //      },
               //      resolve: {
               //           data: function (compradosService) {
               //                return compradosService.query();
               //           },
               //           cliente: function (clientePerfilService) {
               //                return clientePerfilService.get();
               //           },
               //      }
               // })
               .state('app.compras.lotes_comprados.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/compras/lotes_comprados/views/visualizar.html',
                              controller: 'VisualizarCompradosController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, compradosService) {
                              return compradosService.get($stateParams.id);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/compras/lotes_comprados');

          //Menu
          // msNavigationServiceProvider.saveItem('rastreamento.lotes_comprados', {
          //      title: 'comprados',
          //      // icon: 'icon-document',
          //      state: 'app.compras.lotes_comprados.buscar',
          //      translate: 'COMPRAS.LOTES_COMPRADOS',
          //      weight: 4
          // });

     }
})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_comprados')
          .factory('compradosService', compradosService);

     /** @ngInject */
     function compradosService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               getNew: getNew,
               query: query,
               get: get,
               encerrarLote: encerrarLote,
               estornarLote: estornarLote,
               removerLote: removerLote
          };

          return service;

          //////////


          function getNew() {
               return {};
          }

          ////// LISTAR - PAGAMENTO ////// 
          function query(args, cache) {

               // cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               api.LoteDistribuicaoVendaComprados.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         models = response.data;
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          };
          ////// LISTAR - PAGAMENTO ////// 

          ////// CONSULTA POR ID - LOTE ////// 
          function get(id) {
               var deferred = $q.defer();

               api.LoteDistribuicao.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - LOTE ////// 


          ////// REMOVER LOTE ////// 
          function removerLote(id, idLote) {

               var deferred = $q.defer();

               api.LoteDistribuicaoConsolidacao.removerLote(id, idLote).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// REMOVER LOTE ////// 


          ////// ENCERRAR CADERNO CAMPO - LOTE ////// 
          function encerrarLote(model) {

               var deferred = $q.defer();

               api.LoteDistribuicao.encerrar(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// ENCERRAR CADERNO CAMPO - LOTE ////// 


          ////// ESTORNAR CADERNO CAMPO - LOTE ////// 
          function estornarLote(model) {

               var deferred = $q.defer();

               api.LoteDistribuicao.estornarEncerramento(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response.data);
                         // colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// ESTORNAR CADERNO CAMPO - LOTE ////// 

     }

})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_comprados')
          .controller('VisualizarCompradosController', VisualizarCompradosController);

     /** @ngInject */
     function VisualizarCompradosController($scope, $state, $filter, model, $mdToast, $mdDialog, compradosService, $rootScope, $location) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.ConfirmacaoEncerramento = ConfirmacaoEncerramento;
          vm.comeBack = comeBack;
          vm.ConfirmacaoEstorno = ConfirmacaoEstorno;
          vm.ConfirmacaoRemoverLote = ConfirmacaoRemoverLote;
          vm.gotoLoteProducao = gotoLoteProducao;
          vm.gotoLoteVenda = gotoLoteVenda;
          vm.encerrar = encerrar;
          vm.removerLote = removerLote;
          vm.estornar = estornar;
          vm.gotoSearch = gotoSearch;
          vm.back = back;
          vm.isFormValid = isFormValid;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }
          function comeBack(){
               javascript:history.back(1);   
          }
          function ConfirmacaoEncerramento(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Encerrar o lote?')
                    .textContent('Você tem certeza que gostaria de encerrar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não, depois encerro!');

               $mdDialog.show(confirm).then(function () {
                    encerrar(model);
               }, function () {
                    return null
               });
          };

          function ConfirmacaoEstorno(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estornar o lote?')
                    .textContent('Você tem certeza que gostaria de estornar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero estornar!')
                    .cancel('Não, depois estorno!');

               $mdDialog.show(confirm).then(function () {
                    estornar(model);
               }, function () {
                    return null
               });
          };

          function ConfirmacaoRemoverLote(consolidacao, lote) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Remover esse lote?')
                    .textContent('Você tem certeza que gostaria de remover esse lote da consolidação?')
                    .targetEvent(consolidacao, lote)
                    .ok('Sim, quero remover!')
                    .cancel('Não, não quero!');

               $mdDialog.show(confirm).then(function () {
                    removerLote(consolidacao, lote);
               }, function () {
                    return null
               });
          };

          function encerrar(model) {

               compradosService.encerrarLote(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTES_COMPRADOS.LOTE_ENCERRADO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch()
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function removerLote(consolidacao, lote) {

               compradosService.removerLote({
                    id: consolidacao.id,
                    idLote: lote.id
               })
                    .then(function (response) {

                         var itemConsolidacao = vm.model.lote_distribuicao_consolidacao_presentes[vm.model.lote_distribuicao_consolidacao_presentes.indexOf(consolidacao)];
                         itemConsolidacao.lote_distribuicao_consolidacao_lote_distribuicao_vinculos.splice(itemConsolidacao.lote_distribuicao_consolidacao_lote_distribuicao_vinculos.indexOf(lote), 1);

                         var message = $filter('translate')('LOTES_COMPRADOS.LOTE_REMOVIDO_CONSOLIDACAO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch()
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });

          }

          function estornar(model) {

               compradosService.estornarLote(model)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTES_COMPRADOS.LOTE_ESTORNADO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch()
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function gotoSearch() {
               $state.go('app.compras.lotes_comprados.buscar');
          }

          function gotoLoteProducao(id) {
               $state.go('app.registro.lote_producao.visualizar', {
                    id: id
               });
          }

          function gotoLoteVenda(id) {
               $state.go('app.compras.lotes_comprados.visualizar', {
                    id: id
               });
          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function back() {
               $state.go('app.compras.lotes_comprados.buscar');
           }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_comprados')
          .controller('BuscarCompradosController', BuscarCompradosController)
          .controller('VisualizarDistribuidorController', VisualizarDistribuidorController)


     /** @ngInject */
     function BuscarCompradosController(data, $state, $scope, compradosService, $mdDialog, cliente) {
          var vm = this;
          vm.models = data.data;
          // Data
          vm.gotoVisualizar = gotoVisualizar;
          vm.search = search;
          vm.gotoPrint = gotoPrint;
          vm.resetFilters = resetFilters;
          vm.showDialogFornecedor = showDialogFornecedor;
          vm.resetPagination = resetPagination;
          vm.clientePerfil = cliente;
          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               compradosService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               fornecedor_Id: null,
               cidade: null,
               data_inicial: null,
               data_Final: null,
               valor_De: null,
               valor_Ate: null,
               sort_by: 'data_expedicao',
               sort_order: 'desc',
               _change: change
          };

          vm.args._change();



          function resetFilters() {
               vm.args = {
                    loading: false,
                    page: 1,
                    per_page: 10,
                    page_sizes: [5, 10, 25, 100],
                    total_rows: data.total_rows,
                    length_rows: 1,
                    fornecedor_Id: null,
                    cidade: null,
                    data_inicial: null,
                    data_Final: null,
                    valor_De: null,
                    valor_Ate: null,
                    sort_by: 'data_expedicao',
                    sort_order: 'desc',
                    _change: change
               };
               change();
          }

          function resetPagination(){
               vm.args.page = 1;
          }

          function change() {
               vm.args.loading = true;
               compradosService.query(vm.args).then(function (response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function gotoPrint(model, ev) {

               var endereco = vm.clientePerfil.cliente_endereco.endereco +
                    ' ' +
                    vm.clientePerfil.cliente_endereco.numero

               // if (vm.clientePerfil.cliente_endereco.complemento.length > 0) {
               //      endereco += ' - ' + vm.clientePerfil.cliente_endereco.cidade_nome;
               // }

               //  endereco += ' ' + vm.clientePerfil.cliente_endereco.endereco +
               //       '-' + vm.clientePerfil.cliente_endereco.uf
               $mdDialog.show({
                    locals: {
                         dataToPass: {
                              codigo_fornecedor: vm.clientePerfil.id,
                              nome_clientePerfil: vm.clientePerfil.nome,
                              cnpj_cpf_clientePerfil: vm.clientePerfil.cnpj_cpf,
                              lote_numero: model.lote_numero,
                              nome_produtor: model.produtor_nome,
                              endereco: {
                                   rua: model.produtor_endereco_rua,
                                   numero: model.produtor_endereco_numero,
                                   cidade: model.produtor_endereco_cidade_nome,
                                   uf: model.produtor_endereco_uf
                              },
                              cnpj_cpf: model.produtor_cnpj_cpf,
                              telefone: {
                                   ddd: model.produtor_telefone_ddd,
                                   numero: model.produtor_telefone_numero
                              },
                              produto_nome: model.cultura,
                              produto_variedade: model.variedade,
                              // data_colheita: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.data_colheita,
                              data_expedicao: model.data_expedicao,
                              quantidade: model.quantidade,
                              unidade_medida: model.unidade_medida,
                              produto_embalagem_tipo: model.embalagem_tipo,
                              produto_embalagem_peso: model.embalagem_peso,
                              distribuidor_nome: model.cliente_distribuidor_nome ? model.cliente_distribuidor_nome : "null",
                              distribuidor_cnpj_cpf: model.cliente_distribuidor_cnpj_cpf ? model.cliente_distribuidor_cnpj_cpf : "null",
                              quantidade_etiquetas: model.quantidade_etiquetas,
                              tamanho_etiquetas: model.tamanho_etiquetas,
                              tipo_etiquetas: model.tipo_etiquetas,
                              id_lote: model.id

                         }
                    },
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/compras/lotes_comprados/views/print-label.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: false
               })
                    .then(function (answer) {
                         $scope.status = 'You said the information was "' + answer + '".';
                    }, function () {
                         $scope.status = 'You cancelled the dialog.';
                    });
          }

          function mdDialogCtrl($scope, dataToPass, $mdDialog) {

               $scope.rolo = 'Rolo'
               $scope.coluna = '2 Colunas'
               $scope.coluna_unity = '1 Coluna'
               $scope.coluna_3 = '3 Colunas'

               $scope.tamanho_etiquetas = [
                    {
                         id: 1,
                         tamanho: "100mm X 50mm"
                    }, {
                         id: 2,
                         tamanho: "120mm X 50mm"
                    }, {
                         id: 3,
                         tamanho: "60mm X 39mm (Logo)"
                    }, {
                         id: 4,
                         tamanho: "40mm X 25mm"
                    },
                    {
                         id: 5,
                         tamanho: "33mm X 21mm"
                    }
               ];

               $scope.tipo_etiquetas = [
                    {
                         id: 1,
                         tipo: "A4"
                    },
                    {
                         id: 2,
                         tipo: "Rolo"
                    }
               ];

               $scope.colunas = [
                    {
                         id: 1,
                         tipo: "1 coluna"
                    },
                    {
                         id: 2,
                         tipo: "2 colunas"
                    }
               ];

               $scope.Export = function (quantidade) {

                    for (var i = 1; i <= quantidade; i++) {

                         $("#imprimirdezporcincoa4").clone().appendTo("#printThis");

                         if (i % 10 === 0) {
                              $("#printThis").append("<div style='page-break-after:always'></div>");
                         }
                    }

                    var element = document.getElementById('printThis');
                    var opt = {
                         margin: 0.1,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              unit: 'in',
                              format: 'a4',
                              orientation: 'portrait'
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportRolo = function () {

                    $("#imprimirdezporcincorolo").clone().appendTo("#printThisRolo");

                    var element = document.getElementById('printThisRolo');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [107, 58]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportRolo2x = function () {

                    for (var i = 1; i <= 2; i++) {
                         $("#imprimirdezporcincorolo2x").clone().appendTo("#printThisRolo2x");
                    }

                    var element = document.getElementById('printThisRolo2x');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "portrait",
                              unit: "mm",
                              format: [107, 114]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }


               $scope.ExportDoze = function () {


                    $("#imprimirdozeporcinco").clone().appendTo("#printThisDoze");


                    var element = document.getElementById('printThisDoze');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [129, 58]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportDozeRotate = function () {

                    for (var i = 1; i <= 2; i++) {
                         $("#imprimirdozeporcincorotate").clone().appendTo("#printThisDozeRotate");
                    }

                    var element = document.getElementById('printThisDozeRotate');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [129, 119]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportSeisPorQuatro = function () {

                    for (var i = 1; i <= 2; i++) {
                         $("#imprimirseisporquatrorotate").clone().appendTo("#printThisSeisRotate");
                    }

                    var element = document.getElementById('printThisSeisRotate');
                    var opt = {
                         margin: 1,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "portrait",
                              unit: "mm",
                              format: [66, 93]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportQuatroPorDois = function () {

                    $("#imprimirquatropordoisemeio").clone().appendTo("#printThisQuatroPorDois");

                    var element = document.getElementById('printThisQuatroPorDois');
                    var opt = {
                         margin: 1,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [46, 32.9]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportTrintaETresPorVinteEUm = function () {

                    for (var i = 1; i <= 3; i++) {
                         $("#imprimirtrintaetresporvinteeum").clone().appendTo("#printThisTrintaETresPorVinteEUm");
                    }

                    var element = document.getElementById('printThisTrintaETresPorVinteEUm');
                    var opt = {
                         margin: 0,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              unit: 'mm',
                              format: [24, 104],
                              orientation: 'landscape'
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.vm = {
                    model: {
                         data: 'colheita'
                    }
               }
               $scope.model = dataToPass;

               $scope.model.url = getConfig().urlTracker + "home?lote=" + $scope.model.lote_numero;

               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function gotoVisualizar(id) {
               $state.go('app.compras.lotes_comprados.visualizar', {
                    id: id
               });
          }
          function showDialogFornecedor(ev, model) {
               $mdDialog.show({
                    locals: {
                         dataToPass: {
                              fornecedor_id: model.fornecedor_id,
                         }
                    },
                    controller: 'VisualizarDistribuidorController as vm',
                    templateUrl: 'app/main/compras/lotes_comprados/views/visualizar-fornecedor-tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               });

          }

          // function gotoPrintLabel(id) {
          //      $state.go('app.vendas.lote_venda.imprimir', {
          //           id: id
          //      });
          // }

     }



     function VisualizarDistribuidorController($rootScope, $scope, dataToPass, $state, $filter, cadastrosClienteService, $mdToast, $mdDialog) {


          var vm = this;
          $scope.model = dataToPass;

          // Data
          vm.model = {};
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.get = get;
          //////////

          init();

          function init() {
               vm.get();
          }


          function get() {

               cadastrosClienteService.getCliente($scope.model.fornecedor_id).then(function (response) {
                    vm.model = response;
               });
          }


          function gotoSearch() {
               $mdDialog.hide();
          }
     }




})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_externos', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.compras.lotes_externos', {
                    abstract: true,
                    url: '/lotes_externos'
               })
               // .state('app.compras.lotes_externos.buscar', {
               //      url: '/buscar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/compras/lotes_externos/views/buscar.html',
               //                controller: 'BuscarExternosController as vm'
               //           }
               //      },
               //      resolve: {
               //           data: function (externosService) {
               //                return externosService.query();
               //           },
               //           cliente: function (clientePerfilService) {
               //                return clientePerfilService.get();
               //           }
               //      }
               // })

               .state('app.compras.lotes_externos.criar', {
                    url: '/criar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/compras/lotes_externos/views/criar.html',
                              controller: 'CriarLotesExternosController as vm'
                         }
                    },
                    resolve: {
                         model: function (externosService) {
                              return externosService.getNew();
                         },
                         unidade: function (externosService) {
                              return externosService.getUnidade();
                         },
                         fornecedores: function (externosService) {
                              return externosService.getFornecedores();
                         }
                    }
               })
               .state('app.compras.lotes_externos.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/compras/lotes_externos/views/visualizar.html',
                              controller: 'VisualizarExternosController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, externosService) {
                              return externosService.get($stateParams.id);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/compras/lotes_externos');

          //Menu
          // msNavigationServiceProvider.saveItem('rastreamento.lotes_externos', {
          //      title: 'Comprar Lotes Externos',
          //      // icon: 'icon-document',
          //      state: 'app.compras.lotes_externos.buscar',
          //      translate: 'LOTES_EXTERNOS.COMPRAR_LOTES'
          // });

     }
})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_externos')
          .factory('externosService', externosService);

     /** @ngInject */
     function externosService($q, api, cadastrosFornecedorService) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};

          var service = {
               getNew: getNew,
               query: query,
               get: get,
               create: create,
               deletarLoteExterno: deletarLoteExterno,
               getUnidade: getUnidade,
               getFornecedores: getFornecedores,
               searchCultura: searchCultura,
               encerrarLote: encerrarLote,
               estornarLote:estornarLote
          };

          return service;

          //////////


          function getNew() {
               return {};
          }

          function getUnidade() {
               return [
                    "Quilos",
                    "Unidades"
               ]
          };

          ////// LISTAR - LOTES EXTERNOS ////// 
          function query(args, cache) {

               // cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               api.LoteDistribuicaoCompraExterna.query(args).$promise.then(
                    function (response) {
                         queryArgs = angular.copy(args);
                         models = response.data;
                         queryResponse = response;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });

               return deferred.promise;
          };
          ////// LISTAR - LOTES EXTERNOS ////// 


          ////// CRIAR - LOTES EXTERNOS ////// 
          function create(model) {

               var deferred = $q.defer();

               api.LoteDistribuicaoCompraExterna.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - LOTES EXTERNOS ////// 


          ////// CONSULTA POR ID - LOTES EXTERNOS ////// 
          function get(id) {
               var deferred = $q.defer();

               api.LoteDistribuicaoCompraExterna.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - LOTE ////// 


          ////// DELETAR - LOTE EXTERNO ////// 
          function deletarLoteExterno(id) {
          // Create a new deferred object
          var deferred = $q.defer();

          api.LoteDistribuicaoCompraExterna.delete({
               id: id
          }).$promise.then(
               function (response) {
                    //   Resolve the promise
                    deferred.resolve(response);

               }).catch(
               function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
               }
          );

          return deferred.promise;
     }
     ////// DELETAR - LOTE EXTERNO ////// 

     function getFornecedores() {

          var deferred = $q.defer();

          var args = {
               per_page: 999,
               sort_by: 'nome',
               sort_order: 'asc',
          };

          cadastrosFornecedorService.query(args, false).then(function (response) {
               deferred.resolve(response.data);
          }).catch(function (response) {
               deferred.reject(response);
               console.log(response);
          });

          return deferred.promise;
     }
     ////// CONSULTA DE FORNECEDOR ////// 
     
     ////// CONSULTA DE CULTURA - LOTES EXTERNOS ////// 
     function searchCultura(query) {
          var deferred = $q.defer();

          api.Cultura.query({
               query: query
          }).$promise.then(
               function (response) {
                    deferred.resolve(response.data);
               }

          ).catch(function (response) {
               deferred.reject(response);
               console.log(response);
          });
          return deferred.promise;
     }
     ////// CONSULTA DE CULTURA - LOTES EXTERNOS ////// 


     ////// ENCERRAR CADERNO CAMPO - LOTE ////// 
     function encerrarLote(id) {

          var deferred = $q.defer();

          api.LoteDistribuicao.encerrar({
               id: id
          }).$promise.then(

               // SUCCESS
               function (response) {
                    deferred.resolve(response.data);
                    // colheitas.unshift(model);
                    modelNew = {};
               }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
          return deferred.promise;
     }
     ////// ENCERRAR CADERNO CAMPO - LOTE ////// 


     ////// ESTORNAR CADERNO CAMPO - LOTE ////// 
     function estornarLote(id) {

          var deferred = $q.defer();

          api.LoteDistribuicao.estornarEncerramento({
               id: id
          }).$promise.then(

               // SUCCESS
               function (response) {
                    deferred.resolve(response.data);
                    // colheitas.unshift(model);
                    modelNew = {};
               }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
          return deferred.promise;
     }
     ////// ESTORNAR CADERNO CAMPO - LOTE ////// 

}

})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_externos')
          .controller('VisualizarExternosController', VisualizarExternosController);

     /** @ngInject */
     function VisualizarExternosController($scope, $state, $filter, model, $mdToast, $mdDialog, externosService, $rootScope, $location) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Filters
          vm.categoriesSelectFilter = '';

          // Methods
          vm.ConfirmacaoEncerramento = ConfirmacaoEncerramento;
          vm.comeBack = comeBack;
          vm.ConfirmacaoEstorno = ConfirmacaoEstorno;
          vm.encerrar = encerrar;
          vm.estornar = estornar;
          vm.gotoSearch = gotoSearch;
          vm.savePromise = null;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }
          function comeBack(){
               // console.log('oi')
               javascript:history.back(1);
          }

          function ConfirmacaoEncerramento(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Encerrar o lote?')
                    .textContent('Você tem certeza que gostaria de encerrar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não, depois encerro!');

               $mdDialog.show(confirm).then(function () {
                    encerrar(model);
               }, function () {
                    return null
               });
          };

          function ConfirmacaoEstorno(ev) {
               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Estornar o lote?')
                    .textContent('Você tem certeza que gostaria de estornar o lote?')
                    .targetEvent(ev)
                    .ok('Sim, quero estornar!')
                    .cancel('Não, depois estorno!');

               $mdDialog.show(confirm).then(function () {
                    estornar(model);
               }, function () {
                    return null
               });
          };

          function encerrar(model) {

               externosService.encerrarLote(model.lote_distribuicao_id)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTES_COMPRADOS.LOTE_ENCERRADO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch()
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function estornar(model) {

               externosService.estornarLote(model.lote_distribuicao_id)
                    .then(function (response) {
                         // vm.model.id = response.id
                         var message = $filter('translate')('LOTES_COMPRADOS.LOTE_ESTORNADO');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         gotoSearch()
                    }).catch(function (response) {
                         var message = $filter('translate')('LOTES_COMPRADOS.ERROR');
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }

          function gotoSearch() {
               $state.go('app.compras.lotes_externos.buscar');
          }

     }
})();

(function () {
    'use strict';

    angular
         .module('app.compras.lotes_externos')
         .controller('CriarLotesExternosController', CriarLotesExternosController)
         .controller('CriarFornecedorController', CriarFornecedorController)

    /** @ngInject */
    function CriarLotesExternosController($rootScope, $scope, $filter, $state, fornecedores, externosService, model, $mdToast, unidade, $mdDialog, $q, $controller) {
         var vm = this;

         // Data
         vm.model = model;
         vm.status = [];

         // Methods
         vm.save = save;
         vm.gotoSearch = gotoSearch;
         vm.isFormValid = isFormValid;
         vm.savePromise = null;
         vm.unidades = unidade;

         //Events
         vm.gotoSearch = gotoSearch;
     //     vm.showConfirm = showConfirm;
         vm.fornecedores = fornecedores;
         vm.api_response_erro = {};
         vm.culturaSearch = culturaSearch;
         vm.cancelClick = cancelClick;
         vm.showDialogCreateFornecedor = showDialogCreateFornecedor;
         //////////

         init();

         function init() {

         }

         $scope.$watch("vm.model.lote_producao_compra_externa.nome", function (newValue, oldValue) {

               var oldValue =  vm.model.lote_producao_compra_externa.nome;
               vm.model.lote_producao_compra_externa.cultura = oldValue;
               
          }, true);

         function save(form) {

              if (form.$invalid) {
                   return;
              }

              var message = '';
              var message = $filter('translate')('LOTES_EXTERNOS.LOTES_EXTERNOS_CREATED');

              this.savePromise = externosService.create(vm.model);
              $rootScope.loadingProgress = true;
              this.savePromise.then(function (colheita) {
                   $rootScope.loadingProgress = false;
                   model = colheita;
                   $mdToast.show(
                        $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                   );
                   gotoSearch();
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });;
         }

     //     function showConfirm(ev) {
     //          // Appending dialog to document.body to cover sidenav in docs app
     //          var confirm = $mdDialog.confirm()
     //               .title('Antes de finalizar')
     //               .textContent('Deseja encerrar a colheita nessa área?')
     //               .targetEvent(ev)
     //               .ok('Não, ainda há colheitas futuras aqui')
     //               .cancel('Sim, esta é a última colheita nesta área');

     //          $mdDialog.show(confirm).then(function () {
     //               gotoSearch();
     //          }, function () {
     //               encerrar(model.caderno_campo);
     //          });
     //     };

        

         function cancelClick(form, ev) {

              if (!form.$dirty) {
                   gotoSearch();
              } else {
                   var confirm = $mdDialog.confirm()
                        .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                        .targetEvent(ev)
                        .ok($filter('translate')('REGISTERS.DESCARTAR'))
                        .cancel($filter('translate')('REGISTERS.CANCELAR'));
                   $mdDialog.show(confirm).then(function () {
                        gotoSearch()
                   }, null);

              }
         }

         function gotoSearch() {
              $state.go('app.compras.lotes_externos.buscar');
         }

         function culturaSearch(query) {
              console.log(query);
              return externosService.searchCultura(query);
         }

         function isFormValid(formName) {
              if ($scope[formName] && $scope[formName].$valid) {
                   return $scope[formName].$valid;
              }
         }

         function showDialogCreateFornecedor(ev, lista_detalhes) {

            $mdDialog.show({
                 controller: 'CriarFornecedorController as vm',
                 templateUrl: 'app/main/compras/lotes_externos/views/criar_fornecedor.tmpl.html',
                 parent: angular.element(document.body),
                 targetEvent: ev,
                 clickOutsideToClose: false,
                 fullscreen: true // Only for -xs, -sm breakpoints.
            })
               //   .then(function (answer) {
               //        if (answer) {
               //             vm.fornecedores.push(answer);
               //             lista_detalhes.fornecedor = answer;
               //        }
               //   }, function () {
               //        vm.model.cliente = null;
               //   });

       }

    }

    function CriarFornecedorController($rootScope, $scope, $state, $filter, cadastrosFornecedorService, $mdToast, $mdDialog) {


        var vm = this;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        init();

        function init() {

             vm.model.pessoa_tipo = {
                  id: 1
             }

        }

        function save(form) {

             if (form.$invalid) {
                  return;
             }

             var message = '';
             var message = $filter('translate')('VENDA.CLIENTE_ADICIONADO');
             this.savePromise = cadastrosFornecedorService.create(vm.model);

             $rootScope.loadingProgress = true;
             this.savePromise.then(function (response) {
                  $rootScope.loadingProgress = false;
                  vm.model.id = response.id;

                  $mdDialog.hide(vm.model);


                  $mdToast.show(
                       $mdToast.simple()
                            .textContent(message)
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                  );
             }).catch(function (response) {
                  $rootScope.loadingProgress = false;
                  vm.api_response_erro = response;
             });
        }

        function gotoSearch() {
             //$state.go('app.cadastros.buscar');
             $mdDialog.hide();
        }
   }

})();

(function () {
     'use strict';

     angular
          .module('app.compras.lotes_externos')
          .controller('BuscarExternosController', BuscarExternosController)
          .controller('VisualizarFornecedorController', VisualizarFornecedorController);

     /** @ngInject */
     function BuscarExternosController(data, $state, $scope, externosService, $filter, $mdToast, $mdDialog, cliente) {
          var vm = this;
          vm.models = data.data;
          // Data
          vm.gotoVisualizar = gotoVisualizar;
          vm.search = search;
          vm.gotoPrint = gotoPrint;
          vm.gotoComprar = gotoComprar;
          vm.clientePerfil = cliente;
          vm.resetFilters = resetFilters;
          vm.deletarConfirm = deletarConfirm;
          vm.showDialogFornecedor = showDialogFornecedor;
          vm.deletar = deletar;
          vm.resetPagination = resetPagination;
          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               externosService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               variedade: null,
               fornecedor_Id: null,
               cultura: null,
               sort_by: 'data_expedicao',
               sort_order: 'desc',
               _change: change
          };

          vm.args._change();


          function resetFilters(){
               vm.args = {
                    loading: false,
                    page: 1,
                    per_page: 10,
                    page_sizes: [5, 10, 25, 100],
                    total_rows: data.total_rows,
                    length_rows: 1,
                    variedade: null,
                    fornecedor_Id: null,
                    cultura: null,
                    sort_by: 'data_expedicao',
                    sort_order: 'desc',
                    _change: change
               };
               change();

          }

          function change() {
               
               vm.args.loading = true;
               externosService.query(vm.args).then(function (response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function () {
                    vm.args.loading = false;
               });
          }
          function resetPagination(){
               vm.args.page = 1;
          }


          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                    .title('Cancelar lote externo?')
                    .textContent('Tem certeza que deseja cancelar este lote externo?')
                    .targetEvent(model)
                    .ok('Sim, quero cancelar!')
                    .cancel('Não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          };

          function deletar(model) {
               externosService.deletarLoteExterno(model.id)
                    .then(function (response) {
                         vm.models.compras_externas.splice(vm.models.compras_externas.indexOf(model), 1);
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent($filter('translate')('LOTES_EXTERNOS.DELETE'))
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );

                    }).catch(function (response) {

                         $mdToast.show(
                              $mdToast.simple()
                              .textContent($filter('translate')('LOTES_EXTERNOS.DONT_DELETE'))
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }

          function showDialogFornecedor(ev, model) {
               
               $mdDialog.show({
                    locals: {
                         dataToPass: {
                              fornecedorId: model.fornecedor_id,
                         }
                    },
                    controller: 'VisualizarFornecedorController as vm',
                    templateUrl: 'app/main/compras/lotes_comprados/views/visualizar-fornecedor-tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               });

          }

          function gotoPrint(model, ev) {

               var endereco = vm.clientePerfil.cliente_endereco.endereco +
                    ' ' +
                    vm.clientePerfil.cliente_endereco.numero

               $mdDialog.show({
                    locals: {
                         dataToPass: {
                              codigo_fornecedor: vm.clientePerfil.id,
                              lote_numero: model.lote_distribuicao.lote_numero,
                              nome_produtor: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_nome,
                              endereco: {
                                   rua: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_rua,
                                   numero: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_numero,
                                   cidade: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_cidade_nome,
                                   uf: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_endereco_uf
                              },
                              cnpj_cpf: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_cnpj_cpf,
                              telefone: {
                                   ddd: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_telefone_ddd,
                                   numero: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produtor_telefone_numero
                              },
                              produto_nome: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produto_nome,
                              produto_variedade: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.produto_variedade,
                              // data_colheita: model.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.data_colheita,
                              data_expedicao: model.data_expedicao,
                              quantidade: model.quantidade,
                              unidade_medida: model.unidade_medida,
                              produto_embalagem_tipo: model.embalagem_tipo,
                              produto_embalagem_peso: model.embalagem_peso,
                              distribuidor_nome: model.cliente_distribuidor ? model.cliente_distribuidor.nome : "null",
                              distribuidor_cnpj_cpf: model.cliente_distribuidor ? model.cliente_distribuidor.cnpj_cpf : "null",
                              quantidade_etiquetas: model.quantidade_etiquetas,
                              tamanho_etiquetas: model.tamanho_etiquetas,
                              tipo_etiquetas: model.tipo_etiquetas

                         }
                    },
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/compras/lotes_externos/views/print-label.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: false
               })
                    .then(function (answer) {
                         $scope.status = 'You said the information was "' + answer + '".';
                    }, function () {
                         $scope.status = 'You cancelled the dialog.';
                    });
          }

          function mdDialogCtrl($scope, dataToPass, $mdDialog) {

               $scope.rolo = 'Rolo'

               $scope.tamanho_etiquetas = [{
                    id: 1,
                    tamanho: "100mm X 50mm"
               }, {
                    id: 2,
                    tamanho: "120mm X 50mm"
               }];

               $scope.tipo_etiquetas = [{
                    id: 1,
                    tipo: "A4"
               },
               {
                    id: 2,
                    tipo: "Rolo"
               }
               ];

               $scope.colunas = [{
                    id: 1,
                    tipo: "1 coluna"
               },
               {
                    id: 2,
                    tipo: "2 colunas"
               }
               ];

               $scope.Export = function (quantidade) {

                    for (var i = 1; i <= quantidade; i++) {

                         $("#imprimirdezporcincoa4").clone().appendTo("#printThis");

                         if (i % 10 === 0) {
                              $("#printThis").append("<div style='page-break-after:always'></div>");
                         }
                    }

                    var element = document.getElementById('printThis');
                    var opt = {
                         margin: 0.1,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              unit: 'in',
                              format: 'a4',
                              orientation: 'portrait'
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportRolo = function () {

                    $("#imprimirdezporcincorolo").clone().appendTo("#printThisRolo");

                    var element = document.getElementById('printThisRolo');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [108, 58]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }


               $scope.ExportDoze = function () {


                    $("#imprimirdozeporcinco").clone().appendTo("#printThisDoze");


                    var element = document.getElementById('printThisDoze');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [129, 58]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }

               $scope.ExportDozeRotate = function () {

                    for (var i = 1; i <= 2; i++) {
                         $("#imprimirdozeporcincorotate").clone().appendTo("#printThisDozeRotate");
                    }

                    var element = document.getElementById('printThisDozeRotate');
                    var opt = {
                         margin: 0.5,
                         filename: 'myfile.pdf',
                         image: {
                              type: 'jpeg',
                              quality: 1
                         },
                         html2canvas: {
                              scale: 2,
                              logging: true
                         },
                         jsPDF: {
                              orientation: "landscape",
                              unit: "mm",
                              format: [129, 112]
                         }
                    };
                    html2pdf(element, opt);
                    $mdDialog.hide();
               }



               $scope.vm = {
                    model: {
                         data: 'colheita'
                    }
               }
               $scope.model = dataToPass;

               $scope.model.url = getConfig().urlBase + "vendas/lotes/distribuicao/visualizar/" + $scope.model.lote_numero;

               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function gotoVisualizar(id) {
               $state.go('app.compras.lotes_externos.visualizar', {
                    id: id
               });
          }

          function gotoComprar() {
               $state.go('app.compras.lotes_externos.criar');
          }

     }



     function VisualizarFornecedorController($rootScope, $scope, dataToPass, $state, $filter, cadastrosFornecedorService, $mdToast, $mdDialog) {


          var vm = this;
          $scope.model = dataToPass;

          // Data
          vm.model = {};
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.get = get;
          //////////

          init();

          function init() {
               vm.get();
          }


          function get() {

               cadastrosFornecedorService.get($scope.model.fornecedorId).then(function (response) {
                    vm.model = response;
               });
          }


          function gotoSearch() {
               $mdDialog.hide();
          }
     }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.despesa_nome', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.cadastros.despesa_nome', {
                   abstract: true,
                   url: '/despesa_nome'
              })
          //     .state('app.cadastros.despesa_nome.buscar', {
          //          url: '/buscar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/cadastros/despesa_nome/views/buscar.html',
          //                    controller: 'buscarNomeDespesaController as vm'
          //               }
          //          },
          //          resolve: {
          //               data: function (cadastrosDespesaNomeService) {
          //                    return cadastrosDespesaNomeService.query();
          //               }
          //          }
          //     })
          //     .state('app.cadastros.despesa_nome.criar', {
          //          url: '/criar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/cadastros/despesa_nome/views/criar.html',
          //                    controller: 'criarNomeDespesaController as vm'
          //               }
          //          },
          //          resolve: {
          //               model: function (cadastrosDespesaNomeService) {
          //                    return cadastrosDespesaNomeService.getNew();
          //               }
          //          }
          //     })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/cadastros/despesa_nome');
         

     //     //Menu
     //     msNavigationServiceProvider.saveItem('cadastros.despesa_nome', {
     //          title: 'cadastros',
     //          state: 'app.cadastros.despesa_nome.buscar',
     //          translate: 'DESPESA_NOME.DESPESA_NOME'
     //     });

    }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.despesa_nome')
          .factory('cadastrosDespesaNomeService', cadastrosDespesaNomeService);

     /** @ngInject */
     function cadastrosDespesaNomeService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};
          var service = {
               query: query,
               getNew: getNew,
               create: create,
               deleteNomeDespesa: deleteNomeDespesa
          };

          return service;


          function getNew() {
               return modelNew;
          }

          //////////

          ////// LISTAR - NomeDespesa ////// 
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.DespesaNome.query(args).$promise.then(
                         function (response) {
                              
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - NomeDespesa ////// 

          ////// CRIAR - NomeDespesa ////// 
          function create(model) {

               var deferred = $q.defer();

               api.DespesaNome.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CRIAR - NomeDespesa ////// 

          ////// DELETAR - NomeDespesa ////// 
          function deleteNomeDespesa(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.DespesaNome.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// DELETAR - NomeDespesa ////// 


     }

})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.profissional', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.cadastros.profissional', {
                   abstract: true,
                   url: '/profissional'
              })
              .state('app.cadastros.profissional.buscar', {
                   url: '/buscar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/profissional/views/buscar.html',
                             controller: 'buscarProfissionalController as vm'
                        }
                   },
                   resolve: {
                        data: function (cadastrosProfissionalService) {
                             return cadastrosProfissionalService.query();
                        }
                   }
              })
              .state('app.cadastros.profissional.criar', {
                   url: '/criar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/profissional/views/criar.html',
                             controller: 'criarProfissionalController as vm'
                        }
                   },
                   resolve: {
                        model: function (cadastrosProfissionalService) {
                             return cadastrosProfissionalService.getNew();
                        }
                   }
              })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/cadastros');
         $translatePartialLoaderProvider.addPart('app/main/cadastros/profissional');

         //Menu
         msNavigationServiceProvider.saveItem('cadastros.profissional', {
              title: 'cadastros',
              state: 'app.cadastros.profissional.buscar',
              translate: 'PROFISSIONAL.PROFISSIONAL'
         });

    }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.profissional')
         .factory('cadastrosProfissionalService', cadastrosProfissionalService);

    /** @ngInject */
    function cadastrosProfissionalService($q, api) {

         var models = [];
         var queryResponse = {};
         var queryArgs = {};
         var modelNew = {};
         var service = {
              query: query,
              getNew: getNew,
              create: create,
              deleteProfissional: deleteProfissional
         };

         return service;


         function getNew() {
              return modelNew;
         }

         //////////

         ////// LISTAR - PROFISSIONAL ////// 
         function query(args, cache) {

              cache = (typeof cache !== 'undefined') ? cache : true;
              args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

              var deferred = $q.defer();

              if (cache && angular.equals(args, queryArgs)) {
                   deferred.resolve(queryResponse);
              } else {
                   api.TipoProfissional.query(args).$promise.then(
                        function (response) {
                             queryArgs = angular.copy(args);
                             models = response.data;
                             queryResponse = response;
                             deferred.resolve(response);
                        }

                   ).catch(function (response) {
                        deferred.reject(response);
                   });
              }
              return deferred.promise;
         };
         ////// LISTAR - PROFISSIONAL ////// 

         ////// CRIAR - PROFISSIONAL ////// 
         function create(model) {

              var deferred = $q.defer();

              api.TipoProfissional.save(model).$promise.then(

                   // SUCCESS
                   function (response) {
                        deferred.resolve(response);
                        modelNew = {};
                   }).catch(
                   function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                   }
              );
              return deferred.promise;
         }
         ////// CRIAR - PROFISSIONAL ////// 

         ////// DELETAR - PROFISSIONAL ////// 
         function deleteProfissional(id) {
              // Create a new deferred object
              var deferred = $q.defer();

              api.TipoProfissional.delete({
                   id: id
              }).$promise.then(
                   function (response) {
                        //   Resolve the promise
                        deferred.resolve(response);

                   }).catch(
                   function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                   }
              );

              return deferred.promise;
         }
         ////// DELETAR - PROFISSIONAL ////// 


    }

})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.profissional')
         .controller('criarProfissionalController', criarProfissionalController);

    /** @ngInject */
    function criarProfissionalController($rootScope, $scope, $state, $filter, model, cadastrosProfissionalService, cadastrosDistribuidorService, $mdToast, $mdDialog) {
         var vm = this;

         // Data
         vm.model = model;
         vm.api_response_erro = {};

         // Metodos
         vm.citySearch = citySearch;
         vm.gotoSearch = gotoSearch;
         vm.save = save;
         //////////

         init();

         function init() {
         }

         function save(form) {

              if (form.$invalid) {
                   return;
              }

              var message = '';
              this.savePromise = cadastrosProfissionalService.create(vm.model);

              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                             .textContent($filter('translate')('PROFISSIONAL.PROFISSIONAL_ADICIONADO'))
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                   );
                   gotoSearch()
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }

         function citySearch(query) {
              console.log(query);
              var retorno = cadastrosProfissionalService.getCity(query);
              return retorno;
         }

         function gotoSearch() {
              $state.go('app.cadastros.profissional.buscar');
         }

    }
})();
(function () {
    'use strict';

    angular
         .module('app.cadastros.profissional')
         .controller('buscarProfissionalController', buscarProfissionalController);

    /** @ngInject */
    function buscarProfissionalController(data, $state, $filter, cadastrosProfissionalService, $mdDialog, $mdToast, $scope) {
         var vm = this;

         // Data
         vm.search = search;
         vm.gotoAddClient = gotoAddClient;
         vm.gotoVisualizar = gotoVisualizar;
         vm.gotoEditar = gotoEditar;
         vm.deletarConfirm = deletarConfirm;
         vm.deletar = deletar;
         vm.resetFilters = resetFilters;
         vm.showActiveFilters = showActiveFilters;
         vm.desableFilter = desableFilter;
         //////////

          //     init();

          //     function init() {

          //     }

         function search() {

              vm.loadingProgress = true;
              cadastrosProfissionalService.query()
                   .then(function successCallback(data) {
                        vm.models = data;
                   }).finally(function () {
                        vm.loadingProgress = false;
                   });
         }

         /// Query
         vm.args = {
              loading: false,
              page: 1,
              per_page: 10,
              page_sizes: [5, 10, 25, 100],
              total_rows: data.total_rows,
              length_rows: 1,
              sort_by: 'id',
              sort_order: 'asc',
              nome: null,
              _change: change
         };

         vm.args._change();

         function change() {
              vm.args.loading = true;
              cadastrosProfissionalService.query(vm.args).then(function (response) {
                   vm.models = response.data;
                   vm.args.total_rows = response.total_rows;
                   vm.args.length_rows = vm.models.length;
                   showActiveFilters();
                   vm.args.updatePaggination();
              }).finally(function () {
                   vm.args.loading = false;
              });
         }

         function resetFilters() {
               vm.args.nome = null;
               vm.activeFilters = null;
               change();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let arr = null;
               let counter = 0;
               arr = [
                    {
                         description: vm.args.nome,
                         value: 'nome'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value){
               vm.args[value] = null;
               change();
          }

         function _sortBy(col) {

              if (vm.args.sort_by == col) {

                   vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

              } else {
                   vm.args.sort_order = 'asc';
                   vm.args.sort_by = col;
              }

              vm.args._change();

         }

         function deletarConfirm(model) {

              var confirm = $mdDialog.confirm()
                   .title('Deletar profissional?')
                   .textContent('Tem certeza que deseja deletar esse profissional?')
                   .targetEvent(model)
                   .ok('Sim, quero deletar!')
                   .cancel('Não quero!');

              $mdDialog.show(confirm)
                   .then(function () {
                        deletar(model);
                   }, function () {
                        return null
                   });
         };

         function deletar(model) {

              var message = $filter('translate')('PROFISSIONAL.PROFISSIONAL_DELETADO');

              cadastrosProfissionalService.deleteProfissional(model.id)
                   .then(function (response) {
                        vm.models.splice(vm.models.indexOf(model), 1);
                        $mdToast.show(
                             $mdToast.simple()
                             .textContent(message)
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                        );

                   }).catch(function (response) {
                         vm.api_response_erro = response;
                   });
         }

         function gotoAddClient() {
              $state.go('app.cadastros.profissional.criar');
         }

         function gotoVisualizar(id) {
              $state.go('app.cadastros.profissional.visualizar', {
                   id: id
              });
         }

         function gotoEditar(id) {
              $state.go('app.cadastros.profissional.editar', {
                   id: id
              });
         }

    }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.maquina', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.cadastros.maquina', {
                   abstract: true,
                   url: '/maquina'
              })
              .state('app.cadastros.maquina.buscar', {
                   url: '/buscar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/maquina/views/buscar.html',
                             controller: 'buscarMaquinaController as vm'
                        }
                   },
                   resolve: {
                        data: function (cadastrosMaquinaService) {
                             return cadastrosMaquinaService.query();
                        }
                   }
              })
              .state('app.cadastros.maquina.criar', {
                   url: '/criar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/maquina/views/criar.html',
                             controller: 'criarMaquinaController as vm'
                        }
                   },
                   resolve: {
                        model: function (cadastrosMaquinaService) {
                             return cadastrosMaquinaService.getNew();
                        }
                   }
              })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/cadastros');
         $translatePartialLoaderProvider.addPart('app/main/cadastros/maquina');

         //Menu
         msNavigationServiceProvider.saveItem('cadastros.maquina', {
              title: 'cadastros',
              state: 'app.cadastros.maquina.buscar',
              translate: 'MAQUINA.MAQUINA'
         });

    }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.maquina')
         .factory('cadastrosMaquinaService', cadastrosMaquinaService);

    /** @ngInject */
    function cadastrosMaquinaService($q, api) {

         var models = [];
         var queryResponse = {};
         var queryArgs = {};
         var modelNew = {};
         var service = {
              query: query,
              getNew: getNew,
              create: create,
              deleteMaquina: deleteMaquina
         };

         return service;


         function getNew() {
              return modelNew;
         }

         //////////

         ////// LISTAR - CLIENTE MAQUINA ////// 
         function query(args, cache) {

              cache = (typeof cache !== 'undefined') ? cache : true;
              args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

              var deferred = $q.defer();

              if (cache && angular.equals(args, queryArgs)) {
                   deferred.resolve(queryResponse);
              } else {
                   api.Equipamento.query(args).$promise.then(
                        function (response) {
                             queryArgs = angular.copy(args);
                             models = response.data;
                             queryResponse = response;
                             deferred.resolve(response);
                        }

                   ).catch(function (response) {
                        deferred.reject(response);
                        console.log(response);
                   });
              }
              return deferred.promise;
         };
         ////// LISTAR - CLIENTE MAQUINA ////// 

         ////// CRIAR - CLIENTE MAQUINA ////// 
         function create(model) {

              var deferred = $q.defer();

              api.Equipamento.save(model).$promise.then(

                   // SUCCESS
                   function (response) {
                        deferred.resolve(response);
                        modelNew = {};
                   }).catch(
                   function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                   }
              );
              return deferred.promise;
         }
         ////// CRIAR - CLIENTE MAQUINA ////// 

         ////// DELETAR - MAQUINA ////// 
         function deleteMaquina(id) {
              // Create a new deferred object
              var deferred = $q.defer();

              api.Equipamento.delete({
                   id: id
              }).$promise.then(
                   function (response) {
                        //   Resolve the promise
                        deferred.resolve(response);

                   }).catch(
                   function (response) {
                        //   Resolve the promise
                        deferred.reject(response);
                   }
              );

              return deferred.promise;
         }
         ////// DELETAR - MAQUINA ////// 


    }

})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.maquina')
         .controller('criarMaquinaController', criarMaquinaController);

    /** @ngInject */
    function criarMaquinaController($rootScope, $scope, $state, $filter, model, cadastrosMaquinaService, cadastrosDistribuidorService, $mdToast, $mdDialog) {
         var vm = this;

         // Data
         vm.model = model;
         vm.api_response_erro = {};

         // Metodos
         vm.citySearch = citySearch;
         vm.gotoSearch = gotoSearch;
         vm.save = save;
         //////////

         init();

         function init() {

              vm.model.pessoa_tipo = {
                   id: 1
              }

         }

         function save(form) {

              if (form.$invalid) {
                   return;
              }

              var message = '';
              this.savePromise = cadastrosMaquinaService.create(vm.model);

              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                             .textContent($filter('translate')('MAQUINA.MAQUINA_ADICIONADO'))
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                   );
                   gotoSearch()
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }

         function citySearch(query) {
              console.log(query);
              var retorno = cadastrosMaquinaService.getCity(query);
              return retorno;
         }

         function gotoSearch() {
              $state.go('app.cadastros.maquina.buscar');
         }

    }
})();
(function () {
    'use strict';

    angular
         .module('app.cadastros.maquina')
         .controller('buscarMaquinaController', buscarMaquinaController);

    /** @ngInject */
    function buscarMaquinaController(data, $state, $filter, cadastrosMaquinaService, $mdDialog, $mdToast, $scope) {
         var vm = this;

         // Data
         vm.search = search;
         vm.gotoAddClient = gotoAddClient;
         vm.gotoVisualizar = gotoVisualizar;
         vm.gotoEditar = gotoEditar;
         vm.deletarConfirm = deletarConfirm;
         vm.deletar = deletar;
         vm.resetFilters = resetFilters;
         vm.showActiveFilters = showActiveFilters;
         vm.desableFilter = desableFilter;
         //////////

          //     init();

          //     function init() {

          //     }

         function search() {

              vm.loadingProgress = true;
              cadastrosMaquinaService.query()
                   .then(function successCallback(data) {
                        vm.models = data;
                   }).finally(function () {
                        vm.loadingProgress = false;
                   });
         }

         /// Query
         vm.args = {
              loading: false,
              page: 1,
              per_page: 10,
              page_sizes: [5, 10, 25, 100],
              total_rows: data.total_rows,
              length_rows: 1,
              sort_by: 'id',
              sort_order: 'asc',
              _change: change
         };

         vm.args._change();

         function change() {
              vm.args.loading = true;
              cadastrosMaquinaService.query(vm.args).then(function (response) {
                   vm.models = response.data;
                   vm.args.total_rows = response.total_rows;
                   vm.args.length_rows = vm.models.length;
                   showActiveFilters();
                   vm.args.updatePaggination();
              }).finally(function () {
                   vm.args.loading = false;
              });
         }

         function resetFilters() {
               vm.args.nome = null;
               vm.activeFilters = null;
               change();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let arr = null;
               let counter = 0;
               arr = [
                    {
                         description: vm.args.nome,
                         value: 'nome'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value){
               vm.args[value] = null;
               change();
          }

         function _sortBy(col) {

              if (vm.args.sort_by == col) {

                   vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

              } else {
                   vm.args.sort_order = 'asc';
                   vm.args.sort_by = col;
              }

              vm.args._change();

         }

         function deletarConfirm(model) {

              var confirm = $mdDialog.confirm()
                   .title('Deletar máquina?')
                   .textContent('Tem certeza que deseja deletar essa máquina?')
                   .targetEvent(model)
                   .ok('Sim, quero deletar!')
                   .cancel('Não quero!');

              $mdDialog.show(confirm)
                   .then(function () {
                        deletar(model);
                   }, function () {
                        return null
                   });
         };

         function deletar(model) {

              console.log('teste')

              var message = $filter('translate')('MAQUINA.MAQUINA_DELETADO');

              cadastrosMaquinaService.deleteMaquina(model.id)
                   .then(function (response) {
                        vm.models.splice(vm.models.indexOf(model), 1);
                        $mdToast.show(
                             $mdToast.simple()
                             .textContent(message)
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                        );

                   }).catch(function (response) {

                        // TODO mensagem de erro
                   });
         }

         function gotoAddClient() {
              $state.go('app.cadastros.maquina.criar');
         }

         function gotoVisualizar(id) {
              $state.go('app.cadastros.maquina.visualizar', {
                   id: id
              });
         }

         function gotoEditar(id) {
              $state.go('app.cadastros.maquina.editar', {
                   id: id
              });
         }

    }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.fornecedor', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.cadastros.fornecedor', {
                   abstract: true,
                   url: '/fornecedor'
              })
              .state('app.cadastros.fornecedor.buscar', {
                   url: '/buscar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/fornecedor/views/buscar.html',
                             controller: 'buscarFornecedorController as vm'
                        }
                   },
                   resolve: {
                        data: function (cadastrosFornecedorService) {
                             return cadastrosFornecedorService.query();
                        }
                   }
              })
              .state('app.cadastros.fornecedor.criar', {
                   url: '/criar',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/fornecedor/views/criar.html',
                             controller: 'criarFornecedorController as vm'
                        }
                   },
                   resolve: {
                        model: function (cadastrosFornecedorService) {
                             return cadastrosFornecedorService.getNew();
                        }
                   }
              })
              .state('app.cadastros.fornecedor.visualizar', {
                   url: '/visualizar/:id',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/fornecedor/views/visualizar.html',
                             controller: 'visualizarFornecedorController as vm'
                        }
                   },
                   resolve: {
                        model: function ($stateParams, cadastrosFornecedorService) {
                             return cadastrosFornecedorService.get($stateParams.id);
                        }
                   }
              })
              .state('app.cadastros.fornecedor.editar', {
                   url: '/editar/:id',
                   views: {
                        'content@app': {
                             templateUrl: 'app/main/cadastros/fornecedor/views/editar.html',
                             controller: 'editarFornecedorController as vm'
                        }
                   },
                   resolve: {
                        model: function ($stateParams, cadastrosFornecedorService) {
                             return cadastrosFornecedorService.get($stateParams.id);
                        }
                   }
              })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/cadastros');
         $translatePartialLoaderProvider.addPart('app/main/cadastros/fornecedor');

         //Menu
         msNavigationServiceProvider.saveItem('cadastros.fornecedor', {
              title: 'cadastros',
              state: 'app.cadastros.fornecedor.buscar',
              translate: 'FORNECEDOR.FORNECEDOR'
         });

    }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.fornecedor')
          .factory('cadastrosFornecedorService', cadastrosFornecedorService);

     /** @ngInject */
     function cadastrosFornecedorService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};
          var service = {
               query: query,
               getNew: getNew,
               getCity: getCity,
               create: create,
               get: get,
               update: update,
               deleteCliente: deleteCliente,
               preCadastro: preCadastro
          };

          return service;


          function getNew() {
               return modelNew;
          }

          //////////

          ////// LISTAR - CLIENTE FORNECEDOR //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.ClienteFornecedor.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - CLIENTE FORNECEDOR //////


          ////// CONSULTA POR ID - CLIENTE FORNECEDOR //////
          function get(id) {
               var deferred = $q.defer();

               api.ClienteFornecedor.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - CLIENTE FORNECEDOR //////


          ////// CRIAR - CLIENTE FORNECEDOR //////
          function create(model) {

               var deferred = $q.defer();

               api.ClienteFornecedor.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CRIAR - CLIENTE FORNECEDOR //////

          ////// ALTERAR - CLIENTE FORNECEDOR //////
          function update(model) {

               var deferred = $q.defer();

               api.ClienteFornecedor.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// ALTERAR - CLIENTE FORNECEDOR //////


          ////// CONSULTA DE CIDADE - CLIENTE FORNECEDOR //////
          function getCity(query) {

               var deferred = $q.defer();

               api.Cidade.query({
                    query: query
               }).$promise.then(
                    function (response) {

                         var enderecos = [];

                         for (var i = 0; i < response.data.length; i++) {
                              enderecos.push({
                                   cep: "",
                                   endereco: "",
                                   endereco_cidade_nome: response.data[i].nome,
                                   endereco_uf: response.data[i].estado,
                                   numero: "",
                                   complemento: ""
                              });
                         }
                         deferred.resolve(enderecos);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CIDADE - CLIENTE FORNECEDOR //////


          ////// CONSULTA DE FORNECEDOR //////

          ////// DELETAR - COLHEITA //////
          function deleteCliente(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.ClienteFornecedor.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// DELETAR - COLHEITA //////

          ////// ALTERAR - CLIENTE FORNECEDOR //////
          function preCadastro(cnpjCpf) {

               var deferred = $q.defer();

               api.ClienteFornecedorPreCadastro.get({
                    fornecedorCnpjCpf: cnpjCpf
               }).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// ALTERAR - CLIENTE FORNECEDOR //////

     }

})();

(function() {
    'use strict';

    angular
         .module('app.cadastros.fornecedor')
         .controller('visualizarFornecedorController', visualizarFornecedorController);

    /** @ngInject */
    function visualizarFornecedorController($state, model) {
         var vm = this;

         // Data
         vm.model = model;
         vm.status = [];

         // Methods
         vm.gotoSearch = gotoSearch;

         //////////

         init();

         /**
          * Initialize
          */
         function init() {

         }

         function gotoSearch() {
              $state.go('app.cadastros.fornecedor.buscar');
         }
    }
})();
(function () {
    'use strict';

    angular
         .module('app.cadastros.fornecedor')
         .controller('editarFornecedorController', editarFornecedorController);

    /** @ngInject */
    function editarFornecedorController($rootScope, $scope, $state, $filter, model, cadastrosFornecedorService, $mdToast, $mdDialog) {
         var vm = this;

         // Data
         vm.model = model;
         vm.api_response_erro = {};

         // Metodos
         vm.gotoSearch = gotoSearch;
         vm.save = save;
         //////////

         init();

         function init() {

         }

         function save(form) {

              if (form.$invalid) {
                   return;
              }

              var message = '';
              var message = $filter('translate')('FORNECEDOR.FORNECEDOR_ALTERADO');
              this.savePromise = cadastrosFornecedorService.update(vm.model);

              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                   );
                   gotoSearch()
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }

         function gotoSearch() {
              $state.go('app.cadastros.fornecedor.buscar');
         }

    }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.fornecedor')
         .controller('criarFornecedorController', criarFornecedorController);

    /** @ngInject */
    function criarFornecedorController($rootScope, $scope, $state, $filter, model, cadastrosFornecedorService, cadastrosDistribuidorService, $mdToast, $mdDialog) {
         var vm = this;

         // Data
         vm.model = model;
         vm.api_response_erro = {};

         // Metodos
         vm.citySearch = citySearch;
         vm.gotoSearch = gotoSearch;
         vm.save = save;
         vm.changeCnpjCpf = changeCnpjCpf;
         //////////

         init();

         function init() {

              vm.model.pessoa_tipo = {
                   id: 1
              },
              vm.model.categoria = 'Insumo';
         }

         function save(form) {

              if (form.$invalid) {
                   return;
              }

              var message = '';
              var message = $filter('translate')('FORNECEDOR.FORNECEDOR_ADICIONADO');
              this.savePromise = cadastrosFornecedorService.create(vm.model);

              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                             .textContent(message)
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                   );
                   gotoSearch()
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }

         function citySearch(query) {
              console.log(query);
              var retorno = cadastrosFornecedorService.getCity(query);
              return retorno;
         }

         function changeCnpjCpf(){

               if(!vm.model.cnpj_cpf)
                    return;

               $rootScope.loadingProgress = true;
               cadastrosFornecedorService.preCadastro(vm.model.cnpj_cpf)
                    .then(function(response){
                         $rootScope.loadingProgress = false;
                         console.log('preCadastro.then', response)

                         vm.model.endereco = {
                              endereco_cep: response.endereco_cep,
                              endereco_cidade_nome: response.endereco_cidade_nome,
                              endereco_uf: response.endereco_uf,
                              endereco_bairro: response.endereco_bairro,
                              endereco_rua: response.endereco_rua,
                              endereco_numero: response.endereco_numero,
                              endereco_complemento: response.endereco_complemento 
                         }
                         vm.model.telefone = {
                              ddd: response.ddd,
                              numero: response.numero
                         }
                         vm.model.cliente_id = response.cliente_id;
                         vm.model.nome = response.nome;
                    })
                    .catch(function (response) {
                         $rootScope.loadingProgress = false;
                         console.log('preCadastro.catch', response)
                    });
         }

         function gotoSearch() {
              $state.go('app.cadastros.fornecedor.buscar');
         }
    }
})();
(function () {
    'use strict';

    angular
         .module('app.cadastros.fornecedor')
         .controller('buscarFornecedorController', buscarFornecedorController);

    /** @ngInject */
    function buscarFornecedorController(data, $state, $filter, cadastrosFornecedorService, $mdDialog, $mdToast, $scope) {
         var vm = this;

         // Data
         vm.search = search;
         vm.gotoAddClient = gotoAddClient;
         vm.gotoVisualizar = gotoVisualizar;
         vm.gotoEditar = gotoEditar;
         vm.deletarConfirm = deletarConfirm;
         vm.deletar = deletar;
         vm.resetFilters = resetFilters;
         vm.showActiveFilters = showActiveFilters;
         vm.desableFilter = desableFilter;
         //////////

         init();

         function init() {

         }

         function search() {

              vm.loadingProgress = true;
              cadastrosFornecedorService.query()
                   .then(function successCallback(data) {
                        vm.models = data;
                   }).finally(function () {
                        vm.loadingProgress = false;
                   });
         }

         /// Query
         vm.args = {
              loading: false,
              page: 1,
              per_page: 10,
              page_sizes: [5, 10, 25, 100],
              total_rows: data.total_rows,
              length_rows: 1,
              sort_by: 'id',
              sort_order: 'asc',
              categoria:'Insumo',
              _change: change
         };

         vm.args._change();

         function change() {
              vm.args.loading = true;
              cadastrosFornecedorService.query(vm.args).then(function (response) {
                   vm.models = response.data;
                   vm.args.total_rows = response.total_rows;
                   vm.args.length_rows = vm.models.length;
                   showActiveFilters();
                   vm.args.updatePaggination();
              }).finally(function () {
                   vm.args.loading = false;
              });
         }

         function resetFilters() {
               vm.args.nome = null;
               vm.args.cnpj_cpf = null;
               vm.args.cidade = null;
               vm.activeFilters = null;
               change();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let arr = null;
               let counter = 0;
               arr = [
                    {
                         description: vm.args.nome,
                         value: 'nome'
                    },
                    {
                         description: vm.args.cnpj_cpf,
                         value: 'cnpj_cpf'
                    },
                    {
                         description: vm.args.cidade,
                         value: 'cidade'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value){
               vm.args[value] = null;
               change();
          }

         function deletarConfirm(model) {

              var confirm = $mdDialog.confirm()
                   .title('Deletar fornecedor?')
                   .textContent('Tem certeza que deseja deletar esse fornecedor?')
                   .targetEvent(model)
                   .ok('Sim, quero deletar!')
                   .cancel('Não quero!');

              $mdDialog.show(confirm)
                   .then(function () {
                        deletar(model);
                   }, function () {
                        return null
                   });
         };

         function deletar(model) {

              var message = $filter('translate')('FORNECEDOR.FORNECEDOR_DELETADO');

              cadastrosFornecedorService.deleteCliente(model.id)
                   .then(function (response) {
                        vm.models.cliente_fornecedor.splice(vm.models.cliente_fornecedor.indexOf(model), 1);
                        $mdToast.show(
                             $mdToast.simple()
                             .textContent(message)
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                        );

                   }).catch(function (response) {
                         console.log('error:', response)
                   });
         }

         function gotoAddClient() {
              $state.go('app.cadastros.fornecedor.criar');
         }

         function gotoVisualizar(id) {
              $state.go('app.cadastros.fornecedor.visualizar', {
                   id: id
              });
         }

         function gotoEditar(id) {
              $state.go('app.cadastros.fornecedor.editar', {
                   id: id
              });
         }

    }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.distribuidor', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.cadastros.distribuidor', {
                    abstract: true,
                    url: '/distribuidor'
               })
               // .state('app.cadastros.distribuidor.buscar', {
               //      url: '/buscar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/cadastros/distribuidor/views/buscar.html',
               //                controller: 'buscarDistribuidorController as vm'
               //           }
               //      },
               //      resolve: {
               //           data: function (cadastrosDistribuidorService) {
               //                return cadastrosDistribuidorService.query();
               //           }
               //      }
               // })
               // .state('app.cadastros.distribuidor.criar', {
               //      url: '/criar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/cadastros/distribuidor/views/criar.html',
               //                controller: 'criarDistribuidorController as vm'
               //           }
               //      },
               //      resolve: {
               //           model: function (cadastrosDistribuidorService) {
               //                return cadastrosDistribuidorService.getNew();
               //           }
               //      }
               // })
               .state('app.cadastros.distribuidor.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/cadastros/distribuidor/views/visualizar.html',
                              controller: 'visualizarDistribuidorController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, cadastrosDistribuidorService) {
                              return cadastrosDistribuidorService.get($stateParams.id);
                         }
                    }
               })
               .state('app.cadastros.distribuidor.editar', {
                    url: '/editar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/cadastros/distribuidor/views/editar.html',
                              controller: 'editarDistribuidorController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, cadastrosDistribuidorService) {
                              return cadastrosDistribuidorService.get($stateParams.id);
                         }
                    }
               })


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/cadastros');
          $translatePartialLoaderProvider.addPart('app/main/cadastros/distribuidor');

          //Menu
          // msNavigationServiceProvider.saveItem('cadastros.distribuidor', {
          //      title: 'cadastros',
          //      // icon: 'icon-document',
          //      state: 'app.cadastros.distribuidor.buscar',
          //      translate: 'DISTRIBUIDOR.DISTRIBUIDOR'
          // });

     }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.distribuidor')
          .factory('cadastrosDistribuidorService', cadastrosDistribuidorService);

     /** @ngInject */
     function cadastrosDistribuidorService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};
          var service = {
               query: query,
               getNew: getNew,
               getCity: getCity,
               create: create,
               get: get,
               getVendedor: getVendedor,
               update: update,
               deleteCliente: deleteCliente
          };

          return service;

          function getNew() {
               return modelNew;
          }

          //////////

          ////// LISTAR - CLIENTE DISTRIBUIDOR ////// 
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.ClienteDistribuidor.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - CLIENTE DISTRIBUIDOR ////// 


          ////// CONSULTA POR ID - CLIENTE DISTRIBUIDOR ////// 
          function get(id) {
               var deferred = $q.defer();

               api.ClienteDistribuidor.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - CLIENTE DISTRIBUIDOR ////// 
 
          function getVendedor(id) {
               var deferred = $q.defer();

               api.ClienteDistribuidorVendedor.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - CLIENTE DISTRIBUIDOR ////// 


          ////// CRIAR - CLIENTE DISTRIBUIDOR ////// 
          function create(model) {

               var deferred = $q.defer();

               api.ClienteDistribuidor.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - CLIENTE DISTRIBUIDOR ////// 


          ////// ALTERAR - CLIENTE DISTRIBUIDOR ////// 
          function update(model) {

               var deferred = $q.defer();

               api.ClienteDistribuidor.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// ALTERAR - CLIENTE DISTRIBUIDOR ////// 


          ////// CONSULTA DE CIDADE - CLIENTE DISTRIBUIDOR ////// 
          function getCity(query) {

               var deferred = $q.defer();

               api.Cidade.query({
                    query: query
               }).$promise.then(
                    function (response) {

                         var enderecos = [];

                         for (var i = 0; i < response.data.length; i++) {
                              enderecos.push({
                                   cep: "",
                                   endereco: "",
                                   endereco_cidade_nome: response.data[i].nome,
                                   endereco_uf: response.data[i].estado,
                                   numero: "",
                                   complemento: ""
                              });
                         }
                         deferred.resolve(enderecos);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CIDADE - CLIENTE DISTRIBUIDOR ////// 


          ////// DELETAR - COLHEITA ////// 
          function deleteCliente(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.ClienteDistribuidor.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          ////// DELETAR - COLHEITA ////// 


     }

})();

(function() {
     'use strict';

     angular
          .module('app.cadastros.distribuidor')
          .controller('visualizarDistribuidorController', visualizarDistribuidorController);

     /** @ngInject */
     function visualizarDistribuidorController($state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Methods
          vm.gotoSearch = gotoSearch;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.cadastros.distribuidor.buscar');
          }
     }
})();
(function () {
     'use strict';

     angular
          .module('app.cadastros.distribuidor')
          .controller('editarDistribuidorController', editarDistribuidorController);

     /** @ngInject */
     function editarDistribuidorController($rootScope, $scope, $state, $filter, model, cadastrosDistribuidorService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               var message = $filter('translate')('DISTRIBUIDOR.DISTRIBUIDOR_ALTERADO');
               this.savePromise = cadastrosDistribuidorService.update(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(message)
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoSearch()
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               $state.go('app.cadastros.distribuidor.buscar');
          }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.distribuidor')
          .controller('criarDistribuidorController', criarDistribuidorController);

     /** @ngInject */
     function criarDistribuidorController($rootScope, $scope, $state, $filter, model, cadastrosClienteService, cadastrosDistribuidorService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: 1
               }

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               var message = $filter('translate')('DISTRIBUIDOR.DISTRIBUIDOR_ADICIONADO');
               this.savePromise = cadastrosDistribuidorService.create(vm.model);

               if (vm.model.distribuidor == true) {
                    this.savePromise = cadastrosClienteService.create(vm.model);
               }

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );
                    gotoSearch()
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function gotoSearch() {
               $state.go('app.cadastros.distribuidor.buscar');
          }

     }
})();
(function () {
     'use strict';

     angular
          .module('app.cadastros.distribuidor')
          .controller('buscarDistribuidorController', buscarDistribuidorController);

     /** @ngInject */
     function buscarDistribuidorController(data, $state, $filter, cadastrosDistribuidorService, $mdDialog, $mdToast, $scope) {
          var vm = this;

          // Data
          vm.search = search;
          vm.gotoAddClient = gotoAddClient;
          vm.gotoVisualizar = gotoVisualizar;
          vm.gotoEditar = gotoEditar;
          vm.deletarConfirm = deletarConfirm;
          vm.deletar = deletar;
          vm.resetFilters = resetFilters;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               cadastrosDistribuidorService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'asc',
               _change: change
          };

          vm.args._change();

          function change() {
               vm.args.loading = true;
               cadastrosDistribuidorService.query(vm.args).then(function (response) {
                    vm.models = response.data;
                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    showActiveFilters();
                    vm.args.updatePaggination();
               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               vm.args.nome = null;
               vm.args.cnpj_cpf = null;
               vm.args.cidade = null;
               vm.activeFilters = null;
               change();
           }

          function showActiveFilters(){
               vm.activeFilters = null;
               let arr = null;
               let counter = 0;
               arr = [
                    {
                         description: vm.args.nome,
                         value: 'nome'
                    },
                    {
                         description: vm.args.cnpj_cpf,
                         value: 'cnpj_cpf'
                    },
                    {
                         description: vm.args.cidade,
                         value: 'cidade'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value){
               vm.args[value] = null;
               change();
          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                    .title('Deletar distribuidor?')
                    .textContent('Tem certeza que deseja deletar esse distribuidor?')
                    .targetEvent(model)
                    .ok('Sim, quero deletar!')
                    .cancel('Não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          };

          function deletar(model) {

               console.log('teste')

               var message = $filter('translate')('DISTRIBUIDOR.DISTRIBUIDOR_DELETADO');

               cadastrosDistribuidorService.deleteCliente(model.id)
                    .then(function (response) {
                         vm.models.cliente_distribuidor.splice(vm.models.cliente_distribuidor.indexOf(model), 1);
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );
                    }).catch(function (response) {
                         console.log('error:', response)
                    });
          }

          function gotoAddClient() {
               $state.go('app.cadastros.distribuidor.criar');
          }

          function gotoVisualizar(id) {
               $state.go('app.cadastros.distribuidor.visualizar', {
                    id: id
               });
          }

          function gotoEditar(id) {
               $state.go('app.cadastros.distribuidor.editar', {
                    id: id
               });
          }

     }
})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.despesa_tipo', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.cadastros.despesa_tipo', {
                   abstract: true,
                   url: '/despesa_tipo'
              })
          //     .state('app.cadastros.despesa_tipo.buscar', {
          //          url: '/buscar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/cadastros/despesa_tipo/views/buscar.html',
          //                    controller: 'buscarTipoDespesaController as vm'
          //               }
          //          },
          //          resolve: {
          //               data: function (cadastrosDespesaTipoService) {
          //                    return cadastrosDespesaTipoService.query();
          //               }
          //          }
          //     })
          //     .state('app.cadastros.despesa_tipo.criar', {
          //          url: '/criar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/cadastros/despesa_tipo/views/criar.html',
          //                    controller: 'criarTipoDespesaController as vm'
          //               }
          //          },
          //          resolve: {
          //               model: function (cadastrosDespesaTipoService) {
          //                    return cadastrosDespesaTipoService.getNew();
          //               }
          //          }
          //     })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/cadastros/despesa_tipo');
         

     //     //Menu
     //     msNavigationServiceProvider.saveItem('cadastros.despesa_tipo', {
     //          title: 'cadastros',
     //          state: 'app.cadastros.despesa_tipo.buscar',
     //          translate: 'DESPESA_TIPO.DESPESA_TIPO'
     //     });

    }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.despesa_tipo')
          .factory('cadastrosDespesaTipoService', cadastrosDespesaTipoService);

     /** @ngInject */
     function cadastrosDespesaTipoService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};
          var service = {
               query: query,
               getNew: getNew,
               create: create,
               deleteTipoDespesa: deleteTipoDespesa
          };

          return service;


          function getNew() {
               return modelNew;
          }

          //////////

          ////// LISTAR - TipoDespesa ////// 
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.DespesaTipo.query(args).$promise.then(
                         function (response) {
                              
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - TipoDespesa ////// 

          ////// CRIAR - TipoDespesa ////// 
          function create(model) {

               var deferred = $q.defer();

               api.DespesaTipo.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CRIAR - TipoDespesa ////// 

          ////// DELETAR - TipoDespesa ////// 
          function deleteTipoDespesa(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.DespesaTipo.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// DELETAR - TipoDespesa ////// 


     }

})();

(function () {
    'use strict';

    angular
         .module('app.cadastros.despesa_favorecido', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
         // State
         $stateProvider
              .state('app.cadastros.despesa_favorecido', {
                   abstract: true,
                   url: '/despesa_favorecido'
              })
          //     .state('app.cadastros.despesa_favorecido.buscar', {
          //          url: '/buscar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/cadastros/despesa_favorecido/views/buscar.html',
          //                    controller: 'buscarFavorecidoDespesaController as vm'
          //               }
          //          },
          //          resolve: {
          //               data: function (cadastrosDespesaFavorecidoService) {
          //                    return cadastrosDespesaFavorecidoService.query();
          //               }
          //          }
          //     })
          //     .state('app.cadastros.despesa_favorecido.criar', {
          //          url: '/criar',
          //          views: {
          //               'content@app': {
          //                    templateUrl: 'app/main/cadastros/despesa_favorecido/views/criar.html',
          //                    controller: 'criarFavorecidoDespesaController as vm'
          //               }
          //          },
          //          resolve: {
          //               model: function (cadastrosDespesaFavorecidoService) {
          //                    return cadastrosDespesaFavorecidoService.getNew();
          //               }
          //          }
          //     })


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/cadastros/despesa_favorecido');
         

     //     //Menu
     //     msNavigationServiceProvider.saveItem('cadastros.despesa_favorecido', {
     //          title: 'cadastros',
     //          state: 'app.cadastros.despesa_favorecido.buscar',
     //          translate: 'DESPESA_TIPO.DESPESA_TIPO'
     //     });

    }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.despesa_favorecido')
          .factory('cadastrosDespesaFavorecidoService', cadastrosDespesaFavorecidoService);

     /** @ngInject */
     function cadastrosDespesaFavorecidoService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};
          var service = {
               query: query,
               getNew: getNew,
               create: create,
               deleteFavorecidoDespesa: deleteFavorecidoDespesa
          };

          return service;


          function getNew() {
               return modelNew;
          }

          //////////

          ////// LISTAR - FavorecidoDespesa ////// 
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.DespesaFavorecido.query(args).$promise.then(
                         function (response) {
                              
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTAR - FavorecidoDespesa ////// 

          ////// CRIAR - FavorecidoDespesa ////// 
          function create(model) {

               var deferred = $q.defer();

               api.DespesaFavorecido.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }
          ////// CRIAR - FavorecidoDespesa ////// 

          ////// DELETAR - FavorecidoDespesa ////// 
          function deleteFavorecidoDespesa(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.DespesaFavorecido.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );

               return deferred.promise;
          }
          ////// DELETAR - FavorecidoDespesa ////// 


     }

})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.cliente', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider
               .state('app.cadastros.cliente', {
                    abstract: true,
                    url: '/cliente'
               })
               // .state('app.cadastros.cliente.buscar', {
               //      url: '/buscar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/cadastros/cliente/views/buscar.html',
               //                controller: 'buscarClienteController as vm'
               //           }
               //      },
               //      resolve: {
               //           data: function (cadastrosClienteService) {
               //                return cadastrosClienteService.query();
               //           }
               //      }
               // })
               // .state('app.cadastros.cliente.criar', {
               //      url: '/criar',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/cadastros/cliente/views/criar.html',
               //                controller: 'criarClienteController as vm'
               //           }
               //      },
               //      resolve: {
               //           model: function (cadastrosClienteService) {
               //                return cadastrosClienteService.getNew();
               //           }
               //      }
               // })
               .state('app.cadastros.cliente.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/cadastros/cliente/views/visualizar.html',
                              controller: 'visualizarClienteController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, cadastrosClienteService) {
                              return cadastrosClienteService.get($stateParams.id);
                         }
                    }
               })
               .state('app.cadastros.cliente.editar', {
                    url: '/editar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/cadastros/cliente/views/editar.html',
                              controller: 'editarClienteController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, cadastrosClienteService) {
                              return cadastrosClienteService.get($stateParams.id);
                         }
                    }
               })


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/cadastros');
          $translatePartialLoaderProvider.addPart('app/main/cadastros/cliente');

          //Menu
          // msNavigationServiceProvider.saveItem('cadastros.cliente', {
          //      title: 'cadastros',
          //      state: 'app.cadastros.cliente.buscar',
          //      translate: 'CLIENTE.CLIENTE'
          // });

     }
})();

(function() {
     'use strict';

     angular
          .module('app.cadastros.cliente')
          .controller('visualizarClienteController', visualizarClienteController);

     /** @ngInject */
     function visualizarClienteController($state, model) {
          var vm = this;

          // Data
          vm.model = model;
          vm.status = [];

          // Methods
          vm.gotoSearch = gotoSearch;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.cadastros.cliente.buscar');
          }
     }
})();
(function () {
     'use strict';

     angular
          .module('app.cadastros.cliente')
          .controller('editarClienteController', editarClienteController);

     /** @ngInject */
     function editarClienteController($rootScope, $scope, $state, $filter, model, cadastrosClienteService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};

          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }
               var message = '';
               message = $filter('translate')('CLIENTE.CLIENTE_ALTERADO');
               this.savePromise = cadastrosClienteService.update(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                         .textContent(message)
                         .position('top right')
                         .theme("success-toast")
                         .hideDelay(6000)
                    );
                    gotoSearch()
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          // function save(form) {

          //      if (form.$invalid) {
          //           return;
          //      }

          //      var message = '';
          //      var message = $filter('translate')('DISTRIBUIDOR.DISTRIBUIDOR_ALTERADO');
          //      this.savePromise = cadastrosDistribuidorService.update(vm.model);

          //      $rootScope.loadingProgress = true;
          //      this.savePromise.then(function (response) {
          //           $rootScope.loadingProgress = false;
          //           vm.model.id = response.id;

          //           $mdToast.show(
          //                $mdToast.simple()
          //                .textContent(message)
          //                .position('top right')
          //                .theme("success-toast")
          //                .hideDelay(6000)
          //           );
          //           gotoSearch()
          //      }).catch(function (response) {
          //           $rootScope.loadingProgress = false;
          //           vm.api_response_erro = response;
          //      });
          // }

          function gotoSearch() {
               $state.go('app.cadastros.cliente.buscar');
          }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.cliente')
          .controller('criarClienteController', criarClienteController);

     /** @ngInject */
     function criarClienteController($rootScope, $scope, $state, $filter, model, cadastrosClienteService, cadastrosDistribuidorService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};

          // Metodos
          vm.citySearch = citySearch;
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: 1
               }

          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               message = $filter('translate')('CLIENTE.CLIENTE_ADICIONADO');
               this.savePromise = cadastrosClienteService.create(vm.model);

               if (vm.model.distribuidor == true) {
                    this.savePromise = cadastrosDistribuidorService.create(vm.model);
               }

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );
                    gotoSearch()
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }

          function citySearch(query) {
               console.log(query);
               var retorno = cadastrosClienteService.getCity(query);
               return retorno;
          }

          function gotoSearch() {
               $state.go('app.cadastros.cliente.buscar');
          }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.cliente')
          .controller('buscarClienteController', buscarClienteController);

     /** @ngInject */
     function buscarClienteController(data, $state, $filter, cadastrosClienteService, $mdDialog, $mdToast, $scope) {
          var vm = this;

          // Data
          vm.search = search;
          vm.gotoAddClient = gotoAddClient;
          vm.gotoVisualizar = gotoVisualizar;
          vm.gotoEditar = gotoEditar;
          vm.deletarConfirm = deletarConfirm;
          vm.deletar = deletar;
          vm.resetFilters = resetFilters;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               cadastrosClienteService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'asc',
               nome: null,
               cnpj_cpf: null,
               cidade: null,
               _change: change
          };

          vm.args._change();

          function change() {
               console.log('args:', vm.args);
               vm.args.loading = true;
               cadastrosClienteService.query(vm.args).then(function (response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    showActiveFilters();
                    vm.args.updatePaggination();

               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               vm.args.nome = null;
               vm.args.cnpj_cpf = null;
               vm.args.cidade = null;
               vm.activeFilters = null;
               change();
           }

          function showActiveFilters(){
               vm.activeFilters = null;
               let arr = null;
               let counter = 0;
               arr = [
                    {
                         description: vm.args.nome,
                         value: 'nome'
                    },
                    {
                         description: vm.args.cnpj_cpf,
                         value: 'cnpj_cpf'
                    },
                    {
                         description: vm.args.cidade,
                         value: 'cidade'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
          }

          function desableFilter(value){
               vm.args[value] = null;
               change();
          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                    .title('Deletar cliente?')
                    .textContent('Tem certeza que deseja deletar esse cliente?')
                    .targetEvent(model)
                    .ok('Sim, quero deletar!')
                    .cancel('Não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          };

          function deletar(model) {

               var message = $filter('translate')('CLIENTE.CLIENTE_DELETADO');

               cadastrosClienteService.deleteCliente(model.id)
                    .then(function (response) {
                         vm.models.cliente_consumidor.splice(vm.models.cliente_consumidor.indexOf(model), 1);
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         console.log('error:', response)
                    });
          }

          function gotoAddClient() {
               $state.go('app.cadastros.cliente.criar');
          }

          function gotoVisualizar(id) {
               $state.go('app.cadastros.cliente.visualizar', {
                    id: id
               });
          }

          function gotoEditar(id) {
               $state.go('app.cadastros.cliente.editar', {
                    id: id
               });
          }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros.cliente')
          .factory('cadastrosClienteService', cadastrosClienteService);

     /** @ngInject */
     function cadastrosClienteService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};
          var service = {
               query: query,
               getNew: getNew,
               getCity: getCity,
               create: create,
               get: get,
               getCliente: getCliente,
               update: update,
               deleteCliente: deleteCliente
          };

          return service;


          function getNew() {
               return modelNew;
          }

          //////////

          ////// LISTAR - CLIENTE CONSUMIDOR ////// 
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
               } else {
                    api.ClienteConsumidor.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - CLIENTE CONSUMIDOR ////// 


          ////// CONSULTA POR ID - CLIENTE CONSUMIDOR ////// 
          function get(id) {
               var deferred = $q.defer();

               api.ClienteConsumidor.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - CLIENTE CONSUMIDOR ////// 
          function getCliente(fornecedor_id) {
               var deferred = $q.defer();

               api.ClienteFornecedorGet.get({
                    fornecedor_id: fornecedor_id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID - CLIENTE CONSUMIDOR ////// 


          ////// CRIAR - CLIENTE CONSUMIDOR ////// 
          function create(model) {

               var deferred = $q.defer();

               api.ClienteConsumidor.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CRIAR - CLIENTE CONSUMIDOR ////// 

          ////// ALTERAR - CLIENTE CONSUMIDOR ////// 
          function update(model) {

               var deferred = $q.defer();

               api.ClienteConsumidor.update(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// ALTERAR - CLIENTE CONSUMIDOR ////// 


          ////// CONSULTA DE CIDADE - CLIENTE CONSUMIDOR ////// 
          function getCity(query) {

               var deferred = $q.defer();

               api.Cidade.query({
                    query: query
               }).$promise.then(
                    function (response) {

                         var enderecos = [];

                         for (var i = 0; i < response.data.length; i++) {
                              enderecos.push({
                                   cep: "",
                                   endereco: "",
                                   endereco_cidade_nome: response.data[i].nome,
                                   endereco_uf: response.data[i].estado,
                                   numero: "",
                                   complemento: ""
                              });
                         }
                         deferred.resolve(enderecos);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CIDADE - CLIENTE CONSUMIDOR ////// 


          ////// DELETAR - COLHEITA ////// 
          function deleteCliente(id) {
               // Create a new deferred object
               var deferred = $q.defer();

               api.ClienteConsumidor.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }
          ////// DELETAR - COLHEITA ////// 


     }

})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel', [])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider, msApiProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/quick-panel');

    // Api
    // msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
    // msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
    // msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
    // msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function () {
     'use strict';

     angular
          .module('app.suporte', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
               .state('app.suporte', {
                    abstract: true,
                    url: '/suporte'
               })
               .state('app.suporte.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/suporte/view/view.html',
                              controller: 'buscarSuporteController as vm'
                         }
                    },
                    resolve: {
                         data: function (SuporteService) {
                              return SuporteService.query();
                         }
                    }
               })
               .state('app.suporte.criar', {
                    url: '/novo-chamado',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/suporte/view/criar.html',
                              controller: 'NovoChamadoController as vm'
                         }
                    },
                    resolve: {
                         categoriasTipos: function (SuporteService) {
                              return SuporteService.getCategoriaTipo();
                         }
                    }
               })
               .state('app.suporte.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/suporte/view/visualizar.html',
                              controller: 'VisualizarChamadoController as vm'
                         }
                    },
                    resolve: {
                         model: function (SuporteService, $stateParams) {
                              return SuporteService.getId($stateParams.id);
                         }
                    }
               })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/suporte');


          //Menu
          msNavigationServiceProvider.saveItem('suporte', {
               title: 'Suporte',
               weight: 10,
               icon: 'fas fa-comment-dots',
               state: 'app.suporte.buscar',
               translate: 'SUPORTE.SUPORTE'
          });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.suporte')
          .factory('SuporteService', SuporteService);

     /** @ngInject */
     function SuporteService($q, api) {

          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};

          var service = {
               getNew: getNew,
               getCategoriaTipo: getCategoriaTipo,
               create: create,
               responderSuporte: responderSuporte,
               encerrar: encerrar,
               query: query,
               getId: getId
          };

          return service;

          //////////


          function getId(id) {
               var deferred = $q.defer();

               api.AtendimentoSuporte.getId({
                    id: id
               }).$promise.then(
                    function(response) {
                         deferred.resolve(response);
                    }

               ).catch(function(response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }



          ////// LISTAR - SUPORTE ////// 
          function query(args, cache) {
               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs)) {
                    deferred.resolve(queryResponse);
                    console.log("query using: true");
               } else {
                    api.AtendimentoSuporte.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              models = response.data;
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                         console.log(response);
                    });
               }
               return deferred.promise;
          };
          ////// LISTAR - VENDA ////// 

          function create(model) {

               var deferred = $q.defer();

               api.AtendimentoSuporte.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          function responderSuporte(model) {

               var deferred = $q.defer();

               api.AtendimentoSuporte.responderSuporte(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          function encerrar(model) {

               var deferred = $q.defer();

               api.AtendimentoSuporteEncerrar.encerrar(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }


          function getCategoriaTipo(query) {
               var deferred = $q.defer();

               api.AtendimentoSuporte.categoriaTipo({
                    query: query
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response.data);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }


          function getNew() {
               return modelNew;
          }
     }

})();
(function () {
    'use strict';

    angular
         .module('app.area')
         .controller('VisualizarChamadoController', VisualizarChamadoController);

    /** @ngInject */
    function VisualizarChamadoController($rootScope, $stateParams, $scope, model, SuporteService, $state, $filter, areaService, $mdToast, $mdDialog) {
         var vm = this;
         vm.model = model;

         // Data
         //     vm.model = model;
         vm.api_response_erro = {};

         // Metodos
         vm.gotoSearch = gotoSearch;
         vm.openCollapse = openCollapse;
         vm.openNotResolved = openNotResolved;
         vm.encerrar = encerrar;
         vm.openResolved = openResolved;
         vm.save = save
         //////////

         init();

         function init() {
         }

         function openCollapse(index){
              console.log('index', index)

            var element = document.getElementById("Collapse"+index);
            element.classList.toggle("content-collapse");

            var arrow = document.getElementById("arrow-collapse"+index);
            arrow.classList.toggle("arrow-down");
         }

         function openNotResolved(){

            var notresolved = document.getElementById("notresolved");
            notresolved.classList.toggle("box-content-notresolved");

            var notresolved = document.getElementById("save-btn");
            notresolved.classList.toggle("d-none");

            var resolved = document.getElementById("resolved");
            resolved.classList.add("box-content-resolved-collapse");



         }
         function openResolved(){

            var resolved = document.getElementById("resolved");
            resolved.classList.toggle("box-content-resolved-collapse");

            var notresolved = document.getElementById("notresolved");
            notresolved.classList.add("box-content-notresolved");

            var notresolved = document.getElementById("save-btn");
            notresolved.classList.add("d-none");

         }


         function save(form) {
              if (form.$invalid) {
                   return;
              }
              vm.model = {
                    atendimento_suporte_id: vm.model.id,
                    descricao: vm.model.replica
                 }

              var message = '';
              var message = $filter('translate')('SUPORTE.ENVIADO');
              this.savePromise = SuporteService.responderSuporte(vm.model);


              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                             .textContent(message)
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                   );
                   gotoSearch();
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }

         function encerrar(avaliacao) {
              vm.model = {
                    id: vm.model.id,
                    avaliacao: avaliacao
                 }

              var message = '';
              var message = $filter('translate')('SUPORTE.AVALIACAO');
              this.savePromise = SuporteService.encerrar(vm.model);


              $rootScope.loadingProgress = true;
              this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.model.id = response.id;

                   $mdToast.show(
                        $mdToast.simple()
                             .textContent(message)
                             .position('top right')
                             .theme("success-toast")
                             .hideDelay(6000)
                   );
                   gotoSearch();
              }).catch(function (response) {
                   $rootScope.loadingProgress = false;
                   vm.api_response_erro = response;
              });
         }



         function gotoSearch() {
              $state.go('app.suporte.buscar');
         }

    }
})();



(function () {
     'use strict';

     angular
          .module('app.suporte')
          .controller('buscarSuporteController', buscarSuporteController);

     /** @ngInject */
     function buscarSuporteController(data, $state, $filter, SuporteService, $mdDialog, $mdToast, $scope) {
          var vm = this;

          // Data
          vm.search = search;
          vm.gotoNovoChamado = gotoNovoChamado;
          vm.gotoVisualizar = gotoVisualizar;
          vm.gotoEditar = gotoEditar;
          vm.encerrarConfirm = encerrarConfirm;
          vm.resetFilters = resetFilters;
          vm.encerrar = encerrar;

          //////////

          init();

          function init() {

          }

          function search() {

               vm.loadingProgress = true;
               SuporteService.query()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               Atendimento_Tipo: null,
               Atendimento_Status: null,
               Atendimento_Categoria: null,
               Data_De: null,
               Data_Ate: null,
               sort_by: 'id',
               sort_order: 'asc',
               _change: change
          };

          vm.args._change();

          function change() {


               vm.args.loading = true;
               SuporteService.query(vm.args).then(function (response) {
                    vm.models = response.data;

                    vm.args.total_rows = response.total_rows;
                    vm.args.length_rows = vm.models.length;
                    vm.args.updatePaggination();


               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change();

          }

          function resetFilters() {
               vm.args.Atendimento_Tipo = null,
                    vm.args.Atendimento_Status = null,
                    vm.args.Atendimento_Categoria = null,
                    vm.args.Data_De = null,
                    vm.args.Data_Ate = null,
                    change();
          }


          function encerrarConfirm(model) {
               var post = {
                    id: model.id,
                    avaliacao: 0
               }

               var confirm = $mdDialog.confirm()
                    .title('Encerrar chamado aberto?')
                    .textContent('Tem certeza que deseja encerrar esse chamado?')
                    .targetEvent(model)
                    .ok('Sim, quero encerrar!')
                    .cancel('Não quero encerrar');

               $mdDialog.show(confirm)
                    .then(function () {
                         encerrar(post);
                    }, function () {
                         return null
                    });
          };

          function encerrar(post) {
               debugger;

               var message = $filter('translate')('SUPORTE.ENCERRADO_SUCESSO');

               SuporteService.encerrar(post)
                    .then(function (response) {
                         //     vm.models.splice(vm.models.indexOf(model), 1);
                         SuporteService.query(vm.args).then(function (response) {
                              vm.models = response.data;
                              vm.args.total_rows = response.total_rows;
                              vm.args.length_rows = vm.models.length;
                              vm.args.updatePaggination();
                         }).finally(function () {
                              vm.args.loading = false;
                         });

                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(message)
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );

                    }).catch(function (response) {

                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent($filter('translate')('SUPORTE.ENCERRADO_ERRO'))
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(6000)
                         );
                    });
          }



          function gotoNovoChamado() {
               $state.go('app.suporte.criar');
          }

          function gotoVisualizar(id) {
               $state.go('app.suporte.visualizar', {
                    id: id
               });
          }

          function gotoEditar(id) {
               $state.go('app.cadastros.cliente.editar', {
                    id: id
               });
          }

     }
})();

(function () {
     'use strict';

     angular
          .module('app.area')
          .controller('NovoChamadoController', NovoChamadoController);

     /** @ngInject */
     function NovoChamadoController($rootScope, $stateParams, $scope, SuporteService, categoriasTipos, $state, $filter, areaService, $mdToast, $mdDialog) {
          var vm = this;

          // Data
          //     vm.model = model;
          vm.api_response_erro = {};
          vm.tipos = categoriasTipos.atendimento_suporte_tipo;
          vm.categorias = categoriasTipos.atendimento_suporte_motivo_contato;
          var utc = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
          $scope.date = utc;


          // Metodos
          vm.gotoSearch = gotoSearch;
          vm.save = save
          //////////

          init();

          function init() {
               //     autoSelectPropriedade(); 
          }


          function save(form) {
               if (form.$invalid) {
                    return;
               }
               vm.model = {
                    titulo: form.titulo,
                    atendimento_suporte_postagem: [
                      {
                        descricao: form.descricao
                      }
                    ],
                    atendimento_suporte_tipo_id: form.atendimento_suporte_tipo_id,
                    atendimento_suporte_motivo_contato_id: form.atendimento_suporte_motivo_contato_id,
                    nome: form.nome
                  }

               var message = '';
               var message = $filter('translate')('SUPORTE.ENVIADO');
               this.savePromise = SuporteService.create(vm.model);


               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );
                    gotoSearch();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
               });
          }



          function gotoSearch() {
               $state.go('app.suporte.buscar');
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .factory('previsaoColheitaService', previsaoColheitaService);

    /** @ngInject */
    function previsaoColheitaService($q, api, propertieService, areaService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            getUnidade: getUnidade,
            query: query,
            getListDash: getListDash,
            getList: getList,
            getDash: getDash,
            get: get,
            getPropriedades: getPropriedades,
            getAreas: getAreas,
            getFiltros: getFiltros,
            getCulturasVariedades: getCulturasVariedades,
            getColheitas: getColheitas,
            create: create,
            update: update,
            deletar: deletar,
            getStatus: getStatus
        };

        return service;

        function getUnidade() {
            return [
                "kg",
                "unidades"
            ]
        };

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaCultura.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getListDash(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaCultura.get(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getList(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaList.get(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getDash() {
            var deferred = $q.defer();
            api.PrevisaoColheitaDash.get().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }
            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function getFiltros() {
            var deferred = $q.defer();
            api.PrevisaoColheitaFiltro.query().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }
            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function getPropriedades() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            propertieService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }

        // Retorna area para tela de insumo
          // areaid: opcional
          function getAreas() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };
            
            areaService.query(args, false).then(function (response) {
                deferred.resolve(response.data);

            }).catch(function (response) {
                 deferred.reject(response);
                 console.log(response);

            });

            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.PrevisaoColheita
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }


        function get(id) {

            var deferred = $q.defer();

            api.PrevisaoColheitaGetId.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getCulturasVariedades() {

            var deferred = $q.defer();
            api.PropriedadeAreaCulturasVariedades
                .get().$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        }

        function getColheitas(id) {
            var deferred = $q.defer();
                api.PrevisaoColheitaColheitas
                    .get({
                        id: id
                    }).$promise
                    .then(function (response) {
                        deferred.resolve(response);
                    })
                    .catch(function (response) {
                        deferred.reject(response);
                    });
            return deferred.promise;
        }

        ////// ALTERAR ////// 
        function update(model) {
            var deferred = $q.defer();
            api.PrevisaoColheita.update(model).$promise.then(
                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    modelNew = {};
                }).catch(
                    function (response) {
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

        function deletar(id){
            var deferred = $q.defer();

            api.PrevisaoColheita.delete({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }).catch(
                function (response) {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        function getStatus() {
            return [
                {
                    nome: "Válido",
                    id: 1
                },
                {
                    nome: "Vencido",
                    id: 2
                },
                {
                    nome: "Todos",
                    id: 3
                }
            ]
       }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .controller('EditarPrevisaoColheitaController', EditarPrevisaoColheitaController)

    /** @ngInject */
    function EditarPrevisaoColheitaController(model, previsaoColheitaService, $rootScope, $state, $mdToast) {
        var vm = this;
        // Data
        vm.model = model;
        vm.api_response_erro = {};

        // Metodos
        vm.save = save;
        vm.gotoLista = gotoLista;
        //////////

        init();

        function init() {
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }
            console.log('model', vm.model);
            //return

            previsaoColheitaService
                .update(vm.model)
                .then(function (response) {

                    $rootScope.loadingProgress = false;

                    if (response == undefined) {
                        vm.api_response_erro = response;
                        console.log(response);
                        return;
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Previsão alterada com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    gotoLista();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                    console.log(response);
                });
        }

        function gotoLista(){
            $state.go('app.previsao_colheita.buscar');
        }
    }

})();

(function () {
     'use strict';

     angular
          .module('app.previsao_colheita')
          .controller('dashPrevisaoColheitaController', dashPrevisaoColheitaController)

     /** @ngInject */
     function dashPrevisaoColheitaController($state, previsaoColheitaService, propertieService, $mdDialog, $location, $anchorScroll, $filter) {
          var vm = this;
          vm.activeFilters = false;

          // Data
          vm.models = null;
          vm.dash = null;
          vm.filtros = [];
          vm.variedades = [];
          //
          vm.closeColapse = true;
          vm.resetFilters = resetFilters;
          vm.gotoAdd = gotoAdd;
          vm.gotoList = gotoList;
          vm.getDash = getDash;
          vm.toAncoraLink = toAncoraLink;
          vm.isColapsed = isColapsed;
          vm.closeColapsed = closeColapsed;
          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.selectedPeriodo = selectedPeriodo;
          vm.openModalCulturas = openModalCulturas;
          vm.openModalColheitas = openModalColheitas;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          vm.onSelectCultura = onSelectCultura;

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.model = {
               dataInicial: new Date(),
               dataFinal: new Date()
          }

          vm.periods = [
               {
                    description: "Últimos 7 dias",
                    value: 7
               },
               {
                    description: "Últimos 15 dias",
                    value: 15
               },
               {
                    description: "Últimos 30 dias",
                    value: 30
               },
               {
                    description: "Últimos 3 meses",
                    value: 90
               },
               {
                    description: "Últimos 6 meses",
                    value: 180
               }
          ]

          //////////

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: null,
               length_rows: 1,
               //sort_by: 'data_cadastro',
               //sort_order: 'desc',
               query: null,
               periodo: 180,
               data_inicial: null,
               data_final: null,
               cultura: null,
               variedade: null,
               _change: change
          };

          vm.args._change();

          init();

          function init() {
               //console.log('args:',vm.args);
               periodoActive.addClass("select-active");

               propertieService.query().then(function(response) {
                    if (!response || response.data.length == 0)
                         cadastroPropriedadeConfirm();
                    vm.propriedade = response.data;
               });

               getDash();
          }

          function getDash() {
               vm.args.loading = true;
               previsaoColheitaService.getDash().then(function (response) {
                    vm.dash = response;

               }).finally(function () {
                   vm.args.loading = false;
               });
          }

          function change() {
               vm.args.loading = true;
               previsaoColheitaService.getListDash(vm.args).then(function (response) {
                    console.log(response);
                    vm.models = response.previsao_colheita;
                    vm.filtros = response;
                    vm.args.total_rows = response.total_itens;
                    showActiveFilters();
                    vm.args.updatePaggination();
               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function onSelectCultura(culturaName) {
               vm.args.variedade = null;
               let variedades = [];
               vm.filtros.culturas.forEach( function(item) {
                 if(item.nome == culturaName){
                   variedades = item.variedade;
                 }
               });
               vm.variedades = variedades;
           }

          function resetFilters() {
               // IMPORTANTE limpar individualmente p/ não bugar a paginação!
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 180;
               vm.args.cultura = null;
               vm.args.variedade = null;
               change();
          }

          function openModalCulturas(){
               $mdDialog.show({
                   controller: mdDialogCtrlCulturas,
                   templateUrl: 'app/main/previsao_colheita/views/modal_culturas.html',
                   parent: angular.element(document.body),
                   clickOutsideToClose: true,
                   fullscreen: false
              })
          }
           function mdDialogCtrlCulturas($scope, $mdDialog) {
               //$scope.loading = true;
               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
               $scope.culturasVariedades = vm.dash.previsao_culturas
               // previsaoColheitaService.getCulturasVariedades().then(function (response) {
               //     $scope.culturasVariedades = response;
               // }).finally(function () {
               //     $scope.loading = false;
               // });
          }

          function openModalColheitas(id){
               $mdDialog.show({
                    locals:{dataToPass: id}, 
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/previsao_colheita/views/modal_colheitas.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
              })
           }
          function mdDialogCtrl($scope, $mdDialog, dataToPass) {
               $scope.loading = true;
               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
               previsaoColheitaService.getColheitas(dataToPass).then(function (response) {
                   $scope.colheitas = response;
               }).finally(function () {
                   $scope.loading = false;
               });
          }

          function isColapsed(model) {
               model.isLoading = false;
               model.colapsed = true;
               vm.isDisabled = true;
          }
   
          function closeColapsed(model) {
               model.colapsed = false;
               vm.isDisabled = false;
          }

          function gotoAdd() {
               $state.go('app.previsao_colheita.criar');
          }

          function gotoList() {
               $state.go('app.previsao_colheita.buscar');
          }

          function toAncoraLink(value) {
               $location.hash(value);
               $anchorScroll();
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let arr = null;
               let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
               let counter = 0;
               for (let i = 0; i < vm.periods.length; i++) {
                    if (vm.periods[i].value == vm.args.periodo) {
                         periodoSelect = vm.periods[i].description
                    };
               }
               arr = [
                    {
                         description: periodoSelect,
                         value: 'periodo'
                    },
                    {
                         description: inicio?inicio+" - "+fim:null,
                         value: 'datepicker'
                    },
                    {
                         description: vm.args.cultura,
                         value: 'cultura'
                    },
                    {
                         description: vm.args.variedade,
                         value: 'variedade'
                    }
               ];
     
               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }
     
               if(counter > 0){
                    vm.activeFilters = arr;
               }
             }
     
             function desableFilter(value){
               if(value == 'datepicker'){
                    vm.args.data_inicial = null;
                    vm.args.data_final = null;
                    vm.args.periodo = 180;
                    datapickerActive.removeClass("dates-active");
                    periodoActive.addClass("select-active");
               } else if(value == 'periodo'){
                    //periodoActive.removeClass("select-active");
                    vm.args[value] = 180;
               }else{
                    vm.args[value] = null;
               }
               change();
             }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 180;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }
          function cadastroPropriedadeConfirm() {
               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');
               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }
          
     }
})();

(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .controller('CriarPrevisaoColheitaController', CriarPrevisaoColheitaController)

    /** @ngInject */
    function CriarPrevisaoColheitaController($rootScope, $state, $window, propriedades, areas, unidades, previsaoColheitaService, $mdToast) {
        var vm = this;

        // Data
        vm.api_response_erro = {};
        vm.date_init = new Date();
        vm.areas = areas.propriedade_area;
        vm.propriedades = propriedades;
        vm.variedade = false;
        vm.unidades = unidades;

        // Metodos
        vm.save = save;
        vm.gotoSearch = gotoSearch;
        vm.gotoLista = gotoLista;
        vm.areaChange = areaChange;
        //////////

        vm.model = {
            propriedade_area: null,
            cultura: null,
            produto_variedade: null,
            peso_previsto: null,
            data_inicial: null,
            data_final: null,
            unidade_medida: "kg"
        }

        init();

        function init() {
            autoSelectPropriedade();
        }

        function autoSelectPropriedade() {
            vm.model.propriedade = vm.propriedades[0];
        }


        function save(form) {

            if (form.$invalid) {
                return;
            }
            let datasave = null;
            datasave = {
                propriedade_area_id: form.propriedade_area.id,
                cultura_id: form.propriedade_area.cultura_id,
                produto_variedade: form.produto_variedade,
                peso_previsto: form.peso_previsto,
                data_inicial: form.data_inicial,
                data_final: form.data_final,
                unidade_medida: form.unidade_medida
            }
            //console.log('DATA', datasave);
            //return

            $rootScope.loadingProgress = true;

            previsaoColheitaService
                .create(datasave)
                .then(function (response) {

                    $rootScope.loadingProgress = false;

                    if (response == undefined) {
                        vm.api_response_erro = response;
                        return;
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Previsão adicionada com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    gotoLista();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    console.log('ERRO POST', response);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(response.data.detail)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                    //vm.api_response_erro = response;
                });
        }

        function areaChange(area){
            console.log('area selected',area);
            vm.variedade = false;
            vm.model.produto_variedade = null;
            vm.model.cultura = area.cultura;
            if(area.produto_variedade)
                vm.variedade = true;
                vm.model.produto_variedade = area.produto_variedade
        }

        function gotoSearch() {
            $window.history.back();
        }

        function gotoLista(){
            $state.go('app.previsao_colheita.buscar');
        }

    }

})();
/* eslint-disable no-unused-vars */
(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .controller('BuscarPrevisaoColheitaController', BuscarPrevisaoColheitaController);

    /** @ngInject */
    function BuscarPrevisaoColheitaController(data, $state, previsaoColheitaService, propertieService, $mdDialog, $mdToast, $filter) {
        var vm = this;

        // Data
        vm.filtros = [];
        vm.variedades = [];

        vm.gotoEdit = gotoEdit;
        vm.gotoAdd = gotoAdd;
        vm.mdDialogCtrl = mdDialogCtrl;
        vm.deletarConfirm = deletarConfirm;
        vm.deletar = deletar;
        vm.resetFilters = resetFilters;
        vm.clearPreDate = clearPreDate;
        vm.clearRangeDate = clearRangeDate;

        vm.openDatasSelect = openDatasSelect;
        vm.selecionarDatas = selecionarDatas;
        vm.closedDatasSelect = closedDatasSelect;
        vm.clearPreDate = clearPreDate;
        vm.selectedPeriodo = selectedPeriodo;
        vm.activeFilters = false;
        vm.showActiveFilters = showActiveFilters;
        vm.desableFilter = desableFilter;
        vm.onSelectCultura = onSelectCultura;

        // DATAPICKER //////////////////
        var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
        var datapickerActive = angular.element(document.querySelector('#dataspicker'));
        var periodoActive = angular.element(document.querySelector('.select-periodo'));

        vm.periods = [
            {
                description: "Últimos 7 dias",
                value: 7
            },
            {
                description: "Últimos 15 dias",
                value: 15
            },
            {
                description: "Últimos 30 dias",
                value: 30
            },
            {
                description: "Últimos 3 meses",
                value: 90
            },
            {
                description: "Últimos 6 meses",
                value: 180
            }
        ];

        vm.model = {
            data_inicial: new Date(),
            data_final: new Date()
        }

        /// Query
        vm.args = {
            loading: false,
            page: 1,
            per_page: 10,
            page_sizes: [5, 10, 25, 100],
            total_rows: data.total_rows,
            length_rows: 1,
            // sort_by: 'data_cadastro',
            // sort_order: 'desc',
            periodo: 180,
            data_inicial: null,
            data_final: null,
            cultura: null,
            variedade: null,
            query: null,
            _change: change
        };

        vm.args._change();

        function init() {
            periodoActive.addClass("select-active");
            propertieService.query().then(function(response) {
                if (!response || response.data.length == 0)
                    cadastroPropriedadeConfirm();
                vm.propriedade = response.data;
           });
        }

        init();

        function change() {

            vm.args.loading = true;
            previsaoColheitaService.getList(vm.args).then(function (response) {
                vm.models = response.previsao_colheitas;
                vm.filtros = response;
                vm.args.total_rows = response.total_itens;
                //vm.args.length_rows = vm.models.length;
                showActiveFilters();
                vm.args.updatePaggination();
            }).finally(function () {
                vm.args.loading = false;
            });
        }

        function onSelectCultura(culturaName) {
            //console.log('veio aqui',culturaName.nome);
            //this.filterActive = false;
            vm.args.variedade = null;
            let variedades = [];
            vm.filtros.culturas.forEach( function(item) {
              if(item.nome == culturaName){
                variedades = item.variedades;
              }
            });
            vm.variedades = variedades;
        }

        function clearPreDate() {
            vm.args.periodo = null
        }
        function clearRangeDate() {
            vm.args.data_inicial = null
            vm.args.data_final = null
        }

        function resetFilters() {
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            vm.args.periodo = 180;
            vm.args.cultura = null;
            vm.args.variedade = null;
            change();
        }

        function showActiveFilters(){
            vm.activeFilters = null;
            let periodoSelect;
            let arr = null;
            let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
            let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
            let counter = 0;
            for (let i = 0; i < vm.periods.length; i++) {
                if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
                };
            }
            arr = [
                {
                    description: periodoSelect,
                    value: 'periodo'
                },
                {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
                },
                {
                    description: vm.args.cultura,
                    value: 'cultura'
                },
                {
                    description: vm.args.variedade,
                    value: 'variedade'
                }
            ];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
                }

                if(counter > 0){
                    vm.activeFilters = arr;
                }
        }

        function desableFilter(value){
            if(value == 'datepicker'){
                vm.args.data_inicial = null;
                vm.args.data_final = null;
                vm.args.periodo = 180;
                datapickerActive.removeClass("dates-active");
                periodoActive.addClass("select-active");
            } else if(value == 'periodo'){
                vm.args[value] = 180;
            }else{
                vm.args[value] = null;
            }
            change();
        }

        function mdDialogCtrl($scope, dataToPass) {
            $scope.model = dataToPass

            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Exclusão de previsão')
                .textContent('Você deseja excluir essa previsão?')
                .targetEvent(model)
                .ok('Sim')
                .cancel('Não');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

            previsaoColheitaService.deletar(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Previsão deletada com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change();

                }).catch(function (response) {
                });
        }

        function gotoEdit(id) {
            $state.go('app.previsao_colheita.editar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.previsao_colheita.criar');
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }
        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        // DATAPICKER //////////////////
        function clearPreDate() {
            vm.args.periodo = null;
        }
        function selectedPeriodo() {
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            periodoActive.addClass("select-active");
            datapickerActive.removeClass("dates-active");
        }
        function openDatasSelect(){
            datapicker.css("display", "block");
        }
        function selecionarDatas(){
            clearPreDate();
            datapicker.css("display", "none");
            datapickerActive.addClass("dates-active");
            periodoActive.removeClass("select-active");
        }
        function closedDatasSelect(){
            datapicker.css("display", "none");
            vm.args.data_inicial = null;
            vm.args.data_final = null;
            vm.args.periodo = null;
            datapickerActive.removeClass("dates-active");
            //periodoActive.classList.add("select-active");
        }
    }
})();

(function () {
     'use strict';

     angular
          .module('app.passo', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {
          // State
          $stateProvider
               .state('app.passo', {
                    abstract: true,
                    url: '/passo-a-passo'
               })
               .state('app.passo.home', {
                    //abstract: true,
                    url: '/home',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/passo_a_passo/view/passo_a_passo_home.html',
                              controller: 'PassoAPassoController as vm',
                              resolve: {
                                   authorize: function (authorization) {
                                        authorization.authorize();
                                   }
                              }
                         }
                    }
               })
               .state('app.passo.step', {
                    //abstract: true,
                    url: '/step/:passo',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/passo_a_passo/view/passo_a_passo.html',
                              controller: 'PassoAPassoController as vm',
                              resolve: {
                                   authorize: function (authorization) {
                                        authorization.authorize();
                                   }
                              }
                         }
                    }
               })
               // .state('app.passo.1', {
               //      url: '/1',
               //      views: {
               //           'content@app': {
               //                templateUrl: 'app/main/passo_a_passo/view/passo_a_passo.html',
               //                controller: 'PassoAPassoController as vm'
               //           }
               //      }
               // });

               // Translation
               $translatePartialLoaderProvider.addPart('app/main/passo_a_passo');

               //Menu
               msNavigationServiceProvider.saveItem('passo', {
                    title: 'Passo a passo',
                    //icon: 'icon-menu',
                    img: '/assets/icons/ico-menu-passo-a-passo.svg',
                    state: 'app.passo.home',
                    //translate: 'PROPERTIES.PROPERTIES'
               });
     }
})();


(function () {
     'use strict';

     angular
          .module('app.passo')
          .controller('PassoAPassoController', PassoAPassoController)



     /** @ngInject */
     function PassoAPassoController($state, $stateParams, $mdDialog, $location, $timeout, $anchorScroll) {
          var vm = this;

          // Metodos
          vm.autoSelectPasso = autoSelectPasso;
          vm.close = close;
          vm.viewCadastroPropriedade = viewCadastroPropriedade;
          vm.viewCadastroArea = viewCadastroArea;
          vm.viewCadastroInsumo = viewCadastroInsumo;
          vm.viewPlantio = viewPlantio;
          vm.viewAplicarInsumo = viewAplicarInsumo;
          vm.viewCadastroEstoque = viewCadastroEstoque;
          vm.viewColheita = viewColheita;
          vm.viewVenderLotes = viewVenderLotes;
          vm.viewImprimirTrocarCliente = viewImprimirTrocarCliente;
          vm.viewGerarLaudo = viewGerarLaudo;
          vm.gotoPassoAPasso = gotoPassoAPasso;
          vm.viewManejo = viewManejo;

          init();

          function init(){
               autoSelectPasso();
          }

          function autoSelectPasso() {
               if ($stateParams.passo) {
                   vm.autoSelectPasso = $stateParams.passo;
               } else {
                    vm.autoSelectPasso = 1;
               }
               // if(vm.autoSelectPasso > 1){
               //      $timeout(function(){
               //           //$location.hash('anchor'+vm.autoSelectPasso);
               //           $anchorScroll('anchor'+vm.autoSelectPasso);
               //           // var $target = angular.element('anchor'+vm.autoSelectPasso);
               //           // angular.element(document.body).$animate({scrollTop: $target.offset().top}, "slow");
               //       }, 1000);
               // }
          }

          // ACCORDION
          var accHD = document.getElementsByClassName('botao');
          var accItem = document.getElementsByClassName('tab-passo');
          var i;
          for (i = 0; i < accHD.length; i++) {
              accHD[i].addEventListener('click', toggleItem, false);
          }
          function toggleItem() {
              var itemClass = this.parentNode.parentNode.className;
              for (i = 0; i < accItem.length; i++) {
                  accItem[i].className = 'tab-passo';
              }
              if (itemClass == 'tab-passo') {
                  this.parentNode.parentNode.className = 'tab-passo active';
              }
          }

          function viewCadastroEstoque() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/estoque_insumo/semente/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewAplicarInsumo() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/insumo/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }
           function viewCadastroPropriedade() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/propriedade/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }
           function viewColheita() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/colheita/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewPlantio() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/plantio/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewCadastroInsumo() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/tutorial-insumo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewCadastroArea() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/area/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }
           function viewVenderLotes() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-vender-lotes.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewImprimirTrocarCliente() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-imprimiretiqueta-trocarcliente.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewGerarLaudo(){
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-gerar-laudo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewManejo(){
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-gerar-custos.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function mdDialogCtrl($scope, $mdDialog) {

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function close(){
               $mdDialog.hide();
          }

          function gotoPassoAPasso() {
               $state.go('app.passo.home');
          }

     }




})();

(function () {
    'use strict';

    angular
        .module('app.laudo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.laudo', {
                abstract: true,
                url: '/laudo'
            })
            .state('app.laudo.criar', {
                url: '/criar?venda_id&laudo_id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/laudo/views/criar.html',
                        controller: 'CriarLaudoController as vm'
                    }
                },
                resolve: {
                    model: function (laudoService, $stateParams) {
                        if ($stateParams.laudo_id)
                            return laudoService.get($stateParams.laudo_id);
                        else
                            return laudoService.getNew();
                    },
                    venda: function (vendidosService, $stateParams) {

                        if ($stateParams.venda_id)
                            return vendidosService.get($stateParams.venda_id);
                        else
                            return undefined;
                    },
                    defeitos: function (laudoService) {
                        return laudoService.getDefeitos();
                    },
                    classificacoes: function (laudoService) {
                        return laudoService.getClassificacao();
                    },
                    conclusoes: function (laudoService) {
                        return laudoService.getConclusao();
                    },
                    maturacoes: function (laudoService) {
                        return laudoService.getMaturacao();
                    },
                    calibres: function (laudoService) {
                        return laudoService.getCalibre();
                    },
                    coloracoes: function (laudoService) {
                        return laudoService.getColoracao();
                    },
                    odores: function (laudoService) {
                        return laudoService.getOdor();
                    },
                    pressoes: function (laudoService) {
                        return laudoService.getPressao();
                    },
                    sabores: function (laudoService) {
                        return laudoService.getSabor();
                    },
                    brixs: function (laudoService) {
                        return laudoService.getBrix();
                    },
                }
            })
            .state('app.laudo.visualizar', {
                url: '/visualizar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/laudo/views/visualizar.html',
                        controller: 'VisualizarLaudoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, laudoService) {
                        return laudoService.get($stateParams.id);
                    }
                }
            })
            .state('app.laudo.gerenciar', {
                url: '/gerenciar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/laudo/views/gerenciar.html',
                        controller: 'GerenciarLaudoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, laudoService) {
                        return laudoService.getLaudo($stateParams.id);
                    }
                }
            })

        $translatePartialLoaderProvider.addPart('app/main/laudo');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.laudo')
        .factory('laudoService', laudoService);

    /** @ngInject */
    function laudoService($q, api) {

        var queryResponse = {};
        var queryArgs = {};
        var transferData = {}

        var service = {
            query: query,
            getNew: getNew,
            get: get,
            create: create,

            getDefeitos: getDefeitos,
            getClassificacao: getClassificacao,
            getOcorrencia: getOcorrencia,
            getMaturacao: getMaturacao,
            getCalibre: getCalibre,
            getColoracao: getColoracao,
            getOdor: getOdor,
            getPressao: getPressao,
            getLaudo: getLaudo,
            getSabor: getSabor,
            getBrix: getBrix,
            cancelarLaudo: cancelarLaudo,
            getConclusao: getConclusao,

            uploadFile: uploadFile,
            uploadFiles: uploadFiles,
            getPdfFile: getPdfFile,
            setLaudoConfirmation: setLaudoConfirmation,
            getLaudoConfirmation: getLaudoConfirmation
        };

        return service;

        function getNew() {
            return {
                // laudo_upload_file: []
            };
        }

        function setLaudoConfirmation(data) {
          transferData = data;
        }

        function getLaudoConfirmation() {
         return transferData;
        }
       

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.Laudo.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.Laudo
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function cancelarLaudo(model) {
            return api.Laudo.cancelarLaudo(model).$promise;
        }


        function get(id) {

            var deferred = $q.defer();

            api.Laudo.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getDefeitos() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    descricao: 'Amassado'
                },
                {
                    id: 2,
                    descricao: 'Dano profundo'
                },
                {
                    id: 3,
                    descricao: 'Mancha'
                },
                {
                    id: 4,
                    descricao: 'Podridão'
                },
                {
                    id: 5,
                    descricao: 'Rusting'
                },
                {
                    id: 6,
                    descricao: 'Com talo'
                },
                {
                    id: 7,
                    descricao: 'Sem talo'
                },
                {
                    id: 8,
                    descricao: 'Outro'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getConclusao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    descricao: 'Conforme'
                },
                {
                    id: 2,
                    descricao: 'Não conforme'
                },
                {
                    id: 3,
                    descricao: 'Parcialmente conforme'
                },
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getClassificacao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Leve'
                },
                {
                    id: 2,
                    nome: 'Grave'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getOcorrencia() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Presente'
                },
                {
                    id: 2,
                    nome: 'Ausente'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getMaturacao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getCalibre() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getColoracao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getOdor() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getPressao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getSabor() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getBrix() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function uploadFile(file) {

            // Create a new deferred object
            var deferred = $q.defer();


            api.File.upload({
                uploadedFile: file
            }).$promise
                .then(function (response) {

                    console.log('laudoService.upload.then', response);

                    // Resolve the promise
                    deferred.resolve(response);

                })
                .catch(function (response) {
                    // Reject the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function uploadFiles(files) {

            // Create a new deferred object
            var deferred = $q.defer();


            api.Files.upload({
                uploadedFile: files
            }).$promise
                .then(function (response) {

                    console.log('laudoService.upload.then', response);

                    // Resolve the promise
                    deferred.resolve(response);

                })
                .catch(function (response) {

                    // Reject the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function getLaudo(id) {
            var deferred = $q.defer();

            api.LoteLaudoVenda.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        ////// HISTÓRICO DA ÁREA ////// 
        function getPdfFile(laudo_id) {

            var deferred = $q.defer();

            api.LaudoPdf
                .get({
                    id: laudo_id
                })
                .$promise.then(
                    function (response) {
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
                });
            return deferred.promise;
        }
        ////// HISTÓRICO DA ÁREA ////// 

    }
})();
(function () {
    'use strict';

    angular
        .module('app.laudo')
        .controller('VisualizarLaudoController', VisualizarLaudoController)

    /** @ngInject */
    function VisualizarLaudoController($state, model) {
        var vm = this;
        // Data
        vm.model = model;

        vm.comeBack = comeBack;
        // vm.addLaudoAmostra = addLaudoAmostra;
        // vm.addDefeito = addDefeito;

        init();

        function init() {

            // vm.model.laudo_amostra = {
            //     laudo_amostra_medida : new Array()
            // }
            
            // vm.model.laudo_defeito = new Array();

            // vm.addLaudoAmostra();
            // vm.addDefeito();


            for (let index = 0; index < vm.model.laudo_defeito.length; index++) {
                const element = vm.model.laudo_defeito[index];
                
                if (vm.model.laudo_defeito_descricao) {

                    if (vm.model.laudo_defeito[vm.model.laudo_defeito.length - 1].id == element.id)
                        vm.model.laudo_defeito_descricao += ' e ' + element.descricao
                    else
                        vm.model.laudo_defeito_descricao += ', ' + element.descricao
                }
                else {
                    vm.model.laudo_defeito_descricao = element.descricao
                }
            }
        }

        // function addLaudoAmostra() {
        //     vm.model.laudo_amostra.laudo_amostra_medida.push({
        //         medida: ""
        //     });
        // }

        // function addDefeito() {
        //     vm.model.laudo_defeito.push({
        //         laudo_defeito_tipo_id: '', 
        //         laudo_defeito_classificacao_id: '', 
        //         porcentagem: '',
        //         laudo_defeito_tipo_outro: {
        //             descricao: ""
        //         }
        //     });
        // }

        function comeBack(){
            javascript:history.back(1);
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.laudo')
        .controller('GerenciarLaudoController', GerenciarLaudoController)
        .controller('mdDialogPrintLaudo', mdDialogPrintLaudo)
        .run(['$anchorScroll', function($anchorScroll) {
            $anchorScroll.yOffset = 50;
        }]);

    /** @ngInject */
    function GerenciarLaudoController(model, $state, $mdDialog, $scope, laudoService, $rootScope, $filter, $location, $mdToast, $anchorScroll) {
         var vm = this;

         // Data
         vm.model = model;

         // Methods
         vm.comeBack = comeBack;
         vm.gotoCriar = gotoCriar;
         vm.gotoReCriar = gotoReCriar;
         vm.gotoPrintLaudo = gotoPrintLaudo;
         vm.cancelarLaudo = cancelarLaudo;
         vm.gotoVisualizarLaudo = gotoVisualizarLaudo;
         vm.gotoLaudosGerados = gotoLaudosGerados;
         //////////

         init();

         /**
          * Initialize
          */
        function init() {

            vm.redirectBack = laudoService.getLaudoConfirmation();

            if(vm.redirectBack.success){
                gotoLaudosGerados();
            }
        }

        function gotoLaudosGerados() {
            $location.hash('laudos-gerados');
            $anchorScroll();
        };

        function cancelarLaudo(model) {

            this.savePromise = laudoService.cancelarLaudo(model);
            $rootScope.loadingProgress = true;
            this.savePromise.then(function(response) {
                $rootScope.loadingProgress = false;
                angular.copy(response, model);
                console.log(response);
                $mdToast.show(
                        $mdToast.simple()
                        .textContent($filter('translate')('LAUDO.LAUDO_CANCELADO'))
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );
            }).catch(function(response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoPrintLaudo(model, ev) {

        // var confirm = $mdDialog.confirm()
        //     // .title('Atenção.')
        //     .textContent('Aguarde enquanto preparamos o seu laudo?')
        //     .targetEvent(model)
        //     // .ok('!')
        //     .cancel('Não quero!');

        // $mdDialog.show(confirm)
        //     .then(function () {

        //     }, function () {
        //         return null
        //     });

        $mdDialog.show({
            controller: 'mdDialogPrintLaudo as vm',
            templateUrl: 'app/main/laudo/views/laudo-download.tmpl.html',
            resolve: {
                model: function (laudoService) {
                    return laudoService.get(model.id);
                }
            },
            parent: angular.element(document.body),
            targetEvent: ev,
            clickOutsideToClose: false,
            fullscreen: false
        })
            .then(function (answer) {
                $scope.status = 'You said the information was "' + answer + '".';
            }, function () {
                $scope.status = 'You cancelled the dialog.';
            });


        $rootScope.loadingProgress = true;

        laudoService.getPdfFile(model.id)
            .then(function (data) {

                $rootScope.loadingProgress = false;

                var link = document.createElement('a');

                link.href = window.URL.createObjectURL(data.response);
                link.download = 'laudo ' + model.id;
                link.click();

                $mdDialog.hide();

                document.body.removeChild(link);

            }).catch(function (data) {
                $rootScope.loadingProgress = false;
            })
        }
            
        function comeBack(){
            javascript:history.back(1);
        }

        function gotoCriar(id) {
            $state.go('app.laudo.criar',{
                venda_id: id
            });
        }
        
        function gotoVisualizarLaudo(id) {
            $state.go('app.laudo.visualizar',{
                id: id
            });
        }
        
        function gotoReCriar(laudo_id, venda_id) {
            $state.go('app.laudo.criar',{
                laudo_id: laudo_id,
                venda_id: venda_id
            });
        }
        
    }
    
    function mdDialogPrintLaudo($scope, model, $mdDialog) {
     
          var vm = this;
          vm.model = model;

          //data
          // vm.dismissModal = dismissModal;
          vm.exportImpressao = exportImpressao;
          
          init();
          
          function init() {

               for (let index = 0; index < vm.model.laudo_defeito.length; index++) {
                    const element = vm.model.laudo_defeito[index];
                    
                    if (vm.model.laudo_defeito_descricao) {
    
                        if (vm.model.laudo_defeito[vm.model.laudo_defeito.length - 1].id == element.id)
                            vm.model.laudo_defeito_descricao += ' e ' + element.descricao
                        else
                            vm.model.laudo_defeito_descricao += ', ' + element.descricao
                    }
                    else {
                        vm.model.laudo_defeito_descricao = element.descricao
                    }
                }
          }

          $scope.dismissModal = function () {
               $mdDialog.cancel();
          }

          function exportImpressao () {
               $("#impressao").clone().appendTo("#printThis");

               var element = document.getElementById('printThis');
               var opt = {
                    margin: 0.1,
                    filename: 'laudo.pdf',
                    image: {
                         type: 'jpeg',
                         quality: 1
                    },
                    html2canvas: {
                         scale: 2,
                         logging: true
                    },
                    jsPDF: {
                         unit: 'in',
                         format: 'a4',
                         orientation: 'portrait'
                    }
               };
               html2pdf(element, opt);
               $mdDialog.hide();
          }
     }
})();

(function () {
    'use strict';

    angular
        .module('app.laudo')
        .controller('CriarLaudoController', CriarLaudoController)

    /** @ngInject */
    function CriarLaudoController($rootScope, $anchorScroll, $location, $scope, $stateParams, $state, $window, $filter, laudoService, plantioService, $mdDialog, $mdToast, model, venda, defeitos, conclusoes, classificacoes, sabores, brixs, maturacoes, calibres, coloracoes, odores, pressoes) {
        var vm = this;

        // Data
        vm.model = convertLaudoToModel(model);
        vm.venda = venda;
        vm.files = [];
        vm.model.confirmation = {
            success: 1
        };

        vm.defeitos = defeitos;
        vm.classificacoes = classificacoes;
        vm.conclusoes = conclusoes;
        vm.sabores = sabores;
        vm.brixs = brixs;
        vm.maturacoes = maturacoes;
        vm.calibres = calibres;
        vm.coloracoes = coloracoes;
        vm.odores = odores;
        vm.pressoes = pressoes;

        vm.api_response_erro = {};
        vm.limite_fotos = 6;
        vm.unidades_medidas = [
            { id: 1, nome: 'miligrama', sigla: 'mg' },
            { id: 2, nome: 'grama', sigla: 'g' },
            { id: 3, nome: 'quilograma', sigla: 'kg' },
            { id: 4, nome: 'Tonelada', sigla: 'T' }
        ];

        // Metodos
        vm.save = save;
        vm.confirmLaudo = confirmLaudo;
        vm.cancelClick = cancelClick;
        vm.gotoSearch = gotoSearch;
        vm.pesoChange = pesoChange;
        vm.culturaSearch = culturaSearch;
        vm.addLaudoAmostra = addLaudoAmostra;
        vm.removeLaudoAmostra = removeLaudoAmostra;
        vm.addDefeito = addDefeito;
        vm.removeDefeito = removeDefeito;
        vm.calcLaudoAmostra = calcLaudoAmostra;
        vm.gotoGerenciar = gotoGerenciar;
        //////////


        init();

        function init() {

            if (vm.venda)
                copiarDadosVenda(vm.venda);

            vm.model.laudo_amostra = {
                laudo_amostra_medida: new Array()
            }

            vm.model.laudo_defeito = new Array();

            vm.addLaudoAmostra();
            vm.addDefeito();

        }

        function save() {


            // verificação para deletar objeto quando o defeito for diferente de 'outros'
            for (let index = 0; index < vm.model.laudo_defeito.length; index++) {
                const element = vm.model.laudo_defeito[index];

                if (element.laudo_defeito_tipo_id != 8) {
                    delete element.laudo_defeito_tipo_outro;
                }
            };

            // Caso não tenha nenhum defeito, remove da lista, por não é obrigatório.
            if (vm.model.laudo_defeito.length == 1) {
                if (vm.model.laudo_defeito[0].laudo_defeito_classificacao_id == '' &&
                    vm.model.laudo_defeito[0].laudo_defeito_tipo_id == '' &&
                    vm.model.laudo_defeito[0].porcentagem == '')
                    vm.model.laudo_defeito = [];
            }


            // setar tipo_medida_id  = 1
            if (vm.model.unidade_medida == 'kg') {
                vm.model.laudo_amostra.tipo_medida_id = 1;
            }

            // setar tipo_medida_id  = 3
            if (vm.model.unidade_medida == 'unidades') {
                vm.model.laudo_amostra.tipo_medida_id = 3;
            }

            $rootScope.loadingProgress = true;

            laudoService
                .create(vm.model)
                .then(function (response) {

                    $rootScope.loadingProgress = false;
                    // vm.model.id = response.id;

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Laudo criado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    gotoGerenciar(vm.model.LoteDistribuicaoVendaId);
                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }

        function calcLaudoAmostra() {
            let data = vm.model.laudo_amostra.laudo_amostra_medida;
            let result = 0;
            for (let index = 0; index < data.length; index++) {
                const element = data[index].medida;
                var totalAmostra = result += element;
            }
            let resultTotal = totalAmostra * 100 / vm.model.quantidade;
            let resultMedia = totalAmostra / data.length;

            vm.model.laudo_amostra.total_medida = totalAmostra;
            vm.model.laudo_amostra.percentual_medida = resultTotal;
            vm.model.laudo_amostra.media_medida = resultMedia;
        }

        function addLaudoAmostra() {
            vm.model.laudo_amostra.laudo_amostra_medida.push({
                medida: ""
            });
        }

        function removeLaudoAmostra(index) {
            vm.model.laudo_amostra.laudo_amostra_medida.splice(index, 1);
        }

        function addDefeito() {
            vm.model.laudo_defeito.push({
                laudo_defeito_tipo_id: '',
                laudo_defeito_classificacao_id: '',
                porcentagem: '',
                laudo_defeito_tipo_outro: {
                    descricao: ""
                }
            });
        }

        function removeDefeito(index) {
            vm.model.laudo_defeito.splice(index, 1);
        }

        function saveFiles(form) {

            if (form.$invalid) {
                return;
            }

            var files = [];
            var indexFile = 0;
            for (var index = 0; index < vm.model.laudo_upload_file.length; index++) {
                var upload_file = vm.model.laudo_upload_file[index];

                if (upload_file.file) {
                    upload_file.indexFile = indexFile;
                    files.push(upload_file.file);
                    indexFile++;
                }
            }

            $rootScope.loadingProgress = true;

            laudoService
                .uploadFiles(files)
                .then(function (response) {

                    if (files.length != response.data.length) {

                        $rootScope.loadingProgress = false;

                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Ocorreu um erro ao carregar os arquivos. Tente novamente!')
                                .position('top right')
                                .theme("error-toast")
                                .hideDelay(6000)
                        );

                        return;
                    }

                    for (var index = 0; index < vm.model.laudo_upload_file.length; index++) {
                        var obj = vm.model.laudo_upload_file[index];

                        if (obj.indexFile != undefined)
                            obj.uploaded_file_id = response.data[obj.indexFile].id;
                    }

                    save();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }

        function confirmLaudo(form) {

            if (form.$invalid) {
                return;
            }

            if (isFileAdded()) {
                saveFiles(form);
            }
            else {
                save();
            }
        }

        function gotoSearch() {
            $window.history.back();
        }

        function gotoGerenciar(id) {

            var redirectGerenciar = vm.model.confirmation = { success: true }
            laudoService.setLaudoConfirmation(redirectGerenciar);

            $state.go('app.laudo.gerenciar', {
                id: id
            });
        }

        function cancelClick(form, ev) {
            if (!form.$dirty) {
                gotoSearch();
            } else {
                var confirm = $mdDialog.confirm()
                    .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                    .targetEvent(ev)
                    .ok($filter('translate')('REGISTERS.DESCARTAR'))
                    .cancel($filter('translate')('REGISTERS.CANCELAR'));
                $mdDialog.show(confirm).then(function () {
                    gotoSearch()
                }, null);
            }
        }

        function culturaSearch(query) {

            return plantioService.searchCultura(query);
        }

        function pesoChange() {

            var peso = 0;
            if (vm.model.peso_amostra)
                peso = vm.model.peso_amostra

            vm.model.percentual = 100 * peso / vm.model.quantidade
        }

        function isFileAdded() {

            if (!vm.model.laudo_upload_file)
                return false;

            var files = vm.model.laudo_upload_file.filter(function (item) {
                return item.file != undefined;
            });

            return files.length > 0;
        }

        function copiarDadosVenda(venda) {

            if (!venda)
                return;

            if (venda.lote_distribuicao)
                vm.model.lote_numero = venda.lote_distribuicao.lote_numero;

            if (venda.cliente_consumidor)
                vm.model.cliente_nome = venda.cliente_consumidor.nome;

            if (venda.cultura) {
                vm.model.cultura = venda.cultura.nome;
                vm.model.cultura_id = venda.cultura.id;
            }

            if (venda.data_expedicao) {
                vm.model.data_expedicao = venda.data_expedicao;
            }

            if (venda.produto_variedade)
                vm.model.produto_variedade = venda.produto_variedade;

            if (venda.quantidade) {
                vm.model.quantidade = venda.quantidade;
                vm.model.quantidade_disabled = true;
            }

            if (venda.embalagem_peso) {
                vm.model.embalagem_peso = venda.embalagem_peso;
            }

            if (venda.embalagem_tipo) {
                vm.model.embalagem_tipo = venda.embalagem_tipo;
            }

            if (venda.unidade_medida)
                vm.model.unidade_medida = venda.unidade_medida;

            if (venda.lote_distribuicao)
                vm.model.lote_id = venda.lote_distribuicao.id;

            if (venda.id)
                vm.model.LoteDistribuicaoVendaId = venda.id;

            if (venda.id)
                vm.model.lote_distribuicao_venda_id = venda.id;

            if (venda.cliente_consumidor)
                vm.model.cliente_consumidor_nome = venda.cliente_consumidor.nome;

            if (venda.cliente_consumidor)
                vm.model.cliente_consumidor_cnpj_cpf = venda.cliente_consumidor.cnpj_cpf;

            if (venda.cliente_consumidor) {
                vm.model.cliente_consumidor_cnpj_cpf = venda.cliente_consumidor.cnpj_cpf;

                if (vm.model.cliente_consumidor_cnpj_cpf.length == 11) {
                    vm.model.tipo_pessoa = 1;
                }

                if (vm.model.cliente_consumidor_cnpj_cpf.length == 14) {
                    vm.model.tipo_pessoa = 2;
                }
            }

            // vm.model.cliente_consumidor.nome = vm.model.cliente_consumidor_nome;
            // vm.model.cliente_consumidor.cnpj_cpf = vm.model.cliente_consumidor_cnpj_cpf;
        }

        function convertLaudoToModel(laudo) {

            if (!laudo)
                return {};

            if (laudo.quantidade) {
                laudo.quantidade_disabled = true;
            }

            if (laudo.id)
                laudo.lote_id = laudo.id

            if (laudo.responsavel_nome)
                laudo.responsavel = laudo.responsavel_nome;

            if (laudo.laudo_calibre)
                laudo.laudo_calibre_id = laudo.laudo_calibre.id;

            if (laudo.laudo_classificacao)
                laudo.laudo_classificacao_id = laudo.laudo_classificacao.id;

            if (laudo.laudo_coloracao)
                laudo.laudo_coloracao_id = laudo.laudo_coloracao.id;

            if (laudo.laudo_maturacao)
                laudo.laudo_maturacao_id = laudo.laudo_maturacao.id;

            if (laudo.laudo_ocorrencia)
                laudo.laudo_ocorrencia_id = laudo.laudo_ocorrencia.id;

            if (laudo.laudo_odor)
                laudo.laudo_odor_id = laudo.laudo_odor.id;

            if (laudo.laudo_pressao)
                laudo.laudo_pressao_id = laudo.laudo_pressao.id;

            if (laudo.laudo_sabor)
                laudo.laudo_sabor_id = laudo.laudo_sabor.id;

            if (laudo.laudo_brix)
                laudo.laudo_brix_id = laudo.laudo_brix.id;

            if (laudo.laudo_conclusao)
                laudo.laudo_conclusao.laudo_conclusao_conformidade_id = laudo.laudo_conclusao.laudo_conclusao_conformidade.id;

            if (laudo.cultura) {
                laudo.cultura = laudo.cultura.nome;
                laudo.cultura_id = laudo.cultura.id;
            }

            return laudo
        }
    }

})();
(function () {
     'use strict';

     angular
          .module('app.home', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
          .state('app.home', {
               url: '/home',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home.html',
                         controller: 'HomeController as vm',
                         resolve: {
                              authorize: function (authorization) {
                                   authorization.authorize();
                              },
                              // cliente: function (clientePerfilService) {
                              //      return clientePerfilService.get();
                              // },
                              showWelcomeMessage: function ($stateParams) {
                                   return $stateParams.showWelcomeMessage;
                              }
                         }
                    }
               }
          })
          .state('app.areas', {
               url: '/home/areas',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-areas.html'
                    }
               }
          })
          .state('app.manejos', {
               url: '/home/manejos',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-manejos.html'
                    }
               }
          })
          .state('app.insumos', {
               url: '/home/insumos',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-manejos-insumos.html'
                    }
               }
          })
          .state('app.estoque', {
               url: '/home/estoque',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-estoque.html'
                    }
               }
          })
          .state('app.estoque_gestao', {
               url: '/home/estoque-gestao',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-estoque-gestao.html'
                    }
               }
          })
          .state('app.home-financeiro', {
               url: '/home/financeiro',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-financeiro.html'
                    }
               }
          })
          .state('app.home-cadastros', {
               url: '/home/cadastros',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-cadastros.html'
                    }
               }
          })
          .state('app.home-caldas', {
               url: '/home/caldas',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-caldas.html'
                    }
               }
          })
          .state('app.home-previsao', {
               url: '/home/previsao-colheita',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-previsao-colheita.html'
                    }
               }
          })
          .state('app.home-propriedade', {
               url: '/home/propriedade',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-propriedade.html'
                    }
               }
          })
          .state('app.home-fechamento_mensal', {
               url: '/home/fechamento_mensal',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-fechamento_mensal.html'
                    }
               }
          })
          .state('app.home-lotes_produzidos', {
               url: '/home/lotes_produzidos',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/home/view/home-lotes_produzidos.html'
                    }
               }
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/home');


          //Menu
          msNavigationServiceProvider.saveItem('home', {
               title: 'Home',
               weight: 1,
               icon: 'icon-home',
               state: 'app.home',
               //translate: 'HOME.HOME'
          });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.home')
          .factory('HomeService', HomeService);

     /** @ngInject */
     function HomeService() {

          var modelNew = {};

          var service = {
               getNew: getNew,
          };

          return service;

          //////////

          function getNew() {
               return modelNew;
          }
     }

})();

(function () {
     'use strict';

     angular
          .module('app.home')
          .controller('HomeController', HomeController)



     /** @ngInject */
     function HomeController($mdDialog, $state) {
          var vm = this;
          vm.close = close;
          // vm.FnhideMsg = FnhideMsg;
          vm.goToLaudo = goToLaudo;
          vm.viewCadastroPropriedade = viewCadastroPropriedade;
          vm.viewCadastroArea = viewCadastroArea;
          vm.viewCadastroInsumo = viewCadastroInsumo;
          vm.viewPlantio = viewPlantio;
          vm.viewAplicarInsumo = viewAplicarInsumo;
          vm.viewCadastroEstoque = viewCadastroEstoque;
          vm.viewColheita = viewColheita;
          vm.viewVenderLotes = viewVenderLotes;
          vm.viewImprimirTrocarCliente = viewImprimirTrocarCliente;
          vm.viewGerarLaudo = viewGerarLaudo;


          init();

          function init(){
          }

          // function getName() {
          //      clientePerfilService.get().then(function (response) {
          //           // eslint-disable-next-line no-console
          //           console.log(response);
          //           vm.model = response
          //      });
          // }

          function goToLaudo() {
               $mdDialog.hide();
               $state.go('app.vendas.lotes_vendidos.buscar');
           }

           function viewCadastroEstoque() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/estoque_insumo/semente/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewAplicarInsumo() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/tutorial-insumo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }
           function viewCadastroPropriedade() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/propriedade/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }
           function viewColheita() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/colheita/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewPlantio() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/plantio/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewCadastroInsumo() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/estoque_insumo/cadastro_insumo/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewCadastroArea() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/area/views/tutorial.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }
           function viewVenderLotes() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-vender-lotes.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewImprimirTrocarCliente() {
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-imprimiretiqueta-trocarcliente.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function viewGerarLaudo(){
               $mdDialog.show({
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/home/view/videos/tutorial-gerar-laudo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
           }

           function mdDialogCtrl($scope, $mdDialog) {

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function close(){
               $mdDialog.hide();
          }

          // function FnhideMsg(event){
          //      if(event == true){
          //           localStorage.setItem('modalCurso', true)
          //           return
          //      }
          //      localStorage.removeItem('modalCurso')
          // }




     }




})();

(function () {
     'use strict';

     angular
          .module('app.dashboard', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
          // State
          $stateProvider.state('app.dashboard', {
               url: '/dashboard?showWelcomeMessage',
               views: {
                    'content@app': {
                         templateUrl: 'app/main/dashboard/view/dashboard.html',
                         controller: 'DashboardController as vm',
                         resolve: {
                              authorize: function (authorization) {
                                   authorization.authorize();
                              },
                              dashboard: function (DashboardService) {
                                   return DashboardService.dashboard();
                              },
                              // cliente: function (clientePerfilService) {
                              //      return clientePerfilService.get();
                              // },
                              showWelcomeMessage: function ($stateParams) {
                                   return $stateParams.showWelcomeMessage;
                              }
                         }
                    }
               }
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/dashboard');


          //Menu
          // msNavigationServiceProvider.saveItem('dashboard', {
          //      title: 'Painel de Controle',
          //      weight: 2,
          //      icon: 'icon-view-dashboard',
          //      state: 'app.dashboard',
          //      translate: 'DASHBOARD.DASHBOARD'
          // });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.dashboard')
          .factory('DashboardService', DashboardService);

     /** @ngInject */
     function DashboardService($q, $mdToast, $filter, api) {

          var modelNew = {};

          var service = {
               getNew: getNew,
               query: query,
               buscabyEmail: buscabyEmail,
               licencasdisponiveis: licencasdisponiveis,
               vinculaAssinatura: vinculaAssinatura,
               LicencasVinculadas: LicencasVinculadas,
               RemoverAssinatura: RemoverAssinatura,
               CancelaConvite: CancelaConvite,
               boleto: boleto,
               LicencasBloqueadas: LicencasBloqueadas,
               AssinaturaNaoVinculadas: AssinaturaNaoVinculadas,
               VincularAssinatura: VincularAssinatura,
               dashboard: dashboard,
          };

          return service;

          //////////

          function getNew() {
               return modelNew;
          }

          function boleto(model) {

               var deferred = $q.defer();

               api.Boleto.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }

          function CancelaConvite(model) {

               var deferred = $q.defer();

               api.CancelaAssinatura.cancela(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         colheitas.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }

          // transfere assinatura //
          function vinculaAssinatura(model) {
               var deferred = $q.defer();

               api.Assinatura.update(model).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function RemoverAssinatura(model) {
               var deferred = $q.defer();

               api.RemoverAssinatura.remover(model).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function CancelaConvite(model) {
               var deferred = $q.defer();

               api.CancelaConvite.cancela(model).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function LicencasBloqueadas(args) {
               var deferred = $q.defer();

               args.per_page = 9999;

               api.LicencasBloqueadas.query(args).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          ////// Quantidade Licenças disponiveis ////// 

          function licencasdisponiveis(query) {
               var deferred = $q.defer();

               api.Licencasdisponiveis.query({
                    page: 1,
                    per_page: 9999
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function dashboard() {
               var deferred = $q.defer();

               api.Dashboard.get({
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function AssinaturaNaoVinculadas(assinatura_plano_pagamento_id) {
               var deferred = $q.defer();

               api.AssinaturaNaoVinculadas.query({
                    page: 1,
                    per_page: 9999,
                    assinatura_plano_pagamento_id: assinatura_plano_pagamento_id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          // vincula assinatura ao cliente 
          function VincularAssinatura(model) {
               var deferred = $q.defer();

               api.VincularAssinatura.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         pagamentos.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;

          }

          function LicencasVinculadas(query) {
               var deferred = $q.defer();

               api.LicencasVinculadas.query({
                    page: 1,
                    per_page: 9999
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function buscabyEmail(email) {
               var deferred = $q.defer();

               api.Cliente.query({
                    email: email
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               var deferred = $q.defer();

               if (!args) {
                    args = queryCache.args;
               }

               if (queryCache.response && cache && angular.equals(args, queryCache.args)) {
                    deferred.resolve(queryCache.response);
                    console.log("query using: true");
               } else {

                    api.licencasvinculadas.query(args).$promise
                         .then(function (response) {
                              queryCache.args = angular.copy(args);
                              queryCache.response = response;
                              // TODO: setar o valid
                              deferred.resolve(queryCache.response);

                         }).catch(function (response) {
                              deferred.reject(response);
                              console.log(response);
                         });
               }

               return deferred.promise;
          };
     }

})();
(function () {
     'use strict';

     angular
          .module('app.dashboard')
          .controller('DashboardController', DashboardController)
          .controller('BemvindoController', BemvindoController)
          .controller('TransferenciaController', TransferenciaController);


     /** @ngInject */
     function DashboardController($state, dashboard, $rootScope, $mdToast, $filter, DashboardService, DadosPagamentoService, showWelcomeMessage, propertieService, areaService, plantioService, insumoFertilizanteService, insumoBiologicoService, insumoDefensivoService, colheitaService, clientePerfilService, produtoresService, $mdDialog, $scope, $window) {
          var vm = this;

          // compradosService

          vm.showWelcomeMessage = showWelcomeMessage;

          //vm.cliente = cliente;

          vm.propriedades = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.areas = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.plantios = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.biologicos = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.defensivos = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.fertilizantes = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.colheitas = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.comprados = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.externos = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.vendidos = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.produtores = {
               processando: true,
               total_rows: 0,
               data: null
          };
          vm.clientePerfil = {
               processando: true,
               total_rows: 0,
               data: null
          };

          vm.AssinaturaTipoIdSelecionado = '';
          vm.AssinaturasParaVinculo = [];



          vm.licencasdisponiveis = [];
          vm.licencasvinculadas = [];

          vm.dashboard = dashboard;
          vm.gotoPropriedades = gotoPropriedades;
          vm.gotoAreas = gotoAreas;
          vm.gotoPlantios = gotoPlantios;
          vm.gotoBiologicos = gotoBiologicos;
          vm.gotoDefensivos = gotoDefensivos;
          vm.gotoFertilizantes = gotoFertilizantes;
          vm.gotoColheitas = gotoColheitas;
          //vm.gotoExternos = gotoExternos;
          //vm.gotoComprados = gotoComprados;
          //vm.gotoVendidos = gotoVendidos;
          vm.gotoProdutores = gotoProdutores;
          vm.showWelcomeMessage = showWelcomeMessage;
          vm.fn_showWelcomeMessage = fn_showWelcomeMessage;
          vm.vincular = vincular;
          vm.vinculado = vinculado;
          vm.gerenciar = gerenciar;
          vm.cancelar = cancelar;
          vm.cancel = cancel;
          vm.cancelado = cancelado;
          vm.addVinculo = addVinculo;
          vm.removeVinculo = removeVinculo;
          vm.showDialogTransferencia = showDialogTransferencia;
          vm.comprar = comprar;
          vm.setPlano = setPlano;
          vm.next = next;
          vm.enviarPagamento = enviarPagamento;
          vm.gotoDashboard = gotoDashboard;
          vm.buscabyEmail = buscabyEmail;
          vm.RemoverAssinatura = RemoverAssinatura;
          vm.showDialogCancelar = showDialogCancelar;
          vm.showDialogCancelarResposta = showDialogCancelarResposta;
          vm.setPlanoCartao = setPlanoCartao;
          vm.setPlanoBoleto = setPlanoBoleto;
          vm.filtro = '';
          //vm.setClienteStorage = setClienteStorage;
          vm.clearAll = clearAll;
          vm.pagamentoBoleto = pagamentoBoleto;
          vm.AssinaturaNaoVinculadas = AssinaturaNaoVinculadas;
          vm.EnviaAssinatura = EnviaAssinatura;
          vm.setLicenca = setLicenca;
          vm.LicencasBloqueadas = LicencasBloqueadas;
          vm.selectYearly = selectYearly;
          vm.selectMonthly = selectMonthly;
          //vm.plano_pagamento_id = vm.plano_pagamento_id;
          vm.isFormValid = isFormValid;

          vm.filtrarLicencasPorVinculado = function (vinculado) {
               return vm.licencasdisponiveis.filter(
                    function (s) {
                         return s.vinculado == vinculado
                    }
               );
          };



          vm.quantidadeLicencasvinculadas = function () {
               return vm.licencasvinculadas.filter(
                    function (s) {
                         return !s.disponiveis
                    }
               ).length;
          };

          vm.getPortadorFromLicencasvinculadas = function (vinculadas) {


               if (vinculadas.convite_processamento_status.id == 1) {
                    return {
                         nome: vinculadas.cliente_portador.nome,
                         email: vinculadas.cliente_portador.email
                    };
               } else {
                    return {
                         nome: vinculadas.convites_usuarios.length > 0 ? vinculadas.convites_usuarios[0].nome_convidado : "",
                         email: vinculadas.convites_usuarios.length > 0 ? vinculadas.convites_usuarios[0].email_convidado : ""
                    };
               }
          }

          init();

          function init() {

               vm.model = {
                    mensall: true
               };


               if (vm.showWelcomeMessage) {
                    vm.fn_showWelcomeMessage();
               }

               if (vm.model.vinculo == null) {
                    vm.model.vinculo = new Array();
               }

               // if (vm.model.dados_assinatura == null) {
               //      vm.model.dados_assinatura = new Array();
               // }

               vm.planos = [{
                    nome: "Por ano",
                    valor: 385,
                    plano_pagamento_id: 2,
                    boleto: true,
               },
               {
                    nome: "Por mês",
                    valor: 35,
                    plano_pagamento_id: 1,
               }];

               // queryPropriedade(propertieService, vm.propriedades);
               // queryPropriedade(areaService, vm.areas);
               // queryPropriedade(plantioService, vm.plantios);
               // queryPropriedade(insumoBiologicoService, vm.biologicos);
               // queryPropriedade(insumoDefensivoService, vm.defensivos);
               // queryPropriedade(insumoFertilizanteService, vm.fertilizantes);
               // queryPropriedade(colheitaService, vm.colheitas);
               // queryPropriedade(compradosService, vm.comprados);
               // queryPropriedade(externosService, vm.externos);
               // queryPropriedade(vendidosService, vm.vendidos);
               // queryPropriedade(produtoresService, vm.produtores);
               loadLicencasDisponiveis();
               loadLicencasVinculadas();

          }

          function fn_showWelcomeMessage(ev) {
               $mdDialog.show({
                    controller: 'BemvindoController as vm',
                    templateUrl: 'app/main/dashboard/view/bemvindo.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
               })
          }

          function showDialogTransferencia(ev, model) {
               $mdDialog.show({
                    locals: {
                         dataToPass: model
                    },
                    controller: 'TransferenciaController as vm',
                    templateUrl: 'app/main/dashboard/view/licencas/transfere.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true
               }).then(function () {

                    loadLicencasDisponiveis();
                    loadLicencasVinculadas();

               });

          }

          function showDialogCancelar(model) {
               model.showDialogCancelar = true;
               model.mensagem = "";
          }

          function setPlanoCartao() {
               vm.model.setplanocartao = true;
               vm.model.setplanoboleto = false;
          }

          function setPlanoBoleto() {
               vm.model.setplanocartao = false;
               vm.model.setplanoboleto = true;
          }


          // var inclusao = vinculadas.data_inclusao;
          // var calculo_inclusao = moment(startdate, "DD-MM-YYYY").subtract('days', 7);

          // inclusao = calculo_inclusao;

          function showDialogCancelarResposta(model, resposta) {

               if (resposta == 'sim') {

                    let cancelarpromisse;
                    if (model.convite_processamento_status.id == 1) {
                         cancelarpromisse = DashboardService.RemoverAssinatura(model);
                    } else {
                         model.convite_id = model.convites_usuarios[0].id
                         model.assinatura_id = model.id
                         cancelarpromisse = DashboardService.CancelaConvite(model);
                    }

                    cancelarpromisse
                         .then(function (response) {

                              model.mensagem = "Cancelado com sucesso!";
                              model.cancelado = true;
                              setTimeout(function () {
                                   loadLicencasDisponiveis();
                                   loadLicencasVinculadas();
                              }, 6000);

                              model.showDialogCancelar = false;

                         }).catch(function (response) {
                              // TODO: pegar mensagem do back
                              // model.mensagem = response.data.detail;

                         });
               }
               if (resposta == 'nao') {
                    model.showDialogCancelar = false;
                    model.mensagem = "";
               }


          }

          // function setClienteStorage() {
          //      clientePerfilService.get().then(function (response) {
          //           console.log(response);
          //           vm.model.cliente = {
          //                email: response.email,
          //                cnpj_cpf: response.cnpj_cpf,
          //                nome: response.nome,
          //                telefone: {
          //                     ddd: response.cliente_telefone.ddd,
          //                     numero: response.cliente_telefone.numero,
          //                },
          //                endereco: {
          //                     cep: response.cliente_endereco.cep,
          //                     bairro: response.cliente_endereco.bairro,
          //                     cidade_nome: response.cliente_endereco.cidade_nome,
          //                     rua: response.cliente_endereco.endereco,
          //                     uf: response.cliente_endereco.uf,
          //                     numero: response.cliente_endereco.numero,
          //                     complemento: response.cliente_endereco.complemento
          //                }
          //           }
          //      });
          // }

          function clearAll() {
               vm.model.cliente = null;
          }


          // function queryPropriedade(service, item) {

          //      item.processing = true;
          //      service.query({
          //           page: 1,
          //           per_page: 1
          //      }, false).then(function (response) {
          //           item.processing = false;
          //           angular.copy(response, item);

          //      }).catch(function (response) {
          //           item.processing = false;
          //           // TODO: implementar erro
          //           console.warn(response);
          //      });

          // }

          function gotoPropriedades() {
               $state.go('app.registro.propriedade.buscar');
          }

          function gotoAreas() {
               $state.go('app.registro.area.buscar');
          }

          function gotoPlantios() {
               $state.go('app.registro.manejo.plantio.buscar');
          }

          function gotoBiologicos() {
               $state.go('app.registro.manejo.insumo.biologico.buscar');
          }

          function gotoDefensivos() {
               $state.go('app.registro.manejo.insumo.defensivo.buscar');
          }

          function gotoFertilizantes() {
               $state.go('app.registro.manejo.insumo.fertilizante.buscar');
          }

          function gotoColheitas() {
               $state.go('app.registro.manejo.colheita.buscar');
          }

          // function gotoComprados() {
          //      $state.go('app.compras.lotes_comprados.buscar');
          // }

          // function gotoExternos() {
          //      $state.go('app.compras.lotes_externos.buscar');
          // }
          // function gotoVendidos() {
          //      $state.go('app.vendas.lotes_vendidos.buscar');
          // }

          function vincular() {
               vm.model.vincular = true;
               vm.model.gerenciar = false;
               vm.model.comprar = false;
          }

          function vinculado() {
               vm.model.vinculado = true;
          }

          function gerenciar() {
               vm.model.vincular = false;
               vm.model.vinculado = false;
               vm.model.gerenciar = true;
               vm.model.comprar = false;

          }

          function cancelar(model) {
               model.cancelar = true;
          }

          function cancel() {
               vm.model.cancelar = false;
          }

          function cancelado() {
               vm.model.cancelado = true;
               vm.model.cancelar = false;
          }

          function comprar() {
               vm.model.comprar = true;
               vm.model.beneficios = 1;
               vm.model.vincular = false;
               vm.model.gerenciar = false;
               vm.model.setplanoboleto = false;
               vm.boletogerado = false;
          }

          function enviarPagamento(model) {

               vm.processando = true;
               vm.model.numero_de_adicionais = vm.model.numero_de_assinaturas;
               this.savePromise = DadosPagamentoService.create(vm.model);
               this.savePromise.then(function (response) {

                    vm.model.id = response;
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.PAGAMENTO_SUCCESS'))
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(5000)
                    );
                    vm.model.beneficios = 3;

               }).catch(function (error) {
                    vm.processando = false;
                    vm.msgerro = error.data.errors;
                    console.error(error.data.errors);
               });
          }

          function pagamentoBoleto(model) {
               vm.processando = true;
               this.savePromise = DashboardService.boleto(vm.model);
               this.savePromise.then(function (response) {
                    window.open((response.url), "mywindow", "location=1,status=1,scrollbars=1, width = 800, height = 500");
                    console.log(response.url);
                    vm.processando = false;
                    vm.boletogerado = true;
               }).catch(function (response) {
                    vm.api_response_erro = response;
                    vm.processando = false;
               });
          }

          function LicencasBloqueadas(model) {
               DashboardService.LicencasBloqueadas(model).then(function (response) {
                    vm.models = response.data;
                    response.data;
                    console.log(vm.models);


               });
          }

          function next() {
               vm.model.beneficios = 2;
               vm.model.pagamento = true;
               vm.model.setplanocartao = true;
               if (vm.model.licenca == 1) {
                    vm.model.numero_de_adicionais = 0;
               };
               if (vm.model.numero_de_adicionais == null) {
                    vm.model.numero_de_adicionais = 0;
               }
               vm.model.numero_de_assinaturas = (vm.model.cliente_plano_pagamento.valor * vm.model.numero_de_adicionais) / vm.model.cliente_plano_pagamento.valor;

          }

          function gotoDashboard() {
               window.location.reload()
          }

          $scope.showAdvanced = function (ev) {

          }

          function isFormValid(formName) {
               if ($scope[formName] && $scope[formName].$valid) {
                    return $scope[formName].$valid;
               }
          }

          function setLicenca(model, tipo) {
               vm.model.AssinaturaTipoIdSelecionado = tipo;
               model.plano = tipo;
               if (tipo == 'Mensal') {
                    model.pendentes = vm.licencasdisponiveis.mensais.disponiveis;
               }
               if (tipo == 'Anual') {
                    model.pendentes = vm.licencasdisponiveis.anuais.disponiveis;
               }
               if (!model.dados_assinatura) {
                    model.dados_assinatura = {};
               }
               model.dados_assinatura.assinatura_tipo_id = tipo;
          }

          function loadLicencasDisponiveis() {
               DashboardService.licencasdisponiveis().then(function (response) {
                    vm.licencasdisponiveis = response.data

                    // angular.forEach(vm.licencasdisponiveis, function (value, key) {
                    //      // value.vinculado = false;
                    //      // value.convite_id = null;
                    // });

               });
          }

          function selectMonthly() {
               vm.model.mensal = true;
               vm.model.anual = false;
               vm.assinatura_plano_pagamento_id = 1;
               AssinaturaNaoVinculadas(vm.assinatura_plano_pagamento_id);
          }

          function selectYearly() {
               vm.model.mensal = false;
               vm.model.anual = true;
               vm.assinatura_plano_pagamento_id = 2;
               AssinaturaNaoVinculadas(vm.assinatura_plano_pagamento_id);
          }


          function AssinaturaNaoVinculadas(assinatura_plano_pagamento_id) {
               DashboardService.AssinaturaNaoVinculadas(assinatura_plano_pagamento_id).then(function (response) {

                    vm.AssinaturaNaoVinculadas = response.data;
                    console.log(response.data);
               });
          }

          function loadLicencasVinculadas() {
               DashboardService.LicencasVinculadas().then(function (response) {
                    vm.licencasvinculadas = response.data;

                    angular.forEach(vm.licencasvinculadas, function (value, key) {
                         value.vinculado = false;
                    });

               });
          }

          function EnviaAssinatura() {

               angular.forEach(vm.AssinaturasParaVinculo, function (value, key) {
                    value.api_response_erro = false;
                    value.convite_id = null; // O back está esperando null
                    value.processandocupom = true;
                    value.dados_assinatura;

                    DashboardService.VincularAssinatura(value)
                         .then(function (response) {


                              if (vm.model.mensal) {
                                   vm.model.mensal_ativo = true;
                              }

                              if (vm.model.anual) {
                                   vm.model.anual_ativo = true;

                              }

                              value.vinculadoComSucesso = true;
                              vm.btnvincula = true;
                              value.mensagem = "";
                              loadLicencasDisponiveis();
                              loadLicencasVinculadas();
                         }).catch(function (response) {
                              value.mensagem = response.data.detail;
                              vm.btnvincula = false;
                         });
               });
          }

          function gotoProdutores() {
               $state.go('app.produtores.consultar');
          }

          function addVinculo(assinatura_tipo_id) {

               var assinaturaParaVinculo = null;

               for (let index = 0; index < vm.AssinaturaNaoVinculadas.length; index++) {
                    const element = vm.AssinaturaNaoVinculadas[index];
                    if (element.selected || element.selected) {
                         continue;
                    }
                    element.selected = true;
                    assinaturaParaVinculo = element;
                    break;

               }

               if (assinatura_tipo_id == 2) {
                    assinatura_tipo_id = 'Teste';
               }

               vm.AssinaturasParaVinculo.push({
                    dados_assinatura: {
                         id: assinaturaParaVinculo.id,
                         nome: "",
                         email: "",
                         assinatura_tipo_id: assinatura_tipo_id
                    }
               });


               // vm.addVinculo(vm.model.AssinaturaTipoIdSelecionado


               // if (assinaturaTipoIdSelecionado == 'Mensal') {


               //      if (vm.licencasdisponiveis.mensais.disponiveis == 0) {
               //           return;
               //      }


               //      vm.licencasdisponiveis.mensais.disponiveis--
               //      vm.model.pendentes--
               // }
               // if (assinaturaTipoIdSelecionado == 'Anual') {
               //      if (vm.licencasdisponiveis.anuais.disponiveis == 0) {
               //           return;
               //      }

               //      vm.licencasdisponiveis.anuais.disponiveis--
               //      vm.model.pendentes--
               // }
               // vm.btnvincula = false;


               // vm.AssinaturasParaVinculo.push({
               //      convite_id: null,
               //      dados_assinatura: {
               //           nome: "",
               //           email: "",
               //           assinatura_tipo_id: assinaturaTipoIdSelecionado
               //      }
               // });
          }




          function removeVinculo(index) {
               // var selecionado = assinaturasParaVinculo[index];
               // if (selecionado.dados_assinatura.assinatura_tipo_id == 'Mensal') {
               //      vm.licencasdisponiveis.mensais.disponiveis++
               //      vm.model.pendentes++
               // }

               // if (selecionado.dados_assinatura.assinatura_tipo_id == 'Anual') {
               //      vm.licencasdisponiveis.anuais.disponiveis++
               //      vm.model.pendentes++
               // }

               var ass = vm.AssinaturasParaVinculo[index];

               for (let index = 0; index < vm.AssinaturaNaoVinculadas.length; index++) {
                    const element = vm.AssinaturaNaoVinculadas[index];
                    if (element.id != ass.dados_assinatura.id) {
                         continue;
                    }
                    element.selected = false;
                    break;

               }

               vm.AssinaturasParaVinculo.splice(index, 1);
          }

          function buscabyEmail(assinaturaParaVinculo) {
               DashboardService.buscabyEmail(assinaturaParaVinculo.dados_assinatura.email)
                    .then(function (response) {
                         if (response.data.length > 0) {
                              assinaturaParaVinculo.dados_assinatura.nome = response.data[0].nome;
                              assinaturaParaVinculo.dados_assinatura.cliente_endereco.cidade_nome = response.data[0].cliente_endereco.cidade_nome;
                              assinaturaParaVinculo.dados_assinatura.cliente_endereco.uf = response.data[0].cliente_endereco.uf;
                              angular.copy(response)
                              console.log(response)
                         }

                         if (response.data.length == 0) {
                              $mdToast.show(
                                   $mdToast.simple()
                                        .textContent($filter('translate')('DASHBOARD.EMAIL_SEMCADASTRO'))
                                        .position('top right')
                                        .theme("error-toast")
                                        .hideDelay(5000)
                              );


                         }
                         // if (response.data.length > 0) {
                         //      model.assinatura_cliente_portador = response.data;
                         // }


                    }).catch(function (response) {
                         vm.erroemail = true;
                         // $mdToast.show(
                         //      $mdToast.simple()
                         //           .textContent($filter('translate')('DASHBOARD.EMAIL_SEMCADASTRO'))
                         //           .position('top right')
                         //           .theme("error-toast")
                         //           .hideDelay(5000)
                         // );
                    });
          }


          function RemoverAssinatura() {
               var licencas = vm.licencasdisponiveis.filter(function (s) {
                    return s.vinculado
               });

               DashboardService.RemoverAssinatura(licencas)
                    .then(function (response) {
                         console.log(response)

                    }).catch(function (response) {
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent($filter('translate')('DASHBOARD.VINCULO_ERROR'))
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(5000)
                         );
                    });
          }


          function setPlano(plano) {
               vm.model.cliente_plano_pagamento = plano;
          }

          vm.getStatusDescription = function (model) {
               switch (model.status) {
                    case 1:
                         return "Ativo";
                    default:
                         return "Não informado"
               }
          }
     }


     function BemvindoController($mdDialog) {
          var vm = this;

          // Data
          vm.model = {};
          vm.api_response_erro = {};
          vm.close = close;

          // Metodos

          //////////

          init();

          function init() {

          }

          function close() {
               $mdDialog.hide();
          }

     }


     function TransferenciaController(dataToPass, $mdDialog, DashboardService, $mdToast, $filter) {

          var vm = this;
          vm.model = dataToPass
          vm.model.mensagem = "";
          vm.close = close;
          vm.buscabyEmail = buscabyEmail;

          vm.onClickTranfererir = function (model) {

               model.convite_id = null; // O back está esperando null
               DashboardService.vinculaAssinatura(model)
                    .then(function (response) {
                         vm.model.mensagem = "Transferido com sucesso!";
                         vm.model.transferido = true;
                         $mdDialog.hide('transferido');


                    }).catch(function (response) {
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent(response.data.detail)
                                   .position('top right')
                                   .theme("error-toast")
                                   .hideDelay(7000)
                         );
                    });
          }


          // // Data
          // vm.model = {};
          // vm.api_response_erro = {};


          // // Metodos

          // //////////

          // init();

          // function init() {

          // }
          function close() {
               $mdDialog.hide('cancelado');
          }

          function buscabyEmail(model) {
               DashboardService.buscabyEmail(model.assinatura_cliente_portador.email)
                    .then(function (response) {
                         console.log(response)
                         if (response.data.length > 0) {
                              model.assinatura_cliente_portador = response.data[0];
                         }

                         if (response.data.length == 0) {
                              $mdToast.show(
                                   $mdToast.simple()
                                        .textContent($filter('translate')('DASHBOARD.EMAIL_SEMCADASTRO'))
                                        .position('top right')
                                        .theme("error-toast")
                                        .hideDelay(5000)
                              );


                         }
                         // if (response.data.length > 0) {
                         //      model.assinatura_cliente_portador = response.data;
                         // }


                    }).catch(function (response) {
                         vm.erroemail = true;
                         // $mdToast.show(
                         //      $mdToast.simple()
                         //           .textContent($filter('translate')('DASHBOARD.EMAIL_SEMCADASTRO'))
                         //           .position('top right')
                         //           .theme("error-toast")
                         //           .hideDelay(5000)
                         // );
                    });
          }

     }


})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.dados_pagamento', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider.state('app.pages_auth_dados_pagamento', {
               url: '/pages/auth/dados_pagamento',
               views: {
                    'main@': {
                         templateUrl: 'app/core/layouts/content-only.html',
                         controller: 'MainController as vm'
                    },
                    'content@app.pages_auth_dados_pagamento': {
                         templateUrl: 'app/main/dados_pagamento/view/indexpag.html',
                         controller: 'DadosPagamentoController as vm',
                         resolve: {
                              model: function(DadosPagamentoService) {
                                   return DadosPagamentoService.getNew();
                              },
                              client: function (clientePerfilService) {
                                   return clientePerfilService.get();
                              }
                         }
                    }
               },
               bodyClass: 'dados_pagamento'
          })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/dados_pagamento');

          // Navigation
          // msNavigationServiceProvider.saveItem('pages.auth', {
          //      title: 'Authentication',
          //      icon: 'icon-lock',
          //      weight: 1
          // });

          // msNavigationServiceProvider.saveItem('pages.auth.plano_pagamento', {
          //      title: 'Pagamento',
          //      state: 'app.pages_auth_plano_pagamento'
          // });
     }
})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.dados_pagamento')
          .factory('DadosPagamentoService', DadosPagamentoService);

     /** @ngInject */
     function DadosPagamentoService($q, $mdToast, $filter, api) {

          var modelNew = {};
          var pagamentos = [];
          var models = [];

          var service = {
               getNew: getNew,
               create: create,
               pagboleto: pagboleto,
               BoletosValidos: BoletosValidos,
          };

          return service;

          //////////

          function getNew() {
               return modelNew;
          }

          function BoletosValidos() {
               var deferred = $q.defer();

               api.BoletosValidos.query().$promise.then(
                    function (response) {
                         models = response.data;
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          function create(model) {
               var deferred = $q.defer();

               api.Pagamento.save(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         pagamentos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;

          }

          function pagboleto(model) {
               var deferred = $q.defer();

               api.Cupom.save(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         pagamentos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;

          }
     }

})();
(function () {
     'use strict';

     angular
          .module('app.pages.auth.dados_pagamento')
          .controller('DadosPagamentoController', DadosPagamentoController)

     /** @ngInject */
     function DadosPagamentoController($rootScope, $scope, $window, $state, $filter, model, DadosPagamentoService, clientePerfilService, $mdToast, $mdDialog, principal, DashboardService) {
          var vm = this;


          vm.model = model;
          vm.setPlano = setPlano;
          vm.enviarPagamento = enviarPagamento;
          vm.gotoLogin = gotoLogin;
          vm.api_response_erro = {};
          vm.processando = false;
          vm.logout = logout;
          vm.setLicencas = setLicencas;
          vm.next = next;
          vm.back = back;
          vm.clearAll = clearAll;
          vm.gotoBemvindo = gotoBemvindo;
          vm.setcliente = setcliente;
          vm.setPlanoCartao = setPlanoCartao;
          vm.setPlanoBoleto = setPlanoBoleto;
          vm.setPlanoCupom = setPlanoCupom;
          vm.validadaCupom = validadaCupom;
          vm.pagamentoBoleto = pagamentoBoleto;
          vm.setClienteStorage = setClienteStorage;
          vm.gotoPagamento = gotoPagamento;
          vm.BoletosValidos = BoletosValidos;
          vm.reimprimeBoleto = reimprimeBoleto;
          // vm.cliente = cliente;
          //////////

          init();

          function init() {
               vm.model.beneficios = false;
               vm.model.pagamento = false;
               vm.bullets = [{
                    paginacao: "1",
                    index: 0
               }, {
                    paginacao: "2",
                    index: 1
               }];


               vm.descri = [
                    {
                         funcionalidades: [{
                              infos: "Consulta de Lote de Produtores"
                         },
                         {
                              infos: "Impressão de Etiqueta"
                         },
                         {
                              infos: "Liberação de consulta a compradores"
                         },
                         {
                              infos: "Cadastro de propriedade e áreas"
                         },
                         {
                              infos: "Cadastramento de Plantio"
                         },
                         {
                              infos: "Controle de Aplicações de Defensivos"
                         },
                         {
                              infos: "Controle de Aplicações de Fertilizantes"
                         },
                         {
                              infos: "Controle de Colheita com geração de Lote"
                         },
                         {
                              infos: "Rastreamento Aplicação de Insumos nos Lotes"
                         }
                         ]
                    }
               ];

               vm.selecionado = [
                    {
                         titulo: "Benefícios do Pacote"
                    },
                    {
                         titulo: "Plano selecionado"
                    }

               ]
               vm.planos = [
                    {
                         nome: "Por ano",
                         valor: 385,
                         plano_pagamento_id: 2,
                         boleto: true,
                    },
                    {
                         nome: "Por mês",
                         valor: 35,
                         plano_pagamento_id: 1,
                    }
               ];

               vm.model.licenca = 1;
               BoletosValidos();
          }
          function setClienteStorage() {
               clientePerfilService.get().then(function (response) {
                    console.log(response);
                    vm.model.cliente = {
                         email: response.email,
                         cnpj_cpf: response.cnpj_cpf,
                         nome: response.nome,
                         telefone: {
                              ddd: response.cliente_telefone.ddd,
                              numero: response.cliente_telefone.numero,
                         },
                         endereco: {
                              cep: response.cliente_endereco.cep,
                              bairro: response.cliente_endereco.bairro,
                              cidade_nome: response.cliente_endereco.cidade_nome,
                              rua: response.cliente_endereco.endereco,
                              uf: response.cliente_endereco.uf,
                              numero: response.cliente_endereco.numero,
                              complemento: response.cliente_endereco.complemento
                         }
                    }
               });
          }
          function next() {
               vm.model.cliente = null;
               vm.model.infos = {
                    id: 2
               };
               vm.model.beneficios = true;
               vm.model.pagamento = true;
               vm.model.setplanocartao = true;
               if (vm.model.licenca == 1) {
                    vm.model.numero_de_adicionais = 0;
               };
               if (vm.model.numero_de_adicionais == null) {
                    vm.model.numero_de_adicionais = 0;
               }
               vm.model.numero_de_assinaturas = (vm.model.cliente_plano_pagamento.valor * vm.model.numero_de_adicionais + vm.model.cliente_plano_pagamento.valor) / vm.model.cliente_plano_pagamento.valor;

          }
          function clearAll() {
               vm.model.cliente = null;
          }

          function setcliente() {
               vm.model.cliente = {
                    pessoa_tipo: vm.vm.cliente.pessoa_tipo,
                    nome: vm.cliente.nome,
                    email: vm.cliente.email,
                    cnpj_cpf: vm.cliente.cnpj_cpf,
                    telefone: {
                         ddd: vm.cliente.cliente_telefone.ddd,
                         numero: vm.cliente.cliente_telefone.numero,
                    },
                    endereco: {
                         rua: vm.cliente.cliente_endereco.endereco,
                         numero: vm.cliente.cliente_endereco.numero,
                         bairro: vm.cliente.cliente_endereco.bairro,
                         complemento: vm.cliente.cliente_endereco.complemento,
                         cep: vm.cliente.cliente_endereco.cep,
                         uf: vm.cliente.cliente_endereco.uf,
                         cidade_nome: vm.cliente.cliente_endereco.cidade_nome
                    }
               };
               console.log(cliente);
          }

          function back() {
               vm.model.beneficios = false;
               vm.model.pagamento = false;
               vm.model.setplanoboleto = false;
               vm.model.setplanocupom = false;
          }

          function setPlano(plano) {
               vm.model.cliente_plano_pagamento = plano;
          }
          function setPlanoCartao() {
               vm.model.setplanocartao = true;
               vm.model.setplanoboleto = false;
               vm.model.setplanocupom = false;
          }

          function setPlanoBoleto() {
               vm.model.setplanocartao = false;
               vm.model.setplanoboleto = true;
               vm.model.setplanocupom = false;

          }
          function setPlanoCupom() {
               vm.model.setplanocupom = true;
               vm.model.setplanocartao = false;
               vm.model.setplanoboleto = false;
          }
          function setLicencas(licencas) {
               vm.model.cliente_licencas_pagamento = licencas;
          }

          function enviarPagamento(model) {
               vm.processando = true;
               this.savePromise = DadosPagamentoService.create(vm.model);
               this.savePromise.then(function (response) {

                    vm.model.id = response;
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.PAGAMENTO_SUCCESS'))
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(5000)
                    );
                    gotoBemvindo();
               }).catch(function (response) {
                    vm.api_response_erro = response;
                    vm.processando = false;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.PAGAMENTO_ERROR'))
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(20000)
                    );
               });
          }

          function BoletosValidos() {
               vm.loadingProgress = true;
               DadosPagamentoService.BoletosValidos()
                    .then(function successCallback(data) {
                         vm.models = data;
                    }).finally(function () {
                         vm.loadingProgress = false;
                    });
          }


          function reimprimeBoleto() {
               vm.processando = true;
               this.savePromise = DadosPagamentoService.BoletosValidos();
               this.savePromise.then(function (response) {
                    window.open((response.data[0].cliente_pagar_me_transacao.boleto_url), "mywindow", "location=1,status=1,scrollbars=1, width = 800, height = 500");
                    console.log(response.data[0].cliente_pagar_me_transacao.boleto_url);
                    vm.processando = false;
                    vm.boletogerado = true;
               }).catch(function (response) {
                    vm.api_response_erro = response;
                    console.log(response)
                    vm.processandocupom = false;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.PAGAMENTO_ERROR'))
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(20000)
                    );
               });

          }

          function validadaCupom(model) {
               vm.api_response_erro = false;
               vm.model.assinatura_tipo_id = 1  // hoje o cupom é apenas intrasferivel
               vm.processandocupom = true;
               this.savePromise = DadosPagamentoService.pagboleto(vm.model);
               this.savePromise.then(function (response) {

                    vm.model.id = response;
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.PAGAMENTO_SUCCESS'))
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(5000)
                    );
                    gotoBemvindo();
               }).catch(function (response) {
                    vm.api_response_erro = response;
                    console.log(response)
                    vm.processandocupom = false;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.PAGAMENTO_ERROR'))
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(20000)
                    );
               });
          }


          function gotoLogin() {
               principal.goToLogin();
          }
          function pagamentoBoleto(model) {

               vm.model.assinatura_tipo_id = 1
               vm.processando = true;
               this.savePromise = DashboardService.boleto(vm.model);
               this.savePromise.then(function (response) {
                    // $window.open((response.url), '_blank');
                    window.open((response.url), "mywindow", "location=1,status=1,scrollbars=1, width = 800, height = 500");
                    console.log(response.url);
                    vm.processando = false;
                    vm.boletogerado = true;
               }).catch(function (response) {
                    vm.api_response_erro = response;
                    vm.processando = false;
               });
          }

          function logout() {
               principal.logout();
          }

          function gotoBemvindo() {
               $state.go('app.dashboard', {
                    showWelcomeMessage: true
               });
          }
          function gotoPagamento() {
               vm.models.data[0].boleto_valido = false;
          }
     }

})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.dados_convidado', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider.state('app.pages_auth_dados_convidado', {
               url: '/pages/auth/dados_convidado?convite_id=:id',
               views: {
                    'main@': {
                         templateUrl: 'app/core/layouts/content-only.html',
                         controller: 'MainController as vm'
                    },
                    'content@app.pages_auth_dados_convidado': {
                         templateUrl: 'app/main/dados_convidado/view/dados_convidado.html',
                         controller: 'DadosConvidadoController as vm',
                         resolve: {
                              model: function(DadosConvidadoService) {
                                   return DadosConvidadoService.getNew();
                              },
                              conviteAssinatura:function($stateParams, DadosConvidadoService){
                                   return DadosConvidadoService.conviteAssinatura( $stateParams.convite_id);
                              }

                         }
                    }
               },
               bodyClass: 'dados_convidado'
          })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/dados_convidado');

          // Navigation
          // msNavigationServiceProvider.saveItem('pages.auth', {
          //      title: 'Authentication',
          //      icon: 'icon-lock',
          //      weight: 1
          // });

          // msNavigationServiceProvider.saveItem('pages.auth.plano_pagamento', {
          //      title: 'Pagamento',
          //      state: 'app.pages_auth_plano_pagamento'
          // });
     }
})();
(function () {
     'use strict';

     angular
          .module('app.pages.auth.dados_convidado')
          .factory('DadosConvidadoService', DadosConvidadoService);

     /** @ngInject */
     function DadosConvidadoService($q, $mdToast, $filter, api) {

          var modelNew = {};
          var pagamentos = []

          var service = {
               getNew: getNew,
               create: create,
               conviteAssinatura: ConviteAssinatura,
               vinculaAssinatura: vinculaAssinatura
          };

          return service;

          //////////

          function getNew() {
               return modelNew;
          }
          ////// CADASTRAR - CLIENTE ////// 

          function create(model) {
               var deferred = $q.defer();

               api.ClienteConvidado.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         clientes.unshift(model);
                         modelNew = {};
                    }).catch(
                         function (response) {
                              //   Resolve the promise
                              deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }

          // TRAZ INFORMAÇÕES //
          function ConviteAssinatura(id) {
               var deferred = $q.defer();

               api.ConviteAssinatura.convite({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }

          // VINCULA ASSINATURA //
          function vinculaAssinatura(model) {
               var deferred = $q.defer();

               api.Assinatura.update(model).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
     }

})();
(function () {
     'use strict';

     angular
          .module('app.pages.auth.dados_convidado')
          .controller('DadosConvidadoController', DadosConvidadoController)

     /** @ngInject */
     function DadosConvidadoController($q, $rootScope, $scope, $state, $filter, model, DadosConvidadoService, $mdToast, $mdDialog, $location, conviteAssinatura, principal) {
          var vm = this;


          var searchObject = $location.search();
          vm.convite_id = searchObject.convite_id;


          vm.model = model;
          vm.gotoLogin = gotoLogin;
          vm.api_response_erro = {};
          vm.processando = false;
          vm.logout = logout;
          vm.save = save;
          vm.ShowDialogTermos = ShowDialogTermos;
          vm.gotoBemvindo = gotoBemvindo;
          vm.vinculaAssinatura = vinculaAssinatura;
          vm.ConviteAssinaturaa = ConviteAssinaturaa;
          vm.conviteAssinatura = conviteAssinatura;
          vm.msgerro = vm.msgerro;

          //////////

          init();

          function init() {

               vm.showPassword = false;
               vm.toggleShowPassword = function () {
                    vm.showPassword = !vm.showPassword;
               }

               vm.toggleShowconfirmPassword = function () {
                    vm.showconfirmPassword = !vm.showconfirmPassword;
               }
               vm.model.pessoa_tipo = {
                    id: 1
               };
               vm.model.email = conviteAssinatura.email;
               vm.model.nome = conviteAssinatura.nome;
          }

          function vinculaAssinatura() {
               var licencas = vm.filtrarLicencasPorVinculado(true);

               licencas.forEach(function (model) {
                    model.convite_id = null; // O back está esperando null
                    model.mensagem = "";

                    DashboardService.vinculaAssinatura(model)
                         .then(function (response) {
                              model.vinculadoComSucesso = true;
                              loadLicencasVinculadas();
                              model.mensagem = "";

                         }).catch(function (response) {
                              model.mensagem = response.data.detail;
                         });
               });
          }

          function ConviteAssinaturaa(id) {
               DadosConvidadoService.ConviteAssinatura(model.email)
                    .then(function (response) {
                         console.log(response)
                         model.assinatura_cliente_portador = response.data

                    }).catch(function (response) {
                         alert('erro')
                    });
          }

          function save(model) {

               DadosConvidadoService.create(model)
                    .then(function (response) {
                         // Redireciona para login no IdentityServer

                         localStorage.setItem('showwelcomemessage', true);

                         principal.goToConfirmEmail(response.cliente_usuario_sub, response.identity_server_token)
                    }).catch(function (error) {
                         vm.msgerro = error.data.detail;
                         console.error(error.data.detail);
                    });
          }

          function ShowDialogTermos(ev) {

               $mdDialog.show({
                    controller: 'TermosController as vm',
                    templateUrl: 'app/main/novo/termos-uso.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function () {
                         return null;
                    }, function () {
                         return null;
                    });
          }

          function gotoLogin() {
               principal.goToLogin();
          }

          function gotoBemvindo() {
               $state.go('app.dashboard', {
                    showWelcomeMessage: true
               });
          }

          function logout() {
               $state.go('app.pages_auth_principal');
          }

          function TermosController($mdDialog) {
               var vm = this;
               vm.close = close;
               function close() {
                    $mdDialog.hide();
               };
          }

     }

})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.dados_cadastrais', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider.state('app.pages_auth_dados_cadastrais', {
               url: '/pages/auth/dados_cadastrais',
               views: {
                    'main@': {
                         templateUrl: 'app/core/layouts/content-only.html',
                         controller: 'MainController as vm'
                    },
                    'content@app.pages_auth_dados_cadastrais': {
                         templateUrl: 'app/main/dados_cadastrais/view/dados_cadastrais.html',
                         controller: 'DadosCadastraisController as vm',
                         resolve: {
                              model: function(DadosCadastraisService) {
                                   return DadosCadastraisService.getNew();
                              }
                         }
                    }
               },
               bodyClass: 'dados_cadastrais'
          })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/dados_cadastrais');

          // Navigation
          // msNavigationServiceProvider.saveItem('pages.auth', {
          //      title: 'Authentication',
          //      icon: 'icon-lock',
          //      weight: 1
          // });

          // msNavigationServiceProvider.saveItem('pages.auth.plano_pagamento', {
          //      title: 'Pagamento',
          //      state: 'app.pages_auth_plano_pagamento'
          // });
     }
})();
(function() {
     'use strict';

     angular
          .module('app.pages.auth.dados_cadastrais')
          .factory('DadosCadastraisService', DadosCadastraisService);

     /** @ngInject */
     function DadosCadastraisService($q, $mdToast, $filter, api) {

          var modelNew = {};
          var pagamentos = []

          var service = {
               getNew: getNew,
               create: create,
          };

          return service;

          //////////

          function getNew() {
               return modelNew;
          }

          function create(model) {
               var deferred = $q.defer();

               api.Cliente.save(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         pagamentos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;

          }
     }

})();
(function () {
     'use strict';

     angular
          .module('app.pages.auth.dados_cadastrais')
          .controller('DadosCadastraisController', DadosCadastraisController)
          .controller('TermosController');


     /** @ngInject */
     function DadosCadastraisController($rootScope, $scope, $state, $filter, model, DadosCadastraisService, $mdToast, $mdDialog, principal) {
          var vm = this;

          vm.model = model;
          vm.gotoLogin = gotoLogin;
          vm.gotoPagamento = gotoPagamento;
          vm.api_response_erro = {};
          vm.processando = false;
          vm.logout = logout;
          vm.save = save;
          vm.ShowDialogTermos = ShowDialogTermos;
          vm.enviaCliente = enviaCliente;

          //////////

          init();

          function init() {
               vm.model.pessoa_tipo = {
                    id: 1
               };
          }

          function enviaCliente() {
               var cliente = JSON.stringify(vm.model);
               // "Seta" este json no localStorage
               window.localStorage.setItem('cliente', cliente);
          }
          function save(form) {

               enviaCliente();
               var message = '';
               var message = $filter('translate')('CADASTRAIS.CADASTRO_SUCCESS');
               this.savePromise = DadosCadastraisService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;

                    vm.model.id = response.id;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                    );
                    if (response.cliente_isento) {
                         $state.go('app.dashboard');
                    } else {
                         gotoPagamento();
                    }
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    $mdToast.show(
                         $mdToast.simple()
                              .textContent($filter('translate')('CADASTRAIS.ERRO_CADASTRAIS'))
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                    );
               });
          }

          function ShowDialogTermos(ev) {

               $mdDialog.show({
                    controller: 'TermosController as vm',
                    templateUrl: 'app/main/novo/termos-uso.tmpl.html',
                    parent: angular.element(document.body),
                    targetEvent: ev,
                    clickOutsideToClose: true,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function () {
                         return null;
                    }, function () {
                         return null;
                    });

          }

          function gotoLogin() {
               principal.goToLogin();
          }
          function gotoPagamento() {
               if (vm.model.cliente_isento) {
                    $state.go('app.dashboard');
               }
               else {
                    $state.go('app.pages_auth_dados_pagamento');
               };
          }

          function logout() {
               principal.logout();
          }

          function TermosController($mdDialog) {
               var vm = this;
               vm.close = close;

               function close() {
                    $mdDialog.hide();
               };
          }

     }

})();

(function () {
     'use strict';

     angular
          .module('app.cliente_perfil', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {


     }
})();

(function () {
     'use strict';

     angular
          .module('app.cliente_perfil')
          .factory('clientePerfilService', clientePerfilService);

     /** @ngInject */
     function clientePerfilService($q, api) {
          var service = {
               //get: get,
               getAtivo: getAtivo,
               getAssinatura: getAssinatura
          };

          return service;

          function getAtivo() {
               var deferred = $q.defer();
               api.ClientePerfil.getAtivo().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    //console.error(response);

               });


               return deferred.promise;
          }

          function getAssinatura() {
               var deferred = $q.defer();
               api.ClientePerfil.getAssinatura()
                    .$promise.then(function (response) {
                         deferred.resolve(response);
                    }
                    ).catch(function (response) {
                         //console.error(response);
                         deferred.reject(response);
                    });

               return deferred.promise;
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.certificados', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.certificados', {
                abstract: true,
                url: '/certificados',
                resolve: {
                    authorize: function (authorization) {
                         authorization.authorize();
                    }
               }
            })
            .state('app.certificados.lista', {
                url: '/lista',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/certificados/views/buscar.html',
                        controller: 'listaCertificadosController as vm'
                    }
                },
                resolve: {
                    data: function (certificadosService) {
                        return certificadosService.query();
                    },
                    propriedades: function (certificadosService, $stateParams) {
                        return certificadosService.getPropriedades($stateParams);
                    }
                }
            })
            .state('app.certificados.criar', {
                url: '/criar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/certificados/views/criar.html',
                        controller: 'CriarCertificadoController as vm'
                    }
                }
            })
            .state('app.certificados.editar', {
                url: '/certificados/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/certificados/views/editar.html',
                        controller: 'EditarCertificadoController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, certificadosService) {
                        return certificadosService.get($stateParams.id);
                    }
                }
            })
            // .state('app.laudo.gerenciar', {
            //     url: '/gerenciar/:id',
            //     views: {
            //         'content@app': {
            //             templateUrl: 'app/main/laudo/views/gerenciar.html',
            //             controller: 'GerenciarLaudoController as vm'
            //         }
            //     },
            //     resolve: {
            //         model: function ($stateParams, laudoService) {
            //             return laudoService.getLaudo($stateParams.id);
            //         }
            //     }
            // })

            //Menu
            msNavigationServiceProvider.saveItem('certificados', {
                title: 'Certificados / documentos',
                //icon: 'icon-menu',
                weight: 7,
                img: '/assets/icons/certificados/ico-arquivo-br.svg',
                state: 'app.certificados.lista',
                //translate: 'PROPERTIES.PROPERTIES'
           });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.certificados')
        .factory('certificadosService', certificadosService);

    /** @ngInject */
    function certificadosService($q, api, propertieService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,
            get: get,
            getDash: getDash,
            getPropriedades: getPropriedades,
            create: create,
            update: update,

            deletarCertificadoDoc: deletarCertificadoDoc,
            getFiltros: getFiltros,

            uploadFile: uploadFile,
            getPdfFile: getPdfFile,

            getStatus: getStatus,
            createTipoArquivo: createTipoArquivo
        };

        return service;

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.Certificados.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getDash() {
            var deferred = $q.defer();
            api.CertificadosDash.get().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }
            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        ////// PROPRIEDADES //////
        function getPropriedades(propriedadeId) {
            var deferred = $q.defer();
            propertieService.query({}, false).then(function (response) {
                 if (propriedadeId && propriedadeId > 0) {
                        var propriedades = response.data.filter(function (a) {
                        return a.id == propriedadeId;
                    });
                    if (propriedades.length > 0) {
                        deferred.resolve(propriedades);
                        return;
                    }
                 }
                 deferred.resolve(response.data);
            }).catch(function (response) {
                 deferred.reject(response);
                 console.log(response);
            });
            return deferred.promise;
       }
       ////// PROPRIEDADES //////

        function create(model) {

            var deferred = $q.defer();

            api.Certificados
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }


        function get(id) {

            var deferred = $q.defer();

            api.Certificados.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        ////// ALTERAR ////// 
        function update(model) {
            var deferred = $q.defer();
            api.Certificados.update(model).$promise.then(
                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    modelNew = {};
                }).catch(
                    function (response) {
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

        function getFiltros() {
            var deferred = $q.defer();
            api.CertificadosArquivoTipos.get().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }
            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function deletarCertificadoDoc(id){
            var deferred = $q.defer();

            api.Certificados.delete({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }).catch(
                function (response) {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        function uploadFile(file) {

            // Create a new deferred object
            var deferred = $q.defer();


            api.File.upload({
                uploadedFile: file
            }).$promise
                .then(function (response) {

                    console.log('laudoService.upload.then', response);

                    // Resolve the promise
                    deferred.resolve(response);

                })
                .catch(function (response) {
                    // Reject the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        ////// HISTÓRICO DA ÁREA ////// 
        function getPdfFile(laudo_id) {

            var deferred = $q.defer();

            api.LaudoPdf
                .get({
                    id: laudo_id
                })
                .$promise.then(
                    function (response) {
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
                });
            return deferred.promise;
        }
        ////// HISTÓRICO DA ÁREA ////// 


       ////// CRIAR - Tipo de Arquivo ////// 
       function createTipoArquivo(model) {

            var deferred = $q.defer();

            api.CertificadosArquivoTipos.save(model).$promise.then(

                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                }).catch(
                    function (response) {
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }
        ////// CRIAR - Tipo de Arquivo ////// 

        function getStatus() {
            return [
                {
                    nome: "Válido",
                    id: 1
                },
                {
                    nome: "Vencido",
                    id: 2
                },
                {
                    nome: "Todos",
                    id: 3
                }
            ]
       }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.certificados')
        .controller('EditarCertificadoController', EditarCertificadoController)

    /** @ngInject */
    function EditarCertificadoController(model, certificadosService, $rootScope, $state, $scope, $window, $mdDialog, $mdToast) {
        var vm = this;
        // Data
        vm.arquivo_tipos = [];
        vm.model = model;
        vm.file = {
            name: vm.model.uploaded_file.file_name
        };
        vm.api_response_erro = {};

        // Metodos
        vm.save = save;
        vm.showDialogCreateTipoArquivo = showDialogCreateTipoArquivo;
        vm.getFiltros = getFiltros;
        vm.saveFile = saveFile;
        vm.onClickFile = onClickFile;
        vm.removeFile = removeFile;
        vm.selectedFile = selectedFile;
        vm.gotoLista = gotoLista;
        //////////

        vm.data = {
            id: null,
            nome_arquivo: null,
            certificado_tipo_arquivo_id: null,
            data_validade: null,
            uploaded_file_id: null
        }

        init();

        function init() {
            getFiltros();
            console.log('MODEL', vm.model);
        }

        function getFiltros() {
            certificadosService.getFiltros().then(function (response) {
                vm.arquivo_tipos = response;
            }).finally(function () {
                //vm.args.loading = false;
            });
        }

        function saveFile(form) {

            if (form.$invalid || !vm.file) {
                return;
            }

            if(vm.file.lastModified){
                $rootScope.loadingProgress = true;
                console.log('file', vm.file);
                certificadosService
                    .uploadFile(vm.file)
                    .then(function (response) {
                        //vm.data.uploaded_file_id = response.data.id;
                        save(response.data.id);

                    }).catch(function (response) {
                        $rootScope.loadingProgress = false;
                        vm.api_response_erro = response;
                    });
            }else{
                save();
            }
        }

        function save(fileID) {
            
            vm.data = {
                id: vm.model.id,
                nome_arquivo: vm.model.nome_arquivo?vm.model.nome_arquivo:null,
                certificado_tipo_arquivo_id: vm.model.certificado_tipo_arquivo?vm.model.certificado_tipo_arquivo.id:null,
                data_validade: vm.model.data_validade?vm.model.data_validade:null,
                uploaded_file_id: fileID?fileID:vm.model.uploaded_file.id
            }

            console.log('SAVE',vm.data);

            $rootScope.loadingProgress = true;

            certificadosService
                .update(vm.data)
                .then(function (response) {

                    $rootScope.loadingProgress = false;

                    if (response == undefined) {
                        vm.api_response_erro = response;
                        return;
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Documento alterado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    gotoLista();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }

        function onClickFile(){
            //console.log('clicado!');
            document.getElementById('docFile').click();
        }

        function removeFile(){
            vm.file = null;
        }

        function selectedFile(element){
            if (vm.model.$invalid) {
                return;
            }
            $scope.$apply(function() {
                vm.file = element.files[0];
                console.log('FILE:', vm.file);
            });
        }

        function showDialogCreateTipoArquivo(ev, model, index) {

            $mdDialog.show({
                controller: 'CriarTipoArquivoController as vm',
                templateUrl: 'app/main/certificados/views/criar_tipo_arquivo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        console.log('NEW TIPO',answer)
                        vm.arquivo_tipos.push(answer);
                        vm.model.certificado_tipo_arquivo_id = answer.id;
                    }
                }, function () {
                    console.error('Ocorreu um erro ao retornar da modal showDialogCreateTipoArquivo');
                });
        }

        function gotoLista(){
            $state.go('app.certificados.lista');
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('app.certificados')
        .controller('CriarCertificadoController', CriarCertificadoController)

    /** @ngInject */
    function CriarCertificadoController($rootScope, $state, $scope, $window, $filter, certificadosService, $mdDialog, $mdToast) {
        var vm = this;

        // Data
        vm.arquivo_tipos = [];
        vm.file = null;
        vm.api_response_erro = {};
        vm.date_init = new Date();

        // Metodos
        vm.save = save;
        vm.gotoSearch = gotoSearch;
        vm.showDialogCreateTipoArquivo = showDialogCreateTipoArquivo;
        vm.getFiltros = getFiltros;
        vm.saveFile = saveFile;
        vm.onClickFile = onClickFile;
        vm.removeFile = removeFile;
        vm.selectedFile = selectedFile;
        vm.gotoLista = gotoLista;
        //////////

        vm.model = {
            certificado_tipo_arquivo_id: null,
            nome_arquivo: null,
            data_validade: null,
            uploaded_file_id: null
        }

        init();

        function init() {
            getFiltros();
            console.log('DATE', vm.date_init)
        }

        function saveFile(form) {

            if (form.$invalid || !vm.file) {
                return;
            }

            $rootScope.loadingProgress = true;

            certificadosService
                .uploadFile(vm.file)
                .then(function (response) {

                    vm.model.uploaded_file_id = response.data.id;

                    save();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                });
        }

        function save() {

            $rootScope.loadingProgress = true;

            certificadosService
                .create(vm.model)
                .then(function (response) {

                    $rootScope.loadingProgress = false;

                    if (response == undefined) {
                        vm.api_response_erro = response;
                        return;
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Documento adicionado com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    gotoLista();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    console.log('ERRO POST', response);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent(response.data.detail)
                            .position('top right')
                            .theme("error-toast")
                            .hideDelay(6000)
                    );
                    //vm.api_response_erro = response;
                });
        }

        function onClickFile(){
            console.log('clicado!');
            document.getElementById('docFile').click();
        }

        function removeFile(){
            vm.file = null;
        }

        function selectedFile(element){
            console.log('file selected!');
            // var file = document.getElementById('docFile').files[0],
            //     r = new FileReader();

            // r.onloadend = function(e) {
            // var data = e.target.result;
            // //send your binary data via $http or $resource or do anything else with it
            // }
            //r.readAsBinaryString(f);
            $scope.$apply(function() {
                vm.file = element.files[0];
                console.log('FILE:', vm.file);
            });

        }

        function showDialogCreateTipoArquivo(ev, model, index) {

            $mdDialog.show({
                controller: 'CriarTipoArquivoController as vm',
                templateUrl: 'app/main/certificados/views/criar_tipo_arquivo.tmpl.html',
                parent: angular.element(document.body),
                targetEvent: ev,
                clickOutsideToClose: false,
                fullscreen: false // Only for -xs, -sm breakpoints.
            })
                .then(function (answer) {
                    if (answer) {
                        console.log('NEW TIPO',answer)
                        vm.arquivo_tipos.push(answer);
                        vm.model.certificado_tipo_arquivo_id = answer.id;
                    }
                }, function () {
                    console.error('Ocorreu um erro ao retornar da modal showDialogCreateTipoDespesa');
                });
        }

        function getFiltros() {
            certificadosService.getFiltros().then(function (response) {
                vm.arquivo_tipos = response;
                console.log('FILTROS', vm.arquivo_tipos);
            }).finally(function () {
                //vm.args.loading = false;
            });
        }

        function gotoSearch() {
            $window.history.back();
        }

        function gotoLista(){
            $state.go('app.certificados.lista');
        }

    }

})();
(function () {
    'use strict';

    angular
        .module('app.certificados')
        .controller('CriarTipoArquivoController', CriarTipoArquivoController)

    /** @ngInject */
    function CriarTipoArquivoController($rootScope, $filter, certificadosService, $mdToast, $mdDialog) {

        var vm = this;

        // Data
        vm.model = {};
        vm.api_response_erro = {};

        // Metodos
        vm.gotoSearch = gotoSearch;
        vm.save = save;
        //////////

        init();

        function init() {

        }

        function save(form) {

            if (form.$invalid) {
                return;
            }

            this.savePromise = certificadosService.createTipoArquivo(vm.model);

            $rootScope.loadingProgress = true;

            this.savePromise.then(function (response) {
                $rootScope.loadingProgress = false;
                console.log('response create Tipo', response);
                vm.model.id = response.id;

                $mdDialog.hide(vm.model);

                $mdToast.show(
                    $mdToast.simple()
                        .textContent('Tipo de arquivo criado com sucesso!')
                        .position('top right')
                        .theme("success-toast")
                        .hideDelay(6000)
                );

                //gotoSearch();
            }).catch(function (response) {
                $rootScope.loadingProgress = false;
                vm.api_response_erro = response;
            });
        }

        function gotoSearch() {
            $mdDialog.hide();
        }
    }

})();
(function () {
     'use strict';

     angular
          .module('app.certificados')
          .controller('listaCertificadosController', listaCertificadosController)

     /** @ngInject */
     function listaCertificadosController(data, propriedades, $state, certificadosService, $mdDialog, $mdToast, $location, $anchorScroll) {
          var vm = this;

          // Data
          vm.models = data.data;
          vm.propriedades = propriedades;
          vm.dash = null;
          vm.totalMB = null;
          vm.filtros = {
               tipos: null
          };
          vm.status = certificadosService.getStatus();
          
          vm.gotoEditar = gotoEditar;
          vm.resetFilters = resetFilters;
          vm.deletarConfirm = deletarConfirm;
          vm.gotoAdd = gotoAdd;
          vm.getDash = getDash;
          vm.filterVencidos = filterVencidos;
          vm.toAncoraLink = toAncoraLink;
          vm.model = {
               dataInicial: new Date(),
               dataFinal: new Date()
          }
          //////////

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: data.total_rows,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',
               NomeArquivo: null,
               CertificadoTipoArquivoId: null,
               StatusId: null,
               DataValidadeInicial: null,
               DataValidadeFinal: null,
               _change: change
          };

          vm.args._change();

          init();

          function init() {
               //vm.date = new Date();
               getDash();
               getFiltros();
          }

          function change() {

               vm.args.loading = true;
               certificadosService.query(vm.args).then(function (response) {
                    if (vm.propriedades.length == 0)
                         cadastroPropriedadeConfirm();
                    else
                         vm.models = response.data;
                         vm.args.total_rows = response.total_rows;
                         vm.args.updatePaggination();
               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               // IMPORTANTE limpar individualmente p/ não bugar a paginação!
               vm.args.NomeArquivo = null;
               vm.args.CertificadoTipoArquivoId = null;
               vm.args.StatusId = null;
               vm.args.DataValidadeInicial = null;
               vm.args.DataValidadeFinal = null;
               change();
          }

          function getDash() {
               vm.args.loading = true;
               certificadosService.getDash().then(function (response) {
                   vm.dash = response;
                   vm.totalMB = vm.dash.total_tamanho_arquivos / 1000000;
               }).finally(function () {
                   vm.args.loading = false;
               });
          }

          function getFiltros() {
               vm.args.loading = true;
               certificadosService.getFiltros().then(function (response) {
                   vm.filtros.tipos = response;
               }).finally(function () {
                   vm.args.loading = false;
               });
          }

          function filterVencidos() {
               vm.args.StatusId = 2;
               change();
               toAncoraLink('lista');
          }

          function gotoAdd() {
               $state.go('app.certificados.criar');
          }

          function gotoEditar(id) {
               $state.go('app.certificados.editar', {
                    id: id
               });
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                   .title('Excluir Certificado / documento')
                   .textContent('Tem certeza que deseja excluir esse documento?')
                   .targetEvent(model)
                   .ok('Sim')
                   .cancel('Não');
   
               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          };

          function deletar(model) {
               certificadosService.deletarCertificadoDoc(model.id)
                   .then(function (response) {
                       vm.models.splice(vm.models.indexOf(model), 1);
                       getDash();
                       $mdToast.show(
                              $mdToast.simple()
                                   .textContent('Documento excluido com sucesso!')
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                       );
   
                   }).catch(function (response) {
                       // TODO mensagem de erro
                   });
          }

          function toAncoraLink(value) {
               $location.hash(value);
               $anchorScroll();
          }

          function cadastroPropriedadeConfirm() {

               var confirm = $mdDialog.confirm()
                   .title('Propriedade não encontrada')
                   .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                   .ok('Sim, quero cadastrar!')
                   .cancel('Não quero!');
   
               $mdDialog.show(confirm)
                   .then(function () {
                       gotoCadastroPropriedade();
                   }, function () {
                       return null
                   });
           }
          
     }
})();

(function () {
    'use strict';

    angular
        .module('app.plano_aplicacao', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
               .state('app.plano_aplicacao', {
                    abstract: true,
                    url: '/plano_aplicacao'
               })
               .state('app.plano_aplicacao.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas_plano_aplicacao/views/buscar.html',
                         controller: 'PlanoAplicacaoController as vm'
                         }
                    },
                    resolve: {
                         model: function (insumoBiologicoService) {
                         return insumoBiologicoService.getNew();
                         }
                    }
               })
               .state('app.plano_aplicacao.criar', {
                    url: '/criar',
                    views: {
                    'content@app': {
                         templateUrl: 'app/main/caldas_plano_aplicacao/views/criar.html',
                         controller: 'CriarPlanoAplicacaoController as vm'
                    }
                    },
                    resolve: {
                         selects: function (planoAplicacaoService) {
                              return planoAplicacaoService.getSelectsAdd();
                         }
                    }
               })
               .state('app.plano_aplicacao.sucesso', {
                    url: '/sucesso',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/caldas_plano_aplicacao/views/sucesso.html',
                              controller: 'SucessoPlanoAplicacaoController as vm'
                         }
                    }
               })
               .state('app.plano_aplicacao.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas_plano_aplicacao/views/visualizar.html',
                         controller: 'VisualizarPlanoAplicacaoController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, planoAplicacaoService) {
                              return planoAplicacaoService.get($stateParams.id);
                         }
                    }
               })
               .state('app.plano_aplicacao.confirmar', {
                    url: '/confirmar/:id',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas_plano_aplicacao/views/confirmar.html',
                         controller: 'ConfirmarPlanoAplicacaoController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, planoAplicacaoService) {
                              return planoAplicacaoService.getConfirmar($stateParams.id);
                         }
                    }
               })
               .state('app.plano_aplicacao.confirmar_sem_estoque', {
                    url: '/confirmar_sem_estoque/:id',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas_plano_aplicacao/views/confirmar.html',
                         controller: 'ConfirmarSemEstoquePlanoAplicacaoController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, planoAplicacaoService) {
                              return planoAplicacaoService.getConfirmar($stateParams.id);
                         }
                    }
               })
               .state('app.plano_aplicacao.sucesso_confirm', {
                    url: '/confirmar_sucesso',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/caldas_plano_aplicacao/views/sucesso_confirm.html',
                              controller: 'SucessoConfirmPlanoAplicacaoController as vm'
                         }
                    }
               })


          //Menu
          msNavigationServiceProvider.saveItem('manejo.caldas.plano', {
               title: 'Plano de aplicação',
               state: 'app.plano_aplicacao.buscar',
               weight: 2
          });
    }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .factory('planoAplicacaoService', planoAplicacaoService);

     /** @ngInject */
     function planoAplicacaoService($q, api) {

          var insumos = [];
          var queryResponse = {};
          var queryArgs = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',

          };
          var modelNew = {
               produto_aplicados: [],
               propriedade_areas: []
          };

          var service = {
               getNew: getNew,
               get: get,
               getFiltros: getFiltros,
               getConfirmar: getConfirmar,
               create: create,
               confirmPost: confirmPost,
               confirmPostSemEstoque: confirmPostSemEstoque,
               query: query,
               getSelectsAdd: getSelectsAdd,
               deletePlano: deletePlano,
               getExcelFile: getExcelFile
          };

          return service;

          //////////

          function getNew() {
               return {};
          }


          ////// LISTA //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
               } else {
                    api.CaldaAplicacao.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTA //////

          ////// get SELECTS ADD //////
          function getSelectsAdd() {
               var deferred = $q.defer();
               api.SelectsAddPlanoAplicacao.get().$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }
               ).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

          function create(model) {

               var deferred = $q.defer();

               api.CaldaAplicacao.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          ////// CONSULTA POR ID //////
          function get(id) {
               var deferred = $q.defer();

               api.CaldaAplicacao.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID //////

          function getFiltros() {
               var deferred = $q.defer();
               api.FiltrosPlanoAplicacao.get().$promise.then(
               function (response) {
                    deferred.resolve(response);
               }
               ).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

          ////// CONSULTA CONFIRMAR //////
          function getConfirmar(id) {
               var deferred = $q.defer();

               api.CaldaAplicacaoConfirmar.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA CONFIRMAR //////

          ////// POST CONFIRMAR PLANO //////
          function confirmPost(model) {

               var deferred = $q.defer();

               api.CaldaAplicacaoConfirmarComEstoque.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          ////// POST CONFIRMAR PLANO SEM ESTOQUE //////
          function confirmPostSemEstoque(model) {

               var deferred = $q.defer();

               api.CaldaAplicacaoConfirmar.save(model).$promise.then(

                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                         insumos.unshift(model);
                         modelNew = {};
                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          function deletePlano(id) {
               // Create a new deferred object
               var deferred = $q.defer();
               api.CaldaAplicacao.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);

                    }
               );
               return deferred.promise;
          }


          function getExcelFile(modelResponse) {

               var deferred = $q.defer();

               api.ExcelPlanoAplicacao.get(modelResponse).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
     }

})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('VisualizarPlanoAplicacaoController', VisualizarPlanoAplicacaoController);

     /** @ngInject */
     function VisualizarPlanoAplicacaoController($rootScope, $state, planoAplicacaoService, model) {

          var vm = this;

          // Data
          vm.model = model;

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.getExcelFilePlano = getExcelFilePlano;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.plano_aplicacao.buscar');
          }

          function getExcelFilePlano(modelResponse) {
               var obj = {
                   id: modelResponse.id,
               }
               $rootScope.loadingProgress = true;

               planoAplicacaoService.getExcelFile(obj)
                   .then(function (data) {
                         $rootScope.loadingProgress = false;

                         var link = document.createElement('a');
                         var rand = Math.random();
                         link.href = window.URL.createObjectURL(data.response);
                         link.download = 'plano_aplicacao_' + rand + '.xlsx';
                         link.click();
                         //console.log(link);
                         document.body.removeChild(link);

                   }).catch(function (data) {
                       $rootScope.loadingProgress = false;
                       vm.api_response_erro = data;
                   });
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('SucessoConfirmPlanoAplicacaoController', SucessoConfirmPlanoAplicacaoController);

     /** @ngInject */
     function SucessoConfirmPlanoAplicacaoController($state) {
          var vm = this;

          // Data

          // Methods
          vm.gotoList = gotoList;
          vm.gotoPlanos = gotoPlanos;
          vm.gotoHome = gotoHome;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoPlanos() {
              $state.go('app.plano_aplicacao.buscar');
          }

          function gotoList() {
               $state.go('app.aplicacoes.buscar');
          }

          function gotoHome() {
               $state.go('app.home');
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('SucessoPlanoAplicacaoController', SucessoPlanoAplicacaoController);

     /** @ngInject */
     function SucessoPlanoAplicacaoController($state) {
          var vm = this;

          // Data

          // Methods
          vm.gotoList = gotoList;
          vm.gotoAdd = gotoAdd;
          vm.gotoHome = gotoHome;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoList() {
              $state.go('app.plano_aplicacao.buscar');
          }

          function gotoAdd() {
               $state.go('app.plano_aplicacao.criar');
          }

          function gotoHome() {
               $state.go('app.home');
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('CriarPlanoAplicacaoController', CriarPlanoAplicacaoController);

     /** @ngInject */
     function CriarPlanoAplicacaoController($rootScope, $filter, $state, $mdToast, $mdDialog, selects, planoAplicacaoService) {
          var vm = this;

          // Data
          vm.model = {};
          vm.areas = selects.areas;
          vm.caldas = selects.caldas;
          vm.api_response_erro = {};
          vm.step = 1;
          vm.total_area_produtiva = 0;

          // Methods
          vm.openModalEstoque = openModalEstoque;
          vm.save = save;
          vm.changeCalda = changeCalda;
          vm.gotoSearch = gotoSearch;
          vm.gotoSucesso = gotoSucesso;
          vm.gotoStep = gotoStep;
          vm.savePromise = null;
          vm.cancelClick = cancelClick;

          //////////

          init();

          function init() {
               checkAreas();

               vm.model.calda_aplicacao_areas = new Array();

               vm.date = new Date();
          }

          function changeCalda(){

               vm.model.calda.calda_insumos.forEach(function (e) {
                    //area.quantidade_por_hectare = e.quantidade_por_hectare;
                    //let qtd_total = e.quantidade_por_hectare * vm.total_area_produtiva;
                    //e.total_hectares = total_hectares;
                    e.quantidade_total_original = e.quantidade_por_hectare * vm.total_area_produtiva;
                    e.quantidade_total = ArredondaResultado(e.quantidade_por_hectare * vm.total_area_produtiva);
                    //e.quantidade_total_por_area = ArredondaResultado((e.quantidade_total / 100) * (total_hectares * 100 / vm.total_area_produtiva));
               });

               console.log('areas', vm.model.calda_aplicacao_areas);
          }

          function ArredondaResultado(value){
               if(value < 0.0005){
                    return 0.001
               }else{
                    return value
               }
          }

          function AreasInsumosConsolidados(){
               let areas = vm.model.calda_aplicacao_areas;
               let insumos = vm.model.calda.calda_insumos;
               areas.forEach(function (area) {
                    area.insumo_consolidados = new Array();
                    var total_hectares = null;
                    total_hectares = area.total_hectares;

                    for (let index = 0; index < insumos.length; index++) {
                         area.insumo_consolidados.push({
                              tipo_insumo: insumos[index].tipo_insumo,
                              nome_insumo: insumos[index].nome_insumo,
                              quantidade_por_hectare: insumos[index].quantidade_por_hectare,
                              unidade_medida: insumos[index].unidade_medida,
                              carencia: insumos[index].carencia,
                              quantidade_total_por_area: ArredondaResultado((insumos[index].quantidade_total / 100) * (total_hectares * 100 / vm.total_area_produtiva))
                         });
                    }

               });
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               // console.log('save', vm.model)
               // return

               this.savePromise = planoAplicacaoService.create(vm.model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = response.data.detail;
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });

          }

          function checkAreas() {

               if(vm.areas.length == 0)
                    AreaNaoEncontrado();
          }

          function gotoSearch() {
               $state.go('app.plano_aplicacao.buscar');
          }

          function gotoSucesso(){
               $state.go('app.plano_aplicacao.sucesso');
          }

          function gotoCreateArea() {
               $state.go('app.registro.area.criar');
          }

          function gotoStep(step) {
               vm.step = step;

               if(step == 3){
                    AreasInsumosConsolidados();
               }
          }

          function cancelClick(form, ev) {

               if (!form.$dirty) {
                    gotoSearch();
               } else {
                    var confirm = $mdDialog.confirm()
                         .title($filter('translate')('REGISTERS.DESCARTAR_AS_ALTERACOES_NAO_SALVAS'))
                         .targetEvent(ev)
                         .ok($filter('translate')('REGISTERS.DESCARTAR'))
                         .cancel($filter('translate')('REGISTERS.CANCELAR'));
                    $mdDialog.show(confirm).then(function () {
                         gotoSearch()
                    }, null);

               }
          }

          function AreaNaoEncontrado(ev) {

               // Appending dialog to document.body to cover sidenav in docs app
               var confirm = $mdDialog.confirm()
                    .title('Área não encontrada')
                    .textContent('Não foi possível encontrar uma área para essa propriedade. Deseja cadastrar uma nova área?')
                    .targetEvent(ev)
                    .ok('Sim, gostaria!')
                    .cancel('Não, não gostaria!');

               $mdDialog.show(confirm).then(function () {
                    gotoCreateArea();
               }, function () {
                    // gotoSearch();
               });
          }

          function openModalEstoque(produto){
               $mdDialog.show({
                    locals:{dataToPass: produto},
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/registro/insumo/biologico/views/modal_estoque.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
          }
          function mdDialogCtrl($scope, $mdDialog, dataToPass) {
               // Consulta o rateio do produto.
               searchRateioProductStock(dataToPass);
               $scope.dataModal = dataToPass;
               console.log('estoque', dataToPass);

               $scope.hide = function () {
                    $mdDialog.hide();
               };
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('ConfirmarSemEstoquePlanoAplicacaoController', ConfirmarSemEstoquePlanoAplicacaoController);

     /** @ngInject */
     function ConfirmarSemEstoquePlanoAplicacaoController($rootScope, $state, model, $mdToast, planoAplicacaoService, clientePerfilService) {

          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};
          vm.estoque = true;
          vm.hideitem_stock = Boolean;

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          vm.form = {
               calda_aplicacao_id: model.id,
               data_aplicacao: null,
               responsavel: null,
          }

          init();

          /**
           * Initialize
           */
          function init() {

               vm.model.calda_aplicacoes_insumos.find(function(item){
                    if(!item.estoque_suficiente){
                         vm.estoque = false;
                    }
               });

               clientePerfilService.getAtivo().then(function (response) {
                    vm.clientePerfil = response;
                   /*
                         //  OCULTANDO ITENS PARA CLIENTE S/ ESTOQUE
                   */
                    if(!vm.clientePerfil.is_estoque_automatico){
                        vm.hideitem_stock = false
                        vm.estoque = true;
                    }

               });

               vm.date = new Date();
          }

          function gotoSearch() {
               $state.go('app.plano_aplicacao.buscar');
          }

          function gotoSucesso(){
               $state.go('app.plano_aplicacao.sucesso_confirm');
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               console.log('FORM', vm.form);
               //return

               this.savePromise = planoAplicacaoService.confirmPostSemEstoque(vm.form);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = response.data.detail;
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });

          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('ConfirmarPlanoAplicacaoController', ConfirmarPlanoAplicacaoController);

     /** @ngInject */
     function ConfirmarPlanoAplicacaoController($rootScope, $state, model, $mdToast, planoAplicacaoService, clientePerfilService) {

          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};
          vm.estoque = true;
          vm.hideitem_stock = Boolean;

          // Methods
          vm.gotoSearch = gotoSearch;
          vm.save = save;
          //////////

          vm.form = {
               calda_aplicacao_id: model.id,
               data_aplicacao: null,
               responsavel: null,
          }

          init();

          /**
           * Initialize
           */
          function init() {

               vm.model.calda_aplicacoes_insumos.find(function(item){
                    if(!item.estoque_suficiente){
                         vm.estoque = false;
                    }
               });

               clientePerfilService.getAtivo().then(function (response) {
                    vm.clientePerfil = response;
                   /*
                         //  OCULTANDO ITENS PARA CLIENTE S/ ESTOQUE
                   */
                    if(!vm.clientePerfil.is_estoque_automatico){
                        vm.hideitem_stock = false
                        vm.estoque = true;
                    }

               });

               vm.date = new Date();
          }

          function gotoSearch() {
               $state.go('app.plano_aplicacao.buscar');
          }

          function gotoSucesso(){
               $state.go('app.plano_aplicacao.sucesso_confirm');
          }

          function save(form) {

               if (form.$invalid) {
                    return;
               }

               console.log('FORM', vm.form);
               //return

               this.savePromise = planoAplicacaoService.confirmPost(vm.form);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                    $rootScope.loadingProgress = false;
                    gotoSucesso();
               }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;

                    if(response.data.errors)
                    {
                         let err = response.data.detail;
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(err)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    }
               });

          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.plano_aplicacao')
          .controller('PlanoAplicacaoController', PlanoAplicacaoController);

     /** @ngInject */
     function PlanoAplicacaoController($filter, clientePerfilService, planoAplicacaoService, $state, $mdDialog, $mdToast) {

          var vm = this;

          // Status
          vm.loadingProgress = false;
          vm.activeFilters = false;

          // Data
          vm.models = null;
          vm.filtros = [];
          vm.hideitem_stock = Boolean;

          // Methods
          vm.gotoAdd = gotoAdd;
          vm.gotoVisualizar = gotoVisualizar;
          vm.gotoConfirmar = gotoConfirmar;
          vm.gotoConfirmarSemEstoque = gotoConfirmarSemEstoque;
          vm.resetFilters = resetFilters;
          vm.deletarConfirm = deletarConfirm;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.selectedPeriodo = selectedPeriodo;
          //////////

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.periods = [
               {
                    description: "Últimos 7 dias",
                    value: 7
               },
               {
                    description: "Últimos 15 dias",
                    value: 15
               },
               {
                    description: "Últimos 30 dias",
                    value: 30
               },
               {
                    description: "Últimos 3 meses",
                    value: 90
               },
               {
                    description: "Últimos 6 meses",
                    value: 180
               }
          ];

          vm.model = {
               data_inicial: new Date(),
               data_final: new Date()
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',
               periodo: 30,
               data_inicial: null,
               data_final: null,
               calda: null,
               _change: change
          }

          vm.args._change(null);

          init();

          function init() {
               periodoActive.addClass("select-active");
               getFiltros();

               clientePerfilService.getAtivo().then(function (response) {
                    vm.clientePerfil = response;
                   /*
                         //  OCULTANDO ITENS PARA CLIENTE S/ ESTOQUE
                   */
                    if(!vm.clientePerfil.is_estoque_automatico){
                        vm.hideitem_stock = false
                    }

               });
          }


          function change(page) {
               // solução p/ resetar page caso nova busca seja feita depois de pagina 1
               (page > 1 && page != undefined)?vm.args.page = 1:null;
               vm.args.loading = true;
               planoAplicacaoService.query(vm.args).then(function (response) {
                    vm.models = response.data.calda_aplicacaos;

                    vm.args.total_rows = response.data.total_itens;
                    vm.args.length_rows = vm.models.length;
                    showActiveFilters();
                    vm.args.updatePaggination();

               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function getFiltros() {
               vm.args.loading = true;
               planoAplicacaoService.getFiltros().then(function (response) {
                    vm.filtros = response;
               }).finally(function () {
                   vm.args.loading = false;
               });
          }


          function resetFilters() {
               vm.args.periodo = null;
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.calda = null;
               vm.args.periodo = 30;
               datapickerActive.removeClass("dates-active");
               periodoActive.addClass("select-active");
               change(null);
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let arr = null;
               let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
               let counter = 0;
               for (let i = 0; i < vm.periods.length; i++) {
                   if (vm.periods[i].value == vm.args.periodo) {
                       periodoSelect = vm.periods[i].description
                   };
               }
               arr = [
                   {
                       description: periodoSelect,
                       value: 'periodo'
                   },
                   {
                       description: inicio?inicio+" - "+fim:null,
                       value: 'datepicker'
                   },
                   {
                       description: vm.args.calda,
                       value: 'calda'
                   }
               ];
                   for (let i = 0; i < arr.length; i++) {
                       if (arr[i].description != null) counter++;
                   }

                   if(counter > 0){
                       vm.activeFilters = arr;
                   }
          }

          function desableFilter(value){
               if(value == 'datepicker'){
                    vm.args.data_inicial = null;
                    vm.args.data_final = null;
                    datapickerActive.removeClass("dates-active");
               }else{
                    periodoActive.removeClass("select-active");
                    vm.args[value] = null;
               }
               change(null);
          }

          function mdDialogCtrl($scope, $mdDialog) {

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                    .title('Exclusão de aplicação')
                    .textContent('Você deseja excluir essa aplicação')
                    .targetEvent(model)
                    .ok('Sim')
                    .cancel('Voltar');

               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          }

          function deletar(model) {
               planoAplicacaoService.deletePlano(model.id)
                    .then(function (response) {
                         var message = "Aplicação excluida com sucesso";
                         vm.models.splice(vm.models.indexOf(model), 1);
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         //console.log('erro', response.data.detail);
                         var message = response.data.detail;
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }



          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change(null);

          }

          function gotoAdd() {
               $state.go('app.plano_aplicacao.criar');

          }

          function gotoVisualizar(id) {
               $state.go('app.plano_aplicacao.visualizar', {
                    id: id
               });
          }

          function gotoConfirmar(id){
               $state.go('app.plano_aplicacao.confirmar', {
                    id: id
               });
          }

          function gotoConfirmarSemEstoque(id){
               $state.go('app.plano_aplicacao.confirmar_sem_estoque', {
                    id: id
               });
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }

          function cadastroPropriedadeConfirm() {

               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = null;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.aplicacoes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
          // State
          $stateProvider
               .state('app.aplicacoes', {
                    abstract: true,
                    url: '/aplicacoes'
               })
               .state('app.aplicacoes.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas_aplicacoes/views/buscar.html',
                         controller: 'AplicacoesController as vm'
                         }
                    },
                    resolve: {
                         model: function (aplicacoesService) {
                              return aplicacoesService.query();
                         },
                         filtros: function (aplicacoesService) {
                              return aplicacoesService.getFiltros();
                         }
                    }
               })
               .state('app.aplicacoes.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas_aplicacoes/views/visualizar.html',
                         controller: 'VisualizarAplicacoesController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, aplicacoesService) {
                              return aplicacoesService.get($stateParams.id);
                         }
                    }
               })


          //Menu
          msNavigationServiceProvider.saveItem('manejo.caldas.aplicacoes', {
               title: 'Aplicações',
               state: 'app.aplicacoes.buscar',
               weight: 2
          });
    }
})();

(function () {
     'use strict';

     angular
          .module('app.aplicacoes')
          .factory('aplicacoesService', aplicacoesService);

     /** @ngInject */
     function aplicacoesService($q, api) {

          var queryResponse = {};
          var queryArgs = {
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',

          };

          var service = {
               get: get,
               getFiltros: getFiltros,
               query: query,
               deleteAplicacao: deleteAplicacao
          };

          return service;
          //////////


          ////// LISTA //////
          function query(args, cache) {

               cache = (typeof cache !== 'undefined') ? cache : true;
               args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

               var deferred = $q.defer();

               if (cache && angular.equals(args, queryArgs) && queryResponse.data) {
                    deferred.resolve(queryResponse);
               } else {
                    api.CaldaAplicacaoConfirmar.query(args).$promise.then(
                         function (response) {
                              queryArgs = angular.copy(args);
                              queryResponse = response;
                              deferred.resolve(response);
                         }

                    ).catch(function (response) {
                         deferred.reject(response);
                    });
               }
               return deferred.promise;
          }
          ////// LISTA //////

          ////// CONSULTA POR ID //////
          function get(id) {
               var deferred = $q.defer();

               api.CaldaAplicacaoConfirmarInfo.get({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }

               ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA POR ID //////

          function getFiltros() {
               var deferred = $q.defer();
               api.FiltrosCaldaAplicacaoConfirmada.get().$promise.then(
               function (response) {
                    deferred.resolve(response);
               }
               ).catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

          function deleteAplicacao(id) {
               // Create a new deferred object
               var deferred = $q.defer();
               api.CaldaAplicacaoConfirmar.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         //   Resolve the promise
                         deferred.resolve(response);

                    }).catch(
                    function (response) {
                         //   Resolve the promise
                         deferred.reject(response);

                    }
               );
               return deferred.promise;
          }

     }

})();

(function () {
     'use strict';

     angular
          .module('app.aplicacoes')
          .controller('VisualizarAplicacoesController', VisualizarAplicacoesController);

     /** @ngInject */
     function VisualizarAplicacoesController($state, model) {

          var vm = this;

          // Data
          vm.model = model;

          // Methods
          vm.gotoSearch = gotoSearch;

          //////////

          init();

          /**
           * Initialize
           */
          function init() {

          }

          function gotoSearch() {
               $state.go('app.aplicacoes.buscar');
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.aplicacoes')
          .controller('AplicacoesController', AplicacoesController);

     /** @ngInject */
     function AplicacoesController($filter, aplicacoesService, $state, $mdDialog, $mdToast, model, filtros) {

          var vm = this;

          // Status
          vm.loadingProgress = false;
          vm.activeFilters = false;

          // Data
          vm.models = model.calda_aplicacaos_confirmadas;
          vm.filtros = filtros;

          // Methods
          vm.gotoVisualizar = gotoVisualizar;
          vm.resetFilters = resetFilters;
          vm.deletarConfirm = deletarConfirm;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;
          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          vm.selectedPeriodo = selectedPeriodo;
          //////////

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.periods = [
               {
                    description: "Últimos 7 dias",
                    value: 7
               },
               {
                    description: "Últimos 15 dias",
                    value: 15
               },
               {
                    description: "Últimos 30 dias",
                    value: 30
               },
               {
                    description: "Últimos 3 meses",
                    value: 90
               },
               {
                    description: "Últimos 6 meses",
                    value: 180
               }
          ];

          vm.model = {
               data_inicial: new Date(),
               data_final: new Date()
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: 0,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',
               periodo: 30,
               data_inicial: null,
               data_final: null,
               calda: null,
               _change: change
          }

          vm.args._change(null);

          init();

          function init() {
               periodoActive.addClass("select-active");
          }


          function change(page) {
               // solução p/ resetar page caso nova busca seja feita depois de pagina 1
               (page > 1 && page != undefined)?vm.args.page = 1:null;
               vm.args.loading = true;
               aplicacoesService.query(vm.args).then(function (response) {
                    vm.models = response.data.calda_aplicacaos_confirmadas;

                    vm.args.total_rows = response.data.total_itens;
                    //vm.args.length_rows = vm.models.calda_aplicacaos_confirmadas.length;
                    showActiveFilters();
                    vm.args.updatePaggination();

               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               vm.args.periodo = null;
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.calda = null;
               datapickerActive.removeClass("dates-active");
               vm.args.periodo = 30;
               periodoActive.addClass("select-active");
               change(null);
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let periodoSelect;
               let arr = null;
               let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
               let counter = 0;
               for (let i = 0; i < vm.periods.length; i++) {
                   if (vm.periods[i].value == vm.args.periodo) {
                       periodoSelect = vm.periods[i].description
                   };
               }
               arr = [
                   {
                       description: periodoSelect,
                       value: 'periodo'
                   },
                   {
                       description: inicio?inicio+" - "+fim:null,
                       value: 'datepicker'
                   },
                   {
                       description: vm.args.calda,
                       value: 'calda'
                   }
               ];
                   for (let i = 0; i < arr.length; i++) {
                       if (arr[i].description != null) counter++;
                   }

                   if(counter > 0){
                       vm.activeFilters = arr;
                   }
          }

          function desableFilter(value){
               if(value == 'datepicker'){
                   vm.args.data_inicial = null;
                   vm.args.data_final = null;
                   datapickerActive.removeClass("dates-active");
               }else{
                    periodoActive.removeClass("select-active");
                    vm.args[value] = null;
               }
               change(null);
          }

          function mdDialogCtrl($scope, $mdDialog) {

               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.cancelar = function () {
                    $mdDialog.cancel();
               };
          }

          function deletarConfirm(model) {

               var confirm = $mdDialog.confirm()
                    .title('Excluir aplicação')
                    .textContent('Você deseja excluir essa aplicação')
                    .targetEvent(model)
                    .ok('Sim')
                    .cancel('Voltar');

               $mdDialog.show(confirm)
                    .then(function () {
                         deletar(model);
                    }, function () {
                         return null
                    });
          }

          function deletar(model) {
               aplicacoesService.deleteAplicacao(model.id)
                    .then(function (response) {
                         var message = "Aplicação excluida com sucesso";
                         vm.models.splice(vm.models.indexOf(model), 1);
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("success-toast")
                              .hideDelay(6000)
                         );

                    }).catch(function (response) {
                         //console.log('erro', response.data.detail);
                         var message = response.data.detail;
                         $mdToast.show(
                              $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(6000)
                         );
                    });
          }



          function _sortBy(col) {

               if (vm.args.sort_by == col) {

                    vm.args.sort_order = vm.args.sort_order == 'asc' ? 'desc' : 'asc';

               } else {
                    vm.args.sort_order = 'asc';
                    vm.args.sort_by = col;
               }

               vm.args._change(null);

          }

          function gotoVisualizar(id) {
               $state.go('app.aplicacoes.visualizar', {
                    id: id
               });
          }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }

          function cadastroPropriedadeConfirm() {

               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');

               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }

          // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          function selectedPeriodo() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = null;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.caldas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

          // State
          $stateProvider
               .state('app.caldas', {
                    abstract: true,
                    url: '/caldas',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               })
               .state('app.caldas.buscar', {
                    url: '/buscar',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas/views/buscar.html',
                         controller: 'BuscarCaldasController as vm'
                         }
                    },
                    resolve: {
                         data: function (previsaoColheitaService) {
                              return previsaoColheitaService.query();
                         }
                    }
               })
               .state('app.caldas.cadastro', {
                    url: '/cadastro',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas/views/cadastro.html',
                         controller: 'CadastroCaldaController as vm'
                         }
                    },
                    resolve: {
                         tipos: function (caldasService) {
                              return caldasService.getTipoInsumos();
                         }
                    }
               })
               .state('app.caldas.confirmar', {
                    url: '/confirmar',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/caldas/views/confirmar.html',
                              controller: 'ConfirmarCaldaController as vm'
                         }
                    }
               })
               .state('app.caldas.sucesso', {
                    url: '/sucesso',
                    views: {
                         'content@app': {
                              templateUrl: 'app/main/caldas/views/sucesso.html',
                              controller: 'SucessoCaldaController as vm'
                         }
                    }
               })
               .state('app.caldas.visualizar', {
                    url: '/visualizar/:id',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas/views/visualizar.html',
                         controller: 'VisualizarCaldaController as vm'
                         }
                    },
                    resolve: {
                         model: function ($stateParams, caldasService) {
                              return caldasService.get($stateParams.id);
                         }
                    }
               })
               .state('app.caldas.editar', {
                    url: '/editar/:id',
                    views: {
                         'content@app': {
                         templateUrl: 'app/main/caldas/views/editar.html',
                         controller: 'EditarCaldaController as vm'
                         }
                    },
                    resolve: {
                         tipos: function (caldasService) {
                              return caldasService.getTipoInsumos();
                         },
                         model: function ($stateParams, caldasService) {
                              return caldasService.get($stateParams.id);
                         }
                    }
               })


               //Menu
               msNavigationServiceProvider.saveItem('manejo.caldas', {
                    title: 'Aplicação de caldas',
                    weight: 4,
               });
               msNavigationServiceProvider.saveItem('manejo.caldas.buscar', {
                    title: 'Caldas',
                    state: 'app.caldas.buscar',
               });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.caldas')
        .factory('caldasService', caldasService);

    /** @ngInject */
    function caldasService($q, api) {

        var queryResponse = {};
        var queryArgs = {};
        var dadosCaldas = {};


        var service = {
            query: query,
            getList: getList,
            get: get,
            getCulturasVariedades: getCulturasVariedades,
            create: create,
            update: update,
            deletar: deletar,
            getFiltros: getFiltros,
            getTipoInsumos: getTipoInsumos,
            addDados: addDados,
            getDados: getDados,
            clearDados: clearDados
        };

        return service;

          function addDados(dados) {
               dadosCaldas = dados;
          }
          function getDados() {
               return dadosCaldas;
          }
          function clearDados() {
               dadosCaldas = {};
          }

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaCultura.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getList(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.Caldas.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

          function getFiltros() {
               var deferred = $q.defer();
               api.CaldasFiltros.get().$promise.then(
               function (response) {
                    deferred.resolve(response);
               }
               ).catch(function (response) {
               deferred.reject(response);
               console.log(response);
               });
               return deferred.promise;
          }

          function getTipoInsumos() {

               var deferred = $q.defer();
               api.CaldasTiposInsumos
               .query().$promise
               .then(function (response) {
                    deferred.resolve(response);
               })
               .catch(function (response) {
                    deferred.reject(response);
               });
               return deferred.promise;
          }

        function create(model) {

            var deferred = $q.defer();

            api.Caldas
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }


        function get(id) {

            var deferred = $q.defer();

            api.Caldas.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getCulturasVariedades() {

            var deferred = $q.defer();
            api.PropriedadeAreaCulturasVariedades
                .get().$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        }

        ////// ALTERAR //////
        function update(model) {
            var deferred = $q.defer();
            api.Caldas.update(model).$promise.then(
                // SUCCESS
                function (response) {
                    deferred.resolve(response);
                    modelNew = {};
                }).catch(
                    function (response) {
                        deferred.reject(response);
                    }
                );
            return deferred.promise;
        }

        function deletar(id){
            var deferred = $q.defer();

            api.Caldas.delete({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }).catch(
                function (response) {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

    }
})();

(function () {
     'use strict';

     angular
          .module('app.caldas')
          .controller('VisualizarCaldaController', VisualizarCaldaController)

     /** @ngInject */
     function VisualizarCaldaController($rootScope, $state, caldasService, model) {

          var vm = this;

          // Data
          vm.model = model;

          // Metodos
          vm.gotoList = gotoList;
          vm.gotoEdit = gotoEdit;
          //////////

          init();

          function init() {
          }

          function gotoList() {
               $state.go('app.caldas.buscar');
          }

          function gotoEdit(id) {
               $state.go('app.caldas.editar', {
                   id: id
               });
          }
     }


})();

(function () {
     'use strict';

     angular
          .module('app.caldas')
          .controller('SucessoCaldaController', SucessoCaldaController)

     /** @ngInject */
     function SucessoCaldaController($state) {

          var vm = this;

          // Data

          // Metodos
          vm.gotoAdd = gotoAdd;
          vm.gotoList = gotoList;
          vm.gotoHome = gotoHome;
          //////////

          init();

          function init() {
          }

          function gotoAdd() {
               $state.go('app.caldas.cadastro');
          }

          function gotoList() {
               $state.go('app.caldas.buscar');
          }

          function gotoHome() {
               $state.go('app.home');
          }
     }


})();

(function () {
     'use strict';

     angular
          .module('app.caldas')
          .controller('EditarCaldaController', EditarCaldaController)
          .controller('CadastroInsumoModalController', CadastroInsumoModalController)

     /** @ngInject */
     function EditarCaldaController($rootScope, $state, $mdDialog, caldasService, tipos, model, $mdToast) {

          var vm = this;

          // Data
          vm.model = model;
          vm.api_response_erro = {};
          vm.selectTipos = tipos;
          vm.selectUnidades = [];
          vm.selectInsumos = [];

          // Metodos
          vm.save = save;
          vm.gotoView = gotoView;
          vm.gotoLista = gotoLista;
          vm.onSelectTipo = onSelectTipo;
          vm.onSelectInsumo = onSelectInsumo;
          vm.addInsumos = addInsumos;
          vm.removeInsumos = removeInsumos;
          vm.openModalAddInsumo = openModalAddInsumo;
          //////////

          init();

          function init() {

               if (vm.model.calda_insumos) {
                    recuperarDados(vm.model)
               }
          }

          function recuperarDados(dados){
               console.log('dados edit', dados);
               if(dados){
                    for (let i = 0; i < dados.calda_insumos.length; i++) {
                         addInsumos(dados.calda_insumos[i], i);
                    }
               }
          }

          function addInsumos(insumo, index) {
               if(!insumo){
                    vm.model.calda_insumos.push({
                         insumo_tipo_id: null,
                         insumo_id: null,
                         unidade_medida: null,
                         quantidade_por_hectare: null,
                         carencia: null
                    });
               }
               if(index != null){
                    //onSelectTipo(insumo, index);
                    let tipoSelected = insumo;
                    let insumos = [];
                    let tipo;
                    vm.selectTipos.forEach(function (item) {
                         if (item.id_tipo == tipoSelected.insumo_tipo_id) {
                              insumos = item.insumos;
                              tipo = item.id_tipo;
                         }
                    });
                    vm.selectInsumos[index] = insumos;
                    vm.model.calda_insumos[index].insumo_tipo_id = tipo;

                    let selected = vm.model.calda_insumos[index].insumo_id;
                    let unidade;
                    let nome_insumo;
                    vm.selectInsumos[index].forEach(function (item) {
                         if (item.id_insumo == selected) {
                              unidade = item.medidas[0];
                              nome_insumo = item.nome_insumo
                         }
                    });
                    vm.model.calda_insumos[index].unidade_medida = unidade;
                    vm.model.calda_insumos[index].insumo_nome = nome_insumo;
               }
          }

          function removeInsumos(index) {
               vm.model.calda_insumos.splice(index, 1);
          }

          function onSelectTipo(value, index) {
               console.log('tipos', vm.selectTipos);
               let tipoSelected = value;
               console.log('selected tipo', tipoSelected);
               let insumos = [];
               let tipo;
               vm.selectTipos.forEach(function (item) {
                    if (item.id_tipo == tipoSelected.insumo_tipo_id) {
                         insumos = item.insumos;
                         tipo = item.id_tipo;
                    }
               });
               vm.selectInsumos[index] = insumos;
               vm.model.calda_insumos[index].insumo_tipo_id = tipo;
               vm.model.calda_insumos[index].insumo_id = null;
               vm.model.calda_insumos[index].unidade_medida = null;
               vm.model.calda_insumos[index].carencia = null;

               console.log('selected insumos', vm.selectInsumos[index]);
          }

          function onSelectInsumo(index){
               let selected = vm.model.calda_insumos[index].insumo_id;
               let unidade;
               let nome_insumo;
               console.log('selcted isumo', selected);
               vm.selectInsumos[index].forEach(function (item) {
                    if (item.id_insumo == selected) {
                         unidade = item.medidas[0];
                         nome_insumo = item.nome_insumo
                    }
               });
               vm.model.calda_insumos[index].unidade_medida = unidade;
               vm.model.calda_insumos[index].insumo_nome = nome_insumo;
          }

          function save(form) {

               console.log('save', vm.model);
               //return

               if (form.$invalid) {
                    return;
               }else{
                    $rootScope.loadingProgress = true;
                    this.savePromise = caldasService.update(vm.model);
                    this.savePromise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        gotoSucesso();
                    }).catch(function (response) {
                        $rootScope.loadingProgress = false;
                        vm.api_response_erro = response;
                        //console.log('error', response);
                        $mdToast.show(
                         $mdToast.simple()
                             .textContent(response.data.detail)
                             .position('top right')
                             .theme("error-toast")
                             .hideDelay(6000)
                         );
                    });
               }
          }

          function gotoView(id) {
               $state.go('app.caldas.visualizar', {
                   id: id
               });
          }

          function gotoLista(){
               $state.go('app.caldas.buscar');
          }

          function gotoSucesso() {
               $state.go('app.caldas.sucesso');
          }

          function openModalAddInsumo(index) {
               let selectedTipo = vm.model.calda_insumos[index].insumo_tipo_id;

               $mdDialog.show({
                    locals:{dataToPass: selectedTipo},
                    controller: 'CadastroInsumoModalController as vm',
                    templateUrl: 'app/main/caldas/views/modal_add_insumo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function (answer) {
                         if (answer) {
                              console.log('response modal', answer);
                              vm.selectInsumos[index].push({
                                   id_insumo: answer.id,
                                   nome_insumo: answer.nome,
                                   medidas: answer.medidas,
                                   carencia: answer.carencia
                              });

                              vm.model.calda_insumos[index].insumo_id = null;
                         }
                    }, function () {
                         //vm.model.cliente = null;
                    });
          }

     }


     function CadastroInsumoModalController($rootScope, $filter, $mdToast, $mdDialog, $q, cadastrosCadastroInsumoService, dataToPass) {

          var vm = this;

          // Data
          vm.model = {};
          vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
          vm.tipo_insumo = getTipoInsumo();
          vm.defensivos = [];
          vm.api_response_erro = {};
          vm.tipoSelected = dataToPass;

          // Metodos
          vm.close = close;
          vm.save = save;
          vm.getTipoInsumo = getTipoInsumo;
          vm.listaAgrofitSearch = listaAgrofitSearch;
          vm.selectedItemChange = selectedItemChange;
          //////////

          init();

          function init() {

          }

          function save(form) {

               if (form.$invalid) {
                   return;
               }

               if (vm.model.insumo_tipo_id == 4 && vm.model.cultura)
                   vm.model.cultura_id = vm.model.cultura.id;
               else
                   vm.model.cultura_id = undefined;

               var model = {

                   estoque_insumo: [
                       vm.model
                   ]
               }

               var message = $filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO');
               this.savePromise = cadastrosCadastroInsumoService.create(model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   let data = response.data[0];
                   //console.log('response', response.data[0]);
                   //vm.model.id = response.id;

                   $mdToast.show(
                       $mdToast.simple()
                           .textContent(message)
                           .position('top right')
                           .theme("success-toast")
                           .hideDelay(6000)
                   );
                   close(data);
               }).catch(function (response) {
                   $rootScope.loadingProgress = false;

                   if (response.data.errors == undefined) {
                       response.data.errors = response.data.data.errors;
                   }

                   vm.api_response_erro = response;
               });
          }

          function listaAgrofitSearch(query) {

               var deferred = $q.defer();

               var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
               promisse.then(function (response) {

                   vm.defensivos = response.data;
                   let retorno = [];

                   for (let index = 0; index < response.data.length; index++) {
                       const element = response.data[index];
                       retorno.push(element.nome);
                   }

                   deferred.resolve(retorno)

               }).finally(function () {

               });

               return deferred.promise;
          }

           function selectedItemChange(nome) {

               if (nome == undefined) {
                   vm.model.insumo_agricola_id = undefined;
                   return;
               }

               let item = vm.defensivos.filter(function (obj) {
                   return obj.nome == nome
               });

               vm.model.insumo_agricola_id = item[0].id;
          }

          function getTipoInsumo() {

               var tipo_insumo = [
               { id: 1, nome: 'Biológico' },
               { id: 2, nome: 'Defensivo' },
               { id: 3, nome: 'Fertilizante' },
               { id: 4, nome: 'Semente' }
               ];

               return tipo_insumo;
          }

          function getTipoMedida(tipoInsumo) {

               var tipo_medida = [];

               if (tipoInsumo == 4) {
               tipo_medida.push({ id: 1, nome: 'Peso' });
               //tipo_medida.push({ id: 3, nome: 'Unidade' });
               } else {
               tipo_medida.push({ id: 1, nome: 'Peso' });
               tipo_medida.push({ id: 2, nome: 'Líquido' });
               }

               return tipo_medida;
          }

          function close(data) {
               $mdDialog.hide(data);
          }

     }

})();

(function () {
     'use strict';

     angular
          .module('app.caldas')
          .controller('ConfirmarCaldaController', ConfirmarCaldaController)

     /** @ngInject */
     function ConfirmarCaldaController($rootScope, $state, caldasService) {

          var vm = this;

          // Data
          vm.model = caldasService.getDados();

          // Metodos
          vm.gotoStep1 = gotoStep1;
          vm.gotoSucesso = gotoSucesso;
          vm.save = save;
          //////////

          init();

          function init() {
               console.log('dados', vm.model);
               if (!vm.model.insumos) {
                    gotoStep1();
               }
          }

          function save() {
               $rootScope.loadingProgress = true;
               if (vm.model) {

                    let dados = {
                         nome: vm.model.calda,
                         calda_insumos: vm.model.insumos
                    }

                    this.savePromise = caldasService.create(dados);
                    this.savePromise.then(function (response) {
                        $rootScope.loadingProgress = false;
                        let data = response;
                        gotoSucesso();
                    }).catch(function (response) {
                        $rootScope.loadingProgress = false;
                        vm.api_response_erro = response;
                    });
               }
          }

          function gotoSucesso() {
               caldasService.clearDados();
               $state.go('app.caldas.sucesso');
          }

          function gotoStep1() {
               $state.go('app.caldas.cadastro');
          }
     }


})();

(function () {
     'use strict';

     angular
          .module('app.caldas')
          .controller('CadastroCaldaController', CadastroCaldaController)
          .controller('CadastroInsumoModalController', CadastroInsumoModalController)

     /** @ngInject */
     function CadastroCaldaController($rootScope, $state, $mdDialog, caldasService, tipos) {

          var vm = this;

          // Data
          vm.model = caldasService.getDados();
          vm.api_response_erro = {};
          vm.selectTipos = tipos;
          vm.selectUnidades = [];
          vm.selectInsumos = [];

          // Metodos
          vm.gotoConfirmar = gotoConfirmar;
          vm.gotoLista = gotoLista;
          vm.onSelectTipo = onSelectTipo;
          vm.onSelectInsumo = onSelectInsumo;
          vm.addInsumos = addInsumos;
          vm.removeInsumos = removeInsumos;
          vm.openModalAddInsumo = openModalAddInsumo;
          //////////

          init();

          function init() {

               if (!vm.model.insumos) {
                    if (vm.model.insumos == null) {
                         vm.model.insumos = new Array();
                    }
                    addInsumos(null, null);
               }else{
                    recuperarDados(vm.model)
               }
          }

          function recuperarDados(dadosStep1){
               if(dadosStep1){
                    for (let i = 0; i < dadosStep1.insumos.length; i++) {
                         addInsumos(dadosStep1.insumos[i], i);
                    }
               }
          }

          function addInsumos(insumo, index) {
               if(!insumo){
                    vm.model.insumos.push({
                         tipo: null,
                         insumo_id: null,
                         quantidade_por_hectare: null,
                         carencia: null
                    });
               }

               if(index != null){
                    onSelectTipo(insumo, index);

                    onSelectInsumo(index);
               }
          }

          function removeInsumos(index) {
               vm.model.insumos.splice(index, 1);
          }

          function onSelectTipo(value, index) {
               let tipoSelected = value;
               console.log('selcted tipo', tipoSelected);
               let insumos = [];
               let tipo_nome;
               vm.selectTipos.forEach(function (item) {
                    if (item.id_tipo == tipoSelected.tipo) {
                         insumos = item.insumos;
                         tipo_nome = item.nome_tipo;
                    }
               });
               vm.selectInsumos[index] = insumos;
               vm.model.insumos[index].tipo_nome = tipo_nome;
               vm.model.insumos[index].carencia = null;

               console.log('selected insumos', vm.selectInsumos[index]);
          }

          function onSelectInsumo(index){
               let selected = vm.model.insumos[index].insumo_id;
               let unidade;
               let nome_insumo;
               console.log('selcted isumo', selected);
               vm.selectInsumos[index].forEach(function (item) {
                    if (item.id_insumo == selected) {
                         unidade = item.medidas[0];
                         nome_insumo = item.nome_insumo
                    }
               });
               vm.model.insumos[index].insumo_nome = nome_insumo;
               vm.model.insumos[index].unidade_medida = unidade;
          }

          function gotoConfirmar(form) {

               if (form.$invalid) {
                    return;
               }else{
                    $rootScope.loadingProgress = true;

                    caldasService.addDados(vm.model);
                    //console.log(caldasService.getDados());
                    //return

                    $state.go('app.caldas.confirmar');
               }
          }

          function gotoLista(){
               $state.go('app.caldas.buscar');
          }

          function openModalAddInsumo(index) {
               let selectedTipo = vm.model.insumos[index].tipo;

               $mdDialog.show({
                    locals:{dataToPass: selectedTipo},
                    controller: 'CadastroInsumoModalController as vm',
                    templateUrl: 'app/main/caldas/views/modal_add_insumo.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: false,
                    fullscreen: true // Only for -xs, -sm breakpoints.
               })
                    .then(function (answer) {
                         if (answer) {
                              console.log('response modal', answer);

                              vm.selectInsumos[index].push({
                                   id_insumo: answer.id,
                                   nome_insumo: answer.nome,
                                   medidas: answer.medidas,
                                   carencia: answer.carencia
                              });

                              vm.model.insumos[index].insumo_id = null;

                              // vm.model.insumos[index].insumo_id = answer.id;

                              // onSelectInsumo(index);
                         }
                    }, function () {
                         //vm.model.cliente = null;
                    });
          }

     }


     function CadastroInsumoModalController($rootScope, $filter, $mdToast, $mdDialog, $q, cadastrosCadastroInsumoService, dataToPass) {

          var vm = this;

          // Data
          vm.model = {};
          vm.tipo_medida = getTipoMedida(vm.model.insumo_tipo_id);
          vm.tipo_insumo = getTipoInsumo();
          vm.defensivos = [];
          vm.api_response_erro = {};
          vm.tipoSelected = dataToPass;

          // Metodos
          vm.close = close;
          vm.save = save;
          vm.getTipoInsumo = getTipoInsumo;
          vm.listaAgrofitSearch = listaAgrofitSearch;
          vm.selectedItemChange = selectedItemChange;
          //////////

          init();

          function init() {

          }

          function save(form) {

               if (form.$invalid) {
                   return;
               }

               if (vm.model.insumo_tipo_id == 4 && vm.model.cultura)
                   vm.model.cultura_id = vm.model.cultura.id;
               else
                   vm.model.cultura_id = undefined;

               var model = {

                   estoque_insumo: [
                       vm.model
                   ]
               }

               var message = $filter('translate')('CADASTRO_INSUMO.INSUMO_ADICIONADO');
               this.savePromise = cadastrosCadastroInsumoService.create(model);

               $rootScope.loadingProgress = true;
               this.savePromise.then(function (response) {
                   $rootScope.loadingProgress = false;
                   let data = response.data[0];
                   //console.log('response', response.data[0]);
                   //vm.model.id = response.id;

                   $mdToast.show(
                       $mdToast.simple()
                           .textContent(message)
                           .position('top right')
                           .theme("success-toast")
                           .hideDelay(6000)
                   );
                   close(data);
               }).catch(function (response) {
                   $rootScope.loadingProgress = false;

                   if (response.data.errors == undefined) {
                       response.data.errors = response.data.data.errors;
                   }

                   vm.api_response_erro = response;
               });
          }

          function listaAgrofitSearch(query) {

               var deferred = $q.defer();

               var promisse = cadastrosCadastroInsumoService.searchListaAgrofit(query)
               promisse.then(function (response) {

                   vm.defensivos = response.data;
                   let retorno = [];

                   for (let index = 0; index < response.data.length; index++) {
                       const element = response.data[index];
                       retorno.push(element.nome);
                   }

                   deferred.resolve(retorno)

               }).finally(function () {

               });

               return deferred.promise;
          }

           function selectedItemChange(nome) {

               if (nome == undefined) {
                   vm.model.insumo_agricola_id = undefined;
                   return;
               }

               let item = vm.defensivos.filter(function (obj) {
                   return obj.nome == nome
               });

               vm.model.insumo_agricola_id = item[0].id;
          }

          function getTipoInsumo() {

               var tipo_insumo = [
               { id: 1, nome: 'Biológico' },
               { id: 2, nome: 'Defensivo' },
               { id: 3, nome: 'Fertilizante' },
               { id: 4, nome: 'Semente' }
               ];

               return tipo_insumo;
          }

          function getTipoMedida(tipoInsumo) {

               var tipo_medida = [];

               if (tipoInsumo == 4) {
               tipo_medida.push({ id: 1, nome: 'kg' });
               //tipo_medida.push({ id: 3, nome: 'Unidade' });
               } else {
               tipo_medida.push({ id: 1, nome: 'kg' });
               tipo_medida.push({ id: 2, nome: 'L' });
               }

               return tipo_medida;
          }

          function close(data) {
               $mdDialog.hide(data);
          }

     }

})();

/* eslint-disable no-unused-vars */
(function () {
     'use strict';

     angular
          .module('app.caldas')
          .controller('BuscarCaldasController', BuscarCaldasController);

    /** @ngInject */
     function BuscarCaldasController(data, $state, caldasService, $mdDialog, $mdToast, $filter) {
          var vm = this;

          // Data
          vm.filtros = [];

          vm.gotoView = gotoView;
          vm.gotoAdd = gotoAdd;
          vm.mdDialogCtrl = mdDialogCtrl;
          vm.deletarConfirm = deletarConfirm;
          vm.deletar = deletar;
          vm.resetFilters = resetFilters;

          vm.closeColapse = true;
          vm.isColapsed = isColapsed;
          vm.closeColapsed = closeColapsed;
          vm.openDatasSelect = openDatasSelect;
          vm.selecionarDatas = selecionarDatas;
          vm.closedDatasSelect = closedDatasSelect;
          vm.clearPreDate = clearPreDate;
          //vm.clearRangeDate = clearRangeDate;
          vm.selectedPeriodo = selectedPeriodo;
          vm.activeFilters = false;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;

          // DATAPICKER //////////////////
          var datapicker = angular.element(document.querySelector('#dataspicker .date-picker-box'));
          var datapickerActive = angular.element(document.querySelector('#dataspicker'));
          var periodoActive = angular.element(document.querySelector('.select-periodo'));

          vm.periods = [
               {
                    description: "Últimos 7 dias",
                    value: 7
               },
               {
                    description: "Últimos 15 dias",
                    value: 15
               },
               {
                    description: "Últimos 30 dias",
                    value: 30
               },
               {
                    description: "Últimos 3 meses",
                    value: 90
               },
               {
                    description: "Últimos 6 meses",
                    value: 180
               }
          ];

          vm.model = {
               data_inicial: new Date(),
               data_final: new Date()
          }

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: null,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',
               periodo: 30,
               data_inicial: null,
               data_final: null,
               query: null,
               calda: null,
               _change: change
          };

          vm.args._change(null);

          function init() {

               getFiltros();

               periodoActive.addClass("select-active");

               caldasService.clearDados();
          }

          init();

          function getFiltros() {
               vm.args.loading = true;
               caldasService.getFiltros().then(function (response) {
                    vm.filtros = response;
               }).finally(function () {
                   vm.args.loading = false;
               });
          }

          function isColapsed(model) {
               model.isLoading = false;
               model.colapsed = true;
               vm.isDisabled = true;
          }

          function closeColapsed(model) {
               model.colapsed = false;
               vm.isDisabled = false;
          }

          function change(page) {
               // solução p/ resetar page caso nova busca seja feita depois de pagina 1
               (page > 1 && page != undefined)?vm.args.page = 1:null;
               vm.args.loading = true;
               caldasService.getList(vm.args).then(function (response) {
                    vm.models = response.data.caldas;
                    vm.args.total_rows = response.data.total_itens;
                    //vm.args.length_rows = vm.models.length;
                    showActiveFilters();
                    vm.args.updatePaggination();
               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = 30;
               periodoActive.addClass("select-active");
               vm.args.calda = null;
               change(null);
          }

        function showActiveFilters(){
            vm.activeFilters = null;
            let periodoSelect;
            let arr = null;
            let inicio = $filter('date')(vm.args.data_inicial,'dd/MM/yyyy');
            let fim = $filter('date')(vm.args.data_final,'dd/MM/yyyy');
            let counter = 0;
            for (let i = 0; i < vm.periods.length; i++) {
                if (vm.periods[i].value == vm.args.periodo) {
                    periodoSelect = vm.periods[i].description
                };
            }
            arr = [
                {
                    description: periodoSelect,
                    value: 'periodo'
                },
                {
                    description: inicio?inicio+" - "+fim:null,
                    value: 'datepicker'
                },
                {
                    description: vm.args.calda,
                    value: 'calda'
                }
            ];
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
                }

                if(counter > 0){
                    vm.activeFilters = arr;
                }
        }

        function desableFilter(value){
            if(value == 'datepicker'){
                vm.args.data_inicial = null;
                vm.args.data_final = null;
                datapickerActive.removeClass("dates-active");
                periodoActive.addClass("select-active");
            }else{
               periodoActive.removeClass("select-active");
               vm.args[value] = null;
            }
            change(null);
        }

        function mdDialogCtrl($scope, dataToPass) {
            $scope.model = dataToPass

            $scope.cancelar = function () {
                $mdDialog.cancel();
            };
        }

        function deletarConfirm(model) {

            var confirm = $mdDialog.confirm()
                .title('Exclusão de calda')
                .textContent('Você deseja excluir essa calda?')
                .targetEvent(model)
                .ok('Sim')
                .cancel('Não');

            $mdDialog.show(confirm)
                .then(function () {
                    deletar(model);
                }, function () {
                    return null
                });
        }

        function deletar(model) {

          caldasService.deletar(model.id)
                .then(function (response) {
                    vm.models.splice(vm.models.indexOf(model), 1);
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Calda deletada com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );
                    change(null);

                }).catch(function (response) {
                });
        }

        function gotoView(id) {
            $state.go('app.caldas.visualizar', {
                id: id
            });
        }

        function gotoAdd() {
            $state.go('app.caldas.cadastro');
        }

        function gotoCadastroPropriedade() {
            $state.go('app.registro.propriedade.criar');
        }
        function cadastroPropriedadeConfirm() {
            var confirm = $mdDialog.confirm()
                .title('Propriedade não encontrada')
                .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                .ok('Sim, quero cadastrar!')
                .cancel('Não quero!');

            $mdDialog.show(confirm)
                .then(function () {
                    gotoCadastroPropriedade();
                }, function () {
                    return null
                });
        }

        // DATAPICKER //////////////////
          function clearPreDate() {
               vm.args.periodo = null;
          }
          // function clearRangeDate() {
          //      vm.args.data_inicial = null
          //      vm.args.data_final = null
          // }
          function selectedPeriodo() {
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               periodoActive.addClass("select-active");
               datapickerActive.removeClass("dates-active");
          }
          function openDatasSelect(){
               datapicker.css("display", "block");
          }
          function selecionarDatas(){
               clearPreDate();
               datapicker.css("display", "none");
               datapickerActive.addClass("dates-active");
               periodoActive.removeClass("select-active");
          }
          function closedDatasSelect(){
               datapicker.css("display", "none");
               vm.args.data_inicial = null;
               vm.args.data_final = null;
               vm.args.periodo = null;
               datapickerActive.removeClass("dates-active");
               //periodoActive.classList.add("select-active");
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.laudo')
        .factory('laudoService', laudoService);

    /** @ngInject */
    function laudoService($q, api) {

        var queryResponse = {};
        var queryArgs = {};
        var transferData = {}

        var service = {
            query: query,
            getNew: getNew,
            get: get,
            create: create,

            getDefeitos: getDefeitos,
            getClassificacao: getClassificacao,
            getOcorrencia: getOcorrencia,
            getMaturacao: getMaturacao,
            getCalibre: getCalibre,
            getColoracao: getColoracao,
            getOdor: getOdor,
            getPressao: getPressao,
            getLaudo: getLaudo,
            getSabor: getSabor,
            getBrix: getBrix,
            cancelarLaudo: cancelarLaudo,
            getConclusao: getConclusao,

            uploadFile: uploadFile,
            uploadFiles: uploadFiles,
            getPdfFile: getPdfFile,
            setLaudoConfirmation: setLaudoConfirmation,
            getLaudoConfirmation: getLaudoConfirmation
        };

        return service;

        function getNew() {
            return {
                // laudo_upload_file: []
            };
        }

        function setLaudoConfirmation(data) {
          transferData = data;
        }

        function getLaudoConfirmation() {
         return transferData;
        }
       

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.Laudo.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function create(model) {

            var deferred = $q.defer();

            api.Laudo
                .save(model)
                .$promise
                .then(function (response) {
                    deferred.resolve(response);
                })
                .catch(function (response) {
                    //   Resolve the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function cancelarLaudo(model) {
            return api.Laudo.cancelarLaudo(model).$promise;
        }


        function get(id) {

            var deferred = $q.defer();

            api.Laudo.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

        function getDefeitos() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    descricao: 'Amassado'
                },
                {
                    id: 2,
                    descricao: 'Dano profundo'
                },
                {
                    id: 3,
                    descricao: 'Mancha'
                },
                {
                    id: 4,
                    descricao: 'Podridão'
                },
                {
                    id: 5,
                    descricao: 'Rusting'
                },
                {
                    id: 6,
                    descricao: 'Com talo'
                },
                {
                    id: 7,
                    descricao: 'Sem talo'
                },
                {
                    id: 8,
                    descricao: 'Outro'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getConclusao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    descricao: 'Conforme'
                },
                {
                    id: 2,
                    descricao: 'Não conforme'
                },
                {
                    id: 3,
                    descricao: 'Parcialmente conforme'
                },
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getClassificacao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Leve'
                },
                {
                    id: 2,
                    nome: 'Grave'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getOcorrencia() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Presente'
                },
                {
                    id: 2,
                    nome: 'Ausente'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getMaturacao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getCalibre() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getColoracao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getOdor() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getPressao() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getSabor() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function getBrix() {
            var deferred = $q.defer();

            var data = [
                {
                    id: 1,
                    nome: 'Conforme'
                },
                {
                    id: 2,
                    nome: 'Não conforme'
                },
                {
                    id: 3,
                    nome: 'Não se aplica'
                }
            ];

            deferred.resolve(data);

            return deferred.promise;
        }

        function uploadFile(file) {

            // Create a new deferred object
            var deferred = $q.defer();


            api.File.upload({
                uploadedFile: file
            }).$promise
                .then(function (response) {

                    console.log('laudoService.upload.then', response);

                    // Resolve the promise
                    deferred.resolve(response);

                })
                .catch(function (response) {
                    // Reject the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function uploadFiles(files) {

            // Create a new deferred object
            var deferred = $q.defer();


            api.Files.upload({
                uploadedFile: files
            }).$promise
                .then(function (response) {

                    console.log('laudoService.upload.then', response);

                    // Resolve the promise
                    deferred.resolve(response);

                })
                .catch(function (response) {

                    // Reject the promise
                    deferred.reject(response);
                });

            return deferred.promise;
        }

        function getLaudo(id) {
            var deferred = $q.defer();

            api.LoteLaudoVenda.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        ////// HISTÓRICO DA ÁREA ////// 
        function getPdfFile(laudo_id) {

            var deferred = $q.defer();

            api.LaudoPdf
                .get({
                    id: laudo_id
                })
                .$promise.then(
                    function (response) {
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                    console.log(response);
                });
            return deferred.promise;
        }
        ////// HISTÓRICO DA ÁREA ////// 

    }
})();
(function () {
    'use strict';

    angular
        .module('app.assinatura', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

        // State
        $stateProvider
            .state('app.assinatura', {
                abstract: true,
                url: '/assinatura'
            })
            .state('app.assinatura.desativada', {
                url: '/desativada/:dataFinalPeriodo',
                views: {
                    'main@': {
                        templateUrl: 'app/core/layouts/content-only.html',
                        controller: 'MainController as vm'
                    },
                    'content@app.assinatura.desativada': {
                        templateUrl: 'app/main/assinatura/views/desativada.html',
                        controller: 'AssinaturaDesativadaController as vm',
                        resolve: {
                            baseUrl: function (msApi) {
                                return msApi.getBaseUrl();
                            }
                        }
                    }
                },
                resolve: {
                    dataFinalPeriodo: function($stateParams){
                        return $stateParams.dataFinalPeriodo;
                    },
                }
            });

        $translatePartialLoaderProvider.addPart('app/main/assinatura');

    }
})();

(function () {
    'use strict';

    angular
        .module('app.assinatura')
        .controller('AssinaturaDesativadaController', AssinaturaDesativadaController)

    /** @ngInject */
    function AssinaturaDesativadaController($rootScope, $anchorScroll, $location, $scope, $stateParams, $state, $window, $mdDialog, $mdToast, dataFinalPeriodo) {
        var vm = this;

        // Data
        vm.dataFinalPeriodo = dataFinalPeriodo;
        
        // Metodos
        vm.renovarAssinatura = renovarAssinatura;
        
        //////////


        init();

        function init() {

        }

        function renovarAssinatura(){
            window.location.href = getConfig().urlGerenciarlicenca;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.agenda_visitas', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.agenda_visitas', {
                abstract: true,
                url: '/agenda_visitas',
                resolve: {
                    authorize: function (authorization) {
                         authorization.authorize();
                    }
               }
            })
            .state('app.agenda_visitas.dash', {
                url: '/dash',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/agenda_visitas/views/dash.html',
                        controller: 'dashAgendaVisitasController as vm'
                    }
                },
                resolve: {
                    data: function (agendaVisitasService) {
                        return agendaVisitasService.query();
                    }
                }
            })
            .state('app.agenda_visitas.avaliar', {
                url: '/avaliar/:id',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/agenda_visitas/views/avaliar.html',
                        controller: 'AvaliarVisitaController as vm'
                    }
                },
                resolve: {
                    model: function ($stateParams, agendaVisitasService) {
                        return agendaVisitasService.get($stateParams.id);
                    }
                }
            })
            .state('app.agenda_visitas.visualizar', {
               url: '/visualizar/:id',
               views: {
                   'content@app': {
                       templateUrl: 'app/main/agenda_visitas/views/visualizar.html',
                       controller: 'VisualizarVisitaController as vm'
                   }
               },
               resolve: {
                   model: function ($stateParams, agendaVisitasService) {
                       return agendaVisitasService.get($stateParams.id);
                   }
               }
           })

            msNavigationServiceProvider.saveItem('agenda_visitas', {
                title: 'Agendamento visitas',
                weight: 5,
                img: '/assets/icons/visitas/ico-agendamento-br.svg',
                state: 'app.agenda_visitas.dash',
            });

    }
})();

(function () {
    'use strict';

    angular
        .module('app.agenda_visitas')
        .factory('agendaVisitasService', agendaVisitasService);

    /** @ngInject */
    function agendaVisitasService($q, api, propertieService) {

        var queryResponse = {};
        var queryArgs = {};

        var service = {
            query: query,
            getListDash: getListDash,
            getDash: getDash,
            get: get,
            getPropriedades: getPropriedades,
            getFiltros: getFiltros,
            update: update,
            cancelamento: cancelamento,
            estornarAvaliacao: estornarAvaliacao,
            deletar: deletar,
            getAvaliacao: getAvaliacao
        };

        return service;

        function query(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;


            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.PrevisaoColheitaCultura.query(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getListDash(args, cache) {

            var deferred = $q.defer();

            cache = (typeof cache !== 'undefined') ? cache : true;
            args = (typeof args !== 'undefined' && args != null) ? args : queryArgs;

            if (cache && angular.equals(args, queryArgs)) {
                deferred.resolve(queryResponse);
            } else {
                api.VisitasListaDash.get(args).$promise.then(
                    function (response) {
                        queryArgs = angular.copy(args);
                        queryResponse = response;
                        deferred.resolve(response);
                    }

                ).catch(function (response) {
                    deferred.reject(response);
                });
            }
            return deferred.promise;
        }

        function getDash() {
            var deferred = $q.defer();
            api.VisitasDash.get().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }
            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function getFiltros() {
            var deferred = $q.defer();
            api.PrevisaoColheitaFiltro.query().$promise.then(
                function (response) {
                    deferred.resolve(response);
                }
            ).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });
            return deferred.promise;
        }

        function getPropriedades() {

            var deferred = $q.defer();

            var args = {
                per_page: 999,
                sort_by: 'nome',
                sort_order: 'asc',
            };

            propertieService.query(args, false).then(function (response) {
                deferred.resolve(response.data);
            }).catch(function (response) {
                deferred.reject(response);
                console.log(response);
            });

            return deferred.promise;
        }

        function get(id) {

            var deferred = $q.defer();

            api.Visitas.get({
                id: id
            }).$promise.then(
                function (response) {
                    deferred.resolve(response);
                }

            ).catch(function (response) {
                deferred.reject(response);
            });

            return deferred.promise;
        }

          ////// ALTERAR //////
          function update(model) {
               var deferred = $q.defer();
               api.Visitas.update(model).$promise.then(
                    // SUCCESS
                    function (response) {
                         deferred.resolve(response);
                    }).catch(
                         function (response) {
                         deferred.reject(response);
                         }
                    );
               return deferred.promise;
          }

          function cancelamento(model) {
               var deferred = $q.defer();
               api.VisitasCancelamento.update(model).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }).catch(
                    function (response) {
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          function estornarAvaliacao(id){
               var deferred = $q.defer();
               api.VisitasEstorno.update({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }).catch(
                    function (response) {
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }

          function deletar(id){
               var deferred = $q.defer();

               api.PrevisaoColheita.delete({
                    id: id
               }).$promise.then(
                    function (response) {
                         deferred.resolve(response);
                    }).catch(
                    function (response) {
                         deferred.reject(response);
                    }
               );

               return deferred.promise;
          }

          function getAvaliacao() {
               return [
                    {
                         nome: "Avaliado",
                         id: 1
                    },
                    {
                         nome: "Não avaliado",
                         id: 2
                    }
               ]
          }
    }
})();

(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .controller('VisualizarVisitaController', VisualizarVisitaController)

    /** @ngInject */
    function VisualizarVisitaController(model, $state) {
        var vm = this;
        // Data
        vm.model = model;
        vm.api_response_erro = {};

        // Metodos
        vm.gotoDash = gotoDash;
        //////////

        init();

        function init() {
        }

        function gotoDash(){
            $state.go('app.agenda_visitas.dash');
        }
    }

})();

(function () {
     'use strict';

     angular
          .module('app.agenda_visitas')
          .controller('dashAgendaVisitasController', dashAgendaVisitasController)

     /** @ngInject */
     function dashAgendaVisitasController($state, agendaVisitasService, propertieService, $mdDialog, $mdToast, $filter) {
          var vm = this;
          vm.activeFilters = false;

          // Data
          vm.models = null;
          vm.dash = null;
          vm.filtros = null;
          vm.avaliacaoFiltro = null;
          //
          vm.resetFilters = resetFilters;
          vm.gotoAvaliar = gotoAvaliar;
          vm.gotoVisualizar = gotoVisualizar;
          vm.getDash = getDash;
          vm.estornarConfirm = estornarConfirm;
          vm.openModalCancelamento = openModalCancelamento;
          vm.showActiveFilters = showActiveFilters;
          vm.desableFilter = desableFilter;

          vm.model = {
               dataInicial: new Date(),
               dataFinal: new Date(),
               motivo_cancelamento: ''
          }

          //////////

          /// Query
          vm.args = {
               loading: false,
               page: 1,
               per_page: 10,
               page_sizes: [5, 10, 25, 100],
               total_rows: null,
               length_rows: 1,
               sort_by: 'id',
               sort_order: 'desc',
               Consultor: null,
               Status: null,
               Avaliacao: null,
               DataInicio: null,
               DataFim: null,
               _change: change
          };

          vm.args._change();

          init();

          function init() {

               propertieService.query().then(function(response) {
                    if (!response || response.data.length == 0)
                         cadastroPropriedadeConfirm();
                    vm.propriedade = response.data;
               });

               getDash();
               vm.avaliacaoFiltro = agendaVisitasService.getAvaliacao();
          }

          function getDash() {
               vm.args.loading = true;
               agendaVisitasService.getDash().then(function (response) {
                    vm.dash = response;
                    vm.filtros = response.filtros;
               }).finally(function () {
                   vm.args.loading = false;
               });
          }

          function change() {
               vm.args.loading = true;
               agendaVisitasService.getListDash(vm.args).then(function (response) {
                    console.log(response);
                    vm.models = response.visita_list;
                    vm.args.total_rows = response.total_itens;
                    showActiveFilters();
                    vm.args.updatePaggination();
               }).finally(function () {
                    vm.args.loading = false;
               });
          }

          function resetFilters() {
               // IMPORTANTE limpar individualmente p/ não bugar a paginação!
               vm.args.Consultor = null;
               vm.args.Status = null;
               vm.args.Avaliacao = null;
               vm.args.DataInicio = null;
               vm.args.DataFim = null;
               change();
          }

          function gotoAvaliar(id) {
               $state.go('app.agenda_visitas.avaliar', {
                   id: id
               });
          }

          function gotoVisualizar(id) {
               $state.go('app.agenda_visitas.visualizar', {
                   id: id
               });
          }

          function estornarConfirm(model) {
               var confirm = $mdDialog.confirm()
                   .title('Estorno de avaliação')
                   .textContent('Você deseja estornar essa avaliação?')
                   .targetEvent(model)
                   .ok('Sim')
                   .cancel('Não');
               $mdDialog.show(confirm)
                    .then(function () {
                         estornar(model);
                    }, function () {
                         return null
                    });
          };
          function estornar(model) {
               agendaVisitasService.estornarAvaliacao(model.id)
                   .then(function (response) {
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent('Estorno realizado com sucesso!')
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                         change();
                   }).catch(function (response) {
                       // TODO mensagem de erro
                   });
          }

          function openModalCancelamento(id){
               $mdDialog.show({
                    locals:{dataToPass: id},
                    controller: mdDialogCtrl,
                    templateUrl: 'app/main/agenda_visitas/views/modal_cancelamento.html',
                    parent: angular.element(document.body),
                    clickOutsideToClose: true,
                    fullscreen: false
               })
          }
          function mdDialogCtrl($scope, $mdDialog, dataToPass) {
               $scope.motivo = '';
               $scope.loading = true;
               $scope.hide = function () {
                    $mdDialog.hide();
               };
               $scope.save = function () {
                    const model = {
                         id: dataToPass,
                         motivo: $scope.motivo
                    };
                    $mdDialog.hide();
                    cancelamento(model);
               };
          }
          function cancelamento(model){
               agendaVisitasService.cancelamento(model)
                    .then(function (response) {
                         change();
                         $mdToast.show(
                              $mdToast.simple()
                                   .textContent('Cancelamento realizado com sucesso!')
                                   .position('top right')
                                   .theme("success-toast")
                                   .hideDelay(6000)
                         );
                    }).catch(function (response) {
                         //console.log('erro cancelamento');
                    });
          }

          function showActiveFilters(){
               vm.activeFilters = null;
               let arr = null;
               let inicio = $filter('date')(vm.args.DataInicio,'dd/MM/yyyy');
               let fim = $filter('date')(vm.args.DataFim,'dd/MM/yyyy');
               let counter = 0;
               arr = [
                    {
                         description: vm.args.Consultor,
                         value: 'Consultor'
                    },
                    {
                         description: vm.args.Avaliacao,
                         value: 'Avaliacao'
                    },
                    {
                         description: vm.args.Status,
                         value: 'Status'
                    },
                    {
                         description: inicio,
                         value: 'DataInicio'
                    },
                    {
                         description: fim,
                         value: 'DataFim'
                    }
               ];

               for (let i = 0; i < arr.length; i++) {
                    if (arr[i].description != null) counter++;
               }

               if(counter > 0){
                    vm.activeFilters = arr;
               }
             }

             function desableFilter(value){
               vm.args[value] = null;
               change();
             }

          function gotoCadastroPropriedade() {
               $state.go('app.registro.propriedade.criar');
          }
          function cadastroPropriedadeConfirm() {
               var confirm = $mdDialog.confirm()
                    .title('Propriedade não encontrada')
                    .textContent('Não foi encontrado uma propriedade. Deseja cadastrar uma nova propriedade?')
                    .ok('Sim, quero cadastrar!')
                    .cancel('Não quero!');
               $mdDialog.show(confirm)
                    .then(function () {
                         gotoCadastroPropriedade();
                    }, function () {
                         return null
                    });
          }

     }
})();

(function () {
    'use strict';

    angular
        .module('app.previsao_colheita')
        .controller('AvaliarVisitaController', AvaliarVisitaController)

    /** @ngInject */
    function AvaliarVisitaController(model, agendaVisitasService, $rootScope, $state, $mdToast) {
        var vm = this;
        // Data
        vm.model = model;
        vm.api_response_erro = {};

        // Metodos
        vm.save = save;
        vm.gotoDash = gotoDash;
        //////////

        init();

        function init() {
        }

        function save(form) {

            if (form.$invalid) {
                return;
            }
            console.log('model', vm.model);
            //return

            agendaVisitasService
                .update(vm.model)
                .then(function (response) {

                    $rootScope.loadingProgress = false;

                    if (response == undefined) {
                        vm.api_response_erro = response;
                        console.log(response);
                        return;
                    }

                    $mdToast.show(
                        $mdToast.simple()
                            .textContent('Avaliação  realizada com sucesso!')
                            .position('top right')
                            .theme("success-toast")
                            .hideDelay(6000)
                    );

                    gotoDash();

                }).catch(function (response) {
                    $rootScope.loadingProgress = false;
                    vm.api_response_erro = response;
                    console.log(response);
                });
        }

          function gotoDash(){
               $state.go('app.agenda_visitas.dash');
          }
    }

})();

(function () {
     'use strict';

     angular
          .module('app.account', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider) {
          // State
          $stateProvider
               .state('app.account', {
                    abstract: true,
                    url: '/account'
               })
               .state('app.account.callback', {
                    url: '/callback',
                    views: {
                         'main@': {
                              templateUrl: 'app/core/layouts/content-only.html',
                              controller: 'MainController as vm'
                         },
                         'content@app.account.callback': {
                              templateUrl: 'app/main/account/views/callback.html',
                              controller: 'CallbackController  as vm',
                              resolve: {
                                   baseUrl: function (msApi) {
                                        return msApi.getBaseUrl();
                                   }
                              }
                         }
                    },
                    bodyClass: 'callback'
               })
               .state('app.account.logout', {
                    url: '/logoutcallback',
                    views: {
                         'main@': {
                              templateUrl: 'app/core/layouts/content-only.html',
                              controller: 'LogoutcallbackController as vm'
                         }
                    }
               })
               .state('app.account.silent', {
                    url: '/silent',
                    views: {
                         'main@': {
                              controller: 'SilentController as vm'
                         }
                    }
               })
               .state('app.account.callbackconfirmemail', {
                    url: '/callbackconfirmemail',
                    views: {
                         'main@': {
                              templateUrl: 'app/core/layouts/content-only.html',
                              controller: 'MainController as vm'
                         },
                         'content@app.account.callbackconfirmemail': {
                              templateUrl: 'app/main/account/views/callbackconfirmemail.html',
                              controller: 'Callbackconfirmemail  as vm',
                              resolve: {
                                   baseUrl: function (msApi) {
                                        return msApi.getBaseUrl();
                                   }
                              }
                         }
                    },
                    bodyClass: 'callback'
               })







               .state('app.account.accessdenied', {
                    url: '/accessdenied',
                    views: {
                         'main@': {
                              templateUrl: 'app/core/layouts/content-only.html',
                              controller: 'MainController as vm'
                         },
                         'content@app.account.accessdenied': {
                              templateUrl: 'app/main/account/views/accessdenied.html',
                              controller: 'AccessdeniedController  as vm',
                              resolve: {
                                   baseUrl: function (msApi) {
                                        return msApi.getBaseUrl();
                                   }
                              }
                         }
                    },
                    bodyClass: 'callback'
               })









               .state('app.account.passwordlesslogin', {
                    url: '/passwordlesslogin',
                    views: {
                         'main@': {
                              templateUrl: 'app/core/layouts/content-only.html',
                              controller: 'MainController as vm'
                         },
                         'content@app.account.passwordlesslogin': {
                              templateUrl: 'app/main/account/views/passwordlesslogin.html',
                              controller: 'PasswordlessloginController as vm',
                              resolve: {
                                   baseUrl: function (msApi) {
                                        return msApi.getBaseUrl();
                                   }
                              }
                         }
                    },
                    bodyClass: 'callback'
               })
     }
})();
(function () {
  'use strict';

  angular
    .module('app.account')
    .controller('SilentController', CallbackController);

  /** @ngInject */
  function CallbackController($scope, $rootScope, $document, $filter, $state, plantioService, $mdToast, $mdDialog, principal) {
    var vm = this;

    var mgr = new Oidc.UserManager();
    mgr.signinSilentCallback();

  }
})();

(function() {
     'use strict';

     angular
          .module('app.account')
          .controller('PasswordlessloginController', PasswordlessloginController);

     /** @ngInject */
     function PasswordlessloginController($scope, $rootScope, $document, $filter, $state, plantioService, $mdToast, $mdDialog, principal) {
          var vm = this;

          principal.goToLogin();
     }
})();


// teste
(function () {
  'use strict';

  angular
    .module('app.account')
    .controller('LogoutcallbackController', LogoutcallbackController);

  /** @ngInject */
  function LogoutcallbackController(principal, $rootScope) {
    var vm = this;
    principal.signinSilentOrRedirectSignin().then(function () {
      $rootScope.state.go('app.home');
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.account')
    .controller('Callbackconfirmemail', Callbackconfirmemail);

  /** @ngInject */
  function Callbackconfirmemail($scope, $rootScope, $document, $filter, $state, plantioService, $mdToast, $mdDialog, principal) {
    var vm = this;

    console.log("Callbackconfirmemail");
    principal.goToLogin();

  }
})();


// teste

(function () {
     'use strict';

     angular
          .module('app.account')
          .controller('CallbackController', CallbackController);

     /** @ngInject */
     function CallbackController($scope, $rootScope, $document, $filter, $state, plantioService, $mdToast, $mdDialog, principal, api, authentication, $window) {
          new Oidc.UserManager().signinCallback().then(function (user) {
               console.log("signinCallback response success", user);
               $rootScope.state.go('app.home');
          }).catch(function (err) {
               console.error("signinCallback response error", err);
          });
     }
})();

(function () {
     'use strict';

     angular
          .module('app.account')
          .controller('AccessdeniedController', AccessdeniedController);

     /** @ngInject */
     function AccessdeniedController($state, principal) {
          var vm = this;
          vm.gotoLogout = gotoLogout;
          vm.gotoAccount = gotoAccount;

          function gotoLogout() {
               // Returns promise to remove from any storage the currently authenticated user an logof 
               principal.removeUser().then(function () {
                    principal.goToLogin();

               });

          }

          function gotoAccount() {
               // Envia parar o account para Adquirir assinatura
               window.location.href = getConfig().urlBaseAccountApplicationUI;
          }
     }
})();

(function () {
     'use strict';

     angular
          .module('app.core', [
               'ngAnimate',
               'ngAria',
               'ngCookies',
               'ngMessages',
               'ngResource',
               'ngSanitize',
               'ngMaterial',
               'pascalprecht.translate',
               'ui.router',
               'md.time.picker',
               'ui.mask',
               'currencyMask',
               'ui.utils.masks',
               'idf.br-filters',
               'ja.qr',
               'ngMask'
          ]);
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

          console.log("selectColor");

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('msApiMessage', msApiMessage);

  /** @ngInject */
  function msApiMessage($document) {
    return {
      restrict: 'E',
      scope: {
        formApi: '=formApi'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-api-message/ms-api-message.html'
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('lmWebapiDatatable', lmWebapiDatatable);

  /** @ngInject */
  function lmWebapiDatatable($document) {
    return {
      restrict: 'E',
      scope: {
        formApi: '=formApi'
      },
      transclude: true,
      templateUrl: 'app/core/directives/ms-api-message/ms-api-message.html'
    };
  }
})();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('lmtooltip', lmtooltip);

    /** @ngInject */
    function lmtooltip($document, api) {


        function link(scope, elem, attrs) {

            scope.Identifier = attrs.id;
            scope.close = close;

            function init() {
                if (!attrs.id)
                    throw new Error('Não foi encontrado o atributo "id" no componente lm-tooltip. ex: "<lm-tooltip id="identificador_do_lm-tooltip"></lm-tooltip>"');

                loadLocalStorageConfig();
            }

            init();

            function loadLocalStorageConfig() {
                var data = sessionStorage['lm-tooltip.config'];
                var config = angular.fromJson(data);
                if(config){
                    scope.isShow = config[scope.Identifier] == undefined;
                }
                else{
                    scope.isShow = true;
                }
            }

            function saveLocalStorageConfig(value) {
                var data = sessionStorage['lm-tooltip.config'];
                var config = angular.fromJson(data);
                if(!config){
                    config = {}
                }
                config[scope.Identifier] = value;

                sessionStorage['lm-tooltip.config'] = angular.toJson(config);
            }

            function close() {
                scope.isShow = false;
                saveLocalStorageConfig(true);
            }
        }

        // O identificador deve ser unico.
        // <lm-tooltip id="Identifier-lm-tooltip"> [[HTML_CONTENT]] </lm-tooltip>

        return {
            restrict: 'E',
            // require: 'id',
            link: link,
            scope: {
                id: '='
            },
            transclude: true,
            templateUrl: 'app/core/directives/lm-tooltip/lm-tooltip.directive.html'
        };
    }
})();
(function () {
  'use strict';
  angular
    .module('app.core').directive('lmSort', function () {
      return {
        restrict: 'A',
        scope: {
          args: '=lmArgs'
        },
        controller: function ($scope) {
          this.scope = $scope;
        }
      };
    });

  angular
    .module('app.core').directive('lmSortHeader', function () {
      return {
        restrict: 'A',
        require: '^lmSort',
        scope: {
          field: '@lmSortHeader',
          title: '@lmTitle'
        },
        transclude: true,
        templateUrl: 'app/core/directives/lm-sort/lm-sort-header.html',
        link: function (scope, element, attrs, containerController) {
          scope._sortBy = _sortBy;
          scope.args = containerController.scope.args;
          function _sortBy(col) {

            if (scope.args.sort_by == col) {

              scope.args.sort_order = scope.args.sort_order == 'asc' ? 'desc' : 'asc';

            } else {
              scope.args.sort_order = 'asc';
              scope.args.sort_by = col;
            }

            scope.args._change();

          }
        }
      };
    });
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .directive('lmPaginator', lmPaginator);

  /** @ngInject */
  function lmPaginator($document) {

    function link(scope, element, attrs) {

      scope.goToPage = goToPage;
      scope.changePerPage = changePerPage;

      // set default args
      if (scope.args == null) {
        scope.args = {};
      }

      if (scope.args._change == null) {
        scope.args._change = function () {
          console.error("change não configurado");
        };
      }

      scope.args.page = scope.args.page == null ? 1 : scope.args.page;
      scope.args.per_page = scope.args.per_page == null ? 5 : scope.args.per_page;
      scope.args.total_rows = scope.args.total_rows == null ? 0 : scope.args.total_rows;
      scope.args.page_sizes = scope.args.page_sizes == null ? [5, 10, 25, 100] : scope.args.page_sizes;

      scope.args.updatePaggination = refresh;
      refresh();

      function goToPage(inc) {

        scope.args.page += inc;
        refresh();
        scope.args._change();
      }

      function refresh() {

        if (scope.args.total_rows == 0 || scope.args.total_rows == "0") {
          scope.args.total_pages = 0;
          scope.args.from = 0;
          scope.args.to = 0;

        } else {

          scope.args.total_pages = Math.ceil(scope.args.total_rows / scope.args.per_page);
          scope.args.total_pages = scope.args.total_pages < 1 ? 1 : scope.args.total_pages;

          scope.args.page = scope.args.page > scope.args.total_pages ? scope.args.total_pages : scope.args.page;
          scope.args.from = (scope.args.page * scope.args.per_page) - scope.args.per_page + 1;

          scope.args.to = scope.args.from + scope.args.per_page;
          scope.args.to = scope.args.to > scope.args.total_rows ? scope.args.total_rows : scope.args.to;

        }

      }

      function changePerPage() {

        scope.args.page = 1;
        refresh();
        scope.args._change();
      }
    }
    return {
      restrict: 'E',
      link: link,
      scope: {
        args: '=lmArgs'
      },
      transclude: true,
      templateUrl: 'app/core/directives/lm-paginator/lm-paginator.html'
    };
  }
})();

'use strict';
/* Directives */
angular.module('app.core')
     .directive('pwCheck', [function() {
          return {
               require: 'ngModel',
               link: function(scope, elem, attrs, ctrl) {
                    var usuario_senha = '#' + attrs.pwCheck;
                    elem.add(usuario_senha).on('keyup', function() {
                         scope.$apply(function() {
                              // console.info(elem.val() === $(firstPassword).val());
                              ctrl.$setValidity('pwmatch', elem.val() === $(usuario_senha).val());
                         });
                    });
               }
          }
     }]);
// (function () {
//      'use strict';

//      angular.module('app.core')
//           .directive('lmEndereco', lmEndereco);

//      function lmEndereco(api) {
//           return {
//                restrict: 'AE',
//                require: 'ngModel',
//                scope: {
//                     ibge: '=ibge',
//                     estado: '=estado',
//                     cidade: '=cidade',
//                     bairro: '=bairro',
//                     endereco: '=endereco',
//                     loading: '=loading',


//                },
//                link: fnLink
//           };

//           function fnLink(scope, elm, attr, ngModel) {

//                ngModel.$asyncValidators.cepValid = function () {

//                     scope.ibge = "";
//                     scope.estado = "";
//                     scope.cidade = "";
//                     scope.bairro = "";
//                     scope.endereco = "";
//                     scope.loading = true;

//                     return api.Endereco.query({
//                               cep: ngModel.$viewValue
//                          }).$promise.then(function (response) {
//                               scope.loading = false;

//                               ngModel.$setValidity('invalido', response.data.length > 0);

//                               scope.ibge = response.data[0].cidadeCodigoIBGE;
//                               scope.estado = response.data[0].estado;
//                               scope.cidade = response.data[0].cidade;
//                               scope.bairro = response.data[0].bairro;
//                               scope.endereco = response.data[0].endereco;

//                          })
//                          .catch(function (erro) {
//                               scope.loading = false;
//                               ngModel.$setValidity('erroDesconhecido', true);
//                          });
//                };

//           }

//      }

//      lmEndereco.$inject = ['api'];

// })();

(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('chooseImageDescription', chooseImageDescription);

    /** @ngInject */
    function chooseImageDescription($document, api, $mdToast) {


        function link(scope, elem, attrs, ngModelCtrl, model) {

            scope.changed = false;
            scope.modelFiles = scope.ngModel;
            scope.ngImagesAdded = scope.ngImagesAdded;
            scope.MaxFiles = scope.ngMax;
            scope.Message = 'ddsdsd';
            scope.SizeMax = 700000; // 700000 - 700 Kb
            scope.updateDescricao = updateDescricao;

            // scope.status'
            // 1 - selecione um arquivo
            // 2 - Arquivo já selecionado
            // 3 - arquivo não enviado ao servidor
            // 4 - Enviado
            // 5 - download
            // 6 - Enviando...



            scope.status = 1;
            scope.error = '';

            if (scope.ngModel && scope.ngModel.file_name) {
                scope.cfile = scope.ngModel.file_name;
            } else {
                scope.cfile = "Não há arquivo";
            }

            var input = angular.element(elem[0].querySelector('input#fileInput'));
            elem.find('#uploadButton').bind('click', function () {
                input[0].click();
            });

            input.bind('change', function (e) {
                scope.$apply(function () {
                    var files = e.target.files;

                    if (files.length > 0) {

                        if (validarQuantidadeDeArquivos(files)) {
                            for (var i = 0; i < files.length; i++) {

                                if(files[i].size > scope.SizeMax) {
                                    showAlert("Não foi possível carregar a imagem '" + files[i].name + "'. O tamanho máximo permitido é " + scope.SizeMax / 1000 + "Kb.");
                                    continue;
                                }

                                scope.status = 3;
                                convertToImage(files[i]);
                            }

                            scope.cfileList = files;
                            updateView(null);
                        }
                    } else {
                        scope.cfile = null;
                    }
                });
            });

            function convertToImage(file) {

                var promise = new Promise(function (resolve, reject) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            resolve(loadEvent.target.result);
                        });
                    }
                    reader.readAsDataURL(file);
                });

                promise.then(function (data) {
                    scope.$apply(function () {
                        scope.modelFiles.push({
                            name: file.name,
                            obj: file,
                            filepreview: data
                        });

                        updateModel(scope.modelFiles);
                    });
                });
            }

            scope.fileRemove = function (file) {
                const index = scope.modelFiles.indexOf(file);
                scope.modelFiles.splice(index, 1);

                updateModel(scope.modelFiles);

                scope.changed = true;
            }

            scope.imageRemove = function (imagem) {

                const index = scope.ngImagesAdded.indexOf(imagem);
                scope.ngImagesAdded.splice(index, 1);

                scope.changed = true;
            }

            function updateView(value) {
                ngModelCtrl.$viewValue = value;
                ngModelCtrl.$render();
            }

            function updateModel(modelFiles) {

                var models = [];
                for (var index = 0; index < modelFiles.length; index++) {
                    var model = modelFiles[index];

                    if (model.uploaded_file_id)
                        models.push({
                            id: model.id,
                            url: model.url,
                            descricao: model.descricao,
                            uploaded_file_id: model.uploaded_file_id
                        });
                    else
                        models.push({
                            descricao: model.descricao,
                            file: model.obj
                        });
                }

                ngModelCtrl.$modelValue = models;
                scope.ngModel = models; // overwrites ngModel value
            }

            function updateDescricao(file, value) {

                file.descricao = value

                updateModel(scope.modelFiles);
            }

            function updateDescricao() {

                updateModel(scope.modelFiles);
            }

            function showAlert(message) {
                $mdToast.show(
                    $mdToast.simple()
                        .textContent(message)
                        .position('top right')
                        .theme("error-toast")
                        .hideDelay(3000)
                );
            }

            function validarQuantidadeDeArquivos(files) {

                if (!scope.modelFiles)
                    scope.modelFiles = [];

                var ngImagesAddedLength = 0;
                if (scope.ngImagesAdded != undefined)
                    ngImagesAddedLength = scope.ngImagesAdded.length;

                if (ngImagesAddedLength + files.length + scope.modelFiles.length > scope.MaxFiles) {
                    showAlert("É permitido o uso de no máximo " + scope.MaxFiles + " imagens.");
                    return false;
                }

                scope.changed = true;

                return true;
            }
        }

        return {
            restrict: 'E',
            require: 'ngModel',
            link: link,
            scope: {
                ngModel: '=',
                ngMax: '=',
                ngForm: '=',
                ngImagesAdded: '='
            },
            transclude: true,
            templateUrl: 'app/core/directives/lm-choose-image-description/lm-choose-image-description.directive.html'
        };
    }
})();
(function () {
     'use strict';

     angular
          .module('app.core')
          .directive('chooseFile', chooseFile);

     /** @ngInject */
     function chooseFile($document, api, $mdToast) {


          function link(scope, elem, attrs, ngModelCtrl, model) {

               scope.modelFiles = [];
               scope.MaxFiles = scope.ngMax;
               scope.Message = 'ddsdsd';
               scope.arquivos = [];

               // scope.status'
               // 1 - selecione um arquivo
               // 2 - Arquivo já selecionado
               // 3 - arquivo não enviado ao servidor
               // 4 - Enviado
               // 5 - download
               // 6 - Enviando...


               scope.getMessage = function () {


                    switch (scope.status) {
                         case 1:
                              return 'Selecione um arquivo';
                         case 2:
                              return 'Arquivo já selecionado';
                         case 3:
                              return 'Arquivo não enviado';
                         case 4:
                              return 'Enviado com sucesso !';
                         case 5:
                              return 'Download';
                         case 6:
                              return 'Enviando...';
                         default:
                              return '';
                    }
               }


               scope.status = 1;
               scope.error = '';

               if (scope.ngModel && scope.ngModel.file_name) {
                    scope.cfile = scope.ngModel.file_name;
               } else {
                    scope.cfile = "Não há arquivo";
               }

               var input = angular.element(elem[0].querySelector('input#fileInput'));
               elem.find('#uploadButton').bind('click', function () {
                    input[0].click();
               });

               elem.find('#postFileButton').bind('click', function () {

                    scope.status = 6;

                    api.Files.save(
                         {
                              uploadedFile: scope.arquivos
                         })
                         .$promise
                         .then(function (response) {
                              updateView(response);
                              updateModel(response);
                              $('.uri').val(response.uri);
                              scope.status = 4;
                         }).catch(function (errors) {

                              scope.status = 3;
                              updateView(null);
                              updateModel(null);
                              // TODO: Tratar erro
                              scope.error = 'Houve um erro ao tentar enviar arquivo';
                         });

               });
               elem.find('#downloadFileButton').bind('click', function () {
                    api.Files.get(ngModelCtrl.$modelValue)
                         .$promise
                         .then(function (result) {

                              const blob = new Blob([new Uint8Array(result.data)], { type: result.headers('Content-Type') });

                              if (window.navigator.msSaveOrOpenBlob) { // for IE

                                   //msSaveBlob only available for IE & Edge
                                   window.navigator.msSaveBlob(blob, ngModelCtrl.$modelValue.file_name);
                              } else {

                                   const URL = window.URL || window.MozURL || window.webkitURL || window.MSURL || window.OURL;

                                   var anchor = document.createElement('a');
                                   anchor.href = URL.createObjectURL(blob);
                                   anchor.download = ngModelCtrl.$modelValue.file_name;
                                   document.body.appendChild(anchor); //For FF
                                   anchor.target = '_blank';
                                   anchor.click();
                                   //It's better to remove the elem
                                   document.body.removeChild(anchor);
                              }


                         }).catch(function (errors) {
                              // TODO: erro
                         });
               });

               input.bind('change', function (e) {
                    scope.$apply(function () {
                         var files = e.target.files;

                         if (files.length > 0) {


                              if (validarQuantidadeDeArquivos(files)) {
                                   for (var i = 0; i < files.length; i++) {
                                        scope.status = 3;
                                        convertToImage(files[i]);
                                   }

                                   scope.arquivos.push.apply(scope.arquivos,files);
                                   
                                   updateModel(scope.arquivos);
                                   updateView(null);

                              }

                         } else {
                              scope.cfile = null;
                         }
                    });
               });

               function convertToImage(file) {

                    var promise = new Promise(function (resolve, reject) {
                         var reader = new FileReader();
                         reader.onload = function (loadEvent) {
                              scope.$apply(function () {
                                   resolve(loadEvent.target.result);
                              });
                         }
                         reader.readAsDataURL(file);
                    });

                    promise.then(function (data) {
                         scope.$apply(function () {
                              scope.modelFiles.push({
                                   name: file.name,
                                   obj: file,
                                   filepreview: data
                              });
                         });
                    });
               }

               scope.fileRemove = function (file) {
                    const index = scope.modelFiles.indexOf(file);
                    scope.modelFiles.splice(index, 1);
                    scope.arquivos.splice(index, 1);
                    updateModel(scope.arquivos);

                    scope.changed = true;
               }

               scope.imageRemove = function (imagem) {
                    
                    const index = scope.ngImagesAdded.indexOf(imagem);
                    scope.ngImagesAdded.splice(index, 1);
                    
                    scope.changed = true;
               }

               elem.find('.btn-remove-file').bind('click', function (teste) {
                    alert(teste);
               });

               elem.find('.btn-remove-file').bind('click', function () {

               });

               function updateView(value) {
                    ngModelCtrl.$viewValue = value;
                    ngModelCtrl.$render();
               }

               function updateModel(value) {
                    ngModelCtrl.$modelValue = value;
                    scope.ngModel = value; // overwrites ngModel value
               }

               function showAlert(message) {
                    $mdToast.show(
                         $mdToast.simple()
                              .textContent(message)
                              .position('top right')
                              .theme("error-toast")
                              .hideDelay(3000)
                    );
               }

               function validarQuantidadeDeArquivos(files) {

                    var ngImagesAddedLength = 0;
                    if (scope.ngImagesAdded != undefined)
                         ngImagesAddedLength = scope.ngImagesAdded.length;

                    if (ngImagesAddedLength + files.length + scope.modelFiles.length > scope.MaxFiles) {
                         showAlert("É permitido o uso de no máximo " + scope.MaxFiles + " imagens.");
                         return false;
                    }

                    scope.changed = true;
                    
                    return true;
               }
          }

          return {
               restrict: 'E',
               require: 'ngModel',
               link: link,
               scope: {
                    ngModel: '=',
                    ngMax: '=',
                    ngForm: '=?',
                    ngImagesAdded: '=',
                    changed: "=?"
               },
               transclude: true,
               templateUrl: 'app/core/directives/lm-choose-file/lm-choose-file.directive.html'
          };
     }
})();


(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('banner', banner);

    /** @ngInject */
    function banner($document, api) {


        function link(scope, elem, attrs) {

            scope.Identifier = attrs.id;
            scope.close = close;

            function init() {
                if (!attrs.id)
                    throw new Error('Não foi encontrado o atributo "id" no componente banner. ex: "<banner id="identificador_do_banner"></banner>"');

                loadLocalStorageConfig();
            }

            init();

            function loadLocalStorageConfig() {
                var data = sessionStorage['banner.config'];
                var config = angular.fromJson(data);
                if(config){
                    scope.isShow = config[scope.Identifier] == undefined;
                }
                else{
                    scope.isShow = true;
                }
            }

            function saveLocalStorageConfig(value) {
                var data = sessionStorage['banner.config'];
                var config = angular.fromJson(data);
                if(!config){
                    config = {}
                }
                config[scope.Identifier] = value;

                sessionStorage['banner.config'] = angular.toJson(config);
            }

            function close() {
                scope.isShow = false;
                saveLocalStorageConfig(true);
            }
        }

        // O identificador deve ser unico.
        // <banner id="Identifier-banner"> [[HTML_CONTENT]] </banner>

        return {
            restrict: 'E',
            // require: 'id',
            link: link,
            scope: {
                id: '='
            },
            transclude: true,
            templateUrl: 'app/core/directives/lm-banner/lm-banner.directive.html'
        };
    }
})();
(function () {
     'use strict';

     angular
          .module('app.core')
          .directive('areaSelector', areaSelector);

     /** @ngInject */
     function areaSelector($document, api) {

          function link(scope, elem, attrs, ngModelCtrl) {

               scope.changeState = changeState;
               scope.remover = remover;
               scope.ngTotalAreaProdutiva = 0;


               scope.areaSelected = [];

               function changeState(area) {
                    if (area.selected) {
                         scope.ngModel.push(area);
                         scope.ngTotalAreaProdutiva += area.area_produtiva;
                    } else {
                         remover(area);
                    }
               }

               function remover(area) {
                    area.selected = false;
                    var index = scope.ngModel.indexOf(area);
                    scope.ngModel.splice(index, 1);

                    if (scope.ngTotalAreaProdutiva)
                         scope.ngTotalAreaProdutiva -= area.area_produtiva;
               }

               function load() {
                    for (var indexModel = 0; indexModel < scope.ngModel.length; indexModel++) {
                         var model = scope.ngModel[indexModel];

                         for (var index = 0; index < scope.ngAreas.length; index++) {

                              if (model.id == scope.ngAreas[index].id){
                                   scope.ngAreas[index].selected = true;
                                   scope.ngTotalAreaProdutiva += scope.ngAreas[index].area_produtiva;
                              }
                         }
                    }
               }

               load();
          }

          return {
               restrict: 'E',
               require: 'ngModel',
               link: link,
               scope: {
                    ngModel: '=',
                    ngForm: '=',
                    ngAreas: '=',
                    ngTotalAreaProdutiva: '=?'
               },
               transclude: true,
               templateUrl: 'app/core/directives/lm-area-selector/lm-area-selector.directive.html'
          };
     }
})();

(function () {
  'use strict';

  angular.module('app.core')
    .directive('apiFormValidationSummary', apiFormValidationSummary);

  function apiFormValidationSummary() {

    return {
      restrict: 'A',
      link: postLink,
      templateUrl: 'app/core/directives/api-form/api-form-validation-summary.html'
    };

    function postLink(scope, element, attrs) {

      scope.form = scope[attrs.form];

      if (!scope.form || !scope.form.$api || !scope.form.$api.$errors) {
        scope.form.$api = {};
        scope.form.$api.$errors = [];
      }

    }

  }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .factory('ApiFormValidationService', ApiFormValidationService);

  function ApiFormValidationService() {
    return {
      applyErrors: applyErrors,
      applyError: applyError,
      reset: reset,
      setInvalid: setInvalid,
      setValid: setValid
    };



    function applyErrors(form, reason) {

      console.log("ApiFormValidationService: applyErrors");
      console.log(form);
      console.log(reason);

      form.$api.$errors = [];

      var data = reason;

      form.$api.$erro = {
        message: data.detail
      };


      if (!form.$api) {
        reset(form);
      }

      // no data returned, fallback to system error
      if (!data) {
        form.$api.$error['error'] = true;
        setInvalid(form);
        return;
      }
      else {

        // this is general error not connected to any field
        if (data.code) {
          form.$api.$error[data.code] = true;
          setInvalid(form);
        }

        var keys = Object.keys(data.errors);

        for (var i = 0; i < keys.length; i++) {



          for (var j = 0; j < data.errors[keys[i]].length; j++) {

            applyError(form, {
              field: keys[i],
              message: data.errors[keys[i]][j]



            });


          }
        }

        //angular.forEach(data.errors, applyError.bind(null, form));
      }
    }


    function applyError(form, error) {
      var code = error.code,
        field = error.field,
        message = error.message,
        api;

      if (!form.$api) {
        reset(form);
      }

      api = form.$api;


      // Se exite um field com essa chave add erro no form
      if (form[field]) {

        setApiValidator(form[field]);

        form[field].$registerApiError("api_erro");
        form[field].$api = {
          error: {
            message: message
          }
        };
      } else {
        // se não existe um input relacionado add erros na lista genérica
        form.$api.$errors.push(message);
      }
    }


    function reset(form) {
      form.$api = {
        $error: {},
        $invalid: false,
        $valid: true
      };
    }


    function setInvalid(form) {
      if (!form.$api) {
        reset(form);
      }

      form.$api.$invalid = true;
      form.$api.$valid = false;
    }


    function setValid(form) {
      if (!form.$api) {
        reset(form);
      }

      form.$api.$invalid = false;
      form.$api.$valid = true;
    }




    function setApiValidator(ngModel) {

      // storage for current API errors, to be removed once model changed
      var errors = [],
        model;


      model = ngModel;

      // expose interface to register API error for this field
      model.$registerApiError = registerApiError;

      // add validator to validation loop, that will remove current API errors
      model.$validators.apiValidate = apiValidator;


      function apiValidator() {

        // validation loop, remove all field api errors
        while (errors.length) {
          model.$setValidity(errors.shift(), true);
        }

        // this is fake validator, just return true
        return true;
      }


      function registerApiError(code) {
        errors.push(code);

        model.$setValidity(code, false);
      }


    }
  }

})();

(function () {
  'use strict';

  angular.module('app.core')
    .directive('apiForm', apiForm);

  // Mostra quais staus codes são considerados erro
  const STATUS_CODE_ERROR = [500, 422, 400];

  function apiForm(ApiFormValidationService) {
    return {
      require: 'form',
      restrict: 'A',
      link: postLink
    };



    function postLink(scope, element, attrs, formCtrl) {

      var watchPromise = attrs.apiForm || null;

      if (watchPromise !== void 0) {
        scope.$watch(watchPromise, formSubmitted.bind(null, formCtrl));
      }
    }


    function formSubmitted(form, apiResponseErro) {

      if (!apiResponseErro || !apiResponseErro.status || !STATUS_CODE_ERROR.includes(apiResponseErro.status)) {
        // Limpa os erros da tela
        ApiFormValidationService.reset(form);
      } else {

        ApiFormValidationService.applyErrors(form, apiResponseErro.data);

        // Seta os fields com erro para Touched
        angular.forEach(form.$error, function (field) {
          angular.forEach(field, function (errorField) {
            errorField.$setTouched();
          })
        });

      }
    }

  }

  apiForm.$inject = ['ApiFormValidationService'];

})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.principal', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
          // State
          $stateProvider.state('app.pages_auth_principal', {
               url: '/pages/auth/principal',
               views: {
                    'main@': {
                         templateUrl: 'app/core/layouts/content-only.html',
                         controller: 'MainController as vm'
                    },
                    'content@app.pages_auth_principal': {
                         templateUrl: 'app/main/principal/principal.html',
                         controller: 'PrincipalController as vm',
                         resolve: {
                              baseUrl: function(msApi) {
                                   return msApi.getBaseUrl();
                              }
                         }
                    }
               },
               bodyClass: 'principal'
          });

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/principal');

          //// Navigation
          //msNavigationServiceProvider.saveItem('pages.auth', {
          //     title: 'Authentication',
          //     icon: 'icon-lock',
          //     weight: 1
          //});

          //msNavigationServiceProvider.saveItem('pages.auth.principal', {
          //     title: 'Principal',
          //     state: 'app.pages_auth_principal',
          //     weight: 1
          //});
     }
})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.principal')
          .controller('PrincipalController', PrincipalController);

     /** @ngInject */
     function PrincipalController($state, principal, $resource) {
          var vm = this;

          vm.goToLogin = goToLogin;
          vm.gotoNovo = gotoNovo;
          function goToLogin() {

               principal.goToLogin();

               // principal.identity(true).then(function (user) {
               //   if (user === undefined || user === null || user === '') {
               //     // TODO: colocar uma mensagem de erro
               //   } else {
               //     $state.go('app.dashboard');
               //   }
               // });
          }


          function gotoNovo() {
               $state.go('app.pages_auth_criar_novo');

          }


     }
})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.novo', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider.state('app.pages_auth_novo', {
               url: '/pages/auth/novo',
               views: {
                    'main@': {
                         templateUrl: 'app/core/layouts/content-only.html',
                         controller: 'MainController as vm'
                    },
                    'content@app.pages_auth_novo': {
                         templateUrl: 'app/main/novo/novo.html',
                         controller: 'NovoController as vm',
                         resolve: {
                              model: function(novoService) {
                                   return novoService.getNew();
                              }
                         }
                    }
               },
               bodyClass: 'novo'
          })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/novo');

          //// Navigation
          //msNavigationServiceProvider.saveItem('pages.auth', {
          //     title: 'Authentication',
          //     icon: 'icon-lock',
          //     weight: 1
          //});

          //msNavigationServiceProvider.saveItem('pages.auth.novo', {
          //     title: 'Novo',
          //     state: 'app.pages_auth_novo'
          //});
     }
})();
(function() {
     'use strict';

     angular
          .module('app.pages.auth.novo')
          .factory('novoService', novoService);

     /** @ngInject */
     function novoService($q, $mdToast, $filter, api) {

          var clientes = [];
          var status = [];
          var type = [];
          var models = [];
          var queryResponse = {};
          var queryArgs = {};
          var modelNew = {};

          var service = {
               getNew: getNew,
               create: create,
               getCity: getCity
          };

          return service;

          //////////

          function getNew() {
               return {};
          }

          ////// CADASTRAR - CLIENTE ////// 
          function create(model) {

               var deferred = $q.defer();

               api.Cliente.save(model).$promise.then(

                    // SUCCESS
                    function(response) {
                         deferred.resolve(response);
                         clientes.unshift(model);
                         modelNew = {};
                    }).catch(
                    function(response) {
                         //   Resolve the promise
                         deferred.reject(response);
                    }
               );
               return deferred.promise;
          }
          ////// CADASTRAR - CLIENTE ////// 


          ////// CONSULTA DE CIDADE ////// 
          function getCity(query) {

               var deferred = $q.defer();

               api.Cidade.query({
                    query: query
               }).$promise.then(
                    function(response) {

                         var enderecos = [];

                         for (var i = 0; i < response.data.length; i++) {
                              enderecos.push({
                                   cep: "",
                                   endereco: "",
                                   cidade_nome: response.data[i].nome,
                                   uf: response.data[i].estado,
                                   numero: "",
                                   complemento: ""
                              });

                         }

                         deferred.resolve(enderecos);
                    }

               ).catch(function(response) {
                    deferred.reject(response);
                    console.log(response);
               });
               return deferred.promise;
          }
          ////// CONSULTA DE CIDADE ////// 
     }

})();
(function() {
     'use strict';

     angular
          .module('app.pages.auth.novo')
          .controller('NovoController', NovoController)
          .controller('TermosController', TermosController);

     /** @ngInject */
     function NovoController($rootScope, $state, $filter, model, novoService, $mdToast, $mdDialog, principal) {
          var vm = this;
          vm.isDisabled = false;
          vm.checked = false;
          vm.model = model;
          vm.citySearch = citySearch
          vm.save = save
          vm.gotoPagamento = gotoPagamento;
          vm.setPlano = setPlano;
          vm.refreshPerfil = refreshPerfil;
          vm.disableClick = disableClick;
          vm.api_response_erro = {};
          vm.isChecked = true;
          vm.processando = false;
          vm.ShowDialogTermos = ShowDialogTermos;
          //////////

          init();

          function init() {

               vm.model.pessoa_tipo = {
                    id: '1'
               }

               vm.params = {};
               vm.showPassword = false;
               vm.toggleShowPassword = function() {
                    vm.showPassword = !vm.showPassword;
               }

               vm.toggleShowconfirmPassword = function() {
                    vm.showconfirmPassword = !vm.showconfirmPassword;
               }
          }


          function refreshPerfil(model, produtor, comprador) {

               model.cliente_perfis = [];
               if (produtor) {
                    model.cliente_perfis.push({
                         id: 1
                    });
               }

               if (comprador) {
                    model.cliente_perfis.push({
                         id: 2
                    });
               }
          }

          function disableClick() {
               // alert('teste')
               vm.isDisabled = true;
               return false;
          }

          function setPlano(plano) {
               vm.model.cliente_plano_pagamento = plano;
          }

          function gotoPagamento() {
               $state.go('app.pages_auth_pagamento');
          }


          function save(form) {

               if (form.$invalid) {
                    return;
               }

               var message = '';
               if (vm.model.id > 0) {
                    var message = $filter('translate')('NOVO.REGISTER_ALTERED');
                    this.savePromise = novoService.update(vm.model);
               } else {
                    var message = $filter('translate')('NOVO.REGISTER_CREATED');
                    this.savePromise = novoService.create(vm.model);
               }

               vm.processando = true;
               this.savePromise.then(function(response) {
                    vm.model.id = response.id;

                    // Redireciona para para o login
                    if (!vm.model.IdentityServerToken) {
                         principal.goToConfirmEmail(response.cliente_usuario_sub, response.identity_server_token);
                    } else {
                         vm.processando = false;
                    }

               }).catch(function(response) {

                    vm.api_response_erro = response;
                    vm.processando = false;

               });
          }

          function ShowDialogTermos(ev) {

               $mdDialog.show({
                         controller: 'TermosController as vm',
                         templateUrl: 'app/main/novo/termos-uso.tmpl.html',
                         parent: angular.element(document.body),
                         targetEvent: ev,
                         clickOutsideToClose: true,
                         fullscreen: true // Only for -xs, -sm breakpoints.
                    })
                    .then(function() {
                         return null;
                    }, function() {
                         return null;
                    });

          }

          function citySearch(query) {
               var retorno = novoService.getCity(query);
               console.log(retorno);
               return retorno;
          }

     }

     function TermosController($mdDialog) {
          var vm = this;
          vm.close = close;

          function close() {
               $mdDialog.hide();
          };
     }
})();
(function() {
     'use strict';

     angular
          .module('app.pages.auth.confirmar', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
          // State
          $stateProvider.state('app.pages_auth_confirmar', {
               url: '/pages/auth/confirmar',
               views: {
                    'main@': {
                         templateUrl: 'app/core/layouts/content-only.html',
                         controller: 'MainController as vm'
                    },
                    'content@app.pages_auth_confirmar': {
                         templateUrl: 'app/main/confirmar/confirmar.html',
                         controller: 'ConfirmarController as vm',
                         resolve: {

                         }
                    }
               },
               bodyClass: 'pagamento'
          })

          // Translation
          $translatePartialLoaderProvider.addPart('app/main/confirmar');

          //// Navigation
          //msNavigationServiceProvider.saveItem('pages.auth', {
          //     title: 'Authentication',
          //     icon: 'icon-lock',
          //     weight: 1
          //});

          //msNavigationServiceProvider.saveItem('pages.auth.confirmar', {
          //     title: 'Confirmar',
          //     state: 'app.pages_auth_confirmar'
          //});
     }
})();

(function() {
     'use strict';

     angular
          .module('app.pages.auth.confirmar')
          .factory('confirmarService', confirmarService);

     /** @ngInject */
     function confirmarService() {

          var modelNew = {};

          var service = {};

          return service;

          //////////

     }

})();
(function() {
     'use strict';

     angular
          .module('app.pages.auth.confirmar')
          .controller('ConfirmarController', ConfirmarController);

     /** @ngInject */
     function ConfirmarController() {

          //////////

          init();

          function init() {

          }

     }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function () {
     'use strict';

     var fuseThemes = {
          default: {
               primary: {
                    name: 'fuse-paleblue',
                    hues: {
                         'default': '700',
                         'hue-1': '500',
                         'hue-2': '600',
                         'hue-3': '400'
                    }
               },
               accent: {
                    name: 'light-blue',
                    hues: {
                         'default': '600',
                         'hue-1': '400',
                         'hue-2': '700',
                         'hue-3': 'A100'
                    }
               },
               warn: {
                    name: 'red'
               },
               background: {
                    name: 'grey',
                    hues: {
                         'default': 'A100',
                         'hue-1': 'A100',
                         'hue-2': '100',
                         'hue-3': '300'
                    }
               }
          },
          'pinkTheme': {
               primary: {
                    name: 'blue-grey',
                    hues: {
                         'default': '800',
                         'hue-1': '600',
                         'hue-2': '400',
                         'hue-3': 'A100'
                    }
               },
               accent: {
                    name: 'pink',
                    hues: {
                         'default': '400',
                         'hue-1': '300',
                         'hue-2': '600',
                         'hue-3': 'A100'
                    }
               },
               warn: {
                    name: 'blue'
               },
               background: {
                    name: 'grey',
                    hues: {
                         'default': 'A100',
                         'hue-1': 'A100',
                         'hue-2': '100',
                         'hue-3': '300'
                    }
               }
          },
          'tealTheme': {
               primary: {
                    name: 'fuse-blue',
                    hues: {
                         'default': '900',
                         'hue-1': '600',
                         'hue-2': '500',
                         'hue-3': 'A100'
                    }
               },
               accent: {
                    name: 'teal',
                    hues: {
                         'default': '500',
                         'hue-1': '400',
                         'hue-2': '600',
                         'hue-3': 'A100'
                    }
               },
               warn: {
                    name: 'deep-orange'
               },
               background: {
                    name: 'grey',
                    hues: {
                         'default': 'A100',
                         'hue-1': 'A100',
                         'hue-2': '100',
                         'hue-3': '300'
                    }
               }
          },
          'logicalTheme': {
               primary: {
                    name: 'eattae-primary',
                    hues: {
                         'default': '500'
                    }
               },
               accent: {
                    name: 'eattae-secondary',
                    hues: {
                         'default': '500'
                    }
               },
               warn: {
                    name: 'deep-orange'
               },
               background: {
                    name: 'grey',
                    hues: {
                         'default': 'A100',
                         'hue-1': 'A100',
                         'hue-2': '100',
                         'hue-3': '300'
                    }
               }
          },
          // 'logicalTheme': {
          //      primary: {
          //           name: 'compartveg',
          //           hues: {
          //                'default': '500'
          //           }
          //      },
          //      accent: {
          //           name: 'compartveg-secundary',
          //           hues: {
          //                'default': '500'
          //           }
          //      },
          //      warn: {
          //           name: 'deep-orange'
          //      },
          //      background: {
          //           name: 'grey',
          //           hues: {
          //                'default': 'A100',
          //                'hue-1': 'A100',
          //                'hue-2': '100',
          //                'hue-3': '300'
          //           }
          //      }
          // }
     };

     angular
          .module('app.core')
          .constant('fuseThemes', fuseThemes);
})();

(function() {
     'use strict';

     var fusePalettes = [{
               name: 'fuse-blue',
               options: {
                    '50': '#ebf1fa',
                    '100': '#c2d4ef',
                    '200': '#9ab8e5',
                    '300': '#78a0dc',
                    '400': '#5688d3',
                    '500': '#3470ca',
                    '600': '#2e62b1',
                    '700': '#275498',
                    '800': '#21467e',
                    '900': '#1a3865',
                    'A100': '#c2d4ef',
                    'A200': '#9ab8e5',
                    'A400': '#5688d3',
                    'A700': '#275498',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
               }
          },
          {
               name: 'fuse-paleblue',
               options: {
                    '50': '#ececee',
                    '100': '#c5c6cb',
                    '200': '#9ea1a9',
                    '300': '#7d818c',
                    '400': '#5c616f',
                    '500': '#3c4252',
                    '600': '#353a48',
                    '700': '#2d323e',
                    '800': '#262933',
                    '900': '#1e2129',
                    'A100': '#c5c6cb',
                    'A200': '#9ea1a9',
                    'A400': '#5c616f',
                    'A700': '#2d323e',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
               }
          },
          {
               name: 'compartveg',
               options: {
                    '50': '#ececee',
                    '100': '#c5c6cb',
                    '200': '#9ea1a9',
                    '300': '#7d818c',
                    '400': '#5c616f',
                    '500': '#556B2F',
                    '600': '#353a48',
                    '700': '#2d323e',
                    '800': '#262933',
                    '900': '#1e2129',
                    'A100': '#c5c6cb',
                    'A200': '#9ea1a9',
                    'A400': '#5c616f',
                    'A700': '#2d323e',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
               }
          },
          {
               name: 'compartveg-secundary',
               options: {
                    '50': '#ececee',
                    '100': '#c5c6cb',
                    '200': '#9ea1a9',
                    '300': '#7d818c',
                    '400': '#5c616f',
                    '500': '#9ACD32',
                    '600': '#353a48',
                    '700': '#2d323e',
                    '800': '#262933',
                    '900': '#1e2129',
                    'A100': '#c5c6cb',
                    'A200': '#9ea1a9',
                    'A400': '#5c616f',
                    'A700': '#2d323e',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
               }
          },
          {
               name: 'eattae-primary',
               options: {
                    '50': '#ececee',
                    '100': '#c5c6cb',
                    '200': '#9ea1a9',
                    '300': '#7d818c',
                    '400': '#5c616f',
                    '500': '#3A8229',
                    '600': '#353a48',
                    '700': '#2d323e',
                    '800': '#262933',
                    '900': '#1e2129',
                    'A100': '#c5c6cb',
                    'A200': '#9ea1a9',
                    'A400': '#5c616f',
                    'A700': '#2d323e',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
               }
          },
          {
               name: 'eattae-secondary',
               options: {
                    '50': '#ececee',
                    '100': '#c5c6cb',
                    '200': '#9ea1a9',
                    '300': '#7d818c',
                    '400': '#5c616f',
                    '500': '#5b952b',
                    '600': '#353a48',
                    '700': '#2d323e',
                    '800': '#262933',
                    '900': '#1e2129',
                    'A100': '#c5c6cb',
                    'A200': '#9ea1a9',
                    'A400': '#5c616f',
                    'A700': '#2d323e',
                    'contrastDefaultColor': 'light',
                    'contrastDarkColors': '50 100 200 A100',
                    'contrastStrongLightColors': '300 400'
               }
          }
     ];

     angular
          .module('app.core')
          .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MsThemeOptionsController', MsThemeOptionsController)
    .directive('msThemeOptions', msThemeOptions);

  /** @ngInject */
  function MsThemeOptionsController($cookies, fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    console.log("fuseTheming.themes");
    console.log(fuseTheming.themes);


    vm.layoutModes = [{
      label: 'Boxed',
      value: 'boxed'
    },
    {
      label: 'Wide',
      value: 'wide'
    }
    ];
    vm.layoutStyles = [{
      label: 'Vertical Navigation',
      value: 'verticalNavigation',
      figure: '/assets/images/theme-options/vertical-nav.jpg'
    },
    {
      label: 'Vertical Navigation with Fullwidth Toolbar',
      value: 'verticalNavigationFullwidthToolbar',
      figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
    },
    {
      label: 'Vertical Navigation with Fullwidth Toolbar 2',
      value: 'verticalNavigationFullwidthToolbar2',
      figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
    },
    {
      label: 'Horizontal Navigation',
      value: 'horizontalNavigation',
      figure: '/assets/images/theme-options/horizontal-nav.jpg'
    },
    {
      label: 'Content with Toolbar',
      value: 'contentWithToolbar',
      figure: '/assets/images/theme-options/content-with-toolbar.jpg'
    },
    {
      label: 'Content Only',
      value: 'contentOnly',
      figure: '/assets/images/theme-options/content-only.jpg'
    },
    {
      label: 'rafael',
      value: 'contentOnly22',
      figure: '/assets/images/theme-options/content-only.jpg'
    },
    ];

    vm.layoutMode = 'wide';
    vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    // Methods
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.updateLayoutMode = updateLayoutMode;
    vm.updateLayoutStyle = updateLayoutStyle;

    //////////

    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName) {
      fuseTheming.setActiveTheme(themeName);
    }

    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme() {
      return fuseTheming.themes.active;
    }

    /**
     * Update layout mode
     */
    function updateLayoutMode() {
      var bodyEl = angular.element('body');

      // Update class on body element
      bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
    }

    /**
     * Update layout style
     */
    function updateLayoutStyle() {
      // Update the cookie
      $cookies.put('layoutStyle', vm.layoutStyle);

      // Reload the page to apply the changes
      location.reload();
    }
  }

  /** @ngInject */
  function msThemeOptions($mdSidenav) {
    return {
      restrict: 'E',
      scope: {},
      controller: 'MsThemeOptionsController as vm',
      templateUrl: 'app/core/theme-options/theme-options.html',
      compile: function (tElement) {
        tElement.addClass('ms-theme-options');

        return function postLink(scope) {
          /**
           * Toggle options sidenav
           */
          function toggleOptionsSidenav() {
            // Toggle the fuse theme options panel
            $mdSidenav('fuse-theme-options').toggle();
          }

          // Expose the toggle function
          scope.toggleOptionsSidenav = toggleOptionsSidenav;
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.core')
    .factory('toastService', toastService);

  /** @ngInject */
  function toastService($mdToast) {

    var service = {
      message: '',
      serverError: serverError
    };
    return service;
    function serverError(errorMessage) {
      //The toastController gets an instance of toastService, so the error message is exposed
      //via the message property and the controller provides it to the toast.html view
      this.message = errorMessage;
      $mdToast.show(
        $mdToast.simple()
          .textContent(this.message)
          .position('top right')
          .theme("error-toast")
          .hideDelay(6000)
      );
    }


  }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function () {
  'use strict';

  angular
    .module('app.core')
    .provider('msApi', msApiProvider);

  /** @ngInject **/
  function msApiProvider() {
    /* ----------------- */
    /* Provider          */
    /* ----------------- */
    var provider = this;

    // Inject the $log service
    var $log = angular.injector(['ng']).get('$log');

    // Data
    var baseUrl = '';
    var api = [];

    // Methods
    provider.setBaseUrl = setBaseUrl;
    provider.getBaseUrl = getBaseUrl;
    provider.getApiObject = getApiObject;
    provider.register = register;

    //////////

    /**
     * Set base url for API endpoints
     *
     * @param url {string}
     */
    function setBaseUrl(url) {
      baseUrl = url;
    }

    /**
     * Return the base url
     *
     * @returns {string}
     */
    function getBaseUrl() {
      return baseUrl;
    }

    /**
     * Return the api object
     *
     * @returns {object}
     */
    function getApiObject() {
      return api;
    }

    /**
     * Register API endpoint
     *
     * @param key
     * @param resource
     */
    function register(key, resource) {
      if (!angular.isString(key)) {
        $log.error('"path" must be a string (eg. `dashboard.project`)');
        return;
      }

      if (!angular.isArray(resource)) {
        $log.error('"resource" must be an array and it must follow $resource definition');
        return;
      }

      // Store the API object
      api[key] = {
        url: resource[0] || '',
        paramDefaults: resource[1] || [],
        actions: resource[2] || [],
        options: resource[3] || {}
      };
    }

    /* ----------------- */
    /* Service           */
    /* ----------------- */
    this.$get = function ($log, $q, $resource, $rootScope, principal) {
      // Data

      // Methods
      var service = {
        setBaseUrl: setBaseUrl,
        getBaseUrl: getBaseUrl,
        register: register,
        resolve: resolve,
        request: request
      };

      return service;

      //////////

      /**
       * Resolve an API endpoint
       *
       * @param action {string}
       * @param parameters {object}
       * @returns {promise|boolean}
       */
      function resolve(action, parameters) {
        // Emit an event
        $rootScope.$broadcast('msApi::resolveStart');

        var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};

        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        }

        // Create a new deferred object
        var deferred = $q.defer();

        // Get the correct resource definition from api object
        var apiObject = api[resource];

        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        }
        else {
          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

          // Make the call...
          resourceObject[method](params,

            // Success
            function (response) {
              deferred.resolve(response);

              // Emit an event
              $rootScope.$broadcast('msApi::resolveSuccess');
            },

            // Error
            function (response) {
              deferred.reject(response);

              // Emit an event
              $rootScope.$broadcast('msApi::resolveError');
            }
          );
        }

        // Return the promise
        return deferred.promise;
      }

      /**
       * Make a request to an API endpoint
       *
       * @param action {string}
       * @param [parameters] {object}
       * @param [success] {function}
       * @param [error] {function}
       *
       * @returns {promise|boolean}
       */
      function request(action, parameters, success, error) {
        // Emit an event
        $rootScope.$broadcast('msApi::requestStart');

        var actionParts = action.split('@'),
          resource = actionParts[0],
          method = actionParts[1],
          params = parameters || {};

        if (!resource || !method) {
          $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
          return false;
        }

        // Create a new deferred object
        var deferred = $q.defer();

        // Get the correct resource definition from api object
        var apiObject = api[resource];

        if (!apiObject) {
          $log.error('Resource "' + resource + '" is not defined in the api service!');
          deferred.reject('Resource "' + resource + '" is not defined in the api service!');
        }
        else {

          // Prepara o token no Header
          var token = principal.getToken();
          if (token && apiObject.actions[method]) {

            if (!apiObject.actions[method].headers) {
              apiObject.actions[method].headers = [];
            }

            apiObject.actions[method].headers.Authorization = token;
          }


          // Generate the $resource object based on the stored API object
          var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);


          // Make the call...
          resourceObject[method](params,

            // SUCCESS
            function (response) {
              // Emit an event
              $rootScope.$broadcast('msApi::requestSuccess');

              // Resolve the promise
              deferred.resolve(response);

              // Call the success function if there is one
              if (angular.isDefined(success) && angular.isFunction(success)) {
                success(response);
              }
            },

            // ERROR
            function (response) {
              // Emit an event
              $rootScope.$broadcast('msApi::requestError');

              // Reject the promise
              deferred.reject(response);

              // Call the error function if there is one
              if (angular.isDefined(error) && angular.isFunction(error)) {
                error(response);
              }
            }
          );
        }

        // Return the promise
        return deferred.promise;
      }
    };
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
'use strict';
angular.module("ngLocale", [], ["$provide", function ($provide) {
  var PLURAL_CATEGORY = { ZERO: "zero", ONE: "one", TWO: "two", FEW: "few", MANY: "many", OTHER: "other" };
  $provide.value("$locale", {
    "DATETIME_FORMATS": {
      "AMPMS": [
        "AM",
        "PM"
      ],
      "DAY": [
        "domingo",
        "segunda-feira",
        "ter\u00e7a-feira",
        "quarta-feira",
        "quinta-feira",
        "sexta-feira",
        "s\u00e1bado"
      ],
      "ERANAMES": [
        "antes de Cristo",
        "depois de Cristo"
      ],
      "ERAS": [
        "a.C.",
        "d.C."
      ],
      "FIRSTDAYOFWEEK": 6,
      "MONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "SHORTDAY": [
        "dom",
        "seg",
        "ter",
        "qua",
        "qui",
        "sex",
        "s\u00e1b"
      ],
      "SHORTMONTH": [
        "jan",
        "fev",
        "mar",
        "abr",
        "mai",
        "jun",
        "jul",
        "ago",
        "set",
        "out",
        "nov",
        "dez"
      ],
      "STANDALONEMONTH": [
        "janeiro",
        "fevereiro",
        "mar\u00e7o",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "WEEKENDRANGE": [
        5,
        6
      ],
      "fullDate": "EEEE, d 'de' MMMM 'de' y",
      "longDate": "d 'de' MMMM 'de' y",
      "medium": "d 'de' MMM 'de' y HH:mm:ss",
      "mediumDate": "d 'de' MMM 'de' y",
      "mediumTime": "HH:mm:ss",
      "short": "dd/MM/y HH:mm",
      "shortDate": "dd/MM/y",
      "shortTime": "HH:mm"
    },
    "NUMBER_FORMATS": {
      "CURRENCY_SYM": "R$",
      "DECIMAL_SEP": ",",
      "GROUP_SEP": ".",
      "PATTERNS": [
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        },
        {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\u00a4",
          "negSuf": "",
          "posPre": "\u00a4",
          "posSuf": ""
        }
      ]
    },
    "id": "pt-br",
    "localeID": "pt_BR",
    "pluralCat": function (n, opt_precision) { var i = n | 0; if (i >= 0 && i <= 1) { return PLURAL_CATEGORY.ONE; } return PLURAL_CATEGORY.OTHER; }
  });
}]);

(function () {
    'use strict';

    angular
        .module('app.core')
        .filter('unidadeMedidaFormat', unidadeMedidaFormat);

    /** @ngInject */
    function unidadeMedidaFormat($filter) {

        return function (input, tipo_medida) {

            input = Math.abs(parseFloat(input))

               if (tipo_medida == undefined){
                    if(input){
                         return input;
                    }else{ return null }
               }

            switch (tipo_medida.id) {
                case 1: // Peso
                    if (input < 1000)
                        return $filter('number')(input, 3) + ' mg'

                    if (input < 1000000)
                        return $filter('number')(convertToDecimalCase((input / 1000), 4), 3) + ' g'

                    if (input < 1000000000)
                        return $filter('number')(convertToDecimalCase((input / 1000000), 4), 3) + ' kg'
                    else
                        return $filter('number')(convertToDecimalCase((input / 1000000000), 4), 3) + ' T'


                case 2: // Líquido

                    if (input < 1000)
                        return input + ' ml'
                    else {
                        var valor = convertToDecimalCase((input / 1000), 4);
                        return $filter('number')(convertToDecimalCase((input / 1000), 4), 3) + (valor == 1 ? ' Litro' : ' Litros')
                    }

                case 3: // Unidade

                    return input + ' unidades'

                default:
                    return input + '' + tipo_medida.nome;
            }
        };
    }

    function convertToDecimalCase(number, decimal) {
        var n = parseFloat(number);

        if (Number.isInteger(n)) {
            return n;
        }
        else {
            if (Number.isInteger(parseFloat(n.toFixed(decimal))))
                return parseInt(number);

            return parseFloat(n.toFixed(decimal));
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function() {
     'use strict';

     angular
          .module('app.core')
          .filter('brlCurrency', brlCurrency);

     /** @ngInject */
     function brlCurrency($filter) {
          return function(amount, symbol, precision) {
               symbol = symbol ? [symbol, ''].join(' ') : '';
               precision = precision ? precision : 2;
               amount = $filter('currency')(amount, symbol, precision);
               return amount
                    .replace(/\./g, 'DECIMAL')
                    .replace(/,/g, '.')
                    .replace(/DECIMAL/g, ',');
          };
     }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter)
        .filter('roundup', roundupFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

    /** @ngInject */
    function roundupFilter()
    {
        return function (value) {
            return Math.ceil(value);
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        // vm.msScrollOptions = {
        //     suppressScrollX: true
        // };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////
        vm.gotoAccount = gotoAccount;

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        function gotoAccount(){
          window.location.href = getConfig().urlBaseAccountApplicationUI;
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function () {
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, clientePerfilService, propertieService, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, $mdDialog, msNavigationService, principal) {
        var vm = this;



        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');

        vm.openMenuPropriedade = false;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;
        vm.login = login;
        vm.Solucoes = solucoes
        vm.gotoPropriedadeAdd = gotoPropriedadeAdd;
        vm.gotoHome = gotoHome;
        vm.gotoAlterarDados = gotoAlterarDados;
        vm.gotoConsultaPagamento = gotoConsultaPagamento;
        vm.gotoAlterarSenha = gotoAlterarSenha;

        vm.gotoComprador = gotoComprador;
        vm.gotoMeapresenta = gotoMeapresenta;
        vm.gotoCadernocampo = gotoCadernocampo;
        vm.gotoGerenciarlicenca = gotoGerenciarlicenca;
        vm.gotoCredenciados = gotoCredenciados;
        vm.gotoGestaoRede = gotoGestaoRede;

        vm.isAuthenticated = true;
        vm.isSolucoes = true;
        vm.btnGerenciarLicencaOnClick = btnGerenciarLicencaOnClick;
        vm.silentRefresh = silentRefresh;
        vm.modalAssinaturaVencida = modalAssinaturaVencida;
        vm.closeVencimentoModal = closeVencimentoModal;
        vm.openAviso = openAviso;
        vm.closeAviso = closeAviso;
        vm.isLessOrEqualDate = isLessOrEqualDate;
        vm.status_assinatura = 'status-active';
        vm.selectPropriedade = selectPropriedade;
        vm.togglePropriedade = togglePropriedade;

        vm.urlGerenciarlicenca = getConfig().urlGerenciarlicenca;

        init();

        /**
         * Initialize
         */
        function init() {

            vm.isDeveloperUser = false;
            vm.isSolucoes = true;
            vm.isAuthenticated = false;
            vm.username = "";
            vm.user = null;
            vm.nickname = "";
            vm.clientePerfil = {};
            vm.propriedade = null;
            vm.assinatura = null;
            vm.assinaturaVencida = null;
            vm.date15 = addDays(new Date(), 15);
            vm.date5 = addDays(new Date(), 5);

            principal.getUser().then(function (user) {
                //vm.razaosocial = user.cliente_informacoes_adicionais.rg;
                vm.username = user.profile.name;
                vm.nickname = user.profile.nickname;
                vm.isDeveloperUser = vm.username === "desenvolvedores";
                vm.isAuthenticated = true;
            });

            clientePerfilService.getAtivo().then(function (response) {
                vm.clientePerfil = response;
                console.log('CLIENTE DADOS', vm.clientePerfil);

               /*
                //  OCULTANDO MENU PARA CLIENTE S/ ESTOQUE "estoque_insumo.gestao"
                    Usando classe criada no estoque_insumo.module
               */
                if(!vm.clientePerfil.is_estoque_automatico){
                    var itemmenu = angular.element(document.querySelector('.menu-item-estoque-insumo'));
                    itemmenu.hide();
                }

            });

            propertieService.query().then(function (response) {
                if (response && response.data && response.data.length > 0)
                    vm.propriedade = response.data[0];
                    console.log('propriedade', response);
            });

            validarAssinatura();

            getPropriedades();
        }

        $rootScope.$on('toolBar', function() {
            propertieService.query().then(function (response) {
               vm.propriedade = response.data[0];
               console.log('up toollbar', vm.propriedade);
            });
            getPropriedades();
        });

        function openAviso() {
            let contentAviso = angular.element(document.querySelector('#content-aviso-assinatura'));
            contentAviso.addClass('actived');
        }
        function closeAviso() {
            let contentAviso = angular.element(document.querySelector('#content-aviso-assinatura'));
            contentAviso.removeClass('actived');
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId) {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status) {
            vm.userStatus = status;
        }

        function gotoPropriedadeAdd() {
            $state.go('app.registro.propriedade.criar');
            vm.openMenuPropriedade = false;
        }

        function gotoHome() {
            $state.go('app.home');
        }

        function gotoAlterarDados() {
            $state.go('app.registro.dados.alterar');
        }

        function gotoConsultaPagamento() {
            $state.go('app.registro.consulta.pagamento');
        }

        function gotoAlterarSenha() {
            principal.goToChangePassword();
        }

        /**
         * Logout Function
         */
        function logout() {
            principal.logout();
        }

        function login() {
            principal.goToLogin();
        }

        function solucoes() {
            principal.goToSolucoes();
        }

        function gotoComprador() {
            window.location.href = getConfig().urlComprador;
        }

        function gotoMeapresenta() {
            window.location.href = getConfig().urlMeApresenta;
        }

        function gotoCadernocampo() {
            window.location.href = getConfig().urlCadernocampo;
        }

        function gotoGerenciarlicenca() {
            window.location.href = getConfig().urlGerenciarlicenca;
        }

        function gotoCredenciados() {
          window.location.href = getConfig().urlCredenciados;
        }

        function btnGerenciarLicencaOnClick() {
            window.location.href = getConfig().urlBaseAccountApplicationUI;
        }

        function gotoGestaoRede() {
            window.location.href = getConfig().urlGestaoRede;
        }

        function silentRefresh() {
            principal.signinSilent();
        }

        function getPropriedades() {
            //vm.args.loading = true;
            propertieService.getLista().then(function(response) {
                vm.propriedades = response;
            }).finally(function() {
                //vm.args.loading = false;
            });
        }
        function selectPropriedade(id){
            //console.log(model);
            $rootScope.loadingProgress = true;
            propertieService.selectPropriedade(id)
                .then(function () {
                        init();
                        $rootScope.loadingProgress = false;
                        vm.openMenuPropriedade = false;
                        gotoHome();
                        $mdToast.show(
                            $mdToast.simple()
                                .textContent('Propriedade selecionada com sucesso')
                                .position('top right')
                                .theme("success-toast")
                                .hideDelay(6000)
                        );
                }).catch(function (response) {
                        $rootScope.loadingProgress = false;
                        console.log(response);
                });
        }
        function togglePropriedade(){
            vm.openMenuPropriedade = !vm.openMenuPropriedade;
        }

        /**
         * Change Language
         */
        function changeLanguage(lang) {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if (lang.code !== 'en') {
                var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';

                $mdToast.show({
                    template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position: 'top right',
                    parent: '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu() {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded() {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query) {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for (var x = 0; x < flatNavigation.length; x++) {
                if (flatNavigation[x].uisref) {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if (query) {
                navigation = navigation.filter(function (item) {
                    if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function () {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item) {
            // If item has a link
            if (item.uisref) {
                // If there are state params,
                // use them...
                if (item.stateParams) {
                    $state.go(item.state, item.stateParams);
                } else {
                    $state.go(item.state);
                }
            }
        }

        function validarAssinatura() {

            clientePerfilService.getAssinatura().then(function (response) {
                vm.assinatura = response;

                if (vm.assinatura) {
                    if (vm.assinatura.expira_automaticamente && vm.assinatura.data_final_periodo != undefined && isLessOrEqualDate(vm.assinatura.data_final_periodo, vm.date15)) {
                        vm.assinatura_vencida = vm.assinatura;
                        vm.assinatura_vencida.dias_ate_vencimento = new Date(vm.assinatura.data_final_periodo) - new Date();

                        if (isLessOrEqualDate(new Date(vm.assinatura.data_final_periodo), vm.date5)) {
                            vm.status_assinatura = 'status-danger';
                        }
                        else {
                            vm.status_assinatura = 'status-warning';
                        }

                        var data_vencimento = new Date(vm.assinatura.data_final_periodo);
                        let vencimento_caderno_storage = window.localStorage.getItem('vencimento_caderno-' + data_vencimento.getFullYear() + '-' + data_vencimento.getMonth() + '-' + data_vencimento.getDate());
                        if (!vencimento_caderno_storage)
                            modalAssinaturaVencida();
                    }else{
                        vm.status_assinatura = 'status-active'
                    }
                }
                else {
                    vm.status_assinatura = 'status-danger'
                }
            }).catch(function (response) {
                vm.status_assinatura = 'status-danger'
            });

        }

        function modalAssinaturaVencida() {
            $mdDialog.hide();

            $mdDialog.show({
                contentElement: '#DialogAssinaturaVencida',
                //templateUrl: 'app/main/vendas/venda/views/modal-passo-a-passo.html',
                parent: angular.element(document.body),
                clickOutsideToClose: false,
                fullscreen: false, // Only for -xs, -sm breakpoints.
                controller: 'ToolbarController as vm'
            });
        }

        function closeVencimentoModal() {
            $mdDialog.hide();
            if (vm.vencimento && vm.vencimento.check) {
                var data_vencimento = new Date(vm.assinatura.data_final_periodo);
                window.localStorage.setItem('vencimento_caderno-' + data_vencimento.getFullYear() + '-' + data_vencimento.getMonth() + '-' + data_vencimento.getDate(), JSON.stringify(vm.assinatura));
            }
        }

        function isLessOrEqualDate(date1, date2) {
            var dt1 = new Date(date1);
            var dt2 = new Date(date2);

            return new Date(dt1.getFullYear(), dt1.getMonth(), dt1.getDate()) <= new Date(dt2.getFullYear(), dt2.getMonth(), dt2.getDate());
        }

        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }



    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        //msApi.request('quickPanel.activities@get', {},
        //    // Success
        //    function (response)
        //    {
        //        vm.activities = response.data;
        //    }
        //);

        //msApi.request('quickPanel.events@get', {},
        //    // Success
        //    function (response)
        //    {
        //        vm.events = response.data;
        //    }
        //);

        //msApi.request('quickPanel.notes@get', {},
        //    // Success
        //    function (response)
        //    {
        //        vm.notes = response.data;
        //    }
        //);

        // Methods

        //////////
    }

})();

(function () {
     'use strict';

     /**
      * Main module of the Fuse
      */
     angular
          .module('fuse', [

               //Core
               'app.core',

               //app.authentication
               'app.authentication',

               // Navigation
               'app.navigation',

               // Toolbar
               'app.toolbar',

               // Quick Panel
               'app.quick-panel',

               //app.principal
               'app.pages.auth.principal',

               //app.novo
               'app.pages.auth.novo',

               //app.dados_cadastrais
               'app.pages.auth.dados_cadastrais',

               //app.dados_pagamento
               'app.pages.auth.dados_pagamento',

               //app.dados_convidado
               'app.pages.auth.dados_convidado',

               //app.confirmar
               'app.pages.auth.confirmar',

               // Registro
               'app.registro',

               // Manejo
               'app.manejo',

               //Custos
               'app.custos',

               //Despesas
               'app.despesas',

               //Estoque
               'app.estoque_insumo',

               //Estoque Insumo Biologico
               'app.estoque_insumo.biologico',

               //Estoque Insumo Defensivo
               'app.estoque_insumo.defensivo',

               //Estoque Insumo Fertilizante
               'app.estoque_insumo.fertilizante',

               //Estoque Semente
               'app.estoque_insumo.semente',

               //Estoque Insumo cadastro
               'app.estoque_insumo.cadastro_insumo',

               //Financeiro
               'app.financeiro',

               //Rastreamento
               'app.rastreamento',

               //Propriedade MENU
               'app.propriedademenu',

               //Propriedade
               'app.propriedade',

               //Fechamento custos
               'app.fechamento_custos',

               //Fechamento custos MENSAL
               'app.fechamento_custos.mensal',

               //DespesaTipo
               'app.cadastros.despesa_tipo',

               //DespesaNome
               'app.cadastros.despesa_nome',

               //DespesaFavorecido
               'app.cadastros.despesa_favorecido',

               //Area
               'app.area',

               //Plantio
               'app.plantio',

               //Insumo
               'app.insumo',

               //Insumo Defensivo
               'app.insumo.defensivo',

               //Insumo Biológico
               'app.insumo.biologico',

               //Insumo Fertilizante
               'app.insumo.fertilizante',

               //Insumo s/ estoque
               //'app.insumo_sem_estoque',

               //Insumo s/ estoque Defensivo
               //'app.insumo_sem_estoque.defensivo',

               //Colheita
               'app.colheita',

               //Lote Produção
               'app.lote_producao',

               //account
               'app.account',

               //home
               'app.home',

               //Passo a Passo
               'app.passo',

               //Suporte
               'app.suporte',

               //dashboard
               'app.dashboard',

               //Dados
               'app.dados',

               //Consulta Pagamento
               'app.consulta',

               //Relatórios
               'app.relatorios',

               //Relatórios - Insumos
               'app.relatorios.insumos',

               //Vendas
               'app.vendas',

               //Venda
               'app.vendas.venda',

               //Venda
               //'app.vendas.venda_novo',

               //Compras
               'app.compras',

               // //Comprados
               'app.compras.lotes_comprados',

               // //Vendidos
               'app.vendas.lotes_vendidos',

               // //Vendidos
               'app.vendas.lotes_cancelados',

               // //Externos
               'app.compras.lotes_externos',

               // //Distribuição
               'app.vendas.lotes_distribuicao',

               //Produtores//
               'app.produtores',

               //Consulta Produtores
               'app.produtores.consultar',

               //Cadastros//
               'app.cadastros',

               //Cliente //
               //'app.cadastros.cliente',

               //Distribuidor //
               'app.cadastros.distribuidor',

               //Fornecedor //
               'app.cadastros.fornecedor',

               //Profissional //
               'app.cadastros.profissional',

               //Máquina //
               'app.cadastros.maquina',

               // Cliente Perfil
               'app.cliente_perfil',

               // Certificados
               'app.certificados',

               // Assinatura
               'app.assinatura',

               // Previsão Colheita
               'app.previsao_colheita',

               // Agendamento de visitas
               'app.agenda_visitas',

               // Caldas
               'app.caldas',

               // Plano aplicação Caldas
               'app.plano_aplicacao',

               // Aplicações Caldas
               'app.aplicacoes'

          ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope) {

        // var vm = this;
        // vm.fn_showModalTutorial = fn_showModalTutorial;

        // Data

        //////////




        init();

        function init() {

            // setTimeout(function(){ 
            //     var hideModal  = localStorage.getItem('modalCurso');

            //     if(hideModal == "true"){
            //         return                   
            //        }
            //        fn_showModalTutorial();   
            // }, 5000);
        }

        // function fn_showModalTutorial(ev) {
        //      $mdDialog.show({
        //           controller: 'HomeController as vm',
        //           templateUrl: 'app/main/home/view/laudo_news.html',
        //           parent: angular.element(document.body),
        //           targetEvent: ev,
        //           clickOutsideToClose: true,
        //           fullscreen: true
        //      })
        // }

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        // msScrollConfigProvider.config({
        //     wheelPropagation: true
        // });

        /*eslint-enable */
    }
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .run(runBlock);

  /** @ngInject */
  function runBlock($rootScope, $timeout, $state, toastService, $location, $window) {
    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function () {
      $rootScope.loadingProgress = true;
    });

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
      $timeout(function () {
        $rootScope.loadingProgress = false;
      });
    });

    // var stateChangeLoadedEvent = $rootScope.$on('$viewContentLoaded', function (event) {
    //  $window.ga('send', 'pageview', {
    //      page: $location.$$absUrl
    //  });
    // });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function () {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
      // stateChangeLoadedEvent();
    });

    // Trata erros gerais de HTTP
    $rootScope.$on('httpError', function (event, eventData) {
      toastService.serverError(eventData.message);
    });






  }
})();

(function () {
     'use strict';

     angular
          .module('fuse')
          .config(routeConfig);

     /** @ngInject */
     function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
          $locationProvider.html5Mode(true);

          $urlRouterProvider.otherwise('/home');

          /**
           * Layout Style Switcher
           *
           * This code is here for demonstration purposes.
           * If you don't need to switch between the layout
           * styles like in the demo, you can set one manually by
           * typing the template urls into the `State definitions`
           * area and remove this code
           */
          // Inject $cookies
          var $cookies;

          angular.injector(['ngCookies']).invoke([
               '$cookies',
               function (_$cookies) {
                    $cookies = _$cookies;
               }
          ]);

          // Get active layout
          // Usado para layout dinamico
          //var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

          // Layout já setado
          var layoutStyle = 'verticalNavigation';


          var layouts = {
               verticalNavigation: {
                    main: 'app/core/layouts/vertical-navigation.html',
                    toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                    navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
               },
               verticalNavigationFullwidthToolbar: {
                    main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                    toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                    navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
               },
               verticalNavigationFullwidthToolbar2: {
                    main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                    toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                    navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
               },
               horizontalNavigation: {
                    main: 'app/core/layouts/horizontal-navigation.html',
                    toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                    navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
               },
               contentOnly: {
                    main: 'app/core/layouts/content-only.html',
                    toolbar: '',
                    navigation: ''
               },
               contentWithToolbar: {
                    main: 'app/core/layouts/content-with-toolbar.html',
                    toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                    navigation: ''
               }
          };
          // END - Layout Style Switcher

          // State definitions
          $stateProvider
               .state('app', {
                    abstract: true,
                    views: {
                         'main@': {
                              templateUrl: layouts[layoutStyle].main,
                              controller: 'MainController as vm',
                              resolve: {
                                   authorize: function (authorization) {
                                        //authorization.authorize("index.route");
                                   },
                                   user: function (principal) {
                                        // return principal.identity("MainController.resolve.user");
                                   }
                              }

                         },
                         'toolbar@app': {
                              templateUrl: layouts[layoutStyle].toolbar,
                              controller: 'ToolbarController as vm'
                         },
                         'navigation@app': {
                              templateUrl: layouts[layoutStyle].navigation,
                              controller: 'NavigationController as vm'
                         },
                         //'quickPanel@app': {
                         //  templateUrl: 'app/quick-panel/quick-panel.html',
                         //  controller: 'QuickPanelController as vm'
                         //}
                    }
               });
     }

})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming) {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;

    fuseTheming.setActiveTheme("logicalTheme");

    //console.log(fuseTheming.themes.active);
    
    //////////
  }
})();

(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function () {
     'use strict';

     angular
          .module('fuse')
          .config(config);

     /** @ngInject */
     function config($translateProvider, authenticationProvider, msApiProvider, $httpProvider) {
          // Put your common app configurations here

          // angular-translate configuration
          $translateProvider.useLoader('$translatePartialLoader', {
               urlTemplate: '{part}/i18n/{lang}.json'
          });
          $translateProvider.preferredLanguage('en');
          $translateProvider.useSanitizeValueStrategy(null);


          // Configura o Identity server para autenticação
          authenticationProvider.configure.setOidcConfig(getConfig().authentication);

          $httpProvider.interceptors.push('httpInterceptor');
     }

})();

(function () {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, principal) {
        var api = {};

        // Base Url
        api.baseUrl = getConfig().urlApi;
        api.baseUrl150 = getConfig().urlApiV150;
        api.urlAddressApi = getConfig().urlAddressApi;

        function isJSON(str) {
            try {
                return (JSON.parse(str) && !!str);
            } catch (e) {
                return false;
            }
        }

        function mountQueryReturn(data, headers) {

            var isAO = isJSON(data);

            if (isAO) {
                return {
                    data: angular.fromJson(data || '[]'),
                    total_rows: headers()['x-total-count'] || 0
                };
            } else {

                return {
                    data: [],
                    total_rows: 0
                };
            }
        }

        function FileTransformRequest(data) {
            if (data === undefined)
                return data;

            var fd = new FormData();
            angular.forEach(data, function (value, key) {

                if (value instanceof FileList || value instanceof Array) {

                    if (value.length == 1) {
                        fd.append(key, value[0]);
                    } else {
                        angular.forEach(value, function (file, index) {
                            // fd.append(key + '_' + index, file);
                            fd.append(key, file);
                        });
                    }
                } else {

                    if (value instanceof File) {
                        fd.append(key, value);

                    } else {

                        var json = JSON.stringify(value);

                        var blob = new Blob([json], {
                            type: 'application/json'
                        });
                        fd.append("document", blob);
                    }
                }
            });

            return fd;
        }



        /////////////////// Propriedade //////////////////
        api.PropriedadeAddPut = $resource(api.baseUrl150 + 'Propriedade/:id', {
               id: '@id'
          }, {
               get: {
                    headers: {},
                    method: 'GET'
               }
          });
        api.Propriedade = $resource(api.baseUrl150 + 'Propriedade/:id', {
            id: '@id'
        }, {
            update: {
                headers: {},
                method: 'PUT',
            },
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {},
                method: 'GET',
                isArray: true

            },
        });
        api.PropriedadeList = $resource(api.baseUrl150 + 'Propriedade/Propriedades', {
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {},
                method: 'GET',
                isArray: true
            },
        });
        api.PropriedadeSelect = $resource(api.baseUrl + 'Propriedade/TrocaPropriedade/:id', {
            id: '@id'
        }, {
            update: {
                headers: {},
                method: 'PUT',
            },
        });
        api.PropriedadeFile = $resource(api.baseUrl150 + 'Propriedade/Upload/:id', {
            id: '@id'
        }, {
            upload: {
                transformRequest: FileTransformRequest,

                headers: {
                    'Content-Type': undefined
                },
                method: 'POST',
            },
        });

        /////////////////// Propriedade //////////////////

        /////////////////// File //////////////////

        api.File = $resource(api.baseUrl + 'Files', {

        }, {
            upload: {
                transformRequest: FileTransformRequest,

                headers: {
                    'Content-Type': undefined
                },
                method: 'POST',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
        });

        api.Files = $resource(api.baseUrl + 'Files/Multiple', {

        }, {
            upload: {
                transformRequest: FileTransformRequest,

                headers: {
                    'Content-Type': undefined
                },
                method: 'POST',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
        });

        /////////////////// File //////////////////

        /////////////////// Endereco/ Cidade //////////////////
        api.Cidade = $resource(api.urlAddressApi + 'Cidade', {

        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });

        /////////////////// Areas Plantio //////////////////
        api.AreasPlantio = $resource(api.baseUrl150 + 'PropriedadeArea/FiltroPlantio', {

        }, {
            query: {
                headers: {},
                method: 'GET',

            },
            get: {
                headers: {},
                method: 'GET',
                isArray: true
            }
        });

        /////////////////// Endereco/ Cidade //////////////////
         api.AreaFiltro = $resource(api.baseUrl + 'PropriedadeArea/Filtro', {

         }, {
              query: {
                   headers: {


                   },
                   method: 'GET',
                   transformResponse: function (data, headers) {
                        return mountQueryReturn(data, headers);
                   }

              }
         });
        api.AreaList = $resource(api.baseUrl + 'PropriedadeArea/List', {

        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });
        api.PropriedadeAreaHistoricoList = $resource(api.baseUrl + 'PropriedadeArea/Historico', {

        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });
        api.PropriedadeAreaDash = $resource(api.baseUrl150 + 'PropriedadeArea/Indicadores', {}, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });
        api.PropriedadeAreaFiltros = $resource(api.baseUrl + 'PropriedadeArea/FiltroArea', {
        }, {
            get: {
                headers: {

                },
                method: 'GET'

            }
        });
        api.PropriedadeAreaCulturasVariedades = $resource(api.baseUrl150 + 'PropriedadeArea/FiltroCulturaAreas', {
        }, {
            get: {
                headers: {

                },
                method: 'GET'

            }
        });

        /////////////////// Area //////////////////

        ///// PROVISóRIO !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
        api.Area141 = $resource(api.baseUrl150 + 'PropriedadeArea/:id', {
               id: '@id'
          }, {
               update: {
               headers: {

               },
               method: 'PUT'
               },
               query: {
               headers: {


               },
               method: 'GET',
               transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
               }
               },
               save: {
               headers: {

               },
               method: 'POST',
               params: {
                    id: null
               }
               },
               get: {
               headers: {

               },
               method: 'GET'

               },
               delete: {
               headers: {

               },
               method: 'DELETE'
               }
          });

        api.Area = $resource(api.baseUrl150 + 'PropriedadeArea/:id', {
            id: '@id'
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });

          api.AreasCustos = $resource(api.baseUrl150 + 'PropriedadeArea/AreasAtivas', {
          query: {
               headers: {},
               method: 'GET',
               isArray: true
          },
          get: {
              headers: {},
              method: 'GET',
              isArray: true

          }
      });

        /////////////////// Variedades //////////////////////////////////
        api.Variedades = $resource(api.baseUrl + 'Variedade', {
        }, {
            update: {
                headers: {},
                method: 'PUT'
            },
            query: {
                headers: {},
                method: 'GET',
                isArray: true
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {},
                method: 'GET',
                isArray: true

            },
            delete: {
                headers: {},
                method: 'DELETE'
            }
        });

        /////////////////// CadernoCampo/EstornarEncerramento //////////////////


        api.CadernoCampoEstornarEncerramento = $resource(api.baseUrl + 'CadernoCampo/:id/EstornarEncerramento', {
            id: '@id'
        }, {
            estornar: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id'
                }
            },
        });


        /////////////////// CadernoCampo/Cancelados //////////////////

        api.CadernoCampoCancelados = $resource(api.baseUrl + 'CadernoCampo/Cancelados', {
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        /////////////////// Cultura //////////////////

        api.Cultura = $resource(api.baseUrl + 'Cultura', {

        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });

        api.CulturaVariedade = $resource(api.baseUrl + 'CulturaVariedade', {

        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });


        /////////////////// FILTROS NOVO //////////////////
          api.Filtros = $resource(api.baseUrl + 'LoteDistribuicaoVenda/Filtros', {
          }, {
               query: {
                    headers: {

                    },
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               }
          });


        /////////////////// Plantio LISTA //////////////////
        api.PlantioList = $resource(api.baseUrl150 + 'CadernoCampoPlantio/GetListagem', {}, {
            query: {
                headers: {},
                method: 'GET'
            }
          //   get: {
          //       headers: {

          //       },
          //       method: 'GET'

          //   }
        });
        /////////////////// Plantio POST / GET/id //////////////////
        api.Plantio = $resource(api.baseUrl150 + 'CadernoCampoPlantio/:id', {
          id: '@id'
          }, {
               update: {
                    headers: {

                    },
                    method: 'PUT'
               },
               save: {
                    headers: {

                    },
                    method: 'POST',
                    params: {
                         id: null
                    }
               },
               get: {
                    headers: {

                    },
                    method: 'GET'

               },
               delete: {
                    headers: {

                    },
                    method: 'DELETE'
               },
          });
          /////////////////// Filtros Plantio //////////////////
          api.filtrosPlantio = $resource(api.baseUrl150 + 'CadernoCampoPlantio/GetFiltros', {}, {
               query: {
                    headers: {},
                    method: 'GET'
               },
               get: {
                    headers: {},
                    method: 'GET'

               }
          });

        /////////////////// Assinaturas //////////////////

        api.Assinatura = $resource(api.baseUrl + 'Assinatura/:id', {
            id: '@id'
        }, {
            update: {
                headers: {},
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
        });


        /////////////////// Remover assinaturas //////////////////

        api.RemoverAssinatura = $resource(api.baseUrl + 'Assinatura/:id/RemoverAssinatura', {
            id: '@id'
        }, {
            remover: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id'
                }
            },
        });

        /////////////////// BOLETO //////////////////

        api.Boleto = $resource(api.baseUrl + 'Pagamento/Boleto', {
            id: '@id'
        }, {
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
        });

        /////////////////// CUPOM //////////////////

        api.Cupom = $resource(api.baseUrl + 'Pagamento/Cupom', {
            id: '@id'
        }, {
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
        });

        // CONVITE ASSINATURA   //
        api.ConviteAssinatura = $resource(api.baseUrl + 'Assinatura/:id/Convite', {
            id: '@id'
        }, {
            convite: {
                headers: {

                },
                method: 'GET',
                params: {
                    id: '@id'
                }
            },
        });

        /////////////////// Assinaturas //////////////////

        api.Licencasdisponiveis = $resource(api.baseUrl + 'Assinatura/Licencasdisponiveis', {}, {
            query: {
                headers: {
                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        api.LicencasVinculadas = $resource(api.baseUrl + 'Assinatura/LicencasVinculadas', {}, {
            query: {
                headers: {
                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        api.LicencasBloqueadas = $resource(api.baseUrl + 'Assinatura/LicencasBloqueadas', {}, {
            query: {
                headers: {
                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        api.BoletosValidos = $resource(api.baseUrl + 'Assinatura/BoletosValidos', {}, {
            query: {
                headers: {
                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        api.AssinaturaNaoVinculadas = $resource(api.baseUrl + 'Assinatura/AssinaturaNaoVinculadas', {}, {
            query: {
                headers: {
                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        api.VincularAssinatura = $resource(api.baseUrl + 'Assinatura/VincularAssinatura', {}, {
            id: '@id'
        }, {
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
        });

        /////////////////// PropriedadeArea //////////////////

        api.PropriedadeArea = $resource(api.baseUrl + 'PropriedadeArea/:id', {
            id: '@id'
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {


                },
                method: 'GET'
            }
        });

        /////////////////// PropriedadeArea FILTRO INSUMO (Áreas) //////////////////

          api.PropriedadeAreaFiltroInsumo = $resource(api.baseUrl150 + 'PropriedadeArea/FiltroInsumo', {}, {
               get: {
                    headers: {},
                    method: 'GET',
                    isArray: true
               }
          });

          /////////////////// Fechamento mensal DASH /////////////////////
          api.FechamentoCustosMensalDash = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/Dash', {}, {
               query: {
                   headers: {},
                   method: 'GET',
                   transformResponse: function (data, headers) {
                       return mountQueryReturn(data, headers);
                   }
               }
          });
          ////////////////// Fechamento mensal LISTA por ÁREA ///////////////////
          api.FechamentoCustosMensalListArea = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/Area', {}, {
               query: {
                   headers: {},
                   method: 'GET',
                   transformResponse: function (data, headers) {
                       return mountQueryReturn(data, headers);
                   }
               }
          });
          ////////////////// Fechamento mensal LISTA por ATIVIDADE ///////////////////
          api.FechamentoCustosMensalListAtividade = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/Atividade', {}, {
               query: {
                   headers: {},
                   method: 'GET',
                   transformResponse: function (data, headers) {
                       return mountQueryReturn(data, headers);
                   }
               }
          });
          ////////////////// FILTRO Fechamento mensal ÁREA ///////////////////
          api.FiltroFechamentoCustosMensalArea = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/FiltroArea', {}, {
               get: {
                    headers: {},
                    method: 'GET',
                    isArray: true
               }
          });
          ////////////////// FILTRO Fechamento mensal ATIVIDADE ///////////////////
          api.FiltroFechamentoCustosMensalAtividade = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/FiltroAtividade', {}, {
               get: {
                    headers: {},
                    method: 'GET',
                    isArray: true
               }
          });
          //////////////////// Excel Fechamento mensal por Área //
          api.ExcelFechamentoCustosMensalArea = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/ExcelArea', {}, {
               query: {
                    headers: {
                        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    },
                    method: 'GET',
                    responseType: 'arraybuffer',
                    cache: false,
                    transformResponse: function (data) {
                        return {
                            response: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                        };
                    }
                }
          });
          //////////////////// Excel Fechamento mensal por Atividade //
          api.ExcelFechamentoCustosMensalAtividade = $resource(api.baseUrl150 + 'PropriedadeFechamentoCustos/ExcelAtividade', {}, {
               query: {
                    headers: {
                        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    },
                    method: 'GET',
                    responseType: 'arraybuffer',
                    cache: false,
                    transformResponse: function (data) {
                        return {
                            response: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                        };
                    }
                }
          });

        /////////////////// Insumo //////////////////

        api.Insumo = $resource(api.baseUrl + 'CadernoCampoInsumoAgricola/:id', {
            id: '@id'
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
        });

        /////////////////// InsumoAgricola //////////////////

        api.InsumoAgrofit = $resource(api.baseUrl + 'InsumoAgricola', {}, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        /////////////////// Encerrar Caderno Campo //////////////////

        api.CadernoCampo = $resource(api.baseUrl150 + 'CadernoCampo/:id/:event', {
            id: '@id'
        }, {
            encerrar: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'Encerrar'
                }
            },
            encerrarCadernoCampoArea: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'EncerrarCadernoArea'
                }
            },
            EstornarCadernoArea: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'EstornarCadernoArea'
                }
            }
        });

        /////////////////// Colheita //////////////////
        api.ColheitaGet = $resource(api.baseUrl150 + 'CadernoCampoColheita/GetListagem', {}, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    //return mountQueryReturn(data, headers);
                    var isAO = isJSON(data);

                    if (isAO) {
                        return {
                            data: angular.fromJson(data || '[]'),
                            total_rows: headers()['x-total-count'] || 0
                        };
                    } else {

                        return {
                            data: [],
                            total_rows: 0
                        };
                    }
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
        });
        /////////////////// Colheita POST/GET:ID //////////////////
        api.Colheita = $resource(api.baseUrl150 + 'CadernoCampoColheita/:id', {
          id: '@id'
        }, {
               update: {
                    headers: {

                    },
                    method: 'PUT'
               },
               save: {
                    headers: {

                    },
                    method: 'POST',
                    params: {
                         id: null
                    }
               },
               get: {
                    headers: {

                    },
                    method: 'GET'

               },
               delete: {
                    headers: {

                    },
                    method: 'DELETE'
               },
          });
        /////////////////// Filtros Colheita //////////////////
        api.filtrosColheita = $resource(api.baseUrl150 + 'CadernoCampoColheita/GetFiltros', {}, {
          query: {
               headers: {},
               method: 'GET'
           },
           get: {
               headers: {},
               method: 'GET'

           }
        });
        /////////////////// Filtros Colheita CADASTRO //////////////////
        api.filtrosColheitaAdd = $resource(api.baseUrl150 + 'PropriedadeArea/FiltroColheita', {}, {
          query: {
               headers: {},
               method: 'GET'
           },
          get: {
               headers: {},
               method: 'GET',
               isArray: true
          }
        });

        /////////////////// Cliente //////////////////

        api.Cliente = $resource(api.baseUrl + 'Cliente/:id', {
            id: '@id'
        }, {
            get: {
                headers: {

                },
                method: 'GET'
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        /////////////////// ClienteFornecedor //////////////////

        api.ClienteFornecedorGet = $resource(api.baseUrl + 'Cliente/ClienteFornecedor/:fornecedor_id', {
        }, {
            get: {
                headers: {

                },
                method: 'GET',
                params: {
                    fornecedor_id: '@fornecedor_id'
                }
            }
        });
        /////////////////// Dashboard //////////////////

        api.Dashboard = $resource(api.baseUrl + 'Dashboard', {
        }, {
            get: {
                headers: {

                },
                method: 'GET'
            }
        });



        /////////////////// Pagamento //////////////////

        api.Pagamento = $resource(api.baseUrl + 'Pagamento/:id', {
            id: '@id'
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            }
        });

        /////////////////// Cliente Convidado //////////////////

        api.ClienteConvidado = $resource(api.baseUrl + 'ClienteConvidado', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'
            }
        });

        // Cliente Cancelar

        api.CancelaConvite = $resource(api.baseUrl + 'ClienteConvidado/cancelar', {
            id: '@id'
        }, {
            cancela: {
                headers: {
                },
                method: 'POST',
                params: {
                    id: null
                }
            }
        });

        /////////////////// Lote //////////////////

        api.CadernoCampoColheitaLote = $resource(api.baseUrl + 'CadernoCampoColheitaLote/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'
            }
        });

        /////////////////// ClientePerfil //////////////////

        api.ClientePerfil = $resource(api.baseUrl + 'ClientePerfil/:event/:produtoId', {}, {

            // Obsoleto: Utilize o ClientePerfilAtivo
            // get: {
            //     headers: {

            //     },
            //     method: 'GET',
            //     params: {
            //         event: ''
            //     }
            // },
            getAtivo: {
                headers: {

                },
                method: 'GET',
                params: {
                    event: 'Ativo'
                }
            },
            getAssinatura: {
                headers: {

                },
                method: 'GET',
                params: {
                    event: 'Assinatura',
                    produtoId: '1'
                }
            },
        });



        /////////////////// LiberacaoConsulta //////////////////

        api.LiberacaoConsulta = $resource(api.baseUrl + 'LiberacaoConsulta/:id/:event', {
            id: '@id'
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            Inativar: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'Inativar'
                }
            },
        });

        api.ProdutoresLiberados = $resource(api.baseUrl + 'Cliente/ProdutoresLiberados/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            }
        });


        api.Lead = $resource(api.baseUrl + 'Lead/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            }
        });


        api.ClienteConsumidor = $resource(api.baseUrl + 'ClienteConsumidor/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            update: {
                headers: {

                },
                method: 'PUT'
            }
        });

        api.ClienteFornecedor = $resource(api.baseUrl + 'ClienteFornecedor/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            update: {
                headers: {

                },
                method: 'PUT'
            }
        });

        api.ClienteFornecedorPreCadastro = $resource(api.baseUrl + 'ClienteFornecedor/PreCadastro/:fornecedorCnpjCpf ', {

        }, {
            get: {
                headers: {

                },
                method: 'GET',
                params: {
                    fornecedorCnpjCpf: '@fornecedorCnpjCpf',
                }
            }
        });


        api.ClienteDistribuidor = $resource(api.baseUrl + 'ClienteDistribuidor/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            update: {
                headers: {

                },
                method: 'PUT'
            }
        });

        api.ClienteDistribuidorVendedor = $resource(api.baseUrl + 'ClienteDistribuidor/Vendedor/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            update: {
                headers: {

                },
                method: 'PUT'
            }
        });

        api.Endereco = $resource(api.urlAddressApi + 'Endereco', {}, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }

            }
        });

        /////////////////// LoteDistribuicaoVenda //////////////////

        api.LoteDistribuicaoVendaCancelar = $resource(api.baseUrl + 'LoteDistribuicaoVenda', {
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            }
        });

        /////////////////// LoteDistribuicaoVenda //////////////////

        api.LoteDistribuicaoVendaEstorno = $resource(api.baseUrl + 'LoteDistribuicaoVenda/Estornar', {
        }, {
            post: {
                headers: {

                },
                method: 'POST'
            }
        });

        /////////////////// LoteDistribuicaoVenda //////////////////

        api.LoteDistribuicaoVenda = $resource(api.baseUrl + 'LoteDistribuicaoVenda/:id', {
            id: '@id'
        }, {
            update: {
                headers: {

                },
                method: 'PUT'
            },
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            encerrar: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'Encerrar'
                }
            },
            estornarEncerramento: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'EstornarEncerramento'
                }
            },
        });


        /////////////////// LoteLaudo //////////////////

        api.LoteLaudoVenda = $resource(api.baseUrl + 'Laudo/Venda/:id', {
            id: '@id'
        }, {
            get: {
                headers: {

                },
                method: 'GET'

            }
        });


        /////////////////// LoteDistribuiçãoVendaComprados //////////////////
        api.LoteDistribuicaoVendaAlterarConsumidor = $resource(api.baseUrl + 'LoteDistribuicaoVenda/AlteraConsumidor', {
        }, {
            AlteraConsumidor: {
                headers: {

                },
                method: 'PUT'
            }
        });
        /////////////////// LoteDistribuiçãoVendaComprados //////////////////


        /////////////////// LoteDistribuiçãoVendaComprados //////////////////

        api.LoteDistribuicaoVendaCancelados = $resource(api.baseUrl + 'LoteDistribuicaoVenda/Cancelados', {
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
        });

        /////////////////// AtendimentoSuporte //////////////////

        api.AtendimentoSuporteEncerrar = $resource(api.baseUrl + 'AtendimentoSuporte/Encerrar', {
        }, {
            encerrar: {
                headers: {

                },
                method: 'PUT',
                params: {
                }
            },
        });


        api.AtendimentoSuporte = $resource(api.baseUrl + 'AtendimentoSuporte/:id/:event', {
            id: '@id'
        }, {
            query: {
                headers: {
                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                }
            },
            responderSuporte: {
                headers: {

                },
                method: 'POST',
                params: {
                    event: 'ResponderSuporte'
                }
            },
            encerrar: {
                headers: {

                },
                method: 'PUT',
                params: {
                    event: 'Encerrar'
                }
            },
            getId: {
                headers: {

                },
                method: 'GET',
                params: {
                    id: '@id'
                }
            },

            categoriaTipo: {
                headers: {

                },
                method: 'GET',
                params: {
                    event: 'CategoriaTipo'
                },
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
        });
        /////////////////// LoteDistribuiçãoVendaComprados/id //////////////////

        api.VendaCanceladaID = $resource(api.baseUrl + 'LoteDistribuicaoVenda/VendaCancelada/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        /////////////////// LoteDistribuiçãoVendaComprados //////////////////

        api.LoteDistribuicaoVendaComprados = $resource(api.baseUrl + 'LoteDistribuicaoVenda/Comprados', {
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });

        /////////////////// LoteProducao  //////////////////

        api.LoteProducao = $resource(api.baseUrl150 + 'LoteProducao/:id/:event', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            encerrar: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'Encerrar'
                }
            },
            estornarEncerramento: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'EstornarEncerramento'
                }
            },
            getInsumoBiologicoExcluido: {
                headers: {

                },
                method: 'GET',
                params: {
                    id: '@id',
                    insumoBiologicoId: '@insumoBiologicoId',
                    event: 'EstornarEncerramento'
                }

            },
            getInsumoDefensivoExcluido: {
                headers: {

                },
                method: 'GET',
                params: {
                    id: '@id',
                    event: 'EstornarEncerramento'
                }

            },
            getInsumoFertilizanteExcluido: {
                headers: {

                },
                method: 'GET',
                params: {
                    id: '@id',
                    event: 'EstornarEncerramento'
                }

            },
        });

        ///////////////// Filtros Lotes Produzidos List ////////////////////////////////////
          api.LoteProducaoFiltros = $resource(api.baseUrl150 + 'LoteProducao/GetFiltros', {}, {
               get: {
                    headers: {},
                    method: 'GET'
               }
          });

        ///////////////// Dash Lotes Produzidos ///////////////////////////////////////////////////////////
        //////////////////// Filtros //
          api.FiltrosLotesProduzidosDash = $resource(api.baseUrl150 + 'LotesProduzidosDashboard/Filtro', {},
          {
               get: {
                    headers: {},
                    method: 'GET'
               }
          });
        //////////////////// Lista por Area //
          api.LotesProduzidosDashboardPorArea = $resource(api.baseUrl150 + 'LotesProduzidosDashboard/PorArea', {}, {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               }
          });
        //////////////////// Lista por Cultura //
          api.LotesProduzidosDashboardPorCultura = $resource(api.baseUrl150 + 'LotesProduzidosDashboard/PorCultura', {}, {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               }
          });
        //////////////////// Excel por Área //
          api.ExcelLotesProduzidosArea = $resource(api.baseUrl150 + 'LotesProduzidosDashboard/ExcelPorArea', {}, {
               query: {
                    headers: {
                        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    },
                    method: 'GET',
                    responseType: 'arraybuffer',
                    cache: false,
                    transformResponse: function (data) {
                        return {
                            response: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                        };
                    }
                }
          });
          //////////////////// Excel por Cultura //
          api.ExcelLotesProduzidosCultura = $resource(api.baseUrl150 + 'LotesProduzidosDashboard/ExcelPorCultura', {}, {
               query: {
                    headers: {
                        accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    },
                    method: 'GET',
                    responseType: 'arraybuffer',
                    cache: false,
                    transformResponse: function (data) {
                        return {
                            response: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                        };
                    }
                }
          });
        ///////////////// Dash Lotes Produzidos ///////////////////////////////////////////////////////////

        /////////////////// LoteProducaoInsumoBiologico //////////////////
        api.LoteProducaoInsumoBiologico = $resource(api.baseUrl + 'LoteProducao/:id/InsumoBiologico/:insumoBiologicoId/:event', {
            id: '@id'
        },
            {
                get: {
                    headers: {

                    },
                    method: 'GET',
                    params: {
                        id: '@id',
                        insumoBiologicoId: '@insumoBiologicoId',
                    }
                },
                getExcluido: {
                    headers: {

                    },
                    method: 'GET',
                    params: {
                        id: '@id',
                        insumoBiologicoId: '@insumoBiologicoId',
                        event: 'Excluido'
                    }
                }
            });


        /////////////////// LoteProducaoInsumoFertilizante //////////////////


        api.LoteProducaoInsumoFertilizante = $resource(api.baseUrl + 'LoteProducao/:id/InsumoFertilizante/:insumoFertilizanteId/:event', {
            id: '@id'
        },
            {
                get: {
                    headers: {

                    },
                    method: 'GET',
                    params: {
                        id: '@id',
                        insumoFertilizanteId: '@insumoFertilizanteId',
                    }
                },
                getExcluido: {
                    headers: {

                    },
                    method: 'GET',
                    params: {
                        id: '@id',
                        insumoFertilizanteId: '@insumoFertilizanteId',
                        event: 'Excluido'
                    }
                }
            });

        /////////////////// LoteProducaoInsumoDefensivo //////////////////


        api.LoteProducaoInsumoDefensivo = $resource(api.baseUrl + 'LoteProducao/:id/InsumoDefensivo/:insumoDefensivoId/:event', {
            id: '@id'
        },
            {
                get: {
                    headers: {

                    },
                    method: 'GET',
                    params: {
                        id: '@id',
                        insumoDefensivoId: '@insumoDefensivoId',
                    }
                },
                getExcluido: {
                    headers: {

                    },
                    method: 'GET',
                    params: {
                        id: '@id',
                        insumoDefensivoId: '@insumoDefensivoId',
                        event: 'Excluido'
                    }
                }
            });

        /////////////////// LoteDistribuicao //////////////////

        api.LoteDistribuicao = $resource(api.baseUrl + 'LoteDistribuicao/:id/:event', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            encerrar: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'Encerrar'
                }
            },
            estornarEncerramento: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'EstornarEncerramento'
                }
            }
        });


        /////////////////// LoteDistribuicaoLoteNumero //////////////////

        api.LoteDistribuicaoLoteNumero = $resource(api.baseUrl + 'LoteDistribuicao/PorLoteNumero/:id', {
            id: '@id'
        }, {
            get: {
                headers: {

                },
                method: 'GET'

            }
        });


        /////////////////// LoteDistribuicaoConsolicação //////////////////

        api.LoteDistribuicaoConsolidacao = $resource(api.baseUrl + 'LoteDistribuicaoConsolidacao/:id/:event/:idLote', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            removerLote: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: '@id',
                    event: 'removerLote',
                    idLote: '@idLote'
                }
            }
        });


        /////////////////// LoteProducaoDistribuicao //////////////////

        api.LoteProducaoDistribuicao = $resource(api.baseUrl + 'LoteProducaoDistribuicao/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
        });

         /////////////////// LoteDisponivelVendaController //////////////////
         api.LoteDisponivelVenda = $resource(api.baseUrl + 'LoteDisponivelVenda', {
         }, {
              query: {
                   headers: {


                   },
                   method: 'GET',
                   transformResponse: function (data, headers) {
                        return mountQueryReturn(data, headers);
                   }
              }
         });

        /////////////////// LoteProducaoVenda //////////////////

        api.LoteProducaoVenda = $resource(api.baseUrl + 'LoteProducaoVenda/:id', {
            id: '@id'
        },
            {
                query: {
                    headers: {

                    },
                    method: 'GET',
                    transformResponse: function (data, headers) {
                        return mountQueryReturn(data, headers);
                    }
                },
                get: {
                    headers: {

                    },
                    method: 'GET'
                }
            });

        /////////////////// Aplicação de Insumos //////////////////

        api.AplicaocaoInsumos = $resource(api.baseUrl + 'CadernoCampoAplicacaoInsumos/:id', {
            id: '@id'
        },
            {
                query: {
                    headers: {

                    },
                    method: 'GET',
                    transformResponse: function (data, headers) {
                        return mountQueryReturn(data, headers);
                    }
                },
                get: {
                    headers: {

                    },
                    method: 'GET'
                }
            });

        /////////////////// LoteProducaoOcorrencia //////////////////

        api.LoteProducaoOcorrencia = $resource(api.baseUrl + 'LoteProducaoOcorrencia/:id', {
            id: '@id'
        },
            {
                query: {
                    headers: {

                    },
                    method: 'GET',
                    transformResponse: function (data, headers) {
                        return mountQueryReturn(data, headers);
                    }
                },
                get: {
                    headers: {

                    },
                    method: 'GET'
                }
            });

        /////////////////// LoteProducaoOcorrencia //////////////////

        api.LoteProducaoOcorrenciaInsumo = $resource(api.baseUrl + 'LoteProducaoOcorrencia/:event', {

        },
            {
                InsumoBiologico: {
                    headers: {

                    },
                    method: 'POST',
                    params: {
                        event: 'InsumoBiologico'
                    }
                },
                InsumoFertilizante: {
                    headers: {

                    },
                    method: 'POST',
                    params: {
                        event: 'InsumoFertilizante'
                    }
                },
                InsumoDefensivo: {
                    headers: {

                    },
                    method: 'POST',
                    params: {
                        event: 'InsumoDefensivo'
                    }
                }
            });

          /////////////////// CadernoCampoInsumoBiologico //////////////////
          api.CadernoCampoInsumoBiologicoLista = $resource(api.baseUrl150 + 'CadernoCampoInsumoBiologico/GetListagem', {}, {
               query: {
                    headers: {},
                    method: 'GET'
               }
          });
        api.CadernoCampoInsumoBiologico = $resource(api.baseUrl150 + 'CadernoCampoInsumoBiologico/:id', {
            id: '@id'
        }, {
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            get: {
                headers: {

                },
                method: 'GET'
            }
        });
        // SEM ESTOQUE
          api.CadernoCampoInsumoBiologicoSemEstoque = $resource(api.baseUrl150 + 'CadernoCampoInsumoBiologico/SemEstoque', {}, {
               save: {
               headers: {

               },
               method: 'POST',
               params: {
                    id: null
               }
               },
               delete: {
               headers: {

               },
               method: 'DELETE'
               },
               get: {
               headers: {

               },
               method: 'GET'
               }
          });

        ////////////////// Filtros Insumo Biologico ///////////////////
          api.FiltrosInsumoBiologico = $resource(api.baseUrl150 + 'CadernoCampoInsumoBiologico/GetFiltros', {
               get: {
                    headers: {},
                    method: 'GET'

               }
          });

        api.CadernoCampoInsumoBiologicoInativo = $resource(api.baseUrl + 'CadernoCampoInsumoBiologico/:id/Inativo', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'
            }
        });

        /////////////////// CadernoCampoInsumoDefensivo //////////////////
          api.CadernoCampoInsumoDefensivoLista = $resource(api.baseUrl150 + 'CadernoCampoInsumoDefensivo/GetListagem', {}, {
               query: {
                    headers: {},
                    method: 'GET'
               }
          });
        api.CadernoCampoInsumoDefensivo = $resource(api.baseUrl150 + 'CadernoCampoInsumoDefensivo/:id', {
            id: '@id'
        }, {
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            get: {
                headers: {

                },
                method: 'GET'

            }
        });
        // SEM ESTOQUE
          api.CadernoCampoInsumoDefensivoSemEstoque = $resource(api.baseUrl150 + 'CadernoCampoInsumoDefensivo/SemEstoque', {}, {
               save: {
               headers: {

               },
               method: 'POST',
               params: {
                    id: null
               }
               },
               delete: {
               headers: {

               },
               method: 'DELETE'
               },
               get: {
               headers: {

               },
               method: 'GET'
               }
          });
        ////////////////// Filtros ///////////////////
        api.FiltrosInsumoDefensivo = $resource(api.baseUrl150 + 'CadernoCampoInsumoDefensivo/GetFiltros', {
               get: {
                    headers: {},
                    method: 'GET'
               }
          });

        /////////////////// CadernoCampoInsumoFertilizante //////////////////
        api.CadernoCampoInsumoFertilizanteLista = $resource(api.baseUrl150 + 'CadernoCampoInsumoFertilizante/GetListagem', {}, {
               query: {
                    headers: {},
                    method: 'GET'
               }
          });
        api.CadernoCampoInsumoFertilizante = $resource(api.baseUrl150 + 'CadernoCampoInsumoFertilizante/:id', {
            id: '@id'
        }, {
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            get: {
                headers: {

                },
                method: 'GET'

            }
        });
        // SEM ESTOQUE
          api.CadernoCampoInsumoFertilizanteSemEstoque = $resource(api.baseUrl150 + 'CadernoCampoInsumoFertilizante/SemEstoque', {}, {
               save: {
               headers: {

               },
               method: 'POST',
               params: {
                    id: null
               }
               },
               delete: {
               headers: {

               },
               method: 'DELETE'
               },
               get: {
               headers: {

               },
               method: 'GET'
               }
          });
        ////////////////// Filtros ///////////////////
          api.FiltrosInsumoFertilizante = $resource(api.baseUrl150 + 'CadernoCampoInsumoFertilizante/GetFiltros', {
               get: {
                    headers: {},
                    method: 'GET'
               }
          });

        /////////////////// PropriedadeAreaHistorico //////////////////
        api.PropriedadeAreaHistorico = $resource(api.baseUrl + 'PropriedadeAreaHistorico/', {
            id: ''
        }, {
            get: {
                headers: {

                },
                method: 'GET'

            }
        });

        api.LoteDistribuicaoCompraExterna = $resource(api.baseUrl + 'LoteDistribuicaoCompraExterna/:id', {
            id: '@id'
        }, {
            query: {
                headers: {


                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });

        /////////////////// PropriedadeAreaHistoricoExcel //////////////////
        var xlsxContentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
        api.PropriedadeAreaHistoricoExcel = $resource(api.baseUrl + 'PropriedadeAreaHistorico/Excel', {
            id: ''
        }, {
            get: {
                headers: {
                    accept: xlsxContentType
                },
                method: 'GET',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], { type: xlsxContentType })
                    };
                }
            }
        });

        /////////////////// Profissional //////////////////

        api.TipoProfissional = $resource(api.baseUrl + 'TipoProfissional/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });

        /////////////////// Equipamento //////////////////

        api.Equipamento = $resource(api.baseUrl + 'Equipamento/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });


        /////////////////// Equipamento //////////////////

        api.PropriedadeHistorico = $resource(api.baseUrl150 + 'PropriedadeHistorico/:event', {
            id: '@id'
        }, {
            queryArea: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    event: 'Area'
                }
            },
            queryProduto: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    event: 'Produto'
                }
            },
            InsumosAgrupados: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    event: 'InsumosAgrupados'
                }
            },
            getExcel: {
                headers: {
                    accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                },
                method: 'GET',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
                    };
                },
                params: {
                    event: 'Excel'
                }
            }
        });

        /////////////////// CustosAtividade //////////////////

        api.CustosAtividade = $resource(api.baseUrl150 + 'CustosAtividade/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {

                    var isAO = isJSON(data);

                    if (isAO) {
                        return {
                            data: angular.fromJson(data || '[]'),
                            total_rows: headers()['x-total-count'] || 0,
                            total_cost: headers()['x-total-cost'] || 0
                        };
                    } else {

                        return {
                            data: [],
                            total_rows: 0
                        };
                    }

                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            update: {
                headers: {

                },
                method: 'PUT'
            }
        });

        ////////////////// TIPOS Manejos ///////////////////
          api.TiposManejos = $resource(api.baseUrl150 + 'CustosAtividade/TipoManejo/:event', {
               query: {
                    headers: {},
                    params: {
                        event: 'TipoManejo'
                    }
               }
          });
          api.TiposManejosSelect = $resource(api.baseUrl150 + 'CustosAtividade/TipoManejoSelect', {}, {
               get: {
                    headers: {},
                    method: 'GET',
                    isArray: true
               }
          });

        ////////////////// Filtros Custos Manejos ///////////////////
        api.FiltrosCustosManejos = $resource(api.baseUrl150 + 'CustosAtividade/FiltroManejo', {
            query: {
                headers: {},
                method: 'GET'
            },
            get: {
                headers: {},
                method: 'GET'

            }
        });

        /////////////////// DespesaAdministrativa //////////////////

        api.DespesaAdministrativa = $resource(api.baseUrl + 'DespesaAdministrativa/:id/:event', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {

                    var isAO = isJSON(data);

                    if (isAO) {
                        return {
                            data: angular.fromJson(data || '[]'),
                            total_rows: headers()['x-total-count'] || 0,
                            total_cost: headers()['x-total-cost'] || 0
                        };
                    } else {

                        return {
                            data: [],
                            total_rows: 0
                        };
                    }

                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            },
            update: {
                headers: {

                },
                method: 'PUT'
            },
            TipoManejo: {
                headers: {

                },
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    event: 'TipoManejo'
                }
            }
        });

        api.DespesaAdministrativaFiltros = $resource(api.baseUrl150 + 'DespesaAdministrativa/GetFiltros', {},
          {
               query: {
                    headers: {},
                    method: 'GET',
                    // transformResponse: function (data, headers) {
                    //      return mountQueryReturn(data, headers);
                    // }
               }
          });

        /////////////////// DespesaTipo //////////////////

        api.DespesaTipo = $resource(api.baseUrl + 'DespesaTipo/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });


        /////////////////// DespesaTipo //////////////////


        /////////////////// DespesaNome //////////////////

        api.DespesaNome = $resource(api.baseUrl + 'DespesaNome/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });


        /////////////////// DespesaNome //////////////////

        /////////////////// DespesaFavorecido //////////////////

        api.DespesaFavorecido = $resource(api.baseUrl + 'DespesaFavorecido/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });


        /////////////////// DespesaFavorecido //////////////////
        api.EstoqueInsumoDefensivo150 = $resource(api.baseUrl150 + 'EstoqueInsumo/:id/:event/:eventid', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    Enum_Insumo_Tipo: 'defensivo'
                }
            },
            getEstoqueInsumo: {
                headers: {

                },
                method: 'GET',
                params: {

                }
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            queryHistorico: {
                headers: {},
                method: 'GET',
                params: {
                    event: 'Historico'
                },
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            acerto: {
                headers: {},
                method: 'POST',
                params: {
                    event: 'Acerto'
                }
            },
        });
          // SEM CONTROLE ESTOQUE
          api.InsumoDefensivoSemEstoque = $resource(api.baseUrl150 + 'Insumo', {},
          {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    },
                    params: {
                         insumoTipo: 'defensivo'
                    }
               }
          });

        /////////////////// EstoqueInsumoDefensivo //////////////////

        /////////////////// EstoqueInsumoFertilizante //////////////////
        api.EstoqueInsumoFertilizante150 = $resource(api.baseUrl150 + 'EstoqueInsumo/:id/:event/:eventid', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    Enum_Insumo_Tipo: 'fertilizante'
                }
            },
            getEstoqueInsumo: {
                headers: {

                },
                method: 'GET',
                params: {

                }
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            queryHistorico: {
                headers: {},
                method: 'GET',
                params: {
                    event: 'Historico'
                },
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            acerto: {
                headers: {},
                method: 'POST',
                params: {
                    event: 'Acerto'
                }
            },
        });
          // SEM CONTROLE ESTOQUE
          api.InsumoFertilizanteSemEstoque = $resource(api.baseUrl150 + 'Insumo', {},
          {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    },
                    params: {
                         insumoTipo: 'fertilizante'
                    }
               }
          });

        /////////////////// EstoqueInsumoFertilizante //////////////////


        /////////////////// EstoqueInsumoBiologico //////////////////
          api.EstoqueInsumoBiologico150 = $resource(api.baseUrl150 + 'EstoqueInsumo/:id/:event/:eventid', {},
          {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    },
                    params: {
                         Enum_Insumo_Tipo: 'biologico'
                    }
               },
               getEstoqueInsumo: {
                    headers: {

                    },
                    method: 'GET',
                    params: {

                    }
                },
                save: {
                    headers: {},
                    method: 'POST',
                    params: {
                        id: null
                    }
                },
                queryHistorico: {
                    headers: {},
                    method: 'GET',
                    params: {
                        event: 'Historico'
                    },
                    transformResponse: function (data, headers) {
                        return mountQueryReturn(data, headers);
                    }
                },
                acerto: {
                    headers: {},
                    method: 'POST',
                    params: {
                        event: 'Acerto'
                    }
                },
          });
     //    api.EstoqueInsumoBiologico = $resource(api.baseUrl + 'EstoqueInsumo/:id/:event/:eventid', {
     //        id: '@id'
     //    }, {
     //        query: {
     //            headers: {},
     //            method: 'GET',
     //            transformResponse: function (data, headers) {
     //                return mountQueryReturn(data, headers);
     //            },
     //            params: {
     //                Enum_Insumo_Tipo: 'biologico'
     //            }
     //        },
     //        getEstoqueInsumo: {
     //            headers: {

     //            },
     //            method: 'GET',
     //            params: {

     //            }
     //        },
     //        save: {
     //            headers: {},
     //            method: 'POST',
     //            params: {
     //                id: null
     //            }
     //        },
     //        queryHistorico: {
     //            headers: {},
     //            method: 'GET',
     //            params: {
     //                event: 'Historico'
     //            },
     //            transformResponse: function (data, headers) {
     //                return mountQueryReturn(data, headers);
     //            }
     //        },
     //        acerto: {
     //            headers: {},
     //            method: 'POST',
     //            params: {
     //                event: 'Acerto'
     //            }
     //        },
     //    });
        // SEM CONTROLE ESTOQUE
        api.InsumoBiologicoSemEstoque = $resource(api.baseUrl150 + 'Insumo', {},
          {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    },
                    params: {
                         insumoTipo: 'biologico'
                    }
               }
          });

        /////////////////// EstoqueInsumoBiologico //////////////////


        /////////////////// EstoqueInsumoSemente //////////////////

        api.EstoqueInsumoSemente150 = $resource(api.baseUrl150 + 'EstoqueInsumo/:id/:event/:eventid', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    Enum_Insumo_Tipo: 'semente'
                }
            },
            getEstoqueInsumo: {
                headers: {

                },
                method: 'GET',
                params: {

                }
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            queryHistorico: {
                headers: {},
                method: 'GET',
                params: {
                    event: 'Historico'
                },
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            acerto: {
                headers: {},
                method: 'POST',
                params: {
                    event: 'Acerto'
                }
            },
        });


        /////////////////// EstoqueInsumoBiologico //////////////////


        /////////////////// EstoqueInsumoRateio //////////////////
        api.EstoqueInsumoRateio150 = $resource(api.baseUrl150 + 'EstoqueInsumo/Rateio/:id', {
               id: '@id'
          }, {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               },
               delete: {
                    headers: {

                    },
                    method: 'DELETE',
                    params: {
                         id: null
                    }
               }
          });
        api.EstoqueInsumoRateio = $resource(api.baseUrl + 'EstoqueInsumo/Rateio/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            delete: {
                headers: {

                },
                method: 'DELETE',
                params: {
                    id: null
                }
            }
        });


        /////////////////// EstoqueInsumoDefensivoRateio //////////////////
          api.EstoqueInsumoRateioDefensivo = $resource(api.baseUrl150 + 'CadernoCampoInsumoDefensivo/Rateio/:id', {
               id: '@id'
          }, {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               },
               delete: {
                    headers: {

                    },
                    method: 'DELETE',
                    params: {
                         id: null
                    }
               }
          });


        /////////////////// EstoqueInsumoHistorico //////////////////

        api.EstoqueInsumoHistorico = $resource(api.baseUrl150 + 'EstoqueInsumo/Historico/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            }
        });


        /////////////////// EstoqueInsumoHistorico //////////////////

        /////////////////// Estoque Insumo //////////////////

        api.EstoqueInsumo = $resource(api.baseUrl150 + 'Insumo/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {

                },
                method: 'POST',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                },
                params: {
                    id: null
                }
            },
            update: {
                headers: {

                },
                method: 'PUT',
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            delete: {
                headers: {

                },
                method: 'DELETE'
            }
        });
          api.EstoqueInsumoTodos = $resource(api.baseUrl150 + 'Insumo/Todos/:id', {
               id: '@id'
          }, {
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               },
               get: {
                    headers: {

                    },
                    method: 'GET'

               }
          });

        /////////////////// EstoqueInsumo//////////////////



        /////////////////// LoteLaudo //////////////////

        api.Laudo = $resource(api.baseUrl + 'Laudo/:event/:id', {
            id: '@id'
        }, {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {

                },
                method: 'GET'

            },
            save: {
                headers: {

                },
                method: 'POST',
                params: {
                    id: null
                }
            },
            cancelarLaudo: {
                headers: {

                },
                method: 'PUT',
                params: {
                    event: 'Cancelar'
                },
            },
        });

        // Certificados / Documentos /////////////////////////////////////////////
        api.Certificados = $resource(api.baseUrl + 'Certificado/:id', {
            id: '@id'
        }, {
            update: {
                headers: {},
                method: 'PUT'
            },
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {},
                method: 'GET'
            },
            delete: {
                headers: {},
                method: 'DELETE'
            },
        });

        api.CertificadosArquivoTipos = $resource(api.baseUrl + 'Certificado/TipoArquivo/:id', {
            id: '@id'
        }, {
            update: {
                headers: {},
                method: 'PUT'
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {},
                method: 'GET',
                isArray: true
            },
            delete: {
                headers: {},
                method: 'DELETE'
            },
        });

        api.CertificadosDash = $resource(api.baseUrl + 'Certificado/Dashboard', {
            get: {
                headers: {},
                method: 'GET'
            }
        });

        var pdfContentType = 'application/pdf';
        api.LaudoPdf = $resource(api.baseUrl + 'Laudo/pdf/:id', {
            id: '@id'
        }, {
            get: {
                headers: {
                    accept: pdfContentType
                },
                method: 'GET',
                responseType: 'arraybuffer',
                cache: false,
                transformResponse: function (data) {
                    return {
                        response: new Blob([data], { type: pdfContentType })
                    };
                }
            }
        });

        // Previsao Colheita /////////////////////////////////////////////
        api.PrevisaoColheita = $resource(api.baseUrl + 'ColheitaPrevisao/:id', {
            id: '@id'
        }, {
            update: {
                headers: {},
                method: 'PUT'
            },
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            save: {
                headers: {},
                method: 'POST',
                params: {
                    id: null
                }
            },
            get: {
                headers: {},
                method: 'GET'
            },
            delete: {
                headers: {},
                method: 'DELETE'
            },
        });
        api.PrevisaoColheitaCultura = $resource(api.baseUrl + 'ColheitaPrevisao/ListPrevisaoCultura', {
            query: {
                headers: {},
                method: 'GET',
                isArray: true
            },
            get: {
                headers: {},
                method: 'GET'
            }
        });
        api.PrevisaoColheitaList = $resource(api.baseUrl + 'ColheitaPrevisao/ListPrevisao', {
            query: {
                headers: {},
                method: 'GET',
                transformResponse: function (data, headers) {
                    return mountQueryReturn(data, headers);
                }
            },
            get: {
                headers: {},
                method: 'GET'
            }
        });
        api.PrevisaoColheitaDash = $resource(api.baseUrl + 'ColheitaPrevisao/Dash', {
            get: {
                headers: {},
                method: 'GET'
            }
        });
        api.PrevisaoColheitaGetId = $resource(api.baseUrl + 'ColheitaPrevisao/Previsao/:id', {
            id: '@id'
        }, {
            get: {
                headers: {},
                method: 'GET'
            }
        });
        api.PrevisaoColheitaColheitas = $resource(api.baseUrl + 'ColheitaPrevisao/Colheitas/:id', {
            id: '@id'
        }, {
            get: {
                headers: {},
                isArray: true,
                method: 'GET'
            }
        });

        /////////////////////////////////

        // Agendamento Visitas /////////////////////////////////////////////
          api.Visitas = $resource(api.baseUrl150 + 'Visita/:id', {
               id: '@id'
          }, {
               update: {
                    headers: {},
                    method: 'PUT'
               },
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               },
               save: {
                    headers: {},
                    method: 'POST',
                    params: {
                         id: null
                    }
               },
               get: {
                    headers: {},
                    method: 'GET'
               },
               delete: {
                    headers: {},
                    method: 'DELETE'
               },
          });
          api.VisitasDash = $resource(api.baseUrl150 + 'Visita/GetDashCaderno', {
               get: {
                   headers: {},
                   method: 'GET'
               }
          });
          api.VisitasListaDash = $resource(api.baseUrl150 + 'Visita/GetListagemCaderno', {
               get: {
                    headers: {},
                    method: 'GET'
               }
          });
          api.VisitasCancelamento = $resource(api.baseUrl150 + 'Visita/Cancelamento/:id', {
               id: '@id'
          }, {
               update: {
                    headers: {},
                    method: 'PUT'
               }
          });
          api.VisitasEstorno = $resource(api.baseUrl150 + 'Visita/Estorno/:id', {
               id: '@id'
          }, {
               update: {
                    headers: {},
                    method: 'PUT'
               }
          });

          // CALDAS
          api.Caldas = $resource(api.baseUrl150 + 'Calda/:id', {
               id: '@id'
          }, {
               update: {
                    headers: {},
                    method: 'PUT'
               },
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               },
               save: {
                    headers: {},
                    method: 'POST',
                    params: {
                         id: null
                    }
               },
               get: {
                    headers: {},
                    method: 'GET'
               },
               delete: {
                    headers: {},
                    method: 'DELETE'
               },
          });
          api.CaldasTiposInsumos = $resource(api.baseUrl150 + 'Calda/GetTipoInsumos', {
               query: {
                   headers: {},
                   isArray: true,
                   method: 'GET'
               }
           });
           api.CaldasFiltros = $resource(api.baseUrl150 + 'Calda/GetFiltros', {
               get: {
                   headers: {},
                   isArray: true,
                   method: 'GET'
               }
           });

           // PLANO DE APLICAÇÃO DE CALDAS
          api.CaldaAplicacao = $resource(api.baseUrl150 + 'CaldaAplicacao/:id', {
          id: '@id'
          }, {
               update: {
                    headers: {},
                    method: 'PUT'
               },
               query: {
                    headers: {},
                    method: 'GET',
                    transformResponse: function (data, headers) {
                         return mountQueryReturn(data, headers);
                    }
               },
               save: {
                    headers: {},
                    method: 'POST',
                    params: {
                         id: null
                    }
               },
               get: {
                    headers: {},
                    method: 'GET'
               },
               delete: {
                    headers: {},
                    method: 'DELETE'
               },
          });
           api.SelectsAddPlanoAplicacao = $resource(api.baseUrl150 + 'CaldaAplicacao/GetCadastro', {
               get: {
                   headers: {},
                   //isArray: true,
                   method: 'GET'
               }
           });
           api.FiltrosPlanoAplicacao = $resource(api.baseUrl150 + 'CaldaAplicacao/GetFiltros', {
               get: {
                   headers: {},
                   //isArray: true,
                   method: 'GET'
               }
           });
          //var xlsxContentTypePlanoAplic = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
          api.ExcelPlanoAplicacao = $resource(api.baseUrl150 + 'CaldaAplicacao/Excel', {
               id: ''
          }, {
               get: {
                    headers: {
                         accept: xlsxContentType
                    },
                    method: 'GET',
                    responseType: 'arraybuffer',
                    cache: false,
                    transformResponse: function (data) {
                         return {
                         response: new Blob([data], { type: xlsxContentType })
                         };
                    }
               }
          });
          api.CaldaAplicacaoConfirmar = $resource(api.baseUrl150 + 'CaldaAplicacaoConfirmada/:id', {
               id: '@id'
               }, {
                    update: {
                         headers: {},
                         method: 'PUT'
                    },
                    query: {
                         headers: {},
                         method: 'GET',
                         transformResponse: function (data, headers) {
                              return mountQueryReturn(data, headers);
                         }
                    },
                    save: {
                         headers: {},
                         method: 'POST',
                         params: {
                              id: null
                         }
                    },
                    get: {
                         headers: {},
                         method: 'GET'
                    },
                    delete: {
                         headers: {},
                         method: 'DELETE'
                    },
          });
          api.CaldaAplicacaoConfirmarComEstoque = $resource(api.baseUrl150 + 'CaldaAplicacaoConfirmada/comestoque', {},
          {
                    save: {
                         headers: {},
                         method: 'POST',
                         params: {
                              id: null
                         }
                    }
          });
          api.FiltrosCaldaAplicacaoConfirmada = $resource(api.baseUrl150 + 'CaldaAplicacaoConfirmada/GetFiltros', {
               get: {
                   headers: {},
                   //isArray: true,
                   method: 'GET'
               }
          });
          api.CaldaAplicacaoConfirmarInfo = $resource(api.baseUrl150 + 'CaldaAplicacaoConfirmada/info/:id', {
               id: '@id'
               }, {
                    query: {
                         headers: {},
                         method: 'GET',
                         transformResponse: function (data, headers) {
                              return mountQueryReturn(data, headers);
                         }
                    },
                    get: {
                         headers: {},
                         method: 'GET'
                    }
          });

        return api;

    }

})();

(function () {
    'use strict';

    angular
         .module('app.manejo', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

         // State
         $stateProvider
              .state('app.registro.manejo', {
                   abstract: true,
                   url: '/manejo',
                   resolve: {
                        authorize: function (authorization) {
                             authorization.authorize();
                        }
                   }
              });


         msNavigationServiceProvider.saveItem('manejo', {
               title: 'Manejos',
               //icon: 'icon-wrench',
               img: '/assets/icons/ico-menu-manejo.svg',
               // group: true,
               weight: 3
         });

    }
})();

(function () {
     'use strict';

     angular
          .module('app.insumo', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

          // State
          $stateProvider
               .state('app.registro.manejo.insumo', {
                    abstract: true,
                    url: '/insumo',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               });

          msNavigationServiceProvider.saveItem('manejo.insumo', {
               title: 'Aplicação de Insumos',
               // icon: 'icon-fill',
               weight: 1
          });

     }
})();

(function () {
     'use strict';

     angular
          .module('app.vendas', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

          // State
          $stateProvider
               .state('app.vendas', {
                    abstract: true,
                    url: '/vendas',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               });


          // Translation
          $translatePartialLoaderProvider.addPart('app/main/vendas');

         /* msNavigationServiceProvider.saveItem('vendas', {
               title: 'Vendas',
               icon: 'icon-coin',
               // group: true,
               weight: 2,
               translate: 'VENDAS.VENDAS'
          });*/

     }
})();

(function () {
     'use strict';

     angular
          .module('app.registro', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider) {

          // State
          $stateProvider
               .state('app.registro', {
                    abstract: true,
                    url: '/registro',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               });


          // msNavigationServiceProvider.saveItem('registro', {
          //      title: 'Caderno de Campo',
          //      icon: 'icon-library-books',
          //      // group: true,
          //      weight: 3
          // });

     }
})();

(function () {
    'use strict';

    angular
         .module('app.relatorios', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

         // State
         $stateProvider
              .state('app.relatorios', {
                   abstract: true,
                   url: '/relatorios',
                   resolve: {
                        authorize: function (authorization) {
                             authorization.authorize();
                        }
                   }
              });


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/relatorios');

        /* msNavigationServiceProvider.saveItem('relatorios', {
              title: 'Relatório',
              icon: 'icon-file-document',
              // group: true,
              weight: 9,
              translate: 'RELATORIOS.RELATORIOS'
         });*/

    }
})();

(function () {
    'use strict';

    angular
        .module('app.rastreamento', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.rastreamento', {
                abstract: true,
                url: '/rastreamento',
                resolve: {
                    authorize: function (authorization) {
                        authorization.authorize();
                    }
                }
            });

          // Translation
         // $translatePartialLoaderProvider.addPart('app/main/rastreamento');

        //   msNavigationServiceProvider.saveItem('rastreamento', {
        //        title: 'Rastreamento',
        //        icon: 'icon-rastreamento',
        //        weight: 5

        //   });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.propriedademenu', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.propriedademenu', {
                abstract: true,
                url: '/propriedademenu',
                resolve: {
                    authorize: function (authorization) {
                        authorization.authorize();
                    }
                }
            });

          // Translation
         // $translatePartialLoaderProvider.addPart('app/main/propriedade');

          msNavigationServiceProvider.saveItem('propriedademenu', {
               title: 'Propriedade',
               img: '/assets/icons/ico-menu-propriedade.svg',
               weight: 2

          });
    }
})();

(function () {
    'use strict';

    angular
        .module('app.financeiro', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.financeiro', {
                abstract: true,
                url: '/financeiro',
                resolve: {
                    authorize: function (authorization) {
                        authorization.authorize();
                    }
                }
            });

          // Translation
         // $translatePartialLoaderProvider.addPart('app/main/financeiro');

          msNavigationServiceProvider.saveItem('financeiro', {
               title: 'Financeiro',
               icon: 'icon-coin',
               weight: 6

          });
    }
})();

(function () {
     'use strict';

     angular
          .module('app.fechamento_custos', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider) {

          // State
          $stateProvider
               .state('app.propriedademenu.fechamento_custos', {
                    abstract: true,
                    url: '/fechamento_custos',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               });

          msNavigationServiceProvider.saveItem('propriedademenu.fechamento_custos', {
               title: 'Fechamento de custos',
               // icon: 'icon-fill',
               weight: 2
          });

     }
})();

(function () {
    'use strict';

    angular
        .module('app.estoque_insumo', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {

        // State
        $stateProvider
            .state('app.estoque_insumo', {
                abstract: true,
                url: '/estoque_insumo',
                resolve: {
                    authorize: function (authorization) {
                        authorization.authorize();
                    }
                }
            });

        msNavigationServiceProvider.saveItem('estoque_insumo', {
            title: 'Estoque',
            //icon: 'icon-package-variant',
            img: '/assets/icons/ico-menu-estoque.svg',
            weight: 5
        });

          msNavigationServiceProvider.saveItem('estoque_insumo.gestao', {
               title: 'Gestão do estoque',
               // hidden: function (){
               //      return true;
               // },
               weight: 2,
               class: 'menu-item-estoque-insumo'
          });

    }
})();

(function () {
    'use strict';

    angular
         .module('app.compras', [])
         .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

         // State
         $stateProvider
              .state('app.compras', {
                   abstract: true,
                   url: '/compras',
                   resolve: {
                        authorize: function (authorization) {
                             authorization.authorize();
                        }
                   }
              });


         // Translation
         $translatePartialLoaderProvider.addPart('app/main/compras');

         /*msNavigationServiceProvider.saveItem('compras', {
              title: 'Compras',
              icon: 'icon-cart',
              // group: true,
              weight: 9,
              translate: 'COMPRAS.COMPRAS'
         });*/

    }
})();

(function () {
     'use strict';

     angular
          .module('app.cadastros', [])
          .config(config);

     /** @ngInject */
     function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {

          // State
          $stateProvider
               .state('app.cadastros', {
                    abstract: true,
                    url: '/cadastros',
                    resolve: {
                         authorize: function (authorization) {
                              authorization.authorize();
                         }
                    }
               });



          // Translation
          $translatePartialLoaderProvider.addPart('app/main/cadastros');

          msNavigationServiceProvider.saveItem('cadastros', {
               title: 'Cadastros',
               icon: 'icon-account-box',
               // group: true,
               weight: 8,
               //translate: 'CADASTROS.CADASTROS'
          });

     }
})();

(function () {
  'use strict';

  angular
    .module('app.main', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, msNavigationServiceProvider, $translatePartialLoaderProvider) {


    // Translation
    $translatePartialLoaderProvider.addPart('app/main/dashboard');
    $translatePartialLoaderProvider.addPart('app/main/registro');

    // Menu
    msNavigationServiceProvider.saveItem('dashboard', {
      title: 'Caderno de Campo',
      group: true,
      weight: 1,
      translate: 'DASHBOARD.DASHBOARD'
    });

    msNavigationServiceProvider.saveItem('registro', {
      title: 'Caderno de Campo',
      group: true,
      weight: 2
    });



  }
})();

(function () {
    'use strict';

    angular
        .module('app.authentication', [])

        // Provide de configuração do Oidc: As configurações são setadas na index.config.js
        // Esse provider existe apenas para não pegar as configurações diretamente na Factory principal, o que não ficaria muito elegante.
        .provider('authentication', function () {
            var configure = {
                setOidcConfig: setOidcConfig,
                oidcConfig: null
            };

            var provider = {
                $get: Authentication,
                configure: configure
            };
            return provider;

            function setOidcConfig(oidcConfig) {
                configure.oidcConfig = oidcConfig;
            }

            // Implemento a factory dentro do provider
            function Authentication() {
                var model = {
                    oidcConfig: configure.oidcConfig
                };
                return model;
            }
        })

        // principal is a service that tracks the user's identity. 
        // calling identity() returns a promise while it does what you need it to do
        // to look up the signed-in user's identity info. for example, it could make an 
        // HTTP request to a rest endpoint which returns the user's name, roles, etc.
        // after validating an auth token in a cookie. it will only do this identity lookup
        // once, when the application first runs. you can force re-request it by calling identity(true)
        .factory('principal', ['$q', '$timeout', 'authentication', '$rootScope', '$window',
            function ($q, $timeout, authenticationProvider, $rootScope, $window) {

                authenticationProvider.oidcConfig.loadUserInfo = true;
                authenticationProvider.oidcConfig.silent_redirect_uri = window.location.origin + "/authentication_silent.html";

                // TODO: Retirar depois
                authenticationProvider.oidcConfig.redirect_uri = window.location.origin + "/account/callback";
                authenticationProvider.oidcConfig.post_logout_redirect_uri = window.location.origin + "/account/logout";
                // TODO: <-- Retirar depois

                authenticationProvider.oidcConfig.automaticSilentRenew = false;
                authenticationProvider.oidcConfig.revokeAccessTokenOnSignout = true;
                authenticationProvider.oidcConfig.checkSessionInterval = 5000;
                //authenticationProvider.oidcConfig.monitorSession = false;

                // Inicializa a lib de autenticação
                var mgr = new Oidc.UserManager(authenticationProvider.oidcConfig);

                mgr.events.addUserLoaded(function (user) {
                    log("User loaded", user);
                });

                mgr.events.addUserUnloaded(function () {
                    log("User logged out locally");
                });

                mgr.events.addAccessTokenExpiring(function () {
                    log("Access token expiring...");
                });
                mgr.events.addSilentRenewError(function (err) {
                    log("Silent renew error: " + err.message);
                });

                mgr.events.addUserSignedOut(function () {
                    log("User signed out of OP");
                });

                mgr.getUser().then(function (user) {
                    console.log("getUser loaded user after userLoaded event fired", user);
                    return user;
                });

                return {

                    getUser: function () {
                        return $q(function (resolve, reject) {
                            mgr.getUser()
                                .then(function (user) {
                                    resolve(user);
                                }).catch(function (err) {
                                    reject(err);
                                });
                        });
                    },

                    signinSilent: function () {
                        return $q(function (resolve, reject) {
                            mgr.signinSilent()
                                .then(function (user) {
                                    resolve(user);
                                }).catch(function (err) {
                                    reject(err);
                                });
                        });
                    },

                    signinSilentOrRedirectSignin: function () {

                        // Tenta fazer o refresh signin. Se não conseguir redireciona para o login

                        return $q(function (resolve, reject) {
                            mgr.signinSilent()
                                .then(function (user) {
                                    resolve(user);
                                }).catch(function (err) {

                                    mgr.signinRedirect().then(function () {

                                        log("signinRedirect done");
                                        reject(err);
                                    }).catch(function (err) {
                                        log(err);
                                        reject(err);
                                    });;

                                }).catch(function (err) {
                                    log(err);
                                    reject(err);
                                });


                        });

                    },



                    getStorageUser: function () {

                        // TODO: Verificar se o nome de usuário será gradado
                        return "TODO: ???"

                        let user = window.localStorage.getItem('user');
                        if (user == null) {
                            return user;
                        }
                        return JSON.parse(user);
                    },
                    isAuthenticated: function () {
                        return _authenticated;
                    },
                    isInRole: function (role) {
                        if (!_authenticated || !_identity.roles) return false;

                        return _identity.roles.indexOf(role) != -1;
                    },
                    isInAnyRole: function (roles) {
                        if (!_authenticated || !_identity.roles) return false;

                        for (var i = 0; i < roles.length; i++) {
                            if (this.isInRole(roles[i])) return true;
                        }

                        return false;
                    },
                    authenticate: function (identity) {
                        _identity = identity;
                        _authenticated = identity != null;
                    },
                    identity: function (origin) {
                        console.debug(origin + " => identity");
                        return mgr.getUser();
                    },
                    getToken: function () {
                        return window.localStorage.getItem('token');
                    },
                    logout: function () {
                        mgr.signoutRedirect();
                    },
                    removeUser: function () {
                        return mgr.removeUser();
                    },
                    goToLogin: function () {
                        console.log("signinRedirect...");
                        mgr.signinRedirect();
                    },
                    goToConfirmEmail: function (userID, code) {

                        var clienteID = authenticationProvider.oidcConfig.client_id;
                        var redirect = window.location.origin + "/account/callbackconfirmemail";
                        var e = authenticationProvider.oidcConfig.authority + "/Account/PasswordlessLogin?client_id=" + clienteID + "&userId=" + userID + "&token=" + ajustadoEncodeURIComponent(code) + "&returnUrl=" + redirect
                        $window.location.href = e;

                    },
                    goToChangePassword: function () {

                        var e = authenticationProvider.oidcConfig.authority + "/Account/ChangePassword?returnUrl=" + window.location.origin + "/Account/Callback";
                        $window.location.href = e;

                    },
                    signinRedirectCallback: function () {
                        console.debug("=>>>>>>signinRedirectCallback");
                        return mgr.signinRedirectCallback().then(function (user) {

                            updateLocalStorage(user);

                            return user;

                        });
                    }
                };

                function log() {
                    Array.prototype.forEach.call(arguments, function (msg) {
                        if (msg instanceof Error) {
                            msg = "Error: " + msg.message;
                        } else if (typeof msg !== 'string') {
                            msg = JSON.stringify(msg, null, 2);
                        }
                        console.log(msg);
                    });
                }

                function ajustadoEncodeURIComponent(str) {
                    return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
                        return '%' + c.charCodeAt(0).toString(16);
                    });
                }

            }
        ])
        // authorization service's purpose is to wrap up authorize functionality
        // it basically just checks to see if the principal is authenticated and checks the root state 
        // to see if there is a state that needs to be authorized. if so, it does a role check.
        // this is used by the state resolver to make sure when you refresh, hard navigate, or drop onto a
        // route, the app resolves your identity before it does an authorize check. after that,
        // authorize is called from $stateChangeStart to make sure the principal is allowed to change to
        // the desired state
        .factory('authorization', ['$rootScope', '$state', 'principal',
            function ($rootScope, $state, principal) {
                return {
                    authorize: function (origin) {
                        console.log("authorization", origin);
                        return principal.getUser().then(function (user) {

                            if (!user) {
                                principal.goToLogin();
                            }
                        });
                    }
                };
            }
        ])

        .factory('httpInterceptor', ['$q', '$rootScope', '$location', 'principal', '$window', '$timeout', '$injector', function ($q, $rootScope, $location, principal, $window, $timeout, $injector) {

            let isRefreshing = false;

            return {
                request: function (config) {

                    return $q(function (resolve, reject) {

                        principal.getUser()
                            .then(function (user) {
                                config.headers = config.headers || {};
                                if (user) {
                                    config.headers.Authorization = 'bearer ' + user.access_token;
                                }
                                resolve(config);
                            }).catch(function (err) {
                                resolve(config);
                            });
                    });
                },
                response: function (response) {
                    if (response.status >= 200 && response.status <= 299) {
                        isRefreshing = false;
                    }
                    return response;
                },
                responseError: function (rejection) {
                    console.log("responseError", rejection);

                    // 402 Pagamento necessário: Obackend retorna quando o Cliente não está cadastrado ou sem pagamento. 
                    if (rejection.status === 402) {

                        try {

                            if (rejection.data) {

                                var assinaturas = undefined;

                                // Produto Id 1 - Caderno de campo.

                                if (Array.isArray(rejection.data) && rejection.data.length > 0) {
                                    assinaturas = rejection.data.filter(function (item) { return item.ProdutoId == 1 });
                                } else if (rejection.data.data && rejection.data.data.length > 0) {
                                    assinaturas = rejection.data.data.filter(function (item) { return item.ProdutoId == 1 });
                                } else if(assinaturas){
                                    $rootScope.state.go('app.account.accessdenied');
                                }else if (assinaturas &&
                                    assinaturas.length > 0 &&
                                    assinaturas[0].ExpiraAutomaticamente == 1 &&
                                    assinaturas[0].AssinaturaStatusId != 1 &&
                                    assinaturas[0].AssinaturaStatusId != 2) {

                                        //.replaceAll('/', '-')
                                    var date = new Date(assinaturas[0].DataFinalPeriodo);
                                    $rootScope.state.go('app.assinatura.desativada', {
                                        dataFinalPeriodo: date.toLocaleDateString()
                                    });

                                } else {
                                    $rootScope.state.go('app.account.accessdenied');
                                }
                            } else {
                                $rootScope.state.go('app.account.accessdenied');
                            }
                        } catch (error) {
                            $rootScope.state.go('app.account.accessdenied');
                        }
                    }

                    // Para alguns erros tenta fazer um retentaiva de envio
                    // Status codes como 401 e 403 podem significar falta de token ou um token espirado
                    // nesse caso tenta fazer um "signinSilent" para revalidar o token.
                    // Status 500, 503 podem significar uma instabilidade temporária no sistema.
                    if (!isRefreshing && [-1, 401, 403, 500, 503].indexOf(rejection.status) != -1) {
                        return principal.signinSilent().then(function (user) {
                            isRefreshing = true;

                            // Tenta gerar um novo token
                            if (user) {
                                rejection.config.headers.Authorization = 'bearer ' + user.access_token;
                            } else {
                                console.log("isRefreshing: usuario inválido.", rejection);
                                principal.goToLogin();
                                return $q.reject(rejection);
                            }

                            var $http = $injector.get('$http');
                            return $http(rejection.config);
                        }).catch(function (err) {
                            console.log("isRefreshing: Error.", rejection);
                            principal.goToLogin();
                            return $q.reject(rejection);
                        });

                    }


                    if (rejection.status === 500 || rejection.status === -1) {
                        $rootScope.$broadcast('httpError', {
                            message: 'Ocorreu um erro inesperado. Por favor, tente novamente.'
                        });
                    }

                    return $q.reject(rejection);
                }
            };
        }]);

})();

var loggerServer = {
    log: function (message, data) { sendError({ message: message, data: data }) },
    error: function (error) { sendError(processError(error)) },
    url : ""
};


var sendError = function (err) {
    console.log('Caught JS client error:');
    console.dir(err);

    var xhr = new XMLHttpRequest();
    xhr.open('POST', loggerServer.url + "UILogger", true);
    xhr.setRequestHeader('Content-type', 'text/plain; charset=utf-8');
    xhr.send(JSON.stringify(err));
};


/**
 * Chrome and Opera fully support the HTML 5 draft spec for ErrorEvent and window.onerror. 
 * In both of these browsers you can use window.onerror to get a full stacktrace:
 */
var processError = function (msg, url, lineNo, columnNo, error) {
    var log = {};

    // Handle error objects (/w stack trace)
    if (msg && msg.message) {
        log.err = {
            'msg': msg.message,
            'file': !!msg.fileName ? msg.fileName : false,
            'ln': !!msg.lineNumber ? msg.lineNumber : !!lineNo ? lineNo : false,
            'col': !!msg.columnNumber ? msg.columnNumber : !!columnNo ? columnNo : false,
            'stacktrace': !!msg.stack ? msg.stack : false,
            'cause': !!url ? JSON.stringify(url) : false,
            'errorObj': !!error ? error : false
        };
    } else {
        log.err = {
            'msg': msg
        };

        if (!!url) {
            log.err.file = url;
        }
    }

    log.url = window.location.href;
    log.userAgent = window.navigator.userAgent;

    sendError(log);
};

window.onerror = function (exception, url, lineNo, columnNo, error) {
    processError(exception, url, lineNo, columnNo, error);
    return false; // surpress error alerts in old IEs
};

/**
 * Unfortunately Firefox, Safari and IE are still around and we have to support them too. 
 * As the stacktrace is not available in window.onerror we have to do a little bit more work:
 * It turns out that the only thing we can do to get stacktraces from errors is to wrap all 
 * of our code in a `try{ }catch(e){ }` block and then look at `e.stack`.
 */

function wrap(func) {
    // Ensure we only wrap the function once.
    if (!func._wrapped) {
        func._wrapped = function () {
            try {
                func.apply(this, arguments);
            } catch (e) {
                var log = {};

                if (e && e.message) {
                    log.err = {
                        'msg': e.message,
                        'stacktrace': !!e.stack ? e.stack : false
                    };
                    sendError(log);
                }

                throw e;
            }
        }
    }

    return func._wrapped;
};

/**
 * By changing the global definition of addEventListener so that it automatically wraps 
 * the callback we can automatically insert `try{ }catch(e){ }` around most code.
 */
var addEventListener = window.EventTarget.prototype.addEventListener;
window.EventTarget.prototype.addEventListener = function (event, callback, bubble) {
    addEventListener.call(this, event, wrap(callback), bubble);
}

/** 
 * We also need to make sure that removeEventListener keeps working. Because the argument 
 * to addEventListener is changed, it won't. Again we only need to fix this on the prototype object:
 */
var removeEventListener = window.EventTarget.prototype.removeEventListener;
window.EventTarget.prototype.removeEventListener = function (event, callback, bubble) {
    removeEventListener.call(this, event, callback._wrapped || callback, bubble);
}
function updateAuthentication(user) {
     if (user) {
          console.log("User logged in");
          console.log(user.profile);
          window.localStorage.setItem('token', user.token_type + ' ' + user.access_token);
          window.localStorage.setItem('user', JSON.stringify(user));
          console.log("Bearer " + user.access_token);
     } else {
          console.log("User not logged in");
          window.localStorage.removeItem('user');
          window.localStorage.removeItem('token');
     }
}

function isAuthenticated() {
     return true == window.localStorage.getItem('token');
}

function getToken() {
     return window.localStorage.getItem('token');
}

function paymentValidation(callback) {

     // -----------------------------------
     // Detailed
     // -----------------------------------
     let xhr = new XMLHttpRequest();
     xhr.open("GET", getConfig().urlApi + "Cliente", true);
     xhr.setRequestHeader('Authorization', getToken());
     xhr.onreadystatechange = function () {

          switch (xhr.readyState) {
               case 1:
                    console.log("readyState: " + xhr.readyState + " UNSENT");
                    break;
               case 2:
                    console.log("readyState: " + xhr.readyState + " OPENED");
                    break;
               case 3:
                    console.log("readyState: " + xhr.readyState + " LOADING");
                    break;
               case 4:
                    console.log("readyState: " + xhr.readyState + " DONE");
                    console.log("status code: " + xhr.status);
                    if (xhr.status === 200) {
                         let data = xhr.responseText;
                         console.log(data);
                         callback(true);
                    } else {
                         callback(false);
                    }
                    break;
          }
     };
     xhr.send();

}
angular.module('fuse').run(['$templateCache', function($templateCache) {$templateCache.put('app/quick-panel/quick-panel.html','<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs="always"><md-tab><md-tab-label><span \ntranslate="QUICKPANEL.TODAY">TODAY</span></md-tab-label><md-tab-body><md-content class="today-tab scrollable" \nms-scroll ng-include="\'app/quick-panel/tabs/today/today-tab.html\'"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate="QUICKPANEL.CHAT">CHAT</span></md-tab-label><md-tab-body><md-content \nclass="chat-tab scrollable" ms-scroll ng-include="\'app/quick-panel/tabs/chat/chat-tab.html\'" \nng-controller="ChatTabController as vm"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate="QUICKPANEL.ACTIVITY">ACTIVITY</span></md-tab-label><md-tab-body><md-content class="activity-tab scrollable" \nms-scroll ng-include="\'app/quick-panel/tabs/activity/activity-tab.html\'"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>');
$templateCache.put('app/core/layouts/content-only.html','<div id="layout-content-only" class="template-layout" layout="column" flex><md-content id="content" \nclass="animate-slide-up md-hue-2" ui-view="content" flex></md-content></div>');
$templateCache.put('app/core/layouts/content-with-toolbar.html','<div id="layout-content-with-toolbar" class="template-layout" layout="column" flex><md-toolbar id="toolbar" \nclass="md-menu-toolbar md-whiteframe-1dp" ui-view="toolbar"></md-toolbar><md-content id="content" \nclass="animate-slide-up md-hue-2" ui-view="content" flex></md-content><md-sidenav id="quick-panel" \nclass="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav>\n</div>');
$templateCache.put('app/core/layouts/horizontal-navigation.html','<div id="layout-horizontal-navigation" class="template-layout" layout="column" flex><div \nid="toolbar-navigation-container" class="md-whiteframe-1dp" layout="column" layout-align="space-between start">\n<md-toolbar id="toolbar" class="md-menu-toolbar md-whiteframe-1dp" ui-view="toolbar"></md-toolbar><div \nid="horizontal-navigation" ui-view="navigation" layout="row" layout-align="start end" flex></div></div><div \nid="content-container" flex layout="column"><md-content id="content" class="animate-slide-up md-hue-2" ms-scroll \nui-view="content" flex></md-content></div><md-sidenav id="quick-panel" class="md-sidenav-right md-whiteframe-4dp" \nmd-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav></div>');
$templateCache.put('app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html','<div id="layout-vertical-navigation-fullwidth-toolbar-2" class="template-layout" layout="column" flex><md-toolbar \nid="toolbar" class="md-menu-toolbar md-whiteframe-1dp md-accent" ui-view="toolbar"></md-toolbar><div \nid="main-container" layout="row" flex><md-sidenav id="vertical-navigation" class="md-primary-bg" \nmd-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="navigation" ms-scroll ui-view="navigation"></md-sidenav><div \nid="content-container" flex layout="column"><md-content id="content" class="animate-slide-up md-hue-2" ms-scroll \nui-view="content" flex></md-content></div><md-sidenav id="quick-panel" class="md-sidenav-right md-whiteframe-4dp" \nmd-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav></div></div>');
$templateCache.put('app/core/layouts/vertical-navigation-fullwidth-toolbar.html','<div id="layout-vertical-navigation-fullwidth-toolbar" class="template-layout" layout="column" flex><md-toolbar \nid="toolbar" class="md-menu-toolbar md-whiteframe-1dp md-accent" ui-view="toolbar"></md-toolbar><div \nid="main-container" layout="row" flex><md-sidenav id="vertical-navigation" class="md-primary-bg" \nmd-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="navigation" ms-scroll ui-view="navigation"></md-sidenav><div \nid="content-container" flex layout="column"><md-content id="content" class="animate-slide-up md-hue-2" ms-scroll \nui-view="content" flex></md-content></div><md-sidenav id="quick-panel" class="md-sidenav-right md-whiteframe-4dp" \nmd-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav></div></div>');
$templateCache.put('app/core/layouts/vertical-navigation.html','<div id="layout-vertical-navigation" class="template-layout" layout="row" flex><md-sidenav id="vertical-navigation" \nclass="md-primary-bg" md-is-locked-open="$mdMedia(\'gt-sm\')" md-component-id="navigation" ms-scroll \nui-view="navigation"></md-sidenav><div id="content-container" flex layout="column"><md-toolbar id="toolbar" \nclass="md-menu-toolbar md-whiteframe-1dp" ui-view="toolbar"></md-toolbar><md-content id="content" \nclass="animate-slide-up md-hue-2" ms-scroll ui-view="content" flex></md-content></div><md-sidenav id="quick-panel" \nclass="md-sidenav-right md-whiteframe-4dp" md-component-id="quick-panel" ms-scroll ui-view="quickPanel"></md-sidenav>\n</div>');
$templateCache.put('app/core/theme-options/theme-options.html','');
$templateCache.put('app/main/confirmar/confirmar.html','<div id="confirmar" layout="column" ms-scroll=""><div id="confirmar-form-wrapper" layout="column" \nlayout-align="center center"><div id="confirmar-form" class="md-whiteframe-8dp"><md-icon \nmd-font-icon="icon-check-circle" class="s50 green-500-fg"></md-icon><h2>Confirma\xE7\xE3o</h2><p>\nEnviamos um e-mail de confirma\xE7\xE3o para o endere\xE7o cadastrado anteriormente. Verifique sua caixa de entrada, por favor.\n</p></div></div></div>');
$templateCache.put('app/main/novo/novo.html','<div id="novo" layout="column" ms-scroll=""><div id="novo-form-wrapper" layout="column" layout-align="start center" \nng-hide="vm.processando"><div id="novo-form" class="md-whiteframe-8dp"><form name="novoForm" novalidate="" \napi-form="vm.api_response_erro"><div class="form-title md-layout-propertie">Cadastro</div><div \napi-form-validation-summary form="novoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" ng-disabled="vm.model.cnpj_cpf.length > 2" layout="row" required>\n<md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button>\n</md-radio-group><div ng-messages="novoForm.pessoa_tipo.$error" ng-show="novoForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.pessoa_tipo.$api.error.message}}\n</div></div></md-input-container><md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 1"><label \ntranslate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" \nui-br-cpf-mask required><div class="errors" ng-messages="novoForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div \nng-message="api_erro">{{novoForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required><div class="errors" \nng-messages="novoForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="minlength">\nN\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">{{novoForm.cnpj_cpf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="NOVO.NAME">Nome</label><input type="text" \nname="nome" ng-model="vm.model.nome" maxlength="50" required><div class="errors" ng-messages="novoForm.nome.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-input-has-value"><label translate="NOVO.CLIENTE">\n</label><md-checkbox name="comprador" ng-model="vm.comprador" ng-checked="true" ng-disabled="true" \nng-change="vm.refreshPerfil(vm.model,vm.comprador,vm.produtor)"><span>Comprador</span></md-checkbox><md-checkbox \nname="produtor" ng-model="vm.produtor" ng-change="vm.refreshPerfil(vm.model,vm.comprador,vm.produtor)"><span>Produtor\n</span></md-checkbox></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="5"><label translate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" \nng-model="vm.model.cliente_telefone.ddd" maxlength="2" ng-pattern="/^[0-9]*$/" required><div class="errors" \nng-messages="novoForm.ddd.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente n\xFAmeros</div><div ng-message="api_erro">{{novoForm.ddd.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" \nng-model="vm.model.cliente_telefone.numero" ui-mask-placeholder-char="space" ui-mask="99999-9999" required><div \nclass="errors" ng-messages="novoForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container flex>\n<label translate="NOVO.EMAIL">E-mail</label><input type="text" name="email" ng-model="vm.model.email" maxlength="40" \nrequired><div class="errors" ng-messages="novoForm.email.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{novoForm.email.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="!vm.showPassword"><label translate="NOVO.PASSWORD">Senha</label><input type="password" id="usuario_senha" \nname="usuario_senha" ng-model="vm.model.usuario_senha" required><div class="errors" \nng-messages="novoForm.usuario_senha.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.usuario_senha.$api.error.message}}</div></div></md-input-container><md-input-container\n flex ng-if="vm.showPassword"><label translate="NOVO.PASSWORD">Senha</label><input type="text" name="usuario_senha" \nng-model="vm.model.usuario_senha" required><div class="errors" ng-messages="novoForm.usuario_senha.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.usuario_senha.$api.error.message}}\n</div></div></md-input-container><md-icon md-font-icon="icon-eye" ng-if="!vm.showPassword" \nng-click="vm.toggleShowPassword()"></md-icon><md-icon md-font-icon="icon-eye-off" ng-if="vm.showPassword" \nng-click="vm.toggleShowPassword()"></md-icon><md-input-container flex ng-if="!vm.showconfirmPassword"><label \ntranslate="NOVO.CONFIRM_PASSWORD">Confirma\xE7\xE3o Senha</label><input type="password" name="confirm_usuario_senha" \nng-model="vm.model.confirm_usuario_senha" pw-check="usuario_senha" required><div class="errors" \nng-messages="novoForm.confirm_usuario_senha.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.confirm_usuario_senha.$api.error.message}}</div></div><div class="msg-block" \nng-show="novoForm.$error"><span class="msg-error" ng-show="novoForm.confirm_usuario_senha.$error.pwmatch">\nSenhas n\xE3o conferem</span></div></md-input-container><md-input-container flex ng-if="vm.showconfirmPassword"><label \ntranslate="NOVO.CONFIRM_PASSWORD">Confirma\xE7\xE3o Senha</label><input type="text" name="confirm_usuario_senha" \nng-model="vm.model.confirm_usuario_senha" pw-check="usuario_senha" required><div class="errors" \nng-messages="novoForm.confirm_usuario_senha.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.confirm_usuario_senha.$api.error.message}}</div></div><div class="msg-block" \nng-show="novoForm.$error"><span class="msg-error" ng-show="novoForm.confirm_usuario_senha.$error.pwmatch">\nSenhas n\xE3o conferem</span></div></md-input-container><md-icon md-font-icon="icon-eye" ng-if="!vm.showconfirmPassword" \nng-click="vm.toggleShowconfirmPassword()"></md-icon><md-icon md-font-icon="icon-eye-off" \nng-if="vm.showconfirmPassword" ng-click="vm.toggleShowconfirmPassword()"></md-icon></div><div \nclass="form-title md-layout-propertie" ng-show="vm.model.pessoa_tipo.id != null">Informa\xE7\xF5es Adicionais</div><div \nlayout="column" layout-gt-xs="row" layout-margin ng-if="vm.model.pessoa_tipo.id==1"><md-input-container \nclass="md-block" flex="30"><input name="rg" ng-model="vm.model.cliente_informacoes_adicionais.rg" maxlength="9" \nminlength="9" ng-pattern="/^[0-9]/" placeholder="RG" required><div class="errors" ng-messages="novoForm.rg.$error"><div\n ng-message="required">Campo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero inv\xE1lido</div><div \nng-message="pattern">Somente n\xFAmeros.</div><div ng-message="api_erro">{{novoForm.rg.$api.error.message}}</div></div>\n</md-input-container><md-input-container><md-datepicker name="data_nascimento" \nng-model="vm.model.cliente_informacoes_adicionais.data_nascimento" md-placeholder="Nascimento" md-current-view="year" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="novoForm.data_nascimento.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.data_nascimento.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin \nng-if="vm.model.pessoa_tipo.id==2"><md-input-container class="md-block" flex><input type="text" name="razao_social" \nng-model="vm.model.cliente_informacoes_adicionais.razao_social" placeholder="Raz\xE3o Social" required><div \nclass="errors" ng-messages="novoForm.razao_social.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.razao_social.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="35"><input type="text" name="inscricao_estadual" \nng-model="vm.model.cliente_informacoes_adicionais.inscricao_estadual" placeholder="Inscri\xE7\xE3o Estadual" required><div \nclass="errors" ng-messages="novoForm.inscricao_estadual.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.inscricao_estadual.$api.error.message}}</div></div></md-input-container></div><div \nclass="form-title md-layout-propertie">Localiza\xE7\xE3o</div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-block" flex="30"><input class="spinner" type="text" name="cep" lm-endereco \nplaceholder="CEP" required ui-br-cep-mask ng-model-options="{ updateOn: \'blur\' }" \nng-model="vm.model.cliente_endereco.cep" ibge="vm.model.ibge" estado="vm.model.cliente_endereco.uf" \ncidade="vm.model.cliente_endereco.cidade_nome" endereco="vm.model.cliente_endereco.endereco" \nbairro="vm.model.cliente_endereco.bairro" loading="cepLoading" ng-disabled="cepLoading"><div class="errors" \nng-messages="novoForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{novoForm.cep.$api.error.message}}</div></div><md-progress-circular \nng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container>\n<md-input-container flex><input type="text" name="cidade_nome" ng-model="vm.model.cliente_endereco.cidade_nome" \nplaceholder="Cidade" ng-disabled="true" required></md-input-container><md-input-container flex="10"><input type="text" \nname="uf" ng-model="vm.model.cliente_endereco.uf" placeholder="UF" ng-disabled="true" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><input \ntype="text" name="endereco" ng-model="vm.model.cliente_endereco.endereco" maxlength="60" placeholder="Endere\xE7o" \nrequired><div class="errors" ng-messages="novoForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{novoForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container\n class="md-block" flex="10"><input type="text" name="numero" ng-model="vm.model.cliente_endereco.numero" \nplaceholder="N\xFAmero" maxlength="5" required><div class="errors" ng-messages="novoForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.numero.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="md-block" flex="20"><input type="text" name="complemento" \nng-model="vm.model.cliente_endereco.complemento" maxlength="20" placeholder="Complemento"><div class="errors" \nng-messages="novoForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{novoForm.complemento.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="20"><input type="text" name="bairro" ng-model="vm.model.cliente_endereco.bairro" maxlength="30" \nplaceholder="Bairro" required><div class="errors" ng-messages="novoForm.bairro.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.bairro.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin layout-align="space-around center" \nid="checkbox"><md-input-container flex><md-checkbox name="termo_uso_aceito" ng-model="vm.model.termo_uso_aceito" \nrequired></md-checkbox><span>Aceitar os <a href="" ng-click="vm.ShowDialogTermos($event)">termos de uso</a></span><div \nng-messages="novoForm.termo_uso_aceito.$error" ng-if="novoForm.termo_uso_aceito.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.termo_uso_aceito.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><md-button class="md-raised md-accent" \nng-disabled="novoForm.$invalid || novoForm.$pristine || vm.isDisabled" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></md-input-container></div></form></div></div><div id="loading-form-wrapper" layout="column" \nlayout-align="center center" ng-show="vm.processando"><div id="loading-form" class="md-whiteframe-8dp"><h2>\nPor favor, aguarde! Estamos processando sua solicita\xE7\xE3o.</h2></div></div></div>');
$templateCache.put('app/main/novo/termos-uso.tmpl.html','<md-dialog class="termos brd-10"><form name="clienteForm" novalidate="" api-form="vm.api_response_erro"><md-toolbar \nclass="termos-header"><div class="md-toolbar-tools"><h1><b>Termos e condi\xE7\xF5es de uso da Eattae</b></h1><p>A <b>Eattae\n</b>\n preparou seus Termos e Condi\xE7\xF5es de uso de maneira simples, tornando transparente como o seu servi\xE7o e suas regras funcionam.\n</p></div></md-toolbar><md-dialog-content><div api-form-validation-summary form="clienteForm"></div><p><b>\nAo dar o seu aceite no momento de cadastro, o USU\xC1RIO concorda com as disposi\xE7\xF5es constantes nos Termos de Uso e Condi\xE7\xF5es e na legisla\xE7\xE3o vigente. Caso n\xE3o concorde com qualquer das disposi\xE7\xF5es elencadas, n\xE3o acesse, cadastra-se, visualize ou realize qualquer forma de uso da PLATAFORMA.\n</b></p><h2>1. DEFINI\xC7\xD5ES IMPORTANTES</h2><p><b>EATTAE:</b> Sociedade limitada com a raz\xE3o social <b>\nEATTAE INTELIGENCIA DIGITAL LTDA.</b>\n, inscrita no CNPJ n\xBA 37.496.303/0001-57, com sede na Avenida Dr. Gast\xE3o Vidigal, n\xBA 1.132, Conjunto n\xBA 701, 702, 703 e 704, Vila Leopoldina, S\xE3o Paulo, capital, CEP n\xBA 05314-000.\n</p><p><b>PLATAFORMA:</b> Sistema web e mobile dispon\xEDvel no site <a target="_blank" \nhref="https://caderno.eattae.com.br/">www.caderno.eattae.com.br/</a>\n e no Google Play que tem como objetivo o cadastro, gest\xE3o financeira, rastreabilidade e gest\xE3o de estoque e insumos relativos ao caderno de campo.\n</p><p><b>USU\xC1RIO MASTER:</b> Pessoa f\xEDsica ou jur\xEDdica que contratou alguma <b>PLANO</b> disponibilizado pela <b>\nEATTAE.</b></p><p><b>USU\xC1RIO:</b> Pessoa f\xEDsica ou jur\xEDdica com login e senha que utiliza a <b>PLATAFORMA</b>\n de acordo com o <b>PLANO</b> contratado.</p><p><b>PLANO:</b> \xC9 a assinatura mensal disponibilizada pela <b>EATTAE</b>\n mediante o pagamento de contrapresta\xE7\xE3o financeira que permitir\xE1 ao <b>USU\xC1RIO MASTER</b> e ao <b>USU\xC1RIO</b>\n usufruirem das funcionalidades da <b>PLATAFORMA.</b></p><h2>2. QUEM \xC9 A EATTAE E O QUE ELA FAZ?</h2><p>A <b>Eattae</b>\n \xE9 licenciante da <b>PLATAFORMA</b> para que o <b>USU\xC1RIO</b>\n possa realizar o controle, gerenciamento e regulariza\xE7\xE3o do seu caderno de campo em todas as fases da cadeia produtiva, atendendo a obrigatoriedade da Instru\xE7\xE3o Normativa Conjunta n\xBA 2/2018 do Minist\xE9rio da Sa\xFAde e da Ag\xEAncia Nacional de Vigil\xE2ncia Sanit\xE1ria ou qualquer outra normal brasileira sobre obrigatoriedadede rastreabilidade de informa\xE7\xF5es produtivas e normas que exijam o tratamentofitossanit\xE1rio adequado e de modo registrado, por meio das seguintes solu\xE7\xF5es:\n</p><p>\u2022 a. <b>Caderno de Campo:</b>\n Controle de todo o manejo da produ\xE7\xE3o: plantio, aplica\xE7\xE3o de insumos e colheita, incluindo o gerenciamento dos custos administrativos da propriedade de maneira integrada, acess\xEDvel esimplificada, bem como a gest\xE3o aprimorada da compra e venda de insumos, suas\xA0entradas\xA0e\xA0sa\xEDdas, reduzindo o desperd\xEDcio\xA0e garantindo melhor\xA0aproveitamento\xA0de defensivos, fertilizantes, sementes, ferramentaria, entre outros, incluindo a disponibiliza\xE7\xE3o do caderno de campo do produtor a todo e qualquer comprador para rastreabilidade.\n</p><p>\u2022 b. <b>Me apresenta:</b> Solu\xE7\xE3o da <b>EATTAE</b>\n que garante a visibilidade deprodutores e distribuidores na internet, criando um canal de contato dequalidade e f\xE1cil acesso com todas as informa\xE7\xF5es de sua propriedade ou distribuidora.\n<br>Adicionalmente, a <b>EATTAE</b> oferece:</p><p>\u2022 c. <b>Rastreamento:</b>\n Registro fase por fase da produ\xE7\xE3o, distribui\xE7\xE3o, etiquetagem, hist\xF3rico do manuseio dos lotes e o compartilhamento dasinforma\xE7\xF5es com o comprador.\n</p><br><p>Quer conhecer mais sobre a hist\xF3ria, miss\xE3o e solu\xE7\xF5es da EATTAE? Saiba mais em <a target="_blank" \nhref="https://caderno.eattae.com.br/sobre-nos">www.eattae.com.br/sobre-nos</a>.</p><h2>3. DO CADASTRO NA PLATAFORMA\n</h2><p>O uso da <b>PLATAFORMA</b>\xA0poder\xE1 ser realizado por qualquer <b>USU\xC1RIO</b> devidamente cadastrado pelo <b>\nUSU\xC1RIO MASTER</b>, desde que haja respectiva possibilidade do cadastro\xA0de novos <b>USU\xC1RIOS</b> conforme o <b>PLANO\n</b> ofertado pela <b>EATTAE</b> e contratado. A <b>EATTAE</b> n\xE3o se obriga a oferecer a op\xE7\xE3o de cadastro de novos \n<b>USU\xC1RIOS</b> pelo <b>USU\xC1RIO MASTER.</b></p><p>Se o <b>USU\xC1RIO MASTER</b> usar a <b>PLATAFORMA</b>\n por meio do seu login e senha, independente da cria\xE7\xE3o ou n\xE3o de <b>USU\xC1RIOS</b>\n adicionais, ser\xE1 considerado para os fins dos presentes Termos de Uso\xA0e\xA0Condi\xE7\xF5es\xA0como\xA0<b>USU\xC1RIO</b>\n, devendo igualmente observar as regras de usabilidade.</p><p>Para ter acesso \xE0 <b>PLATAFORMA</b>, \xE9 necess\xE1rio que o \n<b>USU\xC1RIO MASTER</b> e o <b>USU\xC1RIO</b>\n possuam acesso \xE0 internet e realizem o cadastro pr\xE9vio informando seus dados de identifica\xE7\xE3o ou, de forma integrada, pode o \n<b>USU\xC1RIO MASTER</b> realizar\xA0o\xA0cadastro por meio do servi\xE7o do Google ou do Facebook, realize o login com senha.</p>\n<p>No ato do cadastro ou durante o uso da <b>PLATAFORMA</b>, a <b>EATTAE</b>\n poder\xE1 solicitar informa\xE7\xF5es adicionais ao <b>USU\xC1RIO</b> para validar, legitimar ou identificar o seu acesso.</p><p>\nA <b>EATTAE</b>\n se reserva ao\xA0direito\xA0de\xA0consultar\xA0bases\xA0p\xFAblicas\xA0judiciais ou governamentais,\xA0respeitando\xA0as\xA0normas\xA0e\xA0diretrizes\xA0de prote\xE7\xE3o\xA0de\xA0dados, podendo,\xA0caso\xA0encontre\xA0qualquer\xA0inconsist\xEAncia\xA0cadastral\xA0do\xA0\n<b>USU\xC1RIO MASTER</b>\xA0ou\xA0do\xA0<b>USU\xC1RIO</b>,\xA0recusar\xA0ou\xA0suspender\xA0o\xA0seu\xA0cadastro\xA0na <b>PLATAFORMA.</b>\n Caracterizam\xA0inconsist\xEAncias\xA0cadastrais informa\xE7\xF5es registradas com erros de digita\xE7\xE3o ou informa\xE7\xF5es falsas.</p><p>\nO\xA0tratamento\xA0dos\xA0dados\xA0pessoais\xA0pela\xA0<b>EATTAE</b>\xA0\xE9\xA0realizado\xA0conforme\xA0sua Pol\xEDtica de Privacidade, dispon\xEDvel em <a \ntarget="_blank" href="https://caderno.eattae.com.br/privacidade">www.eattae.com.br/privacidade.</a></p><h2>\n4. DAS REGRAS DE PAGAMENTO</h2><p>O\xA0<b>USU\xC1RIO\xA0MASTER</b>\xA0pode\xA0usar\xA0a\xA0<b>PLATAFORMA</b>\n\xA0por\xA07\xA0(sete)\xA0dias gratuitamente\xA0para\xA0teste,\xA0hip\xF3tese\xA0em\xA0que\xA0n\xE3o\xA0ser\xE1\xA0cobrado nenhum pagamento mensal como remunera\xE7\xE3o, nos termos do artigo 49 do C\xF3digo de Defesa do Consumidor.\n</p><p>A\xA0concess\xE3o\xA0do\xA0per\xEDodo\xA0de\xA0teste\xA0mencionada\xA0n\xE3o\xA0caracteriza,\xA0de\xA0nenhuma\xA0forma,\xA0qualquer\xA0obriga\xE7\xE3o\xA0da\xA0<b>EATTAE\n</b>\xA0em\xA0disponibilizar\xA0a <b>PLATAFORMA</b> de forma gratuita, constituindo referido per\xEDodo mera faculdade da\xA0<b>EATTAE\n</b> para que\xA0o\xA0<b>USU\xC1RIO\xA0MASTER</b> conhe\xE7a\xA0e\xA0experimente\xA0as\xA0funcionalidades\xA0da <b>PLATAFORMA</b>\n, bem como exer\xE7a, caso queira, seu direito de arrependimento, n\xE3o assegurando nenhum direito adquirido ou qualquer hip\xF3tese de garantia de manuten\xE7\xE3o de eventual \n<b>PLANO</b> sem custo ou em condi\xE7\xF5es diferenciadas.</p><p>Ao final do per\xEDodo de teste, o\xA0<b>USU\xC1RIO MASTER</b>\n\xA0dever\xE1 optar pelo\xA0<b>PLANO</b> que\xA0melhor\xA0se\xA0adequa\xA0ao\xA0seu\xA0interesse,\xA0tanto\xA0para\xA0solu\xE7\xE3o\xA0<b>Caderno de Campo</b>\n\xA0como para solu\xE7\xE3o\xA0<b>Me Apresenta</b>, realizando o pagamento da forma ofertada e indicada na <b>PLATAFORMA.</b></p>\n<p>O\xA0<b>USU\xC1RIO MASTER</b>\xA0que n\xE3o realizar a escolha ou o pagamento do <b>PLANO</b>\n n\xE3o poder\xE1 usar, acessar ou visualizar a <b>PLATAFORMA.</b></p><p>O valor do <b>PLANO</b>\n ser\xE1 definido e divulgado na <b>PLATAFORMA</b> antes da efetivacontrata\xE7\xE3o pelo <b>USU\xC1RIO MASTER</b>\n e poder\xE1 ser reajustado periodicamente e de modo unilateral pela <b>EATTAE</b>\n. Eventual reajuste no pre\xE7o ser\xE1 previamente informado\xA0ao\xA0<b>USU\xC1RIO MASTER</b>\n\xA0pelos\xA0meios\xA0de\xA0contato\xA0disponibilizados\xA0na realiza\xE7\xE3o do cadastro com 20 (vinte) dias de anteced\xEAncia.</p><p>Caso o \n<b>USU\xC1RIO MASTER</b> n\xE3o concorde com o reajuste do pagamento, poder\xE1 cancelar o seu cadastro sem custo na <b>\nPLATAFORMA.</b></p><p>A data mensal de cobran\xE7a do <b>PLANO</b>\n ser\xE1 a mesma do dia de contrata\xE7\xE3o nos meses subsequentes.</p><p>A\xA0<b>EATTAE</b>\n\xA0se\xA0reserva\xA0no\xA0direito\xA0de\xA0suspender\xA0temporariamente\xA0o\xA0acesso\xA0do <b>USU\xC1RIO\xA0MASTER</b>\xA0e\xA0demais\xA0<b>USU\xC1RIOS</b>\n\xA0quando\xA0n\xE3o\xA0for\xA0constatado\xA0o pagamento na data devida. Caso o acesso seja suspenso, o <b>USU\xC1RIO MASTER</b> e demais \n<b>USU\xC1RIOS</b>\n ter\xE3o seus direitos de acesso reestabelecidos assim que for constatado o saneamento da eventual pend\xEAncia financeira existente.\n</p><p>Dentro do per\xEDodo de 10 (dez) dias de atraso no pagamento, caso o <b>USU\xC1RIO MASTER</b>\n\xA0tenha\xA0optado\xA0que\xA0cobran\xE7a\xA0seria\xA0efetivada\xA0via\xA0cart\xE3o\xA0de\xA0cr\xE9dito,\xA0a <b>EATTAE</b>\n se reversa no direito de realizar a tentativa autom\xE1tica de cobran\xE7apor 2 (duas) vezes.</p><p>O\xA0<b>USU\xC1RIO\xA0MASTER</b>\n\xA0poder\xE1\xA0a\xA0qualquer\xA0momento\xA0cancelar\xA0o\xA0<b>PLANO</b> contratado, podendo usar a <b>PLATAFORMA</b>\n at\xE9 o fim do ciclo mensal pago.</p><p>Na\xA0hip\xF3tese\xA0de\xA0cancelamento\xA0do\xA0<b>PLANO</b>,\xA0a\xA0conta\xA0do\xA0<b>USU\xC1RIO MASTER</b>\n\xA0se manter\xE1 dispon\xEDvel na\xA0<b>PLATAFORMA</b>\n\xA0com todas as informa\xE7\xF5es existentes na data do cancelamento pelo per\xEDodo de 2 (dois) anos, caso venha futuramente areativar o seu \n<b>PLANO.</b></p><p>A\xA0<b>EATTAE</b>\n\xA0usa\xA0parceiros\xA0de\xA0pagamento\xA0para\xA0suas\xA0opera\xE7\xF5esfinanceiras, portanto,\xA0taxas sobre\xA0o\xA0pagamento\xA0podem\xA0ser\xA0aplic\xE1veis\xA0pelo\xA0terceiro credenciado,\xA0sem\xA0qualquer\xA0vincula\xE7\xE3o com\xA0a\xA0\n<b>PLATAFORMA.</b>\n\xA0Todas\xA0as\xA0taxas devem ser divulgadas e detalhadas de forma clara e expl\xEDcita no momento da contrata\xE7\xE3o.</p><h2>\n5. DAS CONDI\xC7\xD5ES DE USO PELO USU\xC1RIO</h2><p>O <b>USU\xC1RIO MASTER</b> e o <b>USU\xC1RIO</b>\n criado ser\xE3o os \xFAnicos respons\xE1veis pelas opera\xE7\xF5es efetuadas na conta, uma vez que o acesso s\xF3 ser\xE1 poss\xEDvel mediante o uso de senha de exclusivo conhecimento, intransfer\xEDvel e inalien\xE1vel.\xA0Todo\xA0e\xA0qualquer\xA0\n<b>USU\xC1RIO</b>\xA0concorda\xA0em\xA0usar\xA0a\xA0<b>PLATAFORMA</b>\xA0seguindo\xA0as regras a seguir descritas.</p><p>\u2022 a. O <b>USU\xC1RIO</b>\n pessoa f\xEDsica deve ter 18 (dezoito) anos completos ou ser emancipado na forma da lei\xA0para usar a\xA0<b>PLATAFORMA</b>\n.\xA0O menor de 18(dezoito) anos e maior de 12 (doze) anos completos somente poder\xE1 usar a <b>PLATAFORMA</b>\n\xA0mediante\xA0a\xA0autoriza\xE7\xE3o\xA0e\xA0supervis\xE3o\xA0de\xA0seus\xA0pais\xA0ou respons\xE1veis legais.</p><p>\u2022 b. O\xA0<b>USU\xC1RIO</b>\n\xA0pessoa jur\xEDdica deve ter registros legais perante a Junta Comercial\xA0de\xA0seu\xA0respectivo\xA0Estado\xA0e\xA0estar\xA0devidamente cadastrado perante a Receita Federal do Brasil, n\xE3o possuindo nenhuma inconsist\xEAnciaquanto \xE0 sua regularidade ou validade de constitui\xE7\xE3o.\n</p><p>\u2022 c. O <b>USU\xC1RIO</b>\n dever\xE1 fornecer informa\xE7\xF5es verdadeiras e atuais, sendo respons\xE1vel\xA0pela\xA0integridade\xA0e\xA0veracidade\xA0das\xA0informa\xE7\xF5es\xA0inseridas\xA0na \n<b>PLATAFORMA</b>\n, respondendo c\xEDvel e criminalmente pelos efeitos advindos do\xA0uso\xA0irregular\xA0de\xA0informa\xE7\xF5es\xA0de\xA0terceiros\xA0ou\xA0dados\xA0falsos,\xA0incluindo informa\xE7\xF5es\xA0relativas\xA0ao\xA0caderno\xA0de\xA0campo,\xA0nos termos\xA0da\xA0Instru\xE7\xE3o Normativa\xA0Conjunta\xA0n\xBA\xA02/2018\xA0do\xA0Minist\xE9rio\xA0da\xA0Sa\xFAde\xA0e\xA0da\xA0Ag\xEAncia Nacional de Vigil\xE2ncia Sanit\xE1ria ou qualquer outra norma brasileira sobre a obrigatoriedade de rastreabilidade de informa\xE7\xF5es produtivas.\n</p><p>\u2022 d. O <b>USU\xC1RIO</b> dever\xE1 manter seus dados atualizados na <b>PLATAFORMA</b>\n, possibilitando\xA0a\xA0correta\xA0comunica\xE7\xE3o\xA0sobre\xA0as\xA0atividades\xA0e\xA0informa\xE7\xF5es relevantes.</p><p>\u2022 e. O\xA0<b>USU\xC1RIO</b>\n n\xE3o deve\xA0usar\xA0a\xA0<b>PLATAFORMA</b>\n\xA0para\xA0quaisquer\xA0fins\xA0ou meios\xA0ilegais,\xA0difamat\xF3rios,\xA0discriminat\xF3rios,\xA0abusivos,\xA0ofensivos, pornogr\xE1ficos,\xA0obscenos, agressivos,\xA0injuriosos,\xA0vexat\xF3rios,\xA0enganosos, caluniosos,\xA0violentos,\xA0vulgares\xA0ou\xA0de\xA0ass\xE9dio,\xA0amea\xE7a\xA0ou\xA0uso\xA0de\xA0falsa identidade, ou seja, qualquer uso escuso que possa prejudicar a\xA0\n<b>EATTAE</b>, outros\xA0<b>USU\xC1RIOS</b>\xA0ou\xA0terceiros.\xA0O\xA0<b>USU\xC1RIO</b>\xA0n\xE3o\xA0dever\xE1\xA0usar\xA0a <b>PLATAFORMA</b>\n para fins il\xEDcitos, enganosos, fraudulentos ou com finalidade ilegal ou n\xE3o\xA0autorizada,\xA0inclusive\xA0fraudando\xA0os\xA0registros\xA0de\xA0caderno\xA0de campo.\n</p><p>\u2022 f. O <b>USU\xC1RIO</b> concorda em comunicar a <b>EATTAE</b>\n caso perca sua senha ou\xA0conceda\xA0o\xA0seu\xA0acesso\xA0indevidamente\xA0a\xA0terceiros.\xA0A\xA0<b>EATTAE</b>\n\xA0n\xE3o responder\xE1\xA0por\xA0qualquer atividade\xA0realizada\xA0na\xA0conta\xA0do\xA0usu\xE1rio,\xA0caso\xA0o login\xA0tenha sido efetuado com sucesso mediante o uso da senha, mesmo que por terceiro.\n</p><p>\u2022 g. O <b>USU\xC1RIO MASTER</b>\xA0poder\xE1\xA0cadastrar\xA0quantos\xA0<b>USU\xC1RIOS</b>\xA0quiser para o uso da <b>PLATAFORMA</b>\n dentro das op\xE7\xF5es de <b>PLANOS</b> fornecidas.</p><p>\u2022 h. O\xA0<b>USU\xC1RIO</b>\n\xA0se\xA0compromete\xA0a\xA0n\xE3o\xA0violar\xA0os\xA0direitos\xA0de\xA0propriedade intelectual da <b>EATTAE</b>\n, concordando em n\xE3o compartilhar, armazenar, usar de\xA0modo\xA0indevido\xA0ou realizar\xA0qualquer\xA0modo\xA0de\xA0explora\xE7\xE3o\xA0dos\xA0sinais distintivos,\xA0marcas,\xA0diagramas,\xA0fluxogramas,\xA0fotografias,\xA0obras,\xA0gr\xE1ficos, dados,\xA0entre\xA0outras\xA0informa\xE7\xF5es\xA0publicadas\xA0ou disponibilizadas na PLATAFORMA ou em qualquer outro meio pela \n<b>EATTAE</b>.</p><p>\u2022 i. O\xA0<b>USU\xC1RIO</b>\n\xA0se\xA0compromete\xA0a\xA0n\xE3o\xA0acessar,\xA0usar\xA0ou\xA0explorar\xA0de qualquer forma o c\xF3digo-fonte, elementos de programa\xE7\xE3o, scripts, bancos de\xA0dados\xA0ou\xA0qualquer\xA0outro conjunto\xA0de\xA0dados\xA0que\xA0constituam\xA0a \n<b>PLATAFORMA</b>\n,\xA0bem\xA0como\xA0se\xA0compromete\xA0a\xA0n\xE3o\xA0realizar engenharia reversa, traduzir, decompilar, copiar, modificar, reproduzir, alugar, publicar,divulgar,\xA0transmitir,\xA0emprestar,\xA0distribuir\xA0ou,\xA0de\xA0outra\xA0maneira,\xA0dispor inapropriadamente das funcionalidades e c\xF3digos da \n<b>PLATAFORMA</b>.</p><p>\u2022 j. O\xA0<b>USU\xC1RIO</b>\xA0se\xA0compromete\xA0a\xA0n\xE3o\xA0sublicenciar\xA0a\xA0<b>PLATAFORMA</b>\n\xA0a t\xEDtulo gratuito ou mediante a cobran\xE7a de qualquer quantia, respeitando as disposi\xE7\xF5es\xA0constantes\xA0na Lei do\xA0Software\xA0(Lei\xA0n\xBA\xA09.609/1998)\xA0e\xA0Lei\xA0de Direitos Autorais (Lei n\xBA 9.610/1998).\n</p><p>\u2022 k. O\xA0<b>USU\xC1RIO</b>\n\xA0declara\xA0estar\xA0ciente\xA0que\xA0ao\xA0contratar\xA0a\xA0solu\xE7\xE3o\xA0Me Apresenta\xA0seus\xA0dados\xA0ser\xE3o\xA0disponibilizados\xA0em\xA0uma\xA0p\xE1gina\xA0da <b>\nPLATAFORMA</b>\n,\xA0como\xA0uma\xA0esp\xE9cie\xA0de folder digital,\xA0de\xA0acordo\xA0com\xA0a Pol\xEDtica\xA0de\xA0Privacidade\xA0dispon\xEDvel\xA0em www.eattae.com.br/privacidade, isentando\xA0a\xA0\n<b>PLATAFORMA</b>\n\xA0de\xA0qualquer\xA0responsabilidade\xA0pelas informa\xE7\xF5es inseridas ou validadas, incluindo a responsabilidade sobre sua marca, direitos autoras e outros bens imateriais protegidos por propriedade intelectual, em especial por se tratar a PLATAFORMA de intermedi\xE1rio.\n</p><p>\u2022 l. O <b>USU\xC1RIO</b> declara estar ciente que a <b>PLATAFORMA</b>\n poder\xE1 ou n\xE3o validar a informa\xE7\xE3o inserida na solu\xE7\xE3o Me Apresenta por meio de um selo espec\xEDfico,\xA0n\xE3o respondendo\xA0a\xA0\n<b>PLATAFORMA</b>\n\xA0por\xA0qualquer\xA0aus\xEAncia\xA0ou morosidade\xA0da\xA0valida\xE7\xE3o,\xA0sobretudo\xA0em\xA0raz\xE3o\xA0de\xA0informa\xE7\xF5es inconsistentes cadastradas no painel de controle. O selo demonstrar\xE1 que as informa\xE7\xF5es do \n<b>USU\xC1RIO</b> foram autenticadas como preenchidas, mas a <b>EATTAE</b>\n n\xE3o se responsabiliza pelo conte\xFAdo cadastrado, uma vez que n\xE3o h\xE1, de nenhum modo ou sob qualquer circunst\xE2ncia, a an\xE1lise ou filtro doque \xE9 publicado.\n</p><br><p>O\xA0<b>USU\xC1RIO</b>\n\xA0que\xA0descumprir\xA0quaisquer\xA0das\xA0regras\xA0listadas\xA0estar\xE1\xA0sujeito\xA0a suspens\xE3o,\xA0bloqueio\xA0ou\xA0cancelamento\xA0de\xA0sua\xA0conta,\xA0n\xE3o\xA0respondendo\xA0a \n<b>EATTAE</b>\xA0por\xA0quaisquer\xA0danos ou\xA0preju\xEDzos\xA0eventualmente\xA0causados\xA0ao USU\xC1RIO, a outros <b>USU\xC1RIOS</b>\n ou a terceiros. Na hip\xF3tese do cancelamento da conta \xE9\xA0permitido\xA0\xE0\xA0<b>EATTAE</b>\n\xA0realizar\xA0a\xA0cobran\xE7a\xA0integral\xA0do\xA0m\xEAs vigente, encerrando cobran\xE7as posteriores.</p><p>A <b>EATTAE</b>\n se reserva no direito de promover medidas c\xEDveis e criminais em face do\xA0<b>USU\xC1RIO</b>\n\xA0que causar danos materiais ou morais em decorr\xEAncia de sua(s)conduta(s) na <b>PLATAFORMA.</b></p><p>A <b>EATTAE</b>\n se reserva ao direito de n\xE3o permitir novo cadastro de <b>USU\xC1RIO</b>\n que j\xE1\xA0tenha\xA0sido\xA0cancelado,\xA0bloqueado,\xA0exclu\xEDdo\xA0ou\xA0suspenso\xA0da\xA0<b>PLATAFORMA</b>\n por\xA0viola\xE7\xE3o ou\xA0infra\xE7\xE3o\xA0aos\xA0Termos\xA0de\xA0Uso\xA0e\xA0Condi\xE7\xF5es\xA0da\xA0<b>EATTAE</b>\xA0ou\xA0\xE0 legisla\xE7\xE3o vigente, a qualquer \xE9poca.</p>\n<p>O <b>USU\xC1RIO</b> compromete-se a noticiar a <b>EATTAE</b>\n imediatamente por meio dos canais de contato mantidos pela <b>PLATAFORMA</b> qualquer uso n\xE3o autorizado de sua conta.\n</p><h2>6. DA RESPONSABILIDADE DA EATTAE</h2><p>A <b>EATTAE</b> manter\xE1 a <b>PLATAFORMA</b>\n devidamente hospedada e dispon\xEDvel aos seus <b>USU\xC1RIOS</b>\n, sem quaisquer erros ou limita\xE7\xF5es. Ocorrendo alguma indisponibilidade tempor\xE1ria decorrente de manuten\xE7\xE3o ou mesmo gerada por motivo de for\xE7a maior, como, mas n\xE3o somente, desastres naturais,\xA0falhas\xA0nos\xA0sistemas\xA0de\xA0comunica\xE7\xE3o\xA0ou\xA0acesso\xA0\xE0\xA0internet, ataques cibern\xE9ticos\xA0invasivos ou\xA0quaisquer\xA0fatos\xA0de\xA0terceiro\xA0que\xA0fogem\xA0da\xA0esfera\xA0de vigil\xE2ncia e responsabilidade da\xA0\n<b>EATTAE</b>, a\xA0<b>EATTAE</b>\xA0tomar\xE1 todas as atitudes necess\xE1rias e poss\xEDveis para reestabelecer o acesso a <b>\nPLATAFORMA</b> da forma mais\xA0breve\xA0poss\xEDvel,\xA0dentro\xA0das\xA0limita\xE7\xF5es\xA0t\xE9cnicas\xA0e\xA0jur\xEDdicas\xA0as\xA0quais\xA0est\xE1 sujeita.</p><p>O\xA0\n<b>USU\xC1RIO</b>\xA0fica ciente que n\xE3o poder\xE1 pleitear indeniza\xE7\xE3o ou repara\xE7\xE3o de danos\xA0\xE0\xA0<b>EATTAE</b>\xA0no\xA0caso\xA0de\xA0a\xA0<b>\nPLATAFORMA</b>\n\xA0permanecer\xA0fora\xA0do\xA0ar, independente\xA0da\xA0motiva\xE7\xE3o\xA0ou\xA0em virtude\xA0de\xA0a\xE7\xF5es\xA0de\xA0terceiros\xA0que prejudiquem\xA0o\xA0funcionamento\xA0da\xA0\n<b>PLATAFORMA</b>\xA0ou\xA0causem\xA0preju\xEDzos\xA0aos dispositivos utilizados pelo USU\xC1RIO.</p><p>A <b>EATTAE</b>\n igualmente n\xE3o ser\xE1 respons\xE1vel por:</p><p>\u2022 a.\xA0Problemas\xA0nos\xA0dispositivos\xA0de\xA0acesso\xA0do\xA0<b>USU\xC1RIO</b>\n\xA0ou\xA0em\xA0sua conex\xE3o com a internet, ou, ainda, por atos de terceiros mal-intencionados, como\xA0invasores,\xA0que\xA0possam de alguma\xA0forma\xA0danificar\xA0quaisquer dispositivos\xA0ou\xA0sistemas\xA0do\xA0\n<b>USU\xC1RIO</b>\xA0ou\xA0limitar\xA0o\xA0seu\xA0uso\xA0ou\xA0acesso\xA0\xE0 <b>PLATAFORMA</b>.</p><p>\u2022 b. Acessos\xA0n\xE3o\xA0autorizados\xA0na\xA0conta\xA0do\xA0<b>\nUSU\xC1RIO</b>\xA0mediante\xA0senha, cabendo ao <b>USU\xC1RIO</b> a guarda de seus dados de acesso em local seguro.</p><p>\n\u2022 c. Veracidade\xA0ou\xA0legalidade\xA0dos\xA0dados\xA0inseridos\xA0pelo\xA0<b>USU\xC1RIO</b>\xA0na <b>PLATAFORMA</b>, cabendo somente ao <b>\nUSU\xC1RIO</b>\n a obriga\xE7\xE3o de inser\xE7\xE3o dedados que respeitem o disposto nos Termos e na Pol\xEDtica de Privacidade e na\xA0legisla\xE7\xE3o\xA0vigente,\xA0nos\xA0termos\xA0do\xA0Marco\xA0Civil\xA0da\xA0Internet\xA0(Lei\xA0n\xBA12.965/2014).\n</p><p>\n\u2022 d. Quaisquer inconsist\xEAncias existentes no preenchimento dos dados do caderno de campo, nas abas de cadastro, vendas, estoques de insumo oucompras, ambas dispon\xEDveis na \n<b>PLATAFORMA</b>.</p><p>\n\u2022 e. Fraude\xA0no\xA0caderno\xA0de\xA0campo,\xA0nos\xA0termos\xA0da\xA0Instru\xE7\xE3o\xA0Normativa Conjunta\xA0n\xBA\xA02/2018\xA0do\xA0Minist\xE9rio\xA0da\xA0Sa\xFAde\xA0e\xA0da\xA0Ag\xEAncia\xA0Nacional\xA0de Vigil\xE2ncia\xA0Sanit\xE1ria\xA0ou\xA0qualquer\xA0outra norma\xA0brasileira\xA0sobre\xA0a obrigatoriedade de rastreabilidade de informa\xE7\xF5es produtivas.\n</p><p>\u2022 f. Qualquer explora\xE7\xE3o, c\xF3pia, download ou uso indevido por terceiros ou outros\xA0<b>USU\xC1RIOS</b>\n\xA0de\xA0informa\xE7\xF5es,\xA0dados,\xA0sinais\xA0distintivos\xA0ou\xA0marcas disponibilizadas na solu\xE7\xE3o Me Apresenta.</p><p>A\xA0<b>EATTAE</b>\n\xA0somente\xA0ser\xE1\xA0obrigada\xA0a\xA0disponibilizar\xA0registros\xA0de\xA0acesso\xA0ou informa\xE7\xF5es\xA0pessoais,\xA0incluindo\xA0o\xA0IP (Internet Protocol)\xA0de\xA0acesso,\xA0em\xA0sua plataforma,\xA0mediante ordem\xA0judicial\xA0ou\xA0requisi\xE7\xE3o\xA0de\xA0autoridade\xA0policial\xA0ou administrativa\xA0competente,\xA0nos\xA0termos\xA0do\xA0Marco\xA0Civil\xA0da\xA0Internet\xA0(Lei n\xBA12.965/2014), n\xE3o atendendo nenhuma requisi\xE7\xE3o particular.\n</p><p>A\xA0<b>EATTAE</b>\n\xA0n\xE3o\xA0disponibiliza\xA0o\xA0acesso\xA0ao\xA0caderno\xA0de\xA0campo\xA0de\xA0outros USU\xC1RIOS\xA0cadastrados\xA0na\xA0PLATAFORMA,\xA0salvo\xA0mediante\xA0ordem\xA0judicial\xA0ou requisi\xE7\xE3o\xA0de\xA0autoridade policial ou\xA0administrativa\xA0competente,\xA0preservando pelo\xA0segredo de neg\xF3cio,\xA0nos\xA0termos\xA0da\xA0Lei\xA0de\xA0Propriedade\xA0Industrial\xA0(Lei n\xBA9.279/1996).\n</p><h2>7. DOSPOSI\xC7\xD5ES GERAIS</h2><p>Cada <b>USU\xC1RIO</b>\n\xA0ser\xE1\xA0respons\xE1vel\xA0por\xA0acessar,\xA0incluir,\xA0modificar\xA0ou\xA0excluir\xA0as informa\xE7\xF5es cadastradas na <b>PLATAFORMA</b>.</p><p>\nAo\xA0fornecer\xA0dados\xA0na <b>PLATAFORMA</b>, o <b>USU\xC1RIO</b> entende,\xA0concorda\xA0e\xA0aceita que a <b>EATTAE</b>\n poder\xE1 utiliz\xE1-los para realizar melhoramento e aperfei\xE7oamento de sua tecnologia, respeitando o segredo de neg\xF3cio e tratando as informa\xE7\xF5es como confidenciais, n\xE3o compartilhando-as com terceiros n\xE3o autorizados, salvo nas\xA0hip\xF3teses\xA0legalmente\xA0permitidas\xA0mencionadas\xA0nos presentes\xA0Termos\xA0de Uso e Condi\xE7\xF5es.\n</p><p>A <b>EATTAE</b>\n poder\xE1\xA0a\xA0qualquer\xA0tempo,\xA0sem\xA0necessidade\xA0de\xA0aviso\xA0pr\xE9vio\xA0ou contrapartida\xA0indenizat\xF3ria,\xA0editar\xA0ou\xA0excluir\xA0as\xA0funcionalidades\xA0e\xA0menus existentes, bem como incluir novas funcionalidades \xE0 \n<b>PLATAFORMA</b>.</p><p>Todo\xA0o\xA0<b>USU\xC1RIO</b>\n\xA0cadastrado\xA0concorda\xA0em\xA0receber,\xA0via\xA0e-mail,\xA0informa\xE7\xF5es relevantes\xA0sobre\xA0o\xA0funcionamento,\xA0disponibilidade\xA0e\xA0novas\xA0aplica\xE7\xF5es\xA0da \n<b>PLATAFORMA</b>.</p><p>Os Termos de Uso e Condi\xE7\xF5es poder\xE3o ser atualizados e alterados sem aviso pr\xE9vio.\xA0O\xA0<b>\nUSU\xC1RIO</b>\n\xA0ser\xE1\xA0informado\xA0quando\xA0houver\xA0qualquer\xA0altera\xE7\xE3o\xA0ou mudan\xE7a nas regras estabelecidas. A eventual toler\xE2ncia sobre as regras ser\xE1 considerada\xA0mera\xA0liberalidade\xA0e\xA0n\xE3o\xA0ser\xE1\xA0interpretada\xA0como\xA0nova\xE7\xE3o, precedente\xA0invoc\xE1vel,\xA0ren\xFAncia\xA0a\xA0direitos,\xA0altera\xE7\xE3o\xA0t\xE1cita\xA0dos termos contratuais, direito adquirido ou altera\xE7\xE3o contratual.\n</p><p>O <b>USU\xC1RIO</b>\n declara e aceita que ser\xE1 o \xFAnico respons\xE1vel civil e criminalmente para\xA0garantir\xA0o\xA0estrito\xA0cumprimento\xA0da\xA0legisla\xE7\xE3o\xA0em\xA0todos\xA0os\xA0seus\xA0atos, incluindo o cumprimento das legisla\xE7\xF5es Municipais, Estaduais e Federais. O\xA0\n<b>USU\xC1RIO</b>\xA0declara\xA0que\xA0leu\xA0e\xA0concordou\xA0com\xA0todos\xA0os\xA0Termos\xA0de\xA0Uso\xA0e Condi\xE7\xF5es apresentados.</p><p>\nO presente documento\xA0\xE9\xA0regido\xA0pelas Leis Brasileiras e em caso de qualquer conflito, o que a\xA0<b>EATTAE</b>\n espera que n\xE3o ocorra, as partes elegem o Foro da comarca\xA0de\xA0S\xE3o Paulo,\xA0Estado\xA0de\xA0S\xE3o\xA0Paulo,\xA0como\xA0competente\xA0para\xA0dirimir qualquer\xA0d\xFAvida\xA0originada,\xA0renunciando\xA0expressamente qualquer\xA0outro,\xA0por mais privilegiado que o seja.\n</p><p>A\xA0EATTAE\xA0estabelece\xA0o\xA0e-mail\xA0<a href="mailto:suporte@eattae.com.br">suporte@eattae.com.br</a>\n como\xA0seu\xA0canal oficial de SAC, comprometendo-se o consumidor em relatar qualquer problema ou discord\xE2ncia por respectivo meio antes de qualquer outra medida.\n</p></md-dialog-content><md-dialog-actions class="termos termos-footer" layout="row" \nlayout-align="space-between center"><div class="content-buttons wsize-100"><a class="btn btn-quaternary" \nhref="../assets/pdf/termos-v2.pdf" target="_blank"><md-icon md-font-icon="icon-printer" class="s16"></md-icon><span>\nImprimir termo</span></a><md-button class="btn btn-primary btn-lg" ng-click="vm.close()">Fechar</md-button></div>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/principal/principal.html','<div id="principal" layout="column" ms-scroll=" "><div id="principal-form-wrapper" layout="column" \nlayout-align="center center "><div id="principal-form" class="md-whiteframe-8dp"><div class="logo"><img \nclass="logo-compartveg" src="/assets/images/logos/logo.png"></div><div class="title-logo">Compart<strong>veg</strong>\n</div><div class="title">Caderno de campo</div><md-button class="md-raised submit-button" type="submit" \nng-click="vm.gotoNovo()" translate="PRINCIPAL.CREATE_ACCOUNT">LOG IN</md-button><div class="register" layout="row" \nlayout-sm="column" layout-align="center center "><span class="text" translate="PRINCIPAL.ALREADY_HAVE_AN_ACCOUNT">\nDon\'t have an account?</span> <a class="link" href="#" ng-click="vm.goToLogin()" translate="PRINCIPAL.LOGIN ">Login</a>\n</div></div></div></div>');
$templateCache.put('app/core/directives/api-form/api-form-validation-summary.html','<ul class="error-api" ng-if="form && form.$api && form.$api.$errors"><li ng-repeat="erro in form.$api.$errors"><md-icon\n md-font-icon="icon-alert-circle" class="red-600-fg"></md-icon>{{ erro }}</li></ul>');
$templateCache.put('app/core/directives/lm-area-selector/lm-area-selector.directive.html','<div class="md-selecionar-areas"><md-input-container flex="80"><div layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom escolha-areas" flex="40"><label>Escolha as \xE1reas:</label><div layout="column">\n<div class="check-row" flex="100" ng-repeat="area in ngAreas"><md-checkbox ng-model="area.selected" \nng-change="changeState(area)">{{ area.nome }} <span>\n- {{ area.area_produtiva }} ha - {{ area.cultura_nome }} {{ area.variedade_nome }}</span></md-checkbox></div></div><div\n ng-messages="custosForm.area.$error" ng-if="custosForm.area.$touched"><div ng-message="required">Campo Obrigat\xF3rio\n</div><div ng-message="api_erro">{{custosForm.area.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex><label>\xC1reas selecionadas:</label><ul class="itens" \nng-if="ngModel.length > 0"><li ng-repeat="item in ngAreas | filter:{selected:true}"><div class="txt"><h6>\n{{ item.nome }}</h6><span>{{ item.area_produtiva }} ha - {{ item.cultura_nome }} {{ item.variedade_nome }}</span></div>\n<button class="close" ng-click="remover(item)"><i class="fa fa-trash"></i></button></li></ul><ul class="itens" \nng-if="ngModel.length == 0"><li class="area-vazia"><i class="icon-area"></i></li></ul></md-input-container></div>\n</md-input-container><md-input-container flex="20" class="total_hectares"><label>Total hectares:</label><br><input \ntype="text" style="font-weight: bold;" disabled="disabled" ng-model="ngTotalAreaProdutiva | number:4">\n</md-input-container></div>');
$templateCache.put('app/core/directives/lm-banner/lm-banner.directive.html','<div class="ms-responsive-table-wrapper div-banner" ng-show="isShow"><div ng-transclude></div><button \nng-click="close()">Fechar</button></div>');
$templateCache.put('app/core/directives/lm-choose-file/lm-choose-file.directive.html','<style>\nchoose-file{\n     border: 1px solid #BEBEBE !important;\n     padding: 1rem;\n     border-radius: .5rem;\n     margin: 0!important;\n     margin-bottom: 3rem!important;\n  }\n\n  @media screen and (max-width: 600px) {\n    .custom-upload{\n      margin: 0 auto;\n    }\n  }\n\n  .custom-upload md-card{\n    padding: 0;\n    margin:0;\n  }\n  .green-500-bg[disabled] {\n    background-color: #a1bb8daf !important;\n    color: #FFFF !important;\n  }\n\n  .icon-upload:before {\n    color: white;\n  }\n\n  .icon-upload {\n    color: white;\n  }\n\n  .pd {\n    padding: 20px 0px;\n  }\n\n  .md-select-file {\n    font-size: 10px;\n    background-color: #e4e4e4;\n    width: 150px;\n    height: 150px;\n  }\n\n  .image-thumbnail {\n    display: block;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%,-50%);\n  }\n\n  .div-imagem {\n    height: 150px;\n    width: 150px;\n    background: white;\n    margin: 1rem;\n    position: relative;\n  }\n\n  .remover-imagem {\n    position: absolute;\n    top: -20px;\n    right: -5px;\n    width: 40px!important;\n    height: 40px!important;\n    background-color: #f7f7f7;\n    padding: 0.5rem 1rem!important;\n    margin: 0!important;\n  }\n\n  .remover-imagem:hover{\n    background-color: #f7f7f7!important;\n  }\n</style><div class="custom-upload"><input id="fileInput" type="file" class="ng-hide" ng-model="cfileList" \naccept="image/*" multiple="multiple"><md-card md-theme-watch><md-card-actions layout="column" layout-gt-xs="row">\n<md-card class="insumos" ng-repeat="imagem in ngImagesAdded"><div class="div-imagem"><img class="image-thumbnail" \nng-src="{{imagem.url}}"><md-button class="icon-btn md-icon-button remover-imagem" ng-click="imageRemove(imagem)" \naria-label="Remover imagem"><div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs \nmd-direction="left">Excluir</md-tooltip></i></div></md-button></div></md-card><md-card class="insumos" \nng-repeat="file in modelFiles"><div class="div-imagem"><img class="image-thumbnail" ng-src="{{file.filepreview}}">\n<md-button class="icon-btn md-icon-button remover-imagem" ng-click="fileRemove(file)" aria-label="Remover imagem"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></div></md-card><md-card class="insumos" name="cards" \nng-hide="ngImagesAdded.length + files.length + modelFiles.length >= ngMax"><div class="div-imagem"><md-button \nid="uploadButton" class="md-primary md-hue-2 md-select-file" aria-label="Carregar imagem"><i class="far fa-images"></i>\n Carregar fotos</md-button></div></md-card></md-card-actions></md-card><div></div></div>');
$templateCache.put('app/core/directives/lm-choose-image-description/lm-choose-image-description.directive.html','<div class="component"><div class="container"><input id="fileInput" type="file" class="ng-hide" ng-model="cfileList" \naccept="image/*" multiple="multiple"><div class="item" ng-repeat="imagem in ngImagesAdded"><div class="item-content">\n<div class="imagem" flex="25"><img class="thumbnail-description" ng-src="{{imagem.url}}"></div><div class="body" flex>\n<label>Descri\xE7\xE3o</label><textarea class="textarea-descricao" name="descricao" ng-model="imagem.descricao" cols="40" \nrows="3" maxlength="200"></textarea><div class="actions-button"><md-button \nclass="icon-btn md-icon-button remover-imagem" ng-click="imageRemove(imagem)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</div></div></div></div><div class="item" ng-repeat="file in modelFiles"><div class="item-content"><div class="imagem" \nflex="25"><img class="thumbnail-description" ng-if="!file.uploaded_file_id" ng-src="{{file.filepreview}}"> <img \nclass="thumbnail-description" ng-if="file.uploaded_file_id" ng-src="{{file.url}}"></div><div class="body" flex><label>\nDescri\xE7\xE3o</label><textarea class="textarea-descricao" ng-model="file.descricao" name="descricao" cols="40" required \nrows="3" ng-blur="updateDescricao()" maxlength="200"></textarea><div class="actions-button"><md-button \nclass="icon-btn md-icon-button remover-imagem" ng-click="fileRemove(file)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</div></div></div></div></div><div layout="row" layout-align="center center" \nclass="layout-align-center-center layout-row"><a class="btn btn-quaternary" id="uploadButton" \nng-hide="modelFiles.length >= MaxFiles"><md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar mais fotos</a>\n</div></div>');
$templateCache.put('app/core/directives/lm-paginator/lm-paginator.html','<div id="pagination" layout="row" layout-align="end center" ng-show="args.total_rows > 0"><div \nclass="content-pagination"><div class="numeration-page">P\xE1gina <span>{{args.page}}</span> de {{args.total_pages}}</div>\n<md-button class="md-icon-button" ng-disabled="args.page<=1" ng-click="goToPage(-1)" aria-label="Next"><md-icon \nmd-font-icon="icon-chevron-left"></md-icon></md-button><md-button class="md-icon-button" \nng-disabled="args.page >=args.total_pages" ng-click="goToPage(1)" aria-label="Prior"><md-icon \nmd-font-icon="icon-chevron-right"></md-icon></md-button></div></div><div class="paginator" \nng-show="args.total_rows <= 0"><i class="far fa-file-alt"></i><p>Nenhum registro encontrado.</p></div>');
$templateCache.put('app/core/directives/lm-sort/lm-sort-header.html','<button ng-click="_sortBy(field)">{{title}}<md-icon ng-if="args.sort_by==field && args.sort_order==\'asc\'" \nmd-font-icon="icon-arrow-up s18"></md-icon><md-icon ng-if="args.sort_by==field && args.sort_order==\'desc\'" \nmd-font-icon="icon-arrow-down s18"></md-icon></button>');
$templateCache.put('app/core/directives/lm-tooltip/lm-tooltip.directive.html','<div class="lmbanner-tooltip" ng-show="isShow"><div ng-transclude></div><div class="text-right"><button \nng-click="close()">Fechar</button></div></div>');
$templateCache.put('app/core/directives/lm-webapi-table/lm-webapi-table.html','<!DOCTYPE html><html><head><meta charset="utf-8"><title></title></head><body></body></html>');
$templateCache.put('app/core/directives/ms-api-message/ms-api-message.html','<div ng-if="formApi.$erro.message.length >=0" class="api-erros"><div>{{formApi.$erro.message}}</div><div \nng-repeat="erro in formApi.$errors"><span>{{erro}}</span></div></div>');
$templateCache.put('app/core/directives/ms-info-bar/ms-info-bar.html','<div id="ms-info-bar" layout="row" layout-align="start center" flex><div id="ms-info-bar-message" ng-transclude flex>\n</div><md-button id="ms-info-bar-close" class="md-icon-button" aria-label="Close" ng-click="removeInfoBar()"><md-icon \nmd-font-icon="icon-close s24"></md-icon></md-button></div>');
$templateCache.put('app/core/directives/ms-material-color-picker/ms-material-color-picker.html','<md-menu md-position-mode="target-right target"><div ng-click="$mdMenu.open($event)"><ms-color-picker-button><md-button\n aria-label="Row Color" md-menu-origin ng-click="$mdMenu.open($event)" ng-class="vm.selectedColor.class"><span \nng-show="vm.selectedColor.palette">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show="!vm.selectedColor.palette">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass="ms-material-color-picker-menu-content" layout-column><header \nng-class="vm.selectedColor.class || \'md-accent-bg\'" class="md-whiteframe-4dp" layout="row" \nlayout-align="space-between center"><md-button md-prevent-menu-close ng-click="vm.activateHueSelection(false,false)" \nclass="md-icon-button" ng-class="{\'hidden\':!vm.selectedPalette}" aria-label="Palette"><md-icon \nmd-font-icon="icon-arrow-left" class="s20"></md-icon></md-button><span ng-if="vm.selectedColor.palette">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if="!vm.selectedColor.palette">Select Color\n</span><md-button class="remove-color-button md-icon-button" ng-click="vm.removeColor()" aria-label="Remove Color">\n<md-icon md-font-icon="icon-delete" class="s20"></md-icon></md-button></header><div class="colors" ms-scroll><div \nng-show="!vm.selectedPalette" layout="row" layout-wrap><div class="color" ng-class="\'md-\'+palette+\'-500-bg\'" \nng-repeat="(palette, hues) in vm.palettes" ng-click="vm.activateHueSelection(palette,hues)" layout="row" \nlayout-align="start end" md-prevent-menu-close md-ink-ripple><span class="label">{{palette}}</span></div></div><div \nng-show="vm.selectedPalette" layout="row" layout-wrap><div class="color" \nng-class="\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'" ng-repeat="(hue, values) in vm.selectedHues" \nng-click="vm.selectColor(vm.selectedPalette,hue)" layout="row" layout-align="start end" md-ink-ripple><span \nclass="label">{{hue}} </span><i ng-if="vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue" \nclass="s16 icon-check"></i></div></div></div></md-menu-content></md-menu>');
$templateCache.put('app/core/directives/ms-search-bar/ms-search-bar.html','<div flex layout="row" class="custom-search" layout-align="start center"><label for="ms-search-bar-input"><md-button \nclass="ms-search-bar-expander md-icon-button" aria-label="Expand Search Bar" ng-click="MsSearchBar.expand()" \nng-if="!MsSearchBar.resultsLoading || MsSearchBar.collapsed"><md-icon md-font-icon="icon-magnify" class="icon s24">\n</md-icon></md-button><div class="ms-search-bar-loader" layout="row" layout-align="center center" \nng-if="MsSearchBar.resultsLoading && !MsSearchBar.collapsed"><md-progress-circular class="md-accent" md-diameter="32" \nmd-mode="indeterminate"></md-progress-circular></div></label><input id="ms-search-bar-input" type="text" \nplaceholder="Search" flex ng-model="MsSearchBar.query" ng-model-options="MsSearchBar.queryOptions" \nng-blur="MsSearchBar.collapse()" ng-keydown="MsSearchBar.handleKeydown($event)"><md-button \nclass="ms-search-bar-collapser md-icon-button" ng-click="MsSearchBar.collapse()" aria-label="Collapse Search Bar">\n<md-icon md-font-icon="icon-close" class="icon s24"></md-icon></md-button><div class="ms-search-bar-results" \nng-if="MsSearchBar.results" ms-scroll><div class="no-results" ng-if="MsSearchBar.results.length === 0">No Results!\n</div><div class="result" ng-repeat="result in MsSearchBar.results" ng-click="MsSearchBar.handleResultClick(result)" \nng-mouseenter="MsSearchBar.handleMouseenter($index)" ng-mousedown="MsSearchBar.absorbEvent($event)" \nng-class="{\'selected\': $index == MsSearchBar.selectedResultIndex}" md-ink-ripple><div layout="row" \nlayout-align="start center"><div class="icon-container" layout="row" layout-align="center center"><i \nng-if="result.icon" class="icon {{result.icon}}"></i><div ng-if="!result.icon" class="square md-accent-bg"></div></div>\n<div><div class="title">{{result.title}}</div><div class="description" ng-if="result.description">\n{{result.description}}</div></div></div></div></div></div>');
$templateCache.put('app/core/directives/ms-shortcuts/ms-shortcuts.html','<div class="shortcuts-container" layout="row" layout-align="space-between center" flex \nng-class="{\'mobile-bar-active\': MsShortcuts.mobileBarActive}"><div layout="row" layout-align="start center" flex><div \nclass="shortcuts hide show-gt-xs" layout="row" layout-align="start center" ms-scroll \nng-if="MsShortcuts.shortcuts.length > 0" ng-sortable="MsShortcuts.sortableOptions"><div \nng-repeat="shortcut in MsShortcuts.shortcuts" layout="row" layout-align="center center"><md-button \nclass="md-icon-button shortcut" aria-label="{{shortcut.title}}" ui-sref="{{shortcut.uisref}}"><md-icon \nng-if="shortcut.icon" md-font-icon="{{shortcut.icon}}" class="icon s24"></md-icon><div ng-if="!shortcut.icon" \nclass="first-letter">{{shortcut.title.charAt(0)}}</div><md-tooltip hide-xs md-direction="bottom">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset="8 56" class="shortcut-menu hide show-gt-xs"><md-button \nclass="md-icon-button add-shortcut-button" aria-label="Add shortcut" ng-click="$mdMenu.open($event)"><md-icon \nmd-menu-origin md-font-icon="icon-star" class="icon amber-600-fg s24"></md-icon><md-tooltip hide-xs \nmd-direction="bottom">Click to add/remove shortcut</md-tooltip></md-button><md-menu-content><div \nid="ms-shortcut-add-menu"><div class="shortcut-search" layout="row" layout-align="start center"><div \nclass="search-icon" layout="row" layout-align="center center" ng-if="!MsShortcuts.resultsLoading"><md-icon \nmd-menu-align-target md-font-icon="icon-magnify" class="icon s24"></md-icon></div><div class="shortcut-loader" \nlayout="row" layout-align="center center" ng-if="MsShortcuts.resultsLoading"><md-progress-circular class="md-accent" \nmd-diameter="20" md-mode="indeterminate"></md-progress-circular></div><input type="text" placeholder="Search" flex \nng-model="MsShortcuts.query" ng-model-options="MsShortcuts.queryOptions" \nng-keydown="MsShortcuts.handleKeydown($event)"></div><div class="results" ng-if="MsShortcuts.results" ms-scroll><div \nclass="no-results" ng-if="MsShortcuts.results.length === 0">No Results!</div><div class="result" \nng-repeat="result in MsShortcuts.results" ng-click="MsShortcuts.handleResultClick(result)" \nng-mouseenter="MsShortcuts.handleMouseenter($index)" ng-mousedown="MsShortcuts.absorbEvent($event)" \nng-class="{\'selected\': $index == MsShortcuts.selectedResultIndex}" md-prevent-menu-close="md-prevent-menu-close" \nmd-ink-ripple><div layout="row" layout-align="start space-between"><div layout="row" layout-align="start center" flex>\n<div class="icon icon-container" layout="row" layout-align="center center"><i ng-if="result.icon" \nclass="{{result.icon}}"></i><div ng-if="!result.icon" class="square md-accent-bg"></div></div><div><div class="title">\n{{result.title}}</div></div></div><md-icon md-font-icon="icon-pin" class="icon s18" \nng-class="{\'fade-text\': !result.hasShortcut}"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class="md-icon-button toggle-mobile-menu hide-gt-xs" aria-label="Add shortcut" \nng-click="MsShortcuts.toggleMobileBar()"><md-icon md-menu-origin md-font-icon="icon-star" \nclass="icon amber-600-fg s24" ng-hide="MsShortcuts.mobileBarActive"></md-icon><md-icon md-menu-origin \nmd-font-icon="icon-close" class="icon s24" ng-hide="!MsShortcuts.mobileBarActive"></md-icon></md-button></div>');
$templateCache.put('app/navigation/layouts/horizontal-navigation/navigation.html','<div layout="row" layout-align="start center"><ms-navigation-horizontal></ms-navigation-horizontal></div>');
$templateCache.put('app/navigation/layouts/vertical-navigation/navigation.html','<div class="mask-navigation"><md-toolbar class="navigation-header md-whiteframe-1dp" layout="row" \nlayout-align="space-between center"><a href="#" ng-click="vm.gotoAccount()"><img class="image-logo-eattae open-only" \nsrc="/assets/images/logos/logo-eattae.svg"> <img class="image-logo-eattae closed-only" \nsrc="/assets/images/logos/logo-retratil.svg"></a></md-toolbar><md-icon class="fold-toggle s18" \nmd-font-icon="icon-backburger" hide show-gt-sm ng-click="vm.toggleMsNavigationFolded()"></md-icon></div><ms-navigation \nclass="scrollable" folded="vm.folded" ms-scroll="vm.msScrollOptions"></ms-navigation>');
$templateCache.put('app/quick-panel/tabs/activity/activity-tab.html','<md-list class="friends"><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.FRIENDS">Friends</span>\n</md-subheader><md-list-item class="friend md-3-line" ng-repeat="friend in vm.activities.friends"><img \nng-src="{{friend.avatar}}" class="md-avatar" alt="{{friend.name}}"><div class="status {{friend.status}}"></div><div \nng-if="contact.unread" class="md-accent-bg unread-message-count">{{contact.unread}}</div><div \nclass="md-list-item-text"><h3 class="message">{{friend.message}}</h3><p class="time">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class="servers"><md-subheader class="md-no-sticky"><span \ntranslate="QUICKPANEL.APP_SERVERS">Application Servers</span></md-subheader><md-list-item class="server md-3-line" \nng-repeat="server in vm.activities.servers"><md-icon md-font-icon="icon-checkbox-blank-circle" class="s16 status" \nng-class="server.status"></md-icon><div class="md-list-item-text"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class="stats"><md-subheader class="md-no-sticky"><span\n translate="QUICKPANEL.USER_STATS">User Stats</span></md-subheader><md-list-item class="stat md-2-line" \nng-repeat="stat in vm.activities.stats"><div class="md-list-item-text"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class="stat.status" \nmd-mode="determinate" value="{{stat.percent}}"></md-progress-linear></div></md-list-item></md-list>');
$templateCache.put('app/quick-panel/tabs/chat/chat-tab.html','<div class="main animate-slide-left" ng-hide="vm.chatActive"><md-list class="recent"><md-subheader \nclass="md-no-sticky"><span translate="QUICKPANEL.RECENT">Recent</span></md-subheader><md-list-item \nclass="contact md-3-line" ng-repeat="contact in vm.contacts.recent" ng-click="vm.toggleChat(contact)"><img \nng-src="{{contact.avatar}}" class="md-avatar" alt="{{contact.name}}"><div class="status {{contact.status}}"></div><div \nng-if="contact.unread" class="md-accent-bg unread-message-count">{{contact.unread}}</div><div \nclass="md-list-item-text"><h3>{{contact.name}}</h3><p class="last-message">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class="all"><md-subheader class="md-no-sticky"><span \ntranslate="QUICKPANEL.START_NEW_CHAT">Start New Chat</span></md-subheader><md-list-item class="contact" \nng-repeat="contact in vm.contacts.all" ng-click="vm.toggleChat(contact)"><img ng-src="{{contact.avatar}}" \nclass="md-avatar" alt="{{contact.name}}"><div class="status {{contact.status}}"></div><div class="md-list-item-text">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass="chat animate-slide-right" ng-show="vm.chatActive" layout="column"><md-toolbar class="md-accent"><div \nclass="md-toolbar-tools" layout="row" layout-align="space-between center"><div layout="row" \nlayout-align="start center"><md-button class="md-icon-button" ng-click="vm.toggleChat()" aria-label="Back" translate \ntranslate-attr-aria-label="QUICKPANEL.BACK"><md-icon md-font-icon="icon-keyboard-backspace"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout="row" layout-align="end center"><md-button \nclass="md-icon-button" aria-label="Call" translate translate-attr-aria-label="QUICKPANEL.CALL"><md-icon \nmd-font-icon="icon-phone"></md-icon></md-button><md-button class="md-icon-button" aria-label="More" translate \ntranslate-attr-aria-label="QUICKPANEL.MORE"><md-icon md-font-icon="icon-dots-vertical"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id="chat-dialog"><div layout="row" \nng-repeat="dialog in vm.chat.contact.dialog" class="md-padding message-row" ng-class="dialog.who"><img \nng-if="dialog.who ===\'contact\'" ng-src="{{vm.chat.contact.avatar}}" class="avatar" alt="{{vm.chat.contact.name}}"> <img\n ng-if="dialog.who ===\'user\'" class="avatar" src="assets/images/avatars/profile.jpg"><div class="bubble" flex><div \nclass="message">{{dialog.message}}</div><div class="time secondary-text">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit="vm.reply()" layout="row" class="reply" layout-align="start center"><textarea \nng-keyup="$event.keyCode == 13 ? vm.reply() : null" flex ng-model="vm.replyMessage" \nplaceholder="Type and hit enter to send message" translate translate-attr-placeholder="QUICKPANEL.REPLY_PLACEHOLDER">\n</textarea><md-button class="md-fab md-mini" type="submit" aria-label="Send message" translate \ntranslate-attr-aria-label="QUICKPANEL.SEND_MESSAGE"><md-icon md-font-icon="icon-send" class="s16"></md-icon>\n</md-button></form></div>');
$templateCache.put('app/quick-panel/tabs/today/today-tab.html','<md-list class="date"><md-subheader class="md-no-sticky"><span translate="QUICKPANEL.TODAY">Today</span></md-subheader>\n<md-list-item class="md-display-1 md-2-line"><div class="secondary-text"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout="row" layout-align="start start"><span>{{vm.date | date:\'d\'}}</span> <span class="md-subhead">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass="md-no-sticky"><span translate="QUICKPANEL.EVENTS">Events</span></md-subheader><md-list-item class="md-2-line" \nng-repeat="event in vm.events" ng-click="dummyFunction()"><div class="md-list-item-text"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass="md-no-sticky"><span translate="QUICKPANEL.NOTES">Notes</span></md-subheader><md-list-item class="md-2-line" \nng-repeat="note in vm.notes" ng-click="dummyFunction()"><div class="md-list-item-text"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class="md-no-sticky">\n<span translate="QUICKPANEL.QUICK_SETTINGS">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate="QUICKPANEL.NOTIFICATIONS">Notifications</h3><md-switch class="md-secondary" ng-model="vm.settings.notify" \naria-label="Notifications" translate translate-attr-aria-label="QUICKPANEL.NOTIFICATIONS"></md-switch></md-list-item>\n<md-list-item><h3 translate="QUICKPANEL.CLOUD_SYNC">Cloud Sync</h3><md-switch class="md-secondary" \nng-model="vm.settings.cloud" aria-label="Cloud Sync" translate translate-attr-aria-label="QUICKPANEL.CLOUD_SYNC">\n</md-switch></md-list-item><md-list-item><h3 translate="QUICKPANEL.RETRO_THRUSTERS">Retro Thrusters</h3><md-switch \nclass="md-secondary md-warn" ng-model="vm.settings.retro" aria-label="Retro Thrusters" translate \ntranslate-attr-aria-label="QUICKPANEL.RETRO_THRUSTERS"></md-switch></md-list-item></md-list>');
$templateCache.put('app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html','<ms-navigation class="scrollable" folded="vm.folded" ms-scroll="vm.msScrollOptions"></ms-navigation>');
$templateCache.put('app/toolbar/layouts/horizontal-navigation/toolbar.html','<div class="top-row" layout="row" layout-align="space-between center"><div layout="row" layout-align="start center">\n<div class="navigation-toggle" hide-gt-sm><md-button class="md-icon-button" ng-click="vm.toggleHorizontalMobileMenu()" \naria-label="Toggle Mobile Navigation"><md-icon md-font-icon="icon-menu"></md-icon></md-button></div><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">F</span> <span class="logo-text">FUSE</span></div>\n</div><div layout="row" layout-align="start center"><md-progress-circular id="toolbar-progress" \nng-if="$root.loadingProgress" class="md-accent" md-mode="indeterminate" md-diameter="32"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon aria-label="user" aria-label="user icon" ng-style="{\'color\': vm.userStatus.color }" \nclass="icon status s16"></md-icon></div><span class="username" hide-sm>John Doe</span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16" hide-sm></md-icon></div></md-button><md-menu-content width="3">\n<md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon">\n</md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon \nmd-font-icon="icon-email" class="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item \nclass="md-indent"><md-icon md-font-icon aria-label="user" aria-label="user icon" \nng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu id="user-status-menu"><md-button \nng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">{{vm.userStatus.title}}</md-button>\n<md-menu-content width="2"><md-menu-item class="status md-indent" ng-class="{\'selected\': status === vm.userStatus}" \nng-repeat="status in vm.userStatusOptions"><md-icon md-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" \nclass="icon"></md-icon><md-button ng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon \nmd-font-icon="icon-logout" class="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><ms-search-bar on-search="vm.search(query)" \non-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><md-menu id="language-menu" \nmd-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" ng-click="$mdMenu.open()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nclass="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<md-button id="quick-panel-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'quick-panel\')" \naria-label="Toggle quick panel" translate translate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon \nmd-font-icon="icon-format-list-bulleted" class="icon"></md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation/toolbar.html','<div layout="row" layout-align="start center"><div class="menu-l" layout="row" layout-align="start center" flex>\n<md-button id="navigation-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm \naria-label="Toggle navigation" translate translate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon \nmd-font-icon="icon-menu" class="icon"></md-icon></md-button><div class="avisos_assinatura" \nng-class="[vm.status_assinatura, {activedmenu: vm.openMenuPropriedade}]"><div class="infos"><div class="ico" \nng-click="vm.openAviso()"><span class="ball-mobile"></span> <img src="assets/images/svg/ico-propriedade.svg" \nalt="proriedade"></div><div class="txt" id="content-aviso-assinatura"><div class="close d-mobile" \nng-click="vm.closeAviso()"><i class="fas fa-times"></i></div><h4>Propriedade: <span ng-if="vm.propriedade">\n{{ vm.propriedade.nome }}</span> <small ng-if="!vm.propriedade">N\xE3o cadastrada.</small></h4><div class="aviso-content">\n<span class="ball"></span> <span class="aviso" \nng-if="vm.assinatura_vencida && vm.isLessOrEqualDate(vm.assinatura.data_final_periodo,vm.date5)">\nSua assinatura vence EM {{ vm.assinatura_vencida.dias_ate_vencimento | date:\'dd\' }} DIAS ({{vm.assinatura_vencida.data_final_periodo | date:\'dd/MM/yyyy\' }}) - Renove agora seu plano, \n<a href="{{vm.urlGerenciarlicenca}}">clique aqui</a> </span><span class="aviso" \nng-if="vm.assinatura_vencida && !vm.isLessOrEqualDate(vm.assinatura.data_final_periodo,vm.date5) && vm.isLessOrEqualDate(vm.assinatura.data_final_periodo,vm.date15)">\nSua assinatura vencer\xE1 dia {{vm.assinatura_vencida.data_final_periodo | date:\'dd/MM/yyyy\' }} - Renove seu plano, <a \nhref="{{vm.urlGerenciarlicenca}}">clique aqui</a> </span><span class="aviso" \nng-if="!vm.assinatura_vencida && vm.assinatura">Assinatura ativa - <span>\nRenova em {{ vm.assinatura.data_final_periodo | date:\'dd/MM/yyyy\' }}</span> </span><span class="aviso" \nng-if="!vm.assinatura_vencida && !vm.assinatura">Sua assinatura expirou.</span></div><h3 class="d-mobile text-bold">\nAlterar propriedade:</h3><div class="select-propriedade"><ul><li ng-repeat="item in vm.propriedades" \nng-click="vm.selectPropriedade(item.id)">{{ item.nome }}</li><li ng-if="!vm.propriedade" \nng-click="vm.gotoPropriedadeAdd()">Clique aqui para cadastrar uma propriedade</li></ul></div></div></div><button \nclass="d-desk" ng-click="vm.togglePropriedade()"><i class="fas fa-chevron-down"></i></button></div></div><div \nclass="logo" layout="row" layout-align="center"><img md-menu-align-target \nsrc="assets/images/svg/ico-mobile-eattae.svg"></div><div class="menu-r" layout="row" layout-align="start center" \nclass="caderno-campo"><md-progress-circular id="toolbar-progress" ng-disabled="!$root.loadingProgress" \nclass="md-accent" md-diameter="32"></md-progress-circular><md-menu-bar id="user-menu"><md-button \nng-show="!vm.isAuthenticated" ng-click="vm.login()" class="user-button" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.LOGIN"><div layout="row" layout-align="space-between center"><span hide show-gt-sm>\nLogin</span></div></md-button><md-menu ng-show="vm.isAuthenticated" md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/avatar.svg"><div \nclass="txt"><strong>Ol\xE1, {{vm.nickname}}<br>{{vm.clientePerfil.nome}}</strong><br>Minha conta</div></div></div>\n</md-button><md-menu-content width="3" class="user-menu"><md-menu-item class="md-indent"><i class="fas fa-user-alt">\n</i><md-button ng-click="vm.gotoGerenciarlicenca()">Minha conta</md-button></md-menu-item><md-menu-item \nclass="md-indent"><i class="fas fa-key"></i><md-button ng-click="vm.gotoAlterarSenha()">Alterar senha</md-button>\n</md-menu-item><md-menu-item class="md-indent"><img src="assets/icons/ico-cliente-menu.svg"><md-button \nng-click="vm.gotoCredenciados()">Credenciados</md-button></md-menu-item><md-menu-item ng-if="vm.isDeveloperUser" \nclass="md-indent"><i class="fas fa-lock-open"></i><md-button class="font-weight-semibold" \nng-click="vm.silentRefresh()">Refresh token</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item \nclass="md-indent eattae_green"><i class="fas fa-sign-out-alt eattae_green"></i><md-button class="font-weight-semibold" \nng-click="vm.logout()">Sair</md-button></md-menu-item></md-menu-content></md-menu></md-menu-bar><md-menu-bar \nid="apps-menu user-menu" class="menu-solucoes"><md-menu ng-show="vm.isAuthenticated" md-position-mode="left bottom" \nclass="nav-user ferramentas_user"><md-button class="user-button" ng-click="$mdMenu.open()" aria-label="User settings" \ntranslate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><a class="nav-user-item"><img class="nav-item-icon" \nsrc="assets/images/svg/ico-menu-product.svg"></a></md-button><md-menu-content class="menu-solutions" \naria-labelledby="menu-solutions"><div class="menuApplication"><div class="menuApplication-header"><span>Solu\xE7\xF5es</span>\n <a class="menuApplication-close" ng-click="$mdMenu.close()"><img src="assets/images/svg/ico-close.svg"></a></div><div \nclass="menuApplication-body"><ul><li ng-click="vm.gotoComprador()" ng-if="vm.clientePerfil.is_rastreabilidade"><div \nclass="ico-border-radius caderno-campo"><img src="assets/images/svg/ico-produto-rastreamento.svg" alt="Comprador">\n</div><span>Rastreabilidade</span></li><li class="desabled" ng-if="!vm.clientePerfil.is_rastreabilidade"><div \nclass="ico-border-radius caderno-campo"><img src="assets/images/svg/ico-produto-rastreamento.svg" alt="Comprador">\n</div><span>Rastreabilidade</span></li><li ng-if="vm.clientePerfil.is_caderno_de_campo"><div \nclass="ico-border-radius caderno-campo"><img src="assets/images/svg/ico-caderno-de-campo.svg" alt="Caderno de Campo">\n</div><span>Caderno de campo</span></li><li class="desabled" ng-if="!vm.clientePerfil.is_caderno_de_campo"><div \nclass="ico-border-radius caderno-campo"><img src="assets/images/svg/ico-caderno-de-campo.svg" alt="Caderno de Campo">\n</div><span>Caderno de campo</span></li><li ng-click="vm.gotoMeapresenta()" ng-if="vm.clientePerfil.is_me_apresenta">\n<div class="ico-border-radius caderno-campo"><img src="assets/images/svg/ico-me-apresenta.svg" alt="Me apresenta">\n</div><span>Me apresenta</span></li><li class="desabled" ng-if="!vm.clientePerfil.is_me_apresenta"><div \nclass="ico-border-radius caderno-campo"><img src="assets/images/svg/ico-me-apresenta.svg" alt="Me apresenta"></div>\n<span>Me apresenta</span></li><li ng-click="vm.gotoGestaoRede()" ng-if="vm.clientePerfil.is_credenciador"><div \nclass="ico-border-radius caderno-campo"><img src="assets/icons/ico-gestao-de-rede.svg" alt="Gest\xE3o de rede"></div>\n<span>Gest\xE3o de rede</span></li><li class="desabled" ng-if="!vm.clientePerfil.is_credenciador"><div \nclass="ico-border-radius caderno-campo"><img src="assets/icons/ico-gestao-de-rede.svg" alt="Gest\xE3o de rede"></div>\n<span>Gest\xE3o de rede</span></li><li ng-click="vm.gotoGerenciarlicenca()" ng-if="vm.clientePerfil.is_administrador"><div\n class="ico-border-radius gerenciar-licencas"><img src="assets/images/svg/ico-gerenciar-licenca.svg" \nalt="Gerenciar assinatura"></div><span>Gerenciar assinatura</span></li><li class="desabled" \nng-if="!vm.clientePerfil.is_administrador"><div class="ico-border-radius gerenciar-licencas"><img \nsrc="assets/images/svg/ico-gerenciar-licenca.svg" alt="Gerenciar assinatura"></div><span>Gerenciar assinatura</span>\n</li></ul></div></div></md-menu-content></md-menu></md-menu-bar></div></div><div style="visibility: hidden"><div \nclass="md-dialog-container" id="DialogAssinaturaVencida"><md-dialog><div class="container-modal-avisos"><div \nclass="header"><div class="col-close"><p>Ol\xE1, {{vm.nickname}}.</p><a href="#" class="close" \nng-click="vm.closeVencimentoModal()">X</a></div><h4>Est\xE1 na hora de <strong>renovar seu plano anual.</strong></h4>\n</div><p>Seu plano <b>vence dia {{vm.assinatura_vencida.data_final_periodo | date:\'dd/MM/yyyy\' }}</b>\n e para n\xE3o perder seu acesso a nossa ferramenta agilize a sua renova\xE7\xE3o.</p><div class="footer"><form name="areaForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><md-button md-button-id="bttnCdstr" type="button" \nclass="btn btn-primary" aria-label="Submit" ng-click="vm.gotoGerenciarlicenca()">Renovar assinatura</md-button><br>\n<md-input-container class="md-input-has-value"><md-checkbox name="check" ng-checked="checked" \nng-model="vm.vencimento.check"><span><strong>J\xE1 renovei a assinatura.</strong></span></md-checkbox>\n</md-input-container></form></div></div></md-dialog></div></div>');
$templateCache.put('app/toolbar/layouts/content-with-toolbar/toolbar.html','<div layout="row" layout-align="space-between center"><div layout="row" layout-align="start center"><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">F</span> <span class="logo-text">FUSE</span></div>\n<div class="toolbar-separator"></div><ms-shortcuts></ms-shortcuts><div class="toolbar-separator"></div></div><div \nlayout="row" layout-align="start center"><md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" \nclass="md-accent" md-mode="indeterminate" md-diameter="32"></md-progress-circular><div class="toolbar-separator"></div>\n<md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button class="user-button" \nng-click="$mdMenu.open()" aria-label="User settings" translate translate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div \nlayout="row" layout-align="space-between center"><div class="avatar-wrapper"><img md-menu-align-target class="avatar" \nsrc="assets/images/avatars/profile.jpg"><md-icon md-font-icon aria-label="user" aria-label="user icon" \nng-style="{\'color\': vm.userStatus.color }" class="icon status s16"></md-icon></div><span class="username" hide-sm>\nJohn Doe</span><md-icon md-font-icon="icon-chevron-down" class="icon s16" hide-sm></md-icon></div></md-button>\n<md-menu-content width="3"><md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon \nmd-font-icon="icon-account" class="icon"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass="md-indent" ui-sref="app.mail"><md-icon md-font-icon="icon-email" class="icon"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class="md-indent"><md-icon md-font-icon aria-label="user" \naria-label="user icon" ng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu \nid="user-status-menu"><md-button ng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">\n{{vm.userStatus.title}}</md-button><md-menu-content width="2"><md-menu-item class="status md-indent" \nng-class="{\'selected\': status === vm.userStatus}" ng-repeat="status in vm.userStatusOptions"><md-icon \nmd-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" class="icon"></md-icon><md-button \nng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon md-font-icon="icon-logout" \nclass="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class="toolbar-separator"></div><ms-search-bar on-search="vm.search(query)" \non-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><div class="toolbar-separator"></div>\n<md-menu id="language-menu" md-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" \nng-click="$mdMenu.open()" aria-label="Language" md-menu-origin md-menu-align-target><div layout="row" \nlayout-align="center center"><img class="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span \nclass="iso">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class="toolbar-separator"></div><md-button id="quick-panel-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html','<div layout="row" layout-align="start center"><div layout="row" layout-align="start center" flex><div class="logo" \nlayout="row" layout-align="start center"><span class="logo-image">F</span> <span class="logo-text">FUSE</span></div>\n<div class="toolbar-separator"></div><md-button id="navigation-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm aria-label="Toggle navigation" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon md-font-icon="icon-menu" class="icon"></md-icon>\n</md-button><md-button class="md-icon-button navigation-fold-toggle" hide show-gt-sm \naria-label="Toggle navigation fold" translate translate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION_FOLD" \nng-click="vm.toggleMsNavigationFolded()"><md-icon class="s18" md-font-icon="icon-backburger"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class="toolbar-separator"></div></div><div layout="row" layout-align="start center">\n<md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" md-mode="indeterminate" \nmd-diameter="32"></md-progress-circular><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon aria-label="user" aria-label="user icon" ng-style="{\'color\': vm.userStatus.color }" \nclass="icon status s16"></md-icon></div><span class="username" hide-sm>John Doe</span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16" hide-sm></md-icon></div></md-button><md-menu-content width="3">\n<md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon">\n</md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon \nmd-font-icon="icon-email" class="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item \nclass="md-indent"><md-icon md-font-icon aria-label="user" aria-label="user icon" \nng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu id="user-status-menu"><md-button \nng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">{{vm.userStatus.title}}</md-button>\n<md-menu-content width="2"><md-menu-item class="status md-indent" ng-class="{\'selected\': status === vm.userStatus}" \nng-repeat="status in vm.userStatusOptions"><md-icon md-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" \nclass="icon"></md-icon><md-button ng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon \nmd-font-icon="icon-logout" class="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class="toolbar-separator"></div><ms-search-bar \non-search="vm.search(query)" on-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><div \nclass="toolbar-separator"></div><md-menu id="language-menu" md-offset="0 72" md-position-mode="target-right target">\n<md-button class="language-button" ng-click="$mdMenu.open()" aria-label="Language" md-menu-origin md-menu-align-target>\n<div layout="row" layout-align="center center"><img class="flag" \nng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width="3" id="language-menu-content"><md-menu-item \nng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" aria-label="{{lang.title}}" \ntranslate translate-attr-aria-label="{{lang.title}}"><span layout="row" layout-align="start center"><img class="flag" \nng-src="assets/images/flags/{{lang.flag}}.png"> <span translate="{{lang.translation}}">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class="toolbar-separator"></div><md-button \nid="quick-panel-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'quick-panel\')" \naria-label="Toggle quick panel" translate translate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon \nmd-font-icon="icon-format-list-bulleted" class="icon"></md-icon></md-button></div></div>');
$templateCache.put('app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html','<div layout="row" layout-align="start center"><div layout="row" layout-align="start center" flex><md-button \nid="navigation-toggle" class="md-icon-button" ng-click="vm.toggleSidenav(\'navigation\')" hide-gt-sm \naria-label="Toggle navigation" translate translate-attr-aria-label="TOOLBAR.TOGGLE_NAVIGATION"><md-icon \nmd-font-icon="icon-menu" class="icon"></md-icon></md-button><ms-search-bar on-search="vm.search(query)" \non-result-click="vm.searchResultClick(item)" debounce="300"></ms-search-bar><div class="toolbar-separator"></div>\n<ms-shortcuts></ms-shortcuts><div class="toolbar-separator"></div></div><div layout="row" layout-align="start center">\n<md-progress-circular id="toolbar-progress" ng-if="$root.loadingProgress" class="md-accent" md-mode="indeterminate" \nmd-diameter="32"></md-progress-circular><md-menu-bar id="user-menu"><md-menu md-position-mode="left bottom"><md-button \nclass="user-button" ng-click="$mdMenu.open()" aria-label="User settings" translate \ntranslate-attr-aria-label="TOOLBAR.USER_SETTINGS"><div layout="row" layout-align="space-between center"><div \nclass="avatar-wrapper"><img md-menu-align-target class="avatar" src="assets/images/avatars/profile.jpg"><md-icon \nmd-font-icon aria-label="user" aria-label="user icon" ng-style="{\'color\': vm.userStatus.color }" \nclass="icon status s16"></md-icon></div><span class="username" hide-sm>John Doe</span><md-icon \nmd-font-icon="icon-chevron-down" class="icon s16" hide-sm></md-icon></div></md-button><md-menu-content width="3">\n<md-menu-item class="md-indent" ui-sref="app.pages_profile"><md-icon md-font-icon="icon-account" class="icon">\n</md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item class="md-indent" ui-sref="app.mail"><md-icon \nmd-font-icon="icon-email" class="icon"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item \nclass="md-indent"><md-icon md-font-icon aria-label="user" aria-label="user icon" \nng-style="{\'color\': vm.userStatus.color }" class="icon"></md-icon><md-menu id="user-status-menu"><md-button \nng-click="$mdMenu.open()" class="status" ng-class="vm.userStatus.class">{{vm.userStatus.title}}</md-button>\n<md-menu-content width="2"><md-menu-item class="status md-indent" ng-class="{\'selected\': status === vm.userStatus}" \nng-repeat="status in vm.userStatusOptions"><md-icon md-font-icon="{{status.icon}}" ng-style="{\'color\': status.color }" \nclass="icon"></md-icon><md-button ng-click="vm.setUserStatus(status)">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class="md-indent"><md-icon \nmd-font-icon="icon-logout" class="icon"></md-icon><md-button ng-click="vm.logout()">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class="toolbar-separator"></div><md-menu id="language-menu" \nmd-offset="0 72" md-position-mode="target-right target"><md-button class="language-button" ng-click="$mdMenu.open()" \naria-label="Language" md-menu-origin md-menu-align-target><div layout="row" layout-align="center center"><img \nclass="flag" ng-src="assets/images/flags/{{vm.selectedLanguage.flag}}.png"> <span class="iso">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width="3" id="language-menu-content">\n<md-menu-item ng-repeat="(iso, lang) in vm.languages"><md-button ng-click="vm.changeLanguage(lang)" \naria-label="{{lang.title}}" translate translate-attr-aria-label="{{lang.title}}"><span layout="row" \nlayout-align="start center"><img class="flag" ng-src="assets/images/flags/{{lang.flag}}.png"> <span \ntranslate="{{lang.translation}}">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class="toolbar-separator"></div><md-button id="quick-panel-toggle" class="md-icon-button" \nng-click="vm.toggleSidenav(\'quick-panel\')" aria-label="Toggle quick panel" translate \ntranslate-attr-aria-label="TOOLBAR.TOGGLE_QUICK_PANEL"><md-icon md-font-icon="icon-format-list-bulleted" class="icon">\n</md-icon></md-button></div></div>');
$templateCache.put('app/main/agenda_visitas/views/avaliar.html','<div class="container-header"><div class="breadcrumb"><h1>Agendamento de visitas > Valida\xE7\xE3o da visita</h1></div></div>\n<div id="forms" class="page-layout simple fullwidth agenda-visitas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/visitas/ico-agendamento-br.svg"></span>INFORMA\xC7\xD5ES DA VISITA</h3></div><div \nclass="content-register"><form name="visitaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro">\n<fieldset><md-card><div api-form-validation-summary form="visitaForm"></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="20"><label>Status</label><br><div class="marcador marcador-verde" \nng-if="vm.model.realizado == 1"><span></span><strong>Realizado</strong></div><div class="marcador marcador-amarelo" \nng-if="!vm.model.realizado"><span></span><strong>Planejado</strong></div><div class="marcador marcador-cinza" \nng-if="vm.model.realizado == 0"><span></span><strong>N\xE3o realizado</strong></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="15"><label>Data da visita</label><md-datepicker name="data" \nng-model="vm.model.data" disabled="disabled"></md-datepicker></md-input-container><md-input-container flex="20"><label>\nHor\xE1rio</label><input type="text" name="hora" ng-model="vm.model.hora" disabled="disabled"></md-input-container>\n<md-input-container flex><label>Consultor</label><input type="text" name="consultor" ng-model="vm.model.consultor" \ndisabled="disabled"></md-input-container></div><hr><br><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value" flex="20"><label>A visita foi realizada?</label><md-radio-group \nmd-autofocus name="realizado" ng-model="vm.model.realizado" layout="row" required><md-radio-button value="1"><strong>\nSim</strong></md-radio-button><md-radio-button value="0"><strong>N\xE3o</strong></md-radio-button></md-radio-group><div \nng-messages="visitaForm.realizado.$error" ng-show="visitaForm.realizado.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{visitaForm.realizado.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin ng-show="vm.model.realizado == 0">\n<md-input-container flex><label>Observa\xE7\xE3o</label><textarea placeholder="Digite" name="motivo_cancelamento" \nng-model="vm.model.motivo_cancelamento" cols="40" rows="4" maxlength="500"></textarea><div class="errors" \nng-messages="visitaForm.motivo_cancelamento.$error"><div ng-message="api_erro">\n{{visitaForm.motivo_cancelamento.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset><div \nclass="checklist" ng-hide="vm.model.realizado == 0" ng-class="{\'disabled\': !vm.model.realizado}"><div \nclass="container-title-step"><h3><span><img src="../assets/icons/visitas/ico-relatorio.svg"></span>CHECK LIST</h3>\n</div><fieldset><md-card><h3>\nInforme a data e hor\xE1rio que a visita foi realizada e confirme as tarefas que foram realizadas:</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom" flex="15"><label>\nData da visita</label><md-datepicker name="data_realizada" ng-model="vm.model.data_realizada" \nmd-placeholder="__/__/____" ng-disabled="!vm.model.realizado" ng-required="vm.model.realizado != 0"></md-datepicker>\n<div class="errors" ng-messages="visitaForm.data_realizada.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{visitaForm.data_realizada.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20"><label>Hor\xE1rio</label><input type="text" name="hora_realizada" placeholder="__:__" \nui-time-mask="short" ng-model="vm.model.hora_realizada" ng-disabled="!vm.model.realizado" \nng-required="vm.model.realizado != 0"><div class="errors" ng-messages="visitaForm.hora_realizada.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{visitaForm.hora_realizada.$api.error.message}}</div></div></md-input-container></div><div class="checklist-itens" \nlayout="column" layout-gt-xs="column" layout-margin ng-if="vm.model.checklist.length>1"><div class="sim-nao"><span>Sim\n</span> <span>N\xE3o</span></div><md-input-container class="md-input-radio" flex="20" \nng-repeat="item in vm.model.checklist"><md-radio-group md-autofocus name="check" ng-model="item.checado" layout="col" \nng-disabled="!vm.model.realizado" ng-required="vm.model.realizado != 0"><md-radio-button value="1"></md-radio-button>\n<md-radio-button value="0"></md-radio-button><strong>{{item.descricao}}</strong></md-radio-group><div \nng-messages="visitaForm.check.$error" ng-show="visitaForm.check.$touched"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="api_erro">{{visitaForm.check.$api.error.message}}</div></div></md-input-container></div><br><div\n layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label>Observa\xE7\xE3o</label><textarea \nplaceholder="Digite" name="observacao" ng-model="vm.model.observacao" disabled="disabled" cols="40" rows="4" \nmaxlength="500"></textarea><div class="errors" ng-messages="visitaForm.observacao.$error"><div ng-message="api_erro">\n{{visitaForm.observacao.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset></div><div \nclass="content-buttons"><md-button md-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoDash()">\nVoltar</md-button><md-button md-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="visitaForm.$invalid || visitaForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Salvar\n</md-button></div><div api-form-validation-summary form="visitaForm"></div></form></div></div></div></div>');
$templateCache.put('app/main/agenda_visitas/views/dash.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Agendamento de visitas</h1></div>\n</div></div><div class="page-layout simple fullwidth agenda-visitas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="indices-1 form-search-horizontal"><div \nclass="container"><div class="row grupo-2"><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../assets/icons/visitas/ico-areas-abertas.svg"><h3>REALIZADAS</h3></div><div class="total"><span class="number">\n{{ vm.dash.realizadas }}</span><br><span class="nome">TOTAL</span></div></div></div><div class="col"><div \nclass="box-2"><div class="ico"><img src="../assets/icons/visitas/ico-planejadas.svg"><h3>PLANEJADAS</h3></div><div \nclass="total"><span class="number">{{ vm.dash.planejadas }}</span><br><span class="nome">TOTAL</span></div></div></div>\n<div class="col"><div class="box-2"><div class="ico"><img src="../assets/icons/visitas/ico-cancelamento.svg"><h3>\nCANCELADAS</h3></div><div class="total"><span class="number">{{ vm.dash.canceladas }}</span><br><span class="nome">\nTOTAL</span></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../assets/icons/visitas/ico-nao-realizado.svg"><h3>N\xC3O REALIZADAS</h3></div><div class="total"><span \nclass="number">{{ vm.dash.nao_realizadas }}</span><br><span class="nome">TOTAL</span></div></div></div></div></div>\n</div><div class="form-search-horizontal"><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col"><md-input-container \nclass="form-group select-custom" flex="30"><label>Consultor</label><select id="consultor" ng-model="vm.args.Consultor" \nng-options="item.nome as item.nome for item in vm.filtros.consultores" ng-value="item.nome"><option value="" \nselected="selected" disabled="disabled">Selecione</option></select></md-input-container></div><div class="col">\n<md-input-container class="form-group select-custom" flex><label>Status</label><select id="status" \nng-model="vm.args.Status" ng-options="item.descricao as item.descricao for item in vm.filtros.status" \nng-value="item.descricao"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Avalia\xE7\xE3o\n</label><select id="avaliacao" ng-model="vm.args.Avaliacao"><option value="" selected="selected" disabled="disabled">\nSelecione</option><option ng-value="item.nome" ng-repeat="item in vm.avaliacaoFiltro">{{item.nome}}</option></select>\n</md-input-container></div><div class="col"><h2>Per\xEDodo</h2><div class="content-datepicker-filter"><md-input-container \nclass="datepicker-custom" flex="20"><label>Data inicial</label><md-datepicker name="DataValidadeInicial" \nng-model="vm.args.DataInicio" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="20"><label>Data final</label><md-datepicker \nname="DataValidadeFinal" ng-model="vm.args.DataFim" md-open-on-focus md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container></div></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary" ng-click="vm.resetPagination(); vm.args._change()">Filtrar</md-button><a \nclass="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></div><div \nclass="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><a \nid="lista"></a><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom table-agenda"><thead class="first-level"><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_visita" lm-title="Data visita"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="consultor" lm-title="Consultor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="status" lm-title="Status"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="avaliacao" lm-title="Avalia\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td><h6 class="d-mobile">ID</h6>{{model.id}}</td><td>\n<h6 class="d-mobile">Data</h6>{{model.data_visita | date:\'dd/MM - HH:mm\'}}</td><td><h6 class="d-mobile">Consultor</h6>\n{{model.consultor}}</td><td><h6 class="d-mobile">Status</h6><div class="marcador marcador-amarelo" \nng-if="model.status_id == 1"><span></span>Planejado</div><div class="marcador marcador-verde" \nng-if="model.status_id == 2"><span></span>Realizado</div><div class="marcador marcador-cinza" \nng-if="model.status_id == 3"><span></span>N\xE3o realizado</div><div class="marcador marcador-vermelho" \nng-if="model.status_id == 4"><span></span>Cancelado</div></td><td><h6 class="d-mobile">Avalia\xE7\xE3o</h6><md-button \nclass="btn btn-tertiary" ng-click="vm.gotoAvaliar(model.id)" ng-if="model.status_id == 1">Avaliar</md-button><div \nclass="marcador marcador-verde" ng-if="model.status_id == 2"><span></span>Avaliado</div></td><td><h6 class="d-mobile">\nA\xE7\xF5es</h6><md-button class="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" \nng-if="model.status_id != 1" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs md-direction="top">\nVisualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.estornarConfirm(model)" ng-show="model.status_id == 2" aria-label="Estornar avalia\xE7\xE3o"><i \nclass="fas fa-undo-alt"><md-tooltip hide-xs md-direction="top">Estornar avalia\xE7\xE3o</md-tooltip></i></md-button>\n<md-button class="edit-button md-icon-button" ng-click="vm.openModalCancelamento(model.id)" \nng-show="model.status_id == 1" aria-label="Cancelar"><i class="fas fa-ban"><md-tooltip hide-xs md-direction="top">\nCancelar</md-tooltip></i></md-button></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args">\n</lm-paginator></div></div></div>');
$templateCache.put('app/main/agenda_visitas/views/modal_cancelamento.html','<md-dialog><div class="header-modal"><div class="desc">Cancelamento de agenda</div><div class="close" \nng-click="hide()">X</div></div><div class="content"><md-input-container class="md-block form-group-cancelamento" flex>\n<label>Motivo do cancelamento</label><textarea id="txtareaDescrever" placeholder="Digite" name="motivo" \nng-model="motivo" cols="40" rows="5" maxlength="500"></textarea></md-input-container></div><md-dialog-actions \nlayout="row"><md-button class="btn btn-secondary" ng-click="hide()">Voltar</md-button><md-button \nclass="btn btn-primary" ng-disabled="!motivo" ng-click="save()">Confirmar cancelamento</md-button></md-dialog-actions>\n</md-dialog>');
$templateCache.put('app/main/agenda_visitas/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1>Agendamento de visitas > Visualizar</h1></div></div><div \nid="forms" class="page-layout simple fullwidth agenda-visitas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/visitas/ico-agendamento-br.svg"></span>INFORMA\xC7\xD5ES DA VISITA</h3></div><div \nclass="content-register"><form name="visitaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro">\n<fieldset><md-card><div api-form-validation-summary form="visitaForm"></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="20"><label>Status</label><br><div class="marcador marcador-verde" \nng-if="vm.model.status_id == 2"><span></span><strong>Realizado</strong></div><div class="marcador marcador-amarelo" \nng-if="!vm.model.status_id == 1"><span></span><strong>Planejado</strong></div><div class="marcador marcador-vermelho" \nng-if="vm.model.status_id == 4"><span></span><strong>Cancelado</strong></div><div class="marcador marcador-cinza" \nng-if="vm.model.status_id == 3"><span></span><strong>N\xE3o realizado</strong></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="15"><label>Data da visita</label><md-datepicker name="data" \nng-model="vm.model.data" disabled="disabled"></md-datepicker></md-input-container><md-input-container flex="20"><label>\nHor\xE1rio</label><input type="text" name="hora" ng-model="vm.model.hora" disabled="disabled"></md-input-container>\n<md-input-container flex><label>Consultor</label><input type="text" name="consultor" ng-model="vm.model.consultor" \ndisabled="disabled"></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin \nng-show="vm.model.status_id == 4 || vm.model.status_id == 3"><md-input-container flex><label>Motivo do cancelamento:\n</label><textarea placeholder="Digite" name="observacao" ng-model="vm.model.motivo_cancelamento" disabled="disabled" \ncols="40" rows="4" maxlength="500"></textarea></md-input-container></div></md-card></fieldset><div class="checklist" \nng-hide="vm.model.status_id == 4 || vm.model.status_id == 3"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/visitas/ico-relatorio.svg"></span>CHECK LIST</h3></div><fieldset><md-card><h3>\nData, hor\xE1rio e tarefas da visita que foram realizadas:</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom" flex="15"><label>Data da visita</label><md-datepicker \nname="data_realizada" ng-model="vm.model.data_realizada" md-placeholder="__/__/____" disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex="20"><label>Hor\xE1rio</label><input type="text" \nname="hora_realizada" ng-model="vm.model.hora_realizada" disabled="disabled"></md-input-container></div><div \nclass="checklist-itens" layout="column" layout-gt-xs="column" layout-margin ng-if="vm.model.checklist.length>1"><div \nclass="sim-nao"><span>Sim</span> <span>N\xE3o</span></div><md-input-container class="md-input-radio" flex="20" \nng-repeat="item in vm.model.checklist"><md-radio-group md-autofocus name="check" ng-model="item.checado" layout="col" \ndisabled="disabled"><md-radio-button value="1"></md-radio-button><md-radio-button value="0"></md-radio-button><strong>\n{{item.descricao}}</strong></md-radio-group></md-input-container></div><br><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex><label>Observa\xE7\xE3o</label><textarea placeholder="Digite" name="observacao" \nng-model="vm.model.observacao" disabled="disabled" cols="40" rows="4" maxlength="500"></textarea></md-input-container>\n</div></md-card></fieldset></div><div class="content-buttons"><md-button md-button-id="bttnVltr" \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoDash()">Voltar</md-button></div><div api-form-validation-summary \nform="visitaForm"></div></form></div></div></div></div>');
$templateCache.put('app/main/assinatura/views/desativada.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Assinatura desativada</h1></div>\n</div></div><div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column">\n<div class="container-content-custom"><md-card style="text-align: center;"><img class="logo-desativado" \nsrc="../assets/images/svg/img-emoji-triste.svg"> <span class="title-1" ng-if="vm.dataFinalPeriodo">\nQue pena, mas sua assinatura expirou dia {{ vm.dataFinalPeriodo | date:\'dd/MM\' }}.</span> <span class="title-1" \nng-if="!vm.dataFinalPeriodo">Que pena, mas sua assinatura expirou.</span> <span class="title-2">\nRenove agora seu plano e volte a utilizar as nossas ferramentas. J\xE1 estamos sentindo a sua falta!</span><div \nclass="button-renovar-assinatura"><md-button class="btn btn-tertiary" ng-click="vm.renovarAssinatura()">\nRenovar assinatura</md-button></div><span class="title-3">\nAproveite e atualize seus dados. Manter sua assinatura atualizada \xE9 importante para<br>\noferecermos a melhor experi\xEAncia da nossa ferramenta.</span></md-card></div></div></div>');
$templateCache.put('app/main/caldas/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xF5es de caldas > Caldas</h1></div><md-button \nng-click="vm.gotoAdd()" class="btn btn-primary btn-lg-i" ng-disabled="vm.propriedade.length == 0">Cadastrar calda\n</md-button></div><div class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="form-search-horizontal"><form><div class="container">\n<div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros\n</span></div><div class="col periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.args.data_inicial" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.DataInicio" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Caldas</label><select \nid="calda" ng-model="vm.args.calda" ng-options="item for item in vm.filtros.caldas" ng-value="item"><option value="" \nselected="selected" disabled="disabled">Selecione</option></select></md-input-container></div><div class="col"><div \nclass="content-buttons"><md-button class="btn btn-tertiary btn-md-i" ng-click="vm.args._change(vm.args.page)">Filtrar\n</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div>\n<div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom caldas_list"><thead class="first-level"><tr><th></th><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="calda" lm-title="Calda"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_cadastro" lm-title="Data cadastro"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr class="default" ng-repeat-start="model in vm.models"><td \nclass="click-button desktop-button-plus"><a ng-click="vm.isColapsed(model)" \nng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a\n class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-tooltip md-direction="right">\nS\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a>&nbsp;</td><td>\n<h6 class="d-mobile">ID</h6>{{model.id}}</td><td><h6 class="d-mobile">Calda</h6>{{model.nome}}</td><td><h6 \nclass="d-mobile">Cadastro</h6>{{model.data | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">A\xE7\xF5es</h6><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoView(model.id)" aria-label="Editar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="left">Editar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" aria-label="Apagar" ng-click="vm.deletarConfirm(model)" \nng-disabled="model.is_aplicacao_confirmada"><i class="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">\nRemover</md-tooltip></i></md-button></td><td class="click-button mobile-only"><a ng-click="vm.isColapsed(model)" \nng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a\n class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle"></md-icon></a>\n</td></tr><tr ng-repeat-end class="details"><td class="main" colspan="9" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><h2>Ver detalhes:</h2><table>\n<thead><tr><th>Tipo</th><th>Insumo</th><th>Qtd. por hectare</th><th>Un. medida</th><th>Car\xEAncia</th></tr></thead>\n<tbody><tr class="details" ng-repeat="item in model.calda_insumos"><td><h6 class="d-mobile">Tipo</h6>{{ item.tipo }}\n</td><td><h6 class="d-mobile">Insumo</h6>{{ item.nome }}</td><td><h6 class="d-mobile">Qtd. por hectare</h6>\n{{ item.quantidade | number:3 }}</td><td><h6 class="d-mobile">Un. medida</h6>{{ item.unidade }}</td><td><h6 \nclass="d-mobile">Car\xEAncia</h6>{{ item.carencia }}</td></tr></tbody></table></div></td><td colspan="8" \nng-if="model.isLoading"><div class="loading"><md-progress-circular id="toolbar-progress" class="md-accent" \nmd-diameter="32"></md-progress-circular><p>Carregando</p></div></td></tr></tbody></table></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/caldas/views/cadastro.html','<div class="container-header"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xF5es de Caldas > Caldas > Cadastrar calda\n</h1></div></div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nInclua todos os insumos necess\xE1rios para o preparo da calda.</h2></div><div class="container-title-step"><h3><span><img\n src="../assets/icons/aplicacao/ico-calda-br.svg"></span>INFORMA\xC7\xD5ES DA CALDA</h3></div><div class="content-register">\n<form name="caldasForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div \napi-form-validation-summary form="caldasForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex="40"><label>Nome da calda</label><input type="text" name="calda" \nng-model="vm.model.calda" placeholder="Digite" required><div class="errors" ng-messages="caldasForm.calda.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{caldasForm.calda.$api.error.message}}</div>\n</div></md-input-container></div><hr><div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="insumo in vm.model.insumos"><md-input-container class="select-custom" flex="20"><label>Tipo</label>\n<md-select class="md-block" placeholder="Selecione o tipo" ng-model="insumo.tipo" \nng-change="vm.onSelectTipo(insumo, $index)" name="tipo" required><md-option ng-repeat="item in vm.selectTipos" \nvalue="{{item.id_tipo}}">{{item.nome_tipo}}</md-option></md-select><div class="errors" \nng-messages="caldasForm.tipo.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{caldasForm.tipo.$api.error.message}}</div></div></md-input-container><md-input-container class="select-custom" \nflex="20"><label>Insumo</label><md-select class="md-block" placeholder="Selecione o insumo" \nng-model="insumo.insumo_id" ng-change="vm.onSelectInsumo($index)" ng-disabled="!insumo.tipo" name="insumo_id" required>\n<md-option ng-repeat="item in vm.selectInsumos[$index]" value="{{item.id_insumo}}">{{item.nome_insumo}}</md-option>\n</md-select><div class="errors" ng-messages="caldasForm.insumo_id.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="api_erro">{{caldasForm.insumo_id.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15"><button type="button" class="md-button btn btn-quaternary" style="margin-left: -20px;" \nng-disabled="!insumo.tipo" ng-click="vm.openModalAddInsumo($index)"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nCadastrar insumo</button></md-input-container><md-input-container flex><label>Qtd. por hectare</label><input \nid="inptQntdd" name="quantidade_por_hectare" type="text" ng-model="insumo.quantidade_por_hectare" ui-number-mask="3" \nmin="0.001" required max="99999.999" maxlength="10" placeholder="Digite"> <span class="unidade_medida_input">\n{{insumo.unidade_medida}}</span><div class="errors" ng-messages="insumoForm.quantidade_por_hectare.$error"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">Deve ser maior que {{0.001 | finance:false:3}}</div>\n<div ng-message="max">Deve ser menor que {{99999.999 | finance:false:3}}</div></div></md-input-container>\n<md-input-container flex="10"><label>Car\xEAncia</label><input id="inptQntdd" name="carencia" type="number" \nng-model="insumo.carencia" ng-disabled="insumo.tipo == 1" min="0"></md-input-container><div \nclass="btn-remove display-flex-custom"><md-button class="icon-btn md-icon-button" ng-if="vm.model.insumos.length > 1" \nng-click="vm.removeInsumos($index)"><div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip \nhide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button></div></div></md-card><md-card class="add-card">\n<a id="btnAdc" class="btn btn-quaternary" ng-click="vm.addInsumos(null,null)"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Adicionar mais insumos</a></md-card></fieldset><div class="content-buttons"><md-button \nmd-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoLista()">Voltar</md-button><md-button \nmd-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="caldasForm.$invalid || loadingProgress" ng-click="vm.gotoConfirmar(vm.model)">Pr\xF3ximo passo</md-button>\n</div><div api-form-validation-summary form="caldasForm"></div></form></div></div></div></div>');
$templateCache.put('app/main/caldas/views/confirmar.html','<div class="container-header"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xF5es de Caldas > Caldas > Cadastrar calda\n</h1></div></div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num active last">2</span></div><h2>\nConfira todos os dados para a finalizar o preparo dessa calda.</h2></div><div class="container-title-step"><h3><span>\n<img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>INFORMA\xC7\xD5ES DA CALDA</h3></div><div \nclass="content-register"><md-card><label>Calda</label><strong>{{ vm.model.calda }}</strong><p><br></p><hr><table \nrow-border hover lm-sort id="responsive" class="simple table-custom table-confirm"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="insumo" lm-title="Insumo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="unidade_medida" lm-title="Unidade medida"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="hectare" lm-title="Quant. por hectare"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="carencia" lm-title="Car\xEAncia"></th></tr></thead><tbody><tr \nng-repeat="item in vm.model.insumos"><td><h6 class="d-mobile">Tipo</h6>{{item.tipo_nome}}</td><td><h6 class="d-mobile">\nInsumo</h6>{{item.insumo_nome}}</td><td><h6 class="d-mobile">Un. medida</h6>{{item.unidade_medida}}</td><td><h6 \nclass="d-mobile">Quant. por hectare</h6>{{item.quantidade_por_hectare | number:3}}</td><td><h6 class="d-mobile">\nCar\xEAncia</h6>{{item.carencia}}</td></tr></tbody></table></md-card><div class="content-buttons"><md-button \nmd-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoStep1()">Voltar</md-button><md-button \nmd-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="loadingProgress" ng-click="vm.save()">Concluir</md-button></div></div></div></div></div>');
$templateCache.put('app/main/caldas/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xF5es de Caldas > Caldas > Editar / visualizar\n</h1></div></div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/aplicacao/ico-calda-br.svg"></span>INFORMA\xC7\xD5ES DA CALDA</h3></div><div class="content-register">\n<form name="caldasForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div \napi-form-validation-summary form="caldasForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex="40"><label>Nome da calda</label><input type="text" name="nome" \nng-model="vm.model.nome" placeholder="Digite" required><div class="errors" ng-messages="caldasForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{caldasForm.nome.$api.error.message}}</div>\n</div></md-input-container></div><hr><div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="insumo in vm.model.calda_insumos"><md-input-container class="select-custom" flex="20"><label>Tipo</label>\n<md-select class="md-block" placeholder="Selecione o tipo" ng-model="insumo.insumo_tipo_id" \nng-change="vm.onSelectTipo(insumo, $index)" name="insumo_tipo_id" required><md-option \nng-repeat="item in vm.selectTipos" value="{{item.id_tipo}}">{{item.nome_tipo}}</md-option></md-select><div \nclass="errors" ng-messages="caldasForm.insumo_tipo_id.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{caldasForm.insumo_tipo_id.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="20"><label>Insumo</label><md-select class="md-block" \nplaceholder="Selecione o insumo" ng-model="insumo.insumo_id" ng-change="vm.onSelectInsumo($index)" \nng-disabled="!insumo.insumo_tipo_id" name="insumo_id" required><md-option ng-repeat="item in vm.selectInsumos[$index]" \nvalue="{{item.id_insumo}}">{{item.nome_insumo}}</md-option></md-select><div class="errors" \nng-messages="caldasForm.insumo_id.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{caldasForm.insumo_id.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><button \ntype="button" class="md-button btn btn-quaternary" style="margin-left: -20px;" ng-disabled="!insumo.insumo_tipo_id" \nng-click="vm.openModalAddInsumo($index)"><md-icon md-font-icon="icon-plus-circle"></md-icon>Cadastrar insumo</button>\n</md-input-container><md-input-container flex><label>Qtd. por hectare</label><input id="inptQntdd" \nname="quantidade_por_hectare" type="text" ng-model="insumo.quantidade_por_hectare" ui-number-mask="3" min="0.001" \nrequired max="99999.999" maxlength="10" placeholder="Digite"> <span class="unidade_medida_input">\n{{insumo.unidade_medida}}</span><div class="errors" ng-messages="insumoForm.quantidade_por_hectare.$error"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">Deve ser maior que {{0.001 | finance:false:3}}</div>\n<div ng-message="max">Deve ser menor que {{99999.999 | finance:false:3}}</div></div></md-input-container>\n<md-input-container flex="10"><label>Car\xEAncia</label><input id="inptQntdd" name="carencia" type="text" \nng-model="insumo.carencia" ng-disabled="insumo.insumo_tipo_id == 1"></md-input-container><div \nclass="btn-remove display-flex-custom"><md-button class="icon-btn md-icon-button" \nng-if="vm.model.calda_insumos.length > 1" ng-click="vm.removeInsumos($index)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</div></div></md-card><md-card class="add-card"><a id="btnAdc" class="btn btn-quaternary" \nng-click="vm.addInsumos(null,null)"><md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar mais insumos</a>\n</md-card></fieldset><div class="content-buttons"><md-button md-button-id="bttnVltr" class="btn btn-secondary btn-lg" \nng-click="vm.gotoView(vm.model.id)">Voltar</md-button><md-button md-button-id="bttnCdstr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" ng-disabled="caldasForm.$invalid || loadingProgress" \nng-click="vm.save(vm.model)">Salvar</md-button></div><div api-form-validation-summary form="caldasForm"></div></form>\n</div></div></div></div>');
$templateCache.put('app/main/caldas/views/modal_add_insumo.html','<div><div class="header-modal"><div class="desc">Cadastro de insumo</div><div class="close" ng-click="vm.close()">X\n</div></div><div class="content content-modal-add-insumos"><div class="content-register"><form name="insumoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_INSUMO">Tipo de insumo</label><md-select class="md-block" name="insumo_tipo_id" \nng-model="vm.model.insumo_tipo_id" ng-change="vm.changeInsumoTipo()" placeholder="Escolher uma tipo de insumo" \ndisabled="disabled" required><md-option ng-repeat="tipo_insumo_item in vm.tipo_insumo | filter:{id:vm.tipoSelected}" \nng-selected="tipo_insumo_item.id == vm.tipoSelected" ng-value="tipo_insumo_item.id">{{tipo_insumo_item.nome}}\n</md-option></md-select><div ng-messages="insumoForm.insumo_tipo_id.$error" ng-if="insumoForm.insumo_tipo_id.$touched">\n<div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.insumo_tipo_id.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500" ng-if="vm.model.insumo_tipo_id == 2"><label \ntranslate="CADASTRO_INSUMO.DEFENSIVO">Nome comercial do defensivo</label><md-autocomplete required flex \nclass="md-block" name="insumo_agricola_nome" md-input-name="insumo_agricola_nome" md-no-cache="false" \nmd-selected-item="vm.model.insumo_agricola" md-selected-item-change="vm.selectedItemChange(item)" \nmd-search-text="listaAgrofitQuery" md-items="item in vm.listaAgrofitSearch(listaAgrofitQuery)" \nmd-item-text="item.nome" md-delay="500" md-require-match placeholder="Insira o produto"><md-item-template><span \nmd-highlight-text="listaAgrofitQuery">{{ item }}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="insumoForm.insumo_agricola_nome.$error" \nng-if="insumoForm.insumo_agricola_nome.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.insumo_agricola_nome.$api.error.message}}</div></div></md-input-container>\n<md-input-container md-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">Nome do insumo no estoque</label><input\n type="text" name="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="insumoForm.nome.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.nome.$api.error.message}}\n</div></div></md-input-container><md-input-container class="select-custom" flex="15" md-delay="500"><label>Tipo medida\n</label><md-select class="md-block" ng-model="vm.model.tipo_medida_id" name="tipo_medida_id" \nplaceholder="Escolher uma tipo de insumo agricola" required><md-option ng-repeat="tipo_medida_item in vm.tipo_medida" \nng-value="tipo_medida_item.id">{{tipo_medida_item.nome}}</md-option></md-select><div \nng-messages="insumoForm.tipo_medida_id.$error" ng-if="insumoForm.tipo_medida_id.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.tipo_medida_id.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10" ng-if="vm.model.insumo_tipo_id != 1"><label>Car\xEAncia</label><input \nid="inptCrnc" type="text" name="carencia" ng-model="vm.model.carencia" ng-pattern="/^[0-9]*$/" maxlength="2" \nui-number-mask="0" min="0" max="999" placeholder="Insira a car\xEAncia"><div class="errors" \nng-messages="insumoForm.carencia.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente n\xFAmeros</div><div ng-message="max">Carencia deve ser inferior a \'100\'.</div><div ng-message="api_erro">\n{{insumoForm.carencia.$api.error.message}}</div></div></md-input-container></div></md-card><div \napi-form-validation-summary form="insumoForm"></div></fieldset><md-dialog-actions><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.close()">Voltar</md-button><md-button type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || loadingProgress" ng-click="vm.save(insumoForm)">Cadastrar\n</md-button></md-dialog-actions></form></div></div></div>');
$templateCache.put('app/main/caldas/views/sucesso.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1>\nManejos > Aplica\xE7\xF5es de Caldas > Caldas > Cadastrar calda</h1></div></div><div id="forms" \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-sucesso"><img src="/assets/icons/aplicacao/ico-calda-sucesso.svg" \nalt="sucesso"><h2>Calda preparada com sucesso!</h2><span>-------------------------------------------------------</span>\n<p>O que voc\xEA gostaria de fazer agora?</p><div class="content-buttons-sucesso"><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-click="vm.gotoAdd()">Cadastrar nova calda</md-button><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-click="vm.gotoList()">Ver todas as caldas cadastradas</md-button><md-button \nclass="btn btn-secondary btn-md" ng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div></div></div>');
$templateCache.put('app/main/caldas/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xF5es de Caldas > Caldas > Editar / visualizar\n</h1></div></div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/aplicacao/ico-calda-br.svg"></span>INFORMA\xC7\xD5ES DA CALDA</h3></div><div class="content-register">\n<md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="25">\n<span>Calda</span><br><strong>{{ vm.model.nome }}</strong></md-input-container><md-input-container \nclass="select-custom" flex="15"><span>Data cadastro</span><br><strong>{{ vm.model.data_criacao | date:\'dd/MM/yyyy\' }}\n</strong></md-input-container><md-input-container class="select-custom" flex="15"><span>Data \xFAltima edi\xE7\xE3o</span><br>\n<strong>{{ vm.model.data_alteracao | date:\'dd/MM/yyyy\' }}</strong></md-input-container><md-input-container \nclass="select-custom" flex><span>Respons\xE1vel edi\xE7\xE3o</span><br><strong>{{ vm.model.usuario_alteracao }}</strong>\n</md-input-container></div><p><br></p><hr><table row-border hover lm-sort id="responsive" \nclass="simple table-custom table-confirm"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="tipo" lm-title="Tipo"></th><th class="secondary-text pagination-custom" lm-sort-header="insumo" \nlm-title="Insumo"></th><th class="secondary-text pagination-custom" lm-sort-header="unidade_medida" \nlm-title="Unidade medida"></th><th class="secondary-text pagination-custom" lm-sort-header="hectare" \nlm-title="Quant. por hectare"></th><th class="secondary-text pagination-custom" lm-sort-header="carencia" \nlm-title="Car\xEAncia"></th></tr></thead><tbody><tr ng-repeat="item in vm.model.calda_insumos"><td>{{item.insumo_tipo}}\n</td><td>{{item.insumo_nome}}</td><td>{{item.unidade_medida}}</td><td>{{item.quantidade_por_hectare | number:3}}</td>\n<td>{{item.carencia}}</td></tr></tbody></table></md-card><div class="content-buttons"><md-button \nmd-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoList()">Voltar</md-button><md-button \nmd-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="loadingProgress || vm.model.is_aplicacao_confirmada || vm.model.is_aplicacao" \nng-click="vm.gotoEdit(vm.model.id)">Editar</md-button></div></div></div></div></div>');
$templateCache.put('app/main/account/views/accessdenied.html','<div class="container-denied"><div class="content-denied"><img src="../assets/images/logos/logo-eattae.svg"><p>\nVoc\xEA n\xE3o tem permiss\xE3o para acessar essa p\xE1gina.</p><div class="content-buttons"><md-button class="btn btn-secondary" \nng-click="vm.gotoLogout()">Voltar</md-button><md-button class="btn btn-tertiary" ng-click="vm.gotoAccount()">\nAdquirir assinatura</md-button></div></div></div>');
$templateCache.put('app/main/account/views/callback.html','<div id="splash-screen"><div class="center"><div class="logo"><span></span></div><div class="spinner-wrapper"><div \nclass="spinner"><div class="inner"><div class="gap"></div><div class="left"><div class="half-circle"></div></div><div \nclass="right"><div class="half-circle"></div></div></div></div></div></div></div>');
$templateCache.put('app/main/account/views/callbackconfirmemail.html','<div>Aguarde...</div>');
$templateCache.put('app/main/account/views/logoutcallback.html','<div>Voc\xEA est\xE1 sendo deslogado. Aguarde...</div>');
$templateCache.put('app/main/account/views/passwordlesslogin.html','<div id="splash-screen"><div class="center"><div class="logo"><span></span></div><div class="spinner-wrapper"><div \nclass="spinner"><div class="inner"><div class="gap"></div><div class="left"><div class="half-circle"></div></div><div \nclass="right"><div class="half-circle"></div></div></div></div></div></div></div>');
$templateCache.put('app/main/caldas_aplicacoes/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Aplica\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es</h1></div></div></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><div class="form-search"><form><div \nclass="container"><div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg">\n <span>Filtros</span></div><div class="col periodo"><div class="row-periodo"><div class="select-content">\n<md-input-container class="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.args.data_inicial" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.DataInicio" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Caldas</label><select \nid="calda" ng-model="vm.args.calda" ng-options="item for item in vm.filtros.caldas" ng-value="item"><option value="" \nselected="selected" disabled="disabled">Selecione</option></select></md-input-container></div><div class="col"><div \nclass="content-buttons"><md-button class="btn btn-tertiary btn-md-i" ng-click="vm.args._change(vm.args.page)">Filtrar\n</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div>\n</div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>\n{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" \nng-if="filter.description">{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" \ntitle="Remover">X</a></li></ul></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" \nlayout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom">\n<thead><tr><th class="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID" flex="5"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="calda" lm-title="Calda"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="apelido" lm-title="Apelido"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="total_areas" lm-title="Total \xE1reas"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="total_hectares" lm-title="Total hectares"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_cadastro" lm-title="Data cadastro"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_aplicacao" lm-title="Data aplica\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="responsavel" lm-title="Respons\xE1vel"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td><h6 class="d-mobile">ID</h6>{{ model.id }}</td>\n<td><h6 class="d-mobile">Calda</h6>{{ model.calda }}</td><td><h6 class="d-mobile">Apelido</h6>{{ model.apelido }}</td>\n<td><h6 class="d-mobile">Total \xE1reas</h6>{{ model.total_areas }}</td><td><h6 class="d-mobile">Total hectares</h6>\n{{ model.total_hectares | number:4 }}</td><td><h6 class="d-mobile">Data cadastro</h6>\n{{ model.data_cadastro | date:\'dd/MM/yyyy\' }}</td><td><h6 class="d-mobile">Data Aplica\xE7\xE3o</h6>\n{{ model.data_aplicacao | date:\'dd/MM/yyyy\' }}</td><td><h6 class="d-mobile">Respons\xE1vel</h6>{{ model.responsavel }}\n</td><td><h6 class="d-mobile">A\xE7\xF5es</h6><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="left">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt"><md-tooltip hide-xs \nmd-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator lm-args="vm.args">\n</lm-paginator></div></div></div>');
$templateCache.put('app/main/caldas_aplicacoes/views/visualizar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Aplica\xE7\xF5es > Visualiza\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas</h1></div><div\n id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><fieldset disabled="disabled"><div class="container-title-step content-buttons"><h3>\n<span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>Informa\xE7\xF5es da calda</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label \nclass="fw-normal">Calda</label><strong>{{ vm.model.calda }}</strong></md-input-container><md-input-container flex>\n<label class="fw-normal">Apelido</label><strong>{{ vm.model.apelido }}</strong></md-input-container><md-input-container\n flex><label class="fw-normal">Total \xE1reas</label><strong>{{ vm.model.total_areas }}</strong></md-input-container>\n<md-input-container flex><label class="fw-normal">Total hectares</label><strong>\n{{ vm.model.total_hectares | number:4 }}</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Data cadastro</label><strong>{{ vm.model.data_cadastro | date:\'dd/MM/yyyy\' }}</strong>\n</md-input-container><md-input-container flex><label class="fw-normal">Data aplica\xE7\xE3o</label><strong>\n{{ vm.model.data_aplicacao | date:\'dd/MM/yyyy\' }}</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Respons\xE1vel</label><strong>{{ vm.model.responsavel }}</strong></md-input-container></div><hr><table \nrow-border lm-sort hover id="responsive" class="simple table-custom table-confirm"><thead><tr><th><button \nclass="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th><button class="btn-order">\nCar\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button class="btn-order">\nQuantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr></thead><tbody><tr\n ng-repeat="item in vm.model.calda_aplicacoes_insumos"><td>{{ item.insumo_tipo }}</td><td>{{ item.insumo_nome }}</td>\n<td>{{ item.carencia }}</td><td>{{ item.unidade_medida }}</td><td>{{ item.quantidade_por_hectare | number:3 }}</td><td>\n{{ item.quantidade_total | number:3 }}</td></tr></tbody></table></md-card><br><div class="container-title-step"><h3>\n<span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>Aplica\xE7\xE3o por \xE1rea</h3></div><md-card><fieldset \nng-repeat="area in vm.model.calda_aplicacoes_areas"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex><label class="fw-normal">\xC1rea</label><strong>\n{{ area.area }} - {{ area.hectare | number:4 }} ha</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Cultura / variedade</label><strong>{{ area.cultura }} {{ area.variedade }}</strong>\n</md-input-container></div><table row-border lm-sort hover id="responsive" class="simple table-custom table-confirm">\n<thead><tr><th><button class="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th>\n<button class="btn-order">Car\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button \nclass="btn-order">Quantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr>\n</thead><tbody><tr ng-repeat="insumo in area.insumos_area" $index><td>{{ insumo.tipo }}</td><td>{{ insumo.insumo }}\n</td><td>{{ insumo.carencia }}</td><td>{{ insumo.unidade_medida }}</td><td>\n{{ insumo.quantidade_por_hectare | number:3 }}</td><td>{{ insumo.quantidade_total | number:3 }}</td></tr></tbody>\n</table><hr ng-hide="($index + 1) == vm.model.calda_aplicacoes_areas.length" style="margin-top: 10px;"></fieldset>\n</md-card><div class="content-buttons"><a href="#" class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</a></div></fieldset></div></div></div>');
$templateCache.put('app/main/caldas_plano_aplicacao/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Plano de Aplica\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas</h1></div></div>\n<md-button class="btn btn-primary" ng-click="vm.gotoAdd()">Cadastrar aplica\xE7\xE3o</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><div class="form-search"><form><div \nclass="container"><div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg">\n <span>Filtros</span></div><div class="col periodo"><div class="row-periodo"><div class="select-content">\n<md-input-container class="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.args.data_inicial" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.DataInicio" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Caldas</label><select \nid="calda" ng-model="vm.args.calda" ng-options="item for item in vm.filtros.calda_aplicacaos" ng-value="item"><option \nvalue="" selected="selected" disabled="disabled">Selecione</option></select></md-input-container></div><div \nclass="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change(vm.args.page)">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">\nLimpar</a></div></div></div></div></form></div></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0">\n<ul><li class="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID" flex="5"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="calda" lm-title="Calda"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="apelido" lm-title="Apelido"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="total_areas" lm-title="Total \xE1reas"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="total_hectares" lm-title="Total hectares"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_cadastro" lm-title="Data cadastro"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="ultima_aplicacao" lm-title="\xDAltima aplica\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="numero_aplicacoes" lm-title="N\xBA de aplica\xE7\xF5es"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td><h6 class="d-mobile">ID</h6>{{ model.id }}</td>\n<td><h6 class="d-mobile">Calda</h6>{{ model.calda }}</td><td><h6 class="d-mobile">Apelido</h6>{{ model.apelido }}</td>\n<td><h6 class="d-mobile">Total \xE1reas</h6>{{ model.total_areas }}</td><td><h6 class="d-mobile">Total hectares</h6>\n{{ model.total_hectares | number:4 }}</td><td><h6 class="d-mobile">Data cadastro</h6>\n{{ model.data_cadastro | date:\'dd/MM/yyyy\' }}</td><td><h6 class="d-mobile">\xDAltima Aplica\xE7\xE3o</h6>\n{{ model.ultima_aplicacao | date:\'dd/MM/yyyy\' }}</td><td><h6 class="d-mobile">N\xBA aplica\xE7\xF5es</h6>\n{{ model.nr_aplicacoes }}</td><td class="actions"><h6 class="d-mobile">A\xE7\xF5es</h6><md-button ng-if="!vm.hideitem_stock" \nclass="btn btn-tertiary" ng-click="vm.gotoConfirmarSemEstoque(model.id)">Confirmar<br>aplica\xE7\xE3o</md-button><md-button \nng-if="vm.hideitem_stock" class="btn btn-tertiary" ng-click="vm.gotoConfirmar(model.id)">Confirmar<br>aplica\xE7\xE3o\n</md-button><md-button class="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" \naria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i>\n</md-button><md-button class="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div>\n<lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/caldas_plano_aplicacao/views/confirmar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Plano de Aplica\xE7\xE3o > Confirmar aplica\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas\n</h1></div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><fieldset><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/aplicacao/ico-calda-br.svg"></span>Informa\xE7\xF5es da calda</h3></div><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label class="fw-normal">Calda</label>\n<strong>{{ vm.model.calda }}</strong></md-input-container><md-input-container flex><label class="fw-normal">Apelido\n</label><strong>{{ vm.model.apelido }}</strong></md-input-container><md-input-container flex><label class="fw-normal">\nTotal \xE1reas</label><strong>{{ vm.model.total_areas }}</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Total hectares</label><strong>{{ vm.model.total_hectares | number:4 }}</strong></md-input-container>\n<md-input-container flex><label class="fw-normal">Data cadastro</label><strong>\n{{ vm.model.data_cadastro | date:\'dd/MM/yyyy\' }}</strong></md-input-container></div><hr><table row-border lm-sort \nhover id="responsive" class="simple table-custom table-confirm"><thead><tr><th><button class="btn-order">Tipo</button>\n</th><th><button class="btn-order">Insumo</button></th><th><button class="btn-order">Car\xEAncia</button></th><th><button \nclass="btn-order">Unidade medida</button></th><th><button class="btn-order">Quant. por hectare</button></th><th><button\n class="btn-order">Quant. total</button></th><th ng-hide="!vm.hideitem_stock"><button class="btn-order">Quant. estoque\n</button></th><th ng-hide="!vm.hideitem_stock"><button class="btn-order">Saldo</button></th></tr></thead><tbody><tr \nng-repeat="item in vm.model.calda_aplicacoes_insumos"><td><div class="marcador marcador-vermelho" \nng-if="!item.estoque_suficiente"><span ng-hide="!vm.hideitem_stock"></span>{{ item.insumo_tipo }}</div><div \nclass="marcador marcador-verde" ng-if="item.estoque_suficiente"><span ng-hide="!vm.hideitem_stock"></span>\n{{ item.insumo_tipo }}</div></td><td>{{ item.insumo_nome }}</td><td>{{ item.carencia }}</td><td>\n{{ item.unidade_medida }}</td><td>{{ item.quantidade_por_hectare | number:3 }}</td><td>\n{{ item.quantidade_total | number:3 }}</td><td ng-hide="!vm.hideitem_stock">{{ item.quantidade_estoque | number:3 }}\n</td><td ng-hide="!vm.hideitem_stock" ng-class="{negativo: item.saldo != 0 && !item.estoque_suficiente}">\n{{ item.saldo | number:3 }}</td></tr></tbody></table></md-card><br><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/aplicacao/ico-calda-br.svg"></span>Aplica\xE7\xE3o por \xE1rea</h3></div><md-card><fieldset \nng-repeat="area in vm.model.calda_aplicacoes_areas"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex><label class="fw-normal">\xC1rea</label><strong>\n{{ area.area }} - {{ area.hectare | number:4 }} ha</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Cultura / variedade</label><strong>{{ area.cultura }} {{ area.variedade }}</strong>\n</md-input-container></div><table row-border lm-sort hover id="responsive" class="simple table-custom table-confirm">\n<thead><tr><th><button class="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th>\n<button class="btn-order">Car\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button \nclass="btn-order">Quantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr>\n</thead><tbody><tr ng-repeat="insumo in area.insumos_area" $index><td>{{ insumo.tipo }}</td><td>{{ insumo.insumo }}\n</td><td>{{ insumo.carencia }}</td><td>{{ insumo.unidade_medida }}</td><td>\n{{ insumo.quantidade_por_hectare | number:3 }}</td><td>{{ insumo.quantidade_total | number:3 }}</td></tr></tbody>\n</table><hr ng-hide="($index + 1) == vm.model.calda_aplicacoes_areas.length" style="margin-top: 10px;"></fieldset>\n</md-card><br><form name="confirmPlanoForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><div \nclass="container-title-step"><h3><span><img src="../assets/icons/aplicacao/ico-aplicacao-de-insumos-br.svg"></span>\nInforma\xE7\xF5es da aplica\xE7\xE3o</h3></div><md-card><div api-form-validation-summary form="confirmPlanoForm"></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom" flex="30"><label>\nInforme a data da aplica\xE7\xE3o dessa calda:</label><md-datepicker name="data_aplicacao" ng-model="vm.form.data_aplicacao" \nmd-max-date="vm.date" md-placeholder="__/__/____" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="confirmPlanoForm.data_aplicacao.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{confirmPlanoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label>Respons\xE1vel</label><input type="text" name="responsavel" placeholder="Digite" \nng-model="vm.form.responsavel" maxlength="30"><div class="errors" ng-messages="confirmPlanoForm.responsavel.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{confirmPlanoForm.responsavel.$api.error.message}}</div></div></md-input-container></div></md-card><div \nclass="content-buttons"><a href="#" class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</a><md-button \nid="btnCdstrr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="confirmPlanoForm.$invalid || confirmPlanoForm.$pristine || loadingProgress || !vm.estoque" \nng-click="vm.save(vm.form)" aria-label="confirmar">Salvar</md-button></div></form></fieldset></div></div></div>');
$templateCache.put('app/main/caldas_plano_aplicacao/views/criar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Plano de Aplica\xE7\xE3o > Cadastrar aplica\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas\n</h1></div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><form name="aplicacaoCaldaForm" \nclass="md-inline-form inputdados" novalidate api-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div \nclass="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num active">1</span> <span \nclass="num">2</span> <span class="num last">3</span></div><h2>Selecione onde ser\xE1 aplicada essa calda.</h2></div><div \nclass="container-title-step"><h3><span><img src="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div><md-card>\n<area-selector ng-model="vm.model.calda_aplicacao_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card></fieldset></form></div><div \nclass="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" \nng-click="vm.gotoSearch()">Voltar</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="!vm.model.calda_aplicacao_areas || vm.model.calda_aplicacao_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div><fieldset ng-if="vm.step == 2"><div \nclass="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num active">1</span> <span \nclass="num active">2</span> <span class="num last">3</span></div><h2>Preencha as informa\xE7\xF5es para o preparo da calda.\n</h2></div><div api-form-validation-summary form="aplicacaoCaldaForm"></div><div class="container-title-step"><h3>\n<span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>Informa\xE7\xF5es da calda</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Calda</label>\n<md-select id="slctPrdt" class="md-block" ng-model="vm.model.calda" ng-change="vm.changeCalda()" name="calda" \nplaceholder="Selecione" required><md-option ng-repeat="item in vm.caldas" ng-value="item">{{item.nome}}</md-option>\n</md-select><div ng-messages="aplicacaoCaldaForm.calda.$error" ng-if="aplicacaoCaldaForm.calda.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{aplicacaoCaldaForm.calda.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><label>Apelido</label><input type="text" name="apelido" \nng-model="vm.model.calda.apelido" placeholder="Digite"></md-input-container><md-input-container flex><label \nclass="fw-normal">Total \xE1reas:</label><strong>{{ vm.model.calda_aplicacao_areas.length }}</strong></md-input-container>\n<md-input-container flex><label class="fw-normal">Total hectares:</label><strong>\n{{ vm.total_area_produtiva | number:4 }}</strong></md-input-container></div><hr><table row-border lm-sort hover \nid="responsive" class="simple table-custom table-confirm"><thead ng-if="vm.model.calda"><tr><th><button \nclass="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th><button class="btn-order">\nCar\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button class="btn-order">\nQuantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr></thead><tbody><tr\n ng-if="!vm.model.calda"><td colspan="6">Selecione uma calda acima.</td></tr><tr \nng-repeat="item in vm.model.calda.calda_insumos"><td><h6 class="d-mobile">Tipo</h6>{{ item.tipo_insumo }}</td><td><h6 \nclass="d-mobile">Nome</h6>{{ item.nome_insumo }}</td><td><h6 class="d-mobile">Car\xEAncia</h6>{{ item.carencia }}</td><td>\n<h6 class="d-mobile">Un. medida</h6>{{ item.unidade_medida }}</td><td><h6 class="d-mobile">Peso/hectare</h6>\n{{ item.quantidade_por_hectare | number:3 }}</td><td><h6 class="d-mobile">Peso total</h6><md-input-container><input \ntype="text" ng-model="item.quantidade_total" name="quantidade_total" ui-number-mask="3" min="0.0001" max="9.999.999" \nrequired><div ng-messages="aplicacaoCaldaForm.quantidade_total.$error" \nng-if="aplicacaoCaldaForm.quantidade_total.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{aplicacaoCaldaForm.quantidade_total.$api.error.message}}</div></div></md-input-container></td>\n</tr></tbody></table></md-card><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="aplicacaoCaldaForm.$invalid || !vm.model.calda || loadingProgress" ng-click="vm.gotoStep(3)" \naria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset ng-if="vm.step == 3"><div \nclass="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num active">1</span> <span \nclass="num active">2</span> <span class="num active last">3</span></div><h2>Confirme os dados da aplica\xE7\xE3o da calda.\n</h2></div><div class="container-title-step"><h3><span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>\nInforma\xE7\xF5es da calda</h3></div><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex><label class="fw-normal">Calda</label><strong>{{ vm.model.calda.nome }}</strong>\n</md-input-container><md-input-container flex><label class="fw-normal">Apelido</label><strong>\n{{ vm.model.calda.apelido }}</strong></md-input-container><md-input-container flex><label class="fw-normal">\nTotal \xE1reas:</label><strong>{{ vm.model.calda_aplicacao_areas.length }}</strong></md-input-container>\n<md-input-container flex><label class="fw-normal">Total hectares:</label><strong>\n{{ vm.total_area_produtiva | number:4 }}</strong></md-input-container></div><hr><table row-border lm-sort hover \nid="responsive" class="simple table-custom table-confirm"><thead><tr><th><button class="btn-order">Tipo</button></th>\n<th><button class="btn-order">Insumo</button></th><th><button class="btn-order">Car\xEAncia</button></th><th><button \nclass="btn-order">Unidade medida</button></th><th><button class="btn-order">Quantidade por hectare</button></th><th>\n<button class="btn-order">Quantidade total</button></th></tr></thead><tbody><tr \nng-repeat="item in vm.model.calda.calda_insumos"><td><h6 class="d-mobile">Tipo</h6>{{ item.tipo_insumo }}</td><td><h6 \nclass="d-mobile">Insumo</h6>{{ item.nome_insumo }}</td><td><h6 class="d-mobile">Car\xEAncia</h6>{{ item.carencia }}</td>\n<td><h6 class="d-mobile">Un. medida</h6>{{ item.unidade_medida }}</td><td><h6 class="d-mobile">Peso/hectare</h6>\n{{ item.quantidade_por_hectare | number:3 }}</td><td><h6 class="d-mobile">Peso total</h6>\n{{ item.quantidade_total | number:3 }}</td></tr></tbody></table></md-card><br><div class="container-title-step"><h3>\n<span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>Aplica\xE7\xE3o por \xE1rea</h3></div><md-card><fieldset \nng-repeat="area in vm.model.calda_aplicacao_areas"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex><label class="fw-normal">\xC1rea</label><strong>\n{{ area.nome }} - {{ area.total_hectares | number:4 }} ha</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Cultura / variedade</label><strong>{{ area.cultura }} {{ area.variedade }}</strong>\n</md-input-container></div><table row-border lm-sort hover id="responsive" class="simple table-custom table-confirm">\n<thead><tr><th><button class="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th>\n<button class="btn-order">Car\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button \nclass="btn-order">Quantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr>\n</thead><tbody><tr ng-repeat="insumo in area.insumo_consolidados" $index><td><h6 class="d-mobile">Tipo</h6>\n{{ insumo.tipo_insumo }}</td><td><h6 class="d-mobile">Insumo</h6>{{ insumo.nome_insumo }}</td><td><h6 class="d-mobile">\nCar\xEAncia</h6>{{ insumo.carencia }}</td><td><h6 class="d-mobile">Un. medida</h6>{{ insumo.unidade_medida }}</td><td><h6 \nclass="d-mobile">Peso/hectare</h6>{{ insumo.quantidade_por_hectare | number:3 }}</td><td><h6 class="d-mobile">\nPeso total</h6>{{ insumo.quantidade_total_por_area | number:3 }}</td></tr></tbody></table><hr \nng-hide="($index + 1) == vm.model.calda_aplicacao_areas.length" style="margin-top: 10px;"></fieldset></md-card><div \nclass="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" \nng-click="vm.gotoStep(2)">Voltar</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="aplicacaoCaldaForm.$invalid || !vm.model.calda || vm.model.calda.calda_insumos.length <= 0 || loadingProgress" \nng-click="vm.save(aplicacaoCaldaForm)" aria-label="confirmar">Confirmar</md-button></div></fieldset></div></div>');
$templateCache.put('app/main/caldas_plano_aplicacao/views/sucesso.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Plano de Aplica\xE7\xE3o > Cadastrar aplica\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas\n</h1></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/icons/aplicacao/ico-aplicacao-sucesso.svg" alt="sucesso"><h2>Aplica\xE7\xE3o cadastrada com sucesso!</h2><span>\n-------------------------------------------------------</span><p>O que voc\xEA gostaria de fazer agora?</p><div \nclass="content-buttons-sucesso"><md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoAdd()">\nCadastrar nova aplica\xE7\xE3o</md-button><md-button type="button" class="btn btn-tertiary btn-md-i" \nng-click="vm.gotoList()">Ver todas as aplica\xE7\xF5es</md-button><md-button class="btn btn-secondary btn-md" \nng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div></div></div>');
$templateCache.put('app/main/caldas_plano_aplicacao/views/sucesso_confirm.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Plano de Aplica\xE7\xE3o > Cadastrar aplica\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas\n</h1></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/icons/aplicacao/ico-aplicacao-sucesso.svg" alt="sucesso"><h2>Aplica\xE7\xE3o da calda confirmada!</h2><span>\n-------------------------------------------------------</span><p>O que voc\xEA gostaria de fazer agora?</p><div \nclass="content-buttons-sucesso"><md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoPlanos()">\nVer plano de aplica\xE7\xE3o</md-button><md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoList()">\nVer todas as aplica\xE7\xF5es confirmadas</md-button><md-button class="btn btn-secondary btn-md" ng-click="vm.gotoHome()">\nVoltar para home</md-button></div></div></div></div></div>');
$templateCache.put('app/main/caldas_plano_aplicacao/views/visualizar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nManejos > Aplica\xE7\xF5es de caldas > Plano de Aplica\xE7\xE3o > Visualiza\xE7\xE3o</h1><h1 class="d-mobile">Aplica\xE7\xF5es de caldas</h1>\n</div><div id="forms" class="page-layout simple fullwidth caldas-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><fieldset disabled="disabled"><div \nclass="container-title-step content-buttons"><h3><span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>\nInforma\xE7\xF5es da calda</h3><a href="#" class="btn btn-primary btn-lg" ng-click="vm.getExcelFilePlano(vm.model)">\nGerar arquivo excel</a></div><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex><label class="fw-normal">Calda</label><strong>{{ vm.model.calda }}</strong>\n</md-input-container><md-input-container flex><label class="fw-normal">Apelido</label><strong>{{ vm.model.apelido }}\n</strong></md-input-container><md-input-container flex><label class="fw-normal">Total \xE1reas:</label><strong>\n{{ vm.model.total_areas }}</strong></md-input-container><md-input-container flex><label class="fw-normal">\nTotal hectares:</label><strong>{{ vm.model.total_hectares | number:4 }}</strong></md-input-container></div><hr><table \nrow-border lm-sort hover id="responsive" class="simple table-custom table-confirm"><thead><tr><th><button \nclass="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th><button class="btn-order">\nCar\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button class="btn-order">\nQuantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr></thead><tbody><tr\n ng-repeat="item in vm.model.calda_aplicacoes_insumos"><td>{{ item.insumo_tipo }}</td><td>{{ item.insumo_nome }}</td>\n<td>{{ item.carencia }}</td><td>{{ item.unidade_medida }}</td><td>{{ item.quantidade_por_hectare | number:3 }}</td><td>\n{{ item.quantidade_total | number:3 }}</td></tr></tbody></table></md-card><br><div class="container-title-step"><h3>\n<span><img src="../assets/icons/aplicacao/ico-calda-br.svg"></span>Aplica\xE7\xE3o por \xE1rea</h3></div><md-card><fieldset \nng-repeat="area in vm.model.calda_aplicacoes_areas"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex><label class="fw-normal">\xC1rea</label><strong>\n{{ area.area }} - {{ area.hectare | number:4 }} ha</strong></md-input-container><md-input-container flex><label \nclass="fw-normal">Cultura / variedade</label><strong>{{ area.cultura }} {{ area.variedade }}</strong>\n</md-input-container></div><table row-border lm-sort hover id="responsive" class="simple table-custom table-confirm">\n<thead><tr><th><button class="btn-order">Tipo</button></th><th><button class="btn-order">Insumo</button></th><th>\n<button class="btn-order">Car\xEAncia</button></th><th><button class="btn-order">Unidade medida</button></th><th><button \nclass="btn-order">Quantidade por hectare</button></th><th><button class="btn-order">Quantidade total</button></th></tr>\n</thead><tbody><tr ng-repeat="insumo in area.insumos_area" $index><td>{{ insumo.tipo }}</td><td>{{ insumo.insumo }}\n</td><td>{{ insumo.carencia }}</td><td>{{ insumo.unidade_medida }}</td><td>\n{{ insumo.quantidade_por_hectare | number:3 }}</td><td>{{ insumo.quantidade_total | number:3 }}</td></tr></tbody>\n</table><hr ng-hide="($index + 1) == vm.model.calda_aplicacoes_areas.length" style="margin-top: 10px;"></fieldset>\n</md-card><div class="content-buttons"><a href="#" class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</a> <a href="#" class="btn btn-primary btn-lg" ng-click="vm.getExcelFilePlano(vm.model)">Gerar arquivo excel</a></div>\n</fieldset></div></div></div>');
$templateCache.put('app/main/certificados/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\nCertificados e documentos da propriedade</h1></div></div><div class="top-content-buttons"><md-button \nng-click="vm.gotoAdd()" class="btn btn-primary btn-lg-i" ng-disabled="vm.propriedades.length == 0">Adicionar arquivo\n</md-button></div></div><div class="page-layout simple fullwidth certificados-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="indices-1 form-search-horizontal">\n<div class="container"><div class="row grupo-2"><div class="col c-4"><div class="box-3"><div class="ico"><img \nsrc="../assets/icons/certificados/ico-arquivo.svg"><h3>CERTIFICADOS / DOCUMENTOS</h3></div><div class="loading" \nng-if="vm.args.loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32">\n</md-progress-circular></div><div class="totais" ng-hide="vm.args.loading"><div class="total"><h6>ARQUIVOS</h6><span \nclass="number">{{vm.dash.total_arquivos}}</span><br><span class="nome">TOTAL</span></div><div class="total"><h6>\nTAMANHO EM MB</h6><span class="number">{{ vm.totalMB | number:3 }}</span><br><span class="nome">TOTAL MB (MEGABYTE)\n</span></div></div><div class="footer"><a href="" ng-click="vm.toAncoraLink(\'lista\'); vm.resetFilters()"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Ver lista</a></div></div></div><div class="col c-2"><div class="box-2"><div \nclass="ico"><img src="../assets/icons/certificados/ico-arquivo-vencido.svg"><h3 class="color-red">CERTIFICADOS<br>\nVENCIDOS</h3></div><div class="loading" ng-if="vm.args.loading"><md-progress-circular id="toolbar-progress" \nclass="md-accent" md-diameter="32"></md-progress-circular></div><div class="total" ng-hide="vm.args.loading"><span \nclass="number">{{vm.dash.certificado_vencidos}}</span><br><span class="nome">TOTAL</span></div><div class="footer"><a \nhref="" ng-click="vm.filterVencidos()"><md-icon md-font-icon="icon-plus-circle"></md-icon>Ver lista</a></div></div>\n</div></div></div></div><div class="container-title-step content-buttons"><h3><span><img \nsrc="../assets/icons/certificados/ico-arquivo-br.svg"></span>CERTIFICADOS E DOCUMENTOS DA PROPRIEDADE</h3><md-button \nng-click="vm.gotoAdd()" class="btn btn-primary btn-lg-i" ng-disabled="vm.propriedades.length == 0">Adicionar arquivo\n</md-button></div><div class="form-search-horizontal"><div class="container"><div class="row"><div \nclass="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label>Nome</label><input id="nome-filtro" \nclass="mobile-text-center input-search" placeholder="Digite" ng-model="vm.args.NomeArquivo"></md-input-container></div>\n<div class="col"><md-input-container class="form-group select-custom" flex><label class="form-label">Tipo de arquivo\n</label><select class="form-select" name="CertificadoTipoArquivoId" ng-model="vm.args.CertificadoTipoArquivoId" \nng-init="vm.args.CertificadoTipoArquivoId = options[0]"><option value="" disabled="disabled">Selecione</option><option \nng-value="item.id" ng-repeat="item in vm.filtros.tipos">{{item.nome}}</option></select></md-input-container></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label class="form-label">Status</label><select \nclass="form-select" name="StatusId" ng-model="vm.args.StatusId" ng-init="vm.args.StatusId = options[0]"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="item.id" ng-repeat="item in vm.status">{{item.nome}}\n</option></select></md-input-container></div><div class="col"><h2>Data validade</h2><div \nclass="content-datepicker-filter"><md-input-container class="datepicker-custom" flex="25"><label>Data inicial</label>\n<md-datepicker name="DataValidadeInicial" ng-model="vm.args.DataValidadeInicial" md-placeholder="Inserir data" \nmd-open-on-focus></md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="25"><label>\nData final</label><md-datepicker name="DataValidadeFinal" ng-model="vm.args.DataValidadeFinal" md-open-on-focus \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div></div><div class="col"><div \nclass="content-buttons"><md-button class="btn btn-tertiary" ng-click="vm.resetPagination(); vm.args._change()">Buscar\n</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></div><a \nid="lista"></a><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom"><thead><tr><th \nclass="secondary-text pagination-custom table-column-id" lm-sort-header="CertificadoTipoArquivoId" \nlm-title="Tipo de arquivo"></th><th class="secondary-text pagination-custom table-column-id" \nlm-sort-header="NomeArquivo" lm-title="Nome do arquivo"></th><th class="secondary-text pagination-custom" \nlm-sort-header="DataValidadeInicial" lm-title="Data validade"></th><th class="secondary-text pagination-custom" \nlm-sort-header="data_inclusao" lm-title="Data inclus\xE3o"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Arquivo</span></div></th><th \nclass="secondary-text pagination-custom" lm-sort-header="StatusId" lm-title="Status"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td><h6 class="d-mobile">Tipo arquivo</h6>\n{{model.certificado_tipo_arquivo.nome}}</td><td><h6 class="d-mobile">Nome</h6>{{model.nome_arquivo}}</td><td><h6 \nclass="d-mobile">Data validade</h6>{{model.data_validade | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">\nData cria\xE7\xE3o</h6>{{model.data_criacao | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">Arquivo</h6><strong><a \nhref="{{model.uploaded_file.uri}}" target="_blank">{{model.uploaded_file.file_name}}</a></strong></td><td><h6 \nclass="d-mobile">Status</h6><div class="marcador marcador-vermelho" ng-if="model.vencido"><span></span>Vencido</div>\n<div class="marcador marcador-verde" ng-if="!model.vencido"><span></span>V\xE1lido</div></td><td><h6 class="d-mobile">\nA\xE7\xF5es</h6><md-button class="edit-button md-icon-button" ng-click="vm.gotoEditar(model.id)" aria-label="Editar"><i \nclass="fas fa-pen"><md-tooltip hide-xs md-direction="left">Editar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table></div></div>\n<lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/certificados/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1>Certificados e documentos > Adicionar arquivo</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>CERTIFICADOS E DOCUMENTOS DA PROPRIEDADE</h3></div><div \nclass="content-register"><form name="certificadoForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><div api-form-validation-summary form="certificadoForm"></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label>\nTipo do arquivo</label><md-select class="md-block" ng-model="vm.model.certificado_tipo_arquivo_id" \nname="certificado_tipo_arquivo_id" placeholder="Escolher um tipo" required><md-option \nng-repeat="item in vm.arquivo_tipos" ng-value="item.id">{{item.nome}}</md-option></md-select><div \nng-messages="certificadoForm.certificado_tipo_arquivo_id.$error" \nng-if="certificadoForm.certificado_tipo_arquivo_id.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{certificadoForm.certificado_tipo_arquivo_id.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15"><a class="btn-addnew" \nng-click="vm.showDialogCreateTipoArquivo($event, $index)"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nAdicionar tipo</a></md-input-container><md-input-container flex><label>Nome do arquivo</label><input id="inptNm" \ntype="text" name="nome_arquivo" placeholder="Digite" ng-model="vm.model.nome_arquivo" maxlength="30" required><div \nclass="errors" ng-messages="certificadoForm.nome_arquivo.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{certificadoForm.nome_arquivo.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="15"><label>Data da validade</label><md-datepicker \nname="data_validade" ng-model="vm.model.data_validade" md-placeholder="Inserir data" md-min-date="vm.date_init" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="certificadoForm.data_validade.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{certificadoForm.data_validade.$api.error.message}}</div></div></md-input-container><md-input-container flex><label>\nArquivo</label>{{ vm.fileStatus }} <input class="desktop-only mobile-only" type="file" id="docFile" \nonchange="angular.element(this).scope().vm.selectedFile(this)" \naccept="\n                                                    application/pdf,\n                                                    application/msword,\n                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n                                                    application/excel, application/vnd.ms-excel, application/msexcel,\n                                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n                                                    image/gif, \n                                                    image/jpeg, \n                                                    image/png\n                                                ">\n<md-button type="button" class="btn btn-tertiary" ng-click="vm.onClickFile()" ng-hide="vm.file.name">\nSelecione o arquivo</md-button><div class="file-added" ng-show="vm.file.name"><p title="{{vm.file.name}}">\n{{ vm.file.name }}</p><md-button class="icon-btn md-icon-button float-right" ng-click="vm.removeFile()"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></div></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nmd-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoLista()">Voltar</md-button><md-button \nmd-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="certificadoForm.$invalid || !vm.file.name || certificadoForm.$pristine || loadingProgress" \nng-click="vm.saveFile(vm.model)">Salvar</md-button></div><div api-form-validation-summary form="certificadoForm"></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/certificados/views/criar_tipo_arquivo.tmpl.html','<md-dialog class="modal-custom-register"><form name="tipoDespesaForm" novalidate="" api-form="vm.api_response_erro" \nng-submit="vm.save(tipoDespesaForm)"><md-toolbar><div class="md-toolbar-tools"><h2>Inclus\xE3o de tipo de arquivo</h2>\n<md-button class="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar>\n<md-dialog-content><div api-form-validation-summary form="tipoDespesaForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><label>\nDigite o nome do tipo de arquivo que deseja incluir</label><input type="text" name="tipo_despesa" \nng-model="vm.model.nome" placeholder="Digite" maxlength="30" required><div class="errors" \nng-messages="tipoDespesaForm.tipo_despesa.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{tipoDespesaForm.tipo_despesa.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="tipoDespesaForm.$error.required" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/certificados/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1>Certificados e documentos > Editar arquivo</h1></div></div>\n<div id="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>CERTIFICADOS E DOCUMENTOS DA PROPRIEDADE</h3></div><div \nclass="content-register"><form name="certificadoForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><div api-form-validation-summary form="certificadoForm"></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label>\nTipo do arquivo</label><md-select class="md-block" ng-model="vm.model.certificado_tipo_arquivo.id" \nname="certificado_tipo_arquivo_id" placeholder="Escolher um tipo" required><md-option \nng-repeat="item in vm.arquivo_tipos" ng-value="item.id">{{item.nome}}</md-option></md-select><div \nng-messages="certificadoForm.certificado_tipo_arquivo_id.$error" \nng-if="certificadoForm.certificado_tipo_arquivo_id.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{certificadoForm.certificado_tipo_arquivo_id.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15"><a class="btn-addnew" \nng-click="vm.showDialogCreateTipoArquivo($event, $index)"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nAdicionar tipo</a></md-input-container><md-input-container flex><label>Nome do arquivo</label><input id="inptNm" \ntype="text" name="nome_arquivo" placeholder="Digite" ng-model="vm.model.nome_arquivo" maxlength="30" required><div \nclass="errors" ng-messages="certificadoForm.nome_arquivo.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{certificadoForm.nome_arquivo.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="15"><label>Data da validade</label><md-datepicker \nname="data_validade" ng-model="vm.model.data_validade" md-placeholder="Inserir data" md-open-on-focus required>\n</md-datepicker><div class="errors" ng-messages="certificadoForm.data_validade.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{certificadoForm.data_validade.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex><label>Arquivo</label>{{ vm.fileStatus }} <input \nclass="desktop-only mobile-only" type="file" id="docFile" \nonchange="angular.element(this).scope().vm.selectedFile(this)" \naccept="\n                                                    application/pdf,\n                                                    application/msword,\n                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n                                                    application/excel, application/vnd.ms-excel, application/msexcel,\n                                                    application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,\n                                                    application/vnd.openxmlformats-officedocument.wordprocessingml.document,\n                                                    image/gif, \n                                                    image/jpeg, \n                                                    image/png\n                                                ">\n<md-button type="button" class="btn btn-tertiary" ng-click="vm.onClickFile()" ng-hide="vm.file.name">\nSelecione o arquivo</md-button><div class="file-added" ng-show="vm.file.name"><a href="{{vm.model.uploaded_file.uri}}" \ntitle="{{vm.file.name}}">{{ vm.file.name }}</a><md-button class="icon-btn md-icon-button float-right" \nng-click="vm.removeFile()"><div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs \nmd-direction="left">Excluir</md-tooltip></i></div></md-button></div></md-input-container></div></md-card></fieldset>\n<div class="content-buttons"><md-button md-button-id="bttnVltr" class="btn btn-secondary btn-lg" \nng-click="vm.gotoLista()">Voltar</md-button><md-button md-button-id="bttnCdstr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" ng-disabled="!vm.file.name || loadingProgress" \nng-click="vm.saveFile(vm.model)">Salvar</md-button></div><div api-form-validation-summary form="certificadoForm"></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/certificados/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-header"><h1 translate="LAUDO.TITLE">\nLaudo t\xE9cnico</h1><div class="header-id-lote"><label>ID do laudo</label><input type="text" ng-model="vm.model.id" \ndisabled="disabled"></div></div><div class="content-register with-select"><form name="laudoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>\nDados da venda</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500">\n<label translate="LAUDO.TRACKING_CODE">C\xF3digo rastreamento</label><input type="text" name="codigo_rastreamento" \nplaceholder="Insira o c\xF3digo rastreamento" ng-model="vm.model.lote_numero" disabled="disabled"></md-input-container>\n<md-input-container class="datepicker-custom" flex="20" md-delay="500"><label translate="LAUDO.SHIPPING_DATE">\nData de expedi\xE7\xE3o</label><md-datepicker name="data_expedicao" ng-model="vm.model.data_expedicao" \nmd-placeholder="Inserir data" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="50" md-delay="500"><label \ntranslate="LAUDO.CUSTOMER_NAME">Nome do cliente</label><input type="text" name="nome_cliente" \nplaceholder="Inserir nome do cliente" ng-model="vm.model.cliente_consumidor_nome" disabled="disabled">\n</md-input-container><md-input-container flex="50" md-delay="500"><label translate="LAUDO.EMAIL">E-mail</label><input \ntype="email" name="email" placeholder="Inserir e-mail" maxlength="60" \nng-pattern="/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/" \nng-model="vm.model.cliente_consumidor_email" required><div ng-messages="laudoForm.email.$error" \nng-if="laudoForm.email.$touched"><div ng-message="required">Campo Obrigat\xF3rio.</div><div ng-message="pattern">\nE-mail incorreto.</div><div ng-message="api_erro">{{laudoForm.email.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.CULTURE">Cultura</label><input type="text" name="cultura" \nplaceholder="Inserir cultura" ng-model="vm.model.cultura.nome" disabled="disabled"></md-input-container>\n<md-input-container flex="25" md-delay="500"><label translate="LAUDO.VARIETY">Variedade</label><input type="text" \nname="variedade" placeholder="Inserir variedade" ng-model="vm.model.produto_variedade" disabled="disabled">\n</md-input-container><md-input-container flex="25" md-delay="500"><label translate="LAUDO.CATEGORY">Categoria</label>\n<input type="text" name="nome_cliente" placeholder="Inserir categoria" ng-model="vm.model.categoria"><div \nng-messages="laudoForm.categoria.$error" ng-if="laudoForm.categoria.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.categoria.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15" md-delay="500"><label translate="LAUDO.AMOUNT">Quantidade</label>\n<input type="text" name="quantidade" ng-model="vm.model.quantidade" disabled="disabled"></md-input-container>\n<md-input-container flex="20" md-delay="500" ng-hide="vm.model.unidade_medida == \'Embalagem\'"><label \ntranslate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" name="quantidade" \nng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin ng-if="vm.model.unidade_medida == \'Embalagem\'"><md-input-container flex \nmd-delay="500"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" \nname="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input type="text" name="embalagem_tipo" \nng-model="vm.model.embalagem_tipo" disabled="disabled"></md-input-container><md-input-container flex md-delay="500">\n<label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input type="text" name="embalagem_peso" \nng-model="vm.model.embalagem_peso" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.SALES_DOCUMENT_NUMBER">N\xBA do documento de venda</label><input type="text" \nname="numero_documento_venda" placeholder="Inserir o n\xBA do documento de venda" \nng-model="vm.model.numero_documento_venda"></md-input-container><md-input-container flex="75" md-delay="500"><label \ntranslate="LAUDO.RESPONSIBLE">Respons\xE1vel</label><input type="text" name="responsavel" \nplaceholder="Inserir o respons\xE1vel" ng-model="vm.model.responsavel_nome" required><div \nng-messages="laudoForm.responsavel.$error" ng-if="laudoForm.responsavel.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.responsavel.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n class="select-custom" flex="40" md-delay="500"><label translate="LAUDO.CONCLUSION">Conclus\xE3o</label><input \ntype="text" name="laudo_conclusao_conformidade" \nng-model="vm.model.laudo_conclusao.laudo_conclusao_conformidade.descricao"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea ng-model="vm.model.laudo_conclusao.observacao" \nname="laudo_conclusao_observacao" rows="5"></textarea></md-input-container></div></md-card><md-card><h3>Avalia\xE7\xE3o</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30" md-delay="500"><label \ntranslate="LAUDO.BATCH_ID">ID do lote</label><input type="text" name="lote_id" \nng-model="vm.model.lote_distribuicao_venda_id"></md-input-container></div><hr class="divider"><div class="pesos" \nng-if="vm.model.unidade_medida == \'Kg\' || vm.model.unidade_medida == \'Embalagem\'"><h4>Pesos amostrados</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="peso in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Peso {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-model="peso.medida" ui-number-mask="3" \nmin="0.001" maxlength="15" required></md-input-container></div></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_WEIGHT">\nPeso total da amostra</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" \nui-number-mask="3" min="0.001" max="{{vm.model.quantidade}}"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" \nname="percentual_amostrado" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="vm.model.laudo_amostra.percentual_medida"></md-input-container><md-input-container flex md-delay="500"><label\n translate="LAUDO.AVERAGE_WEIGHT">Peso m\xE9dio</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="3" min="0.001" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_WEIGHT">Peso esperado</label><input \ntype="text" name="peso_amostra" placeholder="Inserir o peso esperado" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="3" min="0.001" maxlength="15"></md-input-container>\n</div></div><div class="quantidade" ng-if="vm.model.unidade_medida == \'Unidades\'"><h4>Quantidade amostradas</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="quantidade in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Quantidade {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-change="vm.calcLaudoAmostra()" \nng-model="quantidade.medida" ui-number-mask="0" min="0.1" maxlength="15" required></md-input-container></div></div><div\n layout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.SAMPLE_TOTAL_AMOUNT">Quantidade total da amostra</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="0" min="0" maxlength="15" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">\nPercentual amostrado</label><input type="text" name="percentual" ui-percentage-value maxlength="5" \nui-percentage-mask="0" min="0.1" max="100.0" ng-model="vm.model.laudo_amostra.percentual_medida" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.AVERAGE_AMOUNT">Quantidade m\xE9dia\n</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="0" \nmin="0" maxlength="15"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.EXPECTED_AMOUNT">Quantidade esperada</label><input type="text" name="peso_amostra" \nplaceholder="Inserir a quantidade" ng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="0" min="0" \nmaxlength="15" required></md-input-container></div></div><div class="defeitos"><h4>Defeitos</h4><div layout="column" \nlayout-gt-xs="row" layout-margin ng-repeat="defeito in vm.model.laudo_defeito"><md-input-container \nclass="select-custom" flex="50" md-delay="500"><label>Defeito {{ $index + 1 }}</label><input type="text" \nname="descricao" ng-model="defeito.descricao"></md-input-container><md-input-container flex="25" md-delay="500" \nng-if="defeito.laudo_defeito_tipo_id == 8"><label translate="LAUDO.OTHER">Outro</label><input type="text" \nname="defeito_outro" placeholder="Inserir defeito" ng-model="defeito.laudo_defeito_tipo_outro.descricao">\n</md-input-container><md-input-container class="select-custom" flex="25" md-delay="500"><label \ntranslate="LAUDO.CLASSIFICATION">Classifica\xE7\xE3o</label><input type="text" name="laudo_defeito_classificacao" \nng-model="defeito.laudo_defeito_classificacao.descricao"></md-input-container><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_OTHER">Porcentagem</label><input type="text" \nname="porcentagem_defeito" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="defeito.porcentagem"></md-input-container></div></div><hr class="divider"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.MATURATION">Matura\xE7\xE3o</label><input type="text" name="laudo_maturacao" \nng-model="vm.model.laudo_maturacao.descricao"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.APPEARANCE">Apar\xEAncia</label><input type="text" name="aparencia" ng-model="vm.model.aparencia">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.TEMPERATURE">Temperatura</label>\n<input type="text" name="laudo_maturacao" ng-model="vm.model.temperatura"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.CALIBER">Calibre</label><input type="text" name="laudo_calibre" \nng-model="vm.model.laudo_calibre.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.COLORING">Colora\xE7\xE3o</label><input type="text" name="laudo_coloracao" \nng-model="vm.model.laudo_coloracao.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.ODOR">Odor</label><input type="text" name="laudo_odor" \nng-model="vm.model.laudo_odor.descricao"></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.FLAVOR">Sabor\n</label><input type="text" name="laudo_sabor" ng-model="vm.model.laudo_sabor.descricao"></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.PRESSURE">Press\xE3o</label><input \ntype="text" name="laudo_pressao" ng-model="vm.model.laudo_pressao.descricao"></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.BRIX">Brix</label><input type="text" \nname="laudo_brix" ng-model="vm.model.laudo_brix.descricao"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.OBSERVATION">\nObserva\xE7\xE3o</label><textarea ng-model="vm.model.observacao" name="observacao" rows="5"></textarea></md-input-container>\n</div></md-card><md-card class="laudo-fotos"><h3 class="custom">Fotos</h3>`<div layout="row" layout-gt-xs="row" \nlayout-margin><div class="item" ng-repeat="imagem in vm.model.laudo_upload_file" flex="40"><div class="item-content">\n<div class="imagem" flex="30"><img class="thumbnail-description" ng-src="{{imagem.url}}"></div><div class="body" flex>\n<label>Descri\xE7\xE3o</label><textarea class="textarea-descricao" name="descricao" ng-model="imagem.descricao" cols="40" \nrows="3"></textarea></div></div></div></div></md-card></fieldset><div api-form-validation-summary form="laudoForm">\n</div></form></div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.comeBack()">\nVoltar</md-button></div></div></div></div>');
$templateCache.put('app/main/dados_cadastrais/view/dados_cadastrais.html','<div layout="column"><div id="pagamento-form-wrapper" layout="column" class="mcadastro" layout-align="start center" \nng-hide="vm.processando"><div class="content content-pagamento"><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="space-between center" class="logout"><img src="/assets/images/logos/logo-compartveg-cadastro_branco.png" \nalt="compartveg"><md-button ng-click="vm.logout()"><md-icon class="icon-logout white-500-fg" \nmd-font-icon="icon-logout"></md-icon>Sair</md-button></div><div class="md-primary" md-center-tabs><div \nlabel="Pagamento"><md-content class="md-padding"><form name="pagamentoForm" novalidate="" \napi-form="vm.api_response_erro"><div class="md-whiteframe-8dp whiteframe-background divider-boxs mcadastro"><div \nlayout="column" layout-gt-sm="row" layout-align="center"><div class="form-title dados">Dados Cadastrais</div></div><hr>\n<div api-form-validation-summary form="pagamentoForm"></div><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="center"><md-input-container class="md-input-has-value cz"><h1>Tipo de pessoa</h1><md-radio-group \nmd-autofocus name="pessoa_tipo" layout-align="center center" ng-disabled="vm.model.cnpj_cpf.length > 2" \nng-model="vm.model.pessoa_tipo.id" layout="row" required><md-radio-button value="1">F\xEDsica</md-radio-button>\n<md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="pagamentoForm.pessoa_tipo.$error" ng-show="pagamentoForm.pessoa_tipo.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.pessoa_tipo.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="CADASTRAIS.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" ui-br-cpfcnpj-mask required><div class="errors" \nng-messages="pagamentoForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="invalido">CPF inv\xE1lido</div><div ng-message="api_erro">{{pagamentoForm.cnpj_cpf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label \ntranslate="CADASTRAIS.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" \nui-br-cpfcnpj-mask required><div class="errors" ng-messages="pagamentoForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.cnpj_cpf.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex><label translate="CADASTRAIS.NOME">Nome</label><input type="text" \nname="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="pagamentoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.nome.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="5">\n<label translate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.cliente_telefone.ddd" \nmaxlength="2" required><div class="errors" ng-messages="pagamentoForm.ddd.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.ddd.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input \ntype="text" name="numero" ng-model="vm.model.cliente_telefone.numero" ui-mask-placeholder-char="space" \nui-mask="99999-9999" required><div class="errors" ng-messages="pagamentoForm.numero.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.numero.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex><label translate="CADASTRAIS.EMAIL">E-mail</label><input type="text" \nname="email" ng-model="vm.model.email" required><div class="errors" ng-messages="pagamentoForm.email.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.email.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="30"><input type="text" name="cep" ng-model="vm.model.cliente_endereco.cep" placeholder="CEP" \nrequired ui-br-cep-mask><div class="errors" ng-messages="pagamentoForm.cep.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{pagamentoForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nflex="50"><label translate="CADASTRAIS.ENDERECO">Endere\xE7o</label><input type="text" name="rua" \nng-model="vm.model.cliente_endereco.endereco" ng-required="true"><div class="errors" \nng-messages="pagamentoForm.rua.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.rua.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.NUMERO">N\xFAmero</label><input type="text" name="numero" \nng-model="vm.model.cliente_endereco.numero" maxlength="6" required><div class="errors" \nng-messages="pagamentoForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.numero.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="35"><label translate="CADASTRAIS.BAIRRO">Bairro</label>\n<input type="text" name="bairro" ng-model="vm.model.cliente_endereco.bairro" required><div class="errors" \nng-messages="pagamentoForm.bairro.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.bairro.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="15"><input type="text" name="complemento" ng-model="vm.model.cliente_endereco.complemento" \nplaceholder="Complemento"><div class="errors" ng-messages="pagamentoForm.complemento.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.complemento.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="25"><input type="text" name="cidade_nome" ng-model="vm.model.cliente_endereco.cidade_nome" placeholder="Cidade" \nrequired><div class="errors" ng-messages="pagamentoForm.Cidade.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="api_erro">{{pagamentoForm.Cidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><input type="text" name="uf" maxlength="2" ng-model="vm.model.cliente_endereco.uf" \nplaceholder="UF" required><div class="errors" ng-messages="pagamentoForm.uf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.uf.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin layout-align="space-between center">\n<md-input-container flex="40"><md-checkbox name="termo_uso_aceito" ng-model="vm.model.termo_uso_aceito" required>\n</md-checkbox><span>Aceitar os <a href="" ng-click="vm.ShowDialogTermos($event)">termos de uso</a></span><div \nng-messages="pagamentoForm.termo_uso_aceito.$error" ng-if="pagamentoForm.termo_uso_aceito.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.termo_uso_aceito.$api.error.message}}</div></div></md-input-container><md-button type="button" \nclass="md-raised md-accent pagar" aria-label="Submit" ng-disabled="pagamentoForm.$invalid" ng-click="vm.save(model)">\nPRONTO<md-icon class="icon-check" md-font-icon="icon-check"></md-icon></md-button></div></div></form></md-content>\n</div></div></div></div></div><div id="loading-form-wrapper" layout="column" layout-align="center center" \nng-show="vm.processando"><div id="loading-form" class="md-whiteframe-8dp"><h2>\nPor favor, aguarde! Estamos processando sua solicita\xE7\xE3o.</h2></div></div>');
$templateCache.put('app/main/dados_cadastrais/view/termos-uso.tmpl.html','<md-dialog class="termos"><form name="clienteForm" novalidate="" api-form="vm.api_response_erro"><md-toolbar><div \nclass="md-toolbar-tools"><div class="md-toolbar-content-60"><h2><span>Termos de Uso</span> do Caderno de Campo.</h2><p>\nEm caso de d\xFAvida, entre em contato com atendimento@eattae.com.br</p></div><div class="md-toolbar-content-40"><img \nclass="termos" src="../assets/images/logos/eattae.png"></div></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="clienteForm"></div><h1 style="text-align:center;">POL\xCDTICA COMERCIAL</h1><h2>EATTAE\n<br>DAR AS M\xC3OS A QUEM ALIMENTA O MUNDO</h2><strong>NOSSAS CREN\xC7AS:</strong><p>\u2022 Semear bons exemplos</p><p>\n\u2022 Plantar a paix\xE3o pelo que fazemos</p><p>\u2022 Irrigar mentes e cora\xE7\xF5es</p><p>\u2022 Colher e distribuir conhecimento</p><p>\n\u2022 Compartilhar bons frutos</p><strong>NOSSOS DIFERENCIAIS:</strong><p>\n\u2022 Experi\xEAncia de mais de 10 anos na rede produtiva de alimentos.</p><p>\n\u2022 Equipe altamente qualificada de profissionais com anos de experi\xEAncia em diferentes setores do agroneg\xF3cio.</p><p>\n\u2022 Projetos realizados em v\xE1rias regi\xF5es do Brasil e para diferentes setores e redes produtivas de alimentos.</p><p>\n\u2022 Possu\xEDmos servi\xE7os e solu\xE7\xF5es totalmente personalizadas para atender a demanda de nossos clientes e parceiros.</p>\n<h2>RESPONSABILIDADES EATTAE:</h2><p>\nDivulgar a marca EATTAE os produtos, em todo o territ\xF3rio nacional em qualquer um dos meios de comunica\xE7\xE3o mais adequado para cada regi\xE3o. Podendo ser: radio, televis\xE3o, jornal, revista, internet, cinema ou qualquer outra m\xEDdia que o departamento de marketing considerar adequado.\n</p><p>\nOferecer a maior quantidade e diversidade de produtos para todo o nosso ecossistema; principalmente para a rede produtiva de alimentos.\n</p><p>\nPrezar pela qualidade e idoneidade de nossos fornecedores e produtores, buscando sempre oferecer os melhores produtos a pre\xE7os altamente competitivos e acess\xEDveis.\n</p><p>Respeitar os Termos e Condi\xE7\xF5es de Uso do Site.</p><strong>FORMA DE PAGAMENTO DA MENSALIDADE & ANUIDADE</strong>\n<p>A mensalidade ser\xE1 paga atrav\xE9s do site institucional do EATTAE: <a target="_blank" \nhref="https://caderno.eattae.com.br/">www.caderno.eattae.com.br</a></p><p>\nA mensalidade de R$ 49,90 reais ser\xE1 cobrada atrav\xE9s do meio de pagamento Pagar.me e poder\xE1 ser paga por cart\xE3o de cr\xE9dito.\n</p><p>\nVoc\xEA pode parcelar a sua assinatura em at\xE9 12 parcelas sem juros nas mais diversas bandeiras de cart\xE3o: Visa, Mastercard, American Express, Elo, Hipercard, Diners, Discover, Aura e JCB. Ao escolher a assinatura anual com o valor de R$ 549,00 reais j\xE1 ser\xE1 aplicado um desconto de 10% em rela\xE7\xE3o \xE0 assinatura mensal.\n</p><strong>TIPO DE ASSINATURA</strong><p>B\xE1sica: R$ 49,90</p><p>>> acesso (login e senha) a plataforma</p><p>\n>> acesso ao caderno de campo</p><strong>POL\xCDTICA DE RESSARCIMENTO DO PRODUTO</strong><p>\nPara solicitar o cancelamento, favor entrar em contato com o SAC atrav\xE9s do e-mail: <a \nhref="mailto:atendimento@eattae.com.br">atendimento@eattae.com.br</a></p><p>\nDa solicita\xE7\xE3o do cancelamento: Assim que solicitado o cancelamento do seu pedido atrav\xE9s do SAC, a EATTAE informar\xE1 qual a forma mais conveniente que voc\xEA gostaria de ser ressarcido:\n</p><p>\n>> Op\xE7\xE3o do ressarcimento: A EATTAE restitui os valores pagos utilizando a mesma forma de pagamento escolhida no processo de compras: 1) No caso do cart\xE3o de cr\xE9dito, o cr\xE9dito do valor estornado acontecer\xE1 em cerca de 5 dias \xFAteis, e se a fatura do seu cliente fechar neste per\xEDodo, o cr\xE9dito entrar\xE1 na fatura do m\xEAs seguinte ao estorno.\n</p><strong>SOLICITA\xC7\xC3O DO RESSARCIMENTO</strong><p>\nPara solicitar o ressarcimento do valor, deve-se entrar em contato com a EATTAE atrav\xE9s do e-mail <a \nhref="mailto:atendimento@eattae.com.br">atendimento@eattae.com.br</a>\n para que as provid\xEAncias sejam tomadas o quanto antes.</p><strong>POL\xCDTICA DE PRIVACIDADE</strong><p>\nEste documento tem por finalidade estabelecer as regras para tratamento de dados que inclui as opera\xE7\xF5es de coleta, produ\xE7\xE3o, recep\xE7\xE3o, classifica\xE7\xE3o, utiliza\xE7\xE3o, acesso, reprodu\xE7\xE3o, transmiss\xE3o, distribui\xE7\xE3o, processamento, arquivamento, armazenamento, elimina\xE7\xE3o, avalia\xE7\xE3o ou controle da informa\xE7\xE3o, modifica\xE7\xE3o, comunica\xE7\xE3o, transfer\xEAncia, difus\xE3o ou extra\xE7\xE3o dos dados coletados dos USU\xC1RIOS, al\xE9m do registro de suas atividades, de acordo com as leis aplic\xE1veis.\n</p><strong>CERTIFICADO DE SEGURAN\xC7A</strong><p>\nO Certificado de Seguran\xE7a garante que todos os seus dados pessoais, tais como informa\xE7\xF5es de cart\xE3o de cr\xE9dito, hist\xF3rico de pedidos ou endere\xE7o de entrega, jamais ser\xE3o divulgados. Nossa tecnologia e a de nossos parceiros impede que os dados sejam acessados por terceiros.\n</p><strong>COMPARTILHAMENTO DE INFORMA\xC7\xD5ES</strong><p>\nA EATTAE n\xE3o vende, aluga ou transfere seus dados para terceiros. As informa\xE7\xF5es ser\xE3o utilizadas apenas internamente, como estat\xEDsticas gen\xE9ricas, visando obter resultados efetivos sobre o perfil dos usu\xE1rios, compras, regi\xE3o e, assim, poder oferecer uma melhor qualidade nos servi\xE7os e no atendimento oferecidos, assim como oferecer produtos mais adequado e melhores para cada perfil de cliente.\n</p><strong>E-MAIL E SERVI\xC7OS</strong><p>\nO envio de e-mail sobre nossas ofertas e servi\xE7os ser\xE3o enviados apenas com o consentimento de nossas consultoras e clientes, podendo ser desativado a qualquer hora. Ao cadastrar-se em nosso site, voc\xEA poder\xE1 escolher se deseja ou n\xE3o receber e-mails com informa\xE7\xF5es promocionais ou nossos newsletters com conte\xFAdo informativo e educativo.\n</p><strong>PROPRIEDADE DAS INFORMA\xC7\xD5ES</strong><p>\nTodas as informa\xE7\xF5es contidas neste site s\xE3o de propriedade da EATTAE, portanto, n\xE3o poder\xE3o ser alteradas, copiadas, extra\xEDda ou de qualquer outra forma utilizadas sem pr\xE9via e expressa autoriza\xE7\xE3o por escrito.\n</p><strong>HIST\xD3RICO DE PRODUTOS VISUALIZADOS</strong><p>\nNa EATTAE uso do hist\xF3rico (cookies) \xE9 feito apenas para reconhecer um visitante constante e melhorar a experi\xEAncia de compra. Os cookies n\xE3o armazenam dados pessoais.\n</p><strong>ENVIO DE E-MAILS</strong><p>\nA EATTAE nunca envia e-mail solicitando confirma\xE7\xE3o de dados/cadastros ou com anexos execut\xE1veis (extens\xF5es .exe, .com, .scr, .bat) e links para download.\n</p><p>\nNos reservamos ao direito de atualizar esse documento a qualquer momento, por esse motivo consulte-o com frequ\xEAncia.\n</p><p>\nEste site \xE9 de propriedade, mantido, e operado por MANGIATERRA, MARTINS E ZANA LTDA ME, pessoa jur\xEDdica de direito privado, com endere\xE7o na Frei Caneca, 219, Conjunto 31, Consola\xE7\xE3o, S\xE3o Paulo, SP, CEP 01307-001, inscrita no CNPJ/MF sob o n\xFAmero 21.435.308/0001-30, adiante identificada como EATTAE.\n</p></md-dialog-content><md-dialog-actions class="termos" layout="row" layout-align="space-between center"><div><a \nhref="../assets/pdf/termos_eattae.pdf" target="_blank"><md-icon class="termos icon-printer white-fg s40" \nmd-font-icon="icon-printer"></md-icon></a></div><md-button class="md-raised md-accent" ng-click="vm.close()">Fechar\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/dados_convidado/view/dados_convidado.html','<div layout="column"><div id="pagamento-form-wrapper" layout="column" class="mcadastro" layout-align="start center" \nng-hide="vm.processando"><div class="content content-pagamento"><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="space-between center" class="logout"><img src="/assets/images/logos/logo-compartveg-cadastro_branco.png" \nalt="compartveg"><md-button ng-click="vm.logout()"><md-icon class="icon-logout white-500-fg" \nmd-font-icon="icon-logout"></md-icon>Sair</md-button></div><div class="md-primary" md-center-tabs><div \nlabel="Pagamento"><md-content class="md-padding"><form name="pagamentoForm" novalidate="" \napi-form="vm.api_response_erro"><div class="md-whiteframe-8dp whiteframe-background divider-boxs mcadastro"><div \nlayout="column" layout-gt-sm="row" layout-align="center"><div class="form-title dados">Cadastro</div></div><hr><div \napi-form-validation-summary form="pagamentoForm"></div><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="center"><md-input-container class="md-input-has-value cz"><h1>Tipo de pessoa</h1><md-radio-group \nmd-autofocus name="pessoa_tipo" layout-align="center center" ng-disabled="vm.model.cnpj_cpf.length > 2" \nng-model="vm.model.pessoa_tipo.id" layout="row" required><md-radio-button value="1">F\xEDsica</md-radio-button>\n<md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="pagamentoForm.pessoa_tipo.$error" ng-show="pagamentoForm.pessoa_tipo.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.pessoa_tipo.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="CADASTRAIS.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" ui-br-cpfcnpj-mask required><div class="errors" \nng-messages="pagamentoForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container\n flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="CADASTRAIS.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" ng-model="vm.model.cnpj_cpf" ui-br-cpfcnpj-mask required><div class="errors" \nng-messages="pagamentoForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="CADASTRAIS.NOME">Nome</label><input type="text" name="nome" ng-model="vm.model.nome" required>\n<div class="errors" ng-messages="pagamentoForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.nome.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="5"><label translate="CADASTRAIS.DDD">DDD\n</label><input type="text" name="ddd" ng-model="vm.model.telefone_ddd" maxlength="2" required><div class="errors" \nng-messages="pagamentoForm.telefone_ddd.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="35"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" \nng-model="vm.model.telefone_numero" ui-mask-placeholder-char="space" ui-mask="99999-9999" required><div class="errors" \nng-messages="pagamentoForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="70"><input type="text" name="cep" ng-model="vm.model.cliente_endereco.cep" placeholder="CEP" required \nui-br-cep-mask><div class="errors" ng-messages="pagamentoForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">{{pagamentoForm.cep.$api.error.message}}\n</div></div><md-progress-circular ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px">\n</md-progress-circular></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="90"><label translate="CADASTRAIS.ENDERECO">Endere\xE7o</label><input type="text" name="rua" \nng-model="vm.model.cliente_endereco.endereco" ng-required="true"><div class="errors" \nng-messages="pagamentoForm.rua.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.rua.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.NUMERO">N\xFAmero</label><input type="text" name="numero" \nng-model="vm.model.cliente_endereco.numero" maxlength="6" required><div class="errors" \nng-messages="pagamentoForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.numero.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="35"><label translate="CADASTRAIS.BAIRRO">Bairro</label>\n<input type="text" name="bairro" ng-model="vm.model.cliente_endereco.bairro" required><div class="errors" \nng-messages="pagamentoForm.bairro.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.bairro.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="15"><input type="text" name="complemento" ng-model="vm.model.cliente_endereco.complemento" \nplaceholder="Complemento"><div class="errors" ng-messages="pagamentoForm.complemento.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.complemento.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="25"><input type="text" name="cidade_nome" ng-model="vm.model.cliente_endereco.cidade_nome" placeholder="Cidade" \nrequired></md-input-container><md-input-container flex="10"><input type="text" name="uf" maxlength="2" \nng-model="vm.model.cliente_endereco.uf" placeholder="UF" required></md-input-container></div><div layout="row" \nlayout-margin="layout-margin"><md-input-container flex="flex"><label translate="NOVO.EMPRESA">EMPRESA</label><input \ntype="text" name="empresa" ng-model="vm.model.empresa" maxlength="50"><div class="errors" \nng-messages="novoForm.empresa.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{novoForm.empresa.$api.error.message}}</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin disabled="disabled"><md-input-container flex><label translate="CADASTRAIS.EMAIL">E-mail</label><input \ntype="text" name="email" ng-model="vm.model.email" disabled="disabled">{{email}}</md-input-container></div><div \nlayout="row" layout-margin="layout-margin"><md-input-container flex="flex" ng-if="!vm.showPassword"><label \ntranslate="NOVO.PASSWORD">Senha</label><input type="password" id="senha" name="senha" ng-model="vm.model.senha" \nrequired="required"><div class="errors" ng-messages="novoForm.senha.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{novoForm.senha.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="flex" ng-if="vm.showPassword"><label translate="NOVO.PASSWORD">Senha\n</label><input type="text" name="senha" ng-model="vm.model.senha" required="required"><div class="errors" \nng-messages="novoForm.senha.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{novoForm.senha.$api.error.message}}</div></div></md-input-container><md-icon md-font-icon="icon-eye" \nng-if="!vm.showPassword" ng-click="vm.toggleShowPassword()"></md-icon><md-icon md-font-icon="icon-eye-off" \nng-if="vm.showPassword" ng-click="vm.toggleShowPassword()"></md-icon></div><div layout="row" \nlayout-margin="layout-margin"><md-input-container flex="flex" ng-if="!vm.showconfirmPassword"><label \ntranslate="NOVO.CONFIRM_PASSWORD">Confirma\xE7\xE3o Senha</label><input type="password" name="confirm_usuario_senha" \nng-model="vm.model.confirm_usuario_senha" pw-check="senha" required="required"><div class="errors" \nng-messages="novoForm.confirm_usuario_senha.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.confirm_usuario_senha.$api.error.message}}</div></div><div class="msg-block" \nng-show="novoForm.$error"><span class="msg-error" ng-show="novoForm.confirm_usuario_senha.$error.pwmatch">\nSenhas n\xE3o conferem</span></div></md-input-container><md-input-container flex="flex" ng-if="vm.showconfirmPassword">\n<label translate="NOVO.CONFIRM_PASSWORD">Confirma\xE7\xE3o Senha</label><input type="text" name="confirm_usuario_senha" \nng-model="vm.model.confirm_usuario_senha" pw-check="senha" required="required"><div class="errors" \nng-messages="novoForm.confirm_usuario_senha.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{novoForm.confirm_usuario_senha.$api.error.message}}</div></div><div class="msg-block" \nng-show="novoForm.$error"><span class="msg-error" ng-show="novoForm.confirm_usuario_senha.$error.pwmatch">\nSenhas n\xE3o conferem</span></div></md-input-container><md-icon md-font-icon="icon-eye" ng-if="!vm.showconfirmPassword" \nng-click="vm.toggleShowconfirmPassword()"></md-icon><md-icon md-font-icon="icon-eye-off" \nng-if="vm.showconfirmPassword" ng-click="vm.toggleShowconfirmPassword()"></md-icon></div><div layout="row" \nlayout-align="space-between center"><md-input-container flex="30"><md-checkbox name="termo_uso_aceito" \nng-model="vm.model.termo_uso_aceito" required></md-checkbox><span>Aceitar os <a href="" \nng-click="vm.ShowDialogTermos($event)">termos de uso</a></span><div \nng-messages="pagamentoForm.termo_uso_aceito.$error" ng-if="pagamentoForm.termo_uso_aceito.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{pagamentoForm.termo_uso_aceito.$api.error.message}}</div></div></md-input-container><div flex="50"><p \nng-if="vm.msgerro" class="msgerror">Error - {{vm.msgerro}}</p></div><md-button type="button" \nclass="md-raised md-accent pagar" aria-label="Submit" ng-disabled="pagamentoForm.$invalid" \nng-click="vm.save(vm.model)">CADASTRAR</md-button></div></div></form></md-content></div></div></div></div></div><div \nid="loading-form-wrapper" layout="column" layout-align="center center" ng-show="vm.processando"><div id="loading-form" \nclass="md-whiteframe-8dp"><h2>Por favor, aguarde! Estamos processando sua solicita\xE7\xE3o.</h2></div></div>');
$templateCache.put('app/main/dados_pagamento/view/dados_pagamento.html','<div layout="column" class="header-pagamento"><div id="pagamento-form-wrapper" layout="column" class="mcadastro" \nlayout-align="start center" ng-hide="vm.processando"><div class="content content-pagamento"><div layout="column" \nlayout-gt-xs="row" layout-margin layout-align="space-between center" class="logout"><img \nsrc="/assets/images/logos/logo-compartveg-cadastro_branco.png" alt="compartveg"><md-button ng-click="vm.logout()">\n<md-icon class="icon-logout white-500-fg" md-font-icon="icon-logout"></md-icon>Sair</md-button></div></div></div></div>\n<div class="body-pagamento"><div class="beneficios"><div ng-if="vm.model.beneficios == false"><h1 class="bold">\nBenef\xEDcios do Pacote</h1><md-tabs md-selected="vm.myTabIndex"><md-tab label="Plano"><div layout="column" \nlayout-gt-sm="row" layout-margin><div flex ng-repeat="descri in vm.descri" layout="column"><div layout="column" \nlayout-align="start"><div class="term" ng-repeat="funcionalidade in descri.funcionalidades"><md-icon \nclass="icon-check-circle green-500-fg" md-font-icon="icon-check-circle"></md-icon>{{funcionalidade.infos}}</div></div>\n</div></div></md-tab></md-tabs></div></div><div ng-if="vm.model.pagamento == true"><h1 class="bold">Plano selecionado\n</h1><div><div><div layout="column" layout-gt-sm="row" layout-margin><div flex layout="column"><div layout="column" \nlayout-align="start"><div class="term anual"><md-icon class="icon-check-circle green-500-fg" \nmd-font-icon="icon-check-circle"></md-icon>{{vm.model.cliente_plano_pagamento.nome}}<br><div>\nR$ {{vm.model.cliente_plano_pagamento.valor | finance:false:2}}</div></div></div></div></div></div><div \nng-if="vm.model.licenca == 2"><h1 class="bold top">Licen\xE7as Adicionais</h1><div><div><div layout="column" \nlayout-gt-sm="row" layout-margin><div flex layout="column"><div layout="column" layout-align="start"><div \nclass="term anual licen"><md-icon class="icon-check-circle green-500-fg" md-font-icon="icon-check-circle"></md-icon>\n<input ng-model="vm.model.numero_de_adicionais" type="text" name="numero-licencas" maxlength="2" flex="10">\n Licen\xE7as Adicionais<br><div ng-model="vm.model.total">\nR$ {{vm.model.cliente_plano_pagamento.valor * vm.model.numero_de_adicionais | finance:false:2}}</div></div></div></div>\n</div></div></div></div><div class="totalpagar"><md-icon class="icon-check-circle green-500-fg" \nmd-font-icon="icon-check-circle"></md-icon><h1 class="bold top total">Total a pagar: R$ <span \nng-model="vm.model.totalassinaturas">\n{{vm.model.cliente_plano_pagamento.valor * vm.model.numero_de_adicionais + vm.model.cliente_plano_pagamento.valor | finance:false:2}}\n</span></h1></div></div></div></div><div class="plano"><div class="box-plano" ng-if="vm.model.beneficios == false"><h1 \nclass="bold">Selecione o Plano</h1><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="50" \nflex-gt-md="20" ng-repeat="plano in vm.planos" ng-click="vm.setPlano(plano)"><ms-widget-front \nclass="white-bg ms-widget-front ng-scope"><a href="" class="decoration" ng-model="vm.model.card"><div><div \nclass="card-plano ng-scope layout-align-center-center layout-column" layout="column" layout-align="center center" \nng-required="true"><div class="price" layout="row" layout-align="center start"><div layout="row" \nlayout-align="center center" class="rs"></div><div class="cardg yellowgreen ng-binding"><p class="bold font-3" \nng-class="{\'plano-selecionado\': vm.model.cliente_plano_pagamento==plano}"><span>R$</span>{{plano.valor}}</p></div>\n</div><div ng-class="{\'plano-selecionado\': vm.model.cliente_plano_pagamento==plano}" \nclass="period font-2 mg-card cardg yellowgreen">{{plano.nome}}</div></div></div><div \nclass="p-5 card-gray border-top ng-scope layout-align-center-center layout-row bold sub" layout="row" \nlayout-align="start center" ng-class="{\'plano-selecionado-bg\': vm.model.cliente_plano_pagamento==plano}"><span \nclass="h4 g-binding"><span class="listas-card bold" \nng-class="{\'plano-selecionado-bg\': vm.model.cliente_plano_pagamento==plano}">Selecionar</span></span></div></a>\n</ms-widget-front></ms-widget><h1><b>Licen\xE7as Adicionais</b></h1><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="center"><md-input-container class="md-input-has-value cz"><md-radio-group md-autofocus name="licenca" \nlayout-align="center center" layout="row" ng-model="vm.model.licenca" required><md-radio-button value="1" class="m">\nPrincipal*</md-radio-button><md-radio-button value="2">Adicionais</md-radio-button></md-radio-group><div \nng-messages="pagamentoForm.licenca.$error" ng-show="pagamentoForm.licenca.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.licenca.$api.error.message}}</div></div>\n</md-input-container></div><md-input-container flex="20" class="quantidade" ng-if="vm.model.licenca == 2"><label \ntranslate="CADASTRAIS.LICENCAS">Quantidade licen\xE7as</label><input ng-model="vm.model.numero_de_adicionais" type="text" \nname="numero-licencas" ui-number-mask="0" maxlength="2"><div class="errors" \nng-messages="pagamentoForm.numero-licencas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.numero-licencas.$api.error.message}}</div></div></md-input-container><div \nlayout="column" layout-gt-xs="row" layout-margin layout-align="end center"><md-button type="button" \nclass="md-raised md-accent bold" aria-label="Submit" \nng-disabled="!vm.model.licenca || !vm.model.cliente_plano_pagamento" ng-click="vm.next()">CONTINUAR</md-button></div>\n<div><p class="msg-licencas">*Uma licen\xE7a deve ser adquirida para a conta vigente.</p></div></div><div \nclass="formaspagamento" ng-if="vm.model.pagamento == true"><h1 class="form-title infos-cliente title">\nFormas de Pagamento</h1><div><div class="credito"><div layout="row" layout-align="start" class="plano-pag"><a href="" \nng-click="vm.setPlanoCartao()"><div class="card-pag bold" \nng-class="{\'card-paghover\': vm.model.setplanocartao == true}"><md-icon class="icon-credit-card" \nmd-font-icon="icon-credit-card"></md-icon><br>Cart\xE3o de Cr\xE9dito</div></a><a href="" ng-click="vm.setPlanoBoleto()" \nng-if="vm.model.cliente_plano_pagamento.boleto"><div class="card-pag bold" \nng-class="{\'card-paghover\': vm.model.setplanoboleto == true}"><md-icon class="icon-barcode" \nmd-font-icon="icon-barcode"></md-icon><br>Boleto Banc\xE1rio</div></a><a href="" ng-click="vm.setPlanoCupom()" \nng-if="vm.model.licenca == 1 && vm.model.cliente_plano_pagamento.boleto"><div class="card-pag bold" \nng-class="{\'card-paghover\': vm.model.setplanocupom == true}"><md-icon class="icon-ticket-account" \nmd-font-icon="icon-ticket-account"></md-icon><br>Cupom de acesso</div></a></div></div></div><div><form \nname="pagamentoForm" novalidate="" api-form="vm.api_response_erro"><div class="term" ng-if="vm.model.setplanocartao">\n<div flex="100" class="form-title infos-cliente mgl">Dados do Pagamento</div><div layout="column" layout-gt-sm="row" \nclass="md-layout-area" layout-margin layout-align="center" ng-if="vm.model.setplanocartao"><div layout="column" \nlayout-align="center center"><div class="form-title">As informa\xE7\xF5es do cliente s\xE3o as mesmas do pagamento?</div><div>\n<md-input-container flex="10" class="md-input-has-value"><md-radio-group md-autofocus name="pessoa_tipo" \nng-model="vm.model.infos" layout="row" required><md-radio-button value="1" ng-click="vm.setClienteStorage()">Sim\n</md-radio-button><md-radio-button value="2" ng-click="vm.clearAll()">N\xE3o</md-radio-button></md-radio-group><div \nng-messages="pagamentoForm.pessoa_tipo.$error" ng-show="pagamentoForm.pessoa_tipo.$touched"><div ng-message="api_erro">\n{{pagamentoForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container></div></div></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15"><label translate="CADASTRAIS.CPFCNPJ">\nCPF/CNPJ</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cliente.cnpj_cpf" ui-br-cpfcnpj-mask required>\n<div class="errors" ng-messages="pagamentoForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container\n flex="85"><label translate="CADASTRAIS.NOME">Nome</label><input type="text" name="nome" \nng-model="vm.model.cliente.nome" required><div class="errors" ng-messages="pagamentoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.nome.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="10">\n<label translate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.cliente.telefone.ddd" \nui-mask="99" maxlength="2" required><div class="errors" ng-messages="pagamentoForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.ddd.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="30"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input \ntype="text" name="numero" ng-model="vm.model.cliente.telefone.numero" ui-mask-placeholder-char="space" \nui-mask="99999-9999" required><div class="errors" ng-messages="pagamentoForm.numero.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.numero.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex><label translate="CADASTRAIS.EMAIL">E-mail</label><input type="text" \nname="email" ng-model="vm.model.cliente.email" required><div class="errors" ng-messages="pagamentoForm.email.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.email.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="30"><input type="text" name="cep" ng-model="vm.model.cliente.endereco.cep" lm-endereco \nplaceholder="CEP" required ui-br-cep-mask ng-model-options="{ updateOn: \'blur\' }" ibge="vm.model.ibge" \nestado="vm.model.cliente_endereco.uf" cidade="vm.model.cliente_endereco.cidade_nome" \nendereco="vm.model.cliente.endereco.rua" bairro="vm.model.cliente.endereco.bairro" loading="cepLoading" \nng-disabled="cepLoading"><div class="errors" ng-messages="pagamentoForm.cep.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{pagamentoForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nflex="50"><label translate="CADASTRAIS.ENDERECO">Endere\xE7o</label><input type="text" name="rua" \nng-model="vm.model.cliente.endereco.rua" ng-required="true"><div class="errors" ng-messages="pagamentoForm.rua.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.rua.$api.error.message}}\n</div></div></md-input-container><md-input-container flex="20"><label translate="CADASTRAIS.NUMERO">N\xFAmero</label>\n<input type="text" name="numero" ng-model="vm.model.cliente.endereco.numero" maxlength="6" required><div \nclass="errors" ng-messages="pagamentoForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.numero.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20"><input type="text" \nname="complemento" ng-model="vm.model.cliente.endereco.complemento" placeholder="Complemento"><div class="errors" \nng-messages="pagamentoForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.complemento.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35"><label translate="CADASTRAIS.BAIRRO">Bairro</label><input type="text" name="bairro" \nng-model="vm.model.cliente.endereco.bairro" required><div class="errors" ng-messages="pagamentoForm.bairro.$error"><div\n ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.bairro.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><input type="text" name="cidade_nome" \nng-model="vm.model.cliente.endereco.cidade_nome" placeholder="Cidade" required><div class="errors" \nng-messages="pagamentoForm.cidade_nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.cidade_nome.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><input type="text" name="uf" maxlength="2" ng-model="vm.model.cliente.endereco.uf" \nplaceholder="UF" required><div class="errors" ng-messages="pagamentoForm.uf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.uf.$api.error.message}}</div></div>\n</md-input-container></div></div></form><form name="pagamentoForm" novalidate="" api-form="vm.api_response_erro" \nng-if="vm.model.setplanocartao"><div layout="column" layout-gt-xs="row" layout-margin><div class="box-card-40"><div \nlayout="column" layout-margin layout-align="start"><div flex="100" class="form-title infos-cliente mgl">Dados do Cart\xE3o\n</div><md-input-container flex="100"><label translate="CADASTRAIS.NUMERO_CARTAO">N\xFAmero do cart\xE3o</label><input \ntype="text" name="codigo" ng-model="vm.model.cartao.codigo" cc-format cc-eager-type cc-number maxlength="20" \nng-required="true"><div class="errors" ng-messages="pagamentoForm.codigo.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoForm.codigo.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="50"><label translate="CADASTRAIS.TITULAR">Nome do titular</label><input \ntype="text" name="portador" ng-model="vm.model.cartao.portador" maxlength="23" required><div class="errors" \nng-messages="pagamentoForm.portador.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.portador.$api.error.message}}</div></div></md-input-container><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="50"><label translate="CADASTRAIS.CCV">\nC\xF3digo de seguran\xE7a</label><input type="text" name="cvv" ng-model="vm.model.cartao.cvv" cc-cvc maxlength="4" required>\n<div class="errors" ng-messages="pagamentoForm.cvv.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.cvv.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="50"><label translate="CADASTRAIS.VENCIMENTO">Data de vencimento</label><input type="text" name="expiracao" \nng-model="vm.model.cartao.expiracao" ui-mask-placeholder-char="space" ui-mask="99-99" required><div class="errors" \nng-messages="pagamentoForm.expiracao.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{pagamentoForm.expiracao.$api.error.message}}</div></div></md-input-container></div></div><div \nlayout="row" layout-align=" center" ng-show="vm.processando"><div><h2 class="aguarde">\nAguarde estamos processando seu pagamento.</h2></div></div><div class="spinner-wrapper" ng-show="vm.processando"><div \nclass="spinner"><div class="inner"><div class="gap"></div><div class="left"><div class="half-circle"></div></div><div \nclass="right"><div class="half-circle"></div></div></div></div></div><div layout="column" layout-gt-xs="row" \nlayout-align="space-between center" class="pagar"><md-button ng-click="vm.back()" class="md-raised"><md-icon \nclass="icon-arrow-left-bold" md-font-icon="icon-arrow-left-bold"></md-icon>VOLTAR</md-button><md-button \nng-if="vm.model.cliente_plano_pagamento.plano_pagamento_id != 0" type="button" class="md-raised md-accent pagar" \naria-label="Submit" ng-disabled="pagamentoForm.$invalid || pagamentoForm.$pristine" \nng-click="vm.enviarPagamento(model)">PAGAR<md-icon class="icon-credit-card" md-font-icon="icon-credit-card"></md-icon>\n</md-button></div></div><div class="box-card"><div class="card md-whiteframe-8dp"><img class="logo-card-compartveg" \nsrc="/assets/images/logos/splash-logo.png"><h2>Compart<span>veg</span></h2><div class="chip"><div class="chip-line">\n</div><div class="chip-line"></div><div class="chip-line"></div><div class="chip-line"></div><div class="chip-main">\n</div></div><div class="infos-cartao numero-cartao">{{pagamentoForm.codigo.$viewValue}}</div><div \nclass="infos-cartao valid-thru">valid thru</div><div class="infos-cartao expiracao-cartao">\n{{pagamentoForm.expiracao.$viewValue}}</div><div class="infos-cartao codigo-seguranca-cartao">\n{{pagamentoForm.cvv.$viewValue}}</div><div class="infos-cartao nome-cartao">{{vm.model.cartao.portador}}</div><div \nclass="brands"><img ng-if="pagamentoForm.codigo.$ccEagerType == \'American Express\'" class="brand-card" \nsrc="/assets/images/logos/american-express.svg"> <img ng-if="pagamentoForm.codigo.$ccEagerType == \'Diners Club\'" \nclass="brand-card" src="/assets/images/logos/diners.svg"> <img \nng-if="pagamentoForm.codigo.$ccEagerType == \'MasterCard\'" class="brand-card" src="/assets/images/logos/mastercard.svg">\n <img ng-if="pagamentoForm.codigo.$ccEagerType == \'Visa\'" class="brand-card" src="/assets/images/logos/visa_2.svg">\n</div></div></div></div></form></div><div class="boleto" ng-if="vm.model.setplanoboleto"><div><form \nname="pagamentoBoleto" novalidate="" api-form="vm.api_response_erro"><div class="term"><div flex="100" \nclass="form-title infos-cliente mgl">Dados do Pagamento</div><div layout="column" layout-gt-sm="row" \nclass="md-layout-area" layout-margin layout-align="center" ng-if="vm.model.setplanoboleto"><div layout="column" \nlayout-align="center center"><div class="form-title">As informa\xE7\xF5es do cliente s\xE3o as mesmas do pagamento?</div><div \nlayout="row" layout-align="space-between center"><md-input-container flex="10" class="md-input-has-value">\n<md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.infos" layout="row" required><md-radio-button \nvalue="1" ng-click="vm.setClienteStorage()">Sim</md-radio-button><md-radio-button value="2" ng-click="vm.clearAll()">\nN\xE3o</md-radio-button></md-radio-group><div ng-messages="pagamentoForm.pessoa_tipo.$error" \nng-show="pagamentoForm.pessoa_tipo.$touched"><div ng-message="api_erro">\n{{pagamentoForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container></div></div></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15"><label translate="CADASTRAIS.CPFCNPJ">\nCPF/CNPJ</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cliente.cnpj_cpf" ui-br-cpfcnpj-mask required>\n<div class="errors" ng-messages="pagamentoBoleto.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{pagamentoBoleto.cnpj_cpf.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="85"><label translate="CADASTRAIS.NOME">Nome</label><input type="text" name="nome" \nng-model="vm.model.cliente.nome" required><div class="errors" ng-messages="pagamentoBoleto.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{pagamentoBoleto.nome.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex>\n<label translate="CADASTRAIS.EMAIL">E-mail</label><input type="text" name="email" ng-model="vm.model.cliente.email" \nrequired><div class="errors" ng-messages="pagamentoBoleto.email.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="api_erro">{{pagamentoBoleto.email.$api.error.message}}</div></div></md-input-container></div>\n</div></form><p>Imprima o boleto e pague no banco, ou pague pela internet utilizando o c\xF3digo de barras do boleto.<br>\n<br>O prazo de validade do boleto \xE9 de 5 dias \xFAteis</p><p><b>Aten\xE7\xE3o</b><br>\nPagamentos por boleto n\xE3o \xE9 necess\xE1rio anexar o comprovante no site.</p></div><div><br><p class="center" \nng-if="vm.boletogerado"><b>O seu boleto foi gerado com sucesso!,<br>\nSeu acesso ser\xE1 liberado ap\xF3s a confirma\xE7\xE3o do pagamento.</b></p><p class="center" ng-if="vm.processando"><b>\nAguarde, seu boleto esta sendo gerado.</b></p><div class="spinner-wrapper" ng-show="vm.processando"><div \nclass="spinner"><div class="inner"><div class="gap"></div><div class="left"><div class="half-circle"></div></div><div \nclass="right"><div class="half-circle"></div></div></div></div></div><p></p><md-button type="button" \nclass="cta-button md-raised md-accent" aria-label="Submit" ng-click="vm.pagamentoBoleto(model)" target="_blank" \nng-disabled="pagamentoBoleto.$invalid || pagamentoBoleto.$pristine || vm.processando == true">GERAR BOLETO</md-button>\n<br><md-button ng-click="vm.back()" class="md-raised"><md-icon class="icon-arrow-left-bold" \nmd-font-icon="icon-arrow-left-bold"></md-icon>VOLTAR</md-button></div></div><div><form name="cupomForm" novalidate="" \napi-form="vm.api_response_erro"><div class="term" ng-if="vm.model.setplanocupom"><div \nclass="form-title infos-cliente mgl">Dados do Pagamento</div><div layout="column" layout-gt-sm="row" \nclass="md-layout-area" layout-margin layout-align="center"><div layout="column" layout-align="center center"><div \nclass="form-title">D\xEDgite abaixo um cupom v\xE1lido para ter acesso ao sistema.</div><div layout="row" class="box-cupom" \nlayout-align="space-between center"><md-input-container class="input-cupom"><label translate="CADASTRAIS.CUPOM">\nCupom de acesso</label><input type="text" name="cupom" ng-model="vm.model.cupom_id" minlength="8" maxlength="8" \nng-required="true"><div class="errors" ng-messages="cupomForm.cupom.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{cupomForm.cupom.$api.error.message}}</div></div>\n</md-input-container><md-button type="button" class="cta-button md-raised md-accent" aria-label="Submit" \nng-click="vm.validadaCupom(model)" ng-disabled="cupomForm.$invalid || cupomForm.$pristine || vm.processando == true">\nVALIDAR</md-button></div><div layout="row" layout-align=" center" ng-show="vm.processandocupom"><div><h2 \nclass="aguarde">Aguarde estamos validando seu cupom.</h2><div class="spinner-wrapper"><div class="spinner"><div \nclass="inner"><div class="gap"></div><div class="left"><div class="half-circle"></div></div><div class="right"><div \nclass="half-circle"></div></div></div></div></div></div></div><div ng-if="vm.api_response_erro"><h1 \nclass="msg-error bold">{{vm.api_response_erro.data.errors.id[0]}}</h1><h1 class="msg-error bold">\n{{vm.api_response_erro.data.errors.pagamento[0]}}</h1></div></div></div></div></form></div></div></div>');
$templateCache.put('app/main/dados_pagamento/view/indexpag.html','<div ng-if="vm.models.data[0].boleto_valido == false"><div \nng-include="\'app/main/dados_pagamento/view/dados_pagamento.html\'"></div></div><div \nng-if="vm.models.data[0].boleto_valido == true"><div ng-include="\'app/main/dados_pagamento/view/reimpressao.html\'">\n</div></div>');
$templateCache.put('app/main/dados_pagamento/view/reimpressao.html','<div layout="column" class="header-pagamento"><div id="pagamento-form-wrapper" layout="column" class="mcadastro" \nlayout-align="start center" ng-hide="vm.processando"><div class="content content-pagamento"><div layout="column" \nlayout-gt-xs="row" layout-margin layout-align="space-between center" class="logout"><img \nsrc="/assets/images/logos/logo-compartveg-cadastro_branco.png" alt="compartveg"><md-button ng-click="vm.logout()">\n<md-icon class="icon-logout white-500-fg" md-font-icon="icon-logout"></md-icon>Sair</md-button></div></div></div></div>\n<div class="body-reimpressao montserrat"><div><div class="header-titulo center bold"><h1 class="bold" \ntranslate="CADASTRAIS.AGUARDANDO">Aguardando comprova\xE7\xE3o</h1></div><div class="body-reimprime"><div class="status-pag">\n<p translate="CADASTRAIS.STATUS" class="center">Status da Compra</p><div class="bllts-nav"><div class="bllts enabled">\n<img src="/assets/icons/icon-pag/pedido-realizado.svg"> <span>Pedido realizado</span></div><div class="bllts pendent">\n<img src="/assets/icons/icon-pag/aguarde-pag.svg"> <span>Aguardando pagamento</span></div><div class="bllts disabled">\n<img src="/assets/icons/icon-pag/licenca-liberada.svg"> <span>Licen\xE7a liberada para uso</span></div></div></div><div \nclass="center"><div class="msg-status"><p translate="CADASTRAIS.MSG_AGUARDE_PAG">\nEstamos aguardando a comprova\xE7\xE3o do seu pagamento, caso preciso reimprimir seu boleto, clique no bot\xE3o abaixo:</p>\n</div></div><div class="btn-reimprime center"><md-button type="button" class="cta-button md-raised md-accent" \naria-label="Submit" ng-click="vm.reimprimeBoleto()">Boleto<md-icon class="icon-printer s20" \nmd-font-icon="icon-printer"></md-icon></md-button></div><div class="msg-compremais center"><p class="inline-block" \ntranslate="CADASTRAIS.COMPRAR_MAIS">Se estiver precisando comprar mais licen\xE7as</p><a class="cliqueaqui" \ntranslate="CADASTRAIS.CLIQUE_AQUI" ng-click="vm.gotoPagamento(model)" href="">clique aqui</a></div></div></div></div>');
$templateCache.put('app/main/dashboard/view/bemvindo.html','<div class="bemvindo"><div class="close"><md-button ng-click="vm.close()" class="md-primary md-raised">x</md-button>\n</div><div class="header"><hr><img src="/assets/images/backgrounds/compartveg.png" alt="compartveg"><hr></div><div \nclass="body"><h1><b>Bem - vindo </b>ao caderno de campo <span class="compart">COMPART</span><span class="veg">VEG\n</span></h1></div></div>');
$templateCache.put('app/main/dashboard/view/dashboard.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DASHBOARD.PAINEL_CONTROLE">Painel de controle</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-dashboard"><div \nclass="widget-group layout-wrap ng-scope layout-row flex-100 montserrat" layout="row" flex="100" layout-wrap="">\n<ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="33" flex-gt-md="20"><ms-widget-front \nng-click="vm.gotoPropriedades()" class="ms-widget-front"><div class="layout-column container-card-dashboard" \nlayout="column" layout-align="center center"><div class="content-card-dashboard"><span class="info-number" \nng-if="!vm.propriedades.processing">{{vm.dashboard.propriedade_contagem}} </span><span class="loading" \nng-if="vm.propriedades.processing">Carregando...</span></div><div class="info-entity"><p>Propriedades</p></div></div>\n<div class="layout-row container-footer-card" layout="row" layout-align="center center"><div \nclass="content-footer-card"><div class="item-footer"><md-icon class="icon-link icon-dashboard" \nmd-font-icon="icon-link"></md-icon>Lista de propriedades</div></div></div></ms-widget-front></ms-widget><ms-widget \nflippable="true" layout="column" flex="100" flex-gt-xs="33" flex-gt-md="20"><ms-widget-front ng-click="vm.gotoAreas()" \nclass="ms-widget-front"><div class="layout-column container-card-dashboard" layout="column" \nlayout-align="center center"><div class="content-card-dashboard"><span class="info-number" \nng-if="!vm.areas.processing">{{vm.dashboard.propriedade_area_contagem}} </span><span class="loading" \nng-if="vm.areas.processing">Carregando...</span></div><div class="info-entity"><p>\xC1reas</p></div></div><div \nclass="layout-row container-footer-card" layout="row" layout-align="center center"><div class="content-footer-card">\n<div class="item-footer"><md-icon class="icon-link icon-dashboard" md-font-icon="icon-link"></md-icon>Lista de \xE1reas\n</div></div></div></ms-widget-front></ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="33" \nflex-gt-md="20"><ms-widget-front ng-click="vm.gotoPlantios()" class="ms-widget-front"><div \nclass="layout-column container-card-dashboard" layout="column" layout-align="center center"><div \nclass="content-card-dashboard"><span class="info-number" ng-if="!vm.plantios.processing">\n{{vm.dashboard.plantios_contagem}} </span><span class="loading" ng-if="vm.plantios.processing">Carregando...</span>\n</div><div class="info-entity"><p>Plantios</p></div></div><div class="layout-row container-footer-card" layout="row" \nlayout-align="center center"><div class="content-footer-card"><div class="item-footer"><md-icon \nclass="icon-link icon-dashboard" md-font-icon="icon-link"></md-icon>Lista de plantios</div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="33" flex-gt-md="20">\n<ms-widget-front ng-click="vm.gotoBiologicos()" class="ms-widget-front"><div \nclass="layout-column container-card-dashboard" layout="column" layout-align="center center"><div \nclass="content-card-dashboard"><span class="info-number" ng-if="!vm.biologicos.processing">\n{{vm.dashboard.biologico_contagem}} </span><span class="loading" ng-if="vm.biologicos.processing">Carregando...</span>\n</div><div class="info-entity"><p>Biol\xF3gicos</p></div></div><div class="layout-row container-footer-card" layout="row" \nlayout-align="center center"><div class="content-footer-card"><div class="item-footer"><md-icon \nclass="icon-link icon-dashboard" md-font-icon="icon-link"></md-icon>Lista de biol\xF3gicos</div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="33" flex-gt-md="20">\n<ms-widget-front ng-click="vm.gotoDefensivos()" class="ms-widget-front"><div \nclass="layout-column container-card-dashboard" layout="column" layout-align="center center"><div \nclass="content-card-dashboard"><span class="info-number" ng-if="!vm.defensivos.processing">\n{{vm.dashboard.defensivo_contagem}} </span><span class="loading" ng-if="vm.defensivos.processing">Carregando...</span>\n</div><div class="info-entity"><p>Defensivos</p></div></div><div class="layout-row container-footer-card" layout="row" \nlayout-align="center center"><div class="content-footer-card"><div class="item-footer"><md-icon \nclass="icon-link icon-dashboard" md-font-icon="icon-link"></md-icon>Lista de defensivos</div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="33" flex-gt-md="20">\n<ms-widget-front ng-click="vm.gotoFertilizantes()" class="ms-widget-front"><div \nclass="layout-column container-card-dashboard" layout="column" layout-align="center center"><div \nclass="content-card-dashboard"><span class="info-number" ng-if="!vm.fertilizantes.processing">\n{{vm.dashboard.fertilizante_contagem}} </span><span class="loading" ng-if="vm.fertilizantes.processing">Carregando...\n</span></div><div class="info-entity"><p>Fertilizantes</p></div></div><div class="layout-row container-footer-card" \nlayout="row" layout-align="center center"><div class="content-footer-card"><div class="item-footer"><md-icon \nclass="icon-link icon-dashboard" md-font-icon="icon-link"></md-icon>Lista de fertilizantes</div></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable="true" layout="column" flex="100" flex-gt-xs="33" flex-gt-md="20">\n<ms-widget-front ng-click="vm.gotoColheitas()" class="ms-widget-front"><div \nclass="layout-column container-card-dashboard" layout="column" layout-align="center center"><div \nclass="content-card-dashboard"><span class="info-number" ng-if="!vm.colheitas.processing">\n{{vm.dashboard.colheita_contagem}} </span><span class="loading" ng-if="vm.colheitas.processing">Carregando...</span>\n</div><div class="info-entity"><p>Colheitas</p></div></div><div class="layout-row container-footer-card" layout="row" \nlayout-align="center center"><div class="content-footer-card"><div class="item-footer"><md-icon \nclass="icon-link icon-dashboard" md-font-icon="icon-link"></md-icon>Lista de colheitas</div></div></div>\n</ms-widget-front></ms-widget></div></div></div></div></div>');
$templateCache.put('app/main/home/view/bckp_home.html','<div class="page-layout simple fullwidth doc-page dashboard" layout="column"><div class="container-home"><h2>\nBem-vindo ao caderno de campo Eattae</h2><p>\nVeja como \xE9 f\xE1cil ter o controle total da sua produ\xE7\xE3o! Aprenda e tire suas d\xFAvidas assistindo o passo a passo, s\xF3 vai levar 2 minutos.\n</p><div class="box-videos"><div class="video" ng-click="vm.viewCadastroPropriedade()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-propriedade.jpg" alt=""> <span class="play"><img \nsrc="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewCadastroArea()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-area-historico.jpg" alt=""> <span class="play"><img\n src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewCadastroInsumo()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-insumo.jpg" alt=""> <span class="play"><img \nsrc="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewAplicarInsumo()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-aplicar-insumos-eattae.jpg" alt=""> <span class="play"><img \nsrc="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewCadastroEstoque()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-estoque-fornecedores.jpg" alt=""> <span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewPlantio()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-plantio-caderno-de-campo.jpg" alt=""> <span class="play">\n<img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewColheita()"><img src="../../../../assets/images/thumbs-videos/thumb-youtube-realizar-colheita.jpg" \nalt=""> <span class="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div \nclass="video" ng-click="vm.viewVenderLotes()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-vender-lotes.jpg" alt=""> <span class="play"><img \nsrc="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewImprimirTrocarCliente()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-imprimir-etiqueta-trocar-cliente.jpg" alt=""> <span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="video" \nng-click="vm.viewGerarLaudo()"><img src="../../../../assets/images/thumbs-videos/thumb-gerar-laudo.jpg" alt=""> <span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div></div></div></div>');
$templateCache.put('app/main/home/view/bemvindo.html','<div class="bemvindo"><div class="close"><md-button ng-click="vm.close()" class="md-primary md-raised">x</md-button>\n</div><div class="header"><hr><img src="/assets/images/backgrounds/compartveg.png" alt="compartveg"><hr></div><div \nclass="body"><h1><b>Bem - vindo </b>ao caderno de campo <span class="compart">COMPART</span><span class="veg">VEG\n</span></h1></div></div>');
$templateCache.put('app/main/home/view/home-areas.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\xC1reas</h1></div></div></div><div \nclass="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/registro/area/dash"><img src="/assets/icons/ico-areas.svg" \nalt=""><p>Dashboard</p></a></li><li class="card-item"><a ng-href="/registro/area/criar"><img \nsrc="/assets/icons/ico-cadastro-area.svg" alt=""><p>Cadastro</p></a></li><li class="card-item"><a \nng-href="/registro/area/historico"><img src="/assets/icons/ico-historico-areas.svg" alt=""><p>Hist\xF3rico</p></a></li>\n</ul></div></div>');
$templateCache.put('app/main/home/view/home-cadastros.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Cadastros</h1></div></div></div>\n<div class="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/cadastros/fornecedor/buscar"><img \nsrc="/assets/icons/ico-meus_fornecedores.svg" alt=""><p>Fornecedores</p></a></li><li class="card-item"><a \nng-href="/cadastros/profissional/buscar"><img src="/assets/icons/ico-profissionais.svg" alt=""><p>Profissionais</p></a>\n</li><li class="card-item"><a ng-href="/cadastros/maquina/buscar"><img src="/assets/icons/ico-atividades.svg" alt="">\n<p>Equipamentos</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home-caldas.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xE3o de caldas</h1>\n</div></div></div><div class="content layout-column" layout="column"><div \nclass="container-content-custom container-cards"><ul class="content-cards"><li class="card-item"><a \nng-href="/caldas/buscar"><img src="/assets/icons/aplicacao/ico-calda.svg" alt=""><p>Caldas</p></a></li><li \nclass="card-item"><a ng-href="/plano_aplicacao/buscar"><img src="/assets/icons/visitas/ico-agendamento.svg" alt=""><p>\nPlano de aplica\xE7\xE3o</p></a></li><li class="card-item"><a ng-href="/aplicacoes/buscar"><img \nsrc="/assets/icons/aplicacao/ico-calda.svg" alt=""><p>Aplica\xE7\xF5es</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home-estoque-gestao.html','<div class="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/estoque_insumo/biologico/buscar/"><img \nsrc="/assets/icons/ico-insumo-biologico.svg" alt=""><p>Biol\xF3gico</p></a></li><li class="card-item"><a \nng-href="/estoque_insumo/defensivo/buscar/"><img src="/assets/icons/ico-insumo-defensivo.svg" alt=""><p>Defensivo</p>\n</a></li><li class="card-item"><a ng-href="/estoque_insumo/fertilizante/buscar/"><img \nsrc="/assets/icons/ico-insumo-fertilizante.svg" alt=""><p>Fertilizante</p></a></li><li class="card-item"><a \nng-href="/estoque_insumo/semente/buscar/"><img src="/assets/icons/ico-sementes.svg" alt=""><p>Semente</p></a></li></ul>\n</div></div>');
$templateCache.put('app/main/home/view/home-estoque.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Estoque</h1></div></div></div><div \nclass="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/estoque_insumo/cadastro_insumo/buscar"><img \nsrc="/assets/icons/ico-cadastro-insumo.svg" alt=""><p>Cadastro de insumos</p></a></li><li class="card-item"><a \nng-href="/home/estoque-gestao"><img src="/assets/icons/ico-gestao-estoque.svg" alt=""><p>Gest\xE3o de estoque</p></a></li>\n</ul></div></div>');
$templateCache.put('app/main/home/view/home-fechamento_mensal.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Propriedade > Fechamento de custos\n</h1></div></div></div><div class="content layout-column" layout="column"><div \nclass="container-content-custom container-cards"><ul class="content-cards"><li class="card-item"><a \nng-href="/fechamento_custos/mensal"><img src="/assets/icons/ico-despesas-administrativas.svg" alt=""><p>Mensal</p></a>\n</li></ul></div></div>');
$templateCache.put('app/main/home/view/home-financeiro.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Financeiro</h1></div></div></div>\n<div class="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/registro/despesas/buscar/"><img \nsrc="/assets/icons/ico-despesas-administrativas.svg" alt=""><p>Despesas administrativas</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home-lotes_produzidos.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Lotes produzidos</h1></div></div>\n</div><div class="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/registro/lote_producao/dash"><img \nsrc="/assets/icons/previsa-colheita/ico-dashboard.svg" alt=""><p>Dashboard</p></a></li><li class="card-item"><a \nng-href="/registro/lote_producao/buscar"><img src="/assets/icons/ico-estoque.svg" alt=""><p>Ver lotes</p></a></li></ul>\n</div></div>');
$templateCache.put('app/main/home/view/home-manejos-insumos.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Manejos > Aplica\xE7\xE3o de insumos</h1>\n</div></div></div><div class="content layout-column" layout="column"><div \nclass="container-content-custom container-cards"><ul class="content-cards"><li class="card-item"><a \nng-href="/registro/manejo/insumo/biologico/buscar"><img src="/assets/icons/ico-aplicacao-insumo-biologico.svg" alt="">\n<p>Biol\xF3gico</p></a></li><li class="card-item"><a ng-href="/registro/manejo/insumo/defensivo/buscar"><img \nsrc="/assets/icons/ico-aplicacao-insumo-defensivo.svg" alt=""><p>Defensivo</p></a></li><li class="card-item"><a \nng-href="/registro/manejo/insumo/fertilizante/buscar"><img src="/assets/icons/ico-aplicacao-insumo-fertilizante.svg" \nalt=""><p>Fertilizante</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home-manejos.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Manejos</h1></div></div></div><div \nclass="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/registro/manejo/plantio/buscar"><img \nsrc="/assets/icons/ico-plantio.svg" alt=""><p>Plantio</p></a></li><li class="card-item"><a ng-href="/home/insumos"><img\n src="/assets/icons/ico-aplicacao-de-insumos.svg" alt=""><p>Aplica\xE7\xE3o de insumos</p></a></li><li class="card-item"><a \nng-href="/registro/manejo/colheita/buscar"><img src="/assets/icons/ico-colheita.svg" alt=""><p>Colheita</p></a></li><li\n class="card-item"><a ng-href="/home/caldas"><span>NOVO!</span> <img src="/assets/icons/aplicacao/ico-calda.svg" \nalt=""><p>Aplica\xE7\xE3o de caldas</p></a></li><li class="card-item"><a ng-href="/registro/custos/buscar"><img \nsrc="/assets/icons/ico-custos-de-manejos.svg" alt=""><p>Outros manejos e custos</p></a></li><li class="card-item"><a \nng-href="/relatorios/insumos/buscar"><img src="/assets/icons/ico-historico-manejos.svg" alt=""><p>Hist\xF3rico dos manejos\n</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home-previsao-colheita.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Previs\xE3o de colheita</h1></div>\n</div></div><div class="content layout-column" layout="column"><div class="container-content-custom container-cards">\n<ul class="content-cards"><li class="card-item"><a ng-href="/previsao_colheita/dash"><img \nsrc="/assets/icons/previsa-colheita/ico-dashboard.svg" alt=""><p>Dashboard</p></a></li><li class="card-item"><a \nng-href="/previsao_colheita/buscar"><img src="/assets/icons/previsa-colheita/ico-previsao-colheita.svg" alt=""><p>\nLista de previs\xF5es</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home-propriedade.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Propriedade</h1></div></div></div>\n<div class="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/registro/propriedade/buscar"><img \nsrc="/assets/icons/ico-propriedade.svg" alt=""><p>Dados da propriedade</p></a></li><li class="card-item"><a \nng-href="/home/fechamento_mensal"><img src="/assets/icons/ico-gestao-estoque.svg" alt=""><p>Fechamento de custos</p>\n</a></li></ul></div></div>');
$templateCache.put('app/main/home/view/home.html','<div class="content layout-column" layout="column"><div class="container-content-custom container-cards"><ul \nclass="content-cards"><li class="card-item"><a ng-href="/passo-a-passo/home"><img \nsrc="/assets/icons/ico-passo-a-passo.svg" alt=""><p>Passo a passo</p></a></li><li class="card-item"><a \nng-href="/home/propriedade"><img src="/assets/icons/ico-propriedade.svg" alt=""><p>Propriedade</p></a></li><li \nclass="card-item"><a ng-href="/home/areas"><img src="/assets/icons/ico-areas.svg" alt=""><p>\xC1reas</p></a></li><li \nclass="card-item"><a ng-href="/home/manejos"><img src="/assets/icons/ico-manejo.svg" alt=""><p>Manejos</p></a></li><li \nclass="card-item"><a ng-href="/home/previsao-colheita"><img \nsrc="/assets/icons/previsa-colheita/ico-previsao-colheita.svg" alt=""><p>Previs\xE3o de colheita</p></a></li><li \nclass="card-item"><a ng-href="/home/lotes_produzidos"><img src="/assets/icons/ico-lotes.svg" alt=""><p>Lotes produzidos\n</p></a></li><li class="card-item"><a ng-href="/home/estoque"><img src="/assets/icons/ico-estoque.svg" alt=""><p>\nEstoque</p></a></li><li class="card-item"><a ng-href="/agenda_visitas/dash"><img \nsrc="/assets/icons/visitas/ico-agendamento.svg" alt=""><p>Agendamento de visitas</p></a></li><li class="card-item"><a \nng-href="/home/financeiro"><img src="/assets/icons/ico-financeiro.svg" alt=""><p>Financeiro</p></a></li><li \nclass="card-item"><a ng-href="/certificados/lista"><img src="/assets/icons/certificados/ico-arquivo.svg" alt=""><p>\nCertificados / documentos</p></a></li><li class="card-item"><a ng-href="/home/cadastros"><img \nsrc="/assets/icons/ico-meus_fornecedores.svg" alt=""><p>Cadastros</p></a></li></ul></div></div>');
$templateCache.put('app/main/home/view/laudo_news.html','');
$templateCache.put('app/main/home/view/news.html','<div class="modal-news"><div class="header-news"><p>Ol\xE1, {{vm.model.nome}}.</p><div class="btn-dimiss" \nng-click="vm.close()">X</div></div><div class="content-body"><h2>Comece a gerenciar seus estoques!</h2><b>\nA partir de agora, para aplicar seus defensivos, \xE9 preciso cadastrar cada insumo e inseri-lo em estoque antes de fazer a aplica\xE7\xE3o.\n</b></div><div class="content-footer"><div class="box-img"><img \nsrc="../../../../assets/images/logos/img-menu-estoque-200.jpg"></div><div><p>\nAssim voc\xEA poder\xE1 controlar seu estoque de forma correta, ter visibilidade do que tem ou falta comprar e principalmente ter o custo real das aplica\xE7\xF5es.\n</p><p>E aguarde, em breve os insumos biol\xF3gicos e fertilizantes estar\xE3o neste mesmo formato.</p></div></div><div \nclass="actions-news"><div class="content-buttons"><md-button class="btn btn-primary btn-lg" ng-click="vm.close()">\nCome\xE7ar</md-button></div><md-input-container class="md-input-has-value"><md-checkbox name="hideMsg" \nng-model="vm.hideMsg" ng-change="vm.FnhideMsg(vm.hideMsg)"><b>N\xE3o mostrar mais esta mensagem</b></md-checkbox>\n</md-input-container></div></div>');
$templateCache.put('app/main/laudo/views/criar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="LAUDO.TITLE">Laudo t\xE9cnico</h1></div>\n<div class="content-register with-select"><fieldset><form name="laudoForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><md-card><h3>Dados da venda</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="25" md-delay="500"><label translate="LAUDO.TRACKING_CODE">C\xF3digo rastreamento</label><input \ntype="text" name="codigo_rastreamento" placeholder="Insira o c\xF3digo rastreamento" ng-model="vm.model.lote_numero" \nng-disabled="vm.venda.lote_distribuicao.lote_numero"></md-input-container><md-input-container \nclass="datepicker-custom" flex="20" md-delay="500"><label translate="LAUDO.SHIPPING_DATE">Data de expedi\xE7\xE3o</label>\n<md-datepicker name="data_expedicao" ng-model="vm.model.data_expedicao" md-placeholder="Inserir data" md-open-on-focus \nng-disabled="vm.venda.data_expedicao"></md-datepicker></md-input-container><md-input-container flex="50" \nmd-delay="500"><label translate="LAUDO.CUSTOMER_NAME">Nome do cliente</label><input type="text" name="nome_cliente" \nplaceholder="Inserir nome do cliente" ng-model="vm.model.cliente_nome" ng-disabled="vm.venda.cliente_consumidor.nome">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex \nng-if="vm.model.tipo_pessoa == 1"><label translate="LAUDO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cliente_consumidor_cnpj_cpf" ui-br-cpf-mask disabled="disabled"><div class="errors" \nng-messages="alterarForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{alterarForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.tipo_pessoa == 2"><label translate="LAUDO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cliente_consumidor_cnpj_cpf" ui-br-cnpj-mask disabled="disabled"></md-input-container>\n<md-input-container flex="50" md-delay="500"><label translate="LAUDO.EMAIL">E-mail</label><input type="email" \nname="email" placeholder="Inserir e-mail" maxlength="60" \nng-pattern="/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/" \nng-model="vm.model.cliente_consumidor_email" required><div ng-messages="laudoForm.email.$error" \nng-if="laudoForm.email.$touched"><div ng-message="required">Campo Obrigat\xF3rio.</div><div ng-message="pattern">\nE-mail incorreto.</div><div ng-message="api_erro">{{laudoForm.email.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex \nmd-delay="500"><label>Cultura</label><md-autocomplete required flex class="md-block" md-input-name="cultura" \nmd-no-cache="false" md-selected-item="vm.model.cultura" md-search-text="culturaQuery" \nmd-items="item in vm.culturaSearch(culturaQuery)" md-item-text="item.nome" md-delay="500" md-require-match \nplaceholder="Buscar cultura" ng-disabled="vm.venda.cultura"><md-item-template><span \nmd-highlight-text="vm.model.cultura">{{item.nome}}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="plantioForm.cultura.$error" ng-if="plantioForm.cultura.$touched">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="md-require-match">\nPor favor, digite uma cultura v\xE1lida</div><div ng-message="api_erro">{{plantioForm.cultura.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="20" md-delay="500"><label translate="LAUDO.VARIETY">Variedade\n</label><input type="text" name="variedade" placeholder="Inserir variedade" ng-model="vm.model.produto_variedade" \nng-disabled="vm.venda.produto_variedade"></md-input-container><md-input-container flex="15" md-delay="500"><label \ntranslate="LAUDO.CATEGORY">Categoria</label><input type="text" name="nome_cliente" placeholder="Inserir categoria" \nmaxlength="50" ng-model="vm.model.categoria"><div ng-messages="laudoForm.categoria.$error" \nng-if="laudoForm.categoria.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{laudoForm.categoria.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nmd-delay="500"><label translate="LAUDO.AMOUNT">Quantidade</label><input type="text" name="quantidade" \nng-model="vm.model.quantidade" disabled="disabled"></md-input-container><md-input-container flex="20" md-delay="500" \nng-hide="vm.model.unidade_medida == \'Embalagem\'"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label>\n<input type="text" name="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin ng-if="vm.model.unidade_medida == \'Embalagem\'">\n<md-input-container flex md-delay="500"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input \ntype="text" name="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input type="text" \nname="embalagem_tipo" ng-model="vm.model.embalagem_tipo" disabled="disabled"></md-input-container><md-input-container \nflex md-delay="500"><label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input type="text" \nname="embalagem_peso" ng-model="vm.model.embalagem_peso" disabled="disabled"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.SALES_DOCUMENT_NUMBER">N\xBA do documento de venda</label><input type="text" \nname="numero_documento_venda" placeholder="Inserir o n\xBA do documento de venda" \nng-model="vm.model.numero_documento_venda" maxlength="40"></md-input-container><md-input-container flex="75" \nmd-delay="500"><label translate="LAUDO.RESPONSIBLE">Respons\xE1vel</label><input type="text" name="responsavel" \nplaceholder="Inserir o respons\xE1vel" ng-model="vm.model.responsavel" required maxlength="80"><div \nng-messages="laudoForm.responsavel.$error" ng-if="laudoForm.responsavel.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.responsavel.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><h3>Avalia\xE7\xE3o</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="30" md-delay="500"><label translate="LAUDO.BATCH_ID">ID do lote</label><input type="text" \nname="lote_id" ng-model="vm.model.lote_id" ng-disabled="vm.venda.lote_distribuicao.id"></md-input-container></div><hr \nclass="divider"><div class="pesos" \nng-if="vm.model.unidade_medida != \'unidades\' || vm.model.unidade_medida == \'Embalagem\'"><h4>Pesos amostrados</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="peso in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Peso {{ $index + 1 }}</h5><md-button class="icon-btn md-icon-button" \nng-click="vm.removeLaudoAmostra($index)" ng-if="vm.model.laudo_amostra.laudo_amostra_medida.length > 1"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></div><md-input-container class="full-percent"><label>&nbsp;</label><input type="text" \nname="peso_amostra" placeholder="Digite" ng-change="vm.calcLaudoAmostra()" ng-model="peso.medida" ui-number-mask="3" \nmin="0.001" max="vm.model.quantidade" maxlength="15" required><div class="errors" \nng-messages="laudoForm.peso_amostra.$error || vm.model.laudo_amostra.percentual_medida > 100"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">Deve ser maior que {{0.001 | finance:false:3}}</div>\n<div ng-message="max">Deve ser menor que {{vm.model.quantidade | finance:false:3}}</div><div ng-message="api_erro">\n{{laudoForm.peso_amostra.$api.error.message}}</div><div ng-if="vm.model.laudo_amostra.percentual_medida > 100">\nA soma dos valores n\xE3o podem ser maior que {{vm.model.quantidade | finance:false:3}}.</div></div></md-input-container>\n</div></div><div layout="row" layout-align="center center" \nclass="layout-align-center-center layout-row content-buttons-repeat"><a class="btn btn-quaternary" \nng-click="vm.addLaudoAmostra()" ng-hide="vm.model.laudo_amostra.laudo_amostra_medida.length == 12"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Adicionar</a></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_WEIGHT">Peso total da amostra</label>\n<input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="3" min="0.001" \nmax="{{vm.model.quantidade}}" disabled="disabled"><div class="errors" ng-messages="laudoForm.peso_amostra.$error"><div \nng-message="max">A soma total deve ser menor que {{vm.model.quantidade | finance:false:3}}</div><div \nng-message="api_erro">{{laudoForm.peso_amostra.$api.error.message}}</div></div></md-input-container><md-input-container\n flex md-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" \nname="percentual_amostrado" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="vm.model.laudo_amostra.percentual_medida" disabled="disabled"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.AVERAGE_WEIGHT">Peso m\xE9dio</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="3" min="0.001" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_WEIGHT">Peso esperado</label><input \ntype="text" name="peso_amostra" placeholder="Inserir o peso esperado" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="3" min="0.001" maxlength="15"><div class="errors" \nng-messages="laudoForm.peso_amostra.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{vm.model.quantidade | finance:false:3}}</div><div ng-message="api_erro">\n{{laudoForm.peso_amostra.$api.error.message}}</div></div></md-input-container></div></div><div class="quantidade" \nng-if="vm.model.unidade_medida == \'unidades\'"><h4>Quantidade amostradas</h4><div layout="column" layout-gt-xs="row" \nlayout-margin layout-wrap=""><div ng-repeat="quantidade in vm.model.laudo_amostra.laudo_amostra_medida" \nclass="container_box" flex="20"><div class="flex-container"><h5>Quantidade {{ $index + 1 }}</h5><md-button \nclass="icon-btn md-icon-button" ng-click="vm.removeLaudoAmostra($index)" \nng-if="vm.model.laudo_amostra.laudo_amostra_medida.length > 1"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</div><md-input-container class="full-percent"><label>&nbsp;</label><input type="text" name="peso_amostra" \nplaceholder="Digite" ng-change="vm.calcLaudoAmostra()" ng-model="quantidade.medida" ui-number-mask="0" min="0.1" \nmax="vm.model.quantidade" maxlength="15" required><div class="errors" \nng-messages="laudoForm.peso_amostra.$error || vm.model.laudo_amostra.percentual_medida > 100"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">Deve ser maior que {{0 | finance:false:3}}</div><div\n ng-message="max">Deve ser menor que {{vm.model.quantidade | finance:false:3}}</div><div ng-message="api_erro">\n{{laudoForm.peso_amostra.$api.error.message}}</div><div ng-if="vm.model.laudo_amostra.percentual_medida > 100">\nA soma dos valores n\xE3o podem ser maior que {{vm.model.quantidade | finance:false:3}}.</div></div></md-input-container>\n</div></div><div layout="row" layout-align="center center" \nclass="layout-align-center-center layout-row content-buttons-repeat"><a class="btn btn-quaternary" \nng-click="vm.addLaudoAmostra()" ng-hide="vm.model.laudo_amostra.laudo_amostra_medida.length == 12"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Adicionar</a></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_AMOUNT">Quantidade total da amostra\n</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="0" \nmin="0" maxlength="15" disabled="disabled"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" name="percentual" \nui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" disabled="disabled" \nng-model="vm.model.laudo_amostra.percentual_medida"></md-input-container><md-input-container flex md-delay="500"><label\n translate="LAUDO.AVERAGE_AMOUNT">Quantidade m\xE9dia</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="0" min="0" maxlength="15" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_AMOUNT">\nQuantidade esperada</label><input type="text" name="peso_amostra" placeholder="Inserir a quantidade" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="0" min="0" maxlength="15"><div class="errors" \nng-messages="laudoForm.peso_amostra.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{vm.model.quantidade | finance:false:3}}</div><div ng-message="api_erro">\n{{laudoForm.peso_amostra.$api.error.message}}</div></div></md-input-container></div></div><hr class="divider"><div \nclass="defeitos"><h4>Defeitos</h4><div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="defeito in vm.model.laudo_defeito"><md-input-container class="select-custom" flex="50" md-delay="500">\n<label>Defeito {{ $index + 1 }}</label><md-select class="md-block" ng-model="defeito.laudo_defeito_tipo_id" \nname="laudo_defeito{{$index}}"><md-option ng-repeat="defeito_tipo in vm.defeitos" ng-value="defeito_tipo.id">\n{{defeito_tipo.descricao}}</md-option></md-select></md-input-container><md-input-container flex="25" md-delay="500" \nng-if="defeito.laudo_defeito_tipo_id == 8"><label translate="LAUDO.OTHER">Outro</label><input type="text" \nplaceholder="Inserir defeito" ng-model="defeito.laudo_defeito_tipo_outro.descricao" maxlength="35" \nname="defeito_outro{{$index}}"></md-input-container><md-input-container class="select-custom" flex="25" md-delay="500">\n<label translate="LAUDO.CLASSIFICATION">Classifica\xE7\xE3o</label><md-select class="md-block" \nng-model="defeito.laudo_defeito_classificacao_id" name="laudo_defeito_classificacao_id{{$index}}" \nplaceholder="Selecione"><md-option ng-repeat="classificacao in vm.classificacoes" ng-value="classificacao.id">\n{{classificacao.nome}}</md-option></md-select></md-input-container><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.PERCENTAGE_OTHER">Porcentagem</label><input type="text" name="porcentagem_defeito{{$index}}" \nplaceholder="Inserir o percentual" ui-percentage-value maxlength="5" ui-percentage-mask="0" max="100.0" \nng-model="defeito.porcentagem"></md-input-container><div class="flex-container-end"><md-button \nclass="icon-btn md-icon-button" ng-click="vm.removeDefeito($index)" ng-if="vm.model.laudo_defeito.length > 1"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></div></div><div layout="row" layout-align="center center" \nclass="layout-align-center-center layout-row content-buttons-repeat"><a class="btn btn-quaternary" \nng-click="vm.addDefeito()" ng-hide="vm.model.laudo_defeito.length == 10"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Adicionar</a></div></div><hr class="divider"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.MATURATION">Matura\xE7\xE3o</label>\n<md-select class="md-block" ng-model="vm.model.laudo_maturacao_id" name="laudo_maturacao_id" placeholder="Selecione">\n<md-option ng-repeat="maturacao in vm.maturacoes" ng-value="maturacao.id">{{maturacao.nome}}</md-option></md-select>\n<div ng-messages="laudoForm.laudo_maturacao_id.$error" ng-if="laudoForm.laudo_maturacao_id.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{laudoForm.laudo_maturacao_id.$api.error.message}}</div></div></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.APPEARANCE">Apar\xEAncia</label><input type="text" name="aparencia" \nplaceholder="Digite" ng-model="vm.model.aparencia" maxlength="40"><div class="errors" \nng-messages="laudoForm.aparencia.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{laudoForm.aparencia.$api.error.message}}</div></div></md-input-container><md-input-container flex md-delay="500">\n<label translate="LAUDO.TEMPERATURE">Temperatura</label><input type="text" name="temperatura" placeholder="Digite" \nui-number-mask="1" min="0.1" max="99999.9" maxlength="7" ng-model="vm.model.temperatura"><div class="errors" \nng-messages="laudoForm.temperatura.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{laudoForm.temperatura.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.CALIBER">Calibre</label><md-select class="md-block" ng-model="vm.model.laudo_calibre_id" \nname="laudo_calibre_id" placeholder="Selecione"><md-option ng-repeat="calibre in vm.calibres" ng-value="calibre.id">\n{{calibre.nome}}</md-option></md-select><div ng-messages="laudoForm.laudo_calibre_id.$error" \nng-if="laudoForm.laudo_calibre_id.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{laudoForm.laudo_calibre_id.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.COLORING">Colora\xE7\xE3o</label>\n<md-select class="md-block" ng-model="vm.model.laudo_coloracao_id" name="coloracao" placeholder="Selecione"><md-option \nng-repeat="coloracao in vm.coloracoes" ng-value="coloracao.id">{{coloracao.nome}}</md-option></md-select><div \nng-messages="laudoForm.laudo_coloracao_id.$error" ng-if="laudoForm.laudo_coloracao_id.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{laudoForm.laudo_coloracao_id.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.ODOR">Odor</label><md-select class="md-block" \nng-model="vm.model.laudo_odor_id" name="laudo_odor_id" placeholder="Selecione"><md-option \nng-repeat="odor in vm.odores" ng-value="odor.id">{{odor.nome}}</md-option></md-select><div \nng-messages="laudoForm.laudo_odor_id.$error" ng-if="laudoForm.laudo_odor_id.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.laudo_odor_id.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.FLAVOR">Sabor</label><md-select class="md-block" \nng-model="vm.model.laudo_sabor_id" name="laudo_sabor_id" placeholder="Selecione"><md-option \nng-repeat="sabor in vm.sabores" ng-value="sabor.id">{{sabor.nome}}</md-option></md-select></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.PRESSURE">Press\xE3o</label>\n<md-select class="md-block" ng-model="vm.model.laudo_pressao_id" name="laudo_pressao_id" placeholder="Selecione">\n<md-option ng-repeat="pressao in vm.pressoes" ng-value="pressao.id">{{pressao.nome}}</md-option></md-select>\n</md-input-container><md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.BRIX">Brix\n</label><md-select class="md-block" ng-model="vm.model.laudo_brix_id" name="laudo_brix_id" placeholder="Selecione">\n<md-option ng-repeat="brix in vm.brixs" ng-value="brix.id">{{brix.nome}}</md-option></md-select></md-input-container>\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea ng-model="vm.model.observacao" name="observacao" \nmaxlength="500" rows="5"></textarea></md-input-container></div></md-card></form><md-card><h3 class="custom">\nAdicionar fotos<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin>\n<choose-image-description ng-model="vm.model.laudo_upload_file" layout="row" ng-max="vm.limite_fotos" \nng-images-added="[]" flex></choose-image-description></div></md-card><md-card><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex="40" md-delay="500"><label translate="LAUDO.CONCLUSION">\nConclus\xE3o</label><md-select class="md-block" ng-model="vm.model.laudo_conclusao.laudo_conclusao_conformidade_id" \nname="laudo_conclusao" placeholder="Selecione" required><md-option ng-repeat="conclusao in vm.conclusoes" \nng-value="conclusao.id">{{conclusao.descricao}}</md-option></md-select><div \nng-messages="laudoForm.laudo_conclusao.$error" ng-if="laudoForm.laudo_conclusao.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.laudo_conclusao.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex \nmd-delay="500"><label translate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea \nng-model="vm.model.laudo_conclusao.observacao" maxlength="300" name="laudo_conclusao_observacao" rows="5"></textarea>\n</md-input-container></div></md-card></fieldset><div api-form-validation-summary form="laudoForm"></div></div><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button>\n<md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="laudoForm.$invalid || loadingProgress" ng-click="vm.confirmLaudo(laudoForm)">Gerar laudo</md-button></div>\n</div></div></div>');
$templateCache.put('app/main/laudo/views/gerenciar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1>Laudo t\xE9cnico</h1><md-button \nclass="btn btn-tertiary btn-lg-i" ng-click="vm.gotoCriar(vm.model.id)">Novo laudo t\xE9cnico</md-button></div><div \nclass="container-search"><div class="form-search align-horizontal"><h2>Gerenciar laudos</h2></div></div><div \nclass="content-register"><form name="areaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro">\n<fieldset disabled="disabled"><md-card><h3>Dados da venda</h3><div api-form-validation-summary form="areaForm"></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15"><label translate="LOTE.ID_LOTE">\nID do lote</label><input type="text" name="id" ng-model="vm.model.id" maxlength="5"></md-input-container>\n<md-input-container flex><label translate="LOTE.NUMERO_LOTE">C\xF3digo de rastreamento</label><input type="text" \nname="numero_lote" ng-model="vm.model.lote_distribuicao.lote_numero"></md-input-container><md-input-container \nflex="20" class="datepicker-custom"><label>Data de expedi\xE7\xE3o</label><md-datepicker name="expedicao" \nng-model="vm.model.data_expedicao" md-max-date="vm.date" md-placeholder="Inserir data" md-open-on-focus required>\n</md-datepicker></md-input-container><md-input-container flex="40"><label translate="LOTE.NOME_CLIENTE">Nome do cliente\n</label><input type="text" name="cliente" ng-model="vm.model.cliente_consumidor.nome"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15"><label translate="LOTE.CULTURA">Cultura\n</label><input type="text" name="cultura" ng-model="vm.model.cultura.nome"></md-input-container><md-input-container \nflex><label translate="LOTE.VARIEDADE">Variedade</label><input type="text" name="variedade" \nng-model="vm.model.produto_variedade"></md-input-container><md-input-container flex><label translate="LOTE.VALOR">Valor\n</label><input type="text" name="valor" ng-model="vm.model.valor" ui-money-mask></md-input-container>\n<md-input-container flex ng-hide="vm.model.unidade_medida == \'Embalagem\'"><label \ntranslate="LAUDO.AMOUNT_UNIT_OF_MEASUREMENT">Quanti./Unid. de medida</label><input type="text" name="unidade_medida" \nvalue="{{ vm.model.quantidade }} {{ vm.model.unidade_medida }}" maxlength="25"></md-input-container><md-input-container\n flex ng-if="vm.model.unidade_medida == \'Embalagem\'"><label translate="LAUDO.AMOUNT_UNIT_OF_MEASUREMENT">\nQuanti./Unid. de medida</label><input type="text" name="unidade_medida" \nvalue="{{ vm.model.quantidade }} {{ vm.model.unidade_medida }}" maxlength="25"></md-input-container><md-input-container\n flex ng-if="vm.model.unidade_medida == \'Embalagem\'"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input\n type="text" name="embalagem_tipo" ng-model="vm.model.embalagem_tipo"></md-input-container><md-input-container flex \nng-if="vm.model.unidade_medida == \'Embalagem\'"><label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input \ntype="text" name="embalagem_peso" ng-model="vm.model.embalagem_peso"></md-input-container></div></md-card></fieldset>\n<div id="laudos-gerados"><md-card><h3>Laudos gerados:</h3><table row-border hover id="responsive" \nclass="simple table-custom laudo"><thead><th>N\xBA do laudo</th><th>Data</th><th>Status</th><th>A\xE7\xE3o</th></thead><tbody>\n<tr ng-repeat="model in vm.model.laudo"><td>{{ model.id }}</td><td>{{ model.data_criacao | date:\'dd/MM/yyyy\' }}</td><td\n ng-if="model.laudo_status_id == 1"><div class="icon-custom"><md-icon class="enabled" md-font-icon="icon-brightness-1">\n</md-icon></div>Ativo</td><td ng-if="model.laudo_status_id == 2"><div class="icon-custom"><md-icon class="disabled" \nmd-font-icon="icon-brightness-1"></md-icon></div>Cancelado</td><td><a class="btn-quaternary mr-3rem" \nng-click="vm.gotoReCriar(model.id, vm.model.id)">Gerar laudo a partir desse</a><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizarLaudo(model.id)"><i class="far fa-eye"><md-tooltip \nhide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-if="model.laudo_status_id == 1" ng-click="vm.gotoPrintLaudo(model, model.id)"><i class="fas fa-download"><md-tooltip\n hide-xs md-direction="top">Download</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.cancelarLaudo(model)" ng-if="model.laudo_status_id == 1"><i class="fas fa-ban"><md-tooltip hide-xs \nmd-direction="right">Cancelar laudo</md-tooltip></i></md-button></td></tr></tbody></table><div class="paginator" \nng-if="vm.model.laudo.length <= 0"><i class="far fa-file-alt"></i><p>Nenhum registro encontrado.</p></div></md-card>\n</div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.comeBack()">Voltar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/laudo/views/laudo-download.tmpl.html','<md-dialog class="modal-custom-wait-download"><md-dialog-content class="container"><div layout="column"><div \nclass="content"><span>Por favor, aguarde.<br>Estamos preparamos o seu laudo.</span><md-progress-circular \nid="download-progress" class="md-accent" md-diameter="32"></md-progress-circular></div></div></md-dialog-content>\n</md-dialog>');
$templateCache.put('app/main/laudo/views/print-laudo.tmpl.html','<md-dialog class="modal-custom-register"><md-dialog-content class="change-client"><div id="forms" \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><md-button \nclass="md-icon-button close-modal" ng-click="dismissModal()">X</md-button><div class="container-content-custom"><div \nid="impressao"><div class="container-header padding-left-175rem"><h1 translate="LAUDO.TITLE">Laudo t\xE9cnico</h1><div \nclass="header-id-lote"><label>ID do laudo</label><input type="text" ng-model="vm.model.id" disabled="disabled"></div>\n</div><div class="content-register with-select"><form name="laudoForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>Dados da venda</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label translate="LAUDO.TRACKING_CODE">\nC\xF3digo rastreamento</label><input type="text" name="codigo_rastreamento" placeholder="Insira o c\xF3digo rastreamento" \nng-model="vm.model.lote_numero" disabled="disabled"></md-input-container><md-input-container class="datepicker-custom" \nflex="20" md-delay="500"><label translate="LAUDO.SHIPPING_DATE">Data de expedi\xE7\xE3o</label><md-datepicker \nname="data_expedicao" ng-model="vm.model.data_expedicao" md-placeholder="Inserir data" md-open-on-focus \ndisabled="disabled"></md-datepicker></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="50" md-delay="500"><label translate="LAUDO.CUSTOMER_NAME">Nome do cliente</label><input \ntype="text" name="nome_cliente" placeholder="Inserir nome do cliente" ng-model="vm.model.cliente.nome" \ndisabled="disabled"></md-input-container><md-input-container flex="50" md-delay="500"><label translate="LAUDO.EMAIL">\nE-mail</label><input type="email" name="email" placeholder="Inserir e-mail" maxlength="60" \nng-pattern="/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/" \nng-model="vm.model.responsavel_email" required><div ng-messages="laudoForm.email.$error" \nng-if="laudoForm.email.$touched"><div ng-message="required">Campo Obrigat\xF3rio.</div><div ng-message="pattern">\nE-mail incorreto.</div><div ng-message="api_erro">{{laudoForm.email.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.CULTURE">Cultura</label><input type="text" name="cultura" \nplaceholder="Inserir cultura" ng-model="vm.model.cultura.nome" disabled="disabled"></md-input-container>\n<md-input-container flex="25" md-delay="500"><label translate="LAUDO.VARIETY">Variedade</label><input type="text" \nname="variedade" placeholder="Inserir variedade" ng-model="vm.model.produto_variedade" disabled="disabled">\n</md-input-container><md-input-container flex="25" md-delay="500"><label translate="LAUDO.CATEGORY">Categoria</label>\n<input type="text" name="nome_cliente" placeholder="Inserir categoria" ng-model="vm.model.categoria"><div \nng-messages="laudoForm.categoria.$error" ng-if="laudoForm.categoria.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.categoria.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15" md-delay="500"><label translate="LAUDO.AMOUNT">Quantidade</label>\n<input type="text" name="quantidade" ng-model="vm.model.quantidade" disabled="disabled"></md-input-container>\n<md-input-container flex="20" md-delay="500" ng-hide="vm.model.unidade_medida == \'Embalagem\'"><label \ntranslate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" name="quantidade" \nng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin ng-if="vm.model.unidade_medida == \'Embalagem\'"><md-input-container flex \nmd-delay="500"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" \nname="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input type="text" name="embalagem_tipo" \nng-model="vm.model.embalagem_tipo" disabled="disabled"></md-input-container><md-input-container flex md-delay="500">\n<label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input type="text" name="embalagem_peso" \nng-model="vm.model.embalagem_peso" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.SALES_DOCUMENT_NUMBER">N\xBA do documento de venda</label><input type="text" \nname="numero_documento_venda" placeholder="Inserir o n\xBA do documento de venda" \nng-model="vm.model.numero_documento_venda"></md-input-container><md-input-container flex="75" md-delay="500"><label \ntranslate="LAUDO.RESPONSIBLE">Respons\xE1vel</label><input type="text" name="responsavel" \nplaceholder="Inserir o respons\xE1vel" ng-model="vm.model.responsavel_nome" required><div \nng-messages="laudoForm.responsavel.$error" ng-if="laudoForm.responsavel.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.responsavel.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n class="select-custom" flex="40" md-delay="500"><label translate="LAUDO.CONCLUSION">Conclus\xE3o</label><input \ntype="text" name="laudo_conclusao_conformidade" \nng-model="vm.model.laudo_conclusao.laudo_conclusao_conformidade.descricao"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea ng-model="vm.model.laudo_conclusao.observacao" \nname="laudo_conclusao_observacao" rows="5"></textarea></md-input-container></div></md-card><md-card><h3>Avalia\xE7\xE3o</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30" md-delay="500"><label \ntranslate="LAUDO.BATCH_ID">ID do lote</label><input type="text" name="lote_id" ng-model="vm.model.id">\n</md-input-container></div><hr class="divider"><div class="pesos" \nng-if="vm.model.unidade_medida == \'Kg\' || vm.model.unidade_medida == \'Embalagem\'"><h4>Pesos amostrados</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="peso in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Peso {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-model="peso.medida" ui-number-mask="3" \nmin="0.001" maxlength="15" required></md-input-container></div></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_WEIGHT">\nPeso total da amostra</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" \nui-number-mask="3" min="0.001" max="{{vm.model.quantidade}}"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" \nname="percentual_amostrado" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="vm.model.laudo_amostra.percentual_medida"></md-input-container><md-input-container flex md-delay="500"><label\n translate="LAUDO.AVERAGE_WEIGHT">Peso m\xE9dio</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="3" min="0.001" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_WEIGHT">Peso esperado</label><input \ntype="text" name="peso_amostra" placeholder="Inserir o peso esperado" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="3" min="0.001" maxlength="15"></md-input-container>\n</div></div><div class="quantidade" ng-if="vm.model.unidade_medida == \'Unidades\'"><h4>Quantidade amostradas</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="quantidade in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Quantidade {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-change="vm.calcLaudoAmostra()" \nng-model="quantidade.medida" ui-number-mask="0" min="0.1" maxlength="15" required></md-input-container></div></div><div\n layout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.SAMPLE_TOTAL_AMOUNT">Quantidade total da amostra</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="0" min="0" maxlength="15" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">\nPercentual amostrado</label><input type="text" name="percentual" ui-percentage-value maxlength="5" \nui-percentage-mask="0" min="0.1" max="100.0" ng-model="vm.model.laudo_amostra.percentual_medida" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.AVERAGE_AMOUNT">Quantidade m\xE9dia\n</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="0" \nmin="0" maxlength="15"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.EXPECTED_AMOUNT">Quantidade esperada</label><input type="text" name="peso_amostra" \nplaceholder="Inserir a quantidade" ng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="0" min="0" \nmaxlength="15" required></md-input-container></div></div><div class="defeitos"><h4>Defeitos</h4><div layout="column" \nlayout-gt-xs="row" layout-margin ng-repeat="defeito in vm.model.laudo_defeito"><md-input-container \nclass="select-custom" flex="50" md-delay="500"><label>Defeito {{ $index + 1 }}</label><input type="text" \nname="descricao" ng-model="defeito.descricao"></md-input-container><md-input-container flex="25" md-delay="500" \nng-if="defeito.laudo_defeito_tipo_id == 8"><label translate="LAUDO.OTHER">Outro</label><input type="text" \nname="defeito_outro" placeholder="Inserir defeito" ng-model="defeito.laudo_defeito_tipo_outro.descricao">\n</md-input-container><md-input-container class="select-custom" flex="25" md-delay="500"><label \ntranslate="LAUDO.CLASSIFICATION">Classifica\xE7\xE3o</label><input type="text" name="laudo_defeito_classificacao" \nng-model="defeito.laudo_defeito_classificacao.descricao"></md-input-container><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_OTHER">Porcentagem</label><input type="text" \nname="porcentagem_defeito" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="defeito.porcentagem"></md-input-container></div></div><hr class="divider"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.MATURATION">Matura\xE7\xE3o</label><input type="text" name="laudo_maturacao" \nng-model="vm.model.laudo_maturacao.descricao"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.APPEARANCE">Apar\xEAncia</label><input type="text" name="aparencia" ng-model="vm.model.aparencia">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.TEMPERATURE">Temperatura</label>\n<input type="text" name="laudo_maturacao" ng-model="vm.model.temperatura"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.CALIBER">Calibre</label><input type="text" name="laudo_calibre" \nng-model="vm.model.laudo_calibre.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.COLORING">Colora\xE7\xE3o</label><input type="text" name="laudo_coloracao" \nng-model="vm.model.laudo_coloracao.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.ODOR">Odor</label><input type="text" name="laudo_odor" \nng-model="vm.model.laudo_odor.descricao"></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.FLAVOR">Sabor\n</label><input type="text" name="laudo_sabor" ng-model="vm.model.laudo_sabor.descricao"></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.PRESSURE">Press\xE3o</label><input \ntype="text" name="laudo_pressao" ng-model="vm.model.laudo_pressao.descricao"></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.BRIX">Brix</label><input type="text" \nname="laudo_brix" ng-model="vm.model.laudo_brix.descricao"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.OBSERVATION">\nObserva\xE7\xE3o</label><textarea ng-model="vm.model.observacao" name="observacao" rows="5"></textarea></md-input-container>\n</div></md-card><md-card><h3 class="custom">Fotos</h3>`<div layout="row" layout-gt-xs="row" layout-margin><div \nclass="item" ng-repeat="imagem in vm.model.laudo_upload_file" flex="40"><div class="item-content"><div class="imagem" \nflex="30"><img class="thumbnail-description" ng-src="{{imagem.url}}"></div><div class="body" flex><label>Descri\xE7\xE3o\n</label><textarea class="textarea-descricao" name="descricao" ng-model="imagem.descricao" cols="40" rows="3">\n</textarea></div></div></div></div></md-card></fieldset></form></div></div></div></div></div></md-dialog-content>\n<md-dialog-actions layout="row"><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="dismissModal()">Fechar</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.exportImpressao()">\nDownload</md-button></div></md-dialog-actions></md-dialog><div id="printThis"></div>');
$templateCache.put('app/main/laudo/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="LAUDO.TITLE">Laudo t\xE9cnico</h1><div \nclass="header-id-lote"><label>ID do laudo</label><input type="text" ng-model="vm.model.id" disabled="disabled"></div>\n</div><div class="content-register with-select"><form name="laudoForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>Dados da venda</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label translate="LAUDO.TRACKING_CODE">\nC\xF3digo rastreamento</label><input type="text" name="codigo_rastreamento" placeholder="Insira o c\xF3digo rastreamento" \nng-model="vm.model.lote_numero" disabled="disabled"></md-input-container><md-input-container class="datepicker-custom" \nflex="20" md-delay="500"><label translate="LAUDO.SHIPPING_DATE">Data de expedi\xE7\xE3o</label><md-datepicker \nname="data_expedicao" ng-model="vm.model.data_expedicao" md-placeholder="Inserir data" md-open-on-focus \ndisabled="disabled"></md-datepicker></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="50" md-delay="500"><label translate="LAUDO.CUSTOMER_NAME">Nome do cliente</label><input \ntype="text" name="nome_cliente" placeholder="Inserir nome do cliente" ng-model="vm.model.cliente_consumidor_nome" \ndisabled="disabled"></md-input-container><md-input-container flex="50" md-delay="500"><label translate="LAUDO.EMAIL">\nE-mail</label><input type="email" name="email" placeholder="Inserir e-mail" maxlength="60" \nng-pattern="/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/" \nng-model="vm.model.cliente_consumidor_email" required><div ng-messages="laudoForm.email.$error" \nng-if="laudoForm.email.$touched"><div ng-message="required">Campo Obrigat\xF3rio.</div><div ng-message="pattern">\nE-mail incorreto.</div><div ng-message="api_erro">{{laudoForm.email.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.CULTURE">Cultura</label><input type="text" name="cultura" \nplaceholder="Inserir cultura" ng-model="vm.model.cultura.nome" disabled="disabled"></md-input-container>\n<md-input-container flex="25" md-delay="500"><label translate="LAUDO.VARIETY">Variedade</label><input type="text" \nname="variedade" placeholder="Inserir variedade" ng-model="vm.model.produto_variedade" disabled="disabled">\n</md-input-container><md-input-container flex="25" md-delay="500"><label translate="LAUDO.CATEGORY">Categoria</label>\n<input type="text" name="nome_cliente" placeholder="Inserir categoria" ng-model="vm.model.categoria"><div \nng-messages="laudoForm.categoria.$error" ng-if="laudoForm.categoria.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.categoria.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15" md-delay="500"><label translate="LAUDO.AMOUNT">Quantidade</label>\n<input type="text" name="quantidade" ng-model="vm.model.quantidade" disabled="disabled"></md-input-container>\n<md-input-container flex="20" md-delay="500" ng-hide="vm.model.unidade_medida == \'Embalagem\'"><label \ntranslate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" name="quantidade" \nng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin ng-if="vm.model.unidade_medida == \'Embalagem\'"><md-input-container flex \nmd-delay="500"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" \nname="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input type="text" name="embalagem_tipo" \nng-model="vm.model.embalagem_tipo" disabled="disabled"></md-input-container><md-input-container flex md-delay="500">\n<label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input type="text" name="embalagem_peso" \nng-model="vm.model.embalagem_peso" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.SALES_DOCUMENT_NUMBER">N\xBA do documento de venda</label><input type="text" \nname="numero_documento_venda" placeholder="Inserir o n\xBA do documento de venda" \nng-model="vm.model.numero_documento_venda"></md-input-container><md-input-container flex="75" md-delay="500"><label \ntranslate="LAUDO.RESPONSIBLE">Respons\xE1vel</label><input type="text" name="responsavel" \nplaceholder="Inserir o respons\xE1vel" ng-model="vm.model.responsavel_nome" required><div \nng-messages="laudoForm.responsavel.$error" ng-if="laudoForm.responsavel.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.responsavel.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n class="select-custom" flex="40" md-delay="500"><label translate="LAUDO.CONCLUSION">Conclus\xE3o</label><input \ntype="text" name="laudo_conclusao_conformidade" \nng-model="vm.model.laudo_conclusao.laudo_conclusao_conformidade.descricao"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea ng-model="vm.model.laudo_conclusao.observacao" \nname="laudo_conclusao_observacao" rows="5"></textarea></md-input-container></div></md-card><md-card><h3>Avalia\xE7\xE3o</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30" md-delay="500"><label \ntranslate="LAUDO.BATCH_ID">ID do lote</label><input type="text" name="lote_id" \nng-model="vm.model.lote_distribuicao_venda_id"></md-input-container></div><hr class="divider"><div class="pesos" \nng-if="vm.model.unidade_medida == \'Kg\' || vm.model.unidade_medida == \'Embalagem\'"><h4>Pesos amostrados</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="peso in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Peso {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-model="peso.medida" ui-number-mask="3" \nmin="0.001" maxlength="15" required></md-input-container></div></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_WEIGHT">\nPeso total da amostra</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" \nui-number-mask="3" min="0.001" max="{{vm.model.quantidade}}"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" \nname="percentual_amostrado" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="vm.model.laudo_amostra.percentual_medida"></md-input-container><md-input-container flex md-delay="500"><label\n translate="LAUDO.AVERAGE_WEIGHT">Peso m\xE9dio</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="3" min="0.001" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_WEIGHT">Peso esperado</label><input \ntype="text" name="peso_amostra" placeholder="Inserir o peso esperado" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="3" min="0.001" maxlength="15"></md-input-container>\n</div></div><div class="quantidade" ng-if="vm.model.unidade_medida == \'Unidades\'"><h4>Quantidade amostradas</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="quantidade in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Quantidade {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-change="vm.calcLaudoAmostra()" \nng-model="quantidade.medida" ui-number-mask="0" min="0.1" maxlength="15" required></md-input-container></div></div><div\n layout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.SAMPLE_TOTAL_AMOUNT">Quantidade total da amostra</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="0" min="0" maxlength="15" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">\nPercentual amostrado</label><input type="text" name="percentual" ui-percentage-value maxlength="5" \nui-percentage-mask="0" min="0.1" max="100.0" ng-model="vm.model.laudo_amostra.percentual_medida" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.AVERAGE_AMOUNT">Quantidade m\xE9dia\n</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="0" \nmin="0" maxlength="15"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.EXPECTED_AMOUNT">Quantidade esperada</label><input type="text" name="peso_amostra" \nplaceholder="Inserir a quantidade" ng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="0" min="0" \nmaxlength="15" required></md-input-container></div></div><div class="defeitos"><h4>Defeitos</h4><div layout="column" \nlayout-gt-xs="row" layout-margin ng-repeat="defeito in vm.model.laudo_defeito"><md-input-container \nclass="select-custom" flex="50" md-delay="500"><label>Defeito {{ $index + 1 }}</label><input type="text" \nname="descricao" ng-model="defeito.descricao"></md-input-container><md-input-container flex="25" md-delay="500" \nng-if="defeito.laudo_defeito_tipo_id == 8"><label translate="LAUDO.OTHER">Outro</label><input type="text" \nname="defeito_outro" placeholder="Inserir defeito" ng-model="defeito.laudo_defeito_tipo_outro.descricao">\n</md-input-container><md-input-container class="select-custom" flex="25" md-delay="500"><label \ntranslate="LAUDO.CLASSIFICATION">Classifica\xE7\xE3o</label><input type="text" name="laudo_defeito_classificacao" \nng-model="defeito.laudo_defeito_classificacao.descricao"></md-input-container><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_OTHER">Porcentagem</label><input type="text" \nname="porcentagem_defeito" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="defeito.porcentagem"></md-input-container></div></div><hr class="divider"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.MATURATION">Matura\xE7\xE3o</label><input type="text" name="laudo_maturacao" \nng-model="vm.model.laudo_maturacao.descricao"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.APPEARANCE">Apar\xEAncia</label><input type="text" name="aparencia" ng-model="vm.model.aparencia">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.TEMPERATURE">Temperatura</label>\n<input type="text" name="laudo_maturacao" ng-model="vm.model.temperatura"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.CALIBER">Calibre</label><input type="text" name="laudo_calibre" \nng-model="vm.model.laudo_calibre.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.COLORING">Colora\xE7\xE3o</label><input type="text" name="laudo_coloracao" \nng-model="vm.model.laudo_coloracao.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.ODOR">Odor</label><input type="text" name="laudo_odor" \nng-model="vm.model.laudo_odor.descricao"></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.FLAVOR">Sabor\n</label><input type="text" name="laudo_sabor" ng-model="vm.model.laudo_sabor.descricao"></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.PRESSURE">Press\xE3o</label><input \ntype="text" name="laudo_pressao" ng-model="vm.model.laudo_pressao.descricao"></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.BRIX">Brix</label><input type="text" \nname="laudo_brix" ng-model="vm.model.laudo_brix.descricao"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.OBSERVATION">\nObserva\xE7\xE3o</label><textarea ng-model="vm.model.observacao" name="observacao" rows="5"></textarea></md-input-container>\n</div></md-card><md-card class="laudo-fotos"><h3 class="custom">Fotos</h3>`<div layout="row" layout-gt-xs="row" \nlayout-margin><div class="item" ng-repeat="imagem in vm.model.laudo_upload_file" flex="40"><div class="item-content">\n<div class="imagem" flex="30"><img class="thumbnail-description" ng-src="{{imagem.url}}"></div><div class="body" flex>\n<label>Descri\xE7\xE3o</label><textarea class="textarea-descricao" name="descricao" ng-model="imagem.descricao" cols="40" \nrows="3"></textarea></div></div></div></div></md-card></fieldset><div api-form-validation-summary form="laudoForm">\n</div></form></div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.comeBack()">\nVoltar</md-button></div></div></div></div>');
$templateCache.put('app/main/passo_a_passo/view/passo_a_passo.html','<div class="page-layout simple fullwidth doc-page passo-a-passo-interna" layout="column"><div class="container-pap">\n<div class="row-pap"><div class="col-chamada"><h2>Passo a passo</h2><p>\nAprenda e tire suas d\xFAvidas assistindo o passo a passo. S\xF3 vai levar 2 minutos.</p></div></div><div class="row-pap">\n<div class="container-pap"><div class="col accordion-div"><div class="tab-passo" \nng-class=" vm.autoSelectPasso == 1 ? \'active\' : \'\' "><a href="#"><div class="botao"><div class="num"><span>PASSO</span>\n<br>01</div><div class="title"><h3>Como <strong>cadastrar</strong> sua<br><strong>propriedade</strong> e as <strong>\n\xE1reas</strong></h3><p>Veja o passo-a-passo, <strong>clique aqui!</strong></p></div></div></a><div \nclass="content-passo"><ul><li><a href="#" ng-click="vm.viewCadastroPropriedade()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-propriedade.jpg);"><span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="txt"><p>\nComece adicionando a sua propriedade. Veja como \xE9 f\xE1cil e r\xE1pido!</p><small>Tempo do v\xEDdeo: 2:31 min</small></div></a>\n</li><li><a href="#" ng-click="vm.viewCadastroArea()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-area-historico.jpg);"><span\n class="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="txt">\n<p>Inclua todas as \xE1reas da sua propriedade para come\xE7ar a administrar suas planta\xE7\xF5es.</p><small>\nTempo do v\xEDdeo: 2:22 min</small></div></a></li></ul></div></div><a id="anchor2"></a><div class="tab-passo" \nng-class=" vm.autoSelectPasso == 2 ? \'active\' : \'\' "><a href="#"><div class="botao"><div class="num"><span>PASSO</span>\n<br>02</div><div class="title"><h3>Como <strong>gerir</strong><br>seus <strong>manejos</strong></h3><p>\nVeja o passo-a-passo, <strong>clique aqui!</strong></p></div></div></a><div class="content-passo"><ul><li><a href="#" \nng-click="vm.viewCadastroInsumo()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-insumo.jpg);"><span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="txt"><p>\nCadastre todos os insumos para poder fazer as aplica\xE7\xF5es necess\xE1rias.</p><small>Tempo do v\xEDdeo: 2:30 min</small></div>\n</a></li><li><a href="#" ng-click="vm.viewCadastroEstoque()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-cadastro-estoque-fornecedores.jpg);">\n<span class="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div \nclass="txt"><p>Aprenda a cadastrar o seu estoque e tenha o controle da sua produ\xE7\xE3o.</p><small>Tempo do v\xEDdeo: 2:36 min\n</small></div></a></li><li><a href="#" ng-click="vm.viewPlantio()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-plantio-caderno-de-campo.jpg);">\n<span class="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div \nclass="txt"><p>Veja como \xE9 simples criar e adicionar um plantio no seu Caderno de Campo.</p><small>\nTempo do v\xEDdeo: 2:28 min</small></div></a></li><li><a href="#" ng-click="vm.viewAplicarInsumo()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-aplicar-insumos-eattae.jpg);"><span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="txt"><p>\nJ\xE1 cadastrou os insumos? Agora \xE9 s\xF3 fazer a aplica\xE7\xE3o em suas \xE1reas.</p><small>Tempo do v\xEDdeo: 3:41 min</small></div>\n</a></li><li><a href="#" ng-click="vm.viewColheita()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-youtube-realizar-colheita.jpg);"><span \nclass="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="txt"><p>\nRegistre as informa\xE7\xF5es das suas colheitas e comece a montar seus lotes produzidos.</p><small>Tempo do v\xEDdeo: 2:46 min\n</small></div></a></li><li><a href="#" ng-click="vm.viewManejo()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/thumb-custos-de-manejos.png);"><span class="play">\n<img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div><div class="txt"><p>\nRegistre as informa\xE7\xF5es dos custos de seus manejos.</p><small>Tempo do v\xEDdeo: 2:39 min</small></div></a></li></ul>\n</div></div></div></div></div><div class="content-button"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoPassoAPasso()" translate="PASSO.VOLTAR">Voltar</md-button></div></div></div>');
$templateCache.put('app/main/passo_a_passo/view/passo_a_passo_home.html','<div class="page-layout simple fullwidth doc-page passo-a-passo" layout="column"><div class="container-pap"><div \nclass="row-pap"><div class="col-chamada"><h2>Bem-vindo ao caderno de campo Eattae</h2><p>\nVeja como \xE9 f\xE1cil ter o controle total da sua produ\xE7\xE3o! Aprenda e tire suas d\xFAvidas assistindo o passo a passo, s\xF3 vai levar 2 minutos.\n</p></div></div><div class="row-pap"><div class="col-first"><img \nsrc="../../../../assets/images/img-tutorial-passo1.svg" alt=""></div><div class="col-middle"><a \nng-href="/passo-a-passo/step/{{1}}"><div class="botao"><div class="num"><span>PASSO</span><br>01</div><div \nclass="title"><h3>Como <strong>cadastrar</strong> sua<br><strong>propriedade</strong> e as <strong>\xE1reas</strong></h3>\n<p>Veja o passo-a-passo, <strong>clique aqui!</strong></p></div></div></a></div><div class="col-last"></div></div><div \nclass="row-pap"><div class="col-tracejado"></div></div><div class="row-pap"><div class="col-first"></div><div \nclass="col-middle"><a ng-href="/passo-a-passo/step/{{2}}"><div class="botao"><div class="num"><span>PASSO</span><br>02\n</div><div class="title"><h3>Como <strong>gerir</strong><br>seus <strong>manejos</strong></h3><p>Veja o passo-a-passo, \n<strong>clique aqui!</strong></p></div></div></a></div><div class="col-last"><img \nsrc="../../../../assets/images/img-tutorial-passo2.svg" alt=""></div></div></div></div>');
$templateCache.put('app/main/previsao_colheita/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1>Previs\xE3o colheita > Lista de previs\xF5es</h1></div><md-button \nng-click="vm.gotoAdd()" class="btn btn-primary btn-lg-i" ng-disabled="vm.propriedade.length == 0">Cadastrar previs\xE3o\n</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/previsa-colheita/ico-laudo-flv-br.svg"></span>LISTA DE PREVIS\xD5ES</h3></div><div \nclass="form-search-horizontal"><form><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col periodo"><div \nclass="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo do Cadastro</label><select class="form-select select-periodo" name="periodo" \nng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option value="" disabled="disabled">Selecione</option>\n<option ng-value="period.value" ng-repeat="period in vm.periods">{{period.description}}</option></select>\n</md-input-container></div><div class="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicial" ng-model="vm.args.data_inicial" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container \nclass="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.DataInicio" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Cultura</label><select \nid="cultura" ng-model="vm.args.cultura" ng-options="cultura.nome as cultura.nome for cultura in vm.filtros.culturas" \nng-value="cultura.nome" ng-change="vm.onSelectCultura(vm.args.cultura)"><option value="" selected="selected" \ndisabled="disabled">Selecione</option></select></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Variedade</label><select id="variedade" ng-model="vm.args.variedade" \nng-disabled="!vm.args.cultura" ng-options="item.produto_variedade as item.produto_variedade for item in vm.variedades" \nng-value="item.produto_variedade"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom despesas"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="nome_area" lm-title="\xC1rea"></th><th class="secondary-text pagination-custom" lm-sort-header="cultura" \nlm-title="Cultura/variedade"></th><th class="secondary-text pagination-custom" lm-sort-header="peso_previsto" \nlm-title="Qtd. prevista"></th><th class="secondary-text pagination-custom" lm-sort-header="data_cadastro" \nlm-title="Data cadastro"></th><th class="secondary-text pagination-custom" lm-sort-header="data_inicial" \nlm-title="Data inicial"></th><th class="secondary-text pagination-custom" lm-sort-header="data_final" \nlm-title="Data final"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr ng-repeat="item in vm.models"><td>\n{{item.nome_area}}</td><td>{{item.cultura}} / {{item.produto_variedade}}</td><td \nng-if="item.unidade_medida != \'unidades\'">{{item.peso_previsto | number:3}} kg</td><td \nng-if="item.unidade_medida == \'unidades\'">{{item.peso_previsto | number}} unidades</td><td>\n{{item.data_cadastro | date:\'dd/MM/yyyy\'}}</td><td>{{item.data_inicial | date:\'dd/MM/yyyy\'}}</td><td>\n{{item.data_final | date:\'dd/MM/yyyy\'}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoEdit(item.id)" aria-label="Editar"><i class="fas fa-pen"><md-tooltip hide-xs md-direction="left">\nEditar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" ng-click="vm.deletarConfirm(item)" \naria-label="Apagar"><i class="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i>\n</md-button></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/previsao_colheita/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1>Previs\xE3o colheita > Cadastro previs\xE3o</h1></div></div><div \nid="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" layout="column">\n<div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>DADOS DA PREVIS\xC3O</h3></div><div class="content-register"><form \nname="previsaoForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div \napi-form-validation-summary form="previsaoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex md-delay="500"><label>\xC1rea</label><md-select class="md-block" \nng-model="vm.model.propriedade_area" placeholder="Selecione a \xE1rea" name="propriedade_area" required \nng-change="vm.areaChange(vm.model.propriedade_area)"><md-option ng-repeat="area in vm.areas" ng-value="area">\n{{area.propriedade_area_nome}}</md-option></md-select><div ng-messages="previsaoForm.propriedade_area.$error" \nng-if="previsaoForm.propriedade_area.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{previsaoForm.propriedade_area.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label>Cultura</label><input type="text" disabled="disabled" name="cultura" \nng-model="vm.model.cultura"></md-input-container><md-input-container flex><label>Variedade</label><input type="text" \nng-disabled="!vm.model.cultura || vm.variedade" name="variedade" ng-model="vm.model.produto_variedade" required><div \nclass="errors" ng-messages="previsaoForm.produto_variedade.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{previsaoForm.produto_variedade.$api.error.message}}</div></div></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="20" \nng-if="vm.model.unidade_medida == \'kg\'"><label>Peso previsto (kg)</label><input id="inptNm" type="text" \nname="peso_previsto" placeholder="Digite" ng-model="vm.model.peso_previsto" ui-number-mask="3" min="0.001" \nmax="9999999.999" maxlength="11" required><div class="errors" ng-messages="previsaoForm.peso_previsto.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{previsaoForm.peso_previsto.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" \nng-if="vm.model.unidade_medida == \'unidades\'"><label>Qtd. prevista</label><input id="inptNm" type="text" \nname="peso_previsto" placeholder="Digite" ng-model="vm.model.peso_previsto" ui-number-mask="0" min="1" \nmax="999.999.999" maxlength="11" required><div class="errors" ng-messages="previsaoForm.peso_previsto.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{previsaoForm.peso_previsto.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" \nng-if="!vm.model.unidade_medida"><label>Peso previsto</label><input type="text" \nplaceholder="Selecione o tipo de unidade" disabled="disabled"></md-input-container><md-input-container \nclass="datepicker-custom" flex="20"><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.model.data_inicial" md-placeholder="Inserir data" md-max-date="vm.model.data_final" md-open-on-focus \nrequired></md-datepicker><div class="errors" ng-messages="previsaoForm.data_inicial.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{previsaoForm.data_validade.$api.error.message}}</div></div>\n</md-input-container><md-input-container class="datepicker-custom" flex="20"><label>Data final</label><md-datepicker \nname="data_final" ng-model="vm.model.data_final" md-placeholder="Inserir data" md-min-date="vm.model.data_inicial" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="previsaoForm.data_final.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{previsaoForm.data_validade.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button md-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoLista()">\nVoltar</md-button><md-button md-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="previsaoForm.$invalid || previsaoForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></div><div api-form-validation-summary form="previsaoForm"></div></form></div></div></div></div>');
$templateCache.put('app/main/previsao_colheita/views/dash.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Previs\xE3o colheita > Dashboard</h1>\n</div></div><div class="top-content-buttons"><md-button ng-click="vm.gotoAdd()" class="btn btn-primary btn-lg-i" \nng-disabled="vm.propriedade.length == 0">Cadastrar previs\xE3o</md-button>&nbsp;&nbsp;<md-button ng-click="vm.gotoList()" \nclass="btn btn-primary btn-lg-i" ng-disabled="vm.propriedade.length == 0">Ver \xFAltimos cadastros</md-button></div></div>\n<div class="page-layout simple fullwidth previsao-colheita-page" layout="column"><div class="content" layout="column">\n<div class="container-content-custom"><div class="indices-1 form-search-horizontal"><div class="container"><div \nclass="row grupo-2"><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../assets/icons/ico-propriedade.svg"><h3>HECTARES</h3></div><div class="total"><span class="number">\n{{ vm.dash.hectares | number }}</span><br><span class="nome">TOTAL</span></div></div></div><div class="col"><div \nclass="box-2"><div class="ico"><img src="../assets/icons/previsa-colheita/ico-laudo-flv.svg"><h3>CULTURAS</h3></div>\n<div class="total"><span class="number">{{ vm.dash.culturas | number }}</span><br><span class="nome">TOTAL</span></div>\n<div class="footer"><a href="#" ng-click="vm.openModalCulturas()"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nVer lista</a></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../assets/icons/previsa-colheita/ico-peso-produzido.svg"><h3>PESO</h3></div><div class="total"><span \nclass="number">{{ vm.dash.peso_previsto | number:3 }}</span><br><span class="nome">TOTAL</span></div></div></div></div>\n</div></div><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/previsa-colheita/ico-laudo-flv-br.svg"></span>LISTA TOTAL PREVISTO POR CULTURA</h3></div><div \nclass="form-search-horizontal"><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col periodo"><div \nclass="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo</label><select class="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" \nng-change="vm.selectedPeriodo()"><option value="">Selecione</option><option ng-value="period.value" \nng-repeat="period in vm.periods">{{period.description}}</option></select></md-input-container></div><div \nclass="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicial" ng-model="vm.args.data_inicial" \nmd-max-date="vm.args.data_final" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.data_inicial" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Cultura</label><select \nid="cultura" ng-model="vm.args.cultura" ng-options="cultura.nome as cultura.nome for cultura in vm.filtros.culturas" \nng-value="cultura.nome" ng-change="vm.onSelectCultura(vm.args.cultura)"><option value="" selected="selected" \ndisabled="disabled">Selecione</option></select></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Variedade</label><select id="variedade" ng-model="vm.args.variedade" \nng-disabled="!vm.args.cultura" ng-options="item.produto_variedade as item.produto_variedade for item in vm.variedades" \nng-value="item.produto_variedade"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary" \nng-click="vm.resetPagination(); vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><a \nid="lista"></a><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom previsao-colheita"><thead class="first-level"><tr>\n<th></th><th class="secondary-text pagination-custom" lm-sort-header="cultura_variedade" \nlm-title="Cultura / variedade"></th><th class="secondary-text pagination-custom" lm-sort-header="hectares" \nlm-title="Hectares"></th><th class="secondary-text pagination-custom" lm-sort-header="areas" lm-title="N\xBA \xE1reas"></th>\n<th class="secondary-text pagination-custom" lm-sort-header="peso" lm-title="Qtd. prevista"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="colhido" lm-title="Colhido"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_inicio" lm-title="Data inicial"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_final" lm-title="Data final"></th></tr></thead><tbody><tr\n class="default" ng-repeat-start="model in vm.models"><td class="click-button desktop-button-plus"><a \nng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled">\n<md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a>&nbsp;</td><td><h6 class="d-mobile">Cultura/variedade</h6>\n{{model.cultura}} / {{model.produto_variedade}}</td><td><h6 class="d-mobile">Hectares</h6>{{model.hectares}}</td><td>\n<h6 class="d-mobile">N\xBA \xE1res</h6>{{model.numero_areas}}</td><td ng-if="model.unidade_medida != \'unidades\'"><h6 \nclass="d-mobile">Qtd. prevista</h6>{{model.peso_previsto | number:3}} kg</td><td \nng-if="model.unidade_medida == \'unidades\'"><h6 class="d-mobile">Qtd. prevista</h6>\n{{model.peso_previsto | number}} unidades</td><td ng-if="model.areas[0].colhido_unidade_medida != \'unidades\'"><h6 \nclass="d-mobile">Colhido</h6>{{model.colhido | number:3}} kg</td><td \nng-if="model.areas[0].colhido_unidade_medida == \'unidades\'"><h6 class="d-mobile">Colhido</h6>\n{{model.colhido | number}} unidades</td><td><h6 class="d-mobile">Data inicial</h6>\n{{model.data_inicial | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">Data final</h6>\n{{model.data_final | date:\'dd/MM/yyyy\'}}</td><td class="click-button mobile-only"><a ng-click="vm.isColapsed(model)" \nng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a\n class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle"></md-icon></a>\n</td></tr><tr ng-repeat-end class="details"><td class="main" colspan="9" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><h2>Total previsto por \xE1rea:\n</h2><table><thead><tr><th>\xC1rea</th><th>Hectares</th><th>Qtd. prevista</th><th>Colhido</th><th>Data inicial</th><th>\nData final</th><th>A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="item in model.areas" class="details"><td><h6 \nclass="d-mobile">\xC1rea</h6>{{ item.nome }}</td><td><h6 class="d-mobile">Hectares</h6>{{ item.area_produtiva | number }}\n</td><td ng-if="item.unidade_medida != \'unidades\'"><h6 class="d-mobile">Peso previsto</h6>\n{{ item.peso_previsto | number:3 }} kg</td><td ng-if="item.unidade_medida == \'unidades\'"><h6 class="d-mobile">\nQtd. prevista</h6>{{ item.peso_previsto | number }} unidades</td><td ng-if="item.colhido_unidade_medida != \'unidades\'">\n<h6 class="d-mobile">Peso colhido</h6>{{ item.colhido | number:3 }} kg</td><td \nng-if="item.colhido_unidade_medida == \'unidades\'"><h6 class="d-mobile">Qtd. colhida</h6>\n{{ item.colhido | number }} unidades</td><td><h6 class="d-mobile">Data inicial</h6>\n{{ item.data_inicial | date:\'dd/MM/yyyy\' }}</td><td><h6 class="d-mobile">Data final</h6>\n{{ item.data_final | date:\'dd/MM/yyyy\' }}</td><td><h6 class="d-mobile">A\xE7\xF5es</h6><md-button \nclass="edit-button md-icon-button" ng-click="vm.openModalColheitas(item.area_id)" aria-label="Visualizar"><img \nsrc="../assets/icons/previsa-colheita/ico-lista.svg"><md-tooltip hide-xs md-direction="left">Lista de colheitas\n</md-tooltip></md-button></td></tr></tbody></table></div></td><td colspan="8" ng-if="model.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div>\n</div></div>');
$templateCache.put('app/main/previsao_colheita/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1>Previs\xE3o colheita > Dashboard > Editar previs\xE3o</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>DADOS DA PREVIS\xC3O</h3></div><div class="content-register"><form \nname="previsaoForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div \napi-form-validation-summary form="previsaoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="20"><label>\xC1rea</label><input type="text" ng-model="vm.model.area_nome" disabled="disabled">\n</md-input-container><md-input-container flex="20"><label>Cultura / variedade</label><input type="text" \ndisabled="disabled" value="{{vm.model.cultura}} / {{vm.model.produto_variedade}}"></md-input-container>\n<md-input-container flex="20" ng-if="vm.model.unidade_medida != \'unidades\'"><label>Peso previsto</label><input \nid="inptNm" type="text" name="peso" placeholder="Digite" ng-model="vm.model.peso_previsto" ui-number-mask="3" \nmin="0.001" max="9999999.999" maxlength="11" required><div class="errors" ng-messages="previsaoForm.peso.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{previsaoForm.nome_arquivo.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" \nng-if="vm.model.unidade_medida == \'unidades\'"><label>Qtd. prevista</label><input id="inptNm" type="text" name="peso" \nplaceholder="Digite" ng-model="vm.model.peso_previsto" ui-number-mask="0" min="1" max="999.999.999" maxlength="11" \nrequired><div class="errors" ng-messages="previsaoForm.peso.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{previsaoForm.nome_arquivo.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="20"><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.model.data_inicial" md-max-date="vm.model.data_final" md-placeholder="Inserir data" md-open-on-focus \nrequired></md-datepicker><div class="errors" ng-messages="previsaoForm.data_inicial.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{previsaoForm.data_validade.$api.error.message}}</div></div>\n</md-input-container><md-input-container class="datepicker-custom" flex="20"><label>Data final</label><md-datepicker \nname="data_final" ng-model="vm.model.data_final" md-min-date="vm.model.data_inicial" md-placeholder="Inserir data" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="previsaoForm.data_final.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{previsaoForm.data_validade.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button md-button-id="bttnVltr" class="btn btn-secondary btn-lg" ng-click="vm.gotoLista()">\nVoltar</md-button><md-button md-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="previsaoForm.$invalid || previsaoForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Salvar\n</md-button></div><div api-form-validation-summary form="previsaoForm"></div></form></div></div></div></div>');
$templateCache.put('app/main/previsao_colheita/views/modal_colheitas.html','<div><div class="header-modal"><div class="desc">Lista de colheitas</div><div class="close" ng-click="hide()">X</div>\n</div><div class="content"><table class="table-culturas" ng-if="colheitas.length!=0"><md-progress-linear \nng-if="loading" md-mode="indeterminate"></md-progress-linear><thead><tr><th>\xC1rea</th><th>Cultura / variedade</th><th>\nData colheita</th><th>Qtd. colhida</th></tr></thead><tbody><tr ng-repeat="item in colheitas"><td>{{ item.area_nome }}\n</td><td>{{ item.cultura }} / {{ item.produto_variedade }}</td><td>{{ item.data_colheita | date:\'dd/MM/yyyy\' }}</td><td\n ng-if="item.unidade_medida == \'kg\'">{{ item.quantidade | number:3 }} {{item.unidade_medida}}</td><td \nng-if="item.unidade_medida != \'kg\'">{{ item.quantidade | number }} {{item.unidade_medida}}</td></tr></tbody></table><p \nng-if="colheitas.length<1">Nenhuma colheita encontrada.</p></div></div>');
$templateCache.put('app/main/previsao_colheita/views/modal_culturas.html','<div><div class="header-modal"><div class="desc">Lista de culturas / variedades</div><div class="close" \nng-click="hide()">X</div></div><div class="content"><table class="table-culturas"><md-progress-linear ng-if="loading" \nmd-mode="indeterminate"></md-progress-linear><thead><tr><th>Cultura</th><th>Variedade</th></tr></thead><tbody><tr \nng-repeat="item in culturasVariedades"><td>{{ item.cultura }}</td><td>{{ item.produto_variedade }}</td></tr></tbody>\n</table></div></div>');
$templateCache.put('app/main/previsao_colheita/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-header"><h1 translate="LAUDO.TITLE">\nLaudo t\xE9cnico</h1><div class="header-id-lote"><label>ID do laudo</label><input type="text" ng-model="vm.model.id" \ndisabled="disabled"></div></div><div class="content-register with-select"><form name="laudoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>\nDados da venda</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500">\n<label translate="LAUDO.TRACKING_CODE">C\xF3digo rastreamento</label><input type="text" name="codigo_rastreamento" \nplaceholder="Insira o c\xF3digo rastreamento" ng-model="vm.model.lote_numero" disabled="disabled"></md-input-container>\n<md-input-container class="datepicker-custom" flex="20" md-delay="500"><label translate="LAUDO.SHIPPING_DATE">\nData de expedi\xE7\xE3o</label><md-datepicker name="data_expedicao" ng-model="vm.model.data_expedicao" \nmd-placeholder="Inserir data" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="50" md-delay="500"><label \ntranslate="LAUDO.CUSTOMER_NAME">Nome do cliente</label><input type="text" name="nome_cliente" \nplaceholder="Inserir nome do cliente" ng-model="vm.model.cliente_consumidor_nome" disabled="disabled">\n</md-input-container><md-input-container flex="50" md-delay="500"><label translate="LAUDO.EMAIL">E-mail</label><input \ntype="email" name="email" placeholder="Inserir e-mail" maxlength="60" \nng-pattern="/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/" \nng-model="vm.model.cliente_consumidor_email" required><div ng-messages="laudoForm.email.$error" \nng-if="laudoForm.email.$touched"><div ng-message="required">Campo Obrigat\xF3rio.</div><div ng-message="pattern">\nE-mail incorreto.</div><div ng-message="api_erro">{{laudoForm.email.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.CULTURE">Cultura</label><input type="text" name="cultura" \nplaceholder="Inserir cultura" ng-model="vm.model.cultura.nome" disabled="disabled"></md-input-container>\n<md-input-container flex="25" md-delay="500"><label translate="LAUDO.VARIETY">Variedade</label><input type="text" \nname="variedade" placeholder="Inserir variedade" ng-model="vm.model.produto_variedade" disabled="disabled">\n</md-input-container><md-input-container flex="25" md-delay="500"><label translate="LAUDO.CATEGORY">Categoria</label>\n<input type="text" name="nome_cliente" placeholder="Inserir categoria" ng-model="vm.model.categoria"><div \nng-messages="laudoForm.categoria.$error" ng-if="laudoForm.categoria.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.categoria.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15" md-delay="500"><label translate="LAUDO.AMOUNT">Quantidade</label>\n<input type="text" name="quantidade" ng-model="vm.model.quantidade" disabled="disabled"></md-input-container>\n<md-input-container flex="20" md-delay="500" ng-hide="vm.model.unidade_medida == \'Embalagem\'"><label \ntranslate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" name="quantidade" \nng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin ng-if="vm.model.unidade_medida == \'Embalagem\'"><md-input-container flex \nmd-delay="500"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" \nname="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input type="text" name="embalagem_tipo" \nng-model="vm.model.embalagem_tipo" disabled="disabled"></md-input-container><md-input-container flex md-delay="500">\n<label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input type="text" name="embalagem_peso" \nng-model="vm.model.embalagem_peso" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.SALES_DOCUMENT_NUMBER">N\xBA do documento de venda</label><input type="text" \nname="numero_documento_venda" placeholder="Inserir o n\xBA do documento de venda" \nng-model="vm.model.numero_documento_venda"></md-input-container><md-input-container flex="75" md-delay="500"><label \ntranslate="LAUDO.RESPONSIBLE">Respons\xE1vel</label><input type="text" name="responsavel" \nplaceholder="Inserir o respons\xE1vel" ng-model="vm.model.responsavel_nome" required><div \nng-messages="laudoForm.responsavel.$error" ng-if="laudoForm.responsavel.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.responsavel.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n class="select-custom" flex="40" md-delay="500"><label translate="LAUDO.CONCLUSION">Conclus\xE3o</label><input \ntype="text" name="laudo_conclusao_conformidade" \nng-model="vm.model.laudo_conclusao.laudo_conclusao_conformidade.descricao"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea ng-model="vm.model.laudo_conclusao.observacao" \nname="laudo_conclusao_observacao" rows="5"></textarea></md-input-container></div></md-card><md-card><h3>Avalia\xE7\xE3o</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30" md-delay="500"><label \ntranslate="LAUDO.BATCH_ID">ID do lote</label><input type="text" name="lote_id" \nng-model="vm.model.lote_distribuicao_venda_id"></md-input-container></div><hr class="divider"><div class="pesos" \nng-if="vm.model.unidade_medida == \'Kg\' || vm.model.unidade_medida == \'Embalagem\'"><h4>Pesos amostrados</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="peso in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Peso {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-model="peso.medida" ui-number-mask="3" \nmin="0.001" maxlength="15" required></md-input-container></div></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_WEIGHT">\nPeso total da amostra</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" \nui-number-mask="3" min="0.001" max="{{vm.model.quantidade}}"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" \nname="percentual_amostrado" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="vm.model.laudo_amostra.percentual_medida"></md-input-container><md-input-container flex md-delay="500"><label\n translate="LAUDO.AVERAGE_WEIGHT">Peso m\xE9dio</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="3" min="0.001" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_WEIGHT">Peso esperado</label><input \ntype="text" name="peso_amostra" placeholder="Inserir o peso esperado" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="3" min="0.001" maxlength="15"></md-input-container>\n</div></div><div class="quantidade" ng-if="vm.model.unidade_medida == \'Unidades\'"><h4>Quantidade amostradas</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="quantidade in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Quantidade {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-change="vm.calcLaudoAmostra()" \nng-model="quantidade.medida" ui-number-mask="0" min="0.1" maxlength="15" required></md-input-container></div></div><div\n layout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.SAMPLE_TOTAL_AMOUNT">Quantidade total da amostra</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="0" min="0" maxlength="15" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">\nPercentual amostrado</label><input type="text" name="percentual" ui-percentage-value maxlength="5" \nui-percentage-mask="0" min="0.1" max="100.0" ng-model="vm.model.laudo_amostra.percentual_medida" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.AVERAGE_AMOUNT">Quantidade m\xE9dia\n</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="0" \nmin="0" maxlength="15"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.EXPECTED_AMOUNT">Quantidade esperada</label><input type="text" name="peso_amostra" \nplaceholder="Inserir a quantidade" ng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="0" min="0" \nmaxlength="15" required></md-input-container></div></div><div class="defeitos"><h4>Defeitos</h4><div layout="column" \nlayout-gt-xs="row" layout-margin ng-repeat="defeito in vm.model.laudo_defeito"><md-input-container \nclass="select-custom" flex="50" md-delay="500"><label>Defeito {{ $index + 1 }}</label><input type="text" \nname="descricao" ng-model="defeito.descricao"></md-input-container><md-input-container flex="25" md-delay="500" \nng-if="defeito.laudo_defeito_tipo_id == 8"><label translate="LAUDO.OTHER">Outro</label><input type="text" \nname="defeito_outro" placeholder="Inserir defeito" ng-model="defeito.laudo_defeito_tipo_outro.descricao">\n</md-input-container><md-input-container class="select-custom" flex="25" md-delay="500"><label \ntranslate="LAUDO.CLASSIFICATION">Classifica\xE7\xE3o</label><input type="text" name="laudo_defeito_classificacao" \nng-model="defeito.laudo_defeito_classificacao.descricao"></md-input-container><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_OTHER">Porcentagem</label><input type="text" \nname="porcentagem_defeito" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="defeito.porcentagem"></md-input-container></div></div><hr class="divider"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.MATURATION">Matura\xE7\xE3o</label><input type="text" name="laudo_maturacao" \nng-model="vm.model.laudo_maturacao.descricao"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.APPEARANCE">Apar\xEAncia</label><input type="text" name="aparencia" ng-model="vm.model.aparencia">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.TEMPERATURE">Temperatura</label>\n<input type="text" name="laudo_maturacao" ng-model="vm.model.temperatura"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.CALIBER">Calibre</label><input type="text" name="laudo_calibre" \nng-model="vm.model.laudo_calibre.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.COLORING">Colora\xE7\xE3o</label><input type="text" name="laudo_coloracao" \nng-model="vm.model.laudo_coloracao.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.ODOR">Odor</label><input type="text" name="laudo_odor" \nng-model="vm.model.laudo_odor.descricao"></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.FLAVOR">Sabor\n</label><input type="text" name="laudo_sabor" ng-model="vm.model.laudo_sabor.descricao"></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.PRESSURE">Press\xE3o</label><input \ntype="text" name="laudo_pressao" ng-model="vm.model.laudo_pressao.descricao"></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.BRIX">Brix</label><input type="text" \nname="laudo_brix" ng-model="vm.model.laudo_brix.descricao"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.OBSERVATION">\nObserva\xE7\xE3o</label><textarea ng-model="vm.model.observacao" name="observacao" rows="5"></textarea></md-input-container>\n</div></md-card><md-card class="laudo-fotos"><h3 class="custom">Fotos</h3>`<div layout="row" layout-gt-xs="row" \nlayout-margin><div class="item" ng-repeat="imagem in vm.model.laudo_upload_file" flex="40"><div class="item-content">\n<div class="imagem" flex="30"><img class="thumbnail-description" ng-src="{{imagem.url}}"></div><div class="body" flex>\n<label>Descri\xE7\xE3o</label><textarea class="textarea-descricao" name="descricao" ng-model="imagem.descricao" cols="40" \nrows="3"></textarea></div></div></div></div></md-card></fieldset><div api-form-validation-summary form="laudoForm">\n</div></form></div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.comeBack()">\nVoltar</md-button></div></div></div></div>');
$templateCache.put('app/main/suporte/view/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="SUPORTE.NOVO_CHAMADO">Novo chamado</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="chamadoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 \ntranslate="SUPORTE.DADOS_ABERTURA">Dados para abertura do chamado</h3><div api-form-validation-summary \nform="chamadoForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="40"><label \ntranslate="SUPORTE.NAME_SUPORTE">Nome</label><input type="text" name="nome" placeholder="Insira o nome" required \nng-model="vm.model.nome"><div class="errors" ng-messages="chamadoForm.nome.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{chamadoForm.area.$api.error.message}}</div></div>\n</md-input-container><md-input-container class="select-custom" flex="20" md-delay="500"><label>Categoria</label>\n<md-select class="md-block color-black" name="categoria" placeholder="Selecione a categoria" \nng-model="vm.model.atendimento_suporte_motivo_contato_id" required><md-option ng-repeat="categoria in vm.categorias" \nng-value="categoria.id">{{categoria.descricao}}</md-option></md-select><div class="errors" \nng-messages="chamadoForm.categoria.$error" ng-if="chamadoForm.categoria.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{chamadoForm.categoria.$api.error.message}}</div></div>\n</md-input-container><md-input-container class="select-custom" flex md-delay="500"><label>Tipo*</label><div \nclass="container-period"><md-input-container class="radiobutton-custom" flex><md-radio-group \nng-model="vm.model.atendimento_suporte_tipo_id" required><md-radio-button ng-repeat="tipo in vm.tipos" \nng-value="tipo.id">{{tipo.descricao}}</md-radio-button></md-radio-group></md-input-container></div>\n</md-input-container></div></md-card><md-card><h3 translate="SUPORTE.ENVIAR_MENSAGEM">Enviar mensagem</h3><div \nlayout="column" layout-gt-xs="row" layout-margin class="space-between"><md-input-container class="datepicker-custom" \nflex="21"><label>Data</label><md-datepicker name="data_validade" ng-model="date" disabled="disabled" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container flex="70">\n<label>T\xEDtulo da mensagem</label><input type="text" name="titulo" required ng-model="vm.model.titulo"><div \nclass="errors" ng-messages="chamadoForm.titulo.$error" ng-if="chamadoForm.titulo.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{chamadoForm.titulo.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="SUPORTE.DESCREVER">Descrever mensagem</label><textarea name="descricao" ng-model="vm.model.descricao" \nplaceholder="Escreva sua mensagem que em breve iremos responder" required maxlength="500" rows="6"></textarea><div \nclass="errors" ng-messages="chamadoForm.descricao.$error" ng-if="chamadoForm.descricao.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">{{chamadoForm.descricao.$api.error.message}}\n</div></div></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button><md-button type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="chamadoForm.$invalid || chamadoForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Enviar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/suporte/view/view.html','<div class="container-header"><div class="breadcrumb"><h1 translate="SUPORTE.SUPORTE">Venda</h1></div><md-button \nclass="btn btn-primary btn-lg-i" ng-click="vm.gotoNovoChamado()">Novo chamado</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div><div\n class="form-search"><form><md-menu md-position-mode="left bottom"><md-menu md-position-mode="left bottom"><button \nng-click="$mdMenu.open()"><a class="button-filter"><i class="fas fa-filter"><md-tooltip hide-xs md-direction="right">\nFiltros</md-tooltip></i></a></button><md-menu-content menu-content class="content-filter" width="6"><md-menu-item \nclass="header-container dropdown-column"><div class="header-content"><p>Filtrar</p><a ng-click="$mdMenu.close()" \nclass="btn-close">X</a></div></md-menu-item><div class="main-container"><div class="main-content"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Tipo</label><select \nclass="md-block" name="area" ng-model="vm.args.Atendimento_Tipo"><option \nng-repeat="tipo in vm.models.atendimento_suporte_tipo" ng-value="tipo.id">{{tipo.tipo}}</option></select>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex><label>Categoria</label><select class="md-block" name="area" \nng-model="vm.args.Atendimento_Categoria"><option ng-repeat="tipo in vm.models.atendimento_suporte_categoria" \nng-value="tipo.id">{{tipo.categoria}}</option></select></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Status</label><select \nclass="md-block" name="area" ng-model="vm.args.Atendimento_Status"><option \nng-repeat="tipo in vm.models.atendimento_suporte_status" ng-value="tipo.id">{{tipo.status}}</option></select>\n</md-input-container></div><hr><h3>Outros per\xEDodos</h3><div layout="column" layout-gt-xs="column" layout-margin><div \nclass="align-datepicker"><md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label>\n<md-datepicker name="data_inicial" ng-model="vm.args.Data_De" md-max-date="vm.date" ng-change="$mdMenu.open()" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container \nclass="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.Data_Ate" md-max-date="vm.date" ng-change="$mdMenu.open()" md-open-on-focus \nng-disabled="vm.args.Data_De == null" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container></div></div><div class="content-buttons"><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar </a><a class="btn btn-quaternary" ng-click="vm.args._change()">Filtrar</a></div>\n</div></div></md-menu-content></md-menu></md-menu></form></div></div><div class="ms-responsive-table-wrapper"><div \nclass="content fullpage-simple" layout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom suporte"><thead><tr><th class="secondary-text pagination-custom" lm-sort-header="id" \nlm-title="ID"></th><th class="secondary-text pagination-custom" lm-sort-header="data_abertura" lm-title="Data"></th><th\n class="secondary-text pagination-custom" lm-sort-header="categoria" lm-title="Categoria"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="atendimento_tipo" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="titulo" lm-title="Titulo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="atendimento_status" lm-title="Status"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models.atendimento_suporte"><td>{{model.id}}</td><td>\n{{model.data_abertura | date:\'dd/MM/yyyy\'}}</td><td>{{model.categoria}}</td><td>{{model.tipo}}</td><td>{{model.titulo}}\n</td><td style="min-width: 150px;"><div class="icon-custom" ng-if="model.status == \'Enviado\'"><md-icon class="orange" \nmd-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">{{model.status}}</md-tooltip></md-icon><span>\n{{model.status}}</span></div><div class="icon-custom" ng-if="model.status == \'Em an\xE1lise\'"><md-icon \nclass="light-orange" md-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">{{model.status}}\n</md-tooltip></md-icon><span>{{model.status}}</span></div><div class="icon-custom" \nng-if="model.status == \'Respondido\'"><md-icon class="blue" md-font-icon="icon-brightness-1"><md-tooltip hide-xs \nmd-direction="top">{{model.status}}</md-tooltip></md-icon><span>{{model.status}}</span></div><div class="icon-custom" \nng-if="model.status == \'Finalizado\'"><md-icon class="enabled" md-font-icon="icon-brightness-1"><md-tooltip hide-xs \nmd-direction="top">{{model.status}}</md-tooltip></md-icon><span>{{model.status}}</span></div></td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-comment-dots"><md-tooltip hide-xs md-direction="right">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-if="model.status != \'Finalizado\'" ng-click="vm.encerrarConfirm(model)" \naria-label="Encerrar"><i class="far fa-times-circle"><md-tooltip hide-xs md-direction="right">Encerrar</md-tooltip></i>\n</md-button><md-button class="edit-button md-icon-button c-default" aria-label="Encerrar"><i \nclass="far fa-times-circle encerrar-disabled" ng-if="model.status == \'Finalizado\'"></i></md-button><br hide-xs></td>\n</tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div>\n</div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/suporte/view/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="SUPORTE.MENSAGEM">Mensagem</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-register"><form name="chamadoForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><div class="ms-responsive-table-wrapper"><div \nclass="content fullpage-simple" layout="column" flex><md-card><h3 translate="SUPORTE.INFOS_MENSAGEM">\nInforma\xE7\xF5es da mensagem</h3><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom my-data"><thead><tr><th class="pd-ajst bold">Nome</th><th class="pd-ajst bold">Categoria\n</th><th class="pd-ajst bold">Tipo</th><th class="pd-ajst bold minw-180">Status</th></tr></thead><tbody><tr><td \nclass="wsize-35 pd-ajst">{{vm.model.nome}}</td><td class="wsize-40 pd-ajst">\n{{vm.model.atendimento_suporte_motivo_contato.descricao}}</td><td class="wsize-40 pd-ajst">\n{{vm.model.atendimento_suporte_tipo.descricao}}</td><td class="wsize-30 pd-ajst"><div class="icon-custom" \nng-if="vm.model.atendimento_suporte_status.descricao == \'Enviado\'"><md-icon class="orange" \nmd-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">\n{{vm.model.atendimento_suporte_status.descricao}}</md-tooltip></md-icon><span>\n{{vm.model.atendimento_suporte_status.descricao}}</span></div><div class="icon-custom" \nng-if="vm.model.atendimento_suporte_status.descricao == \'Em an\xE1lise\'"><md-icon class="light-orange" \nmd-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">\n{{vm.model.atendimento_suporte_status.descricao}}</md-tooltip></md-icon><span>\n{{vm.model.atendimento_suporte_status.descricao}}</span></div><div class="icon-custom" \nng-if="vm.model.atendimento_suporte_status.descricao == \'Respondido\'"><md-icon class="blue" \nmd-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">\n{{vm.model.atendimento_suporte_status.descricao}}</md-tooltip></md-icon><span>\n{{vm.model.atendimento_suporte_status.descricao}}</span></div><div class="icon-custom" \nng-if="vm.model.atendimento_suporte_status.descricao == \'Finalizado\'"><md-icon class="enabled" \nmd-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">\n{{vm.model.atendimento_suporte_status.descricao}}</md-tooltip></md-icon><span>\n{{vm.model.atendimento_suporte_status.descricao}}</span></div></td></tr></tbody></table></md-card><div \nng-repeat="model in vm.model.atendimento_suporte_postagem"><md-card class="pb-1" ng-if="model.atendente_email == null">\n<div class="cursor-pointer space-between" ng-click="vm.openCollapse($index)"><h3 translate="SUPORTE.MENSAGEM_ENVIADA">\nMensagem enviada</h3><div><img src="../../../../assets/images/svg/seta.svg" class="arrow-up" \nid="arrow-collapse{{$index}}" alt=""></div></div><div class="content-collapse" id="Collapse{{$index}}"><div \nlayout="column" layout-gt-xs="row" layout-margin class="space-between"><md-input-container class="datepicker-custom" \nflex="21"><label>Data</label><md-datepicker name="data_validade" ng-model="model.data_criacao" disabled="disabled" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container flex="70">\n<label>T\xEDtulo da mensagem</label><input type="text" name="titulo" ng-model="vm.model.titulo" disabled="disabled">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin class="box-content-collapse">\n<md-input-container flex><label translate="SUPORTE.DESCREVER">Descrever mensagem</label><textarea name="descricao" \nclass="h-100" ng-model="model.descricao" placeholder="Escreva sua mensagem que em breve iremos responder" rows="6" \ndisabled="disabled"></textarea></md-input-container></div></div></md-card><md-card \nng-if="model.atendente_email != null"><div class="space-between"><h3 translate="SUPORTE.RESPOSTA">Resposta</h3><div \nclass="bold" ng-if="model.descricao != \'Enviado\'">\n{{model.data_criacao | date:\'dd/MM/yyyy\'}} \xE0s {{model.data_criacao | date:\'HH:mm\'}}</div></div><div \nclass="box-replace"><span class="pendente" ng-if="vm.model.atendimento_suporte_status.descricao == \'Enviado\'"><div>Ol\xE1,\n</div><div class="mt-10">Estamos avaliando sua mensagem, em breve iremos responder.</div></span><span \nng-if="vm.model.atendimento_suporte_status.descricao != \'Enviado\'"><b>Ol\xE1 {{vm.model.nome}},</b><div \nclass="replace-content">{{model.descricao}}</div><b>Equipe Eattae</b></span></div></md-card></div><md-card \nclass="pb-3" ng-if="vm.model.atendimento_suporte_status.descricao != \'Finalizado\'"><h3 \ntranslate="SUPORTE.MSG_SOLUCIONADA">Sua mensagem foi solucionada?</h3><div class="box-avalia\xE7\xE3o"><span class="confirm" \nng-click="vm.openResolved()"><img src="../../../../assets/images/svg/icone_sim.svg" alt=""> <span>Sim</span> </span>\n<span class="reject" ng-click="vm.openNotResolved()"><img src="../../../../assets/images/svg/icon_nao.svg" alt=""> \n<span>N\xE3o</span></span><div class="box-content-notresolved" id="notresolved"><p>\nPor favor, escreva como podemos ajudar para melhorar.</p><div layout="column" layout-gt-xs="row" layout-margin \nclass="ml-0"><md-input-container flex class="ml-0"><textarea name="replica" class="h-100" rows="6" \nng-model="vm.model.replica" required></textarea><div class="errors" ng-messages="chamadoForm.replica.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{chamadoForm.area.$api.error.message}}</div>\n</div></md-input-container></div></div><div class="box-content-resolved box-content-resolved-collapse" id="resolved">\n<p>Ficamos felizes que foi solucionado, por favor avalie nosso atendimento.</p><div class="ml-0 box-buttons-avaliable">\n<div ng-click="vm.encerrar(1)"><img src="../../../../assets/images/svg/ruim.svg" alt="Ruim"> <span class="red" \nvalue="ruim">Ruim</span></div><div ng-click="vm.encerrar(2)"><img src="../../../../assets/images/svg/bom.svg" \nalt="Bom"> <span class="yellow">Bom</span></div><div ng-click="vm.encerrar(3)"><img \nsrc="../../../../assets/images/svg/otimo.svg" alt="\xD3timo"> <span class="green">\xD3timo</span></div></div></div></div>\n</md-card></div></div></form></div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button><md-button type="button" id="save-btn" \nclass="btn btn-primary btn-lg d-none" aria-label="Submit" \nng-disabled="chamadoForm.$invalid || chamadoForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Enviar\n</md-button></div></div></div></div>');
$templateCache.put('app/core/directives/ms-navigation/templates/horizontal.html','<div class="navigation-toggle" hide-gt-sm><md-button class="md-icon-button" ng-click="vm.toggleHorizontalMobileMenu()" \naria-label="Toggle Mobile Navigation"><md-icon md-font-icon="icon-menu"></md-icon></md-button></div><ul \nclass="horizontal"><li ng-repeat="node in vm.navigation" ms-navigation-horizontal-node="node" \nng-class="{\'has-children\': vm.hasChildren}" ng-include="\'navigation-horizontal-nested.html\'"></li></ul><script \ntype="text/ng-template" id="navigation-horizontal-nested.html">\n<div ms-navigation-horizontal-item layout="row" ng-if="!vm.isHidden()">\n\n        <div class="ms-navigation-horizontal-button" ng-if="!node.uisref && node.title"\n             ng-class="{\'active md-accent-bg md-accent-fg\': vm.isActive}">\n            <i class="icon s18 {{node.icon}}" ng-if="node.icon"></i>\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\n            <span class="badge white-fg" style="background: {{node.badge.color}}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s18 arrow" ng-if="vm.hasChildren"></i>\n        </div>\n\n        <a class="ms-navigation-horizontal-button" ui-sref="{{node.uisref}}" ui-sref-active="active md-accent-bg"\n           ng-class="{\'active md-accent-bg md-accent-fg\': vm.isActive}"\n           ng-if="node.uisref && node.title">\n            <i class="icon s18 {{node.icon}}" ng-if="node.icon"></i>\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\n            <span class="badge white-fg" style="background: {{node.badge.color}}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s18 arrow" ng-if="vm.hasChildren"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if="vm.hasChildren && !vm.isHidden()">\n        <li ng-repeat="node in node.children" ms-navigation-horizontal-node="node"\n            ng-class="{\'has-children\': vm.hasChildren}"\n            ng-include="\'navigation-horizontal-nested.html\'"></li>\n    </ul>\n</script>');
$templateCache.put('app/core/directives/ms-navigation/templates/vertical.html','<ul><li ng-repeat="node in vm.navigation" class="ms-navigation-bottom" ms-navigation-node="node" \nng-class="{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}" ng-include="\'navigation-nested.html\'"></li></ul>\n<script type="text/ng-template" id="navigation-nested.html">\n<div ms-navigation-item layout="row" ng-if="!vm.isHidden()">\n\n        <div class="ms-navigation-button" ng-if="!node.uisref && node.title">\n            <i class="icon s16 {{node.icon}}" ng-if="node.icon"></i>\n            <img src="{{node.img}}" alt="" ng-if="node.img">\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\n            <span class="badge white-fg" ng-style="{\'background\': node.badge.color}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s16 arrow" ng-if="vm.collapsable && vm.hasChildren"></i>\n        </div>\n\n        <a class="ms-navigation-button" ui-sref="{{node.uisref}}" ui-sref-active="active md-accent-bg"\n           ng-if="node.uisref && node.title">\n            <i class="icon s16 {{node.icon}}" ng-if="node.icon"></i>\n            <img src="{{node.img}}" alt="" ng-if="node.img">\n            <span class="title" translate="{{node.translate}}" flex>{{node.title}}</span>\n            <span class="badge white-fg" ng-style="{\'background\': node.badge.color}" ng-if="node.badge">{{node.badge.content}}</span>\n            <i class="icon-chevron-right s16 arrow" ng-if="vm.collapsable && vm.hasChildren"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if="vm.hasChildren && !vm.isHidden()">\n        <li ng-repeat="node in node.children" ms-navigation-node="node"\n            ng-class="{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}"\n            ng-include="\'navigation-nested.html\'"></li>\n    </ul>\n</script>');
$templateCache.put('app/main/cadastros/cliente/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CLIENTE.CLIENTE">Cliente</h1></div><md-button \nclass="btn btn-primary btn-lg-i" translate="CLIENTE.ADD_CLIENTE" ng-click="vm.gotoAddClient()">Adicionar cliente\n</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="form-search-horizontal"><form><div class="container">\n<div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros\n</span></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Cliente</label><input \nid="cliente-filtro" class="mobile-text-center input-search" placeholder="Digite" ng-model="vm.args.nome">\n</md-input-container></div><div class="col"><md-input-container class="form-group select-custom" flex><label>CPF / CNPJ\n</label><input id="cnpj_cpf-filtro" class="mobile-text-center input-search" placeholder="Digite" \nng-model="vm.args.cnpj_cpf"></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Cidade - Estado</label><select class="md-block" name="cidade" \nng-model="vm.args.cidade"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="item in vm.models.cliente_endereco" ng-value="item.cidade_nome">{{item.cidade_nome}} - {{item.cidade_uf}}\n</option></select></md-input-container></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change();">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom cliente"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="nome" lm-title="Nome do cliente"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cnpj_cpf" lm-title="CPF/CNPJ"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cidade" lm-title="Cidade - Estado"></th><th class="secondary-text pagination-custom" \nlm-sort-header="email" lm-title="E-mail"></th><th class="secondary-text pagination-custom"><div class="table-header">\n<span class="actions column-title" translate="AREA.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat="clienteconsumidor in vm.models.cliente_consumidor"><td>{{clienteconsumidor.nome}}</td><td><span \nng-if="clienteconsumidor.cnpj_cpf.length == 11">{{clienteconsumidor.cnpj_cpf | brCpf}}</span> <span \nng-if="clienteconsumidor.cnpj_cpf.length == 14">{{clienteconsumidor.cnpj_cpf | brCnpj}}</span></td><td>\n{{clienteconsumidor.endereco.endereco_cidade_nome}} - {{clienteconsumidor.endereco.endereco_uf}}</td><td>\n{{clienteconsumidor.email}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoEditar(clienteconsumidor.id)" aria-label="Editar"><i class="fas fa-pen"><md-tooltip hide-xs \nmd-direction="left">Editar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(clienteconsumidor.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="top">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.deletarConfirm(clienteconsumidor)" aria-label="Apagar"><i class="far fa-trash-alt"><md-tooltip hide-xs \nmd-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table><lm-paginator lm-args="vm.args">\n</lm-paginator></div></div></div></div></div>');
$templateCache.put('app/main/cadastros/cliente/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CLIENTE.ADD_CLIENTE">Adicionar cliente</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="clienteForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 translate="CLIENTE.DADOS">\nDados do cliente</h3><div api-form-validation-summary form="clienteForm"></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="25" class="md-input-has-value"><label translate="NOVO.TYPE"></label>\n<md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required>\n<md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button>\n</md-radio-group><div ng-messages="clienteForm.pessoa_tipo.$error" ng-show="clienteForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.pessoa_tipo.$api.error.message}}\n</div></div></md-input-container><md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label \ntranslate="NOVO.NAME">Nome</label><input type="text" name="nome" ng-model="vm.model.nome" maxlength="50" required \nplaceholder="Insira o nome"><div class="errors" ng-messages="clienteForm.nome.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.nome.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex ng-if="vm.model.pessoa_tipo.id == 2"><label \ntranslate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" name="nome" ng-model="vm.model.nome" required \nplaceholder="Insira a raz\xE3o social"><div class="errors" ng-messages="clienteForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.nome.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CPF"><div class="errors" \nng-messages="clienteForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{clienteForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="25" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required placeholder="Insira o CNPJ"><div class="errors" \nng-messages="clienteForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{clienteForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="clienteForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{clienteForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="clienteForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.numero.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="NOVO.EMAIL">E-mail</label><input type="email" \nname="email" ng-model="vm.model.email" maxlength="100" placeholder="Insira o E-mail" \nng-pattern="/^[\\w-]+(\\.[\\w-]+)*@([a-z0-9-]+(\\.[a-z0-9-]+)*?\\.[a-z]{2,6}|(\\d{1,3}\\.){3}\\d{1,3})(:\\d{4})?$/" \nnoncapitalize><div class="errors" ng-messages="clienteForm.email.$error"><div ng-message="api_erro">\n{{clienteForm.email.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 translate="">\nEndere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20">\n<label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" \nrequired ui-br-cep-mask placeholder="Insira o CEP"><div class="errors" ng-messages="clienteForm.cep.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{clienteForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label translate="CLIENTE.CITY">Cidade</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" maxlength="50" required placeholder="Insira a cidade"><div \nclass="errors" ng-messages="clienteForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="10"><label translate="CLIENTE.UF">UF</label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required placeholder="UF"><div \nclass="errors" ng-messages="clienteForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{clienteForm.uf.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO">Bairro</label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" required \nplaceholder="Insira o bairro"><div class="errors" ng-messages="clienteForm.uf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.bairro.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><label translate="CLIENTE.RUA">CEP</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" maxlength="50" required placeholder="Insira o endere\xE7o"><div class="errors" \nng-messages="clienteForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="10"><label translate="CLIENTE.NUMERO">Numero</label><input type="text" name="numero" \nng-model="vm.model.endereco.endereco_numero" maxlength="5" required placeholder="N\xFAmero"><div class="errors" \nng-messages="clienteForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="20"><label translate="CLIENTE.COMPLEMENTO">Complemento</label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="clienteForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.complemento.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><md-checkbox \nname="comprador" ng-checked="checked" ng-model="vm.model.distribuidor"><span>Cadastrar distribuidor igual ao cliente\n</span></md-checkbox></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button><md-button \nclass="btn btn-primary btn-lg" ng-click="vm.save(vm.model)">Salvar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/cliente/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CLIENTE.EDIT">Editar cliente</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-register"><form name="clienteForm" novalidate="" \napi-form="vm.api_response_erro"><fieldset><md-card><h3 translate="CLIENTE.DADOS">Dados do cliente</h3><div \napi-form-validation-summary form="clienteForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="25" class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group \nmd-autofocus name="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" disabled="disabled"><md-radio-button \nvalue="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome\n</label><input type="text" name="nome" ng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome">\n<div class="errors" ng-messages="clienteForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="clienteForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.nome.$api.error.message}}</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="25" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF\n</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask \ndisabled="disabled"></md-input-container><md-input-container flex="25" ng-if="vm.model.pessoa_tipo.id == 2"><label \ntranslate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" \nui-br-cnpj-mask disabled="disabled"></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="clienteForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{clienteForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="clienteForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.numero.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="NOVO.EMAIL">E-mail</label><input type="email" \nname="email" ng-model="vm.model.email" maxlength="100" placeholder="Insira o E-mail" \nng-pattern="/^[\\w-]+(\\.[\\w-]+)*@([a-z0-9-]+(\\.[a-z0-9-]+)*?\\.[a-z]{2,6}|(\\d{1,3}\\.){3}\\d{1,3})(:\\d{4})?$/" \nnoncapitalize><div class="errors" ng-messages="clienteForm.email.$error"><div ng-message="api_erro">\n{{clienteForm.email.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 translate="">\nEndere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20">\n<label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" \nrequired ui-br-cep-mask placeholder="Insira o CEP"><div class="errors" ng-messages="clienteForm.cep.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{clienteForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label translate="CLIENTE.CITY">Cidade</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="clienteForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="10"><label translate="CLIENTE.UF">UF</label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div \nclass="errors" ng-messages="clienteForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{clienteForm.uf.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25" class="md-block"><label translate="CADASTRAIS.BAIRRO">Bairro</label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="clienteForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.bairro.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="CLIENTE.ENDERECO">Endere\xE7o</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="clienteForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="10"><label translate="CADASTRAIS.NUMERO">N\xFAmero</label><input type="text" name="numero" \nng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div class="errors" \nng-messages="clienteForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="20"><label translate="CLIENTE.COMPLEMENTO">Complemento</label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="clienteForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.complemento.$api.error.message}}</div></div></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.save(vm.model)">Alterar</md-button></div></form>\n</div></div></div></div>');
$templateCache.put('app/main/cadastros/cliente/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CLIENTE.VIEW">Visualizar cliente</h1></div></div>\n<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="content-register"><form name="clienteForm" novalidate="" \napi-form="vm.api_response_erro" disabled="disabled"><fieldset><md-card><h3 translate="CLIENTE.DADOS">Dados do cliente\n</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" class="md-input-has-value">\n<label translate="NOVO.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo" \nng-model="vm.model.pessoa_tipo.id" layout=" row" disabled="disabled"><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group></md-input-container>\n<md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input \ntype="text" name="nome" ng-model="vm.model.nome" maxlength="50" required></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="25" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF\n</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required>\n</md-input-container><md-input-container flex="25" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">\nCNPJ</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required>\n</md-input-container><md-input-container flex="5"><label translate="CADASTRAIS.DDD">DDD</label><input type="text" \nname="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" ng-pattern="/^[0-9]*$/" required></md-input-container>\n<md-input-container flex="15"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" \nng-model="vm.model.telefone.numero" mask="9?9999-9999" required></md-input-container><md-input-container flex><label \ntranslate="CADASTRAIS.EMAIL">E-mail</label><input type="text" name="email" ng-model="vm.model.email" maxlength="100">\n</md-input-container></div></md-card><md-card><h3 translate="">Endere\xE7o</h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP</label><input \ntype="text" name="cep" ng-model="vm.model.endereco.endereco_cep" required ui-br-cep-mask></md-input-container>\n<md-input-container class="md-block" flex><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Cidade" maxlength="50" required></md-input-container>\n<md-input-container flex="10"><input type="text" name="uf" ng-model="vm.model.endereco.endereco_uf" placeholder="UF" \nmaxlength="2" ng-pattern="/^[a-zA-Z]*$/" required></md-input-container><md-input-container flex="25" class="md-block">\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" placeholder="Bairro" \nrequired></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><input type="text" name="endereco" ng-model="vm.model.endereco.endereco_rua" \nplaceholder="Endere\xE7o" maxlength="50" required></md-input-container><md-input-container class="md-block" flex="10">\n<input type="text" name="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" \nrequired></md-input-container><md-input-container class="md-block" flex="20"><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Complemento"></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/fornecedor/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="FORNECEDOR.FORNECEDOR">Fornecedor</h1></div>\n<md-button class="btn btn-primary btn-lg-i" ng-click="vm.gotoAddClient()">Adicionar fornecedor</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label>Fornecedor</label><input \nid="fornecedor-filtro" class="mobile-text-center input-search" placeholder="Digite" ng-model="vm.args.nome">\n</md-input-container></div><div class="col"><md-input-container class="form-group select-custom" flex><label>CPF / CNPJ\n</label><input id="cnpj_cpf-filtro" class="mobile-text-center input-search" placeholder="Digite" \nng-model="vm.args.cnpj_cpf"></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Cidade - Estado</label><select class="md-block" name="cidade" \nng-model="vm.args.cidade"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="item in vm.models.fornecedor_endereco" ng-value="item.cidade_nome">{{item.cidade_nome}} - {{item.cidade_uf}}\n</option></select></md-input-container></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change();">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom fornecedor"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="nome" lm-title="Nome do fornecedor"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cnpj_cpf" lm-title="CPF/CNPJ"></th><th class="secondary-text pagination-custom" \nlm-sort-header="telefone" lm-title="Telefone"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cidade" lm-title="Cidade - Estado"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title" translate="AREA.ACTIONS">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat="clientefornecedor in vm.models.cliente_fornecedor"><td>{{clientefornecedor.nome}} <img \nng-if="clientefornecedor.cliente_eattae" src="../assets/images/svg/ico-cliente-eattae-verificado.svg" \ntitle="Fornecedor Eattae"></td><td><span ng-if="clientefornecedor.cnpj_cpf.length == 11">\n{{clientefornecedor.cnpj_cpf | brCpf}}</span> <span ng-if="clientefornecedor.cnpj_cpf.length == 14">\n{{clientefornecedor.cnpj_cpf | brCnpj}}</span></td><td>({{clientefornecedor.ddd}}) {{clientefornecedor.numero}}</td>\n<td>{{clientefornecedor.endereco_cidade_nome}} - {{clientefornecedor.endereco_uf}}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoEditar(clientefornecedor.id)" aria-label="Editar"><i \nclass="fas fa-pen"><md-tooltip hide-xs md-direction="left">Editar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(clientefornecedor.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="top">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(clientefornecedor)" aria-label="Apagar"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div></div></div>');
$templateCache.put('app/main/cadastros/fornecedor/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="FORNECEDOR.ADD">Adicionar fornecedor</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="fornecedorForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset ng-disabled="$rootScope.loadingProgress">\n<md-card><h3 translate="FORNECEDOR.DADOS">Dados do fornecedor</h3><div api-form-validation-summary \nform="fornecedorForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo" \nng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica</md-radio-button>\n<md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="fornecedorForm.pessoa_tipo.$error" ng-show="fornecedorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CPF" \nng-change="vm.changeCnpjCpf()"><div class="errors" ng-messages="fornecedorForm.cnpj_cpf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div\n ng-message="api_erro">{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required \nplaceholder="Insira o CNPJ" ng-change="vm.changeCnpjCpf()"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="fornecedorForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}\n</div></div></md-input-container></div></md-card><md-card><h3 translate="">Endere\xE7o</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP\n</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" required ui-br-cep-mask \nplaceholder="Insira o CEP"><div class="errors" ng-messages="fornecedorForm.cep.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label translate="CLIENTE.CITY"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div \nclass="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="fornecedorForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="FORNECEDOR.STREET"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container></div>\n</md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.save(vm.model)">\nSalvar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/fornecedor/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="FORNECEDOR.EDIT">Editar fornecedor</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="fornecedorForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 translate="FORNECEDOR.DADOS">\nDados do distribuidor</h3><div api-form-validation-summary form="fornecedorForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label>\n<md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.tipo_pessoa_id" layout=" row" disabled="disabled">\n<md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button>\n</md-radio-group></md-input-container><md-input-container flex="15" ng-if="vm.model.tipo_pessoa_id == 1"><label \ntranslate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" \nui-br-cpf-mask disabled="disabled"></md-input-container><md-input-container flex="15" \nng-if="vm.model.tipo_pessoa_id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask disabled="disabled"></md-input-container>\n<md-input-container flex ng-if="vm.model.tipo_pessoa_id == 1"><label translate="NOVO.NAME">Nome</label><input \ntype="text" name="nome" ng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div \nclass="errors" ng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex ng-if="vm.model.tipo_pessoa_id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input \ntype="text" name="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="telefone" ng-model="vm.model.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="fornecedorForm.telefone.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.telefone.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 \ntranslate="">Endere\xE7or</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex="20"><label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco_cep" \nrequired ui-br-cep-mask placeholder="Insira o cCEP"><div class="errors" ng-messages="fornecedorForm.cep.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label translate="CLIENTE.CITY"></label><input type="text" name="cidade" \nng-model="vm.model.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.cidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.cidade.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" ng-model="vm.model.endereco_uf" \nplaceholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div class="errors" \nng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label><input \ntype="text" name="bairro" ng-model="vm.model.endereco_bairro" maxlength="30" placeholder="Insira o bairro" required>\n<div class="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><label \ntranslate="CLIENTE.ENDERECO"></label><input type="text" name="endereco" ng-model="vm.model.endereco_rua" \nplaceholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div class="errors" \nng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" name="complemento" \nng-model="vm.model.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container></div>\n</md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.save(vm.model)">\nAlterar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/fornecedor/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="FORNECEDOR.VIEW">Visualizar fornecedor</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="fornecedorForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset ng-disabled="true"><md-card><h3 \ntranslate="FORNECEDOR.DADOS">Dados do distribuidor</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.tipo_pessoa_id" layout=" row" disabled="disabled"><md-radio-button value="1">\nF\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.tipo_pessoa_id == 1"><label translate="NOVO.CPF">CPF</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.tipo_pessoa_id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required></md-input-container>\n<md-input-container flex ng-if="vm.model.tipo_pessoa_id == 1"><label translate="NOVO.NAME">Nome</label><input \ntype="text" name="nome" ng-model="vm.model.nome" maxlength="50" required></md-input-container><md-input-container flex \nng-if="vm.model.tipo_pessoa_id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.numero" \nmask="9?9999-9999" required></md-input-container></div></md-card><md-card><h3 translate="">Endere\xE7o</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20"><label \ntranslate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco_cep" required \nui-br-cep-mask></md-input-container><md-input-container class="md-block" flex><input type="text" name="endereco" \nng-model="vm.model.endereco_cidade_nome" placeholder="Cidade" maxlength="50" required></md-input-container>\n<md-input-container flex="10"><input type="text" name="uf" ng-model="vm.model.endereco_uf" placeholder="UF" \nmaxlength="2" ng-pattern="/^[a-zA-Z]*$/" required></md-input-container><md-input-container flex="25" class="md-block">\n<input type="text" name="bairro" ng-model="vm.model.endereco_bairro" maxlength="30" placeholder="Bairro" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><input type="text" name="endereco" ng-model="vm.model.endereco_rua" placeholder="Endere\xE7o" maxlength="50" \nrequired></md-input-container><md-input-container class="md-block" flex="10"><input type="text" name="numero" \nng-model="vm.model.endereco_numero" placeholder="N\xFAmero" maxlength="5" required></md-input-container>\n<md-input-container class="md-block" flex="20"><input type="text" name="complemento" \nng-model="vm.model.endereco_complemento" placeholder="Complemento"></md-input-container></div></md-card></fieldset><div\n class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button>\n</div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/distribuidor/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DISTRIBUIDOR.DISTRIBUIDOR">Distribuidor</h1></div>\n<md-button class="btn btn-primary btn-lg-i" ng-click="vm.gotoAddClient()">Adicionar distribuidor</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label>Distribuidor</label><input \nid="distribuidor-filtro" class="mobile-text-center input-search" placeholder="Digite" ng-model="vm.args.nome">\n</md-input-container></div><div class="col"><md-input-container class="form-group select-custom" flex><label>CPF / CNPJ\n</label><input id="cnpj_cpf-filtro" class="mobile-text-center input-search" placeholder="Digite" \nng-model="vm.args.cnpj_cpf"></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Cidade - Estado</label><select class="md-block" name="cidade" \nng-model="vm.args.cidade"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="item in vm.models.distribuidor_endereco" ng-value="item.cidade_nome">\n{{item.cidade_nome}} - {{item.cidade_uf}}</option></select></md-input-container></div><div class="col"><div \nclass="content-buttons"><md-button class="btn btn-tertiary btn-md-i" ng-click="vm.args._change();">Filtrar</md-button>\n<a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div \nclass="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom distribuidor"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="nome" lm-title="Nome do distribuidor"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cnpj_cpf" lm-title="CPF/CNPJ"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cidade" lm-title="Cidade - Estado"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title" translate="AREA.ACTIONS">Actions</span></div></th></tr></thead>\n<tbody><tr ng-repeat="clienteconsumidor in vm.models.cliente_distribuidor"><td>{{clienteconsumidor.nome}}</td><td><span\n ng-if="clienteconsumidor.cnpj_cpf.length == 11">{{clienteconsumidor.cnpj_cpf | brCpf}}</span> <span \nng-if="clienteconsumidor.cnpj_cpf.length == 14">{{clienteconsumidor.cnpj_cpf | brCnpj}}</span></td><td>\n{{clienteconsumidor.endereco.endereco_cidade_nome}} - {{clienteconsumidor.endereco.endereco_uf}}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoEditar(clienteconsumidor.id)" aria-label="Editar"><i \nclass="fas fa-pen"><md-tooltip hide-xs md-direction="left">Editar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(clienteconsumidor.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="top">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(clienteconsumidor)" aria-label="Apagar"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div></div></div>');
$templateCache.put('app/main/cadastros/distribuidor/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DISTRIBUIDOR.ADD">Adicionar distribuidor</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="distribuidorForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 \ntranslate="DISTRIBUIDOR.DADOS">Dados do distribuidor</h3><div api-form-validation-summary form="distribuidorForm">\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><label \ntranslate="NOVO.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" \nlayout=" row" required><md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica\n</md-radio-button></md-radio-group><div ng-messages="distribuidorForm.pessoa_tipo.$error" \nng-show="distribuidorForm.pessoa_tipo.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="CLIENTE.CPF">CPF</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required \nplaceholder="Insira o CPF"><div class="errors" ng-messages="distribuidorForm.cnpj_cpf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div\n ng-message="api_erro">{{distribuidorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.CNPJ">CNPJ</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required \nplaceholder="Insira o CNPJ"><div class="errors" ng-messages="distribuidorForm.cnpj_cpf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div\n ng-message="api_erro">{{distribuidorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="CLIENTE.NAME">Nome</label><input \ntype="text" name="nome" ng-model="vm.model.nome" maxlength="25" required placeholder="Insira o nome"><div \nclass="errors" ng-messages="distribuidorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex ng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input \ntype="text" name="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="distribuidorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="5"><label translate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" \nmaxlength="2" ng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" \nng-messages="distribuidorForm.ddd.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente n\xFAmeros</div><div ng-message="api_erro">{{distribuidorForm.ddd.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input \ntype="text" name="numero" ng-model="vm.model.telefone.numero" mask="9?9999-9999" required placeholder="Telefone"><div \nclass="errors" ng-messages="distribuidorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.numero.$api.error.message}}</div></div></md-input-container></div></md-card>\n<md-card><h3 translate="">Endere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.CEP"></label><input type="text" placeholder="Insira o CEP" \nui-br-cep-mask name="cep" ng-model="vm.model.endereco.endereco_cep" required><div class="errors" \nng-messages="distribuidorForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{distribuidorForm.cep.$api.error.message}}</div></div>\n<md-progress-circular ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular>\n</md-input-container><md-input-container class="md-block" flex><label translate="CLIENTE.CITY"></label><input \ntype="text" name="cidade" ng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" \nmaxlength="50" required><div class="errors" ng-messages="distribuidorForm.cidade.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{distribuidorForm.cidade.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" ng-pattern="/^[a-zA-Z]*$/" maxlength="2" required><div \nclass="errors" ng-messages="distribuidorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{distribuidorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" placeholder="Insira o bairro" \nmaxlength="30" required><div class="errors" ng-messages="distribuidorForm.bairro.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{distribuidorForm.bairro.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><label translate="CLIENTE.RUA"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="distribuidorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="distribuidorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.numero.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" \nname="complemento" ng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div \nclass="errors" ng-messages="distribuidorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{distribuidorForm.complemento.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><md-checkbox \nname="comprador" ng-checked="checked" ng-model="vm.model.distribuidor"><span>Cadastrar cliente igual ao distribuidor\n</span></md-checkbox></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button><md-button \nclass="btn btn-primary btn-lg" ng-click="vm.save(vm.model)">Salvar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/distribuidor/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DISTRIBUIDOR.EDIT">Editar distribuidor</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="distribuidorForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 \ntranslate="DISTRIBUIDOR.DADOS">Dados do distribuidor</h3><div api-form-validation-summary form="distribuidorForm">\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><label \ntranslate="NOVO.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" \nlayout=" row" disabled="disabled"><md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">\nJur\xEDdica</md-radio-button></md-radio-group></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask disabled="disabled"></md-input-container><md-input-container\n flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask disabled="disabled"></md-input-container>\n<md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input \ntype="text" name="nome" ng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div \nclass="errors" ng-messages="distribuidorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex ng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input \ntype="text" name="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="distribuidorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="5"><label translate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" \nmaxlength="2" ng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" \nng-messages="distribuidorForm.ddd.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente n\xFAmeros</div><div ng-message="api_erro">{{distribuidorForm.ddd.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input \ntype="text" name="telefone" ng-model="vm.model.telefone.numero" mask="9?9999-9999" required placeholder="N\xFAmero"><div \nclass="errors" ng-messages="distribuidorForm.telefone.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.telefone.$api.error.message}}</div></div></md-input-container></div></md-card>\n<md-card><h3 translate="">Endere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.CEP"></label><input type="text" placeholder="Insira o CEP" \nui-br-cep-mask name="cep" ng-model="vm.model.endereco.endereco_cep" required><div class="errors" \nng-messages="distribuidorForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{distribuidorForm.cep.$api.error.message}}</div></div>\n<md-progress-circular ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular>\n</md-input-container><md-input-container class="md-block" flex><label translate="CLIENTE.CITY"></label><input \ntype="text" name="cidade" ng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" \nmaxlength="50" required><div class="errors" ng-messages="distribuidorForm.cidade.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{distribuidorForm.cidade.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" ng-pattern="/^[a-zA-Z]*$/" maxlength="2" required><div \nclass="errors" ng-messages="distribuidorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{distribuidorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" placeholder="Insira o bairro" \nmaxlength="30" required><div class="errors" ng-messages="distribuidorForm.bairro.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{distribuidorForm.bairro.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><label translate="CLIENTE.ENDERECO"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="distribuidorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="distribuidorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.numero.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" \nname="complemento" ng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div \nclass="errors" ng-messages="distribuidorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{distribuidorForm.complemento.$api.error.message}}</div></div></md-input-container></div>\n</md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.save(vm.model)">\nAlterar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/distribuidor/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DISTRIBUIDOR.VIEW">Visualizar distribuidor</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="distribuidorForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset ng-disabled="true"><md-card><h3 \ntranslate="DISTRIBUIDOR.DADOS">Dados do distribuidor</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-disabled="true" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button \nvalue="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group>\n</md-input-container><md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF\n</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required>\n</md-input-container><md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">\nCNPJ</label><input type="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required>\n</md-input-container><md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome\n</label><input type="text" name="nome" ng-model="vm.model.nome" required></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nrequired></md-input-container><md-input-container flex="10"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label>\n<input type="text" name="numero" ng-model="vm.model.telefone.numero" mask="9?9999-9999" required></md-input-container>\n</div></md-card><md-card><h3 translate="">Endere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-block" flex="20"><input type="text" placeholder="CEP" ui-br-cep-mask name="cep" \nng-model="vm.model.endereco.endereco_cep"></md-input-container><md-input-container class="md-block" flex><input \ntype="text" name="endereco" ng-model="vm.model.endereco.endereco_cidade_nome" ng-disabled="true" placeholder="Cidade" \nmaxlength="50" required></md-input-container><md-input-container flex="10"><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" ng-disabled="true" required></md-input-container>\n<md-input-container flex="25" class="md-block"><input type="text" name="numero" \nng-model="vm.model.endereco.endereco_bairro" ng-disabled="true" placeholder="Bairro" maxlength="30" required>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><input type="text" name="endereco" ng-model="vm.model.endereco.endereco_rua" ng-disabled="true" \nplaceholder="Endere\xE7o" maxlength="50" required></md-input-container><md-input-container class="md-block" flex="10">\n<input type="text" name="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" \nrequired></md-input-container><md-input-container class="md-block" flex="20"><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Complemento"></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/cadastros/maquina/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="MAQUINA.MAQUINA">M\xE1quina</h1></div><md-button \nclass="btn btn-primary btn-lg-i" ng-click="vm.gotoAddClient()">Adicionar Equipamento</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label>Nome</label><input id="maquina-filtro" \nclass="mobile-text-center input-search" placeholder="Digite" ng-model="vm.args.nome"></md-input-container></div><div \nclass="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" ng-click="vm.args._change();">\nFiltrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form>\n</div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>\n{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" \nng-if="filter.description">{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" \ntitle="Remover">X</a></li></ul></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" \nlayout="column" flex><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom maquina"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="nome" lm-title="Nome"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cpf/cnpj" lm-title="Valor/hora"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="AREA.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="maquina in vm.models"><td>\n{{ maquina.nome }}</td><td>R$ {{ maquina.valor_hora | finance:false:2 }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(maquina)" aria-label="Apagar"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div></div></div>');
$templateCache.put('app/main/cadastros/maquina/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="MAQUINA.ADD">Adicionar m\xE1quina</h1></div></div>\n<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="content-register"><form name="maquinaForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 translate="MAQUINA.DADOS">Dados da m\xE1quina</h3><div \napi-form-validation-summary form="maquinaForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-block" flex><label>Tipo m\xE1quina</label><input type="text" name="tipo_maquina" \nng-model="vm.model.nome" placeholder="Insira o tipo de m\xE1quina" maxlength="50" required><div class="errors" \nng-messages="maquinaForm.tipo_maquina.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{maquinaForm.tipo_maquina.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex><label>Valor hora</label><input type="text" name="valor" \nng-model="vm.model.valor_hora" placeholder="Insira o valor hora" maxlength="11" ui-money-mask required><div \nclass="errors" ng-messages="maquinaForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{maquinaForm.valor.$api.error.message}}</div></div></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.save(vm.model)" \nng-disabled="maquinaForm.$invalid || maquinaForm.$pristine || loadingProgress">Salvar</md-button></div></form></div>\n</div></div></div>');
$templateCache.put('app/main/cadastros/profissional/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PROFISSIONAL.PROFISSIONAL">Profissional</h1></div>\n<md-button class="btn btn-primary btn-lg-i" ng-click="vm.gotoAddClient()">Adicionar profissional</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label>Nome</label><input \nid="profissional-filtro" class="mobile-text-center input-search" placeholder="Digite" ng-model="vm.args.nome">\n</md-input-container></div><div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change();">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom profissional"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="nome" lm-title="Nome"></th><th class="secondary-text pagination-custom" lm-sort-header="valor_hora" \nlm-title="Valor/hora"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">A\xE7\xE3o</span></div></th></tr></thead><tbody><tr ng-repeat="profissional in vm.models"><td>\n{{ profissional.nome }}</td><td>R$ {{ profissional.valor_hora | finance:false:2 }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(profissional)" aria-label="Apagar"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div></div></div>');
$templateCache.put('app/main/cadastros/profissional/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PROFISSIONAL.ADD">Adicionar profissional</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="profissionalForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 \ntranslate="PROFISSIONAL.DADOS">Dados do profissional</h3><div api-form-validation-summary form="profissionalForm">\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><label>\nTipo profissinal</label><input type="text" name="tipo_profissional" ng-model="vm.model.nome" \nplaceholder="Insira o profissional" maxlength="50" required><div class="errors" \nng-messages="profissionalForm.tipo_profissional.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{profissionalForm.tipo_profissional.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex><label>Valor hora</label><input type="text" name="valor" \nng-model="vm.model.valor_hora" placeholder="Insira o valor hora" maxlength="11" ui-money-mask required><div \nclass="errors" ng-messages="profissionalForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{profissionalForm.valor.$api.error.message}}</div></div></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button><md-button class="btn btn-primary btn-lg" ng-click="vm.save(vm.model)" \nng-disabled="profissionalForm.$invalid || profissionalForm.$pristine || loadingProgress">Salvar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/compras/lotes_comprados/views/buscar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="LOTES_COMPRADOS.LOTES_COMPRADOS">\nLotes comprados</h1></div><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div><div \nclass="form-search"><form><md-menu md-position-mode="left bottom"><button ng-click="$mdMenu.open()"><a \nclass="button-filter"><i class="fas fa-filter"><md-tooltip hide-xs md-direction="right">Filtros</md-tooltip></i></a>\n</button><md-menu-content menu-content class="content-filter" width="6"><md-menu-item \nclass="header-container dropdown-column"><div class="header-content"><p>Filtrar</p><a ng-click="$mdMenu.close()" \nclass="btn-close">X</a></div></md-menu-item><div class="main-container"><div class="main-content"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Fornecedor</label><select \nclass="md-block" name="area" ng-model="vm.args.fornecedor_Id"><option ng-repeat="fornecedor in vm.models.fornecedores" \nng-value="fornecedor.id">{{fornecedor.nome}}</option></select></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Cidade/Estado</label><select \nclass="md-block" name="Cidade" ng-model="vm.args.cidade"><option ng-repeat="cidade_estado in vm.models.cidade_estados" \nplaceholder="Selecione a cidade" ng-value="cidade_estado.cidade">{{cidade_estado.cidade}} - {{cidade_estado.estado}}\n</option></select></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><div \nclass="filter-date"><md-input-container flex="60"><label translate="LOTES_COMPRADOS.VALOR_DE">Valor de</label><input \ntype="text" name="preco" class="mr-2" ng-model="vm.args.valor_De" ui-money-mask placeholder="Insira o valor">\n</md-input-container><md-input-container flex="60"><label translate="LOTES_COMPRADOS.VALOR_ATE">Valor at\xE9</label><input\n type="text" name="preco" ng-model="vm.args.valor_Ate" ui-money-mask placeholder="Insira o valor"></md-input-container>\n</div></div><hr><h3>Data da compra</h3><div layout="column" layout-gt-xs="column" layout-margin><div \nclass="align-datepicker"><md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label>\n<md-datepicker name="data_inicial" ng-model="vm.args.data_Inicial" md-max-date="vm.args.data_Final" \nng-change="$mdMenu.open()" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_Final" md-min-date="vm.args.data_Inicial" ng-change="$mdMenu.open()" md-open-on-focus \nng-disabled="vm.args.data_Inicial == null" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container></div></div><div class="content-buttons"><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar </a><a class="btn btn-quaternary" \nng-click="vm.resetPagination(); vm.args._change()">Filtrar</a></div></div></div></md-menu-content></md-menu></form>\n</div></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom lotes-comprados"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="lote_numero" lm-title="C\xF3digo rastreamento"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_expedicao" lm-title="Data"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cliente_fornecedor_nome" lm-title="Fornecedor - CPF/CNPJ">\n</th><th class="secondary-text pagination-custom" lm-sort-header="cultura" lm-title="Cultura"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="variedade" lm-title="Variedade"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nQuantidade/Unid. de medida</span></div></th><th class="secondary-text pagination-custom" lm-sort-header="valor" \nlm-title="Valor"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr \nng-repeat="model in vm.models.lote_distribuicao_venda"><td>{{model.lote_numero}}</td><td>\n{{model.data_inclusao | date:\'dd/MM/yyyy\'}}</td><td class="cursor-pointer" \nng-click="vm.showDialogFornecedor($event,model)"><span ng-if="model.fornecedor_cnpj_cpf.length == 11" \nclass="underline">{{model.fornecedor_nome}} - {{model.fornecedor_cnpj_cpf | brCpf}}</span> <span \nng-if="model.fornecedor_cnpj_cpf.length == 14" class="underline">\n{{model.fornecedor_nome}} - {{model.fornecedor_cnpj_cpf | brCnpj}}</span></td><td>{{model.cultura}}</td><td>\n{{model.variedade}}</td><td ng-if="model.unidade_medida != \'Embalagem\'">{{model.quantidade}} {{model.unidade_medida}}\n</td><td ng-if="model.unidade_medida == \'Embalagem\'">\n{{model.quantidade}} {{model.embalagem_tipo}} de {{model.embalagem_peso}}kg</td><td>\nR$ {{model.valor | finance:false:2}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(model.lote_distribuicao_id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip \nhide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoPrint(model)" aria-label="Visualizar"><i class="fas fa-print"><md-tooltip hide-xs \nmd-direction="right">Imprimir</md-tooltip></i></md-button></td></tr></tbody></table><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator lm-args="vm.args">\n</lm-paginator></div></div></div>');
$templateCache.put('app/main/compras/lotes_comprados/views/print-label.html','<md-dialog class="modal-custom-register print dialog-label" aria-label="liberar"><form ng-cloak name="imprimirForm" \nnovalidate="" api-form="api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>\n{{\'LOTE.ETIQUETA\' | translate }}</h2><md-button class="md-icon-button close-modal" ng-click="cancelar()">X</md-button>\n</div></md-toolbar><md-dialog-content><div class="md-dialog-content"><div api-form-validation-summary \nform="imprimirForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex><label>Tamanho</label><md-select class="md-block" name="tamanho_etiquetas" \nng-model="model.tamanho_etiquetas"><md-option ng-repeat="tamanho_etiqueta in tamanho_etiquetas" \nng-value="tamanho_etiqueta">{{tamanho_etiqueta.tamanho}}</md-option></md-select><div class="errors" \nng-messages="imprimirForm.tamanho_etiquetas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{imprimirForm.tamanho_etiquetas.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex \nng-hide="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3 || model.tamanho_etiquetas.id == 4 || model.tamanho_etiquetas.id == 5">\n<label>Tipo</label><md-select class="md-block" name="tipo_etiquetas" ng-model="model.tipo_etiquetas"><md-option \nng-repeat="tipo_etiqueta in tipo_etiquetas" ng-value="tipo_etiqueta">{{tipo_etiqueta.tipo}}</md-option></md-select><div\n class="errors" ng-messages="imprimirForm.tipo_etiquetas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{imprimirForm.tipo_etiquetas.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex \nng-show="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3 || model.tamanho_etiquetas.id == 4 || model.tamanho_etiquetas.id == 5">\n<label>Tipo</label><input type="text" name="quantidade" ng-model="rolo" disabled="disabled"></md-input-container>\n<md-input-container flex \nng-hide="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3 || model.tamanho_etiquetas.id == 4 || model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2 || model.tamanho_etiquetas.id == 5">\n<label>Quantidade</label><input type="text" \nng-disabled="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2" name="quantidade" \nng-model="model.quantidade_etiquetas" maxlength="4" ui-number-mask="0" min="0" max="70" required><div class="errors" \nng-messages="imprimirForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="min">Deve ser maior que 0</div><div ng-message="max">\nS\xF3 podem ser impressas 70 etiquetas por vez</div><div ng-message="api_erro">\n{{imprimirForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex \nng-show="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2"><label>\nColunas</label><md-select class="md-block" name="colunas" ng-model="model.colunas"><md-option \nng-repeat="coluna in colunas" ng-value="coluna">{{coluna.tipo}}</md-option></md-select><div class="errors" \nng-messages="imprimirForm.colunas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{imprimirForm.colunas.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-show="model.tamanho_etiquetas.id == 3"><label>Coluna</label><input type="text" name="coluna" ng-model="coluna" \ndisabled="disabled"></md-input-container><md-input-container flex ng-show="model.tamanho_etiquetas.id == 4"><label>\nColuna</label><input type="text" name="coluna" ng-model="coluna_unity" disabled="disabled"></md-input-container>\n<md-input-container flex ng-show="model.tamanho_etiquetas.id == 5"><label>Coluna</label><input type="text" \nname="coluna" ng-model="coluna_3" disabled="disabled"></md-input-container><md-input-container \nclass="datepicker-custom"><label>Data de validade</label><md-datepicker name="data_validade" \nng-model="vm.model.data_validade" md-max-date="vm.date" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container><md-input-container flex class="md-input-has-value" \nng-hide="model.distribuidor_nome == \'null\' || model.tamanho_etiquetas.id == 5"><md-checkbox class="distribuidor" \nname="comprador" ng-checked="checked" ng-model="vm.model.distribuidor" ng-disabled="model.tamanho_etiquetas.id == 4">\n<span>Incluir distribuidor</span></md-checkbox></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin layout-align="center" ng-if="model.tamanho_etiquetas.id == 1"><div id="imprimirdezporcincoa4" \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 1"><div id="printLabel" class="label"><div \nclass="dados-etiqueta"><strong>{{model.nome_produtor}} </strong><strong ng-if="model.nome_produtor == \'\' ">\n{{model.nome_clientePerfil}}</strong><p ng-if="model.cnpj_cpf.length == 11">CPF: {{model.cnpj_cpf | brCpf}}</p><p \nng-if="model.cnpj_cpf.length == 14">CNPJ: {{model.cnpj_cpf | brCnpj}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11 && model.cnpj_cpf == \'\' ">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14 && model.cnpj_cpf == \'\'">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>C\xF3digo de rastreamento:{{model.lote_numero}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong class="infos-center">\n{{model.produto_nome}} - {{model.produto_variedade}} - {{model.quantidade}} <span class="lowercase" \nng-if="model.unidade_medida != \'Embalagem\'">{{model.unidade_medida}}</span> <span class="lowercase" \nng-if="model.unidade_medida == \'Embalagem\'">{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg\n</span></strong></div><div class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">\nDistribuidor: {{model.distribuidor_nome}}<br>CPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div \nclass="midia-etiqueta"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" \nimage="true"></qr></div><div class="compartveg-logo"><img src="../assets/images/logos/eattae_monocromatico.svg"></div>\n</div></div></div><div id="printThis" ng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 1"></div>\n<div id="imprimirdezporcincorolo" ng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 1" \nng-hide="model.tipo_etiquetas.id == 1"><div id="printLabel" class="label"><div class="dados-etiqueta"><strong>\n{{model.nome_produtor}} </strong><strong ng-if="model.nome_produtor == \'\' ">{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf.length == 11">CPF: {{model.cnpj_cpf | brCpf}}</p><p ng-if="model.cnpj_cpf.length == 14">\nCNPJ: {{model.cnpj_cpf | brCnpj}}</p><p ng-if="model.cnpj_cpf_clientePerfil.length == 11 && model.cnpj_cpf == \'\' ">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14 && model.cnpj_cpf == \'\'">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>C\xF3digo de rastreamento:{{model.lote_numero}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong class="infos-center">\n{{model.produto_nome}} - {{model.produto_variedade}} - {{model.quantidade}} <span class="lowercase" \nng-if="model.unidade_medida != \'Embalagem\'">{{model.unidade_medida}}</span> <span class="lowercase" \nng-if="model.unidade_medida == \'Embalagem\'">{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg\n</span></strong></div><div class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">\nDistribuidor: {{model.distribuidor_nome}}<br>CPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div \nclass="midia-etiqueta"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" \nimage="true"></qr></div><div class="compartveg-logo"><img src="../assets/images/logos/eattae_monocromatico.svg"></div>\n</div></div></div><div id="printThisRolo" ng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2">\n</div><div id="imprimirdezporcincorolo2x" ng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 2" \nng-hide="model.tipo_etiquetas.id == 1"><div id="printLabel" class="label"><div class="dados-etiqueta"><strong>\n{{model.nome_produtor}}</strong><p ng-if="model.cnpj_cpf.length == 11">CPF: {{model.cnpj_cpf | brCpf}}</p><p \nng-if="model.cnpj_cpf.length == 14">CNPJ: {{model.cnpj_cpf | brCnpj}}</p><p>\nC\xF3digo de rastreamento:{{model.lote_numero}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p>\n<p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - {{model.quantidade}} <span \nng-if="model.unidade_medida != \'Embalagem\'">{{model.unidade_medida}}</span> <span \nng-if="model.unidade_medida == \'Embalagem\'">{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg\n</span></strong></div><div class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">\nDistribuidor: {{model.distribuidor_nome}}<br>CPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div \nclass="midia-etiqueta"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" \nimage="true"></qr></div><div class="compartveg-logo"><img src="../assets/images/logos/eattae_monocromatico.svg"></div>\n</div></div></div><div id="printThisRolo2x" ng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2">\n</div></div><div layout="column" layout-gt-xs="row" layout-margin layout-align="center" \nng-if="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3"><div id="imprimirdozeporcinco" \nng-if="model.tamanho_etiquetas.id == 2 && model.colunas.id == 1"><div id="printLabelDoze" class="labelDoze"><div \nclass="dados-etiqueta"><strong>{{model.nome_produtor}} </strong><strong ng-if="model.nome_produtor == \'\' ">\n{{model.nome_clientePerfil}}</strong><p ng-if="model.cnpj_cpf.length == 11">CPF: {{model.cnpj_cpf | brCpf}}</p><p \nng-if="model.cnpj_cpf.length == 14">CNPJ: {{model.cnpj_cpf | brCnpj}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11 && model.cnpj_cpf == \'\' ">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14 && model.cnpj_cpf == \'\'">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>C\xF3digo de rastreamento:{{model.lote_numero}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong class="infos-center">\n{{model.produto_nome}} - {{model.produto_variedade}} - {{model.quantidade}} <span class="lowercase" \nng-if="model.unidade_medida != \'Embalagem\'">{{model.unidade_medida}}</span> <span class="lowercase" \nng-if="model.unidade_medida == \'Embalagem\'">{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg\n</span></strong></div><div class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">\nDistribuidor: {{model.distribuidor_nome}}<br>CPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div \nclass="midia-etiqueta"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" \nimage="true"></qr></div><div class="compartveg-logo"><img src="../assets/images/logos/eattae_monocromatico.svg"></div>\n</div></div></div><div id="printThisDoze" ng-if="model.tamanho_etiquetas.id == 2"></div><div \nid="imprimirdozeporcincorotate" ng-if="model.tamanho_etiquetas.id == 2 && model.colunas.id == 2"><div \nid="printLabelDoze" class="labelDozeRotate"><div class="dados-etiqueta"><strong>{{model.nome_produtor}} </strong>\n<strong ng-if="model.nome_produtor == \'\' ">{{model.nome_clientePerfil}}</strong><p ng-if="model.cnpj_cpf.length == 11">\nCPF: {{model.cnpj_cpf | brCpf}}</p><p ng-if="model.cnpj_cpf.length == 14">CNPJ: {{model.cnpj_cpf | brCnpj}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11 && model.cnpj_cpf == \'\' ">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14 && model.cnpj_cpf == \'\'">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>C\xF3digo de rastreamento:{{model.lote_numero}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong class="infos-center">\n{{model.produto_nome}} - {{model.produto_variedade}} - {{model.quantidade}} <span class="lowercase" \nng-if="model.unidade_medida != \'Embalagem\'">{{model.unidade_medida}}</span> <span class="lowercase" \nng-if="model.unidade_medida == \'Embalagem\'">{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg\n</span></strong></div><div class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">\nDistribuidor: {{model.distribuidor_nome}}<br>CPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div \nclass="midia-etiqueta"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" \nimage="true"></qr></div><div class="compartveg-logo"><img src="../assets/images/logos/eattae_monocromatico.svg"></div>\n</div></div></div><div id="printThisDozeRotate" ng-if="model.tamanho_etiquetas.id == 2"></div><div \nid="imprimirseisporquatrorotate" ng-if="model.tamanho_etiquetas.id == 3"><div id="printLabelDoze" \nclass="labelSeisRotate"><div class="dados-etiqueta"><strong>{{model.nome_produtor}} </strong><strong \nng-if="model.nome_produtor == \'\' ">{{model.nome_clientePerfil}}</strong><p ng-if="model.cnpj_cpf.length == 11">\nCPF: {{model.cnpj_cpf | brCpf}}</p><p ng-if="model.cnpj_cpf.length == 14">CNPJ: {{model.cnpj_cpf | brCnpj}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11 && model.cnpj_cpf == \'\' ">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14 && model.cnpj_cpf == \'\'">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>C\xF3digo de rastreamento:{{model.lote_numero}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong class="infos-center">\n{{model.produto_nome}} - {{model.produto_variedade}} - {{model.quantidade}} <span class="lowercase" \nng-if="model.unidade_medida != \'Embalagem\'">{{model.unidade_medida}}</span> <span class="lowercase" \nng-if="model.unidade_medida == \'Embalagem\'">{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg\n</span></strong></div><div class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">\nDistribuidor: {{model.distribuidor_nome}}</p><p ng-if="vm.model.distribuidor == true">\nCPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><div class="compartveg-logo"><img \nsrc="../assets/images/logos/eattae_monocromatico.svg"></div><p class="version">Vers\xE3o 1.1</p></div></div></div><div \nid="printThisSeisRotate" ng-if="model.tamanho_etiquetas.id == 3"></div></div><div layout="column" layout-gt-xs="row" \nlayout-margin layout-align="center" ng-if="model.tamanho_etiquetas.id == 4"><div id="imprimirquatropordoisemeio" \nng-show="model.tamanho_etiquetas.id == 4"><div id="printLabeQuatroPorDois" class="labelQuatroPorDoisMeio"><div \nclass="dados-etiqueta"><strong>{{model.produto_nome}}</strong></div><div class="dados-etiqueta-2"><span \nclass="variedade">{{model.produto_variedade}} - {{model.quantidade}} - <span class="lowercase">{{model.unidade_medida}}\n</span></span></div><div class="dados-etiqueta-3"><span class="lowercase" ng-if="model.unidade_medida == \'Embalagem\'">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}}kg</span></div><div class="dados-etiqueta-4">\n<strong>{{model.nome_produtor}} </strong><strong ng-if="model.nome_produtor == \'\' ">{{model.nome_clientePerfil}}\n</strong><p ng-if="model.cnpj_cpf.length == 11">CPF: {{model.cnpj_cpf | brCpf}}</p><p \nng-if="model.cnpj_cpf.length == 14">CNPJ: {{model.cnpj_cpf | brCnpj}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11 && model.cnpj_cpf == \'\' ">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14 && model.cnpj_cpf == \'\'">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}\n</p><p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p>\n<span>N\xBA lote: {{model.lote_numero}}</span></div><div class="dados-etiqueta-5"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><p>by Eattae</p></div></div></div></div><div\n id="printThisQuatroPorDois" ng-if="model.tamanho_etiquetas.id == 4"></div><div layout="column" layout-gt-xs="row" \nlayout-margin layout-align="center" ng-if="model.tamanho_etiquetas.id == 5"><div id="imprimirtrintaetresporvinteeum" \nng-show="model.tamanho_etiquetas.id == 5"><div id="printLabeTrintaETresPorVinteEUm" \nclass="labelTrintaETresPorVinteEUm"><div class="display-flex-1"><div class="dados-etiqueta"><strong>\n{{model.produto_nome}} {{model.produto_variedade}}</strong><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p></div><div class="dados-etiqueta-5"><div \nclass="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" image="true"></qr></div></div>\n</div><div class="display-flex-2"><div class="dados-etiqueta-4"><span>Rastreamento: {{model.lote_numero}}</span></div>\n</div></div></div></div><div id="printThisTrintaETresPorVinteEUm" ng-if="model.tamanho_etiquetas.id == 5"></div></div>\n</md-dialog-content><md-dialog-actions><md-button class="btn btn-secondary" ng-click="cancelar()">\n{{\'LOTE.CANCELAR\' | translate }}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 1 && model.quantidade_etiquetas != null" \nclass="btn btn-primary" ng-click="Export(model.quantidade_etiquetas)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button>\n<md-button ng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 1" type="button" class="btn btn-primary" \naria-label="Submit" ng-click="ExportRolo(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 2" type="button" class="btn btn-primary" \naria-label="Submit" ng-click="ExportRolo2x(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 2 && model.colunas.id == 2" type="button" class="btn btn-primary" \naria-label="Submit" ng-click="ExportDozeRotate(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 2  && model.colunas.id == 1" type="button" class="btn btn-primary" \naria-label="Submit" ng-click="ExportDoze(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 3" type="button" class="btn btn-primary" aria-label="Submit" \nng-click="ExportSeisPorQuatro(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 4" type="button" class="btn btn-primary" aria-label="Submit" \nng-click="ExportQuatroPorDois(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 5" type="button" class="btn btn-primary" aria-label="Submit" \nng-click="ExportTrintaETresPorVinteEUm(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/compras/lotes_comprados/views/visualizar-fornecedor-tmpl.html','<md-dialog class="modal-custom-register"><form name="fornecedorForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Visualizar fornecedor</h2><md-button class="md-icon-button close-modal" \nng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><fieldset disabled="disabled"><md-card>\n<h3 translate="FORNECEDOR.DADOS">Dados do fornecedor</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" disabled="disabled"><md-radio-button value="1">\nF\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required></md-input-container>\n<md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input \ntype="text" name="cnpj_cpf" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required></md-input-container>\n<md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input \ntype="text" name="nome" ng-model="vm.model.nome" maxlength="50" required></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required></md-input-container></div></md-card><md-card><h3 translate="">Endere\xE7o</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20"><label \ntranslate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" required \nui-br-cep-mask></md-input-container><md-input-container class="md-block" flex><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Cidade" maxlength="50" required></md-input-container>\n<md-input-container flex="10"><input type="text" name="uf" ng-model="vm.model.endereco.endereco_uf" placeholder="UF" \nmaxlength="2" ng-pattern="/^[a-zA-Z]*$/" required></md-input-container><md-input-container flex="25" class="md-block">\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" placeholder="Bairro" \nrequired></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><input type="text" name="endereco" ng-model="vm.model.endereco.endereco_rua" placeholder="Rua" \nmaxlength="50" required></md-input-container><md-input-container class="md-block" flex="10"><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required>\n</md-input-container><md-input-container class="md-block" flex="20"><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Complemento"></md-input-container></div></md-card>\n</fieldset></md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" \nng-click="vm.gotoSearch()">Voltar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/compras/lotes_comprados/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="LOTES_COMPRADOS.VIEW">Visualizar</h1>\n</div><div class="content-register"><form name="propriedadeForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><h3 translate="LOTES_COMPRADOS.DADOS">Dados do lote</h3><div \nclass="mobile-text-center" flex="100" flex-gt-sm="33"><div class="id-lote"><span name="lote_numero">\nID DO LOTE {{vm.model.id}}</span></div></div><ms-api-message form-api="propriedadeForm.$api"></ms-api-message><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><label \ntranslate="LOTES_COMPRADOS.DATA_EXPEDICAO">Data expedi\xE7\xE3o</label><md-datepicker disabled="disabled" \nname="data_expedicao" ng-model="vm.model.lote_distribuicao_venda.data_expedicao" md-placeholder="Data de expedi\xE7\xE3o" \nmd-open-on-focus></md-datepicker></md-input-container><md-input-container flex><label \ntranslate="LOTES_COMPRADOS.NUMERO_LOTE">N\xFAmero do lote</label><input disabled="disabled" type="text" \nname="lote_numero" ng-model="vm.model.lote_numero"></md-input-container><md-input-container flex><label \ntranslate="LOTES_COMPRADOS.DOCUMENTO_DESTINO">Documento de destino</label><input disabled="disabled" type="text" \nname="documento_destino" ng-model="vm.model.lote_distribuicao_venda.nota_fiscal"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="LOTES_COMPRADOS.VALOR">\nValor</label><input disabled="disabled" type="text" name="valor" ui-money-mask \nng-model="vm.model.lote_distribuicao_venda.valor"></md-input-container><md-input-container flex><label \ntranslate="LOTES_COMPRADOS.QUANTIDADE">Quantidade</label><input disabled="disabled" type="text" name="quantidade" \nng-model="vm.model.lote_distribuicao_venda.quantidade"></md-input-container><md-input-container flex><label \ntranslate="LOTES_COMPRADOS.UNIDADE_MEDIDA">Unidade</label><input disabled="disabled" type="text" name="unidade_medida" \nng-model="vm.model.lote_distribuicao_venda.unidade_medida"></md-input-container><md-input-container flex \nng-if="vm.model.lote_distribuicao_venda.unidade_medida == \'Embalagem\'"><label \ntranslate="LOTES_COMPRADOS.TIPO_EMBALAGEM">Tipo Embalagem</label><input disabled="disabled" type="text" \nname="embalagem_tipo" ng-model="vm.model.lote_distribuicao_venda.embalagem_tipo"></md-input-container>\n<md-input-container flex ng-if="vm.model.lote_distribuicao_venda.unidade_medida == \'Embalagem\'"><label \ntranslate="LOTES_COMPRADOS.PESO_EMBALAGEM">Peso por embalagem</label><input disabled="disabled" type="text" \nname="embalagem" ng-model="vm.model.lote_distribuicao_venda.embalagem_peso"></md-input-container></div></md-card><div \nng-repeat="lote_producao in (vm.model.lote_producao_lote_distribuicao_vinculos | filter: {lote_externo:false})">\n<md-card><h3>Lote de Produ\xE7\xE3o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label>Data da expedi\xE7\xE3o</label><md-datepicker disabled="disabled" name="data_expedicao" \nng-model="lote_producao.data_expedicao" md-placeholder="Data de expedi\xE7\xE3o" md-open-on-focus></md-datepicker>\n</md-input-container><md-input-container flex><label translate="LOTES_COMPRADOS.PROPRIEDADE">Propriedade</label><input \ndisabled="disabled" type="text" name="propriedade" ng-model="lote_producao.lote_producao.propriedade_endereco">\n</md-input-container><md-input-container flex><label translate="LOTES_COMPRADOS.AREA">\xC1rea</label><input \ndisabled="disabled" type="text" name="area" ng-model="lote_producao.lote_producao.area_nome"></md-input-container>\n<md-input-container flex-xs="80" flex><label translate="LOTES_COMPRADOS.PRODUTO">Produto</label><input \ndisabled="disabled" type="text" name="produto" ng-model="lote_producao.lote_producao.produto_nome">\n</md-input-container><md-input-container flex-xs="20" flex><md-button class="edit-button md-icon-button" \nng-click="vm.gotoLoteProducao(lote_producao.lote_producao.id)"><md-icon md-font-icon="icon-eye" class="s16"><md-tooltip\n hide-xs md-direction="right">Visualizar</md-tooltip></md-icon></md-button></md-input-container></div></md-card><div \nng-repeat="lote_externo in (vm.model.lote_producao_lote_distribuicao_vinculos | filter: {lote_externo:true}) ">\n<md-card><h3>Lote Externo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label translate="LOTES_COMPRADOS.DATA_RECEBIMENTO">Data recebimento</label><md-datepicker \nname="data_recebimento" ng-model="lote_externo.data_expedicao" md-max-date="vm.date" \nmd-placeholder="Data do recebimento" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container>\n<md-input-container flex><label translate="LOTES_COMPRADOS.CULTURA">Cultura</label><input type="text" name="cultura" \nng-model="lote_externo.lote_producao.produto_nome" disabled="disabled"></md-input-container><md-input-container flex>\n<label translate="LOTES_COMPRADOS.VARIEDADE">Variedade</label><input type="text" name="variedade" \nng-model="lote_externo.lote_producao.produto_variedade" disabled="disabled"></md-input-container><md-input-container \nflex><label translate="LOTES_COMPRADOS.QUANTIDADE">Quantidade</label><input type="text" name="quantidade" \nvalue="{{lote_externo.lote_producao.quantidade}} {{lote_externo.lote_producao.unidade_medida}}" disabled="disabled">\n</md-input-container></div></md-card></div></div></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.comeBack()">Voltar</md-button><md-button class="btn btn-primary btn-lg" \nng-if="vm.model.lote_distribuicao_status.id == 2" ng-click="vm.ConfirmacaoEstorno(vm.model)">\nEstornar Encerramento do lote</md-button><md-button class="btn btn-primary btn-lg" \nng-if="vm.model.lote_distribuicao_status.id == 1" ng-click="vm.ConfirmacaoEncerramento(vm.model)">Encerrar lote\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/compras/lotes_externos/views/buscar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="LOTES_EXTERNOS.LOTES_EXTERNOS">\nLotes externos</h1><md-button class="btn btn-tertiary btn-lg-i" ng-click="vm.gotoComprar()">Comprar</md-button></div>\n<div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div><div class="form-search"><form>\n<md-menu md-position-mode="left bottom"><button ng-click="$mdMenu.open()"><a class="button-filter"><i \nclass="fas fa-filter"><md-tooltip hide-xs md-direction="right">Filtros</md-tooltip></i></a></button><md-menu-content \nmenu-content class="content-filter" width="6"><md-menu-item class="header-container dropdown-column"><div \nclass="header-content"><p>Filtrar</p><a ng-click="$mdMenu.close()" class="btn-close">X</a></div></md-menu-item><div \nclass="main-container"><div class="main-content"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex><label>Fornecedor</label><select class="md-block" name="fornecedor" \nng-model="vm.args.fornecedor_Id"><option ng-repeat="fornecedor in vm.models.cliente_fornecedor" \nng-value="fornecedor.id">{{fornecedor.nome}}</option></select></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Cultura</label><select \nclass="md-block" name="cultura" ng-model="vm.args.cultura"><option ng-repeat="cultura in vm.models.culturas" \nplaceholder="Selecione a cultura" ng-value="cultura.nome">{{cultura.nome}}</option></select></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Variedade\n</label><select class="md-block" name="variedades" ng-model="vm.args.variedade"><option \nng-repeat="variedade in vm.models.variedades" placeholder="Selecione a variedade" ng-value="variedade.nome">\n{{variedade.nome}}</option></select></md-input-container></div><div class="content-buttons"><a \nclass="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar </a><a class="btn btn-quaternary" \nng-click="vm.resetPagination(); vm.args._change()">Filtrar</a></div></div></div></md-menu-content></md-menu></form>\n</div></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom lotes-externos"><thead><tr><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Data de<br>\nrecebimento</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Fornecedor -<br>CPF/CNPJ</span></div></th><th class="secondary-text pagination-custom" \nlm-sort-header="cultura" lm-title="Cultura"></th><th class="secondary-text pagination-custom" \nlm-sort-header="variedade" lm-title="Variedade"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Quantidade/Unid. de medida</span></div></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models.compras_externas"><td>\n{{model.data_expedicao | date:\'dd/MM/yyyy\'}}</td><td ng-click="vm.showDialogFornecedor($event,model)" \nclass="cursor-pointer"><span ng-if="model.fornecedor_cnpj_cpf.length == 11" class="underline">\n{{model.fornecedor_nome}} - {{model.fornecedor_cnpj_cpf | brCpf}}</span> <span \nng-if="model.fornecedor_cnpj_cpf.length == 14" class="underline">\n{{model.fornecedor_nome}} - {{model.fornecedor_cnpj_cpf | brCnpj}}</span></td><td>{{model.cultura}}</td><td>\n{{model.variedade}}</td><td>{{model.quantidade}} {{model.unidade_medida}}</td><td>R$ {{model.valor | finance:false:2}}\n</td><td><md-button class="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar">\n<i class="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/compras/lotes_externos/views/criar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="LOTES_EXTERNOS.COMPRAR_LOTES">Comprar\n</h1></div><div class="content-register"><form name="externosForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><h3 translate="LOTES_EXTERNOS.DADOS">Dados do lote</h3><div \napi-form-validation-summary form="externosForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom"><label>Data de recebimento</label><md-datepicker name="data_recebimento" \nng-model="vm.model.lote_distribuicao_compra_externa_item.data_expedicao" md-max-date="vm.date" \nmd-placeholder="Insira data" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="externosForm.data_recebimento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{externosForm.data_recebimento.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label>Cultura</label><md-autocomplete required flex class="md-block" md-input-name="cultura" \nmd-no-cache="false" md-selected-item="vm.model.lote_producao_compra_externa" md-search-text="culturaQuery" \nmd-items="item in vm.culturaSearch(culturaQuery)" md-item-text="item.nome" md-delay="500" md-require-match \nplaceholder="Buscar cultura"><md-item-template><span md-highlight-text="vm.model.lote_producao_compra_externa.cultura">\n{{item.nome}}</span></md-item-template><md-not-found>Nenhum resultado encontrado</md-not-found><div \nng-messages="externosForm.cultura.$error" ng-if="externosForm.cultura.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="md-require-match">Por favor, digite uma cultura v\xE1lida</div><div \nng-message="api_erro">{{externosForm.cultura.$api.error.message}}</div></div></md-autocomplete></md-input-container>\n<md-input-container flex><label translate="LOTES_EXTERNOS.VARIEDADE">Variedade</label><input type="text" \nname="variedade" ng-model="vm.model.lote_producao_compra_externa.variedade" maxlength="15" required \nplaceholder="Variedade"><div class="errors" ng-messages="externosForm.variedade.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{externosForm.variedade.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="LOTES_EXTERNOS.VALOR">Valor total</label><input type="text" name="valor" \nng-model="vm.model.lote_distribuicao_compra_externa_item.valor" ui-money-mask placeholder="Insira o valor" required>\n<div class="errors" ng-messages="externosForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pi_erro">{{externosForm.valor.$api.error.message}}</div></div></md-input-container><md-input-container \nflex><label translate="LOTES_EXTERNOS.QUANTIDADE">Quantidade</label><input type="text" name="quantidade" \nng-model="vm.model.lote_producao_compra_externa.quantidade" ui-number-mask="3" min="0.001" max="99999.999" \nmaxlength="10" placeholder="Insira a quantidade" required><div class="errors" \nng-messages="externosForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999.999 | finance:false:3}}</div><div ng-message="api_erro">\n{{externosForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex><label translate="LOTES_EXTERNOS.UNIDADE_MEDIDA">Unidade</label><md-select class="md-block" \nname="unidade" placeholder="Selecione a unidade de medida" \nng-model="vm.model.lote_producao_compra_externa.unidade_medida" required><md-option ng-repeat="unidade in vm.unidades" \nvalue="{{unidade}}">{{unidade}}</md-option></md-select><div class="errors" ng-messages="externosForm.unidade.$error">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{externosForm.unidade.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" class="md-button-right" flex="75"><label \ntranslate="LOTES_EXTERNOS.FORNECEDOR">Fornecedor</label><md-select class="md-block" name="fornecedor" \nng-model="vm.model.cliente_fornecedor" placeholder="Selecione o fornecedor" required><md-option \nng-repeat="fornecedor in vm.fornecedores" ng-value="fornecedor"><span ng-if="fornecedor.cnpj_cpf.length == 11">\n{{fornecedor.cnpj_cpf | brCpf}}</span> <span ng-if="fornecedor.cnpj_cpf.length == 14">{{fornecedor.cnpj_cpf | brCnpj}}\n</span> <span>- {{fornecedor.nome}}</span></md-option><md-option ng-if="vm.fornecedores.length == 0" \ndisabled="disabled">Nenhum cliente cadastrado</md-option></md-select><div class="errors" \nng-messages="externosForm.fornecedor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{externosForm.fornecedor.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="25"><a class="btn btn-quaternary" ng-click="vm.showDialogCreateFornecedor($event,model)">\n<md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar fornecedor</a></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.cancelClick(externosForm,$event)">Voltar</md-button><md-button type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="externosForm.$invalid || externosForm.$pristine || loadingProgress" ng-click="vm.save(vm.model) ">\nCadastrar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/compras/lotes_externos/views/criar_fornecedor.tmpl.html','<md-dialog class="modal-custom-register"><form name="fornecedorForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo fornecedor</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="clienteForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="fornecedorForm.pessoa_tipo.$error" ng-show="fornecedorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CNPJ"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required placeholder="Insira o CPF"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Insira o telefone"><div class="errors" \nng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20"><label \ntranslate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" required \nui-br-cep-mask placeholder="Insira o cep"><div class="errors" ng-messages="fornecedorForm.cep.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label translate="CLIENTE.CITY">CEP</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF">UF</label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="Insira o UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required>\n<div class="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CADASTRAIS.BAIRRO">BAIRRO\n</label><input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="fornecedorForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="CLIENTE.RUA">RUA</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira a rua" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CADASTRAIS.NUMERO">N\xFAmero</label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="Insira o n\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO">COMPLEMENTO</label><input type="text" \nname="complemento" ng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div \nclass="errors" ng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-click="vm.save(vm.model)">Cadastrar</md-button>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/compras/lotes_externos/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="LOTES_VENDIDOS.VIEW">Visualizar lote\n</h1></div><div class="content-register"><form name="externosForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><div class="mobile-text-center" flex="100" \nflex-gt-sm="33"><h3 translate="LOTE.DADOS">Dados do lote</h3></div><div api-form-validation-summary \nform="externosForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label>Data de recebimento</label><md-datepicker name="data_recebimento" \nng-model="vm.model.data_expedicao" md-max-date="vm.date" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex><label translate="LOTES_EXTERNOS.CULTURA">Cultura</label><input \ntype="text" name="cultura" ng-model="vm.model.lote_producao.produto_nome" maxlength="15" required></md-input-container>\n<md-input-container flex="25"><label translate="LOTES_EXTERNOS.VARIEDADE">Variedade</label><input type="text" \nname="variedade" ng-model="vm.model.lote_producao.produto_variedade" maxlength="15" required></md-input-container>\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="15"><label \ntranslate="LOTES_EXTERNOS.VALOR">Valor total</label><input type="text" name="valor" ng-model="vm.model.valor" \nui-money-mask></md-input-container><md-input-container flex><label translate="LOTES_EXTERNOS.FORNECEDOR">Fornecedor\n</label><input type="text" name="fornecedor" ng-model="vm.model.cliente_fornecedor.nome" maxlength="15" required>\n</md-input-container><md-input-container flex="15"><label translate="LOTES_EXTERNOS.QUANTIDADE">Quantidade</label>\n<input type="text" name="quantidade" ng-model="vm.model.quantidade" ui-number-mask="3" min="0.001" max="99999.999" \nmaxlength="10"></md-input-container><md-input-container flex="15"><label translate="LOTES_EXTERNOS.UNIDADE_MEDIDA">\nUnidade de medida</label><input type="text" name="unidade_medida" ng-model="vm.model.unidade_medida" maxlength="15" \nrequired></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.comeBack()">Voltar</md-button><md-button class="btn btn-primary btn-lg" \nng-if="vm.model.lote_distribuicao.lote_distribuicao_status_id == 1" ng-click="vm.ConfirmacaoEncerramento(vm.model)">\nEncerrar lote</md-button><md-button class="btn btn-primary btn-lg" \nng-if="vm.model.lote_distribuicao.lote_distribuicao_status_id == 2" ng-click="vm.ConfirmacaoEstorno(vm.model)">\nEstornar Encerramento do lote</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/biologico/views/acerto.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_BIOLOGICO.TITLE">\nEstoque insumo biol\xF3gico</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column">\n<div class="content" layout="column"><div class="container-content-custom"><div class="content-register with-select">\n<md-card><h3 translate="INVENTORY_BIOLOGICO.DEFENSIVE_DATA">Dados do biol\xF3gico</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="40"><label translate="INVENTORY_BIOLOGICO.PRODUCT">Produto\n</label><input type="text" name="quantidade_maquinas" ng-model="vm.estoque_insumo_rateio.insumo.nome" \ndisabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_BIOLOGICO.CURRENT_AMOUNT">Quantidade</label><input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo_rateio.quantidade | number:3 }} {{ vm.estoque_insumo_rateio.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label translate="INVENTORY_BIOLOGICO.VALUE_TOTAL">\nValor total</label><input type="text" name="valor_total" ng-model="vm.estoque_insumo_rateio.valor" disabled="disabled" \nui-money-mask></md-input-container></div></md-card><form name="despesaAdminstrativaForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset><md-card class="first-md-card"><h3>\nAtualiza\xE7\xE3o dos dados do biol\xF3gico</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex \nmd-delay="500"><label translate="INVENTORY_BIOLOGICO.QUANTITY">Quantidade</label><input type="number" \nname="quantidade" ng-model="vm.model.quantidade" placeholder="Insira uma quantidade" \nng-change="vm.changeQuantidadeOuUnidadeDeMedida()" min="1" required><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="min">A quantidade deve ser maior ou igual a 1.</div><div ng-message="pattern">Somente n\xFAmeros</div><div \nng-message="number">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="INVENTORY_BIOLOGICO.TYPE">Tipo</label><md-select \nclass="md-block" ng-model="vm.model.tipo" name="tipo_id" ng-change="vm.changeTipoAcerto()" \nplaceholder="Escolher uma unidade de medida" required><md-option ng-repeat="tipo_item in vm.tipos" \nng-value="tipo_item">{{tipo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-input-has-value" flex md-delay="500" ng-if="vm.model.tipo.id == 1"><label class="md-required" \ntranslate="INVENTORY_BIOLOGICO.INVENTORY"></label><md-radio-group md-autofocus name="estoque_tipo_id" \nng-change="vm.changeTipoAcerto()" ng-model="vm.model.estoque_tipo_id" layout="row" required><md-radio-button value="1">\nAcrescentar</md-radio-button><md-radio-button value="2">Retirar</md-radio-button></md-radio-group><div \nng-messages="favorecidoForm.estoque_tipo_id.$error" ng-show="favorecidoForm.estoque_tipo_id.$touched"><div \nng-message="required" translate>Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{favorecidoForm.estoque_tipo.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="INVENTORY_BIOLOGICO.NOTE">\nObserva\xE7\xE3o</label><input type="text" name="observacao" ng-model="vm.model.observacao" \nplaceholder="Insira uma observa\xE7\xE3o" maxlength="300"><div class="errors" \nng-messages="despesaAdminstrativaForm.observacao.$error"><div ng-message="api_erro">\n{{despesaAdminstrativaForm.observacao.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset>\n<div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div class="content-buttons">\n<md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button\n type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.save(despesaAdminstrativaForm)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/biologico/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_BIOLOGICO.TITLE">\nEstoque insume biol\xF3gico</h1></div><md-button class="btn btn-primary" translate="INVENTORY_BIOLOGICO.ADD_PRODUCT" \nng-disabled="vm.propriedades.length == 0" ng-click="vm.gotoAdd()">Adicionar insumo no estoque</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.compra_de" md-max-date="vm.args.compra_ate" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.compra_ate" ng-disabled="vm.args.compra_de == null" \nmd-min-date="vm.args.compra_de" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.compra_ate == null">Selecionar</button>\n</div></div></div></div></div></div><div class="col"><md-input-container class="select-custom" flex><label>Fornecedor\n</label><select class="md-block" name="fornecedor" ng-model="vm.args.Fornecedor_id"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="fornecedor in vm.fornecedores" \nng-value="fornecedor.id">{{ fornecedor.nome }}</option></select></md-input-container></div><div class="col">\n<md-input-container class="select-custom" flex><label>Insumo</label><select class="md-block" name="insumo" \nng-model="vm.args.insumo_id"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="insumo in vm.insumos" ng-value="insumo.id">{{ insumo.nome }}</option></select></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom estoque-insumo"><thead><tr><th></th><th \nclass="secondary-text pagination-custom" lm-sort-header="insumo_nome" lm-title="Nome do insumo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. atual / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th></tr></thead><tbody><tr \nclass="default" ng-repeat-start="model in vm.models"><td class="click-button desktop-only"><a \nng-click="vm.openDetail(model)" ng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeDetail(model)" ng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a \nclass="disabled" ng-show="vm.isDetailOpened && !model.isOpen"><md-tooltip md-direction="right">\nS\xF3 \xE9 poss\xEDvel abrir um insumo por vez</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td><td>\n{{ model.insumo_nome }}</td><td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor | finance:false:2}}</td><td class="click-button mobile-only"><a ng-click="vm.openDetail(model)" \nng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeDetail(model)" \nng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" \nng-show="vm.isDetailOpened && !model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr \nng-repeat-end class="details"><td class="main" colspan="5" ng-if="model.isOpen && !model.isLoading"><div \nclass="details-query" ng-if="vm.agrupados.length >= 1"><h2>Detalhes do insumo</h2><table><thead><tr><th>Quant. atual\n</th><th>Quant. comprada</th><th>Loja / Fornecedor</th><th>Data da transa\xE7\xE3o</th><th>Valor pago</th><th>A\xE7\xF5es</th></tr>\n</thead><tbody><tr ng-repeat="item in vm.agrupados"><td>\n{{ item.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\n{{ item.quantidade_origem | number:3 }} {{ model.tipo_medida.descricao }}</td><td>{{ item.fornecedor_nome }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\'}}</td><td>R$ {{ item.valor | finance:false:2 }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoAcerto(item.id)" aria-label="Visualizar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="left">Inserir acerto</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(item)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Deletar o Rateio</md-tooltip></i></md-button></td></tr></tbody></table></div>\n<div class="content-button-inside-table" ng-if="vm.agrupados.length > 0"><md-button class="btn btn-tertiary btn-lg" \naria-label="Voltar" ng-click="vm.gotoHistory(model.id)">Ver hist\xF3rico</md-button></div><div class="no-content" \nng-if="vm.agrupados.length == 0"><i class="far fa-file-alt"></i><p>\nO insumo selecionado n\xE3o foi aplicado em nenhuma \xE1rea.</p></div></td><td colspan="6" ng-if="model.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div>\n</div></div>');
$templateCache.put('app/main/estoque_insumo/biologico/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_BIOLOGICO.TITLE">\nEstoque insumo biol\xF3gico</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column">\n<div class="content" layout="column"><div class="container-content-custom"><div class="content-register with-select">\n<form name="despesaAdminstrativaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset>\n<md-card class="first-md-card"><h3>Dados do biol\xF3gico</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom" md-delay="500"><label translate="INVENTORY_BIOLOGICO.PURCHASE_DATE">\nData de compra</label><md-datepicker name="data_compra" ng-model="vm.model.data_compra" md-placeholder="Inserir data" \nmd-max-date="vm.date" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="despesaAdminstrativaForm.data_compra.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.data_compra.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20" md-delay="500"><label translate="INVENTORY_BIOLOGICO.DOCUMENT_NUMBER">N\xBA do documento\n</label><input type="text" name="numero_documento" placeholder="Insira o N\xBA do documento" \nng-model="vm.model.numero_documento" maxlength="80"><div class="errors" \nng-messages="despesaAdminstrativaForm.numero_documento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.numero_documento.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="40" md-delay="500"><label \ntranslate="INVENTORY_BIOLOGICO.STORE_OR_SUPPLIER">Loja / Fornecedor</label><md-select class="md-block" \nng-model="vm.model.cliente_fornecedor_id" name="cliente_fornecedor_id" placeholder="Escolher uma loja / fornecedor" \nrequired><md-option ng-repeat="fornecedor_item in vm.fornecedores" ng-value="fornecedor_item.id">\n{{fornecedor_item.nome}}</md-option></md-select><div ng-messages="despesaAdminstrativaForm.tipoDespesa.$error" \nng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateMarketplace($event,lista_detalhes)">Cadastrar Loja/Fornecedor</a></md-input-container>\n</div></md-card><md-card class="first-md-card" ng-repeat="biologico in vm.model.estoque"><div \nstyle="position: relative;"><h3 style="float:left">Biol\xF3gico {{biologico.id}}</h3><md-input-container \nstyle="width: 50px; float:right; margin:0;" ng-if="vm.model.estoque.length > 1"><md-button \nclass="icon-btn md-icon-button float-right" aria-label="remove" ng-click="vm.removeInsumo($index)"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex="70" md-delay="500"><label translate="INVENTORY_BIOLOGICO.PRODUCT">\nInsumo</label><md-select class="md-block" ng-model="biologico.insumo" name="insumo_id" \nng-change="vm.changeInsumo(biologico)" placeholder="Escolher um insumo" required><md-option \nng-repeat="insumo_item in vm.insumos" ng-value="insumo_item">{{insumo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="20"><a class="btn btn-quinary" ng-click="vm.showDialogCreateInsumo($event,biologico)">Cadastrar Insumo</a>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="35" \nmd-delay="500"><label translate="INVENTORY_BIOLOGICO.QUANTITY">Quantidade</label><input type="text" name="quantidade" \nng-model="biologico.quantidade" required placeholder="Insira a quantidade" ui-number-mask="3" min="0.001" \nmax="99999.999" ng-change="vm.changeQuantidadeOuUnidadeDeMedida(biologico)"> <span class="unidade_medida_input">\n{{biologico.insumo.tipo_medida.descricao}}</span><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35" md-delay="500"><label translate="INVENTORY_BIOLOGICO.AMOUNT_PAID">Valor pago</label>\n<input type="text" name="valor_pago" ng-model="biologico.valor_pago" ui-money-mask \nng-change="vm.changeQuantidadeOuUnidadeDeMedida(biologico)" maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor_pago.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.valor_pago.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="25" md-delay="500"><label \ntranslate="INVENTORY_BIOLOGICO.EXPIRATION_DATE">Data de validade</label><md-datepicker name="data_vencimento" \nng-model="biologico.data_vencimento" md-placeholder="Inserir data" md-open-on-focus></md-datepicker><div \nclass="errors" ng-messages="despesaAdminstrativaForm.data_vencimento.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{despesaAdminstrativaForm.data_vencimento.$api.error.message}}</div>\n</div></md-input-container></div></md-card><div class="row-add-novo"><a class="btn btn-quaternary" \nng-click="vm.addInsumo()" ng-hide="vm.model.despesas.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nAdicionar mais insumos </a><small style="margin-bottom:30px; color: darkgray;">Adicione mais insumos do mesmo documento\n</small></div></fieldset><div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">\nVoltar</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.showConfirm(despesaAdminstrativaForm, vm.model)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/biologico/views/criar_insumo.tmpl.html','<md-dialog class="modal-custom-register"><form name="cadastrarInsumoForm" novalidate="" \napi-form="vm.api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>Adicionar insumo</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="cadastrarInsumoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container md-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">NOME</label><input type="text" \nname="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="insumoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label><md-select class="md-block" \nng-model="vm.model.tipo_medida_id" name="tipo_medida_id" placeholder="Escolher uma tipo de insumo agricola" required>\n<md-option ng-repeat="tipo_medida_item in vm.tipo_medida" ng-value="tipo_medida_item.id">{{tipo_medida_item.nome}}\n</md-option></md-select><div ng-messages="insumoForm.tipo_medida_id.$error" ng-if="insumoForm.tipo_medida_id.$touched">\n<div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.tipo_medida_id.$api.error.message}}</div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="cadastrarInsumoForm.$error.required" ng-click="vm.save(vm.model)">\nCadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/biologico/views/criar_loja.tmpl.html','<md-dialog class="modal-custom-register"><form name="lojaForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar nova loja/fornecedor</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="lojaForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="fornecedorForm.pessoa_tipo.$error" ng-show="fornecedorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CPF"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required placeholder="Insira o CNPJ"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="fornecedorForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" \nng-model="vm.model.endereco.endereco_cep" required ui-br-cep-mask placeholder="Insira o CEP"><div class="errors" \nng-messages="fornecedorForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular\n ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container>\n<md-input-container class="md-block" flex><label translate="CLIENTE.CITY"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div \nclass="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="fornecedorForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="FORNECEDOR.STREET"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container><input \ntype="hidden" ng-model="vm.model.categoria" ng-value="vm.model.categoria = \'insumo\'"></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="lojaForm.$error.required" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/biologico/views/historico.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_BIOLOGICO.TITLE">\nEstoque insume biol\xF3gico</h1></div></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><br><md-card><h3 \ntranslate="INVENTORY_BIOLOGICO.DEFENSIVE_DATA">Dados do biol\xF3gico</h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="40"><label translate="INVENTORY_BIOLOGICO.PRODUCT">Produto</label><input \ntype="text" name="quantidade_maquinas" ng-model="vm.estoque_insumo.insumo.nome" disabled="disabled">\n</md-input-container><md-input-container flex><label translate="INVENTORY_BIOLOGICO.CURRENT_AMOUNT">Quantidade</label>\n<input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo.quantidade | number:3 }} {{ vm.estoque_insumo.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label translate="INVENTORY_BIOLOGICO.VALUE_TOTAL">\nValor total</label><input type="text" name="valor_total" ng-model="vm.estoque_insumo.valor" disabled="disabled" \nui-money-mask></md-input-container></div></md-card><div class="container-header"><h3 \ntranslate="INVENTORY_BIOLOGICO.HISTORY" class="historico-titulo">Hist\xF3rico</h3></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom historico-insumo"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="fornecedor" lm-title="Loja / Fornecedor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data" lm-title="Data da transa\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xE3o</span></div>\n</th></tr></thead><tbody><tr class="default" ng-repeat="model in vm.models"><td>{{ model.id }}</td><td>\n{{ model.estoque_insumo_rateio.cliente_fornecedor.nome }}</td><td>{{ model.data_lancamento | date:\'dd/MM/yyyy\'}}</td>\n<td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor_pago | finance:false:2 }}</td><td>{{ model.tipo_acerto }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizarRateio(model.estoque_insumo_rateio.id)" \naria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i>\n</md-button></td></tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear></div></div><lm-paginator lm-args="vm.args"></lm-paginator><div class="content-buttons"><md-button\n class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button></div></div></div>\n</div>');
$templateCache.put('app/main/estoque_insumo/biologico/views/rateio.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_BIOLOGICO.TITLE">\nEstoque insumo biol\xF3gico</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column">\n<div class="content" layout="column"><div class="container-content-custom"><div class="content-register with-select">\n<form name="custosForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset \ndisabled="disabled"><md-card><h3>Dados do biol\xF3gico</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom"><label translate="INVENTORY_BIOLOGICO.PURCHASE_DATE">Data de compra\n</label><md-datepicker name="data_aplicacao" ng-model="vm.model.data_compra" md-max-date="vm.date" md-open-on-focus \ndisabled="disabled"></md-datepicker></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_BIOLOGICO.DOCUMENT_NUMBER">N\xBA do documento</label><input type="text" name="numero_documento" \nng-model="vm.model.numero_documento" disabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_BIOLOGICO.STORE_OR_SUPPLIER">Loja / Fornecedor</label><input type="text" \nname="cliente_fornecedor" disabled="disabled" ng-model="vm.model.cliente_fornecedor.nome"></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="INVENTORY_BIOLOGICO.PRODUCT">Insumo</label><input type="text" name="insumo_nome" disabled="disabled" \nng-model="vm.model.insumo.nome"></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_BIOLOGICO.AMOUNT_PAID">Valor pago</label><input type="text" name="valor_pago" disabled="disabled" \nng-model="vm.model.valor" ui-money-mask></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex><label translate="INVENTORY_BIOLOGICO.CURRENT_AMOUNT">Quantidade atual</label>\n<input type="text" name="quantidade" disabled="disabled" \nvalue="{{vm.model.quantidade | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container flex><label translate="INVENTORY_BIOLOGICO.CURRENT_PURCHASED">Quantidade comprada</label><input \ntype="text" name="quantidade_origem" disabled="disabled" \nvalue="{{vm.model.quantidade_origem | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container class="datepicker-custom"><label>Data de validade</label><md-datepicker name="data_aplicacao" \nng-if="vm.model.data_validade" ng-model="vm.model.data_validade" disabled="disabled"></md-datepicker><input \ntype="text" name="data_validade" ng-if="!vm.model.data_validade" disabled="disabled" ng-model="vm.model.data_validade">\n</md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/biologico/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CUSTOS.VIEW_COSTS">Visualizar custos</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register with-select"><form \nname="custosForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled">\n<md-card><h3 translate="CUSTOS.DATA_COSTS">Dados do manejo</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" \nng-model="vm.model.data_aplicacao" md-max-date="vm.date" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex="20"><label>Hora da aplica\xE7\xE3o</label><input type="text" name="hora" \nvalue="{{ vm.model.hora_aplicacao | date:\'h:mm\' }}"></md-input-container><md-input-container flex><label \ntranslate="CUSTOS.TYPE_MANAGEMENT">Tipo de manejo</label><input type="text" name="quantidade_profissionais" \nng-model="vm.model.tipo_manejo.descricao"></md-input-container></div></md-card><md-card \nng-if="vm.model.profissionais != \'\'"><h3 translate="CUSTOS.PROFISSIONAIS">Profissionais</h3><div class="profissional" \nng-repeat="profissional in vm.model.profissionais"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_PROFISSIONAL">Tipo de profissional\n</label><input type="text" name="tipo_profissional" ng-model="profissional.tipo_profissional.nome">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.PROFISSIONAL_AMOUNT">Quantidade de profissionais</label><input type="text" \nname="quantidade_profissionais" ng-model="profissional.quantidade_profissional"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas</label><input type="text" \nname="horas_trabalhadas" ui-mask="99:99" ng-model="profissional.quantidade_horas"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input type="text" name="valor_hora" \nng-model="profissional.tipo_profissional.valor_hora" ui-money-mask></md-input-container><md-input-container flex><label\n translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" name="valor_total" \nng-model="profissional.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card \nng-if="vm.model.equipamentos != \'\'"><h3 translate="CUSTOS.MACHINE">M\xE1quinas/Equipamentos</h3><div class="equipamento" \nng-repeat="equipamento in vm.model.equipamentos"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_MACHINE">Tipo de m\xE1quina</label>\n<input type="text" name="tipo_maquina" ng-model="equipamento.equipamento.nome"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="CUSTOS.MACHINE_AMOUNT">\nQuantidade de m\xE1quinas</label><input type="text" name="quantidade_maquinas" ng-model="equipamento.quantidade_maquinas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas\n</label><input type="text" name="horas_trabalhadas" ui-mask="99:99" ng-model="equipamento.quantidade_horas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input \ntype="text" name="valor_hora" ng-model="equipamento.equipamento.valor_hora" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="valor_total" ng-model="equipamento.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card\n ng-if="vm.model.outros != \'\'"><h3 translate="CUSTOS.OTHER_COSTS">Outros custos</h3><div class="outros" \nng-repeat="outro in vm.model.outros"><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex>\n<label translate="CUSTOS.NAME_COSTS">Nome</label><input type="text" name="outro_nome" ng-model="outro.nome" \nmaxlength="15"></md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">\nQuantidade de horas trabalhadas</label><input type="text" name="outra_hora_trabalhada" ui-mask="99:99" \nng-model="outro.quantidade"></md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">\nValor hora</label><input type="text" name="outro_valor" ng-model="outro.valor" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="outro_valor_total" ng-model="outro.valor_total" ui-money-mask></md-input-container></div></div></md-card><div \nclass="split-area"><div class="percent-35 padding-right"><md-card><h3 translate="CUSTOS.WATER_USE">Utiliza\xE7\xE3o de \xE1gua\n</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.TOTAL_LITERS">Total em litros</label><input type="text" name="hora" placeholder="Insira a hora" \nui-number-mask="3" min="0.001" max="99999.999" maxlength="10" ng-model="vm.model.total_litros"></md-input-container>\n</div></md-card></div><div class="percent-65 padding-left"><md-card><h3 translate="CUSTOS.INFO_AREA">\xC1rea</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label>\xC1rea</label><input type="text" \nname="hora" ng-model="vm.model.propriedade_area.nome"></md-input-container></div></md-card></div></div></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/cadastro_insumo/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 translate="CADASTRO_INSUMO.TITLE">\nCadastro de Insumo</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div><md-button\n class="btn btn-primary btn-lg-i btn-tooltip" ng-click="vm.gotoAddClient()" ng-disabled="vm.propriedades.length == 0">\nCadastrar Insumo</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="container-search"><div><h2 \ntranslate="REGISTERS.LIST">Lista</h2></div><div class="form-search"></div></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom estoque_insumo"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="nome" lm-title="Nome"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo_medida" lm-title="Tipo de medida"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="insumo_tipo" lm-title="Tipo de insumo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_cadastro" lm-title="Data cadastro"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="AREA.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td>\n{{ model.nome }}</td><td>{{ model.tipo_medida.descricao }}</td><td>{{ model.insumo_tipo.descricao }}</td><td>\n{{ model.data_criacao | date:\'dd/MM/yyyy\'}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoEditar(model.id)" aria-label="Editar"><i class="fas fa-pen"><md-tooltip hide-xs md-direction="left">\nEditar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="top">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt"><md-tooltip hide-xs \nmd-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator lm-args="vm.args">\n</lm-paginator></div></div></div>');
$templateCache.put('app/main/estoque_insumo/cadastro_insumo/views/criar.html','<div class="container-header mb-1"><div class="breadcrumb"><h1 translate="CADASTRO_INSUMO.ADD">Adicionar insumo</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><banner id="banner-adicionar-insumo"><p class="sublinhado"><b>\nPasso a passo:</b></p><p>- Selecione qual o <b>tipo de insumo</b> que deseja incluir.</p><p>- Selecione ou digite o <b>\nnome do insumo.</b> Este dado ser\xE1 a sua identifica\xE7\xE3o na listagem de estoque. <i>Ex: Delegate - gal\xE3o 1kg.</i></p><p>\n- Selecione o <b>tipo de medida</b> do seu produto (peso ou liquido).</p><p>- Clique em <b>CADASTRAR</b>\n para salvar os dados.</p></banner><div class="content-register"><form name="insumoForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset><md-card><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex="30" md-delay="500"><label translate="CADASTRO_INSUMO.TIPO_INSUMO">\nTipo de insumo</label><md-select class="md-block" ng-model="vm.model.insumo_tipo_id" name="insumo_tipo_id" \nng-change="vm.changeInsumoTipo()" placeholder="Escolher uma tipo de insumo" required><md-option \nng-repeat="tipo_insumo_item in vm.tipo_insumo" ng-value="tipo_insumo_item.id">{{tipo_insumo_item.nome}}</md-option>\n</md-select><div ng-messages="insumoForm.insumo_tipo_id.$error" ng-if="insumoForm.insumo_tipo_id.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.insumo_tipo_id.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500" ng-if="vm.model.insumo_tipo_id == 2"><label \ntranslate="CADASTRO_INSUMO.DEFENSIVO">Nome comercial do defensivo</label><md-autocomplete required flex \nclass="md-block" name="insumo_agricola_nome" md-input-name="insumo_agricola_nome" md-no-cache="false" \nmd-selected-item="vm.model.insumo_agricola" md-selected-item-change="vm.selectedItemChange(item)" \nmd-search-text="listaAgrofitQuery" md-items="item in vm.listaAgrofitSearch(listaAgrofitQuery)" \nmd-item-text="item.nome" md-delay="500" md-require-match placeholder="Insira o produto"><md-item-template><span \nmd-highlight-text="listaAgrofitQuery">{{ item }}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="insumoForm.insumo_agricola_nome.$error" \nng-if="insumoForm.insumo_agricola_nome.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.insumo_agricola_nome.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500" ng-if="vm.model.insumo_tipo_id == 4"><label>Cultura\n</label><md-autocomplete required flex class="md-block" md-input-name="cultura" md-no-cache="false" \nmd-selected-item="vm.model.cultura" md-search-text="culturaQuery" md-items="item in vm.culturaSearch(culturaQuery)" \nmd-item-text="item.nome" md-delay="500" md-require-match placeholder="Buscar cultura"><md-item-template><span \nmd-highlight-text="vm.model.cultura">{{item.nome}}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="insumoForm.CulturaId.$error" ng-if="insumoForm.CulturaId.$touched">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="md-require-match">\nPor favor, digite uma cultura v\xE1lida</div><div ng-message="api_erro">{{insumoForm.cultura.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nmd-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">Nome do insumo no estoque</label><input type="text" \nname="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="insumoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label><md-select class="md-block" \nng-model="vm.model.tipo_medida_id" name="tipo_medida_id" placeholder="Escolher uma tipo de insumo agricola" required>\n<md-option ng-repeat="tipo_medida_item in vm.tipo_medida" ng-value="tipo_medida_item.id">{{tipo_medida_item.nome}}\n</md-option></md-select><div ng-messages="insumoForm.tipo_medida_id.$error" ng-if="insumoForm.tipo_medida_id.$touched">\n<div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.tipo_medida_id.$api.error.message}}</div></div></md-input-container></div></md-card><div \napi-form-validation-summary form="insumoForm"></div></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button><md-button type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || loadingProgress" ng-click="vm.save(insumoForm)">Cadastrar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/cadastro_insumo/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CADASTRO_INSUMO.EDIT">Editar Insumo</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="insumoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container md-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">NOME\n</label><input type="text" name="nome" ng-model="vm.model.nome" required></md-input-container><md-input-container \nclass="select-custom" flex="30" md-delay="500"><label translate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label>\n<input type="text" name="tipo_medida" ng-model="vm.model.tipo_medida.descricao" disabled="disabled">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex="30" md-delay="500"><label translate="CADASTRO_INSUMO.TIPO_INSUMO">Tipo de insumo</label>\n<input type="text" name="insumo_tipo" ng-model="vm.model.insumo_tipo.descricao" disabled="disabled">\n</md-input-container><md-input-container class="select-custom" flex md-delay="500" \nng-if="vm.model.insumo_tipo.id == 2"><label translate="CADASTRO_INSUMO.DEFENSIVO">Defensivo</label><input type="text" \nname="Defensivo" ng-model="vm.model.insumo_defensivo.nome" disabled="disabled"></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || loadingProgress" ng-click="vm.save(insumoForm)">Cadastrar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/cadastro_insumo/views/tutorial-insumo.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/7GLYc3vdUA0?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/estoque_insumo/cadastro_insumo/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CADASTRO_INSUMO.VIEW">Visualizar Insumo</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="insumoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container md-delay="500" flex><label \ntranslate="CADASTRO_INSUMO.NOME">NOME</label><input type="text" name="nome" ng-model="vm.model.nome" required>\n</md-input-container><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label><input type="text" name="tipo_medida" \nng-model="vm.model.tipo_medida.descricao" required></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_INSUMO">Tipo de insumo</label><input type="text" name="insumo_tipo" \nng-model="vm.model.insumo_tipo.descricao" required></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500" ng-if="vm.model.insumo_tipo.id == 2"><label translate="CADASTRO_INSUMO.DEFENSIVO">Defensivo</label>\n<input type="text" name="Defensivo" ng-model="vm.model.insumo_defensivo.nome" required></md-input-container></div>\n</md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/acerto.html','<div class="container-header mb-1"><div class="breadcrumb"><h1 translate="INVENTORY_DEFENSIVO.TITLE">\nEstoque insumo defensivo</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column">\n<div class="content" layout="column"><div class="container-content-custom"><banner id="banner-acerto-defensivo1"><p \nclass="sublinhado"><b>Passo a passo:</b></p><p>\n- Aqui voc\xEA insere os ajustes de acerto ou perda do insumo. Deixe esses dados bem atualizados para voc\xEA ter um controle maior do seu estoque.\n</p></banner><div class="content-register with-select"><md-card><h3 translate="INVENTORY_DEFENSIVO.DEFENSIVE_DATA">\nDados do defensivo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="40"><label \ntranslate="INVENTORY_DEFENSIVO.PRODUCT">Produto</label><input type="text" name="quantidade_maquinas" \nng-model="vm.estoque_insumo_rateio.insumo.nome" disabled="disabled"></md-input-container><md-input-container flex>\n<label translate="INVENTORY_DEFENSIVO.CURRENT_AMOUNT">Quantidade</label><input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo_rateio.quantidade | number:3 }} {{ vm.estoque_insumo_rateio.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label translate="INVENTORY_DEFENSIVO.VALUE_TOTAL">\nValor total</label><input type="text" name="valor_total" ng-model="vm.estoque_insumo_rateio.valor" disabled="disabled" \nui-money-mask></md-input-container></div></md-card><form name="despesaAdminstrativaForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset><md-card class="first-md-card"><h3>\nAtualiza\xE7\xE3o dos dados do defensivo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex \nmd-delay="500"><label translate="INVENTORY_DEFENSIVO.QUANTITY">Quantidade</label><input type="number" \nname="quantidade" ng-model="vm.model.quantidade" placeholder="Insira uma quantidade" \nng-change="vm.changeQuantidadeOuUnidadeDeMedida()" min="1" required><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="min">A quantidade deve ser maior ou igual a 1.</div><div ng-message="pattern">Somente n\xFAmeros</div><div \nng-message="number">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="INVENTORY_DEFENSIVO.TYPE">Tipo</label><md-select \nclass="md-block" ng-model="vm.model.tipo" name="tipo_id" ng-change="vm.changeTipoAcerto()" \nplaceholder="Escolher uma unidade de medida" required><md-option ng-repeat="tipo_item in vm.tipos" \nng-value="tipo_item">{{tipo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-input-has-value" flex md-delay="500" ng-if="vm.model.tipo.id == 1"><label class="md-required" \ntranslate="INVENTORY_DEFENSIVO.INVENTORY"></label><md-radio-group md-autofocus name="estoque_tipo_id" \nng-change="vm.changeTipoAcerto()" ng-model="vm.model.estoque_tipo_id" layout="row" required><md-radio-button value="1">\nAcrescentar</md-radio-button><md-radio-button value="2">Retirar</md-radio-button></md-radio-group><div \nng-messages="favorecidoForm.estoque_tipo_id.$error" ng-show="favorecidoForm.estoque_tipo_id.$touched"><div \nng-message="required" translate>Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{favorecidoForm.estoque_tipo.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="INVENTORY_DEFENSIVO.NOTE">\nObserva\xE7\xE3o</label><input type="text" name="observacao" ng-model="vm.model.observacao" \nplaceholder="Insira uma observa\xE7\xE3o" maxlength="300"><div class="errors" \nng-messages="despesaAdminstrativaForm.observacao.$error"><div ng-message="api_erro">\n{{despesaAdminstrativaForm.observacao.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset>\n<div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div class="content-buttons">\n<md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button\n type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.save(despesaAdminstrativaForm)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_DEFENSIVO.TITLE">\nEstoque insume defensivo</h1></div><md-button class="btn btn-primary" translate="INVENTORY_DEFENSIVO.ADD_PRODUCT" \nng-disabled="vm.propriedades.length == 0" ng-click="vm.gotoAdd()">Adicionar insumo no estoque</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.compra_de" md-max-date="vm.args.compra_ate" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.compra_ate" ng-disabled="vm.args.compra_de == null" \nmd-min-date="vm.args.compra_de" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.compra_ate == null">Selecionar</button>\n</div></div></div></div></div></div><div class="col"><md-input-container class="select-custom" flex><label>Fornecedor\n</label><select class="md-block" name="fornecedor" ng-model="vm.args.Fornecedor_id"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="fornecedor in vm.fornecedores" \nng-value="fornecedor.id">{{ fornecedor.nome }}</option></select></md-input-container></div><div class="col">\n<md-input-container class="select-custom" flex><label>Insumo</label><select class="md-block" name="insumo" \nng-model="vm.args.insumo_id"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="insumo in vm.insumos" ng-value="insumo.id">{{ insumo.nome }}</option></select></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom estoque-insumo"><thead><tr><th></th><th \nclass="secondary-text pagination-custom" lm-sort-header="insumo_nome" lm-title="Nome do insumo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. atual / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th></tr></thead><tbody><tr \nclass="default" ng-repeat-start="model in vm.models"><td class="click-button desktop-only"><a \nng-click="vm.openDetail(model)" ng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeDetail(model)" ng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a \nclass="disabled" ng-show="vm.isDetailOpened && !model.isOpen"><md-tooltip md-direction="right">\nS\xF3 \xE9 poss\xEDvel abrir um insumo por vez</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td><td>\n{{ model.insumo_nome }}</td><td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor | finance:false:2}}</td><td class="click-button mobile-only"><a ng-click="vm.openDetail(model)" \nng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeDetail(model)" \nng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" \nng-show="vm.isDetailOpened && !model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr \nng-repeat-end class="details"><td class="main" colspan="5" ng-if="model.isOpen && !model.isLoading"><div \nclass="details-query" ng-if="vm.agrupados.length >= 1"><h2>Detalhes do insumo</h2><table><thead><tr><th>Quant. atual\n</th><th>Quant. comprada</th><th>Loja / Fornecedor</th><th>Data da transa\xE7\xE3o</th><th>Valor pago</th><th>A\xE7\xF5es</th></tr>\n</thead><tbody><tr ng-repeat="item in vm.agrupados"><td>\n{{ item.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\n{{ item.quantidade_origem | number:3 }} {{ model.tipo_medida.descricao }}</td><td>{{ item.fornecedor_nome }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\'}}</td><td>R$ {{ item.valor | finance:false:2 }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoAcerto(item.id)" aria-label="Visualizar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="left">Inserir acerto</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(item)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Deletar o Rateio</md-tooltip></i></md-button></td></tr></tbody></table></div>\n<div class="content-button-inside-table" ng-if="vm.agrupados.length > 0"><md-button class="btn btn-tertiary btn-lg" \naria-label="Voltar" ng-click="vm.gotoHistory(model.id)">Ver hist\xF3rico</md-button></div><div class="no-content" \nng-if="vm.agrupados.length == 0"><i class="far fa-file-alt"></i><p>\nO insumo selecionado n\xE3o foi aplicado em nenhuma \xE1rea.</p></div></td><td colspan="6" ng-if="model.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div>\n</div></div>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/criar.html','<div class="container-header mb-1"><div class="breadcrumb"><h1 translate="INVENTORY_DEFENSIVO.TITLE">\nEstoque insumo defensivo</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column">\n<div class="content" layout="column"><div class="container-content-custom"><banner id="banner-cadastro-defensivo1"><p \nclass="sublinhado"><b>Passo a passo:</b></p><p>- Para adicionar um insumo \xE9 necess\xE1rio preencher os campos <b>\nDADOS DO DEFENSIVOS</b></p><p>- Informe a <b>data da compra, n\xBA do documento</b>\n (nota fiscal ou n\xBA referente a compra do produto - campo n\xE3o obrigat\xF3rio) e a loja / fornecedor.</p><p>\n- Caso a loja/fornecedor n\xE3o esteja na lista, clique no bot\xE3o <b>CADASTRAR LOJA/FORNECEDOR</b> e fa\xE7a uma inclus\xE3o.</p>\n</banner><div class="content-register with-select"><form name="despesaAdminstrativaForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset><md-card class="first-md-card mb-1"><h3>Dados do defensivo</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom" md-delay="500">\n<label translate="INVENTORY_DEFENSIVO.PURCHASE_DATE">Data de compra</label><md-datepicker name="data_compra" \nng-model="vm.model.data_compra" md-placeholder="Inserir data" md-max-date="vm.date" md-open-on-focus required>\n</md-datepicker><div class="errors" ng-messages="despesaAdminstrativaForm.data_compra.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.data_compra.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="20" md-delay="500"><label translate="INVENTORY_DEFENSIVO.DOCUMENT_NUMBER">N\xBA do documento</label><input \ntype="text" name="numero_documento" placeholder="Insira o N\xBA do documento" ng-model="vm.model.numero_documento" \nmaxlength="80"><div class="errors" ng-messages="despesaAdminstrativaForm.numero_documento.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.numero_documento.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex="40" md-delay="500"><label translate="INVENTORY_DEFENSIVO.STORE_OR_SUPPLIER">\nLoja / Fornecedor</label><md-select class="md-block" ng-model="vm.model.cliente_fornecedor_id" \nname="cliente_fornecedor_id" placeholder="Escolher uma loja / fornecedor" required><md-option \nng-repeat="fornecedor_item in vm.fornecedores" ng-value="fornecedor_item.id">{{fornecedor_item.nome}}</md-option>\n</md-select><div ng-messages="despesaAdminstrativaForm.tipoDespesa.$error" \nng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateMarketplace($event,lista_detalhes)">Cadastrar Loja/Fornecedor</a></md-input-container>\n</div></md-card><banner id="banner-cadastro-defensivo2"><p>\n- Selecione um insumo j\xE1 cadastrado, preencha a quantidade, unidade de medida, valor pago e sugerimos que voc\xEA informe a data de validade\n</p><p>para um melhor aproveitamento da ferramenta.</p><p>- <b>Caso o insumo n\xE3o esteja na lista,</b> clique no bot\xE3o \n<b>CADASTRAR INSUMO</b> e fa\xE7a uma inclus\xE3o.</p><p>- Caso a loja/fornecedor n\xE3o esteja na lista, clique no bot\xE3o <b>\nCADASTRAR LOJA/FORNECEDOR</b> e fa\xE7a uma inclus\xE3o.</p></banner><md-card class="first-md-card" \nng-repeat="defensivo in vm.model.estoque"><div style="position: relative;"><h3 style="float:left">\nDefensivo {{defensivo.id}}</h3><md-input-container style="width: 50px; float:right; margin:0;" \nng-if="vm.model.estoque.length > 1"><md-button class="icon-btn md-icon-button float-right" aria-label="remove" \nng-click="vm.removeInsumo($index)"><div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs \nmd-direction="left">Excluir</md-tooltip></i></div></md-button></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="70" md-delay="500"><label \ntranslate="INVENTORY_DEFENSIVO.PRODUCT">Insumo</label><md-select class="md-block" ng-model="defensivo.insumo" \nname="insumo_id" ng-change="vm.changeInsumo(defensivo)" placeholder="Escolher um insumo" required><md-option \nng-repeat="insumo_item in vm.insumos" ng-value="insumo_item">{{insumo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="20"><a class="btn btn-quinary" ng-click="vm.showDialogCreateInsumo($event,defensivo)">Cadastrar Insumo</a>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="35" \nmd-delay="500"><label translate="INVENTORY_DEFENSIVO.QUANTITY">Quantidade</label><input type="text" name="quantidade" \nng-model="defensivo.quantidade" required placeholder="Insira a quantidade" ui-number-mask="3" min="0.001" \nmax="99999.999" ng-change="vm.changeQuantidadeOuUnidadeDeMedida(defensivo)"> <span class="unidade_medida_input">\n{{defensivo.insumo.tipo_medida.descricao}}</span><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35" md-delay="500"><label translate="INVENTORY_DEFENSIVO.AMOUNT_PAID">Valor pago</label>\n<input type="text" name="valor_pago" ng-model="defensivo.valor_pago" ui-money-mask \nng-change="vm.changeQuantidadeOuUnidadeDeMedida(defensivo)" maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor_pago.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.valor_pago.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="25" md-delay="500"><label \ntranslate="INVENTORY_DEFENSIVO.EXPIRATION_DATE">Data de validade</label><md-datepicker name="data_vencimento" \nng-model="defensivo.data_vencimento" md-placeholder="Inserir data" md-open-on-focus></md-datepicker><div \nclass="errors" ng-messages="despesaAdminstrativaForm.data_vencimento.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{despesaAdminstrativaForm.data_vencimento.$api.error.message}}</div>\n</div></md-input-container></div></md-card><div class="row-add-novo"><a class="btn btn-quaternary" \nng-click="vm.addInsumo()" ng-hide="vm.model.despesas.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nAdicionar mais insumos </a><small style="margin-bottom:30px; color: darkgray;">Adicione mais insumos do mesmo documento\n</small></div></fieldset><div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">\nVoltar</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.showConfirm(despesaAdminstrativaForm, vm.model)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/criar_insumo.tmpl.html','<md-dialog class="modal-custom-register"><form name="cadastrarInsumoForm" novalidate="" \napi-form="vm.api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>Adicionar insumo</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="cadastrarInsumoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container md-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">NOME</label><input type="text" \nname="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="insumoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label><md-select class="md-block" \nng-model="vm.model.tipo_medida_id" name="tipo_medida_id" placeholder="Escolher uma tipo de insumo agricola" required>\n<md-option ng-repeat="tipo_medida_item in vm.tipo_medida" ng-value="tipo_medida_item.id">{{tipo_medida_item.nome}}\n</md-option></md-select><div ng-messages="insumoForm.tipo_medida_id.$error" ng-if="insumoForm.tipo_medida_id.$touched">\n<div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.tipo_medida_id.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500" \nng-if="vm.model.insumo_tipo_id == 2"><label translate="CADASTRO_INSUMO.DEFENSIVO">Defensivo</label><md-autocomplete \nrequired flex class="md-block" name="insumo_agricola_nome" md-input-name="insumo_agricola_nome" md-no-cache="false" \nmd-selected-item="vm.model.insumo_agricola" md-selected-item-change="vm.selectedItemChange(item)" \nmd-search-text="listaAgrofitQuery" md-items="item in vm.listaAgrofitSearch(listaAgrofitQuery)" \nmd-item-text="item.nome" md-delay="500" md-require-match placeholder="Insira o produto"><md-item-template><span \nmd-highlight-text="listaAgrofitQuery">{{ item }}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="insumoForm.insumo_agricola_nome.$error" \nng-if="insumoForm.insumo_agricola_nome.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.insumo_agricola_nome.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="cadastrarInsumoForm.$error.required" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/criar_loja.tmpl.html','<md-dialog class="modal-custom-register"><form name="lojaForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar nova loja/fornecedor</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="lojaForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="fornecedorForm.pessoa_tipo.$error" ng-show="fornecedorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CPF"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required placeholder="Insira o CNPJ"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="fornecedorForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" \nng-model="vm.model.endereco.endereco_cep" required ui-br-cep-mask placeholder="Insira o CEP"><div class="errors" \nng-messages="fornecedorForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular\n ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container>\n<md-input-container class="md-block" flex><label translate="CLIENTE.CITY"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div \nclass="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="fornecedorForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="FORNECEDOR.STREET"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container><input \ntype="hidden" ng-model="vm.model.categoria" ng-value="vm.model.categoria = \'insumo\'"></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="lojaForm.$error.required" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/historico.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header mb-1"><h1 translate="INVENTORY_DEFENSIVO.TITLE">\nEstoque insume defensivo</h1></div><banner id="banner-cadastro-defensivo1"><p class="sublinhado"><b>Passo a passo:</b>\n</p><p>- Nessa p\xE1gina voc\xEA visualiza todas as transa\xE7\xF5es feitas no estoque deste insumo.</p><p>\n- Caso queira ver os detalhes, v\xE1 at\xE9 a coluna a\xE7\xE3o e clique no \xEDcone do olho.</p></banner><br><md-card><h3 \ntranslate="INVENTORY_DEFENSIVO.DEFENSIVE_DATA">Dados do defensivo</h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="40"><label translate="INVENTORY_DEFENSIVO.PRODUCT">Produto</label><input \ntype="text" name="quantidade_maquinas" ng-model="vm.estoque_insumo.insumo.nome" disabled="disabled">\n</md-input-container><md-input-container flex><label translate="INVENTORY_DEFENSIVO.CURRENT_AMOUNT">Quantidade</label>\n<input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo.quantidade | number:3 }} {{ vm.estoque_insumo.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label translate="INVENTORY_DEFENSIVO.VALUE_TOTAL">\nValor total</label><input type="text" name="valor_total" ng-model="vm.estoque_insumo.valor" disabled="disabled" \nui-money-mask></md-input-container></div></md-card><div class="container-header"><h3 \ntranslate="INVENTORY_DEFENSIVO.HISTORY" class="historico-titulo">Hist\xF3rico</h3></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom historico-insumo"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="fornecedor" lm-title="Loja / Fornecedor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data" lm-title="Data da transa\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xE3o</span></div>\n</th></tr></thead><tbody><tr class="default" ng-repeat="model in vm.models"><td>{{ model.id }}</td><td>\n{{ model.estoque_insumo_rateio.cliente_fornecedor.nome }}</td><td>{{ model.data_lancamento | date:\'dd/MM/yyyy\'}}</td>\n<td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor_pago | finance:false:2 }}</td><td>{{ model.tipo_acerto }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizarRateio(model.estoque_insumo_rateio.id)" \naria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i>\n</md-button></td></tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear></div></div><lm-paginator lm-args="vm.args"></lm-paginator><div class="content-buttons"><md-button\n class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button></div></div></div>\n</div>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/rateio.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_DEFENSIVO.TITLE">\nEstoque insume defensivo</h1></div><div class="content-register with-select"><form name="custosForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>\nDados do defensivo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label translate="INVENTORY_DEFENSIVO.PURCHASE_DATE">Data de compra</label><md-datepicker \nname="data_aplicacao" ng-model="vm.model.data_compra" md-max-date="vm.date" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_DEFENSIVO.DOCUMENT_NUMBER">N\xBA do documento</label><input type="text" name="numero_documento" \nng-model="vm.model.numero_documento" disabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_DEFENSIVO.STORE_OR_SUPPLIER">Loja / Fornecedor</label><input type="text" \nname="cliente_fornecedor" disabled="disabled" ng-model="vm.model.cliente_fornecedor.nome"></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="INVENTORY_DEFENSIVO.PRODUCT">Insumo</label><input type="text" name="insumo_nome" disabled="disabled" \nng-model="vm.model.insumo.nome"></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_DEFENSIVO.AMOUNT_PAID">Valor pago</label><input type="text" name="valor_pago" disabled="disabled" \nng-model="vm.model.valor" ui-money-mask></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex><label translate="INVENTORY_DEFENSIVO.CURRENT_AMOUNT">Quantidade atual</label>\n<input type="text" name="quantidade" disabled="disabled" \nvalue="{{vm.model.quantidade | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container flex><label translate="INVENTORY_DEFENSIVO.CURRENT_PURCHASED">Quantidade comprada</label><input \ntype="text" name="quantidade_origem" disabled="disabled" \nvalue="{{vm.model.quantidade_origem | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container class="datepicker-custom"><label translate="INVENTORY_DEFENSIVO.EXPIRATION_DATE">Data de validade\n</label><md-datepicker name="data_aplicacao" ng-if="vm.model.data_validade" ng-model="vm.model.data_validade" \ndisabled="disabled"></md-datepicker><input type="text" name="data_validade" ng-if="!vm.model.data_validade" \ndisabled="disabled" ng-model="vm.model.data_validade"></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/defensivo/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="CUSTOS.VIEW_COSTS">Visualizar custos\n</h1></div><div class="content-register with-select"><form name="custosForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3 translate="CUSTOS.DATA_COSTS">\nDados do manejo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" \nng-model="vm.model.data_aplicacao" md-max-date="vm.date" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex="20"><label>Hora da aplica\xE7\xE3o</label><input type="text" name="hora" \nvalue="{{ vm.model.hora_aplicacao | date:\'h:mm\' }}"></md-input-container><md-input-container flex><label \ntranslate="CUSTOS.TYPE_MANAGEMENT">Tipo de manejo</label><input type="text" name="quantidade_profissionais" \nng-model="vm.model.tipo_manejo.descricao"></md-input-container></div></md-card><md-card \nng-if="vm.model.profissionais != \'\'"><h3 translate="CUSTOS.PROFISSIONAIS">Profissionais</h3><div class="profissional" \nng-repeat="profissional in vm.model.profissionais"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_PROFISSIONAL">Tipo de profissional\n</label><input type="text" name="tipo_profissional" ng-model="profissional.tipo_profissional.nome">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.PROFISSIONAL_AMOUNT">Quantidade de profissionais</label><input type="text" \nname="quantidade_profissionais" ng-model="profissional.quantidade_profissional"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas</label><input type="text" \nname="horas_trabalhadas" ui-mask="99:99" ng-model="profissional.quantidade_horas"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input type="text" name="valor_hora" \nng-model="profissional.tipo_profissional.valor_hora" ui-money-mask></md-input-container><md-input-container flex><label\n translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" name="valor_total" \nng-model="profissional.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card \nng-if="vm.model.equipamentos != \'\'"><h3 translate="CUSTOS.MACHINE">M\xE1quinas/Equipamentos</h3><div class="equipamento" \nng-repeat="equipamento in vm.model.equipamentos"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_MACHINE">Tipo de m\xE1quina</label>\n<input type="text" name="tipo_maquina" ng-model="equipamento.equipamento.nome"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="CUSTOS.MACHINE_AMOUNT">\nQuantidade de m\xE1quinas</label><input type="text" name="quantidade_maquinas" ng-model="equipamento.quantidade_maquinas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas\n</label><input type="text" name="horas_trabalhadas" ui-mask="99:99" ng-model="equipamento.quantidade_horas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input \ntype="text" name="valor_hora" ng-model="equipamento.equipamento.valor_hora" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="valor_total" ng-model="equipamento.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card\n ng-if="vm.model.outros != \'\'"><h3 translate="CUSTOS.OTHER_COSTS">Outros custos</h3><div class="outros" \nng-repeat="outro in vm.model.outros"><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex>\n<label translate="CUSTOS.NAME_COSTS">Nome</label><input type="text" name="outro_nome" ng-model="outro.nome" \nmaxlength="15"></md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">\nQuantidade de horas trabalhadas</label><input type="text" name="outra_hora_trabalhada" ui-mask="99:99" \nng-model="outro.quantidade"></md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">\nValor hora</label><input type="text" name="outro_valor" ng-model="outro.valor" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="outro_valor_total" ng-model="outro.valor_total" ui-money-mask></md-input-container></div></div></md-card><div \nclass="split-area"><div class="percent-35 padding-right"><md-card><h3 translate="CUSTOS.WATER_USE">Utiliza\xE7\xE3o de \xE1gua\n</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.TOTAL_LITERS">Total em litros</label><input type="text" name="hora" placeholder="Insira a hora" \nui-number-mask="3" min="0.001" max="99999.999" maxlength="10" ng-model="vm.model.total_litros"></md-input-container>\n</div></md-card></div><div class="percent-65 padding-left"><md-card><h3 translate="CUSTOS.INFO_AREA">\xC1rea</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label>\xC1rea</label><input type="text" \nname="hora" ng-model="vm.model.propriedade_area.nome"></md-input-container></div></md-card></div></div></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/acerto.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_FERTILIZANTE.TITLE">\nEstoque insumo fertilizante</h1></div><div class="content-register with-select"><md-card><h3 \ntranslate="INVENTORY_FERTILIZANTE.DEFENSIVE_DATA">Dados do fertilizante</h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="40"><label translate="INVENTORY_FERTILIZANTE.PRODUCT">Produto</label><input \ntype="text" name="quantidade_maquinas" ng-model="vm.estoque_insumo_rateio.insumo.nome" disabled="disabled">\n</md-input-container><md-input-container flex><label translate="INVENTORY_FERTILIZANTE.CURRENT_AMOUNT">Quantidade\n</label><input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo_rateio.quantidade | number:3 }} {{ vm.estoque_insumo_rateio.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_FERTILIZANTE.VALUE_TOTAL">Valor total</label><input type="text" name="valor_total" \nng-model="vm.estoque_insumo_rateio.valor" disabled="disabled" ui-money-mask></md-input-container></div></md-card><form \nname="despesaAdminstrativaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card \nclass="first-md-card"><h3>Atualiza\xE7\xE3o dos dados do fertilizante</h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex md-delay="500"><label translate="INVENTORY_FERTILIZANTE.QUANTITY">Quantidade\n</label><input type="number" name="quantidade" ng-model="vm.model.quantidade" placeholder="Insira uma quantidade" \nng-change="vm.changeQuantidadeOuUnidadeDeMedida()" min="1" required><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="min">A quantidade deve ser maior ou igual a 1.</div><div ng-message="pattern">Somente n\xFAmeros</div><div \nng-message="number">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="INVENTORY_FERTILIZANTE.TYPE">Tipo</label><md-select \nclass="md-block" ng-model="vm.model.tipo" name="tipo_id" ng-change="vm.changeTipoAcerto()" \nplaceholder="Escolher uma unidade de medida" required><md-option ng-repeat="tipo_item in vm.tipos" \nng-value="tipo_item">{{tipo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-input-has-value" flex md-delay="500" ng-if="vm.model.tipo.id == 1"><label class="md-required" \ntranslate="INVENTORY_FERTILIZANTE.INVENTORY"></label><md-radio-group md-autofocus name="estoque_tipo_id" \nng-change="vm.changeTipoAcerto()" ng-model="vm.model.estoque_tipo_id" layout="row" required><md-radio-button value="1">\nAcrescentar</md-radio-button><md-radio-button value="2">Retirar</md-radio-button></md-radio-group><div \nng-messages="favorecidoForm.estoque_tipo_id.$error" ng-show="favorecidoForm.estoque_tipo_id.$touched"><div \nng-message="required" translate>Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{favorecidoForm.estoque_tipo.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="INVENTORY_FERTILIZANTE.NOTE">Observa\xE7\xE3o</label><input type="text" name="observacao" \nng-model="vm.model.observacao" placeholder="Insira uma observa\xE7\xE3o" maxlength="300"><div class="errors" \nng-messages="despesaAdminstrativaForm.observacao.$error"><div ng-message="api_erro">\n{{despesaAdminstrativaForm.observacao.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset>\n<div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div class="content-buttons">\n<md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button\n type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.save(despesaAdminstrativaForm)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_FERTILIZANTE.TITLE">\nEstoque insume fertilizante</h1></div><md-button class="btn btn-primary" \ntranslate="INVENTORY_FERTILIZANTE.ADD_PRODUCT" ng-disabled="vm.propriedades.length == 0" ng-click="vm.gotoAdd()">\nAdicionar insumo no estoque</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="form-search-horizontal"><form><div \nclass="container"><div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg">\n <span>Filtros</span></div><div class="col periodo"><div class="row-periodo"><div class="select-content">\n<md-input-container class="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.compra_de" md-max-date="vm.args.compra_ate" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.compra_ate" ng-disabled="vm.args.compra_de == null" \nmd-min-date="vm.args.compra_de" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.compra_ate == null">Selecionar</button>\n</div></div></div></div></div></div><div class="col"><md-input-container class="select-custom" flex><label>Fornecedor\n</label><select class="md-block" name="fornecedor" ng-model="vm.args.Fornecedor_id"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="fornecedor in vm.fornecedores" \nng-value="fornecedor.id">{{ fornecedor.nome }}</option></select></md-input-container></div><div class="col">\n<md-input-container class="select-custom" flex><label>Insumo</label><select class="md-block" name="insumo" \nng-model="vm.args.insumo_id"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="insumo in vm.insumos" ng-value="insumo.id">{{ insumo.nome }}</option></select></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom estoque-insumo"><thead><tr><th></th><th \nclass="secondary-text pagination-custom" lm-sort-header="insumo_nome" lm-title="Nome do insumo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. atual / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th></tr></thead><tbody><tr \nclass="default" ng-repeat-start="model in vm.models"><td class="click-button desktop-only"><a \nng-click="vm.openDetail(model)" ng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeDetail(model)" ng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a \nclass="disabled" ng-show="vm.isDetailOpened && !model.isOpen"><md-tooltip md-direction="right">\nS\xF3 \xE9 poss\xEDvel abrir um insumo por vez</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td><td>\n{{ model.insumo_nome }}</td><td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor | finance:false:2}}</td><td class="click-button mobile-only"><a ng-click="vm.openDetail(model)" \nng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeDetail(model)" \nng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" \nng-show="vm.isDetailOpened && !model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr \nng-repeat-end class="details"><td class="main" colspan="5" ng-if="model.isOpen && !model.isLoading"><div \nclass="details-query" ng-if="vm.agrupados.length >= 1"><h2>Detalhes do insumo</h2><table><thead><tr><th>Quant. atual\n</th><th>Quant. comprada</th><th>Loja / Fornecedor</th><th>Data da transa\xE7\xE3o</th><th>Valor pago</th><th>A\xE7\xF5es</th></tr>\n</thead><tbody><tr ng-repeat="item in vm.agrupados"><td>\n{{ item.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\n{{ item.quantidade_origem | number:3 }} {{ model.tipo_medida.descricao }}</td><td>{{ item.fornecedor_nome }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\'}}</td><td>R$ {{ item.valor | finance:false:2 }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoAcerto(item.id)" aria-label="Visualizar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="left">Inserir acerto</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(item)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Deletar o Rateio</md-tooltip></i></md-button></td></tr></tbody></table></div>\n<div class="content-button-inside-table" ng-if="vm.agrupados.length > 0"><md-button class="btn btn-tertiary btn-lg" \naria-label="Voltar" ng-click="vm.gotoHistory(model.id)">Ver hist\xF3rico</md-button></div><div class="no-content" \nng-if="vm.agrupados.length == 0"><i class="far fa-file-alt"></i><p>\nO insumo selecionado n\xE3o foi aplicado em nenhuma \xE1rea.</p></div></td><td colspan="6" ng-if="model.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div>\n</div></div>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_FERTILIZANTE.TITLE">\nEstoque insumo fertilizante</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" \nlayout="column"><div class="content" layout="column"><div class="container-content-custom"><div \nclass="content-register with-select"><form name="despesaAdminstrativaForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card class="first-md-card"><h3>Dados do fertilizante</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom" md-delay="500"><label \ntranslate="INVENTORY_FERTILIZANTE.PURCHASE_DATE">Data de compra</label><md-datepicker name="data_compra" \nng-model="vm.model.data_compra" md-placeholder="Inserir data" md-max-date="vm.date" md-open-on-focus required>\n</md-datepicker><div class="errors" ng-messages="despesaAdminstrativaForm.data_compra.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.data_compra.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="20" md-delay="500"><label translate="INVENTORY_FERTILIZANTE.DOCUMENT_NUMBER">N\xBA do documento</label><input \ntype="text" name="numero_documento" placeholder="Insira o N\xBA do documento" ng-model="vm.model.numero_documento" \nmaxlength="80"><div class="errors" ng-messages="despesaAdminstrativaForm.numero_documento.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.numero_documento.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex="40" md-delay="500"><label translate="INVENTORY_FERTILIZANTE.STORE_OR_SUPPLIER">\nLoja / Fornecedor</label><md-select class="md-block" ng-model="vm.model.cliente_fornecedor_id" \nname="cliente_fornecedor_id" placeholder="Escolher uma loja / fornecedor" required><md-option \nng-repeat="fornecedor_item in vm.fornecedores" ng-value="fornecedor_item.id">{{fornecedor_item.nome}}</md-option>\n</md-select><div ng-messages="despesaAdminstrativaForm.tipoDespesa.$error" \nng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateMarketplace($event,lista_detalhes)">Cadastrar Loja/Fornecedor</a></md-input-container>\n</div></md-card><md-card class="first-md-card" ng-repeat="fertilizante in vm.model.estoque"><div \nstyle="position: relative;"><h3 style="float:left">Fertilizante {{fertilizante.id}}</h3><md-input-container \nstyle="width: 50px; float:right; margin:0;" ng-if="vm.model.estoque.length > 1"><md-button \nclass="icon-btn md-icon-button float-right" aria-label="remove" ng-click="vm.removeInsumo($index)"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex="70" md-delay="500"><label translate="INVENTORY_FERTILIZANTE.PRODUCT">\nInsumo</label><md-select class="md-block" ng-model="fertilizante.insumo" name="insumo_id" \nng-change="vm.changeInsumo(fertilizante)" placeholder="Escolher um insumo" required><md-option \nng-repeat="insumo_item in vm.insumos" ng-value="insumo_item">{{insumo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="20"><a class="btn btn-quinary" ng-click="vm.showDialogCreateInsumo($event,fertilizante)">Cadastrar Insumo</a>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="35" \nmd-delay="500"><label translate="INVENTORY_FERTILIZANTE.QUANTITY">Quantidade</label><input type="text" \nname="quantidade" ng-model="fertilizante.quantidade" required placeholder="Insira a quantidade" ui-number-mask="3" \nmin="0.001" max="99999.999" ng-change="vm.changeQuantidadeOuUnidadeDeMedida(fertilizante)"> <span \nclass="unidade_medida_input">{{fertilizante.insumo.tipo_medida.descricao}}</span><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35" md-delay="500"><label translate="INVENTORY_FERTILIZANTE.AMOUNT_PAID">Valor pago</label>\n<input type="text" name="valor_pago" ng-model="fertilizante.valor_pago" ui-money-mask \nng-change="vm.changeQuantidadeOuUnidadeDeMedida(fertilizante)" maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor_pago.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.valor_pago.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="25" md-delay="500"><label \ntranslate="INVENTORY_FERTILIZANTE.EXPIRATION_DATE">Data de validade</label><md-datepicker name="data_vencimento" \nng-model="fertilizante.data_vencimento" md-placeholder="Inserir data" md-open-on-focus></md-datepicker><div \nclass="errors" ng-messages="despesaAdminstrativaForm.data_vencimento.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{despesaAdminstrativaForm.data_vencimento.$api.error.message}}</div>\n</div></md-input-container></div></md-card><div class="row-add-novo"><a class="btn btn-quaternary" \nng-click="vm.addInsumo()" ng-hide="vm.model.despesas.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nAdicionar mais insumos </a><small style="margin-bottom:30px; color: darkgray;">Adicione mais insumos do mesmo documento\n</small></div></fieldset><div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">\nVoltar</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.showConfirm(despesaAdminstrativaForm, vm.model)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/criar_insumo.tmpl.html','<md-dialog class="modal-custom-register"><form name="cadastrarInsumoForm" novalidate="" \napi-form="vm.api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>Adicionar insumo</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="cadastrarInsumoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container md-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">NOME</label><input type="text" \nname="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="insumoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label><md-select class="md-block" \nng-model="vm.model.tipo_medida_id" name="tipo_medida_id" placeholder="Escolher uma tipo de insumo agricola" required>\n<md-option ng-repeat="tipo_medida_item in vm.tipo_medida" ng-value="tipo_medida_item.id">{{tipo_medida_item.nome}}\n</md-option></md-select><div ng-messages="insumoForm.tipo_medida_id.$error" ng-if="insumoForm.tipo_medida_id.$touched">\n<div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.tipo_medida_id.$api.error.message}}</div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="cadastrarInsumoForm.$error.required" ng-click="vm.save(vm.model)">\nCadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/criar_loja.tmpl.html','<md-dialog class="modal-custom-register"><form name="lojaForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar nova loja/fornecedor</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="lojaForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="fornecedorForm.pessoa_tipo.$error" ng-show="fornecedorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CPF"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required placeholder="Insira o CNPJ"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="fornecedorForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" \nng-model="vm.model.endereco.endereco_cep" required ui-br-cep-mask placeholder="Insira o CEP"><div class="errors" \nng-messages="fornecedorForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular\n ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container>\n<md-input-container class="md-block" flex><label translate="CLIENTE.CITY"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div \nclass="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="fornecedorForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="FORNECEDOR.STREET"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container><input \ntype="hidden" ng-model="vm.model.categoria" ng-value="vm.model.categoria = \'insumo\'"></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="lojaForm.$error.required" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/historico.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_FERTILIZANTE.TITLE">\nEstoque insume fertilizante</h1></div><br><md-card><h3 translate="INVENTORY_FERTILIZANTE.DEFENSIVE_DATA">\nDados do fertilizante</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="40"><label \ntranslate="INVENTORY_FERTILIZANTE.PRODUCT">Produto</label><input type="text" name="quantidade_maquinas" \nng-model="vm.estoque_insumo.insumo.nome" disabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_FERTILIZANTE.CURRENT_AMOUNT">Quantidade</label><input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo.quantidade | number:3 }} {{ vm.estoque_insumo.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_FERTILIZANTE.VALUE_TOTAL">Valor total</label><input type="text" name="valor_total" \nng-model="vm.estoque_insumo.valor" disabled="disabled" ui-money-mask></md-input-container></div></md-card><div \nclass="container-header"><h3 translate="INVENTORY_FERTILIZANTE.HISTORY" class="historico-titulo">Hist\xF3rico</h3></div>\n<div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border \nhover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom historico-insumo"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="fornecedor" lm-title="Loja / Fornecedor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data" lm-title="Data da transa\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xE3o</span></div>\n</th></tr></thead><tbody><tr class="default" ng-repeat="model in vm.models"><td>{{ model.id }}</td><td>\n{{ model.estoque_insumo_rateio.cliente_fornecedor.nome }}</td><td>{{ model.data_lancamento | date:\'dd/MM/yyyy\'}}</td>\n<td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor_pago | finance:false:2 }}</td><td>{{ model.tipo_acerto }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizarRateio(model.estoque_insumo_rateio.id)" \naria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i>\n</md-button></td></tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear></div></div><lm-paginator lm-args="vm.args"></lm-paginator><div class="content-buttons"><md-button\n class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button></div></div></div>\n</div>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/rateio.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_FERTILIZANTE.TITLE">\nEstoque insumo fertilizante</h1></div><div class="content-register with-select"><form name="custosForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>\nDados do fertilizante</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label translate="INVENTORY_FERTILIZANTE.PURCHASE_DATE">Data de compra</label><md-datepicker \nname="data_aplicacao" ng-model="vm.model.data_compra" md-max-date="vm.date" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_FERTILIZANTE.DOCUMENT_NUMBER">N\xBA do documento</label><input type="text" name="numero_documento" \nng-model="vm.model.numero_documento" disabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_FERTILIZANTE.STORE_OR_SUPPLIER">Loja / Fornecedor</label><input type="text" \nname="cliente_fornecedor" disabled="disabled" ng-model="vm.model.cliente_fornecedor.nome"></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="INVENTORY_FERTILIZANTE.PRODUCT">Insumo</label><input type="text" name="insumo_nome" disabled="disabled" \nng-model="vm.model.insumo.nome"></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_FERTILIZANTE.AMOUNT_PAID">Valor pago</label><input type="text" name="valor_pago" \ndisabled="disabled" ng-model="vm.model.valor" ui-money-mask></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="INVENTORY_FERTILIZANTE.CURRENT_AMOUNT">\nQuantidade atual</label><input type="text" name="quantidade" disabled="disabled" \nvalue="{{vm.model.quantidade | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container flex><label translate="INVENTORY_FERTILIZANTE.CURRENT_PURCHASED">Quantidade comprada</label><input \ntype="text" name="quantidade_origem" disabled="disabled" \nvalue="{{vm.model.quantidade_origem | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container class="datepicker-custom"><label>Data de validade</label><md-datepicker name="data_aplicacao" \nng-if="vm.model.data_validade" ng-model="vm.model.data_validade" disabled="disabled"></md-datepicker><input \ntype="text" name="data_validade" ng-if="!vm.model.data_validade" disabled="disabled" ng-model="vm.model.data_validade">\n</md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/fertilizante/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="CUSTOS.VIEW_COSTS">Visualizar custos\n</h1></div><div class="content-register with-select"><form name="custosForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3 translate="CUSTOS.DATA_COSTS">\nDados do manejo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" \nng-model="vm.model.data_aplicacao" md-max-date="vm.date" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex="20"><label>Hora da aplica\xE7\xE3o</label><input type="text" name="hora" \nvalue="{{ vm.model.hora_aplicacao | date:\'h:mm\' }}"></md-input-container><md-input-container flex><label \ntranslate="CUSTOS.TYPE_MANAGEMENT">Tipo de manejo</label><input type="text" name="quantidade_profissionais" \nng-model="vm.model.tipo_manejo.descricao"></md-input-container></div></md-card><md-card \nng-if="vm.model.profissionais != \'\'"><h3 translate="CUSTOS.PROFISSIONAIS">Profissionais</h3><div class="profissional" \nng-repeat="profissional in vm.model.profissionais"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_PROFISSIONAL">Tipo de profissional\n</label><input type="text" name="tipo_profissional" ng-model="profissional.tipo_profissional.nome">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.PROFISSIONAL_AMOUNT">Quantidade de profissionais</label><input type="text" \nname="quantidade_profissionais" ng-model="profissional.quantidade_profissional"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas</label><input type="text" \nname="horas_trabalhadas" ui-mask="99:99" ng-model="profissional.quantidade_horas"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input type="text" name="valor_hora" \nng-model="profissional.tipo_profissional.valor_hora" ui-money-mask></md-input-container><md-input-container flex><label\n translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" name="valor_total" \nng-model="profissional.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card \nng-if="vm.model.equipamentos != \'\'"><h3 translate="CUSTOS.MACHINE">M\xE1quinas/Equipamentos</h3><div class="equipamento" \nng-repeat="equipamento in vm.model.equipamentos"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_MACHINE">Tipo de m\xE1quina</label>\n<input type="text" name="tipo_maquina" ng-model="equipamento.equipamento.nome"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="CUSTOS.MACHINE_AMOUNT">\nQuantidade de m\xE1quinas</label><input type="text" name="quantidade_maquinas" ng-model="equipamento.quantidade_maquinas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas\n</label><input type="text" name="horas_trabalhadas" ui-mask="99:99" ng-model="equipamento.quantidade_horas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input \ntype="text" name="valor_hora" ng-model="equipamento.equipamento.valor_hora" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="valor_total" ng-model="equipamento.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card\n ng-if="vm.model.outros != \'\'"><h3 translate="CUSTOS.OTHER_COSTS">Outros custos</h3><div class="outros" \nng-repeat="outro in vm.model.outros"><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex>\n<label translate="CUSTOS.NAME_COSTS">Nome</label><input type="text" name="outro_nome" ng-model="outro.nome" \nmaxlength="15"></md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">\nQuantidade de horas trabalhadas</label><input type="text" name="outra_hora_trabalhada" ui-mask="99:99" \nng-model="outro.quantidade"></md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">\nValor hora</label><input type="text" name="outro_valor" ng-model="outro.valor" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="outro_valor_total" ng-model="outro.valor_total" ui-money-mask></md-input-container></div></div></md-card><div \nclass="split-area"><div class="percent-35 padding-right"><md-card><h3 translate="CUSTOS.WATER_USE">Utiliza\xE7\xE3o de \xE1gua\n</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.TOTAL_LITERS">Total em litros</label><input type="text" name="hora" placeholder="Insira a hora" \nui-number-mask="3" min="0.001" max="99999.999" maxlength="10" ng-model="vm.model.total_litros"></md-input-container>\n</div></md-card></div><div class="percent-65 padding-left"><md-card><h3 translate="CUSTOS.INFO_AREA">\xC1rea</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label>\xC1rea</label><input type="text" \nname="hora" ng-model="vm.model.propriedade_area.nome"></md-input-container></div></md-card></div></div></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/semente/views/acerto.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_SEMENTE.TITLE">\nEstoque insumo semente</h1></div><div class="content-register with-select"><md-card><h3>Dados da semente</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="40"><label \ntranslate="INVENTORY_SEMENTE.PRODUCT">Produto</label><input type="text" name="quantidade_maquinas" \nng-model="vm.estoque_insumo_rateio.insumo.nome" disabled="disabled"></md-input-container><md-input-container flex>\n<label translate="INVENTORY_SEMENTE.CURRENT_AMOUNT">Quantidade</label><input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo_rateio.quantidade | number:3 }} {{ vm.estoque_insumo_rateio.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label translate="INVENTORY_SEMENTE.VALUE_TOTAL">\nValor total</label><input type="text" name="valor_total" ng-model="vm.estoque_insumo_rateio.valor" disabled="disabled" \nui-money-mask></md-input-container></div></md-card><form name="despesaAdminstrativaForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset><md-card class="first-md-card"><h3>\nAtualiza\xE7\xE3o dos dados da semente</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex \nmd-delay="500"><label translate="INVENTORY_SEMENTE.QUANTITY">Quantidade</label><input type="number" name="quantidade" \nng-model="vm.model.quantidade" placeholder="Insira uma quantidade" ng-change="vm.changeQuantidadeOuUnidadeDeMedida()" \nmin="1" required><div class="errors" ng-messages="despesaAdminstrativaForm.quantidade.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">A quantidade deve ser maior ou igual a 1.</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="number">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="INVENTORY_SEMENTE.TYPE">Tipo</label><md-select \nclass="md-block" ng-model="vm.model.tipo" name="tipo_id" ng-change="vm.changeTipoAcerto()" \nplaceholder="Escolher uma unidade de medida" required><md-option ng-repeat="tipo_item in vm.tipos" \nng-value="tipo_item">{{tipo_item.nome}}</md-option></md-select><div \nng-messages="despesaAdminstrativaForm.tipoDespesa.$error" ng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-input-has-value" flex md-delay="500" ng-if="vm.model.tipo.id == 1"><label class="md-required" \ntranslate="INVENTORY_SEMENTE.INVENTORY"></label><md-radio-group md-autofocus name="estoque_tipo_id" \nng-change="vm.changeTipoAcerto()" ng-model="vm.model.estoque_tipo_id" layout="row" required><md-radio-button value="1">\nAcrescentar</md-radio-button><md-radio-button value="2">Retirar</md-radio-button></md-radio-group><div \nng-messages="favorecidoForm.estoque_tipo_id.$error" ng-show="favorecidoForm.estoque_tipo_id.$touched"><div \nng-message="required" translate>Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{favorecidoForm.estoque_tipo.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="INVENTORY_SEMENTE.NOTE">\nObserva\xE7\xE3o</label><input type="text" name="observacao" ng-model="vm.model.observacao" \nplaceholder="Insira uma observa\xE7\xE3o" maxlength="300"><div class="errors" \nng-messages="despesaAdminstrativaForm.observacao.$error"><div ng-message="api_erro">\n{{despesaAdminstrativaForm.observacao.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset>\n<div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div class="content-buttons">\n<md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button\n type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.save(despesaAdminstrativaForm)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/semente/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 \ntranslate="INVENTORY_SEMENTE.TITLE">Estoque insume semente</h1></div><div class="tutorial" \nng-click="vm.viewTutorial()"><img src="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>\nAssista o passo a passo</span></div></div><md-button class="btn btn-primary" translate="INVENTORY_SEMENTE.ADD_PRODUCT" \nng-disabled="vm.propriedades.length == 0" ng-click="vm.gotoAdd()">Adicionar insumo no estoque</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.compra_de" md-max-date="vm.args.compra_ate" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.compra_ate" ng-disabled="vm.args.compra_de == null" \nmd-min-date="vm.args.compra_de" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.compra_ate == null">Selecionar</button>\n</div></div></div></div></div></div><div class="col"><md-input-container class="select-custom" flex><label>Fornecedor\n</label><select class="md-block" name="fornecedor" ng-model="vm.args.Fornecedor_id"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="fornecedor in vm.fornecedores" \nng-value="fornecedor.id">{{ fornecedor.nome }}</option></select></md-input-container></div><div class="col">\n<md-input-container class="select-custom" flex><label>Insumo</label><select class="md-block" name="insumo" \nng-model="vm.args.insumo_id"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="insumo in vm.insumos" ng-value="insumo.id">{{ insumo.nome }}</option></select></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom estoque-insumo"><thead><tr><th></th><th \nclass="secondary-text pagination-custom" lm-sort-header="insumo_nome" lm-title="Nome do insumo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="semente_cultura" lm-title="Cultura"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. atual / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th></tr></thead><tbody><tr \nclass="default" ng-repeat-start="model in vm.models"><td class="click-button desktop-only"><a \nng-click="vm.openDetail(model)" ng-hide="model.isOpen"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeDetail(model)" ng-hide="!model.isOpen"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a \nclass="disabled" ng-show="vm.isDetailOpened && !model.isOpen"><md-tooltip md-direction="right">\nS\xF3 \xE9 poss\xEDvel abrir um insumo por vez</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td><td>\n{{ model.insumo_nome }}</td><td>{{ model.cultura_nome }}</td><td>\n{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>R$ {{ model.valor | finance:false:2}}</td>\n<td class="click-button mobile-only"><a ng-click="vm.openDetail(model)" ng-hide="model.isOpen"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeDetail(model)" ng-hide="!model.isOpen"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="vm.isDetailOpened && !model.isOpen">\n<md-icon md-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr ng-repeat-end class="details"><td class="main" \ncolspan="5" ng-if="model.isOpen && !model.isLoading"><div class="details-query" ng-if="vm.agrupados.length >= 1"><h2>\nDetalhes do insumo</h2><table><thead><tr><th>Quant. atual</th><th>Quant. comprada</th><th>Loja / Fornecedor</th><th>\nData da transa\xE7\xE3o</th><th>Valor pago</th><th>A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="item in vm.agrupados"><td>\n{{ item.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\n{{ item.quantidade_origem | number:3 }} {{ model.tipo_medida.descricao }}</td><td>{{ item.fornecedor_nome }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\'}}</td><td>R$ {{ item.valor | finance:false:2 }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoAcerto(item.id)" aria-label="Visualizar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="left">Inserir acerto</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(item)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Deletar o Rateio</md-tooltip></i></md-button></td></tr></tbody></table></div>\n<div class="content-button-inside-table" ng-if="vm.agrupados.length > 0"><md-button class="btn btn-tertiary btn-lg" \naria-label="Voltar" ng-click="vm.gotoHistory(model.id)">Ver hist\xF3rico</md-button></div><div class="no-content" \nng-if="vm.agrupados.length == 0"><i class="far fa-file-alt"></i><p>\nO insumo selecionado n\xE3o foi aplicado em nenhuma \xE1rea.</p></div></td><td colspan="6" ng-if="model.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/estoque_insumo/semente/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="INVENTORY_SEMENTE.TITLE">Estoque insumo semente\n</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register with-select"><form \nname="despesaAdminstrativaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card \nclass="first-md-card"><h3>Dados do semente</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom" md-delay="500"><label translate="INVENTORY_SEMENTE.PURCHASE_DATE">\nData de compra</label><md-datepicker name="data_compra" ng-model="vm.model.data_compra" md-placeholder="Inserir data" \nmd-max-date="vm.date" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="despesaAdminstrativaForm.data_compra.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.data_compra.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20" md-delay="500"><label translate="INVENTORY_SEMENTE.DOCUMENT_NUMBER">N\xBA do documento\n</label><input type="text" name="numero_documento" placeholder="Insira o N\xBA do documento" \nng-model="vm.model.numero_documento" maxlength="80"><div class="errors" \nng-messages="despesaAdminstrativaForm.numero_documento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.numero_documento.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="40" md-delay="500"><label \ntranslate="INVENTORY_SEMENTE.STORE_OR_SUPPLIER">Loja / Fornecedor</label><md-select class="md-block" \nng-model="vm.model.cliente_fornecedor_id" name="cliente_fornecedor_id" placeholder="Escolher uma loja / fornecedor" \nrequired><md-option ng-repeat="fornecedor_item in vm.fornecedores" ng-value="fornecedor_item.id">\n{{fornecedor_item.nome}}</md-option></md-select><div ng-messages="despesaAdminstrativaForm.tipoDespesa.$error" \nng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateMarketplace($event,lista_detalhes)">Cadastrar Loja/Fornecedor</a></md-input-container>\n</div></md-card><md-card class="first-md-card" ng-repeat="semente in vm.model.estoque"><div \nstyle="position: relative;"><h3 style="float:left">Semente {{semente.id}}</h3><md-input-container \nstyle="width: 50px; float:right; margin:0;" ng-if="vm.model.estoque.length > 1"><md-button \nclass="icon-btn md-icon-button float-right" aria-label="remove" ng-click="vm.removeInsumo($index)"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip>\n</i></div></md-button></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex="70" md-delay="500"><label translate="INVENTORY_SEMENTE.PRODUCT">Insumo\n</label><md-select class="md-block" ng-model="semente.insumo" name="insumo_id" ng-change="vm.changeInsumo(semente)" \nplaceholder="Escolher um insumo" required><md-option ng-repeat="insumo_item in vm.insumos" ng-value="insumo_item">\n{{insumo_item.nome}}</md-option></md-select><div ng-messages="despesaAdminstrativaForm.tipoDespesa.$error" \nng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="20"><a class="btn btn-quinary" ng-click="vm.showDialogCreateInsumo($event,semente)">\nCadastrar Insumo</a></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="30" md-delay="500" ng-if="semente.unidade_medida.tipo_medida_id != 3"><label \ntranslate="INVENTORY_SEMENTE.QUANTITY">Quantidade</label><input type="text" name="quantidade" \nng-model="semente.quantidade" required placeholder="Insira a quantidade" ui-number-mask="3" min="0.0001" \nmax="99999.9999" ng-change="vm.changeQuantidadeOuUnidadeDeMedida(semente)"> <span class="unidade_medida_input">\n{{semente.insumo.tipo_medida.descricao}}</span><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35" md-delay="500" ng-if="semente.unidade_medida.tipo_medida_id == 3"><label \ntranslate="INVENTORY_SEMENTE.QUANTITY">Quantidade</label><input type="text" name="quantidade" \nng-model="semente.quantidade" required placeholder="Insira a quantidade" ui-number-mask="0" min="1" max="999.999.999" \nng-change="vm.changeQuantidadeOuUnidadeDeMedida(semente)"> <span class="unidade_medida_input">\n{{semente.insumo.tipo_medida.descricao}}</span><div class="errors" \nng-messages="despesaAdminstrativaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.quantidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35" md-delay="500"><label translate="INVENTORY_SEMENTE.AMOUNT_PAID">Valor pago</label><input \ntype="text" name="valor_pago" ng-model="semente.valor_pago" ui-money-mask \nng-change="vm.changeQuantidadeOuUnidadeDeMedida(semente)" maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor_pago.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.valor_pago.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="datepicker-custom" flex="25" md-delay="500"><label \ntranslate="INVENTORY_SEMENTE.EXPIRATION_DATE">Data de validade</label><md-datepicker name="data_vencimento" \nng-model="semente.data_vencimento" md-placeholder="Inserir data" md-open-on-focus></md-datepicker><div class="errors" \nng-messages="despesaAdminstrativaForm.data_vencimento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.data_vencimento.$api.error.message}}</div></div></md-input-container>\n</div></md-card><div class="row-add-novo"><a class="btn btn-quaternary" ng-click="vm.addInsumo()" \nng-hide="vm.model.despesas.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar mais insumos </a>\n<small style="margin-bottom:30px; color: darkgray;">Adicione mais insumos do mesmo documento</small></div></fieldset>\n<div api-form-validation-summary form="despesaAdminstrativaForm"></div></form></div><div class="content-buttons">\n<md-button class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button\n type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.showConfirm(despesaAdminstrativaForm, vm.model)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/semente/views/criar_insumo.tmpl.html','<md-dialog class="modal-custom-register"><form name="cadastrarInsumoForm" novalidate="" \napi-form="vm.api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>Adicionar insumo</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="cadastrarInsumoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container md-delay="500" flex><label translate="CADASTRO_INSUMO.NOME">NOME</label><input type="text" \nname="nome" ng-model="vm.model.nome" required><div class="errors" ng-messages="insumoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="select-custom" flex="30" md-delay="500"><label \ntranslate="CADASTRO_INSUMO.TIPO_MEDIDA">Tipo de medida</label><input type="text" name="medida" value="Kg" \ndisabled="disabled"></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="select-custom" flex md-delay="500" ng-if="vm.model.insumo_tipo_id == 4"><label>Cultura\n</label><md-autocomplete required flex class="md-block" md-input-name="cultura" md-no-cache="false" \nmd-selected-item="vm.model.cultura" md-search-text="culturaQuery" md-items="item in vm.culturaSearch(culturaQuery)" \nmd-item-text="item.nome" md-delay="500" md-require-match placeholder="Buscar cultura"><md-item-template><span \nmd-highlight-text="vm.model.cultura">{{item.nome}}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="insumoForm.CulturaId.$error" ng-if="insumoForm.CulturaId.$touched">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="md-require-match">\nPor favor, digite uma cultura v\xE1lida</div><div ng-message="api_erro">{{insumoForm.cultura.$api.error.message}}</div>\n</div></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><md-button \nclass="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button><md-button class="btn btn-primary" \nng-disabled="cadastrarInsumoForm.$error.required" ng-click="vm.save(vm.model)">Cadastrar</md-button>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/semente/views/criar_loja.tmpl.html','<md-dialog class="modal-custom-register"><form name="lojaForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar nova loja/fornecedor</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="lojaForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="fornecedorForm.pessoa_tipo.$error" ng-show="fornecedorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="14" ui-br-cpf-mask required placeholder="Insira o CPF"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required placeholder="Insira o CNPJ"><div class="errors" \nng-messages="fornecedorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{fornecedorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" maxlength="50" required placeholder="Insira o nome"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" ng-model="vm.model.nome" required placeholder="Insira a raz\xE3o social"><div class="errors" \nng-messages="fornecedorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{fornecedorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" maxlength="2" \nng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" ng-messages="fornecedorForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{fornecedorForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nmask="9?9999-9999" required placeholder="Telefone"><div class="errors" ng-messages="fornecedorForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" \nng-model="vm.model.endereco.endereco_cep" required ui-br-cep-mask placeholder="Insira o CEP"><div class="errors" \nng-messages="fornecedorForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{fornecedorForm.cep.$api.error.message}}</div></div><md-progress-circular\n ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container>\n<md-input-container class="md-block" flex><label translate="CLIENTE.CITY"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF"></label><input type="text" name="uf" \nng-model="vm.model.endereco.endereco_uf" placeholder="UF" maxlength="2" ng-pattern="/^[a-zA-Z]*$/" required><div \nclass="errors" ng-messages="fornecedorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente letras</div><div ng-message="api_erro">{{fornecedorForm.uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex="25" class="md-block"><label translate="CLIENTE.BAIRRO"></label>\n<input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" maxlength="30" \nplaceholder="Insira o bairro" required><div class="errors" ng-messages="fornecedorForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{fornecedorForm.bairro.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label translate="FORNECEDOR.STREET"></label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="fornecedorForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.endereco.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="10"><label translate="CLIENTE.NUMERO"></label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="fornecedorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="md-block" flex="20"><label translate="CLIENTE.COMPLEMENTO"></label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="fornecedorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{fornecedorForm.complemento.$api.error.message}}</div></div></md-input-container><input \ntype="hidden" ng-model="vm.model.categoria" ng-value="vm.model.categoria = \'insumo\'"></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="lojaForm.$error.required" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/estoque_insumo/semente/views/historico.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_SEMENTE.TITLE">\nEstoque insume semente</h1></div><br><md-card><h3 translate="INVENTORY_SEMENTE.DEFENSIVE_DATA">Dados do semente</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="40"><label \ntranslate="INVENTORY_SEMENTE.PRODUCT">Produto</label><input type="text" name="quantidade_maquinas" \nng-model="vm.estoque_insumo.insumo.nome" disabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_SEMENTE.CURRENT_AMOUNT">Quantidade</label><input type="text" name="valor_hora" \nvalue="{{ vm.estoque_insumo.quantidade | number:3 }} {{ vm.estoque_insumo.tipo_medida.descricao }}" \ndisabled="disabled"></md-input-container><md-input-container flex><label translate="INVENTORY_SEMENTE.VALUE_TOTAL">\nValor total</label><input type="text" name="valor_total" ng-model="vm.estoque_insumo.valor" disabled="disabled" \nui-money-mask></md-input-container></div></md-card><div class="container-header"><h3 \ntranslate="INVENTORY_SEMENTE.HISTORY" class="historico-titulo">Hist\xF3rico</h3></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom historico-insumo"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="fornecedor" lm-title="Loja / Fornecedor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data" lm-title="Data da transa\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quanti. / Unid."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor pago"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xE3o</span></div>\n</th></tr></thead><tbody><tr class="default" ng-repeat="model in vm.models"><td>{{ model.id }}</td><td>\n{{ model.estoque_insumo_rateio.cliente_fornecedor.nome }}</td><td>{{ model.data_lancamento | date:\'dd/MM/yyyy\'}}</td>\n<td>{{ model.quantidade | number:3 }} {{ model.tipo_medida.descricao }}</td><td>\nR$ {{ model.valor_pago | finance:false:2 }}</td><td>{{ model.tipo_acerto }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizarRateio(model.estoque_insumo_rateio.id)" \naria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i>\n</md-button></td></tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear></div></div><lm-paginator lm-args="vm.args"></lm-paginator><div class="content-buttons"><md-button\n class="btn btn-secondary btn-lg" aria-label="Voltar" ng-click="vm.gotoSearch()">Voltar</md-button></div></div></div>\n</div>');
$templateCache.put('app/main/estoque_insumo/semente/views/rateio.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="INVENTORY_SEMENTE.TITLE">\nEstoque insumo semente</h1></div><div class="content-register with-select"><form name="custosForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>\nDados do semente</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label translate="INVENTORY_SEMENTE.PURCHASE_DATE">Data de compra</label><md-datepicker \nname="data_aplicacao" ng-model="vm.model.data_compra" md-max-date="vm.date" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex="20"><label \ntranslate="INVENTORY_SEMENTE.DOCUMENT_NUMBER">N\xBA do documento</label><input type="text" name="numero_documento" \nng-model="vm.model.numero_documento" disabled="disabled"></md-input-container><md-input-container flex><label \ntranslate="INVENTORY_SEMENTE.STORE_OR_SUPPLIER">Loja / Fornecedor</label><input type="text" name="cliente_fornecedor" \ndisabled="disabled" ng-model="vm.model.cliente_fornecedor.nome"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="INVENTORY_SEMENTE.PRODUCT">Insumo</label>\n<input type="text" name="insumo_nome" disabled="disabled" ng-model="vm.model.insumo.nome"></md-input-container>\n<md-input-container flex="20"><label translate="INVENTORY_SEMENTE.AMOUNT_PAID">Valor pago</label><input type="text" \nname="valor_pago" disabled="disabled" ng-model="vm.model.valor" ui-money-mask></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="INVENTORY_SEMENTE.CURRENT_AMOUNT">Quantidade atual</label><input type="text" name="quantidade" \ndisabled="disabled" value="{{vm.model.quantidade | number:3 }} {{ vm.model.tipo_medida.descricao }}">\n</md-input-container><md-input-container flex><label translate="INVENTORY_SEMENTE.CURRENT_PURCHASED">\nQuantidade comprada</label><input type="text" name="quantidade_origem" disabled="disabled" \nvalue="{{vm.model.quantidade_origem | number:3 }} {{ vm.model.tipo_medida.descricao }}"></md-input-container>\n<md-input-container class="datepicker-custom"><label>Data de validade</label><md-datepicker name="data_aplicacao" \nng-if="vm.model.data_validade" ng-model="vm.model.data_validade" disabled="disabled"></md-datepicker><input \ntype="text" name="data_validade" ng-if="!vm.model.data_validade" disabled="disabled" ng-model="vm.model.data_validade">\n</md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/estoque_insumo/semente/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/JdoJyAMhMRc?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/estoque_insumo/semente/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="CUSTOS.VIEW_COSTS">Visualizar custos\n</h1></div><div class="content-register with-select"><form name="custosForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3 translate="CUSTOS.DATA_COSTS">\nDados do manejo</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" \nng-model="vm.model.data_aplicacao" md-max-date="vm.date" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex="20"><label>Hora da aplica\xE7\xE3o</label><input type="text" name="hora" \nvalue="{{ vm.model.hora_aplicacao | date:\'h:mm\' }}"></md-input-container><md-input-container flex><label \ntranslate="CUSTOS.TYPE_MANAGEMENT">Tipo de manejo</label><input type="text" name="quantidade_profissionais" \nng-model="vm.model.tipo_manejo.descricao"></md-input-container></div></md-card><md-card \nng-if="vm.model.profissionais != \'\'"><h3 translate="CUSTOS.PROFISSIONAIS">Profissionais</h3><div class="profissional" \nng-repeat="profissional in vm.model.profissionais"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_PROFISSIONAL">Tipo de profissional\n</label><input type="text" name="tipo_profissional" ng-model="profissional.tipo_profissional.nome">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.PROFISSIONAL_AMOUNT">Quantidade de profissionais</label><input type="text" \nname="quantidade_profissionais" ng-model="profissional.quantidade_profissional"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas</label><input type="text" \nname="horas_trabalhadas" ui-mask="99:99" ng-model="profissional.quantidade_horas"></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input type="text" name="valor_hora" \nng-model="profissional.tipo_profissional.valor_hora" ui-money-mask></md-input-container><md-input-container flex><label\n translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" name="valor_total" \nng-model="profissional.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card \nng-if="vm.model.equipamentos != \'\'"><h3 translate="CUSTOS.MACHINE">M\xE1quinas/Equipamentos</h3><div class="equipamento" \nng-repeat="equipamento in vm.model.equipamentos"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container flex><label translate="CUSTOS.TYPE_MACHINE">Tipo de m\xE1quina</label>\n<input type="text" name="tipo_maquina" ng-model="equipamento.equipamento.nome"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="CUSTOS.MACHINE_AMOUNT">\nQuantidade de m\xE1quinas</label><input type="text" name="quantidade_maquinas" ng-model="equipamento.quantidade_maquinas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas\n</label><input type="text" name="horas_trabalhadas" ui-mask="99:99" ng-model="equipamento.quantidade_horas">\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input \ntype="text" name="valor_hora" ng-model="equipamento.equipamento.valor_hora" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="valor_total" ng-model="equipamento.valor_total" ui-money-mask></md-input-container></div></div></md-card><md-card\n ng-if="vm.model.outros != \'\'"><h3 translate="CUSTOS.OTHER_COSTS">Outros custos</h3><div class="outros" \nng-repeat="outro in vm.model.outros"><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex>\n<label translate="CUSTOS.NAME_COSTS">Nome</label><input type="text" name="outro_nome" ng-model="outro.nome" \nmaxlength="15"></md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">\nQuantidade de horas trabalhadas</label><input type="text" name="outra_hora_trabalhada" ui-mask="99:99" \nng-model="outro.quantidade"></md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">\nValor hora</label><input type="text" name="outro_valor" ng-model="outro.valor" ui-money-mask></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input type="text" \nname="outro_valor_total" ng-model="outro.valor_total" ui-money-mask></md-input-container></div></div></md-card><div \nclass="split-area"><div class="percent-35 padding-right"><md-card><h3 translate="CUSTOS.WATER_USE">Utiliza\xE7\xE3o de \xE1gua\n</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.TOTAL_LITERS">Total em litros</label><input type="text" name="hora" placeholder="Insira a hora" \nui-number-mask="3" min="0.001" max="99999.999" maxlength="10" ng-model="vm.model.total_litros"></md-input-container>\n</div></md-card></div><div class="percent-65 padding-left"><md-card><h3 translate="CUSTOS.INFO_AREA">\xC1rea</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label>\xC1rea</label><input type="text" \nname="hora" ng-model="vm.model.propriedade_area.nome"></md-input-container></div></md-card></div></div></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/fechamento_custos/mensal/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1>Previs\xE3o colheita > Lista de previs\xF5es</h1></div><md-button \nng-click="vm.gotoAdd()" class="btn btn-primary btn-lg-i" ng-disabled="vm.propriedade.length == 0">Cadastrar previs\xE3o\n</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/previsa-colheita/ico-laudo-flv-br.svg"></span>LISTA DE PREVIS\xD5ES</h3></div><div \nclass="form-search-horizontal"><form><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col periodo"><div \nclass="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo do Cadastro</label><select class="form-select select-periodo" name="periodo" \nng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option value="" disabled="disabled">Selecione</option>\n<option ng-value="period.value" ng-repeat="period in vm.periods">{{period.description}}</option></select>\n</md-input-container></div><div class="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicial" ng-model="vm.args.data_inicial" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container \nclass="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.DataInicio" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Cultura</label><select \nid="cultura" ng-model="vm.args.cultura" ng-options="cultura.nome as cultura.nome for cultura in vm.filtros.culturas" \nng-value="cultura.nome" ng-change="vm.onSelectCultura(vm.args.cultura)"><option value="" selected="selected" \ndisabled="disabled">Selecione</option></select></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Variedade</label><select id="variedade" ng-model="vm.args.variedade" \nng-disabled="!vm.args.cultura" ng-options="item.produto_variedade as item.produto_variedade for item in vm.variedades" \nng-value="item.produto_variedade"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom despesas"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="nome_area" lm-title="\xC1rea"></th><th class="secondary-text pagination-custom" lm-sort-header="cultura" \nlm-title="Cultura/variedade"></th><th class="secondary-text pagination-custom" lm-sort-header="peso_previsto" \nlm-title="Qtd. prevista"></th><th class="secondary-text pagination-custom" lm-sort-header="data_cadastro" \nlm-title="Data cadastro"></th><th class="secondary-text pagination-custom" lm-sort-header="data_inicial" \nlm-title="Data inicial"></th><th class="secondary-text pagination-custom" lm-sort-header="data_final" \nlm-title="Data final"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr ng-repeat="item in vm.models"><td>\n{{item.nome_area}}</td><td>{{item.cultura}} / {{item.produto_variedade}}</td><td \nng-if="item.unidade_medida != \'unidades\'">{{item.peso_previsto | number:3}} kg</td><td \nng-if="item.unidade_medida == \'unidades\'">{{item.peso_previsto | number}} unidades</td><td>\n{{item.data_cadastro | date:\'dd/MM/yyyy\'}}</td><td>{{item.data_inicial | date:\'dd/MM/yyyy\'}}</td><td>\n{{item.data_final | date:\'dd/MM/yyyy\'}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoEdit(item.id)" aria-label="Editar"><i class="fas fa-pen"><md-tooltip hide-xs md-direction="left">\nEditar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" ng-click="vm.deletarConfirm(item)" \naria-label="Apagar"><i class="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i>\n</md-button></td></tr></tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/fechamento_custos/mensal/views/dash.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\nPropriedade > Fechamento de custos > Mensal</h1></div></div><div class="top-content-buttons"><md-button \nclass="btn btn-primary btn-lg-i" ng-click="vm.getExcelFile()" \nng-disabled="vm.args.agrupado_por == 1 && !vm.models.fechamento_mes[0].fechamento_areas || vm.args.agrupado_por == 2 && !vm.models.fechamento_mes[0].fechamento_atividades">\nExportar excel</md-button></div></div><div class="page-layout simple fullwidth fechamento-custos-page" layout="column">\n<div class="content" layout="column"><div class="container-content-custom"><div class="form-search-horizontal"><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="20"><div class="container"><div \nclass="box-propriedade-area"><md-input-container class="md-input-has-value input-relatorio-historico" flex="50"><label>\nAgrupado por:</label><md-radio-group md-autofocus name="agrupar-relatorio" ng-model="vm.args.agrupado_por" \nng-change="vm.agrupadoPorChange()" layout="row" required><md-radio-button id="rArea" value="1">\xC1rea</md-radio-button>\n<md-radio-button id="rAtividade" value="2">Atividade</md-radio-button></md-radio-group></md-input-container></div>\n</div></md-input-container><md-input-container flex="80"><div class="container"><div class="row"><div \nclass="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"></div><div class="col periodo"><div \nclass="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo</label><select class="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" \nng-change="vm.selectedPeriodo()"><option value="">Selecione</option><option ng-value="period.value" \nng-repeat="period in vm.periods">{{period.description}}</option></select></md-input-container></div><div \nclass="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicial" ng-model="vm.args.data_inicial" \nmd-max-date="vm.args.data_final" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.data_inicial" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col" ng-hide="vm.args.agrupado_por == 2"><md-input-container class="form-group select-custom" \nflex><label>\xC1rea</label><select id="area" ng-model="vm.args.area"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-value="area.area_nome" ng-repeat="area in vm.filtros">\n{{ area.area_nome }}</option></select></md-input-container></div><div class="col" ng-show="vm.args.agrupado_por == 2">\n<md-input-container class="form-group select-custom" flex><label>Atividade</label><select id="atividade" \nng-model="vm.args.atividade"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="atividade in vm.filtros" ng-value="atividade.atividade">{{ atividade.atividade }}</option></select>\n</md-input-container></div><div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary" \nng-click="vm.resetPagination(); vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></md-input-container></div></div><div \nclass="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><div \nclass="indices-1 form-search-horizontal"><div class="container"><div class="row grupo-2"><div class="col"><div \nclass="box-3"><div class="ico"><img src="../assets/icons/ico-propriedade.svg"><h3>\xC1REAS</h3></div><div class="total">\n<span class="fz-60">{{ vm.dash.total_areas | number }}</span><br><span class="txt">TOTAL</span></div><hr><div \nclass="footer"><span class="number">{{ vm.dash.hectares_total_areas | number:4 }} ha</span> <span class="txt">TOTAL\n</span></div></div></div><div class="col"><div class="box-3"><div class="ico"><img \nsrc="../assets/icons/previsa-colheita/ico-laudo-flv.svg"><h3>APLICA\xC7\xD5ES DE INSUMOS</h3></div><div class="total"><span \nclass="fz-60">{{ vm.dash.total_insumos | number }}</span><br><span class="txt">TOTAL</span></div><hr><div \nclass="footer"><span class="number">R$ {{ vm.dash.custo_total_insumos | finance:false:2 }}</span> <span class="txt">\nCUSTO TOTAL</span></div></div></div><div class="col"><div class="box-3"><div class="ico"><img \nsrc="../assets/icons/previsa-colheita/ico-peso-produzido.svg"><h3>OUTROS MANEJOS</h3></div><div class="total"><span \nclass="fz-60">{{ vm.dash.total_manejos | number }}</span><br><span class="txt">TOTAL</span></div><hr><div \nclass="footer"><span class="number">R$ {{ vm.dash.custo_total_manejos | finance:false:2 }}</span> <span class="txt">\nCUSTO TOTAL</span></div></div></div><div class="col"><div class="box-3"><div class="ico"><img \nsrc="../assets/icons/previsa-colheita/ico-laudo-flv.svg"><h3>DESPESAS ADMINISTRATIVAS</h3></div><div class="total">\n<span class="fz-60">{{ vm.dash.total_despesas_adm | number }}</span><br><span class="txt">TOTAL</span></div><hr><div \nclass="footer"><span class="number">R$ {{ vm.dash.custo_total_despesas_adm | finance:false:2 }}</span> <span \nclass="txt">CUSTO TOTAL</span></div></div></div></div></div></div><md-card><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="40"><label class="label">Propriedade</label><strong>\n{{ vm.models.propriedade_nome }}</strong></md-input-container><md-input-container flex="60"><label class="label">\nTotal hectares</label><input class="input-text-pure" type="text" name="area_propriedade" \nng-model="vm.models.total_hectares" ui-number-mask="4" disabled="disabled"></md-input-container></div></md-card><a \nid="lista"></a><div class="ms-responsive-table-wrapper" \nng-if="vm.args.agrupado_por == 1 && vm.models.fechamento_mes[0].fechamento_areas"><div class="content fullpage-simple" \nlayout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom fechamento-mensal"><tbody><tr class="default" \nng-repeat-start="model in vm.models.fechamento_mes"><td class="click-button desktop-button-plus"><a \nng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled">\n<md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a>&nbsp;</td><td><h6 class="d-mobile">M\xEAs</h6><span>M\xEAs</span><br><strong>\n{{ model.mes }}/{{ model.ano }}</strong></td><td><h6 class="d-mobile">Total hectares</h6><span>Total hectares</span>\n<br><strong>{{ model.total_hectares | number:4 }} ha</strong></td><td><h6 class="d-mobile">Valor total</h6><span>\nValor total</span><br><strong>{{ model.valor_total | finance:true:2 }}</strong></td><td><h6 class="d-mobile">\nCusto por hectar</h6><span>Custo por hectar</span><br><strong>{{ model.custo_por_hectar | finance:true:2 }}</strong>\n</td><td class="click-button mobile-only"><a ng-click="vm.isColapsed(model)" \nng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a\n class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle"></md-icon></a>\n</td></tr><tr ng-repeat-end class="details"><td class="main" colspan="5" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><table><thead><tr><th></th>\n<th>\xC1rea</th><th>Total hectares</th><th>Valor</th><th>Custo por hectar</th></tr></thead><tbody><tr \nng-repeat-start="area in model.fechamento_areas"><td class="click-button desktop-button-plus d-desk"><a \nng-click="vm.isShowItem(area)" ng-hide="area.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(area)" ng-hide="!area.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a>&nbsp;</td>\n<td><h6 class="d-mobile">\xC1rea</h6>{{ area.area }}</td><td><h6 class="d-mobile">Hectares</h6>\n{{ area.total_hectares | number:4 }} ha</td><td><h6 class="d-mobile">Valor</h6>{{ area.valor | finance:true:2 }}</td>\n<td><h6 class="d-mobile">Custo por hectar</h6>{{ area.custo_por_hectar | finance:true:2 }}</td></tr><tr ng-repeat-end \nclass="details"><td class="main" colspan="5" ng-show="area.show"><div class="details-query"><table class="atividades">\n<thead><tr><th></th><th>Atividade</th><th>Valor</th><th>Custo por hectar</th></tr></thead><tbody><tr \nng-repeat-start="atividade in area.fechamento_atividades"><td class="click-button desktop-button-plus d-desk"><a \nng-click="vm.isShowItem(atividade)" ng-hide="atividade.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(atividade)" ng-hide="!atividade.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a>\n&nbsp;</td><td><h6 class="d-mobile">Atividade</h6>{{ atividade.atividade }}</td><td><h6 class="d-mobile">Valor</h6>\n{{ atividade.valor | finance:true:2 }}</td><td><h6 class="d-mobile">Custo por hectar</h6>\n{{ atividade.custo_por_hectar | finance:true:2 }}</td></tr><tr ng-repeat-end class="details"><td class="main" \ncolspan="5" ng-show="atividade.show"><div class="details-query last-details"><table class="insumos"><thead><tr><th>\nDescri\xE7\xE3o</th><th>Valor</th></tr></thead><tbody><tr ng-repeat="insumo in atividade.fechamento_descricao"><td><h6 \nclass="d-mobile">Descri\xE7\xE3o</h6>{{ insumo.descricao }}</td><td><h6 class="d-mobile">valor</h6>\n{{ insumo.valor | finance:true:2 }}</td></tr></tbody></table></div></td></tr></tbody></table></div></td></tr></tbody>\n</table></div></td><td colspan="8" ng-if="model.isLoading"><div class="loading"><md-progress-circular \nid="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular><p>Carregando</p></div></td></tr>\n</tbody></table></div></div><div class="ms-responsive-table-wrapper" \nng-if="vm.args.agrupado_por == 2 && !vm.models.fechamento_mes[0].fechamento_areas"><div \nclass="content fullpage-simple" layout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom fechamento-mensal"><tbody><tr class="default" \nng-repeat-start="model in vm.models.fechamento_mes"><td class="click-button desktop-button-plus"><a \nng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled">\n<md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a>&nbsp;</td><td><h6 class="d-mobile">M\xEAs</h6><span>M\xEAs</span><br><strong>\n{{ model.mes }}/{{ model.ano }}</strong></td><td><h6 class="d-mobile">Total hectares</h6><span>Total hectares</span>\n<br><strong>{{ model.total_hectares | number:4 }} ha</strong></td><td><h6 class="d-mobile">Valor total</h6><span>\nValor total</span><br><strong>{{ model.valor_total | finance:true:2 }}</strong></td><td><h6 class="d-mobile">\nCusto por hectar</h6><span>Custo por hectar</span><br><strong>{{ model.custo_por_hectar | finance:true:2 }}</strong>\n</td><td class="click-button mobile-only"><a ng-click="vm.isColapsed(model)" \nng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a\n class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle"></md-icon></a>\n</td></tr><tr ng-repeat-end class="details"><td class="main" colspan="5" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><table class="atividades">\n<thead><tr><th></th><th>Atividade</th><th>Valor</th><th>Custo por hectar</th></tr></thead><tbody><tr \nng-repeat-start="atividade in model.fechamento_atividades"><td class="click-button desktop-button-plus d-desk"><a \nng-click="vm.isShowItem(atividade)" ng-hide="atividade.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(atividade)" ng-hide="!atividade.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a>\n&nbsp;</td><td><h6 class="d-mobile">Atividade</h6>{{ atividade.atividade }}</td><td><h6 class="d-mobile">Valor</h6>\n{{ atividade.valor | finance:true:2 }}</td><td><h6 class="d-mobile">Custo por hectar</h6>\n{{ atividade.custo_por_hectar | finance:true:2 }}</td></tr><tr ng-repeat-end class="details"><td class="main" \ncolspan="5" ng-show="atividade.show"><div class="details-query last-details"><table class="insumos"><thead><tr><th>\nDescri\xE7\xE3o</th><th>Valor</th></tr></thead><tbody><tr ng-repeat="insumo in atividade.fechamento_descricao"><td><h6 \nclass="d-mobile">Descri\xE7\xE3o</h6>{{ insumo.descricao }}</td><td><h6 class="d-mobile">valor</h6>\n{{ insumo.valor | finance:true:2 }}</td></tr></tbody></table></div></td></tr></tbody></table></div></td><td \ncolspan="8" ng-if="model.isLoading"><div class="loading"><md-progress-circular id="toolbar-progress" class="md-accent" \nmd-diameter="32"></md-progress-circular><p>Carregando</p></div></td></tr></tbody></table></div></div><div \nclass="paginator" ng-show="vm.models.total_itens <= 0"><i class="far fa-file-alt"></i><p>Nenhum registro encontrado.\n</p></div><div class="content-buttons"><span></span><md-button class="btn btn-primary btn-lg-i" \nng-click="vm.getExcelFile()" \nng-disabled="vm.args.agrupado_por == 1 && !vm.models.fechamento_mes[0].fechamento_areas || vm.args.agrupado_por == 2 && !vm.models.fechamento_mes[0].fechamento_atividades">\nExportar excel</md-button></div></div></div></div>');
$templateCache.put('app/main/fechamento_custos/mensal/views/modal_colheitas.html','<div><div class="header-modal"><div class="desc">Lista de colheitas</div><div class="close" ng-click="hide()">X</div>\n</div><div class="content"><table class="table-culturas" ng-if="colheitas.length!=0"><md-progress-linear \nng-if="loading" md-mode="indeterminate"></md-progress-linear><thead><tr><th>\xC1rea</th><th>Cultura / variedade</th><th>\nData colheita</th><th>Qtd. colhida</th></tr></thead><tbody><tr ng-repeat="item in colheitas"><td>{{ item.area_nome }}\n</td><td>{{ item.cultura }} / {{ item.produto_variedade }}</td><td>{{ item.data_colheita | date:\'dd/MM/yyyy\' }}</td><td\n ng-if="item.unidade_medida == \'kg\'">{{ item.quantidade | number:3 }} {{item.unidade_medida}}</td><td \nng-if="item.unidade_medida != \'kg\'">{{ item.quantidade | number }} {{item.unidade_medida}}</td></tr></tbody></table><p \nng-if="colheitas.length<1">Nenhuma colheita encontrada.</p></div></div>');
$templateCache.put('app/main/fechamento_custos/mensal/views/modal_culturas.html','<div><div class="header-modal"><div class="desc">Lista de culturas / variedades</div><div class="close" \nng-click="hide()">X</div></div><div class="content"><table class="table-culturas"><md-progress-linear ng-if="loading" \nmd-mode="indeterminate"></md-progress-linear><thead><tr><th>Cultura</th><th>Variedade</th></tr></thead><tbody><tr \nng-repeat="item in culturasVariedades"><td>{{ item.cultura }}</td><td>{{ item.produto_variedade }}</td></tr></tbody>\n</table></div></div>');
$templateCache.put('app/main/fechamento_custos/mensal/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth certificados-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-header"><h1 translate="LAUDO.TITLE">\nLaudo t\xE9cnico</h1><div class="header-id-lote"><label>ID do laudo</label><input type="text" ng-model="vm.model.id" \ndisabled="disabled"></div></div><div class="content-register with-select"><form name="laudoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3>\nDados da venda</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500">\n<label translate="LAUDO.TRACKING_CODE">C\xF3digo rastreamento</label><input type="text" name="codigo_rastreamento" \nplaceholder="Insira o c\xF3digo rastreamento" ng-model="vm.model.lote_numero" disabled="disabled"></md-input-container>\n<md-input-container class="datepicker-custom" flex="20" md-delay="500"><label translate="LAUDO.SHIPPING_DATE">\nData de expedi\xE7\xE3o</label><md-datepicker name="data_expedicao" ng-model="vm.model.data_expedicao" \nmd-placeholder="Inserir data" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="50" md-delay="500"><label \ntranslate="LAUDO.CUSTOMER_NAME">Nome do cliente</label><input type="text" name="nome_cliente" \nplaceholder="Inserir nome do cliente" ng-model="vm.model.cliente_consumidor_nome" disabled="disabled">\n</md-input-container><md-input-container flex="50" md-delay="500"><label translate="LAUDO.EMAIL">E-mail</label><input \ntype="email" name="email" placeholder="Inserir e-mail" maxlength="60" \nng-pattern="/^[_a-z0-9]+(\\.[_a-z0-9]+)*@[a-z0-9-]+(\\.[a-z0-9-]+)*(\\.[a-z]{2,4})$/" \nng-model="vm.model.cliente_consumidor_email" required><div ng-messages="laudoForm.email.$error" \nng-if="laudoForm.email.$touched"><div ng-message="required">Campo Obrigat\xF3rio.</div><div ng-message="pattern">\nE-mail incorreto.</div><div ng-message="api_erro">{{laudoForm.email.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.CULTURE">Cultura</label><input type="text" name="cultura" \nplaceholder="Inserir cultura" ng-model="vm.model.cultura.nome" disabled="disabled"></md-input-container>\n<md-input-container flex="25" md-delay="500"><label translate="LAUDO.VARIETY">Variedade</label><input type="text" \nname="variedade" placeholder="Inserir variedade" ng-model="vm.model.produto_variedade" disabled="disabled">\n</md-input-container><md-input-container flex="25" md-delay="500"><label translate="LAUDO.CATEGORY">Categoria</label>\n<input type="text" name="nome_cliente" placeholder="Inserir categoria" ng-model="vm.model.categoria"><div \nng-messages="laudoForm.categoria.$error" ng-if="laudoForm.categoria.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.categoria.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15" md-delay="500"><label translate="LAUDO.AMOUNT">Quantidade</label>\n<input type="text" name="quantidade" ng-model="vm.model.quantidade" disabled="disabled"></md-input-container>\n<md-input-container flex="20" md-delay="500" ng-hide="vm.model.unidade_medida == \'Embalagem\'"><label \ntranslate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" name="quantidade" \nng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin ng-if="vm.model.unidade_medida == \'Embalagem\'"><md-input-container flex \nmd-delay="500"><label translate="LAUDO.UNIT_OF_MEASUREMENT">Unidade de medida</label><input type="text" \nname="quantidade" ng-model="vm.model.unidade_medida" disabled="disabled"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PACKAGE_TIPO">Embalagem tipo</label><input type="text" name="embalagem_tipo" \nng-model="vm.model.embalagem_tipo" disabled="disabled"></md-input-container><md-input-container flex md-delay="500">\n<label translate="LAUDO.PACKAGE_PESO">Embalagem peso</label><input type="text" name="embalagem_peso" \nng-model="vm.model.embalagem_peso" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="25" md-delay="500"><label \ntranslate="LAUDO.SALES_DOCUMENT_NUMBER">N\xBA do documento de venda</label><input type="text" \nname="numero_documento_venda" placeholder="Inserir o n\xBA do documento de venda" \nng-model="vm.model.numero_documento_venda"></md-input-container><md-input-container flex="75" md-delay="500"><label \ntranslate="LAUDO.RESPONSIBLE">Respons\xE1vel</label><input type="text" name="responsavel" \nplaceholder="Inserir o respons\xE1vel" ng-model="vm.model.responsavel_nome" required><div \nng-messages="laudoForm.responsavel.$error" ng-if="laudoForm.responsavel.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{laudoForm.responsavel.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n class="select-custom" flex="40" md-delay="500"><label translate="LAUDO.CONCLUSION">Conclus\xE3o</label><input \ntype="text" name="laudo_conclusao_conformidade" \nng-model="vm.model.laudo_conclusao.laudo_conclusao_conformidade.descricao"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.OBSERVATION">Observa\xE7\xE3o</label><textarea ng-model="vm.model.laudo_conclusao.observacao" \nname="laudo_conclusao_observacao" rows="5"></textarea></md-input-container></div></md-card><md-card><h3>Avalia\xE7\xE3o</h3>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30" md-delay="500"><label \ntranslate="LAUDO.BATCH_ID">ID do lote</label><input type="text" name="lote_id" \nng-model="vm.model.lote_distribuicao_venda_id"></md-input-container></div><hr class="divider"><div class="pesos" \nng-if="vm.model.unidade_medida == \'Kg\' || vm.model.unidade_medida == \'Embalagem\'"><h4>Pesos amostrados</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="peso in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Peso {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-model="peso.medida" ui-number-mask="3" \nmin="0.001" maxlength="15" required></md-input-container></div></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.SAMPLE_TOTAL_WEIGHT">\nPeso total da amostra</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.total_medida" \nui-number-mask="3" min="0.001" max="{{vm.model.quantidade}}"></md-input-container><md-input-container flex \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">Percentual amostrado</label><input type="text" \nname="percentual_amostrado" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="vm.model.laudo_amostra.percentual_medida"></md-input-container><md-input-container flex md-delay="500"><label\n translate="LAUDO.AVERAGE_WEIGHT">Peso m\xE9dio</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="3" min="0.001" disabled="disabled"></md-input-container>\n<md-input-container flex md-delay="500"><label translate="LAUDO.EXPECTED_WEIGHT">Peso esperado</label><input \ntype="text" name="peso_amostra" placeholder="Inserir o peso esperado" \nng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="3" min="0.001" maxlength="15"></md-input-container>\n</div></div><div class="quantidade" ng-if="vm.model.unidade_medida == \'Unidades\'"><h4>Quantidade amostradas</h4><div \nlayout="column" layout-gt-xs="row" layout-margin layout-wrap=""><div \nng-repeat="quantidade in vm.model.laudo_amostra.laudo_amostra_medida" class="container_box" flex="20"><div \nclass="flex-container"><h5>Quantidade {{ $index + 1 }}</h5></div><md-input-container class="full-percent"><label>&nbsp;\n</label><input type="text" name="peso_amostra" placeholder="Digite" ng-change="vm.calcLaudoAmostra()" \nng-model="quantidade.medida" ui-number-mask="0" min="0.1" maxlength="15" required></md-input-container></div></div><div\n layout="column" layout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.SAMPLE_TOTAL_AMOUNT">Quantidade total da amostra</label><input type="text" name="peso_amostra" \nng-model="vm.model.laudo_amostra.total_medida" ui-number-mask="0" min="0" maxlength="15" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.PERCENTAGE_SAMPLE">\nPercentual amostrado</label><input type="text" name="percentual" ui-percentage-value maxlength="5" \nui-percentage-mask="0" min="0.1" max="100.0" ng-model="vm.model.laudo_amostra.percentual_medida" disabled="disabled">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.AVERAGE_AMOUNT">Quantidade m\xE9dia\n</label><input type="text" name="peso_amostra" ng-model="vm.model.laudo_amostra.media_medida" ui-number-mask="0" \nmin="0" maxlength="15"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.EXPECTED_AMOUNT">Quantidade esperada</label><input type="text" name="peso_amostra" \nplaceholder="Inserir a quantidade" ng-model="vm.model.laudo_amostra.esperada_medida" ui-number-mask="0" min="0" \nmaxlength="15" required></md-input-container></div></div><div class="defeitos"><h4>Defeitos</h4><div layout="column" \nlayout-gt-xs="row" layout-margin ng-repeat="defeito in vm.model.laudo_defeito"><md-input-container \nclass="select-custom" flex="50" md-delay="500"><label>Defeito {{ $index + 1 }}</label><input type="text" \nname="descricao" ng-model="defeito.descricao"></md-input-container><md-input-container flex="25" md-delay="500" \nng-if="defeito.laudo_defeito_tipo_id == 8"><label translate="LAUDO.OTHER">Outro</label><input type="text" \nname="defeito_outro" placeholder="Inserir defeito" ng-model="defeito.laudo_defeito_tipo_outro.descricao">\n</md-input-container><md-input-container class="select-custom" flex="25" md-delay="500"><label \ntranslate="LAUDO.CLASSIFICATION">Classifica\xE7\xE3o</label><input type="text" name="laudo_defeito_classificacao" \nng-model="defeito.laudo_defeito_classificacao.descricao"></md-input-container><md-input-container flex="25" \nmd-delay="500"><label translate="LAUDO.PERCENTAGE_OTHER">Porcentagem</label><input type="text" \nname="porcentagem_defeito" ui-percentage-value maxlength="5" ui-percentage-mask="0" min="0.1" max="100.0" \nng-model="defeito.porcentagem"></md-input-container></div></div><hr class="divider"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.MATURATION">Matura\xE7\xE3o</label><input type="text" name="laudo_maturacao" \nng-model="vm.model.laudo_maturacao.descricao"></md-input-container><md-input-container flex md-delay="500"><label \ntranslate="LAUDO.APPEARANCE">Apar\xEAncia</label><input type="text" name="aparencia" ng-model="vm.model.aparencia">\n</md-input-container><md-input-container flex md-delay="500"><label translate="LAUDO.TEMPERATURE">Temperatura</label>\n<input type="text" name="laudo_maturacao" ng-model="vm.model.temperatura"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label \ntranslate="LAUDO.CALIBER">Calibre</label><input type="text" name="laudo_calibre" \nng-model="vm.model.laudo_calibre.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.COLORING">Colora\xE7\xE3o</label><input type="text" name="laudo_coloracao" \nng-model="vm.model.laudo_coloracao.descricao"></md-input-container><md-input-container class="select-custom" flex \nmd-delay="500"><label translate="LAUDO.ODOR">Odor</label><input type="text" name="laudo_odor" \nng-model="vm.model.laudo_odor.descricao"></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.FLAVOR">Sabor\n</label><input type="text" name="laudo_sabor" ng-model="vm.model.laudo_sabor.descricao"></md-input-container>\n<md-input-container class="select-custom" flex md-delay="500"><label translate="LAUDO.PRESSURE">Press\xE3o</label><input \ntype="text" name="laudo_pressao" ng-model="vm.model.laudo_pressao.descricao"></md-input-container><md-input-container \nclass="select-custom" flex md-delay="500"><label translate="LAUDO.BRIX">Brix</label><input type="text" \nname="laudo_brix" ng-model="vm.model.laudo_brix.descricao"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex md-delay="500"><label translate="LAUDO.OBSERVATION">\nObserva\xE7\xE3o</label><textarea ng-model="vm.model.observacao" name="observacao" rows="5"></textarea></md-input-container>\n</div></md-card><md-card class="laudo-fotos"><h3 class="custom">Fotos</h3>`<div layout="row" layout-gt-xs="row" \nlayout-margin><div class="item" ng-repeat="imagem in vm.model.laudo_upload_file" flex="40"><div class="item-content">\n<div class="imagem" flex="30"><img class="thumbnail-description" ng-src="{{imagem.url}}"></div><div class="body" flex>\n<label>Descri\xE7\xE3o</label><textarea class="textarea-descricao" name="descricao" ng-model="imagem.descricao" cols="40" \nrows="3"></textarea></div></div></div></div></md-card></fieldset><div api-form-validation-summary form="laudoForm">\n</div></form></div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.comeBack()">\nVoltar</md-button></div></div></div></div>');
$templateCache.put('app/main/home/view/videos/tutorial-gerar-custos.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/Fk7ZGfyQHJM?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div>');
$templateCache.put('app/main/home/view/videos/tutorial-gerar-laudo.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/-5Bs4xrzp_U?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div>');
$templateCache.put('app/main/home/view/videos/tutorial-imprimiretiqueta-trocarcliente.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/axGVi175nvY?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div>');
$templateCache.put('app/main/home/view/videos/tutorial-vender-lotes.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/IjUniyb0Jyo?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div>');
$templateCache.put('app/main/produtores/consultar/views/consultar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="simple-table-container md-whiteframe-4dp"><div class="header-table-simple"><div layout="row" layout-wrap \nlayout-align="start center"><div class="mobile-text-center" flex="100" flex-gt-sm="33"><md-icon class="icon-document" \nmd-font-icon="icon-document"></md-icon><span class="h1">Consulta de Produtores</span></div><div flex="100" \nflex-gt-sm="33"><md-input-container class="filter-input"><label translate="REGISTERS.SEARCH">Buscar</label><input \nid="txt-filtro" class="mobile-text-center" ng-model="vm.args.query" ng-model-options="{ debounce: 1000 }" \nng-change="vm.args._change()"></md-input-container></div></div></div><div class="ms-responsive-table-wrapper"><div \nclass="content fullpage-simple" layout="column" flex><table row-border hover lm-sort lm-args="vm.args" \nid="responsive_search" class="simple"><thead><tr><th class="secondary-text pagination-custom" lm-sort-header="nome" \nlm-title="Nome"></th><th class="secondary-text pagination-custom" lm-sort-header="cpf/cnpj" lm-title="CPF/CNPJ"></th>\n<th class="secondary-text pagination-custom" lm-sort-header="cidade" lm-title="Cidade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="estado" lm-title="Estado"></th></tr></thead><tbody><tr \nng-repeat="produtores in vm.models"><td>{{produtores.nome}}</td><td><span ng-if="produtores.cnpj_cpf.length == 11">\n{{produtores.cnpj_cpf | brCpf}}</span> <span ng-if="produtores.cnpj_cpf.length == 14">{{produtores.cnpj_cpf | brCnpj}}\n</span></td><td>{{produtores.cliente_endereco.cidade_nome}}</td><td>{{produtores.cliente_endereco.uf}}</td></tr>\n</tbody></table><lm-paginator lm-args="vm.args"></lm-paginator><md-progress-linear ng-if="vm.args.loading" \nmd-mode="indeterminate"></md-progress-linear></div></div></div></div></div>');
$templateCache.put('app/main/registro/colheita/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 translate="COLHEITA.COLHEITA"></h1>\n</div><div class="tutorial" ng-click="vm.viewTutorial()"><img src="../../../../../assets/images/svg/ico-video.svg" \nalt=""> <span>Assista o passo a passo</span></div></div><md-button class="btn btn-primary btn-lg-i" \ntranslate="COLHEITA.ADD_COLHEITA" ng-click="vm.gotoAdd()" ng-disabled="vm.models.propriedades_cliente.length == 0">\nAdicionar colheita</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="form-search-horizontal"><form><div \nclass="container"><div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg">\n <span>Filtros</span></div><div class="col"><md-input-container class="select-custom" flex><label>\xC1rea</label><select \nclass="md-block" name="area" ng-model="vm.args.propriedade_area_id"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-repeat="area in vm.filtros.propriedades_area" ng-value="area.id">\n{{area.nome}}</option></select></md-input-container></div><div class="col"><md-input-container \nclass="form-group select-custom" flex><label>Cultura</label><select id="cultura" ng-model="vm.args.cultura"><option \nvalue="" selected="selected" disabled="disabled">Selecione</option><option ng-repeat="cultura in vm.filtros.culturas" \nng-value="cultura.nome">{{cultura.nome}}</option></select></md-input-container></div><div class="col">\n<md-input-container class="form-group select-custom" flex><label>Variedade</label><select id="variedade" \nng-model="vm.args.variedade" ng-disabled="!vm.args.cultura" \nng-options="variedade for variedade in ((vm.filtros.culturas | filter:{\'nome\':vm.args.cultura})[0].variedades)" \nng-value="variedade"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col col-datepicker"><div class="align-datepicker"><md-input-container \nclass="datepicker-custom first" flex><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.colheita_data_de" md-max-date="vm.args.colheita_data_ate" md-placeholder="Inserir data" \nmd-open-on-focus></md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex><label>\nData final</label><md-datepicker name="data_fim" ng-model="vm.args.colheita_data_ate" \nng-disabled="vm.args.colheita_data_de == null" md-min-date="vm.args.colheita_data_de" md-placeholder="Inserir data" \nmd-open-on-focus></md-datepicker></md-input-container></div></div><div class="col"><div class="content-buttons">\n<md-button class="btn btn-tertiary btn-md-i" ng-click="vm.args._change()">Filtrar</md-button><a \nclass="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div \nclass="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom colheita"><thead><tr><th \nclass="secondary-text pagination-custom table-column-id" lm-sort-header="id" lm-title="ID" flex="10"></th><th \nclass="secondary-text pagination-custom table-column-id" lm-sort-header="caderno_campo_propriedade_area_nome" \nlm-title="\xC1rea" flex="10"></th><th class="secondary-text pagination-custom" lm-sort-header="cultura" \nlm-title="Cultura"></th><th class="secondary-text pagination-custom" lm-sort-header="variedade" lm-title="Variedade">\n</th><th class="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quantidade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_colheita" lm-title="Data da colheita"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="COLHEITA.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td>\n{{model.id}}</td><td>{{model.propriedade_area}}</td><td>{{model.cultura}}</td><td>{{model.variedade}}</td><td \nng-if="model.unidade_medida != \'unidades\'">{{model.quantidade | number:3}} {{model.unidade_medida}}</td><td \nng-if="model.unidade_medida == \'unidades\'">{{model.quantidade | number}} {{model.unidade_medida}}</td><td>\n{{model.data_colheita | date:\'dd/MM/yyyy\'}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoEditar(model.id)" aria-label="Editar"><i class="fas fa-pen"><md-tooltip hide-xs md-direction="left">\nEditar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="top">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.deletarConfirm(model)" aria-label="Apagar" ng-disabled="!model.permite_cancelamento"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div>\n<lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/colheita/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="COLHEITA.ADD_COLHEITA">Adicionar colheita</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="colheitaForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 translate="COLHEITA.DADOS">\nDados da colheita</h3><div api-form-validation-summary form="colheitaForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex md-delay="500"><label>\xC1rea <small>\n(Com plantio)</small></label><md-select class="md-block" ng-model="vm.model.propriedade_area" \nplaceholder="Selecione a \xE1rea" name="propriedade_area" required ng-change="vm.areaChange()"><md-option \nng-repeat="area in vm.areas" ng-value="area">{{area.propriedade_area_nome}}</md-option></md-select><div \nng-messages="colheitaForm.propriedade_area.$error" ng-if="colheitaForm.propriedade_area.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{colheitaForm.propriedade_area.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="COLHEITA.CULTURA">Cultura</label><input type="text" disabled="disabled" name="cultura" \nng-model="vm.cultura"></md-input-container><md-input-container flex><label translate="COLHEITA.VARIEDADE">Variedade\n</label><input type="text" disabled="disabled" name="variedade" ng-model="vm.variedade"></md-input-container></div>\n</md-card><md-card><h3 translate="COLHEITA.INFO">Informa\xE7\xF5es da colheita</h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="datepicker-custom" flex="15"><label>Data da colheita</label><md-datepicker \nname="colheita" ng-model="vm.model.data_colheita" md-max-date="vm.date" md-placeholder="Inserir data" md-open-on-focus \nrequired></md-datepicker><div class="errors" ng-messages="colheitaForm.colheita.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{colheitaForm.colheita.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25"><label>Quantidade <small>(kg)</small></label><input type="text" \nname="quantidade" ng-model="vm.model.quantidade" ui-number-mask="3" min="0.001" max="9999999.999" maxlength="11" \nng-change="vm.model.valor = null" required placeholder="Insira a quantidade"><div class="errors" \nng-messages="colheitaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{9999999.999 | finance:false:3}}</div><div ng-message="api_erro">\n{{colheitaForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container flex="25" \nmd-delay="500"><label>Valor quilo</label><input type="text" name="valor" ng-model="vm.model.valor" ui-money-mask \nng-disabled="!vm.model.quantidade" ng-keyup="vm.calcValor(vm.model.valor)" maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{colheitaForm.valor.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="25" md-delay="500"><label>Valor total</label><input type="text" name="valor_total" \nng-model="vm.model.valor_total" ui-money-mask disabled="disabled"></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.cancelClick(colheitaForm,$event)">\nVoltar</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="colheitaForm.$invalid || colheitaForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/colheita/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="COLHEITA.EDIT_COLHEITA">Editar colheita</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="colheitaForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 translate="COLHEITA.DADOS">\nDados da colheita</h3><div api-form-validation-summary form="colheitaForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="COLHEITA.AREA">\xC1rea</label><input \ntype="text" name="area" ng-disabled="true" ng-model="vm.model.propriedade_area"></md-input-container>\n<md-input-container flex><label translate="COLHEITA.CULTURA">Cultura</label><input type="text" name="cultura" \nng-disabled="true" ng-model="vm.model.cultura"></md-input-container><md-input-container flex><label \ntranslate="COLHEITA.VARIEDADE">Variedade</label><input type="text" name="variedade" ng-disabled="true" \nng-model="vm.model.variedade"></md-input-container></div></md-card><md-card><h3 translate="COLHEITA.INFO">\nInforma\xE7\xF5es da colheita</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label>Data da colheita</label><md-datepicker name="colheita" \nng-model="vm.model.data_colheita" ng-disabled="true" md-max-date="vm.date" md-placeholder="Inserir data" \nmd-open-on-focus required></md-datepicker></md-input-container><md-input-container flex="30"><label>Quantidade <small>\n(kg)</small></label><input type="text" name="quantidade" ng-model="vm.model.quantidade" ui-number-mask="3" min="0.001" \nmax="99999.999" maxlength="10" required placeholder="Insira a quantidade" ng-change="vm.model.valor = null"><div \nclass="errors" ng-messages="colheitaForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="min">Deve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999.999 | finance:false:3}}</div><div ng-message="api_erro">\n{{colheitaForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container flex="25" \nmd-delay="500"><label>Valor quilo</label><input type="text" name="valor" ng-model="vm.model.valor" ui-money-mask \nng-disabled="!vm.model.quantidade" ng-keyup="vm.calcValor(vm.model.valor)" maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{colheitaForm.valor.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="25" md-delay="500"><label>Valor total</label><input type="text" name="valor_total" \nng-model="vm.model.valor_total" ui-money-mask disabled="disabled"></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.cancelClick(colheitaForm,$event)">\nVoltar</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="colheitaForm.$invalid || colheitaForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Salvar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/colheita/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/d4lcWUMFaxA?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/colheita/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1>Manejos > Colheita > Visualizar</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-register"><form name="colheitaForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset ng-disabled="true"><md-card><h3 translate="COLHEITA.DADOS">\nDados da colheita</h3><div api-form-validation-summary form="colheitaForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="COLHEITA.AREA">\xC1rea</label><input \ntype="text" name="area" ng-disabled="true" ng-model="vm.model.propriedade_area"></md-input-container>\n<md-input-container flex><label translate="COLHEITA.CULTURA">Cultura</label><input type="text" name="cultura" \nng-disabled="true" ng-model="vm.model.cultura"></md-input-container><md-input-container flex><label \ntranslate="COLHEITA.VARIEDADE">Variedade</label><input type="text" name="variedade" ng-disabled="true" \nng-model="vm.model.variedade"></md-input-container></div></md-card><md-card><h3 translate="COLHEITA.INFO">\nInforma\xE7\xF5es da colheita</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom" flex="15"><label>Data da colheita</label><md-datepicker name="colheita" \nng-model="vm.model.data_colheita" md-max-date="vm.date" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex="20"><label>Quantidade <small>(kg)</small></label><input \nng-if="vm.model.unidade_medida == \'kg\'" type="text" name="quantidade" ng-model="vm.model.quantidade" \nui-number-mask="3" min="0.001" max="99999.999" maxlength="10" required placeholder="Insira a quantidade"> <input \nng-if="vm.model.unidade_medida == \'unidades\'" type="text" name="quantidade" ng-model="vm.model.quantidade" \nui-number-mask="0" min="1" max="99999.999" maxlength="10" required placeholder="Insira a quantidade">\n</md-input-container><md-input-container flex="20"><label>Valor quilo</label><input type="text" name="valor" \nng-model="vm.model.valor" ui-money-mask></md-input-container><md-input-container flex="20"><label>Valor total</label>\n<input type="text" name="valor_total" ng-model="vm.model.valor_total" ui-money-mask></md-input-container></div>\n</md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/custos/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1><span class="d-desk">Manejos <i \nclass="fas fa-chevron-right"></i></span> Custos de manejos</h1></div><div class="tutorial" \nng-click="vm.viewTutorial()"><img src="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>\nAssista o passo a passo</span></div></div><md-button class="btn btn-primary btn-lg-i" ng-click="vm.gotoAdd()" \nng-disabled="vm.propriedades.length == 0">Adicionar custo</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-search"><div class="identification"><h2 \ntranslate="REGISTERS.LIST">Lista</h2></div><div class="toggle-filtro"><div class="icon-filters" \nng-click="vm.openFilter()"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div></div>\n</div><div class="form-search-horizontal form-search-horizontal-novo"><div class="form-search"><form><div \nclass="container"><div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg">\n <span>Filtros</span><div class="close d-mobile" ng-click="vm.closeFilter()"><i class="fas fa-times"></i></div></div>\n<div class="col periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.Periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.DataInicio" md-max-date="vm.args.DataFim" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.DataFim" ng-disabled="vm.args.DataInicio == null" \nmd-min-date="vm.args.DataInicio" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.DataFim == null">Selecionar</button></div>\n</div></div></div></div></div><div class="col"><md-input-container class="select-custom" flex><label>Nome da \xE1rea\n</label><select class="md-block" name="area" ng-model="vm.args.PropriedadeAreaId"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-repeat="area in vm.filtros.propriedade_area" ng-value="area.id">\n{{ area.descricao }}</option></select></md-input-container></div><div class="col"><md-input-container \nclass="select-custom" flex><label>Nome da atividade</label><select class="md-block" name="area" \nng-model="vm.args.TipoManejoId"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="manejo in vm.filtros.tipos_manejo" ng-value="manejo.id">{{ manejo.descricao }}</option></select>\n</md-input-container></div><div class="col btns"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change(); vm.closeFilter()">Filtrar</md-button><a \nclass="btn btn-quaternary" ng-click="vm.resetFilters(); vm.closeFilter()">Limpar</a></div></div></div></div></form>\n</div></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>\n{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" \nng-if="filter.description">{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" \ntitle="Remover">X</a></li></ul></div><div class="total-costs"><h2>Custo total</h2><span>\nR$ {{ vm.total_cost | finance:false:2 }}</span></div><div class="ms-responsive-table-wrapper"><div \nclass="content fullpage-simple" layout="column" flex><md-progress-linear ng-if="vm.args.loading" \nmd-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom custos_manejo"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="propriedadeArea" lm-title="\xC1rea"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cultura" lm-title="Cultura"></th><th class="secondary-text pagination-custom" \nlm-sort-header="tipoManejo" lm-title="Nome da atividade"></th><th class="secondary-text pagination-custom" \nlm-sort-header="horaAplicacao" lm-title="Data - hora"></th><th class="secondary-text pagination-custom" \nlm-sort-header="valor" lm-title="Valor"></th><th class="secondary-text pagination-custom"><div class="table-header">\n<span class="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr ng-repeat="custo in vm.models"><td>\n<h6 class="d-mobile">\xC1rea</h6>{{custo.propriedade_area}}</td><td ng-if="!custo.cultura"><h6 class="d-mobile">Cultura\n</h6>-</td><td ng-if="custo.cultura"><h6 class="d-mobile">Cultura</h6>{{custo.cultura}}</td><td><h6 class="d-mobile">\nNome da atividade</h6>{{custo.tipo_manejo}}</td><td><h6 class="d-mobile">Data - hora</h6>\n{{ custo.hora_aplicacao | date:\'dd/MM/yyyy HH:mm\'}}</td><td><h6 class="d-mobile">Valor</h6>\nR$ {{ custo.valor_total | finance:false:2}}</td><td><h6 class="d-mobile">A\xE7\xF5es</h6><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(custo.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(custo)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table></div></div>\n<lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/custos/views/criar_maquina.tmpl.html','<md-dialog class="modal-custom-register"><form name="maquinaForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar nova m\xE1quina</h2><md-button class="md-icon-button close-modal" \nng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div api-form-validation-summary \nform="maquinaForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><label>Tipo m\xE1quina</label><input type="text" name="tipo_maquina" ng-model="vm.model.nome" \nplaceholder="Insira o tipo de m\xE1quina" maxlength="50" required><div class="errors" \nng-messages="maquinaForm.tipo_maquina.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{maquinaForm.tipo_maquina.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex><label>Valor hora</label><input type="text" name="valor" \nng-model="vm.model.valor_hora" placeholder="Insira o valor hora" maxlength="11" ui-money-mask required><div \nclass="errors" ng-messages="maquinaForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{maquinaForm.valor.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="maquinaForm.$error.required || btnDesabled" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/custos/views/criar_profissional.tmpl.html','<md-dialog class="modal-custom-register"><form name="profissionalForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo profissional</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="profissionalForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-block" flex><label>Tipo profissinal</label><input type="text" name="tipo_profissional" \nng-model="vm.model.nome" placeholder="Insira o tipo de profissional" maxlength="50" required><div class="errors" \nng-messages="profissionalForm.tipo_profissional.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{profissionalForm.tipo_profissional.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex><label>Valor hora</label><input type="text" name="valor" \nng-model="vm.model.valor_hora" placeholder="Insira o valor hora" maxlength="11" ui-money-mask required><div \nclass="errors" ng-messages="profissionalForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{profissionalForm.valor.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="profissionalForm.$error.required || btnDesabled" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/custos/views/criar_step-1.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1><span class="d-desk">Manejos <i \nclass="fas fa-chevron-right"></i>Custos de manejos <i class="fas fa-chevron-right"></i></span>Adicionar</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nCadastre todos os custos de manejos<br>e tenha controle da sua produ\xE7\xE3o.</h2></div><div class="container-title-step">\n<h3><span><img src="../assets/images/svg/custos/ico-colheita.svg"></span>MANEJOS</h3></div><div \nclass="content-register with-select"><form name="custosForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><div class="split-dados-agua"><div class="percent-65 padding-right"><md-card><h3 \ntranslate="CUSTOS.DATA_COSTS">Dados do manejo</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom"><label>Data manejo</label><md-datepicker name="data_aplicacao" \nng-model="vm.dadosForm.data_aplicacao" md-max-date="vm.date" md-placeholder="Inserir data" md-open-on-focus required>\n</md-datepicker><div class="errors" ng-messages="custosForm.data_aplicacao.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{custosForm.data_plantio.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="20"><label>Hora in\xEDcio</label><input type="text" name="hora" \nplaceholder="hh:mm" ng-model="vm.dadosForm.hora_aplicacao" ui-time-mask="short" required><div class="errors" \nng-messages="custosForm.hora.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{custosForm.hora.$api.error.message}}</div></div></md-input-container><md-input-container class="select-custom" flex>\n<label translate="CUSTOS.TYPE_MANAGEMENT">Tipo de manejo</label><md-select class="md-block" \nng-model="vm.dadosForm.tipo_manejo" name="tipo_manejo" placeholder="Escolher um tipo"><md-option \nng-repeat="item in vm.manejos" ng-value="item" ng-selected="item.id == vm.dadosForm.tipo_manejo.id">{{item.descricao}}\n</md-option></md-select><div ng-messages="custosForm.tipo_manejo.$error" ng-if="custosForm.tipo_manejo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="md-require-match">\nPor favor, digite um tipo de manejo v\xE1lido</div><div ng-message="api_erro">\n{{custosForm.tipo_manejo.$api.error.message}}</div></div></md-input-container></div></md-card></div><div \nclass="percent-35 padding-left"><md-card><h3 translate="CUSTOS.WATER_USE">Utiliza\xE7\xE3o de \xE1gua</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="CUSTOS.TOTAL_LITERS">Total em litros\n</label><input type="text" name="hora" placeholder="Insira a quantidade de litros" ui-number-mask="3" min="0.001" \nmax="99999.999" maxlength="10" ng-model="vm.dadosForm.total_litros"><div class="errors" \nng-messages="custosForm.hora.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{custosForm.hora.$api.error.message}}</div></div></md-input-container></div></md-card></div></div><fieldset><md-card>\n<h3 translate="CUSTOS.PROFISSIONAIS">Profissionais</h3><div class="profissional" \nng-repeat="profissional in vm.dadosForm.profissionais"><div layout="column" layout-gt-xs="row" layout-margin \nclass="align-items-baseline"><md-input-container class="select-custom" flex="50" md-delay="500"><label \ntranslate="CUSTOS.TYPE_PROFISSIONAL">Tipo de profissional</label><md-select class="md-block" \nng-change="vm.onChangeProfessional(profissional, $index)" ng-model="profissional.tipo_profissional" \nname="professionals" placeholder="Escolher um tipo"><md-option ng-repeat="professionals in vm.professionals" \nng-value="professionals" ng-selected="professionals.nome == profissional.tipo_profissional.nome">{{professionals.nome}}\n</md-option></md-select><div ng-messages="custosForm.professionals.$error" ng-if="custosForm.professionals.$touched">\n<div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{custosForm.professionals.$api.error.message}}</div></div></md-input-container><md-input-container flex="25"><a \nclass="btn btn-quinary" ng-click="vm.showDialogCreateProfessional($event,lista_detalhes)">Cadastrar profissional</a>\n</md-input-container><md-input-container flex="25"><md-button class="icon-btn md-icon-button float-right" \nng-if="vm.dadosForm.profissionais.length > 1" ng-click="vm.removeProfissional($index)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.PROFISSIONAL_AMOUNT">Quantidade de profissionais</label><input type="text" \nname="quantidade_profissionais" placeholder="Insira a quantidade" \nng-change="vm.onChangeProfessionalCount(profissional.quantidade_profissional, profissional, $index)" \nng-pattern="/^[0-9]*$/" ng-model="profissional.quantidade_profissional" maxlength="3" \nng-required="isRequiredProfessional"><div class="errors" ng-messages="custosForm.quantidade_profissionais.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">S\xF3 \xE9 permitido n\xFAmeros</div><div \nng-message="api_erro">{{custosForm.quantidade_profissionais.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas</label><input type="text" \nname="horas_trabalhadas" \nng-change="vm.onChangeProfessionalCount(profissional.quantidade_profissional, profissional, $index)" \nng-model="profissional.quantidade_horas" ui-mask="99:99" ng-required="isRequiredProfessional" placeholder="hh:mm"><div \nclass="errors" ng-messages="custosForm.horas_trabalhadas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{custosForm.horas_trabalhadas.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input type="text" name="valor_hora" \nng-model="profissional.valor_hora" ui-money-mask \nng-value="vm.professionals.valor?vm.professionals.valor:profissional.valor_hora" disabled="disabled">\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input \ntype="text" name="valor_total" ng-model="profissional.valor_total" ui-money-mask disabled="disabled">\n</md-input-container></div></div></md-card><div class="row-add-novo"><a class="btn btn-quaternary" \nng-click="vm.addProfissional()" ng-hide="vm.dadosForm.profissionais.length == 10"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Adicionar profissional</a></div><md-card><h3 translate="CUSTOS.MACHINE">\nM\xE1quinas/Equipamentos</h3><div class="equipamento" ng-repeat="equipamento in vm.dadosForm.equipamentos"><div \nlayout="column" layout-gt-xs="row" layout-margin class="align-items-baseline"><md-input-container \nclass="select-custom" flex="50" md-delay="500"><label translate="CUSTOS.TYPE_MACHINE">Tipo de m\xE1quina</label><md-select\n class="md-block" ng-change="vm.onChangeMachine(equipamento, $index)" ng-model="equipamento.equipamento" \nname="equipamento" placeholder="Escolher uma m\xE1quina"><md-option ng-repeat="machine in vm.machines" ng-value="machine" \nng-selected="machine.nome == equipamento.equipamento.nome">{{machine.nome}}</md-option></md-select><div \nng-messages="custosForm.machines.$error" ng-if="custosForm.machines.$touched"><div ng-message="required">\nCampo Obrigat\xF3rio</div><div ng-message="api_erro">{{custosForm.machines.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateMachine($event,lista_detalhes)">Cadastrar m\xE1quina</a></md-input-container>\n<md-input-container flex="25"><md-button class="icon-btn md-icon-button float-right" \nng-if="vm.dadosForm.equipamentos.length > 1" ng-click="vm.removeMaquina($index)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="CUSTOS.MACHINE_AMOUNT">Quantidade de m\xE1quinas</label><input type="text" name="quantidade_maquina" \nplaceholder="Insira a quantidade" ng-pattern="/^[0-9]*$/" ng-change="vm.onChangeMachineCount(equipamento, $index)" \nng-required="isRequiredMachines" ng-model="equipamento.quantidade_maquinas" maxlength="3"><div class="errors" \nng-messages="custosForm.quantidade_maquina.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">S\xF3 \xE9 permitido n\xFAmeros</div><div ng-message="api_erro">\n{{custosForm.quantidade_maquina.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="CUSTOS.WORK_HOUR">Quantidade de horas trabalhadas</label><input type="text" \nname="equipamentohoras_trabalhadas" ng-change="vm.onChangeMachineCount(equipamento, $index)" \nng-required="isRequiredMachines" ng-model="equipamento.quantidade_horas" ui-mask="99:99" placeholder="hh:mm"><div \nclass="errors" ng-messages="custosForm.equipamentohoras_trabalhadas.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{custosForm.equipamentohoras_trabalhadas.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input \ntype="text" name="equipamento_valor_hora" ng-model="equipamento.valor_hora" ui-money-mask disabled="disabled">\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input \ntype="text" name="equipamento_valor_total" ng-model="equipamento.valor_total" ui-money-mask disabled="disabled">\n</md-input-container></div></div></md-card><div layout="row" layout-align="center center" \nclass="layout-align-center-center layout-row row-add-novo"><a class="btn btn-quaternary" ng-click="vm.addMaquina()" \nng-hide="vm.dadosForm.equipamentos.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar m\xE1quina\n</a></div><md-card><h3 translate="CUSTOS.OTHER_COSTS">Outros custos</h3><div class="outros" \nng-repeat="outro in vm.dadosForm.outros"><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nflex><label translate="CUSTOS.NAME_COSTS">Nome</label><input type="text" name="outro_nome" placeholder="Insira o nome" \nng-model="outro.nome" maxlength="15"><div class="errors" ng-messages="custosForm.outro_nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{custosForm.outro_nome.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><label translate="CUSTOS.WORK_HOUR">\nQuantidade de horas trabalhadas</label><input type="text" name="outra_hora_trabalhada" placeholder="hh:mm" \nng-change="vm.onChangeOtherCount($index)" ng-model="outro.quantidade" ui-mask="99:99" placeholder="hh:mm"><div \nclass="errors" ng-messages="custosForm.outra_hora_trabalhada.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{custosForm.outra_hora_trabalhada.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="CUSTOS.VALUE_HOUR">Valor hora</label><input type="text" name="outro_valor" \nplaceholder="Insira a valor hora" ng-change="vm.onChangeOtherCount($index)" ng-model="outro.valor" maxlength="11" \nui-money-mask><div class="errors" ng-messages="custosForm.outro_valor.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{custosForm.outro_valor.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex><label translate="CUSTOS.VALUE_TOTAL">Valor total</label><input \ntype="text" name="outro_valor_total" placeholder="R$ 0,00" ng-model="outro.valor_total" ui-money-mask maxlength="15" \ndisabled="disabled"></md-input-container><md-input-container flex="5" ng-if="vm.dadosForm.outros.length > 1"><md-button\n class="icon-btn md-icon-button float-right" ng-click="vm.removeOutros($index)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</md-input-container></div></div></md-card><div layout="row" layout-align="center center" \nclass="layout-align-center-center layout-row row-add-novo"><a class="btn btn-quaternary" ng-click="vm.addOutros()" \nng-hide="vm.dadosForm.outros.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar outros custos\n</a></div><div class="container-title-step"><h3><span><img src="../assets/images/svg/custos/ico-area.svg"></span>\xC1REAS\n</h3></div><md-card><div class="md-selecionar-areas" layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="80"><div layout-gt-xs="row" layout-margin><md-input-container class="select-custom" \nflex="40"><label>Escolha as \xE1reas:</label><div layout="column"><div class="check-row" flex="50" \nng-repeat="area in vm.propriedade_areas"><md-checkbox ng-model="area.selected" ng-change="vm.areasSelecionadas()" \nng-required="!vm.areas_selecionadas || vm.areas_selecionadas < 1" \nng-selected="area.propriedade_area_nome == equipamento.equipamento.nome">{{ area.propriedade_area_nome }} <span>\n- {{ area.area_produtiva }} ha - {{ area.cultura }} {{ area.produto_variedade }}</span></md-checkbox></div></div><div \nng-messages="custosForm.area.$error" ng-if="custosForm.area.$touched"><div ng-message="required">Campo Obrigat\xF3rio\n</div><div ng-message="api_erro">{{custosForm.area.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="60"><label>\xC1reas selecionadas:</label><ul class="itens" \nng-if="vm.areas_selecionadas.length != 0"><li ng-repeat="area in vm.areas_selecionadas"><div class="txt"><h6>\n{{ area.propriedade_area_nome }}</h6><span>\n{{ area.area_produtiva }} ha - {{ area.cultura }} {{ area.produto_variedade }}</span></div><button class="close" \nng-model="area.selected" ng-click="vm.remover(area)"><i class="fa fa-trash"></i></button></li></ul><ul class="itens" \nng-if="!vm.areas_selecionadas || vm.areas_selecionadas.length == 0"><li class="area-vazia"><i class="icon-area"></i>\n</li></ul></md-input-container></div></md-input-container><md-input-container flex="20" class="total_hectares"><label>\nTotal hectares:</label><br><input type="text" style="font-weight: bold;" disabled="disabled" \nng-model="vm.totalAreaProdutiva | number:4"></md-input-container></div></md-card><div api-form-validation-summary \nform="custosForm"></div></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.cancelClick(custosForm,$event)">Voltar</md-button><md-button type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="custosForm.$invalid || custosForm.$pristine || !vm.areas_selecionadas || vm.areas_selecionadas.length == 0 || loadingProgress" \nng-click="vm.gotoConfirmar(vm.model)">Pr\xF3ximo passo</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/custos/views/criar_step-2.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1><span class="d-desk">Manejos <i \nclass="fas fa-chevron-right"></i>Custos de manejos <i class="fas fa-chevron-right"></i></span> Adicionar</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num">1</span> <span class="num last active">2</span></div><h2>\nVeja todos os cadastros realizados e confirme para finalizar.</h2></div><div \nclass="content-register with-select tela-confirmar-manejos"><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/custos/ico-colheita.svg"></span>MANEJOS</h3></div><div class="split-dados-agua"><div \nclass="percent-65 padding-right"><md-card><div layout="column" layout-gt-xs="row" layout-margin><div flex><label><span>\nData do manejo</span></label><p><strong>{{ vm.model.data_aplicacao | date:\'dd/MM/yyyy\' }}</strong></p></div><div flex>\n<label><span>Hora in\xEDcio</span></label><p><strong>{{ vm.model.hora_aplicacao }}</strong></p></div><div flex><label>\n<span>Tipo de manejo</span></label><p><strong>{{ vm.model.tipo_manejo.descricao }}</strong></p></div></div></md-card>\n</div><div class="percent-35 padding-left"><md-card><div layout="column" layout-gt-xs="row" layout-margin><div flex>\n<label><span>Utiliza\xE7\xE3o de \xE1gua (total em litros)</span></label><p ng-if="vm.model.total_litros"><strong>\n{{ vm.model.total_litros | number:3 }} L</strong></p><p ng-if="!vm.model.total_litros">N\xE3o utilizada</p></div></div>\n</md-card></div></div><div class="ms-responsive-table-wrapper" \nng-if="vm.model.profissionais[0].valor_total || vm.model.equipamentos[0].valor_total || vm.model.outros[0].valor_total">\n<div class="content fullpage-simple" layout="column" flex><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Categoria</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nTipo de profissional</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Quantidade</span></div></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">N\xBA de horas</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Valor hora</span>\n</div></th><th class="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nValor total</span></div></th></tr></thead><tbody><tr ng-if="vm.model.profissionais[0].valor_total" \nng-repeat="item in vm.model.profissionais"><td><h6 class="d-mobile">Categoria</h6>PROFISSIONAIS</td><td><h6 \nclass="d-mobile">Tipo de profissional</h6>{{ item.tipo_profissional.nome }}</td><td><h6 class="d-mobile">Quantidade\n</h6>{{ item.quantidade_profissional}}</td><td><h6 class="d-mobile">N\xBA de horas</h6>\n{{ vm.horasCorridas(item.quantidade_horas) }}h</td><td><h6 class="d-mobile">Valor hora</h6>\n{{ item.valor_hora | currency }}</td><td><h6 class="d-mobile">Valor total</h6>{{ item.valor_total | currency }}</td>\n</tr><tr ng-if="vm.model.equipamentos[0].valor_total" ng-repeat="item in vm.model.equipamentos"><td><h6 \nclass="d-mobile">Categoria</h6>M\xC1QUINAS</td><td><h6 class="d-mobile">Tipo de profissional</h6>\n{{ item.equipamento.nome }}</td><td><h6 class="d-mobile">Quantidade</h6>{{ item.quantidade_maquinas}}</td><td><h6 \nclass="d-mobile">N\xBA de horas</h6>{{ vm.horasCorridas(item.quantidade_horas) }}h</td><td><h6 class="d-mobile">Valor hora\n</h6>{{ item.valor_hora | currency }}</td><td><h6 class="d-mobile">Valor total</h6>{{ item.valor_total | currency }}\n</td></tr><tr ng-if="vm.model.outros[0].valor_total" ng-repeat="item in vm.model.outros"><td><h6 class="d-mobile">\nCategoria</h6>OUTROS CUSTOS</td><td><h6 class="d-mobile">Tipo de profissional</h6>{{ item.nome }}</td><td><h6 \nclass="d-mobile">Quantidade</h6></td><td><h6 class="d-mobile">N\xBA de horas</h6>{{ vm.horasCorridas(item.quantidade) }}h\n</td><td><h6 class="d-mobile">Valor hora</h6>{{ item.valor | currency }}</td><td><h6 class="d-mobile">Valor total</h6>\n{{ item.valor_total | currency }}</td></tr></tbody></table></div></div><div class="container-total"><div class="total">\n<label>TOTAL:</label>&nbsp; <strong>{{ vm.totalGastos | currency}}</strong></div></div><div \nclass="container-title-step"><h3><span><img src="../assets/images/svg/custos/ico-area.svg"></span>CUSTOS POR \xC1REA</h3>\n</div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom"><thead><tr><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\xC1rea</span></div>\n</th><th class="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nTamanho (hectares)</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Utiliza\xE7\xE3o da \xE1gua</span></div></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Valor total</span></div></th></tr></thead><tbody><tr \nng-repeat="item in vm.areas"><td><h6 class="d-mobile">\xC1rea</h6>{{ item.propriedade_area_nome }}</td><td><h6 \nclass="d-mobile">Tamanho (hectares)</h6>{{ item.area_produtiva }} he</td><td><h6 class="d-mobile">Utiliza\xE7\xE3o da \xE1gua\n</h6><span ng-if="item.totallitrosArea">{{ item.totallitrosArea | number:3 }} L</span> <span \nng-if="!item.totallitrosArea">N\xE3o utilizada</span></td><td><h6 class="d-mobile">Valor total</h6>\n{{ item.totalValorArea | currency }}</td></tr></tbody></table></div></div><div class="container-total"><div \nclass="total"><label>TOTAL:</label>&nbsp; <strong>{{ vm.totalGastos | currency}}</strong></div></div><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.cancelClick($event)">Voltar\n</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" ng-click="vm.save(vm.model)">\nConfirmar</md-button></div></div></div></div></div>');
$templateCache.put('app/main/registro/custos/views/criar_sucesso.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1><span class="d-desk">Atividades <i \nclass="fas fa-chevron-right"></i>Custos de manejos <i class="fas fa-chevron-right"></i></span> Adicionar</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/images/svg/custos/ico-colheita-sucesso.svg" alt="sucesso"><h2>Custos de manejos adicionados com sucesso!\n</h2><span>-------------------------------------------------------</span><p>O que voc\xEA gostaria de fazer agora?</p><div\n class="content-buttons-sucesso"><md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoAdd()">\nAdicionar custos de manejos</md-button><md-button type="button" class="btn btn-tertiary btn-md-i" \nng-click="vm.gotoSearch()">Ver todos os custos</md-button><md-button class="btn btn-secondary btn-md" \nng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div></div></div>');
$templateCache.put('app/main/registro/custos/views/visualizar.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1><span class="d-desk">Atividades <i \nclass="fas fa-chevron-right"></i>Custos de manejos <i class="fas fa-chevron-right"></i></span> Visualizar</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom tela-confirmar-manejos"><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/custos/ico-area.svg"></span>\xC1REA</h3></div><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><div flex><label><span>\xC1rea</span></label><p><strong>\n{{ vm.model.propriedade_area_nome }}</strong></p></div><div flex><label><span>Tamanho (hectares)</span></label><p>\n<strong>{{vm.model.area_produtiva}} he</strong></p></div><div flex><label><span>Cultura / variedade</span></label><p>\n<strong>{{ vm.model.cultura }} {{ vm.model.cultura_variedade }}</strong></p></div></div></md-card><div \nclass="container-title-step"><h3><span><img src="../assets/images/svg/custos/ico-colheita.svg"></span>MANEJOS</h3>\n</div><div class="split-dados-agua"><div class="percent-65 padding-right"><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><div flex><label><span>Data da aplica\xE7\xE3o</span></label><p><strong>\n{{ vm.model.data_aplicacao | date:\'dd/MM/yyyy\' }}</strong></p></div><div flex><label><span>Hora</span></label><p>\n<strong>{{ vm.model.hora_aplicacao | date:\'HH:mm\' }}</strong></p></div><div flex><label><span>Tipo de manejo</span>\n</label><p><strong>{{ vm.model.tipo_manejo }}</strong></p></div></div></md-card></div><div \nclass="percent-35 padding-left"><md-card><div layout="column" layout-gt-xs="row" layout-margin><div flex><label><span>\nUtiliza\xE7\xE3o de \xE1gua (total em litros)</span></label><p><strong>{{ vm.model.total_litros | number:3 }} L</strong></p>\n</div></div></md-card></div></div><div class="ms-responsive-table-wrapper" \nng-if="vm.model.profissionais[0].valor_total || vm.model.equipamentos[0].valor_total || vm.model.outros[0].valor_total">\n<div class="content fullpage-simple" layout="column" flex><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Categoria</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nTipo de profissional</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Quantidade</span></div></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">N\xBA de horas</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Valor hora</span>\n</div></th><th class="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nValor total</span></div></th></tr></thead><tbody><tr ng-if="vm.model.profissionais[0].valor_total" \nng-repeat="item in vm.model.profissionais"><td><h6 class="d-mobile">Categoria</h6>PROFISSIONAIS</td><td><h6 \nclass="d-mobile">Tipo de profissional</h6>{{ item.nome }}</td><td><h6 class="d-mobile">Quantidade</h6>\n{{ item.quantidade_profissional}}</td><td><h6 class="d-mobile">N\xBA de horas</h6>\n{{ vm.horasCorridas(item.quantidade_horas) }}h</td><td><h6 class="d-mobile">Valor hora</h6>\n{{ item.valor_hora | currency }}</td><td><h6 class="d-mobile">Valor total</h6>{{ item.valor_total | currency }}</td>\n</tr><tr ng-if="vm.model.equipamentos[0].valor_total" ng-repeat="item in vm.model.equipamentos"><td><h6 \nclass="d-mobile">Categoria</h6>M\xC1QUINAS</td><td><h6 class="d-mobile">Tipo de profissional</h6>{{ item.nome }}</td><td>\n<h6 class="d-mobile">Quantidade</h6>{{ item.quantidade_maquinas}}</td><td><h6 class="d-mobile">N\xBA de horas</h6>\n{{ vm.horasCorridas(item.quantidade_horas) }}h</td><td><h6 class="d-mobile">Valor hora</h6>\n{{ item.valor_hora | currency }}</td><td><h6 class="d-mobile">Valor total</h6>{{ item.valor_total | currency }}</td>\n</tr><tr ng-if="vm.model.outros[0].valor_total" ng-repeat="item in vm.model.outros"><td><h6 class="d-mobile">Categoria\n</h6>OUTROS CUSTOS</td><td><h6 class="d-mobile">Tipo de profissional</h6>{{ item.nome }}</td><td><h6 class="d-mobile">\nQuantidade</h6></td><td><h6 class="d-mobile">N\xBA de horas</h6>{{ vm.horasCorridas(item.quantidade) }}h</td><td><h6 \nclass="d-mobile">Valor hora</h6>{{ item.valor | currency }}</td><td><h6 class="d-mobile">Valor total</h6>\n{{ item.valor_total | currency }}</td></tr></tbody></table></div></div><div class="container-total"><div class="total">\n<label>TOTAL:</label>&nbsp; <strong>{{ vm.model.valor_total | currency }}</strong></div></div><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</div></div></div>');
$templateCache.put('app/main/registro/dados/views/alterar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="DADOS.DADOS">Meus dados</h1></div><div \nclass="container-search"><h2 translate="DADOS.LICENCA">Minha licen\xE7a</h2></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom my-data"><thead><tr><th \nclass="secondary-text pagination-custom wsize-35" lm-sort-header="card_holder_name" lm-title="Plano"></th><th \nclass="secondary-text pagination-custom wsize-40" lm-sort-header="value" lm-title="Validade da licen\xE7a"></th><th \nclass="secondary-text pagination-custom wsize-30" lm-sort-header="card_brand" lm-title="Status"></th></tr></thead>\n<tbody><tr><td class="wsize-35">\n{{vm.model.compart_veg_assinaturas.cliente_pagar_me_assinaturas[0].plano_pagamento.descricao}}</td><td \nclass="wsize-40">{{vm.model.compart_veg_assinaturas.data_expiracao | date:\'dd/MM/yyyy\'}}</td><td class="wsize-30"><div \nclass="icon-custom" \nng-if="vm.model.compart_veg_assinaturas.cliente_pagar_me_assinaturas[0].cliente_pagar_me_assinatura_status.descricao=\'Ativo\'">\n<md-icon class="enabled" md-font-icon="icon-brightness-1"></md-icon><span>\n{{vm.model.compart_veg_assinaturas.cliente_pagar_me_assinaturas[0].cliente_pagar_me_assinatura_status.descricao}}\n</span></div><div class="icon-custom" \nng-if="!vm.model.compart_veg_assinaturas.cliente_pagar_me_assinaturas[0].cliente_pagar_me_assinatura_status.descricao=\'Ativo\'">\n<md-icon class="disabled" md-font-icon="icon-brightness-1"></md-icon><span>\n{{vm.model.compart_veg_assinaturas.cliente_pagar_me_assinaturas[0].cliente_pagar_me_assinatura_status.descricao}}\n</span></div></td></tr></tbody></table></div></div><div class="container-search"><h2 class="mgnbtt-mobile-only" \ntranslate="DADOS.PERFIL">Meu perfil</h2></div><form name="alterarForm" novalidate="" api-form="vm.api_response_erro">\n<md-card><h3 translate="DADOS.CADASTRAIS">Dados cadastrais</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="15" class="md-input-has-value" ng-hide="true"><label translate="NOVO.TYPE"></label>\n<md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" ng-disabled="true" layout=" row" \nrequired><md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button>\n</md-radio-group><div ng-messages="alterarForm.pessoa_tipo.$error" ng-show="alterarForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{alterarForm.pessoa_tipo.$api.error.message}}\n</div></div></md-input-container><md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id==1"><label \ntranslate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" ng-disabled="true" ng-model="vm.model.cnpj_cpf" \nminlength="14" ui-br-cpf-mask required><div class="errors" ng-messages="alterarForm.cnpj_cpf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div\n ng-message="api_erro">{{alterarForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="15" ng-if="vm.model.pessoa_tipo.id==2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" ng-disabled="true" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required><div \nclass="errors" ng-messages="alterarForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{alterarForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="NOVO.NAME">Nome</label><input type="text" name="nome" ng-model="vm.model.nome" required \nplaceholder="Insira o nome"><div class="errors" ng-messages="alterarForm.nome.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{alterarForm.nome.$api.error.message}}</div></div>\n</md-input-container><md-input-container class="md-block" flex="30" ng-if="vm.model.pessoa_tipo.id==2"><label \ntranslate="DADOS.RAZAO">Raz\xE3o Social</label><input type="text" name="razao_social" \nng-model="vm.model.cliente_informacoes_adicionais.razao_social" placeholder="Insira a raz\xE3o social" required><div \nclass="errors" ng-messages="alterarForm.razao_social.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{alterarForm.razao_social.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="35" ng-if="vm.model.pessoa_tipo.id==2"><label \ntranslate="DADOS.INSCRICAOESTADUAL">Inscri\xE7\xE3o estadual</label><input type="text" name="inscricao_estadual" \nng-model="vm.model.cliente_informacoes_adicionais.inscricao_estadual" placeholder="Insira a inscri\xE7\xE3o estadual" \nrequired><div class="errors" ng-messages="alterarForm.inscricao_estadual.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{alterarForm.inscricao_estadual.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.cliente_telefone.ddd" \nmaxlength="2" ng-pattern="/^[0-9]*$/" required placeholder="DDD"><div class="errors" \nng-messages="alterarForm.ddd.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente n\xFAmeros</div><div ng-message="api_erro">{{alterarForm.ddd.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" \nname="telefone" ng-model="vm.model.cliente_telefone.numero" mask="9?9999-9999" required placeholder="Telefone"><div \nclass="errors" ng-messages="alterarForm.telefone.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{alterarForm.telefone.$api.error.message}}</div></div></md-input-container><md-input-container \nflex><label translate="NOVO.EMAIL">E-mail</label><input type="text" name="email" ng-model="vm.model.email" required \nplaceholder="Insira o e-mail"><div class="errors" ng-messages="alterarForm.email.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{alterarForm.email.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card ng-if="vm.model.pessoa_tipo.id==1"><h3 translate="DADOS.CADASTRAIS"><span\n ng-show="vm.model.pessoa_tipo.id != null">Informa\xE7\xF5es Adicionais</span></h3><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="datepicker-custom"><label translate="DADOS.DATA_NASCIMENTO">Data de nascimento\n</label><md-datepicker name="data_nascimento" ng-model="vm.model.cliente_informacoes_adicionais.data_nascimento " \nmd-max-date="vm.date" md-placeholder="Insira data" md-current-view="year" md-open-on-focus required></md-datepicker>\n<div class="errors" ng-messages="alterarForm.data_nascimento.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{alterarForm.data_nascimento.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex><label translate="DADOS.RG">RG</label><input name="rg" \nng-model="vm.model.cliente_informacoes_adicionais.rg" placeholder="Insira o RG" mask="99.999.999-9" required><div \nclass="errors" ng-messages="alterarForm.rg.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero inv\xE1lido</div><div ng-message="pattern">Somente n\xFAmeros.</div><div ng-message="api_erro">\n{{alterarForm.rg.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 \ntranslate="DADOS.ENDERECO">Dados cadastrais</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-block" flex="20"><label translate="CADASTRAIS.CEP">CEP</label><input type="text" \nname="cep" ng-model="vm.model.cliente_endereco.cep" placeholder="Insira o CEP" required ui-br-cep-mask \nplaceholder="CEP"><div class="errors" ng-messages="alterarForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">{{alterarForm.cep.$api.error.message}}\n</div></div><md-progress-circular ng-show="cepLoading" class="md-accent input-progress" md-diameter="20px">\n</md-progress-circular></md-input-container><md-input-container flex><label translate="CLIENTE.CITY">Cidade</label>\n<input type="text" name="cidade_nome" ng-model="vm.model.cliente_endereco.cidade_nome" placeholder="Insira a cidade" \nrequired><div class="errors" ng-messages="alterarForm.cidade_nome.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="api_erro">{{alterarForm.cidade_nome.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label translate="CLIENTE.UF">UF</label><input type="text" name="uf" \nng-model="vm.model.cliente_endereco.uf" placeholder="UF" required><div class="errors" \nng-messages="alterarForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{alterarForm.uf.$api.error.message}}</div></div></md-input-container><md-input-container flex="50"><label \ntranslate="DADOS.RUA">Endere\xE7o</label><input type="text" name="rua" ng-model="vm.model.cliente_endereco.endereco" \nng-required="true" placeholder="Insira o endere\xE7o"><div class="errors" ng-messages="alterarForm.rua.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{alterarForm.rua.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="20">\n<label translate="CADASTRAIS.NUMERO">N\xFAmero</label><input type="text" name="numero" \nng-model="vm.model.cliente_endereco.numero" maxlength="6" required placeholder="N\xFAmero"><div class="errors" \nng-messages="alterarForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{alterarForm.numero.$api.error.message}}</div></div></md-input-container><md-input-container flex="25"><label \ntranslate="CADASTRAIS.BAIRRO">Bairro</label><input type="text" name="bairro" \nng-model="vm.model.cliente_endereco.bairro" required placeholder="Insira o bairro"><div class="errors" \nng-messages="alterarForm.bairro.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{alterarForm.bairro.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="50"><label translate="CLIENTE.COMPLEMENTO">Complemento</label><input type="text" name="complemento" \nng-model="vm.model.cliente_endereco.complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="alterarForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{alterarForm.complemento.$api.error.message}}</div></div></md-input-container></div></md-card>\n<md-input-container class="md-block" flex="100" flex-gt-sm="33"><div class="mobile-text-center"><a href="" \nng-click="vm.ShowDialogTermos($event)" class="btn btn-quaternary"><i class="far fa-file-excel"></i> <span>Termos de uso\n</span></a></div></md-input-container><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoDashboard()">Voltar</md-button><md-button class="btn btn-primary btn-lg" \nng-disabled="alterarForm.$invalid || alterarForm.$pristine || loadingProgress" ng-click="vm.update(vm.model)">Alterar\n</md-button></div></form></div></div></div>');
$templateCache.put('app/main/registro/despesas/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DESPESAS.TITLE">Despesas Administrativas</h1>\n</div><md-button class="btn btn-primary btn-lg-i" translate="DESPESAS.ADD_EXPENDITURE" \nng-disabled="vm.propriedades.length == 0" ng-click="vm.gotoAdd()">Adicionar despesas</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo do Cadastro</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.DataInicio" md-max-date="vm.args.DataFim" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.DataFim" ng-disabled="vm.args.DataInicio == null" \nmd-min-date="vm.args.DataInicio" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.DataFim == null">Selecionar</button></div>\n</div></div></div></div></div><div class="col"><md-input-container class="select-custom" flex><label>Nome da \xE1rea\n</label><select class="md-block" name="area" ng-model="vm.args.PropriedadeAreaId"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-repeat="area in vm.filtros.areas" ng-value="area.id">{{ area.nome }}\n</option></select></md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>\nTipos</label><select class="md-block" name="area" ng-model="vm.args.DespesaTipoId"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="tipo in vm.filtros.tipos" \nng-value="tipo.id">{{ tipo.nome }}</option></select></md-input-container></div><div class="col"><md-input-container \nclass="select-custom" flex><label>Nomes</label><select class="md-block" name="area" ng-model="vm.args.DespesaNomeId">\n<option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="nome in vm.filtros.nomes" ng-value="nome.id">{{ nome.nome }}</option></select></md-input-container></div>\n<div class="col"><md-input-container class="select-custom" flex><label>Favorecidos</label><select class="md-block" \nname="area" ng-model="vm.args.DespesaFavorecidoId"><option value="" selected="selected" disabled="disabled">Selecione\n</option><option ng-repeat="favorecido in vm.filtros.favorecidos" ng-value="favorecido.id">{{ favorecido.nome }}\n</option></select></md-input-container></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="total-costs"><h2 translate="DESPESAS.TOTAL_COSTS">Buscar atividade</h2><span>\nR$ {{ vm.total_cost | finance:false:2 }}</span></div><div class="ms-responsive-table-wrapper"><div \nclass="content fullpage-simple" layout="column" flex><md-progress-linear ng-if="vm.args.loading" \nmd-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom despesas"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="propriedade_area" lm-title="Nome da \xE1rea"></th><th class="secondary-text pagination-custom" \nlm-sort-header="despesa_tipo" lm-title="Tipo"></th><th class="secondary-text pagination-custom" \nlm-sort-header="despesa_nome" lm-title="Nome"></th><th class="secondary-text pagination-custom" \nlm-sort-header="despesa_favorecido" lm-title="Favorecido"></th><th class="secondary-text pagination-custom" \nlm-sort-header="data_entrada" lm-title="Data de Entrada"></th><th class="secondary-text pagination-custom" \nlm-sort-header="data_vencimento" lm-title="Data de Vencimento"></th><th class="secondary-text pagination-custom" \nlm-sort-header="valor_pago" lm-title="Valor Pago"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr \nng-repeat="despesa in vm.models"><td>{{despesa.propriedade_area.nome}}</td><td>{{despesa.despesa_tipo.nome}}</td><td>\n{{despesa.despesa_nome.nome}}</td><td>{{despesa.despesa_favorecido.nome}}</td><td>\n{{despesa.data_entrada | date:\'dd/MM/yyyy\'}}</td><td>{{despesa.data_vencimento | date:\'dd/MM/yyyy\'}}</td><td>\nR$ {{ despesa.valor_pago | finance:false:2}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(despesa.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="left">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.deletarConfirm(despesa)" aria-label="Apagar"><i class="far fa-trash-alt"><md-tooltip hide-xs \nmd-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/despesas/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DESPESAS.ADD_ADMINISTRATIVE_EXPENDITURE">\nAdicionar despesas administrativas</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" \nlayout="column"><div class="content" layout="column"><div class="container-content-custom"><div \nclass="content-register with-select"><form name="despesaAdminstrativaForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card ng-repeat="despesa in vm.model.despesas"><div layout="column" \nlayout-gt-xs="row" layout-margin class="align-items-baseline"><md-input-container class="select-custom" flex="70" \nmd-delay="500"><label translate="DESPESAS.EXPENDITURE_TYPE">Tipo de despesa</label><md-select class="md-block" \nng-model="despesa.despesa_tipo_id" name="tipoDespesa" placeholder="Escolher um tipo" required><md-option \nng-repeat="tipo_despesa_item in vm.tipo_despesas" ng-value="tipo_despesa_item.id">{{tipo_despesa_item.nome}}\n</md-option></md-select><div ng-messages="despesaAdminstrativaForm.tipoDespesa.$error" \nng-if="despesaAdminstrativaForm.tipoDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.tipoDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="25"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateTipoDespesa($event, despesa, $index)">Cadastrar tipo</a></md-input-container>\n<md-input-container flex="5" ng-if="vm.model.despesas.length > 1"><md-button \nclass="icon-btn md-icon-button float-right" ng-click="vm.removeDespesa($index)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir</md-tooltip></i></div></md-button>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex="70" md-delay="500"><label translate="DESPESAS.EXPENDITURE_NAME">Nome da despesa</label>\n<md-select class="md-block" ng-model="despesa.despesa_nome_id" name="nomeDespesa" placeholder="Escolher um nome" \nrequired><md-option ng-repeat="nome_despesa_item in vm.nome_despesas" ng-value="nome_despesa_item.id">\n{{nome_despesa_item.nome}}</md-option></md-select><div ng-messages="despesaAdminstrativaForm.nomeDespesa.$error" \nng-if="despesaAdminstrativaForm.nomeDespesa.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.nomeDespesa.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="25"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateNomeDespesa($event,despesa, $index)">Cadastrar nome</a></md-input-container>\n<md-input-container flex="5" ng-if="vm.model.despesas.length > 1"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="70" md-delay="500"><label \ntranslate="DESPESAS.NAME_OF_THE_FAVORED">Nome do favorecido</label><md-select class="md-block" \nng-model="despesa.despesa_favorecido_id" name="nomeFavorecido" placeholder="Escolher um favorecido" required><md-option\n ng-repeat="nome_favorecido_item in vm.nome_favorecidos" ng-value="nome_favorecido_item.id">\n{{nome_favorecido_item.nome}}</md-option></md-select><div ng-messages="despesaAdminstrativaForm.nomeFavorecido.$error" \nng-if="despesaAdminstrativaForm.nomeFavorecido.$touched"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.nomeFavorecido.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="25"><a class="btn btn-quinary" \nng-click="vm.showDialogCreateFavorecidoDespesa($event,despesa, $index)">Cadastrar favorecido</a></md-input-container>\n<md-input-container flex="5" ng-if="vm.model.despesas.length > 1"></md-input-container><md-input-container flex="5" \nng-if="vm.model.despesas.length > 1"></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="35" md-delay="500"><label translate="DESPESAS.PAY_VALUE">Valor pago</label><input \ntype="text" name="valor_pago" ng-model="despesa.valor_pago" ui-money-mask maxlength="13" required><div class="errors" \nng-messages="despesaAdminstrativaForm.valor_pago.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.valor_pago.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="35" md-delay="500"><label translate="DESPESAS.NOTE_NUMBER">N\xFAmero da nota</label><input \ntype="text" name="numero_nota" ng-model="despesa.numero_nota" maxlength="13"><div class="errors" \nng-messages="despesaAdminstrativaForm.numero_nota.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.numero_nota.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="30"></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom" md-delay="500"><label class="label-date">Data de entrada</label>\n<md-datepicker name="data_entrada" ng-model="despesa.data_entrada" md-max-date="vm.dateEntradaMax" \nmd-placeholder="Inserir data" ng-change="vm.onChangeDataEntrada(despesa)" md-open-on-focus required></md-datepicker>\n<div class="errors" ng-messages="despesaAdminstrativaForm.data_entrada.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{despesaAdminstrativaForm.data_entrada.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="datepicker-custom"><label class="label-date">Data de vencimento\n</label><md-datepicker name="data_vencimento" ng-model="despesa.data_vencimento" md-min-date="despesa.data_entrada" \nmd-placeholder="Inserir data" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="despesaAdminstrativaForm.data_vencimento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{despesaAdminstrativaForm.data_vencimento.$api.error.message}}</div></div></md-input-container>\n</div></md-card></fieldset><div class="row-add-novo"><a class="btn btn-quaternary" ng-click="vm.addDespesa()" \nng-hide="vm.model.despesas.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar despesa</a></div>\n<br><div class="container-title-step"><h3><span><img src="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div>\n<md-card><area-selector ng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div api-form-validation-summary \nform="despesaAdminstrativaForm"></div></form></div><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button><md-button type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="despesaAdminstrativaForm.$invalid || despesaAdminstrativaForm.$pristine || loadingProgress" \nng-click="vm.showConfirm(despesaAdminstrativaForm, vm.model)">Cadastrar</md-button></div></div></div></div>');
$templateCache.put('app/main/registro/despesas/views/criar_favorecido_despesa.tmpl.html','<md-dialog class="modal-custom-register"><form name="favorecidoForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo favorecido</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="favorecidoForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-block" flex><label>Nome</label><input type="text" name="nome" ng-model="vm.model.nome" \nplaceholder="Insira o nome" maxlength="60" required><div class="errors" ng-messages="favorecidoForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{favorecidoForm.nome.$api.error.message}}\n</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-input-has-value"><label class="md-required" translate="PROPERTIES.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo_id" ng-disabled="vm.model.cnpj_cpf.length > 2" ng-model="vm.model.pessoa_tipo_id" layout="row" \nrequired><md-radio-button value="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button>\n</md-radio-group><div ng-messages="favorecidoForm.pessoa_tipo_id.$error" \nng-show="favorecidoForm.pessoa_tipo_id.$touched"><div ng-message="required" translate>Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{favorecidoForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex ng-if="vm.model.pessoa_tipo_id == 1"><label translate="PROPERTIES.CPF">CPF</label><input \ntype="text" name="cnpj_cpf" placeholder="Insira o CPF" ng-model="vm.model.cnpj_cpf" minlength="14" required \nui-br-cpf-mask><div class="errors" ng-messages="favorecidoForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF</div><div ng-message="api_erro">\n{{favorecidoForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo_id == 2"><label translate=" PROPERTIES.CNPJ">CNPJ/CPF</label><input type="text" \nname="cnpj_cpf" placeholder="Insira o CNPJ" ng-model="vm.model.cnpj_cpf" minlength="18" required ui-br-cnpj-mask><div \nclass="errors" ng-messages="favorecidoForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CNPJ</div><div ng-message="api_erro">\n{{favorecidoForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-disabled="favorecidoForm.$error.required" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/despesas/views/criar_nome_despesa.tmpl.html','<md-dialog class="modal-custom-register"><form name="nomeDespesaForm" novalidate="" api-form="vm.api_response_erro" \nng-submit="vm.save(nomeDespesaForm)"><md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo nome de despesa</h2>\n<md-button class="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar>\n<md-dialog-content><div api-form-validation-summary form="nomeDespesaForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><label>Nome</label><input type="text" \nname="nome_despesa" ng-model="vm.model.nome" placeholder="Insira o nome da despesa" maxlength="60" required><div \nclass="errors" ng-messages="nomeDespesaForm.nome_despesa.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{nomeDespesaForm.nome_despesa.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="nomeDespesaForm.$error.required" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/despesas/views/criar_tipo_despesa.tmpl.html','<md-dialog class="modal-custom-register"><form name="tipoDespesaForm" novalidate="" api-form="vm.api_response_erro" \nng-submit="vm.save(tipoDespesaForm)"><md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo tipo de despesa</h2>\n<md-button class="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar>\n<md-dialog-content><div api-form-validation-summary form="tipoDespesaForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><label>Nome</label><input type="text" \nname="tipo_despesa" ng-model="vm.model.nome" placeholder="Insira o tipo de despesa" maxlength="30" required><div \nclass="errors" ng-messages="tipoDespesaForm.tipo_despesa.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{tipoDespesaForm.tipo_despesa.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="tipoDespesaForm.$error.required" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/despesas/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="DESPESAS.VIEW_DESPESAS">\nAdicionar despesas administrativas</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" \nlayout="column"><div class="content" layout="column"><div class="container-content-custom"><div \nclass="content-register with-select"><div class="split-area"><md-card class="percent-65 padding-left"><div \nlayout="column" layout-gt-xs="row" layout-margin class="align-items-baseline"><md-input-container \nclass="select-custom" flex="100"><label translate="DESPESAS.EXPENDITURE_TYPE">Tipo de despesa</label><input \ntype="text" name="despesa_tipo" ng-model="vm.model.despesa_tipo.nome" disabled="disabled"></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="100"><label \ntranslate="DESPESAS.EXPENDITURE_NAME">Nome da despesa</label><input type="text" name="despesa_nome" \nng-model="vm.model.despesa_nome.nome" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="100"><label \ntranslate="DESPESAS.NAME_OF_THE_FAVORED">Nome do favorecido</label><input type="text" name="despesa_favorecido" \nng-model="vm.model.despesa_favorecido.nome" disabled="disabled"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="50"><label translate="DESPESAS.PAY_VALUE">Valor pago</label>\n<input type="text" name="valor_pago" ng-model="vm.model.valor_pago" ui-money-mask disabled="disabled">\n</md-input-container><md-input-container flex="50"><label translate="DESPESAS.NOTE_NUMBER">N\xFAmero da nota</label><input\n type="text" name="numero_nota" ng-model="vm.model.numero_nota" disabled="disabled"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom" flex="50"><label \nclass="label-date">Data de entrada</label><input type="text" name="data_entrada" ng-model="vm.data_entrada_format" \ndisabled="disabled"></md-input-container><md-input-container class="datepicker-custom" flex="50"><label \nclass="label-date">Data de vencimento</label><input type="text" name="data_vencimento" \nng-model="vm.data_vencimento_format" disabled="disabled"></md-input-container></div></md-card></div><div \nclass="split-area"><md-card class="percent-65 padding-left"><h3 translate="DESPESAS.INFO_AREA">\xC1rea</h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex><label>Propriedade\n</label><input type="text" name="propriedade_area" ng-model="vm.model.propriedade_area.propriedade.nome" \ndisabled="disabled"></md-input-container><md-input-container class="select-custom" flex><label>\xC1reas</label><input \ntype="text" name="propriedade_area" ng-model="vm.model.propriedade_area.nome" disabled="disabled"></md-input-container>\n</div></md-card></div></div><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button></div></div></div></div>');
$templateCache.put('app/main/registro/insumo/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/jVDB2JwEDew?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/lote_producao/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 \ntranslate="LOTE_PRODUCAO.LOTE_PRODUCAO">\xC1rea</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div></div><div\n class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><form><div class="container"><div class="row"><div\n class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div \nclass="col"><md-input-container class="select-custom" flex><label>\xC1rea</label><select class="md-block" name="area" \nng-model="vm.args.propriedade_area"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="area in vm.filtros.propriedades_area" ng-value="area.nome">{{area.nome}}</option></select>\n</md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>Cultura</label>\n<select class="md-block" name="cultura" ng-model="vm.args.cultura" ng-change="vm.onSelectCultura(vm.args.cultura)">\n<option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="cultura in vm.filtros.culturas" placeholder="Selecione a cultura" ng-value="cultura.nome">{{cultura.nome}}\n</option></select></md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>\nVariedade</label><select class="md-block" name="variedades" ng-model="vm.args.variedade" \nng-disabled="!vm.args.cultura"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="variedade in vm.variedades" ng-value="variedade.nome">{{variedade.nome}}</option></select>\n</md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>Aberta</label><select\n class="md-block" name="aberta" ng-model="vm.args.aberta"><option value="" selected="selected" disabled="disabled">\nSelecione</option><option ng-value="1">Sim</option><option ng-value="2">N\xE3o</option></select></md-input-container>\n</div><div class="col col-datepicker"><div class="align-datepicker"><md-input-container \nclass="datepicker-custom first" flex><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.args.producao_data_de" md-max-date="vm.args.producao_data_ate" ng-change="$mdMenu.open()" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container \nclass="datepicker-custom" flex><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.producao_data_ate" md-min-date="vm.args.producao_data_de" ng-change="$mdMenu.open()" \nmd-open-on-focus ng-disabled="vm.args.producao_data_de == null" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container></div></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom lote_producao"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="id" lm-title="ID"></th><th class="secondary-text pagination-custom" \nlm-sort-header="propriedade_area_nome" lm-title="Nome da \xE1rea"></th><th class="secondary-text pagination-custom" \nlm-sort-header="produto_nome" lm-title="Cultura"></th><th class="secondary-text pagination-custom" \nlm-sort-header="variedade" lm-title="Variedade"></th><th class="secondary-text pagination-custom" \nlm-sort-header="data_colheita" lm-title="Colheita"></th><th class="secondary-text pagination-custom" \nlm-sort-header="quantidade" lm-title="Quantidade"></th><th class="secondary-text pagination-custom" \nlm-sort-header="valor" lm-title="Valor/kg"></th><th class="secondary-text pagination-custom" \nlm-sort-header="valor_total" lm-title="Valor total"></th><th class="secondary-text pagination-custom" \nlm-sort-header="aberto_venda" lm-title="Aberto venda"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr \nng-repeat="lote in vm.models.lotes_producao"><td>{{lote.id}}</td><td>{{lote.area_nome}}</td><td>{{lote.produto_nome}}\n</td><td>{{lote.produto_variedade}}</td><td>{{lote.data_colheita | date:\'dd/MM/yyyy\'}}</td><td \nng-if="lote.unidade_medida != \'unidades\'">{{lote.quantidade | number:3}} {{lote.unidade_medida}}</td><td \nng-if="lote.unidade_medida == \'unidades\'">{{lote.quantidade | number}} {{lote.unidade_medida}}</td><td>\nR$ {{ lote.valor | finance:false:2 }}</td><td>R$ {{ lote.valor_total | finance:false:2 }}</td><td>\n{{lote.lote_producao_status.descricao}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(lote.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="left">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoManutencao(lote.id)" aria-label="Manuten\xE7\xE3o"><i class="fas fa-tools"><md-tooltip hide-xs \nmd-direction="right">Manuten\xE7\xE3o</md-tooltip></i></md-button></td></tr></tbody></table></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/dash.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>Lotes produzidos > Dashboard</h1>\n</div></div><div class="top-content-buttons"><md-button class="btn btn-primary btn-lg-i" ng-click="vm.getExcelFile()" \nng-disabled="vm.args.agrupado_por == 1 && !vm.models.lista[0].areas || vm.args.agrupado_por == 2 && !vm.models.lista[0].culturas">\nExportar excel</md-button></div></div><div \nclass="page-layout simple fullwidth fechamento-custos-page lotesproduzidos-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="form-search-horizontal"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="20"><div class="container"><div \nclass="box-propriedade-area"><md-input-container class="md-input-has-value input-relatorio-historico" flex="50"><label>\nAgrupado por:</label><md-radio-group md-autofocus name="agrupar-relatorio" ng-model="vm.args.agrupado_por" \nng-change="vm.agrupadoPorChange()" layout="row" required><md-radio-button id="rArea" value="1">\xC1rea</md-radio-button>\n<md-radio-button id="rCultura" value="2">Cultura</md-radio-button></md-radio-group></md-input-container></div></div>\n</md-input-container><md-input-container flex="80"><div class="container"><div class="row"><div \nclass="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"></div><div class="col periodo"><div \nclass="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo</label><select class="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" \nng-change="vm.selectedPeriodo()"><option value="">Selecione</option><option ng-value="period.value" \nng-repeat="period in vm.periods">{{period.description}}</option></select></md-input-container></div><div \nclass="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicial" ng-model="vm.args.data_inicial" \nmd-max-date="vm.args.data_final" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_final" \nng-model="vm.args.data_final" ng-disabled="vm.args.data_inicial == null" md-min-date="vm.args.data_inicial" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col" ng-hide="vm.args.agrupado_por == 2"><md-input-container class="form-group select-custom" \nflex><label>\xC1rea</label><select id="area" ng-model="vm.args.area"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-repeat="area in vm.filtros.areas" ng-value="area">{{area}}</option>\n</select></md-input-container></div><div class="col"><md-input-container class="form-group select-custom" flex><label>\nCultura</label><select id="cultura" ng-model="vm.args.cultura" ng-change="vm.onSelectCultura(vm.args.cultura)"><option \nvalue="" selected="selected" disabled="disabled">Selecione</option><option ng-repeat="cultura in vm.filtros.culturas" \nng-value="cultura.nome">{{cultura.nome}}</option></select></md-input-container></div><div class="col" \nng-show="vm.args.agrupado_por == 2"><md-input-container class="form-group select-custom" flex><label>Variedade</label>\n<select id="variedade" ng-model="vm.args.variedade" ng-disabled="!vm.args.cultura"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="variedade in vm.variedades" \nng-value="variedade.nome">{{variedade.nome}}</option></select></md-input-container></div><div class="col"><div \nclass="content-buttons"><md-button class="btn btn-tertiary" ng-click="vm.resetPagination(); vm.args._change()">Filtrar\n</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div>\n</md-input-container></div></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first">\n<strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" \nng-if="filter.description">{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" \ntitle="Remover">X</a></li></ul></div><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear><div class="indices-1 form-search-horizontal"><div class="container"><div class="row grupo-2"><div\n class="col"><div class="box-3"><div class="ico"><img src="../assets/icons/ico-areas.svg"><h3>\xC1REAS</h3></div><br><br>\n<div class="total"><span class="fz-60">{{ vm.models.areas | number }}</span><br><span class="txt">TOTAL</span></div>\n</div></div><div class="col"><div class="box-3"><div class="ico"><img \nsrc="../assets/icons/dash-areas/ico-laudo-flv.svg"><h3>CULTURAS</h3></div><br><br><div class="total"><span \nclass="fz-60">{{ vm.models.culturas | number }}</span><br><span class="txt">TOTAL</span></div></div></div><div \nclass="col"><div class="box-3"><div class="ico"><img src="../assets/icons/ico-estoque.svg"><h3>LOTES PRODUZIDOS</h3>\n</div><br><br><div class="total"><span class="fz-40">{{ vm.models.lotes_produzidos | number:3 }}</span><br><span \nclass="txt">KG</span></div></div></div><div class="col"><div class="box-3"><div class="ico"><img \nsrc="../assets/icons/ico-financeiro.svg"><h3>VALOR LOTES</h3></div><br><br><div class="total"><span class="fz-40">\nR$ {{ vm.models.valor_lotes | finance:false:2 }}</span><br><span class="txt">TOTAL</span></div></div></div></div></div>\n</div><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="40"><label \nclass="label">Propriedade</label><strong>{{ vm.models.propriedade }}</strong></md-input-container><md-input-container \nflex="60"><label class="label">Total hectares</label><input class="input-text-pure" type="text" \nname="area_propriedade" ng-model="vm.models.total_hectares" ui-number-mask="4" disabled="disabled">\n</md-input-container></div></md-card><a id="lista"></a><div class="ms-responsive-table-wrapper" \nng-if="vm.args.agrupado_por == 1 && vm.models.lista[0].areas"><div class="content fullpage-simple" layout="column" \nflex><table row-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom fechamento-mensal">\n<tbody><tr class="default" ng-repeat-start="model in vm.models.lista"><td class="click-button desktop-button-plus"><a \nng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled">\n<md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a>&nbsp;</td><td><h6 class="d-mobile">M\xEAs</h6><span>M\xEAs</span><br><strong>\n{{ model.mes_ano }}</strong></td><td><h6 class="d-mobile">Total produzido</h6><span>Total produzido</span><br><strong>\n{{ model.total_produzido | number:3 }} kg</strong></td><td><h6 class="d-mobile">Valor estimado</h6><span>Valor estimado\n</span><br><strong>R$ {{ model.valor_estimado | finance:false:2 }}</strong></td><td class="click-button mobile-only"><a\n ng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr ng-repeat-end class="details"><td class="main" colspan="5" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><table><thead><tr><th></th>\n<th>\xC1rea</th><th>Total produzido</th><th>Valor estimado</th></tr></thead><tbody><tr \nng-repeat-start="area in model.areas"><td class="click-button desktop-button-plus d-desk"><a \nng-click="vm.isShowItem(area)" ng-hide="area.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(area)" ng-hide="!area.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a>&nbsp;</td>\n<td><h6 class="d-mobile">\xC1rea</h6>{{ area.nome }}</td><td><h6 class="d-mobile">Total produzido</h6>\n{{ area.total_produzido | number:3 }} Kg</td><td><h6 class="d-mobile">valor</h6>\nR$ {{ area.valor_estimado | finance:false:2 }}</td><td class="click-button mobile-only d-mobile"><a \nng-click="vm.isShowItem(area)" ng-hide="area.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(area)" ng-hide="!area.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a></td></tr>\n<tr ng-repeat-end class="details"><td class="main" colspan="5" ng-show="area.show"><div \nclass="details-query last-details"><table><thead><tr><th>Lotes</th><th>Data colheita</th><th>Total produzido</th><th>\nValor estimado</th></tr></thead><tbody><tr ng-repeat="lote in area.lotes"><td><h6 class="d-mobile">Lotes</h6>\n{{ lote.nome }}</td><td><h6 class="d-mobile">Colheita</h6>{{ lote.data | date: "dd/MM/yyyy" }}</td><td><h6 \nclass="d-mobile">Total produzido</h6>{{ lote.total_produzido | number:3 }} kg</td><td><h6 class="d-mobile">\nValor estimado</h6>R$ {{ lote.valor_estimado | finance:false:2 }}</td></tr></tbody></table></div></td></tr></tbody>\n</table></div></td><td colspan="8" ng-if="model.isLoading"><div class="loading"><md-progress-circular \nid="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular><p>Carregando</p></div></td></tr>\n</tbody></table></div></div><div class="ms-responsive-table-wrapper" \nng-if="vm.args.agrupado_por == 2 && vm.models.lista[0].culturas"><div class="content fullpage-simple" layout="column" \nflex><table row-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom fechamento-mensal">\n<tbody><tr class="default" ng-repeat-start="model in vm.models.lista"><td class="click-button desktop-button-plus"><a \nng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled">\n<md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a>&nbsp;</td><td><h6 class="d-mobile">M\xEAs</h6><span>M\xEAs</span><br><strong>\n{{ model.mes_ano }}</strong></td><td><h6 class="d-mobile">Total produzido</h6><span>Total produzido</span><br><strong>\n{{ model.total_produzido | number:3 }} kg</strong></td><td><h6 class="d-mobile">Valor estimado</h6><span>Valor estimado\n</span><br><strong>R$ {{ model.valor_estimado | finance:false:2 }}</strong></td><td class="click-button mobile-only"><a\n ng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr ng-repeat-end class="details"><td class="main" colspan="5" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><table><thead><tr><th></th>\n<th>Cultura</th><th>Total produzido</th><th>Valor estimado</th></tr></thead><tbody><tr \nng-repeat-start="cultura in model.culturas"><td class="click-button desktop-button-plus d-desk"><a \nng-click="vm.isShowItem(cultura)" ng-hide="cultura.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(cultura)" ng-hide="!cultura.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a>\n&nbsp;</td><td><h6 class="d-mobile">Cultura</h6>{{ cultura.nome }}</td><td><h6 class="d-mobile">Total produzido</h6>\n{{ cultura.total_produzido | number:3 }} Kg</td><td><h6 class="d-mobile">valor</h6>\nR$ {{ cultura.valor_estimado | finance:false:2 }}</td><td class="click-button mobile-only d-mobile"><a \nng-click="vm.isShowItem(cultura)" ng-hide="cultura.show"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.isShowItem(cultura)" ng-hide="!cultura.show"><md-icon md-font-icon="icon-minus-circle"></md-icon></a></td>\n</tr><tr ng-repeat-end class="details"><td class="main" colspan="5" ng-show="cultura.show"><div \nclass="details-query last-details"><table><thead><tr><th>Lotes</th><th>Data colheita</th><th>Total produzido</th><th>\nValor estimado</th></tr></thead><tbody><tr ng-repeat="lote in cultura.lotes"><td><h6 class="d-mobile">Lotes</h6>\n{{ lote.nome }}</td><td><h6 class="d-mobile">Colheita</h6>{{ lote.data | date: "dd/MM/yyyy" }}</td><td><h6 \nclass="d-mobile">Total produzido</h6>{{ lote.total_produzido | number:3 }} kg</td><td><h6 class="d-mobile">\nValor estimado</h6>R$ {{ lote.valor_estimado | finance:false:2 }}</td></tr></tbody></table></div></td></tr></tbody>\n</table></div></td><td colspan="8" ng-if="model.isLoading"><div class="loading"><md-progress-circular \nid="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular><p>Carregando</p></div></td></tr>\n</tbody></table></div></div><div class="paginator" ng-show="vm.models.lista == null"><i class="far fa-file-alt"></i><p>\nNenhum registro encontrado.</p></div><div class="content-buttons"><span></span><md-button \nclass="btn btn-primary btn-lg-i" ng-click="vm.getExcelFile()" \nng-disabled="vm.args.agrupado_por == 1 && !vm.models.lista[0].areas || vm.args.agrupado_por == 2 && !vm.models.lista[0].culturas">\nExportar excel</md-button></div></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/insumo.biologico.excluido.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="BIOLOGICO.VIEW">\nVisualizar insumo biol\xF3gico</h1></div><div class="content-register"><form name="clienteForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3 \ntranslate="BIOLOGICO.DATA_INSUMO">Dados do insumo</h3><ms-api-message form-api="insumoForm.$api"></ms-api-message><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><label>Data da aplica\xE7\xE3o\n</label><md-datepicker name="data_aplicacao" ng-model="vm.model.data_aplicacao" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex><label translate="BIOLOGICO.PRODUTO">Produto</label>\n<input type="text" name="insumo_agricola_nome" ng-model="vm.model.insumo_agricola_nome"></md-input-container>\n<md-input-container flex><label translate="BIOLOGICO.AMOUNT">Quantidade do produto</label><input type="text" \nname="quantidade" value="{{vm.model.quantidade | finance:false:3}} {{vm.model.unidade_medida}}"></md-input-container>\n</div></md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/insumo.defensivo.excluido.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="DEFENSIVO.VIEW">\nVisualizar insumo defensivo</h1></div><div class="content-register"><form name="insumoForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3 translate="DEFENSIVO.DADOS">\nDados do defensivo</h3><ms-api-message form-api="insumoForm.$api"></ms-api-message><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><label translate="DEFENSIVO.DATE">Data\n</label><md-datepicker name="data_aplicacao" ng-model="vm.model.data_aplicacao" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex><label translate="DEFENSIVO.PRODUTO">Produto Aplicado\n</label><input type="text" name="insumo_agricola_nome" ng-model="vm.model.insumo_agricola_nome"></md-input-container>\n<md-input-container flex><label translate="DEFENSIVO.LACK">Car\xEAncia</label><input type="text" name="carencia" \nng-model="vm.model.carencia"></md-input-container><md-input-container flex><label translate="DEFENSIVO.AMOUNT">\nQuantidade do produto</label><input type="text" name="quantidade" \nvalue="{{vm.model.quantidade | finance:false:3}} {{vm.model.unidade_medida}}"></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/insumo.fertilizante.excluido.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="FERTILIZANTE.VIEW">\nVisualizar insumo fertilizante</h1></div><div class="content-register"><form name="insumoForm" class="md-inline-form" \nnovalidate api-form="vm.api_response_erro"><ms-api-message form-api="insumoForm.$api"></ms-api-message><fieldset \ndisabled="disabled"><md-card><h3 translate="FERTILIZANTE.DADOS">Dados do fertilizante</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><label>Data da aplica\xE7\xE3o</label>\n<md-datepicker name="data_aplicacao" ng-model="vm.model.data_aplicacao" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex><label translate="FERTILIZANTE.PRODUTO">Produto Aplicado\n</label><input type="text" name="insumo_agricola_nome" ng-model="vm.model.insumo_agricola_nome"></md-input-container>\n<md-input-container flex><label translate="FERTILIZANTE.AMOUNT">Quantidade do produto</label><input type="text" \nname="quantidade" value="{{vm.model.quantidade | finance:false:3}} {{vm.model.unidade_medida}}"></md-input-container>\n</div></md-card></fieldset><div class="content-buttons"><md-button class="btn btn-secondary btn-lg" \nng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/manutencao.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="LOTE_PRODUCAO.MANUTENCAO">\xC1rea</h1>\n<md-button class="btn btn-tertiary btn-lg-i" translate="LOTE_PRODUCAO.VISUALIZAR_OCORRENCIA" \nng-click="vm.gotoVisualizarOcorrencia()">Visualizar Ocorr\xEAncia</md-button></div><div class="content-register"><form \nname="loteProducaoForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div \nclass="simple-table-container"><div class="ms-responsive-table-wrapper"><div class="paginator" \nng-show="vm.model.lote_producao_insumo_biologicos.length == 0 && vm.model.lote_producao_insumo_defensivos.length == 0 && vm.model.lote_producao_insumo_fertilizantes.length == 0">\n<i class="far fa-file-alt"></i><p>Nenhum registro encontrado.</p></div><div class="entity_division" \nng-if="vm.model.lote_producao_insumo_biologicos.length >= 1"><div class="title-table"><h2 class="head-entities">\nInsumo biol\xF3gico</h2></div><div class="format-table custom" layout="column" layout-gt-xs="row" layout-margin><table \nclass="epochal-area" id="responsive_area" class="simple"><tr><div layout="column" layout-gt-xs="row" \nclass="display-content-custom" layout-margin ng-repeat="biologico in vm.model.lote_producao_insumo_biologicos"><div \nclass="justify-content-end"><md-button class="icon-btn md-icon-button" \nng-click="vm.removerInsumoBiologicoDialog($event, biologico, vm.model)"><div class="btn-icon remove"><i \nclass="far fa-trash-alt remove"><md-tooltip md-direction="left">Excluir</md-tooltip></i></div></md-button></div><div \nclass="display-flex"><md-input-container class="datepicker-custom" disabled="disabled"><label>Data da aplica\xE7\xE3o</label>\n<md-datepicker name="data_aplicacao" ng-model="biologico.data_aplicacao" md-placeholder="Data da aplica\xE7\xE3o" \nmd-open-on-focus disabled="disabled"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.INSUMO_NOME">Nome do Insumo</label><input type="text" name="insumo_nome" disabled="disabled" \nng-model="biologico.insumo_agricola_nome"></md-input-container><md-input-container flex-xs="100" flex="10" \ndisabled="disabled"><label translate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input type="text" \nname="insumo_quantidade" disabled="disabled" \nvalue="{{biologico.quantidade | finance:false:3}} {{biologico.unidade_medida}}"></md-input-container></div></div></tr>\n</table></div></div><div class="entity_division" ng-if="vm.model.lote_producao_insumo_defensivos.length >= 1"><div \nclass="title-table"><h2 class="head-entities">Insumo defensivo</h2></div><div class="format-table custom" \nlayout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" id="responsive_area" class="simple"><tr>\n<div layout="column" layout-gt-xs="row" class="display-content-custom" layout-margin \nng-repeat="defensivo in vm.model.lote_producao_insumo_defensivos"><div class="justify-content-end"><md-button \nclass="icon-btn md-icon-button" ng-click="vm.removerInsumoDefensivoDialog($event, defensivo, vm.model)"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip md-direction="left">Excluir</md-tooltip></i>\n</div></md-button></div><div class="display-flex"><md-input-container class="datepicker-custom" disabled="disabled">\n<label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="defensivo.data_aplicacao" \nmd-placeholder="Data da aplica\xE7\xE3o" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container>\n<md-input-container flex><label translate="LOTE_PRODUCAO.INSUMO_NOME">Nome do Insumo</label><input type="text" \nname="insumo_nome" disabled="disabled" ng-model="defensivo.insumo_agricola_nome"></md-input-container>\n<md-input-container flex-xs="100" flex="10" ng-if="defensivo.carencia >= 1"><label translate="LOTE_PRODUCAO.CARENCIA">\nCar\xEAncia</label><input type="text" name="insumo_carencia" disabled="disabled" ng-model="defensivo.carencia">\n</md-input-container><md-input-container flex-xs="100" flex="10"><label translate="LOTE_PRODUCAO.QUANTIDADE">Quantidade\n</label><input type="text" name="insumo_quantidade" disabled="disabled" \nvalue="{{defensivo.quantidade | finance:false:3}} {{defensivo.unidade_medida}}"></md-input-container></div></div></tr>\n</table></div></div><div class="entity_division" ng-if="vm.model.lote_producao_insumo_fertilizantes.length >= 1"><div \nclass="title-table"><h2 class="head-entities">Insumo fertilizante</h2></div><div class="format-table custom" \nlayout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" id="responsive_area" class="simple"><tr>\n<div layout="column" layout-gt-xs="row" class="display-content-custom" layout-margin \nng-repeat="fertilizante in vm.model.lote_producao_insumo_fertilizantes"><div class="justify-content-end"><md-button \nclass="icon-btn md-icon-button" ng-click="vm.removerInsumoFertilizanteDialog($event, fertilizante, vm.model)"><div \nclass="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip md-direction="left">Excluir</md-tooltip></i>\n</div></md-button></div><div class="display-flex"><md-input-container class="datepicker-custom" disabled="disabled">\n<label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="fertilizante.data_aplicacao" \nmd-placeholder="Data da aplica\xE7\xE3o" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container>\n<md-input-container flex><label translate="LOTE_PRODUCAO.INSUMO_NOME">Nome do Insumo</label><input type="text" \nname="insumo_nome" disabled="disabled" ng-model="fertilizante.insumo_agricola_nome"></md-input-container>\n<md-input-container flex-xs="100" flex="10"><label translate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input \ntype="text" name="insumo_quantidade" disabled="disabled" \nvalue="{{fertilizante.quantidade | finance:false:3}} {{fertilizante.unidade_medida}}"></md-input-container></div></div>\n</tr></table></div></div></div></div></md-card></fieldset><div class="content-buttons"><a \nhref="javascript:history.back(1);" class="btn btn-secondary btn-lg">Voltar</a></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/manutencao.tmpl.html','<md-dialog class="modal-custom-register modal-motivo-ocorrencia"><form name="motivoForm" novalidate="" \napi-form="vm.api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>Excluir insumo</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.close()">X</md-button></div></md-toolbar><md-dialog-content><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="LOTE_PRODUCAO.OCORRENCIA">\nOcorr\xEAncia</label><textarea name="motivo" ng-model="vm.motivo" placeholder="Escrever o motivo" maxlength="1000">\n</textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout="row"><md-button \nclass="btn btn-secondary" ng-click="vm.close()">Voltar</md-button><md-button class="btn btn-primary" \nng-disabled="vm.motivo == \'\'" ng-click="vm.save()">Salvar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/lote_producao/views/ocorrencia.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="LOTE_PRODUCAO.LOTE_PRODUCAO">\xC1rea</h1>\n</div><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div><div class="form-search"><form>\n<md-input-container><label>&nbsp;</label><input id="txt-filtro" class="mobile-text-center input-search" \nplaceholder="Buscar" ng-model="vm.args.query" ng-model-options="{ debounce: 1000 }" ng-change="vm.args._change()"><div \nclass="i-search"><hr><md-icon md-font-icon="icon-magnify" class="s22 icon-magnify"></md-icon></div>\n</md-input-container></form></div></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" \nlayout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom ocorrencia"><thead><tr><th class="secondary-text pagination-custom" lm-sort-header="data" \nlm-title="Data e hora"></th><th class="secondary-text pagination-custom" lm-sort-header="ocorrenciatipo" \nlm-title="Tipo da ocorr\xEAncia"></th><th class="secondary-text pagination-custom" lm-sort-header="motivo" \nlm-title="Ocorr\xEAncia"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Insumo exclu\xEDdo</span></div></th></tr></thead><tbody><tr \nng-repeat="ocorrencia in vm.models"><td>{{ocorrencia.data_inclusao | date:\'dd/MM/yyyy HH\'}}h</td><td>\n{{ocorrencia.ocorrencia_tipo}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizarMotivo(ocorrencia.motivo)" aria-label="Motivo"><i class="far fa-eye"><md-tooltip \nmd-direction="left">Motivo</md-tooltip></i></md-button></td><td \nng-if="ocorrencia.lote_producao_insumo_biologico_id > 0">Biol\xF3gico<md-button \nclass="button-link-insumo-ocorrencia edit-button md-icon-button" \nng-click="vm.gotoInsumoBiologico(ocorrencia.lote_producao_insumo_biologico_id)" aria-label="Manuten\xE7\xE3o"><md-icon \nmd-font-icon="icon-link"><md-tooltip md-direction="right">Biol\xF3gico</md-tooltip></md-icon></md-button></td><td \nng-if="ocorrencia.lote_producao_insumo_fertilizante_id > 0">Fertilizante<md-button \nclass="button-link-insumo-ocorrencia edit-button md-icon-button" \nng-click="vm.gotoInsumoFertilizante(ocorrencia.lote_producao_insumo_fertilizante_id)" aria-label="Manuten\xE7\xE3o"><md-icon \nmd-font-icon="icon-link"><md-tooltip md-direction="right">Fertilizante</md-tooltip></md-icon></md-button></td><td \nng-if="ocorrencia.lote_producao_insumo_defensivo_id > 0">Defensivo<md-button \nclass="button-link-insumo-ocorrencia edit-button md-icon-button" \nng-click="vm.gotoInsumoDefensivo(ocorrencia.lote_producao_insumo_defensivo_id)" aria-label="Manuten\xE7\xE3o"><md-icon \nmd-font-icon="icon-link"><md-tooltip md-direction="right">Defensivo</md-tooltip></md-icon></md-button></td></tr>\n</tbody></table><lm-paginator lm-args="vm.args"></lm-paginator><md-progress-linear ng-if="vm.args.loading" \nmd-mode="indeterminate"></md-progress-linear></div></div><div class="content-buttons"><a \nhref="javascript:history.back(1);" class="btn btn-secondary btn-lg">Voltar</a></div></div></div></div>');
$templateCache.put('app/main/registro/lote_producao/views/print-label.html','<md-dialog aria-label="liberar"><form ng-cloak name="imprimirForm" novalidate="" api-form="api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>{{\'LOTE.ETIQUETA\' | translate }}</h2><span flex></span></div>\n</md-toolbar><md-dialog-content><div class="md-dialog-content"><div api-form-validation-summary form="imprimirForm">\n</div><div id="printThis" class="label"><div class="dados-etiqueta"><strong>{{model.nome_produtor}}</strong><p>\nEndere\xE7o: {{model.endereco.rua}}, {{model.endereco.numero}} - {{model.endereco.cidade}}</p><p \nng-if="model.cnpj_cpf.length == 11">CPF: {{model.cnpj_cpf | brCpf}}</p><p ng-if="model.cnpj_cpf.length == 14">\nCNPJ: {{model.cnpj_cpf | brCnpj}}</p><p>Telefone: {{model.telefone.ddd}}{{model.telefone.numero}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - 200kg</strong><p>\nC\xF3digo de rastreamento:{{model.lote_numero}}</p></div><div class="dados-etiqueta-2"><p \nng-if="vm.model.expedicao == true">Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p></div><div \nclass="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.logado_nome}}<br>\nCPF/CNPJ: {{model.logado_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'M\'" size="300" input-mode="\'ALPHA_NUM\'" text="model.lote_numero" image="true"></qr></div><div \nclass="compartveg-logo"><img src="../assets/images/logos/logo-compartveg-etiqueta.svg"></div></div></div>\n<md-input-container class="md-input-has-value"><md-checkbox name="comprador" ng-checked="checked" \nng-model="vm.model.distribuidor"><span>Incluir distribuidor</span></md-checkbox><md-checkbox name="comprador" \nng-checked="checked" ng-model="vm.model.expedicao"><span>Incluir data de expedi\xE7\xE3o</span></md-checkbox>\n</md-input-container><div><md-input-container class="md-input-has-value"><md-select \nng-if="vm.model.distribuidor == true" class="md-block" ng-model="vm.model.cliente_distribuidor"><md-option \nng-repeat="cliente_distribuidor in vm.cliente_distribuidores" ng-value="cliente_distribuidor"><span>\n{{cliente_consumidor.nome}}</span></md-option><md-option ng-if="vm.cliente_distribuidores.length==0" \ndisabled="disabled">Nenhum cliente cadastrado</md-option></md-select></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions layout="row"><span flex></span><md-button ng-click="cancelar()">\n{{\'LOTE.CANCELAR\' | translate }}</md-button><md-button class="color-compartveg" ng-print print-element-id="printThis">\n{{\'LOTE.IMPRIMIR\' | translate }}</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/lote_producao/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="LOTE_PRODUCAO.VIEW">Visualizar lote</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="loteProducaoForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card \nclass="style-md-tags"><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label="Informa\xE7\xF5es do lote">\n<md-content><div class="simple-table-container"><div class="ms-responsive-table-wrapper"><div class="entity_division">\n<div class="title-table"><h2 class="head-entities">Propriedade/\xC1rea</h2></div><div class="format-table custom custom" \nlayout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" id="responsive_area" class="simple"><tr>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.AREA_NOME">Nome da \xE1rea</label><input type="text" name="area_nome" \nng-model="vm.model.area_nome"></md-input-container><md-input-container flex="10"><label \ntranslate="LOTE_PRODUCAO.AREA_PRODUTIVA">\xC1rea produtiva</label><input type="text" name="area_area_produtiva" \nng-model="vm.model.area_area_produtiva"></md-input-container><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.ENDERECO">Rua</label><input type="text" name="propriedade_endereco" \nng-model="vm.model.propriedade_endereco"></md-input-container><md-input-container flex="25"><label \ntranslate="LOTE_PRODUCAO.CIDADE">Cidade</label><input type="text" name="propriedade_cidade_nome" \nvalue="{{vm.model.propriedade_cidade_nome}} - {{vm.model.propriedade_uf}}"></md-input-container></div></tr></table>\n</div></div><div class="entity_division"><div class="title-table"><h2 class="head-entities">Plantio</h2></div><div \nclass="format-table custom" layout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" \nid="responsive_area" class="simple"><tr><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label translate="LOTE_PRODUCAO.DATA_PLANTIO">Data do plantio</label><md-datepicker \nname="data_plantio" ng-model="vm.model.plantio_data" md-placeholder="Data do plantio" md-open-on-focus \ndisabled="disabled"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.CULTURA">Cultura</label><input type="text" name="produto_nome" \nng-model="vm.model.produto_nome"></md-input-container><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.VARIEDADE">Variedade</label><input type="text" name="produtor_variedade" \nng-model="vm.model.produto_variedade"></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex><label translate="LOTE_PRODUCAO.PLANTIO_DE">Plantio de</label><input type="text" \nname="plantio_de" ng-model="vm.model.plantio_tipo"></md-input-container><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input type="text" name="plantio_quantidade" \nvalue="{{vm.model.plantio_quantidade}} {{vm.model.plantio_unidade_medida}}"></md-input-container><md-input-container \nclass="datepicker-custom" ng-if="vm.model.data_colheita_prevista"><label translate="LOTE_PRODUCAO.COLHEITA_PREVISTA">\nColheita prevista</label><md-datepicker name="data_colheita_prevista" ng-model="vm.model.data_colheita_prevista" \nmd-placeholder="Data da colheita prevista" md-open-on-focus disabled="disabled"></md-datepicker><input type="text" \nvalue="Data da colheita prevista" disabled="disabled"></md-input-container><md-input-container flex \nng-if="!vm.model.data_colheita_prevista"><label>Colheita prevista</label><input type="text" value="-- / -- / ----">\n</md-input-container><md-input-container flex><label translate="LOTE_PRODUCAO.PERCENTUAL_PERDA">Percentual de perda\n</label><input type="text" name="porcentagem_perda_prevista" value="{{vm.model.porcentagem_perda_prevista}}%">\n</md-input-container><md-input-container flex><label translate="LOTE_PRODUCAO.PESO_UNIDADE_GRAMAS">\nPeso por unidade em gramas</label><input type="text" name="peso_unidade_gramas" \nvalue="{{vm.model.unidade_peso_previsto}}g"></md-input-container></div></tr></table></div></div><div \nclass="entity_division"><div class="title-table"><h2 class="head-entities">Colheita</h2></div><div \nclass="format-table custom" layout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" \nid="responsive_area" class="simple"><tr><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom"><label translate="LOTE_PRODUCAO.DATA_COLHEITA">Data da colheita</label><md-datepicker \nname="data_colheita" ng-model="vm.model.data_colheita" md-placeholder="Data da colheita" md-open-on-focus \ndisabled="disabled"></md-datepicker></md-input-container><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input type="text" name="quantidade" \nvalue="{{vm.model.quantidade | number:3 }} {{vm.model.unidade_medida}}"></md-input-container><md-input-container flex>\n<label>Valor por quilo</label><input type="text" name="valor" value="R$ {{vm.model.valor | finance:false:2 }}">\n</md-input-container><md-input-container flex><label>Valor total</label><input type="text" name="valor_total" \nvalue="R$ {{vm.model.valor_total | finance:false:2 }}"></md-input-container></div></tr></table></div></div></div></div>\n</md-content></md-tab><md-tab label="Aplica\xE7\xE3o de insumo" \nng-if="vm.model.lote_producao_insumo_fertilizantes.length >= 1 || vm.model.lote_producao_insumo_defensivos.length >= 1 || vm.model.lote_producao_insumo_biologicos.length >= 1">\n<md-content><div class="simple-table-container"><div class="entity_division" \nng-if="vm.model.lote_producao_insumo_biologicos.length >= 1"><div class="title-table"><h2 class="head-entities">\nInsumo biol\xF3gico</h2></div><div class="format-table custom" layout="column" layout-gt-xs="row" layout-margin><table \nclass="epochal-area" id="responsive_area" class="simple"><tr><div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="biologico in vm.model.lote_producao_insumo_biologicos"><md-input-container class="datepicker-custom"><label>\nData da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="biologico.data_aplicacao" \nmd-placeholder="Data da aplica\xE7\xE3o" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container>\n<md-input-container flex><label translate="LOTE_PRODUCAO.INSUMO_NOME">Nome do Insumo</label><input type="text" \nname="insumo_nome" ng-model="biologico.insumo_agricola_nome"></md-input-container><md-input-container flex="10"><label \ntranslate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input type="text" name="insumo_quantidade" \nvalue="{{biologico.quantidade | finance:false:3}} {{biologico.unidade_medida}}"></md-input-container></div></tr>\n</table></div></div><div class="entity_division" ng-if="vm.model.lote_producao_insumo_defensivos.length >= 1"><div \nclass="title-table"><h2 class="head-entities">Insumo defensivo</h2></div><div class="format-table custom" \nlayout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" id="responsive_area" class="simple"><tr>\n<div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="defensivo in vm.model.lote_producao_insumo_defensivos"><md-input-container class="datepicker-custom"><label>\nData da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="defensivo.data_aplicacao" \nmd-placeholder="Data da aplica\xE7\xE3o" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container>\n<md-input-container flex><label translate="LOTE_PRODUCAO.INSUMO_NOME">Nome do Insumo</label><input type="text" \nname="insumo_nome" ng-model="defensivo.insumo_agricola_nome"></md-input-container><md-input-container flex="10" \nng-if="defensivo.carencia >= 1"><label translate="LOTE_PRODUCAO.CARENCIA">Car\xEAncia</label><input type="text" \nname="insumo_carencia" ng-model="defensivo.carencia"></md-input-container><md-input-container flex="10"><label \ntranslate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input type="text" name="insumo_quantidade" \nvalue="{{defensivo.quantidade | finance:false:3}} {{defensivo.unidade_medida}}"></md-input-container></div></tr>\n</table></div></div><div class="entity_division" ng-if="vm.model.lote_producao_insumo_fertilizantes.length >= 1"><div \nclass="title-table"><h2 class="head-entities">Insumo fertilizante</h2></div><div class="format-table custom" \nlayout="column" layout-gt-xs="row" layout-margin><table class="epochal-area" id="responsive_area" class="simple"><tr>\n<div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="fertilizante in vm.model.lote_producao_insumo_fertilizantes"><md-input-container class="datepicker-custom">\n<label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="fertilizante.data_aplicacao" \nmd-placeholder="Data da aplica\xE7\xE3o" md-open-on-focus disabled="disabled"></md-datepicker></md-input-container>\n<md-input-container flex><label translate="LOTE_PRODUCAO.INSUMO_NOME">Nome do Insumo</label><input type="text" \nname="insumo_nome" ng-model="fertilizante.insumo_agricola_nome"></md-input-container><md-input-container flex="10">\n<label translate="LOTE_PRODUCAO.QUANTIDADE">Quantidade</label><input type="text" name="insumo_quantidade" \nvalue="{{fertilizante.quantidade | finance:false:3}} {{fertilizante.unidade_medida}}"></md-input-container></div></tr>\n</table></div></div></div></md-content></md-tab></md-tabs></md-content></md-card></fieldset><div \nclass="content-buttons"><a href="javascript:history.back(1);" class="btn btn-secondary btn-lg">Voltar</a><md-button \nclass="btn btn-primary" ng-if="vm.model.lote_producao_status.id == 1" ng-click="vm.ConfirmacaoEncerramento(vm.model)">\nEncerrar lote</md-button><md-button class="btn btn-primary" ng-if="vm.model.lote_producao_status.id == 2" \nng-click="vm.ConfirmacaoEstorno(vm.model)">Estornar lote</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/plantio/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 translate="PLANTIO.PLANTIO">Plantio\n</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div><md-button\n class="btn btn-primary btn-lg-i" translate="PLANTIO.ADD_PLANTIO" ng-click="vm.gotoAdd(vm.args.Propriedade_Id)" \nng-disabled="vm.rows.propriedades_cliente.length == 0">Adicionar plantio</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div>\n</div><div class="form-search-horizontal"><form><div class="container"><div class="row"><div class="col icon-filters">\n<img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col"><md-input-container \nclass="select-custom" flex><label>\xC1rea</label><select class="md-block" name="area" \nng-model="vm.args.propriedade_area_id" ng-init="vm.args.propriedade_area_id = options[0]"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="area in vm.filtros.propriedades_area" \nng-value="area.id">{{area.nome}}</option></select></md-input-container></div><div class="col"><md-input-container \nclass="select-custom" flex><label>Cultura</label><select class="md-block" name="cultura" ng-model="vm.args.cultura">\n<option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="cultura in vm.filtros.cultura" placeholder="Selecione a cultura" ng-value="cultura.nome">{{cultura.nome}}\n</option></select></md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>\nPlantio de</label><select class="md-block" name="plantio_de" ng-model="vm.args.plantio_de"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="plantio_de in vm.filtros.tipos_plantio" \nng-value="plantio_de.nome">{{plantio_de.nome}}</option></select></md-input-container></div><div class="col">\n<md-input-container class="select-custom datepicker-custom"><label>Data plantio</label><md-datepicker \nname="data_inicial" ng-model="vm.args.data_plantio" md-max-date="vm.date" ng-change="$mdMenu.open()" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="col"><div \nclass="content-buttons"><md-button class="btn btn-tertiary btn-md-i" ng-click="vm.args._change();">Filtrar</md-button>\n<a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div \nclass="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom plantio"><thead><tr><th \nclass="secondary-text pagination-custom table-column-id" lm-sort-header="id" lm-title="ID" flex="10"></th><th \nclass="secondary-text pagination-custom table-column-id" lm-sort-header="caderno_campo_propriedade_area_nome" \nlm-title="Nome da \xE1rea" flex="10"></th><th class="secondary-text pagination-custom" lm-sort-header="cultura_nome" \nlm-title="Cultura" flex="50"></th><th class="secondary-text pagination-custom" lm-sort-header="variedade" \nlm-title="Variedade" flex="50"></th><th class="secondary-text pagination-custom" lm-sort-header="data_plantio" \nlm-title="Data plantio"></th><th class="secondary-text pagination-custom" lm-sort-header="tipo_plantio" \nlm-title="Plantio de"></th><th class="secondary-text pagination-custom" lm-sort-header="quantidade" \nlm-title="Quantidade"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title" translate="PLANTIO.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat="model in vm.rows"><td>{{model.id}}</td><td>{{model.propriedade_area_nome}}</td><td>{{model.cultura_nome}}\n</td><td>{{model.variedade_nome}}</td><td>{{model.data_plantio | date:\'dd/MM/yyyy\'}}</td><td>{{model.tipo_plantio}}\n</td><td ng-if="model.tipo_plantio == \'Semente\'">{{ model.quantidade | number:3 }}</td><td \nng-if="model.tipo_plantio != \'Semente\'">{{ model.quantidade | number }}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table></div></div>\n<lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/plantio/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PLANTIO.ADD_PLANTIO">Adicionar \xE1rea</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="plantioForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 \ntranslate="PLANTIO.DATA_PLANTIO">Dados do plantio</h3><div api-form-validation-summary class="style-error" \nform="plantioForm"></div><div layout="column" layout-gt-xs="row" layout-margin style="margin-bottom: -2px;">\n<md-input-container class="select-custom" flex md-delay="500"><label>\xC1rea</label><md-select id="slctAr" \nclass="md-block" ng-change="vm.changeArea()" name="area" placeholder="Selecione a \xE1rea" \nng-model="vm.model.propriedade_area" required><md-option ng-repeat="area in vm.areas" ng-value="area">{{area.nome}}\n</md-option></md-select><div class="errors" ng-messages="plantioForm.area.$error" ng-if="plantioForm.area.$touched">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{plantioForm.area.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><label>Cultura</label><input id="inptVrdd" type="text" \nname="cultura" ng-model="vm.model.cultura.nome" placeholder="..." disabled="disabled" required><div class="errors" \nng-messages="plantioForm.cultura.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{plantioForm.cultura.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="PLANTIO.VARIEDADE">Variedade</label><input id="inptVrdd" type="text" name="variedade" \nng-model="vm.model.variedade" placeholder="..." ng-disabled="vm.model.variedadeId || !vm.model.cultura" maxlength="20" \nrequired><div class="errors" ng-messages="plantioForm.variedade.$error"><div ng-message="required">Campo obrigat\xF3rio\n</div><div ng-message="api_erro">{{plantioForm.variedade.$api.error.message}}</div></div></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><label>\nData do plantio</label><md-datepicker name="data_plantio" ng-model="vm.model.data_plantio" md-max-date="vm.date" \nmd-placeholder="Inserir data" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="plantioForm.data_plantio.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{plantioForm.data_plantio.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="30"><label translate="PLANTIO.PLANTIO_DE">Plantio de</label><md-select \nid="slctPlnt" class="md-block" placeholder="Selecione o tipo de plantio" ng-change="vm.changeTipoPlantio()" \nname="plantiode" ng-disabled="!vm.model.cultura" ng-model="vm.model.obj_tipo_plantio" required><md-option \nng-repeat="tipo_plantio in vm.tipo_plantios" ng-value="tipo_plantio">{{tipo_plantio.nome}}</md-option></md-select><div \nclass="errors" ng-messages="plantioForm.plantiode.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{plantioForm.plantiode.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="30" md-delay="500" \nng-if="vm.model.obj_tipo_plantio.id == 2"><label>Estoque de semente</label><md-select id="slctEstq" class="md-block" \nng-model="vm.model.insumo_estoque" ng-change="vm.changeProduto()" name="insumo_agricola_nome" \nplaceholder="Selecione o produto" required><md-option ng-repeat="insumo_produto in vm.productStock" \nng-value="insumo_produto">{{insumo_produto.insumo_nome}}</md-option></md-select><div \nng-messages="insumoForm.produto.$error" ng-if="insumoForm.produto.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.produto.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="30" ng-if="vm.model.obj_tipo_plantio.id == 2"><label>Quantidade (kg)\n</label><input id="inptQtdd" type="text" name="quantidade" placeholder="Insira a quantidade" \nng-model="vm.model.quantidade" ui-number-mask="3" min="0.001" max="9.999.999" maxlength="11" \nng-change="vm.changeQuantidade()" required placeholder="Quantidade" ng-disabled="!vm.model.tipo_unidade_medida"><div \nclass="errors" ng-messages="plantioForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="min">Deve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{9999999999.999 | finance:false:3}}</div><div ng-message="api_erro">\n{{plantioForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container flex="30" \nng-if="vm.model.obj_tipo_plantio.id == 1"><label>Quantidade (Unidades)</label><input id="inptQtdd" type="text" \nname="quantidade" placeholder="Insira a quantidade" ng-model="vm.model.quantidade" ui-number-mask="0" min="1" \nmax="999.999.999" maxlength="11" ng-change="vm.changeQuantidade()" required placeholder="Quantidade" \nng-disabled="!vm.model.tipo_unidade_medida"><div class="errors" ng-messages="plantioForm.quantidade.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="min">Deve ser maior que {{1 | number}}</div><div \nng-message="max">Deve ser menor que {{999.999.999 | number}}</div><div ng-message="api_erro">\n{{plantioForm.quantidade.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>Previs\xE3o\n<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="PLANTIO.PER_DAYS">Previs\xE3o de dias</label><input id="inptDs" type="text" name="dias" \nng-model="vm.model.dias" maxlength="4" ng-pattern="/^[0-9]*$/" placeholder="Insira a previs\xE3o de dias"><div \nclass="errors" ng-messages="plantioForm.dias.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">{{plantioForm.days.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="datepicker-custom"><label>Colheita prevista</label><md-datepicker\n name="data_colheita_prevista" ng-model="vm.model.data_colheita_prevista" md-min-date="vm.date" \nmd-placeholder="Inserir data" md-open-on-focus disabled="disabled"></md-datepicker><div class="errors" \nng-messages="plantioForm.data_colheita_prevista.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{plantioForm.data_colheita_prevista.$api.error.message}}</div></div></md-input-container><md-input-container flex>\n<label translate="PLANTIO.PERCENT_LOST">Percentual de Perda</label><input id="inptPrcntl" type="text" \nname="porcentagem_perda_prevista" ng-model="vm.model.porcentagem_perda_prevista" ui-percentage-value maxlength="4" \nui-percentage-mask="0" min="0.1" max="99.0" placeholder="Insira o percentual de perda"><div class="errors" \nng-messages="plantioForm.porcentagem_perda_prevista.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="min">Deve ser maior que {{1}}%</div><div ng-message="max">Deve ser menor que {{99}}%</div><div \nng-message="api_erro">{{plantioForm.area.$api.error.message}}</div></div></md-input-container><md-input-container flex>\n<label translate="PLANTIO.WEIGHT_PER_UNIT">Peso por Unidade</label><input id="inptPs" type="text" \nname="unidade_peso_previsto" ng-model="vm.model.unidade_peso_previsto" ui-number-mask="3" min="0.001" max="9.999.999" \nmaxlength="11" placeholder="Insira o peso por unidade"><div class="errors" \nng-messages="plantioForm.unidade_peso_previsto.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{plantioForm.unidade_peso_previsto.$api.error.message}}</div></div></md-input-container></div></md-card></fieldset>\n<div class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.cancelClick(plantioForm,$event)">\nVoltar</md-button><md-button id="btnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="plantioForm.$invalid || plantioForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/plantio/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/EW2z9NNi3aU?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/plantio/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PLANTIO.VIEW_PLANTIO">Visualizar \xE1rea</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="plantioForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><md-card><h3 \ntranslate="PLANTIO.DATA_PLANTIO">Dados do plantio</h3><div api-form-validation-summary class="style-error" \nform="plantioForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="PLANTIO.PROPERTIE">Propriedade</label><input type="text" name="plantio_propriedade" \nng-model="vm.model.propriedade_nome"></md-input-container><md-input-container flex><label translate="PLANTIO.AREA">\xC1rea\n</label><input type="text" name="plantio_area" ng-model="vm.model.propriedade_area_nome"></md-input-container></div>\n<div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="PLANTIO.CULTURA">\nCultura</label><input type="text" name="plantio _cultura" ng-model="vm.model.cultura_nome"></md-input-container>\n<md-input-container flex><label translate="PLANTIO.VARIEDADE">Variedade</label><input type="text" name="variedade" \nng-model="vm.model.variedade_nome"></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom"><label translate="PLANTIO.DATA_PLANTIO">Data do plantio</label>\n<md-datepicker name="data_plantio" ng-model="vm.model.data_plantio" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex><label translate="PLANTIO.PLANTIO_DE">Plantio de</label>\n<input type="text" name="tipo_plantio" ng-model="vm.model.tipo_plantio"></md-input-container><md-input-container flex \nng-if="vm.model.tipo_plantio == \'Semente\'"><label translate="PLANTIO.QUANTIDADE">Quantidade</label><input type="text" \nname="quantidade" placeholder="Insira a quantidade" ng-model="vm.model.quantidade" ui-number-mask="3">\n</md-input-container><md-input-container flex ng-if="vm.model.tipo_plantio != \'Semente\'"><label \ntranslate="PLANTIO.QUANTIDADE">Quantidade</label><input type="text" name="quantidade" \nplaceholder="Insira a quantidade" ng-model="vm.model.quantidade" ui-number-mask="0"></md-input-container>\n<md-input-container flex><label translate="PLANTIO.UNIDADE">Unidade</label><input type="text" name="unidade" \nng-model="vm.model.unidade_medida"></md-input-container></div></md-card><md-card \nng-if="vm.model.data_colheita_prevista"><h3>Previs\xE3o<span>(opcional)</span></h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><label \ntranslate="PLANTIO.DATA_COLHEITA">Data da colheita</label><md-datepicker name="data_colheita_prevista" \nng-model="vm.model.data_colheita_prevista" md-placeholder="Insira data" md-open-on-focus disabled="disabled">\n</md-datepicker></md-input-container><md-input-container flex><label translate="PLANTIO.PERCENT_LOST">\nPercentual de Perda</label><input type="text" name="porcentagem_perda_prevista" \nvalue="{{vm.model.porcentagem_perda_prevista}}%"></md-input-container><md-input-container flex><label \ntranslate="PLANTIO.WEIGHT_PER_UNIT">Peso por Unidade em Gramas</label><input type="text" name="unidade_peso_previsto" \nvalue="{{vm.model.unidade_peso_previsto}}g"></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div>\n</form></div></div></div></div>');
$templateCache.put('app/main/registro/propriedade/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 translate="PROPERTIES.PROPERTIES">\nPropriedades</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div><div>\n<md-icon md-font-icon="icon-question-mark-circle" ng-if="vm.models.length >= 1" class="s22 icon-question-mark-circle">\n<md-tooltip md-direction="left">N\xE3o \xE9 poss\xEDvel cadastrar mais do que uma propriedade</md-tooltip></md-icon><md-button \nclass="btn btn-primary btn-lg-i" translate="PROPERTIES.ADD_PROPERTIE" ng-disabled="vm.models.length >= 1" \nng-click="vm.gotoAdd()">Adicionar propriedade</md-button></div></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div>\n</div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom propriedade"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="nome" lm-title="Nome"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cnpj_cpf" lm-title="CNPJ/CPF" flex="50"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="endereco_cidade_nome" lm-title="Cidade - Estado"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="PROPERTIES.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td>\n{{model.nome}}</td><td ng-if="model.cnpj_cpf.length == 11">{{model.cnpj_cpf | brCpf}}</td><td \nng-if="model.cnpj_cpf.length == 14">{{model.cnpj_cpf | brCnpj}}</td><td>\n{{model.propriedade_endereco.cidade_nome}} - {{model.propriedade_endereco.uf}}</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoEditar(model.id)" aria-label="Editar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="right">Editar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="right">Visualizar</md-tooltip></i></md-button><br hide-xs></td>\n</tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div>\n</div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/propriedade/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PROPERTIES.ADD_PROPERTIE">Adicionar propriedade\n</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/custos/ico-propriedade.svg"></span>DADOS DA PROPRIEDADE</h3></div><div \nclass="content-register"><form name="propriedadeForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><div api-form-validation-summary form="propriedadeForm"></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><label \nclass="md-required" translate="PROPERTIES.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo_id" \nng-disabled="vm.model.cnpj_cpf.length > 2" ng-model="vm.model.pessoa_tipo_id" layout="row" required><md-radio-button \nid="rdoFisica" value="1">F\xEDsica</md-radio-button><md-radio-button id="rdoJuridica" value="2">Jur\xEDdica</md-radio-button>\n</md-radio-group><div ng-messages="propriedadeForm.pessoa_tipo_id.$error" \nng-show="propriedadeForm.pessoa_tipo_id.$touched"><div ng-message="required" translate>Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{propriedadeForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex="20" ng-if="vm.model.pessoa_tipo_id == 1">\n<label translate="PROPERTIES.CPF">CPF</label><input type="text" id="iptCnpjCpf" name="cnpj_cpf" \nplaceholder="Insira o CPF" ng-model="vm.model.cnpj_cpf" minlength="14" required ui-br-cpf-mask><div class="errors" \nng-messages="propriedadeForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF</div><div ng-message="api_erro">\n{{propriedadeForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" \nng-if="vm.model.pessoa_tipo_id == 2"><label translate=" PROPERTIES.CNPJ">CNPJ</label><input type="text" \nid="iptCnpjCpf" name="cnpj_cpf" placeholder="Insira o CNPJ" ng-model="vm.model.cnpj_cpf" minlength="18" required \nui-br-cnpj-mask><div class="errors" ng-messages="propriedadeForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CNPJ</div><div ng-message="api_erro">\n{{propriedadeForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20"><label \ntranslate=" PROPERTIES.CCIR">CCIR</label><input type="text" id="iptCcir" name="produtor_rural_inscricao" \nplaceholder="Insira o CCIR" ng-model="vm.model.produtor_rural_inscricao" ng-pattern="/^[0-9]*$/" maxlength="15" \nrequired><div class="errors" ng-messages="propriedadeForm.produtor_rural_inscricao.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{propriedadeForm.produtor_rural_inscricao.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="40"><label ng-if="vm.model.pessoa_tipo_id == 1">Nome</label><label ng-if="vm.model.pessoa_tipo_id == 2">\nRaz\xE3o social</label><input type="text" id="iptNome" name="nome" ng-model="vm.model.nome" maxlength="60" required><div \nclass="errors" ng-messages="propriedadeForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{propriedadeForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex><label>Tamanho (Hectares)</label><input type="text" id="iptHectares" name="area_propriedade" \nplaceholder="0,000 ha" ng-model="vm.model.area_propriedade" maxlength="12" required ui-number-mask="4" min="0.0001" \nmax="999.999.9999"><div class="errors" ng-messages="propriedadeForm.area_propriedade.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{ propriedadeForm.area_propriedade.$api.error.message }}</div><div ng-message="min">\nDeve ser maior que {{ 0.0001 | finance:false:2 }}</div><div ng-message="max">\nDeve ser menor que {{ 999.999.9999 | finance:false:2 }}</div></div></md-input-container></div></md-card><md-card><h3 \ntranslate="PROPERTIES.ADDRESS">Endere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nflex><label translate="PROPERTIES.CITY"></label><input type="text" placeholder="Insira a cidade" \nname="propriedade_endereco_cidade" ng-model="vm.model.propriedade_endereco.cidade_nome" maxlength="60" required><div \nclass="errors" ng-messages="propriedadeForm.propriedade_endereco_cidade.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{propriedadeForm.propriedade_endereco_cidade.$api.error.message}}\n</div></div></md-input-container><md-input-container flex="10"><label>UF</label><input type="text" \nplaceholder="Insira o estado" name="propriedade_endereco_uf" ng-model="vm.model.propriedade_endereco.uf" maxlength="2" \nrequired><div class="errors" ng-messages="propriedadeForm.propriedade_endereco_uf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{propriedadeForm.propriedade_endereco_uf.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="PROPERTIES.ADDRESS">Endere\xE7o</label><input \nid="iptEndereco" type="text" placeholder="Insira o endere\xE7o" ng-disabled="vm.model.propriedade_endereco == null" \nname="propriedade_endereco_endereco" ng-model="vm.model.propriedade_endereco.endereco" maxlength="60" required><div \nclass="errors" ng-messages="propriedadeForm.propriedade_endereco_endereco.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{propriedadeForm.propriedade_endereco_endereco.$api.error.message}}\n</div></div></md-input-container></div></md-card><md-card><h3>Localiza\xE7\xE3o<span>(opcional)</span></h3><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.LATITUDE">\nLatitude</label><input id="iptLatitude" type="text" placeholder="Insira a latitude" name="area_latitude" \nng-model="vm.model.area_latitude" maxlength="15"><div class="errors" \nng-messages="propriedadeForm.area_latitude.$error"><div ng-message="api_erro">\n{{propriedadeForm.area_latitude.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="PROPERTIES.LONGITUDE">Longitude</label><input id="iptLongitude" type="text" \nplaceholder="Insira a longitude" name="area_longitude" ng-model="vm.model.area_longitude" maxlength="15"><div \nclass="errors" ng-messages="propriedadeForm.area_longitude.$error"><div ng-message="api_erro">\n{{propriedadeForm.area_longitude.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>\nSobre a propriedade</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="PROPERTIES.DESCRIBE">Descrever</label><textarea id="txtareaDescrever" \nplaceholder="Inserir um breve relato sobre a sua propriedade." name="sobre_propriedade" \nng-model="vm.model.sobre_propriedade" cols="40" rows="5" maxlength="2000"></textarea><div class="errors" \nng-messages="propriedadeForm.sobre_propriedade.$error"><div ng-message="api_erro">\n{{propriedadeForm.sobre_propriedade.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>\nInforma\xE7\xF5es gerais<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n flex><label translate="PROPERTIES.SITE_ADDRESS">Endere\xE7o do site</label><input id="iptSite" type="text" \nplaceholder="Inserir endere\xE7o do site." name="endereco_site" ng-model="vm.model.endereco_site" maxlength="250"><div \nclass="errors" ng-messages="propriedadeForm.endereco_site.$error"><div ng-message="api_erro">\n{{propriedadeForm.endereco_site.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.TECHNICAL_MANAGER_NAME">\nNome do respons\xE1vel t\xE9cnico</label><input id="iptNomeResponsavel" type="text" placeholder="Inserir nome." \nname="nome_responsavel_tecnico" ng-model="vm.model.nome_responsavel_tecnico" maxlength="250"><div class="errors" \nng-messages="propriedadeForm.nome_responsavel_tecnico.$error"><div ng-message="api_erro">\n{{propriedadeForm.nome_responsavel_tecnico.$api.error.message}}</div></div></md-input-container><md-input-container \nflex><label translate="PROPERTIES.REGISTRATION_NUMBER">N\xFAmero do registro</label><input id="iptNumeroRegistro" \ntype="text" placeholder="Inserir n\xFAmero." name="numero_registro" ng-model="vm.model.numero_registro" maxlength="15">\n<div class="errors" ng-messages="propriedadeForm.numero_registro.$error"><div ng-message="api_erro">\n{{propriedadeForm.numero_registro.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 \nclass="custom">Adicionar fotos<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin>\n<choose-file id="btnCarregarFotos" ng-model="vm.files" layout="row" ng-max="5" \nng-images-added="vm.model.propriedade_files" flex></choose-file></div></md-card></fieldset><div \nclass="content-buttons"><md-button id="btnVoltar" class="btn btn-secondary btn-lg" \nng-click="vm.cancelClick(propriedadeForm,$event)" translate="PROPERTIES.VOLTAR">Voltar</md-button><md-button \nid="btnSalvar" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="propriedadeForm.$invalid || propriedadeForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)" \ntranslate="PROPERTIES.SALVAR">Salvar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/propriedade/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PROPERTIES.EDIT_PROPERTIE">Editar propriedade</h1>\n</div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="propriedadeForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><h3 \ntranslate="PROPERTIES.DATA_PROPERTIE">Dados da propriedade</h3><div api-form-validation-summary form="propriedadeForm">\n</div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value" \nng-class="{ \'md-input-invalid\' : propriedadeForm.tipo_pessoa_id.$invalid && propriedadeForm.tipo_pessoa_id.$touched }">\n<label class="md-required" translate="PROPERTIES.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo_id" \nng-disabled="vm.model.cnpj_cpf.length > 2" ng-model="vm.model.pessoa_tipo_id" layout="row" required><md-radio-button \nvalue="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="propriedadeForm.pessoa_tipo_id.$error" ng-show="propriedadeForm.pessoa_tipo_id.$touched"><div \nng-message="required" translate>Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{propriedadeForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="20" ng-if="vm.model.pessoa_tipo_id == 1"><label \ntranslate="PROPERTIES.CPF">CPF</label><input type="text" name="cnpj_cpf" placeholder="Insira o CPF" \nng-model="vm.model.cnpj_cpf" minlength="14" required ui-br-cpf-mask disabled="disabled"><div class="errors" \nng-messages="propriedadeForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF</div><div ng-message="api_erro">\n{{propriedadeForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" \nng-if="vm.model.pessoa_tipo_id == 2"><label translate=" PROPERTIES.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" placeholder="Insira o CNPJ" ng-model="vm.model.cnpj_cpf" minlength="18" required ui-br-cnpj-mask \ndisabled="disabled"><div class="errors" ng-messages="propriedadeForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CNPJ</div><div ng-message="api_erro">\n{{propriedadeForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20"><label \ntranslate=" PROPERTIES.CCIR">CCIR</label><input type="text" name="produtor_rural_inscricao" \nplaceholder="Insira o CCIR" ng-model="vm.model.produtor_rural_inscricao" ng-pattern="/^[0-9]*$/" maxlength="15" \nrequired><div class="errors" ng-messages="propriedadeForm.produtor_rural_inscricao.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{propriedadeForm.produtor_rural_inscricao.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="40"><label translate="PROPERTIES.NAME">Nome</label><input type="text" name="nome" placeholder="Insira o nome" \nng-model="vm.model.nome" maxlength="60" required><div class="errors" ng-messages="propriedadeForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{propriedadeForm.nome.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><label>Tamanho (Hectares)</label><input type="text" \nid="iptHectares" name="area_propriedade" placeholder="0,000 ha" ng-model="vm.model.hectares" maxlength="12" required \nui-number-mask="4" min="0.0001" max="999.999.9999"><div class="errors" \nng-messages="propriedadeForm.area_propriedade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{ propriedadeForm.area_propriedade.$api.error.message }}</div><div ng-message="min">\nDeve ser maior que {{ 0.0001 | finance:false:2 }}</div><div ng-message="max">\nDeve ser menor que {{ 999.999.9999 | finance:false:2 }}</div></div></md-input-container></div></md-card><md-card><h3 \ntranslate="PROPERTIES.ADDRESS">Endere\xE7o</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nflex><label translate="PROPERTIES.CITY"></label><input type="text" placeholder="Insira a cidade" \nname="propriedade_endereco_cidade" ng-model="vm.model.cidade" maxlength="60" required><div class="errors" \nng-messages="propriedadeForm.propriedade_endereco_cidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div\n ng-message="api_erro">{{propriedadeForm.propriedade_endereco_cidade.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><label>UF</label><input type="text" placeholder="Insira o estado" \nname="propriedade_endereco_uf" ng-model="vm.model.uf" maxlength="2" required><div class="errors" \nng-messages="propriedadeForm.propriedade_endereco_uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{propriedadeForm.propriedade_endereco_uf.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="PROPERTIES.ADDRESS">Endere\xE7o</label><input type="text" \nplaceholder="Insira o endere\xE7o" ng-disabled="vm.model.propriedade_endereco == null" \nname="propriedade_endereco_endereco" ng-model="vm.model.endereco" maxlength="60" required><div class="errors" \nng-messages="propriedadeForm.propriedade_endereco_endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{propriedadeForm.propriedade_endereco_endereco.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><h3>Localiza\xE7\xE3o<span>(opcional)</span></h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.LATITUDE">Latitude</label><input\n type="text" placeholder="Insira a latitude" name="area_latitude" ng-model="vm.model.area_latitude" maxlength="15"><div\n class="errors" ng-messages="propriedadeForm.area_latitude.$error"><div ng-message="api_erro">\n{{propriedadeForm.area_latitude.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="PROPERTIES.LONGITUDE">Longitude</label><input type="text" placeholder="Insira a longitude" \nname="area_longitude" ng-model="vm.model.area_longitude" maxlength="15"><div class="errors" \nng-messages="propriedadeForm.area_longitude.$error"><div ng-message="api_erro">\n{{propriedadeForm.area_longitude.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>\nSobre a propriedade</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="PROPERTIES.DESCRIBE">Descrever</label><textarea \nplaceholder="Inserir um breve relato sobre a sua propriedade." name="sobre_propriedade" \nng-model="vm.model.sobre_propriedade" cols="40" rows="5" maxlength="2000"></textarea><div class="errors" \nng-messages="propriedadeForm.sobre_propriedade.$error"><div ng-message="api_erro">\n{{propriedadeForm.sobre_propriedade.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>\nInforma\xE7\xF5es gerais<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n flex><label translate="PROPERTIES.SITE_ADDRESS">Endere\xE7o do site</label><input type="text" \nplaceholder="Inserir endere\xE7o do site." name="endereco_site" ng-model="vm.model.endereco_site" maxlength="250"><div \nclass="errors" ng-messages="propriedadeForm.endereco_site.$error"><div ng-message="api_erro">\n{{propriedadeForm.endereco_site.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.TECHNICAL_MANAGER_NAME">\nNome do respons\xE1vel t\xE9cnico</label><input type="text" placeholder="Inserir nome." name="nome_responsavel_tecnico" \nng-model="vm.model.nome_responsavel_tecnico" maxlength="250"><div class="errors" \nng-messages="propriedadeForm.nome_responsavel_tecnico.$error"><div ng-message="api_erro">\n{{propriedadeForm.nome_responsavel_tecnico.$api.error.message}}</div></div></md-input-container><md-input-container \nflex><label translate="PROPERTIES.REGISTRATION_NUMBER">N\xFAmero do registro</label><input type="text" \nplaceholder="Inserir n\xFAmero." name="numero_registro" ng-model="vm.model.numero_registro" maxlength="15"><div \nclass="errors" ng-messages="propriedadeForm.numero_registro.$error"><div ng-message="api_erro">\n{{propriedadeForm.numero_registro.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 \nclass="custom">Adicionar fotos<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin>\n<choose-file ng-model="vm.files" layout="row" ng-max="5" ng-images-added="vm.model.propriedade_files" \nchanged="vm.propriedade_files_changed" flex></choose-file></div></md-card></fieldset><div class="content-buttons">\n<md-button class="btn btn-secondary btn-lg" ng-click="vm.cancelClick(propriedadeForm,$event)" \ntranslate="PROPERTIES.VOLTAR">Voltar</md-button><md-button type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="(propriedadeForm.$invalid || propriedadeForm.$pristine || loadingProgress)  && !vm.propriedade_files_changed" \nng-click="vm.save(vm.model)" translate="PROPERTIES.SALVAR">Salvar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/propriedade/views/sucesso.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1>Propriedade > Adicionar</h1></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/icons/ico-tela-sucesso.svg" alt="sucesso"><h2>Propriedade adicionada com sucesso!</h2><span>\n-------------------------------------------------------</span><p>O que voc\xEA gostaria de fazer agora?</p><br><div \nclass="content-buttons-sucesso"><md-button type="button" class="btn btn-tertiary btn-md-i" \nng-click="vm.gotoVisualizar()">Ver dados da propriedade</md-button><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-href="/registro/area/criar">Adicionar \xE1rea</md-button><md-button \nclass="btn btn-secondary btn-md" ng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div></div></div>');
$templateCache.put('app/main/registro/propriedade/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/XXw1O5WutOA?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div>');
$templateCache.put('app/main/registro/propriedade/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="PROPERTIES.VIEW_PROPERTIE">Visualizar propriedade\n</h1></div></div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><form name="propriedadeForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset disabled="disabled"><div \napi-form-validation-summary form="propriedadeForm"></div><md-card><h3 translate="PROPERTIES.DATA_PROPERTIE">\nDados da propriedade</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-input-has-value" \nng-class="{ \'md-input-invalid\' : propriedadeForm.tipo_pessoa_id.$invalid && propriedadeForm.tipo_pessoa_id.$touched }">\n<label class="md-required" translate="PROPERTIES.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo_id" \nng-disabled="vm.model.cnpj_cpf.length > 2" ng-model="vm.model.pessoa_tipo_id" layout="row" required><md-radio-button \nvalue="1">F\xEDsica</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="propriedadeForm.pessoa_tipo_id.$error" ng-show="propriedadeForm.pessoa_tipo_id.$touched"><div \nng-message="required" translate>Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{propriedadeForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="20" ng-if="vm.model.pessoa_tipo_id == 1"><label \ntranslate="PROPERTIES.CPF">CPF</label><input type="text" name="cnpj_cpf" placeholder="Insira o CPF" \nng-model="vm.model.cnpj_cpf" minlength="14" required ui-br-cpf-mask disabled="disabled"><div class="errors" \nng-messages="propriedadeForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF</div><div ng-message="api_erro">\n{{propriedadeForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" \nng-if="vm.model.pessoa_tipo_id == 2"><label translate=" PROPERTIES.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" placeholder="Insira o CNPJ" ng-model="vm.model.cnpj_cpf" minlength="18" required ui-br-cnpj-mask \ndisabled="disabled"><div class="errors" ng-messages="propriedadeForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CNPJ</div><div ng-message="api_erro">\n{{propriedadeForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20"><label \ntranslate=" PROPERTIES.CCIR">CCIR</label><input type="text" name="produtor_rural_inscricao" \nplaceholder="Insira o CCIR" ng-model="vm.model.produtor_rural_inscricao" ng-pattern="/^[0-9]*$/" maxlength="15" \nrequired><div class="errors" ng-messages="propriedadeForm.produtor_rural_inscricao.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{propriedadeForm.produtor_rural_inscricao.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="40"><label translate="PROPERTIES.NAME">Nome</label><input type="text" name="nome" placeholder="Insira o nome" \nng-model="vm.model.nome" maxlength="60" required><div class="errors" ng-messages="propriedadeForm.nome.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{propriedadeForm.nome.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><label>Tamanho (Hectares)</label><input type="text" \nid="iptHectares" name="area_propriedade" placeholder="0,000 ha" ng-model="vm.model.hectares" ui-number-mask="4">\n</md-input-container></div></md-card><md-card><h3 translate="PROPERTIES.ADDRESS">Endere\xE7o</h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.CITY"></label><input \ntype="text" placeholder="Insira a cidade" name="propriedade_endereco_cidade" ng-model="vm.model.cidade" maxlength="60" \nrequired><div class="errors" ng-messages="propriedadeForm.propriedade_endereco_cidade.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{propriedadeForm.propriedade_endereco_cidade.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="10"><label>UF</label><input type="text" placeholder="Insira o estado" name="propriedade_endereco_uf" \nng-model="vm.model.uf" maxlength="2" required><div class="errors" \nng-messages="propriedadeForm.propriedade_endereco_uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{propriedadeForm.propriedade_endereco_uf.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="PROPERTIES.ADDRESS">Endere\xE7o</label><input type="text" \nplaceholder="Insira o endere\xE7o" ng-disabled="vm.model.propriedade_endereco == null" \nname="propriedade_endereco_endereco" ng-model="vm.model.endereco" maxlength="60" required><div class="errors" \nng-messages="propriedadeForm.propriedade_endereco_endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div>\n<div ng-message="api_erro">{{propriedadeForm.propriedade_endereco_endereco.$api.error.message}}</div></div>\n</md-input-container></div></md-card><md-card><h3>Localiza\xE7\xE3o<span>(opcional)</span></h3><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.LATITUDE">Latitude</label><input\n type="text" placeholder="Insira a latitude" name="area_latitude" ng-model="vm.model.area_latitude" maxlength="15"><div\n class="errors" ng-messages="propriedadeForm.area_latitude.$error"><div ng-message="api_erro">\n{{propriedadeForm.area_latitude.$api.error.message}}</div></div></md-input-container><md-input-container flex><label \ntranslate="PROPERTIES.LONGITUDE">Longitude</label><input type="text" placeholder="Insira a longitude" \nname="area_longitude" ng-model="vm.model.area_longitude" maxlength="15"><div class="errors" \nng-messages="propriedadeForm.area_longitude.$error"><div ng-message="api_erro">\n{{propriedadeForm.area_longitude.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>\nSobre a propriedade</h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="PROPERTIES.DESCRIBE">Descrever</label><textarea \nplaceholder="Inserir um breve relato sobre a sua propriedade." name="sobre_propriedade" \nng-model="vm.model.sobre_propriedade" cols="40" rows="5" maxlength="2" maxlength="2000"></textarea><div class="errors" \nng-messages="propriedadeForm.sobre_propriedade.$error"><div ng-message="api_erro">\n{{propriedadeForm.sobre_propriedade.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3>\nInforma\xE7\xF5es gerais<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin><md-input-container\n flex><label translate="PROPERTIES.SITE_ADDRESS">Endere\xE7o do site</label><input type="text" \nplaceholder="Inserir endere\xE7o do site." name="endereco_site" ng-model="vm.model.endereco_site" maxlength="250"><div \nclass="errors" ng-messages="propriedadeForm.endereco_site.$error"><div ng-message="api_erro">\n{{propriedadeForm.endereco_site.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="PROPERTIES.TECHNICAL_MANAGER_NAME">\nNome do respons\xE1vel t\xE9cnico</label><input type="text" placeholder="Inserir nome." name="nome_responsavel_tecnico" \nng-model="vm.model.nome_responsavel_tecnico" maxlength="250"><div class="errors" \nng-messages="propriedadeForm.nome_responsavel_tecnico.$error"><div ng-message="api_erro">\n{{propriedadeForm.nome_responsavel_tecnico.$api.error.message}}</div></div></md-input-container><md-input-container \nflex><label translate="PROPERTIES.REGISTRATION_NUMBER">N\xFAmero do registro</label><input type="text" \nplaceholder="Inserir n\xFAmero." name="numero_registro" ng-model="vm.model.numero_registro" maxlength="15"><div \nclass="errors" ng-messages="propriedadeForm.numero_registro.$error"><div ng-message="api_erro">\n{{propriedadeForm.numero_registro.$api.error.message}}</div></div></md-input-container></div></md-card><md-card><h3 \nclass="custom">Fotos<span>(opcional)</span></h3><div layout="column" layout-gt-xs="row" layout-margin \nclass="custom-upload-view"><md-card class="insumos" name="cards" ng-repeat="imagem in vm.model.propriedade_files"><div \nclass="div-imagem"><img class="image-thumbnail" ng-src="{{imagem.url}}"></div></md-card></div></md-card></fieldset><div\n class="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()" \ntranslate="PROPERTIES.VOLTAR">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/relatorios/insumos/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1 translate="RELATORIOS.INSUMOS">\nRelat\xF3rios</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div></div><div\n class="page-layout simple fullwidth doc-page" layout="column"><div class="content content-historico" layout="column">\n<div class="container-content-custom"><div class="propriedade-area"><div class="box-propriedade-area">\n<md-input-container class="md-input-has-value input-relatorio-historico" flex="50"><label>Gerar relat\xF3rio agrupado por:\n</label><md-radio-group md-autofocus name="agrupar-relatorio" ng-model="vm.model.agrupado_por" layout="row" required \nng-change="vm.agrupadoPorChange()"><md-radio-button id="rArea" value="1">\xC1rea</md-radio-button><md-radio-button \nid="rProduto" value="2">Produto</md-radio-button></md-radio-group></md-input-container></div></div><div \nclass="filter-top desktop-only"><div class="full-container"><div class="search-icon"><i class="fa fa-search"></i></div>\n<div class="filtro-area"><md-input-container><label>\xC1rea:</label><md-autocomplete flex class="md-block" \nmd-input-name="area" md-no-cache="false" md-selected-item="vm.model.area" md-search-text="areaQuery" \nng-disabled="vm.models.propriedades_cliente.length == 0" md-items="item in vm.areaSearch(areaQuery)" \nmd-item-text="item.nome" md-delay="500" md-require-match placeholder="Buscar"><md-item-template><span \nmd-highlight-text="vm.model.area">{{item.nome}}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete></md-input-container></div><div class="tipo_insumo"><div><label>Tipo de insumo:\n</label><div class="content-buttons-filter"><md-input-container class="radiobutton-custom" flex><md-radio-group \nng-model="vm.args.Tipo_Insumo"><md-radio-button ng-repeat="periods in vm.tipo_insumos" ng-value="periods.value">\n{{periods.description}}</md-radio-button></md-radio-group></md-input-container></div></div></div><div \nclass="sixtypercent-title"><label>Periodo:</label><div class="content-datepicker-filter"><md-input-container \nclass="datepicker-custom" flex="25"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.Data_Inicial" md-max-date="vm.date" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container><md-input-container class="datepicker-custom" flex="25"><label>Data final</label><md-datepicker \nname="data_fim" ng-model="vm.args.Data_Final" md-open-on-focus md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><div class="content-buttons"><md-button class="btn btn-tertiary" \nng-click="vm.search()">Buscar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div>\n</div></div></div></div><div class="filter-top mobile-only"><md-card><div class="full-container"><h2>Tipo de insumo\n</h2><div class="content-buttons-filter"><md-input-container class="radiobutton-custom" flex><md-radio-group \nng-model="vm.args.Tipo_Insumo"><md-radio-button ng-repeat="periods in vm.tipo_insumos" ng-value="periods.value">\n{{periods.description}}</md-radio-button></md-radio-group></md-input-container></div><h2>Per\xEDodo</h2><div \nclass="content-datepicker-filter"><md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label>\n<md-datepicker name="data_inicio" ng-model="vm.args.Data_Inicial" md-max-date="vm.date" md-placeholder="Inserir data" \nmd-open-on-focus></md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>\nData final</label><md-datepicker name="data_fim" ng-model="vm.args.Data_Final" md-open-on-focus \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="content-buttons">\n<md-button class="btn btn-tertiary" ng-click="vm.search()">Buscar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></md-card></div></div><div class="container-content-custom">\n<md-progress-linear ng-if="vm.loadingProgress" md-mode="indeterminate"></md-progress-linear><div \nng-if="(vm.model.agrupado_por == 1 && vm.models.propriedade_areas.length <= 0) || (vm.model.agrupado_por != 1 && vm.models.insumos.length <= 0)">\n<p class="text-center"><i class="far fa-file-alt"></i> N\xE3o h\xE1 nenhum registro para o filtro aplicado.</p></div><div \nclass="title-result" \nng-if="(vm.model.agrupado_por == 1 && vm.models.propriedade_areas.length > 0) || (vm.model.agrupado_por != 1 && vm.models.insumos.length > 0)">\n<div class="title"><h2>Resultados da pesquisa</h2></div><div class="actions"><a class="btn btn-quaternary" \nng-click="vm.getExcelFile()"><i class="far fa-file-excel"></i>Gerar arquivo excel</a></div></div><div \nclass="ms-responsive-table-wrapper" ng-if="vm.model.agrupado_por == 1" ng-repeat="area in vm.models.propriedade_areas">\n<div layout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom relatorios-insumo"><tbody class="ttop"><tr class="default"><td colspan="5"><span>\xC1rea: \n<strong>{{ area.nome }}</strong></span> <span>Tamanho da \xE1rea produtiva: <strong>\n{{ area.area_produtiva | number:4 }} hectares</strong></span> <span>Custo total: <strong>\nR$ {{ area.custo | finance:false:2 }}</strong></span></td></tr></tbody><tbody class="thead desktop"><tr><th class="w0">\n</th><th class="first secondary-text pagination-custom" lm-sort-header="nome" lm-title="Nome do insumo"></th><th \nclass="secondary-text pagination-custom w10" lm-sort-header="unidade_medida" lm-title="Unidade"></th><th \nclass="secondary-text pagination-custom w10" lm-sort-header="total" lm-title="Quantidade total"></th><th \nclass="secondary-text pagination-custom w10" lm-sort-header="custo" lm-title="Custo total"></th></tr></tbody><tbody><tr\n class="default" ng-repeat-start="insumo in area.insumos"><td class="click-button desktop"><a \nng-click="vm.isColapsed(insumo)" ng-hide="insumo.colapsed || insumo.isLoading"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeColapsed(insumo)" ng-hide="!insumo.colapsed">\n<md-icon md-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" \nng-show="!insumo.colapsed && vm.isDisabled"><md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um insumo por vez\n</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td><td>\n&nbsp;&nbsp;&nbsp;&nbsp; {{ insumo.insumo_agricola_nome }}</td><td>{{ insumo.unidade_medida }}</td><td>\n{{ insumo.total | number:3 }}</td><td>R$ {{ insumo.custo | finance:false:2 }}</td><td class="click-button mobile-only">\n<a ng-click="vm.isColapsed(insumo)" ng-hide="insumo.colapsed || insumo.isLoading"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeColapsed(insumo)" ng-hide="!insumo.colapsed">\n<md-icon md-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" \nng-show="!insumo.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td></tr><tr \nng-repeat-end class="details"><td class="main" colspan="6" \nng-if="insumo.colapsed && !insumo.isLoading || !vm.closeColapse"><div class="details-query" \nng-if="vm.agrupados.length >= 1"><table><thead><tr><th>Data da aplica\xE7\xE3o</th><th>Unidade</th><th>Quantidade</th><th>\nCusto</th></tr></thead><tbody><tr ng-repeat="insumos in vm.agrupados"><td class="w50">\n{{ insumos.data_aplicacao | date:\'dd/MM/yyyy\' }}</td><td class="w10">{{ insumos.unidade_medida }}</td><td class="w10">\n{{ insumos.total | number:3 }}</td><td class="w10">R$ {{ insumos.valor | finance:false:2 }}</td></tr></tbody></table>\n</div><div class="no-content" ng-if="vm.agrupados.length == 0"><i class="far fa-file-alt"></i><p>\nO insumo selecionado n\xE3o foi aplicado em nenhuma \xE1rea.</p></div></td><td colspan="6" ng-if="insumo.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate">\n</md-progress-linear></div></div><div class="ms-responsive-table-wrapper" ng-if="vm.model.agrupado_por != 1" \nng-repeat="insumo in vm.models.insumos"><div layout="column" flex><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom relatorios-insumo"><tbody class="ttop"><tr class="default"><td colspan="5">\n<span>Nome do insumo: <strong>{{ insumo.insumo_agricola_nome }}</strong></span> <span>Unidade: <strong>\n{{ insumo.unidade_medida }}</strong></span> <span>Quantidade: <strong>{{ insumo.total | number:3 }}</strong></span> \n<span>Custo total: <strong>R$ {{ insumo.custo }}</strong></span></td></tr></tbody><tbody class="thead desktop"><tr><th \nclass="w0"></th><th class="first secondary-text pagination-custom" lm-sort-header="nome" lm-title="\xC1rea"></th><th \nclass="secondary-text pagination-custom w10" lm-sort-header="unidade_medida" lm-title="Unidade"></th><th \nclass="secondary-text pagination-custom w10" lm-sort-header="total" lm-title="Quantidade total"></th><th \nclass="secondary-text pagination-custom w10" lm-sort-header="custo" lm-title="Custo total"></th></tr></tbody><tbody><tr\n class="default" ng-repeat-start="area in insumo.areas"><td class="click-button desktop"><a \nng-click="vm.isColapsed(area)" ng-hide="area.colapsed || area.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(area)" ng-hide="!area.colapsed"><md-icon md-font-icon="icon-minus-circle">\n</md-icon></a><a class="disabled" ng-show="!area.colapsed && vm.isDisabled"><md-tooltip md-direction="right">\nS\xF3 \xE9 poss\xEDvel abrir um insumo por vez</md-tooltip><md-icon md-font-icon="icon-plus-circle"></md-icon></a></td><td>\n&nbsp;&nbsp;&nbsp;&nbsp;{{ area.propriedade_area_nome }}</td><td>{{ area.unidade_medida }}</td><td>\n{{ area.total | number:3 }}</td><td>R$ {{ area.custo | finance:false:2 }}</td><td class="click-button mobile-only"><a \nng-click="vm.isColapsed(area)" ng-hide="area.colapsed || area.isLoading"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a><a ng-click="vm.closeColapsed(area)" ng-hide="!area.colapsed"><md-icon md-font-icon="icon-minus-circle">\n</md-icon></a><a class="disabled" ng-show="!area.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle">\n</md-icon></a></td></tr><tr ng-repeat-end class="details"><td class="main" colspan="6" \nng-if="area.colapsed && !area.isLoading || !vm.closeColapse"><div class="details-query" \nng-if="vm.agrupados.length >= 1"><table><thead><tr><th>Data da aplica\xE7\xE3o</th><th>Unidade</th><th>Quantidade</th><th>\nCusto</th></tr></thead><tbody><tr ng-repeat="insumos in vm.agrupados"><td class="w50">\n{{ insumos.data_aplicacao | date:\'dd/MM/yyyy\' }}</td><td class="w10">{{ insumos.unidade_medida }}</td><td class="w10">\n{{ insumos.total | number:3 }}</td><td class="w10">R$ {{ insumos.valor | finance:false:2 }}</td></tr></tbody></table>\n</div><div class="no-content" ng-if="vm.agrupados.length == 0"><i class="far fa-file-alt"></i><p>\nO insumo selecionado n\xE3o foi aplicado em nenhuma \xE1rea.</p></div></td><td colspan="6" ng-if="area.isLoading"><div \nclass="loading"><md-progress-circular id="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular>\n<p>Carregando</p></div></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/main/relatorios/insumos/views/excel-download.tmpl.html','<md-dialog class="modal-custom-wait-download"><md-dialog-content class="container"><div layout="column"><div \nclass="content"><span>Por favor, aguarde.<br>Estamos preparamos o seu arquivo excel.</span><md-progress-circular \nid="download-progress" class="md-accent" md-diameter="32"></md-progress-circular></div></div></md-dialog-content>\n</md-dialog>');
$templateCache.put('app/main/relatorios/insumos/views/lotes_produzidos.tmpl.html','<md-dialog class="modal-custom-register"><form name="clienteForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Lotes produzidos</h2><md-button class="md-icon-button close-modal" \nng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content class="lotes_produzidos"><span \nclass="title"><i class="fas fa-arrow-circle-right"></i> {{ vm.area_nome }}</span><div class="format-table-round" \nlayout="column" layout-gt-xs="row" layout-margin><table class="simple table-custom lotes_produzidos" id="responsive">\n<thead><tr><th>Lote produzido</th><th>Cultura</th><th>Data da<br>aplica\xE7\xE3o</th><th>Quantidade/<br>Unidade de medida\n</th><th>Valor</th><th>A\xE7\xE3o</th></tr></thead><tr ng-repeat="lote in vm.lotesProduzidos"><td>{{ lote.id }}</td><td>\n{{ lote.cultura }}</td><td>{{ lote.data_aplicacao | date:\'dd/MM/yyyy\'}}</td><td>\n{{ lote.quantidade }} {{ lote.unidade_medida }}</td><td>R$ {{ lote.valor | finance:false:2 }}</td><td><md-button \nclass="view-button md-icon-button" ng-click="vm.gotoVisualizar(lote.id)" aria-label="Visualizar"><i class="far fa-eye">\n<md-tooltip hide-xs md-direction="right">Visualizar</md-tooltip></i></md-button></td></tr></table></div>\n</md-dialog-content></form></md-dialog>');
$templateCache.put('app/main/vendas/lotes_cancelados/views/buscar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="CANCELADOS.CANCELADOS">Lotes cancelados</h1></div>\n</div><div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div>\n</div><div class="form-search-horizontal"><form><div class="container"><div class="row"><div class="col icon-filters">\n<img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col"><md-input-container \nclass="select-custom" flex><label>Cliente</label><select class="md-block" name="cliente" \nng-model="vm.args.cliente_consumidor_id"><option value="" selected="selected" disabled="disabled">Selecione</option>\n<option ng-repeat="cliente in vm.models.consumidores" placeholder="Selecione o cliente" ng-value="cliente.id">\n{{cliente.nome}}</option></select></md-input-container></div><div class="col"><md-input-container \nclass="select-custom" flex><label>Cultura</label><select class="md-block" name="cultura" ng-model="vm.args.cultura">\n<option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="cultura in vm.models.culturas" placeholder="Selecione a cultura" ng-value="cultura.nome">{{cultura.nome}}\n</option></select></md-input-container></div><div class="col col-datepicker"><div class="align-datepicker">\n<md-input-container class="datepicker-custom first" flex><label>Data inicial</label><md-datepicker name="data_inicial" \nng-model="vm.args.data_inicial" md-max-date="vm.args.data_final" ng-change="$mdMenu.open(); vm.clearPreDate()" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container><md-input-container \nclass="datepicker-custom" flex><label>Data final</label><md-datepicker name="data_final" ng-model="vm.args.data_final" \nng-change="$mdMenu.open(); vm.clearPreDate()" md-open-on-focus md-min-date="vm.args.data_inicial" \nng-disabled="vm.args.data_inicial == null" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container></div></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom lotes-cancelados"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID do lote"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_cancelamento" lm-title="Data de cancelamento"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_expedicao" lm-title="Data de expedi\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cliente_consumidor_nome" lm-title="Cliente"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cultura" lm-title="Cultura"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="variedade" lm-title="Variedade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" \nlm-title="Quantidade Unid. de\n                                            medida"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="consolidado" lm-title="Consolidado"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr ng-repeat="model in vm.models.lote_distribuicao_venda"><td>{{model.id}}</td><td>\n{{model.data_cancelamento | date:\'dd/MM/yyyy\'}}</td><td>{{model.data_expedicao | date:\'dd/MM/yyyy\'}}</td><td>\n{{model.cliente_consumidor_nome}}</td><td>{{model.cultura}}</td><td>{{model.variedade}}</td><td>\nR$ {{model.valor | finance:false:2}}</td><td>{{model.quantidade}} {{model.unidade_medida}}</td><td><div \nclass="icon-custom" ng-if="model.consolidado == \'Sim\'"><md-icon class="enabled" md-font-icon="icon-brightness-1">\n<md-tooltip hide-xs md-direction="top">Sim</md-tooltip></md-icon><span>Sim</span></div><div class="icon-custom" \nng-if="model.consolidado == \'N\xE3o\'"><md-icon class="disabled" md-font-icon="icon-brightness-1"><md-tooltip hide-xs \nmd-direction="top">N\xE3o</md-tooltip></md-icon><span>N\xE3o</span></div></td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label=" Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoEstornar($event,model)" aria-label=" Estornar"><i \nclass="fas fa-undo-alt"><md-tooltip hide-xs md-direction="left">Estornar</md-tooltip></i></md-button></td></tr></tbody>\n</table><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div>\n<lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/vendas/lotes_cancelados/views/estornar.html','<md-dialog class="modal-custom-register print dialog-label" aria-label="liberar"><form ng-cloak name="cancelarForm" \nnovalidate="" api-form="api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>\n{{\'CANCELADOS.ESTORNO\' | translate }}</h2><md-button class="md-icon-button close-modal" ng-click="close()">X\n</md-button></div></md-toolbar><md-dialog-content><div class="md-dialog-content"><div api-form-validation-summary \nform="cancelarForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30"><label>\nTipo</label><input type="text" name="quantidade" ng-model="estorno" disabled="disabled"></md-input-container>\n<md-input-container class="datepicker-custom" flex="21"><label>Data</label><md-datepicker name="data_validade" \nng-model="date" disabled="disabled" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.OCORRENCIA">Ocorr\xEAncia</label><textarea name="descricao" ng-model="descricao" \nplaceholder="Escrever o motivo" maxlength="500" rows="3"></textarea><div class="errors" \nng-messages="cancelarForm.descricao.$error"><div ng-message="required">Campo obrigat\xF3rio</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button class="btn btn-secondary" \nng-click="close()">{{\'LOTE.FECHAR\' | translate }}</md-button><md-button type="button" class="btn btn-primary" \naria-label="Submit" ng-click="estornarLote(model)">{{\'CANCELADOS.ESTORNAR\' | translate}}</md-button>\n</md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/vendas/lotes_cancelados/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><div class="container-header"><h1 translate="LOTES_VENDIDOS.VIEW">Visualizar lote\n</h1></div><div class="content-register"><form name="propriedadeForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><div><h3 translate="LOTE.DADOS">Dados do lote</h3><div \nclass="mobile-text-center" flex="100" flex-gt-sm="33"><div class="id-lote"><span name="lote_numero">\nID DO LOTE {{vm.model.lote_distribuicao.id}}</span></div></div></div><ms-api-message form-api="propriedadeForm.$api">\n</ms-api-message><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom">\n<label>Data da expedi\xE7\xE3o</label><label translate="LOTES_VENDIDOS.DATA_EXPEDICAO">Data expedi\xE7\xE3o</label><md-datepicker \ndisabled="disabled" name="data_expedicao" ng-model="vm.model.data_expedicao" md-placeholder="Data de expedi\xE7\xE3o" \nmd-open-on-focus></md-datepicker></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.NUMERO_LOTE">N\xFAmero do lote</label><input disabled="disabled" type="text" name="lote_numero" \nng-model="vm.model.lote_distribuicao.lote_numero"></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.DOCUMENTO_DESTINO">Documento de destino</label><input disabled="disabled" type="text" \nname="documento_destino" ng-model="vm.model.nota_fiscal"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label translate="LOTES_VENDIDOS.VALOR">Valor</label><input \ndisabled="disabled" type="text" name="valor" ui-money-mask ng-model="vm.model.valor"></md-input-container>\n<md-input-container flex><label translate="LOTES_VENDIDOS.QUANTIDADE">Quantidade</label><input disabled="disabled" \ntype="text" name="quantidade" ng-model="vm.model.quantidade"></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.UNIDADE_MEDIDA">Unidade</label><input disabled="disabled" type="text" name="unidade_medida" \nng-model="vm.model.unidade_medida"></md-input-container><md-input-container flex \nng-if="vm.model.lote_distribuicao_venda.unidade_medida == \'Embalagem\'"><label \ntranslate="LOTES_VENDIDOS.TIPO_EMBALAGEM">Tipo Embalagem</label><input disabled="disabled" type="text" \nname="embalagem_tipo" ng-model="vm.model.lote_distribuicao_venda.embalagem_tipo"></md-input-container>\n<md-input-container flex ng-if="vm.model.lote_distribuicao_venda.unidade_medida == \'Embalagem\'"><label \ntranslate="LOTES_VENDIDOS.PESO_EMBALAGEM">Peso por embalagem</label><input disabled="disabled" type="text" \nname="embalagem" ng-model="vm.model.lote_distribuicao_venda.embalagem_peso"></md-input-container></div></md-card><div \nng-repeat="lote_externo in vm.model.lote_distribuicao_venda_cancelada_ocorrencia"><md-card><h3>Ocorr\xEAncia</h3><div \nclass="md-dialog-content"><div api-form-validation-summary form="cancelarForm"></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="30"><label>Tipo</label><input type="text" name="quantidade" \nng-model="lote_externo.lote_distribuicao_venda_ocorrencia_tipo.descricao" disabled="disabled"></md-input-container>\n<md-input-container class="datepicker-custom" flex="21"><label>Data</label><md-datepicker name="data_validade" \nng-model="lote_externo.data_inclusao" disabled="disabled" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nflex><label translate="CANCELADOS.DESCRICAO">Descri\xE7\xE3o</label><textarea name="descricao" \nng-model="lote_externo.comentario" placeholder="Escrever o motivo" maxlength="500" rows="3" disabled="disabled">\n</textarea></md-input-container></div></div></md-card></div></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.comeBack()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/vendas/lotes_distribuicao/views/buscar.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="simple-table-container md-whiteframe-4dp"><div class="header-table-simple"><div layout="row" layout-wrap \nlayout-align="start center"><div class="mobile-text-center" flex="100" flex-gt-sm="33"><md-icon \nclass="icon-document icon-entities" md-font-icon="icon-document"></md-icon><span class="h1 title-entities" \ntranslate="LOTES_VENDIDOS.LOTES_VENDIDOS">Lote Venda</span></div><div flex="100" flex-gt-sm="33"><md-input-container \nclass="filter-input"><label translate="REGISTERS.SEARCH">Buscar</label><input id="txt-filtro" \nclass="mobile-text-center" ng-model="vm.args.query" ng-model-options="{ debounce: 1000 }" \nng-change="vm.args._change()"></md-input-container></div></div></div><div class="ms-responsive-table-wrapper"><div \nclass="content fullpage-simple" layout="column" flex><table row-border hover lm-sort lm-args="vm.args" \nid="responsive_search" class="simple"><thead><tr><th class="secondary-text pagination-custom" \nlm-sort-header="lote_numero" lm-title="C\xF3digo rastreamento"></th><th class="secondary-text pagination-custom" \nlm-sort-header="data_venda" lm-title="Data da Venda"></th><th class="secondary-text pagination-custom" \nlm-sort-header="cliente" lm-title="Cliente"></th><th class="secondary-text pagination-custom" \nlm-sort-header="distribuidor" lm-title="Distribuidor"></th><th class="secondary-text pagination-custom" \nlm-sort-header="consolidado" lm-title="Consolidado"></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">A\xE7\xF5es</span></div></th></tr></thead><tbody><tr \nng-repeat="model in vm.models"><td>{{model.lote_distribuicao.lote_numero}}</td><td>\n{{model.data_inclusao | date:\'dd/MM/yyyy\'}}</td><td>{{model.cliente_consumidor.nome}}</td><td>\n{{model.cliente_distribuidor.nome}}</td><td><md-icon \nng-if="model.lote_distribuicao_consolidacao_lote_distribuicao_vinculos[0].lote_distribuicao_consolidacao.lote_distribuicao_consolidacao_status.id == 1" \nmd-font-icon="icon-brightness-1" class="green-500-fg s14"><md-tooltip hide-xs md-direction="top">Sim</md-tooltip>\n</md-icon><md-icon ng-if="model.lote_distribuicao_consolidacao_lote_distribuicao_vinculos == \'\'" \nmd-font-icon="icon-brightness-1" class="red-500-fg s14"><md-tooltip hide-xs md-direction="top">N\xE3o</md-tooltip>\n</md-icon></td><td><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(model.lote_distribuicao.lote_numero)" aria-label="Visualizar"><md-icon \nmd-font-icon="icon-eye" class="s16"><md-tooltip hide-xs md-direction="right">Visualizar</md-tooltip></md-icon>\n</md-button><md-button class="edit-button md-icon-button" ng-click="vm.gotoPrint(model)" aria-label="Visualizar">\n<md-icon md-font-icon="icon-printer" class="s16"><md-tooltip hide-xs md-direction="right">Imprimir lote</md-tooltip>\n</md-icon></md-button></td></tr></tbody></table><lm-paginator lm-args="vm.args"></lm-paginator><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div></div></div></div>');
$templateCache.put('app/main/vendas/lotes_distribuicao/views/visualizar.html','<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n layout="row"><div id="teste" class="form-wrapper md-whiteframe-1dp" flex><form name="propriedadeForm" \nclass="md-inline-form" novalidate><fieldset><div class="mobile-text-center" flex="100" flex-gt-sm="33"><md-icon \nclass="icon-eye icon-entities" md-font-icon="icon-eye"></md-icon><span \nclass="h1 title-entities md-layout-propertie-bottom" translate="LOTES_VENDIDOS.VIEW">Visualizar</span></div><div \nlayout="column" layout-gt-sm="row" layout-align="start"><div class="form-title md-layout-area">Dados do Lote</div>\n</div><ms-api-message form-api="propriedadeForm.$api"></ms-api-message><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container><label translate="LOTES_VENDIDOS.DATA_EXPEDICAO">Data expedi\xE7\xE3o</label><md-datepicker\n disabled="disabled" name="data_expedicao" ng-model="vm.model.lote_distribuicao_venda.data_expedicao" \nmd-placeholder="Data de expedi\xE7\xE3o" md-open-on-focus></md-datepicker></md-input-container><md-input-container flex>\n<label translate="LOTES_VENDIDOS.NUMERO_LOTE">N\xFAmero do lote</label><input disabled="disabled" type="text" \nname="lote_numero" ng-model="vm.model.lote_numero"></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.DOCUMENTO_DESTINO">Documento de destino</label><input disabled="disabled" type="text" \nname="documento_destino" ng-model="vm.model.lote_distribuicao_venda.nota_fiscal"></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label translate="LOTES_VENDIDOS.VALOR">Valor\n</label><input disabled="disabled" type="text" name="valor" ui-money-mask \nng-model="vm.model.lote_distribuicao_venda.valor"></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.QUANTIDADE">Quantidade</label><input disabled="disabled" type="text" name="quantidade" \nng-model="vm.model.lote_distribuicao_venda.quantidade"></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.UNIDADE_MEDIDA">Unidade</label><input disabled="disabled" type="text" name="unidade_medida" \nng-model="vm.model.lote_distribuicao_venda.unidade_medida"></md-input-container><md-input-container flex \nng-if="vm.model.lote_distribuicao_venda.unidade_medida == \'Embalagem\'"><label \ntranslate="LOTES_VENDIDOS.TIPO_EMBALAGEM">Tipo Embalagem</label><input disabled="disabled" type="text" \nname="embalagem_tipo" ng-model="vm.model.lote_distribuicao_venda.embalagem_tipo"></md-input-container>\n<md-input-container flex ng-if="vm.model.lote_distribuicao_venda.unidade_medida == \'Embalagem\'"><label \ntranslate="LOTES_VENDIDOS.PESO_EMBALAGEM">Peso por embalagem</label><input disabled="disabled" type="text" \nname="embalagem" ng-model="vm.model.lote_distribuicao_venda.embalagem_peso"></md-input-container></div><div \nlayout="column" layout-gt-sm="row" layout-align="start"><div class="form-title md-layout-area">Lote de Produ\xE7\xE3o</div>\n</div><div layout="column" layout-gt-xs="row" layout-margin \nng-repeat="lote_producao in vm.model.lote_producao_lote_distribuicao_vinculos"><md-input-container><md-datepicker \ndisabled="disabled" name="data_geracao" ng-model="lote_producao.lote_producao.data_geracao" \nmd-placeholder="Data de expedi\xE7\xE3o" md-open-on-focus></md-datepicker></md-input-container><md-input-container flex>\n<label translate="LOTES_VENDIDOS.PROPRIEDADE">Propriedade</label><input disabled="disabled" type="text" \nname="propriedade" ng-model="lote_producao.lote_producao.propriedade_endereco"></md-input-container><md-input-container\n flex><label translate="LOTES_VENDIDOS.AREA">\xC1rea</label><input disabled="disabled" type="text" name="area" \nng-model="lote_producao.lote_producao.area_nome"></md-input-container><md-input-container flex><label \ntranslate="LOTES_VENDIDOS.PRODUTO">Produto</label><input disabled="disabled" type="text" name="produto" \nng-model="lote_producao.lote_producao.produto_nome"></md-input-container><md-button class="edit-button md-icon-button" \nng-click="vm.gotoLoteProducao(lote_producao.lote_producao.id)"><md-icon md-font-icon="icon-eye" class="s16"><md-tooltip\n hide-xs md-direction="right">Visualizar</md-tooltip></md-icon></md-button></div><div layout="column" \nlayout-gt-sm="row" layout-align="start" \nng-if="vm.model.lote_distribuicao_consolidacao_presentes[0].lote_distribuicao_consolidacao_lote_distribuicao_vinculos.length > 0">\n<div class="form-title md-layout-area">Lote Consolidados</div></div><div class="lote-margin" \nng-repeat="consolidacao in vm.model.lote_distribuicao_consolidacao_presentes"><div \nclass="lote-border md-whiteframe-1dp" layout="column" layout-gt-xs="row" layout-margin \nng-repeat="vinculos in consolidacao.lote_distribuicao_consolidacao_lote_distribuicao_vinculos"><md-input-container \nflex><label translate="LOTES_VENDIDOS.PROPRIEDADE">Propriedade</label><input disabled="disabled" type="text" \nname="propriedade" \nng-model="vinculos.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.propriedade_nome">\n</md-input-container><md-input-container flex><label translate="LOTES_VENDIDOS.AREA">\xC1rea</label><input \ndisabled="disabled" type="text" name="area" \nng-model="vinculos.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.area_nome">\n</md-input-container><md-input-container><md-datepicker disabled="disabled" name="data_geracao" \nng-model="vinculos.lote_distribuicao.lote_producao_lote_distribuicao_vinculos[0].lote_producao.data_geracao" \nmd-placeholder="Data de expedi\xE7\xE3o" md-open-on-focus></md-datepicker></md-input-container><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoLoteVenda(vinculos.lote_distribuicao.id)"><md-icon \nmd-font-icon="icon-eye" class="s16"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></md-icon>\n</md-button></div></div></fieldset></form></div></div></div></div>');
$templateCache.put('app/main/vendas/venda/views/confirmar.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1>Vender lotes</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span \nclass="num active">1</span> <span class="num active">2</span> <span class="num active last">3</span></div><h2>\nConfira os dados para finalizar a venda.</h2></div><div class="container-title-step"><h3><span><i \nclass="fas fa-shopping-cart"></i></span> Dados da venda</h3></div><div class="content-register"><md-card \nclass="confirmadados"><div layout="column" layout-gt-xs="row" layout-margin><div flex><label><span>Data da expedi\xE7\xE3o\n</span></label><p>{{vm.dadosVenda.data | date:\'dd/MM/yyyy\'}}</p></div><div flex><label><span>Cultura / Variedade</span>\n</label><p>\n{{vm.lotes[0].lote_producao_distribuicao_cultura.cultura_descricao}} {{vm.lotes[0].lote_producao_distribuicao_cultura.cultura_variedade}}\n</p></div><div ng-if="vm.lotes[0].unidade_medida == \'kg\'" flex><label><span>Peso total dos lotes</span></label><p>\n{{ vm.pesoTotal | number:3 }} {{vm.lotes[0].unidade_medida}}</p></div><div ng-if="vm.lotes[0].unidade_medida != \'kg\'" \nflex><label><span>Total dos lotes</span></label><p>{{ vm.pesoTotal | number:0 }} {{vm.lotes[0].unidade_medida}}</p>\n</div></div><hr><div layout="column" layout-gt-xs="row" layout-margin><p>Forma de envio</p></div><div layout="column" \nlayout-gt-xs="row" layout-margin><div flex="30"><label><span>Tipo Embalagem</span></label><p>\n{{vm.dadosVenda.tipo_embalagem}}</p></div><div ng-if="vm.lotes[0].unidade_medida == \'kg\'" flex="30"><label><span>\nPeso por embalagem ({{vm.lotes[0].unidade_medida}})</span></label><p>{{ vm.dadosVenda.peso_embalagem | number:3}}</p>\n</div><div ng-if="vm.lotes[0].unidade_medida != \'kg\'" flex="30"><label><span>Quantidade em cada embalagem</span>\n</label><p>{{ vm.dadosVenda.peso_embalagem | number:0}}</p></div><div flex><label><span>Quantidade de embalagem</span>\n</label><p>{{vm.dadosVenda.quantidade_embalagem}}</p></div></div><hr><div layout="column" layout-gt-xs="row" \nlayout-margin><div flex><label><span>Valor total da venda</span></label><p>{{ vm.dadosVenda.valor_total | currency }}\n</p></div><div flex><label><span>N\xBA do documento (opcional)</span></label><p>{{vm.dadosVenda.numero_doc}}</p></div><div\n flex="25"></div></div><div layout="column" layout-gt-xs="row" layout-margin><div flex="30"><label><span>\nNome do cliente</span></label><p>{{vm.dadosVenda.cliente.nome}}</p></div><div flex><label><span>E-mail do cliente\n</span></label><p>{{vm.dadosVenda.email_cliente}}</p></div></div><div layout="column" layout-gt-xs="row" layout-margin>\n<div flex="30"><label><span>Distribuidor (opcional)</span></label><p>{{vm.dadosVenda.distribuidor.nome}}</p></div>\n</div></md-card><br><div class="container-title-step"><h3><span><i class="fas fa-shopping-cart"></i></span>\n Lotes selecionados</h3></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" \nlayout="column" flex><table row-border hover lm-sort lm-args="vm.args" id="responsive" \nclass="simple table-custom vender-lotes confirmar-vender-lotes"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo_lote" lm-title="Tipo do Lote"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="fornecedor" lm-title="Fornecedor"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Colheita/<br>\nexpedi\xE7\xE3o</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Rastreabilidade<br>TOTAL</span></div></th><th class="secondary-text pagination-custom">\n<div class="table-header"><span class="actions column-title">Quantidade<br>TOTAL</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Quantidade<br>\nDISPON\xCDVEL</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Vender</span></div></th></tr></thead><tbody><tr ng-repeat="lote in vm.lotes"><td><h6 \nclass="d-mobile">ID</h6>{{lote.id}}</td><td><h6 class="d-mobile">Tipo do Lote</h6>\n{{lote.lote_producao_distribuicao_tipo.nome}}</td><td><h6 class="d-mobile">Fornecedor</h6>{{lote.produtor_nome}}</td>\n<td><h6 class="d-mobile">Colheita/expedi\xE7\xE3o</h6>{{lote.data | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">\nRastreabilidade total</h6><div ng-if="lote.lote_producao_distribuicao_tipo.nome != \'Externo\'" class="ico-yes"><span>\n</span> Sim</div><div ng-if="lote.lote_producao_distribuicao_tipo.nome == \'Externo\'" class="ico-no"><span></span> N\xE3o\n</div></td><td ng-if="lote.unidade_medida == \'kg\'"><h6 class="d-mobile">Quantidade TOTAL</h6>\n{{lote.quantidade | number:3}} {{lote.unidade_medida}}</td><td ng-if="lote.unidade_medida == \'kg\'"><h6 \nclass="d-mobile">Quantidade DISPON\xCDVEL</h6>{{lote.quantidade_disponivel | number:3}} {{lote.unidade_medida}}</td><td \nng-if="lote.unidade_medida == \'kg\'" class="acoes-vender"><h6 class="d-mobile">Vender</h6><label for="todolote"><input \ntype="checkbox" ng-checked="lote.quantidade_vendida == lote.quantidade_disponivel" disabled="disabled"> Todo o lote\n</label><md-input-container class="form-group" flex><input type="text" name="qtd" \nvalue="{{lote.quantidade_vendida | number:3}}" disabled="disabled"></md-input-container>{{ lote.unidade_medida }}</td>\n<td ng-if="lote.unidade_medida == \'unidades\'"><h6 class="d-mobile">Quantidade TOTAL</h6>\n{{lote.quantidade | number}} {{lote.unidade_medida}}</td><td ng-if="lote.unidade_medida == \'unidades\'"><h6 \nclass="d-mobile">Quantidade DISPON\xCDVEL</h6>{{lote.quantidade_disponivel | number}} {{lote.unidade_medida}}</td><td \nng-if="lote.unidade_medida == \'unidades\'" class="acoes-vender"><h6 class="d-mobile">Vender</h6><label for="todolote">\n<input type="checkbox" ng-checked="lote.quantidade_vendida == lote.quantidade_disponivel" disabled="disabled">\n Todo o lote</label><md-input-container class="form-group" flex><input type="text" name="qtd" \nvalue="{{lote.quantidade_vendida | number}}" disabled="disabled"></md-input-container>{{ lote.unidade_medida }}</td>\n</tr></tbody></table></div></div><div class="container-total"><div class="total"><label>TOTAL:</label>\n<md-input-container ng-if="vm.lotes[0].unidade_medida == \'kg\'" class="form-group"><input type="text" \nvalue="{{ vm.pesoTotal | number:3 }}" disabled="disabled"></md-input-container><md-input-container \nng-if="vm.lotes[0].unidade_medida != \'kg\'" class="form-group"><input type="text" value="{{ vm.pesoTotal | number:0 }}" \ndisabled="disabled"></md-input-container><span>{{ vm.undMedida }}</span></div></div><div class="content-buttons">\n<md-button id="btnVltr" class="btn btn-secondary btn-lg" ng-click="vm.cancelClick()">Voltar</md-button><md-button \nid="btnCdstrr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" ng-click="vm.save()">Concluir venda\n</md-button></div></div></div></div></div>');
$templateCache.put('app/main/vendas/venda/views/criar_cliente.tmpl.html','<md-dialog class="modal-custom-register"><form name="clienteForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo cliente</h2><md-button class="md-icon-button close-modal" \nng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div api-form-validation-summary \nform="clienteForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="25" \nclass="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus name="pessoa_tipo" \nng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica</md-radio-button>\n<md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="clienteForm.pessoa_tipo.$error" ng-show="clienteForm.pessoa_tipo.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.pessoa_tipo.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome\n</label><input type="text" name="nome" placeholder="Insira o nome" ng-model="vm.model.nome" maxlength="50" required>\n<div class="errors" ng-messages="clienteForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" placeholder="Insira a raz\xE3o social" ng-model="vm.model.nome" required><div class="errors" \nng-messages="clienteForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.nome.$api.error.message}}</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container flex="25" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF\n</label><input type="text" name="cnpj_cpf" placeholder="Insira o CPF" ng-model="vm.model.cnpj_cpf" minlength="14" \nui-br-cpf-mask required><div class="errors" ng-messages="clienteForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div \nng-message="api_erro">{{clienteForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="25" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" placeholder="Insira o CNPJ" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required><div \nclass="errors" ng-messages="clienteForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{clienteForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" placeholder="DDD" \nmaxlength="2" ng-pattern="/^[0-9]*$/" required><div class="errors" ng-messages="clienteForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{clienteForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nplaceholder="Telefone" mask="9?9999-9999" required><div class="errors" ng-messages="clienteForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.numero.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="CADASTRAIS.EMAIL">E-mail</label><input \ntype="email" name="email" ng-model="vm.model.email" maxlength="100" placeholder="Insira o E-mail" \nng-pattern="/^[\\w-]+(\\.[\\w-]+)*@([a-z0-9-]+(\\.[a-z0-9-]+)*?\\.[a-z]{2,6}|(\\d{1,3}\\.){3}\\d{1,3})(:\\d{4})?$/" \nnoncapitalize><div class="errors" ng-messages="clienteForm.email.$error"><div ng-message="api_erro">\n{{clienteForm.email.$api.error.message}}</div></div></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="md-block" flex="20"><label>CEP</label><input type="text" name="cep" \nng-model="vm.model.endereco.endereco_cep" placeholder="Insira o CEP" required ui-br-cep-mask><div class="errors" \nng-messages="clienteForm.cep.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">\nCEP inv\xE1lido</div><div ng-message="api_erro">{{clienteForm.cep.$api.error.message}}</div></div><md-progress-circular \nng-show="cepLoading" class="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container>\n<md-input-container class="md-block" flex><label>Cidade</label><input type="text" name="cidade" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="clienteForm.cidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.cidade.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="10"><label>UF</label><input type="text" name="uf" ng-model="vm.model.endereco.endereco_uf" maxlength="2" \nplaceholder="UF" ng-pattern="/^[a-zA-Z]*$/" required><div class="errors" ng-messages="clienteForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente letras</div><div ng-message="api_erro">\n{{clienteForm.uf.$api.error.message}}</div></div></md-input-container><md-input-container flex="25" class="md-block">\n<label>Bairro</label><input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" \nplaceholder="Insira o bairro" maxlength="30" required><div class="errors" ng-messages="clienteForm.bairro.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.bairro.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label>Endere\xE7o</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="clienteForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="10"><label>N\xFAmero</label><input type="text" name="numero" ng-model="vm.model.endereco.endereco_numero" \nplaceholder="N\xFAmero" maxlength="5" required><div class="errors" ng-messages="clienteForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.numero.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="md-block" flex="20"><label>Complemento</label><input type="text" \nname="complemento" ng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div \nclass="errors" ng-messages="clienteForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.complemento.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><md-checkbox \nclass="custom-modal-register" name="comprador" ng-checked="checked" ng-model="vm.model.distribuidor"><span>\nCadastrar distribuidor igual ao cliente</span></md-checkbox></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/vendas/venda/views/criar_distribuidor.tmpl.html','<md-dialog class="modal-custom-register"><form name="distribuidorForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Cadastrar novo distribuidor</h2><md-button \nclass="md-icon-button close-modal" ng-click="vm.gotoSearch()">X</md-button></div></md-toolbar><md-dialog-content><div \napi-form-validation-summary form="distribuidorForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="distribuidorForm.pessoa_tipo.$error" ng-show="distribuidorForm.pessoa_tipo.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{distribuidorForm.pessoa_tipo.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" placeholder="Insira o CPF" minlength="14" ui-br-cpf-mask required><div class="errors" \nng-messages="distribuidorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{distribuidorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex="15" \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" name="cnpj_cpf" \nng-model="vm.model.cnpj_cpf" placeholder="Insira o CNPJ" minlength="18" ui-br-cnpj-mask required><div class="errors" \nng-messages="distribuidorForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{distribuidorForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nng-model="vm.model.nome" placeholder="Insira o nome" maxlength="25" required><div class="errors" \nng-messages="distribuidorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex ng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input \ntype="text" name="nome" ng-model="vm.model.nome" placeholder="Insira a raz\xE3o social" required><div class="errors" \nng-messages="distribuidorForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="5"><label translate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" \nplaceholder="DDD" maxlength="2" ng-pattern="/^[0-9]*$/" required><div class="errors" \nng-messages="distribuidorForm.ddd.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente n\xFAmeros</div><div ng-message="api_erro">{{distribuidorForm.ddd.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="10"><label translate="CADASTRAIS.TELEFONE">TELEFONE</label><input \ntype="text" name="numero" ng-model="vm.model.telefone.numero" placeholder="Telefone" mask="9?9999-9999" required><div \nclass="errors" ng-messages="distribuidorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.numero.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex="20"><label \ntranslate="CADASTRAIS.CEP">CEP</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" required \nui-br-cep-mask placeholder="Insira o CEP"><div class="errors" ng-messages="distribuidorForm.cep.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{distribuidorForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label>Cidade</label><input type="text" name="cidade" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="distribuidorForm.cidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.cidade.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="10"><label>UF</label><input type="text" name="uf" ng-model="vm.model.endereco.endereco_uf" \nmaxlength="2" placeholder="UF" ng-pattern="/^[a-zA-Z]*$/" required><div class="errors" \nng-messages="distribuidorForm.uf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">\nSomente letras</div><div ng-message="api_erro">{{distribuidorForm.uf.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25" class="md-block"><label>Bairro</label><input type="text" \nname="bairro" ng-model="vm.model.endereco.endereco_bairro" placeholder="Insira o bairro" maxlength="30" required><div \nclass="errors" ng-messages="distribuidorForm.bairro.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.bairro.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" flex><label>Endere\xE7o</label>\n<input type="text" name="endereco" ng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" \nmaxlength="50" required><div class="errors" ng-messages="distribuidorForm.endereco.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{distribuidorForm.endereco.$api.error.message}}</div></div>\n</md-input-container><md-input-container class="md-block" flex="10"><label>N\xFAmero</label><input type="text" \nname="numero" ng-model="vm.model.endereco.endereco_numero" placeholder="N\xFAmero" maxlength="5" required><div \nclass="errors" ng-messages="distribuidorForm.numero.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.numero.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="md-block" flex="20"><label>Complemento</label><input type="text" name="complemento" \nng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div class="errors" \nng-messages="distribuidorForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{distribuidorForm.complemento.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value"><md-checkbox \nclass="custom-modal-register" name="comprador" ng-checked="checked" ng-model="vm.model.distribuidor"><span>\nCadastrar cliente igual ao distribuidor</span></md-checkbox></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">Cancelar</md-button>\n<md-button class="btn btn-primary" ng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/vendas/venda/views/modal-passo-a-passo.html','<div class="container-modal-vender"><div class="row"><div class="col-6"><img \nsrc="/assets/images/img-passo-vender-lotes.png" alt=""></div><div class="col-6">\nAgora na Eattae voc\xEA consegue visualizar a quantidade dispon\xEDvel dos seus lotes para montar a sua venda! Siga o nosso passo a passo e veja como \xE9 f\xE1cil: Passo 1: \u2022 Inclua a cultura e variedade que voc\xEA deseja vender, clique em \u201CFiltrar\u201D e veja todos os lotes dispon\xEDveis. \u2022 Visualize a quantidade dispon\xEDvel de cada lote e fa\xE7a o rateamento. Passo 2: \u2022 Preencha os dados da sua venda. Passo 3: \u2022 Confira os dados para finalizar. Ao finalizar a venda voc\xEA j\xE1 ter\xE1 o seu n\xBA do rastreamento!\n</div></div><form name="areaForm" class="md-inline-form" novalidate api-form="vm.api_response_erro"><div \nclass="content-buttons"><md-button md-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" ng-click="vm.checkModal($event, _dataToPass)">Come\xE7ar</md-button></div><fieldset>\n<md-input-container flex><input id="inptNm" type="text" name="area" placeholder="Insira o nome da \xE1rea" \nng-model="vm.model.nome" maxlength="15" required><div class="errors" ng-messages="areaForm.area.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{areaForm.area.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="md-input-has-value"><md-checkbox name="check" \nng-checked="checked" ng-model="vm.model.check"><span>texto check...</span></md-checkbox></md-input-container>\n</fieldset></form></div>');
$templateCache.put('app/main/vendas/venda/views/modal-tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/IjUniyb0Jyo?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div>');
$templateCache.put('app/main/vendas/venda/views/preencher.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1>Vender lotes</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span \nclass="num active">1</span> <span class="num active">2</span> <span class="num last">3</span></div><h2>\nPreencha os dados da sua venda.</h2></div><div class="container-title-step"><h3><span><i class="fas fa-shopping-cart">\n</i></span> Dados da venda</h3></div><div class="content-register"><form name="vendaForm" \nclass="md-inline-form inputdados" novalidate api-form="vm.api_response_erro"><fieldset><div \napi-form-validation-summary form="vendaForm"></div><md-card><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex class="datepicker-custom"><label>Data da expedi\xE7\xE3o</label><md-datepicker name="expedicao" \nng-model="vm.selecionarForm.data" md-placeholder="Inserir data" md-min-date="vm.minDate" md-max-date="vm.maxDate" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="vendaForm.expedicao.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{vendaForm.expedicao.$api.error.message}}\n</div></div></md-input-container><md-input-container flex class="select-custom"><label>Cultura</label><input \ntype="text" name="cultura" value="{{vm.lotes[0].lote_producao_distribuicao_cultura.cultura_descricao}}" \ndisabled="disabled" value="cultura" required></md-input-container><md-input-container flex class="select-custom">\n<label>Variedade</label><input type="text" name="variedade" \nvalue="{{vm.lotes[0].lote_producao_distribuicao_cultura.cultura_variedade}}" disabled="disabled" value="variedade" \nrequired></md-input-container><md-input-container ng-if="vm.lotes[0].unidade_medida == \'kg\'" flex \nclass="select-custom"><label>Peso total dos lotes</label><input type="text" name="peso" \nvalue="{{vm.pesoTotal | number:3}}" disabled="disabled" value="peso total" required></md-input-container>\n<md-input-container ng-if="vm.lotes[0].unidade_medida != \'kg\'" flex class="select-custom"><label>Total dos lotes\n</label><input type="text" name="peso" value="{{vm.pesoTotal | number:0}}" disabled="disabled" value="peso total" \nrequired></md-input-container><md-input-container flex class="select-custom"><label>Unidade</label><input type="text" \nname="unidade" value="{{vm.lotes[0].unidade_medida}}" disabled="disabled" value="kg" required></md-input-container>\n</div><hr><div layout="column" layout-gt-xs="row" layout-margin><h3>Forma de envio</h3></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="30"><label>Tipo Embalagem</label>\n<md-select class="md-block" placeholder="Selecione o tipo de embalagem" ng-model="vm.selecionarForm.tipo_embalagem">\n<md-option ng-repeat="tipo in vm.tipos" value="{{tipo}}">{{tipo}}</md-option></md-select><div class="errors" \nng-messages="vendaForm.embalagem.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{vendaForm.embalagem.$api.error.message}}</div></div></md-input-container><md-input-container \nng-if="vm.lotes[0].unidade_medida == \'kg\'" flex="30" class="select-custom"><label>Peso por embalagem <span>\n({{vm.lotes[0].unidade_medida}})</span></label><input type="text" name="embalagem" \nng-model="vm.selecionarForm.peso_embalagem" placeholder="Digite" ui-number-mask="3" min="0.001" max="{{vm.pesoTotal}}" \nng-keyup="vm.checkQTD()" required> <span class="qtderror" ng-if="vm.qtdstatus">{{vm.qtdstatus}}</span><div \nclass="errors" ng-messages="vendaForm.embalagem.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pi_erro">{{vendaForm.embalagem.$api.error.message}}</div></div></md-input-container><md-input-container \nng-if="vm.lotes[0].unidade_medida != \'kg\'" flex="30" class="select-custom"><label>Quantidade em cada embalagem</label>\n<input type="text" name="embalagem" ng-model="vm.selecionarForm.peso_embalagem" placeholder="Digite" \nui-number-mask="0" max="{{vm.pesoTotal}}" ng-keyup="vm.checkQTD()" required> <span class="qtderror" \nng-if="vm.qtdstatus">{{vm.qtdstatus}}</span><div class="errors" ng-messages="vendaForm.embalagem.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pi_erro">{{vendaForm.embalagem.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex class="select-custom"><label>Quantidade de embalagem<span></span>\n</label><input type="number" name="qtdEmbalagem" ng-model="vm.selecionarForm.quantidade_embalagem" maxlength="30" \nrequired disabled="disabled"><div class="errors" ng-messages="vendaForm.qtd_embalagem.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{vendaForm.qtd_embalagem.$api.error.message}}\n</div></div></md-input-container></div><hr><br><br><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex class="select-custom"><label>Valor total da venda</label><input id="inptVlr" type="text" \nname="preco" ng-model="vm.selecionarForm.valor_total" ui-money-mask placeholder="Digite" required><div class="errors" \nng-messages="vendaForm.valor.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="pi_erro">\n{{vendaForm.valor.$api.error.message}}</div></div></md-input-container><md-input-container flex class="select-custom">\n<label>N\xBA do documento<span>(opcional)</span></label><input id="inptDcmnt" type="text" name="nota" \nng-model="vm.selecionarForm.numero_doc" maxlength="30" placeholder="Digite"><div class="errors" \nng-messages="vendaForm.nota.$error"><div ng-message="api_erro">{{vendaForm.nota.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="25"></md-input-container></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="select-custom" flex="30"><label>Nome do cliente</label><md-select \nid="slctClnt" class="md-block" name="cliente" ng-model="vm.selecionarForm.cliente" placeholder="Selecione um cliente" \nng-change="vm.selectedClienteEmail()" required><md-option ng-repeat="cliente_consumidor in vm.cliente_consumidores" \nng-value="cliente_consumidor"><span ng-if="cliente_consumidor.cnpj_cpf.length == 11">\n{{cliente_consumidor.cnpj_cpf | brCpf}}</span> <span ng-if="cliente_consumidor.cnpj_cpf.length == 14">\n{{cliente_consumidor.cnpj_cpf | brCnpj}}</span> <span>- {{cliente_consumidor.nome}}</span></md-option><md-option \nng-if="vm.cliente_consumidores.length == 0" disabled="disabled">Nenhum cliente cadastrado</md-option></md-select><div \nclass="errors" ng-messages="vendaForm.cliente.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{vendaForm.cliente.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="25" class="select-custom"><a id="btnAdcnrClnt" class="btn btn-quaternary" \nng-click="vm.showDialogCreateCliente($event,lista_detalhes)"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nAdicionar cliente</a></md-input-container><md-input-container flex class="select-custom"><label>E-mail do cliente\n</label><input type="text" name="email_cliente" ng-model="vm.selecionarForm.email_cliente" placeholder="Digite"><div \nclass="errors" ng-messages="vendaForm.email.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{vendaForm.email.$api.error.message}}</div></div></md-input-container></div><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container class="select-custom" flex="30"><label>\nDistribuidor<span>(opcional)</span></label><md-select id="slctDstrbdr" class="md-block" name="distribuidor" \nng-model="vm.selecionarForm.distribuidor" placeholder="Selecione um distribuidor"><md-option \nng-repeat="cliente_distribuidor in vm.cliente_distribuidores" ng-value="cliente_distribuidor"><span \nng-if="cliente_distribuidor.cnpj_cpf.length == 11">{{cliente_distribuidor.cnpj_cpf | brCpf}}</span> <span \nng-if="cliente_distribuidor.cnpj_cpf.length == 14">{{cliente_distribuidor.cnpj_cpf | brCnpj}}</span> <span>\n- {{cliente_distribuidor.nome}}</span></md-option><md-option ng-if="vm.cliente_distribuidores.length==0" \ndisabled="disabled">Nenhum cliente cadastrado</md-option></md-select><div class="errors" \nng-messages="vendaForm.cliente.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{vendaForm.distribuidor.$api.error.message}}</div></div></md-input-container><md-input-container flex="25"><a \nid="btnAdcnrDstrbdr" class="btn btn-quaternary" ng-click="vm.showDialogCreateDistribuidor($event,lista_detalhes)">\n<md-icon md-font-icon="icon-plus-circle"></md-icon>Adicionar distribuidor</a></md-input-container></div></md-card>\n</fieldset><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \nng-click="vm.cancelClick(vendaForm,$event)">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="!vm.checkQTD() || vendaForm.$invalid || vendaForm.$pristine || loadingProgress" \nng-click="vm.gotoConfirmar(vm.selecionarForm)">Pr\xF3ximo passo</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/vendas/venda/views/selecionar.html','<div class="container-header container-header-novo"><div class="box-tutorial"><div class="breadcrumb"><h1>Vender lotes\n</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div></div><div\n class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span \nclass="num active">1</span> <span class="num">2</span> <span class="num last">3</span></div><h2>\nUtilize os filtros e adicione os lotes dispon\xEDveis.</h2></div><div class="container-title-step"><h3><span><i \nclass="fas fa-archive"></i></span> Selecionar lotes</h3></div><div \nclass="form-search-horizontal form-search-horizontal-venda"><form><div class="container"><div class="row"><div \nclass="icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col">\n<md-input-container class="form-group select-custom" flex><label>Cultura*</label><select id="cultura" \nng-model="vm.args.cultura" ng-options="cultura.nome as cultura.nome for cultura in vm.filtros.culturas" \nng-value="cultura.nome"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Variedade*\n</label><select id="variedade" ng-model="vm.variedade" ng-disabled="!vm.args.cultura" \nng-options="variedade.nome for variedade in ((vm.filtros.culturas | filter:{\'nome\':vm.args.cultura})[0].lote_distribuicao_variedades)" \nng-value="variedade.nome"><option value="" selected="selected" disabled="disabled">Selecione</option></select>\n</md-input-container></div><div class="col periodo"><div class="row-periodo"><div class="select-content">\n<md-input-container class="form-group select-custom" flex><label class="form-label">Per\xEDodo</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option \nvalue="" disabled="disabled">Selecione</option><option ng-value="period.value" ng-repeat="period in vm.periods">\n{{period.description}}</option></select></md-input-container></div><div class="date-picker" id="dataspicker"><a \nng-click="vm.openDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.date_inicio" md-max-date="vm.args.date_fim" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.date_fim" ng-disabled="vm.args.date_inicio == null" \nmd-min-date="vm.args.date_inicio" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.selecionarDatas();" ng-disabled="vm.args.date_fim == null">Selecionar</button>\n</div></div></div></div></div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>\nFornecedor</label><select name="fornecedor" ng-model="vm.args.fornecedor"><option value="" selected="selected">\nSelecione</option><option ng-value="fornecedor.nome" ng-repeat="fornecedor in vm.filtros.fornecedores">\n{{fornecedor.nome}}</option></select></md-input-container></div><div class="col"><div class="content-buttons">\n<md-button type="submit" class="btn btn-tertiary btn-md-i" ng-click="vm.args._change()">Aplicar</md-button><a \nclass="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div \nclass="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}\n</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><form\n ng-submit="addText(SelecionarForm)"><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" \nlayout="column" flex><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom vender-lotes"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="tipo_lote" lm-title="Tipo"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="fornecedor" lm-title="Fornecedor"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data" lm-title="Colheita/exp."></th><th \nclass="secondary-text pagination-custom" lm-sort-header="rastreabilidade" lm-title="Rastreabilidade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quant. total"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade_disponivel" lm-title="Quant. dispon\xEDvel"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Vender</span>\n</div></th></tr></thead><tbody><tr ng-if="vm.args.total_rows" \nng-repeat="(key, model) in vm.models.lote_producao_distribuicao"><td><h6 class="d-mobile">ID</h6>{{model.id}}</td><td>\n<h6 class="d-mobile">Tipo do Lote</h6>{{model.lote_producao_distribuicao_tipo.nome}}</td><td><h6 class="d-mobile">\nFornecedor</h6>{{ model.produtor_nome | limitTo: 30 }}</td><td><h6 class="d-mobile">Colheita/expedi\xE7\xE3o</h6>\n{{model.data | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">Rastreabilidade total</h6><div \nng-if="model.lote_distribuicao_rastreabilidade_total.id == 1" class="ico-yes"><span></span> Sim</div><div \nng-if="model.lote_distribuicao_rastreabilidade_total.id != 1" class="ico-no"><span></span> N\xE3o</div></td><td \nng-if="model.unidade_medida == \'kg\'"><h6 class="d-mobile">Quant. TOTAL</h6>\n{{model.quantidade | number:3}} {{model.unidade_medida}}</td><td ng-if="model.unidade_medida == \'kg\'"><h6 \nclass="d-mobile">Quant. DISPON\xCDVEL</h6>{{model.quantidade_disponivel | number:3}} {{model.unidade_medida}}</td><td \nng-if="model.unidade_medida != \'kg\'"><h6 class="d-mobile">Quant. TOTAL</h6>\n{{model.quantidade | number}} {{model.unidade_medida}}</td><td ng-if="model.unidade_medida != \'kg\'"><h6 \nclass="d-mobile">Quant. DISPON\xCDVEL</h6>{{model.quantidade_disponivel | number}} {{model.unidade_medida}}</td><td \nclass="acoes-vender"><h6 class="d-mobile">Vender</h6><label><input type="checkbox" class="checkqtd_{{key}}" \nng-model="model.selected" ng-click="vm.checkFunction(model)" \nng-disabled="vm.uniddMedida && vm.uniddMedida != model.unidade_medida" \nng-checked="model.qtdinput == model.quantidade_disponivel"> Todo o lote</label><md-input-container \nng-if="model.unidade_medida == \'kg\'" class="form-group" flex><input id="inptqtd{{key}}" type="text" name="qtd" \nui-number-mask="3" ng-model="model.qtdinput" ng-keyup="vm.updateValor()" \nng-disabled="vm.uniddMedida && vm.uniddMedida != model.unidade_medida"></md-input-container><md-input-container \nng-if="model.unidade_medida != \'kg\'" class="form-group" flex><input id="inptqtd{{key}}" type="text" name="qtd" \nui-number-mask="0" ng-model="model.qtdinput" ng-keyup="vm.updateValor()" \nng-disabled="vm.uniddMedida && vm.uniddMedida != model.unidade_medida"></md-input-container>{{model.unidade_medida}} \n<span class="qtderror">{{model.errors}}</span></td></tr></tbody></table></div></div><div class="paginator" \nng-if="!vm.args.total_rows || vm.args.total_rows == undefined"><i class="far fa-file-alt"></i><p>\nUtilize os filtros acima para visualizar os lotes dispon\xEDveis.</p></div><div class="paginator" \nng-if="vm.args.total_rows <= 0 && vm.args.total_rows"><i class="far fa-file-alt"></i><p>Nenhum registro encontrado.</p>\n</div><div class="container-total"><div class="total"><label>TOTAL:</label><md-input-container class="form-group">\n<input ng-if="vm.uniddMedida == \'kg\'" type="text" ui-number-mask="3" ng-model="vm.totalInputs" disabled="disabled"> \n<input ng-if="vm.uniddMedida == \'unidades\' || vm.uniddMedida == \'Unidades\'" type="text" ui-number-mask="0" \nng-model="vm.totalInputs" disabled="disabled"></md-input-container><span>{{vm.uniddMedida}}</span><md-input-container \nng-if="!vm.uniddMedida" class="form-group"><input type="text" disabled="disabled" value="..."></md-input-container>\n</div></div><span class="qtderror" id="inperrorTotal"></span><div class="container-button"><md-button \nng-disabled="!vm.myCheck" type="button" class="btn btn-primary btn-md-i" \nng-click="vm.gotoVenda(vm.models.lote_producao_distribuicao)">Pr\xF3ximo passo</md-button></div></form></div></div></div>\n<div style="visibility: hidden"><div class="md-dialog-container" id="myStaticDialog"><md-dialog><div \nclass="container-modal-vender"><div class="header"><div class="col-close"><p>Ol\xE1, {{vm.user.nome}}.</p><a href="#" \nclass="close" ng-click="vm.close()">X</a></div><h2>\nAgora na Eattae voc\xEA consegue visualizar a quantidade dispon\xEDvel dos seus lotes para montar a sua venda!</h2></div><div\n class="row"><div class="col-1"><img src="/assets/images/img-passo-vender-lotes.png" alt=""></div><div class="col-2">\n<strong>Siga o nosso passo a passo e veja como \xE9 f\xE1cil:</strong><br><br><strong>Passo 1:</strong>\n \u2022 Inclua a cultura e variedade que voc\xEA deseja vender, clique em \u201CFiltrar\u201D e veja todos os lotes dispon\xEDveis. \u2022 Visualize a quantidade dispon\xEDvel de cada lote e fa\xE7a o rateamento.\n<br><br><strong>Passo 2:</strong> \u2022 Preencha os dados da sua venda.<br><br><strong>Passo 3:</strong>\n \u2022 Confira os dados para finalizar.<br><br><strong>Ao finalizar a venda voc\xEA j\xE1 ter\xE1 o seu n\xBA do rastreamento!</strong>\n</div></div><div class="footer"><form name="areaForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><md-button md-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" ng-click="vm.checkModal()">Come\xE7ar</md-button><br><md-input-container class="md-input-has-value">\n<md-checkbox name="check" ng-checked="checked" ng-model="vm.model.check"><span>N\xE3o mostrar mais esta mensagem</span>\n</md-checkbox></md-input-container></form></div></div></md-dialog></div></div>');
$templateCache.put('app/main/vendas/venda/views/sucesso.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1>Vender lotes</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-sucesso"><img src="/assets/images/svg/ico-sucesso.svg" \nalt="sucesso"><h2>Venda e rastreamento realizados com sucesso!</h2><p>N\xBA do rastreamento: <strong>\n{{vm.model.lote_distribuicao.lote_numero}}</strong></p><span>-------------------------------------------------------\n</span><p>O que voc\xEA gostaria de fazer agora?</p><div class="content-buttons-sucesso"><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-click="vm.showConfirm(vm.model.id)">Gerar laudo</md-button><md-button \ntype="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoPrint(model)">Gerar etiqueta</md-button><md-button \ntype="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoVender()">Vender novo lote</md-button><md-button \nclass="btn btn-secondary btn-md" ng-click="vm.gotoHome()">Voltar para home</md-button></div><span>\n-------------------------------------------------------</span><p>\nPrecisa de ajuda? Ent\xE3o assista nossos tutoriais e tire as suas d\xFAvidas:</p><div class="content-passo"><ul><li><a \nhref="#" ng-click="vm.viewGerarLaudo()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/440x248-thumb-youtube-laudo-de-qualidade.jpg);">\n<span class="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div></a></li><li>\n<a href="#" ng-click="vm.viewImprimirTrocarCliente()"><div class="thumb" \nstyle="background-image: url(../../../../assets/images/thumbs-videos/440x248-thumb-youtube-imprimir-etiqueta.jpg);">\n<span class="play"><img src="../../../../assets/icons/ico-play-tutorial-youtube.svg" alt=""></span></div></a></li></ul>\n</div></div></div></div></div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/buscar.html','<div class="container-header container-header-novo"><div class="breadcrumb"><h1 translate="LOTE.VENDIDOS">\nLotes vendidos</h1></div></div><div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-search"><div class="identification"><h2 \ntranslate="REGISTERS.LIST">Lista</h2></div><div class="toggle-filtro"><div class="icon-filters" \nng-click="vm.openFilter()"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div></div>\n</div><div class="form-search-horizontal form-search-horizontal-novo"><form><div class="container"><div class="row">\n<div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span><div \nclass="close d-mobile" ng-click="vm.closeFilter()"><i class="fas fa-times"></i></div></div><div class="col periodo">\n<div class="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo expedi\xE7\xE3o</label><select class="form-select select-periodo" name="periodo" \nng-model="vm.addQuery.periodo" ng-change="vm.selectedPeriodo()"><option value="" selected="selected">Selecione</option>\n<option ng-value="period.value" ng-repeat="period in vm.periods">{{period.description}}</option></select>\n</md-input-container></div><div class="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicial" ng-model="vm.addQuery.data_inicial" \nmd-max-date="vm.addQuery.data_final" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker \nname="data_final" ng-model="vm.addQuery.data_final" ng-disabled="vm.addQuery.data_inicial == null" \nmd-min-date="vm.addQuery.data_inicial" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container></div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">\nCancelar</button> <button class="btn btn-submit" ng-click="vm.selecionarDatas();" \nng-disabled="vm.addQuery.data_final == null">Selecionar</button></div></div></div></div></div></div><div class="col">\n<md-input-container class="form-group select-custom" flex><label>Busca por palavra</label><input id="txt-filtro" \nclass="mobile-text-center input-search" placeholder="Digite" ng-model="vm.addQuery.query"></md-input-container></div>\n<div class="col"><md-input-container class="select-custom" flex><label>Cliente</label><select class="md-block" \nname="cliente" ng-model="vm.addQuery.cliente_consumidor_id" ng-init="vm.addQuery.cliente_consumidor_id = options[0]">\n<option value="" selected="selected">Selecione</option><option ng-repeat="cliente in vm.models.cliente_consumidor" \nplaceholder="Selecione o cliente" ng-value="cliente.id">{{cliente.nome}}</option></select></md-input-container></div>\n<div class="col"><md-input-container class="select-custom" flex><label>Cultura</label><select class="md-block" \nname="cultura" ng-model="vm.addQuery.cultura" ng-init="vm.addQuery.cultura = options[0]"><option value="" \nselected="selected">Selecione</option><option ng-repeat="cultura in vm.models.cultura" \nplaceholder="Selecione a cultura" ng-value="cultura.nome">{{cultura.nome}}</option></select></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button type="submit" class="btn btn-tertiary btn-md-i" \nng-model="vm.btnFiltrar" ng-click="vm.resetPagination(); vm.btnFiltrar(); vm.closeFilter()">Filtrar</md-button><a \nclass="btn btn-quaternary" ng-click="vm.resetFilters(); vm.closeFilter()">Limpar</a></div></div></div></div></form>\n</div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>\n{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" \nng-if="filter.description">{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" \ntitle="Remover">X</a></li></ul></div><div class="ms-responsive-table-wrapper"><div class="content fullpage-simple" \nlayout="column" flex><md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table \nrow-border hover lm-sort lm-args="vm.args" id="responsive" class="simple table-custom lotes-vendidos"><thead \nclass="first-level"><tr><th></th><th class="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID"></th>\n<th class="secondary-text pagination-custom" lm-sort-header="data_expedicao" lm-title="Expedi\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cliente_consumidor_nome" lm-title="Cliente"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cultura" lm-title="Cultura"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="variedade" lm-title="Variedade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="embalagem" lm-title="Embalagem"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="total_lote" lm-title="Total lote"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">A\xE7\xF5es</span>\n</div></th></tr></thead><tbody><tr class="default" ng-repeat-start="model in vm.models.lote_distribuicao_venda"><td \nclass="click-button"><a ng-click="vm.isColapsed(model)" ng-hide="model.colapsed || model.isLoading"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a><a ng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon \nmd-font-icon="icon-minus-circle"></md-icon></a><a class="disabled" ng-show="!model.colapsed && vm.isDisabled">\n<md-tooltip md-direction="right">S\xF3 \xE9 poss\xEDvel abrir um lote por vez</md-tooltip><md-icon \nmd-font-icon="icon-plus-circle"></md-icon></a></td><td>{{model.id}}</td><td>\n{{model.data_expedicao | date:\'dd/MM/yyyy\'}}</td><td>{{model.cliente_consumidor_nome}}</td><td>{{model.cultura}}</td>\n<td>{{model.variedade}}</td><td ng-if="model.unidade_medida == \'kg\'">\n{{model.embalagem_peso | number:3}} {{model.unidade_medida}}</td><td ng-if="model.unidade_medida == \'kg\'">\n{{model.quantidade | number:3}} {{model.unidade_medida}}</td><td ng-if="model.unidade_medida == \'unidades\'">\n{{model.embalagem_peso | number:0}} {{model.unidade_medida}}</td><td ng-if="model.unidade_medida == \'unidades\'">\n{{model.quantidade | number:0}} {{model.unidade_medida}}</td><td><md-button class="edit-button md-icon-button" \nng-click="vm.showDialogCliente($event,model)" aria-label="Trocar cliente"><i class="fas fa-sync-alt"><md-tooltip \nhide-xs md-direction="left">Trocar cliente</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i class="far fa-eye"><md-tooltip hide-xs \nmd-direction="left">Visualizar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-click="vm.gotoPrint(model)" aria-label="Imprimir"><i class="fas fa-print"><md-tooltip hide-xs md-direction="right">\nImprimir</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" ng-click="vm.gotoCancelar(model)" \naria-label="Imprimir"><i class="fas fa-ban"><md-tooltip hide-xs md-direction="right">Cancelar lote</md-tooltip></i>\n</md-button></td><td class="click-button mobile-only"><a ng-click="vm.isColapsed(model)" \nng-hide="model.colapsed || model.isLoading"><md-icon md-font-icon="icon-plus-circle"></md-icon></a><a \nng-click="vm.closeColapsed(model)" ng-hide="!model.colapsed"><md-icon md-font-icon="icon-minus-circle"></md-icon></a><a\n class="disabled" ng-show="!model.colapsed && vm.isDisabled"><md-icon md-font-icon="icon-plus-circle"></md-icon></a>\n</td></tr><tr ng-repeat-end class="details"><td class="main" colspan="9" \nng-if="model.colapsed && !model.isLoading || !vm.closeColapse"><div class="details-query"><h2>Detalhes do produto:</h2>\n<table><thead><tr><th>C\xF3digo de rastreamento</th><th>Valor</th><th>Tipo de embalagem</th><th>Status</th><th>Consolidado\n</th><th>Laudo</th></tr></thead><tbody><tr><td>{{ model.codigo_rastreamento }}</td><td>\nR$ {{ model.valor | finance:false:2}}</td><td>{{ model.embalagem_tipo }}</td><td><div class="icon-custom" \nng-if="model.status == \'Vendido\'"><md-icon class="enabled" md-font-icon="icon-brightness-1"></md-icon><span>\n{{ model.status }}</span></div><div class="icon-custom" ng-if="model.status != \'Vendido\'"><md-icon class="disabled" \nmd-font-icon="icon-brightness-1"></md-icon><span>{{ model.status }}</span></div></td><td><div class="icon-custom" \nng-if="model.consolidado == \'Sim\'"><md-icon class="enabled" md-font-icon="icon-brightness-1"><md-tooltip hide-xs \nmd-direction="top">{{ model.consolidado }}</md-tooltip></md-icon><span>{{ model.consolidado }}</span></div><div \nclass="icon-custom" ng-if="model.consolidado == \'N\xE3o\'"><md-icon class="disabled" md-font-icon="icon-brightness-1">\n<md-tooltip hide-xs md-direction="top">{{ model.consolidado }}</md-tooltip></md-icon><span>{{ model.consolidado }}\n</span></div></td><td><a href="#" class="btn-quaternary mr-1rem" ng-click="vm.showConfirm(model.id)">Gerar laudo </a>| \n<a href="#" class="btn-quaternary separator" ng-click="vm.gotoGerenciar(model.id)">Gerenciar laudos</a></td></tr>\n</tbody></table></div></td><td colspan="8" ng-if="model.isLoading"><div class="loading"><md-progress-circular \nid="toolbar-progress" class="md-accent" md-diameter="32"></md-progress-circular><p>Carregando</p></div></td></tr>\n</tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/cancelar.html','<md-dialog class="modal-custom-register print dialog-label" aria-label="liberar"><form ng-cloak name="cancelarForm" \nnovalidate="" api-form="api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>\n{{\'LOTE.CANCELAMENTO\' | translate }}</h2><md-button class="md-icon-button close-modal" ng-click="close()">X</md-button>\n</div></md-toolbar><md-dialog-content><div class="md-dialog-content"><div api-form-validation-summary \nform="cancelarForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30"><label>\nTipo</label><input type="text" name="quantidade" ng-model="cancelamento" disabled="disabled"></md-input-container>\n<md-input-container class="datepicker-custom" flex="21"><label>Data</label><md-datepicker name="data_validade" \nng-model="date" disabled="disabled" md-placeholder="Inserir data" md-open-on-focus></md-datepicker>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="LOTE_PRODUCAO.OCORRENCIA">Ocorr\xEAncia</label><textarea name="descricao" ng-model="descricao" \nplaceholder="Escrever o motivo" maxlength="500" rows="3"></textarea><div class="errors" \nng-messages="cancelarForm.descricao.$error"><div ng-message="required">Campo obrigat\xF3rio</div></div>\n</md-input-container></div></div></md-dialog-content><md-dialog-actions><md-button class="btn btn-secondary" \nng-click="close()">{{\'LOTE.FECHAR\' | translate }}</md-button><md-button ng-disabled="!btncancelarlote" type="button" \nclass="btn btn-primary" aria-label="Submit" ng-click="cancelarLote(model)">{{\'LOTE.CANCELAR_LOTE\' | translate}}\n</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/editar_cliente.tmpl.html','<md-dialog class="modal-custom-register"><form name="clienteForm" novalidate="" api-form="vm.api_response_erro">\n<md-toolbar><div class="md-toolbar-tools"><h2>Trocar cliente</h2><md-button class="md-icon-button close-modal" \nng-click="vm.dismissModal()">X</md-button></div></md-toolbar><md-dialog-content class="change-client"><div \napi-form-validation-summary form="clienteForm"></div><div class="select-option"><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container class="md-input-has-value md-input-custom"><div class="label">\nSelecione abaixo a op\xE7\xE3o desejada:</div><md-radio-group md-autofocus name="pessoa_tipo" ng-model="vm.model.select" \nlayout=" row" required><md-radio-button value="1">Cliente j\xE1 cadastrado</md-radio-button><md-radio-button value="2">\nAdicionar novo cliente</md-radio-button></md-radio-group></md-input-container></div></div><div class="select-client" \nng-if="vm.model.select == 1"><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex><label translate="VENDA.CLIENTE">Cliente</label><md-select class="md-block" name="cliente" \nng-model="vm.model.lote_distribuicao_venda_itens.cliente" placeholder="Selecione" required><md-option \nng-repeat="clientes in vm.clientes" ng-value="clientes"><span ng-if="clientes.cnpj_cpf.length == 11">\n{{clientes.cnpj_cpf | brCpf}}</span> <span ng-if="clientes.cnpj_cpf.length == 14">{{clientes.cnpj_cpf | brCnpj}}</span>\n <span>- {{clientes.nome}}</span></md-option><md-option ng-if="vm.clientes.length == 0" disabled="disabled">\nNenhum cliente cadastrado</md-option></md-select><div class="errors" ng-messages="clienteForm.cliente.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.cliente.$api.error.message}}\n</div></div></md-input-container></div><hr><div layout="column" layout-margin><md-input-container class="md-block" \nflex><div class="label">Motivo da troca de cliente</div><label>&nbsp;</label><input type="textarea" name="comentario" \nng-model="vm.model.comentario" placeholder="Descreva o motivo" maxlength="100"></md-input-container><span class="obs">\nOBS: Para visualizar esta troca de cliente, clique no \xEDcone visualizar e acesse a aba \u201COcorr\xEAncias\u201D</span></div></div>\n<div class="add-client" ng-if="vm.model.select == 2"><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="md-input-has-value"><label translate="NOVO.TYPE"></label><md-radio-group md-autofocus \nname="pessoa_tipo" ng-model="vm.model.pessoa_tipo.id" layout=" row" required><md-radio-button value="1">F\xEDsica\n</md-radio-button><md-radio-button value="2">Jur\xEDdica</md-radio-button></md-radio-group><div \nng-messages="clienteForm.pessoa_tipo.$error" ng-show="clienteForm.pessoa_tipo.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.pessoa_tipo.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex="15" ng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.CPF">CPF\n</label><input type="text" name="cnpj_cpf" placeholder="Insira o CPF" ng-model="vm.model.cnpj_cpf" minlength="14" \nui-br-cpf-mask required><div class="errors" ng-messages="clienteForm.cnpj_cpf.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div \nng-message="api_erro">{{clienteForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="15" ng-if="vm.model.pessoa_tipo.id == 2"><label translate="NOVO.CNPJ">CNPJ</label><input type="text" \nname="cnpj_cpf" placeholder="Insira o CNPJ" ng-model="vm.model.cnpj_cpf" minlength="18" ui-br-cnpj-mask required><div \nclass="errors" ng-messages="clienteForm.cnpj_cpf.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="minlength">N\xFAmero n\xE3o corresponde a um CPF/CNPJ</div><div ng-message="api_erro">\n{{clienteForm.cnpj_cpf.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 1"><label translate="NOVO.NAME">Nome</label><input type="text" name="nome" \nplaceholder="Insira o nome" ng-model="vm.model.nome" maxlength="50" required><div class="errors" \nng-messages="clienteForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-if="vm.model.pessoa_tipo.id == 2"><label translate="CLIENTE.RAZAOSOCIAL">Raz\xE3o Social</label><input type="text" \nname="nome" placeholder="Insira a raz\xE3o social" ng-model="vm.model.nome" required><div class="errors" \nng-messages="clienteForm.nome.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.nome.$api.error.message}}</div></div></md-input-container><md-input-container flex="5"><label \ntranslate="CADASTRAIS.DDD">DDD</label><input type="text" name="ddd" ng-model="vm.model.telefone.ddd" placeholder="DDD" \nmaxlength="2" ng-pattern="/^[0-9]*$/" required><div class="errors" ng-messages="clienteForm.ddd.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="api_erro">\n{{clienteForm.ddd.$api.error.message}}</div></div></md-input-container><md-input-container flex="10"><label \ntranslate="CADASTRAIS.TELEFONE">TELEFONE</label><input type="text" name="numero" ng-model="vm.model.telefone.numero" \nplaceholder="Telefone" mask="9?9999-9999" required><div class="errors" ng-messages="clienteForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.numero.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex="20"><label>CEP</label><input type="text" name="cep" ng-model="vm.model.endereco.endereco_cep" \nplaceholder="Insira o CEP" required ui-br-cep-mask><div class="errors" ng-messages="clienteForm.cep.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="invalido">CEP inv\xE1lido</div><div ng-message="api_erro">\n{{clienteForm.cep.$api.error.message}}</div></div><md-progress-circular ng-show="cepLoading" \nclass="md-accent input-progress" md-diameter="20px"></md-progress-circular></md-input-container><md-input-container \nclass="md-block" flex><label>Cidade</label><input type="text" name="cidade" \nng-model="vm.model.endereco.endereco_cidade_nome" placeholder="Insira a cidade" maxlength="50" required><div \nclass="errors" ng-messages="clienteForm.cidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.cidade.$api.error.message}}</div></div></md-input-container><md-input-container \nflex="10"><label>UF</label><input type="text" name="uf" ng-model="vm.model.endereco.endereco_uf" maxlength="2" \nplaceholder="UF" ng-pattern="/^[a-zA-Z]*$/" required><div class="errors" ng-messages="clienteForm.uf.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente letras</div><div ng-message="api_erro">\n{{clienteForm.uf.$api.error.message}}</div></div></md-input-container><md-input-container flex="20" class="md-block">\n<label>Bairro</label><input type="text" name="bairro" ng-model="vm.model.endereco.endereco_bairro" \nplaceholder="Insira o bairro" maxlength="30" required><div class="errors" ng-messages="clienteForm.bairro.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.bairro.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="md-block" flex><label>Endere\xE7o</label><input type="text" name="endereco" \nng-model="vm.model.endereco.endereco_rua" placeholder="Insira o endere\xE7o" maxlength="50" required><div class="errors" \nng-messages="clienteForm.endereco.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{clienteForm.endereco.$api.error.message}}</div></div></md-input-container><md-input-container class="md-block" \nflex="10"><label>N\xFAmero</label><input type="text" name="numero" ng-model="vm.model.endereco.endereco_numero" \nplaceholder="N\xFAmero" maxlength="5" required><div class="errors" ng-messages="clienteForm.numero.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{clienteForm.numero.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="md-block" flex="20"><label>Complemento</label><input type="text" \nname="complemento" ng-model="vm.model.endereco.endereco_complemento" placeholder="Insira o complemento"><div \nclass="errors" ng-messages="clienteForm.complemento.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{clienteForm.complemento.$api.error.message}}</div></div></md-input-container></div><hr><div \nlayout="column" layout-margin><md-input-container class="md-block" flex><div class="label">Motivo da troca de cliente\n</div><label>&nbsp;</label><input type="textarea" name="comentario" ng-model="vm.model.comentario" \nplaceholder="Descreva o motivo" maxlength="100"></md-input-container><span class="obs">\nOBS: Para visualizar esta troca de cliente, clique no \xEDcone visualizar e acesse a aba \u201COcorr\xEAncias\u201D</span></div></div>\n</md-dialog-content><md-dialog-actions layout="row"><div class="content-buttons select" ng-if="vm.model.select == 1">\n<md-button class="btn btn-secondary" ng-click="vm.dismissModal()">Cancelar</md-button><md-button \nclass="btn btn-primary" ng-disabled="vm.model.select == \'\'" ng-click="vm.update(vm.model)">Alterar</md-button></div>\n<div class="content-buttons add" ng-if="vm.model.select == 2"><md-button class="btn btn-secondary" \nng-click="vm.dismissModal()">Cancelar</md-button><md-button class="btn btn-primary" ng-click="vm.save(vm.model)">Salvar\n</md-button></div></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/modal-caderno.html','<div class="page-visualizar-lote-vendido modal-insumos"><div class="header-modal"><div class="desc">\nVisualiza\xE7\xE3o do Caderno de Campo</div><div class="close" ng-click="hide()">X</div></div><div class="content"><div \nclass="container-title-step"><h3><span><img src="../assets/images/svg/lotes_vendidos/ico-caderno-de-campo.svg"></span>\nCADERNO DE CAMPO: LOTE ID - {{ model.loteID }}</h3></div><h4>Dados da propriedade</h4><div \nclass="format-table custom custom" layout="column" layout-gt-xs="row" layout-margin><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label>Nome da propriedade</label><input disabled="disabled" \ntype="text" ng-model="model.insumos.nome_propriedade"></md-input-container><md-input-container flex><label>Nome da \xE1rea\n</label><input disabled="disabled" type="text" ng-model="model.insumos.nome_area"></md-input-container>\n<md-input-container flex><label>Tamanho da \xE1rea</label><input disabled="disabled" type="text" \nvalue="{{ model.insumos.tamanho_area }} ha"></md-input-container><md-input-container flex><label>Cidade / Estado\n</label><input disabled="disabled" type="text" value="{{ model.insumos.cidade }} / {{ model.insumos.estado }}">\n</md-input-container></div></div><h4>Plantio / colheita</h4><div class="format-table custom custom" layout="column" \nlayout-gt-xs="row" layout-margin><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label>\nCultura</label><input disabled="disabled" type="text" ng-model="model.insumos.cultura.produto_nome">\n</md-input-container><md-input-container flex><label>Variedade</label><input disabled="disabled" type="text" \nng-model="model.insumos.variedade"></md-input-container><md-input-container flex><label>Quantidade / unidade</label>\n<input ng-if="model.insumos.unidade ==\'kg\'" disabled="disabled" type="text" \nvalue="{{ model.insumos.quantidade_disponivel | number:3 }} {{ model.insumos.unidade }}"> <input \nng-if="model.insumos.unidade ==\'unidades\'" disabled="disabled" type="text" \nvalue="{{ model.insumos.quantidade_disponivel | number }} {{ model.insumos.unidade }}"></md-input-container>\n<md-input-container class="datepicker-custom"><label>Data plantio</label><md-datepicker disabled="disabled" \nng-model="model.insumos.data_plantio" md-open-on-focus></md-datepicker></md-input-container><md-input-container \nclass="datepicker-custom"><label>Data colheita</label><md-datepicker disabled="disabled" \nng-model="model.insumos.data_colheita" md-open-on-focus></md-datepicker></md-input-container></div></div><div \nng-if="model.insumos.caderno_aplicacoes_insumos.length != 0"><hr><h4>Aplica\xE7\xE3o de insumos &nbsp;<md-button \ntype="button" class="btn btn-tertiary btn-md-i" ng-click="openInsumos();"><span ng-if="!isumosdetalhes">Ver detalhes\n</span> <span ng-if="isumosdetalhes">Fechar</span></md-button></h4><div class="insumos-detalhes {{ isumosdetalhes }}">\n<div class="format-table custom custom" layout="column" layout-gt-xs="row" layout-margin><div layout="column" \nlayout-gt-xs="row" layout-margin><table row-border hover id="responsive" \nclass="simple table-custom lotes-vendidos-visualizar"><thead class="first-level"><tr><th>Data da aplica\xE7\xE3o</th><th>\nTipo de insumo</th><th>Nome</th><th>Car\xEAncia</th><th>Quantidade / unidade</th></tr></thead><tbody><tr class="default" \nng-repeat="model in model.insumos.caderno_aplicacoes_insumos"><td>{{ model.data_aplicacao | date:\'dd/MM/yyyy\'}}</td>\n<td>{{ model.tipo_insumo }}</td><td>{{ model.insumo_agricola_nome }}</td><td>{{ model.carencia | date:\'dd/MM/yyyy\'}}\n</td><td>{{ model.quantidade }} {{ model.unidade_medida }}</td></tr></tbody></table></div></div></div></div></div>\n</div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/modal-videos.html','<div><div class="header-modal"><div class="desc">Passo a passo</div><div class="close" ng-click="vm.close()">X</div>\n</div><div class="content"><div>Assista e tire duas d\xFAvidas com os nossos tutoriais:</div><div class="box-videos"><div \nclass="video" ng-click="vm.viewTutorialVenderLotes()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-vender-lotes.jpg" alt=""><div class="tutorial"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Vender lotes</span></div></div><div class="video" \nng-click="vm.viewTutorialImprimirTrocarClienteLotes()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-youtube-imprimir-etiqueta-trocar-cliente.jpg" alt=""><div \nclass="tutorial"><img src="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>\nImprimir etiqueta e trocar cliente</span></div></div><div class="video" ng-click="vm.viewTutorialGerarLaudo()"><img \nsrc="../../../../assets/images/thumbs-videos/thumb-gerar-laudo.jpg" alt=""><div class="tutorial"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Gerar laudo de qualidade</span></div></div></div>\n</div></div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/print-label.html','<md-dialog class="modal-custom-register print dialog-label" aria-label="liberar"><form ng-cloak name="imprimirForm" \nnovalidate="" api-form="api_response_erro"><md-toolbar><div class="md-toolbar-tools"><h2>\n{{\'LOTE.ETIQUETA\' | translate }}</h2><md-button class="md-icon-button close-modal" ng-click="cancelar()">X</md-button>\n</div></md-toolbar><md-dialog-content><div class="md-dialog-content"><div api-form-validation-summary \nform="imprimirForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="select-custom" flex><label>Tamanho</label><md-select id="slctTmnh" class="md-block" name="tamanho_etiquetas" \nng-model="model.tamanho_etiquetas"><md-option ng-repeat="tamanho_etiqueta in tamanho_etiquetas" \nng-value="tamanho_etiqueta">{{tamanho_etiqueta.tamanho}}</md-option></md-select><div class="errors" \nng-messages="imprimirForm.tamanho_etiquetas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{imprimirForm.tamanho_etiquetas.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex \nng-hide="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3 || model.tamanho_etiquetas.id == 4 || model.tamanho_etiquetas.id == 5">\n<label>Tipo</label><md-select id="slctTp" class="md-block" name="tipo_etiquetas" ng-model="model.tipo_etiquetas">\n<md-option ng-repeat="tipo_etiqueta in tipo_etiquetas" ng-value="tipo_etiqueta">{{tipo_etiqueta.tipo}}</md-option>\n</md-select><div class="errors" ng-messages="imprimirForm.tipo_etiquetas.$error"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{imprimirForm.tipo_etiquetas.$api.error.message}}</div></div>\n</md-input-container><md-input-container flex \nng-show="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3 || model.tamanho_etiquetas.id == 4 || model.tamanho_etiquetas.id == 5">\n<label>Tipo</label><input id="inptTpQntdd" type="text" name="quantidade" ng-model="rolo" disabled="disabled">\n</md-input-container><md-input-container flex="20" \nng-hide="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3 || model.tamanho_etiquetas.id == 4 || model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2 || model.tamanho_etiquetas.id == 5">\n<label>Quantidade</label><input id="inptQntdd" type="text" \nng-disabled="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2" name="quantidade" \nng-model="model.quantidade_etiquetas" maxlength="4" ui-number-mask="0" min="0" max="70" required><div class="errors" \nng-messages="imprimirForm.quantidade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="min">Deve ser maior que 0</div><div ng-message="max">\nS\xF3 podem ser impressas 70 etiquetas por vez</div><div ng-message="api_erro">\n{{imprimirForm.quantidade.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex \nng-show="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2"><label>\nColunas</label><md-select id="slctClns" class="md-block" name="colunas" ng-model="model.colunas"><md-option \nng-repeat="coluna in colunas" ng-value="coluna">{{coluna.tipo}}</md-option></md-select><div class="errors" \nng-messages="imprimirForm.colunas.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{imprimirForm.colunas.$api.error.message}}</div></div></md-input-container><md-input-container flex \nng-show="model.tamanho_etiquetas.id == 3"><label>Coluna</label><input id="inptCln3" type="text" name="coluna" \nng-model="coluna" disabled="disabled"></md-input-container><md-input-container flex \nng-show="model.tamanho_etiquetas.id == 4"><label>Coluna</label><input id="inptCln4" type="text" name="coluna" \nng-model="coluna_unity" disabled="disabled"></md-input-container><md-input-container flex \nng-show="model.tamanho_etiquetas.id == 5"><label>Coluna</label><input id="inptCln5" type="text" name="coluna" \nng-model="coluna_3" disabled="disabled"></md-input-container><md-input-container class="datepicker-custom"><label>\nData de validade</label><md-datepicker id="dtpckrDt" name="data_validade" ng-model="vm.model.data_validade" \nmd-max-date="vm.date" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container flex class="md-input-has-value" \nng-hide="model.distribuidor_nome == null || model.tamanho_etiquetas.id == 5"><md-checkbox id="chckbxInclr" \nclass="distribuidor" name="comprador" ng-checked="checked" ng-model="vm.model.distribuidor" \nng-disabled="model.tamanho_etiquetas.id == 4"><span>Incluir distribuidor</span></md-checkbox></md-input-container>\n</div><div layout="column" layout-gt-xs="row" layout-margin layout-align="center" \nng-if="model.tamanho_etiquetas.id == 1"><div id="imprimirdezporcincoa4" \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 1"><div id="printLabel" class="label"><div \nclass="dados-etiqueta"><strong>{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11">CPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14">CNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>\nC\xF3digo de rastreamento: {{model.lote_numero}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p>\n<p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - <span class="lowercase">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></strong></div><div\n class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.distribuidor_nome}}<br>\nCPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><div class="compartveg-logo"><img \nsrc="../assets/images/logos/eattae_monocromatico.svg"></div></div></div></div><div id="printThis" \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 1"></div><div id="imprimirdezporcincorolo" \nng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 1" ng-hide="model.tipo_etiquetas.id == 1"><div \nid="printLabel" class="label"><div class="dados-etiqueta"><strong>{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11">CPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14">CNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>\nC\xF3digo de rastreamento: {{model.lote_numero}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p>\n<p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - <span class="lowercase">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></strong></div><div\n class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.distribuidor_nome}}<br>\nCPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><div class="compartveg-logo"><img \nsrc="../assets/images/logos/eattae_monocromatico.svg"></div></div></div></div><div id="printThisRolo" \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2"></div><div id="imprimirdezporcincorolo2x" \nng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 2" ng-hide="model.tipo_etiquetas.id == 1"><div \nid="printLabel" class="label"><div class="dados-etiqueta"><strong>{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11">CPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14">CNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>\nC\xF3digo de rastreamento: {{model.lote_numero}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p>\n<p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - <span class="lowercase">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></strong></div><div\n class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.distribuidor_nome}}<br>\nCPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><div class="compartveg-logo"><img \nsrc="../assets/images/logos/eattae_monocromatico.svg"></div></div></div></div><div id="printThisRolo2x" \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 2"></div></div><div layout="column" \nlayout-gt-xs="row" layout-margin layout-align="center" \nng-if="model.tamanho_etiquetas.id == 2 || model.tamanho_etiquetas.id == 3"><div id="imprimirdozeporcinco" \nng-if="model.tamanho_etiquetas.id == 2 && model.colunas.id == 1"><div id="printLabelDoze" class="labelDoze"><div \nclass="dados-etiqueta"><strong>{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11">CPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14">CNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>\nC\xF3digo de rastreamento: {{model.lote_numero}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p>\n<p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - <span class="lowercase">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></strong></div><div\n class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.distribuidor_nome}}<br>\nCPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><div class="compartveg-logo"><img \nsrc="../assets/images/logos/eattae_monocromatico.svg"></div></div></div></div><div id="printThisDoze" \nng-if="model.tamanho_etiquetas.id == 2"></div><div id="imprimirdozeporcincorotate" \nng-if="model.tamanho_etiquetas.id == 2 && model.colunas.id == 2"><div id="printLabelDoze" class="labelDozeRotate"><div \nclass="dados-etiqueta"><strong>{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11">CPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14">CNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>\nC\xF3digo de rastreamento: {{model.lote_numero}}</p><p>Data de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p>\n<p ng-if="vm.model.data_validade != null">Data de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong \nclass="infos-center">{{model.produto_nome}} - {{model.produto_variedade}} - <span class="lowercase">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></strong></div><div\n class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.distribuidor_nome}}<br>\nCPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div class="midia-etiqueta"><div class="qrcode"><qr type-number="8" \ncorrection-level="\'H\'" size="300" text="model.url" image="true"></qr></div><div class="compartveg-logo"><img \nsrc="../assets/images/logos/eattae_monocromatico.svg"></div></div></div></div><div id="printThisDozeRotate" \nng-if="model.tamanho_etiquetas.id == 2"></div><div id="imprimirseisporquatrorotate" \nng-if="model.tamanho_etiquetas.id == 3"><div id="printLabelDoze" class="labelSeisRotate"><div class="dados-etiqueta">\n<strong>{{model.nome_clientePerfil}}</strong><p ng-if="model.cnpj_cpf_clientePerfil.length == 11">\nCPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p ng-if="model.cnpj_cpf_clientePerfil.length == 14">\nCNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>C\xF3digo de rastreamento: {{model.lote_numero}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><strong class="infos-center">\n{{model.produto_nome}} - {{model.produto_variedade}} - <span class="lowercase">\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></strong></div><div\n class="dados-etiqueta-3"><p ng-if="vm.model.distribuidor == true">Distribuidor: {{model.distribuidor_nome}}</p><p \nng-if="vm.model.distribuidor_cnpj_cpf != null">CPF/CNPJ: {{model.distribuidor_cnpj_cpf}}</p></div><div \nclass="midia-etiqueta"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" \nimage="true"></qr></div><div class="compartveg-logo"><img src="../assets/images/logos/eattae_monocromatico.svg"></div>\n<p class="version">Vers\xE3o 1.1</p></div></div></div><div id="printThisSeisRotate" \nng-if="model.tamanho_etiquetas.id == 3"></div></div><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="center" ng-if="model.tamanho_etiquetas.id == 4"><div id="imprimirquatropordoisemeio" \nng-show="model.tamanho_etiquetas.id == 4"><div id="printLabeQuatroPorDois" class="labelQuatroPorDoisMeio"><div \nclass="dados-etiqueta"><strong>{{model.nome_clientePerfil}}</strong></div><div class="dados-etiqueta-2"><span \nclass="variedade">{{model.produto_nome}} - {{model.produto_variedade}}</span></div><div class="dados-etiqueta-3"><span>\n{{model.produto_embalagem_tipo}} de {{model.produto_embalagem_peso}} {{model.unidade_medida}}</span></div><div \nclass="dados-etiqueta-4"><strong ng-if="model.nome_produtor == \'\' ">{{model.nome_clientePerfil}}</strong><p \nng-if="model.cnpj_cpf_clientePerfil.length == 11">CPF: {{model.cnpj_cpf_clientePerfil | brCpf}}</p><p \nng-if="model.cnpj_cpf_clientePerfil.length == 14">CNPJ: {{model.cnpj_cpf_clientePerfil | brCnpj}}</p><p>\nData de Expedi\xE7\xE3o: {{model.data_expedicao | date:\'dd/MM/yyyy\'}}</p><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p><span>N\xBA lote: {{model.lote_numero}}</span></div>\n<div class="dados-etiqueta-5"><div class="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" \ntext="model.url" image="true"></qr></div><p>by Eattae</p></div></div></div></div><div id="printThisQuatroPorDois" \nng-if="model.tamanho_etiquetas.id == 4"></div><div layout="column" layout-gt-xs="row" layout-margin \nlayout-align="center" ng-if="model.tamanho_etiquetas.id == 5"><div id="imprimirtrintaetresporvinteeum" \nng-show="model.tamanho_etiquetas.id == 5"><div id="printLabeTrintaETresPorVinteEUm" \nclass="labelTrintaETresPorVinteEUm"><div class="display-flex-1"><div class="dados-etiqueta"><strong>\n{{model.produto_nome}} {{model.produto_variedade}}</strong><p ng-if="vm.model.data_validade != null">\nData de validade: {{vm.model.data_validade | date:\'dd/MM/yyyy\'}}</p></div><div class="dados-etiqueta-5"><div \nclass="qrcode"><qr type-number="8" correction-level="\'H\'" size="300" text="model.url" image="true"></qr></div></div>\n</div><div class="display-flex-2"><div class="dados-etiqueta-4"><span>Rastreamento: {{model.lote_numero}}</span></div>\n</div></div></div></div><div id="printThisTrintaETresPorVinteEUm" ng-if="model.tamanho_etiquetas.id == 5"></div></div>\n</md-dialog-content><md-dialog-actions><md-button id="btnCnclr" class="btn btn-secondary" ng-click="cancelar()">\n{{\'LOTE.CANCELAR\' | translate }}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 1 && model.tipo_etiquetas.id == 1 && model.quantidade_etiquetas != null" \nclass="btn btn-primary" ng-click="Export(model.quantidade_etiquetas)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button>\n<md-button ng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 1 && model.tipo_etiquetas.id != 1" \ntype="button" class="btn btn-primary" aria-label="Submit" ng-click="ExportRolo(model)">{{\'LOTE.IMPRIMIR\' | translate}}\n</md-button><md-button ng-if="model.tamanho_etiquetas.id == 1 && model.colunas.id == 2" type="button" \nclass="btn btn-primary" aria-label="Submit" ng-click="ExportRolo2x(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button>\n<md-button ng-if="model.tamanho_etiquetas.id == 2 && model.colunas.id == 2" type="button" class="btn btn-primary" \naria-label="Submit" ng-click="ExportDozeRotate(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 2  && model.colunas.id == 1" type="button" class="btn btn-primary" \naria-label="Submit" ng-click="ExportDoze(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 3" type="button" class="btn btn-primary" aria-label="Submit" \nng-click="ExportSeisPorQuatro(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 4" type="button" class="btn btn-primary" aria-label="Submit" \nng-click="ExportQuatroPorDois(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button><md-button \nng-if="model.tamanho_etiquetas.id == 5" type="button" class="btn btn-primary" aria-label="Submit" \nng-click="ExportTrintaETresPorVinteEUm(model)">{{\'LOTE.IMPRIMIR\' | translate}}</md-button></md-dialog-actions></form>\n</md-dialog>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/visualizar.html','<div class="container-header container-header-novo"><h1>Lotes vendidos <i class="fas fa-chevron-right"></i>\nDados do lote</h1></div><div id="forms" class="page-layout simple fullwidth doc-page page-visualizar-lote-vendido" \nlayout="column"><div class="content" layout="column"><div class="container-content-custom"><div \nclass="content-register"><form name="propriedadeForm" class="md-inline-form" novalidate \napi-form="vm.api_response_erro"><fieldset><md-card><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel="Informa\xE7\xF5es da venda"><md-content><div class="simple-table-container"><div class="ms-responsive-table-wrapper">\n<div class="entity_division"><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/lotes_vendidos/ico-dados-da-venda.svg"></span>DADOS DA VENDA</h3></div><div \nclass="format-table custom custom" layout="column" layout-gt-xs="row" layout-margin><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="10"><label translate="LOTE.ID_LOTE">ID do lote</label><input\n disabled="disabled" type="text" name="id_lote" ng-model="vm.model.lote_distribuicao.id"></md-input-container>\n<md-input-container flex><label translate="LOTE.NUMERO_LOTE">N\xFAmero do lote</label><input disabled="disabled" \ntype="text" name="lote_numero" ng-model="vm.model.lote_distribuicao.lote_numero"></md-input-container>\n<md-input-container class="datepicker-custom"><label>Data expedi\xE7\xE3o</label><md-datepicker disabled="disabled" \nname="data_expedicao" ng-model="vm.model.data_expedicao" md-placeholder="Data de expedi\xE7\xE3o" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container flex><label translate="LOTE.CULTURA">Cultura</label><input \ndisabled="disabled" type="text" name="cultura" ng-model="vm.model.cultura.nome"></md-input-container>\n<md-input-container flex><label translate="LOTE.VARIEDADE">Variedade</label><input disabled="disabled" type="text" \nname="variedade" ng-model="vm.model.produto_variedade"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex ng-if="vm.model.unidade_medida == \'kg\'"><label>\nQuantidade total</label><input disabled="disabled" type="text" name="quantidade" \nvalue="{{ vm.model.quantidade | number:3}} {{ vm.model.unidade_medida }}"></md-input-container><md-input-container \nflex ng-if="vm.model.unidade_medida == \'unidades\'"><label>Quantidade total</label><input disabled="disabled" \ntype="text" name="quantidade" value="{{ vm.model.quantidade | number}} {{ vm.model.unidade_medida }}">\n</md-input-container><md-input-container flex><label>Tipo de embalagem</label><input disabled="disabled" type="text" \nname="embalagem_tipo" ng-model="vm.model.embalagem_tipo"></md-input-container><md-input-container flex \nng-if="vm.model.unidade_medida == \'kg\'"><label>Peso por embalagem</label><input disabled="disabled" type="text" \nvalue="{{ vm.model.embalagem_peso | number:3}} {{ vm.model.unidade_medida }}"></md-input-container><md-input-container \nflex ng-if="vm.model.unidade_medida == \'unidades\'"><label>Quantidade por embalagem</label><input disabled="disabled" \ntype="text" value="{{ vm.model.embalagem_peso | number}} {{ vm.model.unidade_medida }}"></md-input-container>\n<md-input-container flex><label>Quantidade de embalagem</label><input disabled="disabled" type="text" \nvalue="{{ vm.model.quantidade / vm.model.embalagem_peso | roundup }}"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex><label>Status do lote</label><input disabled="disabled" \ntype="text" name="quantidade" value="{{ (vm.model.lote_distribuicao_venda_status_id == 1)?\'vendido\':\'estornado\' }}">\n</md-input-container><md-input-container flex><label>N\xBA do documento</label><input disabled="disabled" type="text" \nname="quantidade" value="{{ vm.model.nota_fiscal }}"></md-input-container><md-input-container flex="50"><label>\nE-mail do envio</label><input disabled="disabled" type="text" \nvalue="{{ vm.model.lote_distribuicao_venda_email_notificacaos[0].email }}"></md-input-container></div></div></div><div \nclass="entity_division"><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/lotes_vendidos/ico-dados-do-comprador.svg"></span>DADOS DO COMPRADOR</h3></div><div \nclass="format-table custom custom" layout="column" layout-gt-xs="row" layout-margin><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="50"><label>Nome</label><input disabled="disabled" \ntype="text" name="id_lote" ng-model="vm.model.cliente_consumidor.nome"></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="50"><label>Endere\xE7o</label><input disabled="disabled" \ntype="text" name="id_lote" ng-model="vm.model.cliente_consumidor.endereco_rua"></md-input-container><md-input-container\n flex><label>Cidade / Estado</label><input disabled="disabled" type="text" name="lote_numero" \nvalue="{{ vm.model.cliente_consumidor.endereco_cidade_nome }} / {{ vm.model.cliente_consumidor.endereco_uf }}">\n</md-input-container></div></div></div><div class="entity_division" ng-if="vm.model.cliente_distribuidor"><div \nclass="container-title-step"><h3><span><img src="../assets/images/svg/lotes_vendidos/ico-dados-do-distribuidor.svg">\n</span>DADOS DO DISTRIBUIDOR</h3></div><div class="format-table custom custom" layout="column" layout-gt-xs="row" \nlayout-margin><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="50"><label>Nome</label>\n<input disabled="disabled" type="text" name="id_lote" ng-model="vm.model.cliente_distribuidor.nome">\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="50"><label>\nEndere\xE7o</label><input disabled="disabled" type="text" name="id_lote" \nng-model="vm.model.cliente_distribuidor.endereco_rua"></md-input-container><md-input-container flex><label>\nCidade / Estado</label><input disabled="disabled" type="text" name="lote_numero" \nvalue="{{ vm.model.cliente_distribuidor.endereco_cidade_nome }} / {{ vm.model.cliente_consumidor.endereco_uf }}">\n</md-input-container></div></div></div><div class="entity_division"><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/lotes_vendidos/ico-composicao-dos-lotes.svg"></span>COMPOSI\xC7\xC3O DOS LOTES</h3></div><div \nclass="format-table custom custom" layout="column" layout-gt-xs="row" layout-margin><div layout="column" \nlayout-gt-xs="row" layout-margin><table row-border hover id="responsive" \nclass="simple table-custom lotes-vendidos-visualizar"><thead class="first-level"><tr><th>ID</th><th>Tipo do lote</th>\n<th>Data colheita /<br>expedi\xE7\xE3o</th><th>Fornecedor</th><th>C\xF3digo<br>Rastreamento</th><th>Rastreamento<br>total</th>\n<th>Quant. / unid.</th><th>A\xE7\xF5es</th></tr></thead><tbody><tr class="default" \nng-repeat="model in vm.model.lote_producao_distribuicao"><td><h6 class="d-mobile">ID</h6>{{ model.id }}</td><td><h6 \nclass="d-mobile">Tipo do lote</h6>{{ model.lote_producao_distribuicao_tipo.nome }}</td><td><h6 class="d-mobile">\nData colheita /<br>expedi\xE7\xE3o</h6>{{ model.data | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">Fornecedor</h6>\n{{ model.produtor_nome }}</td><td><h6 class="d-mobile">C\xF3digo<br>Rastreamento</h6>\n{{ model.lote_numero?model.lote_numero:\'&nbsp;\' }}</td><td><h6 class="d-mobile">Rastreamento<br>total</h6><div \nclass="icon-custom" ng-if="model.rastreabilidade_total == \'1\'"><md-icon class="enabled" \nmd-font-icon="icon-brightness-1"></md-icon><span>Sim</span></div><div class="icon-custom" \nng-if="model.rastreabilidade_total != \'1\'"><md-icon class="disabled" md-font-icon="icon-brightness-1"></md-icon><span>\nN\xE3o</span></div></td><td ng-if="model.unidade_medida ==\'kg\'"><h6 class="d-mobile">Quant. / unid.</h6><strong>\n{{ model.quantidade | number:3 }} {{ model.unidade_medida }}</strong></td><td \nng-if="model.unidade_medida ==\'unidades\'"><h6 class="d-mobile">Quant. / unid.</h6><strong>\n{{ model.quantidade | number }} {{ model.unidade_medida }}</strong></td><td class="acoes"><h6 class="d-mobile">A\xE7\xF5es\n</h6><a href="#" class="btn-quaternary mr-1rem" \nng-click="vm.viewCaderno(model.id, model.lote_producao_distribuicao_tipo.id)" \nng-if="model.rastreabilidade_total == \'1\'"><img src="../assets/images/svg/lotes_vendidos/ico-caderno-de-campo-pt.svg"> \n</a><a class="btn-quaternary mr-1rem inactive" ng-if="model.rastreabilidade_total != \'1\'"><img \nsrc="../assets/images/svg/lotes_vendidos/ico-caderno-de-campo-pt.svg"></a></td></tr></tbody></table></div></div></div>\n</div></div></md-content></md-tab><md-tab label="Ocorr\xEAncias" \nng-if="vm.model.lote_distribuicao_venda_ocorrencia.length > 0"><md-content><div class="simple-table-container"><div \nclass="ms-responsive-table-wrapper"><div class="item-list-collapse" \nng-repeat="ocorrencia in vm.model.lote_distribuicao_venda_ocorrencia" ng-click="vm.isCollapsed(ocorrencia)"><div \nclass="row-collapse" ng-class="{\'collapse-open\' : ocorrencia.open }"><div class="container-collapse"><div \nclass="icon-collapse"><i class="fas fa-sort-down" ng-if="!ocorrencia.open"></i> <i class="fas fa-sort-up" \nng-if="ocorrencia.open"></i></div><div class="align lower-percent"><div class="date">\n{{ ocorrencia.data_inclusao | date:\'dd/MM/yyyy\' }}</div><div class="change-client">Troca de cliente</div></div><div \nclass="align higher-percent"><div class="old-client">\n{{ ocorrencia.lote_distribuicao_venda_ocorrencia_alteracao_consumidor.cliente_consumidor_antigo_nome}}</div><i \nclass="icon-transfer fas fa-long-arrow-alt-right"></i><div class="new-client">\n{{ ocorrencia.lote_distribuicao_venda_ocorrencia_alteracao_consumidor.cliente_consumidor_novo_nome }}</div></div></div>\n</div><div class="row-collapse-reason" ng-class="{\'collapse-open\' : ocorrencia.open }" ng-if="ocorrencia.open"><div \nclass="container-collapse-reason">Motivo: {{ ocorrencia.comentario }}</div></div></div></div></div></md-content>\n</md-tab></md-tabs></md-content></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.comeBack()">Voltar</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/consulta/views/pagamento.html','<div class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-header"><h1 translate="CONSULTA.HISTORICO">Hist\xF3rico de compras\n</h1></div><div class="container-search"><h2 translate="CONSULTA.LICENCAS">Licen\xE7as</h2></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom historico-compra"><thead><tr><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">N\xFAmero<br>\nde licen\xE7as</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Plano<br>contratado</span></div></th><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Data<br>da compra</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Validade<br>\nda licen\xE7a</span></div></th><th class="secondary-text pagination-custom" lm-sort-header="card_brand" lm-title="Valor">\n</th><th class="secondary-text pagination-custom" lm-sort-header="card_brand" lm-title="Status"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data" lm-title="Pagamento"></th></tr></thead><tbody><tr \nng-repeat="model in vm.models"><td><span ng-if="model.dados_boleto.numero_assinaturas == null">1 </span>\n{{model.dados_boleto.numero_assinaturas}}</td><td>{{model.plano}}</td><td>{{model.date_created | date:\'dd/MM/yyyy\'}}\n</td><td>{{model.data_expiracao | date:\'dd/MM/yyyy\'}} <span ng-if="model.data_expiracao == null">-</span></td><td>\nR${{model.paid_amount | finance:false:2}}</td><td><div class="icon-custom" ng-if="model.status == \'Ativo\'"><md-icon \nclass="enabled" md-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">Sim</md-tooltip></md-icon>\n<span>{{model.status}}</span></div><div class="icon-custom" ng-if="model.status == \'Inativo\'"><md-icon \nclass="disabled" md-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">N\xE3o</md-tooltip></md-icon>\n<span>{{model.status}}</span></div></td><td><div ng-if="model.payment_method == \'Boleto\'"><md-button \nclass="edit-button md-icon-button" ng-click="vm.reimprimeboleto(model)" aria-label="Imprimir"><md-icon \nmd-font-icon="icon-printer" class="s16"><md-tooltip hide-xs md-direction="right">Reimprimir</md-tooltip></md-icon>\n</md-button><a href="#" ng-click="vm.reimprimeboleto(model)" class="black">Boleto</a></div><div \nng-if="model.payment_method == \'Credito\'"><md-icon md-font-icon="icon-credit-card" class="s16"></md-icon><span>Cart\xE3o\n</span></div></td></tr></tbody></table><lm-paginator lm-args="vm.args"></lm-paginator><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div></div></div></div>');
$templateCache.put('app/main/registro/area/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\xC1reas</h1></div><div \nclass="tutorial" ng-click="vm.viewTutorial()"><img src="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>\nAssista o passo a passo</span></div></div><md-button class="btn btn-primary btn-lg-i" translate="AREA.ADD_AREA" \nng-click="vm.gotoAdd()" ng-disabled="vm.models.propriedades_cliente.length == 0">Adicionar \xE1rea</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="container-title-step"><h3><span><img src="../assets/icons/ico-area.svg">\n</span>\xC1REAS</h3></div><div class="container-search"><div><h2 translate="REGISTERS.LIST">Lista</h2></div></div><div \nclass="form-search-horizontal"><form><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col periodo"><div \nclass="row-periodo"><div class="select-content"><md-input-container class="form-group select-custom" flex><label \nclass="form-label">Per\xEDodo do Cadastro</label><select class="form-select select-periodo" name="periodo" \nng-model="vm.args.periodo" ng-change="vm.selectedPeriodo()"><option value="" disabled="disabled">Selecione</option>\n<option ng-value="period.value" ng-repeat="period in vm.periods">{{period.description}}</option></select>\n</md-input-container></div><div class="date-picker" id="dataspicker"><a ng-click="vm.openDatasSelect();"><img \nsrc="../../../../../assets/icons/ico-calendario.svg"></a><div class="date-picker-box"><div layout="column" \nlayout-gt-xs="column" layout-margin><div class="align-datepicker"><md-input-container class="datepicker-custom" \nflex="40"><label>Data inicial</label><md-datepicker name="data_inicio" ng-model="vm.args.date_inicio" \nmd-max-date="vm.args.date_fim" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n<md-input-container class="datepicker-custom" flex="40"><label>Data final</label><md-datepicker name="data_fim" \nng-model="vm.args.date_fim" ng-disabled="vm.args.date_inicio == null" md-min-date="vm.args.date_inicio" \nmd-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div><div class="butons"><button \nclass="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button class="btn btn-submit" \nng-click="vm.selecionarDatas();" ng-disabled="vm.args.date_fim == null">Selecionar</button></div></div></div></div>\n</div></div><div class="col"><md-input-container class="form-group select-custom" flex><label>Cultura</label><select \nclass="md-block" name="cultura" ng-model="vm.args.cultura" \nng-options="cultura.nome as cultura.nome for cultura in vm.filtros.propriedade_area_cultura_list"><option value="" \nselected="selected" disabled="disabled">Selecione</option></select></md-input-container></div><div class="col">\n<md-input-container class="form-group select-custom" flex><label>\xC1rea</label><select class="md-block" name="area" \nng-model="vm.args.area" ng-options="item.nome as item.nome for item in vm.filtros.propriedade_area_list"><option \nvalue="" selected="selected" disabled="disabled">Selecione</option></select></md-input-container></div><div \nclass="col"><md-input-container class="form-group select-custom" flex><label>Status</label><select class="md-block" \nname="aberta" ng-model="vm.args.status"><option value="" disabled="disabled">Selecione</option><option \nng-value="item.value" ng-repeat="item in vm.status">{{item.description}}</option></select></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.resetPagination(); vm.args._change();">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><md-progress-linear \nng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><table row-border hover lm-sort lm-args="vm.args" \nid="responsive" class="simple table-custom area"><thead><tr><th \nclass="secondary-text pagination-custom table-column-id" lm-sort-header="id" lm-title="ID" flex="10"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="nome" lm-title="\xC1rea" flex="50"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="area_produtiva" lm-title="Hectare"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="cultura" lm-title="Cultura/variedade" flex="10"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="data_cadastro" lm-title="Cadastro" flex="10"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="ultima_abertura" lm-title="\xDAltimo caderno" flex="10"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="caderno_campo_ativo" lm-title="Status" flex="10"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="AREA.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr \nng-repeat="model in vm.models.propriedade_area"><td><h6 class="d-mobile">ID</h6>{{model.id}}</td><td><h6 \nclass="d-mobile">\xC1rea</h6>{{model.propriedade_area_nome}}</td><td><h6 class="d-mobile">Hectare</h6>\n{{model.area_produtiva}}</td><td><h6 class="d-mobile">Cultura</h6>{{model.cultura}} {{model.produto_variedade}}</td>\n<td><h6 class="d-mobile">Cadastro</h6>{{model.data_cadastro | date:\'dd/MM/yyyy\'}}</td><td><h6 class="d-mobile">\n\xDAltimo caderno</h6>{{model.ultimo_caderno | date:\'dd/MM/yyyy\'}}</td><td style="min-width: 150px;"><h6 class="d-mobile">\nStatus</h6><div class="icon-custom" ng-if="model.caderno_status == \'Aberto\'"><md-icon class="enabled" \nmd-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">{{model.caderno_status}}</md-tooltip></md-icon>\n<span>{{model.caderno_status}}</span></div><div class="icon-custom" ng-if="model.caderno_status == \'Fechado\'"><md-icon \nclass="disabled" md-font-icon="icon-brightness-1"><md-tooltip hide-xs md-direction="top">{{model.caderno_status}}\n</md-tooltip></md-icon><span>{{model.caderno_status}}</span></div></td><td><h6 class="d-mobile">A\xE7\xF5es</h6><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoEditar(model.id)" aria-label="Editar"><i class="fas fa-pen">\n<md-tooltip hide-xs md-direction="left">Editar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="right">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-if="model.caderno_status == \'Aberto\'" ng-click="vm.showConfirmEncerrar(model)" \naria-label="Encerrar"><i class="fas fa-ban"><md-tooltip hide-xs md-direction="right">Encerrar</md-tooltip></i>\n</md-button><md-button class="edit-button md-icon-button" ng-if="model.caderno_status == \'Fechado\'" \nng-click="vm.estornarConfirm(model)" aria-label="Estornar"><i class="fas fa-undo-alt"><md-tooltip hide-xs \nmd-direction="left">Estornar</md-tooltip></i></md-button><md-button class="edit-button md-icon-button" \nng-disabled="model.caderno_status == \'Aberto\'" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i \nclass="far fa-trash-alt"><md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr>\n</tbody></table></div></div><lm-paginator lm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/area/views/criar.html','<div class="container-header"><div class="breadcrumb"><h1>\xC1reas > Cadastro > Adicionar \xE1rea</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page page-areas" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>DADOS DA \xC1REA</h3></div><div class="content-register"><form name="areaForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card ng-if="vm.model.propriedade"><div \napi-form-validation-summary form="areaForm"></div><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex="20"><label translate="AREA.NAME_AREA">Nome da \xE1rea</label><input id="inptNm" type="text" \nname="area" placeholder="Insira o nome da \xE1rea" ng-model="vm.model.nome" maxlength="15" required><div class="errors" \nng-messages="areaForm.area.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{areaForm.area.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label>\nTamanho da \xE1rea produtiva (hectares)</label><input id="inptTmnh" type="text" name="area_produtiva" \nplaceholder="Insira o tamanho (em hectares)" ng-model="vm.model.area_produtiva" maxlength="8" required \nui-number-mask="4" min="0.0001" max="999.9999"><div class="errors" ng-messages="areaForm.area_produtiva.$error"><div \nng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">{{areaForm.area.$api.error.message}}</div><div \nng-message="min">Deve ser maior que {{0.0001 | finance:false:2}}</div><div ng-message="max">\nDeve ser menor que {{999.99.99 | finance:false:2}}</div></div></md-input-container><md-input-container flex><label>\nCultura</label><md-autocomplete required flex class="md-block" md-input-id="inptCltr" md-input-name="cultura" \nmd-no-cache="false" md-selected-item="vm.model.cultura" md-search-text="culturaQuery" \nmd-items="item in vm.culturaSearch(culturaQuery)" md-item-text="item.nome" md-delay="500" md-require-match \nmd-selected-item-change="vm.onSelectCultura(item)" placeholder="Buscar cultura"><md-item-template><span \nmd-highlight-text="vm.model.cultura">{{item.nome}}</span></md-item-template><md-not-found>Nenhum resultado encontrado\n</md-not-found></md-autocomplete><div ng-messages="plantioForm.cultura.$error" ng-if="plantioForm.cultura.$touched">\n<div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="md-require-match">\nPor favor, digite uma cultura v\xE1lida</div><div ng-message="api_erro">{{plantioForm.cultura.$api.error.message}}</div>\n</div></md-input-container><md-input-container class="form-group select-custom" flex><label>Variedade*</label><select \nid="variedade" name="variedade" class="form-control" ng-model="vm.model.variedade_id" ng-disabled="!vm.model.cultura" \nng-options="item.id as item.nome for item in vm.variedades" ng-value="item.id" required><option value="" \nselected="selected" disabled="disabled">Selecione</option></select><div class="errors" \nng-messages="areaForm.variedade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{areaForm.variedade.$api.error.message}}</div></div></md-input-container><md-input-container flex="10" \nng-show="vm.model.cultura"><a class="btn-addnew" ng-click="vm.showDialogCreateVariedade($event, $index)"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Adicionar</a></md-input-container></div></md-card><md-card \nng-if="!vm.model.propriedade"><div layout="column" layout-margin><md-input-container class="card-aviso-propriedade">\n<h2><strong>Propriedade n\xE3o encontrada</strong></h2><p>\nN\xE3o foi encontrado uma propriedade. Clique no bot\xE3o abaixo para cadastrar uma nova propriedade:</p><md-button \ntype="button" class="btn btn-primary btn-lg" ng-click="vm.gotoCadastroPropriedade()">Cadastrar propriedade</md-button>\n</md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button md-button-id="bttnVltr" \nclass="btn btn-secondary btn-lg" ng-click="vm.cancelClick(areaForm,$event)">Voltar</md-button><md-button \nmd-button-id="bttnCdstr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="areaForm.$invalid || areaForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Cadastrar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/area/views/criar_variedade.tmpl.html','<md-dialog><form name="VariedadeForm" novalidate="" api-form="vm.api_response_erro" ng-submit="vm.save(VariedadeForm)">\n<md-toolbar><div class="header-modal"><div class="desc">Inclus\xE3o de variedade</div><div class="close" \nng-click="vm.gotoSearch()">X</div></div></md-toolbar><md-dialog-content><div api-form-validation-summary \nform="VariedadeForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container class="md-block" \nflex><label>Digite o nome da variedade que deseja incluir</label><input type="text" name="variedade" \nng-model="vm.model.nome" placeholder="Digite" maxlength="20" required><div class="errors" \nng-messages="VariedadeForm.variedade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{VariedadeForm.variedade.$api.error.message}}</div></div></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout="row"><md-button class="btn btn-secondary" ng-click="vm.gotoSearch()">\nCancelar</md-button><md-button class="btn btn-primary" ng-disabled="VariedadeForm.$error.required" \nng-click="vm.save(vm.model)">Cadastrar</md-button></md-dialog-actions></form></md-dialog>');
$templateCache.put('app/main/registro/area/views/culturas.html','<div><div class="header-modal"><div class="desc">Culturas</div><div class="close" ng-click="hide()">X</div></div><div \nclass="content"><table class="table-culturas"><md-progress-linear ng-if="loading" md-mode="indeterminate">\n</md-progress-linear><thead></thead><tbody><tr ng-repeat="item in culturasVariedades.propriedade_area_culturas_list">\n<td>{{ item.nome }}</td><td>{{ item.variedade }}</td></tr></tbody></table></div></div>');
$templateCache.put('app/main/registro/area/views/dashboard.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\xC1reas > Dashboard</h1></div></div>\n<div class="top-content-buttons"><md-button class="btn btn-primary btn-xl-i" ng-disabled="vm.propriedade.length == 0" \nng-click="vm.gotoLista(0)">Ver lista com todas as \xE1reas</md-button>&nbsp;<md-button class="btn btn-primary btn-lg-i" \ntranslate="AREA.ADD_AREA" ng-click="vm.gotoAdd(vm.args.Propriedade_Id)" ng-disabled="vm.propriedade.length == 0">\nAdicionar \xE1rea</md-button></div></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="indices-1 form-search-horizontal">\n<div class="container"><div class="row"><div class="col"><div class="box"><div class="ico"><img \nsrc="../../../../../assets/icons/ico-propriedade.svg"></div><div class="txt"><h3>\xC1REA TOTAL</h3><span class="number">\n{{ vm.models.area_total | number:3 }}</span><span class="unid">HECTARES</span></div></div></div><div class="col"><div \nclass="box"><div class="ico"><img src="../../../../../assets/icons/dash-areas/ico-provedor-solicitacao.svg"></div><div \nclass="txt"><h3>\xC1REA PRODUTIVA</h3><span class="number">{{ vm.models.area_produtiva | number:3 }}</span><span \nclass="unid">HECTARES</span></div></div></div><div class="col"><div class="box"><div class="ico"><img \nsrc="../../../../../assets/icons/dash-areas/ico-area-sem-uso.svg"></div><div class="txt"><h3>\xC1REA SEM USO</h3><span \nclass="number">{{ vm.models.area_sem_uso | number:3 }}</span><span class="unid">HECTARES</span></div></div></div></div>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear><div class="row grupo-2"><div \nclass="col"><div class="box-2"><div class="ico"><img src="../../../../../assets/icons/dash-areas/ico-area-aberta.svg">\n<h3>EM ABERTO</h3></div><div class="total"><span class="number">{{ vm.models.aberto }}</span><br><span class="nome">\n\xC1REAS</span></div><div class="footer"><a href="#" ng-click="vm.gotoLista(1)"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Ver lista</a></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/dash-areas/ico-areas-abertas.svg"><h3>DISPON\xCDVEIS</h3></div><div class="total"><span \nclass="number">{{ vm.models.diponivel }}</span><br><span class="nome">\xC1REAS</span></div><div class="footer"><a \nhref="#" ng-click="vm.gotoLista(2)"><md-icon md-font-icon="icon-plus-circle"></md-icon>Ver lista</a></div></div></div>\n<div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/dash-areas/ico-laudo-flv.svg"><h3>CULTURAS</h3></div><div class="total"><span \nclass="number">{{ vm.models.cultura_variedade }}</span><br><span class="nome">TOTAL</span></div><div class="footer"><a \nhref="#" ng-click="vm.openModalCulturas()"><md-icon md-font-icon="icon-plus-circle"></md-icon>Ver lista</a></div></div>\n</div></div></div></div></div></div></div>');
$templateCache.put('app/main/registro/area/views/editar.html','<div class="container-header"><div class="breadcrumb"><h1 translate="AREA.EDIT_AREA">Editar \xE1rea</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page page-areas" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>DADOS DA \xC1REA</h3></div><div class="content-register"><form name="areaForm" \nclass="md-inline-form" novalidate api-form="vm.api_response_erro"><fieldset><md-card><div api-form-validation-summary \nform="areaForm"></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="AREA.NAME_AREA">Nome da \xE1rea</label><input type="text" name="area" placeholder="Insira o nome da \xE1rea" \nng-model="vm.model.nome" maxlength="15" required><div class="errors" ng-messages="areaForm.area.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{areaForm.nome.$api.error.message}}</div>\n</div></md-input-container><md-input-container flex><label translate="AREA.SIZE_AREA">Tamanho da \xE1rea produtiva</label>\n<input type="text" name="area_produtiva" ng-model="vm.model.area_produtiva" maxlength="11" \nplaceholder="Insira o tamanho (em hectares)" required ui-number-mask="4" min="0.01" max="99.999.9999"><div \nclass="errors" ng-messages="areaForm.area_produtiva.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="min">Deve ser maior que {{0.01 | finance:false:2}}</div><div ng-message="max">\nDeve ser menor que {{99.999.99 | finance:false:2}}</div><div ng-message="api_erro">{{areaForm.area.$api.error.message}}\n</div></div></md-input-container><md-input-container flex><label>Cultura</label><md-autocomplete required flex \nclass="md-block" md-input-name="cultura" md-no-cache="false" md-selected-item="vm.model.cultura" \nmd-search-text="culturaQuery" md-items="item in vm.culturaSearch(culturaQuery)" md-item-text="item.nome" \nmd-delay="500" md-require-match md-selected-item-change="vm.onSelectCultura(item)" placeholder="Buscar cultura">\n<md-item-template><span md-highlight-text="vm.model.cultura">{{item.nome}}</span></md-item-template><md-not-found>\nNenhum resultado encontrado</md-not-found></md-autocomplete><div ng-messages="plantioForm.cultura.$error" \nng-if="plantioForm.cultura.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="md-require-match">Por favor, digite uma cultura v\xE1lida</div><div ng-message="api_erro">\n{{plantioForm.cultura.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="form-group select-custom" flex><label>Variedade*</label><select id="variedade" name="variedade" \nclass="form-control" ng-model="vm.model.variedade_id" ng-disabled="!vm.model.cultura" \nng-options="item.id as item.nome for item in vm.variedades" ng-value="item.id" required><option value="" \nselected="selected" disabled="disabled">Selecione</option></select><div class="errors" \nng-messages="areaForm.variedade.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{areaForm.variedade.$api.error.message}}</div></div></md-input-container><md-input-container flex="10" \nng-hide="!vm.model.cultura"><a class="btn-addnew" ng-click="vm.showDialogCreateVariedade($event)"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Adicionar</a></md-input-container></div></md-card></fieldset><div \nclass="content-buttons"><md-button class="btn btn-secondary btn-lg" ng-click="vm.cancelClick(areaForm,$event)">Voltar\n</md-button><md-button type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="areaForm.$invalid || areaForm.$pristine || loadingProgress" ng-click="vm.save(vm.model)">Salvar\n</md-button></div></form></div></div></div></div>');
$templateCache.put('app/main/registro/area/views/historico.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\xC1reas > Hist\xF3rico</h1></div></div>\n</div><div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content content-historico-areas" layout="column"><div class="container-content-custom"><div \nclass="content-register"><form name="historyForm" class="md-inline-form" novalidate api-form="vm.api_response_erro">\n<fieldset ng-disabled="vm.models.propriedades_cliente.length == 0"><md-card class="historico"><div \nng-class="vm.api_response_erro" api-form-validation-summary class="style-error" form="historyForm"></div><div \nclass="align-elements" layout-align="space-around"><div layout-gt-xs="row" layout-margin class="icon-filter"><i \nclass="fa fa-search"></i> <span>Buscar</span></div><div layout-gt-xs="row" layout-margin flex="40" class="row-select">\n<div class="select-content"><md-input-container class="form-group select-custom"><label class="form-label">\xC1rea <small>\n(Selecione uma \xE1rea para realizar a busca)</small></label><select class="form-select select-periodo" name="periodo" \nng-model="vm.model.id" ng-class="vm.model.id?\'select-active\':null"><option value="" disabled="disabled">Selecione\n</option><option ng-value="item.id" ng-repeat="item in vm.areas">{{item.nome}}</option></select></md-input-container>\n</div></div><div layout-gt-xs="row" layout-margin><label class="label-datas">Per\xEDodo</label><md-input-container \nclass="datepicker-custom"><span>Data inicial</span><md-datepicker name="data_inicial" md-max-date="vm.date" \nng-model="vm.model.dataInicial" required></md-datepicker><div class="errors" \nng-messages="historyForm.data_inicial.$error"><div ng-message="min">Data inicial n\xE3o pode ser menor que a final</div>\n<div ng-message="api_erro">{{historyForm.data_inicial.$api.error.message}}</div></div></md-input-container></div><div \nlayout-gt-xs="row" layout-margin><md-input-container class="datepicker-custom"><span>Data final</span><md-datepicker \nname="data_final" md-max-date="vm.date" ng-model="vm.model.dataFinal" required></md-datepicker><div class="errors" \nng-messages="historyForm.data_final.$error"><div ng-message="max">Data final n\xE3o pode ser maior que a inicial</div><div\n ng-message="api_erro">{{historyForm.data_final.$api.error.message}}</div></div></md-input-container></div><div \nclass="ws-100"><md-button class="btn btn-tertiary" \nng-disabled="vm.models.propriedades_cliente.length == 0 || vm.model.id == null" \nng-disabled="vm.model.dataInicial.erros || vm.model.dataFinal == null" ng-click="vm.getHistory(vm.model)">Buscar\n</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a></div></div></md-card></fieldset>\n</form></div><div class="result-historico" ng-if="vm.modelResponse.propriedade_nome || vm.modelResponse.area_nome"><hr>\n<div class="content-buttons"><h2>Resultado da pesquisa</h2><a class="btn btn-quaternary" \nng-click="vm.getExcelFile(vm.model)"><i class="far fa-file-excel"></i>Gerar arquivo Excel</a></div><div \nclass="paginator" \nng-show="\n                vm.modelResponse.plantios.length == 0 &&\n                vm.modelResponse.colheitas.length == 0 &&\n                vm.modelResponse.insumos_biologicos.length == 0 &&\n                vm.modelResponse.insumos_defensivos.length == 0 &&\n                vm.modelResponse.insumos_fertilizantes.length == 0\n                ">\n<i class="far fa-file-alt"></i><p>Nenhum registro encontrado.</p></div><div><div class="ms-responsive-table-wrapper">\n<div id="plantio" class="entity_division" ng-if="vm.modelResponse.plantios.length > 0"><div class="row-title-result">\n<div class="title"><h2>Plantio</h2></div><div class="area">\xC1rea: <strong>{{vm.modelResponse.area_nome}}</strong></div>\n</div><div class="format-table" layout="column" layout-gt-xs="row" layout-margin><table class="epochal-area plantio">\n<thead><tr><th class="w-20">Data</th><th class="w-20">Cultura</th><th class="w-20">Variedade</th><th class="w-20">\nQuantidade</th><th class="w-20">Unidade de medida</th><th class="w-20">Tipo</th></tr></thead><tr \nng-repeat="plantio in vm.modelResponse.plantios"><td class="w-20">{{plantio.data | date:\'dd/MM/yyyy\'}}</td><td \nclass="w-20">{{plantio.cultura}}</td><td class="w-20">{{plantio.variedade}}</td><td class="w-20">\n{{plantio.quantidade | finance:false:3 }}</td><td class="w-20">{{plantio.unidade_medida}}</td><td class="w-20">\n{{plantio.tipo_plantio}}</td></tr></table></div></div><div id="insumo-biologico" class="entity_division" \nng-if="vm.modelResponse.insumos_biologicos.length > 0"><div class="row-title-result"><div class="title"><h2>\nAplica\xE7\xE3o de insumos biol\xF3gicos</h2></div><div class="area">\xC1rea: <strong>{{vm.modelResponse.area_nome}}</strong></div>\n</div><div class="format-table" layout="column" layout-gt-xs="row" layout-margin><table class="epochal-area insumo">\n<thead><tr><th class="w-25">Data</th><th class="w-25">Produto</th><th class="w-30">Quantidade</th><th class="w-10">\nValor</th><th class="w-25">Condi\xE7\xE3o Clim\xE1tica</th><th class="w-25">Equipamento</th><th class="w-30">Operador</th><th \nclass="w-20">Reentrada(dias)</th></tr></thead><tr \nng-repeat="insumos_biologicos in vm.modelResponse.insumos_biologicos"><td class="w-25">\n{{insumos_biologicos.data | date:\'dd/MM/yyyy\'}}</td><td class="w-25">{{insumos_biologicos.produto_nome}}</td><td \nclass="w-30">{{insumos_biologicos.quantidade | finance:false:3 }} {{insumos_biologicos.unidade_medida}}</td><td \nclass="w-10">{{insumos_biologicos.valor | currency }}</td><td class="w-25">{{insumos_biologicos.condicao_climatica}}\n</td><td class="w-25">{{insumos_biologicos.equipamento}}</td><td class="w-25">{{insumos_biologicos.operador}}</td><td \nclass="w-25">{{insumos_biologicos.reentrada}}</td></tr></table></div></div><div id="insumo-defensivos" \nclass="entity_division" ng-if="vm.modelResponse.insumos_defensivos.length > 0"><div class="row-title-result"><div \nclass="title"><h2 class="head-entities">Aplica\xE7\xE3o de insumos defensivos</h2></div><div class="area">\xC1rea: <strong>\n{{vm.modelResponse.area_nome}}</strong></div></div><div class="format-table" layout="column" layout-gt-xs="row" \nlayout-margin><table class="epochal-area insumo"><thead><tr><th class="w-25">Data</th><th class="w-25">Produto</th><th \nclass="w-30">Quantidade</th><th class="w-10">Valor</th><th class="w-25">Condi\xE7\xE3o Clim\xE1tica</th><th class="w-25">\nEquipamento</th><th class="w-30">Operador</th><th class="w-20">Reentrada(dias)</th></tr></thead><tr \nng-repeat="insumos_defensivos in vm.modelResponse.insumos_defensivos"><td class="w-25">\n{{insumos_defensivos.data | date:\'dd/MM/yyyy\'}}</td><td class="w-25">{{insumos_defensivos.produto_nome}}</td><td \nclass="w-30">{{insumos_defensivos.quantidade | finance:false:3 }} {{insumos_defensivos.unidade_medida}}</td><td \nclass="w-10">{{insumos_defensivos.valor | currency }}</td><td class="w-25">{{insumos_defensivos.condicao_climatica}}\n</td><td class="w-25">{{insumos_defensivos.equipamento}}</td><td class="w-25">{{insumos_defensivos.operador}}</td><td \nclass="w-25">{{insumos_defensivos.reentrada}}</td></tr></table></div></div><div id="insumo-fertilizantes" \nclass="entity_division" ng-if="vm.modelResponse.insumos_fertilizantes.length > 0"><div class="row-title-result"><div \nclass="title"><h2 class="head-entities">Aplica\xE7\xE3o de insumos fertilizantes</h2></div><div class="area">\xC1rea: <strong>\n{{vm.modelResponse.area_nome}}</strong></div></div><div class="format-table" layout="column" layout-gt-xs="row" \nlayout-margin><table class="epochal-area insumo"><thead><tr><th class="w-25">Data</th><th class="w-25">Produto</th><th \nclass="w-30">Quantidade</th><th class="w-20">Valor</th><th class="w-25">Condi\xE7\xE3o Clim\xE1tica</th><th class="w-25">\nEquipamento</th><th class="w-30">Operador</th><th class="w-20">Reentrada(dias)</th></tr></thead><tr \nng-repeat="insumos_fertilizantes in vm.modelResponse.insumos_fertilizantes"><td class="w-25">\n{{insumos_fertilizantes.data | date:\'dd/MM/yyyy\'}}</td><td class="w-25">{{insumos_fertilizantes.produto_nome}}</td><td \nclass="w-30">{{insumos_fertilizantes.quantidade | finance:false:3 }} {{insumos_fertilizantes.unidade_medida}}</td><td \nclass="w-10">{{insumos_fertilizantes.valor | currency }}</td><td class="w-25">\n{{insumos_fertilizantes.condicao_climatica}}</td><td class="w-25">{{insumos_fertilizantes.equipamento}}</td><td \nclass="w-25">{{insumos_fertilizantes.operador}}</td><td class="w-25">{{insumos_fertilizantes.reentrada}}</td></tr>\n</table></div></div><div id="colheitas" class="entity_division" ng-if="vm.modelResponse.colheitas.length > 0"><div \nclass="row-title-result"><div class="title"><h2 class="head-entities">Colheita</h2></div><div class="area">\xC1rea: \n<strong>{{vm.modelResponse.area_nome}}</strong></div></div><div class="format-table" layout="column" \nlayout-gt-xs="row" layout-margin><table class="epochal-area colheita"><thead><tr><th class="w-40">Data</th><th \nclass="w-40">Quantidade</th><th class="w-20">Unidade de medida</th></tr></thead><tr \nng-repeat="colheitas in vm.modelResponse.colheitas"><td class="w-40">{{colheitas.data | date:\'dd/MM/yyyy\'}}</td><td \nclass="w-40">{{colheitas.quantidade | finance:false:3 }}</td><td class="w-20">{{colheitas.unidade_medida}}</td></tr>\n</table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/main/registro/area/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/vgC_nAoZmZY?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/area/views/visualizar.html','<div class="container-header"><div class="breadcrumb"><h1>\xC1reas > Visualizar: {{vm.models.nome}}</h1></div></div><div \nid="forms" class="page-layout simple fullwidth doc-page visualizar-area" layout="column"><div class="content" \nlayout="column"><div class="container-content-custom"><div class="content-register"><div class="content-buttons"><div \nclass="container-title-step"><h3><span><img src="../assets/images/svg/custos/ico-propriedade.svg"></span>DADOS DA \xC1REA\n</h3></div><md-button ng-click="vm.gotoEditar(vm.models.id)" class="btn btn-primary btn-lg">Editar \xE1rea</md-button>\n</div><div layout="column" layout-gt-xs="row"><md-card class="dados-top" flex><div layout="column" layout-gt-xs="row" \nlayout-margin><div class="group" flex><span>Nome</span> <strong>{{ vm.models.nome }}</strong></div><div class="group" \nflex><span>\xC1rea produtiva (hectares)</span> <strong>{{ vm.models.area_produtiva | number:4 }} ha</strong></div><div \nclass="group" flex><span>Cultura/variedade</span> <strong>{{ vm.models.cultura.nome }} {{ vm.models.variedade }}\n</strong></div></div></md-card><md-card flex="30"><div class="form-search-horizontal"><div class="container"><div \nclass="row"><div class="periodo"><div class="row-periodo"><div class="select-content"><md-input-container \nclass="form-group select-custom" flex><label class="form-label">Per\xEDodo</label><select \nclass="form-select select-periodo" name="periodo" ng-model="vm.args.periodo" ng-change="vm.topSelectedPeriodo()" \nng-class="vm.args.periodo?\'select-active\':null"><option value="" disabled="disabled">Selecione</option><option \nng-value="period.value" ng-repeat="period in vm.periods">{{period.description}}</option></select></md-input-container>\n</div><div class="date-picker" id="dataspicker" ng-class="!vm.args.periodo?\'dates-active\':null"><a \nng-click="vm.topOpenDatasSelect();"><img src="../../../../../assets/icons/ico-calendario.svg"></a><div \nclass="date-picker-box"><div layout="column" layout-gt-xs="column" layout-margin><div class="align-datepicker">\n<md-input-container class="datepicker-custom" flex="40"><label>Data inicial</label><md-datepicker name="data_inicio" \nng-model="vm.args.data_inicio" md-max-date="vm.args.data_final" md-placeholder="Inserir data" md-open-on-focus>\n</md-datepicker></md-input-container><md-input-container class="datepicker-custom" flex="40"><label>Data final</label>\n<md-datepicker name="data_fim" ng-model="vm.args.data_final" ng-disabled="vm.args.data_inicio == null" \nmd-min-date="vm.args.data_inicio" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container>\n</div><div class="butons"><button class="btn btn-cancel" ng-click="vm.closedDatasSelect()">Cancelar</button> <button \nclass="btn btn-submit" ng-click="vm.topSelecionarDatas();" ng-disabled="vm.args.data_final == null">Selecionar</button>\n</div></div></div></div></div></div></div></div></div></md-card></div><md-progress-linear ng-if="vm.args.loading" \nmd-mode="indeterminate"></md-progress-linear><div class="indices-1"><div class="container"><div class="row"><div \nclass="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/dash-areas/ico-aplicacao-de-insumos.svg"><h3>PLANTIO</h3></div><div class="total">\n<span class="number">{{ vm.models.indicadores.plantio }}</span><br><span class="nome">TOTAL \xC1REAS</span></div><div \nclass="footer"><a href="#" ng-click="vm.gotoPlantio()"><md-icon md-font-icon="icon-plus-circle"></md-icon>Ver hist\xF3rico\n</a></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/dash-areas/ico-sementes.svg"><h3><span>INSUMOS</span><br>SEMENTES</h3></div><div \nclass="total"><span class="number">{{ vm.models.indicadores.insumos_semente | number:3 }}</span><br><span class="nome">\nTOTAL KG</span></div><div class="footer"><a href="#" ng-click="vm.gotoSementes()"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Ver hist\xF3rico</a></div></div></div><div class="col"><div class="box-2"><div \nclass="ico"><img src="../../../../../assets/icons/ico-insumo-biologico.svg"><h3><span>INSUMOS</span><br>BIOL\xD3GICOS</h3>\n</div><div class="total"><span class="number">{{ vm.models.indicadores.insumos_biologico }}</span><br><span \nclass="nome">TOTAL APLICA\xC7\xD5ES</span></div><div class="custo"><hr><h4><span><i class="fa fa-dollar-sign"></i></span>\n CUSTO DA APLICA\xC7\xC3O</h4><span class="number">R$ {{ vm.models.indicadores.biologico_custo_aplicacao | finance:false:2 }}\n</span></div><div class="footer"><a href="#" ng-click="vm.gotoBiologico()"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Ver hist\xF3rico</a></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/ico-insumo-defensivo.svg"><h3><span>INSUMOS</span><br>DEFENSIVOS</h3></div><div \nclass="total"><span class="number">{{ vm.models.indicadores.insumos_defensivo }}</span><br><span class="nome">\nTOTAL APLICA\xC7\xD5ES</span></div><div class="custo"><hr><h4><span><i class="fa fa-dollar-sign"></i></span>\n CUSTO DA APLICA\xC7\xC3O</h4><span class="number">R$ {{ vm.models.indicadores.defensivo_custo_aplicacao | finance:false:2 }}\n</span></div><div class="footer"><a href="#" ng-click="vm.gotoDefensivo()"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Ver hist\xF3rico</a></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/ico-insumo-fertilizante.svg"><h3><span>INSUMOS</span><br>FERTILIZANTES</h3></div><div \nclass="total"><span class="number">{{ vm.models.indicadores.insumos_fertilizante }}</span><br><span class="nome">\nTOTAL APLICA\xC7\xD5ES</span></div><div class="custo"><hr><h4><span><i class="fa fa-dollar-sign"></i></span>\n CUSTO DA APLICA\xC7\xC3O</h4><span class="number">\nR$ {{ vm.models.indicadores.fertilizante_custo_aplicacao | finance:false:2 }}</span></div><div class="footer"><a \nhref="#" ng-click="vm.gotoFertilizante()"><md-icon md-font-icon="icon-plus-circle"></md-icon>Ver hist\xF3rico</a></div>\n</div></div></div><div class="row"><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/ico-colheita.svg"><h3>COLHEITA</h3></div><div class="total"><span class="number-2">\n{{ vm.models.indicadores.colheita | number:3 }}</span><br><span class="nome">TOTAL KG</span></div><div class="footer">\n<a href="#" ng-click="vm.gotoColheita()"><md-icon md-font-icon="icon-plus-circle"></md-icon>Ver hist\xF3rico</a></div>\n</div></div><div class="col"><div class="box-2"><div class="ico"><img src="../../../../../assets/icons/ico-manejo.svg">\n<h3>CUSTOS MANEJOS</h3></div><div class="total"><span class="number-2">{{ vm.models.indicadores.custo_manejo_total }}\n</span><br><span class="nome">TOTAL</span></div><div class="custo"><hr><h4><span><i class="fa fa-dollar-sign"></i>\n</span> CUSTO</h4><span class="number">R$ {{ vm.models.indicadores.custo_manejo_custo | finance:false:2 }}</span></div>\n<div class="footer"><a href="#" ng-click="vm.gotoCustos()"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nVer hist\xF3rico</a></div></div></div><div class="col"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/ico-lotes.svg"><h3>LOTES PRODUZIDOS</h3></div><div class="total"><img \nsrc="../../../../../assets/icons/dash-areas/ico-peso-produzido.svg"><h4>PESO</h4><span class="number-2">\n{{ vm.models.indicadores.lotes_produzidos_peso | number:3 }}</span><br><span class="nome">KG</span></div><div \nclass="footer"><a href="#" ng-click="vm.gotoLotesProduzidos()"><md-icon md-font-icon="icon-plus-circle"></md-icon>\nVer hist\xF3rico</a></div></div></div><div class="col area"><div class="box-2"><div class="ico"><img \nsrc="../../../../../assets/icons/ico-areas.svg"><h3>\xC1REA</h3></div><div class="total"><h4><span><i \nclass="fa fa-dollar-sign"></i></span> CUSTO TOTAL</h4><span class="number-2">\nR$ {{ vm.models.indicadores.area_custo_total | finance:false:2 }}</span></div><div><br></div></div></div></div></div>\n</div></div></div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-1/template-1.html','<div class="template-1"><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="content pv-24 ph-16"><div class="title h1" \nng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">{{card.subtitle}}\n</div><div class="text pt-16" ng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-10/template-10.html','<div class="template-10 p-16"><div class="pb-16" layout="row" layout-align="space-between center"><div class="info">\n<div class="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="subtitle h2" \nng-if="card.subtitle">{{card.subtitle}}</div></div><div class="media ml-16"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div><div \nclass="text">{{card.text}}</div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-2/template-2.html','<div class="template-2"><div class="header p-16" layout="row" layout-align="start center"><div ng-if="card.avatar"><img\n class="avatar mr-16" ng-src="{{card.avatar.src}}" alt="{{card.avatar.alt}}"></div><div class="info"><div \nclass="title" ng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div></div></div><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="text p-16" ng-if="card.text">{{card.text}}\n</div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-4/template-4.html','<div class="template-4"><div class="info white-fg ph-16 pv-24"><div class="title h1" ng-if="card.title">{{card.title}}\n</div><div class="text" ng-if="card.text">{{card.text}}</div></div><div class="media"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-5/template-5.html','<div class="template-5 p-16" layout="row" layout-align="space-between start"><div class="info"><div \nclass="title secondary-text" ng-if="card.title">{{card.title}}</div><div class="event h2" ng-if="card.event">\n{{card.event}}</div></div><div class="media ml-16"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-3/template-3.html','<div class="template-3 p-16 teal-bg white-fg" layout="row" layout-align="space-between"><div layout="column" \nlayout-align="space-between"><div class="info"><div class="title h1" ng-if="card.title">{{card.title}}</div><div \nclass="subtitle h3 secondary-text" ng-if="card.subtitle">{{card.subtitle}}</div></div><div class="cta"><md-button \nclass="m-0">{{card.cta}}</md-button></div></div><div class="media pl-16"><img class="image" \nng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" ng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-6/template-6.html','<div class="template-6"><div class="content pv-24 ph-16"><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div><div class="title h2" ng-if="card.title">{{card.title}}</div><div class="text pt-8" \nng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-7/template-7.html','<div class="template-7" layout="row" layout-align="space-between"><div class="info" layout="column" \nlayout-align="space-between" layout-fill flex><div class="p-16"><div class="title h1" ng-if="card.title">{{card.title}}\n</div><div class="subtitle h4 secondary-text" ng-if="card.subtitle">{{card.subtitle}}</div><div class="text h4 pt-8" \nng-if="card.text">{{card.text}}</div></div><div><md-divider></md-divider><div class="p-8" layout="row"><md-icon \nmd-font-icon="icon-star-outline" class="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5">\n</md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" \nclass="mh-5"></md-icon><md-icon md-font-icon="icon-star-outline" class="mh-5"></md-icon></div></div></div><div \nclass="media"><img class="image" ng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" \nng-show="card.media.image"></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-8/template-8.html','<div class="template-8"><div class="media"><img class="image" ng-src="{{card.media.image.src}}" \nalt="{{card.media.image.alt}}" ng-show="card.media.image"></div><div class="content pv-24 ph-16"><div class="title h1" \nng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">{{card.subtitle}}\n</div><div class="buttons pt-16"><md-button class="m-0">{{card.button1}}</md-button><md-button class="m-0 md-accent">\n{{card.button2}}</md-button></div><div class="text pt-16" ng-if="card.text">{{card.text}}</div></div></div>');
$templateCache.put('app/core/directives/ms-card/templates/template-9/template-9.html','<div class="template-9"><div class="header p-16" layout="row" layout-align="start center"><div ng-if="card.avatar"><img\n class="avatar mr-16" ng-src="{{card.avatar.src}}" alt="{{card.avatar.alt}}"></div><div class="info"><div \nclass="title" ng-if="card.title">{{card.title}}</div><div class="subtitle secondary-text" ng-if="card.subtitle">\n{{card.subtitle}}</div></div></div><div class="text ph-16 pb-16" ng-if="card.text">{{card.text}}</div><div \nclass="media"><img class="image" ng-src="{{card.media.image.src}}" alt="{{card.media.image.alt}}" \nng-show="card.media.image"></div><div class="buttons m-8"><md-button class="md-icon-button mr-16" \naria-label="Favorite"><md-icon md-font-icon="icon-heart-outline" class="s24"></md-icon></md-button><md-button \nclass="md-icon-button" aria-label="Share"><md-icon md-font-icon="icon-share" class="s24"></md-icon></md-button></div>\n</div>');
$templateCache.put('app/core/directives/ms-stepper/templates/horizontal/horizontal.html','<div class="ms-stepper-horizontal"><div class="ms-stepper-navigation-wrapper"><div class="ms-stepper-navigation" \nlayout="row" layout-align="center center"><md-button class="ms-stepper-navigation-item" \nng-class="{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}" \nng-click="MsStepper.gotoStep(step.stepNumber)" ng-disabled="MsStepper.isStepDisabled(step.stepNumber)" \nng-repeat="step in MsStepper.steps | filter:MsStepper.filterHiddenStep" layout="row" layout-align="start center"><div \nclass="step md-accent-bg" layout="row" layout-align="center center"><span \nng-if="!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)">{{$index + 1}} </span>\n<span ng-if="MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)"><i \nclass="icon icon-check s18"></i></span></div><div layout="column" layout-align="start start"><div class="title" \ntranslate="{{step.stepTitleTranslate}}">{{step.stepTitle}}</div><div class="subtitle" \nng-if="MsStepper.isStepOptional(step.stepNumber)">Optional</div></div></md-button></div></div><div \nclass="ms-stepper-steps" ng-transclude></div><div class="ms-stepper-controls" layout="row" \nlayout-align="center center"><md-button class="md-accent md-raised" ng-disabled="MsStepper.isFirstStep()" \nng-click="MsStepper.gotoPreviousStep()">Back</md-button><div class="ms-stepper-dots"><span \nng-repeat="step in MsStepper.steps" ng-hide="MsStepper.isStepHidden(step.stepNumber)" \nng-class="{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}"></span></div><md-button \nclass="md-accent md-raised" ng-if="!MsStepper.isLastStep()" \nng-disabled="!MsStepper.isStepValid(MsStepper.currentStepNumber)" ng-click="MsStepper.gotoNextStep()">Next</md-button>\n<md-button type="submit" class="md-accent md-raised" ng-click="MsStepper.resetForm()" ng-if="MsStepper.isLastStep()" \nng-disabled="!MsStepper.isFormValid()">Submit</md-button></div></div>');
$templateCache.put('app/core/directives/ms-stepper/templates/vertical/vertical.html','<div class="ms-stepper-vertical"><div class="ms-stepper-vertical-line"></div><div class="ms-stepper-steps" \nng-transclude></div></div>');
$templateCache.put('app/main/registro/insumo/biologico/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\nManejos > Aplica\xE7\xE3o de insumos > Biol\xF3gicos</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div><md-button\n class="btn btn-primary" translate="BIOLOGICO.ADD_BIOLOGICO" \nng-click="vm.gotoAdd(vm.clientePerfil.is_estoque_automatico)" ng-disabled="vm.propriedades.length == 0">\nAdicionar biol\xF3gico</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="form-search-horizontal"><div \nclass="form-search"><form><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col"><md-input-container \nclass="select-custom" flex><label>\xC1rea em aberto</label><select class="md-block" name="area" \nng-model="vm.args.propriedade_area_id"><option value="" selected="selected" disabled="disabled">Selecione</option>\n<option ng-repeat="area in vm.filtros.areas" ng-value="area.area_nome">{{area.area_nome}}</option></select>\n</md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>Insumo</label><select\n class="md-block" name="insumo" ng-model="vm.args.insumo_agricola"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-repeat="insumo in vm.filtros.insumos" \nplaceholder="Selecione a insumo" ng-value="insumo.insumo_nome">{{insumo.insumo_nome}}</option></select>\n</md-input-container></div><div class="col"><md-input-container class="select-custom datepicker-custom"><label>\nData da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="vm.args.data_aplicacao" md-max-date="vm.date" \nng-change="$mdMenu.open()" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom insumo-biologico"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID" flex="50"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="caderno_campo_propriedade_area_nome" lm-title="Nome da \xE1rea" \nflex="50"></th><th class="secondary-text pagination-custom" lm-sort-header="insumo_agricola_nome" lm-title="Insumo">\n</th><th class="secondary-text pagination-custom" lm-sort-header="data_aplicacao" lm-title="Data da aplica\xE7\xE3o"></th><th\n class="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quantidade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="BIOLOGICO.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td>\n{{model.id}}</td><td>{{model.area}}</td><td>{{model.insumo_agricola_nome}}</td><td>\n{{model.data_aplicacao | date:\'dd/MM/yyyy\'}}</td><td>{{model.quantidade | finance:false:3 }} {{model.unidade_medida}}\n</td><td>R$ {{ model.valor | finance:false:2 }}</td><td ng-if="model.valor == null">-</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/insumo/biologico/views/criar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Biol\xF3gicos > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nSelecione os insumos para aplica\xE7\xE3o,<br>escolha as \xE1reas e fa\xE7a o registro clim\xE1tico.</h2></div><div \napi-form-validation-summary form="insumoForm"></div><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-aplicacoes.svg"></span>Aplica\xE7\xF5es</h3></div><md-card \nng-repeat="add_produtos in vm.model.produtos"><div class="display-flex-custom"><h3>Aplica\xE7\xE3o {{ $index + 1 }}</h3>\n<md-button class="icon-btn md-icon-button" ng-if="vm.model.produtos.length > 1" ng-click="vm.removeProducts($index)">\n<div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir\n</md-tooltip></i></div></md-button></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom" flex="30"><label>Data da aplica\xE7\xE3o</label><md-datepicker id="inptDt" class="md-block" \nname="data_aplicacao" ng-model="add_produtos.data_aplicacao" md-max-date="vm.date" aria-label="data aplica\xE7\xE3o" \nmd-placeholder="Inserir data" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="insumoForm.data_aplicacao.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="70" md-delay="500"><label translate="BIOLOGICO.PRODUTO">Produto</label>\n<md-select id="slctPrdt" class="md-block" ng-model="add_produtos.insumo_estoque" \nng-change="vm.changeProduto(add_produtos)" name="insumo_agricola_nome" placeholder="Selecione o produto" required \naria-label="produto"><md-option ng-repeat="insumo_produto in vm.productStock" ng-value="insumo_produto">\n{{insumo_produto.insumo_nome}}</md-option></md-select><div ng-messages="insumoForm.produto.$error" \nng-if="insumoForm.produto.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="30"><label>Total em estoque</label><input \nid="total_estoque" name="total_estoque" type="text" \nvalue="{{ add_produtos.insumo_estoque.quantidade | number:3 }} {{add_produtos.insumo_estoque.tipo_medida_descricao}}" \ndisabled="disabled"></md-input-container><md-input-container class="select-custom" flex="30"><md-button \nclass="btn btn-quaternary" ng-disabled="!add_produtos.insumo_estoque" ng-click="vm.openModalEstoque(add_produtos)">\n<md-icon md-font-icon="icon-plus-circle"></md-icon>Visualizar estoque</md-button></md-input-container>\n<md-input-container flex="40"><label translate="BIOLOGICO.AMOUNT">Quantidade do produto</label><input id="inptQntdd" \nname="quantidade" type="text" ng-model="add_produtos.quantidade" aria-label="quantidade" \nng-disabled="!add_produtos.insumo_estoque" ng-change="vm.changeQuantidade(add_produtos)" required ui-number-mask="3" \nmin="0.001" max="99999.999" maxlength="10" placeholder="Insira a quantidade"> <span class="unidade_medida_input">\n{{add_produtos.insumo_estoque.tipo_medida_descricao}}</span><div class="errors" \nng-messages="insumoForm.quantidade.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999999.999 | finance:false:3}}</div></div></md-input-container></div></md-card><md-card \nclass="add-card"><a id="btnAdc" class="btn btn-quaternary" ng-click="vm.addProducts()" \nng-hide="vm.model.produtos.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Aplicar mais insumos</a>\n</md-card><div class="container-title-step"><h3><span><img src="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div>\n<md-card><area-selector ng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="BIOLOGICO.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="BIOLOGICO.EQUIPAMENTO">Equipamento</label><input id="inptEqpmt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="BIOLOGICO.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label>\nReentrada<small>(dias)</small></label><input id="inptRntrd" name="reentrada" type="text" ng-model="vm.model.reentrada" \nmaxlength="3" placeholder="Insira a reentrada" ui-number-mask="0" min="0" max="999"><div class="errors" \nng-messages="insumoForm.reentrada.$error"><div ng-message="required">Campo Obrigat\xF3rio</div></div></md-input-container>\n</div></md-card><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset \nng-if="vm.step == 2"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num">1\n</span> <span class="num last active">2</span></div><h2>Veja a quantidade de insumos aplicadas<br>\npor area selecionada e confirme.</h2></div><div api-form-validation-summary form="insumoForm"></div><div \nng-repeat="area_consolidada in vm.areas_consolidadas"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>{{ area_consolidada.area.nome }} <small>\n- {{ area_consolidada.area.area_produtiva }}ha - {{ area_consolidada.area.cultura_nome }} {{ area_consolidada.area.variedade_nome }}\n</small></h3></div><div ng-repeat="produtos_por_tipo_medida in area_consolidada.produtos"><table row-border lm-sort \nhover id="responsive" class="simple table-custom insumo-biologico-consolidacao-area" \nng-if="produtos_por_tipo_medida.produtos.length > 0"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Insumo</span></div></th><th></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Quant. / Unid.\n</span></div></th></tr></thead><tbody><tr ng-repeat="produto in produtos_por_tipo_medida.produtos"><td \nclass="td-insumo_agricola_nome">{{produto.produto.insumo_agricola_nome}}</td><td class="empty-space"></td><td>\n{{ produto.quantidade | finance:false:3 }} {{ produto.produto.insumo_estoque.tipo_medida_descricao }}</td></tr></tbody>\n</table></div><br></div><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.save(insumoForm)" aria-label="Confirmar aplica\xE7\xE3o">Confirmar aplica\xE7\xE3o</md-button></div></fieldset></form>\n</div></div></div>');
$templateCache.put('app/main/registro/insumo/biologico/views/criar_sem_estoque.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Biol\xF3gico > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nSelecione os insumos para aplica\xE7\xE3o,<br>escolha as \xE1reas e fa\xE7a o registro clim\xE1tico.</h2></div><div \napi-form-validation-summary form="insumoForm"></div><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-aplicacoes.svg"></span>Aplica\xE7\xF5es</h3></div><md-card \nng-repeat="add_produtos in vm.model.produtos"><div class="display-flex-custom"><h3>Aplica\xE7\xE3o {{ $index + 1 }}</h3>\n<md-button class="icon-btn md-icon-button" ng-if="vm.model.produtos.length > 1" ng-click="vm.removeProducts($index)">\n<div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir\n</md-tooltip></i></div></md-button></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom" flex="30"><label>Data da aplica\xE7\xE3o</label><md-datepicker class="md-block" \nname="data_aplicacao" ng-model="add_produtos.data_aplicacao" md-max-date="vm.date" md-placeholder="Inserir data" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="insumoForm.data_aplicacao.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex="70" md-delay="500"><label translate="DEFENSIVO.PRODUTO">Produto</label><md-select \nid="slctPrdt" class="md-block" ng-model="add_produtos.insumo_estoque" ng-change="vm.changeProduto(add_produtos)" \nname="insumo_agricola_nome" placeholder="Selecione o produto" required><md-option \nng-repeat="insumo_produto in vm.productStock" ng-value="insumo_produto">{{insumo_produto.nome}}</md-option></md-select>\n<div ng-messages="insumoForm.produto.$error" ng-if="insumoForm.produto.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.produto.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="DEFENSIVO.AMOUNT">Quantidade</label><input id="inptQntdd" name="quantidade" type="text" \nng-model="add_produtos.quantidade" ng-disabled="!add_produtos.insumo_estoque" ui-number-mask="3" min="0.001" required \nmax="99999.999" maxlength="10" placeholder="Insira a quantidade"> <span class="unidade_medida_input">\n{{add_produtos.insumo_estoque.tipo_medida.descricao}}</span><div class="errors" \nng-messages="insumoForm.quantidade.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999.999 | finance:false:3}}</div></div></md-input-container><md-input-container flex><label \ntranslate="DEFENSIVO.VALOR">Valor</label><input id="inptVlr" name="valor" type="text" ng-model="add_produtos.valor" \nui-money-mask="2" ng-disabled="!add_produtos.insumo_estoque" maxlength="15" placeholder="Insira o valor"><div \nclass="errors" ng-messages="insumoForm.valor.$error"><div ng-message="maxlength">Deve ser inferior a \'9.999.999,99\'.\n</div><div ng-message="api_erro">{{insumoForm.valor.$api.error.message}}</div></div></md-input-container></div>\n</md-card><md-card class="add-card"><a id="btnAdc" class="btn btn-quaternary" ng-click="vm.addProducts()" \nng-hide="vm.model.produtos.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Aplicar mais insumos</a>\n</md-card><div class="container-title-step"><h3><span><img src="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div>\n<md-card><area-selector ng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="DEFENSIVO.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="DEFENSIVO.EQUIPAMENTO">Equipamento</label><input id="inptEqpmnt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="DEFENSIVO.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="DEFENSIVO.REENTRADA">Reentrada</label><input id="inptRntrd" name="reentrada" type="text" \nng-model="vm.model.reentrada" maxlength="3" placeholder="Insira a reentrada"><div class="errors" \nng-messages="insumoForm.reentrada.$error"><div ng-message="required">Campo Obrigat\xF3rio</div></div></md-input-container>\n</div></md-card><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset \nng-if="vm.step == 2"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num">1\n</span> <span class="num last active">2</span></div><h2>Veja a quantidade de insumos aplicadas<br>\npor area selecionada e confirme.</h2></div><div api-form-validation-summary form="insumoForm"></div><div \nng-repeat="area_consolidada in vm.areas_consolidadas"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>{{ area_consolidada.area.nome }} <small>\n- {{ area_consolidada.area.area_produtiva }}ha - {{ area_consolidada.area.cultura_nome }} {{ area_consolidada.area.variedade_nome }}\n</small></h3></div><div ng-repeat="produtos_por_tipo_medida in area_consolidada.produtos"><table row-border lm-sort \nhover id="responsive" class="simple table-custom insumo-defensivo-consolidacao-area" \nng-if="produtos_por_tipo_medida.produtos.length > 0"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Insumo</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Quantidade</span>\n</div></th><th class="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nValor</span></div></th></tr></thead><tbody><tr ng-repeat="produto in produtos_por_tipo_medida.produtos"><td \nclass="td-insumo_agricola_nome">{{produto.produto.insumo_agricola_nome}}</td><td class="td-insumo_agricola_nome">\n{{ produto.quantidade | number:3 }} {{ produto.produto.insumo_estoque.tipo_medida.descricao }}</td><td \nclass="td-insumo_agricola_nome">{{ produto.valor | finance:true:2 }}</td></tr></tbody></table></div><br></div><div \nclass="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" \nng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.save(insumoForm)" aria-label="Confirmar aplica\xE7\xE3o">Confirmar aplica\xE7\xE3o</md-button></div></fieldset></form>\n</div></div></div>');
$templateCache.put('app/main/registro/insumo/biologico/views/modal_estoque.html','<md-dialog><div class="header-modal"><div class="desc">Visualiza\xE7\xE3o de estoque</div><div class="close" \nng-click="hide()">X</div></div><div class="content"><table class="table-estoque-isumos"><tbody><tr><td>\nNome produto estoque</td></tr><tr><td><strong>{{ dataModal.rateioProductStock[0].insumo_nome }}</strong></td></tr>\n</tbody></table><br><br><table class="table-culturas"><md-progress-linear ng-if="loading" md-mode="indeterminate">\n</md-progress-linear><thead><tr><th>Fornecedor</th><th>Data compra</th><th>Quantidade</th></tr></thead><tbody><tr \nng-repeat="item in dataModal.rateioProductStock"><td>{{ item.loja_fornecedor }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\' }}</td><td>{{ item.quantidade | number:3 }} {{ item.tipo_medida_descricao }}\n</td></tr></tbody></table></div></md-dialog>');
$templateCache.put('app/main/registro/insumo/biologico/views/sucesso.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Biol\xF3gicos > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/images/svg/ico-aplicacao-de-insumos-sucesso.svg" alt="sucesso"><h2>\nAplica\xE7\xE3o de insumos realizada com sucesso!</h2><span>-------------------------------------------------------</span><p>\nO que voc\xEA gostaria de fazer agora?</p><div class="content-buttons-sucesso"><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-click="vm.gotoAplicarInsumoBiologico()">Aplicar insumo biol\xF3gico</md-button>\n<md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoList()">Ver lista de aplica\xE7\xF5es</md-button>\n<md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoHistorico()">Ver hist\xF3rico</md-button>\n<md-button class="btn btn-secondary btn-md" ng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div>\n</div></div>');
$templateCache.put('app/main/registro/insumo/biologico/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/nLu19Vebyeo?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/insumo/biologico/views/visualizar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Biol\xF3gicos > Visualizar</h1><h1 class="d-mobile">Visualizar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>Dados da aplica\xE7\xE3o</h3></div><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="40"><label for="">\xC1rea</label><input type="text" \nname="propriedade_areas" \nvalue="{{ vm.model.area }} - {{ vm.model.area_produtiva | number:4 }} ha - {{ vm.model.cultura }} {{ vm.model.produto_variedade }}">\n</md-input-container><md-input-container flex="15"><label for="">Data registro</label><input type="text" \nvalue="{{ vm.model.data_registro | date:\'dd/MM/yyyy\' }}"></md-input-container></div><hr><br><h3 \ntranslate="BIOLOGICO.DATA_INSUMO">Dados do insumo</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex class="datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker \nname="data_aplicacao" ng-model="vm.model.data_aplicacao" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex><label translate="BIOLOGICO.PRODUTO">Produto</label><input type="text" \nname="insumo_agricola_nome" ng-model="vm.model.insumo_agricola_nome"></md-input-container><md-input-container flex>\n<label translate="BIOLOGICO.AMOUNT">Quantidade do produto</label><input type="text" name="quantidade" \nvalue="{{vm.model.quantidade | finance:false:3}} {{vm.model.unidade_medida}}"></md-input-container><md-input-container \nflex><label translate="BIOLOGICO.VALOR">Valor da aplica\xE7\xE3o</label><input type="text" name="valor" ui-money-mask \nng-model="vm.model.valor"></md-input-container></div></md-card><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="BIOLOGICO.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="BIOLOGICO.EQUIPAMENTO">Equipamento</label><input id="inptEqpmt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="BIOLOGICO.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="BIOLOGICO.REENTRADA">Reentrada</label><input id="inptRntrd" name="reentrada" type="text" \nng-model="vm.model.reentrada" maxlength="3" placeholder="Insira a reentrada" ui-number-mask="0" min="0" max="999"><div \nclass="errors" ng-messages="insumoForm.reentrada.$error"><div ng-message="required">Campo Obrigat\xF3rio</div></div>\n</md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div>');
$templateCache.put('app/main/registro/insumo/defensivo/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\nManejos > Aplica\xE7\xE3o de insumos > Defensivo</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div><md-button\n class="btn btn-primary" translate="DEFENSIVO.ADD" ng-click="vm.gotoAdd(vm.clientePerfil.is_estoque_automatico)" \nng-disabled="vm.propriedades.length == 0">Aplicar insumo defensivo</md-button></div><div \nclass="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="form-search-horizontal"><div class="form-search"><form><div \nclass="container"><div class="row"><div class="col icon-filters"><img src="../../../../../assets/icons/ico-filtro.svg">\n <span>Filtros</span></div><div class="col"><md-input-container class="select-custom" flex><label>\xC1rea em aberto\n</label><select class="md-block" name="area" ng-model="vm.args.propriedade_area_id"><option value="" \nselected="selected" disabled="disabled">Selecione</option><option ng-repeat="area in vm.filtros.areas" \nng-value="area.area_nome">{{area.area_nome}}</option></select></md-input-container></div><div class="col">\n<md-input-container class="select-custom" flex><label>Insumo</label><select class="md-block" name="insumo" \nng-model="vm.args.insumo_agricola"><option value="" selected="selected" disabled="disabled">Selecione</option><option \nng-repeat="insumo in vm.filtros.insumos" placeholder="Selecione a insumo" ng-value="insumo.insumo_nome">\n{{insumo.insumo_nome}}</option></select></md-input-container></div><div class="col"><md-input-container \nclass="select-custom datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" \nng-model="vm.args.data_aplicacao" md-max-date="vm.date" ng-change="$mdMenu.open()" md-placeholder="Inserir data" \nmd-open-on-focus></md-datepicker></md-input-container></div><div class="col"><div class="content-buttons"><md-button \nclass="btn btn-tertiary btn-md-i" ng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" \nng-click="vm.resetFilters()">Limpar</a></div></div></div></div></form></div></div><div class="filtros-ativos" \nng-if="vm.activeFilters.length > 0"><ul><li class="first"><strong>{{vm.args.total_rows}}</strong>\n resultado(s) para o filtro:</li><li ng-repeat="filter in vm.activeFilters" ng-if="filter.description">\n{{filter.description}} <a href="#" ng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom insumo-defensivo"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID" flex="50"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="caderno_campo_propriedade_area_nome" lm-title="Nome da \xE1rea" \nflex="50"></th><th class="secondary-text pagination-custom" lm-sort-header="insumo_agricola_nome" lm-title="Insumo">\n</th><th class="secondary-text pagination-custom" lm-sort-header="data_aplicacao" lm-title="Data aplica\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quantidade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="DEFENSIVO.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td>\n{{model.id}}</td><td>{{model.area}}</td><td>{{model.insumo_agricola_nome}}</td><td>\n{{model.data_aplicacao | date:\'dd/MM/yyyy\'}}</td><td>{{model.quantidade | finance:false:3 }} {{model.unidade_medida}}\n</td><td>R$ {{ model.valor | finance:false:2 }}</td><td ng-if="model.valor == null">-</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/insumo/defensivo/views/criar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Defensivo > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nSelecione os insumos para aplica\xE7\xE3o,<br>escolha as \xE1reas e fa\xE7a o registro clim\xE1tico.</h2></div><div \napi-form-validation-summary form="insumoForm"></div><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-aplicacoes.svg"></span>Aplica\xE7\xF5es</h3></div><md-card \nng-repeat="add_produtos in vm.model.produtos"><div class="display-flex-custom"><h3>Aplica\xE7\xE3o {{ $index + 1 }}</h3>\n<md-button class="icon-btn md-icon-button" ng-if="vm.model.produtos.length > 1" ng-click="vm.removeProducts($index)">\n<div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir\n</md-tooltip></i></div></md-button></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom" flex="30"><label>Data da aplica\xE7\xE3o</label><md-datepicker class="md-block" \nname="data_aplicacao" ng-model="add_produtos.data_aplicacao" md-max-date="vm.date" md-placeholder="Inserir data" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="insumoForm.data_aplicacao.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex="70" md-delay="500"><label translate="DEFENSIVO.PRODUTO">Produto</label><md-select \nid="slctPrdt" class="md-block" ng-model="add_produtos.insumo_estoque" ng-change="vm.changeProduto(add_produtos)" \nname="insumo_agricola_nome" placeholder="Selecione o produto" required><md-option \nng-repeat="insumo_produto in vm.productStock" ng-value="insumo_produto">{{insumo_produto.insumo_nome}}</md-option>\n</md-select><div ng-messages="insumoForm.produto.$error" ng-if="insumoForm.produto.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.produto.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30">\n<label>Total em estoque</label><input id="total_estoque" name="total_estoque" type="text" \nvalue="{{ add_produtos.insumo_estoque.quantidade | number:3 }} {{ add_produtos.insumo_estoque.tipo_medida_descricao }}" \ndisabled="disabled"></md-input-container><md-input-container class="select-custom"><md-button \nclass="btn btn-quaternary" ng-disabled="!add_produtos.insumo_estoque" ng-click="vm.openModalEstoque(add_produtos)">\n<md-icon md-font-icon="icon-plus-circle"></md-icon>Visualizar estoque</md-button></md-input-container>\n<md-input-container flex="35"><label translate="DEFENSIVO.AMOUNT">Quantidade</label><input id="inptQntdd" \nname="quantidade" type="text" ng-model="add_produtos.quantidade" ng-disabled="!add_produtos.insumo_estoque" required \nng-change="vm.changeQuantidade(add_produtos)" ui-number-mask="3" min="0.001" max="99999.999" maxlength="10" \nplaceholder="Insira a quantidade"> <span class="unidade_medida_input">\n{{add_produtos.insumo_estoque.tipo_medida_descricao}}</span><div class="errors" \nng-messages="insumoForm.quantidade.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999.999 | finance:false:3}}</div></div></md-input-container><md-input-container flex="15">\n<label>Car\xEAncia</label><input id="inptCrnc" type="text" name="carencia" ng-model="add_produtos.carencia" \nng-pattern="/^[0-9]*$/" maxlength="2" ui-number-mask="0" min="0" max="999" placeholder="Insira a car\xEAncia"><div \nclass="errors" ng-messages="insumoForm.carencia.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="pattern">Somente n\xFAmeros</div><div ng-message="max">Carencia deve ser inferior a \'100\'.</div><div \nng-message="api_erro">{{insumoForm.carencia.$api.error.message}}</div></div></md-input-container></div></md-card>\n<md-card class="add-card"><a id="btnAdc" class="btn btn-quaternary" ng-click="vm.addProducts()" \nng-hide="vm.model.produtos.length == 10"><md-icon md-font-icon="icon-plus-circle"></md-icon>Aplicar mais insumos</a>\n</md-card><div class="container-title-step"><h3><span><img src="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div>\n<md-card><area-selector ng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="DEFENSIVO.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="DEFENSIVO.EQUIPAMENTO">Equipamento</label><input id="inptEqpmnt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="DEFENSIVO.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="DEFENSIVO.REENTRADA">Reentrada</label><input id="inptRntrd" name="reentrada" type="text" \nng-model="vm.model.reentrada" maxlength="3" placeholder="Insira a reentrada"><div class="errors" \nng-messages="insumoForm.reentrada.$error"><div ng-message="required">Campo Obrigat\xF3rio</div></div></md-input-container>\n</div></md-card><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset \nng-if="vm.step == 2"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num">1\n</span> <span class="num last active">2</span></div><h2>Veja a quantidade de insumos aplicadas<br>\npor area selecionada e confirme.</h2></div><div api-form-validation-summary form="insumoForm"></div><div \nng-repeat="area_consolidada in vm.areas_consolidadas"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>{{ area_consolidada.area.nome }} <small>\n- {{ area_consolidada.area.area_produtiva }}ha - {{ area_consolidada.area.cultura_nome }} {{ area_consolidada.area.variedade_nome }}\n</small></h3></div><div ng-repeat="produtos_por_tipo_medida in area_consolidada.produtos"><table row-border lm-sort \nhover id="responsive" class="simple table-custom insumo-defensivo-consolidacao-area" \nng-if="produtos_por_tipo_medida.produtos.length > 0"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Insumo</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Car\xEAncia</span>\n</div></th><th class="empty-space"></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Quantidade</span></div></th></tr></thead><tbody><tr \nng-repeat="produto in produtos_por_tipo_medida.produtos"><td class="td-insumo_agricola_nome">\n{{produto.produto.insumo_agricola_nome}}</td><td>{{ produto.produto.carencia }}</td><td class="empty-space"></td><td>\n{{ produto.quantidade | finance:false:3 }} {{ produto.produto.insumo_estoque.tipo_medida_descricao }}</td></tr></tbody>\n</table></div><br></div><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.save(insumoForm)" aria-label="Confirmar aplica\xE7\xE3o">Confirmar aplica\xE7\xE3o</md-button></div></fieldset></form>\n</div></div></div>');
$templateCache.put('app/main/registro/insumo/defensivo/views/criar_sem_estoque.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Defensivo > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nSelecione os insumos para aplica\xE7\xE3o,<br>escolha as \xE1reas e fa\xE7a o registro clim\xE1tico.</h2></div><div \napi-form-validation-summary form="insumoForm"></div><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-aplicacoes.svg"></span>Aplica\xE7\xF5es</h3></div><md-card \nng-repeat="add_produtos in vm.model.produtos"><div class="display-flex-custom"><h3>Aplica\xE7\xE3o {{ $index + 1 }}</h3>\n<md-button class="icon-btn md-icon-button" ng-if="vm.model.produtos.length > 1" ng-click="vm.removeProducts($index)">\n<div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs md-direction="left">Excluir\n</md-tooltip></i></div></md-button></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container \nclass="datepicker-custom" flex="30"><label>Data da aplica\xE7\xE3o</label><md-datepicker class="md-block" \nname="data_aplicacao" ng-model="add_produtos.data_aplicacao" md-max-date="vm.date" md-placeholder="Inserir data" \nmd-open-on-focus required></md-datepicker><div class="errors" ng-messages="insumoForm.data_aplicacao.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container><md-input-container \nclass="select-custom" flex="70" md-delay="500"><label translate="DEFENSIVO.PRODUTO">Produto</label><md-select \nid="slctPrdt" class="md-block" ng-model="add_produtos.insumo_estoque" ng-change="vm.changeProduto(add_produtos)" \nname="insumo_agricola_nome" placeholder="Selecione o produto" required><md-option \nng-repeat="insumo_produto in vm.productStock" ng-value="insumo_produto">{{insumo_produto.nome}}</md-option></md-select>\n<div ng-messages="insumoForm.produto.$error" ng-if="insumoForm.produto.$touched"><div ng-message="required">\nCampo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.produto.$api.error.message}}</div></div>\n</md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30"><label \ntranslate="DEFENSIVO.AMOUNT">Quantidade</label><input id="inptQntdd" name="quantidade" type="text" \nng-model="add_produtos.quantidade" ng-disabled="!add_produtos.insumo_estoque" ui-number-mask="3" min="0.001" required \nmax="99999.999" maxlength="10" placeholder="Insira a quantidade"> <span class="unidade_medida_input">\n{{add_produtos.insumo_estoque.tipo_medida.descricao}}</span><div class="errors" \nng-messages="insumoForm.quantidade.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999.999 | finance:false:3}}</div></div></md-input-container><md-input-container flex><label \ntranslate="DEFENSIVO.VALOR">Valor</label><input id="inptVlr" name="valor" type="text" ng-model="add_produtos.valor" \nui-money-mask="2" ng-disabled="!add_produtos.insumo_estoque" maxlength="15" placeholder="Insira o valor"><div \nclass="errors" ng-messages="insumoForm.valor.$error"><div ng-message="maxlength">Deve ser inferior a \'9.999.999,99\'.\n</div><div ng-message="api_erro">{{insumoForm.valor.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15"><label>Car\xEAncia</label><input id="inptCrnc" type="text" name="carencia" \nng-model="add_produtos.carencia" ng-pattern="/^[0-9]*$/" maxlength="2" ui-number-mask="0" min="0" max="999" \nplaceholder="Insira a car\xEAncia"><div class="errors" ng-messages="insumoForm.carencia.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="max">\nCarencia deve ser inferior a \'100\'.</div><div ng-message="api_erro">{{insumoForm.carencia.$api.error.message}}</div>\n</div></md-input-container></div></md-card><md-card class="add-card"><a id="btnAdc" class="btn btn-quaternary" \nng-click="vm.addProducts()" ng-hide="vm.model.produtos.length == 10"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Aplicar mais insumos</a></md-card><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div><md-card><area-selector \nng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="DEFENSIVO.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="DEFENSIVO.EQUIPAMENTO">Equipamento</label><input id="inptEqpmnt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="DEFENSIVO.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container><md-input-container flex="15"><label \ntranslate="DEFENSIVO.REENTRADA">Reentrada</label><input id="inptRntrd" name="reentrada" type="text" \nng-model="vm.model.reentrada" maxlength="3" placeholder="Insira a reentrada"><div class="errors" \nng-messages="insumoForm.reentrada.$error"><div ng-message="required">Campo Obrigat\xF3rio</div></div></md-input-container>\n</div></md-card><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoSearch()">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset \nng-if="vm.step == 2"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num">1\n</span> <span class="num last active">2</span></div><h2>Veja a quantidade de insumos aplicadas<br>\npor area selecionada e confirme.</h2></div><div api-form-validation-summary form="insumoForm"></div><div \nng-repeat="area_consolidada in vm.areas_consolidadas"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>{{ area_consolidada.area.nome }} <small>\n- {{ area_consolidada.area.area_produtiva }}ha - {{ area_consolidada.area.cultura_nome }} {{ area_consolidada.area.variedade_nome }}\n</small></h3></div><div ng-repeat="produtos_por_tipo_medida in area_consolidada.produtos"><table row-border lm-sort \nhover id="responsive" class="simple table-custom insumo-defensivo-consolidacao-area" \nng-if="produtos_por_tipo_medida.produtos.length > 0"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Insumo</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Car\xEAncia</span>\n</div></th><th class="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nQuantidade</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Valor</span></div></th></tr></thead><tbody><tr \nng-repeat="produto in produtos_por_tipo_medida.produtos"><td class="td-insumo_agricola_nome">\n{{produto.produto.insumo_agricola_nome}}</td><td class="td-insumo_agricola_nome">{{ produto.produto.carencia }}</td><td\n class="td-insumo_agricola_nome">\n{{ produto.quantidade | number:3 }} {{ produto.produto.insumo_estoque.tipo_medida.descricao }}</td><td \nclass="td-insumo_agricola_nome">{{ produto.valor | finance:true:2 }}</td></tr></tbody></table></div><br></div><div \nclass="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" \nng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.save(insumoForm)" aria-label="Confirmar aplica\xE7\xE3o">Confirmar aplica\xE7\xE3o</md-button></div></fieldset></form>\n</div></div></div>');
$templateCache.put('app/main/registro/insumo/defensivo/views/modal_estoque.html','<md-dialog><div class="header-modal"><div class="desc">Visualiza\xE7\xE3o de estoque</div><div class="close" \nng-click="hide()">X</div></div><div class="content"><table class="table-estoque-isumos"><tbody><tr><td>\nNome produto estoque</td><td>Nome produto comercial</td></tr><tr><td><strong>\n{{ dataModal.rateioProductStock[0].insumo_nome }}</strong></td><td><strong>\n{{ dataModal.rateioProductStock[0].insumo_nome_comercial }}</strong></td></tr></tbody></table><br><br><table \nclass="table-culturas"><md-progress-linear ng-if="loading" md-mode="indeterminate"></md-progress-linear><thead><tr><th>\nFornecedor</th><th>Data compra</th><th>Quantidade</th></tr></thead><tbody><tr \nng-repeat="item in dataModal.rateioProductStock"><td>{{ item.loja_fornecedor }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\' }}</td><td>{{ item.quantidade | number:3 }} {{ item.tipo_medida_descricao }}\n</td></tr></tbody></table></div></md-dialog>');
$templateCache.put('app/main/registro/insumo/defensivo/views/sucesso.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Defensivo > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/images/svg/ico-aplicacao-de-insumos-sucesso.svg" alt="sucesso"><h2>\nAplica\xE7\xE3o de insumos realizada com sucesso!</h2><span>-------------------------------------------------------</span><p>\nO que voc\xEA gostaria de fazer agora?</p><div class="content-buttons-sucesso"><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-click="vm.gotoAplicarInsumoDefensivo()">Aplicar insumo defensivo</md-button>\n<md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoList()">Ver lista de aplica\xE7\xF5es</md-button>\n<md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoHistorico()">Ver hist\xF3rico</md-button>\n<md-button class="btn btn-secondary btn-md" ng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div>\n</div></div>');
$templateCache.put('app/main/registro/insumo/defensivo/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/nLu19Vebyeo?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/insumo/defensivo/views/visualizar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Defensivo > Visualizar</h1><h1 class="d-mobile">Visualizar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>Dados da aplica\xE7\xE3o</h3></div><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="40"><label for="">\xC1rea</label><input type="text" \nvalue="{{ vm.model.area }} - {{ vm.model.area_produtiva | number:4 }} ha - {{ vm.model.cultura }} {{ vm.model.produto_variedade }}">\n</md-input-container><md-input-container flex="15"><label for="">Data registro</label><input type="text" \nvalue="{{ vm.model.data_registro | date:\'dd/MM/yyyy\' }}"></md-input-container></div><hr><br><h3 \ntranslate="DEFENSIVO.DATA_INSUMO">Dados do insumo</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container class="datepicker-custom" flex><label>Data da aplica\xE7\xE3o</label><md-datepicker \nname="data_aplicacao" ng-model="vm.model.data_aplicacao" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex><label translate="DEFENSIVO.PRODUTO">Produto Aplicado</label><input \ntype="text" name="insumo_agricola_nome" ng-model="vm.model.insumo_agricola_nome"></md-input-container>\n<md-input-container flex><label translate="DEFENSIVO.AMOUNT">Quantidade do produto</label><input type="text" \nname="quantidade" value="{{vm.model.quantidade | finance:false:3}} {{vm.model.unidade_medida}}"></md-input-container>\n<md-input-container flex><label translate="DEFENSIVO.VALOR">Valor</label><input type="text" name="valor" ui-money-mask \nng-model="vm.model.valor"></md-input-container><md-input-container flex><label translate="DEFENSIVO.LACK">Car\xEAncia\n</label><input type="text" name="carencia" ng-model="vm.model.carencia"></md-input-container></div></md-card><div \nclass="container-title-step"><h3><span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>\nRegistros clim\xE1ticos</h3></div><md-card><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex>\n<label translate="DEFENSIVO.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input name="condicao_climatica" type="text" \nng-model="vm.model.condicao_climatica" required></md-input-container><md-input-container flex><label \ntranslate="DEFENSIVO.EQUIPAMENTO">Equipamento</label><input name="equipamento" type="text" \nng-model="vm.model.equipamento" required></md-input-container><md-input-container flex><label \ntranslate="DEFENSIVO.OPERADOR">Operador</label><input name="operador" type="text" ng-model="vm.model.operador" \nrequired></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/buscar.html','<div class="container-header"><div class="box-tutorial"><div class="breadcrumb"><h1>\nManejos > Aplica\xE7\xE3o de insumos > Fertilizante</h1></div><div class="tutorial" ng-click="vm.viewTutorial()"><img \nsrc="../../../../../assets/images/svg/ico-video.svg" alt=""> <span>Assista o passo a passo</span></div></div><md-button\n class="btn btn-primary" translate="FERTILIZANTE.ADD_FERTILIZANTE" \nng-click="vm.gotoAdd(vm.clientePerfil.is_estoque_automatico)" ng-disabled="vm.propriedades.length == 0">\nAdicionar insumo fertilizante</md-button></div><div class="page-layout simple fullwidth doc-page" layout="column"><div \nclass="content" layout="column"><div class="container-content-custom"><div class="form-search-horizontal"><div \nclass="form-search"><form><div class="container"><div class="row"><div class="col icon-filters"><img \nsrc="../../../../../assets/icons/ico-filtro.svg"> <span>Filtros</span></div><div class="col"><md-input-container \nclass="select-custom" flex><label>\xC1rea em aberto</label><select class="md-block" name="area" \nng-model="vm.args.propriedade_area_id"><option value="" selected="selected" disabled="disabled">Selecione</option>\n<option ng-repeat="area in vm.filtros.areas" ng-value="area.area_nome">{{area.area_nome}}</option></select>\n</md-input-container></div><div class="col"><md-input-container class="select-custom" flex><label>Insumo</label><select\n class="md-block" name="insumo" ng-model="vm.args.insumo_agricola"><option value="" selected="selected" \ndisabled="disabled">Selecione</option><option ng-repeat="insumo in vm.filtros.insumos" \nplaceholder="Selecione a insumo" ng-value="insumo.insumo_nome">{{insumo.insumo_nome}}</option></select>\n</md-input-container></div><div class="col"><md-input-container class="select-custom datepicker-custom"><label>\nData da aplica\xE7\xE3o</label><md-datepicker name="data_aplicacao" ng-model="vm.args.data_aplicacao" md-max-date="vm.date" \nng-change="$mdMenu.open()" md-placeholder="Inserir data" md-open-on-focus></md-datepicker></md-input-container></div>\n<div class="col"><div class="content-buttons"><md-button class="btn btn-tertiary btn-md-i" \nng-click="vm.args._change()">Filtrar</md-button><a class="btn btn-quaternary" ng-click="vm.resetFilters()">Limpar</a>\n</div></div></div></div></form></div></div><div class="filtros-ativos" ng-if="vm.activeFilters.length > 0"><ul><li \nclass="first"><strong>{{vm.args.total_rows}}</strong> resultado(s) para o filtro:</li><li \nng-repeat="filter in vm.activeFilters" ng-if="filter.description">{{filter.description}} <a href="#" \nng-click="vm.desableFilter(filter.value)" title="Remover">X</a></li></ul></div><div \nclass="ms-responsive-table-wrapper"><div class="content fullpage-simple" layout="column" flex><table row-border hover \nlm-sort lm-args="vm.args" id="responsive" class="simple table-custom insumo-fertilizante"><thead><tr><th \nclass="secondary-text pagination-custom" lm-sort-header="id" lm-title="ID" flex="50"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="caderno_campo_propriedade_area_nome" lm-title="Nome da \xE1rea" \nflex="50"></th><th class="secondary-text pagination-custom" lm-sort-header="insumo_agricola_nome" lm-title="Insumo">\n</th><th class="secondary-text pagination-custom" lm-sort-header="data_aplicacao" lm-title="Data aplica\xE7\xE3o"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="quantidade" lm-title="Quantidade"></th><th \nclass="secondary-text pagination-custom" lm-sort-header="valor" lm-title="Valor"></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title" \ntranslate="FERTILIZANTE.ACTIONS">Actions</span></div></th></tr></thead><tbody><tr ng-repeat="model in vm.models"><td>\n{{model.id}}</td><td>{{model.area}}</td><td>{{model.insumo_agricola_nome}}</td><td>\n{{model.data_aplicacao | date:\'dd/MM/yyyy\'}}</td><td>{{model.quantidade | finance:false:3 }} {{model.unidade_medida}}\n</td><td>R$ {{ model.valor | finance:false:2 }}</td><td ng-if="model.valor == null">-</td><td><md-button \nclass="edit-button md-icon-button" ng-click="vm.gotoVisualizar(model.id)" aria-label="Visualizar"><i \nclass="far fa-eye"><md-tooltip hide-xs md-direction="left">Visualizar</md-tooltip></i></md-button><md-button \nclass="edit-button md-icon-button" ng-click="vm.deletarConfirm(model)" aria-label="Apagar"><i class="far fa-trash-alt">\n<md-tooltip hide-xs md-direction="right">Remover</md-tooltip></i></md-button></td></tr></tbody></table>\n<md-progress-linear ng-if="vm.args.loading" md-mode="indeterminate"></md-progress-linear></div></div><lm-paginator \nlm-args="vm.args"></lm-paginator></div></div></div>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/criar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Fertilizantes > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nSelecione os insumos para aplica\xE7\xE3o,<br>escolha as \xE1reas e fa\xE7a o registro clim\xE1tico.</h2></div><div \napi-form-validation-summary form="insumoForm"></div><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-aplicacoes.svg"></span>Aplica\xE7\xF5es</h3></div><md-card \nng-repeat="add_produtos in vm.model.produtos"><div class="display-flex-custom"><h3>Aplica\xE7\xE3o {{ $index + 1 }}</h3>\n<md-button class="icon-btn md-icon-button" ng-if="vm.model.produtos.length > 1" ng-click="vm.removeProducts($index)" \naria-label="Remover"><div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs \nmd-direction="left">Excluir</md-tooltip></i></div></md-button></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="datepicker-custom" flex="30"><label>Data da aplica\xE7\xE3o</label><md-datepicker \nid="inptDt" class="md-block" name="data_aplicacao" ng-model="add_produtos.data_aplicacao" md-max-date="vm.date" \naria-label="data aplica\xE7\xE3o" md-placeholder="Inserir data" md-open-on-focus required></md-datepicker><div \nclass="errors" ng-messages="insumoForm.data_aplicacao.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="70" md-delay="500"><label translate="FERTILIZANTE.PRODUTO">Produto\n</label><md-select id="slctPrdt" class="md-block" ng-model="add_produtos.insumo_estoque" \nng-change="vm.changeProduto(add_produtos)" name="insumo_agricola_nome" placeholder="Selecione o produto" required \naria-label="produto"><md-option ng-repeat="insumo_produto in vm.productStock" ng-value="insumo_produto">\n{{insumo_produto.insumo_nome}}</md-option></md-select><div ng-messages="insumoForm.produto.$error" \nng-if="insumoForm.produto.$touched"><div ng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container></div><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="30"><label>Total em estoque</label><input \nid="total_estoque" name="total_estoque" type="text" \nvalue="{{ add_produtos.insumo_estoque.quantidade | number:3 }} {{ add_produtos.insumo_estoque.tipo_medida_descricao }}" \ndisabled="disabled"></md-input-container><md-input-container class="select-custom"><md-button \nclass="btn btn-quaternary" ng-disabled="!add_produtos.insumo_estoque" ng-click="vm.openModalEstoque(add_produtos)">\n<md-icon md-font-icon="icon-plus-circle"></md-icon>Visualizar estoque</md-button></md-input-container>\n<md-input-container flex="35"><label translate="FERTILIZANTE.AMOUNT">Quantidade do produto</label><input \nid="inptQntdd" name="quantidade" type="text" ng-model="add_produtos.quantidade" aria-label="quantidade" \nng-disabled="!add_produtos.insumo_estoque" required ng-change="vm.changeQuantidade(add_produtos)" ui-number-mask="3" \nmin="0.001" max="99999.999" maxlength="10" placeholder="Insira a quantidade"> <span class="unidade_medida_input">\n{{add_produtos.insumo_estoque.tipo_medida_descricao}}</span><div class="errors" \nng-messages="insumoForm.quantidade.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999999.999 | finance:false:3}}</div></div></md-input-container><md-input-container flex="15">\n<label translate="FERTILIZANTE.LACK">Car\xEAncia</label><input id="inptCrnc" type="text" name="carencia" \nng-model="add_produtos.carencia" ng-pattern="/^[0-9]*$/" maxlength="2" placeholder="Insira a car\xEAncia"><div \nclass="errors" ng-messages="insumoForm.carencia.$error"><div ng-message="pattern">Somente n\xFAmeros</div><div \nng-message="max">Carencia deve ser inferior a \'100\'.</div><div ng-message="api_erro">\n{{insumoForm.carencia.$api.error.message}}</div></div></md-input-container></div></md-card><md-card class="add-card"><a\n id="btnAdc" class="btn btn-quaternary" ng-click="vm.addProducts()" ng-hide="vm.model.produtos.length == 10"><md-icon \nmd-font-icon="icon-plus-circle"></md-icon>Aplicar mais insumos</a></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div><md-card><area-selector \nng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="FERTILIZANTE.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="FERTILIZANTE.EQUIPAMENTO">Equipamento</label><input id="inptEqpmt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="FERTILIZANTE.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container></div></md-card><div class="content-buttons">\n<md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" ng-click="vm.gotoSearch()">Voltar\n</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset \nng-if="vm.step == 2"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num">1\n</span> <span class="num last active">2</span></div><h2>Veja a quantidade de insumos aplicadas<br>\npor area selecionada e confirme.</h2></div><div api-form-validation-summary form="insumoForm"></div><div \nng-repeat="area_consolidada in vm.areas_consolidadas"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>{{ area_consolidada.area.nome }} <small>\n- {{ area_consolidada.area.area_produtiva }}ha - {{ area_consolidada.area.cultura_nome }} {{ area_consolidada.area.variedade_nome }}\n</small></h3></div><div ng-repeat="produtos_por_tipo_medida in area_consolidada.produtos"><table row-border lm-sort \nhover id="responsive" class="simple table-custom insumo-fertilizante-consolidacao-area" \nng-if="produtos_por_tipo_medida.produtos.length > 0"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Insumo</span></div></th><th></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Quant. / Unid.\n</span></div></th></tr></thead><tbody><tr ng-repeat="produto in produtos_por_tipo_medida.produtos"><td \nclass="td-insumo_agricola_nome">{{produto.produto.insumo_agricola_nome}}</td><td class="empty-space"></td><td>\n{{ produto.quantidade | finance:false:3 }} {{ produto.produto.insumo_estoque.tipo_medida_descricao }}</td></tr></tbody>\n</table></div><br></div><div class="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" \naria-label="voltar" ng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" \nclass="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.save(insumoForm)" aria-label="Confirmar aplica\xE7\xE3o">Confirmar aplica\xE7\xE3o</md-button></div></fieldset></form>\n</div></div></div>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/criar_sem_estoque.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Fertilizantes > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset ng-if="vm.step == 1"><div class="container-steps"><div class="steps"><span \nclass="tlt">PASSO</span> <span class="num active">1</span> <span class="num last">2</span></div><h2>\nSelecione os insumos para aplica\xE7\xE3o,<br>escolha as \xE1reas e fa\xE7a o registro clim\xE1tico.</h2></div><div \napi-form-validation-summary form="insumoForm"></div><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-aplicacoes.svg"></span>Aplica\xE7\xF5es</h3></div><md-card \nng-repeat="add_produtos in vm.model.produtos"><div class="display-flex-custom"><h3>Aplica\xE7\xE3o {{ $index + 1 }}</h3>\n<md-button class="icon-btn md-icon-button" ng-if="vm.model.produtos.length > 1" ng-click="vm.removeProducts($index)" \naria-label="Remover"><div class="btn-icon remove"><i class="far fa-trash-alt remove"><md-tooltip hide-xs \nmd-direction="left">Excluir</md-tooltip></i></div></md-button></div><div layout="column" layout-gt-xs="row" \nlayout-margin><md-input-container class="datepicker-custom" flex="30"><label>Data da aplica\xE7\xE3o</label><md-datepicker \nclass="md-block" name="data_aplicacao" ng-model="add_produtos.data_aplicacao" md-max-date="vm.date" \nmd-placeholder="Inserir data" md-open-on-focus required></md-datepicker><div class="errors" \nng-messages="insumoForm.data_aplicacao.$error"><div ng-message="required">Campo obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.data_aplicacao.$api.error.message}}</div></div></md-input-container>\n<md-input-container class="select-custom" flex="70" md-delay="500"><label translate="DEFENSIVO.PRODUTO">Produto</label>\n<md-select id="slctPrdt" class="md-block" ng-model="add_produtos.insumo_estoque" \nng-change="vm.changeProduto(add_produtos)" name="insumo_agricola_nome" placeholder="Selecione o produto" required>\n<md-option ng-repeat="insumo_produto in vm.productStock" ng-value="insumo_produto">{{insumo_produto.nome}}</md-option>\n</md-select><div ng-messages="insumoForm.produto.$error" ng-if="insumoForm.produto.$touched"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="api_erro">{{insumoForm.produto.$api.error.message}}</div>\n</div></md-input-container></div><div layout="column" layout-gt-xs="row" layout-margin><md-input-container flex="30">\n<label translate="DEFENSIVO.AMOUNT">Quantidade</label><input id="inptQntdd" name="quantidade" type="text" \nng-model="add_produtos.quantidade" ng-disabled="!add_produtos.insumo_estoque" ui-number-mask="3" min="0.001" required \nmax="99999.999" maxlength="10" placeholder="Insira a quantidade"> <span class="unidade_medida_input">\n{{add_produtos.insumo_estoque.tipo_medida.descricao}}</span><div class="errors" \nng-messages="insumoForm.quantidade.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="min">\nDeve ser maior que {{0.001 | finance:false:3}}</div><div ng-message="max">\nDeve ser menor que {{99999.999 | finance:false:3}}</div></div></md-input-container><md-input-container flex><label \ntranslate="DEFENSIVO.VALOR">Valor</label><input id="inptVlr" name="valor" type="text" ng-model="add_produtos.valor" \nui-money-mask="2" ng-disabled="!add_produtos.insumo_estoque" maxlength="15" placeholder="Insira o valor"><div \nclass="errors" ng-messages="insumoForm.valor.$error"><div ng-message="maxlength">Deve ser inferior a \'9.999.999,99\'.\n</div><div ng-message="api_erro">{{insumoForm.valor.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex="15"><label>Car\xEAncia</label><input id="inptCrnc" type="text" name="carencia" \nng-model="add_produtos.carencia" ng-pattern="/^[0-9]*$/" maxlength="2" ui-number-mask="0" min="0" max="999" \nplaceholder="Insira a car\xEAncia"><div class="errors" ng-messages="insumoForm.carencia.$error"><div \nng-message="required">Campo obrigat\xF3rio</div><div ng-message="pattern">Somente n\xFAmeros</div><div ng-message="max">\nCarencia deve ser inferior a \'100\'.</div><div ng-message="api_erro">{{insumoForm.carencia.$api.error.message}}</div>\n</div></md-input-container></div></md-card><md-card class="add-card"><a id="btnAdc" class="btn btn-quaternary" \nng-click="vm.addProducts()" ng-hide="vm.model.produtos.length == 10"><md-icon md-font-icon="icon-plus-circle">\n</md-icon>Aplicar mais insumos</a></md-card><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>\xC1reas</h3></div><md-card><area-selector \nng-model="vm.model.propriedade_areas" layout="row" ng-areas="vm.areas" \nng-total-area-produtiva="vm.total_area_produtiva" flex></area-selector></md-card><div class="container-title-step"><h3>\n<span><img src="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="FERTILIZANTE.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input id="inptCndc" name="condicao_climatica" \ntype="text" ng-model="vm.model.condicao_climatica" placeholder="Insira a condi\xE7\xE3o clim\xE1tica"><div class="errors" \nng-messages="insumoForm.condicao_climatica.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.condicao_climatica.$api.error.message}}</div></div></md-input-container>\n<md-input-container flex><label translate="FERTILIZANTE.EQUIPAMENTO">Equipamento</label><input id="inptEqpmt" \nname="equipamento" type="text" ng-model="vm.model.equipamento" placeholder="Insira o equipamento"><div class="errors" \nng-messages="insumoForm.equipamento.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div \nng-message="api_erro">{{insumoForm.equipamento.$api.error.message}}</div></div></md-input-container><md-input-container\n flex><label translate="FERTILIZANTE.OPERADOR">Operador</label><input id="inptOprdr" name="operador" type="text" \nng-model="vm.model.operador" placeholder="Insira o operador"><div class="errors" \nng-messages="insumoForm.operador.$error"><div ng-message="required">Campo Obrigat\xF3rio</div><div ng-message="api_erro">\n{{insumoForm.produto.$api.error.message}}</div></div></md-input-container></div></md-card><div class="content-buttons">\n<md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" ng-click="vm.gotoSearch()">Voltar\n</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" aria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.gotoStep(2)" aria-label="confirmar">Pr\xF3ximo passo</md-button></div></fieldset><fieldset \nng-if="vm.step == 2"><div class="container-steps"><div class="steps"><span class="tlt">PASSO</span> <span class="num">1\n</span> <span class="num last active">2</span></div><h2>Veja a quantidade de insumos aplicadas<br>\npor area selecionada e confirme.</h2></div><div api-form-validation-summary form="insumoForm"></div><div \nng-repeat="area_consolidada in vm.areas_consolidadas"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>{{ area_consolidada.area.nome }} <small>\n- {{ area_consolidada.area.area_produtiva }}ha - {{ area_consolidada.area.cultura_nome }} {{ area_consolidada.area.variedade_nome }}\n</small></h3></div><div ng-repeat="produtos_por_tipo_medida in area_consolidada.produtos"><table row-border lm-sort \nhover id="responsive" class="simple table-custom insumo-fertilizante-consolidacao-area" \nng-if="produtos_por_tipo_medida.produtos.length > 0"><thead><tr><th class="secondary-text pagination-custom"><div \nclass="table-header"><span class="actions column-title">Insumo</span></div></th><th \nclass="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">Car\xEAncia</span>\n</div></th><th class="secondary-text pagination-custom"><div class="table-header"><span class="actions column-title">\nQuantidade</span></div></th><th class="secondary-text pagination-custom"><div class="table-header"><span \nclass="actions column-title">Valor</span></div></th></tr></thead><tbody><tr \nng-repeat="produto in produtos_por_tipo_medida.produtos"><td class="td-insumo_agricola_nome">\n{{produto.produto.insumo_agricola_nome}}</td><td class="td-insumo_agricola_nome">{{ produto.produto.carencia }}</td><td\n class="td-insumo_agricola_nome">\n{{ produto.quantidade | number:3 }} {{ produto.produto.insumo_estoque.tipo_medida.descricao }}</td><td \nclass="td-insumo_agricola_nome">{{ produto.valor | finance:true:2 }}</td></tr></tbody></table></div><br></div><div \nclass="content-buttons"><md-button id="btnVltr" class="btn btn-secondary btn-lg" aria-label="voltar" \nng-click="vm.gotoStep(1)">Voltar</md-button><md-button id="btnCdstrr" type="button" class="btn btn-primary btn-lg" \naria-label="Submit" \nng-disabled="insumoForm.$invalid || insumoForm.$pristine || !vm.model.propriedade_areas || vm.model.propriedade_areas.length <= 0 || loadingProgress" \nng-click="vm.save(insumoForm)" aria-label="Confirmar aplica\xE7\xE3o">Confirmar aplica\xE7\xE3o</md-button></div></fieldset></form>\n</div></div></div>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/modal_estoque.html','<md-dialog><div class="header-modal"><div class="desc">Visualiza\xE7\xE3o de estoque</div><div class="close" \nng-click="hide()">X</div></div><div class="content"><table class="table-estoque-isumos"><tbody><tr><td>\nNome produto estoque</td></tr><tr><td><strong>{{ dataModal.rateioProductStock[0].insumo_nome }}</strong></td></tr>\n</tbody></table><br><br><table class="table-culturas"><md-progress-linear ng-if="loading" md-mode="indeterminate">\n</md-progress-linear><thead><tr><th>Fornecedor</th><th>Data compra</th><th>Quantidade</th></tr></thead><tbody><tr \nng-repeat="item in dataModal.rateioProductStock"><td>{{ item.loja_fornecedor }}</td><td>\n{{ item.data_compra | date:\'dd/MM/yyyy\' }}</td><td>{{ item.quantidade | number:3 }} {{ item.tipo_medida_descricao }}\n</td></tr></tbody></table></div></md-dialog>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/sucesso.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Fertilizantes > Aplicar</h1><h1 class="d-mobile">Aplicar Insumo</h1></div><div \nid="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div \nclass="container-content-custom"><div class="content-sucesso"><img \nsrc="/assets/images/svg/ico-aplicacao-de-insumos-sucesso.svg" alt="sucesso"><h2>\nAplica\xE7\xE3o de insumos realizada com sucesso!</h2><span>-------------------------------------------------------</span><p>\nO que voc\xEA gostaria de fazer agora?</p><div class="content-buttons-sucesso"><md-button type="button" \nclass="btn btn-tertiary btn-md-i" ng-click="vm.gotoAplicarInsumoFertilizante()">Aplicar insumo fertilizante</md-button>\n<md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoList()">Ver lista de aplica\xE7\xF5es</md-button>\n<md-button type="button" class="btn btn-tertiary btn-md-i" ng-click="vm.gotoHistorico()">Ver hist\xF3rico</md-button>\n<md-button class="btn btn-secondary btn-md" ng-click="vm.gotoHome()">Voltar para home</md-button></div></div></div>\n</div></div>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/tutorial.html','<div class="videoWrapper"><iframe src="https://www.youtube.com/embed/nLu19Vebyeo?autoplay=1" \ntitle="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen>\n</iframe></div>');
$templateCache.put('app/main/registro/insumo/fertilizante/views/visualizar.html','<div class="container-header container-header-novo"><h1 class="d-desk">\nAtividades > Aplica\xE7\xE3o de insumos > Fertilizantes > Visualizar</h1><h1 class="d-mobile">Visualizar Insumo</h1></div>\n<div id="forms" class="page-layout simple fullwidth doc-page" layout="column"><div class="content" layout="column"><div\n class="container-content-custom"><form name="insumoForm" class="md-inline-form inputdados" novalidate \napi-form="vm.api_response_erro"><fieldset disabled="disabled"><div class="container-title-step"><h3><span><img \nsrc="../assets/icons/ico-area.svg"></span>Dados da aplica\xE7\xE3o</h3></div><md-card><div layout="column" \nlayout-gt-xs="row" layout-margin><md-input-container flex="40"><label for="">\xC1rea</label><input type="text" \nname="propriedade_areas" \nvalue="{{ vm.model.area }} - {{ vm.model.area_produtiva | number:4 }} ha - {{ vm.model.cultura }} {{ vm.model.produto_variedade }}">\n</md-input-container><md-input-container flex="15"><label for="">Data registro</label><input type="text" \nvalue="{{ vm.model.data_registro | date:\'dd/MM/yyyy\' }}"></md-input-container></div><hr><br><h3 \ntranslate="FERTILIZANTE.DATA_INSUMO">Dados do insumo</h3><div layout="column" layout-gt-xs="row" layout-margin>\n<md-input-container flex class="datepicker-custom"><label>Data da aplica\xE7\xE3o</label><md-datepicker \nname="data_aplicacao" ng-model="vm.model.data_aplicacao" md-open-on-focus disabled="disabled"></md-datepicker>\n</md-input-container><md-input-container flex><label translate="FERTILIZANTE.PRODUTO">Produto Aplicado</label><input \ntype="text" name="insumo_agricola_nome" ng-model="vm.model.insumo_agricola_nome"></md-input-container>\n<md-input-container flex><label translate="FERTILIZANTE.AMOUNT">Quantidade do produto</label><input type="text" \nname="quantidade" value="{{vm.model.quantidade | finance:false:3}} {{vm.model.unidade_medida}}"></md-input-container>\n<md-input-container flex><label translate="FERTILIZANTE.VALOR">Valor</label><input type="text" name="valor" \nui-money-mask ng-model="vm.model.valor"></md-input-container><md-input-container flex><label \ntranslate="DEFENSIVO.LACK">Car\xEAncia</label><input type="text" name="carencia" ng-model="vm.model.carencia">\n</md-input-container></div></md-card><div class="container-title-step"><h3><span><img \nsrc="../assets/images/svg/ico-registro-climaticos.svg"></span>Registros clim\xE1ticos</h3></div><md-card><div \nlayout="column" layout-gt-xs="row" layout-margin><md-input-container flex><label \ntranslate="FERTILIZANTE.CONDICAO_CLIMATICA">Condi\xE7\xE3o Clim\xE1tica</label><input name="condicao_climatica" type="text" \nng-model="vm.model.condicao_climatica" required></md-input-container><md-input-container flex><label \ntranslate="FERTILIZANTE.EQUIPAMENTO">Equipamento</label><input name="equipamento" type="text" \nng-model="vm.model.equipamento" required></md-input-container><md-input-container flex><label \ntranslate="FERTILIZANTE.OPERADOR">Operador</label><input name="operador" type="text" ng-model="vm.model.operador" \nrequired></md-input-container></div></md-card></fieldset><div class="content-buttons"><md-button \nclass="btn btn-secondary btn-lg" ng-click="vm.gotoSearch()">Voltar</md-button></div></form></div></div></div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/tutorials/gerar-laudo.html','<div><div class="header-modal"><div class="desc">Passo a passo</div><div class="close" ng-click="vm.close()">X</div>\n</div><div class="content"><div class="videoWrapper"><iframe \nsrc="https://www.youtube.com/embed/-5Bs4xrzp_U?autoplay=1" title="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div></div><div class="footer"><md-button \nclass="md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" ng-click="vm.returnModal()">\nVoltar</md-button><md-button class="btn-tertiary" ng-click="vm.close()">Fechar</md-button></div></div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/tutorials/tutorial-imprimir-trocarcliente.html','<div><div class="header-modal"><div class="desc">Passo a passo</div><div class="close" ng-click="vm.close()">X</div>\n</div><div class="content"><div class="videoWrapper"><iframe \nsrc="https://www.youtube.com/embed/axGVi175nvY?autoplay=1" title="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div></div><div class="footer"><md-button \nclass="md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" ng-click="vm.returnModal()">\nVoltar</md-button><md-button class="btn-tertiary" ng-click="vm.close()">Fechar</md-button></div></div>');
$templateCache.put('app/main/vendas/lotes_vendidos/views/tutorials/tutorial-vender-lotes.html','<div><div class="header-modal"><div class="desc">Passo a passo</div><div class="close" ng-click="vm.close()">X</div>\n</div><div class="content"><div class="videoWrapper"><iframe \nsrc="https://www.youtube.com/embed/PkRRyFNYjzo?autoplay=1" title="YouTube video player" frameborder="0" \nallow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen \ncontrols autoplay></iframe></div></div><div class="footer"><md-button \nclass="md-primary md-cancel-button md-button ng-scope md-default-theme md-ink-ripple" ng-click="vm.returnModal()">\nVoltar</md-button><md-button class="btn-tertiary" ng-click="vm.close()">Fechar</md-button></div></div>');
$templateCache.put('app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html','<md-button class="ms-stepper-navigation-item" \nng-class="{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}" \nng-click="MsStepper.gotoStep(stepInfo.stepNumber)" ng-disabled="MsStepper.isStepDisabled(stepInfo.stepNumber)" \nng-hide="MsStepper.isStepHidden(stepInfo.stepNumber)" aria-label="Stepper navigation button" layout="row" \nlayout-align="start center"><div class="step" layout="row" layout-align="center center"><span \nng-if="!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)"><i \nclass="icon icon-checkbox-blank-circle-outline s18 md-accent-fg"></i> </span><span \nng-if="MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)"><i \nclass="icon icon-check-circle s18 md-accent-fg"></i></span></div><div layout="column" layout-align="start start"><div \nclass="title" ng-if="stepInfo.stepTitleTranslate">{{stepInfo.stepTitleTranslate | translate }}</div><div class="title" \nng-if="!stepInfo.stepTitleTranslate">{{stepInfo.stepTitle}}</div><div class="subtitle" \nng-if="MsStepper.isStepOptional(stepInfo.stepNumber)">Optional</div></div></md-button><div \nclass="ms-stepper-step-content" ng-transclude></div><div class="ms-stepper-controls" layout="row" \nlayout-align="start center" ng-show="MsStepper.isStepCurrent(stepInfo.stepNumber)"><md-button \nclass="md-accent md-raised" ng-disabled="MsStepper.isFirstStep()" ng-click="MsStepper.gotoPreviousStep()">Back\n</md-button><md-button class="md-accent md-raised" ng-if="!MsStepper.isLastStep()" \nng-disabled="!MsStepper.isStepValid(MsStepper.currentStepNumber)" ng-click="MsStepper.gotoNextStep()">Next</md-button>\n<md-button type="submit" class="md-accent md-raised" ng-click="MsStepper.resetForm()" ng-if="MsStepper.isLastStep()" \nng-disabled="!MsStepper.isFormValid()">Submit</md-button></div>');}]);